/* eslint-disable */
// Transcrit et minifié par esbuild depuis packages/reasoner/src/reasoner.ts (moteur gelé) : ne pas modifier à la main.
var eI = Object.defineProperty;
var nI = (e, n) => {
  for (var t in n) eI(e, t, { get: n[t], enumerable: !0 });
};
var VT = { '+': 1, '\u2212': 1, '\xD7': 1, '\xF7': 1, '^': 1, parmi: 1 },
  Em = 'parmi';
var cf = { ln: 1, exp: 1, cos: 1, sin: 1, tan: 1, arg: 1, arccos: 1, arcsin: 1, arctan: 1, log: 1 },
  Ca = { π: Math.PI },
  tI = { '>': 1, '<': 1, '\u2265': 1, '\u2264': 1, '\u2248': 1 };
function cu(e) {
  return e !== void 0 && tI[e] === 1;
}
var DT = { '<': !0, '\u2264': !0, '>': !1, '\u2265': !1 };
function Dr(e) {
  return !!e && cf[e] === 1;
}
function Xt(e) {
  return !!e && Ca[e] !== void 0;
}
var Tx =
    'A-Za-z\xC0-\xD6\xD8-\xF6\xF8-\xFF\u0391-\u03A9\u03B1-\u03C9\u2113\u0108\u011C\u0124\u0134\u015C\u0174\u0176',
  rI = '\u2080-\u209C',
  BT = '\u2070\xB9\xB2\xB3\u2074-\u2079\u207A\u207B\u207F',
  xh = new RegExp('[' + Tx + ']'),
  sI = new RegExp('^[' + Tx + '][' + Tx + rI + '\\u0302\\u0304]*'),
  iI = new RegExp('^[' + BT + ']+'),
  oI = new RegExp('^\\d+[' + BT + ']+$');
function yh(e) {
  return /^\[\d+\]$/.test(e || '');
}
function zT(e) {
  return Number(e.slice(1, -1));
}
function yt(e) {
  return /^\d+(?:,\d+)?$/.test(e || '');
}
function jt(e) {
  return xh.test((e || '')[0] || '') && e !== 'ou' && e !== Em && !Dr(e) && !Xt(e);
}
function Ea(e) {
  return oI.test(e || '');
}
var $x = '\u2070\xB9\xB2\xB3\u2074\u2075\u2076\u2077\u2078\u2079';
function Ds(e) {
  return !!e && e !== '\xB2' && [...e].every((n) => $x.includes(n));
}
function UT(e) {
  return Number([...e].map((n) => String($x.indexOf(n))).join(''));
}
function ff(e) {
  return yt(e) || jt(e) || Ea(e) || Xt(e);
}
var aI = new RegExp(
  "^(card|[A-Za-z\u03B1-\u03C9\u0391-\u03A9]{1,2})([\u2032'\u2019]{0,2}|\u2033)(_[A-Za-z\u0100-\u017F][\\u0300-\\u036F]?[\u2080-\u2089]*)?\\(\\s*(\u2212|-)?([A-Za-z\xC0-\xD6\xD8-\xF6\xF8-\xFF\u0100-\u017F\u03B1-\u03C9\u0391-\u03A9\\u0300-\\u036F0-9\u2080-\u2089\u2229\u222A\xD7|,;\\s]+?)\\s*\\)",
);
function Cx(e) {
  let n = aI.exec(e);
  if (!n) return null;
  let t = n[1];
  if (Dr(t) || t === 'ou') return null;
  let r = n[5].replace(/\s+/g, '');
  if (!r) return null;
  let s = '\u2032'.repeat(n[2] === '\u2033' ? 2 : (n[2] ?? '').length),
    i = n[3] ?? '',
    o = n[4] ? '\u2212' : '';
  return { atom: `${t}${s}${i}(${o}${r})`, len: n[0].length };
}
function pe(e) {
  if (!isFinite(e)) return '?';
  let n = Math.abs(e);
  if (n >= 1e-9 && n < 1e-4) {
    let o = Math.min(20, Math.ceil(-Math.log10(n)) + 9),
      a = Number(n.toPrecision(10)).toFixed(o).replace(/0+$/, '').replace('.', ',');
    return (e < 0 ? '\u2212' : '') + a;
  }
  let t = Math.round(e * 1e6) / 1e6,
    r = t < 0,
    s = Math.abs(t),
    i = Number.isInteger(s) ? String(s) : String(Number(s.toFixed(6)));
  return ((i = i.replace('.', ',')), (r ? '\u2212' : '') + i);
}
function lI(e) {
  let n = /^(\d+)(?:[.,](\d+))?$/.exec(String(e));
  if (n) {
    let r = n[1].replace(/^0+(?=\d)/, ''),
      s = (n[2] ?? '').replace(/0+$/, '');
    return s ? `${r},${s}` : r;
  }
  let t = Number(String(e).replace(',', '.'));
  return isFinite(t) ? pe(t) : String(e);
}
function Te(e) {
  let n = [],
    t = 0,
    r = String(e);
  for (; t < r.length; ) {
    let s = r[t];
    if (/\s/.test(s)) {
      t++;
      continue;
    }
    if (/\d/.test(s)) {
      let i = /^\d+(?:[.,]\d+)?/.exec(r.slice(t));
      t += i[0].length;
      let o = iI.exec(r.slice(t));
      o && o[0] !== '\xB2' && /^\d+$/.test(i[0])
        ? (n.push(i[0] + o[0]), (t += o[0].length))
        : n.push(lI(i[0]));
      continue;
    }
    if (xh.test(s)) {
      let i = r.slice(t);
      if (s === 'e' && r[t + 1] === '^' && !xh.test(r[t - 1] ?? '')) {
        (n.push('exp'), (t += 2));
        continue;
      }
      let o = Cx(i);
      if (o) {
        (n.push(o.atom), (t += o.len));
        continue;
      }
      let a = sI.exec(i)[0],
        l = Object.keys(cf).find(
          (c) => a.length === c.length + 1 && a.startsWith(c) && /[xtθ]$/.test(a),
        );
      if (l && !xh.test(r[t - 1] ?? '')) {
        (n.push(l), (t += l.length));
        continue;
      }
      let u = a.indexOf('\u03C0');
      if (u >= 0 && a.length > 1) {
        let c = u === 0 ? '\u03C0' : a.slice(0, u);
        (n.push(c), (t += c.length));
        continue;
      }
      (n.push(a), (t += a.length));
      continue;
    }
    if (s === '-' || s === '\u2212') {
      (n.push('\u2212'), t++);
      continue;
    }
    if (s === '*' || s === '\xD7') {
      (n.push('\xD7'), t++);
      continue;
    }
    if (s === '/' || s === '\xF7') {
      (n.push('\xF7'), t++);
      continue;
    }
    if (s === '^' && r[t + 1] === '2' && !/[\d.,]/.test(r[t + 2] ?? '')) {
      (n.push('\xB2'), (t += 2));
      continue;
    }
    if (s === '^') {
      (n.push('^'), t++);
      continue;
    }
    if (s === '[') {
      let i = /^\[\s*(\d+)\s*\]/.exec(r.slice(t));
      if (i) {
        (n.push('[' + i[1] + ']'), (t += i[0].length));
        continue;
      }
    }
    if (s === '\u2261') {
      (n.push('\u2261'), t++);
      continue;
    }
    if (s === '|') {
      (n.push('|'), t++);
      continue;
    }
    if (s === '\u2248' || s === '\u2243' || (s === '~' && r[t + 1] === '=')) {
      (n.push('\u2248'), (t += s === '~' ? 2 : 1));
      continue;
    }
    if (s === '>' || s === '<' || s === '\u2265' || s === '\u2264') {
      (s === '>' || s === '<') && r[t + 1] === '='
        ? (n.push(s === '>' ? '\u2265' : '\u2264'), (t += 2))
        : (n.push(s), t++);
      continue;
    }
    if (s === '!') {
      (n.push('!'), t++);
      continue;
    }
    if (s === '\xB0') {
      (n.push('\xB0'), t++);
      continue;
    }
    if ($x.includes(s)) {
      let i = n[n.length - 1],
        o = /^[⁰¹²³⁴⁵⁶⁷⁸⁹]+/.exec(r.slice(t))[0];
      if (i !== void 0 && (i === ')' || jt(i) || Xt(i) || yt(i)) && o !== '\xB2') {
        (n.push(o), (t += o.length));
        continue;
      }
    }
    if ('+=()\xB2\u221A%'.indexOf(s) >= 0) {
      (n.push(s), t++);
      continue;
    }
    if ('\u2070\xB9\xB3\u2074\u2075\u2076\u2077\u2078\u2079\u207B'.indexOf(s) >= 0) {
      (n.push(s), t++);
      continue;
    }
    t++;
  }
  return n;
}
function uI(e) {
  return ff(e) || e === ')' || e === '\xB2' || Ds(e) || e === '%' || e === '\xB0' || e === '!';
}
function cI(e) {
  return jt(e) || Xt(e) || Dr(e) || e === '(' || e === '\u221A';
}
function wt(e) {
  let n = [],
    t = [],
    r = !1,
    s = !1;
  return (
    e.forEach((i, o) => {
      i.atoms.forEach((a) => {
        let l = n[n.length - 1],
          u = l !== void 0 && (uI(l) || s),
          c = a === '|' && !r;
        (u && (cI(a) || c) && (n.push('\xD7'), t.push(o)),
          (s = a === '|' && r),
          a === '|' && (r = !r),
          n.push(a),
          t.push(o));
      });
    }),
    { atoms: n, src: t }
  );
}
function ne(e) {
  return wt([{ atoms: e }]).atoms;
}
function wh(e, n) {
  let t = [[]],
    r = [],
    s = 0;
  return (
    e.forEach((i) => {
      (i === '(' && s++,
        i === ')' && s--,
        s === 0 && n.indexOf(i) >= 0 ? (r.push(i), t.push([])) : t[t.length - 1].push(i));
    }),
    { parts: t, ops: r }
  );
}
function Sh(e) {
  if (e.length <= 1) return [e.slice()];
  if (e.length > 4) return [e.slice()];
  let n = [];
  return (
    e.forEach((t, r) => {
      let s = e.slice(0, r).concat(e.slice(r + 1));
      Sh(s).forEach((i) => n.push([t].concat(i)));
    }),
    n
  );
}
function Rx(e, n) {
  let t = [];
  return (
    e.forEach((r, s) => {
      (s > 0 && t.push(n), (t = t.concat(r)));
    }),
    t
  );
}
function Sx(e) {
  let n = wh(e, ['+', '\u2212']);
  if (
    n.parts.length > 1 &&
    n.ops.every((r) => r === '+') &&
    n.parts.every((r) => r.length && r[0] !== '\u2212')
  )
    return Sh(n.parts).map((r) => Rx(r, '+'));
  let t = wh(e, ['\xD7', '\xF7']);
  return t.parts.length > 1 && t.ops.every((r) => r === '\xD7')
    ? Sh(t.parts).map((r) => Rx(r, '\xD7'))
    : [e];
}
function fI(e) {
  let n = wh(e, ['=']).parts;
  if (n.length === 1) return Sx(n[0]);
  if (n.length !== 2) return [e];
  let t = [];
  return (
    Sx(n[0]).forEach((r) => {
      Sx(n[1]).forEach((s) => {
        (t.push(r.concat(['=']).concat(s)), t.push(s.concat(['=']).concat(r)));
      });
    }),
    t
  );
}
function GT(e) {
  let n = wh(e, ['ou']).parts,
    t = n.map(fI),
    r = n.length <= 3 ? Sh(n.map((a, l) => l)) : [n.map((a, l) => l)],
    s = [];
  r.forEach((a) => {
    let l = [[]];
    (a.forEach((u) => {
      let c = [];
      (l.forEach((f) => {
        t[u].forEach((d) => c.push(f.concat([d])));
      }),
        (l = c.slice(0, 200)));
    }),
      l.forEach((u) => s.push(Rx(u, 'ou'))));
  });
  let i = {},
    o = [];
  return (
    [e].concat(s).forEach((a) => {
      let l = a.join('');
      i[l] || ((i[l] = 1), o.push(a));
    }),
    o
  );
}
function vn(e, n) {
  let t = !!n?.chains,
    r = !0,
    s = 0,
    i = !1,
    o = !1,
    a = !1,
    l = !1,
    u = '',
    c = 0,
    f = (d, m) => ({ ok: !1, index: d, msg: m });
  for (let d = 0; d < e.length; d++) {
    let m = e[d];
    if (r) {
      if (ff(m)) {
        r = !1;
        continue;
      }
      if (m === '(') {
        s++;
        continue;
      }
      if (m === '\u221A' || Dr(m)) continue;
      if (m === '|') {
        c++;
        continue;
      }
      if (m === '\u2212' || m === '+') {
        let p = e[d - 1];
        if (p === '\u2212' || p === '+')
          return f(d, 'Deux signes \xE0 la suite : il manque un nombre entre les deux.');
        continue;
      }
      return m === '=' || m === '\u2261' || cu(m)
        ? f(
            d,
            d === 0
              ? 'Une ligne ne commence pas par \xAB ' + m + ' \xBB.'
              : 'Il manque un nombre ou une lettre avant \xAB ' + m + ' \xBB.',
          )
        : yh(m)
          ? f(
              d,
              '\xAB ' +
                m +
                ' \xBB se place \xE0 la fin d\u2019une congruence, apr\xE8s un nombre ou une lettre.',
            )
          : VT[m]
            ? f(d, 'Deux op\xE9rations \xE0 la suite : il manque un nombre entre les deux.')
            : m === ')'
              ? f(d, 'Parenth\xE8se ferm\xE9e trop t\xF4t : il manque quelque chose dedans.')
              : m === '\xB2' || Ds(m) || m === '%' || m === '\xB0' || m === '!'
                ? f(
                    d,
                    '\xAB ' +
                      m +
                      ' \xBB se place juste apr\xE8s un nombre, une lettre ou une parenth\xE8se.',
                  )
                : m === 'ou'
                  ? f(d, '\xAB ou \xBB relie deux \xE9galit\xE9s compl\xE8tes.')
                  : f(d, 'Ce bout ne peut pas venir ici.');
    }
    if (a && m !== 'ou')
      return f(
        d,
        'Le modulo \xAB ' + e[d - 1] + ' \xBB termine la congruence : rien ne vient apr\xE8s.',
      );
    if (VT[m]) {
      r = !0;
      continue;
    }
    if (m === '|' && c > 0) {
      c--;
      continue;
    }
    if (cu(m)) {
      if (s > 0) return f(d, 'Ferme la parenth\xE8se avant \xAB ' + m + ' \xBB.');
      if (t && l && m !== '\u2248') {
        if (DT[m] !== DT[u])
          return f(d, 'Une cha\xEEne de comparaisons va dans un seul sens : \xAB a < x < b \xBB.');
        ((u = m), (r = !0));
        continue;
      }
      if (i || l)
        return f(
          d,
          t
            ? 'Une comparaison relie deux membres : pas de \xAB = \xBB en plus.'
            : 'Une comparaison relie deux membres : une seule par ligne, sans \xAB = \xBB.',
        );
      ((u = m), (l = !0), (i = !0), (r = !0));
      continue;
    }
    if (m === '=' || m === '\u2261') {
      if (s > 0) return f(d, 'Ferme la parenth\xE8se avant \xAB ' + m + ' \xBB.');
      if (l) return f(d, 'Une comparaison relie deux membres : pas de \xAB = \xBB en plus.');
      ((i = !0), m === '\u2261' && (o = !0), (r = !0));
      continue;
    }
    if (yh(m)) {
      if (s > 0) return f(d, 'Ferme la parenth\xE8se avant le modulo \xAB ' + m + ' \xBB.');
      if (!o)
        return f(
          d,
          'Le modulo \xAB ' +
            m +
            ' \xBB suit une congruence : \xE9cris d\u2019abord \xAB \u2261 \xBB.',
        );
      a = !0;
      continue;
    }
    if (m === ')') {
      if (s === 0)
        return f(d, 'Cette parenth\xE8se fermante n\u2019a pas de parenth\xE8se ouvrante.');
      s--;
      continue;
    }
    if (!(m === '\xB2' || Ds(m) || m === '%' || m === '\xB0' || m === '!')) {
      if (m === 'ou') {
        if (s > 0) return f(d, 'Ferme la parenth\xE8se avant \xAB ou \xBB.');
        if (!i)
          return f(d, '\xC9cris d\u2019abord une \xE9galit\xE9 compl\xE8te avant \xAB ou \xBB.');
        if (o && !a)
          return f(d, 'Termine la congruence par son modulo (\xAB [7] \xBB) avant \xAB ou \xBB.');
        ((i = !1), (o = !1), (a = !1), (l = !1), (r = !0));
        continue;
      }
      return yt(m) || Ea(m)
        ? f(d, 'Deux nombres coll\xE9s : ajoute une op\xE9ration entre les deux.')
        : f(d, 'Ce bout ne peut pas venir ici.');
    }
  }
  return { ok: !0, complete: !r && s === 0 && c === 0 && (!o || a), hasEq: i };
}
var dI = { ln: 1, exp: 1, cos: 1, sin: 1, tan: 1, arg: 1, arccos: 1, arcsin: 1, arctan: 1 };
function _x(e) {
  return dI[e.k] === 1;
}
var qm = '';
function X(e) {
  return { k: 'n', v: e };
}
function pf(e) {
  return { k: 's', n: e };
}
function V(e, n) {
  let t = [];
  return (
    n.forEach((r) => {
      r.k === e ? (t = t.concat(r.c)) : t.push(r);
    }),
    t.length === 1 ? t[0] : { k: e, c: t }
  );
}
function qe(e) {
  return e.k === 'n' ? X(-e.v) : e.k === 'neg' ? e.a : { k: 'neg', a: e };
}
function tn(e, n) {
  return { k: e, a: n };
}
function Ro(e, n, t) {
  return { k: e, a: n, b: t };
}
function ms(e, n) {
  return Ro('div', e, n);
}
function Ci(e, n) {
  return Ro('pow', e, n);
}
function qa(e) {
  return e.k === 'div' || e.k === 'pow' || e.k === 'binom';
}
function Cn(e) {
  return e.c ? e.c : qa(e) ? [e.a, e.b] : e.a ? [e.a] : [];
}
function Ei(e, n) {
  return e.c
    ? V(e.k, e.c.map(n))
    : qa(e)
      ? Ro(e.k, n(e.a), n(e.b))
      : e.k === 'neg'
        ? qe(n(e.a))
        : e.a
          ? tn(e.k, n(e.a))
          : e;
}
var Mx = {
    '\u2070': '0',
    '\xB9': '1',
    '\xB2': '2',
    '\xB3': '3',
    '\u2074': '4',
    '\u2075': '5',
    '\u2076': '6',
    '\u2077': '7',
    '\u2078': '8',
    '\u2079': '9',
    '\u207A': '+',
    '\u207B': '\u2212',
    ⁿ: 'n',
  },
  XT = {};
Object.keys(Mx).forEach((e) => {
  XT[Mx[e]] = e;
});
function YT(e, n) {
  let t = [[]],
    r = 0;
  return (
    e.forEach((s) => {
      (s === '(' && r++,
        s === ')' && r--,
        r === 0 && s === n ? t.push([]) : t[t.length - 1].push(s));
    }),
    t
  );
}
function mI(e) {
  let n = /^(\d+)(.+)$/.exec(e),
    t = n[2]
      .split('')
      .map((r) => Mx[r] || '')
      .join('');
  return Ci(X(Number(n[1])), $i(ne(Te(t))));
}
function $i(e) {
  let n = 0,
    t = () => e[n],
    r = () => e[n++];
  function s() {
    let f = [i()];
    for (; t() === '+' || t() === '\u2212'; ) {
      let d = r(),
        m = i();
      f.push(d === '\u2212' ? qe(m) : m);
    }
    return V('add', f);
  }
  function i() {
    let f = o();
    for (; t() === '\xD7' || t() === '\xF7'; ) {
      let d = r(),
        m = o();
      f = d === '\xD7' ? V('mul', [f, m]) : ms(f, m);
    }
    return f;
  }
  function o() {
    let f = a();
    for (; t() === 'parmi'; ) (r(), (f = Ro('binom', f, a())));
    return f;
  }
  function a() {
    return t() === '\u2212' ? (r(), qe(a())) : t() === '+' ? (r(), a()) : l();
  }
  function l() {
    let f = u();
    for (;;)
      if (t() === '\xB2' || t() === '%') f = tn(r() === '\xB2' ? 'sq' : 'pct', f);
      else if (t() === '\xB0') (r(), (f = tn('deg', f)));
      else if (t() === '!') (r(), (f = tn('fact', f)));
      else if (t() === '^') (r(), (f = Ci(f, a())));
      else if (Ds(t())) f = Ci(f, X(UT(r())));
      else break;
    return f;
  }
  function u() {
    let f = r();
    if (f === void 0) throw new Error('fin');
    if (Ea(f)) return mI(f);
    if (yt(f)) return X(Number(f.replace(',', '.')));
    if (jt(f) || Xt(f)) return pf(f);
    if (Dr(f)) return t() === '\u2212' ? (r(), tn(f, qe(u()))) : tn(f, u());
    if (f === '(') {
      let d = s();
      if (r() !== ')') throw new Error('parenth\xE8se');
      return d;
    }
    if (f === '\u221A') return tn('sqrt', l());
    if (f === '|') {
      let d = s();
      if (r() !== '|') throw new Error('barre');
      return tn('abs', d);
    }
    throw new Error('inattendu');
  }
  let c = s();
  if (n !== e.length) throw new Error('reste');
  return c;
}
function Ae(e, n) {
  return { dis: YT(e, 'ou').map((t) => hI(t, !!n?.chains)) };
}
var pI = { '<': 1, '\u2264': 1 },
  gI = { '>': 1, '\u2265': 1 };
function hI(e, n = !1) {
  let t = e[e.length - 1],
    r = t !== void 0 && yh(t) ? zT(t) : void 0,
    s = r === void 0 ? e : e.slice(0, -1),
    i = ZT(s, cu);
  if (i >= 0) {
    if (r !== void 0 || s.indexOf('=') >= 0 || s.indexOf('\u2261') >= 0)
      throw new Error('comparaison m\xEAl\xE9e \xE0 une \xE9galit\xE9');
    if (ZT(s.slice(i + 1), cu) >= 0) {
      if (!n) throw new Error('deux comparaisons');
      return bI(s);
    }
    return { sides: [$i(s.slice(0, i)), $i(s.slice(i + 1))], cmp: s[i] };
  }
  if (r === void 0 && s.indexOf('\u2261') < 0) return { sides: YT(s, '=').map($i) };
  let o = [[]],
    a = [],
    l = 0;
  s.forEach((c) => {
    (c === '(' && l++,
      c === ')' && l--,
      l === 0 && (c === '=' || c === '\u2261') ? (a.push(c), o.push([])) : o[o.length - 1].push(c));
  });
  let u = { sides: o.map($i), rels: a };
  return (r !== void 0 && (u.mod = r), u);
}
function bI(e) {
  let n = [[]],
    t = [],
    r = 0;
  e.forEach((o) => {
    if ((o === '(' && r++, o === ')' && r--, r === 0 && cu(o))) {
      if (o === '\u2248') throw new Error('\xAB \u2248 \xBB dans une cha\xEEne');
      (t.push(o), n.push([]));
    } else n[n.length - 1].push(o);
  });
  let s = t.every((o) => pI[o]),
    i = t.every((o) => gI[o]);
  if (!s && !i) throw new Error('cha\xEEne dans les deux sens');
  return { sides: n.map($i), chain: t };
}
function vI(e) {
  if (!Number.isFinite(e) || e < 0 || Math.abs(e - Math.round(e)) > 1e-9) return NaN;
  let n = 1;
  for (let t = 2; t <= Math.round(e); t++) n *= t;
  return n;
}
function kI(e, n) {
  let t = (o) => Number.isFinite(o) && o >= -1e-9 && Math.abs(o - Math.round(o)) <= 1e-9;
  if (!t(e) || !t(n)) return NaN;
  let r = Math.round(e),
    s = Math.round(n);
  if (s > r) return 0;
  s = Math.min(s, r - s);
  let i = 1;
  for (let o = 1; o <= s; o++) i = (i * (r - s + o)) / o;
  return i > 2 ** 53 ? i : Math.round(i);
}
function ZT(e, n) {
  let t = 0;
  for (let r = 0; r < e.length; r++) {
    let s = e[r];
    if (s === '(') t++;
    else if (s === ')') t--;
    else if (t === 0 && n(s)) return r;
  }
  return -1;
}
function La(e, n, t) {
  if (!Number.isFinite(n) || !Number.isFinite(t)) return !1;
  let r = Ce(n, t);
  switch (e) {
    case '>':
      return n > t && !r;
    case '<':
      return n < t && !r;
    case '\u2265':
      return n > t || r;
    case '\u2264':
      return n < t || r;
    case '\u2248':
      return Math.abs(n - t) <= 0.5 * 10 ** -Rh(t) + 1e-9;
  }
}
function Rh(e) {
  for (let n = 0; n <= 6; n++) if (Math.abs(Math.round(e * 10 ** n) / 10 ** n - e) < 1e-9) return n;
  return 6;
}
function Mi(e, n) {
  let t = 10 ** n;
  return Math.round((e + Math.sign(e) * 1e-12) * t) / t;
}
function eR(e, n) {
  let t = 10 ** n;
  return Math.trunc((e + Math.sign(e) * 1e-12) * t) / t;
}
function Ve(e) {
  return Ae(ne(Te(e)), { chains: !0 });
}
function Lm(e, n) {
  return { dis: [{ sides: [e, n] }] };
}
function H(e, n) {
  switch (e.k) {
    case 'n':
      return e.v;
    case 's':
      return n[e.n] !== void 0 ? n[e.n] : (Ca[e.n] ?? NaN);
    case 'add':
      return e.c.reduce((t, r) => t + H(r, n), 0);
    case 'mul':
      return e.c.reduce((t, r) => t * H(r, n), 1);
    case 'div': {
      let t = H(e.b, n);
      return t === 0 ? NaN : H(e.a, n) / t;
    }
    case 'pow':
      return xI(H(e.a, n), H(e.b, n));
    case 'neg':
      return -H(e.a, n);
    case 'sq': {
      let t = H(e.a, n);
      return t * t;
    }
    case 'sqrt': {
      let t = H(e.a, n);
      return t < 0 ? NaN : Math.sqrt(t);
    }
    case 'pct':
      return H(e.a, n) / 100;
    case 'deg':
      return (H(e.a, n) * Math.PI) / 180;
    case 'fact':
      return vI(H(e.a, n));
    case 'binom':
      return kI(H(e.b, n), H(e.a, n));
    case 'ln': {
      let t = H(e.a, n);
      return t > 0 ? Math.log(t) : NaN;
    }
    case 'log': {
      let t = H(e.a, n);
      return t > 0 ? Math.log10(t) : NaN;
    }
    case 'exp':
      return Math.exp(H(e.a, n));
    case 'cos':
      return Math.cos(H(e.a, n));
    case 'sin':
      return Math.sin(H(e.a, n));
    case 'tan': {
      let t = H(e.a, n);
      return Math.abs(Math.cos(t)) < 1e-12 ? NaN : Math.tan(t);
    }
    case 'abs':
      return Math.abs(H(e.a, n));
    case 'arccos': {
      let t = H(e.a, n);
      return t >= -1 - 1e-12 && t <= 1 + 1e-12
        ? (Math.acos(Math.max(-1, Math.min(1, t))) * 180) / Math.PI
        : NaN;
    }
    case 'arcsin': {
      let t = H(e.a, n);
      return t >= -1 - 1e-12 && t <= 1 + 1e-12
        ? (Math.asin(Math.max(-1, Math.min(1, t))) * 180) / Math.PI
        : NaN;
    }
    case 'arctan':
      return (Math.atan(H(e.a, n)) * 180) / Math.PI;
    case 'arg': {
      let t = H(e.a, n);
      return t > 0 ? 0 : t < 0 ? Math.PI : NaN;
    }
  }
  return NaN;
}
function Ce(e, n) {
  return (
    isFinite(e) && isFinite(n) && Math.abs(e - n) <= 1e-9 * Math.max(1, Math.abs(e), Math.abs(n))
  );
}
function Fe(e, n) {
  let t = n || {};
  return (e.k === 's' && !Xt(e.n) && (t[e.n] = 1), Cn(e).forEach((r) => Fe(r, t)), t);
}
function qx(e) {
  let n = {};
  return (e.dis.forEach((t) => t.sides.forEach((r) => Fe(r, n))), n);
}
function pt(e, n) {
  return Object.keys(Fe(e)).every((t) => n[t] !== void 0);
}
function ds(e, n) {
  if (!pt(e, n)) return null;
  let t = H(e, n);
  return isFinite(t) ? t : null;
}
function De(e, n) {
  return !pt(e, n);
}
function ps(e, n) {
  return Object.keys(qx(e)).some((t) => n[t] === void 0);
}
function Mm(e, n, t) {
  let r = n.map((s) => ds(s, t));
  return r.some((s) => s === null)
    ? null
    : e === 'add'
      ? r.reduce((s, i) => s + i, 0)
      : r.reduce((s, i) => s * i, 1);
}
function Ne(e) {
  return e.k === 'n'
    ? pe(e.v)
    : e.k === 's'
      ? e.n
      : e.c
        ? e.k + '(' + e.c.map(Ne).sort().join(',') + ')'
        : qa(e)
          ? e.k + '(' + Ne(e.a) + ',' + Ne(e.b) + ')'
          : e.k + '(' + Ne(e.a) + ')';
}
function Yt(e) {
  if (!isFinite(e)) return !1;
  let n = Number(pe(e).replace('\u2212', '-').replace(',', '.'));
  return Math.abs(n - e) <= Math.max(1e-10, 1e-13 * Math.abs(e));
}
function xI(e, n) {
  if (e >= 0 || Number.isInteger(n) || !isFinite(n)) return Math.pow(e, n);
  let t = $h(n);
  if (!t || t[1] % 2 === 0) return NaN;
  let r = Math.pow(-e, n);
  return Math.abs(t[0]) % 2 === 1 ? -r : r;
}
function $h(e) {
  if (!isFinite(e)) return null;
  for (let n = 2; n <= 1e3; n++) {
    let t = Math.round(e * n);
    if (Math.abs(t / n - e) < 1e-12 * Math.max(1, Math.abs(e))) return [t, n];
  }
  return null;
}
function gf(e, n, t, r) {
  if (e.k === 's') {
    let s = n[e.n];
    if (s === void 0 || t) return e;
    if (Yt(s)) return X(s);
    let i = $h(s);
    return i ? ms(X(i[0]), X(i[1])) : (r?.[e.n] ?? e);
  }
  return Ei(e, (s) => gf(s, n, !1, r));
}
function nR(e, n) {
  return { dis: e.dis.map((t) => ({ sides: t.sides.map((r) => gf(r, n)) })) };
}
function Nm(e, n, t) {
  return e.k === 's' ? (e.n === n ? t : e) : Ei(e, (r) => Nm(r, n, t));
}
function Ri(e) {
  return (e.k === 'n' && e.v >= 0) || e.k === 's' || e.k === 'abs' || !!Lx(e);
}
function HT(e) {
  let n = pe(Math.abs(e));
  return e < 0 ? ['\u2212', n] : [n];
}
function Lx(e) {
  if (e.k !== 'pow' || e.a.k !== 'n' || e.a.v < 0 || !Number.isInteger(e.a.v)) return null;
  let n = e.b,
    t = null;
  if (
    (n.k === 'n' && n.v >= 0 && Number.isInteger(n.v)
      ? (t = String(n.v))
      : n.k === 's' && n.n.length === 1
        ? (t = n.n)
        : n.k === 'add' &&
          n.c.length === 2 &&
          n.c[0].k === 's' &&
          n.c[0].n.length === 1 &&
          n.c[1].k === 'n' &&
          Number.isInteger(n.c[1].v) &&
          (t = n.c[0].n + (n.c[1].v < 0 ? '\u2212' : '+') + Math.abs(n.c[1].v)),
    t === null)
  )
    return null;
  let r = t.split('').map((s) => XT[s]);
  return r.some((s) => !s) ? null : String(e.a.v) + r.join('');
}
function yr(e, n) {
  let t = Br(e);
  return n ? ['('].concat(t).concat([')']) : t;
}
function WT(e) {
  if (e.k === 'mul' && e.c[0].k === 'n' && e.c[0].v < 0) {
    let t = e.c.slice(1);
    return ['(']
      .concat(Br(e.c[0]))
      .concat([')', '\xD7'])
      .concat(
        t.length === 1
          ? yr(t[0], t[0].k === 'add' || t[0].k === 'neg' || (t[0].k === 'n' && t[0].v < 0))
          : Br(V('mul', t)),
      );
  }
  let n = Br(e);
  return e.k === 'add' || e.k === 'binom' || n[0] === '\u2212' ? ['('].concat(n).concat([')']) : n;
}
function Br(e) {
  switch (e.k) {
    case 'n':
      return HT(e.v);
    case 's':
      return [e.n];
    case 'add': {
      let n = [];
      return (
        e.c.forEach((t, r) => {
          if (r === 0) {
            n = n.concat(Br(t));
            return;
          }
          if (t.k === 'n' && t.v < 0) (n.push('\u2212'), (n = n.concat(HT(-t.v))));
          else if (t.k === 'neg') (n.push('\u2212'), (n = n.concat(WT(t.a))));
          else if (t.k === 'mul' && t.c[0].k === 'n' && t.c[0].v < 0)
            (n.push('\u2212'), (n = n.concat(Br(V('mul', [X(-t.c[0].v)].concat(t.c.slice(1)))))));
          else {
            let s = Br(t);
            (n.push('+'), (n = n.concat(s[0] === '\u2212' ? ['('].concat(s).concat([')']) : s)));
          }
        }),
        n
      );
    }
    case 'mul': {
      if (e.c[0].k === 'n' && e.c[0].v < 0)
        return ['\u2212'].concat(Br(V('mul', [X(-e.c[0].v)].concat(e.c.slice(1)))));
      let n = [];
      return (
        e.c.forEach((t, r) => {
          let s = e.c[r - 1],
            i =
              s &&
              ((s.k === 'n' &&
                s.v >= 0 &&
                (t.k === 's' || t.k === 'add' || (t.k === 'sq' && t.a.k === 's'))) ||
                (s.k === 'add' && t.k === 'add') ||
                (s.k === 's' && t.k === 'add') ||
                !1);
          (r > 0 && !i && n.push('\xD7'),
            (n = n.concat(
              yr(
                t,
                t.k === 'add' ||
                  t.k === 'neg' ||
                  (t.k === 'n' && t.v < 0 && r > 0) ||
                  (t.k === 'div' && r > 0) ||
                  t.k === 'binom',
              ),
            )));
        }),
        n
      );
    }
    case 'div':
      return yr(e.a, e.a.k === 'add' || e.a.k === 'neg' || e.a.k === 'binom')
        .concat(['\xF7'])
        .concat(yr(e.b, !Ri(e.b) && e.b.k !== 'sq' && e.b.k !== 'pct'));
    case 'pow': {
      let n = Lx(e);
      return n
        ? [n]
        : yr(e.a, !Ri(e.a) || e.a.k === 'pow')
            .concat(['^'])
            .concat(yr(e.b, !Ri(e.b)));
    }
    case 'neg':
      return ['\u2212'].concat(WT(e.a));
    case 'sq':
      return yr(e.a, !Ri(e.a) || e.a.k === 'pow').concat(['\xB2']);
    case 'pct':
      return yr(e.a, !Ri(e.a)).concat(['%']);
    case 'deg':
      return yr(e.a, !Ri(e.a)).concat(['\xB0']);
    case 'fact':
      return yr(e.a, !Ri(e.a)).concat(['!']);
    case 'binom':
      return yr(e.a, !Ri(e.a))
        .concat(['parmi'])
        .concat(yr(e.b, !Ri(e.b)));
    case 'sqrt':
      return ['\u221A'].concat(yr(e.a, !Ri(e.a)));
    case 'abs':
      return ['|'].concat(Br(e.a)).concat(['|']);
    case 'arg':
    case 'ln':
    case 'log':
    case 'exp':
    case 'cos':
    case 'sin':
    case 'tan':
    case 'arccos':
    case 'arcsin':
    case 'arctan':
      return [e.k].concat(yr(e.a, !0));
  }
  return [];
}
function zr(e) {
  let n = [];
  return (
    e.dis.forEach((t, r) => {
      (r && n.push('ou'),
        t.sides.forEach((s, i) => {
          (i && n.push(t.chain ? t.chain[i - 1] : (t.cmp ?? (t.rels ? t.rels[i - 1] : '='))),
            (n = n.concat(Br(s))));
        }),
        t.mod !== void 0 && n.push('[' + t.mod + ']'));
    }),
    n
  );
}
function ot(e) {
  let n = '',
    t = !1,
    r = !1;
  return (
    e.forEach((s, i) => {
      let o = e[i - 1],
        a = e[i - 2];
      if (s === '\xF7') {
        ((n += '/'), (r = !1));
        return;
      }
      if (i && (r || (s === '|' && t))) {
        ((n += s), (r = !1), s === '|' && (t = !t));
        return;
      }
      ((r = s === '|' && !t),
        s === '|' && (t = !t),
        i &&
          (s[0] === '\u2009' ||
          s === '\xB2' ||
          s === ')' ||
          o === '\xF7' ||
          s === '^' ||
          o === '^' ||
          s === '\xB0' ||
          s === '!' ||
          (Dr(o) && s === '(')
            ? (n += '')
            : s === '%'
              ? (n += '\u202F')
              : o === '(' ||
                  o === '\u221A' ||
                  (o === '\u2212' &&
                    (a === void 0 || a === '=' || a === '(' || a === 'ou' || /^[+−×÷]$/.test(a))) ||
                  (o === '+' && a === '(') ||
                  ((yt(o) || o === ')' || o === '\xB2') &&
                    (jt(s) || Xt(s) || Dr(s) || s === '(')) ||
                  (jt(o) && s === '(') ||
                  (jt(o) && jt(s) && o.length === 1 && s.length === 1)
                ? (n += '')
                : (n += ' ')),
        (n += s));
    }),
    n
  );
}
function z(e) {
  return ot(Br(e));
}
function Ke(e) {
  return ot(zr(e));
}
function Ma(e) {
  return e.k === 'n' || e.k === 's' || (Lx(e) && De(e, {}))
    ? 0
    : e.c
      ? e.c.length - 1 + e.c.reduce((n, t) => n + Ma(t), 0)
      : qa(e)
        ? 1 + Ma(e.a) + Ma(e.b)
        : 1 + Ma(e.a);
}
function fr(e) {
  return (
    ((e.k === 'mul' && e.c.some((t) => t.k === 'add')) || (e.k === 'sq' && e.a.k === 'add')
      ? 2
      : 0) + Cn(e).reduce((t, r) => t + fr(r), 0)
  );
}
function Th(e, n) {
  return e.k === 's' ? (n[e.n] !== void 0 ? 1 : 0) : Cn(e).reduce((t, r) => t + Th(r, n), 0);
}
function gs(e, n) {
  return e.sides.reduce((t, r) => {
    let s = Ma(r) + fr(r);
    return t + s + Th(r, n) + (De(r, n) ? 10 * s : 0);
  }, 0);
}
var Ch = [
  [1.37, 2.11, 0.83],
  [2.9, 0.61, 3.7],
  [0.53, 3.3, 1.9],
  [4.1, 1.7, 2.6],
  [1.13, 4.6, 0.97],
];
function Nx(e, n, t) {
  let r = Object.assign({}, e);
  return (
    n.forEach((s, i) => {
      r[s] = Ch[t][i % 3] + i * 0.17;
    }),
    r
  );
}
function Ox(e, n, t) {
  if (e.sides.length !== 2 || n.sides.length !== 2) return !1;
  let r = Object.keys(Fe({ k: 'add', c: e.sides })).sort(),
    s = Object.keys(Fe({ k: 'add', c: n.sides })).sort();
  if (r.join() !== s.join()) return !1;
  let i = r.filter((a) => t[a] === void 0),
    o = null;
  for (let a = 0; a < Ch.length; a++) {
    let l = Nx(t, i, a),
      u = H(e.sides[0], l) - H(e.sides[1], l),
      c = H(n.sides[0], l) - H(n.sides[1], l);
    if (!isFinite(u) || !isFinite(c)) return !1;
    let f = Math.abs(u) < 1e-9,
      d = Math.abs(c) < 1e-9;
    if (f !== d) return !1;
    if (!f) {
      let m = u / c;
      if (o === null) o = m;
      else if (!Ce(m, o)) return !1;
    }
    if (!i.length) break;
  }
  return !0;
}
function Kx(e, n, t) {
  return e.dis.length !== n.dis.length
    ? !1
    : Px(n.dis.map((r, s) => s)).some((r) => e.dis.every((s, i) => Ox(s, n.dis[r[i]], t)));
}
function Eh(e, n, t) {
  let r = Object.keys(Fe({ k: 'add', c: [e, n] })).filter((s) => t[s] === void 0);
  for (let s = 0; s < Ch.length; s++) {
    let i = Nx(t, r, s);
    if (!Ce(H(e, i), H(n, i))) return !1;
    if (!r.length) break;
  }
  return !0;
}
function Px(e) {
  if (e.length <= 1) return [e.slice()];
  let n = [];
  return (
    e.forEach((t, r) => {
      Px(e.slice(0, r).concat(e.slice(r + 1))).forEach((s) => n.push([t].concat(s)));
    }),
    n
  );
}
function mf() {
  return { ev: 0, sub: 0 };
}
function fs(...e) {
  let n = mf();
  return (
    e.forEach((t) => {
      ((n.ev += t.ev), (n.sub += t.sub));
    }),
    n
  );
}
function df(e) {
  return e ? { mis: e.mis, at: e.at } : null;
}
function _a(e, n) {
  e && n && ((e.mis = n.mis), (e.at = n.at));
}
function Ex(e) {
  if (e.k !== 'mul') return null;
  let n = e.c[0];
  if (n.k === 'neg' && n.a.k !== 'n') return { k: 'neg', a: V('mul', [n.a, ...e.c.slice(1)]) };
  let t = n.k === 'n' && n.v < 0 ? -n.v : n.k === 'neg' && n.a.k === 'n' ? n.a.v : null;
  if (t === null) return null;
  let r = e.c.slice(1);
  return { k: 'neg', a: t === 1 && r.length === 1 ? r[0] : V('mul', [X(t), ...r]) };
}
function Qt(e, n, t, r) {
  if (e.k === 'n') {
    let o = ds(n, t);
    return o === null
      ? null
      : Ce(o, e.v)
        ? { ev: n.k === 'n' || n.k === 's' ? 0 : 1, sub: Th(n, t) }
        : r && r.mis < r.max && n.k !== 'n'
          ? (r.mis++, (r.at = { wrote: e.v, expected: o, f: n }), mf())
          : null;
  }
  if (e.k === 's') return n.k === 's' && n.n === e.n ? mf() : null;
  if (
    (e.k === 'neg' || (e.k === 'mul' && Ex(e))) &&
    !Object.keys(Fe(e)).length &&
    n.k !== 'n' &&
    pt(n, t)
  ) {
    let o = ds(e, t),
      a = ds(n, t);
    if (o !== null && a !== null && Ce(o, a)) return { ev: 1, sub: Th(n, t) };
  }
  let s = Ex(e),
    i = Ex(n);
  if (s && n.k === 'neg') return Qt(s, n, t, r);
  if (i && e.k === 'neg') {
    let o = Qt(e, i, t, r);
    return o || i.a.k === 'mul' ? o : Qt(e, { k: 'neg', a: V('mul', [X(1), i.a]) }, t, r);
  }
  if (e.k !== n.k) {
    if (n.k === 'sq' && e.k === 'mul' && e.c.length === 2) {
      let o = df(r),
        a = Qt(e.c[0], n.a, t, r),
        l = a && Qt(e.c[1], n.a, t, r);
      return a && l ? fs(a, l, { ev: 1, sub: 0 }) : (_a(r, o), null);
    }
    if (n.k === 'pct' && e.k === 'div' && e.b.k === 'n' && e.b.v === 100) {
      let o = Qt(e.a, n.a, t, r);
      return o ? fs(o, { ev: 1, sub: 0 }) : null;
    }
    return n.k === 'add' || n.k === 'mul' ? JT({ k: n.k, c: [e] }, n, t, r) : null;
  }
  if (e.c) return JT(e, n, t, r);
  if (qa(e)) {
    let o = df(r),
      a = Qt(e.a, n.a, t, r),
      l = a && Qt(e.b, n.b, t, r);
    return a && l ? fs(a, l) : (_a(r, o), null);
  }
  return Qt(e.a, n.a, t, r);
}
function JT(e, n, t, r) {
  let s = e.c,
    i = [],
    o = [];
  n.c.forEach((f) => (pt(f, t) ? i : o).push(f));
  let a = null,
    l = s.map(() => !1);
  function u(f, d) {
    if (f === o.length) {
      let m = c();
      if (m) {
        let p = fs(d, m);
        (!a || p.ev < a.ev) && (a = p);
      }
      return;
    }
    for (let m = 0; m < s.length; m++) {
      if (l[m]) continue;
      let p = df(r),
        g = Qt(s[m], o[f], t, r);
      if (!g) {
        _a(r, p);
        continue;
      }
      if (((l[m] = !0), u(f + 1, fs(d, g)), (l[m] = !1), a)) return;
      _a(r, p);
    }
  }
  function c() {
    let f = s.filter((g, h) => !l[h]),
      d = i.length;
    if (f.length === d && d > 4) {
      let g = df(r),
        h = mf();
      for (let b = 0; b < d && h; b++) {
        let v = Qt(f[b], i[b], t, r);
        h = v ? fs(h, v) : null;
      }
      if (h) return h;
      _a(r, g);
    }
    let m = f.length + 1,
      p = Math.pow(m, d);
    if (d > 8 || p > 2e5) return null;
    for (let g = 0; g < p; g++) {
      let h = f.map(() => []),
        b = [],
        v = g;
      for (let S = 0; S < d; S++) {
        let w = v % m;
        ((v = Math.floor(v / m)), w === f.length ? b.push(i[S]) : h[w].push(i[S]));
      }
      if (b.length) {
        let S = Mm(n.k, b, t);
        if (S === null || !Ce(S, n.k === 'add' ? 0 : 1)) continue;
      }
      let k = df(r),
        y = { ev: b.length ? 1 : 0, sub: 0 };
      for (let S = 0; S < f.length && y; S++) {
        let w = h[S];
        if (!w.length) {
          y = null;
          break;
        }
        if (w.length === 1) {
          let _ = Qt(f[S], w[0], t, r);
          y = _ ? fs(y, _) : null;
        } else {
          if (f[S].k !== 'n') {
            y = null;
            break;
          }
          let _ = Mm(n.k, w, t);
          y = _ !== null && Ce(_, f[S].v) ? fs(y, { ev: 1, sub: 0 }) : null;
        }
      }
      if (y) return y;
      _a(r, k);
    }
    return null;
  }
  return (u(0, mf()), a);
}
function Mh(e, n, t, r) {
  if (e.sides.length !== 2 || n.sides.length !== 2) return null;
  let s = df(r),
    i = Qt(e.sides[0], n.sides[0], t, r),
    o = i && Qt(e.sides[1], n.sides[1], t, r);
  return (i && o) ||
    (_a(r, s),
    (i = Qt(e.sides[0], n.sides[1], t, r)),
    (o = i && Qt(e.sides[1], n.sides[0], t, r)),
    i && o)
    ? fs(i, o)
    : (_a(r, s), null);
}
function hs(e, n, t, r) {
  if (e.dis.length !== n.dis.length) return null;
  let s = Px(n.dis.map((i, o) => o));
  for (let i = 0; i < s.length; i++) {
    let o = mf(),
      a = !0;
    for (let l = 0; l < e.dis.length && a; l++) {
      let u = Mh(e.dis[l], n.dis[s[i][l]], t, r);
      u ? (o = fs(o, u)) : (a = !1);
    }
    if (a) return o;
  }
  return null;
}
function _m(e, n) {
  let t = e.k === 'neg' ? e.a : e;
  return (t.k === 'mul' ? t.c : [t]).filter((s) => De(s, n));
}
function yI(e, n, t) {
  let r = Object.keys(Fe({ k: 'add', c: [e, n] })).filter((i) => t[i] === void 0),
    s = null;
  for (let i = 0; i < Ch.length; i++) {
    let o = Nx(t, r, i),
      a = H(e, o),
      l = H(n, o);
    if (!isFinite(a) || !isFinite(l) || Math.abs(l) < 1e-12) return !1;
    if (s === null) s = a / l;
    else if (!Ce(a / l, s)) return !1;
  }
  return !0;
}
function tR(e, n, t) {
  let r = _m(n, t);
  if (r.length <= 1) return !0;
  let s = _m(e, t);
  return r.every((i) => s.some((o) => yI(o, i, t)));
}
function fu(e, n, t, r) {
  if (e.sides.length !== 2 || n.sides.length !== 2) return null;
  for (let s = 0; s < 2; s++)
    for (let i = 0; i < 2; i++) {
      let o = e.sides[i],
        a = e.sides[1 - i],
        l = n.sides[s],
        u = n.sides[1 - s];
      if (Qt(o, l, t) && Eh(a, u, t) && (r || tR(u, a, t))) return { from: u, to: a };
    }
  return null;
}
var rR = 32768;
function uR(e) {
  return Number.isInteger(e) && Math.abs(e) <= Number.MAX_SAFE_INTEGER ? BigInt(e) : null;
}
function sR(e) {
  return (e < 0n ? -e : e).toString(2).length;
}
function Ct(e, n) {
  switch (e.k) {
    case 'n':
      return uR(e.v);
    case 's':
      return n[e.n] ?? null;
    case 'add': {
      let t = 0n;
      for (let r of e.c) {
        let s = Ct(r, n);
        if (s === null) return null;
        t += s;
      }
      return t;
    }
    case 'mul': {
      let t = 1n;
      for (let r of e.c) {
        let s = Ct(r, n);
        if (s === null || ((t *= s), sR(t) > rR)) return null;
      }
      return t;
    }
    case 'neg': {
      let t = Ct(e.a, n);
      return t === null ? null : -t;
    }
    case 'sq': {
      let t = Ct(e.a, n);
      return t === null ? null : t * t;
    }
    case 'pow': {
      let t = Ct(e.a, n),
        r = Ct(e.b, n);
      return t === null || r === null || r < 0n
        ? null
        : t === 0n || t === 1n || t === -1n
          ? r === 0n
            ? 1n
            : t === -1n && r % 2n
              ? -1n
              : t
          : Number(r) * sR(t) > rR
            ? null
            : t ** r;
    }
    case 'div': {
      let t = Ct(e.a, n),
        r = Ct(e.b, n);
      return t === null || r === null || r === 0n || t % r !== 0n ? null : t / r;
    }
    default:
      return null;
  }
}
function Na(e, n) {
  let t = e % n;
  return t < 0n ? t + n : t;
}
function wI(e, n, t) {
  let r = 1n % t,
    s = Na(e, t),
    i = n;
  for (; i > 0n; ) (i & 1n && (r = (r * s) % t), (s = (s * s) % t), (i >>= 1n));
  return r;
}
function $o(e, n, t) {
  switch (e.k) {
    case 'n': {
      let r = uR(e.v);
      return r === null ? null : Na(r, n);
    }
    case 's': {
      let r = t[e.n];
      return r === void 0 ? null : Na(r, n);
    }
    case 'add': {
      let r = 0n;
      for (let s of e.c) {
        let i = $o(s, n, t);
        if (i === null) return null;
        r = (r + i) % n;
      }
      return r;
    }
    case 'mul': {
      let r = 1n % n;
      for (let s of e.c) {
        let i = $o(s, n, t);
        if (i === null) return null;
        r = (r * i) % n;
      }
      return r;
    }
    case 'neg': {
      let r = $o(e.a, n, t);
      return r === null ? null : Na(-r, n);
    }
    case 'sq': {
      let r = $o(e.a, n, t);
      return r === null ? null : (r * r) % n;
    }
    case 'pow': {
      let r = $o(e.a, n, t),
        s = Ct(e.b, t);
      return r === null || s === null || s < 0n ? null : wI(r, s, n);
    }
    case 'div': {
      let r = Ct(e, t);
      return r === null ? null : Na(r, n);
    }
    default:
      return null;
  }
}
function Et(e) {
  if (e.k === 'n' || e.k === 's') return e;
  if (e.k === 'sq') return Ci(Et(e.a), X(2));
  if (e.k === 'neg') return qe(Et(e.a));
  if (e.k === 'pow') return Ci(Et(e.a), Et(e.b));
  if (e.k === 'mul') {
    let n = V('mul', e.c.map(Et));
    if (n.k !== 'mul') return n;
    let t = n.c.filter((r) => !(r.k === 'n' && r.v === 1));
    return t.length ? (t.length === 1 ? t[0] : { k: 'mul', c: t }) : X(1);
  }
  return e.k === 'add'
    ? V('add', e.c.map(Et))
    : e.k === 'div'
      ? { k: 'div', a: Et(e.a), b: Et(e.b) }
      : e;
}
function _i(e) {
  return Ne(Et(e));
}
function iR(e) {
  let n = Et(e);
  return n.k === 'mul' ? n.c.slice() : [n];
}
function Bs(e) {
  return Object.keys(Fe(e)).length === 0;
}
function SI(e) {
  if (e < 2 || !Number.isInteger(e)) return !1;
  for (let n = 2; n * n <= e; n++) if (e % n === 0) return !1;
  return !0;
}
function Oa(e, n) {
  let t = n;
  for (; e.parent.has(t) && e.parent.get(t) !== t; ) t = e.parent.get(t);
  return t;
}
function TI(e, n, t) {
  let r = _i(n),
    s = _i(t);
  return r === s || (e.parent.has(r) && e.parent.has(s) && Oa(e, r) === Oa(e, s));
}
function RI(e, n, t) {
  let r = _i(n),
    s = _i(t);
  [
    [r, n],
    [s, t],
  ].forEach(([a, l]) => {
    e.parent.has(a) || (e.parent.set(a, a), e.nodes.set(a, Et(l)));
  });
  let i = Oa(e, r),
    o = Oa(e, s);
  return i === o ? !1 : (e.parent.set(i, o), !0);
}
function cR(e) {
  return { ...e, parent: new Map(e.parent), nodes: new Map(e.nodes), facts: e.facts.slice() };
}
var $I = [-4, 3, 11, 17];
function Qx(e, n, t) {
  let r = Object.keys(Fe({ k: 'add', c: n })),
    s = [{}];
  for (let i of r) {
    let o = t ? $I : (e.reps[i] ?? []);
    if (!o.length) return [];
    let a = [];
    (s.forEach((l) => o.forEach((u) => a.push({ ...l, [i]: BigInt(u) }))), (s = a));
  }
  return s;
}
function qh(e, n, t) {
  let r = Qx(e, [n, t], !0);
  return r.length
    ? r.every((s) => {
        let i = Ct(n, s),
          o = Ct(t, s);
        if (i !== null && o !== null) return i === o;
        let a = {};
        return (Object.keys(s).forEach((l) => (a[l] = Number(s[l]))), Ce(H(n, a), H(t, a)));
      })
    : !1;
}
function fR(e, n, t) {
  let r = Qx(e, [n, t], !1);
  if (!r.length) return !1;
  let s = !0;
  for (let i of r) {
    let o = $o(n, e.N, i),
      a = $o(t, e.N, i);
    if (o === null || a === null) return null;
    o !== a && (s = !1);
  }
  return s;
}
function _h(e, n) {
  if (!Bs(n)) return null;
  let t = $o(n, e.N, {});
  return t === null ? null : t.toString();
}
function dR(e, n) {
  for (let t = 0; t + 1 < n.sides.length; t++) {
    let r = n.rels ? n.rels[t] : '=',
      s = n.sides[t],
      i = n.sides[t + 1];
    if (r === '=') {
      if (!qh(e, s, i)) return { ok: !1, at: t };
    } else {
      let o = fR(e, s, i);
      if (o === null) return { ok: !1, at: t, impossible: !0 };
      if (!o) return { ok: !1, at: t };
    }
  }
  return { ok: !0, at: -1 };
}
function mR(e) {
  return BigInt(Math.max(100, 10 * e.n));
}
function Ax(e, n) {
  if (n.k !== 'n' && !(n.k === 'neg' && n.a.k === 'n')) return null;
  let t = Ct(n, {});
  if (t === null) return null;
  let r = mR(e);
  return t <= r && t >= -r ? t : null;
}
function oR(e, n) {
  let t = Et(n.k === 'neg' ? n.a : n);
  if (t.k === 'n') {
    let r = Ct(t, {});
    return r !== null && r !== 0n && r % e.N === 0n;
  }
  return t.k === 'mul'
    ? t.c.some((r) => {
        if (r.k !== 'n') return !1;
        let s = Ct(r, {});
        return s !== null && s % e.N === 0n;
      })
    : !1;
}
var CI = 'R\xE9duction modulo ',
  EI = 'Remplacement par une congruence \xE9tablie',
  MI = 'Puissance d\u2019une congruence',
  jx = 'Petit th\xE9or\xE8me de Fermat';
function hf(e, n, t, r = 0) {
  if (r > 12) return null;
  let s = Et(n),
    i = Et(t);
  if (Ne(s) === Ne(i)) return '';
  if (TI(e, s, i)) return EI;
  let o = CI + e.n,
    a = Ax(e, s),
    l = Ax(e, i);
  if (a !== null && l !== null) return Na(a - l, e.N) === 0n ? o : null;
  if (SI(e.n) && s.k === 'pow' && s.a.k === 'n' && s.b.k === 'n') {
    let u = Ct(s.a, {}),
      c = s.b.v;
    if (
      u !== null &&
      Na(u, e.N) !== 0n &&
      ((c === e.n - 1 && i.k === 'n' && i.v === 1) || (c === e.n && Ne(i) === Ne(s.a)))
    )
      return jx;
  }
  if (s.k === 'neg' && i.k === 'neg') return hf(e, s.a, i.a, r + 1);
  if (i.k === 'n' && i.v === 0 && oR(e, s)) return o;
  if (s.k === 'add') {
    let u = s.c.filter((c) => !oR(e, c));
    if (u.length < s.c.length) {
      let c = u.length ? V('add', u) : X(0);
      if (hf(e, c, i, r + 1) !== null) return o;
    }
  }
  if (s.k === 'pow' && i.k === 'pow' && Ne(Et(s.b)) === Ne(Et(i.b))) {
    let u = hf(e, s.a, i.a, r + 1);
    if (u !== null) return u === '' ? '' : MI;
  }
  if (s.k === 'add' && i.k === 'add' && s.c.length === i.c.length) {
    let u = Ix(e, s.c, i.c, r);
    if (u !== null) return u;
  }
  if (s.k === 'mul' || i.k === 'mul') {
    let u = iR(s),
      c = iR(i);
    if (u.length === c.length) {
      let m = Ix(e, u, c, r);
      if (m !== null) return m;
    }
    let f = u.filter((m) => !Bs(m)),
      d = c.filter((m) => !Bs(m));
    if (d.length && f.length === d.length && Ix(e, f, d, r) !== null) {
      let m = u.filter(Bs),
        p = c.filter(Bs),
        g = Ct(V('mul', m.length ? m : [X(1)]), {}),
        h = Ct(V('mul', p.length ? p : [X(1)]), {}),
        b = mR(e);
      if (g !== null && h !== null && g <= b && g >= -b && Na(g - h, e.N) === 0n) return o;
    }
  }
  return null;
}
function Ix(e, n, t, r) {
  let s = new Set(),
    i = [];
  for (let o of n) {
    let a = -1;
    for (let l = 0; l < t.length && a < 0; l++) {
      if (s.has(l)) continue;
      let u = hf(e, o, t[l], r + 1);
      u !== null && ((a = l), u && i.push(u));
    }
    if (a < 0) return null;
    s.add(a);
  }
  return i.length ? i[0] : '';
}
function aR(e, n, t) {
  return _i(n) === _i(t) || qh(e, n, t) ? !0 : hf(e, n, t) !== null;
}
function _I(e, n, t) {
  for (let r of e.facts) {
    let s = r.eq.sides,
      i = s[0],
      o = s[s.length - 1];
    for (let [a, l] of [
      [i, o],
      [o, i],
    ]) {
      let u = Et(n),
        c = Et(t);
      if (u.k === 'mul' && u.c[0].k === 'n') {
        let f = u.c[0];
        if (f.v !== 1 && qh(e, u, V('mul', [f, a])) && qh(e, c, V('mul', [f, l])))
          return 'Multiplier les deux membres par ' + z(f);
      }
      if (aR(e, a, n) && aR(e, l, t)) return 'R\xE9duction modulo ' + e.n;
    }
  }
  return null;
}
function pR(e, n) {
  let t = {};
  Object.entries(e.symbols).forEach(([o, a]) => {
    let l = a.given && a.value !== void 0 ? [a.value] : (a.values ?? []);
    l.length && (t[o] = l.flatMap((u) => [u, u + n.mod]));
  });
  let r = Ve(n.target).dis[0].sides[0],
    s = {
      n: n.mod,
      N: BigInt(n.mod),
      target: r,
      residue: 0,
      reps: t,
      parent: new Map(),
      nodes: new Map(),
      facts: [],
    },
    i = n.residue ?? null;
  if (i === null) {
    let o = Qx(s, [r], !1)[0],
      a = o ? $o(r, s.N, o) : null;
    i = a === null ? 0 : Number(a);
  }
  return (
    (s.residue = i),
    (e.givens || []).forEach((o) => bf(s, Ve(o).dis[0], 'given')),
    (e.admitted || []).forEach((o) => bf(s, Ve(o).dis[0], 'given')),
    s
  );
}
function bf(e, n, t) {
  let r = 0;
  for (let s = 0; s + 1 < n.sides.length; s++) RI(e, n.sides[s], n.sides[s + 1]) && r++;
  return (e.facts.push({ eq: n, source: t }), r);
}
function vf(e) {
  let n = _i(e.target);
  if (!e.parent.has(n)) return !1;
  let t = Oa(e, n);
  for (let [r, s] of e.nodes)
    if (
      !(Oa(e, r) !== t || s.k !== 'n') &&
      Number.isInteger(s.v) &&
      s.v >= 0 &&
      s.v < e.n &&
      s.v === e.residue
    )
      return !0;
  return !1;
}
function gR(e) {
  let n = _i(e.target);
  if (!e.parent.has(n)) return [];
  let t = Oa(e, n),
    r = [];
  return (
    e.nodes.forEach((s, i) => {
      Oa(e, i) === t &&
        s.k === 'n' &&
        Number.isInteger(s.v) &&
        s.v >= 0 &&
        s.v < e.n &&
        r.push(s.v);
    }),
    r
  );
}
function hR(e, n) {
  return n.dis.every((t) => dR(e, t).ok);
}
function qI(e, n, t) {
  return e[n] !== void 0 ? e[n] : t - 1;
}
function Fx(e, n, t, r) {
  let s = wt(t),
    i = s.atoms;
  if (!i.length) return { kind: 'empty', atoms: i, badChip: -1 };
  let o = vn(i);
  if (!o.ok)
    return {
      kind: 'syntax',
      atoms: i,
      title: '\xC7a commence mal',
      message: o.msg,
      badChip: qI(s.src, o.index, t.length),
    };
  if (!o.complete || !o.hasEq) return { kind: 'open', atoms: i, complete: !1 };
  let a;
  try {
    a = Ae(i);
  } catch {
    return { kind: 'open', atoms: i, complete: !1 };
  }
  let l = NI(e, n, a, i);
  return !r?.verify && (l.kind === 'unjustified' || l.kind === 'false')
    ? { kind: 'pending', atoms: i, complete: !0 }
    : l;
}
function LI(e, n) {
  let t = lR(n);
  for (let r of e.traps || [])
    try {
      let s = Ve(r.line);
      if (lR(s) === t) return { line: s, title: r.title, why: r.why };
    } catch {}
  return null;
}
function lR(e) {
  return e.dis
    .map((n) => _i(n.sides[0]) + '~' + _i(n.sides[n.sides.length - 1]) + '~' + (n.mod ?? ''))
    .join('|');
}
function NI(e, n, t, r) {
  if (t.dis.length !== 1)
    return {
      kind: 'unjustified',
      atoms: r,
      title: 'Une congruence \xE0 la fois',
      message: '\xC9cris une seule congruence (ou une seule cha\xEEne) par ligne.',
    };
  let s = t.dis[0],
    i = s.rels ?? s.sides.slice(1).map(() => '=');
  if (s.mod !== void 0 && s.mod !== e.n)
    return {
      kind: 'unjustified',
      atoms: r,
      title: 'Pas le bon modulo',
      message: `Dans cette question, on travaille modulo ${e.n} : termine ta congruence par [${e.n}].`,
    };
  let o = LI(n, t),
    a = dR(e, s);
  if (!a.ok) {
    if (o)
      return {
        kind: 'trap',
        atoms: r,
        title: 'Pi\xE8ge : ' + o.title.charAt(0).toLowerCase() + o.title.slice(1),
        message: o.why,
        trap: o,
        badChip: -1,
      };
    let h = s.sides[a.at],
      b = s.sides[a.at + 1];
    if (a.impossible)
      return {
        kind: 'false',
        atoms: r,
        title: 'Pas dans les entiers',
        message:
          'Une congruence relie des ENTIERS : on ne divise jamais. Pour \xAB diviser \xBB par a, on multiplie par un inverse de a modulo ' +
          e.n +
          '.',
      };
    if (i[a.at] === '=') {
      let y = _h(e, h),
        S = _h(e, b);
      return !(Bs(h) && Bs(b)) && fR(e, h, b)
        ? {
            kind: 'false',
            atoms: r,
            title: 'Ce n\u2019est pas une \xE9galit\xE9',
            message: `\xAB ${z(h)} \xBB et \xAB ${z(b)} \xBB ne sont pas \xE9gaux, seulement congrus : \xE9cris \xAB ${z(h)} \u2261 ${z(b)} [${e.n}] \xBB.`,
          }
        : {
            kind: 'false',
            atoms: r,
            title: 'Ce n\u2019est pas \xE9gal',
            message:
              `\xAB ${z(h)} = ${z(b)} \xBB est faux.` +
              (y !== null && S !== null && y === S
                ? ` Ces deux nombres sont seulement CONGRUS modulo ${e.n} : \xE9cris \xAB \u2261 \xBB, pas \xAB = \xBB.`
                : ''),
          };
    }
    let v = _h(e, h),
      k = _h(e, b);
    return {
      kind: 'false',
      atoms: r,
      title: 'Ce n\u2019est pas congru',
      message:
        `\xAB ${z(h)} \u2261 ${z(b)} [${e.n}] \xBB est faux` +
        (v !== null && k !== null
          ? ` : modulo ${e.n}, ${z(h)} a pour reste ${v} et ${z(b)} a pour reste ${k}.`
          : '.'),
    };
  }
  let l = [],
    u = !1;
  for (let h = 0; h + 1 < s.sides.length; h++) {
    let b = s.sides[h],
      v = s.sides[h + 1];
    if (i[h] === '=') {
      l.includes('Calcul') || l.push('Calcul');
      continue;
    }
    let k = hf(e, b, v);
    if ((k === null && h === 0 && !(Bs(b) && Bs(v)) && (k = _I(e, b, v)), k === null)) {
      let y = Bs(b) && (b.k !== 'n' || Ax(e, b) === null);
      return {
        kind: 'unjustified',
        atoms: r,
        keep: { line: t, kind: 'jump' },
        title: 'D\u2019o\xF9 vient ce maillon ?',
        message:
          `\xAB ${z(b)} \u2261 ${z(v)} [${e.n}] \xBB est vrai, mais il ne se justifie pas encore. ` +
          (y
            ? `Calcule d\u2019abord ${z(b)} avec \xAB = \xBB (ou d\xE9coupe la puissance), puis r\xE9duis modulo ${e.n}.`
            : Bs(b)
              ? 'R\xE9duis un nombre, ou remplace par une congruence que tu as d\xE9j\xE0 \xE9tablie.'
              : 'Pars d\u2019une congruence d\xE9j\xE0 \xE9crite : multiplie ses deux membres par un m\xEAme nombre, puis r\xE9duis.'),
      };
    }
    (k === jx && (u = !0), k && !l.includes(k) && l.push(k));
  }
  let c = vf(e),
    f = cR(e),
    d = bf(f, s, 'line');
  if (!d)
    return {
      kind: 'useless',
      atoms: r,
      line: t,
      title: 'Juste, mais \xE7a ne t\u2019avance pas',
      message: 'Chaque maillon est juste, mais tu avais d\xE9j\xE0 tout \xE7a.',
    };
  let m = !c && vf(f),
    p = Math.min(6, d + (u ? 1 : 0)),
    g = l.join(' \u2192 ') || 'Calcul';
  return {
    kind: 'step',
    atoms: r,
    line: t,
    final: m,
    hora: p,
    rule: {
      id: u ? 'fermat' : 'congruence',
      card: '',
      label: g,
      hora: p,
      why: m
        ? `Le reste est entre 0 et ${e.n - 1} : c\u2019est la r\xE9ponse.`
        : 'Chaque maillon est juste et justifi\xE9.',
    },
  };
}
function bR(e, n) {
  if (vf(e)) return !1;
  let t = cR(e);
  return (n.dis.forEach((r) => bf(t, r, 'line')), vf(t));
}
var Us = 'i',
  OI = (e, n) => [e[0] + n[0], e[1] + n[1]],
  Lh = (e, n) => [e[0] * n[0] - e[1] * n[1], e[0] * n[1] + e[1] * n[0]];
function Zx(e, n) {
  let t = n[0] * n[0] + n[1] * n[1];
  return t === 0 ? null : [(e[0] * n[0] + e[1] * n[1]) / t, (e[1] * n[0] - e[0] * n[1]) / t];
}
function KI(e, n) {
  if (!Number.isInteger(n) || Math.abs(n) > 5e3) return null;
  let t = [1, 0],
    r = e,
    s = Math.abs(n);
  for (; s; ) (s & 1 && (t = Lh(t, r)), (r = Lh(r, r)), (s >>= 1));
  return n < 0 ? Zx([1, 0], t) : t;
}
var Nh = (e) => (e && Math.abs(e[1]) < 1e-12 ? e[0] : null);
function un(e, n, t = [0, 1]) {
  let r = (s) => Nh(un(s, n, t));
  switch (e.k) {
    case 'n':
      return [e.v, 0];
    case 's':
      if (e.n === Us) return t;
      if (n[e.n] !== void 0) {
        let s = n[e.n];
        return typeof s == 'number' ? [s, 0] : s;
      }
      return Ca[e.n] !== void 0 ? [Ca[e.n], 0] : null;
    case 'add': {
      let s = [0, 0];
      for (let i of e.c) {
        let o = un(i, n, t);
        if (!o) return null;
        s = OI(s, o);
      }
      return s;
    }
    case 'mul': {
      let s = [1, 0];
      for (let i of e.c) {
        let o = un(i, n, t);
        if (!o) return null;
        s = Lh(s, o);
      }
      return s;
    }
    case 'div': {
      let s = un(e.a, n, t),
        i = un(e.b, n, t);
      return s && i ? Zx(s, i) : null;
    }
    case 'neg': {
      let s = un(e.a, n, t);
      return s ? [-s[0], -s[1]] : null;
    }
    case 'sq': {
      let s = un(e.a, n, t);
      return s ? Lh(s, s) : null;
    }
    case 'pow': {
      let s = un(e.a, n, t),
        i = r(e.b);
      if (!s || i === null) return null;
      if (Number.isInteger(i)) return KI(s, i);
      let o = Nh(s);
      return o !== null && o >= 0 ? [Math.pow(o, i), 0] : null;
    }
    case 'exp': {
      let s = un(e.a, n, t);
      if (!s) return null;
      let i = Math.exp(s[0]);
      return [i * Math.cos(s[1]), i * Math.sin(s[1])];
    }
    case 'abs': {
      let s = un(e.a, n, t);
      return s ? [Math.hypot(s[0], s[1]), 0] : null;
    }
    case 'arg': {
      let s = un(e.a, n, t);
      return !s || (Math.abs(s[0]) < 1e-12 && Math.abs(s[1]) < 1e-12)
        ? null
        : [Math.atan2(s[1], s[0]), 0];
    }
    case 'sqrt':
    case 'cos':
    case 'sin':
    case 'tan':
    case 'arccos':
    case 'arcsin':
    case 'arctan':
    case 'ln':
    case 'log':
    case 'deg':
    case 'pct':
    case 'fact': {
      let s = r(e.a);
      if (s === null) return null;
      let i = H({ ...e, a: { k: 'n', v: s } }, {});
      return Number.isFinite(i) ? [i, 0] : null;
    }
  }
  return null;
}
var Ur = (e, n) => !!e && !!n && Ce(e[0], n[0]) && Ce(e[1], n[1]);
function vR(e) {
  let n = Math.abs(e[0]) < 1e-9 ? 0 : e[0],
    t = Math.abs(e[1]) < 1e-9 ? 0 : e[1],
    r = (s) => (Ce(Math.abs(s), 1) ? '' : pe(Math.abs(s))) + 'i';
  return t
    ? n
      ? pe(n) + (t < 0 ? ' \u2212 ' : ' + ') + r(t)
      : (t < 0 ? '\u2212' : '') + r(t)
    : pe(n);
}
function Oh(e) {
  return (e.k === 's' && e.n === Us) || Cn(e).some(Oh);
}
function Eo(e, n) {
  return n.k === 's' ? n.n === Us || Array.isArray(e.env[n.n]) : Cn(n).some((t) => Eo(e, t));
}
function Vx(e, n) {
  return e.k === 's'
    ? e.n !== Us && n[e.n] === void 0 && Ca[e.n] === void 0
    : Cn(e).some((t) => Vx(t, n));
}
function Ka(e) {
  return e.k === 'n' || (e.k === 'neg' && e.a.k === 'n');
}
function _o(e) {
  return Ka(e)
    ? !0
    : e.k === 's'
      ? Ca[e.n] !== void 0
      : e.k === 'neg'
        ? _o(e.a)
        : e.k === 'sqrt'
          ? e.a.k === 'n'
          : e.k === 'pow'
            ? e.a.k === 'n' && e.b.k === 'n'
            : e.k === 'mul'
              ? e.c.length <= 3 && e.c.every(_o)
              : e.k === 'div'
                ? _o(e.a) && Ka(e.b)
                : !1;
}
function qi(e) {
  if (e.k === 's') return e.n === Us;
  if (e.k === 'neg') return qi(e.a);
  if (e.k === 'div') return qi(e.a) && Ka(e.b);
  if (e.k === 'mul') {
    let n = e.c.filter((t) => t.k === 's' && t.n === Us);
    return n.length === 1 && e.c.length <= 3 && e.c.every((t) => t === n[0] || _o(t));
  }
  return !1;
}
function zs(e) {
  if (_o(e) || qi(e)) return !0;
  if (e.k === 'add' && e.c.length === 2) {
    let [n, t] = e.c;
    return (_o(n) && qi(t)) || (_o(t) && qi(n));
  }
  return e.k === 'div' ? Ka(e.b) && e.a.k === 'add' && zs(e.a) : !1;
}
function CR(e) {
  let n = (t) => t.k === 'exp' && qi(t.a);
  return n(e)
    ? !0
    : e.k === 'mul' && e.c.length === 2 && e.c.some(n) && e.c.some((t) => !Oh(t) && _o(t));
}
function Dx(e) {
  return e.k === 'n' || e.k === 's' ? 0 : 1 + Cn(e).reduce((n, t) => n + Dx(t), 0);
}
function bs(e) {
  return e.k === 'sq'
    ? [e.a, 2]
    : e.k === 'pow' && e.b.k === 'n' && Number.isInteger(e.b.v)
      ? [e.a, e.b.v]
      : null;
}
function PI(e) {
  return e.k === 'mul' ? e.c : [e];
}
var Yn = (e) => Ne(e);
function Ni(e, n) {
  let t = n;
  for (; e.parent.get(t) !== t; ) t = e.parent.get(t);
  return t;
}
function Bx(e, n) {
  let t = Yn(n);
  return (e.parent.has(t) || (e.parent.set(t, t), e.nodes.set(t, n)), t);
}
function II(e, n, t) {
  let r = Ni(e, Bx(e, n)),
    s = Ni(e, Bx(e, t));
  return r === s ? !1 : (e.parent.set(r, s), !0);
}
function AI(e, n, t) {
  let r = Yn(n),
    s = Yn(t);
  return e.parent.has(r) && e.parent.has(s) && Ni(e, r) === Ni(e, s);
}
function ER(e) {
  return { ...e, parent: new Map(e.parent), nodes: new Map(e.nodes), facts: e.facts.slice() };
}
function zx(e, n) {
  if (kR(e, n) || (n.k === 's' && e.defs.includes(n.n))) return !0;
  let t = bs(n);
  return t
    ? Eo(e, t[0]) && Yn(t[0]) !== Us && kR(e, t[0])
    : n.k === 'mul' || n.k === 'div'
      ? Cn(n).some((r) => Eo(e, r)) && Cn(n).every((r) => !Eo(e, r) || zx(e, r))
      : !1;
}
function kR(e, n) {
  let t = Yn(n);
  if (e.parent.has(t)) return !0;
  let r = (s) => Yn(s) === t || Cn(s).some(r);
  if (r(e.target)) return !0;
  for (let s of e.nodes.values()) if (r(s)) return !0;
  return !1;
}
var jI = 'D\xE9velopper, r\xE9duire',
  QI = 'Puissance de i',
  FI = 'D\xE9couper la puissance',
  VI = 'Puissance d\u2019un produit',
  kf = 'Calculer',
  xR = 'Produit de deux complexes',
  DI = 'Forme trigonom\xE9trique',
  BI = 'Formule de Moivre',
  zI = 'Formule d\u2019Euler',
  yR = 'Module',
  UI = 'Module d\u2019un produit, d\u2019un quotient, d\u2019une puissance',
  GI = 'Argument',
  ZI = 'Retirer des tours (2\u03C0)',
  HI = 'Formule',
  WI = 'Remplacer par un r\xE9sultat \xE9tabli';
function JI(e, n, t) {
  let r = [
      [0.6, 0.8],
      [-0.28, 0.96],
      [0.8, -0.6],
      [0.03, 0.04],
      [-0.02, 0.05],
    ],
    s = Object.keys(e.env).filter((o) => Array.isArray(e.env[o])),
    i = 0;
  for (let o = 0; o < r.length; o++) {
    let a = r[o],
      l = { ...e.env };
    s.forEach((d, m) => (l[d] = r[(o + m + 1) % r.length]));
    let u = un(n, l, a),
      c = un(t, l, a),
      f = (d) => !!d && Number.isFinite(d[0]) && Number.isFinite(d[1]);
    if (!(!f(u) || !f(c))) {
      if (!Ur(u, c)) return !1;
      i++;
    }
  }
  return i >= 2;
}
function wR(e) {
  let n = bs(e);
  return !!n && n[0].k === 's' && n[0].n === Us;
}
function Ux(e) {
  let n = z(e);
  return (/cos/.test(n) && /sin/.test(n)) || CR(e);
}
function SR(e, n) {
  let t = Yn(n);
  if (!e.parent.has(t)) return !1;
  let r = Ni(e, t);
  for (let [s, i] of e.nodes) if (Ni(e, s) === r && Ux(i)) return !0;
  return !1;
}
function XI(e, n) {
  let t = (i) => (i.k === 'abs' ? Yn(i.a) : null);
  if (e.k === 'mul' && n.k === 'mul' && e.c.length === n.c.length) {
    let i = e.c.map(Yn).sort().join('|'),
      o = n.c.map(t);
    return !o.includes(null) && o.sort().join('|') === i;
  }
  let r = bs(e),
    s = bs(n);
  return r && s
    ? r[1] === s[1] && t(s[0]) === Yn(r[0])
    : e.k === 'div' && n.k === 'div'
      ? t(n.a) === Yn(e.a) && t(n.b) === Yn(e.b)
      : !1;
}
function Co(e, n, t, r = 0) {
  if (r > 10) return null;
  if (Yn(n) === Yn(t)) return '';
  let s = un(n, e.env),
    i = un(t, e.env);
  if (!Ur(s, i)) return null;
  if (AI(e, n, t)) return WI;
  if (n.k === 's' && e.defs.includes(n.n) && !Ka(t)) return HI;
  if (n.k === 'neg' && (t.k === 'neg' || (t.k === 'n' && t.v < 0)))
    return Co(e, n.a, t.k === 'neg' ? t.a : { k: 'n', v: -t.v }, r + 1);
  if (!Eo(e, n) && !Eo(e, t)) return Dx(t) < Dx(n) || Ka(t) ? kf : null;
  if (n.k === 'abs') {
    let c = n.a;
    if ((!Eo(e, t) && /√|²|\^/.test(z(t)) && zs(c)) || (!Eo(e, t) && _o(t) && (Ux(c) || SR(e, c))))
      return yR;
    if (XI(c, t)) return UI;
  }
  if (n.k === 'arg' && !Eo(e, t) && (Ux(n.a) || SR(e, n.a))) return GI;
  if (n.k === 'exp' && t.k === 'exp' && qi(n.a) && qi(t.a)) return ZI;
  let o = n.k === 'neg' ? n.a : n;
  if (wR(o) && bs(o)[1] <= 4 && (Ka(t) || qi(t))) return QI;
  if (((n.k === 'cos' || n.k === 'sin') && zs(t)) || (n.k === 'exp' && Ka(t) && Ur(i, [1, 0])))
    return kf;
  {
    let c = z(n),
      f = z(t);
    if (/exp/.test(c) && !/exp/.test(f) && /cos/.test(f) && /sin/.test(f) && !bs(n)) return zI;
  }
  if (o.k === 'mul' && o.c.every((c) => !Oh(c) || wR(c) || (c.k === 's' && c.n === Us)) && zs(t))
    return kf;
  let a = (c) => {
    let f = z(c);
    return (/cos/.test(f) && /sin/.test(f)) || /exp/.test(f);
  };
  if (!a(n) && a(t) && zs(n)) return DI;
  if ((n.k === 'pow' || n.k === 'div') && n.k === t.k) {
    let c = Co(e, n.a, t.a, r + 1),
      f = c === null ? null : Co(e, n.b, t.b, r + 1);
    if (c !== null && f !== null && (c || f)) return c || f;
  }
  if (JI(e, n, t)) {
    let c = (p) => (p.k === 'exp' ? [p] : Cn(p).flatMap(c)),
      f = c(n),
      d = c(t);
    if (f.length > d.length && d.length && d.every((p) => qi(p.a))) return null;
    let m = bs(n);
    return m && m[1] > 3 && Oh(m[0]) && t.k === 'add'
      ? null
      : m && (bs(t) || t.k === 'mul')
        ? PI(n).length > 1 || (m[0].k === 'mul' && t.k === 'mul')
          ? VI
          : FI
        : jI;
  }
  let l = bs(n),
    u = Yn(n) === Yn(e.target);
  if (
    (!u && l && l[1] === 2 && zs(l[0]) && zs(t)) ||
    (!u && n.k === 'mul' && n.c.length === 2 && n.c.every(zs) && zs(t))
  )
    return xR;
  if (l && a(l[0]) && a(t) && !bs(t)) return BI;
  if (n.k === t.k && Cn(n).length === Cn(t).length && Cn(n).length) {
    let c = Cn(n),
      f = Cn(t);
    if (n.c) {
      let m = new Set(),
        p = [];
      for (let g of c) {
        let h = -1;
        for (let b = 0; b < f.length && h < 0; b++) {
          if (m.has(b)) continue;
          let v = Co(e, g, f[b], r + 1);
          v !== null && ((h = b), v && p.push(v));
        }
        if (h < 0) return null;
        m.add(h);
      }
      return p[0] ?? '';
    }
    let d = [];
    for (let m = 0; m < c.length; m++) {
      let p = Co(e, c[m], f[m], r + 1);
      if (p === null) return null;
      p && d.push(p);
    }
    return d[0] ?? '';
  }
  if ((n.k === 'add' || n.k === 'mul') && n.k === t.k) {
    let c = t.c;
    for (let f = 0; f < n.c.length; f++) {
      let d = n.c.filter((v, k) => k !== f),
        m = d.map(Yn).sort().join('|'),
        p = c.filter((v) => d.some((k) => Yn(k) === Yn(v)));
      if (p.map(Yn).sort().join('|') !== m) continue;
      let g = c.filter((v) => !p.includes(v));
      if (!g.length) continue;
      let h = g.length === 1 ? g[0] : { k: n.k, c: g },
        b = Co(e, n.c[f], h, r + 1);
      if (b !== null) return b;
    }
  }
  return null;
}
function MR(e, n) {
  let t = {};
  (Object.entries(e.symbols).forEach(([a, l]) => {
    a !== Us && l.given && l.value !== void 0 && (t[a] = l.value);
  }),
    [...(e.givens || []), ...(e.admitted || [])].forEach((a) => {
      let l = Ve(a).dis[0];
      !l ||
        l.sides.length !== 2 ||
        [0, 1].forEach((u) => {
          let c = l.sides[u];
          if (c.k !== 's' || c.n === Us || t[c.n] !== void 0) return;
          let f = un(l.sides[1 - u], t);
          f && (t[c.n] = f);
        });
    }),
    Object.entries(n.defs ?? {}).forEach(([a, l]) => {
      let u = un(Ve(l).dis[0].sides[0], t);
      u && (t[a] = Nh(u) ?? u);
    }));
  let r = Ve(n.target).dis[0],
    s = r.sides[0],
    i = (n.solutions ?? []).map((a) => un(Ve(a).dis[0].sides[0], t)).filter((a) => !!a),
    o = {
      target: s,
      form: n.form ?? 'algebraic',
      value: n.unknown ? (i[0] ?? [NaN, NaN]) : (un(s, t) ?? [NaN, NaN]),
      env: t,
      parent: new Map(),
      nodes: new Map(),
      facts: [],
      sols: i,
      eqLines: [],
      defs: Object.keys(n.defs ?? {}),
    };
  return (
    n.unknown && ((o.unknown = n.unknown), o.eqLines.push({ dis: [r] })),
    Bx(o, s),
    [...(e.givens || []), ...(e.admitted || [])].forEach((a) => Kh(o, Ve(a).dis[0])),
    o
  );
}
function Hx(e, n) {
  if (!Xx(e, n)) {
    Kh(e, n.dis[0]);
    return;
  }
  (e.eqLines.push(n),
    n.dis.forEach((t) => {
      let r = t.sides.filter((s) => !Li(e, s));
      r.length > 1 && Kh(e, { sides: r });
    }));
}
function Kh(e, n) {
  let t = 0;
  for (let r = 0; r + 1 < n.sides.length; r++) II(e, n.sides[r], n.sides[r + 1]) && t++;
  return (e.facts.push(n), t);
}
function Wx(e, n) {
  return n.k === 's' && Array.isArray(e.env[n.n]) ? !0 : e.form === 'exponential' ? CR(n) : zs(n);
}
function du(e) {
  if (e.unknown) return e.eqLines.slice(1).some((r) => OR(e, r));
  let n = Yn(e.target);
  if (!e.parent.has(n)) return !1;
  let t = Ni(e, n);
  for (let [r, s] of e.nodes)
    if (r !== n && Ni(e, r) === t && Wx(e, s) && Ur(un(s, e.env), e.value)) return !0;
  return !1;
}
function _R(e) {
  let n = Yn(e.target);
  if (!e.parent.has(n)) return [];
  let t = Ni(e, n),
    r = [];
  return (
    e.nodes.forEach((s, i) => {
      if (Ni(e, i) !== t || !zs(s)) return;
      let o = Nh(un(s, e.env));
      o !== null && r.push(o);
    }),
    r
  );
}
function qR(e, n) {
  return Xx(e, n)
    ? NR(e, n)
    : n.dis.every((t) => {
        for (let r = 0; r + 1 < t.sides.length; r++)
          if (!Ur(un(t.sides[r], e.env), un(t.sides[r + 1], e.env))) return !1;
        return !0;
      });
}
function Jx(e, n, t, r) {
  let s = wt(t),
    i = s.atoms;
  if (!i.length) return { kind: 'empty', atoms: i, badChip: -1 };
  let o = vn(i);
  if (!o.ok)
    return {
      kind: 'syntax',
      atoms: i,
      title: '\xC7a commence mal',
      message: o.msg,
      badChip: s.src[o.index] !== void 0 ? s.src[o.index] : t.length - 1,
    };
  if (!o.complete || !o.hasEq) return { kind: 'open', atoms: i, complete: !1 };
  let a;
  try {
    a = Ae(i);
  } catch {
    return { kind: 'open', atoms: i, complete: !1 };
  }
  let l = YI(e, n, a, i);
  return !r?.verify && (l.kind === 'unjustified' || l.kind === 'false')
    ? { kind: 'pending', atoms: i, complete: !0 }
    : l;
}
function LR(e, n) {
  let t = Ph(n);
  for (let r of e.traps || [])
    try {
      let s = Ve(r.line);
      if (Ph(s) === t) return { line: s, title: r.title, why: r.why };
    } catch {}
  return null;
}
function Ph(e) {
  return e.dis.map((n) => n.sides.map(Yn).join('=')).join('|');
}
function YI(e, n, t, r) {
  if (Xx(e, t) && !t.dis.some((m) => m.cmp || m.rels)) return iA(e, n, t, r);
  if (t.dis.length !== 1 || t.dis[0].cmp || t.dis[0].rels)
    return {
      kind: 'unjustified',
      atoms: r,
      title: 'Une \xE9galit\xE9 \xE0 la fois',
      message: '\xC9cris une seule \xE9galit\xE9 (ou une cha\xEEne de \xAB = \xBB) par ligne.',
    };
  let s = t.dis[0],
    i = LR(n, t);
  for (let m = 0; m + 1 < s.sides.length; m++) {
    let p = s.sides[m],
      g = s.sides[m + 1],
      h = un(p, e.env),
      b = un(g, e.env);
    if (Vx(p, e.env) || Vx(g, e.env) || !h || !b)
      return {
        kind: 'unjustified',
        atoms: r,
        title: 'Je ne sais pas calculer \xE7a',
        message: '\xC9cris des calculs avec les nombres de la question et i.',
      };
    if (!Ur(h, b))
      return i
        ? {
            kind: 'trap',
            atoms: r,
            title: 'Pi\xE8ge : ' + i.title.charAt(0).toLowerCase() + i.title.slice(1),
            message: i.why,
            trap: i,
            badChip: -1,
          }
        : {
            kind: 'false',
            atoms: r,
            title: 'Ce n\u2019est pas \xE9gal',
            message: `\xAB ${z(p)} \xBB vaut ${vR(h)}, pas ${vR(b)}. Rappel : i\xB2 = \u22121.`,
          };
  }
  if (!zx(e, s.sides[0]) && !zx(e, s.sides[s.sides.length - 1]))
    return {
      kind: 'unjustified',
      atoms: r,
      keep: { line: t, kind: 'aside' },
      title: 'D\u2019o\xF9 part ce calcul ?',
      message:
        'Pars de l\u2019expression de la question (ou d\u2019un morceau), ou d\u2019un r\xE9sultat que tu as d\xE9j\xE0 \xE9crit.',
    };
  let o = [];
  for (let m = 0; m + 1 < s.sides.length; m++) {
    let p = s.sides[m],
      g = s.sides[m + 1],
      h = Co(e, p, g);
    if (h === null) {
      let b = bs(p);
      return {
        kind: 'unjustified',
        atoms: r,
        keep: { line: t, kind: 'jump' },
        title: 'D\u2019o\xF9 vient ce maillon ?',
        message:
          `\xAB ${z(p)} = ${z(g)} \xBB est vrai, mais c\u2019est un trop grand saut. ` +
          (b && b[1] > 2
            ? 'D\xE9coupe la puissance (z\u2078 = (z\xB2)\u2074) ou passe par la forme trigonom\xE9trique.'
            : 'D\xE9veloppe, puis remplace i\xB2 par \u22121, puis regroupe.'),
      };
    }
    h && !o.includes(h) && o.push(h);
  }
  let a = du(e),
    l = ER(e),
    u = Kh(l, s);
  if (!u)
    return {
      kind: 'useless',
      atoms: r,
      line: t,
      title: 'Juste, mais \xE7a ne t\u2019avance pas',
      message: 'Chaque maillon est juste, mais tu avais d\xE9j\xE0 tout \xE7a.',
    };
  let c = !a && du(l),
    f = Math.min(6, u + 1),
    d = o.join(' \u2192 ') || kf;
  return {
    kind: 'step',
    atoms: r,
    line: t,
    final: c,
    hora: f,
    rule: {
      id: 'complexe',
      card: '',
      label: d,
      hora: f,
      why: c
        ? 'C\u2019est la forme alg\xE9brique a + bi : c\u2019est la r\xE9ponse.'
        : 'Chaque maillon est juste et justifi\xE9.',
    },
  };
}
var eA = 'M\xEAme op\xE9ration des deux c\xF4t\xE9s',
  TR = 'Racines carr\xE9es',
  RR = 'Formule du second degr\xE9',
  nA = 'Produit nul';
function Li(e, n) {
  return e.unknown ? (n.k === 's' ? n.n === e.unknown : Cn(n).some((t) => Li(e, t))) : !1;
}
function Xx(e, n) {
  return !!e.unknown && n.dis.some((t) => t.sides.some((r) => Li(e, r)));
}
function xf(e, n, t) {
  return un(n, { ...e.env, [e.unknown]: t });
}
function NR(e, n) {
  return e.sols.every((t) =>
    n.dis.some((r) => {
      let s = xf(e, r.sides[0], t);
      return r.sides.every((i) => Ur(xf(e, i, t), s));
    }),
  );
}
function Mo(e, n) {
  let t = n.sides[0];
  if (t.k !== 's' || t.n !== e.unknown || n.sides.length < 2) return null;
  let r = n.sides[n.sides.length - 1];
  return Li(e, r) ? null : r;
}
function OR(e, n) {
  let t = n.dis.map((s) => Mo(e, s));
  if (t.some((s) => !s || !Wx(e, s))) return !1;
  let r = t.map((s) => un(s, e.env));
  return (
    e.sols.every((s) => r.some((i) => Ur(i, s))) && r.every((s) => e.sols.some((i) => Ur(s, i)))
  );
}
function Gx(e, n, t) {
  if (n.sides.length < 2 || t.sides.length < 2) return !1;
  let r = (a, l) => {
      let u = xf(e, a.sides[0], l),
        c = xf(e, a.sides[1], l);
      return u && c ? [u[0] - c[0], u[1] - c[1]] : null;
    },
    s = [
      [0.37, 0.81],
      [-1.2, 0.4],
      [0.9, -1.7],
      [2.3, 1.1],
    ],
    i = null,
    o = 0;
  for (let a of s) {
    let l = r(n, a),
      u = r(t, a);
    if (!l || !u || Math.hypot(l[0], l[1]) < 1e-9) continue;
    let c = Zx(u, l);
    if (!c || !Number.isFinite(c[0]) || (i && !Ur(i, c))) return !1;
    ((i = i ?? c), o++);
  }
  return o >= 3 && !!i && Math.hypot(i[0], i[1]) > 1e-9;
}
function $R(e, n) {
  if (n.sides.length !== 2) return !1;
  let t = (i) => bs(i)?.[1] === 2,
    [r, s] = n.sides;
  return (t(r) && Li(e, r) && t(s) && !Li(e, s)) || (t(s) && Li(e, s) && t(r) && !Li(e, r));
}
function tA(e, n) {
  if (n.sides.length !== 2) return !1;
  let t = (s) => s.k === 'n' && s.v === 0,
    r = t(n.sides[1]) ? n.sides[0] : t(n.sides[0]) ? n.sides[1] : null;
  return !!r && r.k === 'mul' && r.c.filter((s) => Li(e, s)).length >= 2;
}
function rA(e, n, t) {
  let r = xf(e, n.sides[0], t);
  return n.sides.every((s) => Ur(xf(e, s, t), r));
}
function sA(e, n) {
  let t = e.eqLines,
    r = n.dis.map((u) => ({ sides: u.sides.slice(0, 2) })),
    s = (u) => {
      let c = Mo(e, u);
      return c ? un(c, e.env) : null;
    },
    i = e.defs.some((u) => e.parent.has(u)),
    o = (u) => /√/.test(z(u.sides[1])),
    a = e.unknown,
    l = (u) => {
      let c = u.sides.map(z).join(' = ');
      return (
        new RegExp(a + '(\xB2|\\^2)').test(c) &&
        !new RegExp(a + '([\xB3\u2074\u2075\u2076]|\\^[3-9])').test(c)
      );
    };
  for (let u of t.filter((c) => c.dis.length === 1)) {
    let c = u.dis[0];
    if (tA(e, c)) {
      let d = (c.sides[0].k === 'mul' ? c.sides[0] : c.sides[1]).c.filter((m) => Li(e, m));
      if (
        d.length === r.length &&
        d.every((m) => r.some((p) => Gx(e, { sides: [m, { k: 'n', v: 0 }] }, p)))
      )
        return nA;
    }
    if ($R(e, c) && r.every((f) => s(f))) return TR;
    if (i && l(c) && r.every((f) => s(f)) && r.some(o)) return RR;
  }
  for (let u of t.filter((c) => c.dis.length > 1)) {
    let c = new Set(),
      f = [],
      d = !0;
    for (let m of u.dis) {
      let p = { sides: m.sides.slice(0, 2) },
        g = Mo(e, m),
        h = r.findIndex((k) => Gx(e, p, k) || (!!g && !!Mo(e, k) && Co(e, g, Mo(e, k)) !== null));
      if (h >= 0) {
        c.add(h);
        continue;
      }
      let b = r
          .map((k, y) => [k, y])
          .filter(([k]) => {
            let y = s(k);
            return !!y && rA(e, p, y);
          }),
        v = $R(e, p);
      if (b.length && (v || (i && l(p) && b.some(([k]) => o(k))))) {
        (b.forEach(([, k]) => c.add(k)), f.push(v ? TR : RR));
        continue;
      }
      d = !1;
      break;
    }
    if (d && c.size === r.length) return f[0] ?? kf;
  }
  return null;
}
function iA(e, n, t, r) {
  let s = LR(n, t);
  if (!NR(e, t)) {
    if (s)
      return {
        kind: 'trap',
        atoms: r,
        title: 'Pi\xE8ge : ' + s.title.charAt(0).toLowerCase() + s.title.slice(1),
        message: s.why,
        trap: s,
        badChip: -1,
      };
    let c = t.dis.length === 1 ? Mo(e, t.dis[0]) : null,
      f = c ? un(c, e.env) : null;
    return f && e.sols.length > 1 && e.sols.some((d) => Ur(d, f))
      ? {
          kind: 'false',
          atoms: r,
          title: 'Il manque une solution',
          message: `Cette \xE9quation a ${e.sols.length} solutions : \xE9cris \xAB ${e.unknown} = \u2026 ou ${e.unknown} = \u2026 \xBB.`,
        }
      : {
          kind: 'false',
          atoms: r,
          title: 'Ce n\u2019est pas juste',
          message:
            'Remplace ' +
            e.unknown +
            ' par la solution : cette \xE9galit\xE9 ne tient pas. Rappel : i\xB2 = \u22121.',
        };
  }
  if (t.dis.length > 1)
    for (let c of t.dis) {
      let f = Mo(e, c),
        d = f ? un(f, e.env) : null;
      if (f && !e.sols.some((m) => Ur(m, d)))
        return {
          kind: 'false',
          atoms: r,
          title: 'Ce n\u2019est pas une solution',
          message: `\xAB ${z(f)} \xBB ne v\xE9rifie pas l\u2019\xE9quation.`,
        };
    }
  let i = [],
    o = e.eqLines,
    a = t.dis.length > 1 ? sA(e, t) : null;
  for (let c of t.dis) {
    let f = { sides: c.sides.slice(0, 2) },
      d = a;
    if (t.dis.length === 1 && o.some((m) => m.dis.length === 1 && Gx(e, m.dis[0], f))) {
      let m = Mo(e, f) !== null && Wx(e, f.sides[1]),
        p = o.some((g) => g.dis.length === 1 && Mo(e, g.dis[0]));
      d = !m || p ? eA : null;
    }
    if (!d)
      return {
        kind: 'unjustified',
        atoms: r,
        keep: { line: t, kind: 'jump' },
        title: 'D\u2019o\xF9 vient cette \xE9quation ?',
        message:
          t.dis.length > 1
            ? 'Pour conclure, \xE9cris d\u2019abord un carr\xE9 (z\xB2 = (3i)\xB2), un produit nul, ou calcule \u0394 et utilise la formule.'
            : 'Fais la m\xEAme op\xE9ration des deux c\xF4t\xE9s d\u2019une \xE9quation d\xE9j\xE0 \xE9crite.',
      };
    i.includes(d) || i.push(d);
    for (let m = 1; m + 1 < c.sides.length; m++) {
      let p = Co(e, c.sides[m], c.sides[m + 1]);
      if (p === null)
        return {
          kind: 'unjustified',
          atoms: r,
          keep: { line: t, kind: 'jump' },
          title: 'D\u2019o\xF9 vient ce maillon ?',
          message: `\xAB ${z(c.sides[m])} = ${z(c.sides[m + 1])} \xBB est vrai, mais c\u2019est un trop grand saut.`,
        };
      p && !i.includes(p) && i.push(p);
    }
  }
  if (o.some((c) => Ph(c) === Ph(t)))
    return {
      kind: 'useless',
      atoms: r,
      line: t,
      title: 'D\xE9j\xE0 \xE9crit',
      message: 'Tu as d\xE9j\xE0 cette \xE9quation.',
    };
  let l = !du(e) && OR(e, t),
    u = Math.min(6, 2 + t.dis.length);
  return {
    kind: 'step',
    atoms: r,
    line: t,
    final: l,
    hora: u,
    rule: {
      id: 'complexe',
      card: '',
      label: i.join(' \u2192 '),
      hora: u,
      why: l
        ? 'Toutes les solutions, sous la forme a + bi : c\u2019est la r\xE9ponse.'
        : 'L\u2019\xE9quation est transform\xE9e correctement.',
    },
  };
}
function KR(e, n) {
  if (du(e)) return !1;
  let t = { ...ER(e), eqLines: e.eqLines.slice() };
  return (Hx(t, n), du(t));
}
var Aa = class extends Error {},
  Om = "[A-Z][\u2032']?",
  oA = new RegExp(`^\\((?:(${Om})(${Om})|([a-z\u0394][\u2080-\u2089]*))\\)$`),
  aA = new RegExp(`^\\[(${Om})(${Om})\\]$`),
  Yx = new RegExp(`^${Om}$`);
function Gs(e) {
  return e.match(/[A-Z][′']?/g) ?? [];
}
function ey(e) {
  let n = oA.exec(e);
  if (!n) return null;
  if (n[3]) return `(${n[3]})`;
  let [t, r] = [n[1], n[2]].sort();
  return t === r ? null : `(${t}${r})`;
}
function PR(e) {
  let n = aA.exec(e);
  if (!n) return null;
  let [t, r] = [n[1], n[2]].sort();
  return t === r ? null : `[${t}${r}]`;
}
function Km(e) {
  let n = e
      .replace(/\u2009|\u202F|\u00A0/g, ' ')
      .replace(/∥/g, '//')
      .replace(/\s+/g, ' ')
      .trim(),
    t = /^(\S+) (\/\/|⊥) (\S+)$/.exec(n);
  if (t) {
    let r = ey(t[1]),
      s = ey(t[3]);
    if (!r || !s)
      throw new Aa('Une droite s\u2019\xE9crit entre parenth\xE8ses : (AB) ou (d\u2081).');
    if (r === s) throw new Aa('Il faut deux droites diff\xE9rentes.');
    let [i, o] = [r, s].sort();
    return { k: t[2] === '//' ? 'par' : 'perp', a: i, b: o };
  }
  if (((t = /^(\S+) (?:est (?:le )?)?milieu de (\S+)$/.exec(n)), t)) {
    let r = PR(t[2]);
    if (!Yx.test(t[1])) throw new Aa('Le milieu est un point : une lettre majuscule.');
    if (!r) throw new Aa('Un segment s\u2019\xE9crit entre crochets : [AB].');
    return { k: 'mid', p: t[1], s: r };
  }
  if (((t = /^(\S+) ∈ (\S+)$/.exec(n)), t)) {
    let r = PR(t[2]) ?? ey(t[2]);
    if (!Yx.test(t[1]) || !r) throw new Aa('\xC9cris \xAB J \u2208 [AC] \xBB.');
    return { k: 'on', p: t[1], s: r };
  }
  if (((t = /^([A-Z][′']?){4} (?:est un )?parallélogramme$/.exec(n)), t))
    return { k: 'para', v: n.split(' ')[0] };
  if (
    ((t = /^(\S+) (?:est )?rectangle en (\S+)$/.exec(n)),
    t && Gs(t[1]).length === 3 && Yx.test(t[2]) && Gs(t[1]).includes(t[2]))
  )
    return { k: 'rect', t: t[1], at: t[2] };
  throw new Aa(
    '\xC9cris une seule propri\xE9t\xE9 : \xAB (d\u2081) // (d\u2082) \xBB, \xAB (AB) \u22A5 (BC) \xBB, \xAB I milieu de [AB] \xBB, \xAB ABCD parall\xE9logramme \xBB\u2026',
  );
}
function ja(e) {
  switch (e.k) {
    case 'par':
      return `${e.a}//${e.b}`;
    case 'perp':
      return `${e.a}\u22A5${e.b}`;
    case 'mid':
      return `${e.p} mil ${e.s}`;
    case 'on':
      return `${e.p} \u2208 ${e.s}`;
    case 'para': {
      let n = Gs(e.v),
        t = [];
      for (let r = 0; r < 4; r++) {
        let s = [...n.slice(r), ...n.slice(0, r)];
        t.push(s.join(''), [...s].reverse().join(''));
      }
      return 'para ' + t.sort()[0];
    }
    case 'rect': {
      let n = Gs(e.t)
        .filter((t) => t !== e.at)
        .sort();
      return `rect ${e.at} ${n.join('')}`;
    }
  }
}
function lA(e) {
  switch (e.k) {
    case 'par':
      return `${e.a} // ${e.b}`;
    case 'perp':
      return `${e.a} \u22A5 ${e.b}`;
    case 'mid':
      return `${e.p} milieu de ${e.s}`;
    case 'on':
      return `${e.p} \u2208 ${e.s}`;
    case 'para':
      return `${e.v} parall\xE9logramme`;
    case 'rect':
      return `${e.t} rectangle en ${e.at}`;
  }
}
function Ft(e, n) {
  let [t, r] = [e, n].sort();
  return `(${t}${r})`;
}
function IR(e, n) {
  let [t, r] = [e, n].sort();
  return `[${t}${r}]`;
}
function Ih(e) {
  let n = Gs(e);
  return [n[0], n[1]];
}
function AR(e, n = []) {
  let t = { spec: e, goal: Km(e.goal), facts: new Map() };
  return (
    n.forEach((r) => {
      try {
        let s = Km(r);
        t.facts.set(ja(s), s);
      } catch {}
    }),
    t
  );
}
function uA(e, n) {
  return e.facts.has(ja(n));
}
var yf = (e, n) => [...e.facts.values()].filter((t) => t.k === n);
function cA(e) {
  let n = [];
  for (let r of e.facts.values()) {
    if (r.k !== 'mid' && r.k !== 'on') continue;
    let s = Gs(r.s);
    s.length === 2 && n.push([...s, r.p]);
  }
  let t = !0;
  for (; t; ) {
    t = !1;
    for (let r = 0; r < n.length && !t; r++)
      for (let s = r + 1; s < n.length && !t; s++)
        n[r].filter((o) => n[s].includes(o)).length >= 2 &&
          ((n[r] = [...new Set([...n[r], ...n[s]])]), n.splice(s, 1), (t = !0));
  }
  return n;
}
function Qa(e, n) {
  let t = Gs(n);
  if (t.length !== 2) return n;
  let r = cA(e).find((o) => o.includes(t[0]) && o.includes(t[1]));
  if (!r) return n;
  let [s, i] = [...r].sort();
  return Ft(s, i);
}
function Ah(e, n) {
  return yf(e, n).flatMap((t) => {
    let r = t,
      s = Qa(e, r.a),
      i = Qa(e, r.b);
    return [
      [s, i],
      [i, s],
    ];
  });
}
function Pa(e, n, t, r) {
  let s = Qa(e, t),
    i = Qa(e, r);
  return Ah(e, n).some(([o, a]) => o === s && a === i);
}
function Ia(e, n, t) {
  return Qa(e, n) === Qa(e, t);
}
function fA(e, n) {
  if (n.k === 'par') {
    if (Pa(e, 'par', n.a, n.b)) return 'Ce sont les m\xEAmes droites, \xE0 alignement pr\xE8s';
    let t = Qa(e, n.a),
      r = Qa(e, n.b);
    for (let [i, o] of Ah(e, 'perp'))
      if (i === t && Pa(e, 'perp', r, o))
        return 'Deux droites perpendiculaires \xE0 une m\xEAme droite sont parall\xE8les';
    for (let [i, o] of Ah(e, 'par'))
      if (i === t && o !== r && Pa(e, 'par', r, o))
        return 'Deux droites parall\xE8les \xE0 une m\xEAme droite sont parall\xE8les';
    let s = yf(e, 'mid');
    for (let i of s)
      for (let o of s) {
        if (i === o) continue;
        let [a, l] = Ih(i.s),
          [u, c] = Ih(o.s),
          f = [a, l].find((h) => h === u || h === c);
        if (!f) continue;
        let d = f === a ? l : a,
          m = f === u ? c : u;
        if (d === m) continue;
        let p = Ft(i.p, o.p),
          g = Ft(d, m);
        if ((Ia(e, n.a, p) && Ia(e, n.b, g)) || (Ia(e, n.a, g) && Ia(e, n.b, p)))
          return 'Th\xE9or\xE8me des milieux';
      }
    for (let i of yf(e, 'para')) {
      let [o, a, l, u] = Gs(i.v);
      if (
        [
          [Ft(o, a), Ft(l, u)],
          [Ft(o, u), Ft(a, l)],
        ].some(([f, d]) => (Ia(e, n.a, f) && Ia(e, n.b, d)) || (Ia(e, n.a, d) && Ia(e, n.b, f)))
      )
        return 'Les c\xF4t\xE9s oppos\xE9s d\u2019un parall\xE9logramme sont parall\xE8les';
    }
    return null;
  }
  if (n.k === 'perp') {
    for (let [t, r] of Ah(e, 'par'))
      for (let [s, i] of [
        [n.a, n.b],
        [n.b, n.a],
      ])
        if (t === s && Pa(e, 'perp', r, i))
          return 'Si deux droites sont parall\xE8les, toute perpendiculaire \xE0 l\u2019une est perpendiculaire \xE0 l\u2019autre';
    for (let t of yf(e, 'rect')) {
      let [r, s] = Gs(t.t).filter((a) => a !== t.at),
        i = Ft(t.at, r),
        o = Ft(t.at, s);
      if ((n.a === i && n.b === o) || (n.a === o && n.b === i))
        return 'Dans un triangle rectangle, les c\xF4t\xE9s de l\u2019angle droit sont perpendiculaires';
    }
    return null;
  }
  if (n.k === 'rect') {
    let [t, r] = Gs(n.t).filter((o) => o !== n.at),
      s = Ft(n.at, t),
      i = Ft(n.at, r);
    return Pa(e, 'perp', s, i)
      ? 'Deux c\xF4t\xE9s perpendiculaires : le triangle est rectangle'
      : null;
  }
  if (n.k === 'mid') {
    let [t, r] = Ih(n.s);
    if (!uA(e, { k: 'on', p: n.p, s: n.s })) return null;
    for (let i of yf(e, 'mid')) {
      let [o, a] = Ih(i.s);
      for (let [l, u] of [
        [t, r],
        [r, t],
      ]) {
        if (o !== l && a !== l) continue;
        let c = o === l ? a : o;
        if (c !== u && Pa(e, 'par', Ft(i.p, n.p), Ft(c, u)))
          return 'R\xE9ciproque du th\xE9or\xE8me des milieux';
      }
    }
    return null;
  }
  if (n.k === 'para') {
    let [t, r, s, i] = Gs(n.v);
    if (Pa(e, 'par', Ft(t, r), Ft(s, i)) && Pa(e, 'par', Ft(t, i), Ft(r, s)))
      return 'Un quadrilat\xE8re aux c\xF4t\xE9s oppos\xE9s parall\xE8les est un parall\xE9logramme';
    let o = yf(e, 'mid'),
      a = IR(t, s),
      l = IR(r, i);
    return o.some((u) => u.s === a && o.some((c) => c.s === l && c.p === u.p))
      ? 'Un quadrilat\xE8re dont les diagonales ont le m\xEAme milieu est un parall\xE9logramme'
      : null;
  }
  return null;
}
function dA(e) {
  return { dis: [{ sides: [{ k: 's', n: lA(e) }] }] };
}
function jR(e) {
  return Km(e.dis[0].sides.map((n) => n.n ?? '').join(' '));
}
function mA(e) {
  return /(\/\/|⊥|milieu de|∈|rectangle en)\s*$/.test(e) || /^\S+$/.test(e.trim());
}
function QR(e, n, t, r) {
  let s = t.flatMap((d) => d.atoms);
  if (!s.length) return { kind: 'empty', atoms: s, badChip: -1 };
  let i = s.join(' ').replace(/\s+/g, ' ').trim(),
    o;
  try {
    o = Km(i);
  } catch (d) {
    return mA(i)
      ? { kind: 'open', atoms: s, complete: !1 }
      : {
          kind: 'syntax',
          atoms: s,
          title: '\xC7a commence mal',
          message: d.message,
          badChip: t.length - 1,
        };
  }
  let a = dA(o),
    l = ja(o),
    u = n.find((d) => {
      try {
        return ja(Km(d.line)) === l;
      } catch {
        return !1;
      }
    });
  if (u)
    return {
      kind: 'trap',
      atoms: s,
      title: 'Pi\xE8ge : ' + u.title.charAt(0).toLowerCase() + u.title.slice(1),
      message: u.why,
      trap: { line: a, title: u.title, why: u.why },
      badChip: -1,
    };
  if (e.facts.has(l))
    return {
      kind: 'useless',
      atoms: s,
      line: a,
      title: 'Tu le sais d\xE9j\xE0',
      message: 'C\u2019est d\xE9j\xE0 dans l\u2019\xE9nonc\xE9 ou dans ta feuille.',
    };
  let c = fA(e, o);
  if (!c)
    return r?.verify
      ? {
          kind: 'unjustified',
          atoms: s,
          title: 'D\u2019o\xF9 vient-elle ?',
          message:
            'Cette propri\xE9t\xE9 ne d\xE9coule pas encore de ce que tu as \xE9crit. Cherche une propri\xE9t\xE9 du cours dont TOUTES les conditions sont dans l\u2019\xE9nonc\xE9 ou dans ta feuille.',
        }
      : { kind: 'pending', atoms: s, complete: !0 };
  let f = ja(e.goal) === l;
  return {
    kind: 'step',
    atoms: s,
    line: a,
    final: f,
    hora: 2,
    rule: {
      id: 'geometrie',
      card: '',
      label: c,
      hora: 2,
      why: f ? 'C\u2019est ce qu\u2019il fallait d\xE9montrer.' : c + '.',
    },
  };
}
function FR(e, n) {
  let t = jR(n);
  e.facts.set(ja(t), t);
}
function VR(e) {
  return e.facts.has(ja(e.goal));
}
function DR(e, n) {
  try {
    return e.facts.has(ja(jR(n)));
  } catch {
    return !1;
  }
}
var x = {};
nI(x, {
  BRAND: () => jA,
  DIRTY: () => mu,
  EMPTY_PATH: () => bA,
  INVALID: () => ge,
  NEVER: () => Sj,
  OK: () => er,
  ParseStatus: () => Vt,
  Schema: () => Pe,
  ZodAny: () => Da,
  ZodArray: () => Oo,
  ZodBigInt: () => gu,
  ZodBoolean: () => hu,
  ZodBranded: () => Im,
  ZodCatch: () => Cu,
  ZodDate: () => bu,
  ZodDefault: () => $u,
  ZodDiscriminatedUnion: () => Fh,
  ZodEffects: () => xs,
  ZodEnum: () => Tu,
  ZodError: () => wr,
  ZodFirstPartyTypeKind: () => ke,
  ZodFunction: () => Dh,
  ZodIntersection: () => yu,
  ZodIssueCode: () => Q,
  ZodLazy: () => wu,
  ZodLiteral: () => Su,
  ZodMap: () => Cf,
  ZodNaN: () => Mf,
  ZodNativeEnum: () => Ru,
  ZodNever: () => Zs,
  ZodNull: () => ku,
  ZodNullable: () => Pi,
  ZodNumber: () => pu,
  ZodObject: () => Sr,
  ZodOptional: () => vs,
  ZodParsedType: () => Y,
  ZodPipeline: () => Am,
  ZodPromise: () => Ba,
  ZodReadonly: () => Eu,
  ZodRecord: () => Vh,
  ZodSchema: () => Pe,
  ZodSet: () => Ef,
  ZodString: () => Va,
  ZodSymbol: () => Rf,
  ZodTransformer: () => xs,
  ZodTuple: () => Ki,
  ZodType: () => Pe,
  ZodUndefined: () => vu,
  ZodUnion: () => xu,
  ZodUnknown: () => No,
  ZodVoid: () => $f,
  addIssueToContext: () => W,
  any: () => ZA,
  array: () => XA,
  bigint: () => DA,
  boolean: () => e$,
  coerce: () => wj,
  custom: () => JR,
  date: () => BA,
  datetimeRegex: () => HR,
  defaultErrorMap: () => qo,
  discriminatedUnion: () => tj,
  effect: () => pj,
  enum: () => fj,
  function: () => lj,
  getErrorMap: () => wf,
  getParsedType: () => Oi,
  instanceof: () => FA,
  intersection: () => rj,
  isAborted: () => jh,
  isAsync: () => Sf,
  isDirty: () => Qh,
  isValid: () => Fa,
  late: () => QA,
  lazy: () => uj,
  literal: () => cj,
  makeIssue: () => Pm,
  map: () => oj,
  nan: () => VA,
  nativeEnum: () => dj,
  never: () => WA,
  null: () => GA,
  nullable: () => hj,
  number: () => YR,
  object: () => YA,
  objectUtil: () => ny,
  oboolean: () => yj,
  onumber: () => xj,
  optional: () => gj,
  ostring: () => kj,
  pipeline: () => vj,
  preprocess: () => bj,
  promise: () => mj,
  quotelessJson: () => pA,
  record: () => ij,
  set: () => aj,
  setErrorMap: () => hA,
  strictObject: () => ej,
  string: () => XR,
  symbol: () => zA,
  transformer: () => pj,
  tuple: () => sj,
  undefined: () => UA,
  union: () => nj,
  unknown: () => HA,
  util: () => Be,
  void: () => JA,
});
var Be;
(function (e) {
  e.assertEqual = (s) => {};
  function n(s) {}
  e.assertIs = n;
  function t(s) {
    throw new Error();
  }
  ((e.assertNever = t),
    (e.arrayToEnum = (s) => {
      let i = {};
      for (let o of s) i[o] = o;
      return i;
    }),
    (e.getValidEnumValues = (s) => {
      let i = e.objectKeys(s).filter((a) => typeof s[s[a]] != 'number'),
        o = {};
      for (let a of i) o[a] = s[a];
      return e.objectValues(o);
    }),
    (e.objectValues = (s) =>
      e.objectKeys(s).map(function (i) {
        return s[i];
      })),
    (e.objectKeys =
      typeof Object.keys == 'function'
        ? (s) => Object.keys(s)
        : (s) => {
            let i = [];
            for (let o in s) Object.prototype.hasOwnProperty.call(s, o) && i.push(o);
            return i;
          }),
    (e.find = (s, i) => {
      for (let o of s) if (i(o)) return o;
    }),
    (e.isInteger =
      typeof Number.isInteger == 'function'
        ? (s) => Number.isInteger(s)
        : (s) => typeof s == 'number' && Number.isFinite(s) && Math.floor(s) === s));
  function r(s, i = ' | ') {
    return s.map((o) => (typeof o == 'string' ? `'${o}'` : o)).join(i);
  }
  ((e.joinValues = r),
    (e.jsonStringifyReplacer = (s, i) => (typeof i == 'bigint' ? i.toString() : i)));
})(Be || (Be = {}));
var ny;
(function (e) {
  e.mergeShapes = (n, t) => ({ ...n, ...t });
})(ny || (ny = {}));
var Y = Be.arrayToEnum([
    'string',
    'nan',
    'number',
    'integer',
    'float',
    'boolean',
    'date',
    'bigint',
    'symbol',
    'function',
    'undefined',
    'null',
    'array',
    'object',
    'unknown',
    'promise',
    'void',
    'never',
    'map',
    'set',
  ]),
  Oi = (e) => {
    switch (typeof e) {
      case 'undefined':
        return Y.undefined;
      case 'string':
        return Y.string;
      case 'number':
        return Number.isNaN(e) ? Y.nan : Y.number;
      case 'boolean':
        return Y.boolean;
      case 'function':
        return Y.function;
      case 'bigint':
        return Y.bigint;
      case 'symbol':
        return Y.symbol;
      case 'object':
        return Array.isArray(e)
          ? Y.array
          : e === null
            ? Y.null
            : e.then && typeof e.then == 'function' && e.catch && typeof e.catch == 'function'
              ? Y.promise
              : typeof Map < 'u' && e instanceof Map
                ? Y.map
                : typeof Set < 'u' && e instanceof Set
                  ? Y.set
                  : typeof Date < 'u' && e instanceof Date
                    ? Y.date
                    : Y.object;
      default:
        return Y.unknown;
    }
  };
var Q = Be.arrayToEnum([
    'invalid_type',
    'invalid_literal',
    'custom',
    'invalid_union',
    'invalid_union_discriminator',
    'invalid_enum_value',
    'unrecognized_keys',
    'invalid_arguments',
    'invalid_return_type',
    'invalid_date',
    'invalid_string',
    'too_small',
    'too_big',
    'invalid_intersection_types',
    'not_multiple_of',
    'not_finite',
  ]),
  pA = (e) => JSON.stringify(e, null, 2).replace(/"([^"]+)":/g, '$1:'),
  wr = class e extends Error {
    get errors() {
      return this.issues;
    }
    constructor(n) {
      (super(),
        (this.issues = []),
        (this.addIssue = (r) => {
          this.issues = [...this.issues, r];
        }),
        (this.addIssues = (r = []) => {
          this.issues = [...this.issues, ...r];
        }));
      let t = new.target.prototype;
      (Object.setPrototypeOf ? Object.setPrototypeOf(this, t) : (this.__proto__ = t),
        (this.name = 'ZodError'),
        (this.issues = n));
    }
    format(n) {
      let t =
          n ||
          function (i) {
            return i.message;
          },
        r = { _errors: [] },
        s = (i) => {
          for (let o of i.issues)
            if (o.code === 'invalid_union') o.unionErrors.map(s);
            else if (o.code === 'invalid_return_type') s(o.returnTypeError);
            else if (o.code === 'invalid_arguments') s(o.argumentsError);
            else if (o.path.length === 0) r._errors.push(t(o));
            else {
              let a = r,
                l = 0;
              for (; l < o.path.length; ) {
                let u = o.path[l];
                (l === o.path.length - 1
                  ? ((a[u] = a[u] || { _errors: [] }), a[u]._errors.push(t(o)))
                  : (a[u] = a[u] || { _errors: [] }),
                  (a = a[u]),
                  l++);
              }
            }
        };
      return (s(this), r);
    }
    static assert(n) {
      if (!(n instanceof e)) throw new Error(`Not a ZodError: ${n}`);
    }
    toString() {
      return this.message;
    }
    get message() {
      return JSON.stringify(this.issues, Be.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
      return this.issues.length === 0;
    }
    flatten(n = (t) => t.message) {
      let t = {},
        r = [];
      for (let s of this.issues)
        if (s.path.length > 0) {
          let i = s.path[0];
          ((t[i] = t[i] || []), t[i].push(n(s)));
        } else r.push(n(s));
      return { formErrors: r, fieldErrors: t };
    }
    get formErrors() {
      return this.flatten();
    }
  };
wr.create = (e) => new wr(e);
var gA = (e, n) => {
    let t;
    switch (e.code) {
      case Q.invalid_type:
        e.received === Y.undefined
          ? (t = 'Required')
          : (t = `Expected ${e.expected}, received ${e.received}`);
        break;
      case Q.invalid_literal:
        t = `Invalid literal value, expected ${JSON.stringify(e.expected, Be.jsonStringifyReplacer)}`;
        break;
      case Q.unrecognized_keys:
        t = `Unrecognized key(s) in object: ${Be.joinValues(e.keys, ', ')}`;
        break;
      case Q.invalid_union:
        t = 'Invalid input';
        break;
      case Q.invalid_union_discriminator:
        t = `Invalid discriminator value. Expected ${Be.joinValues(e.options)}`;
        break;
      case Q.invalid_enum_value:
        t = `Invalid enum value. Expected ${Be.joinValues(e.options)}, received '${e.received}'`;
        break;
      case Q.invalid_arguments:
        t = 'Invalid function arguments';
        break;
      case Q.invalid_return_type:
        t = 'Invalid function return type';
        break;
      case Q.invalid_date:
        t = 'Invalid date';
        break;
      case Q.invalid_string:
        typeof e.validation == 'object'
          ? 'includes' in e.validation
            ? ((t = `Invalid input: must include "${e.validation.includes}"`),
              typeof e.validation.position == 'number' &&
                (t = `${t} at one or more positions greater than or equal to ${e.validation.position}`))
            : 'startsWith' in e.validation
              ? (t = `Invalid input: must start with "${e.validation.startsWith}"`)
              : 'endsWith' in e.validation
                ? (t = `Invalid input: must end with "${e.validation.endsWith}"`)
                : Be.assertNever(e.validation)
          : e.validation !== 'regex'
            ? (t = `Invalid ${e.validation}`)
            : (t = 'Invalid');
        break;
      case Q.too_small:
        e.type === 'array'
          ? (t = `Array must contain ${e.exact ? 'exactly' : e.inclusive ? 'at least' : 'more than'} ${e.minimum} element(s)`)
          : e.type === 'string'
            ? (t = `String must contain ${e.exact ? 'exactly' : e.inclusive ? 'at least' : 'over'} ${e.minimum} character(s)`)
            : e.type === 'number'
              ? (t = `Number must be ${e.exact ? 'exactly equal to ' : e.inclusive ? 'greater than or equal to ' : 'greater than '}${e.minimum}`)
              : e.type === 'bigint'
                ? (t = `Number must be ${e.exact ? 'exactly equal to ' : e.inclusive ? 'greater than or equal to ' : 'greater than '}${e.minimum}`)
                : e.type === 'date'
                  ? (t = `Date must be ${e.exact ? 'exactly equal to ' : e.inclusive ? 'greater than or equal to ' : 'greater than '}${new Date(Number(e.minimum))}`)
                  : (t = 'Invalid input');
        break;
      case Q.too_big:
        e.type === 'array'
          ? (t = `Array must contain ${e.exact ? 'exactly' : e.inclusive ? 'at most' : 'less than'} ${e.maximum} element(s)`)
          : e.type === 'string'
            ? (t = `String must contain ${e.exact ? 'exactly' : e.inclusive ? 'at most' : 'under'} ${e.maximum} character(s)`)
            : e.type === 'number'
              ? (t = `Number must be ${e.exact ? 'exactly' : e.inclusive ? 'less than or equal to' : 'less than'} ${e.maximum}`)
              : e.type === 'bigint'
                ? (t = `BigInt must be ${e.exact ? 'exactly' : e.inclusive ? 'less than or equal to' : 'less than'} ${e.maximum}`)
                : e.type === 'date'
                  ? (t = `Date must be ${e.exact ? 'exactly' : e.inclusive ? 'smaller than or equal to' : 'smaller than'} ${new Date(Number(e.maximum))}`)
                  : (t = 'Invalid input');
        break;
      case Q.custom:
        t = 'Invalid input';
        break;
      case Q.invalid_intersection_types:
        t = 'Intersection results could not be merged';
        break;
      case Q.not_multiple_of:
        t = `Number must be a multiple of ${e.multipleOf}`;
        break;
      case Q.not_finite:
        t = 'Number must be finite';
        break;
      default:
        ((t = n.defaultError), Be.assertNever(e));
    }
    return { message: t };
  },
  qo = gA;
var BR = qo;
function hA(e) {
  BR = e;
}
function wf() {
  return BR;
}
var Pm = (e) => {
    let { data: n, path: t, errorMaps: r, issueData: s } = e,
      i = [...t, ...(s.path || [])],
      o = { ...s, path: i };
    if (s.message !== void 0) return { ...s, path: i, message: s.message };
    let a = '',
      l = r
        .filter((u) => !!u)
        .slice()
        .reverse();
    for (let u of l) a = u(o, { data: n, defaultError: a }).message;
    return { ...s, path: i, message: a };
  },
  bA = [];
function W(e, n) {
  let t = wf(),
    r = Pm({
      issueData: n,
      data: e.data,
      path: e.path,
      errorMaps: [e.common.contextualErrorMap, e.schemaErrorMap, t, t === qo ? void 0 : qo].filter(
        (s) => !!s,
      ),
    });
  e.common.issues.push(r);
}
var Vt = class e {
    constructor() {
      this.value = 'valid';
    }
    dirty() {
      this.value === 'valid' && (this.value = 'dirty');
    }
    abort() {
      this.value !== 'aborted' && (this.value = 'aborted');
    }
    static mergeArray(n, t) {
      let r = [];
      for (let s of t) {
        if (s.status === 'aborted') return ge;
        (s.status === 'dirty' && n.dirty(), r.push(s.value));
      }
      return { status: n.value, value: r };
    }
    static async mergeObjectAsync(n, t) {
      let r = [];
      for (let s of t) {
        let i = await s.key,
          o = await s.value;
        r.push({ key: i, value: o });
      }
      return e.mergeObjectSync(n, r);
    }
    static mergeObjectSync(n, t) {
      let r = {};
      for (let s of t) {
        let { key: i, value: o } = s;
        if (i.status === 'aborted' || o.status === 'aborted') return ge;
        (i.status === 'dirty' && n.dirty(),
          o.status === 'dirty' && n.dirty(),
          i.value !== '__proto__' &&
            (typeof o.value < 'u' || s.alwaysSet) &&
            (r[i.value] = o.value));
      }
      return { status: n.value, value: r };
    }
  },
  ge = Object.freeze({ status: 'aborted' }),
  mu = (e) => ({ status: 'dirty', value: e }),
  er = (e) => ({ status: 'valid', value: e }),
  jh = (e) => e.status === 'aborted',
  Qh = (e) => e.status === 'dirty',
  Fa = (e) => e.status === 'valid',
  Sf = (e) => typeof Promise < 'u' && e instanceof Promise;
var ue;
(function (e) {
  ((e.errToObj = (n) => (typeof n == 'string' ? { message: n } : n || {})),
    (e.toString = (n) => (typeof n == 'string' ? n : n?.message)));
})(ue || (ue = {}));
var ks = class {
    constructor(n, t, r, s) {
      ((this._cachedPath = []),
        (this.parent = n),
        (this.data = t),
        (this._path = r),
        (this._key = s));
    }
    get path() {
      return (
        this._cachedPath.length ||
          (Array.isArray(this._key)
            ? this._cachedPath.push(...this._path, ...this._key)
            : this._cachedPath.push(...this._path, this._key)),
        this._cachedPath
      );
    }
  },
  zR = (e, n) => {
    if (Fa(n)) return { success: !0, data: n.value };
    if (!e.common.issues.length) throw new Error('Validation failed but no issues detected.');
    return {
      success: !1,
      get error() {
        if (this._error) return this._error;
        let t = new wr(e.common.issues);
        return ((this._error = t), this._error);
      },
    };
  };
function Le(e) {
  if (!e) return {};
  let { errorMap: n, invalid_type_error: t, required_error: r, description: s } = e;
  if (n && (t || r))
    throw new Error(
      `Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`,
    );
  return n
    ? { errorMap: n, description: s }
    : {
        errorMap: (o, a) => {
          let { message: l } = e;
          return o.code === 'invalid_enum_value'
            ? { message: l ?? a.defaultError }
            : typeof a.data > 'u'
              ? { message: l ?? r ?? a.defaultError }
              : o.code !== 'invalid_type'
                ? { message: a.defaultError }
                : { message: l ?? t ?? a.defaultError };
        },
        description: s,
      };
}
var Pe = class {
    get description() {
      return this._def.description;
    }
    _getType(n) {
      return Oi(n.data);
    }
    _getOrReturnCtx(n, t) {
      return (
        t || {
          common: n.parent.common,
          data: n.data,
          parsedType: Oi(n.data),
          schemaErrorMap: this._def.errorMap,
          path: n.path,
          parent: n.parent,
        }
      );
    }
    _processInputParams(n) {
      return {
        status: new Vt(),
        ctx: {
          common: n.parent.common,
          data: n.data,
          parsedType: Oi(n.data),
          schemaErrorMap: this._def.errorMap,
          path: n.path,
          parent: n.parent,
        },
      };
    }
    _parseSync(n) {
      let t = this._parse(n);
      if (Sf(t)) throw new Error('Synchronous parse encountered promise.');
      return t;
    }
    _parseAsync(n) {
      let t = this._parse(n);
      return Promise.resolve(t);
    }
    parse(n, t) {
      let r = this.safeParse(n, t);
      if (r.success) return r.data;
      throw r.error;
    }
    safeParse(n, t) {
      let r = {
          common: { issues: [], async: t?.async ?? !1, contextualErrorMap: t?.errorMap },
          path: t?.path || [],
          schemaErrorMap: this._def.errorMap,
          parent: null,
          data: n,
          parsedType: Oi(n),
        },
        s = this._parseSync({ data: n, path: r.path, parent: r });
      return zR(r, s);
    }
    '~validate'(n) {
      let t = {
        common: { issues: [], async: !!this['~standard'].async },
        path: [],
        schemaErrorMap: this._def.errorMap,
        parent: null,
        data: n,
        parsedType: Oi(n),
      };
      if (!this['~standard'].async)
        try {
          let r = this._parseSync({ data: n, path: [], parent: t });
          return Fa(r) ? { value: r.value } : { issues: t.common.issues };
        } catch (r) {
          (r?.message?.toLowerCase()?.includes('encountered') && (this['~standard'].async = !0),
            (t.common = { issues: [], async: !0 }));
        }
      return this._parseAsync({ data: n, path: [], parent: t }).then((r) =>
        Fa(r) ? { value: r.value } : { issues: t.common.issues },
      );
    }
    async parseAsync(n, t) {
      let r = await this.safeParseAsync(n, t);
      if (r.success) return r.data;
      throw r.error;
    }
    async safeParseAsync(n, t) {
      let r = {
          common: { issues: [], contextualErrorMap: t?.errorMap, async: !0 },
          path: t?.path || [],
          schemaErrorMap: this._def.errorMap,
          parent: null,
          data: n,
          parsedType: Oi(n),
        },
        s = this._parse({ data: n, path: r.path, parent: r }),
        i = await (Sf(s) ? s : Promise.resolve(s));
      return zR(r, i);
    }
    refine(n, t) {
      let r = (s) =>
        typeof t == 'string' || typeof t > 'u' ? { message: t } : typeof t == 'function' ? t(s) : t;
      return this._refinement((s, i) => {
        let o = n(s),
          a = () => i.addIssue({ code: Q.custom, ...r(s) });
        return typeof Promise < 'u' && o instanceof Promise
          ? o.then((l) => (l ? !0 : (a(), !1)))
          : o
            ? !0
            : (a(), !1);
      });
    }
    refinement(n, t) {
      return this._refinement((r, s) =>
        n(r) ? !0 : (s.addIssue(typeof t == 'function' ? t(r, s) : t), !1),
      );
    }
    _refinement(n) {
      return new xs({
        schema: this,
        typeName: ke.ZodEffects,
        effect: { type: 'refinement', refinement: n },
      });
    }
    superRefine(n) {
      return this._refinement(n);
    }
    constructor(n) {
      ((this.spa = this.safeParseAsync),
        (this._def = n),
        (this.parse = this.parse.bind(this)),
        (this.safeParse = this.safeParse.bind(this)),
        (this.parseAsync = this.parseAsync.bind(this)),
        (this.safeParseAsync = this.safeParseAsync.bind(this)),
        (this.spa = this.spa.bind(this)),
        (this.refine = this.refine.bind(this)),
        (this.refinement = this.refinement.bind(this)),
        (this.superRefine = this.superRefine.bind(this)),
        (this.optional = this.optional.bind(this)),
        (this.nullable = this.nullable.bind(this)),
        (this.nullish = this.nullish.bind(this)),
        (this.array = this.array.bind(this)),
        (this.promise = this.promise.bind(this)),
        (this.or = this.or.bind(this)),
        (this.and = this.and.bind(this)),
        (this.transform = this.transform.bind(this)),
        (this.brand = this.brand.bind(this)),
        (this.default = this.default.bind(this)),
        (this.catch = this.catch.bind(this)),
        (this.describe = this.describe.bind(this)),
        (this.pipe = this.pipe.bind(this)),
        (this.readonly = this.readonly.bind(this)),
        (this.isNullable = this.isNullable.bind(this)),
        (this.isOptional = this.isOptional.bind(this)),
        (this['~standard'] = { version: 1, vendor: 'zod', validate: (t) => this['~validate'](t) }));
    }
    optional() {
      return vs.create(this, this._def);
    }
    nullable() {
      return Pi.create(this, this._def);
    }
    nullish() {
      return this.nullable().optional();
    }
    array() {
      return Oo.create(this);
    }
    promise() {
      return Ba.create(this, this._def);
    }
    or(n) {
      return xu.create([this, n], this._def);
    }
    and(n) {
      return yu.create(this, n, this._def);
    }
    transform(n) {
      return new xs({
        ...Le(this._def),
        schema: this,
        typeName: ke.ZodEffects,
        effect: { type: 'transform', transform: n },
      });
    }
    default(n) {
      let t = typeof n == 'function' ? n : () => n;
      return new $u({
        ...Le(this._def),
        innerType: this,
        defaultValue: t,
        typeName: ke.ZodDefault,
      });
    }
    brand() {
      return new Im({ typeName: ke.ZodBranded, type: this, ...Le(this._def) });
    }
    catch(n) {
      let t = typeof n == 'function' ? n : () => n;
      return new Cu({ ...Le(this._def), innerType: this, catchValue: t, typeName: ke.ZodCatch });
    }
    describe(n) {
      let t = this.constructor;
      return new t({ ...this._def, description: n });
    }
    pipe(n) {
      return Am.create(this, n);
    }
    readonly() {
      return Eu.create(this);
    }
    isOptional() {
      return this.safeParse(void 0).success;
    }
    isNullable() {
      return this.safeParse(null).success;
    }
  },
  vA = /^c[^\s-]{8,}$/i,
  kA = /^[0-9a-z]+$/,
  xA = /^[0-9A-HJKMNP-TV-Z]{26}$/i,
  yA = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i,
  wA = /^[a-z0-9_-]{21}$/i,
  SA = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/,
  TA =
    /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/,
  RA = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i,
  $A = '^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$',
  ty,
  CA =
    /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/,
  EA =
    /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/,
  MA =
    /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/,
  _A =
    /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/,
  qA = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/,
  LA = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/,
  GR =
    '((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))',
  NA = new RegExp(`^${GR}$`);
function ZR(e) {
  let n = '[0-5]\\d';
  e.precision ? (n = `${n}\\.\\d{${e.precision}}`) : e.precision == null && (n = `${n}(\\.\\d+)?`);
  let t = e.precision ? '+' : '?';
  return `([01]\\d|2[0-3]):[0-5]\\d(:${n})${t}`;
}
function OA(e) {
  return new RegExp(`^${ZR(e)}$`);
}
function HR(e) {
  let n = `${GR}T${ZR(e)}`,
    t = [];
  return (
    t.push(e.local ? 'Z?' : 'Z'),
    e.offset && t.push('([+-]\\d{2}:?\\d{2})'),
    (n = `${n}(${t.join('|')})`),
    new RegExp(`^${n}$`)
  );
}
function KA(e, n) {
  return !!(((n === 'v4' || !n) && CA.test(e)) || ((n === 'v6' || !n) && MA.test(e)));
}
function PA(e, n) {
  if (!SA.test(e)) return !1;
  try {
    let [t] = e.split('.');
    if (!t) return !1;
    let r = t
        .replace(/-/g, '+')
        .replace(/_/g, '/')
        .padEnd(t.length + ((4 - (t.length % 4)) % 4), '='),
      s = JSON.parse(atob(r));
    return !(
      typeof s != 'object' ||
      s === null ||
      ('typ' in s && s?.typ !== 'JWT') ||
      !s.alg ||
      (n && s.alg !== n)
    );
  } catch {
    return !1;
  }
}
function IA(e, n) {
  return !!(((n === 'v4' || !n) && EA.test(e)) || ((n === 'v6' || !n) && _A.test(e)));
}
var Va = class e extends Pe {
  _parse(n) {
    if ((this._def.coerce && (n.data = String(n.data)), this._getType(n) !== Y.string)) {
      let i = this._getOrReturnCtx(n);
      return (W(i, { code: Q.invalid_type, expected: Y.string, received: i.parsedType }), ge);
    }
    let r = new Vt(),
      s;
    for (let i of this._def.checks)
      if (i.kind === 'min')
        n.data.length < i.value &&
          ((s = this._getOrReturnCtx(n, s)),
          W(s, {
            code: Q.too_small,
            minimum: i.value,
            type: 'string',
            inclusive: !0,
            exact: !1,
            message: i.message,
          }),
          r.dirty());
      else if (i.kind === 'max')
        n.data.length > i.value &&
          ((s = this._getOrReturnCtx(n, s)),
          W(s, {
            code: Q.too_big,
            maximum: i.value,
            type: 'string',
            inclusive: !0,
            exact: !1,
            message: i.message,
          }),
          r.dirty());
      else if (i.kind === 'length') {
        let o = n.data.length > i.value,
          a = n.data.length < i.value;
        (o || a) &&
          ((s = this._getOrReturnCtx(n, s)),
          o
            ? W(s, {
                code: Q.too_big,
                maximum: i.value,
                type: 'string',
                inclusive: !0,
                exact: !0,
                message: i.message,
              })
            : a &&
              W(s, {
                code: Q.too_small,
                minimum: i.value,
                type: 'string',
                inclusive: !0,
                exact: !0,
                message: i.message,
              }),
          r.dirty());
      } else if (i.kind === 'email')
        RA.test(n.data) ||
          ((s = this._getOrReturnCtx(n, s)),
          W(s, { validation: 'email', code: Q.invalid_string, message: i.message }),
          r.dirty());
      else if (i.kind === 'emoji')
        (ty || (ty = new RegExp($A, 'u')),
          ty.test(n.data) ||
            ((s = this._getOrReturnCtx(n, s)),
            W(s, { validation: 'emoji', code: Q.invalid_string, message: i.message }),
            r.dirty()));
      else if (i.kind === 'uuid')
        yA.test(n.data) ||
          ((s = this._getOrReturnCtx(n, s)),
          W(s, { validation: 'uuid', code: Q.invalid_string, message: i.message }),
          r.dirty());
      else if (i.kind === 'nanoid')
        wA.test(n.data) ||
          ((s = this._getOrReturnCtx(n, s)),
          W(s, { validation: 'nanoid', code: Q.invalid_string, message: i.message }),
          r.dirty());
      else if (i.kind === 'cuid')
        vA.test(n.data) ||
          ((s = this._getOrReturnCtx(n, s)),
          W(s, { validation: 'cuid', code: Q.invalid_string, message: i.message }),
          r.dirty());
      else if (i.kind === 'cuid2')
        kA.test(n.data) ||
          ((s = this._getOrReturnCtx(n, s)),
          W(s, { validation: 'cuid2', code: Q.invalid_string, message: i.message }),
          r.dirty());
      else if (i.kind === 'ulid')
        xA.test(n.data) ||
          ((s = this._getOrReturnCtx(n, s)),
          W(s, { validation: 'ulid', code: Q.invalid_string, message: i.message }),
          r.dirty());
      else if (i.kind === 'url')
        try {
          new URL(n.data);
        } catch {
          ((s = this._getOrReturnCtx(n, s)),
            W(s, { validation: 'url', code: Q.invalid_string, message: i.message }),
            r.dirty());
        }
      else
        i.kind === 'regex'
          ? ((i.regex.lastIndex = 0),
            i.regex.test(n.data) ||
              ((s = this._getOrReturnCtx(n, s)),
              W(s, { validation: 'regex', code: Q.invalid_string, message: i.message }),
              r.dirty()))
          : i.kind === 'trim'
            ? (n.data = n.data.trim())
            : i.kind === 'includes'
              ? n.data.includes(i.value, i.position) ||
                ((s = this._getOrReturnCtx(n, s)),
                W(s, {
                  code: Q.invalid_string,
                  validation: { includes: i.value, position: i.position },
                  message: i.message,
                }),
                r.dirty())
              : i.kind === 'toLowerCase'
                ? (n.data = n.data.toLowerCase())
                : i.kind === 'toUpperCase'
                  ? (n.data = n.data.toUpperCase())
                  : i.kind === 'startsWith'
                    ? n.data.startsWith(i.value) ||
                      ((s = this._getOrReturnCtx(n, s)),
                      W(s, {
                        code: Q.invalid_string,
                        validation: { startsWith: i.value },
                        message: i.message,
                      }),
                      r.dirty())
                    : i.kind === 'endsWith'
                      ? n.data.endsWith(i.value) ||
                        ((s = this._getOrReturnCtx(n, s)),
                        W(s, {
                          code: Q.invalid_string,
                          validation: { endsWith: i.value },
                          message: i.message,
                        }),
                        r.dirty())
                      : i.kind === 'datetime'
                        ? HR(i).test(n.data) ||
                          ((s = this._getOrReturnCtx(n, s)),
                          W(s, {
                            code: Q.invalid_string,
                            validation: 'datetime',
                            message: i.message,
                          }),
                          r.dirty())
                        : i.kind === 'date'
                          ? NA.test(n.data) ||
                            ((s = this._getOrReturnCtx(n, s)),
                            W(s, {
                              code: Q.invalid_string,
                              validation: 'date',
                              message: i.message,
                            }),
                            r.dirty())
                          : i.kind === 'time'
                            ? OA(i).test(n.data) ||
                              ((s = this._getOrReturnCtx(n, s)),
                              W(s, {
                                code: Q.invalid_string,
                                validation: 'time',
                                message: i.message,
                              }),
                              r.dirty())
                            : i.kind === 'duration'
                              ? TA.test(n.data) ||
                                ((s = this._getOrReturnCtx(n, s)),
                                W(s, {
                                  validation: 'duration',
                                  code: Q.invalid_string,
                                  message: i.message,
                                }),
                                r.dirty())
                              : i.kind === 'ip'
                                ? KA(n.data, i.version) ||
                                  ((s = this._getOrReturnCtx(n, s)),
                                  W(s, {
                                    validation: 'ip',
                                    code: Q.invalid_string,
                                    message: i.message,
                                  }),
                                  r.dirty())
                                : i.kind === 'jwt'
                                  ? PA(n.data, i.alg) ||
                                    ((s = this._getOrReturnCtx(n, s)),
                                    W(s, {
                                      validation: 'jwt',
                                      code: Q.invalid_string,
                                      message: i.message,
                                    }),
                                    r.dirty())
                                  : i.kind === 'cidr'
                                    ? IA(n.data, i.version) ||
                                      ((s = this._getOrReturnCtx(n, s)),
                                      W(s, {
                                        validation: 'cidr',
                                        code: Q.invalid_string,
                                        message: i.message,
                                      }),
                                      r.dirty())
                                    : i.kind === 'base64'
                                      ? qA.test(n.data) ||
                                        ((s = this._getOrReturnCtx(n, s)),
                                        W(s, {
                                          validation: 'base64',
                                          code: Q.invalid_string,
                                          message: i.message,
                                        }),
                                        r.dirty())
                                      : i.kind === 'base64url'
                                        ? LA.test(n.data) ||
                                          ((s = this._getOrReturnCtx(n, s)),
                                          W(s, {
                                            validation: 'base64url',
                                            code: Q.invalid_string,
                                            message: i.message,
                                          }),
                                          r.dirty())
                                        : Be.assertNever(i);
    return { status: r.value, value: n.data };
  }
  _regex(n, t, r) {
    return this.refinement((s) => n.test(s), {
      validation: t,
      code: Q.invalid_string,
      ...ue.errToObj(r),
    });
  }
  _addCheck(n) {
    return new e({ ...this._def, checks: [...this._def.checks, n] });
  }
  email(n) {
    return this._addCheck({ kind: 'email', ...ue.errToObj(n) });
  }
  url(n) {
    return this._addCheck({ kind: 'url', ...ue.errToObj(n) });
  }
  emoji(n) {
    return this._addCheck({ kind: 'emoji', ...ue.errToObj(n) });
  }
  uuid(n) {
    return this._addCheck({ kind: 'uuid', ...ue.errToObj(n) });
  }
  nanoid(n) {
    return this._addCheck({ kind: 'nanoid', ...ue.errToObj(n) });
  }
  cuid(n) {
    return this._addCheck({ kind: 'cuid', ...ue.errToObj(n) });
  }
  cuid2(n) {
    return this._addCheck({ kind: 'cuid2', ...ue.errToObj(n) });
  }
  ulid(n) {
    return this._addCheck({ kind: 'ulid', ...ue.errToObj(n) });
  }
  base64(n) {
    return this._addCheck({ kind: 'base64', ...ue.errToObj(n) });
  }
  base64url(n) {
    return this._addCheck({ kind: 'base64url', ...ue.errToObj(n) });
  }
  jwt(n) {
    return this._addCheck({ kind: 'jwt', ...ue.errToObj(n) });
  }
  ip(n) {
    return this._addCheck({ kind: 'ip', ...ue.errToObj(n) });
  }
  cidr(n) {
    return this._addCheck({ kind: 'cidr', ...ue.errToObj(n) });
  }
  datetime(n) {
    return typeof n == 'string'
      ? this._addCheck({ kind: 'datetime', precision: null, offset: !1, local: !1, message: n })
      : this._addCheck({
          kind: 'datetime',
          precision: typeof n?.precision > 'u' ? null : n?.precision,
          offset: n?.offset ?? !1,
          local: n?.local ?? !1,
          ...ue.errToObj(n?.message),
        });
  }
  date(n) {
    return this._addCheck({ kind: 'date', message: n });
  }
  time(n) {
    return typeof n == 'string'
      ? this._addCheck({ kind: 'time', precision: null, message: n })
      : this._addCheck({
          kind: 'time',
          precision: typeof n?.precision > 'u' ? null : n?.precision,
          ...ue.errToObj(n?.message),
        });
  }
  duration(n) {
    return this._addCheck({ kind: 'duration', ...ue.errToObj(n) });
  }
  regex(n, t) {
    return this._addCheck({ kind: 'regex', regex: n, ...ue.errToObj(t) });
  }
  includes(n, t) {
    return this._addCheck({
      kind: 'includes',
      value: n,
      position: t?.position,
      ...ue.errToObj(t?.message),
    });
  }
  startsWith(n, t) {
    return this._addCheck({ kind: 'startsWith', value: n, ...ue.errToObj(t) });
  }
  endsWith(n, t) {
    return this._addCheck({ kind: 'endsWith', value: n, ...ue.errToObj(t) });
  }
  min(n, t) {
    return this._addCheck({ kind: 'min', value: n, ...ue.errToObj(t) });
  }
  max(n, t) {
    return this._addCheck({ kind: 'max', value: n, ...ue.errToObj(t) });
  }
  length(n, t) {
    return this._addCheck({ kind: 'length', value: n, ...ue.errToObj(t) });
  }
  nonempty(n) {
    return this.min(1, ue.errToObj(n));
  }
  trim() {
    return new e({ ...this._def, checks: [...this._def.checks, { kind: 'trim' }] });
  }
  toLowerCase() {
    return new e({ ...this._def, checks: [...this._def.checks, { kind: 'toLowerCase' }] });
  }
  toUpperCase() {
    return new e({ ...this._def, checks: [...this._def.checks, { kind: 'toUpperCase' }] });
  }
  get isDatetime() {
    return !!this._def.checks.find((n) => n.kind === 'datetime');
  }
  get isDate() {
    return !!this._def.checks.find((n) => n.kind === 'date');
  }
  get isTime() {
    return !!this._def.checks.find((n) => n.kind === 'time');
  }
  get isDuration() {
    return !!this._def.checks.find((n) => n.kind === 'duration');
  }
  get isEmail() {
    return !!this._def.checks.find((n) => n.kind === 'email');
  }
  get isURL() {
    return !!this._def.checks.find((n) => n.kind === 'url');
  }
  get isEmoji() {
    return !!this._def.checks.find((n) => n.kind === 'emoji');
  }
  get isUUID() {
    return !!this._def.checks.find((n) => n.kind === 'uuid');
  }
  get isNANOID() {
    return !!this._def.checks.find((n) => n.kind === 'nanoid');
  }
  get isCUID() {
    return !!this._def.checks.find((n) => n.kind === 'cuid');
  }
  get isCUID2() {
    return !!this._def.checks.find((n) => n.kind === 'cuid2');
  }
  get isULID() {
    return !!this._def.checks.find((n) => n.kind === 'ulid');
  }
  get isIP() {
    return !!this._def.checks.find((n) => n.kind === 'ip');
  }
  get isCIDR() {
    return !!this._def.checks.find((n) => n.kind === 'cidr');
  }
  get isBase64() {
    return !!this._def.checks.find((n) => n.kind === 'base64');
  }
  get isBase64url() {
    return !!this._def.checks.find((n) => n.kind === 'base64url');
  }
  get minLength() {
    let n = null;
    for (let t of this._def.checks)
      t.kind === 'min' && (n === null || t.value > n) && (n = t.value);
    return n;
  }
  get maxLength() {
    let n = null;
    for (let t of this._def.checks)
      t.kind === 'max' && (n === null || t.value < n) && (n = t.value);
    return n;
  }
};
Va.create = (e) =>
  new Va({ checks: [], typeName: ke.ZodString, coerce: e?.coerce ?? !1, ...Le(e) });
function AA(e, n) {
  let t = (e.toString().split('.')[1] || '').length,
    r = (n.toString().split('.')[1] || '').length,
    s = t > r ? t : r,
    i = Number.parseInt(e.toFixed(s).replace('.', '')),
    o = Number.parseInt(n.toFixed(s).replace('.', ''));
  return (i % o) / 10 ** s;
}
var pu = class e extends Pe {
  constructor() {
    (super(...arguments),
      (this.min = this.gte),
      (this.max = this.lte),
      (this.step = this.multipleOf));
  }
  _parse(n) {
    if ((this._def.coerce && (n.data = Number(n.data)), this._getType(n) !== Y.number)) {
      let i = this._getOrReturnCtx(n);
      return (W(i, { code: Q.invalid_type, expected: Y.number, received: i.parsedType }), ge);
    }
    let r,
      s = new Vt();
    for (let i of this._def.checks)
      i.kind === 'int'
        ? Be.isInteger(n.data) ||
          ((r = this._getOrReturnCtx(n, r)),
          W(r, {
            code: Q.invalid_type,
            expected: 'integer',
            received: 'float',
            message: i.message,
          }),
          s.dirty())
        : i.kind === 'min'
          ? (i.inclusive ? n.data < i.value : n.data <= i.value) &&
            ((r = this._getOrReturnCtx(n, r)),
            W(r, {
              code: Q.too_small,
              minimum: i.value,
              type: 'number',
              inclusive: i.inclusive,
              exact: !1,
              message: i.message,
            }),
            s.dirty())
          : i.kind === 'max'
            ? (i.inclusive ? n.data > i.value : n.data >= i.value) &&
              ((r = this._getOrReturnCtx(n, r)),
              W(r, {
                code: Q.too_big,
                maximum: i.value,
                type: 'number',
                inclusive: i.inclusive,
                exact: !1,
                message: i.message,
              }),
              s.dirty())
            : i.kind === 'multipleOf'
              ? AA(n.data, i.value) !== 0 &&
                ((r = this._getOrReturnCtx(n, r)),
                W(r, { code: Q.not_multiple_of, multipleOf: i.value, message: i.message }),
                s.dirty())
              : i.kind === 'finite'
                ? Number.isFinite(n.data) ||
                  ((r = this._getOrReturnCtx(n, r)),
                  W(r, { code: Q.not_finite, message: i.message }),
                  s.dirty())
                : Be.assertNever(i);
    return { status: s.value, value: n.data };
  }
  gte(n, t) {
    return this.setLimit('min', n, !0, ue.toString(t));
  }
  gt(n, t) {
    return this.setLimit('min', n, !1, ue.toString(t));
  }
  lte(n, t) {
    return this.setLimit('max', n, !0, ue.toString(t));
  }
  lt(n, t) {
    return this.setLimit('max', n, !1, ue.toString(t));
  }
  setLimit(n, t, r, s) {
    return new e({
      ...this._def,
      checks: [...this._def.checks, { kind: n, value: t, inclusive: r, message: ue.toString(s) }],
    });
  }
  _addCheck(n) {
    return new e({ ...this._def, checks: [...this._def.checks, n] });
  }
  int(n) {
    return this._addCheck({ kind: 'int', message: ue.toString(n) });
  }
  positive(n) {
    return this._addCheck({ kind: 'min', value: 0, inclusive: !1, message: ue.toString(n) });
  }
  negative(n) {
    return this._addCheck({ kind: 'max', value: 0, inclusive: !1, message: ue.toString(n) });
  }
  nonpositive(n) {
    return this._addCheck({ kind: 'max', value: 0, inclusive: !0, message: ue.toString(n) });
  }
  nonnegative(n) {
    return this._addCheck({ kind: 'min', value: 0, inclusive: !0, message: ue.toString(n) });
  }
  multipleOf(n, t) {
    return this._addCheck({ kind: 'multipleOf', value: n, message: ue.toString(t) });
  }
  finite(n) {
    return this._addCheck({ kind: 'finite', message: ue.toString(n) });
  }
  safe(n) {
    return this._addCheck({
      kind: 'min',
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: ue.toString(n),
    })._addCheck({
      kind: 'max',
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: ue.toString(n),
    });
  }
  get minValue() {
    let n = null;
    for (let t of this._def.checks)
      t.kind === 'min' && (n === null || t.value > n) && (n = t.value);
    return n;
  }
  get maxValue() {
    let n = null;
    for (let t of this._def.checks)
      t.kind === 'max' && (n === null || t.value < n) && (n = t.value);
    return n;
  }
  get isInt() {
    return !!this._def.checks.find(
      (n) => n.kind === 'int' || (n.kind === 'multipleOf' && Be.isInteger(n.value)),
    );
  }
  get isFinite() {
    let n = null,
      t = null;
    for (let r of this._def.checks) {
      if (r.kind === 'finite' || r.kind === 'int' || r.kind === 'multipleOf') return !0;
      r.kind === 'min'
        ? (t === null || r.value > t) && (t = r.value)
        : r.kind === 'max' && (n === null || r.value < n) && (n = r.value);
    }
    return Number.isFinite(t) && Number.isFinite(n);
  }
};
pu.create = (e) =>
  new pu({ checks: [], typeName: ke.ZodNumber, coerce: e?.coerce || !1, ...Le(e) });
var gu = class e extends Pe {
  constructor() {
    (super(...arguments), (this.min = this.gte), (this.max = this.lte));
  }
  _parse(n) {
    if (this._def.coerce)
      try {
        n.data = BigInt(n.data);
      } catch {
        return this._getInvalidInput(n);
      }
    if (this._getType(n) !== Y.bigint) return this._getInvalidInput(n);
    let r,
      s = new Vt();
    for (let i of this._def.checks)
      i.kind === 'min'
        ? (i.inclusive ? n.data < i.value : n.data <= i.value) &&
          ((r = this._getOrReturnCtx(n, r)),
          W(r, {
            code: Q.too_small,
            type: 'bigint',
            minimum: i.value,
            inclusive: i.inclusive,
            message: i.message,
          }),
          s.dirty())
        : i.kind === 'max'
          ? (i.inclusive ? n.data > i.value : n.data >= i.value) &&
            ((r = this._getOrReturnCtx(n, r)),
            W(r, {
              code: Q.too_big,
              type: 'bigint',
              maximum: i.value,
              inclusive: i.inclusive,
              message: i.message,
            }),
            s.dirty())
          : i.kind === 'multipleOf'
            ? n.data % i.value !== BigInt(0) &&
              ((r = this._getOrReturnCtx(n, r)),
              W(r, { code: Q.not_multiple_of, multipleOf: i.value, message: i.message }),
              s.dirty())
            : Be.assertNever(i);
    return { status: s.value, value: n.data };
  }
  _getInvalidInput(n) {
    let t = this._getOrReturnCtx(n);
    return (W(t, { code: Q.invalid_type, expected: Y.bigint, received: t.parsedType }), ge);
  }
  gte(n, t) {
    return this.setLimit('min', n, !0, ue.toString(t));
  }
  gt(n, t) {
    return this.setLimit('min', n, !1, ue.toString(t));
  }
  lte(n, t) {
    return this.setLimit('max', n, !0, ue.toString(t));
  }
  lt(n, t) {
    return this.setLimit('max', n, !1, ue.toString(t));
  }
  setLimit(n, t, r, s) {
    return new e({
      ...this._def,
      checks: [...this._def.checks, { kind: n, value: t, inclusive: r, message: ue.toString(s) }],
    });
  }
  _addCheck(n) {
    return new e({ ...this._def, checks: [...this._def.checks, n] });
  }
  positive(n) {
    return this._addCheck({
      kind: 'min',
      value: BigInt(0),
      inclusive: !1,
      message: ue.toString(n),
    });
  }
  negative(n) {
    return this._addCheck({
      kind: 'max',
      value: BigInt(0),
      inclusive: !1,
      message: ue.toString(n),
    });
  }
  nonpositive(n) {
    return this._addCheck({
      kind: 'max',
      value: BigInt(0),
      inclusive: !0,
      message: ue.toString(n),
    });
  }
  nonnegative(n) {
    return this._addCheck({
      kind: 'min',
      value: BigInt(0),
      inclusive: !0,
      message: ue.toString(n),
    });
  }
  multipleOf(n, t) {
    return this._addCheck({ kind: 'multipleOf', value: n, message: ue.toString(t) });
  }
  get minValue() {
    let n = null;
    for (let t of this._def.checks)
      t.kind === 'min' && (n === null || t.value > n) && (n = t.value);
    return n;
  }
  get maxValue() {
    let n = null;
    for (let t of this._def.checks)
      t.kind === 'max' && (n === null || t.value < n) && (n = t.value);
    return n;
  }
};
gu.create = (e) =>
  new gu({ checks: [], typeName: ke.ZodBigInt, coerce: e?.coerce ?? !1, ...Le(e) });
var hu = class extends Pe {
  _parse(n) {
    if ((this._def.coerce && (n.data = !!n.data), this._getType(n) !== Y.boolean)) {
      let r = this._getOrReturnCtx(n);
      return (W(r, { code: Q.invalid_type, expected: Y.boolean, received: r.parsedType }), ge);
    }
    return er(n.data);
  }
};
hu.create = (e) => new hu({ typeName: ke.ZodBoolean, coerce: e?.coerce || !1, ...Le(e) });
var bu = class e extends Pe {
  _parse(n) {
    if ((this._def.coerce && (n.data = new Date(n.data)), this._getType(n) !== Y.date)) {
      let i = this._getOrReturnCtx(n);
      return (W(i, { code: Q.invalid_type, expected: Y.date, received: i.parsedType }), ge);
    }
    if (Number.isNaN(n.data.getTime())) {
      let i = this._getOrReturnCtx(n);
      return (W(i, { code: Q.invalid_date }), ge);
    }
    let r = new Vt(),
      s;
    for (let i of this._def.checks)
      i.kind === 'min'
        ? n.data.getTime() < i.value &&
          ((s = this._getOrReturnCtx(n, s)),
          W(s, {
            code: Q.too_small,
            message: i.message,
            inclusive: !0,
            exact: !1,
            minimum: i.value,
            type: 'date',
          }),
          r.dirty())
        : i.kind === 'max'
          ? n.data.getTime() > i.value &&
            ((s = this._getOrReturnCtx(n, s)),
            W(s, {
              code: Q.too_big,
              message: i.message,
              inclusive: !0,
              exact: !1,
              maximum: i.value,
              type: 'date',
            }),
            r.dirty())
          : Be.assertNever(i);
    return { status: r.value, value: new Date(n.data.getTime()) };
  }
  _addCheck(n) {
    return new e({ ...this._def, checks: [...this._def.checks, n] });
  }
  min(n, t) {
    return this._addCheck({ kind: 'min', value: n.getTime(), message: ue.toString(t) });
  }
  max(n, t) {
    return this._addCheck({ kind: 'max', value: n.getTime(), message: ue.toString(t) });
  }
  get minDate() {
    let n = null;
    for (let t of this._def.checks)
      t.kind === 'min' && (n === null || t.value > n) && (n = t.value);
    return n != null ? new Date(n) : null;
  }
  get maxDate() {
    let n = null;
    for (let t of this._def.checks)
      t.kind === 'max' && (n === null || t.value < n) && (n = t.value);
    return n != null ? new Date(n) : null;
  }
};
bu.create = (e) => new bu({ checks: [], coerce: e?.coerce || !1, typeName: ke.ZodDate, ...Le(e) });
var Rf = class extends Pe {
  _parse(n) {
    if (this._getType(n) !== Y.symbol) {
      let r = this._getOrReturnCtx(n);
      return (W(r, { code: Q.invalid_type, expected: Y.symbol, received: r.parsedType }), ge);
    }
    return er(n.data);
  }
};
Rf.create = (e) => new Rf({ typeName: ke.ZodSymbol, ...Le(e) });
var vu = class extends Pe {
  _parse(n) {
    if (this._getType(n) !== Y.undefined) {
      let r = this._getOrReturnCtx(n);
      return (W(r, { code: Q.invalid_type, expected: Y.undefined, received: r.parsedType }), ge);
    }
    return er(n.data);
  }
};
vu.create = (e) => new vu({ typeName: ke.ZodUndefined, ...Le(e) });
var ku = class extends Pe {
  _parse(n) {
    if (this._getType(n) !== Y.null) {
      let r = this._getOrReturnCtx(n);
      return (W(r, { code: Q.invalid_type, expected: Y.null, received: r.parsedType }), ge);
    }
    return er(n.data);
  }
};
ku.create = (e) => new ku({ typeName: ke.ZodNull, ...Le(e) });
var Da = class extends Pe {
  constructor() {
    (super(...arguments), (this._any = !0));
  }
  _parse(n) {
    return er(n.data);
  }
};
Da.create = (e) => new Da({ typeName: ke.ZodAny, ...Le(e) });
var No = class extends Pe {
  constructor() {
    (super(...arguments), (this._unknown = !0));
  }
  _parse(n) {
    return er(n.data);
  }
};
No.create = (e) => new No({ typeName: ke.ZodUnknown, ...Le(e) });
var Zs = class extends Pe {
  _parse(n) {
    let t = this._getOrReturnCtx(n);
    return (W(t, { code: Q.invalid_type, expected: Y.never, received: t.parsedType }), ge);
  }
};
Zs.create = (e) => new Zs({ typeName: ke.ZodNever, ...Le(e) });
var $f = class extends Pe {
  _parse(n) {
    if (this._getType(n) !== Y.undefined) {
      let r = this._getOrReturnCtx(n);
      return (W(r, { code: Q.invalid_type, expected: Y.void, received: r.parsedType }), ge);
    }
    return er(n.data);
  }
};
$f.create = (e) => new $f({ typeName: ke.ZodVoid, ...Le(e) });
var Oo = class e extends Pe {
  _parse(n) {
    let { ctx: t, status: r } = this._processInputParams(n),
      s = this._def;
    if (t.parsedType !== Y.array)
      return (W(t, { code: Q.invalid_type, expected: Y.array, received: t.parsedType }), ge);
    if (s.exactLength !== null) {
      let o = t.data.length > s.exactLength.value,
        a = t.data.length < s.exactLength.value;
      (o || a) &&
        (W(t, {
          code: o ? Q.too_big : Q.too_small,
          minimum: a ? s.exactLength.value : void 0,
          maximum: o ? s.exactLength.value : void 0,
          type: 'array',
          inclusive: !0,
          exact: !0,
          message: s.exactLength.message,
        }),
        r.dirty());
    }
    if (
      (s.minLength !== null &&
        t.data.length < s.minLength.value &&
        (W(t, {
          code: Q.too_small,
          minimum: s.minLength.value,
          type: 'array',
          inclusive: !0,
          exact: !1,
          message: s.minLength.message,
        }),
        r.dirty()),
      s.maxLength !== null &&
        t.data.length > s.maxLength.value &&
        (W(t, {
          code: Q.too_big,
          maximum: s.maxLength.value,
          type: 'array',
          inclusive: !0,
          exact: !1,
          message: s.maxLength.message,
        }),
        r.dirty()),
      t.common.async)
    )
      return Promise.all(
        [...t.data].map((o, a) => s.type._parseAsync(new ks(t, o, t.path, a))),
      ).then((o) => Vt.mergeArray(r, o));
    let i = [...t.data].map((o, a) => s.type._parseSync(new ks(t, o, t.path, a)));
    return Vt.mergeArray(r, i);
  }
  get element() {
    return this._def.type;
  }
  min(n, t) {
    return new e({ ...this._def, minLength: { value: n, message: ue.toString(t) } });
  }
  max(n, t) {
    return new e({ ...this._def, maxLength: { value: n, message: ue.toString(t) } });
  }
  length(n, t) {
    return new e({ ...this._def, exactLength: { value: n, message: ue.toString(t) } });
  }
  nonempty(n) {
    return this.min(1, n);
  }
};
Oo.create = (e, n) =>
  new Oo({
    type: e,
    minLength: null,
    maxLength: null,
    exactLength: null,
    typeName: ke.ZodArray,
    ...Le(n),
  });
function Tf(e) {
  if (e instanceof Sr) {
    let n = {};
    for (let t in e.shape) {
      let r = e.shape[t];
      n[t] = vs.create(Tf(r));
    }
    return new Sr({ ...e._def, shape: () => n });
  } else
    return e instanceof Oo
      ? new Oo({ ...e._def, type: Tf(e.element) })
      : e instanceof vs
        ? vs.create(Tf(e.unwrap()))
        : e instanceof Pi
          ? Pi.create(Tf(e.unwrap()))
          : e instanceof Ki
            ? Ki.create(e.items.map((n) => Tf(n)))
            : e;
}
var Sr = class e extends Pe {
  constructor() {
    (super(...arguments),
      (this._cached = null),
      (this.nonstrict = this.passthrough),
      (this.augment = this.extend));
  }
  _getCached() {
    if (this._cached !== null) return this._cached;
    let n = this._def.shape(),
      t = Be.objectKeys(n);
    return ((this._cached = { shape: n, keys: t }), this._cached);
  }
  _parse(n) {
    if (this._getType(n) !== Y.object) {
      let u = this._getOrReturnCtx(n);
      return (W(u, { code: Q.invalid_type, expected: Y.object, received: u.parsedType }), ge);
    }
    let { status: r, ctx: s } = this._processInputParams(n),
      { shape: i, keys: o } = this._getCached(),
      a = [];
    if (!(this._def.catchall instanceof Zs && this._def.unknownKeys === 'strip'))
      for (let u in s.data) o.includes(u) || a.push(u);
    let l = [];
    for (let u of o) {
      let c = i[u],
        f = s.data[u];
      l.push({
        key: { status: 'valid', value: u },
        value: c._parse(new ks(s, f, s.path, u)),
        alwaysSet: u in s.data,
      });
    }
    if (this._def.catchall instanceof Zs) {
      let u = this._def.unknownKeys;
      if (u === 'passthrough')
        for (let c of a)
          l.push({
            key: { status: 'valid', value: c },
            value: { status: 'valid', value: s.data[c] },
          });
      else if (u === 'strict')
        a.length > 0 && (W(s, { code: Q.unrecognized_keys, keys: a }), r.dirty());
      else if (u !== 'strip')
        throw new Error('Internal ZodObject error: invalid unknownKeys value.');
    } else {
      let u = this._def.catchall;
      for (let c of a) {
        let f = s.data[c];
        l.push({
          key: { status: 'valid', value: c },
          value: u._parse(new ks(s, f, s.path, c)),
          alwaysSet: c in s.data,
        });
      }
    }
    return s.common.async
      ? Promise.resolve()
          .then(async () => {
            let u = [];
            for (let c of l) {
              let f = await c.key,
                d = await c.value;
              u.push({ key: f, value: d, alwaysSet: c.alwaysSet });
            }
            return u;
          })
          .then((u) => Vt.mergeObjectSync(r, u))
      : Vt.mergeObjectSync(r, l);
  }
  get shape() {
    return this._def.shape();
  }
  strict(n) {
    return (
      ue.errToObj,
      new e({
        ...this._def,
        unknownKeys: 'strict',
        ...(n !== void 0
          ? {
              errorMap: (t, r) => {
                let s = this._def.errorMap?.(t, r).message ?? r.defaultError;
                return t.code === 'unrecognized_keys'
                  ? { message: ue.errToObj(n).message ?? s }
                  : { message: s };
              },
            }
          : {}),
      })
    );
  }
  strip() {
    return new e({ ...this._def, unknownKeys: 'strip' });
  }
  passthrough() {
    return new e({ ...this._def, unknownKeys: 'passthrough' });
  }
  extend(n) {
    return new e({ ...this._def, shape: () => ({ ...this._def.shape(), ...n }) });
  }
  merge(n) {
    return new e({
      unknownKeys: n._def.unknownKeys,
      catchall: n._def.catchall,
      shape: () => ({ ...this._def.shape(), ...n._def.shape() }),
      typeName: ke.ZodObject,
    });
  }
  setKey(n, t) {
    return this.augment({ [n]: t });
  }
  catchall(n) {
    return new e({ ...this._def, catchall: n });
  }
  pick(n) {
    let t = {};
    for (let r of Be.objectKeys(n)) n[r] && this.shape[r] && (t[r] = this.shape[r]);
    return new e({ ...this._def, shape: () => t });
  }
  omit(n) {
    let t = {};
    for (let r of Be.objectKeys(this.shape)) n[r] || (t[r] = this.shape[r]);
    return new e({ ...this._def, shape: () => t });
  }
  deepPartial() {
    return Tf(this);
  }
  partial(n) {
    let t = {};
    for (let r of Be.objectKeys(this.shape)) {
      let s = this.shape[r];
      n && !n[r] ? (t[r] = s) : (t[r] = s.optional());
    }
    return new e({ ...this._def, shape: () => t });
  }
  required(n) {
    let t = {};
    for (let r of Be.objectKeys(this.shape))
      if (n && !n[r]) t[r] = this.shape[r];
      else {
        let i = this.shape[r];
        for (; i instanceof vs; ) i = i._def.innerType;
        t[r] = i;
      }
    return new e({ ...this._def, shape: () => t });
  }
  keyof() {
    return WR(Be.objectKeys(this.shape));
  }
};
Sr.create = (e, n) =>
  new Sr({
    shape: () => e,
    unknownKeys: 'strip',
    catchall: Zs.create(),
    typeName: ke.ZodObject,
    ...Le(n),
  });
Sr.strictCreate = (e, n) =>
  new Sr({
    shape: () => e,
    unknownKeys: 'strict',
    catchall: Zs.create(),
    typeName: ke.ZodObject,
    ...Le(n),
  });
Sr.lazycreate = (e, n) =>
  new Sr({
    shape: e,
    unknownKeys: 'strip',
    catchall: Zs.create(),
    typeName: ke.ZodObject,
    ...Le(n),
  });
var xu = class extends Pe {
  _parse(n) {
    let { ctx: t } = this._processInputParams(n),
      r = this._def.options;
    function s(i) {
      for (let a of i) if (a.result.status === 'valid') return a.result;
      for (let a of i)
        if (a.result.status === 'dirty')
          return (t.common.issues.push(...a.ctx.common.issues), a.result);
      let o = i.map((a) => new wr(a.ctx.common.issues));
      return (W(t, { code: Q.invalid_union, unionErrors: o }), ge);
    }
    if (t.common.async)
      return Promise.all(
        r.map(async (i) => {
          let o = { ...t, common: { ...t.common, issues: [] }, parent: null };
          return { result: await i._parseAsync({ data: t.data, path: t.path, parent: o }), ctx: o };
        }),
      ).then(s);
    {
      let i,
        o = [];
      for (let l of r) {
        let u = { ...t, common: { ...t.common, issues: [] }, parent: null },
          c = l._parseSync({ data: t.data, path: t.path, parent: u });
        if (c.status === 'valid') return c;
        (c.status === 'dirty' && !i && (i = { result: c, ctx: u }),
          u.common.issues.length && o.push(u.common.issues));
      }
      if (i) return (t.common.issues.push(...i.ctx.common.issues), i.result);
      let a = o.map((l) => new wr(l));
      return (W(t, { code: Q.invalid_union, unionErrors: a }), ge);
    }
  }
  get options() {
    return this._def.options;
  }
};
xu.create = (e, n) => new xu({ options: e, typeName: ke.ZodUnion, ...Le(n) });
var Lo = (e) =>
    e instanceof wu
      ? Lo(e.schema)
      : e instanceof xs
        ? Lo(e.innerType())
        : e instanceof Su
          ? [e.value]
          : e instanceof Tu
            ? e.options
            : e instanceof Ru
              ? Be.objectValues(e.enum)
              : e instanceof $u
                ? Lo(e._def.innerType)
                : e instanceof vu
                  ? [void 0]
                  : e instanceof ku
                    ? [null]
                    : e instanceof vs
                      ? [void 0, ...Lo(e.unwrap())]
                      : e instanceof Pi
                        ? [null, ...Lo(e.unwrap())]
                        : e instanceof Im || e instanceof Eu
                          ? Lo(e.unwrap())
                          : e instanceof Cu
                            ? Lo(e._def.innerType)
                            : [],
  Fh = class e extends Pe {
    _parse(n) {
      let { ctx: t } = this._processInputParams(n);
      if (t.parsedType !== Y.object)
        return (W(t, { code: Q.invalid_type, expected: Y.object, received: t.parsedType }), ge);
      let r = this.discriminator,
        s = t.data[r],
        i = this.optionsMap.get(s);
      return i
        ? t.common.async
          ? i._parseAsync({ data: t.data, path: t.path, parent: t })
          : i._parseSync({ data: t.data, path: t.path, parent: t })
        : (W(t, {
            code: Q.invalid_union_discriminator,
            options: Array.from(this.optionsMap.keys()),
            path: [r],
          }),
          ge);
    }
    get discriminator() {
      return this._def.discriminator;
    }
    get options() {
      return this._def.options;
    }
    get optionsMap() {
      return this._def.optionsMap;
    }
    static create(n, t, r) {
      let s = new Map();
      for (let i of t) {
        let o = Lo(i.shape[n]);
        if (!o.length)
          throw new Error(
            `A discriminator value for key \`${n}\` could not be extracted from all schema options`,
          );
        for (let a of o) {
          if (s.has(a))
            throw new Error(`Discriminator property ${String(n)} has duplicate value ${String(a)}`);
          s.set(a, i);
        }
      }
      return new e({
        typeName: ke.ZodDiscriminatedUnion,
        discriminator: n,
        options: t,
        optionsMap: s,
        ...Le(r),
      });
    }
  };
function ry(e, n) {
  let t = Oi(e),
    r = Oi(n);
  if (e === n) return { valid: !0, data: e };
  if (t === Y.object && r === Y.object) {
    let s = Be.objectKeys(n),
      i = Be.objectKeys(e).filter((a) => s.indexOf(a) !== -1),
      o = { ...e, ...n };
    for (let a of i) {
      let l = ry(e[a], n[a]);
      if (!l.valid) return { valid: !1 };
      o[a] = l.data;
    }
    return { valid: !0, data: o };
  } else if (t === Y.array && r === Y.array) {
    if (e.length !== n.length) return { valid: !1 };
    let s = [];
    for (let i = 0; i < e.length; i++) {
      let o = e[i],
        a = n[i],
        l = ry(o, a);
      if (!l.valid) return { valid: !1 };
      s.push(l.data);
    }
    return { valid: !0, data: s };
  } else return t === Y.date && r === Y.date && +e == +n ? { valid: !0, data: e } : { valid: !1 };
}
var yu = class extends Pe {
  _parse(n) {
    let { status: t, ctx: r } = this._processInputParams(n),
      s = (i, o) => {
        if (jh(i) || jh(o)) return ge;
        let a = ry(i.value, o.value);
        return a.valid
          ? ((Qh(i) || Qh(o)) && t.dirty(), { status: t.value, value: a.data })
          : (W(r, { code: Q.invalid_intersection_types }), ge);
      };
    return r.common.async
      ? Promise.all([
          this._def.left._parseAsync({ data: r.data, path: r.path, parent: r }),
          this._def.right._parseAsync({ data: r.data, path: r.path, parent: r }),
        ]).then(([i, o]) => s(i, o))
      : s(
          this._def.left._parseSync({ data: r.data, path: r.path, parent: r }),
          this._def.right._parseSync({ data: r.data, path: r.path, parent: r }),
        );
  }
};
yu.create = (e, n, t) => new yu({ left: e, right: n, typeName: ke.ZodIntersection, ...Le(t) });
var Ki = class e extends Pe {
  _parse(n) {
    let { status: t, ctx: r } = this._processInputParams(n);
    if (r.parsedType !== Y.array)
      return (W(r, { code: Q.invalid_type, expected: Y.array, received: r.parsedType }), ge);
    if (r.data.length < this._def.items.length)
      return (
        W(r, {
          code: Q.too_small,
          minimum: this._def.items.length,
          inclusive: !0,
          exact: !1,
          type: 'array',
        }),
        ge
      );
    !this._def.rest &&
      r.data.length > this._def.items.length &&
      (W(r, {
        code: Q.too_big,
        maximum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: 'array',
      }),
      t.dirty());
    let i = [...r.data]
      .map((o, a) => {
        let l = this._def.items[a] || this._def.rest;
        return l ? l._parse(new ks(r, o, r.path, a)) : null;
      })
      .filter((o) => !!o);
    return r.common.async ? Promise.all(i).then((o) => Vt.mergeArray(t, o)) : Vt.mergeArray(t, i);
  }
  get items() {
    return this._def.items;
  }
  rest(n) {
    return new e({ ...this._def, rest: n });
  }
};
Ki.create = (e, n) => {
  if (!Array.isArray(e)) throw new Error('You must pass an array of schemas to z.tuple([ ... ])');
  return new Ki({ items: e, typeName: ke.ZodTuple, rest: null, ...Le(n) });
};
var Vh = class e extends Pe {
    get keySchema() {
      return this._def.keyType;
    }
    get valueSchema() {
      return this._def.valueType;
    }
    _parse(n) {
      let { status: t, ctx: r } = this._processInputParams(n);
      if (r.parsedType !== Y.object)
        return (W(r, { code: Q.invalid_type, expected: Y.object, received: r.parsedType }), ge);
      let s = [],
        i = this._def.keyType,
        o = this._def.valueType;
      for (let a in r.data)
        s.push({
          key: i._parse(new ks(r, a, r.path, a)),
          value: o._parse(new ks(r, r.data[a], r.path, a)),
          alwaysSet: a in r.data,
        });
      return r.common.async ? Vt.mergeObjectAsync(t, s) : Vt.mergeObjectSync(t, s);
    }
    get element() {
      return this._def.valueType;
    }
    static create(n, t, r) {
      return t instanceof Pe
        ? new e({ keyType: n, valueType: t, typeName: ke.ZodRecord, ...Le(r) })
        : new e({ keyType: Va.create(), valueType: n, typeName: ke.ZodRecord, ...Le(t) });
    }
  },
  Cf = class extends Pe {
    get keySchema() {
      return this._def.keyType;
    }
    get valueSchema() {
      return this._def.valueType;
    }
    _parse(n) {
      let { status: t, ctx: r } = this._processInputParams(n);
      if (r.parsedType !== Y.map)
        return (W(r, { code: Q.invalid_type, expected: Y.map, received: r.parsedType }), ge);
      let s = this._def.keyType,
        i = this._def.valueType,
        o = [...r.data.entries()].map(([a, l], u) => ({
          key: s._parse(new ks(r, a, r.path, [u, 'key'])),
          value: i._parse(new ks(r, l, r.path, [u, 'value'])),
        }));
      if (r.common.async) {
        let a = new Map();
        return Promise.resolve().then(async () => {
          for (let l of o) {
            let u = await l.key,
              c = await l.value;
            if (u.status === 'aborted' || c.status === 'aborted') return ge;
            ((u.status === 'dirty' || c.status === 'dirty') && t.dirty(), a.set(u.value, c.value));
          }
          return { status: t.value, value: a };
        });
      } else {
        let a = new Map();
        for (let l of o) {
          let u = l.key,
            c = l.value;
          if (u.status === 'aborted' || c.status === 'aborted') return ge;
          ((u.status === 'dirty' || c.status === 'dirty') && t.dirty(), a.set(u.value, c.value));
        }
        return { status: t.value, value: a };
      }
    }
  };
Cf.create = (e, n, t) => new Cf({ valueType: n, keyType: e, typeName: ke.ZodMap, ...Le(t) });
var Ef = class e extends Pe {
  _parse(n) {
    let { status: t, ctx: r } = this._processInputParams(n);
    if (r.parsedType !== Y.set)
      return (W(r, { code: Q.invalid_type, expected: Y.set, received: r.parsedType }), ge);
    let s = this._def;
    (s.minSize !== null &&
      r.data.size < s.minSize.value &&
      (W(r, {
        code: Q.too_small,
        minimum: s.minSize.value,
        type: 'set',
        inclusive: !0,
        exact: !1,
        message: s.minSize.message,
      }),
      t.dirty()),
      s.maxSize !== null &&
        r.data.size > s.maxSize.value &&
        (W(r, {
          code: Q.too_big,
          maximum: s.maxSize.value,
          type: 'set',
          inclusive: !0,
          exact: !1,
          message: s.maxSize.message,
        }),
        t.dirty()));
    let i = this._def.valueType;
    function o(l) {
      let u = new Set();
      for (let c of l) {
        if (c.status === 'aborted') return ge;
        (c.status === 'dirty' && t.dirty(), u.add(c.value));
      }
      return { status: t.value, value: u };
    }
    let a = [...r.data.values()].map((l, u) => i._parse(new ks(r, l, r.path, u)));
    return r.common.async ? Promise.all(a).then((l) => o(l)) : o(a);
  }
  min(n, t) {
    return new e({ ...this._def, minSize: { value: n, message: ue.toString(t) } });
  }
  max(n, t) {
    return new e({ ...this._def, maxSize: { value: n, message: ue.toString(t) } });
  }
  size(n, t) {
    return this.min(n, t).max(n, t);
  }
  nonempty(n) {
    return this.min(1, n);
  }
};
Ef.create = (e, n) =>
  new Ef({ valueType: e, minSize: null, maxSize: null, typeName: ke.ZodSet, ...Le(n) });
var Dh = class e extends Pe {
    constructor() {
      (super(...arguments), (this.validate = this.implement));
    }
    _parse(n) {
      let { ctx: t } = this._processInputParams(n);
      if (t.parsedType !== Y.function)
        return (W(t, { code: Q.invalid_type, expected: Y.function, received: t.parsedType }), ge);
      function r(a, l) {
        return Pm({
          data: a,
          path: t.path,
          errorMaps: [t.common.contextualErrorMap, t.schemaErrorMap, wf(), qo].filter((u) => !!u),
          issueData: { code: Q.invalid_arguments, argumentsError: l },
        });
      }
      function s(a, l) {
        return Pm({
          data: a,
          path: t.path,
          errorMaps: [t.common.contextualErrorMap, t.schemaErrorMap, wf(), qo].filter((u) => !!u),
          issueData: { code: Q.invalid_return_type, returnTypeError: l },
        });
      }
      let i = { errorMap: t.common.contextualErrorMap },
        o = t.data;
      if (this._def.returns instanceof Ba) {
        let a = this;
        return er(async function (...l) {
          let u = new wr([]),
            c = await a._def.args.parseAsync(l, i).catch((m) => {
              throw (u.addIssue(r(l, m)), u);
            }),
            f = await Reflect.apply(o, this, c);
          return await a._def.returns._def.type.parseAsync(f, i).catch((m) => {
            throw (u.addIssue(s(f, m)), u);
          });
        });
      } else {
        let a = this;
        return er(function (...l) {
          let u = a._def.args.safeParse(l, i);
          if (!u.success) throw new wr([r(l, u.error)]);
          let c = Reflect.apply(o, this, u.data),
            f = a._def.returns.safeParse(c, i);
          if (!f.success) throw new wr([s(c, f.error)]);
          return f.data;
        });
      }
    }
    parameters() {
      return this._def.args;
    }
    returnType() {
      return this._def.returns;
    }
    args(...n) {
      return new e({ ...this._def, args: Ki.create(n).rest(No.create()) });
    }
    returns(n) {
      return new e({ ...this._def, returns: n });
    }
    implement(n) {
      return this.parse(n);
    }
    strictImplement(n) {
      return this.parse(n);
    }
    static create(n, t, r) {
      return new e({
        args: n || Ki.create([]).rest(No.create()),
        returns: t || No.create(),
        typeName: ke.ZodFunction,
        ...Le(r),
      });
    }
  },
  wu = class extends Pe {
    get schema() {
      return this._def.getter();
    }
    _parse(n) {
      let { ctx: t } = this._processInputParams(n);
      return this._def.getter()._parse({ data: t.data, path: t.path, parent: t });
    }
  };
wu.create = (e, n) => new wu({ getter: e, typeName: ke.ZodLazy, ...Le(n) });
var Su = class extends Pe {
  _parse(n) {
    if (n.data !== this._def.value) {
      let t = this._getOrReturnCtx(n);
      return (W(t, { received: t.data, code: Q.invalid_literal, expected: this._def.value }), ge);
    }
    return { status: 'valid', value: n.data };
  }
  get value() {
    return this._def.value;
  }
};
Su.create = (e, n) => new Su({ value: e, typeName: ke.ZodLiteral, ...Le(n) });
function WR(e, n) {
  return new Tu({ values: e, typeName: ke.ZodEnum, ...Le(n) });
}
var Tu = class e extends Pe {
  _parse(n) {
    if (typeof n.data != 'string') {
      let t = this._getOrReturnCtx(n),
        r = this._def.values;
      return (
        W(t, { expected: Be.joinValues(r), received: t.parsedType, code: Q.invalid_type }),
        ge
      );
    }
    if ((this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(n.data))) {
      let t = this._getOrReturnCtx(n),
        r = this._def.values;
      return (W(t, { received: t.data, code: Q.invalid_enum_value, options: r }), ge);
    }
    return er(n.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    let n = {};
    for (let t of this._def.values) n[t] = t;
    return n;
  }
  get Values() {
    let n = {};
    for (let t of this._def.values) n[t] = t;
    return n;
  }
  get Enum() {
    let n = {};
    for (let t of this._def.values) n[t] = t;
    return n;
  }
  extract(n, t = this._def) {
    return e.create(n, { ...this._def, ...t });
  }
  exclude(n, t = this._def) {
    return e.create(
      this.options.filter((r) => !n.includes(r)),
      { ...this._def, ...t },
    );
  }
};
Tu.create = WR;
var Ru = class extends Pe {
  _parse(n) {
    let t = Be.getValidEnumValues(this._def.values),
      r = this._getOrReturnCtx(n);
    if (r.parsedType !== Y.string && r.parsedType !== Y.number) {
      let s = Be.objectValues(t);
      return (
        W(r, { expected: Be.joinValues(s), received: r.parsedType, code: Q.invalid_type }),
        ge
      );
    }
    if (
      (this._cache || (this._cache = new Set(Be.getValidEnumValues(this._def.values))),
      !this._cache.has(n.data))
    ) {
      let s = Be.objectValues(t);
      return (W(r, { received: r.data, code: Q.invalid_enum_value, options: s }), ge);
    }
    return er(n.data);
  }
  get enum() {
    return this._def.values;
  }
};
Ru.create = (e, n) => new Ru({ values: e, typeName: ke.ZodNativeEnum, ...Le(n) });
var Ba = class extends Pe {
  unwrap() {
    return this._def.type;
  }
  _parse(n) {
    let { ctx: t } = this._processInputParams(n);
    if (t.parsedType !== Y.promise && t.common.async === !1)
      return (W(t, { code: Q.invalid_type, expected: Y.promise, received: t.parsedType }), ge);
    let r = t.parsedType === Y.promise ? t.data : Promise.resolve(t.data);
    return er(
      r.then((s) =>
        this._def.type.parseAsync(s, { path: t.path, errorMap: t.common.contextualErrorMap }),
      ),
    );
  }
};
Ba.create = (e, n) => new Ba({ type: e, typeName: ke.ZodPromise, ...Le(n) });
var xs = class extends Pe {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ke.ZodEffects
      ? this._def.schema.sourceType()
      : this._def.schema;
  }
  _parse(n) {
    let { status: t, ctx: r } = this._processInputParams(n),
      s = this._def.effect || null,
      i = {
        addIssue: (o) => {
          (W(r, o), o.fatal ? t.abort() : t.dirty());
        },
        get path() {
          return r.path;
        },
      };
    if (((i.addIssue = i.addIssue.bind(i)), s.type === 'preprocess')) {
      let o = s.transform(r.data, i);
      if (r.common.async)
        return Promise.resolve(o).then(async (a) => {
          if (t.value === 'aborted') return ge;
          let l = await this._def.schema._parseAsync({ data: a, path: r.path, parent: r });
          return l.status === 'aborted'
            ? ge
            : l.status === 'dirty'
              ? mu(l.value)
              : t.value === 'dirty'
                ? mu(l.value)
                : l;
        });
      {
        if (t.value === 'aborted') return ge;
        let a = this._def.schema._parseSync({ data: o, path: r.path, parent: r });
        return a.status === 'aborted'
          ? ge
          : a.status === 'dirty'
            ? mu(a.value)
            : t.value === 'dirty'
              ? mu(a.value)
              : a;
      }
    }
    if (s.type === 'refinement') {
      let o = (a) => {
        let l = s.refinement(a, i);
        if (r.common.async) return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error(
            'Async refinement encountered during synchronous parse operation. Use .parseAsync instead.',
          );
        return a;
      };
      if (r.common.async === !1) {
        let a = this._def.schema._parseSync({ data: r.data, path: r.path, parent: r });
        return a.status === 'aborted'
          ? ge
          : (a.status === 'dirty' && t.dirty(), o(a.value), { status: t.value, value: a.value });
      } else
        return this._def.schema
          ._parseAsync({ data: r.data, path: r.path, parent: r })
          .then((a) =>
            a.status === 'aborted'
              ? ge
              : (a.status === 'dirty' && t.dirty(),
                o(a.value).then(() => ({ status: t.value, value: a.value }))),
          );
    }
    if (s.type === 'transform')
      if (r.common.async === !1) {
        let o = this._def.schema._parseSync({ data: r.data, path: r.path, parent: r });
        if (!Fa(o)) return ge;
        let a = s.transform(o.value, i);
        if (a instanceof Promise)
          throw new Error(
            'Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.',
          );
        return { status: t.value, value: a };
      } else
        return this._def.schema
          ._parseAsync({ data: r.data, path: r.path, parent: r })
          .then((o) =>
            Fa(o)
              ? Promise.resolve(s.transform(o.value, i)).then((a) => ({
                  status: t.value,
                  value: a,
                }))
              : ge,
          );
    Be.assertNever(s);
  }
};
xs.create = (e, n, t) => new xs({ schema: e, typeName: ke.ZodEffects, effect: n, ...Le(t) });
xs.createWithPreprocess = (e, n, t) =>
  new xs({
    schema: n,
    effect: { type: 'preprocess', transform: e },
    typeName: ke.ZodEffects,
    ...Le(t),
  });
var vs = class extends Pe {
  _parse(n) {
    return this._getType(n) === Y.undefined ? er(void 0) : this._def.innerType._parse(n);
  }
  unwrap() {
    return this._def.innerType;
  }
};
vs.create = (e, n) => new vs({ innerType: e, typeName: ke.ZodOptional, ...Le(n) });
var Pi = class extends Pe {
  _parse(n) {
    return this._getType(n) === Y.null ? er(null) : this._def.innerType._parse(n);
  }
  unwrap() {
    return this._def.innerType;
  }
};
Pi.create = (e, n) => new Pi({ innerType: e, typeName: ke.ZodNullable, ...Le(n) });
var $u = class extends Pe {
  _parse(n) {
    let { ctx: t } = this._processInputParams(n),
      r = t.data;
    return (
      t.parsedType === Y.undefined && (r = this._def.defaultValue()),
      this._def.innerType._parse({ data: r, path: t.path, parent: t })
    );
  }
  removeDefault() {
    return this._def.innerType;
  }
};
$u.create = (e, n) =>
  new $u({
    innerType: e,
    typeName: ke.ZodDefault,
    defaultValue: typeof n.default == 'function' ? n.default : () => n.default,
    ...Le(n),
  });
var Cu = class extends Pe {
  _parse(n) {
    let { ctx: t } = this._processInputParams(n),
      r = { ...t, common: { ...t.common, issues: [] } },
      s = this._def.innerType._parse({ data: r.data, path: r.path, parent: { ...r } });
    return Sf(s)
      ? s.then((i) => ({
          status: 'valid',
          value:
            i.status === 'valid'
              ? i.value
              : this._def.catchValue({
                  get error() {
                    return new wr(r.common.issues);
                  },
                  input: r.data,
                }),
        }))
      : {
          status: 'valid',
          value:
            s.status === 'valid'
              ? s.value
              : this._def.catchValue({
                  get error() {
                    return new wr(r.common.issues);
                  },
                  input: r.data,
                }),
        };
  }
  removeCatch() {
    return this._def.innerType;
  }
};
Cu.create = (e, n) =>
  new Cu({
    innerType: e,
    typeName: ke.ZodCatch,
    catchValue: typeof n.catch == 'function' ? n.catch : () => n.catch,
    ...Le(n),
  });
var Mf = class extends Pe {
  _parse(n) {
    if (this._getType(n) !== Y.nan) {
      let r = this._getOrReturnCtx(n);
      return (W(r, { code: Q.invalid_type, expected: Y.nan, received: r.parsedType }), ge);
    }
    return { status: 'valid', value: n.data };
  }
};
Mf.create = (e) => new Mf({ typeName: ke.ZodNaN, ...Le(e) });
var jA = Symbol('zod_brand'),
  Im = class extends Pe {
    _parse(n) {
      let { ctx: t } = this._processInputParams(n),
        r = t.data;
      return this._def.type._parse({ data: r, path: t.path, parent: t });
    }
    unwrap() {
      return this._def.type;
    }
  },
  Am = class e extends Pe {
    _parse(n) {
      let { status: t, ctx: r } = this._processInputParams(n);
      if (r.common.async)
        return (async () => {
          let i = await this._def.in._parseAsync({ data: r.data, path: r.path, parent: r });
          return i.status === 'aborted'
            ? ge
            : i.status === 'dirty'
              ? (t.dirty(), mu(i.value))
              : this._def.out._parseAsync({ data: i.value, path: r.path, parent: r });
        })();
      {
        let s = this._def.in._parseSync({ data: r.data, path: r.path, parent: r });
        return s.status === 'aborted'
          ? ge
          : s.status === 'dirty'
            ? (t.dirty(), { status: 'dirty', value: s.value })
            : this._def.out._parseSync({ data: s.value, path: r.path, parent: r });
      }
    }
    static create(n, t) {
      return new e({ in: n, out: t, typeName: ke.ZodPipeline });
    }
  },
  Eu = class extends Pe {
    _parse(n) {
      let t = this._def.innerType._parse(n),
        r = (s) => (Fa(s) && (s.value = Object.freeze(s.value)), s);
      return Sf(t) ? t.then((s) => r(s)) : r(t);
    }
    unwrap() {
      return this._def.innerType;
    }
  };
Eu.create = (e, n) => new Eu({ innerType: e, typeName: ke.ZodReadonly, ...Le(n) });
function UR(e, n) {
  let t = typeof e == 'function' ? e(n) : typeof e == 'string' ? { message: e } : e;
  return typeof t == 'string' ? { message: t } : t;
}
function JR(e, n = {}, t) {
  return e
    ? Da.create().superRefine((r, s) => {
        let i = e(r);
        if (i instanceof Promise)
          return i.then((o) => {
            if (!o) {
              let a = UR(n, r),
                l = a.fatal ?? t ?? !0;
              s.addIssue({ code: 'custom', ...a, fatal: l });
            }
          });
        if (!i) {
          let o = UR(n, r),
            a = o.fatal ?? t ?? !0;
          s.addIssue({ code: 'custom', ...o, fatal: a });
        }
      })
    : Da.create();
}
var QA = { object: Sr.lazycreate },
  ke;
(function (e) {
  ((e.ZodString = 'ZodString'),
    (e.ZodNumber = 'ZodNumber'),
    (e.ZodNaN = 'ZodNaN'),
    (e.ZodBigInt = 'ZodBigInt'),
    (e.ZodBoolean = 'ZodBoolean'),
    (e.ZodDate = 'ZodDate'),
    (e.ZodSymbol = 'ZodSymbol'),
    (e.ZodUndefined = 'ZodUndefined'),
    (e.ZodNull = 'ZodNull'),
    (e.ZodAny = 'ZodAny'),
    (e.ZodUnknown = 'ZodUnknown'),
    (e.ZodNever = 'ZodNever'),
    (e.ZodVoid = 'ZodVoid'),
    (e.ZodArray = 'ZodArray'),
    (e.ZodObject = 'ZodObject'),
    (e.ZodUnion = 'ZodUnion'),
    (e.ZodDiscriminatedUnion = 'ZodDiscriminatedUnion'),
    (e.ZodIntersection = 'ZodIntersection'),
    (e.ZodTuple = 'ZodTuple'),
    (e.ZodRecord = 'ZodRecord'),
    (e.ZodMap = 'ZodMap'),
    (e.ZodSet = 'ZodSet'),
    (e.ZodFunction = 'ZodFunction'),
    (e.ZodLazy = 'ZodLazy'),
    (e.ZodLiteral = 'ZodLiteral'),
    (e.ZodEnum = 'ZodEnum'),
    (e.ZodEffects = 'ZodEffects'),
    (e.ZodNativeEnum = 'ZodNativeEnum'),
    (e.ZodOptional = 'ZodOptional'),
    (e.ZodNullable = 'ZodNullable'),
    (e.ZodDefault = 'ZodDefault'),
    (e.ZodCatch = 'ZodCatch'),
    (e.ZodPromise = 'ZodPromise'),
    (e.ZodBranded = 'ZodBranded'),
    (e.ZodPipeline = 'ZodPipeline'),
    (e.ZodReadonly = 'ZodReadonly'));
})(ke || (ke = {}));
var FA = (e, n = { message: `Input not instance of ${e.name}` }) => JR((t) => t instanceof e, n),
  XR = Va.create,
  YR = pu.create,
  VA = Mf.create,
  DA = gu.create,
  e$ = hu.create,
  BA = bu.create,
  zA = Rf.create,
  UA = vu.create,
  GA = ku.create,
  ZA = Da.create,
  HA = No.create,
  WA = Zs.create,
  JA = $f.create,
  XA = Oo.create,
  YA = Sr.create,
  ej = Sr.strictCreate,
  nj = xu.create,
  tj = Fh.create,
  rj = yu.create,
  sj = Ki.create,
  ij = Vh.create,
  oj = Cf.create,
  aj = Ef.create,
  lj = Dh.create,
  uj = wu.create,
  cj = Su.create,
  fj = Tu.create,
  dj = Ru.create,
  mj = Ba.create,
  pj = xs.create,
  gj = vs.create,
  hj = Pi.create,
  bj = xs.createWithPreprocess,
  vj = Am.create,
  kj = () => XR().optional(),
  xj = () => YR().optional(),
  yj = () => e$().optional(),
  wj = {
    string: (e) => Va.create({ ...e, coerce: !0 }),
    number: (e) => pu.create({ ...e, coerce: !0 }),
    boolean: (e) => hu.create({ ...e, coerce: !0 }),
    bigint: (e) => gu.create({ ...e, coerce: !0 }),
    date: (e) => bu.create({ ...e, coerce: !0 }),
  };
var Sj = ge;
var zh = /^-?(0|[1-9]\d*)(\/[1-9]\d*)?$/,
  Tj = 10n ** 12n,
  Rj = 4096;
function n$(e) {
  return e < 0n ? -e : e;
}
function $j(e, n) {
  for (e = n$(e), n = n$(n); n !== 0n; ) [e, n] = [n, e % n];
  return e;
}
function t$(e) {
  if (typeof e == 'bigint') return e;
  if (!Number.isSafeInteger(e)) throw new RangeError(`entier attendu : ${e}`);
  return BigInt(e);
}
function C(e, n = 1n) {
  let t = t$(e),
    r = t$(n);
  if (r === 0n) throw new RangeError('d\xE9nominateur nul');
  r < 0n && ((t = -t), (r = -r));
  let s = $j(t, r) || 1n;
  return { n: t / s, d: r / s };
}
var F = C(0),
  q = C(1);
function re(e, n) {
  return C(e.n * n.d + n.n * e.d, e.d * n.d);
}
function me(e, n) {
  return C(e.n * n.d - n.n * e.d, e.d * n.d);
}
function N(e, n) {
  return C(e.n * n.n, e.d * n.d);
}
function A(e, n) {
  return n.n === 0n ? null : C(e.n * n.d, e.d * n.n);
}
function fe(e) {
  return { n: -e.n, d: e.d };
}
function mn(e) {
  return e.n < 0n ? fe(e) : e;
}
function te(e) {
  return e.n === 0n ? 0 : e.n < 0n ? -1 : 1;
}
function Re(e, n) {
  let t = e.n * n.d - n.n * e.d;
  return t === 0n ? 0 : t < 0n ? -1 : 1;
}
function M(e, n) {
  return e.n === n.n && e.d === n.d;
}
function L(e) {
  return e.n === 0n;
}
function B(e) {
  return e.d === 1n;
}
function at(e, n) {
  if (!Number.isInteger(n) || Math.abs(n) > Rj) return null;
  if (n < 0) return e.n === 0n ? null : at(C(e.d, e.n), -n);
  let t = BigInt(n);
  return C(e.n ** t, e.d ** t);
}
function bt(e) {
  return e.d === 1n ? e.n.toString() : `${e.n}/${e.d}`;
}
function sy(e) {
  if (!zh.test(e)) return null;
  let [n, t] = e.split('/');
  return C(BigInt(n), t === void 0 ? 1n : BigInt(t));
}
var Cj = /^([+\-−]?)(\d{1,40})(?:[.,](\d{1,40}))?$/;
function nr(e) {
  let n = Cj.exec(e.trim());
  if (!n) return null;
  let t = n[3] ?? '',
    r = BigInt(n[2] + t),
    s = C(r, 10n ** BigInt(t.length));
  return n[1] === '-' || n[1] === '\u2212' ? fe(s) : s;
}
function en(e) {
  return Number(e.n) / Number(e.d);
}
function _f(e) {
  if (e < 1n || e > Tj) return null;
  let n = Number(e),
    t = 1,
    r = 1;
  for (let s = 2; s * s <= n; s += s === 2 ? 1 : 2) {
    let i = 0;
    for (; n % s === 0; ) ((n /= s), i++);
    i > 0 && ((t *= s ** Math.floor(i / 2)), i % 2 === 1 && (r *= s));
  }
  return (n > 1 && (r *= n), { square: BigInt(t), free: BigInt(r) });
}
function iy(e, n) {
  if (n < 0n) return null;
  if (e.n === 0n || n === 0n) return { coef: F, rad: 1n };
  let t = _f(n);
  return t ? { coef: N(e, C(t.square)), rad: t.free } : null;
}
function Uh(e) {
  return { coef: e, rad: 1n };
}
function Hs(e) {
  return e.n < 0n ? null : iy(C(1n, e.d), e.n * e.d);
}
function jm(e) {
  return e.rad === 1n || e.coef.n === 0n;
}
function Bh(e, n) {
  if (e.rad === 1n || e.coef.n === 0n) return Re(e.coef, n);
  let t = te(e.coef),
    r = te(n);
  if (t !== r) return t > r ? 1 : -1;
  let s = N(N(e.coef, e.coef), C(e.rad)),
    i = N(n, n),
    o = Re(s, i);
  return t > 0 ? o : -o;
}
function qf(e, n, t) {
  if (!Number.isInteger(t) || t < 0 || t > 30) return !1;
  let r = C(1n, 2n * 10n ** BigInt(t));
  return Bh(e, me(n, r)) >= 0 && Bh(e, re(n, r)) <= 0;
}
function on(e) {
  return e.k === 'rel'
    ? [{ rel: e.rel, l: e.l, r: e.r }]
    : e.k === 'or'
      ? e.items
      : e.k === 'set'
        ? e.clauses.flat()
        : [];
}
function Mt(e, n) {
  let t = (r) => ({ rel: r.rel, l: n(r.l), r: n(r.r) });
  return e.k === 'expr'
    ? { k: 'expr', e: n(e.e) }
    : e.k === 'rel'
      ? { k: 'rel', ...t(e) }
      : e.k === 'set'
        ? { k: 'set', clauses: e.clauses.map((r) => r.map(t)) }
        : { k: 'or', items: e.items.map(t) };
}
var T = (e) => ({ k: 'num', v: typeof e == 'number' ? C(e) : e }),
  rn = (e) => ({ k: 'sym', n: e }),
  he = (...e) => ({ k: 'add', c: e }),
  I = (...e) => ({ k: 'mul', c: e }),
  ye = (e, n) => ({ k: 'div', a: e, b: n }),
  et = (e, n) => ({ k: 'pow', a: e, b: n }),
  be = (e, n) => ({ k: 'fn', f: e, a: n }),
  i$ = (e, n) => ({ k: 'binom', a: e, b: n }),
  Mu = (e) => (e.k === 'num' ? T(fe(e.v)) : I(T(-1), e)),
  ve = (e, n) => he(e, Mu(n));
var _u = { π: 1 },
  Gr = class extends Error {
    constructor(t) {
      super(`non pris en charge : ${t}`);
      this.what = t;
    }
    what;
  };
function Ej(e) {
  let n = String(e),
    t = /^(-?)(\d+)(?:\.(\d+))?e([+-]\d+)$/.exec(n);
  if (!t) return n;
  let r = t[2] + (t[3] ?? ''),
    s = t[2].length + Number(t[4]),
    i =
      s <= 0
        ? '0.' + '0'.repeat(-s) + r
        : s >= r.length
          ? r + '0'.repeat(s - r.length)
          : r.slice(0, s) + '.' + r.slice(s);
  return t[1] + i;
}
function Mj(e) {
  if (!Number.isFinite(e)) throw new Gr('nombre infini');
  let n = nr(Ej(e));
  if (!n) throw new Gr(`nombre ${e}`);
  return n;
}
function _e(e) {
  switch (e.k) {
    case 'n':
      return T(Mj(e.v));
    case 's':
      return rn(e.n);
    case 'add':
      return he(...e.c.map(_e));
    case 'mul':
      return I(...e.c.map(_e));
    case 'div':
      return ye(_e(e.a), _e(e.b));
    case 'pow':
      return et(_e(e.a), _e(e.b));
    case 'neg':
      return Mu(_e(e.a));
    case 'sq':
      return et(_e(e.a), T(2));
    case 'pct':
      return ye(_e(e.a), T(100));
    case 'binom':
      return i$(_e(e.a), _e(e.b));
    case 'sqrt':
    case 'abs':
    case 'fact':
    case 'deg':
    case 'ln':
    case 'exp':
    case 'cos':
    case 'sin':
    case 'tan':
    case 'arg':
    case 'arccos':
    case 'arcsin':
    case 'arctan':
    case 'log':
      return be(e.k, _e(e.a));
  }
  throw new Gr(e.k);
}
function _j(e) {
  if (!e.chain || e.chain.length !== e.sides.length - 1) return null;
  let n = e.sides.map(_e);
  return e.chain.map((t, r) => ({ rel: t, l: n[r], r: n[r + 1] }));
}
function oy(e) {
  return e.chain || e.rels || e.mod !== void 0
    ? null
    : e.cmp
      ? e.cmp === '\u2248'
        ? null
        : { rel: e.cmp, l: _e(e.sides[0]), r: _e(e.sides[1]) }
      : e.sides.length === 1
        ? _e(e.sides[0])
        : e.sides.length === 2
          ? { rel: '=', l: _e(e.sides[0]), r: _e(e.sides[1]) }
          : null;
}
function ie(e) {
  let n;
  try {
    n = Ve(e);
  } catch {
    return { ok: !1, reason: 'unparsable' };
  }
  return qu(n);
}
function qu(e) {
  try {
    if (
      e.dis.some((r) => r.chain) ||
      (e.dis.length > 1 && e.dis.some((r) => r.cmp && r.cmp !== '\u2248'))
    ) {
      let r = [];
      for (let s of e.dis) {
        let i = _j(s);
        if (i) {
          r.push(i);
          continue;
        }
        let o = oy(s);
        if (!o || !('rel' in o)) return { ok: !1, reason: 'unsupported' };
        r.push([o]);
      }
      return { ok: !0, s: { k: 'set', clauses: r } };
    }
    if (e.dis.length > 1) {
      let r = [];
      for (let s of e.dis) {
        let i = oy(s);
        if (!i || !('rel' in i) || i.rel !== '=') return { ok: !1, reason: 'unsupported' };
        r.push(i);
      }
      return { ok: !0, s: { k: 'or', items: r } };
    }
    let t = oy(e.dis[0]);
    return t === null
      ? { ok: !1, reason: 'unsupported' }
      : { ok: !0, s: 'rel' in t ? { k: 'rel', ...t } : { k: 'expr', e: t } };
  } catch (n) {
    if (n instanceof Gr) return { ok: !1, reason: 'unsupported' };
    throw n;
  }
}
function Po(e, n) {
  switch (e.k) {
    case 'num':
      return !1;
    case 'sym':
      return n[e.n] === 'matrix';
    case 'add':
    case 'mul':
      return e.c.some((t) => Po(t, n));
    case 'div':
    case 'pow':
      return Po(e.a, n) || Po(e.b, n);
    case 'fn':
    case 'binom':
      return !1;
  }
}
function E(e) {
  switch (e.k) {
    case 'num':
      return bt(e.v);
    case 'sym':
      return `$${e.n}`;
    case 'add':
      return `+(${e.c.map(E).join(',')})`;
    case 'mul':
      return `*(${e.c.map(E).join(',')})`;
    case 'div':
      return `/(${E(e.a)},${E(e.b)})`;
    case 'pow':
      return `^(${E(e.a)},${E(e.b)})`;
    case 'fn':
      return `${e.f}(${E(e.a)})`;
    case 'binom':
      return `C(${E(e.a)},${E(e.b)})`;
  }
}
function Ii(e) {
  return e.k === 'expr'
    ? `E:${E(e.e)}`
    : e.k === 'rel'
      ? `R:${e.rel}:${E(e.l)}|${E(e.r)}`
      : e.k === 'set'
        ? `S:${e.clauses.map((n) => n.map((t) => `${t.rel}:${E(t.l)}|${E(t.r)}`).join('&')).join(';')}`
        : `O:${e.items.map((n) => `${E(n.l)}|${E(n.r)}`).join(';')}`;
}
var qj = 64n;
function Lj(e) {
  let n = Hs(e);
  return n && jm(n) ? n.coef : null;
}
function R(e, n = {}) {
  switch (e.k) {
    case 'num':
    case 'sym':
      return e;
    case 'add': {
      let t = [],
        r = F;
      for (let i of e.c.map((o) => R(o, n)))
        for (let o of i.k === 'add' ? i.c : [i]) o.k === 'num' ? (r = re(r, o.v)) : t.push(o);
      let s = t.sort(r$);
      return (
        L(r) || s.push(T(r)),
        s.length === 0 ? T(0) : s.length === 1 ? s[0] : { k: 'add', c: s }
      );
    }
    case 'mul': {
      let t = [],
        r = q;
      for (let o of e.c.map((a) => R(a, n)))
        for (let a of o.k === 'mul' ? o.c : [o]) a.k === 'num' ? (r = N(r, a.v)) : t.push(a);
      if (L(r)) return T(0);
      let i = !t.some((o) => Po(o, n)) ? Kj(t, n).sort(r$) : t;
      return i.length === 0
        ? T(r)
        : M(r, q)
          ? i.length === 1
            ? i[0]
            : { k: 'mul', c: i }
          : { k: 'mul', c: [T(r), ...i] };
    }
    case 'div': {
      let t = R(e.a, n),
        r = R(e.b, n);
      if (r.k === 'num' && M(r.v, q)) return t;
      if (t.k === 'num' && r.k === 'num') {
        let s = A(t.v, r.v);
        if (s) return T(s);
      }
      return { k: 'div', a: t, b: r };
    }
    case 'pow': {
      let t = R(e.a, n),
        r = R(e.b, n);
      if (r.k === 'num' && M(r.v, q)) return t;
      if (t.k === 'num' && r.k === 'num' && B(r.v) && mn(r.v).n <= qj) {
        let s = at(t.v, Number(r.v.n));
        if (s) return T(s);
      }
      return { k: 'pow', a: t, b: r };
    }
    case 'fn': {
      let t = R(e.a, n);
      if (t.k === 'num') {
        if (e.f === 'sqrt') {
          let r = Lj(t.v);
          if (r) return T(r);
        }
        if (e.f === 'abs') return T(mn(t.v));
        if (e.f === 'fact' && B(t.v) && t.v.n >= 0n && t.v.n <= 20n) {
          let r = 1n;
          for (let s = 2n; s <= t.v.n; s++) r *= s;
          return T(C(r));
        }
      }
      return { k: 'fn', f: e.f, a: t };
    }
    case 'binom': {
      let t = R(e.a, n),
        r = R(e.b, n);
      if (t.k === 'num' && r.k === 'num') {
        let s = Oj(r.v, t.v);
        if (s !== null) return T(s);
      }
      return { k: 'binom', a: t, b: r };
    }
  }
}
var Nj = 1000n;
function Oj(e, n) {
  if (!B(e) || !B(n) || e.n < 0n || n.n < 0n || e.n > Nj) return null;
  if (n.n > e.n) return F;
  let t = n.n < e.n - n.n ? n.n : e.n - n.n,
    r = 1n;
  for (let s = 1n; s <= t; s++) r = (r * (e.n - t + s)) / s;
  return C(r);
}
function Kj(e, n) {
  let t = new Map(),
    r = [];
  for (let i of e) {
    let o = i.k === 'pow' && i.b.k === 'num' && B(i.b.v),
      a = o ? i.a : i,
      l = o ? i.b.v : q,
      u = E(a),
      c = t.get(u);
    c ? ((c.e = re(c.e, l)), c.n++) : (t.set(u, { base: a, e: l, n: 1 }), r.push(u));
  }
  let s = [];
  for (let i of r) {
    let o = t.get(i);
    if (o.n === 1) {
      s.push(M(o.e, q) ? o.base : { k: 'pow', a: o.base, b: T(o.e) });
      continue;
    }
    L(o.e) || s.push(R(M(o.e, q) ? o.base : { k: 'pow', a: o.base, b: T(o.e) }, n));
  }
  return s;
}
function r$(e, n) {
  let t = E(e),
    r = E(n);
  return t < r ? -1 : t > r ? 1 : 0;
}
function za(e, n, t = {}) {
  return E(R(e, t)) === E(R(n, t));
}
function $(e, n = new Set()) {
  switch (e.k) {
    case 'sym':
      _u[e.n] || n.add(e.n);
      break;
    case 'add':
    case 'mul':
      e.c.forEach((t) => $(t, n));
      break;
    case 'div':
    case 'pow':
    case 'binom':
      ($(e.a, n), $(e.b, n));
      break;
    case 'fn':
      $(e.a, n);
      break;
    default:
      break;
  }
  return n;
}
function Dn(e) {
  let n = new Set();
  return (e.k === 'expr' ? $(e.e, n) : on(e).forEach((t) => ($(t.l, n), $(t.r, n))), n);
}
function j(e, n) {
  switch (e.k) {
    case 'num':
      return e;
    case 'sym':
      return n[e.n] ?? e;
    case 'add':
      return he(...e.c.map((t) => j(t, n)));
    case 'mul':
      return I(...e.c.map((t) => j(t, n)));
    case 'div':
      return ye(j(e.a, n), j(e.b, n));
    case 'pow':
      return et(j(e.a, n), j(e.b, n));
    case 'fn':
      return be(e.f, j(e.a, n));
    case 'binom':
      return i$(j(e.a, n), j(e.b, n));
  }
}
var pn = { add: 1, mul: 2, div: 2, binom: 3, unary: 4, pow: 5, atom: 6 };
function ay(e) {
  let n = e.d,
    t = 0,
    r = 0;
  for (; n % 2n === 0n; ) ((n /= 2n), t++);
  for (; n % 5n === 0n; ) ((n /= 5n), r++);
  let s = Math.max(t, r);
  if (n !== 1n || s === 0 || s > 6) return null;
  let o = (((e.n < 0n ? -e.n : e.n) * 10n ** BigInt(s)) / e.d).toString().padStart(s + 1, '0');
  return `${e.n < 0n ? '\u2212' : ''}${o.slice(0, -s)},${o.slice(-s)}`;
}
function o$(e) {
  let n = e.n < 0n ? '\u2212' : '';
  if (e.d === 1n)
    return { text: n + (e.n < 0n ? -e.n : e.n).toString(), prec: n ? pn.unary : pn.atom };
  let t = e.d > 12n ? ay(e) : null;
  return t
    ? { text: t, prec: n ? pn.unary : pn.atom }
    : { text: `${n}${e.n < 0n ? -e.n : e.n} \xF7 ${e.d}`, prec: pn.mul };
}
function Ko(e, n) {
  return e.prec < n ? `(${e.text})` : e.text;
}
function Pj(e) {
  if (e.k === 'num') return { coef: e.v, rest: [] };
  if (e.k === 'mul') {
    let n = e.c[0];
    return n?.k === 'num' ? { coef: n.v, rest: e.c.slice(1) } : { coef: q, rest: e.c };
  }
  return { coef: q, rest: [e] };
}
function s$(e) {
  return e.k === 'sym'
    ? !0
    : e.k === 'pow'
      ? e.a.k === 'sym'
      : e.k === 'fn'
        ? e.f === 'sqrt'
        : e.k === 'add';
}
function Ij(e) {
  let n = Ws(e);
  return n.text.startsWith('\u2212') || n.prec < pn.mul || e.k === 'div' || e.k === 'binom'
    ? `(${n.text})`
    : n.text;
}
function a$(e, n) {
  if (n.length === 0) return o$(e);
  let t = te(e) < 0,
    r = mn(e),
    s = n
      .map((o) => ({ f: o, t: Ij(o) }))
      .reduce((o, { f: a, t: l }, u) => {
        let c = n[u - 1];
        return (
          u > 0 && a.k === 'sym' && a.n === '\u03C0' && c?.k === 'sym' && c.n !== '\u03C0'
            ? (o[o.length - 1] += l)
            : o.push(l),
          o
        );
      }, []),
    i;
  if (M(r, q)) i = s.join(' \xD7 ');
  else if (r.d === 1n) {
    let o = r.n.toString();
    i = s$(n[0])
      ? o + s[0] + (s.length > 1 ? ' \xD7 ' + s.slice(1).join(' \xD7 ') : '')
      : `${o} \xD7 ${s.join(' \xD7 ')}`;
  } else
    r.n !== 1n && ay(r) && s$(n[0])
      ? (i = ay(r) + s[0] + (s.length > 1 ? ' \xD7 ' + s.slice(1).join(' \xD7 ') : ''))
      : (i = `${a$(C(r.n), n).text} \xF7 ${r.d}`);
  return { text: (t ? '\u2212' : '') + i, prec: t ? pn.unary : pn.mul };
}
function Ws(e) {
  switch (e.k) {
    case 'num':
      return o$(e.v);
    case 'sym':
      return { text: e.n, prec: pn.atom };
    case 'add': {
      let n = e.c.map(Ws),
        t = n.findIndex((i) => !i.text.startsWith('\u2212')),
        r = t > 0 ? [t, ...n.keys()].filter((i, o) => o === 0 || i !== t) : [...n.keys()],
        s = '';
      return (
        r.forEach((i, o) => {
          let a = n[i];
          o === 0
            ? (s = a.text)
            : a.prec < pn.mul
              ? (s += ` + (${a.text})`)
              : a.text.startsWith('\u2212')
                ? (s += ` \u2212 ${a.text.slice(1)}`)
                : (s += ` + ${a.text}`);
        }),
        { text: s, prec: pn.add }
      );
    }
    case 'mul': {
      let { coef: n, rest: t } = Pj(e);
      return a$(n, t);
    }
    case 'div':
      return {
        text: `${e.a.k === 'binom' ? `(${Ws(e.a).text})` : Ko(Ws(e.a), pn.mul)} \xF7 ${Ko(Ws(e.b), pn.pow)}`,
        prec: pn.mul,
      };
    case 'binom':
      return { text: `${Ko(Ws(e.a), pn.pow)} parmi ${Ko(Ws(e.b), pn.pow)}`, prec: pn.binom };
    case 'pow': {
      let n = Ko(Ws(e.a), pn.atom);
      return e.b.k === 'num' && M(e.b.v, C(2))
        ? { text: `${n}\xB2`, prec: pn.pow }
        : { text: `${n}^${Ko(Ws(e.b), pn.atom)}`, prec: pn.pow };
    }
    case 'fn': {
      let n = Ws(e.a);
      switch (e.f) {
        case 'sqrt':
          return { text: `\u221A${Ko(n, pn.atom)}`, prec: pn.unary };
        case 'abs':
          return { text: `|${n.text}|`, prec: pn.atom };
        case 'fact':
          return { text: `${Ko(n, pn.atom)}!`, prec: pn.pow };
        case 'deg':
          return { text: `${Ko(n, pn.atom)}\xB0`, prec: pn.pow };
        default:
          return { text: `${e.f}(${n.text})`, prec: pn.unary };
      }
    }
  }
}
function oe(e) {
  return Ws(e).text;
}
function _t(e) {
  return e.k === 'expr'
    ? oe(e.e)
    : e.k === 'rel'
      ? `${oe(e.l)} ${e.rel} ${oe(e.r)}`
      : e.k === 'set'
        ? e.clauses.map(Aj).join(' ou ')
        : e.items.map((n) => `${oe(n.l)} ${n.rel} ${oe(n.r)}`).join(' ou ');
}
function Aj(e) {
  let n = oe(e[0].l);
  return (
    e.forEach((t, r) => {
      (r > 0 && E(e[r - 1].r) !== E(t.l) && (n += ` et ${oe(t.l)}`), (n += ` ${t.rel} ${oe(t.r)}`));
    }),
    n
  );
}
var sn = class extends Error {
    constructor(t) {
      super(t);
      this.code = t;
    }
    code;
  },
  cy = 4e3,
  b$ = 24,
  Hh = 1e12;
function v$(e) {
  return _u[e]
    ? { key: `$${e}`, kind: 'opaque', term: rn(e), constant: !0, value: Math.PI }
    : { key: `$${e}`, kind: 'sym', term: rn(e), constant: !1, symbol: e };
}
function k$(e) {
  return {
    key: `\u221A${e}`,
    kind: 'root',
    term: be('sqrt', T(e)),
    constant: !0,
    value: Math.sqrt(e),
    prime: e,
  };
}
function Lf(e) {
  let n = Qm(e),
    t = { key: E(e), kind: 'opaque', term: e, constant: !n };
  return (n || (t.value = D(e, {})), t);
}
function Qm(e) {
  switch (e.k) {
    case 'num':
      return !1;
    case 'sym':
      return !_u[e.n];
    case 'add':
    case 'mul':
      return e.c.some(Qm);
    case 'div':
    case 'pow':
    case 'binom':
      return Qm(e.a) || Qm(e.b);
    case 'fn':
      return Qm(e.a);
  }
}
function Ga(e) {
  return e.map((n) => (n.e === 1 ? n.a.key : `${n.a.key}^${n.e}`)).join('\xB7');
}
function jj(e, n) {
  let t = [],
    r = q,
    s = 0,
    i = 0,
    o = (a, l) => {
      if (a.kind === 'root') {
        let u = Math.floor(l / 2);
        (u > 0 && (r = N(r, at(C(a.prime), u))), l % 2 === 1 && t.push({ a, e: 1 }));
      } else t.push({ a, e: l });
    };
  for (; s < e.length || i < n.length; ) {
    let a = e[s],
      l = n[i];
    a && (!l || a.a.key < l.a.key)
      ? (o(a.a, a.e), s++)
      : l && (!a || l.a.key < a.a.key)
        ? (o(l.a, l.e), i++)
        : (o(a.a, a.e + l.e), s++, i++);
  }
  return { c: r, m: t };
}
function x$(e, n) {
  let t = 0,
    r = 0;
  for (; t < e.length || r < n.length; ) {
    let s = e[t],
      i = n[r];
    if (s && (!i || s.a.key < i.a.key)) return 1;
    if (i && (!s || i.a.key < s.a.key)) return -1;
    if (s.e !== i.e) return s.e > i.e ? 1 : -1;
    (t++, r++);
  }
  return 0;
}
function y$(e, n) {
  let t = [],
    r = 0;
  for (let s of e) {
    let i = n[r];
    if (i && i.a.key < s.a.key) return null;
    if (i && i.a.key === s.a.key) {
      if (i.e > s.e) return null;
      (s.e > i.e && t.push({ a: s.a, e: s.e - i.e }), r++);
    } else t.push(s);
  }
  return r === n.length ? t : null;
}
function l$(e) {
  return e.reduce((n, t) => n + t.e, 0);
}
var Um = { t: new Map() };
function qt(e) {
  return L(e) ? { t: new Map() } : { t: new Map([['', { m: [], c: e }]]) };
}
function Zr(e) {
  let n = [{ a: e, e: 1 }];
  return { t: new Map([[Ga(n), { m: n, c: q }]]) };
}
function w$(e, n, t) {
  if (L(t)) return;
  let r = Ga(n),
    s = e.get(r);
  if (!s) e.set(r, { m: n, c: t });
  else {
    let i = re(s.c, t);
    L(i) ? e.delete(r) : e.set(r, { m: n, c: i });
  }
}
function Io(e, n) {
  let t = new Map(e.t);
  for (let { m: r, c: s } of n.t.values()) w$(t, r, s);
  if (t.size > cy) throw new sn('too_big');
  return { t };
}
function lt(e, n) {
  if (L(n)) return Um;
  let t = new Map();
  for (let [r, { m: s, c: i }] of e.t) t.set(r, { m: s, c: N(i, n) });
  return { t };
}
function Gm(e) {
  return lt(e, C(-1));
}
function Lu(e, n) {
  return Io(e, Gm(n));
}
function vt(e, n) {
  if (e.t.size * n.t.size > cy * 8) throw new sn('too_big');
  let t = new Map();
  for (let r of e.t.values())
    for (let s of n.t.values()) {
      let i = jj(r.m, s.m);
      w$(t, i.m, N(N(r.c, s.c), i.c));
    }
  if (t.size > cy) throw new sn('too_big');
  return { t };
}
function Bm(e, n) {
  let t = qt(q);
  for (let r = 0; r < n; r++) t = vt(t, e);
  return t;
}
function Ue(e) {
  return e.t.size === 0;
}
function Zm(e, n) {
  return Ue(Lu(e, n));
}
function je(e) {
  return e.t.size === 0 ? F : e.t.size === 1 && e.t.has('') ? e.t.get('').c : null;
}
function an(e) {
  for (let { m: n } of e.t.values()) if (n.some((t) => !t.a.constant)) return !1;
  return !0;
}
function Dt(e) {
  let n = 0;
  for (let { m: t, c: r } of e.t.values()) n += en(r) * t.reduce((s, i) => s * i.a.value ** i.e, 1);
  return n;
}
function Lt(e) {
  let n = new Set();
  for (let { m: t } of e.t.values())
    for (let r of t)
      if (r.a.kind === 'sym') n.add(r.a.symbol);
      else if (!r.a.constant) for (let s of Fm(r.a.term)) n.add(s);
  return n;
}
function Fm(e, n = new Set()) {
  return (
    e.k === 'sym'
      ? _u[e.n] || n.add(e.n)
      : e.k === 'add' || e.k === 'mul'
        ? e.c.forEach((t) => Fm(t, n))
        : e.k === 'div' || e.k === 'pow'
          ? (Fm(e.a, n), Fm(e.b, n))
          : e.k === 'fn' && Fm(e.a, n),
    n
  );
}
function Wh(e) {
  for (let { m: n } of e.t.values())
    if (n.some((t) => t.a.kind === 'opaque' && !t.a.constant)) return !0;
  return !1;
}
function fy(e) {
  let n = null;
  for (let t of e.t.values()) (!n || x$(t.m, n.m) > 0) && (n = t);
  return n;
}
function Xs(e) {
  return [...e.t.values()].sort((n, t) => l$(t.m) - l$(n.m) || x$(t.m, n.m));
}
function Tr(e, n) {
  if (Ue(n)) return null;
  let t = fy(n),
    r = e,
    s = Um;
  for (let i = 0; i < 2e3; i++) {
    if (Ue(r)) return Zm(vt(s, n), e) ? s : null;
    let o = fy(r),
      a = y$(o.m, t.m);
    if (!a) return null;
    let l = { t: new Map([[Ga(a), { m: a, c: A(o.c, t.c) }]]) };
    s = Io(s, l);
    let u = Lu(r, vt(l, n));
    if (u.t.has(Ga(o.m)) && M(u.t.get(Ga(o.m)).c, o.c)) return null;
    r = u;
  }
  return null;
}
function S$(e) {
  let n = 0n,
    t = 1n,
    r = (s, i) => (i === 0n ? (s < 0n ? -s : s) : r(i, s % i));
  for (let { c: s } of e.t.values()) ((n = r(n, s.n)), (t = (t / r(t, s.d)) * s.d));
  return n === 0n ? q : C(n, t);
}
var zm = () => qt(q);
function ze(e, n = zm()) {
  let t = je(n);
  if (t !== null) {
    if (L(t)) throw new sn('division_by_zero');
    return { n: lt(e, A(q, t)), d: zm() };
  }
  return { n: e, d: n };
}
function Qj(e, n) {
  return Zm(e, n);
}
function Zh(e, n) {
  return Qj(e.d, n.d) ? ze(Io(e.n, n.n), e.d) : ze(Io(vt(e.n, n.d), vt(n.n, e.d)), vt(e.d, n.d));
}
function Fj(e, n) {
  return Zh(e, { n: Gm(n.n), d: n.d });
}
function Js(e, n) {
  return ze(vt(e.n, n.n), vt(e.d, n.d));
}
function Hr(e, n) {
  if (Ue(n.n)) throw new sn('division_by_zero');
  return ze(vt(e.n, n.d), vt(e.d, n.n));
}
function Nu(e) {
  return Ue(e.n);
}
function T$(e, n) {
  return Zm(vt(e.n, n.d), vt(n.n, e.d));
}
function _n(e) {
  let n = je(e.n),
    t = je(e.d);
  return n !== null && t !== null ? A(n, t) : null;
}
function $e(e) {
  let { n, d: t } = e;
  if (je(t) !== null) return ze(n, t);
  let r = Vj([...n.t.values(), ...t.t.values()]);
  r.length && ((n = u$(n, r)), (t = u$(t, r)));
  let s = Tr(n, t);
  if (s) return ze(s);
  let i = fy(t);
  return { n: lt(n, A(q, i.c)), d: lt(t, A(q, i.c)) };
}
function Vj(e) {
  if (!e.length) return [];
  let n = e[0].m.filter((t) => t.a.kind !== 'root');
  for (let t of e.slice(1))
    n = n
      .map((r) => {
        let s = t.m.find((i) => i.a.key === r.a.key);
        return s ? { a: r.a, e: Math.min(r.e, s.e) } : null;
      })
      .filter((r) => r !== null);
  return n;
}
function u$(e, n) {
  let t = new Map();
  for (let r of e.t.values()) {
    let s = y$(r.m, n);
    t.set(Ga(s), { m: s, c: r.c });
  }
  return { t };
}
function Ge(e, n = {}) {
  let t = dr(R(e, n.sorts ?? {}), n.sorts ?? {});
  return Dj(t) ? $e(t) : t;
}
function Dj(e) {
  for (let n of [e.n, e.d])
    for (let t of n.t.values()) if (t.m.some((r) => r.a.key.startsWith('fact('))) return !0;
  return !1;
}
function Z(e, n = {}) {
  try {
    return { ok: !0, rf: Ge(e, n) };
  } catch (t) {
    if (t instanceof sn) return { ok: !1, code: t.code };
    throw t;
  }
}
function dr(e, n) {
  switch (e.k) {
    case 'num':
      return ze(qt(e.v));
    case 'sym':
      return ze(Zr(v$(e.n)));
    case 'add':
      return e.c.map((t) => dr(t, n)).reduce(Zh);
    case 'mul': {
      if (e.c.filter((t) => Po(t, n)).length > 1) throw new sn('noncommutative');
      return e.c.map((t) => dr(t, n)).reduce(Js);
    }
    case 'div':
      return Hr(dr(e.a, n), dr(e.b, n));
    case 'pow':
      return Zj(e.a, e.b, n);
    case 'fn':
      return M$(e.f, e.a, n);
    case 'binom':
      return Gj(e.a, e.b, n);
  }
}
var Bj = 64,
  zj = 1000n;
function Uj(e) {
  let n = 1n;
  for (let t = 2n; t <= e; t++) n *= t;
  return n;
}
function Gh(e) {
  let n = _n(e);
  if (n !== null) {
    if (!B(n) || n.n < 0n) throw new sn('undefined_value');
    if (n.n > zj) throw new sn('too_big');
    return ze(qt(C(Uj(n.n))));
  }
  let t = je(e.d),
    r = () => ze(Zr(Lf(be('fact', Je($e(e))))));
  if (t === null) return r();
  let s = lt(e.n, A(q, t)),
    i = je({ t: new Map([...s.t].filter(([c]) => c === '')) }) ?? F;
  if (!B(i) || mn(i).n > BigInt(Bj)) return r();
  let o = Lu(s, qt(i)),
    a = ze(Zr(Lf(be('fact', kn(o))))),
    l = Number(i.n),
    u = a;
  for (let c = 1; c <= Math.abs(l); c++) {
    let f = l > 0 ? c : 1 - c,
      d = ze(Io(o, qt(C(f))));
    u = l > 0 ? Js(u, d) : Hr(u, d);
  }
  return u;
}
function Gj(e, n, t) {
  let r = $e(dr(e, t)),
    s = $e(dr(n, t)),
    i = _n(r),
    o = _n(s);
  if (i !== null && o !== null) {
    if (!B(i) || !B(o) || i.n < 0n || o.n < 0n) throw new sn('undefined_value');
    if (i.n > o.n) return ze(Um);
  }
  if (i !== null && (!B(i) || i.n < 0n)) throw new sn('undefined_value');
  return Hr(Gh(s), Js(Gh(r), Gh(Fj(s, r))));
}
function c$(e, n) {
  return Je($e(dr(e, n)));
}
function Zj(e, n, t) {
  let r = dr(e, t),
    s = dr(n, t),
    i = _n(s);
  if (i !== null && B(i)) {
    let a = Number(i.n);
    if (Math.abs(a) > b$) {
      let c = _n(r);
      if (c !== null) {
        let f = at(c, a);
        if (f === null) throw new sn(L(c) ? 'division_by_zero' : 'too_big');
        return ze(qt(f));
      }
      throw new sn('too_big');
    }
    let l = Bm(r.n, Math.abs(a)),
      u = Bm(r.d, Math.abs(a));
    return a >= 0 ? ze(l, u) : Hr(ze(zm()), ze(l, u));
  }
  let o = _n(r);
  if (i !== null && o !== null) {
    let a = R$(o, i);
    if (a) return a;
  }
  return i === null && o !== null && te(o) > 0
    ? M$('exp', { k: 'mul', c: [n, { k: 'fn', f: 'ln', a: e }] }, t)
    : ze(Zr(Lf(et(c$(e, t), c$(n, t)))));
}
function R$(e, n) {
  if (e.n < 0n) return null;
  let t = Number(n.d);
  if (t === 2) return $$(at(e, Number(n.n)));
  let r = f$(e.n, t),
    s = f$(e.d, t);
  if (r === null || s === null) return null;
  let i = at(C(r, s), Number(n.n));
  return i ? ze(qt(i)) : null;
}
function f$(e, n) {
  if (e < 0n || n < 2 || n > 64) return null;
  if (e < 2n) return e;
  let t = BigInt(Math.round(Number(e) ** (1 / n)));
  for (let r of [t - 1n, t, t + 1n]) if (r >= 0n && r ** BigInt(n) === e) return r;
  return null;
}
function $$(e) {
  if (e.n < 0n) throw new sn('undefined_value');
  let n = Hs(e);
  if (!n) return null;
  if (n.rad === 1n) return ze(qt(n.coef));
  if (n.rad > BigInt(Hh)) return null;
  let t = C$(Number(n.rad));
  if (!t) return null;
  let r = qt(n.coef);
  for (let s of t) r = vt(r, Zr(k$(s)));
  return ze(r);
}
function C$(e) {
  if (e > Hh) return null;
  let n = [],
    t = e;
  for (let r = 2; r * r <= t; r += r === 2 ? 1 : 2) for (; t % r === 0; ) (n.push(r), (t /= r));
  return (t > 1 && n.push(t), n);
}
var d$ = { exp: q, cos: q, sin: F, tan: F, arcsin: F, arctan: F };
function Hj(e) {
  let n = je(e.d);
  if (n === null) return null;
  let t = [...e.n.t.values()];
  if (!t.length) return F;
  if (t.length !== 1) return null;
  let r = t[0];
  return r.m.length !== 1 || r.m[0].a.key !== '$\u03C0' || r.m[0].e !== 1 ? null : A(r.c, n);
}
var m$ = (e, n) => ze(lt(Zr(k$(e)), n)),
  Vm = (e) => ze(qt(e));
function Ua(e) {
  let n = ((e % 360) + 360) % 360,
    [t, r] = n <= 90 ? [n, 1] : n <= 180 ? [180 - n, -1] : n <= 270 ? [n - 180, -1] : [360 - n, 1],
    s = C(r);
  switch (t) {
    case 0:
      return Vm(s);
    case 30:
      return m$(3, N(s, C(1, 2)));
    case 45:
      return m$(2, N(s, C(1, 2)));
    case 60:
      return Vm(N(s, C(1, 2)));
    default:
      return Vm(F);
  }
}
function Wj(e) {
  let n = Hj(e);
  if (n === null) return null;
  let t = N(n, C(12));
  if (!B(t)) return null;
  let r = Number(t.n);
  return !Number.isSafeInteger(r) || (r % 2 !== 0 && r % 3 !== 0) ? null : r * 15;
}
function Jj(e, n) {
  let t = Wj(n);
  if (t === null) return null;
  if (e === 'cos') return Ua(t);
  if (e === 'sin') return Ua(90 - t);
  let r = Ua(t);
  if (Ue(r.n)) throw new sn('undefined_value');
  return $e(Hr(Ua(90 - t), r));
}
var Xj = (e, n) => Ue(Lu(vt(e.n, n.d), vt(n.n, e.d)));
function Yj(e, n) {
  let t =
    e === 'arccos'
      ? [0, 30, 45, 60, 90, 120, 135, 150, 180]
      : e === 'arcsin'
        ? [-90, -60, -45, -30, 0, 30, 45, 60, 90]
        : [-60, -45, -30, 0, 30, 45, 60];
  for (let r of t) {
    let s = e === 'arccos' ? Ua(r) : e === 'arcsin' ? Ua(90 - r) : $e(Hr(Ua(90 - r), Ua(r)));
    if (Xj(n, s)) return Vm(C(r));
  }
  return null;
}
function p$(e) {
  if (e > BigInt(Hh)) return null;
  let n = new Map();
  for (let t of C$(Number(e)) ?? []) n.set(t, (n.get(t) ?? 0) + 1);
  return n;
}
var dy = (e) => Lf(be('ln', T(e)));
function E$(e) {
  let n = p$(e.n),
    t = p$(e.d);
  if (!n || !t) return null;
  let r = Um;
  for (let [s, i] of n) r = Io(r, lt(Zr(dy(s)), C(i)));
  for (let [s, i] of t) r = Io(r, lt(Zr(dy(s)), C(-i)));
  return ze(r);
}
function eQ(e, n) {
  let t = [...e.n.t.values()],
    r = [...e.d.t.values()];
  if (t.length !== 1 || r.length !== 1) return null;
  let s = A(t[0].c, r[0].c);
  if (te(s) <= 0) return null;
  let i = E$(s);
  if (!i) return null;
  for (let [o, a] of [
    [t[0].m, 1],
    [r[0].m, -1],
  ])
    for (let l of o) {
      let u = C(a * l.e);
      if (l.a.kind === 'root') i = Zh(i, ze(lt(Zr(dy(l.a.prime)), N(u, C(1, 2)))));
      else if (l.a.kind === 'opaque' && l.a.term.k === 'fn' && l.a.term.f === 'exp')
        i = Zh(i, Js(ze(qt(u)), dr(l.a.term.a, n)));
      else return null;
    }
  return i;
}
var ly = (e) => Lf(be('exp', e));
function g$(e, n) {
  let t = Bm(Zr(e), Math.abs(n));
  return n >= 0 ? ze(t) : Hr(ze(zm()), ze(t));
}
function nQ(e) {
  let n = je(e.d);
  if (n === null) return null;
  let t = ze(zm()),
    r = [];
  for (let s of e.n.t.values()) {
    let i = A(s.c, n),
      o = B(i) && Math.abs(Number(i.n)) <= b$;
    if (!s.m.length) {
      o ? (t = Js(t, g$(ly(T(1)), Number(i.n)))) : r.push({ m: [], c: i });
      continue;
    }
    let a = s.m[0],
      l =
        s.m.length === 1 &&
        a.e === 1 &&
        a.a.term.k === 'fn' &&
        a.a.term.f === 'ln' &&
        a.a.term.a.k === 'num'
          ? a.a.term.a.v
          : null;
    if (l && o) {
      t = Js(t, Vm(at(l, Number(i.n))));
      continue;
    }
    if (l) {
      let u = R$(l, i);
      if (u) {
        t = Js(t, u);
        continue;
      }
    }
    if (o) {
      let u = kn({ t: new Map([[Ga(s.m), { m: s.m, c: q }]]) });
      t = Js(t, g$(ly(u), Number(i.n)));
    } else r.push({ m: s.m, c: i });
  }
  if (r.length) {
    let s = { t: new Map(r.map((i) => [Ga(i.m), i])) };
    t = Js(t, ze(Zr(ly(kn(s)))));
  }
  return t;
}
function M$(e, n, t) {
  if (e === 'log')
    return dr({ k: 'div', a: { k: 'fn', f: 'ln', a: n }, b: { k: 'fn', f: 'ln', a: T(10) } }, t);
  if (e === 'ln' && n.k === 'fn' && n.f === 'exp') return dr(n.a, t);
  if (e === 'exp' && n.k === 'fn' && n.f === 'ln') {
    let i = $e(dr(n.a, t));
    if (an(i.n) && an(i.d)) {
      let o = Dt(i.n) / Dt(i.d);
      if (Number.isFinite(o) && o > 1e-9) return i;
    }
  }
  let r = $e(dr(n, t)),
    s = _n(r);
  switch (e) {
    case 'cos':
    case 'sin':
    case 'tan': {
      let i = Jj(e, r);
      if (i) return i;
      break;
    }
    case 'arccos':
    case 'arcsin':
    case 'arctan': {
      if (s !== null && e !== 'arctan' && en(mn(s)) > 1) throw new sn('undefined_value');
      let i = Yj(e, r);
      if (i) return i;
      break;
    }
    case 'exp': {
      let i = nQ(r);
      if (i) return i;
      break;
    }
  }
  switch (e) {
    case 'sqrt': {
      if (s !== null) {
        let i = $$(s);
        if (i) return i;
      }
      break;
    }
    case 'abs': {
      if (s !== null) return ze(qt(mn(s)));
      if (an(r.n) && an(r.d)) {
        let i = Dt(r.n) / Dt(r.d);
        if (Math.abs(i) > 1e-9) return i > 0 ? r : Js(ze(qt(C(-1))), r);
      }
      break;
    }
    case 'deg':
      return Js(r, ze(lt(Zr(v$('\u03C0')), C(1, 180))));
    case 'fact':
      return Gh(r);
    case 'ln': {
      if (s !== null && te(s) <= 0) throw new sn('undefined_value');
      if (s !== null && M(s, q)) return ze(Um);
      let i = s !== null ? E$(s) : eQ(r, t);
      if (i) return i;
      break;
    }
    default:
      if (s !== null && L(s) && d$[e]) return ze(qt(d$[e]));
  }
  return ze(Zr(Lf(be(e, Je($e(r))))));
}
function tQ(e) {
  let n = [],
    t = 1;
  for (let r of e)
    r.a.kind === 'root' ? (t *= r.a.prime) : n.push(r.e === 1 ? r.a.term : et(r.a.term, T(r.e)));
  return (t > 1 && n.unshift(be('sqrt', T(t))), n);
}
function kn(e) {
  let n = Xs(e).map(({ m: t, c: r }) => {
    let s = tQ(t);
    return s.length
      ? M(r, q)
        ? s.length === 1
          ? s[0]
          : { k: 'mul', c: s }
        : { k: 'mul', c: [T(r), ...s] }
      : T(r);
  });
  return n.length ? R(n.length === 1 ? n[0] : { k: 'add', c: n }) : T(0);
}
function Je(e) {
  let n = je(e.d);
  return n !== null ? kn(lt(e.n, A(q, n))) : R({ k: 'div', a: kn(e.n), b: kn(e.d) });
}
function qn(e, n, t = {}) {
  let r = Z(e, t),
    s = Z(n, t);
  if (!r.ok || !s.ok) return 'undecided';
  let i = Lu(vt(r.rf.n, s.rf.d), vt(s.rf.n, r.rf.d));
  return Ue(i) ? 'equal' : Wh(i) || rQ(i) ? 'undecided' : 'different';
}
function rQ(e) {
  for (let { m: n } of e.t.values())
    if (n.some((t) => t.a.kind === 'opaque' && t.a.constant && t.a.key !== '$\u03C0')) return !0;
  return !1;
}
function Ai(e, n, t = {}) {
  let r = {};
  for (let [s, i] of Object.entries(n)) r[s] = T(i);
  return _n(Ge(j(e, r), t));
}
var Dm = !1;
function Nf(e) {
  let n = Dm;
  Dm = !0;
  try {
    return e();
  } finally {
    Dm = n;
  }
}
var _$ = () => Dm,
  uy = (e) => (Dm ? e : (e * 180) / Math.PI);
function D(e, n) {
  switch (e.k) {
    case 'num':
      return en(e.v);
    case 'sym':
      return e.n in n ? n[e.n] : e.n === '\u03C0' ? Math.PI : NaN;
    case 'add':
      return e.c.reduce((t, r) => t + D(r, n), 0);
    case 'mul':
      return e.c.reduce((t, r) => t * D(r, n), 1);
    case 'div': {
      let t = D(e.b, n);
      return t === 0 ? NaN : D(e.a, n) / t;
    }
    case 'pow':
      return sQ(D(e.a, n), D(e.b, n));
    case 'binom': {
      let t = D(e.a, n),
        r = D(e.b, n);
      if (!Number.isInteger(t) || !Number.isInteger(r) || t < 0 || r < 0) return NaN;
      if (t > r) return 0;
      let s = Math.min(t, r - t),
        i = 1;
      for (let o = 1; o <= s; o++) i = (i * (r - s + o)) / o;
      return i;
    }
    case 'fn': {
      let t = D(e.a, n);
      switch (e.f) {
        case 'sqrt':
          return t < 0 ? NaN : Math.sqrt(t);
        case 'abs':
          return Math.abs(t);
        case 'fact': {
          if (!Number.isInteger(t) || t < 0 || t > 170) return NaN;
          let r = 1;
          for (let s = 2; s <= t; s++) r *= s;
          return r;
        }
        case 'deg':
          return (t * Math.PI) / 180;
        case 'ln':
          return t <= 0 ? NaN : Math.log(t);
        case 'log':
          return t <= 0 ? NaN : Math.log10(t);
        case 'exp':
          return Math.exp(t);
        case 'cos':
          return Math.cos(t);
        case 'sin':
          return Math.sin(t);
        case 'tan':
          return Math.tan(t);
        case 'arccos':
          return uy(Math.acos(t));
        case 'arcsin':
          return uy(Math.asin(t));
        case 'arctan':
          return uy(Math.atan(t));
        case 'arg':
          return NaN;
      }
    }
  }
}
function sQ(e, n) {
  if (e >= 0 || Number.isInteger(n)) return e ** n;
  let t = 1 / n;
  return Number.isInteger(Math.round(t)) &&
    Math.abs(t - Math.round(t)) < 1e-12 &&
    Math.round(t) % 2 !== 0
    ? -((-e) ** n)
    : NaN;
}
function Jh(e, n) {
  let t = new Map();
  for (let { m: p, c: g } of e.t.values()) {
    if (p.length > 1 || (p.length === 1 && p[0].a.symbol !== n)) return null;
    t.set(p.length ? p[0].e : 0, g);
  }
  if (!t.size) return null;
  let r = Math.max(...t.keys());
  if (r === 0) return [];
  let s = 1n,
    i = (p, g) => (g === 0n ? p : i(g, p % g));
  for (let p of t.values()) s = (s / i(s, p.d)) * p.d;
  let o = [];
  for (let p = 0; p <= r; p++) {
    let g = t.get(p);
    o.push(g ? (g.n * s) / g.d : 0n);
  }
  let a = [],
    l = 0;
  for (; o[l] === 0n; ) l++;
  if ((l > 0 && a.push(F), l === r)) return a;
  let u = o[l] < 0n ? -o[l] : o[l],
    c = o[r] < 0n ? -o[r] : o[r],
    f = h$(u),
    d = h$(c);
  if (!f || !d) return null;
  let m = new Set();
  for (let p of f)
    for (let g of d)
      for (let h of [1n, -1n]) {
        let b = C(h * p, g),
          v = bt(b);
        if (m.has(v)) continue;
        m.add(v);
        let k = F;
        for (let y = r; y >= 0; y--) k = re(N(k, b), C(o[y]));
        L(k) && a.push(b);
      }
  return a.sort(Re);
}
function h$(e) {
  if (e > BigInt(Hh)) return null;
  let n = Number(e),
    t = [];
  for (let r = 1; r * r <= n; r++)
    if (n % r === 0 && (t.push(BigInt(r)), r * r !== n && t.push(BigInt(n / r)), t.length > 4e3))
      return null;
  return t;
}
var In = {
    pos: { pos: !0, zero: !1, neg: !1 },
    neg: { pos: !1, zero: !1, neg: !0 },
    zero: { pos: !1, zero: !0, neg: !1 },
    nonzero: { pos: !0, zero: !1, neg: !0 },
    nonneg: { pos: !0, zero: !0, neg: !1 },
    nonpos: { pos: !1, zero: !0, neg: !0 },
    any: { pos: !0, zero: !0, neg: !0 },
  },
  py = (e, n) => ({ pos: e.pos && n.pos, zero: e.zero && n.zero, neg: e.neg && n.neg }),
  q$ = (e, n) => ({
    pos: (e.pos && n.pos) || (e.neg && n.neg),
    neg: (e.pos && n.neg) || (e.neg && n.pos),
    zero: e.zero || n.zero,
  }),
  iQ = (e, n) => (n % 2 === 0 ? { pos: e.pos || e.neg, zero: e.zero, neg: !1 } : e),
  oQ = (e) => ({ pos: e.neg, zero: e.zero, neg: e.pos }),
  aQ = {
    positive: In.pos,
    negative: In.neg,
    nonzero: In.nonzero,
    nonnegative: In.nonneg,
    zero: In.zero,
    natural: In.nonneg,
  };
function L$(e) {
  let n = ie(e);
  return n.ok && n.s.k === 'expr' ? n.s.e : null;
}
function ji(e = [], n = {}) {
  let t = { sign: new Map(), integer: new Set(), polys: [], sorts: n };
  for (let r of e) lQ(t, r);
  return t;
}
function lQ(e, n) {
  let t = n.of.length === 1 ? L$(n.of[0]) : null;
  if (!t) return;
  (n.kind === 'integer' || n.kind === 'natural') && t.k === 'sym' && e.integer.add(t.n);
  let r = aQ[n.kind];
  if (!r) return;
  if (t.k === 'sym') {
    e.sign.set(t.n, py(e.sign.get(t.n) ?? In.any, r));
    return;
  }
  let s = Z(t, { sorts: e.sorts });
  s.ok && je(s.rf.d) !== null && e.polys.push({ p: s.rf.n, s: r });
}
function uQ(e, n) {
  if (e.kind === 'sym') return n.sign.get(e.symbol) ?? In.any;
  if (e.kind === 'root') return In.pos;
  if (e.constant) {
    let r = e.value ?? NaN;
    return Number.isFinite(r) && Math.abs(r) > 1e-9 ? (r > 0 ? In.pos : In.neg) : In.any;
  }
  let t = e.term;
  return (t.k === 'fn' && t.f === 'exp') || (t.k === 'fn' && t.f === 'fact')
    ? In.pos
    : t.k === 'fn' && (t.f === 'sqrt' || t.f === 'abs')
      ? In.nonneg
      : In.any;
}
function cQ(e, n) {
  let t = Xs(e)[0],
    r = Xs(n)[0];
  if (!t || !r) return null;
  let s = A(t.c, r.c);
  return s && Zm(e, lt(n, s)) ? s : null;
}
function gy(e, n) {
  if (Ue(e)) return In.zero;
  let t = je(e);
  if (t !== null) return te(t) > 0 ? In.pos : In.neg;
  let r = In.any;
  if (an(e)) {
    let o = Dt(e);
    if (Number.isFinite(o) && Math.abs(o) > 1e-9) return o > 0 ? In.pos : In.neg;
  }
  for (let o of n.polys) {
    let a = cQ(e, o.p);
    a && (r = py(r, te(a) > 0 ? o.s : oQ(o.s)));
  }
  let s = Xs(e).map(({ m: o, c: a }) =>
      o.reduce((l, u) => q$(l, iQ(uQ(u.a, n), u.e)), te(a) > 0 ? In.pos : In.neg),
    ),
    i = In.any;
  return (
    s.length === 1
      ? (i = s[0])
      : s.every((o) => !o.neg)
        ? (i = { pos: s.some((o) => o.pos), zero: s.every((o) => o.zero), neg: !1 })
        : s.every((o) => !o.pos) &&
          (i = { neg: s.some((o) => o.neg), zero: s.every((o) => o.zero), pos: !1 }),
    py(r, i)
  );
}
function my(e, n) {
  let t = gy(e.d, n);
  return q$(gy(e.n, n), { ...t, zero: !1 });
}
var Xh = (e, n) => {
  if (!e.pos && !e.zero && !e.neg) return 'false';
  let t = (r) => e[r] && Object.keys(e).every((s) => s === r || !e[s]);
  switch (n) {
    case 'nonzero':
      return e.zero ? (t('zero') ? 'false' : 'unknown') : 'true';
    case 'positive':
      return !e.zero && !e.neg ? 'true' : e.pos ? 'unknown' : 'false';
    case 'negative':
      return !e.zero && !e.pos ? 'true' : e.neg ? 'unknown' : 'false';
    case 'nonnegative':
      return e.neg ? (!e.pos && !e.zero ? 'false' : 'unknown') : 'true';
    case 'zero':
      return t('zero') ? 'true' : e.zero ? 'unknown' : 'false';
    default:
      return 'unknown';
  }
};
function tr(e, n) {
  if (e.kind === 'real') return 'true';
  if (e.kind === 'defined_on') return 'unknown';
  let t = e.of.map(L$);
  if (t.some((o) => o === null)) return 'unknown';
  let r = t.map((o) => Z(o, { sorts: n.sorts }));
  if (r.some((o) => !o.ok)) return 'unknown';
  let s = r.map((o) => o.rf);
  if (e.kind === 'distinct') {
    let o = 'true';
    for (let a = 0; a < s.length; a++)
      for (let l = a + 1; l < s.length; l++) {
        if (T$(s[a], s[l])) return 'false';
        let u = Z(
          { k: 'add', c: [t[a], { k: 'mul', c: [{ k: 'num', v: C(-1) }, t[l]] }] },
          { sorts: n.sorts },
        );
        (u.ok ? Xh(my(u.rf, n), 'nonzero') : 'unknown') !== 'true' && (o = 'unknown');
      }
    return o;
  }
  let i = s[0];
  if (e.kind === 'integer' || e.kind === 'natural') {
    let o = je(i.d) !== null ? je(i.n) : null,
      a = t[0],
      l = o !== null ? B(A(o, je(i.d))) : a.k === 'sym' && n.integer.has(a.n) ? !0 : null;
    return l === null
      ? 'unknown'
      : l
        ? e.kind === 'integer'
          ? 'true'
          : Xh(my(i, n), 'nonnegative')
        : 'false';
  }
  return Xh(my(i, n), e.kind);
}
function Wr(e, n) {
  return { kind: e, of: [oe(n)] };
}
function N$(e, n) {
  return Xh(gy(e, n), 'nonzero');
}
var fQ = [
  [2, 1],
  [3, 1],
  [-1, 1],
  [1, 2],
  [-2, 1],
  [5, 3],
  [1, 1],
  [-3, 2],
  [4, 1],
  [-5, 1],
  [7, 2],
  [1, 3],
  [-2, 3],
  [6, 1],
  [-7, 1],
  [10, 1],
  [0, 1],
  [9, 4],
  [-1, 2],
  [11, 1],
].map(([e, n]) => C(e, n));
function dQ(e) {
  let n = 2166136261;
  for (let t = 0; t < e.length; t++) n = Math.imul(n ^ e.charCodeAt(t), 16777619) >>> 0;
  return n;
}
function mQ(e) {
  let n = e >>> 0;
  return () => {
    n = (n + 1831565813) >>> 0;
    let t = n;
    return (
      (t = Math.imul(t ^ (t >>> 15), t | 1)),
      (t ^= t + Math.imul(t ^ (t >>> 7), t | 61)),
      ((t ^ (t >>> 14)) >>> 0) / 4294967296
    );
  };
}
function pQ(e, n, t) {
  let r = t.sign.get(e);
  if (r) {
    let s = te(n);
    if ((s > 0 && !r.pos) || (s < 0 && !r.neg) || (s === 0 && !r.zero)) return !1;
  }
  return !(t.integer.has(e) && !B(n));
}
function gQ(e, n) {
  for (let t of n.polys) {
    let r;
    try {
      r = Ai(kn(t.p), e);
    } catch {
      return !1;
    }
    if (r === null) continue;
    let s = te(r);
    if ((s > 0 && !t.s.pos) || (s < 0 && !t.s.neg) || (s === 0 && !t.s.zero)) return !1;
  }
  return !0;
}
function Yh(e, n = ji(), t = '', r = 12) {
  let s = [...e].sort();
  if (!s.length) return [{}];
  let i = s.map((u) => fQ.filter((c) => pQ(u, c, n)));
  if (i.some((u) => !u.length)) return [];
  let o = [],
    a = new Set(),
    l = mQ(dQ(`${t}|${s.join(',')}`));
  for (let u = 0; o.length < r && u < r * 20; u++) {
    let c = {};
    s.forEach((d, m) => {
      let p = i[m];
      c[d] = u === 0 ? p[m % p.length] : p[Math.floor(l() * p.length)];
    });
    let f = s.map((d) => bt(c[d])).join(',');
    a.has(f) || !gQ(c, n) || (a.add(f), o.push(c));
  }
  return o;
}
function Ys(e, n) {
  let t = [];
  for (let { m: r, c: s } of e.t.values()) {
    if (r.length > 1 || (r.length === 1 && r[0].a.symbol !== n)) return null;
    let i = r.length ? r[0].e : 0;
    for (; t.length <= i; ) t.push(F);
    t[i] = s;
  }
  return t;
}
function hQ(e, n) {
  let t = e.length - 1,
    r = new Array(t).fill(F),
    s = F;
  for (let i = t; i >= 1; i--) ((s = re(N(s, n), e[i])), (r[i - 1] = s));
  return r;
}
function O$(e) {
  let n = [...e];
  for (; n.length > 1 && L(n[n.length - 1]); ) n.pop();
  return n;
}
function Bt(e, n, t = 0) {
  let r = Ys(e.n, n);
  if (!r) return vQ(e, n) ?? kQ(e, n, t) ?? xQ(e, n) ?? SQ(e, n, t);
  let s = O$(r);
  if (s.length === 1) return L(s[0]) ? null : { roots: [], complete: !0 };
  let i = Jh(e.n, n) ?? (s.length <= 3 ? [] : null);
  if (!i) return null;
  let o = i.map((u) => T(u));
  for (let u of i)
    for (let c = 0; c < 64 && s.length > 1; c++) {
      let f = F;
      for (let d = s.length - 1; d >= 0; d--) f = re(N(f, u), s[d]);
      if (!L(f)) break;
      s = O$(hQ(s, u));
    }
  let a = s.length <= 1;
  if ((s.length === 2 && (o.push(T(fe(A(s[0], s[1])))), (a = !0)), s.length === 3)) {
    let [u, c, f] = s,
      d = me(N(c, c), N(C(4), N(f, u)));
    if (((a = !0), te(d) >= 0))
      for (let m of te(d) === 0 ? [1] : [-1, 1]) {
        let p = he(T(fe(c)), I(T(m), be('sqrt', T(d))));
        o.push(ye(p, T(N(C(2), f))));
      }
  }
  if (s.length === 5 && L(s[1]) && L(s[3])) {
    let u = bQ(s[0], s[2], s[4]);
    if (u) {
      a = !0;
      for (let c of u) {
        if (te(c) < 0) continue;
        if (L(c)) {
          o.push(T(F));
          continue;
        }
        let f = Hs(c),
          d = f && jm(f) ? T(f.coef) : be('sqrt', T(c));
        o.push(I(T(C(-1)), d), d);
      }
    }
  }
  return {
    roots: o.filter((u) => {
      try {
        let c = Ge(j(kn(e.d), { [n]: u }));
        return !Nu(c);
      } catch (c) {
        if (c instanceof sn) return !1;
        throw c;
      }
    }),
    complete: a,
  };
}
function bQ(e, n, t) {
  let r = me(N(n, n), N(C(4), N(t, e)));
  if (te(r) < 0) return [];
  let s = Hs(r);
  if (s && jm(s)) {
    let a = [];
    for (let l of te(r) === 0 ? [1] : [-1, 1]) {
      let u = A(re(fe(n), N(C(l), s.coef)), N(C(2), t));
      u && !a.some((c) => M(c, u)) && a.push(u);
    }
    return a;
  }
  let i = A(fe(n), t),
    o = A(e, t);
  return i && o && te(i) < 0 && te(o) > 0 ? [] : null;
}
function vQ(e, n) {
  let t = [...e.n.t.values()];
  if (t.length !== 1) return null;
  let r = !1;
  for (let s of t[0].m)
    if (s.a.kind === 'sym' && s.a.symbol === n) r = !0;
    else {
      if (s.a.kind === 'opaque' && s.a.term.k === 'fn' && s.a.term.f === 'exp') continue;
      if (!s.a.constant) return null;
    }
  return Wm(e, n, r ? [T(F)] : []);
}
function kQ(e, n, t) {
  let r = [...e.n.t.values()];
  if (r.length !== 2) return null;
  let s = [];
  for (let c of r) {
    if (c.m.length !== 1 || c.m[0].e !== 1) return null;
    let f = c.m[0].a;
    if (f.kind !== 'opaque' || f.constant || f.term.k !== 'fn' || f.term.f !== 'ln') return null;
    s.push(f.term.a);
  }
  if (!L(re(r[0].c, r[1].c))) return null;
  let i;
  try {
    i = Ge(he(s[0], I(T(-1), s[1])));
  } catch (c) {
    if (c instanceof sn) return null;
    throw c;
  }
  let o = Bt(i, n, t + 1);
  if (!o) return null;
  let a = (c, f) => {
      let d = D(j(c, { [n]: f }), {});
      return Number.isFinite(d) && d > 1e-9;
    },
    l = o.roots.filter((c) => a(s[0], c) && a(s[1], c)),
    u = Wm(e, n, l);
  return u && { roots: u.roots, complete: o.complete };
}
function xQ(e, n) {
  let t = new Map();
  for (let { m: o, c: a } of e.n.t.values()) {
    let l = 0,
      u = [];
    for (let m of o)
      if (m.a.kind === 'sym' && m.a.symbol === n) l += m.e;
      else if (m.a.constant) u.push(m);
      else return null;
    let c = u.map((m) => (m.e === 1 ? m.a.key : `${m.a.key}^${m.e}`)).join('\xB7'),
      f = t.get(l) ?? { t: new Map() },
      d = f.t.get(c);
    (f.t.set(c, { m: u, c: d ? re(d.c, a) : a }),
      d && L(f.t.get(c).c) && f.t.delete(c),
      t.set(l, f));
  }
  let r = Math.max(0, ...[...t.entries()].filter(([, o]) => !Ue(o)).map(([o]) => o));
  if (r === 0) {
    let o = t.get(0);
    return !o || Ue(o) ? null : { roots: [], complete: !0 };
  }
  if (r !== 1) {
    let o = t.get(r),
      a = [];
    for (let c = 0; c <= r; c++) {
      let f = t.get(c);
      if (!f || Ue(f)) {
        a.push(F);
        continue;
      }
      let d = Tr(f, o),
        m = d ? je(d) : null;
      if (m === null) return r === 2 ? wQ(e, n, t) : null;
      a.push(m);
    }
    let l = { t: new Map() },
      u = Ge(rn(n)).n;
    return (
      a.forEach((c, f) => {
        L(c) || (l = Io(l, lt(Bm(u, f), c)));
      }),
      Bt({ n: l, d: e.d }, n)
    );
  }
  let s = t.get(1),
    i = t.get(0) ?? { t: new Map() };
  return Wm(e, n, yQ(s, i));
}
function yQ(e, n) {
  let t = Dt(e);
  if (!Number.isFinite(t) || Math.abs(t) < 1e-9) return null;
  let r = qt(q);
  return [Je($e(Hr({ n: Gm(n), d: r }, { n: e, d: r })))];
}
function Wm(e, n, t) {
  return t
    ? {
        roots: t.filter((s) => {
          try {
            return !Nu(Ge(j(kn(e.d), { [n]: s })));
          } catch (i) {
            if (i instanceof sn) return !1;
            throw i;
          }
        }),
        complete: !0,
      }
    : null;
}
function wQ(e, n, t) {
  let r = { t: new Map() },
    s = t.get(2),
    i = t.get(1) ?? r,
    o = t.get(0) ?? r,
    a = Dt(s);
  if (!Number.isFinite(a) || Math.abs(a) < 1e-9) return null;
  let l = Lu(vt(i, i), lt(vt(s, o), C(4))),
    u = lt(s, C(2)),
    c = kn(Gm(i));
  if (Ue(l)) return Wm(e, n, [ye(c, kn(u))]);
  let f = Dt(l);
  if (!Number.isFinite(f) || Math.abs(f) < 1e-9) return null;
  if (f < 0) return { roots: [], complete: !0 };
  let d = be('sqrt', kn(l));
  return Wm(
    e,
    n,
    [-1, 1].map((m) => ye(he(c, I(T(C(m)), d)), kn(u))),
  );
}
var K$ = '\xA7';
function Hm(e, n, t) {
  if (E(e) === n) return t;
  switch (e.k) {
    case 'add':
    case 'mul':
      return { k: e.k, c: e.c.map((r) => Hm(r, n, t)) };
    case 'div':
    case 'pow':
    case 'binom':
      return { k: e.k, a: Hm(e.a, n, t), b: Hm(e.b, n, t) };
    case 'fn':
      return { k: 'fn', f: e.f, a: Hm(e.a, n, t) };
    default:
      return e;
  }
}
function SQ(e, n, t) {
  if (t > 2) return null;
  let r = RQ(e, n, t);
  if (r) return r;
  let s = null;
  for (let { m } of e.n.t.values())
    for (let p of m)
      if (!p.a.constant) {
        if (p.a.kind !== 'opaque' || (s && s.key !== p.a.key)) return null;
        s = { key: p.a.key, term: p.a.term };
      }
  let i = s?.term;
  if (!i) return null;
  let o = i.k === 'fn' && (i.f === 'exp' || i.f === 'ln' || i.f === 'sqrt'),
    a = i.k === 'pow' ? TQ(i, n) : null;
  if (!o && !a) return null;
  let l;
  try {
    l = Ge(Hm(kn(e.n), s.key, rn(K$)));
  } catch (m) {
    if (m instanceof sn) return null;
    throw m;
  }
  let u = Bt({ n: l.n, d: qt(q) }, K$, t + 1);
  if (!u) return null;
  let c = [],
    f = u.complete;
  for (let m of u.roots) {
    let p = D(m, {});
    if (!Number.isFinite(p)) return null;
    let g, h;
    if (a) {
      let k = a.target(m, p);
      if (!k) continue;
      ((g = k), (h = a.arg));
    } else if (i.k === 'fn' && i.f === 'exp') {
      if (p <= 1e-12) continue;
      ((g = be('ln', m)), (h = i.a));
    } else if (i.k === 'fn' && i.f === 'ln') ((g = be('exp', m)), (h = i.a));
    else if (i.k === 'fn') {
      if (p < -1e-12) continue;
      ((g = I(m, m)), (h = i.a));
    } else return null;
    let b;
    try {
      b = Ge(he(h, I(T(-1), g)));
    } catch (k) {
      if (k instanceof sn) return null;
      throw k;
    }
    let v = Bt(b, n, t + 1);
    if (!v) return null;
    ((f &&= v.complete), c.push(...v.roots));
  }
  return {
    roots: c.filter((m) => {
      try {
        return !Nu(Ge(j(kn(e.d), { [n]: m })));
      } catch (p) {
        if (p instanceof sn) return !1;
        throw p;
      }
    }),
    complete: f,
  };
}
function TQ(e, n) {
  let t = (r) => {
    try {
      return [...Ge(r).n.t.values(), ...Ge(r).d.t.values()].some((s) =>
        s.m.some((i) => !i.a.constant),
      );
    } catch {
      return !0;
    }
  };
  if (!t(e.a) && t(e.b)) {
    let r = D(e.a, {});
    return !(r > 0) || Math.abs(r - 1) < 1e-12
      ? null
      : { arg: e.b, target: (s, i) => (i > 1e-12 ? ye(be('ln', s), be('ln', e.a)) : null) };
  }
  if (t(e.a) && !t(e.b)) {
    let r = Ge(e.b),
      s = r.n.t.size === 1 ? [...r.n.t.values()][0] : null,
      i = r.d.t.size === 1 ? [...r.d.t.values()][0] : null;
    if (!s || !i || s.m.length || i.m.length) return null;
    let o = A(s.c, i.c);
    if (o.n !== 1n || o.d < 2n || o.d > 12n) return null;
    let a = Number(o.d);
    return {
      arg: e.a,
      target: (l, u) => (a % 2 === 0 && u < -1e-12 ? null : { k: 'pow', a: l, b: T(a) }),
    };
  }
  return null;
}
function RQ(e, n, t) {
  let r = [...e.n.t.values()];
  if (r.length !== 2) return null;
  let s = [],
    i = [],
    o = !1;
  for (let [c, f] of r.entries()) {
    let d = c === 0 ? f.c : fe(f.c);
    i.push(te(d));
    let m = [be('ln', T(mn(d)))];
    for (let p of f.m)
      if (p.a.kind === 'root') m.push(I(T(C(p.e, 2)), be('ln', T(p.a.prime))));
      else if (p.a.kind === 'opaque' && p.a.term.k === 'fn' && p.a.term.f === 'exp')
        (p.a.constant || (o = !0), m.push(I(T(p.e), p.a.term.a)));
      else if (p.a.kind === 'opaque' && p.a.term.k === 'pow' && $Q(p.a.term.a))
        (p.a.constant || (o = !0), m.push(I(T(p.e), p.a.term.b, be('ln', p.a.term.a))));
      else return null;
    s.push(he(...m));
  }
  if (!o) return null;
  if (i[0] !== i[1]) return { roots: [], complete: !0 };
  let a;
  try {
    a = Ge(he(s[0], I(T(-1), s[1])));
  } catch (c) {
    if (c instanceof sn) return null;
    throw c;
  }
  let l = Bt(a, n, t + 1);
  return l
    ? {
        roots: l.roots.filter((c) => {
          try {
            return !Nu(Ge(j(kn(e.d), { [n]: c })));
          } catch (f) {
            if (f instanceof sn) return !1;
            throw f;
          }
        }),
        complete: l.complete,
      }
    : null;
}
function $Q(e) {
  try {
    let t = Ge(e);
    for (let r of [t.n, t.d])
      for (let { m: s } of r.t.values()) if (s.some((i) => !i.a.constant)) return !1;
  } catch {
    return !1;
  }
  let n = D(e, {});
  return Number.isFinite(n) && n > 1e-9;
}
var Q$ = new Set(['cos', 'sin', 'tan']),
  CQ = { t: new Map([['', { m: [], c: q }]]) },
  Of = rn('\u03C0'),
  P$ = '\xA7t',
  ei = '\xA7s',
  ni = '\xA7c';
function F$(e) {
  if (L(e)) return T(0);
  let n = e.n === 1n ? Of : I(T(C(e.n)), Of);
  return e.d === 1n ? n : ye(n, T(C(e.d)));
}
var tb = (e) => oe(R(F$(e)));
function ri(e, n = {}) {
  let t = Z(e, { sorts: n });
  if (!t.ok) return null;
  let r = je(t.rf.d);
  if (r === null || L(r)) return null;
  let s = [...t.rf.n.t.values()];
  if (!s.length) return F;
  if (s.length !== 1) return null;
  let i = s[0];
  return i.m.length !== 1 || i.m[0].a.key !== '$\u03C0' || i.m[0].e !== 1 ? null : A(i.c, r);
}
function V$(e, n) {
  let t = Z(e, { sorts: n });
  if (!t.ok) return null;
  let r = je(t.rf.d),
    s = je(t.rf.n);
  return r === null || s === null || L(r) ? null : A(s, r);
}
var ti = (e, n) => {
  let t = Z(e, { sorts: n });
  return t.ok && Ue(t.rf.n);
};
function eb(e, n, t = {}) {
  if (!$(e).has(n) || [...$(e)].some((o) => o !== n)) return null;
  let r = (o) => j(e, { [n]: T(o) }),
    s = V$(ve(r(1), r(0)), t),
    i = ri(r(0), t);
  return !s || !i || L(s) || !ti(ve(e, he(I(T(s), rn(n)), I(T(i), Of))), t) ? null : { a: s, b: i };
}
function Za(e, n, t = []) {
  switch (e.k) {
    case 'add':
    case 'mul':
      e.c.forEach((r) => Za(r, n, t));
      break;
    case 'div':
    case 'pow':
    case 'binom':
      (Za(e.a, n, t), Za(e.b, n, t));
      break;
    case 'fn':
      Q$.has(e.f) && $(e.a).has(n) ? t.push(e) : Za(e.a, n, t);
      break;
    default:
      break;
  }
  return t;
}
function ys(e, n, t) {
  if (E(e) === n) return t;
  switch (e.k) {
    case 'add':
    case 'mul':
      return { ...e, c: e.c.map((r) => ys(r, n, t)) };
    case 'div':
    case 'pow':
    case 'binom':
      return { ...e, a: ys(e.a, n, t), b: ys(e.b, n, t) };
    case 'fn':
      return { ...e, a: ys(e.a, n, t) };
    default:
      return e;
  }
}
function nb(e, n) {
  let t = A(e, n),
    r = t.n >= 0n ? t.n / t.d : -((-t.n + t.d - 1n) / t.d);
  return me(e, N(n, C(r)));
}
var rb = C(2);
function Kf(e) {
  let n = [];
  return (
    e.forEach((t) => {
      n.some((r) => M(r, t)) || n.push(t);
    }),
    n
  );
}
function D$(e, n, t = {}) {
  let r = D(n, {});
  if (!Number.isFinite(r)) return null;
  if (e !== 'tan') {
    if (Math.abs(r) > 1 + 1e-9) return [];
    if (Math.abs(r) > 1 - 1e-9 && !ti(ve(n, T(Math.sign(r))), t)) return null;
  }
  let s = [];
  for (let f = 0; f < 24; f++) {
    if (f % 2 !== 0 && f % 3 !== 0) continue;
    let d = C(f, 12),
      m = Math.cos(Math.PI * en(d));
    if (e === 'tan' && Math.abs(m) < 1e-12) continue;
    let p = e === 'cos' ? m : e === 'sin' ? Math.sin(Math.PI * en(d)) : Math.tan(Math.PI * en(d));
    if (!(Math.abs(p - r) > 1e-6))
      try {
        ti(ve(be(e, I(T(d), Of)), n), t) && s.push(d);
      } catch (g) {
        if (!(g instanceof sn)) throw g;
      }
  }
  if (s.length) return s;
  let i = EQ(n, t);
  if (!i) return null;
  let { g: o, w: a } = i;
  if (o !== e) {
    if (e === 'tan' || o === 'tan') return null;
    ((a = me(C(1, 2), a)), (o = e));
  }
  let l = e === 'cos' ? [a, fe(a)] : e === 'sin' ? [a, me(q, a)] : [a, re(a, q)],
    u = Kf(l.map((f) => nb(f, rb)));
  return u.every((f) => {
    let d = Math.PI * en(f),
      m = e === 'cos' ? Math.cos(d) : e === 'sin' ? Math.sin(d) : Math.tan(d);
    return Math.abs(m - r) < 1e-9;
  })
    ? u
    : null;
}
function EQ(e, n) {
  let t = R(e),
    r = 1;
  if (
    (t.k === 'mul' &&
      t.c.length === 2 &&
      t.c[0].k === 'num' &&
      M(mn(t.c[0].v), q) &&
      ((r = te(t.c[0].v)), (t = t.c[1])),
    t.k !== 'fn' || !Q$.has(t.f) || $(t.a).size)
  )
    return null;
  let s = ri(t.a, n);
  return s ? (r > 0 ? { g: t.f, w: s } : { g: t.f, w: t.f === 'cos' ? me(q, s) : fe(s) }) : null;
}
function B$(e, n, t) {
  let r = A(rb, mn(n));
  return e.map((s) => ({ base: A(me(s, t), n), step: r }));
}
function by(e, n, t, r = {}) {
  let s = ys(ys(e, E(n), rn(ei)), E(t), rn(ni));
  if ([...$(s)].some((l) => l !== ei && l !== ni)) return null;
  let i = j(s, { [ei]: T(1), [ni]: T(0) }),
    o = j(s, { [ei]: T(0), [ni]: T(1) }),
    a = he(I(i, rn(ei)), I(o, rn(ni)));
  return ti(ve(s, a), r) ? { A: i, B: o } : null;
}
function sb(e, n, t, r = {}) {
  let s = ve(e.l, e.r),
    i = $(s);
  if (!i.has(n) || [...i].some((l) => l !== n && !t.has(l))) return null;
  let o = Za(s, n);
  if (!o.length) return qQ(s, n, t, r);
  if ([...i].some((l) => t.has(l))) return null;
  let a = [...new Set(o.map(E))];
  if (a.length === 1) return MQ(s, o[0], n, r);
  if (a.length === 2) {
    let l = o.find((c) => E(c) === a[0]),
      u = o.find((c) => E(c) === a[1]);
    if (l.k !== 'fn' || u.k !== 'fn') return null;
    if (E(l.a) === E(u.a)) {
      let [c, f] = l.f === 'sin' && u.f === 'cos' ? [l, u] : [u, l];
      if (c.f !== 'sin' || f.f !== 'cos') return null;
      let d = by(s, c, f, r);
      if (!d) return null;
      let m = eb(c.a, n, r);
      if (!m) return null;
      let p = ti(d.A, r),
        g = ti(d.B, r);
      if (p && g) return null;
      let [h, b] = p ? ['cos', T(0)] : g ? ['sin', T(0)] : ['tan', I(T(-1), ye(d.B, d.A))],
        v = D$(h, b, r);
      return v ? B$(v, m.a, m.b) : null;
    }
    return _Q(s, l, u, n, r);
  }
  return null;
}
function MQ(e, n, t, r) {
  if (n.k !== 'fn') return null;
  let s = eb(n.a, t, r);
  if (!s) return null;
  let i = ys(e, E(n), rn(P$));
  if ($(i).has(t)) return null;
  let o = Z(i, { sorts: r });
  if (!o.ok || je(o.rf.d) === null) return null;
  let a = Bt({ n: o.rf.n, d: CQ }, P$);
  if (!a || !a.complete) return null;
  let l = [];
  for (let u of a.roots) {
    let c = D$(n.f, u, r);
    if (!c) return null;
    l.push(...B$(c, s.a, s.b));
  }
  return l;
}
function _Q(e, n, t, r, s) {
  if (n.k !== 'fn' || t.k !== 'fn') return null;
  let i = ys(ys(e, E(n), rn(ei)), E(t), rn(ni));
  if ([...$(i)].some((h) => h !== ei && h !== ni)) return null;
  let o = j(i, { [ei]: T(1), [ni]: T(0) }),
    a = j(i, { [ei]: T(0), [ni]: T(1) }),
    l = j(i, { [ei]: T(0), [ni]: T(0) });
  if (!ti(l, s) || !ti(he(o, a), s) || ti(o, s) || !ti(ve(i, I(o, ve(rn(ei), rn(ni)))), s))
    return null;
  let u = eb(n.a, r, s),
    c = eb(t.a, r, s);
  if (!u || !c) return null;
  let f = n.f,
    d = t.f;
  if (f !== d) {
    if (f === 'tan' || d === 'tan') return null;
    d === 'sin'
      ? ((c = { a: fe(c.a), b: me(C(1, 2), c.b) }), (d = 'cos'))
      : ((u = { a: fe(u.a), b: me(C(1, 2), u.b) }), (f = 'cos'));
  }
  let m = f === 'tan' ? q : rb,
    p = [{ a: me(u.a, c.a), b: me(u.b, c.b) }];
  (f === 'cos' && p.push({ a: re(u.a, c.a), b: re(u.b, c.b) }),
    f === 'sin' && p.push({ a: re(u.a, c.a), b: me(re(u.b, c.b), q) }));
  let g = [];
  for (let h of p) {
    if (L(h.a)) {
      if (L(nb(h.b, m))) return null;
      continue;
    }
    g.push({ base: A(fe(h.b), h.a), step: A(m, mn(h.a)) });
  }
  return g;
}
function qQ(e, n, t, r) {
  let s = [...$(e)].filter((d) => t.has(d)),
    i = { [n]: T(0) };
  s.forEach((d) => (i[d] = T(0)));
  let o = j(e, i),
    a = V$(ve(j(e, { ...i, [n]: T(1) }), o), r),
    l = ri(o, r);
  if (!a || !l || L(a)) return null;
  let u = [];
  for (let d of s) {
    let m = ri(ve(j(e, { ...i, [d]: T(1) }), o), r);
    if (!m) return null;
    u.push(m);
  }
  let c = he(I(T(a), rn(n)), ...s.map((d, m) => I(T(u[m]), rn(d), Of)), I(T(l), Of));
  if (!ti(ve(e, c), r)) return null;
  let f = F;
  for (let d of u) L(d) || (f = LQ(f, mn(A(d, a))));
  return [{ base: A(fe(l), a), step: f }];
}
function LQ(e, n) {
  if (L(e)) return n;
  if (L(n)) return e;
  let t = (r, s) => (s === 0n ? r : t(s, r % s));
  return C(t(e.n * n.d, n.n * e.d), e.d * n.d);
}
function I$(e, n, t, r = {}) {
  if (e.k === 'expr') return null;
  let s =
    e.k === 'set' ? (e.clauses.every((o) => o.length === 1) ? e.clauses.flat() : null) : on(e);
  if (!s) return null;
  let i = [];
  for (let o of s) {
    if (o.rel !== '=') return null;
    let a = sb(o, n, t, r);
    if (!a) return null;
    i.push(...a);
  }
  return i;
}
var NQ = 96;
function OQ(e, n) {
  let t = (s, i) => (i === 0n ? (s < 0n ? -s : s) : t(i, s % i));
  return C(((s, i) => (s / t(s, i)) * i)(e.n, n.n), t(e.d, n.d));
}
function A$(e, n) {
  let t = [],
    r = [];
  for (let i of e) {
    if (L(i.step)) {
      r.push(i.base);
      continue;
    }
    let o = A(n, i.step);
    if (!B(o) || o.n > BigInt(NQ)) return null;
    for (let a = 0n; a < o.n; a++) t.push(nb(re(i.base, N(i.step, C(a))), n));
  }
  let s = Kf(t);
  return { res: s, points: Kf(r).filter((i) => !(n && s.some((o) => M(o, nb(i, n))))) };
}
var hy = (e, n) => n.some((t) => (L(t.step) ? M(t.base, e) : B(A(me(e, t.base), t.step))));
function KQ(e, n) {
  let t = null;
  for (let u of [...e, ...n]) L(u.step) || (t = t ? OQ(t, u.step) : u.step);
  let r = A$(e, t),
    s = A$(n, t);
  if (!r || !s) return null;
  let i = (u, c) => {
      for (let f = 0; f < 6; f++) {
        let d = t ? re(u, N(t, C(f))) : u;
        if (!hy(d, c)) return d;
      }
      return null;
    },
    o = (u, c) => {
      for (let f of u.res) {
        if (hy(f, c) && t && c.every((m) => !L(m.step))) continue;
        let d = i(f, c);
        if (d) return d;
      }
      for (let f of u.points) if (!hy(f, c)) return f;
      return null;
    },
    a = o(r, n);
  if (a) return { kind: 'lost', at: a };
  let l = o(s, e);
  return l ? { kind: 'extra', at: l } : { kind: 'equal' };
}
function ib(e, n, t = {}) {
  if (!e) return null;
  let r = e.k === 'rel' ? on(e) : e.k === 'set' && e.clauses.length === 1 ? e.clauses[0] : null;
  if (!r) return null;
  let s = { lo: null, hi: null, loStrict: !1, hiStrict: !1 };
  for (let i of r) {
    let o = i.l.k === 'sym' && i.l.n === n,
      a = i.r.k === 'sym' && i.r.n === n;
    if (o === a || i.rel === '=') return null;
    let l = ri(o ? i.r : i.l, t);
    if (!l) return null;
    let u = o ? i.rel === '<' || i.rel === '\u2264' : i.rel === '>' || i.rel === '\u2265',
      c = i.rel === '<' || i.rel === '>';
    u ? ([s.hi, s.hiStrict] = [l, c]) : ([s.lo, s.loStrict] = [l, c]);
  }
  return s;
}
var Jm = (e, n) =>
  (n.lo === null || (n.loStrict ? Re(e, n.lo) > 0 : Re(e, n.lo) >= 0)) &&
  (n.hi === null || (n.hiStrict ? Re(e, n.hi) < 0 : Re(e, n.hi) <= 0));
function PQ(e, n) {
  if (n.lo === null || n.hi === null) return null;
  let t = [];
  for (let r of e) {
    if (L(r.step)) {
      Jm(r.base, n) && t.push(r.base);
      continue;
    }
    let s = A(me(n.lo, r.base), r.step),
      i = s.n >= 0n ? (s.n + s.d - 1n) / s.d : -(-s.n / s.d);
    for (let o = i; ; o++) {
      let a = re(r.base, N(r.step, C(o)));
      if (Re(a, n.hi) > 0) break;
      if ((Jm(a, n) && t.push(a), t.length > 200)) return null;
    }
  }
  return Kf(t).sort((r, s) => Re(r, s));
}
function z$(e, n) {
  if (L(n.step)) return M(e, n.base) ? 0n : null;
  let t = A(me(e, n.base), n.step);
  return B(t) ? t.n : null;
}
function U$(e, n, t, r, s, i = {}) {
  if (!(!!s && s.lo !== null && s.hi !== null)) {
    let a = I$(e, t, r, i),
      l = I$(n, t, r, i);
    if (!a || !l || s) return null;
    let u = KQ(a, l);
    return u ? (u.kind === 'equal' ? u : { kind: u.kind, at: u.at }) : null;
  }
  return IQ(e, n, t, r, s, i);
}
var j$ = (e) => `${E(e.l)}${e.rel}${E(e.r)}`;
function IQ(e, n, t, r, s, i) {
  if (e.k === 'expr' || n.k === 'expr') return null;
  let o = [];
  for (let m of [...on(e), ...on(n)]) {
    if ([...$(m.l), ...$(m.r)].some((b) => r.has(b)) && m.rel !== '=') return null;
    let g = sb({ rel: '=', l: m.l, r: m.r }, t, r, i);
    if (!g) return null;
    let h = PQ(g, s);
    if (!h) return null;
    o.push({ key: j$(m), zeros: h });
  }
  let a = Kf([
      ...o.flatMap((m) => m.zeros),
      ...(s.loStrict ? [] : [s.lo]),
      ...(s.hiStrict ? [] : [s.hi]),
    ]).sort((m, p) => Re(m, p)),
    l = Kf([s.lo, ...a, s.hi]).sort((m, p) => Re(m, p)),
    u = [...a];
  for (let m = 0; m + 1 < l.length; m++) u.push(A(re(l[m], l[m + 1]), rb));
  u.sort((m, p) => Re(m, p));
  let c = (m, p) => {
      let g = (v) => {
        let k = o.find((S) => S.key === j$(v));
        if (!k) return null;
        if (k.zeros.some((S) => M(S, p)))
          return v.rel === '=' || v.rel === '\u2264' || v.rel === '\u2265';
        if (v.rel === '=') return !1;
        let y = D(j(ve(v.l, v.r), { [t]: F$(p) }), {});
        return !Number.isFinite(y) || Math.abs(y) < 1e-9
          ? null
          : v.rel === '<' || v.rel === '\u2264'
            ? y < 0
            : y > 0;
      };
      if (m.k === 'rel') return g({ rel: m.rel, l: m.l, r: m.r });
      let h = m.k === 'or' ? m.items.map((v) => [v]) : m.k === 'set' ? m.clauses : [],
        b = !1;
      for (let v of h) {
        let k = !0;
        for (let y of v) {
          let S = g(y);
          if (S === !1) {
            k = !1;
            break;
          }
          S === null && (k = null);
        }
        if (k === !0) return !0;
        k === null && (b = !0);
      }
      return b ? null : !1;
    },
    f = null,
    d = e.k === 'rel' ? e.rel === '=' : e.k === 'or';
  for (let m of u) {
    if (!Jm(m, s)) continue;
    let p = c(e, m),
      g = c(n, m);
    if (p === null || g === null) return null;
    if (p && !g) return { kind: d ? 'lost' : 'counterexample', at: m };
    g && !p && (f ??= m);
  }
  return f ? { kind: 'extra', at: f } : { kind: 'equal' };
}
function G$(e, n) {
  return `${e} = ${tb(n)}`;
}
var Y$ = ['irreducible', 'scientific', 'primes', 'prime'],
  Ln = (e) => e.k === 'num',
  ub = (e) => Ln(e) && M(e.v, C(-1));
function ky(e) {
  if (e.k === 'fn' && (e.f === 'cos' || e.f === 'sin' || e.f === 'tan')) {
    let n = ri(e.a);
    return n ? { s: 1, f: e.f, u: n } : null;
  }
  if (e.k === 'mul' && e.c.length === 2 && ub(e.c[0])) {
    let n = ky(e.c[1]);
    return n ? { ...n, s: n.s === 1 ? -1 : 1 } : null;
  }
  return null;
}
var Xm = (e) => B(e),
  AQ = (e) => B(N(e, C(2))),
  jQ = (e) => te(e) >= 0 && Re(e, C(1, 2)) <= 0;
function QQ(e, n) {
  let t = re(e.u, n.u),
    r = me(e.u, n.u);
  if (e.f === n.f) return M(e.u, n.u) ? !1 : Xm(t) || Xm(r);
  if (e.f === 'tan' || n.f === 'tan') return !1;
  let s = C(1, 2);
  return Xm(me(t, s)) || Xm(me(r, s)) || Xm(re(r, s));
}
function Z$(e) {
  return Ln(e) ? e.v : e.k === 'div' && Ln(e.a) && Ln(e.b) ? A(e.a.v, e.b.v) : null;
}
function FQ(e) {
  let n = e;
  if (
    (e.k === 'mul' && e.c.length === 2 && Ln(e.c[0]) && (n = e.c[1]),
    n.k !== 'fn' || n.f !== 'sqrt' || !Ln(n.a) || !B(n.a.v))
  )
    return null;
  let t = n.a.v.n;
  if (t < 4n) return null;
  let r = _f(t);
  return r && r.square > 1n ? t : null;
}
function VQ(e) {
  let n = e;
  if (e.k === 'mul' && e.c.length === 2 && Ln(e.c[0])) {
    if (!B(e.c[0].v)) return !1;
    n = e.c[1];
  }
  if (n.k !== 'fn' || n.f !== 'sqrt' || !Ln(n.a) || !B(n.a.v)) return !1;
  let t = _f(n.a.v.n);
  return !!t && t.square === 1n;
}
function yy(e, n, t) {
  let r = ky(e);
  if (r) {
    let i = ky(n);
    return i
      ? QQ(r, i)
        ? 'trig'
        : null
      : !t || AQ(r.u)
        ? null
        : jQ(r.u)
          ? r.s === -1
            ? 'trigValue'
            : null
          : 'circle';
  }
  let s = Z$(e);
  return s && te(s) > 0 && n.k === 'fn' && n.f === 'sqrt' && Z$(n.a)
    ? 'rootWrite'
    : FQ(e) && VQ(n)
      ? 'rootSimplify'
      : null;
}
function Nt(e) {
  if (Ln(e) && B(e.v)) return e.v.n;
  if (e.k === 'mul' && e.c.length === 2 && ub(e.c[0])) {
    let n = Nt(e.c[1]);
    return n === null ? null : -n;
  }
  return null;
}
var eC = (e, n) => {
  let t = e < 0n ? -e : e,
    r = n < 0n ? -n : n;
  for (; r; ) [t, r] = [r, t % r];
  return t;
};
function jf(e) {
  if (e < 2n || e > 1000000000000n) return !1;
  if (e < 4n) return !0;
  if (e % 2n === 0n) return !1;
  for (let n = 3n; n * n <= e; n += 2n) if (e % n === 0n) return !1;
  return !0;
}
function ws(e) {
  let n = e.k === 'mul' ? e.c : [e],
    t = [];
  for (let r of n)
    if (Ln(r) && B(r.v) && r.v.n > 0n) t.push({ b: r.v.n, e: 1 });
    else if (
      r.k === 'pow' &&
      Ln(r.a) &&
      B(r.a.v) &&
      r.a.v.n > 0n &&
      Ln(r.b) &&
      B(r.b.v) &&
      r.b.v.n >= 1n &&
      r.b.v.n <= 64n
    )
      t.push({ b: r.a.v.n, e: Number(r.b.v.n) });
    else return null;
  return t;
}
var Pf = (e) => `${e.b}^${e.e}`;
function Af(e, n) {
  if (e.length !== n.length) return !1;
  let t = [...e].sort(),
    r = [...n].sort();
  return t.every((s, i) => s === r[i]);
}
function np(e) {
  let n = e,
    t = q;
  if (
    (e.k === 'mul' && e.c.length === 2 && ub(e.c[0]) && ((n = e.c[1]), (t = C(-1))),
    n.k !== 'mul' || n.c.length !== 2)
  )
    return null;
  let [r, s] = n.c,
    i = (o, a) => {
      if (!Ln(o) || a.k !== 'pow' || !Ln(a.a) || !M(a.a.v, C(10))) return null;
      let l = Nt(a.b);
      return l === null ? null : { m: N(t, o.v), n: l };
    };
  return i(r, s) ?? i(s, r);
}
function Ku(e, n) {
  switch (n) {
    case 'irreducible': {
      if (Nt(e) !== null) return !0;
      let t = e;
      if ((e.k === 'mul' && e.c.length === 2 && ub(e.c[0]) && (t = e.c[1]), t.k !== 'div'))
        return !1;
      let r = Nt(t.a),
        s = Nt(t.b);
      return r !== null && s !== null && s > 1n && eC(r, s) === 1n;
    }
    case 'scientific': {
      let t = np(e);
      if (!t) return !1;
      let r = te(t.m) < 0 ? fe(t.m) : t.m;
      return Re(r, q) >= 0 && Re(r, C(10)) < 0;
    }
    case 'primes': {
      let t = ws(e);
      return !t || !t.length
        ? !1
        : new Set(t.map((s) => s.b)).size === t.length && t.every((s) => jf(s.b));
    }
    case 'prime': {
      let t = Nt(e);
      return t !== null && jf(t);
    }
  }
}
function xy(e) {
  let n = ws(e);
  return n ? n.reduce((t, r) => t * r.b ** BigInt(r.e), 1n) : null;
}
function cb(e) {
  if (e.k !== 'div' || (Nt(e.a) !== null && Nt(e.b) !== null)) return null;
  let n = xy(e.a),
    t = xy(e.b);
  return n === null || t === null || t === 0n ? null : { p: n, q: t };
}
function nC(e) {
  if (Ku(e, 'irreducible')) return !0;
  let n = cb(e);
  return !!n && n.q > 1n && eC(n.p, n.q) === 1n;
}
function tC(e, n) {
  return e.k !== 'div' ? !1 : Nt(e.a) === n.p && Nt(e.b) === n.q;
}
function H$(e) {
  let n = ws(e);
  return !n || !n.length || !n.every((t) => jf(t.b)) ? null : xy(e);
}
function wy(e, n) {
  if (e.k !== 'div' || n.k !== 'div') return !1;
  let t = Nt(e.a),
    r = Nt(e.b),
    s = H$(n.a),
    i = H$(n.b);
  if (
    t === null ||
    r === null ||
    s === null ||
    i === null ||
    t !== s ||
    r !== i ||
    r <= 1n ||
    t < 1n
  )
    return !1;
  let o = (u) => new Set((ws(u) ?? []).map((c) => c.b)),
    a = o(n.a);
  if ([...o(n.b)].some((u) => a.has(u))) return !1;
  let l = (u, c) => Xe(u) === Xe(c);
  return !l(e.a, n.a) || !l(e.b, n.b);
}
function rC(e) {
  for (let n of e) {
    if (/[<>≤≥]/.test(n)) continue;
    let t = n.split('=').map(Qf);
    if (!(t.length < 2 || t.some((r) => !r))) {
      for (let r = 0; r + 1 < t.length; r++) if (wy(t[r], t[r + 1])) return !0;
    }
  }
  return !1;
}
function sC(e) {
  if (e.form !== 'irreducible' || e.rels.length !== 1 || (e.at && Object.keys(e.at).length))
    return !1;
  let n = Qf(e.rels[0]);
  return !!n && cb(n) !== null;
}
function iC(e, n, t) {
  if (t === 'primes') {
    let r = ws(e),
      s = ws(n);
    return !!r && !!s && Af(r.map(Pf), s.map(Pf));
  }
  if (t === 'scientific') {
    let r = np(e),
      s = np(n);
    return !!r && !!s && M(r.m, s.m) && r.n === s.n;
  }
  return Xe(e) === Xe(n);
}
function tp(e) {
  let n = (a) => {
      let l = ws(a);
      return !l || l.length < 2 || l.some((u) => u.e !== 1) ? null : l.map((u) => u.b);
    },
    t = n(e);
  if (t) return { factors: t, r: 0n };
  if (e.k !== 'add' || e.c.length !== 2) return null;
  let [r, s] = e.c,
    i = n(r),
    o = Nt(s);
  return !i || o === null || o < 0n ? null : { factors: i, r: o };
}
function DQ(e, n) {
  let t = Nt(e);
  if (t === null || t < 1n || n.k !== 'add') return !1;
  let r = tp(n);
  return !!r && r.r > 0n && r.factors.some((s) => s >= 2n && r.r < s);
}
function Xe(e) {
  switch (e.k) {
    case 'num':
      return bt(e.v);
    case 'sym':
      return e.n;
    case 'pow':
      return `pow(${Xe(e.a)},${Xe(e.b)})`;
    case 'mul':
    case 'add':
      return `${e.k}(${e.c.map(Xe).join(',')})`;
    case 'div':
    case 'binom':
      return `${e.k}(${Xe(e.a)},${Xe(e.b)})`;
    case 'fn':
      return `${e.f}(${Xe(e.a)})`;
    default:
      return JSON.stringify(e);
  }
}
function vy(e) {
  if (e.k === 'pow') {
    let n = Nt(e.b);
    return n === null ? null : { base: Xe(e.a), e: C(n) };
  }
  return Ln(e) || e.k === 'sym' ? { base: Xe(e), e: q } : null;
}
function ob(e) {
  let n = ws(e);
  return n ? n.flatMap((t) => (t.b === 1n ? [] : Array(t.e).fill(t.b.toString()))) : null;
}
function W$(e, n) {
  let t = [...e];
  for (let r of n) {
    let s = t.indexOf(r);
    if (s < 0) return null;
    t.splice(s, 1);
  }
  return t;
}
function BQ(e, n) {
  if (e.k !== 'div') return !1;
  let t = ws(e.a),
    r = ws(e.b),
    s = ob(e.a),
    i = ob(e.b);
  if (!t || !r || !s || !i || new Set([...s, ...i]).size < 2) return !1;
  let o = ob(n.k === 'div' ? n.a : n),
    a = n.k === 'div' ? ob(n.b) : [];
  if (!o || !a) return !1;
  let l = W$(s, o),
    u = W$(i, a);
  return !l || !u || !l.length || !Af(l, u) ? !1 : l.length >= 2 || t.length >= 3 || r.length >= 3;
}
function rp(e, n) {
  if (BQ(e, n)) return 'cancel';
  if (DQ(e, n)) return 'euclid';
  let t = ws(e),
    r = ws(n);
  if (t && r) {
    if (r.length === t.length + 1) {
      let o = t.map(Pf),
        a = r.map(Pf);
      for (let l = 0; l < t.length; l++) {
        let u = t[l];
        if (u.e !== 1 || u.b < 4n) continue;
        let c = o.filter((f, d) => d !== l);
        for (let f = 0; f < r.length; f++)
          for (let d = f + 1; d < r.length; d++) {
            let m = r[f],
              p = r[d];
            if (
              !(m.e !== 1 || p.e !== 1 || m.b < 2n || p.b < 2n || m.b * p.b !== u.b) &&
              Af(
                c,
                a.filter((g, h) => h !== f && h !== d),
              )
            )
              return 'decompose';
          }
      }
    }
    if (r.length < t.length) {
      let o = new Set([...t, ...r].map((u) => u.b)),
        a = 0;
      if (
        [...o].every((u) => {
          let c = t.filter((m) => m.b === u),
            f = r.filter((m) => m.b === u);
          if (Af(c.map(Pf), f.map(Pf))) return !0;
          let d = c.reduce((m, p) => m + p.e, 0);
          return c.length >= 2 && f.length === 1 && f[0].e === d ? (a++, !0) : !1;
        }) &&
        a > 0
      )
        return 'powerGroup';
    }
  }
  if (e.k === 'mul' && e.c.length >= 3 && n.k === 'mul' && n.c.length === e.c.length - 1) {
    let o = n.c.map(Xe);
    for (let a = 0; a < e.c.length; a++)
      for (let l = a + 1; l < e.c.length; l++) {
        let u = vy(e.c[a]),
          c = vy(e.c[l]);
        if (!u || !c || u.base !== c.base || (e.c[a].k !== 'pow' && e.c[l].k !== 'pow')) continue;
        let f = e.c.filter((p, g) => g !== a && g !== l).map(Xe),
          d = re(u.e, c.e),
          m = n.c.findIndex((p) => {
            let g = vy(p);
            return !!g && p.k === 'pow' && g.base === u.base && M(g.e, d);
          });
        if (
          !(m < 0) &&
          Af(
            f,
            o.filter((p, g) => g !== m),
          )
        )
          return 'powerMerge';
      }
  }
  if (Ln(e) && !B(e.v) && n.k === 'div') {
    let o = Nt(n.a),
      a = Nt(n.b);
    if (o !== null && a !== null && a >= 10n && /^10*$/.test(a.toString())) return 'decimalFrac';
  }
  let s = np(n);
  if (s && (Ln(e) || Nt(e) !== null)) return 'sciWrite';
  let i = np(e);
  return i && s && i.n !== s.n ? 'sciWrite' : null;
}
function Rr(e) {
  if (Ln(e)) return e.v;
  if (e.k === 'div') {
    let n = Rr(e.a),
      t = Rr(e.b);
    return n && t && !L(t) ? A(n, t) : null;
  }
  if (e.k === 'mul') {
    let n = q;
    for (let t of e.c) {
      let r = Rr(t);
      if (!r) return null;
      n = N(n, r);
    }
    return n;
  }
  return null;
}
function lb(e) {
  if (e.k === 'fn' && (e.f === 'ln' || e.f === 'log')) return { f: e.f, c: q, arg: e.a };
  if (e.k === 'div') {
    let n = lb(e.a),
      t = Rr(e.b),
      r = n && t && !L(t) ? A(n.c, t) : null;
    return n && r ? { f: n.f, c: r, arg: n.arg } : null;
  }
  if (e.k === 'mul') {
    let n = q,
      t = null;
    for (let r of e.c) {
      let s = Rr(r);
      if (s) {
        n = N(n, s);
        continue;
      }
      let i = lb(r);
      if (!i || t) return null;
      t = i;
    }
    return t ? { f: t.f, c: N(n, t.c), arg: t.arg } : null;
  }
  return null;
}
function Ha(e) {
  return e.k === 'sym' ? e.n === 'e' : e.k === 'fn' && e.f === 'exp' && Ln(e.a) && M(e.a.v, q);
}
function zQ(e) {
  return Ln(e) && M(e.v, q)
    ? F
    : Ln(e) && M(e.v, C(10))
      ? q
      : e.k === 'pow' && Ln(e.a) && M(e.a.v, C(10))
        ? Rr(e.b)
        : null;
}
var UQ = (e, n) => (e === 'ln' ? oC(n) : zQ(n));
function oC(e) {
  return Ln(e) && M(e.v, q)
    ? F
    : Ha(e)
      ? q
      : e.k === 'fn' && e.f === 'exp'
        ? Rr(e.a)
        : e.k === 'pow' && Ha(e.a)
          ? Rr(e.b)
          : e.k === 'fn' && e.f === 'sqrt' && Ha(e.a)
            ? C(1, 2)
            : null;
}
function Ym(e, n) {
  if (Xe(e) === Xe(n)) return null;
  if (e.k === 'fn' && n.k === 'fn' && e.f === n.f) return Ym(e.a, n.a) ?? [e, n];
  if ((e.k === 'pow' || e.k === 'div') && n.k === e.k) {
    let t = n;
    return Xe(e.a) === Xe(t.a) ? Ym(e.b, t.b) : Xe(e.b) === Xe(t.b) ? Ym(e.a, t.a) : [e, n];
  }
  if ((e.k === 'mul' || e.k === 'add') && n.k === e.k && e.c.length === n.c.length) {
    let t = e.c.flatMap((r, s) => (Xe(r) === Xe(n.c[s]) ? [] : [s]));
    if (t.length === 1) return Ym(e.c[t[0]], n.c[t[0]]);
  }
  return [e, n];
}
function GQ(e, n) {
  if (!Ln(e) || te(e.v) <= 0 || n.k !== 'pow' || !Ln(n.a) || !B(n.a.v) || n.a.v.n < 2n) return !1;
  let t = Rr(n.b);
  if (!t || !B(t) || t.n === 0n || t.n === 1n || t.n > 64n || t.n < -64n) return !1;
  let r = at(n.a.v, Number(t.n));
  return !!r && M(r, e.v);
}
function ZQ(e, n) {
  let t = Ym(e, n);
  if (!t) return null;
  let [r, s] = t;
  if (GQ(r, s)) return 'lnWrite';
  if (r.k === 'fn' && r.f === 'sqrt' && Ha(r.a)) {
    let i = oC(s);
    if (
      (i && M(i, C(1, 2)) && s.k !== 'fn') ||
      (i && M(i, C(1, 2)) && s.k === 'fn' && s.f === 'exp')
    )
      return 'lnWrite';
  }
  return rp(r, s) === 'decompose' ? 'decompose' : null;
}
function J$(e, n) {
  let t = e.arg,
    r = null;
  return (
    (t.k === 'pow' && Xe(t.a) === Xe(n.arg)) ||
    (e.f === 'ln' && t.k === 'pow' && Ha(t.a) && Ha(n.arg))
      ? (r = Rr(t.b))
      : e.f === 'ln' && t.k === 'fn' && t.f === 'exp' && Ha(n.arg) && !Ha(t) && (r = Rr(t.a)),
    !!r && M(N(e.c, r), n.c)
  );
}
function HQ(e, n) {
  if (e.f !== n.f) return null;
  if (M(e.c, n.c)) return ZQ(e.arg, n.arg);
  if (J$(e, n) || J$(n, e)) return 'lnPower';
  let t = C(1, 2),
    r = (i, o) =>
      i.arg.k === 'fn' && i.arg.f === 'sqrt' && Xe(i.arg.a) === Xe(o.arg) && M(N(i.c, t), o.c);
  if (r(e, n) || r(n, e)) return 'lnRoot';
  let s = (i, o) => {
    if (i.arg.k !== 'div') return !1;
    let a = Rr(i.arg.a);
    return !!a && M(a, q) && Xe(i.arg.b) === Xe(o.arg) && M(fe(i.c), o.c);
  };
  return s(e, n) || s(n, e) ? 'lnInverse' : null;
}
function ab(e) {
  return e.k === 'mul' ? e.c.flatMap(ab) : [Xe(e)];
}
function X$(e, n, t) {
  if (n.f !== e.f || t.f !== e.f) return null;
  if (
    e.arg.k === 'mul' &&
    M(n.c, e.c) &&
    M(t.c, e.c) &&
    Af(ab(e.arg), [...ab(n.arg), ...ab(t.arg)])
  )
    return 'lnProduct';
  if (e.arg.k === 'div') {
    let r = Xe(e.arg.a),
      s = Xe(e.arg.b);
    for (let [i, o] of [
      [n, t],
      [t, n],
    ])
      if (M(i.c, e.c) && M(o.c, fe(e.c)) && Xe(i.arg) === r && Xe(o.arg) === s) return 'lnQuotient';
  }
  return null;
}
function aC(e) {
  if (e.k === 'add') {
    let n = F;
    for (let t of e.c) {
      let r = aC(t);
      if (!r) return null;
      n = re(n, r);
    }
    return n;
  }
  return Rr(e);
}
function Sy(e, n) {
  let t = e.k === 'add' ? e.c : [e],
    r = n.k === 'add' ? [...n.c] : [n],
    s = [];
  for (let a of t) {
    let l = r.findIndex((u) => Xe(u) === Xe(a));
    l >= 0 ? r.splice(l, 1) : s.push(a);
  }
  if (!s.length || !r.length) return null;
  let i = s.map(lb),
    o = r.map(lb);
  if (s.length === 1 && r.length === 1) {
    let a = i[0],
      l = o[0];
    return a && l
      ? HQ(a, l)
      : ((c, f) => {
            if (!c) return !1;
            let d = UQ(c.f, c.arg),
              m = aC(f);
            return !!d && !!m && M(N(c.c, d), m);
          })(a ?? null, r[0])
        ? 'lnValue'
        : null;
  }
  return s.length === 1 && r.length === 2 && i[0] && o[0] && o[1]
    ? X$(i[0], o[0], o[1])
    : s.length === 2 && r.length === 1 && o[0] && i[0] && i[1]
      ? X$(o[0], i[0], i[1])
      : null;
}
function Ou(e) {
  switch (e.k) {
    case 'fn':
      return e.f === 'ln' || e.f === 'log' || Ou(e.a);
    case 'add':
    case 'mul':
      return e.c.some(Ou);
    case 'div':
    case 'pow':
    case 'binom':
      return Ou(e.a) || Ou(e.b);
    default:
      return !1;
  }
}
function WQ(e) {
  if (e < 4n) return !1;
  for (let n = 2n; 2n ** n <= e; n++) {
    let t = 1n,
      r = e;
    for (; t < r; ) {
      let s = (t + r + 1n) / 2n;
      s ** n <= e ? (t = s) : (r = s - 1n);
    }
    if (t ** n === e) return !0;
  }
  return !1;
}
function If(e) {
  switch (e.k) {
    case 'fn':
      if (e.f === 'ln' || e.f === 'log') {
        let n = e.a;
        return !Ln(n) || !B(n.v) || n.v.n < 2n || (e.f === 'log' && n.v.n === 10n) ? !0 : WQ(n.v.n);
      }
      return If(e.a);
    case 'add':
    case 'mul':
      return e.c.some(If);
    case 'div':
    case 'pow':
    case 'binom':
      return If(e.a) || If(e.b);
    default:
      return !1;
  }
}
var lC = /(^|[^A-Za-zÀ-ÿ])e(?![A-Za-zÀ-ÿ^])/;
function uC(e) {
  for (let n of e) {
    if (/[<>≤≥]/.test(n)) continue;
    let t = n.split('=').map(Qf);
    if (!(t.length < 2 || t.some((r) => !r))) {
      for (let r = 0; r + 1 < t.length; r++) if (Sy(t[r], t[r + 1])) return !0;
    }
  }
  return !1;
}
function Qf(e) {
  let n = ie(e.trim());
  return n.ok && n.s.k === 'expr' ? n.s.e : null;
}
function ep(e) {
  switch (e.k) {
    case 'fn':
      return e.f === 'cos' || e.f === 'sin' || e.f === 'tan' || ep(e.a);
    case 'add':
    case 'mul':
      return e.c.some(ep);
    case 'div':
    case 'pow':
    case 'binom':
      return ep(e.a) || ep(e.b);
    default:
      return !1;
  }
}
function cC(e) {
  for (let n of e) {
    if (/[<>≤≥]/.test(n)) continue;
    let t = n.split('=').map(Qf);
    if (!(t.length < 2 || t.some((r) => !r))) {
      for (let r = 0; r + 1 < t.length; r++) if (yy(t[r], t[r + 1], !ep(t[r + 1]))) return !0;
    }
  }
  return !1;
}
function fC(e) {
  for (let n of e) {
    if (/[<>≤≥]/.test(n)) continue;
    let t = n.split('=').map(Qf);
    if (!(t.length < 2 || t.some((r) => !r)))
      for (let r = 0; r + 1 < t.length; r++) {
        let s = rp(t[r], t[r + 1]);
        if (s && s !== 'euclid') return !0;
      }
  }
  return !1;
}
function dC(e) {
  for (let n of e) {
    if (/[<>≤≥]/.test(n)) continue;
    let t = n.split('=').map(Qf);
    if (!(t.length < 2 || t.some((r) => !r))) {
      for (let r = 0; r + 1 < t.length; r++) if (rp(t[r], t[r + 1]) === 'euclid') return !0;
    }
  }
  return !1;
}
var JQ = /÷\s*0(?![,\d])/;
function mC(e) {
  return e.some((n) => JQ.test(n));
}
var XQ = 1,
  YQ = ['real', 'integer', 'natural', 'rational', 'complex', 'vector', 'matrix', 'bool'],
  fb = x.enum(YQ),
  gC = ['real', 'integer', 'natural', 'rational'],
  Pu = x.string().trim().min(1).max(400),
  eF = [
    'real',
    'integer',
    'natural',
    'nonzero',
    'positive',
    'negative',
    'nonnegative',
    'zero',
    'distinct',
    'defined_on',
  ],
  nF = x.enum(eF),
  tF = x
    .object({
      lo: x.string().regex(zh).nullable(),
      hi: x.string().regex(zh).nullable(),
      loOpen: x.boolean(),
      hiOpen: x.boolean(),
    })
    .strict()
    .superRefine((e, n) => {
      if (
        (e.lo === null &&
          !e.loOpen &&
          n.addIssue({ code: 'custom', path: ['loOpen'], message: 'borne infinie ferm\xE9e' }),
        e.hi === null &&
          !e.hiOpen &&
          n.addIssue({ code: 'custom', path: ['hiOpen'], message: 'borne infinie ferm\xE9e' }),
        e.lo !== null && e.hi !== null)
      ) {
        let t = Re(sy(e.lo), sy(e.hi));
        (t > 0 || (t === 0 && (e.loOpen || e.hiOpen))) &&
          n.addIssue({ code: 'custom', path: ['hi'], message: 'intervalle vide' });
      }
    }),
  Iu = x
    .object({ kind: nF, of: x.array(Pu).min(1).max(8), domain: tF.optional() })
    .strict()
    .superRefine((e, n) => {
      ((e.kind === 'distinct' ? e.of.length < 2 : e.of.length !== 1) &&
        n.addIssue({
          code: 'custom',
          path: ['of'],
          message: e.kind === 'distinct' ? 'au moins deux termes' : 'un seul terme',
        }),
        (e.kind === 'defined_on') != (e.domain !== void 0) &&
          n.addIssue({
            code: 'custom',
            path: ['domain'],
            message: 'domaine requis pour defined_on, interdit sinon',
          }));
    });
var rF = [
  'factor',
  'expand',
  'simplify',
  'solve',
  'isolate_variable',
  'compute',
  'compare',
  'prove',
  'differentiate',
  'integrate',
  'find_antiderivative',
  'find_limit',
  'model',
  'verify_program',
];
var sF = /^[a-z][a-z0-9-]{1,39}\.[a-z][a-z0-9_]{1,39}$/,
  Ty = x.union([x.enum(rF), x.string().regex(sF)]),
  hC = x
    .object({ kind: Ty, target: Pu.optional() })
    .strict()
    .superRefine((e, n) => {
      e.kind === 'isolate_variable' &&
        e.target === void 0 &&
        n.addIssue({ code: 'custom', path: ['target'], message: 'variable \xE0 isoler requise' });
    });
var iF = ['valid', 'invalid', 'conditional', 'unknown', 'unsupported'],
  oF = x.enum(iF),
  aF = ['identity', 'equivalent', 'implies', 'deduction', 'evaluation', 'approximation', 'none'],
  bC = x.enum(aF),
  lF = ['exact', 'rule', 'sampled', 'none'],
  uF = x.enum(lF),
  vC = /^[a-z][a-z0-9_]{0,39}(\.[a-z][a-z0-9_]{0,39}){1,3}$/,
  kC = /^[a-z][a-z0-9_]{0,39}(\.[a-z][a-z0-9_]{0,39}){1,3}@[1-9]\d{0,2}$/,
  cF = /^[a-z][a-z0-9-]{1,39}@[1-9]\d{0,2}$/,
  xC = x
    .object({
      code: x.string().regex(/^[a-z][a-z0-9_]{0,63}$/),
      params: x
        .record(x.string().regex(/^[a-z][a-zA-Z0-9_]{0,31}$/), x.string().max(400))
        .optional(),
    })
    .strict(),
  fF = x
    .object({
      from: Pu,
      to: Pu,
      relation: bC,
      ruleId: x.string().regex(kC).optional(),
      explanation: xC.optional(),
    })
    .strict(),
  dF = x.lazy(() => x.object({ when: x.array(Iu).min(1).max(8), check: yC }).strict()),
  yC = x.lazy(() =>
    x
      .object({
        status: oF,
        relation: bC,
        proof: uF,
        ruleId: x.string().regex(kC).optional(),
        explanation: xC.optional(),
        conditions: x.array(Iu).max(16).optional(),
        branches: x.array(dF).min(2).max(8).optional(),
        trace: x.array(fF).max(64).optional(),
      })
      .strict(),
  );
function mr(e, n) {
  return {
    status: 'unknown',
    relation: 'none',
    proof: 'none',
    explanation: { code: e, ...(n && { params: n }) },
  };
}
function sp(e, n) {
  return {
    status: 'unsupported',
    relation: 'none',
    proof: 'none',
    explanation: { code: e, ...(n && { params: n }) },
  };
}
var rX = x
  .object({
    ms: x.number().int().min(0).max(6e4),
    nodes: x.number().int().min(1).max(1e7),
    depth: x.number().int().min(1).max(64),
    branches: x.number().int().min(0).max(64),
  })
  .strict();
var mF = x
    .object({
      statement: Pu,
      sort: fb,
      hypotheses: x.array(Iu).max(32),
      conditions: x.array(Iu).max(32),
      goal: hC.optional(),
    })
    .strict(),
  sX = x
    .object({
      sort: fb,
      from: Pu,
      to: Pu,
      goal: hC.optional(),
      hypotheses: x.array(Iu).max(32).optional(),
    })
    .strict(),
  pC = { v: x.literal(XQ), packs: x.array(x.string().regex(cF)).max(32) },
  iX = x.discriminatedUnion('kind', [
    x.object({ ...pC, kind: x.literal('state'), body: mF }).strict(),
    x.object({ ...pC, kind: x.literal('check'), body: yC }).strict(),
  ]);
var $y = ['<', '>', '\u2264', '\u2265'];
function wC(e) {
  switch (e) {
    case '<':
      return '>';
    case '>':
      return '<';
    case '\u2264':
      return '\u2265';
    case '\u2265':
      return '\u2264';
    default:
      return e;
  }
}
var pF = /[^\p{L}\p{M}0-9\s?+\-−×*÷/^²√()=<>≤≥,|!%°₀-₉⁰¹²³⁴-⁹′]/u,
  gF = /\p{L}{3,}/gu,
  Ry = /\?([A-Za-zα-ω][₀-₉]?)(?![\p{L}₀-₉])/gu;
function SC(e) {
  let n = pF.exec(e);
  if (n) return { ok: !1, code: 'forbidden_char', detail: n[0] };
  for (let t of e.match(gF) ?? [])
    if (cf[t] !== 1 && t !== Em) return { ok: !1, code: 'forbidden_word', detail: t };
  return null;
}
function hF(e) {
  return e.rels || e.mod !== void 0
    ? null
    : e.cmp
      ? e.cmp === '\u2248'
        ? null
        : e.cmp
      : e.sides.length === 1
        ? 'none'
        : e.sides.length === 2
          ? '='
          : null;
}
function TC(e) {
  let n;
  try {
    n = Ae(ne(Te(e)));
  } catch (i) {
    return { ok: !1, code: 'unparsable', detail: i instanceof Error ? i.message : String(i) };
  }
  if (n.dis.length !== 1) return { ok: !1, code: 'unsupported_relation', detail: 'ou' };
  let t = n.dis[0],
    r = hF(t);
  if (r === null) return { ok: !1, code: 'unsupported_relation', detail: t.cmp ?? 'cha\xEEne' };
  let s = {};
  return (
    t.sides.forEach((i) => Fe(i, s)),
    { ok: !0, parsed: { relation: r, sides: t.sides, vars: Object.keys(s).sort() } }
  );
}
function db(e) {
  let n = SC(e);
  if (n) return n;
  if ([...e.matchAll(Ry)].length !== (e.match(/\?/g) ?? []).length)
    return { ok: !1, code: 'bad_pattern_var', detail: e };
  let r = ne(Te(e.replace(Ry, ' 0 '))).find((s) => jt(s));
  return r !== void 0
    ? { ok: !1, code: 'literal_symbol', detail: r }
    : TC(e.replace(Ry, (s, i) => `(${i})`));
}
function Cy(e) {
  let n = SC(e);
  return n || (e.includes('?') ? { ok: !1, code: 'pattern_var_in_example', detail: e } : TC(e));
}
var RC = new WeakMap();
function pb(e) {
  let n = RC.get(e);
  if (n) return n;
  let t = {};
  for (let [r, s] of Object.entries(e.forms)) {
    let i = db(s.text);
    if (!i.ok) throw new Error(`forme illisible ${e.qid}/${r}`);
    t[r] = { relation: i.parsed.relation, sides: i.parsed.sides.map((o) => R(_e(o))) };
  }
  return (RC.set(e, t), t);
}
var Au = (e, n) => (e.k === 'sym' && e.n in n.vars && !_u[e.n] ? e.n : null),
  mb = (e, n) => Au(e, n) !== null;
function bF(e, n, t, r) {
  let s = e[n];
  return s ? (za(s, t, r.sorts) ? [e] : []) : [{ ...e, [n]: R(t, r.sorts) }];
}
function EC(e, n) {
  if (n === 1) return [e];
  if (e.k === 'num') {
    if (e.v.n < 0n && n % 2 === 0) return [];
    if (n === 2) {
      let s = Hs(e.v);
      return s ? [s.rad === 1n ? T(s.coef) : I(T(s.coef), be('sqrt', T(Number(s.rad))))] : [];
    }
    let t = $C(e.v.n < 0n ? -e.v.n : e.v.n, n),
      r = $C(e.v.d, n);
    return t === null || r === null ? [] : [T(C(e.v.n < 0n ? -t : t, r))];
  }
  if (e.k === 'pow' && e.b.k === 'num' && B(e.b.v)) {
    let t = Number(e.b.v.n);
    return t % n === 0 ? [t / n === 1 ? e.a : et(e.a, T(t / n))] : [];
  }
  if (e.k === 'mul') {
    let t = e.c.map((r) => EC(r, n)[0]);
    return t.every((r) => r) ? [I(...t)] : [];
  }
  return [];
}
function $C(e, n) {
  if (e < 2n) return e;
  let t = BigInt(Math.round(Number(e) ** (1 / n)));
  for (let r of [t - 1n, t, t + 1n]) if (r >= 0n && r ** BigInt(n) === e) return r;
  return null;
}
function gt(e, n, t, r) {
  if (--r.fuel.n < 0) return [];
  let s = Au(e, r);
  if (s !== null) return bF(t, s, n, r);
  switch (e.k) {
    case 'num':
      return n.k === 'num' && M(e.v, n.v) ? [t] : [];
    case 'sym':
      return n.k === 'sym' && n.n === e.n ? [t] : [];
    case 'add':
      return n.k === 'add' ? MC(e.c, n.c, t, r, 'add') : [];
    case 'mul':
      return vF(e, n, t, r);
    case 'div':
      return n.k === 'div'
        ? gt(e.a, n.a, t, r).flatMap((i) => gt(e.b, n.b, i, r))
        : n.k === 'num' && n.v.d !== 1n
          ? gt(e.b, T(C(n.v.d)), t, r).flatMap((i) => gt(e.a, T(C(n.v.n)), i, r))
          : [];
    case 'pow': {
      let i = [];
      if (
        (n.k === 'pow' && i.push(...gt(e.a, n.a, t, r).flatMap((o) => gt(e.b, n.b, o, r))),
        !i.length && e.b.k === 'num' && B(e.b.v) && e.b.v.n > 1n)
      )
        for (let o of EC(n, Number(e.b.v.n))) i.push(...gt(e.a, o, t, r));
      return i;
    }
    case 'fn':
      return n.k === 'fn' && n.f === e.f ? gt(e.a, n.a, t, r) : [];
    case 'binom':
      return n.k === 'binom' ? gt(e.a, n.a, t, r).flatMap((i) => gt(e.b, n.b, i, r)) : [];
  }
}
function vF(e, n, t, r) {
  let s = e.c[0]?.k === 'num' ? e.c[0].v : null;
  if (s && !L(s)) {
    let o = e.c.slice(1),
      a = R(I(T(A(q, s)), n), r.sorts),
      l = o.length === 1 ? o[0] : { k: 'mul', c: o };
    return gt(l, a, t, r);
  }
  let i = n.k === 'mul' ? n.c : [n];
  return e.c.some((o) => Po(o, r.sorts)) || i.some((o) => Po(o, r.sorts))
    ? _C(e.c, i, t, r)
    : MC(e.c, i, t, r, 'mul');
}
function MC(e, n, t, r, s) {
  if (e.length > n.length || n.length > 8) return [];
  let i = [...e].sort((l, u) => Number(mb(l, r)) - Number(mb(u, r))),
    o = [],
    a = (l, u, c) => {
      if (r.fuel.n < 0 || o.length >= 64) return;
      if (l === i.length) {
        u.every(Boolean) && o.push(c);
        return;
      }
      let f = i[l];
      if (l === i.length - 1 && mb(f, r) && !c[Au(f, r)]) {
        let m = n.filter((g, h) => !u[h]);
        if (!m.length) return;
        let p = m.length === 1 ? m[0] : { k: s, c: m };
        for (let g of gt(f, p, c, r))
          a(
            l + 1,
            u.map(() => !0),
            g,
          );
        return;
      }
      for (let m = 0; m < n.length; m++)
        if (!u[m])
          for (let p of gt(f, n[m], c, r)) {
            let g = [...u];
            ((g[m] = !0), a(l + 1, g, p));
          }
      if (Au(f, r) !== null && !c[Au(f, r)] && n.length - u.filter(Boolean).length > i.length - l) {
        let m = n.map((p, g) => g).filter((p) => !u[p]);
        for (let p = 0; p < m.length; p++)
          for (let g = p + 1; g < m.length; g++) {
            let h = { k: s, c: [n[m[p]], n[m[g]]] };
            for (let b of gt(f, h, c, r)) {
              let v = [...u];
              ((v[m[p]] = !0), (v[m[g]] = !0), a(l + 1, v, b));
            }
          }
      }
    };
  return (
    a(
      0,
      n.map(() => !1),
      t,
    ),
    o
  );
}
function _C(e, n, t, r) {
  if (!e.length) return n.length ? [] : [t];
  let [s, ...i] = e,
    o = [],
    a = mb(s, r) ? n.length - i.length : 1;
  for (let l = 1; l <= a; l++) {
    let u = n.slice(0, l),
      c = u.length === 1 ? u[0] : { k: 'mul', c: u };
    for (let f of gt(s, c, t, r)) o.push(..._C(i, n.slice(l), f, r));
  }
  return o;
}
function Qi(e, n, t = {}) {
  return R(j(e, n), t);
}
function qC(e, n) {
  let t = Z(e, n);
  return t.ok ? Je($e(t.rf)) : null;
}
function Wa(e, n, t, r = new Set()) {
  let s = Au(e, t);
  return (
    s !== null
      ? n[s] || r.add(s)
      : e.k === 'add' || e.k === 'mul'
        ? e.c.forEach((i) => Wa(i, n, t, r))
        : e.k === 'div' || e.k === 'pow' || e.k === 'binom'
          ? (Wa(e.a, n, t, r), Wa(e.b, n, t, r))
          : e.k === 'fn' && Wa(e.a, n, t, r),
    r
  );
}
function Ff(e, n, t, r, s) {
  let i = [...Wa(e, t, r)];
  if (!i.length) return t;
  if (i.length > 1) return null;
  let o = i[0];
  if (Au(e, r) !== null) return { ...t, [o]: n };
  let a = (l) => Wa(l, t, r).size > 0;
  if (e.k === 'add') {
    let l = e.c.filter(a);
    if (l.length !== 1) return null;
    let c = e.c
      .filter((f) => !a(f))
      .map((f) => Qi(f, t, r.sorts))
      .reduce((f, d) => ve(f, d), n);
    return Ff(l[0], R(c, r.sorts), t, r, s);
  }
  if (e.k === 'mul') {
    let l = e.c.filter(a);
    if (l.length !== 1) return null;
    let u = e.c.filter((c) => !a(c)).map((c) => Qi(c, t, r.sorts));
    return u.length ? Ff(l[0], ye(n, I(...u)), t, r, s) : null;
  }
  return e.k === 'div'
    ? a(e.b) && !a(e.a)
      ? Ff(e.b, ye(Qi(e.a, t, r.sorts), n), t, r, s)
      : a(e.a) && !a(e.b)
        ? Ff(e.a, I(n, Qi(e.b, t, r.sorts)), t, r, s)
        : null
    : null;
}
function Ja(e, n, t) {
  return e === '>'
    ? { rel: '<', l: t, r: n }
    : e === '\u2265'
      ? { rel: '\u2264', l: t, r: n }
      : { rel: e, l: n, r: t };
}
function kF(e, n, t) {
  let r = [];
  for (let s of e.preconditions) {
    let i = [];
    for (let o of s.of) {
      let a = n[o];
      if (!a) return null;
      let l = qC(a, { sorts: t });
      i.push(oe(l ?? a));
    }
    r.push({ ...s, of: i });
  }
  return r;
}
function gb(e, n, t, r = {}) {
  let s = r.sorts ?? {},
    i = { vars: e.vars, sorts: s, fuel: { n: r.fuel ?? 4e3 } },
    o = pb(e),
    a = [];
  for (let l of e.directions) {
    let u = o[l.from],
      c = o[l.to],
      f =
        e.appliesTo === 'expression'
          ? yF(u, c, n, t, i).map((d) => ({ b: d, mirrored: !1 }))
          : xF(u, c, n, t, i);
    for (let { b: d, mirrored: m } of f) {
      let p = kF(e, d, s);
      if (
        p &&
        (a.push({
          rule: e,
          from: l.from,
          to: l.to,
          bindings: d,
          conditions: p,
          ...(m ? { mirrored: m } : {}),
        }),
        a.length >= e.maxMatches)
      )
        return a;
    }
  }
  return a;
}
function xF(e, n, t, r, s) {
  if (t.k !== 'rel' || r.k !== 'rel' || e.sides.length !== 2 || n.sides.length !== 2) return [];
  let i = Ja(e.relation, e.sides[0], e.sides[1]),
    o = Ja(t.rel, t.l, t.r),
    a = Ja(n.relation, n.sides[0], n.sides[1]),
    l = Ja(r.rel, r.l, r.r),
    u = (g) => (g === '\u2264' ? '<' : g);
  if (i.rel === a.rel) {
    if (u(i.rel) !== u(o.rel) || u(a.rel) !== u(l.rel) || o.rel !== l.rel) return [];
  } else if (i.rel !== o.rel || a.rel !== l.rel) return [];
  let f = o.rel === '=' ? [o, { rel: o.rel, l: o.r, r: o.l }] : [o],
    d = l.rel === '=' ? [{ rel: l.rel, l: l.r, r: l.l }] : [],
    m = [],
    p = { sorts: s.sorts };
  for (let g of f) {
    let h = g === o ? [l] : [l, ...d];
    for (let b of gt(i.l, g.l, {}, s).flatMap((v) => gt(i.r, g.r, v, s)))
      for (let v of h) {
        let k = [
            [a.l, v.l, a.r, v.r],
            [a.r, v.r, a.l, v.l],
          ],
          y = !1;
        for (let [S, w, _, O] of k) {
          let G = Ff(S, w, b, s, p);
          if ((G && (G = Ff(_, O, G, s, p)), !G)) continue;
          let Se = { ...G },
            U = !0;
          for (let xe of Object.keys(Se))
            if (!(xe in b)) {
              let le = qC(Se[xe], p);
              le ? (Se[xe] = le) : (U = !1);
            }
          if (!U) continue;
          let ae = Qi(a.l, Se, s.sorts),
            P = Qi(a.r, Se, s.sorts),
            ee = (xe) => qn(ae, xe.l, p) === 'equal' && qn(P, xe.r, p) === 'equal';
          if (
            !(ee(o) || (v !== l && ee(g))) &&
            qn(ae, v.l, p) === 'equal' &&
            qn(P, v.r, p) === 'equal'
          ) {
            (m.some((xe) => My(xe.b, Se)) || m.push({ b: Se, mirrored: v !== l }), (y = !0));
            break;
          }
        }
        if (y) break;
      }
    if (m.length) break;
  }
  return m;
}
function My(e, n) {
  let t = Object.keys(e).sort(),
    r = Object.keys(n).sort();
  return t.join() === r.join() && t.every((s) => E(e[s]) === E(n[s]));
}
function Vf(e, n = (r) => r, t = []) {
  if ((t.push({ t: e, put: n }), t.length > 400)) return t;
  switch (e.k) {
    case 'add':
    case 'mul': {
      let r = e.c.length;
      if (
        (e.c.forEach((s, i) =>
          Vf(s, (o) => n({ k: e.k, c: e.c.map((a, l) => (l === i ? o : a)) }), t),
        ),
        r > 2 && r <= 7)
      )
        for (let s = 1; s < (1 << r) - 1; s++) {
          let i = [...Array(r).keys()].filter((l) => s & (1 << l));
          if (i.length < 2) continue;
          let o = { k: e.k, c: i.map((l) => e.c[l]) },
            a = [...Array(r).keys()].filter((l) => !(s & (1 << l)));
          t.push({ t: o, put: (l) => n({ k: e.k, c: [l, ...a.map((u) => e.c[u])] }) });
        }
      break;
    }
    case 'div':
    case 'pow':
    case 'binom': {
      let { a: r, b: s } = e;
      (Vf(r, (i) => n({ ...e, a: i }), t), Vf(s, (i) => n({ ...e, b: i }), t));
      break;
    }
    case 'fn':
      Vf(e.a, (r) => n({ ...e, a: r }), t);
      break;
    default:
      break;
  }
  return t;
}
function CC(e, n, t, r, s) {
  let i = [],
    o = E(R(r, s.sorts));
  for (let a of Vf(R(t, s.sorts))) {
    for (let l of gt(e.sides[0], a.t, {}, s)) {
      if (Wa(n.sides[0], l, s).size) continue;
      let u = Qi(n.sides[0], l, s.sorts);
      if (za(u, a.t, s.sorts)) continue;
      let c = R(a.put(u), s.sorts);
      E(c) === o && !i.some((f) => My(f, l)) && i.push(l);
    }
    if (s.fuel.n < 0) break;
  }
  return i;
}
function Ey(e, n, t, r, s) {
  let i = CC(e, n, t, r, s);
  return i.length ? i : CC(n, e, r, t, s);
}
function yF(e, n, t, r, s) {
  if (e.relation !== 'none' || n.relation !== 'none') return [];
  if (t.k === 'expr' && r.k === 'expr') return Ey(e, n, t.e, r.e, s);
  if (t.k === 'rel' && r.k === 'rel' && t.rel === r.rel) {
    let i = [];
    return (
      za(t.r, r.r, s.sorts) && i.push(...Ey(e, n, t.l, r.l, s)),
      za(t.l, r.l, s.sorts) && i.push(...Ey(e, n, t.r, r.r, s)),
      i
    );
  }
  return [];
}
function _y(e, n = {}, t = 4e3) {
  return { vars: e.vars, sorts: n, fuel: { n: t } };
}
function LC(e, n, t, r) {
  let s = [],
    i = new Set();
  for (let o of Vf(R(t, r.sorts))) {
    for (let a of gt(e.sides[0], o.t, {}, r)) {
      if (Wa(n.sides[0], a, r).size) continue;
      let l = Qi(n.sides[0], a, r.sorts);
      if (za(l, o.t, r.sorts)) continue;
      let u = R(o.put(l), r.sorts),
        c = E(u);
      i.has(c) || (i.add(c), s.push({ term: u, bindings: a }));
    }
    if (r.fuel.n < 0 || s.length > 32) break;
  }
  return s;
}
function NC(e, n, t) {
  let r = Ja(e.relation, e.sides[0], e.sides[1]),
    s = Ja(n.rel, n.l, n.r),
    i = (l) => (l === '\u2264' ? '<' : l);
  if (i(r.rel) !== i(s.rel)) return [];
  let o = s.rel === '=' ? [s, { rel: s.rel, l: s.r, r: s.l }] : [s],
    a = [];
  for (let l of o)
    for (let u of gt(r.l, l.l, {}, t).flatMap((c) => gt(r.r, l.r, c, t)))
      a.some((c) => My(c, u)) || a.push(u);
  return a;
}
function OC(e, n, t, r, s = {}) {
  if (n.sides.length !== 2) return null;
  let i = n.relation,
    o = t.rel === '\u2264' || t.rel === '\u2265',
    a = Ja(e.relation, e.sides[0], e.sides[1]).rel,
    l = Ja(n.relation, n.sides[0], n.sides[1]).rel;
  o &&
    a === '<' &&
    (l === '<' || l === '\u2264') &&
    (i = i === '<' ? '\u2264' : i === '>' ? '\u2265' : i);
  let u = Qi(n.sides[0], r, s),
    c = Qi(n.sides[1], r, s);
  return t.rel === '>' || t.rel === '\u2265'
    ? {
        rel:
          i === '<'
            ? '>'
            : i === '>'
              ? '<'
              : i === '\u2264'
                ? '\u2265'
                : i === '\u2265'
                  ? '\u2264'
                  : i,
        l: c,
        r: u,
      }
    : { rel: i, l: u, r: c };
}
var Bn = (e, n, t, r = 'exact') => ({
    status: 'valid',
    relation: e,
    proof: r,
    explanation: { code: n, ...(t && { params: t }) },
  }),
  St = (e, n, t = 'exact') => ({
    status: 'invalid',
    relation: 'none',
    proof: t,
    explanation: { code: e, ...(n && { params: n }) },
  }),
  zf = (e) => (e.length > 400 ? e.slice(0, 397) + '\u2026' : e);
function Ss(e, n, t) {
  let r = t.now ?? (() => Date.now()),
    s = [...(t.hypotheses ?? [])],
    i = t.sorts ?? {},
    o = {
      rules: t.rules,
      hyps: s,
      facts: ji(s, i),
      sorts: i,
      goal: t.goal,
      approximation: t.approximation,
      deadline: t.deadline ?? r() + 50,
      now: r,
      fuel: t.fuel ?? 4e3,
      branches: t.branches ?? !0,
      angles: t.angles ?? {},
      ...(t.trig ? { trig: t.trig } : {}),
    },
    a = e,
    l = n;
  if (t.substitutions?.length) {
    let u = {};
    for (let c of t.substitutions) {
      let f = ie(c.value);
      if (!f.ok || f.s.k !== 'expr') return sp('bad_substitution');
      u[c.name] = f.s.e;
    }
    ((a = Mt(a, (c) => j(c, u))), (l = Mt(l, (c) => j(c, u))));
  }
  return Object.keys(o.angles).length
    ? ((a = Mt(a, ju)), (l = Mt(l, ju)), wF(Ny(a, l, o), o))
    : Ny(a, l, o);
}
var Oy = new Set(['cos', 'sin', 'tan']);
function Df(e) {
  switch (e.k) {
    case 'add':
    case 'mul':
      return { ...e, c: e.c.map(Df) };
    case 'div':
    case 'pow':
    case 'binom':
      return { ...e, a: Df(e.a), b: Df(e.b) };
    case 'fn':
      return e.f === 'deg' ? Df(e.a) : { ...e, a: Df(e.a) };
    default:
      return e;
  }
}
function ju(e) {
  switch (e.k) {
    case 'add':
    case 'mul':
      return { ...e, c: e.c.map(ju) };
    case 'div':
    case 'pow':
    case 'binom':
      return { ...e, a: ju(e.a), b: ju(e.b) };
    case 'fn':
      return e.f === 'deg'
        ? ju(e.a)
        : Oy.has(e.f)
          ? be(e.f, be('deg', Df(e.a)))
          : { ...e, a: ju(e.a) };
    default:
      return e;
  }
}
function Bf(e, n) {
  switch (e.k) {
    case 'add':
    case 'mul':
      return { ...e, c: e.c.map((t) => Bf(t, n)) };
    case 'div':
    case 'pow':
    case 'binom':
      return { ...e, a: Bf(e.a, n), b: Bf(e.b, n) };
    case 'fn': {
      if (e.f === 'deg') return Bf(e.a, n);
      if (!Oy.has(e.f)) return { ...e, a: Bf(e.a, n) };
      let t = Z(ye(I(e.a, T(180)), rn('\u03C0')), { sorts: n.sorts });
      return t.ok ? be(e.f, Je($e(t.rf))) : e;
    }
    default:
      return e;
  }
}
function wF(e, n) {
  let t = e.explanation?.params;
  if (!t) return e;
  let r = {};
  for (let [s, i] of Object.entries(t)) {
    if (s === 'label' || !/\b(cos|sin|tan)\b|°|π/.test(i)) {
      r[s] = i;
      continue;
    }
    let o = ie(i);
    r[s] = o.ok ? _t(Mt(o.s, (a) => Bf(a, n))) : i;
  }
  return { ...e, explanation: { ...e.explanation, params: r } };
}
function ip(e, n, t = []) {
  switch (e.k) {
    case 'add':
    case 'mul':
      e.c.forEach((r) => ip(r, n, t));
      break;
    case 'div':
    case 'pow':
    case 'binom':
      (ip(e.a, n, t), ip(e.b, n, t));
      break;
    case 'fn':
      Oy.has(e.f) && $(e.a).has(n) ? t.push(e) : ip(e.a, n, t);
      break;
    default:
      break;
  }
  return t;
}
function op(e, n, t) {
  if (E(e) === n) return t;
  switch (e.k) {
    case 'add':
    case 'mul':
      return { ...e, c: e.c.map((r) => op(r, n, t)) };
    case 'div':
    case 'pow':
    case 'binom':
      return { ...e, a: op(e.a, n, t), b: op(e.b, n, t) };
    case 'fn':
      return { ...e, a: op(e.a, n, t) };
    default:
      return e;
  }
}
var KC = '\xA7angle',
  SF = { acute: 90, angle: 180 };
function PC(e, n, t, r) {
  if (e.k !== 'rel' || e.rel !== '=') return null;
  let s = ve(e.l, e.r),
    i = SF[t],
    o = (h) => h > 1e-9 && h < i - 1e-9,
    a = ip(s, n),
    l = [...new Set(a.map(E))];
  if (l.length === 2) {
    let h = a.find((_) => E(_) === l[0]),
      b = a.find((_) => E(_) === l[1]);
    if (h.k !== 'fn' || b.k !== 'fn' || E(h.a) !== E(b.a)) return null;
    let [v, k] = h.f === 'sin' ? [h, b] : [b, h];
    if (v.f !== 'sin' || k.f !== 'cos') return null;
    let y = by(s, v, k, r.sorts);
    if (!y) return null;
    let S = Z(y.A, { sorts: r.sorts });
    if (!S.ok || Ue(S.rf.n)) return null;
    let w = be('tan', v.a);
    ((s = he(w, ye(y.B, y.A))), (a = [w]));
  }
  if (!a.length) {
    let h = Z(s, { sorts: r.sorts });
    if (!h.ok || an(h.rf.n)) return null;
    let b = Bt({ n: h.rf.n, d: kb }, n);
    return !b || !b.complete ? null : { roots: b.roots.filter((v) => o(D(v, {}))), trig: null };
  }
  let u = E(a[0]);
  if (a.some((h) => E(h) !== u)) return null;
  let c = a[0];
  if (c.k !== 'fn' || c.a.k !== 'fn' || c.a.f !== 'deg') return null;
  let f = c.a.a;
  if (f.k !== 'sym' || f.n !== n) return null;
  let d = op(s, u, rn(KC));
  if ($(d).has(n)) return null;
  let m = Z(d, { sorts: r.sorts });
  if (!m.ok || an(m.rf.n)) return null;
  let p = Bt({ n: m.rf.n, d: kb }, KC);
  if (!p || !p.complete) return null;
  let g = [];
  for (let h of p.roots) {
    let b = D(h, {});
    if (!Number.isFinite(b)) return null;
    if (c.f === 'cos') b > -1 + 1e-12 && b < 1 - 1e-12 && g.push(be('arccos', h));
    else if (c.f === 'sin') {
      if (b <= 1e-12 || b > 1 + 1e-12) continue;
      Math.abs(b - 1) <= 1e-12
        ? g.push(T(90))
        : (g.push(be('arcsin', h)), t === 'angle' && g.push(ve(T(180), be('arcsin', h))));
    } else Math.abs(b) > 1e-12 && g.push(b > 0 ? be('arctan', h) : he(T(180), be('arctan', h)));
  }
  return { roots: g.filter((h) => o(D(h, {}))), trig: c.f };
}
function TF(e, n, t) {
  let r = Z(ve(e, n), { sorts: t.sorts });
  if (r.ok && Ue(r.rf.n)) return !0;
  let s = D(e, {}),
    i = D(n, {});
  return !Number.isFinite(s) || !Number.isFinite(i) ? null : Math.abs(s - i) > 1e-9 ? !1 : null;
}
function RF(e, n, t, r, s) {
  let i = PC(e, t, r, s),
    o = PC(n, t, r, s);
  if (!i || !o || (!i.trig && !o.trig)) return null;
  let a = (u) => {
      let c = Z(u, { sorts: s.sorts });
      return oe(c.ok && an(c.rf.n) && an(c.rf.d) ? Je(c.rf) : R(u));
    },
    l = (u, c) => {
      let f = !1;
      for (let d of c) {
        let m = TF(u, d, s);
        if (m) return !0;
        m === null && (f = !0);
      }
      return f ? null : !1;
    };
  for (let u of i.roots) {
    let c = l(u, o.roots);
    if (c === null) return null;
    if (!c) return St('lost_solution', { at: `${t} = ${a(u)}` });
  }
  for (let u of o.roots) {
    let c = l(u, i.roots);
    if (c === null) return null;
    if (!c) return Bn('implies', 'extra_solutions', { at: `${t} = ${a(u)}` });
  }
  return i.trig && !o.trig
    ? Bn('equivalent', 'inverse_trig', { f: i.trig })
    : Bn('equivalent', 'equivalent');
}
function IC(e, n) {
  let t = {};
  for (let [r, s] of n.facts.sign) s.zero && !s.pos && !s.neg && (t[r] = T(0));
  return Object.keys(t).length ? Mt(e, (r) => j(r, t)) : e;
}
function Ny(e, n, t) {
  let r = IC(e, t),
    s = IC(n, t),
    i = AC(s, t);
  if (i) return St(i);
  if (AC(r, t)) return mr('previous_line_undefined');
  if (t.now() > t.deadline) return mr('budget_exhausted');
  if (Object.values(t.sorts).includes('matrix')) return ZF(r, s, t);
  let o = _F(r, s, t);
  if (o) return o;
  if (t.now() > t.deadline) return mr('budget_exhausted');
  if (r.k === 'expr' && s.k === 'expr') return KF(r.e, s.e, t);
  if (r.k === 'expr' || s.k === 'expr') return mr('statement_kind_changed');
  let a = HC(r, s, t);
  return a.status === 'unknown' ? ($F(r, s, t) ?? a) : a;
}
function $F(e, n, t) {
  let r = [],
    s = !1,
    i = (c, f) => {
      if (c.k !== 'rel' || c.rel !== '=') return null;
      let [d, m, p] =
        c.l.k === 'fn' && c.l.f === 'sqrt'
          ? [c.l, c.r, !0]
          : c.r.k === 'fn' && c.r.f === 'sqrt'
            ? [c.r, c.l, !1]
            : [null, null, !1];
      if (!d || !m || d.k !== 'fn') return null;
      let g = Wr('nonnegative', m),
        h = tr(g, t.facts);
      if (h === 'false') return null;
      h !== 'true' && (f ? r.push(g) : (s = !0));
      let b = { k: 'pow', a: m, b: T(2) };
      return p ? { k: 'rel', rel: '=', l: d.a, r: b } : { k: 'rel', rel: '=', l: b, r: d.a };
    },
    o = i(e, !1),
    a = i(n, !0);
  if (!o && !a) return null;
  let l = HC(o ?? e, a ?? n, { ...t, branches: !1 });
  if (l.status !== 'valid') return null;
  let u = s && l.relation === 'equivalent' ? { ...l, relation: 'implies' } : l;
  return r.length
    ? { ...u, status: 'conditional', conditions: r, explanation: { code: 'square_root' } }
    : { ...u, explanation: { code: 'square_root' } };
}
function AC(e, n) {
  let t = e.k === 'expr' ? [e.e] : on(e).flatMap((r) => [r.l, r.r]);
  for (let r of t) {
    let s = Z(r, { sorts: n.sorts });
    if (!s.ok && (s.code === 'division_by_zero' || s.code === 'undefined_value')) return s.code;
  }
  return null;
}
function CF(e, n, t) {
  if (e.appliesTo === 'expression')
    return n.k !== 'or' && t.k !== 'or' && n.k !== 'set' && t.k !== 'set';
  if (n.k !== 'rel' || t.k !== 'rel') return !1;
  let r = (s) => s === '=';
  return e.appliesTo === 'equation' ? r(n.rel) && r(t.rel) : !r(n.rel) && !r(t.rel);
}
function hb(e) {
  let n = new Set(e.rule.directions.find((r) => r.from === e.from && r.to === e.to)?.introduces),
    t = 0;
  for (let [r, s] of Object.entries(e.bindings)) {
    let i = oe(s);
    ((t += i.length + (i.includes('\xF7') ? 6 : 0) + (i.startsWith('\u2212') ? 3 : 0)),
      n.has(r) && Dn({ k: 'expr', e: s }).size && (t += 20));
  }
  return t + e.rule.cost * 10;
}
function EF(e, n, t) {
  if (t.goal?.target) return new Set([t.goal.target]);
  let r = new Set([...Dn(e), ...Dn(n)]);
  return r.size === 1 ? r : new Set();
}
function MF(e, n) {
  return e.of.some((t) => {
    let r = ie(t);
    return r.ok && [...Dn(r.s)].some((s) => n.has(s));
  });
}
function _F(e, n, t) {
  let r = [],
    s = qF(e, t);
  for (let f of t.rules)
    if (CF(f, e, n)) {
      for (let d of gb(f, e, n, { sorts: t.sorts, fuel: t.fuel })) {
        let m = [...d.conditions, ...NF(d, t)],
          p = m.map((g) => (s && LF(g, s, t) ? 'false' : tr(g, t.facts)));
        p.includes('false') || r.push({ m: d, conds: m, decisions: p });
      }
      if (t.now() > t.deadline) break;
    }
  if (!r.length) return null;
  let i = r.filter((f) => f.decisions.every((d) => d === 'true'));
  if (i.length) {
    let f = i.sort((d, m) => hb(d.m) - hb(m.m))[0];
    return jC(f.m, e, n);
  }
  let o = EF(e, n, t),
    a = r.filter(
      (f) => !f.m.mirrored && !f.conds.some((d, m) => f.decisions[m] !== 'true' && MF(d, o)),
    );
  if (!a.length) return null;
  let l = a.sort((f, d) => hb(f.m) - hb(d.m))[0],
    u = l.conds.filter((f, d) => l.decisions[d] !== 'true'),
    c = l.m.rule.onUnknown ?? 'conditional';
  if (c === 'refuse') return null;
  if (c === 'branch' && t.branches) {
    let f = zC(u[0], e, n, t);
    if (f) return f;
  }
  return { ...jC(l.m, e, n), status: 'conditional', conditions: u };
}
function qF(e, n) {
  if (e.k !== 'rel' || e.rel !== '=') return null;
  let t = Z(ve(e.l, e.r), { sorts: n.sorts });
  return t.ok && !an(t.rf.n) ? t.rf.n : null;
}
function LF(e, n, t) {
  if (e.kind !== 'nonzero' || e.of.length !== 1) return !1;
  let r = ie(e.of[0]);
  if (!r.ok || r.s.k !== 'expr') return !1;
  let s = Z(r.s.e, { sorts: t.sorts });
  return s.ok && !Ue(s.rf.n) && Tr(s.rf.n, n) !== null;
}
function NF(e, n) {
  let t = [],
    r = new Set(e.rule.directions.find((s) => s.from === e.from && s.to === e.to)?.introduces);
  for (let [s, i] of Object.entries(e.bindings)) {
    if (!r.has(s)) continue;
    let o = Z(i, { sorts: n.sorts });
    o.ok && je(o.rf.d) === null && t.push(Wr('nonzero', kn(o.rf.d)));
  }
  return t;
}
function jC(e, n, t) {
  let r = { label: zf(e.rule.label) };
  for (let [s, i] of Object.entries(e.bindings).slice(0, 6)) r[`v_${s}`] = zf(oe(i));
  return {
    status: 'valid',
    relation: e.rule.relation,
    proof: 'rule',
    ruleId: e.rule.qid,
    explanation: { code: 'rule', params: r },
    trace: [{ from: zf(_t(n)), to: zf(_t(t)), relation: e.rule.relation, ruleId: e.rule.qid }],
  };
}
function OF(e, n) {
  let t = Z(e, { sorts: n.sorts });
  if (!t.ok) return e;
  for (let s of [t.rf.n, t.rf.d]) {
    if (an(s)) continue;
    let i = [...s.t.values()];
    if (i.length !== 1) return e;
    let o = i[0].m;
    if (o.length !== 1 || o[0].a.kind !== 'sym' || o[0].e % 2 === 0) return e;
  }
  let r = [...Lt(t.rf.n), ...Lt(t.rf.d)];
  return r.length === 1 ? rn(r[0]) : e;
}
function zC(e, n, t, r) {
  let s = ie(e.of[0]);
  if (!s.ok || s.s.k !== 'expr') return null;
  let i = OF(s.s.e, r),
    o = [];
  for (let l of ['positive', 'negative', 'zero']) {
    let u = Wr(l, i);
    if (tr(u, r.facts) === 'false') continue;
    let c = [...r.hyps, u],
      f = { ...r, hyps: c, facts: ji(c, r.sorts), branches: !1 };
    o.push({ when: [u], check: Ny(n, t, f) });
  }
  if (o.length < 2) return o[0]?.check ?? null;
  let a = o[0].check;
  return o.every((l) => l.check.status === a.status && l.check.relation === a.relation)
    ? a
    : {
        status: 'conditional',
        relation: 'none',
        proof: 'none',
        explanation: { code: 'depends_on_sign', params: { of: zf(oe(i)) } },
        branches: o,
      };
}
function qy(e) {
  return Dn({ k: 'expr', e }).size > 0;
}
function KF(e, n, t) {
  let r = { sorts: t.sorts },
    s = qn(e, n, r);
  if (s === 'equal') {
    let a = Z(n, r),
      l = a.ok && _n(a.rf) !== null;
    return qy(e) || !l ? Bn('identity', 'identity') : Bn('evaluation', 'evaluation');
  }
  if (!qy(e) && !qy(n)) {
    let a = AF(e, n, t);
    if (a) return a;
  }
  let i = PF(e, n, t);
  if (i && !i.at) return St('wrong_value', { got: i.got, expected: i.expected });
  if (i) return St('counterexample', i);
  if (s === 'different') return St('not_identical');
  let o = IF(e, n, t);
  return o ? St('counterexample', o, 'sampled') : mr('no_proof');
}
function PF(e, n, t) {
  let r = [...Dn({ k: 'or', items: [{ rel: '=', l: e, r: n }] })];
  for (let s of Yh(r, t.facts, `${E(e)}|${E(n)}`, 12)) {
    let i, o;
    try {
      ((i = Ai(e, s, { sorts: t.sorts })), (o = Ai(n, s, { sorts: t.sorts })));
    } catch {
      continue;
    }
    if (i && o && !M(i, o)) return { at: Ky(s), got: oe(T(o)), expected: oe(T(i)) };
  }
  return null;
}
function IF(e, n, t) {
  let r = [...Dn({ k: 'or', items: [{ rel: '=', l: e, r: n }] })];
  for (let s of Yh(r, t.facts, `f|${E(e)}|${E(n)}`, 12)) {
    let i = {};
    for (let [l, u] of Object.entries(s)) i[l] = en(u);
    let o = D(e, i),
      a = D(n, i);
    if (
      !(!Number.isFinite(o) || !Number.isFinite(a)) &&
      Math.abs(o - a) > 1e-6 * Math.max(1, Math.abs(o), Math.abs(a))
    )
      return { at: Ky(s) };
  }
  return null;
}
function Ky(e) {
  return Object.entries(e)
    .map(([n, t]) => `${n} = ${oe('k' in t ? t : T(t))}`)
    .join(', ');
}
function AF(e, n, t) {
  let r = Z(n, { sorts: t.sorts });
  if (!r.ok) return null;
  let s = _n(r.rf);
  if (!s || s.d === 1n) return null;
  let i = UC(s);
  if (i === null) return null;
  let o = Z(e, { sorts: t.sorts });
  if (!o.ok || _n(o.rf) !== null) return null;
  let a = GC(o.rf),
    l = null,
    u = 'exact';
  if (a) l = qf(a, s, i);
  else {
    let f = Dt(o.rf.n) / Dt(o.rf.d);
    if (!Number.isFinite(f)) return null;
    let d = 0.5 * 10 ** -i,
      m = Math.abs(f - en(s));
    if (Math.abs(m - d) < 1e-12) return null;
    ((l = m < d), (u = 'sampled'));
  }
  let c = t.approximation?.places;
  return l && c !== void 0 && i >= c
    ? Bn('approximation', 'approximation', { places: String(i) }, u)
    : l
      ? St('approximation_not_exact', { places: String(i) }, u)
      : St('bad_approximation', { places: String(i) }, u);
}
function UC(e) {
  let n = e.d,
    t = 0,
    r = 0;
  for (; n % 2n === 0n; ) ((n /= 2n), t++);
  for (; n % 5n === 0n; ) ((n /= 5n), r++);
  return n === 1n ? Math.max(t, r) : null;
}
function GC(e) {
  let n = je(e.d);
  if (n === null) return null;
  let t = [...e.n.t.values()];
  if (t.length !== 1 || t[0].m.length !== 1) return null;
  let r = t[0].m[0];
  return r.a.kind !== 'root' || r.e !== 1 ? null : iy(A(t[0].c, n), BigInt(r.a.prime));
}
function Uf(e, n, t, r) {
  let s = r.sorts ?? {},
    i = Z(t, { sorts: s }),
    o = i.ok ? _n(i.rf) : null,
    a = o ? UC(o) : null;
  if (!o || a === null) return sp('approximation_not_decimal');
  let l = Math.max(a, r.approximation?.places ?? 0),
    u = jF(e, n, r);
  if (!u?.length) return mr('no_exact_value');
  let c = u.map((p) => QC(p, o, l, s));
  if (c.some((p) => p === null)) return mr('approximation_undecided');
  let f = c,
    d = f.some((p) => p.proof === 'sampled') ? 'sampled' : 'exact',
    m = { places: String(l) };
  return f.every((p) => p.kind === 'rounds')
    ? Bn('approximation', 'approximation', m, d)
    : f.some((p) => p.kind === 'rounds')
      ? mr('several_values')
      : a < l && u.map((g) => QC(g, o, a, s)).every((g) => g?.kind === 'rounds')
        ? St('approximation_too_coarse', { places: String(a), wanted: String(l) }, d)
        : f.every((p) => p.kind === 'truncates')
          ? St('truncated', m, d)
          : St('bad_approximation', m, d);
}
function jF(e, n, t) {
  let r = t.sorts ?? {};
  if (Dn({ k: 'expr', e: n }).size === 0) return [n];
  if (n.k !== 'sym' || !e) return null;
  let s = n.n,
    i = [];
  for (let u of Py(e)) {
    if (u.rel !== '=') return null;
    let c = Z(ve(u.l, u.r), { sorts: r });
    if (!c.ok) return null;
    let f = new Set([...Lt(c.rf.n), ...Lt(c.rf.d)]);
    if (f.size !== 1 || !f.has(s)) return null;
    let d = Bt(c.rf, s);
    if (!d?.complete) return null;
    i.push(...d.roots);
  }
  let o = ji([], r),
    a = (t.hypotheses ?? []).filter((u) => {
      let c = u.of.length === 1 ? ie(u.of[0]) : null;
      return !!c?.ok && c.s.k === 'expr' && c.s.e.k === 'sym' && c.s.e.n === s;
    }),
    l = [];
  for (let u of i)
    a.some((c) => tr(Wr(c.kind, u), o) === 'false') ||
      l.some((c) => qn(c, u, { sorts: r }) === 'equal') ||
      l.push(u);
  return l;
}
function QC(e, n, t, r) {
  let s = Z(e, { sorts: r });
  if (!s.ok) return null;
  let i = _n(s.rf),
    o = i ? null : GC(s.rf),
    a = i ? en(i) : Dt(s.rf.n) / Dt(s.rf.d);
  if (!Number.isFinite(a)) return null;
  let l = !!(i || o),
    u = (b) => {
      if (i) return Re(i, b);
      if (o) return Bh(o, b);
      let v = a - en(b);
      return Math.abs(v) < 1e-12 * Math.max(1, Math.abs(a)) ? null : v > 0 ? 1 : -1;
    },
    c = C(1n, 10n ** BigInt(t)),
    f = C(1n, 2n * 10n ** BigInt(t)),
    d = u(me(n, f)),
    m = u(re(n, f));
  if (d === null || m === null) return null;
  let p = l ? 'exact' : 'sampled';
  if (d >= 0 && m <= 0) return { kind: 'rounds', proof: p };
  let g = u(F);
  return g === null
    ? null
    : {
        kind: (g >= 0 ? u(n) !== -1 && u(re(n, c)) === -1 : u(n) !== 1 && u(me(n, c)) === 1)
          ? 'truncates'
          : 'wrong',
        proof: p,
      };
}
var Py = (e) => on(e);
function FC(e, n, t) {
  let r;
  try {
    r = Ge(j(ve(e.l, e.r), n), { sorts: t.sorts });
  } catch (i) {
    if (i instanceof sn)
      return i.code === 'division_by_zero' || i.code === 'undefined_value' ? !1 : null;
    throw i;
  }
  for (let i of [e.l, e.r]) {
    let o = Z(j(i, n), { sorts: t.sorts });
    if (!o.ok) return o.code === 'too_big' ? null : !1;
  }
  if (Wh(r.n) || Wh(r.d)) return null;
  let s = ZC(r);
  if (s === null) return null;
  switch (e.rel) {
    case '=':
      return s === 0;
    case '<':
      return s < 0;
    case '>':
      return s > 0;
    case '\u2264':
      return s <= 0;
    case '\u2265':
      return s >= 0;
  }
}
function ZC(e) {
  if (Ue(e.n)) return 0;
  let n = _n(e);
  if (n) return te(n);
  if (!an(e.n) || !an(e.d)) return null;
  let t = Dt(e.n) / Dt(e.d);
  return !Number.isFinite(t) || Math.abs(t) < 1e-9 ? null : t > 0 ? 1 : -1;
}
function vb(e, n, t) {
  if (e.k === 'set') {
    let s = !1;
    for (let i of e.clauses) {
      let o = !0;
      for (let a of i) {
        let l = FC(a, n, t);
        if (l === !1) {
          o = !1;
          break;
        }
        l === null && (o = null);
      }
      if (o === !0) return !0;
      o === null && (s = !0);
    }
    return s ? null : !1;
  }
  let r = !1;
  for (let s of Py(e)) {
    let i = FC(s, n, t);
    if (i === !0) return !0;
    i === null && (r = !0);
  }
  return r ? null : !1;
}
function HC(e, n, t) {
  let r = [...new Set([...Dn(e), ...Dn(n)])];
  if (t.trig && !Object.keys(t.angles).length) {
    let o = FF(e, n, r, t);
    if (o) return o;
    if (t.trig.domain) return mr('no_proof');
  }
  if (r.length === 0) return VF(e, n, t);
  if (r.length === 1) {
    let o = t.angles[r[0]];
    if (o) {
      let l = RF(e, n, r[0], o, t);
      if (l) return l;
    }
    let a = WC(e, n, r[0], t);
    if (a) return a;
  }
  let s = QF(e, n, t);
  if (s) return s;
  if (e.k === 'rel' && n.k === 'rel') {
    let o = zF(e, n, t);
    if (o) return o;
  }
  let i = bb(e, n, r, t);
  return i ? St('counterexample', { at: i }) : mr('no_proof');
}
function QF(e, n, t) {
  if (e.k !== 'rel' || n.k !== 'rel' || e.rel !== n.rel) return null;
  let r = { sorts: t.sorts };
  for (let s of [e.l, e.r, n.l, n.r]) {
    let i = Z(s, r);
    if (!i.ok || (je(i.rf.d) === null && N$(i.rf.d, t.facts) !== 'true')) return null;
  }
  return qn(e.l, n.l, r) === 'equal' && qn(e.r, n.r, r) === 'equal'
    ? Bn('equivalent', 'equivalent')
    : null;
}
function FF(e, n, t, r) {
  let s = r.goal?.target;
  if (!s || !t.includes(s)) return null;
  let i = new Set(t.filter((u) => u !== s));
  if ([...i].some((u) => !r.facts.integer.has(u))) return null;
  let o = r.trig?.domain ? ib(r.trig.domain, s, r.sorts) : null;
  if (r.trig?.domain && !o) return null;
  let a = U$(e, n, s, i, o, r.sorts);
  if (!a) return null;
  if (a.kind === 'equal') return Bn('equivalent', 'equivalent');
  let l = { at: G$(s, a.at) };
  return a.kind === 'extra'
    ? Bn('implies', 'extra_solutions', l)
    : St(a.kind === 'lost' ? 'lost_solution' : 'counterexample', l);
}
function VF(e, n, t) {
  let r = vb(e, {}, t),
    s = vb(n, {}, t);
  return r === null || s === null
    ? mr('no_proof')
    : r && !s
      ? St('false_statement')
      : r && s
        ? Bn('equivalent', 'equivalent')
        : s
          ? Bn('implies', 'vacuous')
          : Bn('equivalent', 'equivalent');
}
function VC(e, n, t) {
  let r = [],
    s = !0;
  for (let i of Py(e)) {
    let o = Z(ve(i.l, i.r), { sorts: t.sorts });
    if (!o.ok) return null;
    for (let a of [o.rf.n, o.rf.d]) {
      if (an(a)) continue;
      let l = Bt({ n: a, d: kb }, n);
      if (!l) return null;
      s &&= l.complete;
      for (let u of l.roots) r.push({ t: u, v: D(u, {}) });
    }
    for (let a of [i.l, i.r]) r.push(...DF(a, n, t));
  }
  return { pts: r, complete: s };
}
function DF(e, n, t) {
  let r = [],
    s = (i) => {
      switch (i.k) {
        case 'add':
        case 'mul':
          i.c.forEach(s);
          return;
        case 'div':
        case 'pow':
        case 'binom':
          (s(i.a), s(i.b));
          return;
        case 'fn': {
          if ((s(i.a), (i.f !== 'sqrt' && i.f !== 'ln') || !$(i.a).has(n))) return;
          let o = Z(i.a, { sorts: t.sorts });
          if (!o.ok || an(o.rf.n)) return;
          Bt({ n: o.rf.n, d: kb }, n)?.roots.forEach((l) => r.push({ t: l, v: D(l, {}) }));
          return;
        }
        default:
          return;
      }
    };
  return (s(e), r);
}
var kb = { t: new Map([['', { m: [], c: q }]]) };
function Ly(e, n, t) {
  if (t) {
    let r = Math.floor(e) + 1;
    return r < n ? C(r) : null;
  }
  if (n - e > 1) {
    let r = Math.floor(e) + 1;
    if (r < n) return C(r);
  }
  for (let r = 2; r <= 4096; r *= 2) {
    let s = Math.floor(e * r) + 1;
    if (s / r < n && s / r > e) return C(s, r);
  }
  return null;
}
function WC(e, n, t, r) {
  let s = VC(e, t, r),
    i = VC(n, t, r);
  if (!s || !i) return null;
  let o = s.complete && i.complete,
    a = [];
  for (let m of [...s.pts, ...i.pts]) {
    if (!Number.isFinite(m.v)) return null;
    if (!a.some((p) => Math.abs(p.v - m.v) < 1e-12 && qn(p.t, m.t) === 'equal')) {
      if (a.some((p) => Math.abs(p.v - m.v) < 1e-9)) return null;
      a.push(m);
    }
  }
  a.sort((m, p) => m.v - p.v);
  let l = r.facts.integer.has(t),
    u = [],
    c = (m) => {
      m && u.push(T(m));
    };
  if (!a.length) [0, 1, -1].forEach((m) => u.push(T(m)));
  else {
    c(Ly(a[0].v - 2, a[0].v, l));
    for (let m = 0; m < a.length; m++)
      (u.push(a[m].t), m + 1 < a.length && c(Ly(a[m].v, a[m + 1].v, l)));
    c(Ly(a[a.length - 1].v, a[a.length - 1].v + 2, l));
  }
  let f = !1,
    d = null;
  for (let m of u) {
    if (!BF(t, m, r)) continue;
    let p = { [t]: m },
      g = vb(e, p, r),
      h = vb(n, p, r);
    if (g === null || h === null) {
      f = !0;
      continue;
    }
    if (g && !h)
      return St(
        e.k === 'or' || (e.k === 'rel' && e.rel === '=') ? 'lost_solution' : 'counterexample',
        { at: `${t} = ${oe(R(m))}` },
      );
    h && !g && (d ??= m);
  }
  return !o || f
    ? null
    : d
      ? Bn('implies', 'extra_solutions', { at: `${t} = ${oe(R(d))}` })
      : Bn('equivalent', 'equivalent');
}
function BF(e, n, t) {
  let r = D(n, {}),
    s = t.facts.sign.get(e);
  if (s) {
    let i = Math.abs(r) < 1e-12 ? 0 : r > 0 ? 1 : -1;
    if ((i > 0 && !s.pos) || (i < 0 && !s.neg) || (i === 0 && !s.zero)) return !1;
  }
  if (t.facts.integer.has(e)) {
    let i = Z(n),
      o = i.ok ? _n(i.rf) : null;
    if (!o || !B(o)) return !1;
  }
  for (let i of t.facts.polys) {
    let o;
    try {
      o = Ge(j(kn(i.p), { [e]: n }));
    } catch {
      return !1;
    }
    let a = ZC(o);
    if (a !== null && ((a > 0 && !i.s.pos) || (a < 0 && !i.s.neg) || (a === 0 && !i.s.zero)))
      return !1;
  }
  return !0;
}
function DC(e, n) {
  let [t, r, s] =
      e.rel === '>'
        ? [e.r, e.l, '<']
        : e.rel === '\u2265'
          ? [e.r, e.l, '\u2264']
          : [e.l, e.r, e.rel],
    i = Z(ve(r, t), { sorts: n.sorts });
  return i.ok ? { p: i.rf.n, d: i.rf.d, rel: s } : null;
}
function zF(e, n, t) {
  let r = DC(e, t),
    s = DC(n, t);
  if (!r || !s || (r.rel === '=') != (s.rel === '=')) return null;
  if (r.rel === '=') {
    let m = Tr(r.d, s.d),
      h = (m !== null && an(m) ? [] : [r.d, s.d])
        .filter((y) => je(y) === null)
        .map((y) => Wr('nonzero', kn(y)))
        .filter((y, S, w) => w.findIndex((_) => _.of[0] === y.of[0]) === S)
        .filter((y) => tr(y, t.facts) !== 'true'),
      b = (y) =>
        h.length && y.status === 'valid' ? { ...y, status: 'conditional', conditions: h } : y;
    if (Ue(s.p)) return Ue(r.p) ? b(Bn('equivalent', 'equivalent')) : null;
    if (Ue(r.p)) return null;
    let v = Tr(r.p, s.p);
    if (v) {
      if (an(v)) return b(Bn('equivalent', 'equivalent'));
      let y = Wr('nonzero', kn(v));
      if (tr(y, t.facts) === 'true') return b(Bn('equivalent', 'equivalent'));
      let w = bb(e, n, [...Lt(r.p), ...Lt(s.p)], t);
      return w
        ? St('lost_solution', { at: w })
        : {
            ...Bn('equivalent', 'equivalent'),
            status: 'conditional',
            conditions: [y, ...h].filter(
              (_, O, G) => G.findIndex((Se) => Se.kind === _.kind && Se.of[0] === _.of[0]) === O,
            ),
          };
    }
    let k = Tr(s.p, r.p);
    if (k && !an(k)) {
      let y = Wr('nonzero', kn(k));
      return tr(y, t.facts) === 'true'
        ? b(Bn('equivalent', 'equivalent'))
        : b(Bn('implies', 'may_add_solutions'));
    }
    return null;
  }
  let i = je(r.d),
    o = je(s.d);
  if (i === null || o === null) return null;
  let a = lt(r.p, C(te(i))),
    l = lt(s.p, C(te(o)));
  if (Ue(a) || Ue(l)) return null;
  let u = Tr(a, l);
  if (!u) return null;
  let c = kn(u),
    f = UF(u, t);
  if (f === 0) return t.branches ? zC(Wr('positive', c), e, n, t) : null;
  if (f < 0) {
    let m = bb(e, n, [...Lt(a), ...Lt(l)], t);
    return m ? St('sign_not_flipped', { at: m, factor: zf(oe(c)) }) : null;
  }
  if (r.rel === s.rel) return Bn('equivalent', 'equivalent');
  if (r.rel === '<' && s.rel === '\u2264') return Bn('implies', 'weakened');
  let d = bb(e, n, [...Lt(a), ...Lt(l)], t);
  return d ? St('counterexample', { at: d }) : null;
}
function UF(e, n) {
  return tr(Wr('positive', kn(e)), n.facts) === 'true'
    ? 1
    : tr(Wr('negative', kn(e)), n.facts) === 'true'
      ? -1
      : 0;
}
function bb(e, n, t, r) {
  let s = [...new Set(t)].sort(),
    i = r.goal?.target,
    o = [...Dn(e)].sort(),
    a = [...new Set([...o, ...s])].filter((u) => s.includes(u)),
    l = (i && s.includes(i) ? [i, ...a.filter((u) => u !== i)] : a).slice(0, 4);
  for (let u of l) {
    let c = s.filter((f) => f !== u);
    for (let f of Yh(c, r.facts, `${_t(e)}|${u}`, 6)) {
      if (r.now() > r.deadline) return null;
      let d = {};
      for (let [b, v] of Object.entries(f)) d[b] = T(v);
      let m = Mt(e, (b) => j(b, d)),
        p = Mt(n, (b) => j(b, d)),
        g = { ...r, branches: !1 },
        h = WC(m, p, u, g);
      if (h?.status === 'invalid') {
        let b = h.explanation?.params?.at ?? '';
        return [Ky(f), b].filter(Boolean).join(', ');
      }
    }
  }
  return null;
}
function BC(e, n) {
  return e.map((t) => n[0].map((r, s) => t.reduce((i, o, a) => re(i, N(o, n[a][s])), F)));
}
function GF(e, n) {
  return e.map((t, r) => t.map((s, i) => re(s, n[r][i])));
}
var ap = (e, n) =>
  Array.from({ length: n }, (t, r) => Array.from({ length: n }, (s, i) => (r === i ? e : F)));
function lp(e, n, t) {
  switch (e.k) {
    case 'num':
      return ap(e.v, t);
    case 'sym':
      return n[e.n] ?? null;
    case 'add': {
      let r = ap(F, t);
      for (let s of e.c) {
        let i = lp(s, n, t);
        if (!i || !r) return null;
        r = GF(r, i);
      }
      return r;
    }
    case 'mul': {
      let r = ap(q, t);
      for (let s of e.c) {
        let i = lp(s, n, t);
        if (!i || !r) return null;
        r = BC(r, i);
      }
      return r;
    }
    case 'pow': {
      if (e.b.k !== 'num' || !B(e.b.v) || e.b.v.n < 0n || e.b.v.n > 16n) return null;
      let r = lp(e.a, n, t);
      if (!r) return null;
      let s = ap(q, t);
      for (let i = 0n; i < e.b.v.n; i++) s = BC(s, r);
      return s;
    }
    default:
      return null;
  }
}
function ZF(e, n, t) {
  if (e.k !== 'expr' || n.k !== 'expr') return sp('matrix_relation');
  if (za(e.e, n.e, t.sorts)) return Bn('identity', 'identity');
  let r = [...Dn(e), ...Dn(n)],
    s = [
      [
        [1, 2],
        [0, 1],
      ],
      [
        [0, 1],
        [1, 0],
      ],
      [
        [2, 0],
        [1, 3],
      ],
      [
        [1, -1],
        [2, 0],
      ],
    ].map((u) => u.map((c) => c.map((f) => C(f)))),
    i = {};
  [...new Set(r)].sort().forEach((u, c) => {
    i[u] = t.sorts[u] === 'matrix' ? s[c % s.length] : ap(C(c + 2), 2);
  });
  let o = lp(e.e, i, 2),
    a = lp(n.e, i, 2);
  return !o || !a
    ? mr('no_proof')
    : o.some((u, c) => u.some((f, d) => !M(f, a[c][d])))
      ? St('not_commutative', { at: 'matrices 2 \xD7 2' })
      : mr('no_proof');
}
var JC = {
  id: 'algebra-core',
  version: 1,
  schema: 1,
  label: 'Calcul litt\xE9ral : d\xE9velopper, factoriser, r\xE9duire',
  rules: [
    {
      id: 'algebra.distribute',
      version: 1,
      kind: 'identity',
      vars: { k: 'real', a: 'real', b: 'real' },
      forms: { factored: '?k \xD7 (?a + ?b)', expanded: '?k \xD7 ?a + ?k \xD7 ?b' },
      directions: [
        { from: 'factored', to: 'expanded', goals: ['expand', 'simplify', 'solve'] },
        { from: 'expanded', to: 'factored', goals: ['factor', 'solve'] },
      ],
      cost: 1,
      label: 'Distributivit\xE9 : k(a + b) = ka + kb',
      ref: 'distributivit\xE9 simple',
      levels: ['5e', '4e', '3e', '2nde'],
      examples: [
        { from: '3(x + 1)', to: '3x + 3', expect: 'valid' },
        { from: '\u22124(3 \u2212 2x)', to: '\u221212 + 8x', expect: 'valid' },
        { from: '6x + 4', to: '2(3x + 2)', expect: 'valid' },
        { from: '3(x + 1)', to: '3x + 1', expect: 'invalid' },
      ],
    },
    {
      id: 'algebra.distribute_three',
      version: 1,
      kind: 'identity',
      vars: { k: 'real', a: 'real', b: 'real', c: 'real' },
      forms: {
        factored: '?k \xD7 (?a + ?b + ?c)',
        expanded: '?k \xD7 ?a + ?k \xD7 ?b + ?k \xD7 ?c',
      },
      directions: [
        { from: 'factored', to: 'expanded', goals: ['expand', 'simplify'] },
        { from: 'expanded', to: 'factored', goals: ['factor'] },
      ],
      cost: 1,
      label: 'Distributivit\xE9 : k(a + b + c) = ka + kb + kc',
      ref: 'distributivit\xE9 simple',
      levels: ['5e', '4e', '3e'],
      examples: [
        { from: '2(x + y + 1)', to: '2x + 2y + 2', expect: 'valid' },
        { from: '2(x + y + 1)', to: '2x + y + 2', expect: 'invalid' },
      ],
    },
    {
      id: 'algebra.double_distribute',
      version: 1,
      kind: 'identity',
      vars: { a: 'real', b: 'real', c: 'real', d: 'real' },
      forms: {
        factored: '(?a + ?b)(?c + ?d)',
        expanded: '?a \xD7 ?c + ?a \xD7 ?d + ?b \xD7 ?c + ?b \xD7 ?d',
      },
      directions: [{ from: 'factored', to: 'expanded', goals: ['expand', 'simplify'] }],
      cost: 2,
      label: 'Double distributivit\xE9 : (a + b)(c + d) = ac + ad + bc + bd',
      ref: 'double distributivit\xE9',
      levels: ['4e', '3e', '2nde'],
      examples: [
        { from: '(x + 2)(x + 3)', to: 'x\xB2 + 3x + 2x + 6', expect: 'valid' },
        { from: '(x + 2)(x + 3)', to: 'x\xB2 + 6', expect: 'invalid' },
      ],
    },
    {
      id: 'algebra.difference_of_squares',
      version: 1,
      kind: 'identity',
      vars: { a: 'real', b: 'real' },
      forms: { diff: '?a\xB2 \u2212 ?b\xB2', prod: '(?a \u2212 ?b)(?a + ?b)' },
      directions: [
        { from: 'diff', to: 'prod', goals: ['factor', 'solve'] },
        { from: 'prod', to: 'diff', goals: ['expand', 'simplify'] },
      ],
      cost: 2,
      label: 'a\xB2 \u2212 b\xB2 = (a \u2212 b)(a + b)',
      ref: 'identit\xE9 remarquable',
      levels: ['3e', '2nde'],
      examples: [
        { from: 'x\xB2 \u2212 9', to: '(x \u2212 3)(x + 3)', expect: 'valid' },
        { from: '4x\xB2 \u2212 25', to: '(2x \u2212 5)(2x + 5)', expect: 'valid' },
        { from: 'x\xB2 + 9', to: '(x \u2212 3)(x + 3)', expect: 'invalid' },
      ],
    },
    {
      id: 'algebra.square_of_difference',
      version: 1,
      kind: 'identity',
      vars: { a: 'real', b: 'real' },
      forms: { square: '(?a \u2212 ?b)\xB2', expanded: '?a\xB2 \u2212 2 \xD7 ?a \xD7 ?b + ?b\xB2' },
      directions: [
        { from: 'square', to: 'expanded', goals: ['expand', 'simplify'] },
        { from: 'expanded', to: 'square', goals: ['factor', 'solve'] },
      ],
      cost: 2,
      label: '(a \u2212 b)\xB2 = a\xB2 \u2212 2ab + b\xB2',
      ref: 'identit\xE9 remarquable',
      levels: ['3e', '2nde'],
      examples: [
        { from: '(x \u2212 3)\xB2', to: 'x\xB2 \u2212 6x + 9', expect: 'valid' },
        { from: '(x \u2212 3)\xB2', to: 'x\xB2 \u2212 9', expect: 'invalid' },
      ],
    },
    {
      id: 'algebra.square_of_sum',
      version: 1,
      kind: 'identity',
      vars: { a: 'real', b: 'real' },
      forms: { square: '(?a + ?b)\xB2', expanded: '?a\xB2 + 2 \xD7 ?a \xD7 ?b + ?b\xB2' },
      directions: [
        { from: 'square', to: 'expanded', goals: ['expand', 'simplify'] },
        { from: 'expanded', to: 'square', goals: ['factor', 'solve'] },
      ],
      cost: 2,
      label: '(a + b)\xB2 = a\xB2 + 2ab + b\xB2',
      ref: 'identit\xE9 remarquable',
      levels: ['3e', '2nde'],
      examples: [
        { from: '(x + 3)\xB2', to: 'x\xB2 + 6x + 9', expect: 'valid' },
        { from: '(x + 3)\xB2', to: 'x\xB2 + 9', expect: 'invalid' },
      ],
    },
    {
      id: 'algebra.fraction_same_denominator',
      version: 1,
      kind: 'identity',
      vars: { a: 'real', b: 'real', c: 'real' },
      forms: { split: '?a \xF7 ?c + ?b \xF7 ?c', joined: '(?a + ?b) \xF7 ?c' },
      directions: [
        { from: 'split', to: 'joined', goals: ['simplify', 'compute'] },
        { from: 'joined', to: 'split', goals: ['expand'] },
      ],
      cost: 1,
      label: 'M\xEAme d\xE9nominateur : a/c + b/c = (a + b)/c',
      ref: 'somme de fractions',
      levels: ['5e', '4e', '3e'],
      examples: [
        { from: 'x \xF7 3 + 2 \xF7 3', to: '(x + 2) \xF7 3', expect: 'valid' },
        { from: 'x \xF7 3 + 2 \xF7 3', to: '(x + 2) \xF7 6', expect: 'invalid' },
      ],
    },
    {
      id: 'algebra.fraction_product',
      version: 1,
      kind: 'identity',
      vars: { a: 'real', b: 'real', c: 'real', d: 'real' },
      forms: { split: '(?a \xF7 ?b) \xD7 (?c \xF7 ?d)', joined: '(?a \xD7 ?c) \xF7 (?b \xD7 ?d)' },
      directions: [{ from: 'split', to: 'joined', goals: ['simplify', 'compute'] }],
      cost: 1,
      label: 'Produit de fractions : (a/b)(c/d) = ac/bd',
      ref: 'produit de fractions',
      levels: ['4e', '3e'],
      examples: [
        { from: '(x \xF7 2) \xD7 (y \xF7 5)', to: '(x \xD7 y) \xF7 10', expect: 'valid' },
        { from: '(x \xF7 2) \xD7 (y \xF7 5)', to: '(x \xD7 y) \xF7 7', expect: 'invalid' },
      ],
    },
    {
      id: 'algebra.simplify_fraction',
      version: 1,
      kind: 'identity',
      vars: { k: 'real', a: 'real', b: 'real' },
      forms: { long: '(?k \xD7 ?a) \xF7 (?k \xD7 ?b)', short: '?a \xF7 ?b' },
      directions: [{ from: 'long', to: 'short', goals: ['simplify'] }],
      preconditions: [{ nonzero: '?k' }],
      on_unknown: 'conditional',
      cost: 1,
      label: 'Simplifier une fraction par un facteur commun non nul',
      ref: 'simplification de fraction',
      levels: ['4e', '3e', '2nde'],
      examples: [
        { from: '(2x) \xF7 (2y)', to: 'x \xF7 y', expect: 'valid' },
        {
          from: '(a \xD7 x) \xF7 (a \xD7 y)',
          to: 'x \xF7 y',
          assume: [{ nonzero: 'a' }],
          expect: 'valid',
        },
        { from: '(2x) \xF7 (2y)', to: 'x \xF7 (2y)', expect: 'invalid' },
      ],
    },
    {
      id: 'algebra.opposite',
      version: 1,
      kind: 'identity',
      vars: { a: 'real' },
      forms: { diff: '?a \u2212 ?a', zero: '0' },
      directions: [{ from: 'diff', to: 'zero', goals: ['simplify', 'compute'] }],
      cost: 0,
      label: 'Un nombre moins lui-m\xEAme vaut 0',
      ref: 'oppos\xE9',
      levels: ['5e', '4e'],
      examples: [
        { from: '3x \u2212 3x', to: '0', expect: 'valid' },
        { from: '3x \u2212 3x', to: '3x', expect: 'invalid' },
      ],
    },
  ],
};
var XC = {
  id: 'condition-core',
  version: 1,
  schema: 1,
  label:
    "Conditions : une racine carr\xE9e face \xE0 un nombre positif, la condition d'existence \xE9crite (moteur v49)",
  rules: [
    {
      id: 'condition.sqrt_below',
      version: 1,
      kind: 'equivalence',
      applies_to: 'inequality',
      vars: { a: 'real', b: 'real' },
      forms: { before: '\u221A(?a) < ?b', after: '?a < ?b\xB2' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      preconditions: [{ nonnegative: '?a' }, { nonnegative: '?b' }],
      on_unknown: 'conditional',
      cost: 1,
      label:
        'x \u21A6 x\xB2 est croissante sur [0 ; +\u221E[ : \u221Aa < b, avec a \u2265 0 et b \u2265 0, \xE9quivaut \xE0 a < b\xB2',
      ref: 'fonction carr\xE9 croissante sur [0 ; +\u221E[',
      levels: ['2nde', '1re', 'tle'],
      examples: [
        { from: '\u221A(x) < 3', to: 'x < 9', assume: [{ nonnegative: 'x' }], expect: 'valid' },
        {
          from: '\u221A(x) \u2264 3',
          to: 'x \u2264 9',
          assume: [{ nonnegative: 'x' }],
          expect: 'valid',
        },
        { from: '\u221A(x) < 3', to: 'x < 3', assume: [{ nonnegative: 'x' }], expect: 'invalid' },
      ],
    },
  ],
};
var YC = {
  id: 'counting-core',
  version: 1,
  schema: 1,
  label: 'D\xE9nombrement : factorielles et \xAB k parmi n \xBB',
  rules: [
    {
      id: 'counting.binom_def',
      version: 1,
      kind: 'identity',
      vars: { k: 'natural', n: 'natural' },
      forms: { binom: '?k parmi ?n', fact: '?n! \xF7 (?k! \xD7 (?n \u2212 ?k)!)' },
      directions: [
        { from: 'binom', to: 'fact', goals: ['simplify', 'compute', 'solve'] },
        { from: 'fact', to: 'binom', goals: ['simplify'] },
      ],
      cost: 1,
      label: 'k parmi n = n! \xF7 (k! \xD7 (n \u2212 k)!)',
      ref: 'coefficient binomial',
      levels: ['tle', 'mpsi', 'ptsi'],
      examples: [
        {
          from: 'k parmi n',
          to: 'n! \xF7 (k! \xD7 (n \u2212 k)!)',
          expect: 'valid',
          assume: [{ natural: 'k' }, { natural: 'n' }],
        },
        {
          from: '2 parmi n',
          to: 'n! \xF7 (2! \xD7 (n \u2212 2)!)',
          expect: 'valid',
          assume: [{ natural: 'n' }],
        },
        {
          from: 'n! \xF7 (p! \xD7 (n \u2212 p)!)',
          to: 'p parmi n',
          expect: 'valid',
          assume: [{ natural: 'n' }, { natural: 'p' }],
        },
        {
          from: 'k parmi n',
          to: 'n! \xF7 (n \u2212 k)!',
          expect: 'invalid',
          assume: [{ natural: 'k' }, { natural: 'n' }],
        },
      ],
    },
    {
      id: 'counting.binom_two',
      version: 1,
      kind: 'identity',
      vars: { n: 'natural' },
      forms: { binom: '2 parmi ?n', product: '?n \xD7 (?n \u2212 1) \xF7 2' },
      directions: [
        { from: 'binom', to: 'product', goals: ['simplify', 'compute', 'solve'] },
        { from: 'product', to: 'binom', goals: ['simplify'] },
      ],
      cost: 1,
      label: '2 parmi n = n(n \u2212 1) \xF7 2',
      ref: 'nombre de paires',
      levels: ['tle', 'mpsi', 'ptsi'],
      examples: [
        {
          from: '2 parmi n',
          to: 'n(n \u2212 1) \xF7 2',
          expect: 'valid',
          assume: [{ natural: 'n' }],
        },
        {
          from: '2 parmi (n + 1)',
          to: '(n + 1)n \xF7 2',
          expect: 'valid',
          assume: [{ natural: 'n' }],
        },
        { from: '2 parmi n', to: 'n(n \u2212 1)', expect: 'invalid', assume: [{ natural: 'n' }] },
      ],
    },
    {
      id: 'counting.symmetry',
      version: 1,
      kind: 'identity',
      vars: { k: 'natural', n: 'natural' },
      forms: { left: '?k parmi ?n', right: '(?n \u2212 ?k) parmi ?n' },
      directions: [{ from: 'left', to: 'right', goals: ['simplify'] }],
      cost: 1,
      label: 'Sym\xE9trie : k parmi n = (n \u2212 k) parmi n',
      ref: "choisir k \xE9l\xE9ments, c'est choisir les n \u2212 k exclus",
      levels: ['tle', 'mpsi', 'ptsi'],
      examples: [
        {
          from: 'k parmi n',
          to: '(n \u2212 k) parmi n',
          expect: 'valid',
          assume: [{ natural: 'k' }, { natural: 'n' }],
        },
        {
          from: 'p parmi n',
          to: '(n \u2212 p) parmi n',
          expect: 'valid',
          assume: [{ natural: 'n' }, { natural: 'p' }],
        },
        {
          from: 'k parmi n',
          to: '(n \u2212 k) parmi k',
          expect: 'invalid',
          assume: [{ natural: 'k' }, { natural: 'n' }],
        },
      ],
    },
    {
      id: 'counting.pascal',
      version: 1,
      kind: 'identity',
      vars: { k: 'natural', n: 'natural' },
      forms: { split: '?k parmi ?n + (?k + 1) parmi ?n', joined: '(?k + 1) parmi (?n + 1)' },
      directions: [
        { from: 'split', to: 'joined', goals: ['simplify'] },
        { from: 'joined', to: 'split', goals: ['expand'] },
      ],
      cost: 1,
      label: 'Pascal : k parmi n + (k + 1) parmi n = (k + 1) parmi (n + 1)',
      ref: 'relation de Pascal',
      levels: ['tle', 'mpsi', 'ptsi'],
      examples: [
        {
          from: 'k parmi n + (k + 1) parmi n',
          to: '(k + 1) parmi (n + 1)',
          expect: 'valid',
          assume: [{ natural: 'k' }, { natural: 'n' }],
        },
        {
          from: 'p parmi m + (p + 1) parmi m',
          to: '(p + 1) parmi (m + 1)',
          expect: 'valid',
          assume: [{ natural: 'm' }, { natural: 'p' }],
        },
        {
          from: 'k parmi n + (k + 1) parmi n',
          to: '(k + 1) parmi n',
          expect: 'invalid',
          assume: [{ natural: 'k' }, { natural: 'n' }],
        },
      ],
    },
    {
      id: 'counting.pascal_down',
      version: 1,
      kind: 'identity',
      vars: { k: 'natural', n: 'natural' },
      forms: {
        split: '(?k \u2212 1) parmi (?n \u2212 1) + ?k parmi (?n \u2212 1)',
        joined: '?k parmi ?n',
      },
      directions: [
        { from: 'split', to: 'joined', goals: ['simplify'] },
        { from: 'joined', to: 'split', goals: ['expand'] },
      ],
      cost: 1,
      label: 'Pascal : (k \u2212 1) parmi (n \u2212 1) + k parmi (n \u2212 1) = k parmi n',
      ref: 'relation de Pascal',
      levels: ['tle', 'mpsi', 'ptsi'],
      examples: [
        {
          from: '(k \u2212 1) parmi (n \u2212 1) + k parmi (n \u2212 1)',
          to: 'k parmi n',
          expect: 'valid',
          assume: [{ natural: 'k' }, { natural: 'n' }],
        },
        {
          from: 'k parmi n',
          to: '(k \u2212 1) parmi (n \u2212 1) + k parmi (n \u2212 1)',
          expect: 'valid',
          assume: [{ natural: 'k' }, { natural: 'n' }],
        },
        {
          from: '(k \u2212 1) parmi (n \u2212 1) + k parmi (n \u2212 1)',
          to: 'k parmi (n \u2212 1)',
          expect: 'invalid',
          assume: [{ natural: 'k' }, { natural: 'n' }],
        },
      ],
    },
    {
      id: 'counting.fact_rec',
      version: 1,
      kind: 'identity',
      vars: { n: 'natural' },
      forms: { short: '?n!', long: '?n \xD7 (?n \u2212 1)!' },
      directions: [
        { from: 'short', to: 'long', goals: ['simplify', 'compute', 'expand'] },
        { from: 'long', to: 'short', goals: ['simplify'] },
      ],
      cost: 1,
      label: 'n! = n \xD7 (n \u2212 1)!',
      ref: 'factorielle',
      levels: ['tle', 'mpsi', 'ptsi'],
      examples: [
        { from: 'n!', to: 'n \xD7 (n \u2212 1)!', expect: 'valid', assume: [{ natural: 'n' }] },
        { from: '(n + 1)!', to: '(n + 1) \xD7 n!', expect: 'valid', assume: [{ natural: 'n' }] },
        { from: '100!', to: '100 \xD7 99!', expect: 'valid', assume: [] },
        { from: 'n!', to: 'n \xD7 n!', expect: 'invalid', assume: [{ natural: 'n' }] },
      ],
    },
  ],
};
var eE = {
  id: 'equation-core',
  version: 1,
  schema: 1,
  label: '\xC9quations : transformer sans changer les solutions',
  rules: [
    {
      id: 'equation.add_both_sides',
      version: 1,
      kind: 'equivalence',
      applies_to: 'equation',
      vars: { u: 'real', v: 'real', c: 'real' },
      forms: { before: '?u = ?v', after: '?u + ?c = ?v + ?c' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      cost: 1,
      label: 'Ajouter (ou retrancher) un m\xEAme terme aux deux membres',
      ref: '\xE9quations \xE9quivalentes',
      levels: ['4e', '3e', '2nde'],
      examples: [
        { from: 'x \u2212 2 = 5', to: 'x = 7', expect: 'valid' },
        { from: '2x \u2212 1 = x + 4', to: 'x \u2212 1 = 4', expect: 'valid' },
        { from: 'x \u2212 2 = 5', to: 'x = 3', expect: 'invalid' },
      ],
    },
    {
      id: 'equation.divide_both_sides',
      version: 1,
      kind: 'equivalence',
      applies_to: 'equation',
      vars: { u: 'real', v: 'real', k: 'real' },
      forms: { before: '?u = ?v', after: '?u \xF7 ?k = ?v \xF7 ?k' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      preconditions: [{ nonzero: '?k' }],
      on_unknown: 'conditional',
      cost: 1,
      label: 'Diviser les deux membres par un m\xEAme nombre non nul',
      ref: '\xE9quations \xE9quivalentes',
      levels: ['4e', '3e', '2nde'],
      examples: [
        { from: '3x = 12', to: 'x = 4', expect: 'valid' },
        { from: 'a \xD7 x = b', to: 'x = b \xF7 a', assume: [{ nonzero: 'a' }], expect: 'valid' },
        { from: '3x = 12', to: 'x = 9', expect: 'invalid' },
      ],
    },
    {
      id: 'equation.multiply_both_sides',
      version: 1,
      kind: 'equivalence',
      applies_to: 'equation',
      vars: { u: 'real', v: 'real', k: 'real' },
      forms: { before: '?u = ?v', after: '?k \xD7 ?u = ?k \xD7 ?v' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      preconditions: [{ nonzero: '?k' }],
      on_unknown: 'conditional',
      cost: 1,
      label: 'Multiplier les deux membres par un m\xEAme nombre non nul',
      ref: '\xE9quations \xE9quivalentes',
      levels: ['4e', '3e', '2nde'],
      examples: [
        { from: 'x \xF7 3 = 2', to: 'x = 6', expect: 'valid' },
        { from: 'x \xF7 3 + 2 = x \xF7 2', to: '2x + 12 = 3x', expect: 'valid' },
        { from: 'x \xF7 3 = 2', to: 'x = 5', expect: 'invalid' },
      ],
    },
    {
      id: 'equation.swap_sides',
      version: 1,
      kind: 'equivalence',
      applies_to: 'equation',
      vars: { u: 'real', v: 'real' },
      forms: { before: '?u = ?v', after: '?v = ?u' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      cost: 0,
      label: '\xC9changer les deux membres',
      ref: "sym\xE9trie de l'\xE9galit\xE9",
      levels: ['5e', '4e', '3e'],
      examples: [
        { from: '12 = 3x', to: '3x = 12', expect: 'valid' },
        { from: '12 = 3x', to: '3x = 13', expect: 'invalid' },
      ],
    },
    {
      id: 'equation.square_both_sides',
      version: 1,
      kind: 'implication',
      applies_to: 'equation',
      vars: { a: 'real', b: 'real' },
      forms: { eq: '?a = ?b', sq: '?a\xB2 = ?b\xB2' },
      directions: [{ from: 'eq', to: 'sq', goals: ['solve'] }],
      cost: 2,
      label: "\xC9lever au carr\xE9 (implication seulement : des solutions peuvent s'ajouter)",
      ref: '\xE9l\xE9vation au carr\xE9',
      levels: ['2nde', '1re'],
      examples: [
        { from: 'x = 3', to: 'x\xB2 = 9', expect: 'valid' },
        { from: 'x = 3', to: 'x\xB2 = 3', expect: 'invalid' },
      ],
    },
  ],
};
var nE = {
  id: 'explog-core',
  version: 1,
  schema: 1,
  label: 'Exponentielle et logarithme : composer sans changer les solutions',
  rules: [
    {
      id: 'explog.exp_equal',
      version: 1,
      kind: 'equivalence',
      applies_to: 'equation',
      vars: { a: 'real', b: 'real' },
      forms: { before: 'exp(?a) = exp(?b)', after: '?a = ?b' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      cost: 1,
      label: 'exp(a) = exp(b) \xE9quivaut \xE0 a = b',
      ref: 'fonction exponentielle strictement croissante',
      levels: ['1re', 'tle'],
      examples: [
        { from: 'exp(2x \u2212 1) = exp(5)', to: '2x \u2212 1 = 5', expect: 'valid' },
        { from: 'exp(3x) = exp(6)', to: '3x = 6', expect: 'valid' },
        { from: 'exp(2x \u2212 1) = exp(5)', to: '2x = 5', expect: 'invalid' },
      ],
    },
    {
      id: 'explog.exp_compare',
      version: 1,
      kind: 'equivalence',
      applies_to: 'inequality',
      vars: { a: 'real', b: 'real' },
      forms: { before: 'exp(?a) < exp(?b)', after: '?a < ?b' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      cost: 1,
      label: 'exp est croissante : exp(a) < exp(b) \xE9quivaut \xE0 a < b',
      ref: 'fonction exponentielle strictement croissante',
      levels: ['1re', 'tle'],
      examples: [
        { from: 'exp(x + 2) < exp(5)', to: 'x + 2 < 5', expect: 'valid' },
        { from: 'exp(2x + 1) \u2264 exp(5)', to: '2x + 1 \u2264 5', expect: 'valid' },
        { from: 'exp(x + 2) < exp(5)', to: 'x + 2 > 5', expect: 'invalid' },
      ],
    },
    {
      id: 'explog.exp_to_ln',
      version: 1,
      kind: 'equivalence',
      applies_to: 'equation',
      vars: { a: 'real', b: 'real' },
      forms: { before: 'exp(?a) = ?b', after: '?a = ln(?b)' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      preconditions: [{ positive: '?b' }],
      on_unknown: 'conditional',
      cost: 1,
      label: 'exp(a) = b, avec b > 0, \xE9quivaut \xE0 a = ln(b)',
      ref: "logarithme n\xE9p\xE9rien, r\xE9ciproque de l'exponentielle",
      levels: ['tle'],
      examples: [
        { from: 'exp(x) = 4', to: 'x = ln(4)', expect: 'valid' },
        { from: 'exp(2x) = 5', to: '2x = ln(5)', expect: 'valid' },
        { from: 'exp(x) = 4', to: 'x = ln(5)', expect: 'invalid' },
      ],
    },
    {
      id: 'explog.exp_to_ln_below',
      version: 1,
      kind: 'equivalence',
      applies_to: 'inequality',
      vars: { a: 'real', b: 'real' },
      forms: { before: 'exp(?a) < ?b', after: '?a < ln(?b)' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      preconditions: [{ positive: '?b' }],
      on_unknown: 'conditional',
      cost: 1,
      label: 'ln est croissante : exp(a) < b, avec b > 0, \xE9quivaut \xE0 a < ln(b)',
      ref: 'logarithme n\xE9p\xE9rien, fonction croissante',
      levels: ['tle'],
      examples: [
        { from: 'exp(x) < 3', to: 'x < ln(3)', expect: 'valid' },
        { from: 'exp(x) \u2264 3', to: 'x \u2264 ln(3)', expect: 'valid' },
        { from: 'exp(x) < 3', to: 'x > ln(3)', expect: 'invalid' },
      ],
    },
    {
      id: 'explog.exp_to_ln_above',
      version: 1,
      kind: 'equivalence',
      applies_to: 'inequality',
      vars: { a: 'real', b: 'real' },
      forms: { before: '?b < exp(?a)', after: 'ln(?b) < ?a' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      preconditions: [{ positive: '?b' }],
      on_unknown: 'conditional',
      cost: 1,
      label: 'ln est croissante : exp(a) > b, avec b > 0, \xE9quivaut \xE0 a > ln(b)',
      ref: 'logarithme n\xE9p\xE9rien, fonction croissante',
      levels: ['tle'],
      examples: [
        { from: 'exp(x) > 5', to: 'x > ln(5)', expect: 'valid' },
        { from: 'exp(x) \u2265 5', to: 'x \u2265 ln(5)', expect: 'valid' },
        { from: 'exp(x) > 5', to: 'x > 5', expect: 'invalid' },
      ],
    },
    {
      id: 'explog.ln_to_exp',
      version: 1,
      kind: 'equivalence',
      applies_to: 'equation',
      vars: { a: 'real', b: 'real' },
      forms: { before: 'ln(?a) = ?b', after: '?a = exp(?b)' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      cost: 1,
      label: 'ln(a) = b \xE9quivaut \xE0 a = exp(b)',
      ref: "logarithme n\xE9p\xE9rien, r\xE9ciproque de l'exponentielle",
      levels: ['tle'],
      examples: [
        { from: 'ln(x) = 3', to: 'x = exp(3)', expect: 'valid' },
        { from: 'ln(2x) = 1', to: '2x = exp(1)', expect: 'valid' },
        { from: 'ln(x) = 3', to: 'x = 3', expect: 'invalid' },
      ],
    },
    {
      id: 'explog.ln_to_exp_below',
      version: 1,
      kind: 'equivalence',
      applies_to: 'inequality',
      vars: { a: 'real', b: 'real' },
      forms: { before: 'ln(?a) < ?b', after: '?a < exp(?b)' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      preconditions: [{ positive: '?a' }],
      on_unknown: 'conditional',
      cost: 1,
      label: 'exp est croissante : ln(a) < b \xE9quivaut \xE0 a < exp(b), pour a > 0',
      ref: 'fonction exponentielle strictement croissante',
      levels: ['tle'],
      examples: [
        { from: 'ln(x) < 2', to: 'x < exp(2)', assume: [{ positive: 'x' }], expect: 'valid' },
        { from: 'ln(x) < 2', to: 'x > exp(2)', assume: [{ positive: 'x' }], expect: 'invalid' },
      ],
    },
    {
      id: 'explog.ln_to_exp_above',
      version: 1,
      kind: 'equivalence',
      applies_to: 'inequality',
      vars: { a: 'real', b: 'real' },
      forms: { before: '?b < ln(?a)', after: 'exp(?b) < ?a' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      preconditions: [{ positive: '?a' }],
      on_unknown: 'conditional',
      cost: 1,
      label: 'exp est croissante : ln(a) > b \xE9quivaut \xE0 a > exp(b), pour a > 0',
      ref: 'fonction exponentielle strictement croissante',
      levels: ['tle'],
      examples: [
        { from: 'ln(x) > 2', to: 'x > exp(2)', assume: [{ positive: 'x' }], expect: 'valid' },
        { from: 'ln(x) > 2', to: 'x > 2', assume: [{ positive: 'x' }], expect: 'invalid' },
      ],
    },
    {
      id: 'explog.ln_equal',
      version: 1,
      kind: 'equivalence',
      applies_to: 'equation',
      vars: { a: 'real', b: 'real' },
      forms: { before: 'ln(?a) = ln(?b)', after: '?a = ?b' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      preconditions: [{ positive: '?a' }, { positive: '?b' }],
      on_unknown: 'conditional',
      cost: 1,
      label: 'ln(a) = ln(b) \xE9quivaut \xE0 a = b, pour a > 0 et b > 0',
      ref: 'logarithme n\xE9p\xE9rien strictement croissant',
      levels: ['tle'],
      examples: [
        { from: 'ln(2x) = ln(6)', to: '2x = 6', assume: [{ positive: 'x' }], expect: 'valid' },
        { from: 'ln(2x) = ln(6)', to: '2x = 5', assume: [{ positive: 'x' }], expect: 'invalid' },
      ],
    },
    {
      id: 'explog.ln_compare',
      version: 1,
      kind: 'equivalence',
      applies_to: 'inequality',
      vars: { a: 'real', b: 'real' },
      forms: { before: 'ln(?a) < ln(?b)', after: '?a < ?b' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      preconditions: [{ positive: '?a' }, { positive: '?b' }],
      on_unknown: 'conditional',
      cost: 1,
      label: 'ln est croissante : ln(a) < ln(b) \xE9quivaut \xE0 a < b, pour a > 0 et b > 0',
      ref: 'logarithme n\xE9p\xE9rien strictement croissant',
      levels: ['tle'],
      examples: [
        { from: 'ln(x) < ln(3)', to: 'x < 3', assume: [{ positive: 'x' }], expect: 'valid' },
        { from: 'ln(x) < ln(3)', to: 'x > 3', assume: [{ positive: 'x' }], expect: 'invalid' },
      ],
    },
    {
      id: 'explog.apply_ln_equal',
      version: 1,
      kind: 'equivalence',
      applies_to: 'equation',
      vars: { a: 'real', b: 'real' },
      forms: { before: '?a = ?b', after: 'ln(?a) = ln(?b)' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      preconditions: [{ positive: '?a' }, { positive: '?b' }],
      on_unknown: 'conditional',
      cost: 2,
      label: 'Composer par ln les deux membres, strictement positifs',
      ref: 'logarithme n\xE9p\xE9rien strictement croissant',
      levels: ['tle'],
      examples: [
        { from: '2^x = 5', to: 'x \xD7 ln(2) = ln(5)', expect: 'valid' },
        { from: '2^x = 5', to: 'x \xD7 ln(5) = ln(2)', expect: 'invalid' },
      ],
    },
    {
      id: 'explog.apply_ln_compare',
      version: 1,
      kind: 'equivalence',
      applies_to: 'inequality',
      vars: { a: 'real', b: 'real' },
      forms: { before: '?a < ?b', after: 'ln(?a) < ln(?b)' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      preconditions: [{ positive: '?a' }, { positive: '?b' }],
      on_unknown: 'conditional',
      cost: 2,
      label: 'ln est croissante : composer par ln garde le sens, membres strictement positifs',
      ref: 'logarithme n\xE9p\xE9rien strictement croissant',
      levels: ['tle'],
      examples: [
        { from: '1,5^n > 100', to: 'n \xD7 ln(1,5) > ln(100)', expect: 'valid' },
        { from: '0,5^n < 0,01', to: 'n \xD7 ln(0,5) < ln(0,01)', expect: 'valid' },
        { from: '1,5^n > 100', to: 'n \xD7 ln(1,5) < ln(100)', expect: 'invalid' },
      ],
    },
  ],
};
var tE = {
  id: 'log-core',
  version: 1,
  schema: 1,
  label: "Logarithme d\xE9cimal, logarithme d'un produit ou d'un quotient (moteur v47)",
  rules: [
    {
      id: 'log.pow10_to_log',
      version: 1,
      kind: 'equivalence',
      applies_to: 'equation',
      vars: { a: 'real', b: 'real' },
      forms: { before: '10^?a = ?b', after: '?a = log(?b)' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      preconditions: [{ positive: '?b' }],
      on_unknown: 'conditional',
      cost: 1,
      label: '10^a = b, avec b > 0, \xE9quivaut \xE0 a = log(b)',
      ref: 'logarithme d\xE9cimal, r\xE9ciproque de x \u21A6 10^x',
      levels: ['tle'],
      examples: [
        { from: '10^x = 50', to: 'x = log(50)', expect: 'valid' },
        { from: '10^(2x) = 7', to: '2x = log(7)', expect: 'valid' },
        { from: '10^x = 50', to: 'x = ln(50)', expect: 'invalid' },
      ],
    },
    {
      id: 'log.pow10_to_log_below',
      version: 1,
      kind: 'equivalence',
      applies_to: 'inequality',
      vars: { a: 'real', b: 'real' },
      forms: { before: '10^?a < ?b', after: '?a < log(?b)' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      preconditions: [{ positive: '?b' }],
      on_unknown: 'conditional',
      cost: 1,
      label: 'log est croissante : 10^a < b, avec b > 0, \xE9quivaut \xE0 a < log(b)',
      ref: 'logarithme d\xE9cimal, fonction croissante',
      levels: ['tle'],
      examples: [
        { from: '10^x < 3', to: 'x < log(3)', expect: 'valid' },
        { from: '10^x \u2264 3', to: 'x \u2264 log(3)', expect: 'valid' },
        { from: '10^x < 3', to: 'x > log(3)', expect: 'invalid' },
      ],
    },
    {
      id: 'log.pow10_to_log_above',
      version: 1,
      kind: 'equivalence',
      applies_to: 'inequality',
      vars: { a: 'real', b: 'real' },
      forms: { before: '?b < 10^?a', after: 'log(?b) < ?a' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      preconditions: [{ positive: '?b' }],
      on_unknown: 'conditional',
      cost: 1,
      label: 'log est croissante : 10^a > b, avec b > 0, \xE9quivaut \xE0 a > log(b)',
      ref: 'logarithme d\xE9cimal, fonction croissante',
      levels: ['tle'],
      examples: [
        { from: '10^x > 5', to: 'x > log(5)', expect: 'valid' },
        { from: '10^x \u2265 5', to: 'x \u2265 log(5)', expect: 'valid' },
        { from: '10^x > 5', to: 'x > 5', expect: 'invalid' },
      ],
    },
    {
      id: 'log.log_to_pow10',
      version: 1,
      kind: 'equivalence',
      applies_to: 'equation',
      vars: { a: 'real', b: 'real' },
      forms: { before: 'log(?a) = ?b', after: '?a = 10^?b' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      cost: 1,
      label: 'log(a) = b \xE9quivaut \xE0 a = 10^b',
      ref: 'logarithme d\xE9cimal, r\xE9ciproque de x \u21A6 10^x',
      levels: ['tle'],
      examples: [
        { from: 'log(x) = 1', to: 'x = 10^1', assume: [{ positive: 'x' }], expect: 'valid' },
        { from: 'log(2x) = 1', to: '2x = 10^1', assume: [{ positive: 'x' }], expect: 'valid' },
        { from: 'log(x) = 1', to: 'x = 1', assume: [{ positive: 'x' }], expect: 'invalid' },
      ],
    },
    {
      id: 'log.log_to_pow10_below',
      version: 1,
      kind: 'equivalence',
      applies_to: 'inequality',
      vars: { a: 'real', b: 'real' },
      forms: { before: 'log(?a) < ?b', after: '?a < 10^?b' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      preconditions: [{ positive: '?a' }],
      on_unknown: 'conditional',
      cost: 1,
      label: 'x \u21A6 10^x est croissante : log(a) < b \xE9quivaut \xE0 a < 10^b, pour a > 0',
      ref: 'fonction x \u21A6 10^x strictement croissante',
      levels: ['tle'],
      examples: [
        { from: 'log(x) < 2', to: 'x < 10^2', assume: [{ positive: 'x' }], expect: 'valid' },
        { from: 'log(x) < 2', to: 'x > 10^2', assume: [{ positive: 'x' }], expect: 'invalid' },
      ],
    },
    {
      id: 'log.log_to_pow10_above',
      version: 1,
      kind: 'equivalence',
      applies_to: 'inequality',
      vars: { a: 'real', b: 'real' },
      forms: { before: '?b < log(?a)', after: '10^?b < ?a' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      preconditions: [{ positive: '?a' }],
      on_unknown: 'conditional',
      cost: 1,
      label: 'x \u21A6 10^x est croissante : log(a) > b \xE9quivaut \xE0 a > 10^b, pour a > 0',
      ref: 'fonction x \u21A6 10^x strictement croissante',
      levels: ['tle'],
      examples: [
        {
          from: 'log(x) \u2265 2',
          to: 'x \u2265 10^2',
          assume: [{ positive: 'x' }],
          expect: 'valid',
        },
        { from: 'log(x) > 2', to: 'x < 10^2', assume: [{ positive: 'x' }], expect: 'invalid' },
      ],
    },
    {
      id: 'log.log_equal',
      version: 1,
      kind: 'equivalence',
      applies_to: 'equation',
      vars: { a: 'real', b: 'real' },
      forms: { before: 'log(?a) = log(?b)', after: '?a = ?b' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      preconditions: [{ positive: '?a' }, { positive: '?b' }],
      on_unknown: 'conditional',
      cost: 1,
      label: 'log(a) = log(b) \xE9quivaut \xE0 a = b, pour a > 0 et b > 0',
      ref: 'logarithme d\xE9cimal strictement croissant',
      levels: ['tle'],
      examples: [
        { from: 'log(x) = log(5)', to: 'x = 5', assume: [{ positive: 'x' }], expect: 'valid' },
        { from: 'log(x) = log(5)', to: 'x = 6', assume: [{ positive: 'x' }], expect: 'invalid' },
      ],
    },
    {
      id: 'log.log_compare',
      version: 1,
      kind: 'equivalence',
      applies_to: 'inequality',
      vars: { a: 'real', b: 'real' },
      forms: { before: 'log(?a) < log(?b)', after: '?a < ?b' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      preconditions: [{ positive: '?a' }, { positive: '?b' }],
      on_unknown: 'conditional',
      cost: 1,
      label: 'log est croissante : log(a) < log(b) \xE9quivaut \xE0 a < b, pour a > 0 et b > 0',
      ref: 'logarithme d\xE9cimal strictement croissant',
      levels: ['tle'],
      examples: [
        { from: 'log(x) < log(3)', to: 'x < 3', assume: [{ positive: 'x' }], expect: 'valid' },
        { from: 'log(x) < log(3)', to: 'x > 3', assume: [{ positive: 'x' }], expect: 'invalid' },
      ],
    },
    {
      id: 'log.ln_product',
      version: 1,
      kind: 'identity',
      vars: { a: 'real', b: 'real' },
      forms: { split: 'ln(?a) + ln(?b)', joined: 'ln(?a \xD7 ?b)' },
      directions: [{ from: 'split', to: 'joined', goals: ['solve', 'simplify'] }],
      preconditions: [{ positive: '?a' }, { positive: '?b' }],
      on_unknown: 'conditional',
      cost: 1,
      label: 'ln(a) + ln(b) = ln(ab), pour a > 0 et b > 0',
      ref: "logarithme d'un produit",
      levels: ['tle'],
      examples: [
        {
          from: 'ln(x) + ln(x + 1)',
          to: 'ln(x(x + 1))',
          assume: [{ positive: 'x' }],
          expect: 'valid',
        },
        {
          from: 'ln(x) + ln(x + 3)',
          to: 'ln(x(x + 3))',
          assume: [{ positive: 'x' }],
          expect: 'valid',
        },
        {
          from: 'ln(x) + ln(x + 3)',
          to: 'ln(x + x + 3)',
          assume: [{ positive: 'x' }],
          expect: 'invalid',
        },
      ],
    },
    {
      id: 'log.ln_quotient',
      version: 1,
      kind: 'identity',
      vars: { a: 'real', b: 'real' },
      forms: { split: 'ln(?a) \u2212 ln(?b)', joined: 'ln(?a \xF7 ?b)' },
      directions: [{ from: 'split', to: 'joined', goals: ['solve', 'simplify'] }],
      preconditions: [{ positive: '?a' }, { positive: '?b' }],
      on_unknown: 'conditional',
      cost: 1,
      label: 'ln(a) \u2212 ln(b) = ln(a \xF7 b), pour a > 0 et b > 0',
      ref: "logarithme d'un quotient",
      levels: ['tle'],
      examples: [
        {
          from: 'ln(x + 1) \u2212 ln(x)',
          to: 'ln((x + 1) \xF7 x)',
          assume: [{ positive: 'x' }],
          expect: 'valid',
        },
        {
          from: 'ln(x + 1) \u2212 ln(x)',
          to: 'ln(x + 1 \u2212 x)',
          assume: [{ positive: 'x' }],
          expect: 'invalid',
        },
      ],
    },
  ],
};
var rE = {
  id: 'radical-core',
  version: 1,
  schema: 1,
  label:
    'Racines carr\xE9es : \xE9lever au carr\xE9, prendre la racine, sans changer les solutions',
  rules: [
    {
      id: 'radical.sqrt_equal',
      version: 1,
      kind: 'equivalence',
      applies_to: 'equation',
      vars: { a: 'real', b: 'real' },
      forms: { before: '\u221A(?a) = ?b', after: '?a = ?b\xB2' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      preconditions: [{ nonnegative: '?b' }],
      on_unknown: 'conditional',
      cost: 1,
      label: '\u221Aa = b, avec b \u2265 0, \xE9quivaut \xE0 a = b\xB2',
      ref: "racine carr\xE9e d'un nombre positif",
      levels: ['2nde', '1re', 'tle'],
      examples: [
        { from: '\u221A(x) = 4', to: 'x = 16', expect: 'valid' },
        { from: '\u221A(2x + 1) = 3', to: '2x + 1 = 9', expect: 'valid' },
        { from: '\u221A(x) = 4', to: 'x = 2', expect: 'invalid' },
      ],
    },
    {
      id: 'radical.square_root',
      version: 1,
      kind: 'equivalence',
      applies_to: 'equation',
      vars: { a: 'real', b: 'real' },
      forms: { before: '?a\xB2 = ?b', after: '?a = \u221A(?b)' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      preconditions: [{ nonnegative: '?a' }],
      on_unknown: 'conditional',
      cost: 1,
      label: 'a\xB2 = b, avec a \u2265 0, \xE9quivaut \xE0 a = \u221Ab',
      ref: "racine carr\xE9e d'un nombre positif",
      levels: ['4e', '3e', '2nde', '1re', 'tle'],
      examples: [
        { from: 'c\xB2 = 50', to: 'c = \u221A(50)', assume: [{ positive: 'c' }], expect: 'valid' },
        { from: 'c\xB2 = A', to: 'c = \u221A(A)', assume: [{ positive: 'c' }], expect: 'valid' },
        { from: 'c\xB2 = 50', to: 'c = 25', assume: [{ positive: 'c' }], expect: 'invalid' },
      ],
    },
    {
      id: 'radical.sqrt_compare',
      version: 1,
      kind: 'equivalence',
      applies_to: 'inequality',
      vars: { a: 'real', b: 'real' },
      forms: { before: '?b < \u221A(?a)', after: '?b\xB2 < ?a' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      preconditions: [{ nonnegative: '?b' }],
      on_unknown: 'conditional',
      cost: 1,
      label: '\u221A est croissante : \u221Aa > b, avec b \u2265 0, \xE9quivaut \xE0 a > b\xB2',
      ref: 'fonction racine carr\xE9e croissante',
      levels: ['2nde', '1re', 'tle'],
      examples: [
        { from: '\u221A(x) > 2', to: 'x > 4', expect: 'valid' },
        { from: '\u221A(x) \u2265 3', to: 'x \u2265 9', expect: 'valid' },
        { from: '\u221A(x) > 2', to: 'x > 2', expect: 'invalid' },
      ],
    },
  ],
};
var sE = {
  id: 'inequality-core',
  version: 1,
  schema: 1,
  label: 'In\xE9quations : transformer en gardant (ou en changeant) le sens',
  rules: [
    {
      id: 'inequality.add_both_sides',
      version: 1,
      kind: 'equivalence',
      applies_to: 'inequality',
      vars: { u: 'real', v: 'real', c: 'real' },
      forms: { before: '?u < ?v', after: '?u + ?c < ?v + ?c' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      cost: 1,
      label: 'Ajouter (ou retrancher) un m\xEAme terme : le sens ne change pas',
      ref: 'in\xE9galit\xE9s et addition',
      levels: ['3e', '2nde'],
      examples: [
        { from: 'x \u2212 2 < 5', to: 'x < 7', expect: 'valid' },
        { from: 'x \u2212 2 < 5', to: 'x > 7', expect: 'invalid' },
      ],
    },
    {
      id: 'inequality.multiply_positive',
      version: 1,
      kind: 'equivalence',
      applies_to: 'inequality',
      vars: { u: 'real', v: 'real', k: 'real' },
      forms: { before: '?u < ?v', after: '?k \xD7 ?u < ?k \xD7 ?v' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      preconditions: [{ positive: '?k' }],
      on_unknown: 'branch',
      cost: 1,
      label: 'Multiplier par un nombre positif : le sens ne change pas',
      ref: 'in\xE9galit\xE9s et multiplication',
      levels: ['3e', '2nde'],
      examples: [
        { from: 'x \xF7 2 < 3', to: 'x < 6', expect: 'valid' },
        { from: 'x \xF7 2 < 3', to: 'x > 6', expect: 'invalid' },
      ],
    },
    {
      id: 'inequality.multiply_negative',
      version: 1,
      kind: 'equivalence',
      applies_to: 'inequality',
      vars: { u: 'real', v: 'real', k: 'real' },
      forms: { before: '?u < ?v', after: '?k \xD7 ?u > ?k \xD7 ?v' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      preconditions: [{ negative: '?k' }],
      on_unknown: 'branch',
      effects: [{ flip_relation: !0 }],
      cost: 1,
      label: 'Multiplier par un nombre n\xE9gatif : le sens change',
      ref: 'in\xE9galit\xE9s et multiplication',
      levels: ['3e', '2nde'],
      examples: [
        { from: '\u2212x < \u22123', to: 'x > 3', expect: 'valid' },
        { from: '\u2212x < \u22123', to: 'x < 3', expect: 'invalid' },
      ],
    },
    {
      id: 'inequality.divide_positive',
      version: 1,
      kind: 'equivalence',
      applies_to: 'inequality',
      vars: { u: 'real', v: 'real', k: 'real' },
      forms: { before: '?u < ?v', after: '?u \xF7 ?k < ?v \xF7 ?k' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      preconditions: [{ positive: '?k' }],
      on_unknown: 'branch',
      cost: 1,
      label: 'Diviser par un nombre positif : le sens ne change pas',
      ref: 'in\xE9galit\xE9s et division',
      levels: ['3e', '2nde'],
      examples: [
        { from: '3x < 12', to: 'x < 4', expect: 'valid' },
        { from: '3x < 12', to: 'x > 4', expect: 'invalid' },
      ],
    },
    {
      id: 'inequality.divide_negative',
      version: 1,
      kind: 'equivalence',
      applies_to: 'inequality',
      vars: { u: 'real', v: 'real', k: 'real' },
      forms: { before: '?u < ?v', after: '?u \xF7 ?k > ?v \xF7 ?k' },
      directions: [{ from: 'before', to: 'after', goals: ['solve', 'isolate_variable'] }],
      preconditions: [{ negative: '?k' }],
      on_unknown: 'branch',
      effects: [{ flip_relation: !0 }],
      cost: 1,
      label: 'Diviser par un nombre n\xE9gatif : le sens change',
      ref: 'in\xE9galit\xE9s et division',
      levels: ['3e', '2nde'],
      examples: [
        { from: '\u22122x < 6', to: 'x > \u22123', expect: 'valid' },
        { from: '\u22122x < 6', to: 'x < \u22123', expect: 'invalid' },
      ],
    },
  ],
};
var iE = [JC, eE, sE, nE, rE, YC, tE, XC];
var Wf = {
    tool: 'formula.tool@1',
    replace: 'kernel.substitute@1',
    compute: 'kernel.compute@1',
    swap: 'kernel.swap@1',
    round: 'kernel.round@1',
    check: 'formula.check@1',
  },
  pr = class extends Error {};
function Sb(e) {
  return ne(Te(e));
}
function zy(e) {
  let n = e.lastIndexOf('\u2248'),
    t = n >= 0 ? e.slice(0, n) : e,
    r = n >= 0 ? e.slice(n + 1) : [];
  if (n >= 0 && (!t.length || !r.length)) throw new pr();
  if (t.includes('\u2248') || t.includes('ou')) throw new pr();
  let s = t.includes('='),
    i,
    o,
    a = null;
  try {
    if (s || n < 0) {
      if (((i = Ae(t)), i.dis.length !== 1)) throw new pr();
      let u = i.dis[0];
      if (u.rels || u.mod !== void 0 || u.chain) throw new pr();
      if (u.cmp === '\u2248') throw new pr();
      if (u.cmp) {
        if (n >= 0) throw new pr();
        a = u.cmp;
      }
      o = u.sides.map(_e);
    } else {
      i = Ae([...t, '\u2248', ...r]);
      let u = i.dis[0];
      o = [_e(u.sides[0])];
    }
  } catch (u) {
    throw u instanceof pr || u instanceof Gr ? new pr() : new pr();
  }
  let l = null;
  if (n >= 0) {
    try {
      let u = Ae(r),
        c = u.dis[0];
      if (u.dis.length !== 1 || c.sides.length !== 1) throw new pr();
      l = _e(c.sides[0]);
    } catch {
      throw new pr();
    }
    if (s)
      try {
        i = Ve(e.join(' ').replace(/≈.*$/, '').trim());
      } catch {
        throw new pr();
      }
  }
  if (!o.length || (a === null && o.length < 2 && !l)) throw new pr();
  return { members: o, cmp: a, approx: l, line: i };
}
function cp(e) {
  try {
    return zy(Sb(e));
  } catch {
    return null;
  }
}
var Cr = (e) => e.k === 'num';
function Ot(e) {
  return $(e).size === 0;
}
function hr(e) {
  return e.k === 'mul' && e.c.length === 2 && Cr(e.c[0]) && M(e.c[0].v, C(-1)) && !Cr(e.c[1]);
}
function mE(e) {
  if (e.k !== 'fn' || e.f === 'deg' || e.f === 'abs' || e.f === 'fact') return !1;
  let n = e.a.k === 'fn' && e.a.f === 'deg' ? e.a.a : e.a;
  if (!Cr(n) && !Jf(n)) return !1;
  let t = Z(e);
  return !(t.ok && _n(t.rf));
}
function Ay(e) {
  return hr(e) ? Ay(e.c[1]) : Jf(e);
}
function oE(e) {
  return (e.k === 'sym' && e.n === '\u03C0') || mE(e);
}
function gr(e) {
  if (Cr(e)) return e.v;
  if (Jf(e)) {
    let n = e;
    return A(n.a.v, n.b.v);
  }
  if (hr(e)) {
    let n = gr(e.c[1]);
    return n ? fe(n) : null;
  }
  return null;
}
function Nn(e) {
  if (Jf(e) || mE(e)) return 0;
  switch (e.k) {
    case 'num':
    case 'sym':
      return 0;
    case 'add':
      return e.c.length - 1 + e.c.reduce((n, t) => n + Nn(t), 0);
    case 'mul': {
      if (hr(e)) return Nn(e.c[1]);
      let n = e.c.filter(oE).length,
        t = (s) => {
          let i = gr(s);
          return i !== null && !L(i);
        },
        r = n === 1 && e.c.some(t) ? 1 : 0;
      return e.c.length - 1 - r + e.c.reduce((s, i) => s + Nn(i), 0);
    }
    case 'div':
      return oE(e.a) && gr(e.b) !== null ? 0 : 1 + Nn(e.a) + Nn(e.b);
    case 'pow':
    case 'binom':
      return 1 + Nn(e.a) + Nn(e.b);
    case 'fn':
      return (e.f === 'deg' ? 0 : 1) + Nn(e.a);
  }
}
function Ye(e) {
  switch (e.k) {
    case 'num':
      return bt(e.v);
    case 'sym':
      return e.n;
    case 'add':
    case 'mul':
      return `${e.k}(${e.c.map(Ye).sort().join(',')})`;
    case 'div':
    case 'pow':
    case 'binom':
      return `${e.k}(${Ye(e.a)},${Ye(e.b)})`;
    case 'fn':
      return `${e.f}(${Ye(e.a)})`;
  }
}
function fp(e) {
  return Ye(e.l) + '=' + Ye(e.r);
}
function dp(e) {
  return [fp(e), Ye(e.r) + '=' + Ye(e.l)];
}
function sV(e) {
  let n = ie(e);
  return n.ok && n.s.k === 'expr' ? n.s.e : null;
}
function aE(e) {
  if (!Number.isFinite(e)) return null;
  let n = Math.round(e * 1e6) / 1e6;
  if (Math.abs(n - e) > 1e-12 * Math.max(1, Math.abs(e))) return null;
  let t = nr(String(n));
  return t ? T(t) : null;
}
function jy(e, n) {
  let t = {};
  for (let r of $(n)) {
    let s = e.W[r];
    if (!s?.exact) return null;
    t[r] = s.exact;
  }
  return j(n, t);
}
function Vu(e, n) {
  return D(n, e.Wf);
}
function Qu(e, n, t) {
  let r = jy(e, n),
    s = jy(e, t);
  if (r && s) {
    let a = qn(r, s);
    if (a === 'equal') return !0;
    if (a === 'different') return !1;
  }
  let i = Vu(e, n),
    o = Vu(e, t);
  return !Number.isFinite(i) || !Number.isFinite(o)
    ? null
    : Math.abs(i - o) <= 1e-9 * Math.max(1, Math.abs(i), Math.abs(o));
}
function Uy(e, n, t, r) {
  let s = Vu(e, t),
    i = Vu(e, r);
  if (!Number.isFinite(s) || !Number.isFinite(i)) return null;
  let o = Qu(e, t, r);
  return o === !0
    ? n === '\u2265' || n === '\u2264'
    : o === null && Math.abs(s - i) < 1e-9
      ? null
      : n === '>' || n === '\u2265'
        ? s > i
        : s < i;
}
function lE(e) {
  let n = cp(e);
  return !n || n.cmp || n.approx || n.members.length < 2
    ? null
    : { l: n.members[0], r: n.members[n.members.length - 1] };
}
function yb(e) {
  let n = Z({ k: 'add', c: [e.l, { k: 'mul', c: [T(-1), e.r] }] });
  return n.ok ? n.rf : null;
}
function pE(e, n) {
  if (!e || !n) return !1;
  try {
    let t = $e(Hr(e, n)),
      r = _n(t);
    return !!r && !L(r);
  } catch {
    return !1;
  }
}
function iV(e) {
  let n = [],
    t = [];
  for (let r of e.preds ?? [])
    if (r.skill === 'formule')
      n.push({
        text: r.line,
        label: r.label || 'Formule',
        hora: r.hora || 3,
        why: r.why || 'On applique la formule : ' + r.line + '.',
        hint: r.hint || 'Utilise la formule : ' + r.line + '.',
        card: 'Formule',
      });
    else if (r.skill === 'pythagore') {
      let [s, i] = r.sides,
        o = r.hyp;
      n.push({
        text: `${o}\xB2 = ${s}\xB2 + ${i}\xB2`,
        label: 'Pythagore',
        hora: 5,
        why: `Le triangle est rectangle en ${r.right}, donc [${o}] est l\u2019hypot\xE9nuse : ${o}\xB2 = ${s}\xB2 + ${i}\xB2.`,
        hint: `Le triangle est rectangle en ${r.right} : quel th\xE9or\xE8me relie ses trois c\xF4t\xE9s ? Commence la ligne par ${o}\xB2.`,
        card: 'Th\xE9or\xE8me de Pythagore',
      });
      let a = `L\u2019angle droit est en ${r.right} : l\u2019hypot\xE9nuse est le c\xF4t\xE9 oppos\xE9, [${o}]. C\u2019est ${o}\xB2 qui est seul d\u2019un c\xF4t\xE9.`,
        l =
          'Pour obtenir le carr\xE9 de l\u2019hypot\xE9nuse, on ADDITIONNE les carr\xE9s des deux autres c\xF4t\xE9s.';
      t.push(
        {
          line: `${o} = ${s} + ${i}`,
          title: 'Additionner les longueurs',
          why: `Pythagore relie les CARR\xC9S des longueurs : ${o}\xB2 = ${s}\xB2 + ${i}\xB2.`,
        },
        {
          line: `${o}\xB2 = ${s} + ${i}`,
          title: 'Il manque les carr\xE9s',
          why: `Ce sont les carr\xE9s des c\xF4t\xE9s qui s\u2019additionnent : ${s}\xB2 + ${i}\xB2.`,
        },
        { line: `${s}\xB2 = ${o}\xB2 + ${i}\xB2`, title: 'Mauvaise hypot\xE9nuse', why: a },
        { line: `${i}\xB2 = ${o}\xB2 + ${s}\xB2`, title: 'Mauvaise hypot\xE9nuse', why: a },
        {
          line: `${o}\xB2 = ${i}\xB2 \u2212 ${s}\xB2`,
          title: 'Soustraire au lieu d\u2019additionner',
          why: l,
        },
        {
          line: `${o}\xB2 = ${s}\xB2 \u2212 ${i}\xB2`,
          title: 'Soustraire au lieu d\u2019additionner',
          why: l,
        },
      );
    } else if (r.skill === 'baisse') {
      let s = typeof r.base == 'number' ? pe(r.base) : r.base,
        i = pe(r.taux);
      (n.push(
        {
          text: `${r.remise} = ${i} % \xD7 ${s}`,
          label: 'Pourcentage',
          hora: 4,
          why: `Baisser de ${i} %, c\u2019est retirer ${i} % du prix : la remise vaut ${i} % de ${s}.`,
          hint: `Commence par la remise : combien font ${i} % de ${s} ?`,
          card: 'Appliquer un pourcentage',
        },
        {
          text: `${r.nouveau} = ${s} \u2212 ${r.remise}`,
          label: 'Retirer la remise',
          hora: 3,
          why: 'Le nouveau prix, c\u2019est le prix de d\xE9part moins la remise.',
          hint: 'Le nouveau prix, c\u2019est le prix de d\xE9part moins la remise.',
          card: 'Appliquer un pourcentage',
        },
        {
          text: `${r.nouveau} = ${s} \xD7 (1 \u2212 ${i} %)`,
          label: 'Coefficient multiplicateur',
          hora: 5,
          why: `Baisser de ${i} %, c\u2019est garder ${pe(100 - r.taux)} % du prix : on multiplie par 1 \u2212 ${i} %.`,
          hint: `Baisser de ${i} %, c\u2019est multiplier le prix par un nombre. Lequel ?`,
          card: 'Appliquer un pourcentage',
        },
      ),
        t.push(
          {
            line: `${r.nouveau} = ${s} \u2212 ${i}`,
            title: `\u2212${i} % n\u2019est pas \u2212${i}`,
            why: `${i} % de ${s} ne font pas ${i} : la remise se calcule sur le prix (${i} % \xD7 ${s}).`,
          },
          {
            line: `${r.nouveau} = ${i} % \xD7 ${s}`,
            title: '\xC7a, c\u2019est la remise',
            why: `${i} % \xD7 ${s} est le montant de la r\xE9duction, pas le nouveau prix. Il faut encore le retirer du prix de d\xE9part.`,
          },
        ));
    } else
      r.skill === 'secondDegre' &&
        (n.push({
          text: `${r.delta} = ${r.b}\xB2 \u2212 4 \xD7 ${r.a} \xD7 ${r.c}`,
          label: 'Discriminant',
          hora: 5,
          why: 'Pour ax\xB2 + bx + c = 0, on calcule le discriminant : \u0394 = b\xB2 \u2212 4ac.',
          hint: 'Commence par le discriminant : \u0394 = b\xB2 \u2212 4ac.',
          card: '\xC9quation du second degr\xE9',
        }),
        [
          [r.roots[0], '\u2212'],
          [r.roots[1], '+'],
        ].forEach(([i, o]) =>
          n.push({
            text: `${i} = (\u2212${r.b} ${o} \u221A${r.delta}) \xF7 (2 \xD7 ${r.a})`,
            label: 'Formule des racines',
            hora: 5,
            why: `\u0394 > 0, donc deux solutions : ${r.roots[0]} = (\u2212b \u2212 \u221A\u0394) \xF7 (2a) et ${r.roots[1]} = (\u2212b + \u221A\u0394) \xF7 (2a).`,
            hint: `\u0394 est positif : il y a deux solutions. \xC9cris ${i} = (\u2212b ${o} \u221A\u0394) \xF7 (2a).`,
            card: '\xC9quation du second degr\xE9',
          }),
        ),
        r.double &&
          n.push({
            text: `${r.double} = \u2212${r.b} \xF7 (2 \xD7 ${r.a})`,
            label: 'Solution double',
            hora: 5,
            why: `\u0394 = 0, donc une seule solution : ${r.double} = \u2212b \xF7 (2a).`,
            hint: `\u0394 est nul : il y a une seule solution. \xC9cris ${r.double} = \u2212b \xF7 (2a).`,
            card: '\xC9quation du second degr\xE9',
          }));
  return { tools: n, traps: t };
}
function oV(e) {
  return new Set(Object.keys(e.symbols));
}
var Qy = class extends Error {};
function gE(e) {
  let n = e.kernel,
    t = {
      model: e,
      goals: [...e.goal],
      answer: null,
      W: {},
      Wf: {},
      given: [],
      tools: [],
      traps: [],
      checks: [],
      hyps: [],
      path: n.path ?? [],
      lines: [],
      checked: new Set(),
    },
    r = (c, f, d) => {
      ((t.W[c] = { exact: f, f: d }), (t.Wf[c] = d));
    };
  for (let [c, f] of Object.entries(e.symbols)) {
    let d = f.exact?.length ? sV(f.exact[0]) : null;
    if (d && Ot(d)) {
      r(c, d, D(d, {}));
      continue;
    }
    let m = f.value ?? (f.values?.length === 1 ? f.values[0] : void 0);
    m !== void 0 && r(c, aE(m), m);
  }
  let s = t.path.flatMap((c) => {
    let f = cp(c);
    return f && !f.cmp && f.members.length >= 2 ? [f] : [];
  });
  for (let c = 0; c < 4; c++) {
    let f = !1;
    for (let d of s) {
      let m = d.members[0];
      if (!(m.k !== 'sym' || t.W[m.n]?.exact))
        for (let p of d.members.slice(1).reverse()) {
          if ($(p).has(m.n)) continue;
          let g = jy(t, p);
          if (!g) continue;
          let h = Z(g),
            b = h.ok && _n(h.rf) ? T(_n(h.rf)) : g,
            v = D(g, {});
          if (!Number.isFinite(v)) continue;
          let k = t.W[m.n];
          if (!(k && Math.abs(k.f - v) > 1e-6 * Math.max(1, Math.abs(v)))) {
            (r(m.n, b, v), (f = !0));
            break;
          }
        }
    }
    if (!f) break;
  }
  let i = [...oV(e)].filter((c) => !(c in t.Wf));
  if (i.length) throw new Qy(`grandeur sans valeur : ${i.join(', ')}`);
  let o = ie(n.answer);
  o.ok && (t.answer = o.s);
  let a = (c) => {
    let f = fp(c);
    t.given.some((d) => d.key === f) || t.given.push({ ...c, key: f, given: !0 });
  };
  for (let [c, f] of Object.entries(e.symbols)) {
    if (!f.given) continue;
    let d = t.W[c],
      m = d.exact ?? aE(d.f);
    m && a({ l: { k: 'sym', n: c }, r: m });
  }
  for (let c of [...(e.givens ?? []), ...(e.admitted ?? [])]) {
    let f = cp(c);
    if (!(!f || f.cmp || f.members.length < 2))
      for (let d = 1; d < f.members.length; d++) a({ l: f.members[0], r: f.members[d] });
  }
  let { tools: l, traps: u } = iV(e);
  for (let c of l) {
    let f = lE(c.text);
    if (!f) continue;
    let d = new Set([...$(f.l), ...$(f.r)]);
    t.tools.push({ ...c, rel: f, names: d, rf: yb(f) });
  }
  for (let c of [...(e.traps ?? []), ...u]) {
    let f = lE(c.line);
    if (!f) continue;
    let d;
    try {
      d = Ve(c.line);
    } catch {
      continue;
    }
    t.traps.push({ rel: f, line: d, title: c.title, why: c.why, rf: yb(Fy(t, f)), key: fp(f) });
  }
  for (let c of e.checks ?? []) {
    let f = cp(c.line);
    !f ||
      !f.cmp ||
      t.checks.push({
        spec: c,
        rel: { rel: f.cmp, l: f.members[0], r: f.members[1] },
        key: `${Ye(f.members[0])}${f.cmp}${Ye(f.members[1])}`,
      });
  }
  for (let c of Object.keys(e.symbols)) {
    let f = t.Wf[c];
    (f > 0
      ? t.hyps.push({ kind: 'positive', of: [c] })
      : f < 0 && t.hyps.push({ kind: 'negative', of: [c] }),
      e.symbols[c].kind === 'int' &&
        Number.isInteger(f) &&
        t.hyps.push({ kind: 'integer', of: [c] }));
  }
  return t;
}
function Fy(e, n) {
  let t = {};
  for (let [r, s] of Object.entries(e.model.symbols)) {
    if (!s.given) continue;
    let i = e.W[r];
    i?.exact && (t[r] = i.exact);
  }
  return { l: j(n.l, t), r: j(n.r, t) };
}
function el(e) {
  let n = [];
  for (let t = e.lines.length - 1; t >= 0; t--) {
    let r = e.lines[t];
    if (r.trusted) for (let s of r.rels) n.push({ ...s, key: fp(s), given: !1 });
  }
  return (n.push(...e.given), n);
}
function Vy(e) {
  return Ot(e) ? (Nn(e) === 0 ? !0 : up(e) ? !1 : Nn(e) <= hE(e) + 1) : !1;
}
function hE(e) {
  let n = Z(e);
  if (!n.ok) return Nn(e);
  try {
    return Nn(Je(n.rf));
  } catch {
    return Nn(e);
  }
}
function bE(e) {
  let n = new Set();
  for (let [r, s] of Object.entries(e.model.symbols)) s.given && n.add(r);
  let t = el(e);
  for (let r of t)
    (r.l.k === 'sym' && Vy(r.r) && n.add(r.l.n), r.r.k === 'sym' && Vy(r.l) && n.add(r.r.n));
  for (let r = 0; r < 3; r++)
    for (let s of t)
      s.l.k === 'sym' &&
        s.r.k === 'sym' &&
        (n.has(s.r.n) && n.add(s.l.n), n.has(s.l.n) && n.add(s.r.n));
  return n;
}
var ut = { replace: [], leaf: 0, expand: 0, deep: 0, reorder: !1 };
function Fu(e, n) {
  return {
    ...(e.expr || n.expr ? { expr: !0 } : {}),
    replace: [...e.replace, ...n.replace],
    leaf: e.leaf + n.leaf,
    expand: e.expand + n.expand,
    deep: e.deep + n.deep,
    reorder: e.reorder || n.reorder,
  };
}
var Hf = (e) => e.deep * 100 + e.replace.length * 3 + e.leaf * 2 + e.expand * 2 + +e.reorder;
function Dy(e) {
  if (!hr(e)) return e;
  let n = e.c[1];
  return n.k !== 'mul' || hr(n) || !Cr(n.c[0])
    ? e
    : { k: 'mul', c: [T(fe(n.c[0].v)), ...n.c.slice(1)] };
}
function ii(e, n, t, r = 0) {
  let s = uE(e, n, t, r);
  if (s && !s.deep) return s;
  let i = Dy(n),
    o = Dy(t);
  if (i === n && o === t) return s;
  let a = uE(e, i, o, r);
  return a && (!s || Hf(a) < Hf(s)) ? a : s;
}
function uE(e, n, t, r) {
  if (Ye(n) === Ye(t)) return E(n) === E(t) ? ut : { ...ut, reorder: !0 };
  if (r > 40) return null;
  if (r === 0) {
    let c = lV(e, n, t);
    if (c) return c;
  }
  if (hr(n) && Cr(t)) return ii(e, n.c[1], T(fe(t.v)), r + 1);
  if (Cr(n) && hr(t)) return ii(e, T(fe(n.v)), t.c[1], r + 1);
  if (n.k === 'sym')
    return Ot(t) && Qu(e, n, t)
      ? { ...ut, replace: [n.n] }
      : !Ot(t) && vE(e, n.n).some((c) => Ye(c) === Ye(t))
        ? { ...ut, replace: [n.n], expr: !0 }
        : null;
  let s = Ot(n),
    i = Ot(t),
    o = fV(e, n, t, r);
  if (o) return o;
  if (s && i && Nn(n) - Nn(t) === 1 && Qu(e, n, t)) return { ...ut, leaf: 1 };
  let a = uV(e, n, t, r);
  if (a) return a;
  if (kE(n, t)) return { ...ut, leaf: 1 };
  if (n.k === 'add' && t.k === 'add' && t.c.length > n.c.length) {
    let c = Ya(aV(n));
    if (Ye(c) === Ye(Ya(t))) return { ...ut, expand: 1 };
  }
  if (s && i) {
    if (!Qu(e, n, t)) return null;
    let c = Nn(n) - Nn(t);
    return c === 1
      ? { ...ut, leaf: 1 }
      : c === 0 && Ay(n) !== Ay(t) && gr(n) && gr(t)
        ? { ...ut, leaf: 1 }
        : c === 0
          ? { ...ut, reorder: !0 }
          : { ...ut, deep: Math.max(1, Math.abs(c)) };
  }
  let l = [...$(n)].sort().join(','),
    u = [...$(t)].sort().join(',');
  if (l === u && cV(n, t)) {
    let c = Nn(n) - Nn(t);
    return c === 1
      ? { ...ut, leaf: 1 }
      : c <= 0
        ? { ...ut, reorder: !0, deep: c < 0 ? 1 : 0 }
        : { ...ut, deep: c };
  }
  return null;
}
function aV(e) {
  if (e.k !== 'add') return e;
  let n = [];
  for (let t of e.c)
    if (hr(t) && t.c[1].k === 'add')
      for (let r of t.c[1].c)
        n.push(Cr(r) ? T(fe(r.v)) : hr(r) ? r.c[1] : { k: 'mul', c: [T(-1), r] });
    else t.k === 'add' ? n.push(...t.c) : n.push(t);
  return { k: 'add', c: n };
}
function Ya(e) {
  switch (e.k) {
    case 'add':
    case 'mul': {
      let n = [];
      for (let t of e.c.map(Ya)) t.k === e.k && !hr(t) ? n.push(...t.c) : n.push(t);
      return { k: e.k, c: n };
    }
    case 'div':
    case 'pow':
    case 'binom':
      return { ...e, a: Ya(e.a), b: Ya(e.b) };
    case 'fn':
      return { ...e, a: Ya(e.a) };
    default:
      return e;
  }
}
function lV(e, n, t) {
  let r = [...$(n)].filter((a) => !$(t).has(a));
  if (!r.length || r.length > 2) return null;
  let s = r.map((a) => vE(e, a).map((l) => [a, l]));
  if (s.some((a) => !a.length)) return null;
  let i = Ye(Ya(t)),
    o = (a, l) =>
      a === s.length ? Ye(Ya(j(n, l))) === i : s[a].some(([u, c]) => o(a + 1, { ...l, [u]: c }));
  return o(0, {}) ? { ...ut, replace: r, expr: !0 } : null;
}
function vE(e, n) {
  let t = [];
  for (let r of el(e))
    (r.l.k === 'sym' && r.l.n === n && !Ot(r.r) && !$(r.r).has(n) && t.push(r.r),
      r.r.k === 'sym' && r.r.n === n && !Ot(r.l) && !$(r.l).has(n) && t.push(r.l));
  return t;
}
function kE(e, n) {
  if (e.k !== 'add') return !1;
  if (e.c.length > 2) {
    if (n.k !== 'add' || n.c.length !== e.c.length - 1) return !1;
    for (let o = 0; o < e.c.length; o++)
      for (let a = o + 1; a < e.c.length; a++) {
        let l = e.c.filter((u, c) => c !== o && c !== a).map(Ye);
        for (let u of n.c) {
          let c = n.c.filter((f) => f !== u).map(Ye);
          if (
            c.length === l.length &&
            [...c].sort().join('|') === [...l].sort().join('|') &&
            kE({ k: 'add', c: [e.c[o], e.c[a]] }, u)
          )
            return !0;
        }
      }
    return !1;
  }
  if (e.c.length !== 2) return !1;
  let t = (o) => {
      let a = Dy(o);
      if (a.k === 'mul' && a.c.length === 2) {
        let l = gr(a.c[0]);
        if (l && gr(a.c[1]) === null) return { k: l, x: Ye(a.c[1]) };
        let u = gr(a.c[1]);
        if (u && gr(a.c[0]) === null) return { k: u, x: Ye(a.c[0]) };
      }
      return gr(a) === null && a.k !== 'add' ? { k: q, x: Ye(a) } : null;
    },
    r = t(e.c[0]),
    s = t(e.c[1]),
    i = t(n);
  return !r || !s || !i || r.x !== s.x || s.x !== i.x ? !1 : M(re(r.k, s.k), i.k);
}
function uV(e, n, t, r) {
  if (n.k !== 'mul' || t.k !== 'add' || n.c.length !== 2) return null;
  let s = n.c.findIndex((u) => u.k === 'add');
  if (s < 0) return null;
  let i = n.c[s],
    o = n.c[1 - s];
  if (i.c.length !== t.c.length) return null;
  let a = i.c.map((u) => ({ k: 'mul', c: [o, u] })),
    l = By(e, a, t.c, r);
  return !l || l.deep ? null : Fu(l, { ...ut, expand: 1 });
}
function cV(e, n) {
  return qn(e, n) === 'equal';
}
function fV(e, n, t, r) {
  if (n.k !== t.k) return null;
  switch (n.k) {
    case 'div':
    case 'pow':
    case 'binom': {
      let s = t,
        i = ii(e, n.a, s.a, r + 1),
        o = i && ii(e, n.b, s.b, r + 1);
      return i && o ? Fu(i, o) : null;
    }
    case 'fn': {
      let s = t;
      return s.f !== n.f ? null : ii(e, n.a, s.a, r + 1);
    }
    case 'add':
    case 'mul':
      return dV(e, n, t, r);
    default:
      return null;
  }
}
function dV(e, n, t, r) {
  if (n.c.length === t.c.length) {
    let s = ut;
    for (let o = 0; o < n.c.length && s; o++) {
      let a = ii(e, n.c[o], t.c[o], r + 1);
      s = a ? Fu(s, a) : null;
    }
    if (s) return s;
    let i = By(e, n.c, t.c, r);
    return i ? { ...i, reorder: !0 } : null;
  }
  if (n.k === 'add' && t.c.length > n.c.length && t.c.length <= 8) {
    let s = n.c.length,
      i = t.c.length,
      o = null,
      a = (l, u, c) => {
        if (u === 1) {
          let f = [...c, i - l],
            d = ut,
            m = 0;
          (f.forEach((p, g) => {
            if (!d) return;
            let h = p === 1 ? t.c[m] : { k: 'add', c: t.c.slice(m, m + p) };
            m += p;
            let b = ii(e, n.c[g], h, r + 1);
            d = b ? Fu(d, b) : null;
          }),
            d && d.replace.length && (!o || Hf(d) < Hf(o)) && (o = d));
          return;
        }
        for (let f = 1; l + f <= i - (u - 1); f++) a(l + f, u - 1, [...c, f]);
      };
    if ((a(0, s, []), o)) return o;
  }
  if (t.c.length < n.c.length) {
    let s = (c) => gr(c) !== null,
      i = n.c.filter(s).map((c) => T(gr(c))),
      o = t.c.filter(s).map((c) => T(gr(c))),
      a = n.c.filter((c) => !s(c)),
      l = t.c.filter((c) => !s(c)),
      u = i.length - o.length;
    if (u >= 1 && a.length === l.length) {
      let c = a.length ? By(e, a, l, r) : ut;
      if (c && mV(n.k, i, o)) return Fu(c, u === 1 ? { ...ut, leaf: 1 } : { ...ut, deep: u });
    }
  }
  return null;
}
function mV(e, n, t) {
  let r = (o) => o.reduce((a, l) => (e === 'add' ? re(a, l) : N(a, l)), e === 'add' ? F : q);
  if (!M(r(n.map((o) => o.v)), r(t.map((o) => o.v)))) return !1;
  let s = n.map((o) => bt(o.v)),
    i = 0;
  for (let o of t) {
    let a = s.indexOf(bt(o.v));
    a >= 0 ? s.splice(a, 1) : i++;
  }
  return i === 1 || (i === 0 && s.length > 0);
}
function By(e, n, t, r) {
  if (n.length !== t.length || n.length > 7) return null;
  let s = new Array(t.length).fill(!1),
    i = ut,
    o = [];
  for (let a of n) {
    let l = Ye(a),
      u = t.findIndex((c, f) => !s[f] && Ye(c) === l);
    u >= 0 ? (s[u] = !0) : o.push(a);
  }
  for (let a of o) {
    let l = null;
    for (let u = 0; u < t.length; u++) {
      if (s[u]) continue;
      let c = ii(e, a, t[u], r + 1);
      c && (!l || Hf(c) < Hf(l.ev)) && (l = { j: u, ev: c });
    }
    if (!l) return null;
    ((s[l.j] = !0), (i = Fu(i, l.ev)));
  }
  return i;
}
function xE(e, n, t) {
  return n.deep > 0 || (n.replace.length && (n.leaf || n.expand)) || (n.expand && n.leaf)
    ? 'jump'
    : n.replace.length
      ? n.expr || n.replace.every((r) => t.has(r))
        ? 'replace'
        : 'jump'
      : n.expand
        ? 'expand'
        : n.leaf
          ? 'compute'
          : n.reorder
            ? 'reorder'
            : 'same';
}
function Gy(e, n, t, r) {
  let s = null,
    i = { same: 0, reorder: 1, replace: 2, compute: 2, expand: 2, jump: 9 };
  for (let o of [!1, !0]) {
    let a = ii(e, n.l, o ? t.r : t.l),
      l = a && ii(e, n.r, o ? t.l : t.r);
    if (!a || !l) continue;
    let u = Fu(a, l),
      c = xE(e, u, r),
      f = { kind: c, swapped: o, names: [...new Set(u.replace)], leaf: u.leaf };
    (!s || i[c] < i[s.kind]) && (s = f);
  }
  return s;
}
function Tb(e, n) {
  return [...new Set([...$(e.l), ...$(e.r)])].filter((t) => !n.has(t));
}
function wb(e, n) {
  let t = Tb(e, n);
  return t.length <= 1 ? cE(e, t) : Math.min(...t.map((r) => cE(e, [r])));
}
function cE(e, n) {
  if (!n.length) return 0;
  let t = (c) => n.some((f) => $(c).has(f)),
    r = (c) => c.k === 'sym' && n.includes(c.n);
  if (r(e.l) && !t(e.r)) return 0;
  if (r(e.r) && !t(e.l)) return 1;
  let s = (c, f) => {
      let d = f(c) ? 1 : 0;
      return (
        c.k === 'add' || c.k === 'mul'
          ? (d += c.c.reduce((m, p) => m + s(p, f), 0))
          : c.k === 'div' || c.k === 'pow' || c.k === 'binom'
            ? (d += s(c.a, f) + s(c.b, f))
            : c.k === 'fn' && (d += s(c.a, f)),
        d
      );
    },
    i = (c) =>
      s(
        c,
        (f) =>
          (f.k === 'mul' && f.c.some((d) => d.k === 'add' && t(d))) ||
          (f.k === 'pow' && f.a.k === 'add' && t(f.a)),
      ),
    o = (c) => s(c, (f) => f.k === 'div' && t(f)),
    a = (c) => s(c, (f) => f.k === 'sym' && n.includes(f.n)),
    l = t(e.l) && t(e.r) ? 100 : 0,
    u = (c) => (t(c) ? 3 * Nn(c) : Nn(c));
  return (
    l +
    50 * (i(e.l) + i(e.r)) +
    10 * (o(e.l) + o(e.r)) +
    u(e.l) +
    u(e.r) +
    a(e.l) +
    a(e.r) +
    (t(e.l) ? 0 : 1)
  );
}
var pV = (e) => e.charAt(0).toLowerCase() + e.slice(1),
  Gf = (e) => `\xAB ${Jr(e)} \xBB`;
function gV(e) {
  if (!e.known) {
    let n = [...e.path, e.model.kernel.answer];
    e.known = n.flatMap((t) => {
      try {
        return [Sb(t)];
      } catch {
        return [];
      }
    });
  }
  return e.known;
}
function yE(e, n, t) {
  let r = wt(n),
    s = r.atoms;
  if (!s.length) return { kind: 'empty', atoms: s, badChip: -1 };
  let i = gV(e).some((d) => d.length > s.length && s.every((m, p) => d[p] === m)),
    o = s.lastIndexOf('\u2248'),
    a = o >= 0 && s.slice(0, o).includes('=') ? s.slice(0, o) : s,
    l = vn(a);
  if (!l.ok)
    return i
      ? { kind: 'building', atoms: s, complete: !1 }
      : {
          kind: 'syntax',
          atoms: s,
          title: '\xC7a commence mal',
          message: l.msg,
          badChip: r.src[l.index] !== void 0 ? r.src[l.index] : n.length - 1,
        };
  let u = o < 0 || (o < s.length - 1 && vn(s.slice(o + 1)).ok);
  if (!l.complete || (!l.hasEq && o < 0) || !u)
    return { kind: i ? 'building' : 'open', atoms: s, complete: !1 };
  let c;
  try {
    c = zy(s);
  } catch {
    return i
      ? { kind: 'building', atoms: s, complete: !1 }
      : {
          kind: 'unjustified',
          atoms: s,
          title: 'Une relation par ligne',
          message:
            '\xC9cris une \xE9galit\xE9 (avec \xAB = \xBB), \xE9ventuellement suivie d\u2019une valeur approch\xE9e (\xAB \u2248 \xBB), ou une comparaison.',
        };
  }
  let f = wE(e, c, s);
  return i && !t?.verify
    ? f.kind === 'step'
      ? { ...f, kind: 'ready' }
      : { kind: 'building', atoms: s, complete: !0 }
    : !t?.verify && (f.kind === 'unjustified' || f.kind === 'false')
      ? { kind: 'pending', atoms: s, complete: !0 }
      : f;
}
function wE(e, n, t) {
  let r = n.line,
    s = new Set();
  (n.members.forEach((w) => $(w).forEach((_) => s.add(_))),
    n.approx && $(n.approx).forEach((w) => s.add(w)));
  let i = [...s].filter((w) => !(w in e.Wf));
  if (i.length)
    return {
      kind: 'unjustified',
      atoms: t,
      line: r,
      title: 'Lettre inconnue',
      message: `\xAB ${i[0]} \xBB n\u2019est pas une grandeur de cette question : utilise celles de l\u2019\xE9nonc\xE9.`,
    };
  if (n.cmp) return RV(e, n, t);
  let o = bE(e);
  for (let w = 0; w + 1 < n.members.length; w++) {
    let _ = n.members[w],
      O = n.members[w + 1],
      G = Qu(e, _, O);
    if (G !== !0)
      return G === null
        ? {
            kind: 'useless',
            atoms: t,
            line: r,
            unknown: !0,
            title: 'Je ne sais pas encore v\xE9rifier ce passage',
            message:
              'Ta ligne est peut-\xEAtre juste, mais je ne sais pas la v\xE9rifier. Garde-la sans HORA, ou \xE9cris le passage autrement.',
            kfor: { rels: [], trusted: !1 },
          }
        : SV(e, n, w, t);
  }
  if (n.approx) return wV(e, n, t, o);
  let a = [],
    l = n.members[0];
  for (let w = 1; w < n.members.length; w++) a.push({ l, r: n.members[w] });
  for (let w = 2; w < n.members.length; w++) a.push({ l: n.members[w - 1], r: n.members[w] });
  let u = el(e),
    c = { l: n.members[0], r: n.members[1] },
    f = dp(c);
  if (n.members.length === 2 && e.given.some((w) => f.includes(w.key)))
    return {
      kind: 'given',
      atoms: t,
      line: r,
      title: 'C\u2019est l\u2019\xE9nonc\xE9',
      message:
        'Cette \xE9galit\xE9 est d\xE9j\xE0 en t\xEAte de ta feuille : sers-t\u2019en pour la suite.',
    };
  let d = (w) => {
    let _ = dp(w);
    return u.some((O) => _.includes(O.key));
  };
  if (a.every(d))
    return {
      kind: 'dup',
      atoms: t,
      line: r,
      title: 'D\xE9j\xE0 \xE9crit',
      message: 'Tu as d\xE9j\xE0 cette ligne sur ta feuille.',
    };
  let m = [],
    p,
    g = hV(e, c, u, o);
  if (g.kind === 'step') (m.push(g.rule), (p = g.tool));
  else if (g.kind === 'regress')
    return {
      kind: 'useless',
      atoms: t,
      line: r,
      title: 'Juste, mais \xE7a ne t\u2019avance pas',
      message:
        'Ta ligne est juste, mais elle ne rapproche pas de la r\xE9ponse : isole la grandeur cherch\xE9e.',
      kfor: { rels: a, trusted: !0 },
    };
  let h = g.kind === 'jump',
    b = c;
  for (let w = 2; w < n.members.length && !h; w++) {
    let _ = { l, r: n.members[w] },
      O = Gy(e, b, _, o);
    (!O || O.kind === 'jump'
      ? (h = !0)
      : O.kind === 'replace'
        ? m.push(TE(O.names))
        : O.kind === 'compute'
          ? m.push($E())
          : O.kind === 'expand' && m.push(RE()),
      (b = _));
  }
  let v = kV(e, a, o),
    k = v && xV(e, a),
    y = a.every((w) => Tb(w, o).length === 0) && !v;
  if (h)
    return {
      kind: 'useless',
      atoms: t,
      line: r,
      jump: !0,
      final: k,
      title: k ? 'Juste !' : 'Juste, mais tu sautes des \xE9tapes',
      message: k
        ? 'C\u2019est la bonne valeur. D\xE9taille ton calcul, une \xE9tape par ligne, pour gagner des HORA. Tu peux garder cette ligne sans HORA.'
        : 'Ta ligne est juste. D\xE9taille-la, une \xE9tape par ligne, pour gagner des HORA. Tu peux la garder sans HORA.',
      kfor: { rels: a, trusted: !0 },
    };
  if (y)
    return {
      kind: 'useless',
      atoms: t,
      line: r,
      title: 'Calcul juste',
      message:
        'Ce calcul est juste. Garde-le s\u2019il t\u2019aide : il ne rapporte pas de HORA, la ligne utile parle de la grandeur cherch\xE9e.',
      kfor: { rels: a, trusted: !0 },
    };
  if (!m.length)
    return {
      kind: 'useless',
      atoms: t,
      line: r,
      title: 'M\xEAme chose, \xE9crite autrement',
      message:
        'Ta ligne est juste, mais elle redit ce que tu as d\xE9j\xE0 \xE9crit, dans un autre ordre. Avance d\u2019une \xE9tape : remplace ou calcule.',
      kfor: { rels: a, trusted: !0 },
    };
  let S = SE(m);
  return {
    kind: 'step',
    atoms: t,
    line: r,
    hora: S.hora,
    final: k,
    rule: S,
    kfor: { rels: a, trusted: !0, ...(p !== void 0 ? { tool: p } : {}) },
  };
}
function SE(e) {
  if (e.length === 1) return e[0];
  let n = e.map((t) => t.label).filter((t, r, s) => s.indexOf(t) === r);
  return {
    id: e[0].id,
    card: e[0].card,
    label: n.join(' \u2192 '),
    hora: e.reduce((t, r) => t + r.hora, 0),
    why: e.map((t) => t.why).join(' '),
  };
}
function TE(e) {
  let n =
    e.length <= 1 ? (e[0] ?? 'la grandeur') : e.slice(0, -1).join(', ') + ' et ' + e[e.length - 1];
  return {
    id: Wf.replace,
    card: 'Calcul',
    label: 'Remplacer',
    hora: 2,
    why: `On remplace ${n} par ${e.length > 1 ? 'leurs valeurs' : 'sa valeur'}.`,
  };
}
function RE() {
  return {
    id: 'kernel.expand@1',
    card: 'Calcul litt\xE9ral',
    label: 'D\xE9velopper',
    hora: 1,
    why: 'On distribue : k \xD7 (a + b) = k \xD7 a + k \xD7 b.',
  };
}
function $E() {
  return {
    id: Wf.compute,
    card: 'Calcul',
    label: 'Calculer',
    hora: 1,
    why: 'On fait un calcul (un seul par endroit) : la valeur ne change pas, elle s\u2019\xE9crit plus simplement.',
  };
}
function hV(e, n, t, r) {
  let s = null,
    i = { same: 9, reorder: 8, replace: 1, compute: 1, expand: 2, jump: 9 };
  for (let l of t) {
    let u = Gy(e, l, n, r);
    if (u) {
      if (u.kind === 'same' && u.swapped) {
        if (wb(n, r) < wb(l, r))
          return {
            kind: 'step',
            rule: {
              id: Wf.swap,
              card: 'Calcul',
              label: '\xC9changer les membres',
              hora: 1,
              why: 'On lit la m\xEAme \xE9galit\xE9 dans l\u2019autre sens : la grandeur cherch\xE9e passe \xE0 gauche.',
            },
          };
        continue;
      }
      if (((!s || i[u.kind] < i[s.mv.kind]) && (s = { mv: u, f: l }), i[u.kind] === 1)) break;
    }
  }
  if (s?.mv.kind === 'replace') return { kind: 'step', rule: TE(s.mv.names) };
  if (s?.mv.kind === 'compute') return { kind: 'step', rule: $E() };
  if (s?.mv.kind === 'expand') return { kind: 'step', rule: RE() };
  let o = bV(e, n, r);
  if (o) return o;
  if (Tb(n, r).length) {
    let l = vV(e, n, t, r);
    if (l) return l;
  }
  return { kind: 'jump' };
}
function bV(e, n, t) {
  let r = yb(n);
  for (let s = 0; s < e.tools.length; s++) {
    let i = e.tools[s];
    if (e.lines.some((c) => c.tool === s)) continue;
    let o = (c) => ({
      kind: 'step',
      tool: s,
      rule: { id: Wf.tool, card: i.card, label: i.label, hora: i.hora, why: i.why + c },
    });
    if (dp(n).includes(fp(i.rel))) return o('');
    let l = new Set([...$(n.l), ...$(n.r)]);
    if (l.size === i.names.size && [...l].every((c) => i.names.has(c)) && pE(r, i.rf)) return o('');
    let u = Gy(e, i.rel, n, t);
    if (u && (u.kind === 'replace' || (u.kind === 'same' && u.swapped)))
      return o(u.kind === 'replace' ? ' On remplace aussit\xF4t par les valeurs connues.' : '');
  }
  return null;
}
function vV(e, n, t, r) {
  let s = { k: 'rel', rel: '=', l: n.l, r: n.r },
    i = 0;
  for (let o of t) {
    if (!Tb(o, r).length) continue;
    if (++i > 8) break;
    let a = { k: 'rel', rel: '=', l: o.l, r: o.r },
      l;
    try {
      l = Ss(a, s, { rules: Du(), hypotheses: e.hyps, branches: !1 });
    } catch {
      continue;
    }
    if (l.status !== 'valid' || l.proof !== 'rule' || !l.ruleId) continue;
    if (fE(n) < fE(o)) return { kind: 'jump' };
    if (wb(n, r) >= wb(o, r)) return { kind: 'regress' };
    let u = $b(l, s, a);
    return {
      kind: 'step',
      rule: { id: u.id, card: u.card, label: u.label, hora: u.hora, why: u.why },
    };
  }
  return null;
}
function fE(e) {
  let n = (t) => {
    let r = ME(t) ? Math.max(1, Nn(t)) : 0;
    if (r) return r;
    if (t.k === 'add') {
      let s = new Set();
      for (let i of t.c) {
        let o = CE(i);
        o !== null && (s.has(o) && r++, s.add(o));
      }
    }
    return t.k === 'add' || t.k === 'mul'
      ? r + t.c.reduce((s, i) => s + n(i), 0)
      : t.k === 'div' || t.k === 'pow' || t.k === 'binom'
        ? r + n(t.a) + n(t.b)
        : t.k === 'fn'
          ? r + n(t.a)
          : r;
  };
  return n(e.l) + n(e.r);
}
function CE(e) {
  if (hr(e)) return CE(e.c[1]);
  if (gr(e) !== null) return null;
  if (e.k === 'mul') {
    let n = e.c.filter((t) => gr(t) === null);
    if (n.length === 1) return Ye(n[0]);
  }
  return Ot(e) ? null : Ye(e);
}
function kV(e, n, t) {
  return Rb(e) && !e.model.rounding ? !1 : n.some((r) => Zy(e, r) !== null) && !_E(e, n);
}
function xV(e, n) {
  if (e.goals.length < 2) return !0;
  let t = [...el(e), ...n];
  return e.goals.every((r) => t.some((s) => Zy(e, s) === r));
}
function Zy(e, n) {
  for (let [t, r] of [
    [n.l, n.r],
    [n.r, n.l],
  ])
    if (!(t.k !== 'sym' || !e.goals.includes(t.n)) && !(!Ot(r) || !EE(e, t.n, r))) return t.n;
  return null;
}
function EE(e, n, t) {
  if (Cr(t) || Nn(t) === 0) return !0;
  let r = yV(e, n);
  return r && Ye(r) === Ye(t) ? !0 : !(!Vy(t) || (r && Nn(t) > Math.max(Nn(r), hE(t)) + 1));
}
function Jf(e) {
  if (e.k !== 'div' || !Cr(e.a) || !Cr(e.b)) return !1;
  let n = e.a.v,
    t = e.b.v;
  if (!B(n) || !B(t) || t.n <= 1n) return !1;
  let r = (s, i) => (i === 0n ? (s < 0n ? -s : s) : r(i, s % i));
  return r(n.n, t.n) === 1n;
}
function ME(e) {
  if (e.k === 'num' || e.k === 'sym' || hr(e) || Jf(e) || (e.k === 'fn' && e.f === 'deg') || !Ot(e))
    return !1;
  let n = Z(e);
  return n.ok && !!_n(n.rf);
}
function up(e) {
  if (ME(e)) return !0;
  switch (e.k) {
    case 'num':
    case 'sym':
      return !1;
    case 'add':
    case 'mul':
      return e.c.some(up);
    case 'div':
    case 'pow':
    case 'binom':
      return up(e.a) || up(e.b);
    case 'fn':
      return up(e.a);
  }
}
function yV(e, n) {
  let t = e.answer;
  return !t || t.k !== 'rel'
    ? null
    : t.l.k === 'sym' && t.l.n === n
      ? t.r
      : t.r.k === 'sym' && t.r.n === n
        ? t.l
        : null;
}
function Rb(e) {
  let n = e.model.rounding;
  return n ? (n.symbol ?? e.goals[0]) : null;
}
function _E(e, n) {
  let t = Rb(e);
  return t ? !e.lines.some((r) => r.approx && r.approx.name === t) : !1;
}
function Hy(e) {
  if (!Cr(e)) return null;
  let n = e.v.d,
    t = 0;
  for (; n % 10n === 0n; ) ((n /= 10n), t++);
  if (n !== 1n) {
    let r = e.v.d;
    for (; r % 2n === 0n || r % 5n === 0n; ) r = r % 2n === 0n ? r / 2n : r / 5n;
    if (r !== 1n) return null;
    for (let s = 0; s <= 12; s++) if ((10n ** BigInt(s) * e.v.n) % e.v.d === 0n) return s;
    return null;
  }
  return t;
}
function xb(e) {
  return e === 0
    ? '\xE0 l\u2019unit\xE9'
    : e === 1
      ? 'au dixi\xE8me'
      : e === 2
        ? 'au centi\xE8me'
        : e === 3
          ? 'au milli\xE8me'
          : `\xE0 ${e} chiffres apr\xE8s la virgule`;
}
function wV(e, n, t, r) {
  let s = n.line,
    i = n.members[n.members.length - 1],
    o = n.members[0],
    a = n.approx,
    l = Vu(e, i),
    u = Ot(a) ? D(a, {}) : NaN,
    c = Hy(a);
  if (!Number.isFinite(l) || !Number.isFinite(u) || c === null)
    return {
      kind: 'unjustified',
      atoms: t,
      line: s,
      title: 'Une valeur approch\xE9e',
      message: 'Apr\xE8s \xAB \u2248 \xBB, \xE9cris un nombre d\xE9cimal : la valeur approch\xE9e.',
    };
  let f = o.k === 'sym' ? o.n : null,
    d = Mi(l, c);
  if (!(Math.abs(d - u) < 1e-9 * Math.max(1, Math.abs(u)))) {
    let y = Math.trunc(l * 10 ** c) / 10 ** c;
    return Math.abs(y - u) < 1e-9 * Math.max(1, Math.abs(u))
      ? {
          kind: 'false',
          atoms: t,
          line: s,
          title: 'Arrondir, ce n\u2019est pas couper',
          message: `On regarde le chiffre suivant : s\u2019il vaut 5 ou plus, on arrondit au-dessus. Arrondis ${xb(c)}.`,
        }
      : {
          kind: 'false',
          atoms: t,
          line: s,
          title: 'Valeur approch\xE9e fausse',
          message: `${Jr(i)} ne vaut pas environ ${Jr(a)} : refais le calcul, puis arrondis ${xb(c)}.`,
        };
  }
  let p = [];
  for (let y = 1; y < n.members.length; y++) p.push({ l: o, r: n.members[y] });
  let g = null;
  if (
    n.members.length >= 2 &&
    !p.every((y) => el(e).some((S) => dp(y).includes(S.key))) &&
    ((g = wE(e, { ...n, approx: null }, t)),
    g.kind !== 'step' && g.kind !== 'useless' && g.kind !== 'dup')
  )
    return g;
  let h = e.model.rounding,
    b = Rb(e),
    v = f !== null && f === b,
    k =
      v &&
      (n.members.length >= 2 ||
        el(e).some(
          (y) =>
            (y.l.k === 'sym' && y.l.n === f && Ot(y.r)) ||
            (y.r.k === 'sym' && y.r.n === f && Ot(y.l)),
        ));
  if (h && v) {
    if (
      (c < h.places && Math.abs(Mi(l, h.places) - u) < 1e-9 * Math.max(1, Math.abs(u))
        ? h.places
        : c) !== h.places
    )
      return {
        kind: 'unjustified',
        atoms: t,
        line: s,
        title: c > h.places ? 'Garde moins de chiffres' : 'Pas assez pr\xE9cis',
        message: `La question demande une valeur arrondie ${xb(h.places)}.`,
      };
    let S = {
        id: Wf.round,
        card: 'Calcul',
        label: 'Arrondir',
        hora: h.hora ?? 1,
        why: `On arrondit la valeur exacte ${xb(h.places)}.`,
      },
      w = { rels: p, trusted: !0, approx: { name: f, value: a } };
    if (!k)
      return {
        kind: 'useless',
        atoms: t,
        line: s,
        jump: !0,
        final: !0,
        title: 'Juste !',
        message:
          'C\u2019est la bonne valeur approch\xE9e. \xC9cris d\u2019abord la valeur exacte, puis arrondis, pour gagner des HORA. Tu peux garder cette ligne sans HORA.',
        kfor: w,
      };
    let _ = g?.kind === 'step' ? g.rule : null,
      O = _ ? SE([_, S]) : S;
    return { kind: 'step', atoms: t, line: s, hora: O.hora, final: !0, rule: O, kfor: w };
  }
  return {
    kind: 'useless',
    atoms: t,
    line: s,
    title: 'Valeur approch\xE9e juste',
    message:
      'Ta valeur approch\xE9e est juste. Garde-la si elle t\u2019aide \xE0 te rep\xE9rer : la r\xE9ponse attendue est la valeur exacte.',
    kfor: { rels: g ? p : [], trusted: !0, approx: { name: f, value: a } },
  };
}
function SV(e, n, t, r) {
  let s = n.line,
    i = n.members[t],
    o = n.members[t + 1],
    a = { l: n.members[0], r: n.members[n.members.length - 1] };
  for (let c of [a, { l: i, r: o }]) {
    let f = TV(e, c);
    if (f)
      return {
        kind: 'trap',
        atoms: r,
        line: s,
        title: 'Pi\xE8ge : ' + pV(f.title),
        message: f.why,
        trap: { line: f.line, title: f.title, why: f.why },
        badChip: -1,
      };
  }
  let l = Hy(o);
  if (l !== null && Ot(o)) {
    let c = Vu(e, i),
      f = D(o, {});
    if (Number.isFinite(c) && Math.abs(Mi(c, l) - f) < 1e-9 * Math.max(1, Math.abs(f)))
      return {
        kind: 'unjustified',
        atoms: r,
        line: s,
        title: '\xC9cris \xAB \u2248 \xBB',
        message: `${Gf(i)} ne vaut pas exactement ${Jr(o)} : c\u2019en est une valeur arrondie. \xC9cris \xAB \u2248 \xBB \xE0 la place de \xAB = \xBB.`,
      };
  }
  let u = Ot(i) && Ot(o);
  return {
    kind: 'false',
    atoms: r,
    line: s,
    title: u ? 'Calcul faux' : 'Ce n\u2019est pas \xE9gal',
    message: u
      ? `${Gf(i)} ne fait pas ${Jr(o)} : refais ce calcul.`
      : `${Gf(i)} et ${Gf(o)} n\u2019ont pas la m\xEAme valeur : v\xE9rifie la formule et les valeurs.`,
  };
}
function TV(e, n) {
  let t = dp(n),
    r = e.traps.find((a) => t.includes(a.key));
  if (r) return r;
  let s = yb(Fy(e, n));
  if (!s) return null;
  let i = (a) => [...new Set([...$(a.l), ...$(a.r)])].filter((l) => !e.model.symbols[l]?.given),
    o = i(n).sort().join(',');
  return e.traps.find((a) => pE(s, a.rf) && i(Fy(e, a.rel)).sort().join(',') === o) ?? null;
}
function RV(e, n, t) {
  let r = n.line,
    [s, i] = n.members,
    o = Uy(e, n.cmp, s, i);
  if (o === null)
    return {
      kind: 'useless',
      atoms: t,
      line: r,
      unknown: !0,
      title: 'Je ne sais pas encore v\xE9rifier ce passage',
      message:
        'Je ne sais pas trancher cette comparaison. Garde-la sans HORA, ou \xE9cris-la autrement.',
      kfor: { rels: [], trusted: !1 },
    };
  if (!o)
    return {
      kind: 'false',
      atoms: t,
      line: r,
      title: 'Ce n\u2019est pas vrai',
      message: `${Gf(s)} ${n.cmp} ${Gf(i)} est faux : compare les valeurs.`,
    };
  let a = `${Ye(s)}${n.cmp}${Ye(i)}`,
    l = { '>': '<', '<': '>', '\u2265': '\u2264', '\u2264': '\u2265' },
    u = `${Ye(i)}${l[n.cmp]}${Ye(s)}`,
    c = e.checks.find((f) => f.key === a || f.key === u);
  if (c) {
    if (e.checked.has(c.key))
      return {
        kind: 'dup',
        atoms: t,
        line: r,
        title: 'D\xE9j\xE0 \xE9crit',
        message: 'Tu as d\xE9j\xE0 cette comparaison sur ta feuille.',
      };
    let f = bE(e),
      d = [...$(s), ...$(i)].filter((p) => !f.has(p));
    if (d.length)
      return {
        kind: 'unjustified',
        atoms: t,
        line: r,
        title: `Calcule d\u2019abord ${d[0]}`,
        message: `Pour comparer, il faut d\u2019abord la valeur de ${d[0]}.`,
      };
    let m = {
      id: Wf.check,
      card: 'Calcul',
      label: c.spec.label,
      hora: c.spec.hora ?? 2,
      why: c.spec.why,
    };
    return {
      kind: 'step',
      atoms: t,
      line: r,
      hora: m.hora,
      rule: m,
      kfor: { rels: [], trusted: !0, check: c.key },
    };
  }
  return {
    kind: 'useless',
    atoms: t,
    line: r,
    title: 'Juste, mais \xE0 c\xF4t\xE9',
    message: 'Ta comparaison est juste, mais elle ne sert pas cette question. Tu peux la garder.',
    kfor: { rels: [], trusted: !0 },
  };
}
function qE(e, n) {
  let t = n.kfor;
  t &&
    (e.lines.push({
      rels: t.rels,
      trusted: t.trusted,
      ...(t.approx ? { approx: t.approx } : {}),
      ...(t.tool !== void 0 ? { tool: t.tool } : {}),
    }),
    t.check && e.checked.add(t.check));
}
function LE(e) {
  let n = el(e);
  if (!e.goals.every((r) => n.some((s) => Zy(e, s) === r))) {
    let r = Rb(e);
    return !r || e.goals.length !== 1 ? !1 : e.lines.some((s) => s.approx?.name === r);
  }
  return !_E(e, []);
}
function NE(e) {
  let n = {},
    t = (r, s) => {
      if (!Number.isFinite(s)) return;
      let i = (n[r] ??= []);
      i.some((o) => Math.abs(o - s) < 1e-9) || i.push(s);
    };
  for (let r of el(e))
    for (let [s, i] of [
      [r.l, r.r],
      [r.r, r.l],
    ])
      s.k === 'sym' && e.goals.includes(s.n) && Ot(i) && EE(e, s.n, i) && t(s.n, D(i, {}));
  for (let r of e.lines)
    r.approx?.name && e.goals.includes(r.approx.name) && t(r.approx.name, D(r.approx.value, {}));
  return n;
}
function OE(e, n) {
  let t = cp(n);
  if (!t) return !1;
  if (t.cmp) return Uy(e, t.cmp, t.members[0], t.members[1]) === !0;
  for (let r = 0; r + 1 < t.members.length; r++)
    if (Qu(e, t.members[r], t.members[r + 1]) !== !0) return !1;
  if (t.approx) {
    let r = Vu(e, t.members[t.members.length - 1]),
      s = Hy(t.approx);
    return s === null ? !1 : Math.abs(Mi(r, s) - D(t.approx, {})) < 1e-9;
  }
  return !0;
}
var dE = 1,
  Ao = 2,
  Zf = 3,
  Xa = 4,
  jo = 5;
function $V(e) {
  let n = e.n < 0n,
    t = n ? -e.n : e.n;
  if (e.d === 1n) return { text: (n ? '\u2212' : '') + t.toString(), prec: n ? Zf : jo };
  let r = e.d,
    s = 0;
  for (; r % 2n === 0n || r % 5n === 0n; ) ((r = r % 2n === 0n ? r / 2n : r / 5n), s++);
  if (r === 1n)
    for (let i = 1; i <= 6; i++) {
      let o = 10n ** BigInt(i);
      if ((o * t) % e.d === 0n) {
        let a = ((t * o) / e.d).toString().padStart(i + 1, '0');
        return {
          text: (n ? '\u2212' : '') + a.slice(0, -i) + ',' + a.slice(-i),
          prec: n ? Zf : jo,
        };
      }
    }
  return { text: `${n ? '\u2212' : ''}${t}/${e.d}`, prec: n ? Zf : Ao };
}
function si(e, n) {
  return e.prec < n ? `(${e.text})` : e.text;
}
function $r(e) {
  switch (e.k) {
    case 'num':
      return $V(e.v);
    case 'sym':
      return { text: e.n, prec: jo };
    case 'add': {
      let n = '';
      return (
        e.c.forEach((t, r) => {
          let s = hr(t) ? t.c[1] : null,
            i =
              r > 0 && s && (s.k === 'mul' || s.k === 'div') && !hr(s)
                ? { text: '\u2212' + $r(s).text, prec: Ao }
                : $r(t);
          r === 0
            ? (n = i.text)
            : i.text.startsWith('\u2212') && i.prec >= Ao
              ? (n += ` \u2212 ${i.text.slice(1)}`)
              : (n += ` + ${i.prec <= dE ? `(${i.text})` : i.text}`);
        }),
        { text: n, prec: dE }
      );
    }
    case 'mul': {
      if (hr(e)) {
        let t = $r(e.c[1]);
        return { text: '\u2212' + si(t, Xa), prec: Zf };
      }
      let n = '';
      return (
        e.c.forEach((t, r) => {
          let s = $r(t),
            i = r > 0 && s.text.startsWith('\u2212') ? `(${s.text})` : si(s, Ao + 0.5);
          if (r === 0) n = i;
          else {
            let o = e.c[r - 1],
              a =
                r === 1 &&
                Cr(o) &&
                te(o.v) > 0 &&
                (t.k === 'sym' || (t.k === 'fn' && t.f === 'sqrt'));
            n += a ? i : ` \xD7 ${i}`;
          }
        }),
        { text: n, prec: Ao }
      );
    }
    case 'div':
      return Jf(e)
        ? { text: `${$r(e.a).text}/${$r(e.b).text}`, prec: Ao }
        : { text: `${si($r(e.a), Ao)} \xF7 ${si($r(e.b), Xa)}`, prec: Ao };
    case 'pow': {
      let n = si($r(e.a), jo);
      return Cr(e.b) && M(e.b.v, C(2))
        ? { text: `${n}\xB2`, prec: Xa }
        : { text: `${n}^${si($r(e.b), jo)}`, prec: Xa };
    }
    case 'binom':
      return { text: `${si($r(e.a), Xa)} parmi ${si($r(e.b), Xa)}`, prec: Ao };
    case 'fn': {
      let n = $r(e.a);
      return e.f === 'sqrt'
        ? { text: `\u221A${si(n, jo)}`, prec: Zf }
        : e.f === 'deg'
          ? { text: `${si(n, jo)}\xB0`, prec: Xa }
          : e.f === 'fact'
            ? { text: `${si(n, jo)}!`, prec: Xa }
            : e.f === 'abs'
              ? { text: `|${n.text}|`, prec: jo }
              : { text: `${e.f}(${n.text})`, prec: Zf };
    }
  }
}
function Jr(e) {
  return $r(e).text;
}
var Iy = null;
function Wy() {
  return (
    Iy ||
      (Iy = {
        model: { symbols: {}, goal: ['_'] },
        goals: [],
        answer: null,
        W: {},
        Wf: {},
        given: [],
        tools: [],
        traps: [],
        checks: [],
        hyps: [],
        path: [],
        lines: [],
        checked: new Set(),
      }),
    Iy
  );
}
function mp(e, n) {
  let t = Wy(),
    r = ii(t, e, n);
  if (!r) return 'jump';
  let s = xE(t, r, new Set());
  return s === 'replace' ? 'jump' : s;
}
function Fi(e, n) {
  return Qu(Wy(), e, n);
}
function Xf(e, n, t) {
  return Uy(Wy(), e, n, t);
}
function Yf(e) {
  return Nn(e);
}
function nl(e) {
  return Ye(e);
}
function Jy(e) {
  try {
    return zy(e);
  } catch {
    return null;
  }
}
function Kt(e) {
  switch (e.k) {
    case 'mul':
      return (e.c.some((n) => n.k === 'add') ? 1 : 0) + e.c.reduce((n, t) => n + Kt(t), 0);
    case 'pow':
      return (e.a.k === 'add' ? 1 : 0) + Kt(e.a) + Kt(e.b);
    case 'add':
      return e.c.reduce((n, t) => n + Kt(t), 0);
    case 'div':
    case 'binom':
      return Kt(e.a) + Kt(e.b);
    case 'fn':
      return Kt(e.a);
    default:
      return 0;
  }
}
function rr(e) {
  switch (e.k) {
    case 'mul': {
      let n = 0,
        t = 0,
        r = 0;
      for (let s of e.c) {
        let i = s.k === 'pow' && s.a.k === 'add' ? Fo(s.b) : null;
        s.k === 'add'
          ? ((n += 1), (r += rr(s)))
          : i !== null && s.k === 'pow'
            ? ((n += i), (r += rr(s.a)))
            : ((t += 1), (r += rr(s)));
      }
      return (n ? n - 1 + (t ? 1 : 0) : 0) + r;
    }
    case 'pow': {
      if (e.a.k === 'add') {
        let n = Fo(e.b);
        return (n !== null ? n - 1 : 1) + rr(e.a) + rr(e.b);
      }
      return rr(e.a) + rr(e.b);
    }
    case 'add':
      return e.c.reduce((n, t) => n + rr(t), 0);
    case 'div':
    case 'binom':
      return rr(e.a) + rr(e.b);
    case 'fn':
      return rr(e.a);
    default:
      return 0;
  }
}
function Qo(e) {
  switch (e.k) {
    case 'add':
      return e.c.reduce((n, t) => n + (t.k === 'add' ? 1 : 0) + Qo(t), 0);
    case 'mul':
      return e.c.reduce((n, t) => n + Qo(t), 0);
    case 'pow':
    case 'div':
    case 'binom':
      return Qo(e.a) + Qo(e.b);
    case 'fn':
      return Qo(e.a);
    default:
      return 0;
  }
}
function nt(e) {
  return e.k === 'mul' ? e.c.flatMap(nt) : [e];
}
var pp = (e) => e.k === 'num',
  Fo = (e) => (e.k === 'num' && e.v.d === 1n && e.v.n >= 1n && e.v.n <= 8n ? Number(e.v.n) : null),
  Xy = (e) => (e.k === 'pow' ? Xy(e.a) : e);
function Ts(e) {
  switch (e.k) {
    case 'mul': {
      let n = new Map();
      nt(e)
        .filter((r) => !pp(r) && r.k !== 'add')
        .forEach((r) => {
          let s = E(R(Xy(r)));
          n.set(s, (n.get(s) ?? 0) + 1);
        });
      let t = 0;
      return (n.forEach((r) => (t += r - 1)), t + e.c.reduce((r, s) => r + Ts(s), 0));
    }
    case 'pow': {
      let n = 0;
      e.a.k === 'pow' && (n += 1);
      let t = e.a.k === 'mul' ? nt(e.a) : [];
      return (
        t.length > 1 &&
          t.some((r) => !pp(r)) &&
          ((n += 1),
          (n += t.filter(
            (r) =>
              (r.k === 'num' && !(r.v.d === 1n && (r.v.n === 1n || r.v.n === -1n))) ||
              r.k === 'pow',
          ).length)),
        n + Ts(e.a) + Ts(e.b)
      );
    }
    case 'div': {
      let n = (o) =>
          new Set(
            nt(o)
              .filter((a) => !pp(a) && a.k !== 'add')
              .map((a) => E(R(Xy(a)))),
          ),
        t = n(e.a),
        r = [...n(e.b)],
        s = r.some((o) => t.has(o)) ? 1 : 0,
        i = R(e.a);
      if (!s && i.k === 'add' && r.length) {
        let o = i.c.map(n);
        r.some((a) => o.every((l) => l.has(a))) && (s = 1);
      }
      return s + Ts(e.a) + Ts(e.b);
    }
    case 'add':
      return e.c.reduce((n, t) => n + Ts(t), 0);
    case 'fn':
      return Ts(e.a);
    default:
      return 0;
  }
}
function Cb(e) {
  let n = [];
  for (let t of nt(e)) {
    if (t.k === 'num') {
      if (t.v.n === -1n && t.v.d === 1n) continue;
      n.push({ k: 'num', v: mn(t.v) });
      continue;
    }
    let r = t.k === 'pow' ? Fo(t.b) : null;
    if (t.k === 'pow' && r !== null && r <= 4 && t.a.k !== 'num') {
      let s = t.a.k === 'mul' ? nt(t.a) : [t.a];
      for (let i = 0; i < r; i++) n.push(...s);
      continue;
    }
    n.push(t);
  }
  return n;
}
var ed = (e) => E(R(e));
function CV(e) {
  let n = e.map(Cb);
  if (n.some((c) => c.length < 2)) return !1;
  let t = (c) => {
      let f = new Map();
      return (c.forEach((d) => f.set(ed(d), (f.get(ed(d)) ?? 0) + 1)), f);
    },
    r = n.map(t),
    s = E({ k: 'num', v: C(1) }),
    i = new Map();
  if (
    (r[0].forEach((c, f) => {
      let d = Math.min(c, ...r.slice(1).map((m) => m.get(f) ?? 0));
      d > 0 && f !== s && i.set(f, d);
    }),
    !i.size)
  )
    return !1;
  let o = n[0].filter((c) => c.k === 'num' && i.has(ed(c))),
    a = 1n,
    l = new Set();
  o.forEach((c) => {
    let f = ed(c);
    if (!(l.has(f) || c.k !== 'num' || c.v.d !== 1n)) {
      l.add(f);
      for (let d = 0; d < i.get(f); d++) a *= c.v.n;
    }
  });
  let u = e.map(EV);
  if (u.every((c) => c !== null)) {
    let c = u.reduce((d, m) => hp(d, m.coef), 0n);
    if (c > 1n && c !== a) return !1;
    let f = new Set(u.flatMap((d) => [...d.exps.keys()]));
    for (let d of f) {
      let m = Math.min(...u.map((p) => p.exps.get(d) ?? 0));
      if (m > 0 && (i.get(E({ k: 'sym', n: d })) ?? 0) !== m) return !1;
    }
  }
  return !0;
}
function EV(e) {
  let n = R(e),
    t = n.k === 'mul' ? n.c : [n],
    r = 1n,
    s = new Map();
  for (let i of t)
    if (i.k === 'num') {
      if (i.v.d !== 1n) return null;
      r *= i.v.n < 0n ? -i.v.n : i.v.n;
    } else if (i.k === 'sym') s.set(i.n, (s.get(i.n) ?? 0) + 1);
    else if (i.k === 'pow' && i.a.k === 'sym' && Fo(i.b) !== null)
      s.set(i.a.n, (s.get(i.a.n) ?? 0) + Fo(i.b));
    else return null;
  return { coef: r, exps: s };
}
function gp(e) {
  return e.k === 'pow' && Fo(e.b) === 2 ? e.a : null;
}
function Yy(e) {
  return e.k === 'mul' && e.c[0]?.k === 'num' && e.c[0].v.n === -1n && e.c[0].v.d === 1n
    ? { neg: !0, body: e.c.length === 2 ? e.c[1] : { k: 'mul', c: e.c.slice(1) } }
    : { neg: !1, body: e };
}
function MV(e) {
  if (e.length !== 2) return !1;
  let [n, t] = e.map(Yy);
  return n.neg !== t.neg && !!gp(n.body) && !!gp(t.body);
}
function _V(e) {
  if (e.length !== 3) return !1;
  let n = e.map((t) => ({ t, s: Yy(t) })).filter((t) => !t.s.neg && gp(t.s.body));
  if (n.length < 2) return !1;
  for (let t = 0; t < n.length; t++)
    for (let r = t + 1; r < n.length; r++) {
      let s = e.find((a) => a !== n[t].t && a !== n[r].t);
      if (!s) continue;
      let i = [{ k: 'num', v: C(2) }, ...Cb(gp(n[t].s.body)), ...Cb(gp(n[r].s.body))]
          .map(ed)
          .sort(),
        o = Cb(Yy(s).body).map(ed).sort();
      if (i.length === o.length && i.every((a, l) => a === o[l])) return !0;
    }
  return !1;
}
function IE(e) {
  return e.k === 'pow'
    ? e.a.k === 'add'
    : e.k !== 'mul'
      ? !1
      : nt(e).some((n) => n.k === 'add' || (n.k === 'pow' && n.a.k === 'add'));
}
function qV(e) {
  return (e.k === 'pow' ? [e] : nt(e)).reduce((t, r) => {
    let s = r.k === 'pow' && r.a.k === 'add' ? r.a : r;
    return t + (s.k === 'add' ? Kt(s) + Qo(s) : Kt(s));
  }, 0);
}
var hp = (e, n) => (n === 0n ? (e < 0n ? -e : e) : hp(n, e % n));
function Vi(e, n = new Set()) {
  return (
    e.k === 'sym'
      ? n.add(e.n)
      : e.k === 'add' || e.k === 'mul'
        ? e.c.forEach((t) => Vi(t, n))
        : e.k === 'pow' || e.k === 'div' || e.k === 'binom'
          ? (Vi(e.a, n), Vi(e.b, n))
          : e.k === 'fn' && Vi(e.a, n),
    n
  );
}
function LV(e) {
  let n = R(e);
  if (n.k !== 'add') return !0;
  let t = 0n,
    r = !0,
    s;
  for (let i of n.c) {
    let o = i.k === 'mul' ? i.c : [i],
      a = o.find((f) => f.k === 'num'),
      l = a && a.k === 'num' ? a.v : { n: 1n, d: 1n };
    (l.d !== 1n && (r = !1), (t = hp(t, l.n)));
    let u = new Set();
    o.filter((f) => f.k !== 'num').forEach((f) => Vi(f, u));
    let c = s;
    s = c ? new Set([...c].filter((f) => u.has(f))) : u;
  }
  return (r && t > 1n) || (s && s.size > 0) ? !1 : !AE(n);
}
function AE(e) {
  let n;
  try {
    n = Ge(e);
  } catch {
    return !1;
  }
  if (!an(n.d)) return !1;
  let t = [...Lt(n.n)];
  if (t.length !== 1) return !1;
  let r = Ys(n.n, t[0]);
  if (!r || r.length < 3) return !1;
  let s = Jh(n.n, t[0]);
  return !!s && s.length > 0;
}
function NV(e) {
  return (e.k === 'pow' ? [e] : nt(e)).reduce((t, r) => {
    let s = r.k === 'pow' && r.a.k === 'add' ? r.a : r;
    return s.k !== 'add' || LV(s) ? t : t + Math.max(1, OV(s) - 1);
  }, 0);
}
function OV(e) {
  try {
    let n = Ge(e),
      t = [...Lt(n.n)];
    if (t.length !== 1 || !an(n.d)) return 1;
    let r = Ys(n.n, t[0]);
    return r ? r.length - 1 : 1;
  } catch {
    return 1;
  }
}
function KV(e) {
  if (e.k === 'div') return e.b;
  if (e.k !== 'mul') return null;
  let n = nt(e),
    t = n.filter((r) => r.k === 'div');
  return t.length !== 1 || n.some((r) => r.k !== 'div' && Vi(r).size > 0) ? null : t[0].b;
}
function t1(e) {
  if (e.k === 'div') return { n: e.a, d: e.b };
  if (e.k !== 'mul') return null;
  let n = nt(e),
    t = n.filter((r) => r.k === 'div');
  return t.length !== 1 || n.some((r) => r.k !== 'div' && r.k !== 'num')
    ? null
    : { n: t[0].a, d: t[0].b };
}
function PV(e, n) {
  let t = (a) => {
      let l = [...a];
      for (; l.length > 1 && L(l[l.length - 1]); ) l.pop();
      return l;
    },
    r = (a) => a.length === 1 && L(a[0]),
    s = (a, l) => {
      let u = t(a),
        c = l.length - 1,
        f = l[c];
      for (let d = 0; d < 64 && !r(u) && u.length - 1 >= c; d++) {
        let m = A(u[u.length - 1], f),
          p = u.length - 1 - c;
        for (let g = 0; g <= c; g++) u[p + g] = me(u[p + g], N(m, l[g]));
        ((u = u.slice(0, u.length - 1)), (u = u.length ? t(u) : [F]));
      }
      return u;
    },
    i = t(e),
    o = t(n);
  for (let a = 0; a < 64 && !r(o); a++) {
    let l = s(i, o);
    ((i = o), (o = l));
  }
  return i.length - 1;
}
function KE(e) {
  let n = 0n;
  for (let { c: t } of e.t.values()) {
    if (t.d !== 1n) return 0n;
    n = hp(n, t.n);
  }
  return n;
}
function IV(e, n) {
  let t, r;
  try {
    ((t = Ge(e)), (r = Ge(n)));
  } catch {
    return !1;
  }
  if (!an(t.d) || !an(r.d)) return !0;
  let s = KE(t.n),
    i = KE(r.n);
  if (s > 1n && i > 1n && hp(s, i) > 1n) return !0;
  if (an(r.n)) return !1;
  let o = (c, f) =>
    c.some((d) => {
      let m = d.k === 'pow' ? d.a : d;
      if (Vi(m).size === 0) return !1;
      try {
        let p = Ge(m);
        return an(p.d) && !an(p.n) && !!Tr(f, p.n);
      } catch {
        return !1;
      }
    });
  if (o(nt(n), t.n) || o(nt(e), r.n)) return !0;
  let a = [...new Set([...Lt(t.n), ...Lt(r.n)])];
  if (a.length !== 1) return !1;
  let l = Ys(t.n, a[0]),
    u = Ys(r.n, a[0]);
  return !l || !u ? !1 : l.every((c) => L(c)) ? !0 : PV(l, u) > 0;
}
function jE(e) {
  let n = e.k === 'add' ? e.c : [e];
  if (n.length < 2) return null;
  let t = n.map((i) => {
    let o = t1(i);
    return o ? { n: i.k === 'div' ? o.n : AV(i, o.n), d: o.d } : { n: i, d: null };
  });
  if (new Set(t.map((i) => (i.d ? E(R(i.d)) : '1'))).size !== t.length) return null;
  let s = 0;
  try {
    for (let i = 0; i < t.length; i++) {
      let o = t.filter((u, c) => c !== i && t[c].d).map((u) => u.d),
        a = o.length ? { k: 'mul', c: [t[i].n, ...o] } : t[i].n,
        l = Ge(a);
      if (!an(l.d)) return null;
      s += Math.max(1, l.n.t.size);
    }
  } catch {
    return null;
  }
  return s;
}
function AV(e, n) {
  if (e.k !== 'mul') return n;
  let t = nt(e).filter((r) => r.k !== 'div');
  return t.length ? { k: 'mul', c: [...t, n] } : n;
}
function QE(e) {
  let n = t1(e),
    t = n ? n.n : e;
  return t.k === 'add' ? t.c.length : 1;
}
function Uu(e) {
  switch (e.k) {
    case 'div':
      return !0;
    case 'add':
    case 'mul':
      return e.c.some(Uu);
    case 'pow':
    case 'binom':
      return Uu(e.a) || Uu(e.b);
    case 'fn':
      return Uu(e.a);
    default:
      return !1;
  }
}
function jV(e, n) {
  let t = (s) =>
      new Set(
        nt(s)
          .map((i) => (i.k === 'pow' ? i.a : i))
          .filter((i) => Vi(i).size > 0)
          .map((i) => E(R(i))),
      ),
    r = t(e);
  return [...t(n)].some((s) => r.has(s));
}
function e1(e) {
  let n = t1(e);
  if (n && (Uu(n.n) || Uu(n.d))) {
    let i = e1(n.n),
      o = Uu(n.d) ? e1(n.d).h + 1 : 0;
    return {
      h: 5 + i.h + o,
      dens: 1,
      parts: 1,
      numExpand: 0,
      reducible: !0,
      visible: !1,
      inner: i,
    };
  }
  if (n) {
    let i = rr(n.n) + Qo(n.n),
      o = IV(n.n, n.d),
      a = o && jV(n.n, n.d);
    return {
      h: o ? (a ? 1 : i + 2) : i,
      dens: 1,
      parts: 1,
      numExpand: i,
      reducible: o,
      visible: a,
    };
  }
  let t = e.k === 'add' ? e.c : [e],
    r = new Set(),
    s = 0;
  for (let i of t) {
    let o = KV(i);
    (o && (s += 1), r.add(o ? E(R(o)) : '1'));
  }
  if (!s) {
    let i = rr(e) + Qo(e);
    return { h: i, dens: 1, parts: t.length, numExpand: i, reducible: !1, visible: !1 };
  }
  return {
    h: 10 + 2 * (r.size - 1) + 1,
    dens: r.size,
    parts: t.length,
    numExpand: 0,
    reducible: !1,
    visible: !1,
  };
}
function FE(e, n, t) {
  let r = Qo(e);
  if (n === 'fraction') {
    let o = e1(e);
    return { h: o.h, pow: Ts(e), nested: r, product: !1, pattern: null, done: o.h === 0, frac: o };
  }
  if (n === 'canonical') {
    let o = DV(e);
    return { h: o, pow: 0, nested: r, product: !1, pattern: null, done: o === 0 };
  }
  if (n === 'expanded') {
    let o = rr(e),
      a = Ts(e);
    return {
      h: o + r,
      pow: a,
      nested: r,
      product: !1,
      pattern: null,
      done: o === 0 && r === 0 && a === 0,
    };
  }
  if (IE(e)) {
    let o = qV(e),
      l = !!t && E(R(e)) === t ? 0 : NV(e),
      u = l === 0;
    return {
      h: o ? 3 : u ? 0 : 3 + l,
      pow: 0,
      nested: r,
      product: !0,
      pattern: null,
      done: o === 0 && u,
    };
  }
  let s = e.k === 'add' ? e.c : [e],
    i = s.length < 2 ? null : MV(s) ? 'squares' : _V(s) ? 'perfect' : CV(s) ? 'common' : null;
  return { h: i ? 7 : 10, pow: 0, nested: r, product: !1, pattern: i, done: !1 };
}
var tl = (e) => Vi(e).size === 0;
function QV(e, n) {
  if (e.k === 'sym') return e.n === n;
  if (e.k !== 'add' || e.c.length !== 2) return !1;
  let [t, r] = e.c;
  return (t.k === 'sym' && t.n === n && tl(r)) || (r.k === 'sym' && r.n === n && tl(t));
}
function PE(e, n) {
  let t = (s) => s.k === 'pow' && Fo(s.b) === 2 && QV(s.a, n);
  if (t(e)) return !0;
  if (e.k !== 'mul') return !1;
  let r = nt(e);
  return r.filter(t).length === 1 && r.every((s) => t(s) || tl(s));
}
function Bu(e, n) {
  let t = nt(e),
    r = 0;
  for (let s of t)
    if (!tl(s))
      if (s.k === 'sym' && s.n === n) r += 1;
      else if (s.k === 'pow' && s.a.k === 'sym' && s.a.n === n && Fo(s.b) !== null) r += Fo(s.b);
      else return 0;
  return r;
}
function FV(e, n) {
  let t = e.filter((r) => Bu(r, n) === 2);
  return t.length !== 1
    ? !1
    : nt(t[0]).every((r) => !tl(r) || (r.k === 'num' && r.v.n === 1n && r.v.d === 1n));
}
function VV(e) {
  if (e.k === 'add') return e;
  if (e.k !== 'mul') return null;
  let n = nt(e),
    t = n.filter((r) => r.k === 'add');
  return t.length === 1 && n.every((r) => r.k === 'add' || tl(r)) ? t[0] : null;
}
function DV(e) {
  let n = [...Vi(e)];
  if (n.length !== 1) return 4;
  let t = n[0],
    s = (e.k === 'add' ? e.c : [e]).filter((i) => !tl(i));
  if (s.length === 1 && PE(s[0], t)) return 0;
  if (s.length === 1) {
    let i = VV(s[0]);
    if (i) {
      let o = i.k === 'add' ? i.c : [i],
        a = o.filter((l) => !tl(l));
      if (a.length === 1 && PE(a[0], t)) return 1;
      if (
        a.length === o.length &&
        a.every((l) => Bu(l, t) > 0) &&
        a.some((l) => Bu(l, t) === 2) &&
        a.every((l) => Bu(l, t) <= 2)
      )
        return 2;
    }
  }
  return s.length >= 1 &&
    s.every((i) => Bu(i, t) > 0 && Bu(i, t) <= 2) &&
    s.some((i) => Bu(i, t) === 2)
    ? FV(s, t)
      ? 2
      : 3
    : 4;
}
function VE(e, n) {
  return (n.k === 'mul' ? nt(n) : [n]).some((r) => r.k === 'pow' && r.a.k === 'add') ||
    e === 'perfect'
    ? 'On reconna\xEEt une identit\xE9 remarquable : a\xB2 + 2ab + b\xB2 = (a + b)\xB2, a\xB2 \u2212 2ab + b\xB2 = (a \u2212 b)\xB2.'
    : e === 'squares'
      ? 'On reconna\xEEt une identit\xE9 remarquable : a\xB2 \u2212 b\xB2 = (a \u2212 b)(a + b).'
      : 'On met le facteur commun en \xE9vidence : ka + kb = k(a + b).';
}
function zu(e) {
  switch (e.k) {
    case 'pow': {
      let n = e.a.k === 'mul' ? nt(e.a) : [];
      return n.length > 1 &&
        n.some((t) => !pp(t)) &&
        n.some(
          (t) =>
            (t.k === 'num' && !(t.v.d === 1n && (t.v.n === 1n || t.v.n === -1n))) || t.k === 'pow',
        )
        ? !0
        : zu(e.a) || zu(e.b);
    }
    case 'add':
    case 'mul':
      return e.c.some(zu);
    case 'div':
    case 'binom':
      return zu(e.a) || zu(e.b);
    case 'fn':
      return zu(e.a);
    default:
      return !1;
  }
}
function n1(e) {
  if (e.k === 'mul') {
    let n = nt(e);
    return n.some((t) => t.k === 'pow' && t.a.k === 'num') &&
      n.some((t) => !pp(t) && !(t.k === 'pow' && t.a.k === 'num'))
      ? !0
      : e.c.some(n1);
  }
  return e.k === 'add' ? e.c.some(n1) : !1;
}
function BV(e) {
  try {
    return Te(e).some(Ds);
  } catch {
    return !1;
  }
}
function DE(e, n) {
  let t = e.kernel;
  if (!t || !['algebra', 'formula', 'claims'].includes(t.plugin ?? '')) return !1;
  let s = [
    ...[t.start ?? '', ...(t.path ?? []), ...(t.givens ?? []), t.answer ?? ''],
    ...(e.traps ?? []).map((c) => c.line ?? ''),
    ...(e.choices ?? []).map((c) => c.line ?? ''),
    ...(t.claims ?? []).flatMap((c) => [...(c.rels ?? []), ...Object.values(c.at ?? {})]),
  ];
  if (s.some(BV)) return !0;
  let i = t.goal?.target ?? 'x';
  if (t.method === 'factor' && n && s.some((c) => !!c && n(c, i))) return !0;
  if (!t.form) return !1;
  let o = (c) => {
      let f = ie(c);
      return !f.ok || f.s.k !== 'rel' || f.s.rel !== '='
        ? null
        : f.s.l.k === 'sym' && f.s.l.n === i
          ? f.s.r
          : null;
    },
    a = [t.start ?? '', ...(t.path ?? [])].map(o),
    l = o(t.answer ?? ''),
    u = l ? E(R(l)) : '';
  for (let c = 1; c < a.length; c++) {
    let f = a[c - 1],
      d = a[c];
    if (!(!f || !d)) {
      if (t.form === 'expanded') {
        if ((Kt(f) === Kt(d) && rr(d) < rr(f)) || (zu(f) && n1(d))) return !0;
      } else if (
        IE(d) &&
        E(R(d)) !== u &&
        (d.k === 'pow' ? [d] : nt(d)).some(
          (p) =>
            (p.k === 'pow' && p.a.k === 'add' ? p.a : p).k === 'add' &&
            AE(p.k === 'pow' && p.a.k === 'add' ? p.a : p),
        )
      )
        return !0;
    }
  }
  return !1;
}
var Di = (e) => nl(e);
function vp(e) {
  return [...$(e)].filter((n) => n !== '\u03C0').sort();
}
var _b = (e) => vp(e).length > 0;
function qb(e, n) {
  let t = qn(e, n);
  return t === 'equal' ? !0 : t === 'different' ? !1 : null;
}
function zE(e) {
  let n = Z(e);
  if (!n.ok || !an(n.rf.d)) return null;
  let t = je(n.rf.d);
  if (!t || L(t)) return null;
  let r = A(q, t);
  return r ? kn(lt(n.rf.n, r)) : null;
}
function Zu(e) {
  switch (e.k) {
    case 'add':
      return { k: 'add', c: e.c.map(Zu) };
    case 'mul': {
      let n = e.c.map(Zu).flatMap((s) => (s.k === 'mul' ? s.c : [s])),
        t = n.filter((s) => s.k === 'num'),
        r = t.find((s) => M(s.v, C(-1)));
      if (t.length === 2 && r) {
        let s = t.find((i) => i !== r);
        ((n = n.filter((i) => i !== r && i !== s)), n.unshift({ k: 'num', v: fe(s.v) }));
      }
      return n.length === 1 ? n[0] : { k: 'mul', c: n };
    }
    case 'pow':
    case 'div':
    case 'binom':
      return { ...e, a: Zu(e.a), b: Zu(e.b) };
    case 'fn':
      return { ...e, a: Zu(e.a) };
    default:
      return e;
  }
}
function UE(e) {
  if (!_b(e)) return !1;
  if (GE(e)) return !0;
  let n = zE(e);
  return n ? Di(Zu(e)) === Di(Zu(n)) : !1;
}
function nd(e) {
  return e.k === 'num' && B(e.v) ? e.v : null;
}
function Gu(e) {
  if (e.k === 'sym' && e.n !== '\u03C0') return { x: e.n, e: q };
  if (e.k === 'pow' && e.a.k === 'sym' && e.a.n !== '\u03C0') {
    let n = nd(e.b);
    return n ? { x: e.a.n, e: n } : null;
  }
  return null;
}
function BE(e) {
  let n = e.k === 'mul' ? e.c : [e],
    t = [];
  for (let r of n) {
    let s = Gu(r);
    if (!s || Re(s.e, q) < 0 || (r.k === 'pow' && M(s.e, q)) || t.includes(s.x)) return null;
    t.push(s.x);
  }
  return t;
}
function GE(e) {
  if (e.k !== 'div') return !1;
  let n = BE(e.b);
  if (!n) return !1;
  if (e.a.k === 'num') return M(e.a.v, q);
  let t = BE(e.a);
  return !!t && !t.some((r) => n.includes(r));
}
var Vo = (e, n) => Di(e) === Di(n);
function ZE(e, n) {
  if (e.k === 'pow' && e.b.k === 'add' && n.k === 'pow' && Vo(e.a, n.a)) {
    let r = e.b.c.map(nd),
      s = nd(n.b);
    if (s && r.every((i) => i !== null)) {
      let i = r.reduce((o, a) => re(o, a), F);
      if (M(i, s) && e.a.k === 'sym' && e.a.n !== '\u03C0') return 'compute';
    }
  }
  let t = Gu(e);
  if (t && e.k === 'pow') {
    if (te(t.e) < 0 && n.k === 'div' && n.a.k === 'num' && M(n.a.v, q)) {
      let r = Gu(n.b);
      if (r && r.x === t.x && M(r.e, fe(t.e))) return 'power';
    }
    if (L(t.e) && n.k === 'num' && M(n.v, q)) return 'power';
  }
  if (e.k === 'div') {
    let r = Gu(e.a),
      s = Gu(e.b);
    if (r && s && r.x === s.x) {
      let i = me(r.e, s.e);
      if (n.k === 'pow' && n.a.k === 'sym' && n.a.n === r.x && n.b.k === 'add') {
        let a = n.b.c.map(nd);
        if (a.length === 2 && a.every((l) => l !== null) && M(a[0], r.e) && M(a[1], fe(s.e)))
          return 'power';
      }
      let o = Gu(n);
      if (
        (o && o.x === r.x && M(o.e, i) && !L(i)) ||
        (L(i) && ((n.k === 'num' && M(n.v, q)) || (o && L(o.e))))
      )
        return 'power';
      if (te(i) < 0 && n.k === 'div' && n.a.k === 'num' && M(n.a.v, q)) {
        let a = Gu(n.b);
        if (a && a.x === r.x && M(a.e, fe(i))) return 'power';
      }
    }
    if (
      e.a.k === 'pow' &&
      e.b.k === 'pow' &&
      n.k === 'pow' &&
      n.a.k === 'div' &&
      nd(e.a.b) &&
      Vo(e.a.b, e.b.b) &&
      Vo(n.b, e.a.b) &&
      Vo(n.a.a, e.a.a) &&
      Vo(n.a.b, e.b.a)
    )
      return 'power';
  }
  return e.k === 'pow' &&
    e.a.k === 'div' &&
    n.k === 'div' &&
    n.a.k === 'pow' &&
    n.b.k === 'pow' &&
    nd(e.b) &&
    Vo(n.a.b, e.b) &&
    Vo(n.b.b, e.b) &&
    Vo(n.a.a, e.a.a) &&
    Vo(n.b.a, e.a.b)
    ? 'power'
    : null;
}
function HE(e) {
  let n = (t) => {
    if (GE(t)) return !0;
    switch (t.k) {
      case 'add':
      case 'mul':
        return t.c.some(n);
      case 'div':
      case 'pow':
      case 'binom':
        return n(t.a) || n(t.b);
      case 'fn':
        return n(t.a);
      default:
        return !1;
    }
  };
  for (let t of e)
    for (let r of t.split(/[=<>≤≥≠]/)) {
      let s = ie(r.trim());
      if (s.ok && s.s.k === 'expr' && n(s.s.e)) return !0;
    }
  return !1;
}
function WE(e) {
  for (let n of e) {
    if (/[<>≤≥]/.test(n)) continue;
    let t = n.split('=').map((r) => {
      let s = ie(r.trim());
      return s.ok && s.s.k === 'expr' ? s.s.e : null;
    });
    if (!(t.length < 2 || t.some((r) => !r))) {
      for (let r = 0; r + 1 < t.length; r++) if (ZE(t[r], t[r + 1])) return !0;
    }
  }
  return !1;
}
var Eb = (e, n) => e.k === 'num' && M(e.v, C(n));
function rl(e) {
  switch (e.k) {
    case 'add': {
      let n = e.c.map(rl).filter((t) => !Eb(t, 0));
      return n.length === 0 ? { k: 'num', v: F } : n.length === 1 ? n[0] : { k: 'add', c: n };
    }
    case 'mul': {
      let n = e.c.map(rl);
      if (n.some((r) => Eb(r, 0))) return { k: 'num', v: F };
      let t = n.filter((r) => !Eb(r, 1));
      return t.length === 0 ? { k: 'num', v: q } : t.length === 1 ? t[0] : { k: 'mul', c: t };
    }
    case 'pow': {
      let n = rl(e.a),
        t = rl(e.b);
      return Eb(t, 1) ? n : { k: 'pow', a: n, b: t };
    }
    case 'div':
    case 'binom':
      return { ...e, a: rl(e.a), b: rl(e.b) };
    case 'fn':
      return { ...e, a: rl(e.a) };
    default:
      return e;
  }
}
function zV(e, n) {
  if (e.k !== 'pow' || e.b.k !== 'num' || n.k !== 'mul') return !1;
  let t = en(e.b.v);
  if (!Number.isInteger(t) || t < 2 || t > 6 || n.c.length !== t) return !1;
  let r = Di(e.a);
  return n.c.every((s) => Di(s) === r);
}
var bp = new Map(),
  UV = 2e3;
function GV(e, n) {
  let t = new Set([...vp(e), ...vp(n)]);
  return ['T', 'S', 'R', 'Z', 'W'].find((r) => !t.has(r)) ?? '\u03A9';
}
function JE(e, n) {
  let t = `${Di(e)}\u2192${Di(n)}`;
  if (bp.has(t)) return bp.get(t);
  let r = ZV(e, n);
  return (bp.size >= UV && bp.clear(), bp.set(t, r), r);
}
function r1(e, n, t, r) {
  let s = `${n} = ${oe(r)}`;
  return {
    symbols: {},
    goal: [n],
    kernel: {
      plugin: 'algebra',
      goal: { kind: 'simplify', target: n },
      form: e,
      start: `${n} = ${oe(t)}`,
      answer: s,
      path: [s],
    },
  };
}
function s1(e, n, t) {
  try {
    let r = Lb(e),
      s = o1(`${n} = ${oe(t)}`),
      i = Nb(
        r,
        s.map((o) => ({ atoms: [o] })),
        { verify: !0 },
      );
    return i.kind === 'step' ? (i.rule?.label ?? '') : null;
  } catch {
    return null;
  }
}
function ZV(e, n) {
  if (Di(rl(e)) === Di(n)) return 'neutral';
  let t = ZE(e, n);
  if (t) return t;
  if (zV(e, n)) return 'powerExpand';
  let r = zE(e);
  if (!r) return null;
  let s = GV(e, n);
  if (e.k === 'add' && HV(n)) {
    let a = s1(r1('factored', s, e, n), s, n);
    return a !== null && /^(Factoriser|Faire apparaître|Écrire les carrés)/.test(a)
      ? 'factor'
      : null;
  }
  let i = s1(r1('expanded', s, e, r), s, n);
  if (i !== null)
    return i.startsWith('D\xE9velopper')
      ? Hu(n) < Hu(e) && Mb(n) <= Mb(e)
        ? 'compute'
        : 'expand'
      : i.startsWith('Enlever les parenth\xE8ses')
        ? 'parens'
        : i.startsWith('R\xE8gles des puissances')
          ? 'power'
          : i.startsWith('Simplifier la fraction')
            ? 'fraction'
            : Ts(n) < Ts(e) && Mb(e) === Mb(n)
              ? 'power'
              : 'compute';
  let o = s1(r1('factored', s, e, n), s, n);
  return o !== null && /^(Factoriser|Faire apparaître|Écrire les carrés)/.test(o) ? 'factor' : null;
}
function HV(e) {
  return e.k === 'pow'
    ? e.a.k === 'add'
    : e.k === 'mul' && e.c.some((n) => n.k === 'add' || (n.k === 'pow' && n.a.k === 'add'));
}
var Mb = (e) => (e.k === 'add' ? e.c.length : 1);
function Hu(e) {
  switch (e.k) {
    case 'add':
      return e.c.length + e.c.reduce((n, t) => n + Hu(t), 0);
    case 'mul':
      return e.c.reduce((n, t) => n + Hu(t), 0);
    case 'pow':
    case 'div':
    case 'binom':
      return Hu(e.a) + Hu(e.b);
    case 'fn':
      return Hu(e.a);
    default:
      return 0;
  }
}
var i1 = [1, 2, 3, -1, 4, 5, 10, -2];
function XE(e, n) {
  let t = [...new Set([...vp(e), ...vp(n)])];
  if (!t.length || t.length > 3) return null;
  for (let r = 0; r < i1.length; r++) {
    let s = {};
    t.forEach((l, u) => (s[l] = C(i1[(r + u * 2) % i1.length])));
    let i = null,
      o = null;
    try {
      ((i = Ai(e, s)), (o = Ai(n, s)));
    } catch {
      continue;
    }
    if (!i || !o || M(i, o)) continue;
    return {
      at: t.map((l) => `${l} = ${Jr({ k: 'num', v: s[l] })}`).join(', '),
      va: Jr({ k: 'num', v: i }),
      vb: Jr({ k: 'num', v: o }),
    };
  }
  return null;
}
var Qe = {
    compute: 'kernel.compute@1',
    expand: 'kernel.expand@1',
    replace: 'kernel.substitute@1',
    signs: 'claims.signs@1',
    power: 'claims.power@1',
    fraction: 'claims.fraction@1',
    trig: 'claims.trig@1',
    root: 'claims.root@1',
    factor: 'claims.factor@1',
    scientific: 'claims.scientific@1',
    euclid: 'claims.euclid@1',
    ln: 'claims.ln@1',
    fractionPrimes: 'claims.fraction_primes@1',
    decide: 'claims.decide@1',
  },
  oM = 'Calcul',
  sl = {
    compute: {
      id: Qe.compute,
      label: 'Calculer',
      hora: 1,
      why: 'On fait un calcul (un seul par endroit) : la valeur ne change pas, elle s\u2019\xE9crit plus simplement.',
    },
    expand: {
      id: Qe.expand,
      label: 'D\xE9velopper',
      hora: 1,
      why: 'On distribue : k \xD7 (a + b) = k \xD7 a + k \xD7 b.',
    },
    expandLetters: {
      id: Qe.expand,
      label: 'D\xE9velopper',
      hora: 1,
      why: 'On d\xE9veloppe un produit (k(a + b) = ka + kb, (a + b)(c + d) = ac + ad + bc + bd, (a \u2212 b)\xB2 = a\xB2 \u2212 2ab + b\xB2\u2026) : l\u2019expression ne change pas, elle s\u2019\xE9crit autrement.',
    },
    parens: {
      id: Qe.expand,
      label: 'Enlever les parenth\xE8ses',
      hora: 1,
      why: 'Des parenth\xE8ses pr\xE9c\xE9d\xE9es de \xAB + \xBB s\u2019enl\xE8vent sans rien changer ; pr\xE9c\xE9d\xE9es de \xAB \u2212 \xBB, on change le signe de chaque terme.',
    },
    reduce: {
      id: Qe.compute,
      label: 'R\xE9duire',
      hora: 1,
      why: 'On calcule les nombres et on regroupe les termes semblables (5x + 5x = 10x, x \xD7 x = x\xB2) : l\u2019expression ne change pas.',
    },
    factorLetters: {
      id: Qe.factor,
      label: 'Factoriser',
      hora: 1,
      why: 'On met un facteur commun en \xE9vidence (ka + kb = k(a + b)) ou on reconna\xEEt une identit\xE9 remarquable : l\u2019expression ne change pas.',
    },
    powerRules: {
      id: Qe.power,
      label: 'R\xE8gles des puissances',
      hora: 1,
      why: 'a\u207F \xD7 a\u1D50 = a\u207F\u207A\u1D50, a\u207F \xF7 a\u1D50 = a\u207F\u207B\u1D50, (a\u207F)\u1D50 = a\u207F\u02E3\u1D50.',
    },
    replace: {
      id: Qe.replace,
      label: 'Remplacer',
      hora: 2,
      why: 'On remplace la lettre par la valeur propos\xE9e.',
    },
    signs: {
      id: Qe.signs,
      label: 'R\xE8gle des signes',
      hora: 1,
      why: 'On enl\xE8ve les parenth\xE8ses d\u2019un nombre relatif : soustraire \u22123, c\u2019est ajouter 3 ; ajouter \u22123, c\u2019est soustraire 3.',
    },
    powerNeg: {
      id: Qe.power,
      label: 'Puissance n\xE9gative',
      hora: 1,
      why: 'a\u207B\u207F = 1 \xF7 a\u207F.',
    },
    powerProduct: {
      id: Qe.power,
      label: 'Produit de puissances',
      hora: 1,
      why: 'a\u1D50 \xD7 a\u207F = a\u1D50\u207A\u207F : on ajoute les exposants.',
    },
    powerQuotient: {
      id: Qe.power,
      label: 'Quotient de puissances',
      hora: 1,
      why: 'a\u1D50 \xF7 a\u207F = a\u1D50\u207B\u207F : on soustrait les exposants.',
    },
    powerPower: {
      id: Qe.power,
      label: 'Puissance d\u2019une puissance',
      hora: 1,
      why: '(a\u1D50)\u207F = a\u1D50\u02E3\u207F : on multiplie les exposants.',
    },
    powerExpand: {
      id: Qe.power,
      label: '\xC9crire la puissance en produit',
      hora: 1,
      why: 'a\u207F = a \xD7 a \xD7 \u2026 \xD7 a : n facteurs \xE9gaux \xE0 a.',
    },
    fracSimplify: {
      id: Qe.fraction,
      label: 'Simplifier la fraction',
      hora: 1,
      why: 'On divise le num\xE9rateur et le d\xE9nominateur par un m\xEAme nombre.',
    },
    fracFactor: {
      id: Qe.fraction,
      label: 'Facteur commun',
      hora: 1,
      why: 'On fait appara\xEEtre un m\xEAme facteur au num\xE9rateur et au d\xE9nominateur.',
    },
    fracCommon: {
      id: Qe.fraction,
      label: 'M\xEAme d\xE9nominateur',
      hora: 1,
      why: 'On \xE9crit les fractions avec le m\xEAme d\xE9nominateur.',
    },
    fracAdd: {
      id: Qe.fraction,
      label: 'Additionner les num\xE9rateurs',
      hora: 1,
      why: 'M\xEAme d\xE9nominateur : on additionne les num\xE9rateurs, on garde le d\xE9nominateur.',
    },
    fracMul: {
      id: Qe.fraction,
      label: 'Multiplier les fractions',
      hora: 1,
      why: 'On multiplie les num\xE9rateurs entre eux, et les d\xE9nominateurs entre eux.',
    },
    fracInverse: {
      id: Qe.fraction,
      label: 'Multiplier par l\u2019inverse',
      hora: 1,
      why: 'Diviser par une fraction, c\u2019est multiplier par son inverse.',
    },
    trig: {
      id: Qe.trig,
      label: 'Angles associ\xE9s',
      hora: 1,
      why: 'cos(\u03C0 \u2212 x) = \u2212cos(x), sin(\u03C0 \u2212 x) = sin(x), cos(\u2212x) = cos(x), sin(\u2212x) = \u2212sin(x), cos(\u03C0 + x) = \u2212cos(x), cos(\u03C0 \xF7 2 \u2212 x) = sin(x)\u2026 : on se ram\xE8ne \xE0 un angle entre 0 et \u03C0 \xF7 2.',
    },
    circle: {
      id: Qe.trig,
      label: 'Lire sur le cercle',
      hora: 1,
      why: 'Sur le cercle trigonom\xE9trique, cet angle est associ\xE9 \xE0 un angle entre 0 et \u03C0 \xF7 2 : on y lit sa valeur, avec son signe.',
    },
    rootWrite: {
      id: Qe.root,
      label: '\xC9crire comme une racine',
      hora: 1,
      why: 'Un nombre positif a est la racine carr\xE9e de a\xB2 : 3 = \u221A9. On compare ensuite les nombres sous la racine.',
    },
    rootSimplify: {
      id: Qe.root,
      label: 'Simplifier la racine',
      hora: 1,
      why: '\u221A(a\xB2 \xD7 b) = a\u221Ab : on sort les carr\xE9s de la racine (\u221A40 = \u221A(4 \xD7 10) = 2\u221A10).',
    },
    decompose: {
      id: Qe.factor,
      label: 'D\xE9composer',
      hora: 1,
      why: 'On \xE9crit un nombre comme le produit de deux entiers plus grands que 1 (84 = 2 \xD7 42, puis 42 = 2 \xD7 21\u2026).',
    },
    fracPrimes: {
      id: Qe.fractionPrimes,
      label: 'D\xE9composer en facteurs premiers',
      hora: 2,
      why: 'On d\xE9compose le num\xE9rateur et le d\xE9nominateur en facteurs premiers : s\u2019ils n\u2019ont aucun facteur commun, la fraction est irr\xE9ductible (16 \xF7 51 = 2\u2074 \xF7 (3 \xD7 17)).',
    },
    powerGroup: {
      id: Qe.power,
      label: 'Regrouper en puissance',
      hora: 1,
      why: 'Un m\xEAme facteur r\xE9p\xE9t\xE9 s\u2019\xE9crit avec une puissance : 2 \xD7 2 \xD7 2 = 2\xB3.',
    },
    cancel: {
      id: Qe.fraction,
      label: 'Barrer les facteurs communs',
      hora: 1,
      why: 'On barre un m\xEAme facteur en haut et en bas de la fraction : (2 \xD7 2 \xD7 3) \xF7 (2 \xD7 3 \xD7 5) = 2 \xF7 5.',
    },
    decimalFrac: {
      id: Qe.fraction,
      label: 'Fraction d\xE9cimale',
      hora: 1,
      why: 'Un nombre d\xE9cimal s\u2019\xE9crit comme une fraction de d\xE9nominateur 10, 100, 1000\u2026 : 0,125 = 125 \xF7 1000.',
    },
    euclid: {
      id: Qe.euclid,
      label: 'Division euclidienne',
      hora: 1,
      why: 'On \xE9crit la division euclidienne : nombre = diviseur \xD7 quotient + reste, le reste entre 1 et le diviseur moins 1 (17 = 5 \xD7 3 + 2).',
    },
    sciWrite: {
      id: Qe.scientific,
      label: 'Puissance de 10',
      hora: 1,
      why: 'On d\xE9place la virgule et l\u2019exposant de 10 compte les rangs : 45 000 = 4,5 \xD7 10\u2074, 0,5 \xD7 10\u207B\xB3 = 5 \xD7 10\u207B\u2074.',
    },
    lnProduct: {
      id: Qe.ln,
      label: 'Logarithme d\u2019un produit',
      hora: 1,
      why: 'ln(a \xD7 b) = ln(a) + ln(b), pour a > 0 et b > 0 (de m\xEAme avec log).',
    },
    lnQuotient: {
      id: Qe.ln,
      label: 'Logarithme d\u2019un quotient',
      hora: 1,
      why: 'ln(a \xF7 b) = ln(a) \u2212 ln(b), pour a > 0 et b > 0 (de m\xEAme avec log).',
    },
    lnPower: {
      id: Qe.ln,
      label: 'Logarithme d\u2019une puissance',
      hora: 1,
      why: 'ln(a\u207F) = n \xD7 ln(a), pour a > 0 (de m\xEAme avec log).',
    },
    lnRoot: {
      id: Qe.ln,
      label: 'Logarithme d\u2019une racine',
      hora: 1,
      why: 'ln(\u221Aa) = (1 \xF7 2) \xD7 ln(a), pour a > 0 (de m\xEAme avec log).',
    },
    lnInverse: {
      id: Qe.ln,
      label: 'Logarithme d\u2019un inverse',
      hora: 1,
      why: 'ln(1 \xF7 a) = \u2212ln(a), pour a > 0 (de m\xEAme avec log).',
    },
    lnValue: {
      id: Qe.ln,
      label: 'Valeur \xE0 conna\xEEtre',
      hora: 1,
      why: 'ln(1) = 0, ln(e) = 1, ln(e\u02E3) = x ; log(1) = 0, log(10) = 1, log(10\u02E3) = x.',
    },
    lnWrite: {
      id: Qe.ln,
      label: '\xC9crire comme une puissance',
      hora: 1,
      why: 'On \xE9crit le nombre comme une puissance (8 = 2\xB3, 0,01 = 10\u207B\xB2, \u221Ae = e^(1 \xF7 2)) pour se servir de ln(a\u207F) = n \xD7 ln(a).',
    },
  },
  a1 = { id: Qe.decide, card: oM, label: 'Trancher', hora: 1, why: '' },
  br = class extends Error {};
function aM(e) {
  return Sb(e);
}
function YE(e, n = !0) {
  let t = ie(e);
  return t.ok && t.s.k === 'expr' ? (n ? Do(t.s.e) : t.s.e) : null;
}
var WV = { k: 'fn', f: 'exp', a: { k: 'num', v: q } };
function Do(e) {
  switch (e.k) {
    case 'sym':
      return e.n === 'e' ? WV : e;
    case 'add':
    case 'mul':
      return { ...e, c: e.c.map(Do) };
    case 'div':
    case 'pow':
    case 'binom':
      return { ...e, a: Do(e.a), b: Do(e.b) };
    case 'fn':
      return { ...e, a: Do(e.a) };
    default:
      return e;
  }
}
function u1(e) {
  return [...$(e)].filter((n) => n !== '\u03C0');
}
var zn = (e) => u1(e).length === 0,
  de = (e) => nl(e),
  Wu = (e) => e.k === 'num';
function d1(e) {
  return e.k === 'mul' && e.c.length === 2 && Wu(e.c[0]) && M(e.c[0].v, C(-1)) && !Wu(e.c[1]);
}
function zt(e) {
  if (Wu(e) && B(e.v)) return e.v.n;
  if (d1(e)) {
    let n = zt(e.c[1]);
    return n === null ? null : -n;
  }
  return null;
}
function lM(e) {
  let n = zt(e);
  if (n !== null) return n;
  let t = Z(e);
  if (!t.ok) return null;
  let r = _n(t.rf);
  return r && B(r) ? r.n : null;
}
var JV = (e, n) => {
  let t = e < 0n ? -e : e,
    r = n < 0n ? -n : n;
  for (; r; ) [t, r] = [r, t % r];
  return t;
};
function il(e) {
  if (e.k === 'div') {
    let n = zt(e.a),
      t = zt(e.b);
    return n === null || t === null || t === 0n ? null : { p: n, q: t };
  }
  if (d1(e)) {
    let n = il(e.c[1]);
    return n && e.c[1].k === 'div' ? { p: -n.p, q: n.q } : null;
  }
  return null;
}
function m1(e) {
  if (Wu(e)) return e.v;
  let n = il(e);
  if (n && n.q > 1n && JV(n.p, n.q) === 1n) return A(C(n.p), C(n.q));
  if (d1(e)) {
    let t = m1(e.c[1]);
    return t ? fe(t) : null;
  }
  return null;
}
function kp(e) {
  switch (e.k) {
    case 'fn':
      if (e.f === 'sqrt' && Wu(e.a) && B(e.a.v) && e.a.v.n > 1n) {
        let n = e.a.v.n;
        for (let t = 2n; t * t <= n; t++) if (n % (t * t) === 0n) return !0;
      }
      return kp(e.a);
    case 'add':
    case 'mul':
      return e.c.some(kp);
    case 'div':
    case 'pow':
    case 'binom':
      return kp(e.a) || kp(e.b);
    default:
      return !1;
  }
}
function c1(e) {
  return e.k === 'div' && Wu(e.b) && L(e.b.v) && m1(e.a) !== null;
}
function Er(e) {
  switch (e.k) {
    case 'div':
      return Fi(e.b, { k: 'num', v: F }) === !0 || Er(e.a) || Er(e.b);
    case 'add':
    case 'mul':
      return e.c.some(Er);
    case 'pow':
    case 'binom':
      return Er(e.a) || Er(e.b);
    case 'fn':
      return Er(e.a);
    default:
      return !1;
  }
}
function Bi(e) {
  switch (e.k) {
    case 'fn':
      if (e.f === 'ln' && zn(e.a)) {
        let n = { k: 'num', v: F };
        if (Xf('\u2264', e.a, n) === !0) return !0;
      }
      return Bi(e.a);
    case 'add':
    case 'mul':
      return e.c.some(Bi);
    case 'div':
    case 'pow':
    case 'binom':
      return Bi(e.a) || Bi(e.b);
    default:
      return !1;
  }
}
function eM(e, n) {
  return (
    e.k === 'div' &&
    n.k === 'div' &&
    Er(e) &&
    Er(n) &&
    Fi(e.b, { k: 'num', v: F }) === !0 &&
    Fi(n.b, { k: 'num', v: F }) === !0 &&
    Fi(e.a, n.a) === !0
  );
}
function uM(e) {
  return zn(e) ? (m1(e) !== null ? !0 : Yf(e) !== 0 || kp(e) || If(e) ? !1 : Z(e).ok) : !1;
}
function l1(e, n = !0) {
  let t = ie(e);
  return !t.ok || t.s.k !== 'rel'
    ? null
    : n
      ? { rel: t.s.rel, l: Do(t.s.l), r: Do(t.s.r) }
      : { rel: t.s.rel, l: t.s.l, r: t.s.r };
}
function cM(e, n, t) {
  return !zn(n) || !zn(t) ? (e === '=' ? qb(n, t) : null) : e === '=' ? Fi(n, t) : Xf(e, n, t);
}
function fM(e, n) {
  let t = de(n[0]),
    r = e.rawSidesAll.get(t);
  if (!r || r.length < 2 || n.length < 2) return e.rawSides.get(t);
  let s = r.filter((i) => {
    let o = j(n[0], e.claims[i].at ?? {});
    return de(o) === de(n[1]) || mp(o, n[1]) === 'same';
  });
  return s.find((i) => !e.replaced.has(i)) ?? s[0] ?? e.rawSides.get(t);
}
function dM(e) {
  let n = e.kernel,
    t = n.claims ?? [];
  if (t.length < 2) throw new br('au moins deux affirmations');
  let r = !t.some((f) => f.at && 'e' in f.at),
    s = new Map(),
    i = new Map(),
    o = (f, d) => {
      s.set(f, d);
      let m = i.get(f) ?? [];
      (m.includes(d) || m.push(d), i.set(f, m));
    },
    a = t.map((f, d) => {
      let m = null;
      if (f.at && Object.keys(f.at).length) {
        m = {};
        for (let [S, w] of Object.entries(f.at)) {
          let _ = YE(w, r);
          if (!_ || !zn(_)) throw new br(`valeur de ${S} illisible : ${w}`);
          m[S] = _;
        }
      }
      if (f.rels.length === 1 && !/[=<>≤≥≠]/.test(f.rels[0])) {
        let S = f.rels[0],
          w = YE(S, r);
        if (!w) throw new br(`\xE9criture illisible : ${S}`);
        let _ = m ? j(w, m) : w;
        if (!zn(_)) throw new br(`lettre sans valeur dans \xAB ${S} \xBB`);
        zn(w) || o(de(w), d);
        let O = f.divisibleBy
          ? { kind: 'divisible', d: BigInt(f.divisibleBy) }
          : f.form
            ? { kind: 'form', form: f.form }
            : null;
        if (!O) throw new br(`propri\xE9t\xE9 absente : ${S}`);
        let G;
        if (O.kind === 'divisible' || O.form === 'prime') {
          let ae = lM(_);
          if (ae === null)
            throw new br(
              `\xAB ${O.kind === 'divisible' ? 'divisible par' : 'nombre premier'} \xBB sur un entier : ${S}`,
            );
          G = O.kind === 'divisible' ? ae % O.d === 0n : jf(ae);
        } else G = O.form === 'irreducible' ? nC(_) : Ku(_, O.form);
        let Se = !!f.not;
        Se && (G = !G);
        let U = f.at
          ? Object.entries(f.at)
              .map(([ae, P]) => `${ae} = ${P}`)
              .join(' ; ')
          : null;
        return {
          index: d,
          rels: [{ rel: '=', l: _, r: _, rawL: w, rawR: w, text: S }],
          at: m,
          atText: U,
          truth: G,
          form: null,
          formOk: !0,
          prop: O,
          negated: Se,
        };
      }
      let g =
        !m &&
        f.rels.some((S) => {
          let w = l1(S, r);
          return !!w && (_b(w.l) || _b(w.r));
        });
      if (g && f.form) throw new br('une forme va avec une affirmation sans lettre');
      let h = f.rels.map((S) => {
          let w = l1(S, r);
          if (!w) throw new br(`affirmation illisible : ${S}`);
          let _ = m ? j(w.l, m) : w.l,
            O = m ? j(w.r, m) : w.r;
          if (g) {
            if (w.rel !== '=')
              throw new br(`une identit\xE9 en lettres est une \xE9galit\xE9 : ${S}`);
            return { rel: w.rel, l: _, r: O, rawL: w.l, rawR: w.r, text: S };
          }
          if (!zn(_) || !zn(O)) throw new br(`lettre sans valeur dans \xAB ${S} \xBB`);
          return (
            zn(w.l) || o(de(w.l), d),
            zn(w.r) || o(de(w.r), d),
            { rel: w.rel, l: _, r: O, rawL: w.l, rawR: w.r, text: S }
          );
        }),
        b = f.form ?? null;
      if (b && (h.length !== 1 || h[0].rel !== '='))
        throw new br('une forme va avec UNE \xE9galit\xE9 \xAB a = b \xBB');
      let v = b ? Ku(h[0].rawR, b) : !0,
        k = v;
      for (let S of h) {
        let w = cM(S.rel, S.l, S.r);
        if (
          (w === null && (Er(S.l) || Er(S.r)) && (w = !1),
          w === null && (Bi(S.l) || Bi(S.r)) && (w = !1),
          w === null)
        )
          throw new br(`affirmation ind\xE9cidable : ${S.text}`);
        w || (k = !1);
      }
      let y = f.at
        ? Object.entries(f.at)
            .map(([S, w]) => `${S} = ${w}`)
            .join(' ; ')
        : null;
      return {
        index: d,
        rels: h,
        at: m,
        atText: y,
        truth: k,
        form: b,
        formOk: v,
        prop: null,
        negated: !1,
        ...(g ? { identity: !0 } : {}),
      };
    }),
    l = a.some((f) => f.identity);
  if (l && a.some((f) => f.at))
    throw new br(
      'des identit\xE9s en lettres et des valeurs propos\xE9es : pas sur la m\xEAme feuille',
    );
  let u = new Set();
  for (let f of a) for (let d of f.rels) (u.add(de(d.l)), u.add(de(d.r)));
  let c = (e.traps ?? []).flatMap((f) => {
    let d = l1(f.line, r);
    if (!d) return [];
    let m;
    try {
      m = Ve(f.line);
    } catch {
      return [];
    }
    let p = `${de(d.l)}=${de(d.r)}`,
      g = `${de(d.r)}=${de(d.l)}`;
    return [{ line: m, title: f.title, why: f.why, keys: [p, g] }];
  });
  return {
    model: e,
    claims: a,
    parent: new Map(),
    value: new Map(),
    terms: new Map(),
    known: u,
    rawSides: s,
    rawSidesAll: i,
    single: !!n.single,
    eConst: r,
    letters: l,
    replaced: new Set(),
    written: new Set(),
    path: n.path ?? [],
    traps: c,
    lines: 0,
  };
}
function ai(e, n) {
  let t = n;
  for (; e.has(t) && e.get(t) !== t; ) t = e.get(t);
  return t;
}
function mM(e, n) {
  return uM(n) || c1(n) || (!!e.letters && UE(n));
}
function XV(e, n, t) {
  let r = ai(e.parent, n),
    s = ai(e.parent, t);
  if (r === s) return;
  (e.parent.set(r, s), e.parent.has(s) || e.parent.set(s, s));
  let i = e.value.get(r);
  i && !e.value.has(s) && e.value.set(s, i);
}
function p1(e, n, t) {
  n.forEach((r, s) => {
    e.parent.has(r) || e.parent.set(r, r);
    let i = t[s];
    if ((e.terms.has(r) || e.terms.set(r, i), mM(e, i))) {
      let o = ai(e.parent, r);
      e.value.has(o) || e.value.set(o, i);
    }
  });
  for (let r = 1; r < n.length; r++) XV(e, n[0], n[r]);
}
function nM(e, n) {
  if (mM(e, n)) return n;
  let t = de(n);
  return e.parent.has(t) ? (e.value.get(ai(e.parent, t)) ?? null) : null;
}
function pM(e, n) {
  let t = de(n.l),
    r = de(n.r);
  if (!e.parent.has(t) && !e.parent.has(r)) return null;
  if (n.rel === '=' && e.parent.has(t) && e.parent.has(r) && ai(e.parent, t) === ai(e.parent, r))
    return !0;
  if ((e.parent.has(t) && Bi(n.r)) || (e.parent.has(r) && Bi(n.l))) return !1;
  let s = nM(e, n.l),
    i = nM(e, n.r);
  return s && i ? (c1(s) || c1(i) ? !1 : cM(n.rel, s, i)) : null;
}
function YV(e, n) {
  let t = n.rels[0],
    r = de(t.l);
  if (e.parent.has(r)) {
    let i = ai(e.parent, r);
    for (let [o, a] of e.terms)
      if (ai(e.parent, o) === i && Ku(a, n.form)) return n.formOk && Fi(a, t.r) === !0;
  }
  let s = pM(e, t);
  return s === null ? null : s && n.formOk;
}
function eD(e, n) {
  let t = de(n);
  if (!e.parent.has(t)) return [];
  let r = ai(e.parent, t),
    s = [];
  for (let [i, o] of e.terms) ai(e.parent, i) === r && s.push(o);
  return s;
}
function nD(e, n) {
  let t = n.prop,
    r = n.rels[0].l,
    s = eD(e, r);
  if (!s.length) return null;
  let i = null;
  if (t.kind === 'divisible')
    for (let o of s) {
      let a = tp(o);
      if (
        !(!a || !a.factors.includes(t.d)) &&
        (a.r === 0n ? (i = !0) : a.r < t.d && (i = !1), i !== null)
      )
        break;
    }
  else if (t.form === 'prime') {
    let o = lM(r);
    if (o !== null && o >= 2n)
      if (
        s.some((l) => {
          let u = tp(l);
          return !!u && u.r === 0n && u.factors.every((c) => c >= 2n);
        })
      )
        i = !1;
      else {
        let l = (c) =>
            s.some((f) => {
              let d = tp(f);
              return !!d && d.r > 0n && d.r < c && d.factors.includes(c);
            }),
          u = !0;
        for (let c = 2n; c * c <= o && u; c++) jf(c) && !l(c) && (u = !1);
        u && (i = !0);
      }
  } else {
    let o = n.rels[0].rawR,
      a = n.at ? r : o,
      l = t.form === 'irreducible' ? cb(a) : null;
    for (let u of s)
      if (Ku(u, t.form)) {
        i = l ? tC(u, l) : iC(u, a, t.form) && Ku(a, t.form);
        break;
      }
  }
  return i === null ? null : n.negated ? !i : i;
}
function g1(e, n) {
  if (n.prop) return nD(e, n);
  if (n.form) return YV(e, n);
  let t = !0;
  for (let r of n.rels) {
    let s = pM(e, r);
    if (s === !1) return !1;
    s === null && (t = !1);
  }
  return t ? !0 : null;
}
var gM = (e) => ({ parent: e.parent, value: e.value, terms: e.terms, letters: e.letters });
function hM(e) {
  return {
    parent: new Map(e.parent),
    value: new Map(e.value),
    terms: new Map(e.terms),
    letters: e.letters,
  };
}
function h1(e, n) {
  return e.single
    ? n.filter((r) => r === !0).length === 1
      ? n.map((r) => r ?? !1)
      : n.filter((r) => r === null).length === 1 && n.every((r) => r !== !0)
        ? n.map((r) => r ?? !0)
        : n
    : n;
}
function Ib(e) {
  let n = gM(e);
  return h1(
    e,
    e.claims.map((t) => g1(n, t)),
  );
}
function bM(e) {
  return Ib(e).every((n) => n !== null);
}
function tM(e) {
  let n = 0;
  for (let t = 0; t + 1 < e.length; t++)
    e[t] === '(' && (e[t + 1] === '\u2212' || e[t + 1] === '+') && n++;
  return n;
}
function Ob(e) {
  return e.k === 'pow'
    ? { base: de(e.a), e: e.b, b: e.a }
    : Wu(e) || e.k === 'sym'
      ? { base: de(e), e: { k: 'num', v: q }, b: e }
      : null;
}
function oi(e) {
  return xp(e);
}
function xp(e) {
  switch (e.k) {
    case 'num':
      return e.v;
    case 'add': {
      let n = F;
      for (let t of e.c) {
        let r = xp(t);
        if (!r) return null;
        n = re(n, r);
      }
      return n;
    }
    case 'mul': {
      let n = q;
      for (let t of e.c) {
        let r = xp(t);
        if (!r) return null;
        n = N(n, r);
      }
      return n;
    }
    case 'div': {
      let n = xp(e.a),
        t = xp(e.b);
      return !n || !t || L(t) ? null : A(n, t);
    }
    default:
      return null;
  }
}
function Pb(e, n) {
  if (e.k === 'pow' && n.k === 'div') {
    let t = oi(e.b),
      r = zt(n.a);
    if (t && te(t) < 0 && r === 1n && n.b.k === 'pow' && de(n.b.a) === de(e.a)) {
      let s = oi(n.b.b);
      if (s && M(s, fe(t))) return 'powerNeg';
    }
  }
  if (e.k === 'pow' && e.a.k === 'pow' && n.k === 'pow' && de(n.a) === de(e.a.a)) {
    let t = oi(e.a.b),
      r = oi(e.b),
      s = oi(n.b);
    if (t && r && s && M(N(t, r), s)) return 'powerPower';
  }
  if (e.k === 'mul' && e.c.length === 2 && n.k === 'pow') {
    let t = Ob(e.c[0]),
      r = Ob(e.c[1]);
    if (t && r && t.base === r.base && t.base === de(n.a)) {
      let s = oi(t.e),
        i = oi(r.e),
        o = oi(n.b);
      if (s && i && o && M(re(s, i), o) && (e.c[0].k === 'pow' || e.c[1].k === 'pow'))
        return 'powerProduct';
    }
  }
  if (e.k === 'div' && n.k === 'pow') {
    let t = Ob(e.a),
      r = Ob(e.b);
    if (t && r && t.base === r.base && t.base === de(n.a)) {
      let s = oi(t.e),
        i = oi(r.e),
        o = oi(n.b);
      if (s && i && o && M(me(s, i), o) && (e.a.k === 'pow' || e.b.k === 'pow'))
        return 'powerQuotient';
    }
  }
  return null;
}
function vM(e) {
  return e.k === 'mul' ? e.c.flatMap(vM) : [e];
}
function tD(e, n) {
  if (e.k !== 'pow' || n.k !== 'mul') return !1;
  let t = zt(e.b);
  if (t === null || t < 2n || t > 8n) return !1;
  let r = vM(n),
    s = de(e.a);
  return r.length === Number(t) && r.every((i) => de(i) === s);
}
function yp(e, n) {
  if (tD(e, n)) return 'powerExpand';
  let t = Pb(e, n);
  if (t) return t;
  if (e.k !== n.k) return null;
  if (e.k === 'div' || e.k === 'pow') {
    let r = n;
    return de(e.a) === de(r.a) ? yp(e.b, r.b) : de(e.b) === de(r.b) ? yp(e.a, r.a) : null;
  }
  if ((e.k === 'mul' || e.k === 'add') && n.k === e.k && e.c.length === n.c.length) {
    let r = e.c.flatMap((s, i) => (de(s) === de(n.c[i]) ? [] : [i]));
    return r.length === 1 ? yp(e.c[r[0]], n.c[r[0]]) : null;
  }
  return null;
}
function kM(e) {
  for (let n of e) {
    if (/[<>≤≥]/.test(n)) continue;
    let t = n.split('=').map((r) => {
      let s = ie(r.trim());
      return s.ok && s.s.k === 'expr' ? s.s.e : null;
    });
    if (!(t.length < 2 || t.some((r) => !r)))
      for (let r = 0; r + 1 < t.length; r++) {
        let s = t[r],
          i = t[r + 1];
        if (mp(s, i) === 'jump' && !Pb(s, i) && yp(s, i)) return !0;
      }
  }
  return !1;
}
function Kb(e) {
  if (e.k !== 'mul' || e.c.length !== 2) return [];
  let n = zt(e.c[0]),
    t = zt(e.c[1]);
  return n === null || t === null
    ? []
    : [
        { k: n, x: t },
        { k: t, x: n },
      ];
}
function rM(e) {
  if (e.k !== 'add') return null;
  let n = [];
  for (let t of e.c) {
    let r = il(t);
    if (r) {
      n.push({ ...r, written: !0 });
      continue;
    }
    let s = zt(t);
    if (s === null) return null;
    n.push({ p: s, q: 1n, written: !1 });
  }
  return n;
}
function sM(e, n) {
  let t = il(e),
    r = il(n);
  if (t && r && r.q !== 0n) {
    let o = (a) => (a < 0n ? -a : a);
    if (t.p * r.q === r.p * t.q && o(r.q) < o(t.q)) return 'fracSimplify';
  }
  if (t && n.k === 'div') {
    for (let o of Kb(n.a))
      for (let a of Kb(n.b))
        if (o.k === a.k && o.k > 1n && o.k * o.x === t.p && a.k * a.x === t.q) return 'fracFactor';
  }
  if (e.k === 'div')
    for (let o of Kb(e.a))
      for (let a of Kb(e.b)) {
        if (o.k !== a.k || o.k <= 1n) continue;
        if (r && r.p === o.x && r.q === a.x) return 'fracSimplify';
        let l = zt(n);
        if (a.x === 1n && l !== null && l === o.x) return 'fracSimplify';
      }
  let s = rM(e),
    i = rM(n);
  if (s && i && s.length === i.length && i.length >= 2) {
    let o = i[0].q,
      a = i.every((c) => c.q === o && c.written) && o !== 1n,
      l = s.every((c, f) => c.p * i[f].q === i[f].p * c.q),
      u = s.some((c, f) => c.q !== i[f].q);
    if (a && l && u) return 'fracCommon';
  }
  if (s && s.length >= 2 && n.k === 'div') {
    let o = s[0].q;
    if (o !== 1n && s.every((a) => a.q === o && a.written)) {
      let a = s.reduce((u, c) => u + c.p, 0n);
      if (zt(n.b) === o) {
        let u = zt(n.a);
        if (u !== null && u === a) return 'fracAdd';
        if (n.a.k === 'add') {
          let c = n.a.c.map(zt);
          if (c.every((f) => f !== null) && c.reduce((f, d) => f + d, 0n) === a) return 'fracAdd';
        }
      }
    }
  }
  if (e.k === 'mul' && e.c.length >= 2 && n.k === 'div') {
    let o = e.c.map((a) => il(a) ?? (zt(a) !== null ? { p: zt(a), q: 1n } : null));
    if (o.every((a) => a !== null) && e.c.some((a) => a.k === 'div')) {
      let a = o.reduce((c, f) => c * f.p, 1n),
        l = o.reduce((c, f) => c * f.q, 1n),
        u = (c) => {
          let f = zt(c);
          if (f !== null) return f;
          if (c.k === 'mul') {
            let d = c.c.map(zt);
            return d.every((m) => m !== null) ? d.reduce((m, p) => m * p, 1n) : null;
          }
          return null;
        };
      if (u(n.a) === a && u(n.b) === l) return 'fracMul';
    }
  }
  if (e.k === 'div' && n.k === 'mul' && n.c.length === 2) {
    let o = il(e.b);
    if (o) {
      let [a, l] = n.c,
        u = (c) => {
          let f = il(c);
          return !!f && f.p === o.q && f.q === o.p;
        };
      if ((de(a) === de(e.a) && u(l)) || (de(l) === de(e.a) && u(a))) return 'fracInverse';
    }
  }
  return null;
}
function rD(e) {
  let n = [[]],
    t = 0;
  for (let r of e)
    (r === '(' && t++,
      r === ')' && t--,
      r === '=' && t === 0 ? n.push([]) : n[n.length - 1].push(r));
  return n;
}
function sD(e, n) {
  return e.path.some((t) => {
    let r;
    try {
      r = aM(t);
    } catch {
      return !1;
    }
    return r.length > n.length && n.every((s, i) => r[i] === s);
  });
}
function xM(e, n, t) {
  let r = wt(n),
    s = r.atoms;
  if (!s.length) return { kind: 'empty', atoms: s, badChip: -1 };
  let i = sD(e, s),
    o = vn(s);
  if (!o.ok)
    return i
      ? { kind: 'building', atoms: s, complete: !1 }
      : {
          kind: 'syntax',
          atoms: s,
          title: '\xC7a commence mal',
          message: o.msg,
          badChip: r.src[o.index] !== void 0 ? r.src[o.index] : n.length - 1,
        };
  if (!o.complete || !o.hasEq) return { kind: i ? 'building' : 'open', atoms: s, complete: !1 };
  let a = Jy(s),
    l = a && iD(e, a);
  if (!l)
    return i
      ? { kind: 'building', atoms: s, complete: !1 }
      : {
          kind: 'unjustified',
          atoms: s,
          title: 'Une relation par ligne',
          message:
            '\xC9cris un calcul avec \xAB = \xBB (\xAB 11 \xD7 48 = \u2026 \xBB), ou une comparaison.',
        };
  let u = fD(e, l, s);
  return i && !t?.verify
    ? u.kind === 'step'
      ? { ...u, kind: 'ready', complete: !0 }
      : { kind: 'building', atoms: s, complete: !0 }
    : !t?.verify && (u.kind === 'unjustified' || u.kind === 'false')
      ? { kind: 'pending', atoms: s, complete: !0 }
      : { ...u, complete: !0 };
}
var ol = (e) => `\xAB ${Jr(e)} \xBB`;
function iD(e, n) {
  return e.eConst ? { ...n, members: n.members.map(Do), raw: n.members } : { ...n, raw: n.members };
}
function oD(e) {
  let n = [[]],
    t = 0;
  for (let r of e)
    ((r === '(' || r === '[') && t++,
      (r === ')' || r === ']') && t--,
      r === '=' && t === 0 ? n.push([]) : n[n.length - 1].push(r));
  return n.map((r) => r.join(' '));
}
var aD = {
    irreducible: 'fraction irr\xE9ductible',
    scientific: 'notation scientifique',
    primes: 'en facteurs premiers',
    prime: 'nombre premier',
  },
  lD = {
    irreducible: ['fraction irr\xE9ductible', 'pas une fraction irr\xE9ductible'],
    scientific: ['notation scientifique', 'pas en notation scientifique'],
    primes: [
      'd\xE9composition en facteurs premiers',
      'pas une d\xE9composition en facteurs premiers',
    ],
    prime: ['nombre premier', 'pas un nombre premier'],
  };
function uD(e, n) {
  return e.kind === 'divisible'
    ? `${n ? 'pas divisible' : 'divisible'} par ${e.d}`
    : lD[e.form][n ? 1 : 0];
}
var yM = {
  irreducible:
    'Cette \xE9criture n\u2019est pas une fraction irr\xE9ductible : elle se simplifie encore.',
  scientific:
    'Ce n\u2019est pas une notation scientifique : le nombre devant la puissance de 10 doit \xEAtre au moins 1 et moins que 10.',
  primes:
    'Ce n\u2019est pas une d\xE9composition en facteurs premiers : chaque facteur doit \xEAtre premier, et \xE9crit une seule fois (avec une puissance s\u2019il revient).',
  prime: '',
};
function cD(e, n) {
  let t = e.prop,
    r = e.negated ? !n : n;
  return t.kind === 'divisible'
    ? r
      ? `La division par ${t.d} tombe juste : le reste est 0.`
      : `La division par ${t.d} laisse un reste : il n\u2019est pas 0.`
    : t.form === 'prime'
      ? r
        ? 'Aucun nombre premier jusqu\u2019\xE0 sa racine carr\xE9e ne le divise : il est premier.'
        : 'Il s\u2019\xE9crit comme un produit de deux entiers plus grands que 1 : il n\u2019est pas premier.'
      : r
        ? ''
        : yM[t.form];
}
function iM(e) {
  let n = e.rels.map((t) => t.text).join(' et ');
  if (e.prop) {
    let t = uD(e.prop, e.negated);
    return e.atText ? `${n} (${t}, pour ${e.atText})` : `${n} (${t})`;
  }
  return e.form ? `${n} (${aD[e.form]})` : e.atText ? `${n} (pour ${e.atText})` : n;
}
function f1(e, n, t) {
  let r = (l) => !!t && t[l.index] === null,
    s = n
      .filter((l) => !r(l))
      .map((l) => {
        let u = e.claims[l.index],
          c = !l.truth && u.rels.some((m) => Er(m.l) || Er(m.r)),
          f = !l.truth && u.form && !u.formOk ? ' ' + yM[u.form] : '',
          d = u.prop ? cD(u, l.truth) : '';
        return `\xAB ${iM(u)} \xBB est ${l.truth ? 'VRAIE' : 'FAUSSE'}.${c ? ' On ne divise jamais par 0 : valeur interdite.' : ''}${f}${d ? ' ' + d : ''}`;
      }),
    i = (l) => {
      let u = l.map((c) => `\xAB ${iM(e.claims[c.index])} \xBB`);
      return u.length > 1 ? `${u.slice(0, -1).join(', ')} et ${u[u.length - 1]}` : u[0];
    },
    o = n.filter((l) => r(l) && l.truth),
    a = n.filter((l) => r(l) && !l.truth);
  return (
    o.length &&
      s.push(`Une seule r\xE9ponse est juste et les autres sont fausses : ${i(o)} est donc VRAIE.`),
    a.length &&
      s.push(
        `Une seule r\xE9ponse est juste, et elle est trouv\xE9e : ${i(a)} ${a.length > 1 ? 'sont donc FAUSSES' : 'est donc FAUSSE'}.`,
      ),
    s.join(' ')
  );
}
function fD(e, n, t) {
  let r = { atoms: t, line: n.line },
    s = n.raw ?? n.members;
  if (n.approx)
    return {
      kind: 'unjustified',
      ...r,
      title: 'Des valeurs exactes',
      message:
        'Ici, on tranche avec des calculs exacts : \xE9cris \xAB = \xBB et la valeur exacte.',
    };
  let i = n.members,
    o = i.map((U) => !zn(U));
  if (!e.letters && (o.some((U, ae) => U && ae > 0) || (o[0] && (n.cmp || i.length < 2)))) {
    let U = i.flatMap(u1)[0],
      ae = e.claims.find((P) => P.at && U in P.at);
    return {
      kind: 'unjustified',
      ...r,
      title: ae ? `Remplace ${U}` : 'Lettre inconnue',
      message: ae
        ? `Remplace d\u2019abord ${U} par la valeur propos\xE9e (${ae.atText}), puis calcule.`
        : `\xAB ${U} \xBB n\u2019est pas une grandeur de cette question : on calcule avec des nombres.`,
    };
  }
  if (n.cmp) {
    let [U, ae] = i,
      [P, ee] = s,
      Mn = Xf(n.cmp, U, ae);
    return Mn === null
      ? {
          kind: 'useless',
          ...r,
          unknown: !0,
          title: 'Je ne sais pas encore v\xE9rifier ce passage',
          message:
            'Je ne sais pas trancher cette comparaison. Garde-la sans HORA, ou calcule d\u2019abord.',
          cmove: { text: t.join(' '), keys: [], terms: [], replaced: [] },
        }
      : Mn
        ? {
            kind: 'useless',
            ...r,
            title: 'Comparaison juste',
            message:
              'C\u2019est juste. D\xE8s qu\u2019une valeur est calcul\xE9e, la feuille compare toute seule : calcule les membres de l\u2019affirmation.',
            cmove: { text: t.join(' '), keys: [], terms: [], replaced: [] },
          }
        : {
            kind: 'false',
            ...r,
            title: 'Ce n\u2019est pas vrai',
            message: `${ol(P)} ${n.cmp} ${ol(ee)} est faux : compare les valeurs.`,
          };
  }
  let a = null,
    l = i.slice();
  if (!e.letters && o[0]) {
    let U = fM(e, i);
    if (U === void 0) {
      let ae = u1(i[0])[0],
        P = e.claims.some((ee) => ee.at && ae in ee.at);
      return {
        kind: 'unjustified',
        ...r,
        title: P ? 'D\u2019o\xF9 vient-elle ?' : 'Lettre inconnue',
        message: P
          ? 'Commence par un membre d\u2019une affirmation, puis remplace la lettre par la valeur propos\xE9e.'
          : `\xAB ${ae} \xBB n\u2019est pas une grandeur de cette question : on calcule avec des nombres.`,
      };
    }
    ((a = U), (l[0] = j(i[0], e.claims[U].at)));
  }
  for (let U = 0; U + 1 < l.length; U++) {
    if (de(l[U]) === de(l[U + 1]) || eM(l[U], l[U + 1])) continue;
    let ae = Er(l[U]);
    if (ae !== Er(l[U + 1]))
      return {
        kind: 'false',
        ...r,
        title: 'Division par 0',
        message: `On ne divise jamais par 0 : ${ol(ae ? s[U] : s[U + 1])} n\u2019existe pas, elle n\u2019a pas de valeur.`,
      };
    let P = Bi(l[U]);
    if (P || Bi(l[U + 1]))
      return {
        kind: 'false',
        ...r,
        title: 'Logarithme d\u2019un nombre n\xE9gatif',
        message: `ln(a) n\u2019existe que pour a > 0 : ${ol(P ? s[U] : s[U + 1])} n\u2019a pas de valeur.`,
      };
    let ee = e.letters && (!zn(l[U]) || !zn(l[U + 1])) ? qb(l[U], l[U + 1]) : Fi(l[U], l[U + 1]);
    if (ee !== !0)
      return ee === null
        ? {
            kind: 'useless',
            ...r,
            unknown: !0,
            title: 'Je ne sais pas encore v\xE9rifier ce passage',
            message:
              'Ta ligne est peut-\xEAtre juste, mais je ne sais pas la v\xE9rifier. Garde-la sans HORA, ou \xE9cris le passage autrement.',
          }
        : vD(e, r, i, U, s);
  }
  let u = l.map(de),
    c = t.join(' ');
  if (u.every((U) => e.parent.has(U)) && new Set(u.map((U) => ai(e.parent, U))).size === 1)
    return {
      kind: 'dup',
      ...r,
      title: 'D\xE9j\xE0 \xE9crit',
      message: 'Ces calculs sont d\xE9j\xE0 sur ta feuille.',
    };
  let f = oD(t);
  if (f.length === l.length && new Set(f).size === 1)
    return {
      kind: 'useless',
      ...r,
      title: 'Rien de nouveau',
      message:
        'Ta ligne \xE9crit deux fois la m\xEAme chose. Calcule un membre de l\u2019affirmation.',
    };
  let d = [],
    m = [],
    p = 0;
  if (a !== null) {
    if (de(l[0]) !== de(l[1] ?? l[0]) && mp(l[0], l[1]) !== 'same')
      return {
        kind: 'unjustified',
        ...r,
        title: 'Une \xE9tape \xE0 la fois',
        message: `Remplace d\u2019abord la lettre par sa valeur (${e.claims[a].atText}), sans calculer en m\xEAme temps.`,
      };
    (e.replaced.has(a) || (d.push(sl.replace), m.push(a)), (p = 1));
  } else {
    let U = e.claims.find(
      (ae) =>
        ae.at &&
        !e.replaced.has(ae.index) &&
        ae.rels.some((P) => (!zn(P.rawL) && de(P.l) === u[0]) || (!zn(P.rawR) && de(P.r) === u[0])),
    );
    if (U) (d.push(sl.replace), m.push(U.index));
    else if (!e.known.has(u[0]))
      return u.slice(1).some((ae) => e.known.has(ae))
        ? {
            kind: 'unjustified',
            ...r,
            title: 'Commence par ce que tu calcules',
            message:
              '\xC9cris d\u2019abord l\u2019expression de l\u2019affirmation, puis son calcul : \xAB 11 \xD7 48 = \u2026 \xBB.',
          }
        : bD(e, r, c, u, l, m);
  }
  let g = rD(t),
    h = !1;
  for (let U = p; U + 1 < l.length && !h; U++) {
    let ae = l[U],
      P = l[U + 1],
      ee = g[U] ?? [],
      Mn = g[U + 1] ?? [];
    if (eM(ae, P)) {
      de(ae) !== de(P) && d.push(sl.compute);
      continue;
    }
    if (e.letters && (!zn(ae) || !zn(P))) {
      if (de(ae) === de(P)) continue;
      let Xn = JE(ae, P);
      Xn ? d.push(sl[dD[Xn]]) : (h = !0);
      continue;
    }
    let xe = pD(e, ae, P, ee, Mn);
    if (xe) {
      d.push(sl[xe]);
      continue;
    }
    let le = mp(ae, P);
    if (le === 'compute') d.push(sl.compute);
    else if (le === 'expand') d.push(sl.expand);
    else if ((le === 'reorder' || le === 'same') && (Ou(ae) || Ou(P)) && gD(ae, P)) h = !0;
    else if (le === 'jump') {
      let Xn = yp(ae, P);
      Xn ? d.push(sl[Xn]) : (h = !0);
    }
  }
  let b = Ib(e),
    v = hM(e);
  p1(v, u, l);
  let k = e.claims.map((U) => g1(v, U)),
    y = h1(e, k),
    S = y.flatMap((U, ae) => (U !== null && b[ae] === null ? [{ index: ae, truth: U }] : [])),
    w = y.every((U) => U !== null),
    _ = { text: c, keys: u, terms: l, replaced: m },
    O = S.length ? ' ' + f1(e, S, k) : '';
  if (h)
    return {
      kind: 'useless',
      ...r,
      jump: !0,
      final: w,
      decided: S,
      title: S.length ? 'Juste, tu tranches !' : 'Juste, mais tu sautes des \xE9tapes',
      message:
        'Ta ligne est juste. D\xE9taille-la, un calcul par ligne, pour gagner des HORA. Tu peux la garder sans HORA.' +
        O,
      cmove: _,
    };
  if (!d.length)
    return S.length
      ? {
          kind: 'step',
          ...r,
          hora: a1.hora,
          final: w,
          decided: S,
          rule: { ...a1, why: f1(e, S, k) },
          cmove: _,
        }
      : {
          kind: 'useless',
          ...r,
          title: 'M\xEAme chose, \xE9crite autrement',
          message:
            'Ta ligne est juste, mais elle redit ce que tu as d\xE9j\xE0 \xE9crit, dans un autre ordre. Avance d\u2019un calcul.',
          cmove: _,
        };
  let G = mD(d.map((U) => ({ ...U, card: oM }))),
    Se = G.hora + (S.length ? a1.hora : 0);
  return {
    kind: 'step',
    ...r,
    hora: Se,
    final: w,
    decided: S,
    rule: {
      ...G,
      hora: Se,
      ...(S.length ? { label: `${G.label} \u2192 Trancher` } : {}),
      why: G.why + O,
    },
    cmove: _,
  };
}
var dD = {
  expand: 'expandLetters',
  parens: 'parens',
  compute: 'reduce',
  neutral: 'compute',
  power: 'powerRules',
  powerExpand: 'powerExpand',
  fraction: 'fracSimplify',
  factor: 'factorLetters',
};
function mD(e) {
  if (e.length === 1) return e[0];
  let n = e.map((r) => r.label).filter((r, s, i) => i.indexOf(r) === s),
    t = e.map((r) => r.why).filter((r, s, i) => i.indexOf(r) === s);
  return {
    id: e[0].id,
    card: e[0].card,
    label: n.join(' \u2192 '),
    hora: e.reduce((r, s) => r + s.hora, 0),
    why: t.join(' '),
  };
}
function pD(e, n, t, r, s) {
  if (E(n) === E(t) && tM(r) > tM(s)) return 'signs';
  let i = Sy(n, t);
  if (i) return i;
  let o = yy(n, t, uM(t));
  if (o === 'rootWrite' && !hD(e, n)) return Pb(n, t) ?? sM(n, t);
  if (o) return o === 'trigValue' ? 'compute' : o;
  let a = Pb(n, t) ?? sM(n, t) ?? rp(n, t) ?? (wy(n, t) ? 'fracPrimes' : null);
  return a === 'powerMerge' ? 'powerProduct' : a;
}
function gD(e, n) {
  let t = (i, o) => {
      switch (i.k) {
        case 'fn':
          i.f === 'ln' || i.f === 'log' ? o.push(`${i.f}:${de(i.a)}`) : t(i.a, o);
          break;
        case 'add':
        case 'mul':
          i.c.forEach((a) => t(a, o));
          break;
        case 'div':
        case 'pow':
        case 'binom':
          (t(i.a, o), t(i.b, o));
          break;
        default:
          break;
      }
      return o;
    },
    r = t(e, []).sort().join('|'),
    s = t(n, []).sort().join('|');
  return r !== s;
}
function hD(e, n) {
  let t = de(n);
  return e.claims.some((r) => r.rels.some((s) => de(s.l) === t || de(s.r) === t));
}
function bD(e, n, t, r, s, i) {
  let o = hM(e);
  p1(o, r, s);
  let a = Ib(e),
    l = e.claims.map((f) => g1(o, f)),
    u = h1(e, l),
    c = u.flatMap((f, d) => (f !== null && a[d] === null ? [{ index: d, truth: f }] : []));
  return {
    kind: 'useless',
    ...n,
    final: u.every((f) => f !== null),
    decided: c,
    title: c.length ? 'Juste, tu tranches !' : 'Juste, mais \xE0 c\xF4t\xE9',
    message: c.length
      ? f1(e, c, l)
      : 'Ce calcul est juste, mais il ne part d\u2019aucune affirmation : commence par l\u2019une d\u2019elles.',
    cmove: { text: t, keys: r, terms: s, replaced: i },
  };
}
function vD(e, n, t, r, s = t) {
  let i = t[r],
    o = t[r + 1],
    a = [`${de(t[0])}=${de(t[t.length - 1])}`, `${de(i)}=${de(o)}`],
    l = e.traps.find((u) => u.keys.some((c) => a.includes(c)));
  if (l)
    return {
      kind: 'trap',
      ...n,
      title: 'Pi\xE8ge : ' + l.title.charAt(0).toLowerCase() + l.title.slice(1),
      message: l.why,
      trap: { line: l.line, title: l.title, why: l.why },
      badChip: -1,
    };
  if (e.letters && (!zn(i) || !zn(o))) {
    let u = XE(i, o);
    return {
      kind: 'false',
      ...n,
      title: 'Ce n\u2019est pas \xE9gal',
      message: u
        ? `${ol(s[r] ?? i)} et ${ol(s[r + 1] ?? o)} ne sont pas \xE9gales : pour ${u.at}, la premi\xE8re vaut ${u.va} et la seconde ${u.vb}. Refais ce calcul.`
        : `${ol(s[r] ?? i)} n\u2019est pas \xE9gale \xE0 ${Jr(s[r + 1] ?? o)} : refais ce calcul.`,
    };
  }
  return {
    kind: 'false',
    ...n,
    title: 'Calcul faux',
    message: `${ol(s[r] ?? i)} ne fait pas ${Jr(s[r + 1] ?? o)} : refais ce calcul.`,
  };
}
function wM(e, n) {
  let t = n.cmove;
  t &&
    (e.written.add(t.text),
    e.lines++,
    t.keys.length && (p1(gM(e), t.keys, t.terms), t.keys.forEach((r) => e.known.add(r))),
    t.replaced.forEach((r) => e.replaced.add(r)));
}
function SM(e, n) {
  let t;
  try {
    t = aM(n);
  } catch {
    return !1;
  }
  let r = Jy(t);
  if (!r || r.approx) return !1;
  let s = e.eConst ? r.members.map(Do) : r.members;
  if (e.letters) {
    if (r.cmp) return Xf(r.cmp, s[0], s[1]) === !0;
    for (let i = 0; i + 1 < s.length; i++) {
      let o = s[i],
        a = s[i + 1];
      if ((zn(o) && zn(a) ? Fi(o, a) : qb(o, a)) !== !0) return !1;
    }
    return !0;
  }
  if (s.some((i) => !zn(i))) {
    let i = fM(e, s);
    if (i === void 0 || ((s = [j(s[0], e.claims[i].at), ...s.slice(1)]), s.some((o) => !zn(o))))
      return !1;
  }
  if (r.cmp) return Xf(r.cmp, s[0], s[1]) === !0;
  for (let i = 0; i + 1 < s.length; i++) if (Fi(s[i], s[i + 1]) !== !0) return !1;
  return !0;
}
var Ab = {
    solved: 0,
    square: 10,
    cube: 10,
    factored: 10,
    canonical: 15,
    partial: 17,
    expanded: 20,
    unsorted: 25,
    rational: 30,
    transcendental: 40,
    unknown: 50,
  },
  Xr = (e, n) => $(e).has(n);
function al(e, n) {
  switch (e.k) {
    case 'sym':
      return e.n === n ? 1 : 0;
    case 'num':
      return 0;
    case 'add':
    case 'mul':
      return e.c.reduce((t, r) => t + al(r, n), 0);
    case 'div':
    case 'pow':
    case 'binom':
      return al(e.a, n) + al(e.b, n);
    case 'fn':
      return al(e.a, n);
  }
}
function jb(e) {
  let n = Z(e);
  return n.ok ? $e(n.rf) : null;
}
function td(e, n) {
  let t = jb(e);
  if (!t) return null;
  let r = (o) => {
      let a = 0,
        l = !1;
      for (let { m: u } of o.t.values())
        for (let c of u)
          c.a.kind === 'sym' && c.a.symbol === n
            ? (a = Math.max(a, c.e))
            : c.a.kind === 'opaque' && !c.a.constant && Xr(c.a.term, n) && (l = !0);
      return { deg: a, opaque: l };
    },
    s = r(t.n),
    i = r(t.d);
  return { deg: s.deg, den: i.deg > 0 || i.opaque || Bo(e, n), opaque: s.opaque || i.opaque };
}
function Bo(e, n) {
  switch (e.k) {
    case 'add':
    case 'mul':
      return e.c.some((t) => Bo(t, n));
    case 'div':
      return Xr(e.b, n) || Bo(e.a, n);
    case 'pow':
    case 'binom':
      return Bo(e.a, n) || Bo(e.b, n);
    case 'fn':
      return Bo(e.a, n);
    default:
      return !1;
  }
}
function li(e) {
  let n = jb(e);
  return !!n && Ue(n.n);
}
function ll(e, n = []) {
  switch (e.k) {
    case 'num':
      return n;
    case 'mul':
      return (e.c.forEach((t) => ll(t, n)), n);
    case 'div':
      return (ll(e.a, n), ll(e.b, n), n);
    case 'pow':
      return e.b.k === 'num' && B(e.b.v) && e.b.v.n > 0n ? ll(e.a, n) : (n.push(e), n);
    default:
      return (n.push(e), n);
  }
}
function TM(e, n) {
  let t = [];
  for (let r of ll(e)) {
    if (!Xr(r, n)) continue;
    let s = td(r, n);
    if (!s || s.opaque || s.den) return null;
    t.push({ f: r, deg: s.deg });
  }
  return t;
}
function kD(e, n) {
  if (e.k === 'add') return !1;
  let t = TM(e, n);
  return !!t && t.length > 0 && t.every((r) => r.deg <= 1);
}
function xD(e, n) {
  if (e.k === 'add') return !1;
  let t = TM(e, n);
  return !!t && t.length > 1 && t.some((r) => r.deg >= 2);
}
function wp(e, n) {
  let t = (s) => {
      if (s.k !== 'pow' || s.b.k !== 'num' || !M(s.b.v, C(2))) return null;
      let i = td(s.a, n);
      return i && i.deg === 1 && !i.den && !i.opaque && al(s.a, n) === 1 ? s.a : null;
    },
    r = t(e);
  if (r) return { base: r, coef: !1 };
  if (e.k === 'mul') {
    let s = e.c.filter((i) => i.k !== 'num');
    if (s.length === 1) {
      let i = t(s[0]);
      if (i) return { base: i, coef: !0 };
    }
  }
  return null;
}
function Qb(e, n) {
  let t = (s) => {
      if (s.k !== 'pow' || s.b.k !== 'num' || !M(s.b.v, C(3))) return null;
      let i = td(s.a, n);
      return i && i.deg === 1 && !i.den && !i.opaque && al(s.a, n) === 1 ? s.a : null;
    },
    r = t(e);
  if (r) return { base: r, coef: !1 };
  if (e.k === 'mul') {
    let s = e.c.filter((i) => i.k !== 'num');
    if (s.length === 1) {
      let i = t(s[0]);
      if (i) return { base: i, coef: !0 };
    }
  }
  return null;
}
function yD(e, n) {
  if (al(e, n) !== 1) return !1;
  let t = (r, s) => {
    switch (r.k) {
      case 'sym':
        return r.n === n && s;
      case 'num':
        return !1;
      case 'add':
      case 'mul':
        return r.c.some((i) => t(i, s));
      case 'div':
        return t(r.a, s) || t(r.b, s);
      case 'pow':
        return t(r.a, s || (r.b.k === 'num' && M(r.b.v, C(2)))) || t(r.b, s);
      case 'fn':
      case 'binom':
        return !1;
    }
  };
  return t(e, !1);
}
function RM(e, n, t) {
  return e.l.k === 'sym' && e.l.n === n && !Xr(e.r, n)
    ? !0
    : t && e.r.k === 'sym' && e.r.n === n && !Xr(e.l, n);
}
function ui(e, n, t = !1) {
  if ((!Xr(e.l, n) && !Xr(e.r, n)) || RM(e, n, t)) return 'solved';
  let r = td(ve(e.l, e.r), n);
  if (!r) return 'unknown';
  if (r.opaque) return 'transcendental';
  if (r.deg <= 1 && !r.den) return 'linear';
  let s = li(e.l),
    i = li(e.r),
    o = s ? e.r : i ? e.l : null;
  if (o && kD(o, n)) return 'factored';
  let a = Xr(e.l, n),
    l = Xr(e.r, n),
    u = a && !l ? e.l : l && !a ? e.r : null;
  if (u && al(u, n) === 1) {
    if (wp(u, n)) return 'square';
    if (Qb(u, n)) return 'cube';
    if (yD(u, n)) return 'canonical';
  }
  return r.den && e.rel === '=' ? 'rational' : o ? (xD(o, n) ? 'partial' : 'expanded') : 'unsorted';
}
function wD(e) {
  return {
    rel: { '=': '=', '<': '>', '>': '<', '\u2264': '\u2265', '\u2265': '\u2264' }[e.rel],
    l: e.r,
    r: e.l,
  };
}
function b1(e, n, t) {
  let r = (a, l) => {
    let u = ui(a, n, l);
    if (u === 'linear') {
      let f = l ? Math.min(t(a), t(wD(a))) : t(a);
      return Math.min(9, f);
    }
    if (u === 'transcendental') return Ab.transcendental + t(a);
    let c = !l && !Xr(a.l, n) && Xr(a.r, n) ? 1 : 0;
    if (u === 'square') {
      let f = wp(Xr(a.l, n) ? a.l : a.r, n);
      return Ab.square + (f?.coef ? 2 : 0) + c;
    }
    if (u === 'cube') {
      let f = Qb(Xr(a.l, n) ? a.l : a.r, n);
      return Ab.cube + (f?.coef ? 2 : 0) + c;
    }
    return Ab[u] + (u === 'solved' ? 0 : c);
  };
  if (e.k === 'expr') return 0;
  if (e.k === 'rel') return r(e, !1);
  let i = (e.k === 'set' ? e.clauses : e.items.map((a) => [a])).map((a) =>
      Math.max(...a.map((l) => r(l, !0))),
    ),
    o = Math.max(...i);
  return o + 0.1 * (i.reduce((a, l) => a + l, 0) - o) + 0.05 * (i.length - 1);
}
function zo(e, n) {
  if (e.k === 'expr') return !1;
  let t = e.k === 'rel' ? [e] : e.k === 'set' ? e.clauses.flat() : e.items;
  return t.length > 0 && t.every((r) => RM(r, n, !0));
}
function Fb(e, n) {
  let t = jb(ve(e.l, e.r)),
    r = t ? je(t.d) : null;
  if (!t || r === null) return null;
  let s = Ys(t.n, n);
  if (!s || s.length !== 3 || L(s[2])) return null;
  let i = A(q, r),
    [o, a, l] = s.map((c) => N(c, i)),
    u = me(N(a, a), N(C(4), N(l, o)));
  return { a: l, b: a, c: o, disc: u };
}
function v1(e, n) {
  let t = ui(e, n);
  if (t !== 'expanded' && t !== 'unsorted' && t !== 'partial' && t !== 'canonical') return 0;
  let r = jb(ve(e.l, e.r)),
    s = r ? je(r.d) : null;
  if (!r || s === null || L(s)) return 0;
  let i = Ys(r.n, n);
  if (!i || i.length < 3) return 0;
  let o = A(q, s),
    a = i.map((c) => N(c, o)).filter((c) => !L(c));
  if (a.some((c) => !B(c))) return 1;
  let l = (c, f) => (f === 0n ? c : l(f, c % f));
  return a.reduce((c, f) => l(c, f.n < 0n ? -f.n : f.n), 0n) > 1n ? 1 : 0;
}
function k1(e, n) {
  return e === '\u0394'
    ? 'disc'
    : e === `${n}\u2081` || e === `${n}\u2082` || e === `${n}\u2080`
      ? 'root'
      : null;
}
var K = class extends Error {
  constructor(t, r, s) {
    super(r);
    this.code = t;
    this.line = s;
    this.name = 'PyError';
  }
  code;
  line;
};
var SD = [
    '**=',
    '//=',
    '**',
    '//',
    '==',
    '!=',
    '<=',
    '>=',
    '+=',
    '-=',
    '*=',
    '/=',
    '%=',
    '->',
    '+',
    '-',
    '*',
    '/',
    '%',
    '<',
    '>',
    '=',
    '(',
    ')',
    '[',
    ']',
    '{',
    '}',
    ',',
    ':',
    '.',
    ';',
  ],
  $M = 4e3;
function Vb(e) {
  if (e.length > $M) throw new K('syntax', 'Programme trop long.', 1);
  let n = [],
    t = e.replace(
      /\r\n?/g,
      `
`,
    ).split(`
`),
    r = [0],
    s = 0;
  for (let o = 0; o < t.length; o++) {
    let a = t[o],
      l = o + 1,
      u = 0;
    if (s === 0) {
      let c = 0;
      for (; u < a.length && (a[u] === ' ' || a[u] === '	'); ) ((c += a[u] === '	' ? 4 : 1), u++);
      let f = a.slice(u);
      if (!f.trim() || f.trimStart().startsWith('#')) continue;
      let d = r[r.length - 1];
      if (c > d) (r.push(c), n.push({ t: 'indent', v: '', line: l }));
      else if (c < d) {
        for (; r[r.length - 1] > c; ) (r.pop(), n.push({ t: 'dedent', v: '', line: l }));
        if (r[r.length - 1] !== c) throw new K('syntax', 'Indentation incoh\xE9rente.', l);
      }
    }
    for (; u < a.length; ) {
      let c = a[u];
      if (c === ' ' || c === '	') {
        u++;
        continue;
      }
      if (c === '#') break;
      if (c === '\\' && u === a.length - 1) {
        u++;
        continue;
      }
      if (/[A-Za-z_À-ɏ]/.test(c)) {
        let d = u + 1;
        for (; d < a.length && /[A-Za-z0-9_À-ɏ]/.test(a[d]); ) d++;
        (n.push({ t: 'name', v: a.slice(u, d), line: l }), (u = d));
        continue;
      }
      if (/[0-9]/.test(c) || (c === '.' && /[0-9]/.test(a[u + 1] ?? ''))) {
        let d = /^(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?/.exec(a.slice(u));
        if (/[A-Za-z_]/.test(a[u + d[0].length] ?? ''))
          throw new K('syntax', 'Nombre mal \xE9crit.', l);
        (n.push({ t: 'num', v: d[0], line: l }), (u += d[0].length));
        continue;
      }
      if (c === '"' || c === "'") {
        let d = u + 1,
          m = '';
        for (; d < a.length && a[d] !== c; )
          if (a[d] === '\\' && d + 1 < a.length) {
            let p = a[d + 1];
            ((m +=
              p === 'n'
                ? `
`
                : p === 't'
                  ? '	'
                  : p),
              (d += 2));
          } else m += a[d++];
        if (d >= a.length) throw new K('syntax', 'Cha\xEEne de caract\xE8res non ferm\xE9e.', l);
        (n.push({ t: 'str', v: m, line: l }), (u = d + 1));
        continue;
      }
      let f = SD.find((d) => a.startsWith(d, u));
      if (!f) throw new K('syntax', `Caract\xE8re inattendu \xAB ${c} \xBB.`, l);
      ((f === '(' || f === '[' || f === '{') && s++,
        (f === ')' || f === ']' || f === '}') && (s = Math.max(0, s - 1)),
        n.push({ t: 'op', v: f, line: l }),
        (u += f.length));
    }
    s === 0 &&
      n.length &&
      n[n.length - 1].t !== 'newline' &&
      n.push({ t: 'newline', v: '', line: l });
  }
  if (s > 0) throw new K('syntax', 'Parenth\xE8se non ferm\xE9e.', t.length);
  let i = t.length;
  for (
    n.length && n[n.length - 1].t !== 'newline' && n.push({ t: 'newline', v: '', line: i });
    r.length > 1;
  )
    (r.pop(), n.push({ t: 'dedent', v: '', line: i }));
  return (n.push({ t: 'eof', v: '', line: i }), n);
}
var CM = new Set([
    'if',
    'elif',
    'else',
    'while',
    'for',
    'in',
    'def',
    'return',
    'and',
    'or',
    'not',
    'pass',
    'break',
    'continue',
    'import',
    'from',
    'as',
    'is',
    'lambda',
    'class',
    'try',
    'except',
    'with',
    'global',
    'nonlocal',
    'yield',
    'del',
    'assert',
    'raise',
    'True',
    'False',
    'None',
  ]),
  x1 = new Set([
    'lambda',
    'class',
    'try',
    'except',
    'with',
    'global',
    'nonlocal',
    'yield',
    'del',
    'assert',
    'raise',
    'is',
    'as',
  ]),
  y1 = { '+=': '+', '-=': '-', '*=': '*', '/=': '/', '//=': '//', '%=': '%', '**=': '**' },
  Db = class {
    constructor(n) {
      this.toks = n;
    }
    toks;
    i = 0;
    get tok() {
      return this.toks[this.i];
    }
    kind() {
      return this.toks[this.i].t;
    }
    peek(n = 1) {
      return this.toks[Math.min(this.i + n, this.toks.length - 1)];
    }
    isOp(n) {
      return this.tok.t === 'op' && this.tok.v === n;
    }
    isKw(n) {
      return this.tok.t === 'name' && this.tok.v === n;
    }
    fail(n, t = this.tok.line) {
      throw new K('syntax', n, t);
    }
    expectOp(n) {
      return (this.isOp(n) || this.fail(`\xAB ${n} \xBB attendu.`), this.toks[this.i++]);
    }
    expectKw(n) {
      (this.isKw(n) || this.fail(`\xAB ${n} \xBB attendu.`), this.i++);
    }
    expectName() {
      let n = this.tok;
      return ((n.t !== 'name' || CM.has(n.v)) && this.fail('Nom attendu.'), this.i++, n);
    }
    module() {
      let n = [];
      for (; this.tok.t !== 'eof'; ) {
        if (this.tok.t === 'newline') {
          this.i++;
          continue;
        }
        (this.tok.t === 'indent' && this.fail('Indentation inattendue.'),
          n.push(...this.statement()));
      }
      return { body: n };
    }
    statement() {
      let n = this.tok;
      if (n.t === 'name' && x1.has(n.v))
        throw new K('unsupported', `\xAB ${n.v} \xBB n\u2019est pas pris en charge.`, n.line);
      return this.isKw('if')
        ? [this.ifStmt()]
        : this.isKw('while')
          ? [this.whileStmt()]
          : this.isKw('for')
            ? [this.forStmt()]
            : this.isKw('def')
              ? [this.defStmt()]
              : this.simpleLine();
    }
    block() {
      if ((this.expectOp(':'), this.tok.t !== 'newline')) return this.simpleLine();
      (this.i++,
        this.toks[this.i].t !== 'indent' && this.fail('Bloc indent\xE9 attendu.'),
        this.i++);
      let n = [];
      for (; this.kind() !== 'dedent' && this.kind() !== 'eof'; ) {
        if (this.kind() === 'newline') {
          this.i++;
          continue;
        }
        n.push(...this.statement());
      }
      return (this.kind() === 'dedent' && this.i++, n.length || this.fail('Bloc vide.'), n);
    }
    ifStmt() {
      let n = this.tok.line;
      this.i++;
      let t = this.expr(),
        r = this.block(),
        s = [];
      return (
        this.isKw('elif')
          ? (s = [{ ...this.ifStmt(), elif: !0 }])
          : this.isKw('else') && (this.i++, (s = this.block())),
        { k: 'if', test: t, body: r, orelse: s, line: n }
      );
    }
    whileStmt() {
      let n = this.tok.line;
      this.i++;
      let t = this.expr(),
        r = this.block();
      if (this.isKw('else'))
        throw new K(
          'unsupported',
          '\xAB while \u2026 else \xBB n\u2019est pas pris en charge.',
          this.tok.line,
        );
      return { k: 'while', test: t, body: r, line: n };
    }
    forStmt() {
      let n = this.tok.line;
      this.i++;
      let t = this.targetList();
      this.expectKw('in');
      let r = this.exprList(),
        s = this.block();
      if (this.isKw('else'))
        throw new K(
          'unsupported',
          '\xAB for \u2026 else \xBB n\u2019est pas pris en charge.',
          this.tok.line,
        );
      return { k: 'for', target: t, iter: r, body: s, line: n };
    }
    defStmt() {
      let n = this.tok.line;
      this.i++;
      let t = this.expectName().v;
      this.expectOp('(');
      let r = [];
      for (; !this.isOp(')'); ) {
        if ((r.push(this.expectName().v), this.isOp(':')))
          throw new K(
            'unsupported',
            'Les annotations de type ne sont pas prises en charge.',
            this.tok.line,
          );
        if (this.isOp('='))
          throw new K(
            'unsupported',
            'Les valeurs par d\xE9faut ne sont pas prises en charge.',
            this.tok.line,
          );
        this.isOp(')') || this.expectOp(',');
      }
      if ((this.i++, this.isOp('->')))
        throw new K(
          'unsupported',
          'Les annotations de type ne sont pas prises en charge.',
          this.tok.line,
        );
      new Set(r).size !== r.length && this.fail('Param\xE8tre en double.', n);
      let s = this.block();
      return { k: 'def', name: t, params: r, body: s, line: n };
    }
    simpleLine() {
      let n = [this.small()];
      for (; this.isOp(';') && (this.i++, this.tok.t !== 'newline'); ) n.push(this.small());
      return (this.tok.t !== 'newline' && this.fail('Fin de ligne attendue.'), this.i++, n);
    }
    small() {
      let n = this.tok,
        t = n.line;
      if (n.t === 'name' && x1.has(n.v))
        throw new K('unsupported', `\xAB ${n.v} \xBB n\u2019est pas pris en charge.`, t);
      if (this.isKw('pass')) return (this.i++, { k: 'pass', line: t });
      if (this.isKw('break')) return (this.i++, { k: 'break', line: t });
      if (this.isKw('continue')) return (this.i++, { k: 'continue', line: t });
      if (this.isKw('return'))
        return (
          this.i++,
          this.tok.t === 'newline' || this.isOp(';')
            ? { k: 'return', value: null, line: t }
            : { k: 'return', value: this.exprList(), line: t }
        );
      if (this.isKw('import')) {
        this.i++;
        let s = [this.expectName().v];
        for (; this.isOp(','); ) (this.i++, s.push(this.expectName().v));
        return { k: 'import', names: s, from: null, line: t };
      }
      if (this.isKw('from')) {
        this.i++;
        let s = this.expectName().v;
        this.expectKw('import');
        let i = [];
        if (this.isOp('*')) (this.i++, i.push('*'));
        else
          for (i.push(this.expectName().v); this.isOp(','); )
            (this.i++, i.push(this.expectName().v));
        return { k: 'import', names: i, from: s, line: t };
      }
      let r = this.exprList();
      if (this.tok.t === 'op' && y1[this.tok.v]) {
        let s = y1[this.tok.v];
        this.i++;
        let i = rd(r);
        return (
          i.k === 'tuple' && this.fail('Affectation augment\xE9e sur plusieurs variables.', t),
          { k: 'aug', target: i, op: s, value: this.expr(), line: t }
        );
      }
      if (this.isOp('=')) {
        let s = [rd(r)],
          i = r;
        for (; this.isOp('='); ) (this.i++, (i = this.exprList()), this.isOp('=') && s.push(rd(i)));
        return { k: 'assign', targets: s, value: i, line: t };
      }
      return { k: 'expr', e: r, line: t };
    }
    targetList() {
      let n = this.tok.line,
        t = [rd(this.primaryOrParen())],
        r = !1;
      for (; this.isOp(',') && ((r = !0), this.i++, !this.isKw('in')); )
        t.push(rd(this.primaryOrParen()));
      return r ? { k: 'tuple', items: t, line: n } : t[0];
    }
    primaryOrParen() {
      return this.primary();
    }
    exprList() {
      let n = this.tok.line,
        t = this.expr();
      if (!this.isOp(',')) return t;
      let r = [t];
      for (; this.isOp(',') && (this.i++, !this.endsList()); ) r.push(this.expr());
      return { k: 'tuple', items: r, line: n };
    }
    endsList() {
      let n = this.tok;
      return (
        n.t === 'newline' ||
        (n.t === 'op' && [')', ']', '=', ';', ':'].includes(n.v)) ||
        (n.t === 'op' && !!y1[n.v])
      );
    }
    expr() {
      let n = this.tok.line,
        t = this.orTest();
      if (this.isKw('if')) {
        this.i++;
        let r = this.orTest();
        this.expectKw('else');
        let s = this.expr();
        return { k: 'ifexp', test: r, body: t, orelse: s, line: n };
      }
      return t;
    }
    orTest() {
      let n = this.andTest();
      for (; this.isKw('or'); ) {
        let t = this.tok.line;
        (this.i++, (n = { k: 'bool', op: 'or', l: n, r: this.andTest(), line: t }));
      }
      return n;
    }
    andTest() {
      let n = this.notTest();
      for (; this.isKw('and'); ) {
        let t = this.tok.line;
        (this.i++, (n = { k: 'bool', op: 'and', l: n, r: this.notTest(), line: t }));
      }
      return n;
    }
    notTest() {
      if (this.isKw('not')) {
        let n = this.tok.line;
        return (this.i++, { k: 'unary', op: 'not', e: this.notTest(), line: n });
      }
      return this.comparison();
    }
    cmpOp() {
      let n = this.tok;
      if (n.t === 'op' && ['<', '>', '<=', '>=', '==', '!='].includes(n.v)) return n.v;
      if (this.isKw('in')) return 'in';
      if (this.isKw('not') && this.peek().t === 'name' && this.peek().v === 'in') return 'not in';
      if (this.isKw('is'))
        throw new K('unsupported', '\xAB is \xBB n\u2019est pas pris en charge.', n.line);
      return null;
    }
    comparison() {
      let n = this.tok.line,
        t = this.arith(),
        r = [],
        s = [];
      for (let i = this.cmpOp(); i; i = this.cmpOp())
        ((this.i += i === 'not in' ? 2 : 1), r.push(i), s.push(this.arith()));
      return r.length ? { k: 'compare', first: t, ops: r, rest: s, line: n } : t;
    }
    arith() {
      let n = this.term();
      for (; this.isOp('+') || this.isOp('-'); ) {
        let t = this.toks[this.i++];
        n = { k: 'bin', op: t.v, l: n, r: this.term(), line: t.line };
      }
      return n;
    }
    term() {
      let n = this.factor();
      for (; this.isOp('*') || this.isOp('/') || this.isOp('//') || this.isOp('%'); ) {
        let t = this.toks[this.i++];
        n = { k: 'bin', op: t.v, l: n, r: this.factor(), line: t.line };
      }
      return n;
    }
    factor() {
      if (this.isOp('-') || this.isOp('+')) {
        let n = this.toks[this.i++];
        return { k: 'unary', op: n.v, e: this.factor(), line: n.line };
      }
      return this.power();
    }
    power() {
      let n = this.primary();
      if (this.isOp('**')) {
        let t = this.toks[this.i++];
        return { k: 'bin', op: '**', l: n, r: this.factor(), line: t.line };
      }
      return n;
    }
    primary() {
      let n = this.atom();
      for (;;)
        if (this.isOp('(')) {
          let t = this.tok.line;
          this.i++;
          let r = [];
          for (; !this.isOp(')'); ) {
            if (this.tok.t === 'name' && this.peek().t === 'op' && this.peek().v === '=')
              throw new K(
                'unsupported',
                'Les arguments nomm\xE9s ne sont pas pris en charge.',
                this.tok.line,
              );
            (r.push(this.expr()), this.isOp(')') || this.expectOp(','));
          }
          (this.i++, (n = { k: 'call', f: n, args: r, line: t }));
        } else if (this.isOp('[')) {
          let t = this.tok.line;
          this.i++;
          let r = null;
          if ((this.isOp(':') || (r = this.expr()), this.isOp(':'))) {
            this.i++;
            let s = this.isOp(']') || this.isOp(':') ? null : this.expr(),
              i = null;
            (this.isOp(':') && (this.i++, (i = this.isOp(']') ? null : this.expr())),
              this.expectOp(']'),
              (n = { k: 'slice', e: n, lo: r, hi: s, step: i, line: t }));
          } else (this.expectOp(']'), (n = { k: 'index', e: n, i: r, line: t }));
        } else if (this.isOp('.')) {
          let t = this.tok.line;
          (this.i++, (n = { k: 'attr', e: n, name: this.expectName().v, line: t }));
        } else return n;
    }
    atom() {
      let n = this.tok,
        t = n.line;
      if (n.t === 'num') return (this.i++, { k: 'num', text: n.v, line: t });
      if (n.t === 'str') {
        this.i++;
        let r = n.v;
        for (; this.tok.t === 'str'; ) r += this.toks[this.i++].v;
        return { k: 'str', v: r, line: t };
      }
      if (n.t === 'name') {
        if (n.v === 'True' || n.v === 'False' || n.v === 'None')
          return (this.i++, { k: 'const', v: n.v, line: t });
        if (x1.has(n.v))
          throw new K('unsupported', `\xAB ${n.v} \xBB n\u2019est pas pris en charge.`, t);
        return (
          CM.has(n.v) && this.fail(`\xAB ${n.v} \xBB inattendu.`),
          this.i++,
          { k: 'name', id: n.v, line: t }
        );
      }
      if (this.isOp('(')) {
        if ((this.i++, this.isOp(')'))) return (this.i++, { k: 'tuple', items: [], line: t });
        let r = this.expr();
        if (this.isOp(')')) return (this.i++, r);
        let s = [r];
        for (; this.isOp(',') && (this.i++, !this.isOp(')')); ) s.push(this.expr());
        return (this.expectOp(')'), { k: 'tuple', items: s, line: t });
      }
      if (this.isOp('[')) {
        this.i++;
        let r = [];
        if (this.isOp(']')) return (this.i++, { k: 'list', items: r, line: t });
        let s = this.expr();
        if (this.isKw('for')) {
          this.i++;
          let i = this.targetList();
          this.expectKw('in');
          let o = this.orTest(),
            a = null;
          if ((this.isKw('if') && (this.i++, (a = this.orTest())), this.isKw('for')))
            throw new K('unsupported', 'Une seule boucle par compr\xE9hension.', this.tok.line);
          return (this.expectOp(']'), { k: 'comp', elt: s, target: i, iter: o, cond: a, line: t });
        }
        for (r.push(s); this.isOp(',') && (this.i++, !this.isOp(']')); ) r.push(this.expr());
        return (this.expectOp(']'), { k: 'list', items: r, line: t });
      }
      if (this.isOp('{'))
        throw new K('unsupported', 'Les dictionnaires ne sont pas pris en charge.', t);
      ((n.t === 'newline' || n.t === 'eof') && this.fail('Expression incompl\xE8te.'),
        this.fail(`\xAB ${n.v} \xBB inattendu.`));
    }
  };
function rd(e) {
  if (e.k === 'name') return { k: 'name', id: e.id, line: e.line };
  if (e.k === 'tuple') return { k: 'tuple', items: e.items.map(rd), line: e.line };
  if (e.k === 'index') return { k: 'index', e: e.e, i: e.i, line: e.line };
  throw new K('syntax', 'On ne peut pas affecter une valeur \xE0 cette expression.', e.line);
}
function w1(e) {
  return new Db(Vb(e)).module();
}
function S1(e) {
  return new Db(Vb(e)).expr();
}
var EM = (e) => e.k === 'if' || e.k === 'while' || e.k === 'for' || e.k === 'def';
var Sp = class {
  mt = new Uint32Array(624);
  mti = 625;
  constructor(n = 0n) {
    this.seed(n);
  }
  initGenrand(n) {
    let t = this.mt;
    t[0] = n >>> 0;
    for (let r = 1; r < 624; r++) {
      let s = t[r - 1];
      t[r] = (Math.imul(1812433253, s ^ (s >>> 30)) + r) >>> 0;
    }
    this.mti = 624;
  }
  initByArray(n) {
    let t = this.mt;
    this.initGenrand(19650218);
    let r = 1,
      s = 0;
    for (let i = Math.max(624, n.length); i > 0; i--) {
      let o = t[r - 1];
      ((t[r] = ((t[r] ^ Math.imul(o ^ (o >>> 30), 1664525)) + n[s] + s) >>> 0),
        r++,
        s++,
        r >= 624 && ((t[0] = t[623]), (r = 1)),
        s >= n.length && (s = 0));
    }
    for (let i = 623; i > 0; i--) {
      let o = t[r - 1];
      ((t[r] = ((t[r] ^ Math.imul(o ^ (o >>> 30), 1566083941)) - r) >>> 0),
        r++,
        r >= 624 && ((t[0] = t[623]), (r = 1)));
    }
    t[0] = 2147483648;
  }
  seed(n) {
    let t = n < 0n ? -n : n,
      r = [];
    for (; t > 0n; ) (r.push(Number(t & 0xffffffffn)), (t >>= 32n));
    (r.length || r.push(0), this.initByArray(r));
  }
  next32() {
    let n = this.mt;
    if (this.mti >= 624) {
      let r = 0,
        s;
      for (; r < 227; r++)
        ((s = (n[r] & 2147483648) | (n[r + 1] & 2147483647)),
          (n[r] = n[r + 397] ^ (s >>> 1) ^ (s & 1 ? 2567483615 : 0)));
      for (; r < 623; r++)
        ((s = (n[r] & 2147483648) | (n[r + 1] & 2147483647)),
          (n[r] = n[r + -227] ^ (s >>> 1) ^ (s & 1 ? 2567483615 : 0)));
      ((s = (n[623] & 2147483648) | (n[0] & 2147483647)),
        (n[623] = n[396] ^ (s >>> 1) ^ (s & 1 ? 2567483615 : 0)),
        (this.mti = 0));
    }
    let t = n[this.mti++];
    return (
      (t ^= t >>> 11),
      (t ^= (t << 7) & 2636928640),
      (t ^= (t << 15) & 4022730752),
      (t ^= t >>> 18),
      t >>> 0
    );
  }
  random() {
    let n = BigInt(this.next32() >>> 5),
      t = BigInt(this.next32() >>> 6);
    return { n: n * 67108864n + t, d: 9007199254740992n };
  }
  getrandbits(n) {
    if (n <= 0) return 0n;
    if (n <= 32) return BigInt(this.next32() >>> (32 - n));
    let t = 0n,
      r = 0n;
    for (let s = n; s > 0; s -= 32) {
      let i = this.next32();
      (s < 32 && (i >>>= 32 - s), (t |= BigInt(i) << r), (r += 32n));
    }
    return t;
  }
  randbelow(n) {
    if (n <= 0n) return 0n;
    let t = n.toString(2).length,
      r = this.getrandbits(t);
    for (; r >= n; ) r = this.getrandbits(t);
    return r;
  }
};
var vr = { t: 'none' },
  gn = (e) => ({ t: 'int', v: BigInt(e) }),
  An = (e) => ({ t: 'float', v: e }),
  Uo = (e) => ({ t: 'bool', v: e }),
  ul = (e) => e.t === 'int' || e.t === 'float' || e.t === 'bool';
function On(e) {
  return e.t === 'int' ? C(e.v) : e.t === 'float' ? e.v : e.t === 'bool' ? (e.v ? q : F) : null;
}
function zi(e, n) {
  let t = On(e),
    r = On(n);
  return t && r
    ? M(t, r)
    : e.t === 'str' && n.t === 'str'
      ? e.v === n.v
      : e.t === 'none' && n.t === 'none'
        ? !0
        : (e.t === 'list' && n.t === 'list') || (e.t === 'tuple' && n.t === 'tuple')
          ? e.items.length === n.items.length && e.items.every((s, i) => zi(s, n.items[i]))
          : e.t === 'range' && n.t === 'range'
            ? e.start === n.start && e.stop === n.stop && e.step === n.step
            : !1;
}
function Pt(e) {
  return e.t === 'list'
    ? { t: 'list', items: e.items.map(Pt) }
    : e.t === 'tuple'
      ? { t: 'tuple', items: e.items.map(Pt) }
      : e;
}
function T1(e) {
  let n = e.d;
  for (; n % 2n === 0n; ) n /= 2n;
  for (; n % 5n === 0n; ) n /= 5n;
  return n === 1n;
}
function R1(e, n = ',') {
  let t = e.n < 0n,
    r = t ? -e.n : e.n,
    s = 0,
    i = 1n;
  for (; (r * i) % e.d !== 0n && ((i *= 10n), s++, !(s > 40)); );
  let o = ((r * i) / e.d).toString().padStart(s + 1, '0'),
    a = o.slice(0, o.length - s),
    l = s ? o.slice(o.length - s) : '';
  return (t ? '\u2212' : '') + a + (l ? n + l : '');
}
function TD(e) {
  let n = e.d,
    t = 0,
    r = 0;
  for (; n % 2n === 0n; ) ((n /= 2n), t++);
  for (; n % 5n === 0n; ) ((n /= 5n), r++);
  return Math.max(t, r);
}
function RD(e, n, t) {
  let r = Number(e.n) / Number(e.d);
  if (!Number.isFinite(r)) return MM(e, n);
  let s = String(r);
  return (
    t && Number.isInteger(r) && !/e/.test(s) && (s += '.0'),
    (r < 0 ? '\u2212' + s.slice(1) : s).replace('.', n)
  );
}
function MM(e, n) {
  let t = C(e.n * 1000000n, e.d),
    r = (t.n * 2n + (t.n < 0n ? -t.d : t.d)) / (2n * t.d);
  return R1(C(r, 1000000n), n);
}
function ct(e, n = !1) {
  let t = n ? '.' : ',',
    r = (s) => (n ? s.replace(/^−/, '-') : s);
  switch (e.t) {
    case 'int':
      return r(e.v < 0n ? '\u2212' + (-e.v).toString() : e.v.toString());
    case 'float': {
      if (e.bin || (n && (!T1(e.v) || TD(e.v) > 17))) return r(RD(e.v, t, n));
      let s = r(T1(e.v) ? R1(e.v, t) : MM(e.v, t));
      return n && e.v.d === 1n ? s + '.0' : s;
    }
    case 'bool':
      return e.v ? 'True' : 'False';
    case 'none':
      return 'None';
    case 'str':
      return n ? JSON.stringify(e.v) : e.v;
    case 'list':
      return '[' + e.items.map((s) => ct(s, n)).join(', ') + ']';
    case 'tuple':
      return '(' + e.items.map((s) => ct(s, n)).join(', ') + (e.items.length === 1 ? ',)' : ')');
    case 'range':
      return `range(${e.start}, ${e.stop}${e.step === 1n ? '' : ', ' + e.step})`;
    case 'func':
      return `<fonction ${e.def.name}>`;
    case 'builtin':
      return `<fonction ${e.name}>`;
    case 'module':
      return `<module ${e.name}>`;
    case 'method':
      return `<m\xE9thode ${e.name}>`;
  }
}
function Yr(e) {
  switch (e.t) {
    case 'int':
      return 'un entier';
    case 'float':
      return 'un nombre d\xE9cimal';
    case 'bool':
      return 'un bool\xE9en';
    case 'none':
      return 'None';
    case 'str':
      return 'une cha\xEEne';
    case 'list':
      return 'une liste';
    case 'tuple':
      return 'un tuple';
    case 'range':
      return 'un range';
    default:
      return 'une fonction';
  }
}
var LM = 2e3,
  $D = 5e3,
  _M = new Set(['randint', 'random', 'choice', 'randrange', 'uniform', 'seed', 'shuffle']),
  M1 = 2e4,
  CD = 1e3,
  ED = 100,
  Tp = 1e4,
  MD = 2048n,
  Rs = { k: 'normal' },
  _D = new Set([
    'print',
    'range',
    'len',
    'abs',
    'min',
    'max',
    'sum',
    'int',
    'float',
    'round',
    'str',
    'list',
    'sorted',
    'bool',
    'enumerate',
  ]),
  qM = new Set(['sqrt', 'floor', 'ceil', 'fabs']);
function Yu(e) {
  return e.n >= 0n ? e.n / e.d : -((-e.n + e.d - 1n) / e.d);
}
function qD(e) {
  return -Yu(fe(e));
}
function id(e, n) {
  if ((e < 0n ? -e : e).toString(2).length > Number(MD))
    throw new K('value', 'Nombre trop grand.', n);
  return e;
}
function Ju(e, n) {
  return (id(e.n, n), id(e.d, n), e);
}
function NM(e) {
  if (e.n < 0n) return null;
  let n = (s) => {
      if (s < 2n) return s;
      let i = BigInt(Math.floor(Math.sqrt(Number(s))));
      for (; i * i > s; ) i--;
      for (; (i + 1n) * (i + 1n) <= s; ) i++;
      return i * i === s ? i : null;
    },
    t = n(e.n),
    r = n(e.d);
  return t !== null && r !== null ? C(t, r) : null;
}
function Xu(e) {
  switch (e.t) {
    case 'bool':
      return e.v;
    case 'int':
      return e.v !== 0n;
    case 'float':
      return e.v.n !== 0n;
    case 'none':
      return !1;
    case 'str':
      return e.v.length > 0;
    case 'list':
    case 'tuple':
      return e.items.length > 0;
    case 'range':
      return _1(e) > 0n;
    default:
      return !0;
  }
}
function _1(e) {
  return e.step > 0n
    ? e.stop > e.start
      ? (e.stop - e.start + e.step - 1n) / e.step
      : 0n
    : e.start > e.stop
      ? (e.start - e.stop - e.step - 1n) / -e.step
      : 0n;
}
function $s(e) {
  return e.t === 'int' || e.t === 'bool';
}
function Ut(e) {
  return e.t === 'int' ? e.v : e.t === 'bool' && e.v ? 1n : 0n;
}
function $1(e, n, t, r) {
  if (e === '+') {
    if (n.t === 'list' && t.t === 'list') return sd([...n.items, ...t.items], r);
    if (n.t === 'str' && t.t === 'str') return { t: 'str', v: n.v + t.v };
    if (n.t === 'tuple' && t.t === 'tuple') return { t: 'tuple', items: [...n.items, ...t.items] };
  }
  if (e === '*') {
    let o = (a, l) => {
      let u = Ut(l);
      if (u * BigInt(a.length) > BigInt(Tp)) throw new K('value', 'Liste trop longue.', r);
      let c = [];
      for (let f = 0n; f < u; f++) c.push(...a.map(Pt));
      return c;
    };
    if (n.t === 'list' && $s(t)) return { t: 'list', items: o(n.items, t) };
    if (t.t === 'list' && $s(n)) return { t: 'list', items: o(t.items, n) };
    if (n.t === 'str' && $s(t)) return { t: 'str', v: n.v.repeat(Math.max(0, Number(Ut(t)))) };
  }
  if (e === '%' && n.t === 'str')
    throw new K(
      'unsupported',
      'Le formatage de cha\xEEnes avec % n\u2019est pas pris en charge.',
      r,
    );
  if (!ul(n) || !ul(t))
    throw new K('type', `Op\xE9ration \xAB ${e} \xBB impossible entre ${Yr(n)} et ${Yr(t)}.`, r);
  if ($s(n) && $s(t)) {
    let o = Ut(n),
      a = Ut(t);
    switch (e) {
      case '+':
        return gn(id(o + a, r));
      case '-':
        return gn(id(o - a, r));
      case '*':
        return gn(id(o * a, r));
      case '/':
        if (a === 0n) throw new K('zero_division', 'Division par z\xE9ro.', r);
        return An(C(o, a));
      case '//':
        if (a === 0n) throw new K('zero_division', 'Division par z\xE9ro.', r);
        return gn(Yu(C(o, a)));
      case '%': {
        if (a === 0n) throw new K('zero_division', 'Division par z\xE9ro (reste).', r);
        return gn(o - a * Yu(C(o, a)));
      }
      case '**': {
        if (a < 0n) {
          if (o === 0n) throw new K('zero_division', '0 \xE0 une puissance n\xE9gative.', r);
          if (-a > 4096n) throw new K('value', 'Exposant trop grand.', r);
          return An(Ju(at(C(o), Number(a)), r));
        }
        if (a > 4096n && o !== 0n && o !== 1n && o !== -1n)
          throw new K('value', 'Exposant trop grand.', r);
        return gn(id(o ** (a > 4096n ? a % 2n : a), r));
      }
    }
  }
  let s = On(n),
    i = On(t);
  switch (e) {
    case '+':
      return An(Ju(re(s, i), r));
    case '-':
      return An(Ju(me(s, i), r));
    case '*':
      return An(Ju(N(s, i), r));
    case '/': {
      let o = A(s, i);
      if (!o) throw new K('zero_division', 'Division par z\xE9ro.', r);
      return An(Ju(o, r));
    }
    case '//': {
      let o = A(s, i);
      if (!o) throw new K('zero_division', 'Division par z\xE9ro.', r);
      return An(C(Yu(o)));
    }
    case '%': {
      let o = A(s, i);
      if (!o) throw new K('zero_division', 'Division par z\xE9ro (reste).', r);
      return An(Ju(me(s, N(i, C(Yu(o)))), r));
    }
    case '**': {
      if (B(i)) {
        let o = Number(i.n);
        if (Math.abs(o) > 4096) throw new K('value', 'Exposant trop grand.', r);
        let a = at(s, o);
        if (!a) throw new K('zero_division', '0 \xE0 une puissance n\xE9gative.', r);
        return An(Ju(a, r));
      }
      if (M(i, C(1, 2))) {
        let o = NM(s);
        if (!o)
          throw new K('inexact', 'Cette racine n\u2019a pas de valeur d\xE9cimale exacte.', r);
        return An(o);
      }
      throw new K('inexact', 'Puissance non enti\xE8re : pas de valeur exacte.', r);
    }
  }
}
function cl(e, n, t, r) {
  if (e === '==') return zi(n, t);
  if (e === '!=') return !zi(n, t);
  if (e === 'in' || e === 'not in') {
    let a;
    if (t.t === 'list' || t.t === 'tuple') a = t.items.some((l) => zi(l, n));
    else if (t.t === 'range') {
      let l = On(n);
      a =
        !!l &&
        B(l) &&
        (t.step > 0n ? l.n >= t.start && l.n < t.stop : l.n <= t.start && l.n > t.stop) &&
        (l.n - t.start) % t.step === 0n;
    } else if (t.t === 'str' && n.t === 'str') a = t.v.includes(n.v);
    else throw new K('type', `\xAB in \xBB impossible avec ${Yr(t)}.`, r);
    return e === 'in' ? a : !a;
  }
  let s = On(n),
    i = On(t),
    o;
  if (s && i) o = Re(s, i);
  else if (n.t === 'str' && t.t === 'str') o = n.v < t.v ? -1 : n.v > t.v ? 1 : 0;
  else throw new K('type', `Comparaison impossible entre ${Yr(n)} et ${Yr(t)}.`, r);
  switch (e) {
    case '<':
      return o < 0;
    case '>':
      return o > 0;
    case '<=':
      return o <= 0;
    case '>=':
      return o >= 0;
  }
}
function sd(e, n) {
  if (e.length > Tp) throw new K('value', 'Liste trop longue.', n);
  return { t: 'list', items: e };
}
function fl(e, n) {
  if (e.t === 'list' || e.t === 'tuple') return e.items.slice();
  if (e.t === 'str') return [...e.v].map((t) => ({ t: 'str', v: t }));
  if (e.t === 'range') {
    let t = _1(e);
    if (t > BigInt(Tp)) throw new K('budget', 'Boucle trop longue.', n);
    let r = [];
    for (let s = 0n; s < t; s++) r.push(gn(e.start + s * e.step));
    return r;
  }
  throw new K('type', `On ne peut pas parcourir ${Yr(e)}.`, n);
}
function Bb(e, n, t) {
  if (!$s(n)) throw new K('type', 'Un indice doit \xEAtre un entier.', t);
  let r = Number(Ut(n));
  if ((r < 0 && (r += e.length), r < 0 || r >= e.length))
    throw new K('index', 'Indice hors de la liste.', t);
  return r;
}
var Go = {
  or: 1,
  and: 2,
  not: 3,
  cmp: 4,
  '+': 5,
  '-': 5,
  '*': 6,
  '/': 6,
  '//': 6,
  '%': 6,
  unary: 7,
  '**': 8,
};
function xn(e, n = 0) {
  let t = (r, s) => (s < n ? `(${r})` : r);
  switch (e.k) {
    case 'num':
      return e.text;
    case 'str':
      return JSON.stringify(e.v);
    case 'const':
      return e.v;
    case 'name':
      return e.id;
    case 'list':
      return '[' + e.items.map((r) => xn(r)).join(', ') + ']';
    case 'tuple':
      return '(' + e.items.map((r) => xn(r)).join(', ') + ')';
    case 'comp':
      return `[${xn(e.elt)} for \u2026 in ${xn(e.iter)}]`;
    case 'unary':
      return e.op === 'not'
        ? t('not ' + xn(e.e, Go.not), Go.not)
        : t(e.op + xn(e.e, Go.unary), Go.unary);
    case 'bin': {
      let r = Go[e.op];
      return t(`${xn(e.l, r)} ${e.op} ${xn(e.r, r + 1)}`, r);
    }
    case 'bool': {
      let r = Go[e.op];
      return t(`${xn(e.l, r)} ${e.op} ${xn(e.r, r + 1)}`, r);
    }
    case 'compare':
      return t(
        [xn(e.first, Go.cmp + 1), ...e.ops.map((r, s) => `${r} ${xn(e.rest[s], Go.cmp + 1)}`)].join(
          ' ',
        ),
        Go.cmp,
      );
    case 'call':
      return `${xn(e.f, 9)}(${e.args.map((r) => xn(r)).join(', ')})`;
    case 'index':
      return `${xn(e.e, 9)}[${xn(e.i)}]`;
    case 'slice':
      return `${xn(e.e, 9)}[${e.lo ? xn(e.lo) : ''}:${e.hi ? xn(e.hi) : ''}]`;
    case 'attr':
      return `${xn(e.e, 9)}.${e.name}`;
    case 'ifexp':
      return `${xn(e.body)} if ${xn(e.test)} else ${xn(e.orelse)}`;
  }
}
function C1(e, n) {
  return `${e}(${n.map((t) => ct(t)).join(', ')})`;
}
var E1 = class {
  constructor(n) {
    this.maxSteps = n;
    this.stack.push({ id: 0, name: 'Programme', f: this.globals });
  }
  maxSteps;
  steps = 0;
  depth = 0;
  points = [];
  conds = [];
  calls = [];
  output = [];
  focus = null;
  wanted = null;
  globals = { vars: new Map(), focus: !1 };
  evals = [];
  loopSeq = 0;
  draws = null;
  drawIdx = 0;
  rng = null;
  seedDefault = 0n;
  stack = [];
  frameSeq = 0;
  sim = null;
  tick(n) {
    if (++this.steps > this.maxSteps)
      throw new K('budget', 'Le programme ne s\u2019arr\xEAte pas (ou il est trop long).', n);
  }
  snapshot(n) {
    let t = {};
    return (
      n.vars.forEach((r, s) => {
        r.t === 'func' ||
          r.t === 'builtin' ||
          r.t === 'module' ||
          r.t === 'method' ||
          (t[s] = Pt(r));
      }),
      t
    );
  }
  tracing = !0;
  point(n, t, r = 'assign', s) {
    if (!(!n.focus || !this.tracing)) {
      if (this.points.length >= CD) throw new K('budget', 'Trace trop longue.', t);
      this.points.push({
        kind: r,
        line: t,
        vars: this.snapshot(n),
        end: r === 'return',
        ...(r === 'return' ? { unit: 'return', ret: Pt(s) } : {}),
      });
    }
  }
  markEnd(n, t, r, s) {
    if (!n.focus || this.points.length <= t) return;
    let i = this.points[this.points.length - 1];
    i.end || ((i.end = !0), (i.unit = r), s && (i.loop = s));
  }
  simRec(n, t, r, s = {}) {
    let i = this.sim;
    if (!i) return;
    if (i.steps.length >= LM) {
      i.truncated = !0;
      return;
    }
    let o = i.steps[i.steps.length - 1],
      a = this.stack.map(({ id: l, name: u, f: c }) => {
        let f = o?.frames.find((m) => m.id === l),
          d = [];
        return (
          c.vars.forEach((m, p) => {
            if (m.t === 'func' || m.t === 'builtin' || m.t === 'module' || m.t === 'method') return;
            let g = ct(m, !0),
              h = f?.vars.find((b) => b.name === p);
            d.push({ name: p, value: g, changed: !h || h.value !== g });
          }),
          { id: l, name: u, vars: d }
        );
      });
    i.steps.push({ line: t, kind: n, label: r, frames: a, output: this.output.slice(), ...s });
  }
  srcLine(n) {
    return (this.sim?.lines[n - 1] ?? '').trim();
  }
  lookup(n, t, r) {
    let s = n.vars.get(t) ?? this.globals.vars.get(t);
    if (s) return s;
    if (_D.has(t)) return { t: 'builtin', name: t };
    throw new K('name', `La variable \xAB ${t} \xBB n\u2019existe pas (encore).`, r);
  }
  execBody(n, t, r) {
    let s = -1,
      i = t.focus && r === 0;
    for (let o = 0; o < n.length; o++) {
      let a = n[o],
        l = !EM(a) && a.k !== 'return';
      i &&
        (l ? s < 0 && (s = this.points.length) : s >= 0 && (this.markEnd(t, s, 'block'), (s = -1)));
      let u = this.exec(a, t, r);
      if (u.k !== 'normal') return (i && s >= 0 && this.markEnd(t, s, 'block'), u);
    }
    return (i && s >= 0 && this.markEnd(t, s, 'block'), Rs);
  }
  exec(n, t, r) {
    switch ((this.tick(n.line), n.k)) {
      case 'pass':
        return (this.simRec('stmt', n.line, 'pass : rien \xE0 faire'), Rs);
      case 'break':
        return (this.simRec('stmt', n.line, 'break : on sort de la boucle'), { k: 'break' });
      case 'continue':
        return (
          this.simRec('stmt', n.line, 'continue : on passe au tour suivant'),
          { k: 'continue' }
        );
      case 'import':
        return (this.doImport(n), this.simRec('stmt', n.line, this.srcLine(n.line)), Rs);
      case 'def':
        return (
          t.vars.set(n.name, { t: 'func', def: n }),
          this.simRec(
            'stmt',
            n.line,
            `La fonction ${n.name} est d\xE9finie (elle ne s\u2019ex\xE9cute pas encore)`,
          ),
          Rs
        );
      case 'expr': {
        let s = n.e;
        return (
          this.eval(s, t),
          s.k === 'call' && s.f.k === 'attr' && this.point(t, n.line),
          this.simRec('stmt', n.line, this.srcLine(n.line)),
          Rs
        );
      }
      case 'assign': {
        let s = this.eval(n.value, t);
        return (
          n.targets.forEach((i) => this.assign(i, n.targets.length > 1 ? Pt(s) : s, t)),
          this.point(t, n.line),
          this.simRec('stmt', n.line, this.srcLine(n.line)),
          Rs
        );
      }
      case 'aug': {
        let s = this.eval(KM(n.target), t),
          i = this.eval(n.value, t);
        if (s.t === 'list' && n.op === '+' && i.t === 'list') {
          if ((s.items.push(...i.items.map(Pt)), s.items.length > Tp))
            throw new K('value', 'Liste trop longue.', n.line);
        } else this.assign(n.target, $1(n.op, s, i, n.line), t);
        return (this.point(t, n.line), this.simRec('stmt', n.line, this.srcLine(n.line)), Rs);
      }
      case 'return': {
        let s = n.value ? this.eval(n.value, t) : vr;
        this.point(t, n.line, 'return', s);
        let i = ct(s, !0);
        return (
          this.simRec('return', n.line, `La fonction renvoie ${i}`, { ret: i }),
          { k: 'return', v: s }
        );
      }
      case 'if': {
        let s = this.points.length,
          i = this.execIf(n, t, r);
        return (t.focus && r === 0 && this.markEnd(t, s, 'branch'), i);
      }
      case 'while': {
        let s = t.focus ? ++this.loopSeq : 0;
        for (;;) {
          if (!this.test(n.test, t, n.line, !0)) return Rs;
          this.tick(n.line);
          let i = this.points.length,
            o = this.execBody(n.body, t, r + 1);
          if ((this.markEnd(t, i, 'iteration', s), o.k === 'break')) return Rs;
          if (o.k === 'return') return o;
        }
      }
      case 'for': {
        let s = t.focus ? ++this.loopSeq : 0,
          i = fl(this.eval(n.iter, t), n.line);
        for (let o of i) {
          this.tick(n.line);
          let a = this.points.length;
          (this.assign(n.target, o, t),
            this.point(t, n.line),
            this.simRec(
              'stmt',
              n.line,
              `Nouveau tour : ${OM(n.target)} prend la valeur ${ct(o, !0)}`,
            ));
          let l = this.execBody(n.body, t, r + 1);
          if ((this.markEnd(t, a, 'iteration', s), l.k === 'break')) return Rs;
          if (l.k === 'return') return l;
        }
        return (this.simRec('stmt', n.line, 'La boucle for est finie'), Rs);
      }
    }
  }
  execIf(n, t, r) {
    return this.test(n.test, t, n.line, !1)
      ? this.execBody(n.body, t, r + 1)
      : n.orelse.length === 1 && n.orelse[0].k === 'if' && n.orelse[0].elif
        ? this.execIf(n.orelse[0], t, r)
        : n.orelse.length
          ? this.execBody(n.orelse, t, r + 1)
          : Rs;
  }
  decide(n, t, r) {
    if (n.k === 'compare' && n.ops.length === 1 && n.ops[0] !== 'in' && n.ops[0] !== 'not in') {
      let s = this.eval(n.first, t),
        i = this.eval(n.rest[0], t);
      return { result: cl(n.ops[0], s, i, r), cmp: { l: Pt(s), op: n.ops[0], r: Pt(i) } };
    }
    if (n.k === 'bool') {
      let s = this.decide(n.l, t, r);
      return (n.op === 'or' ? s.result : !s.result) ? s : this.decide(n.r, t, r);
    }
    return { result: Xu(this.eval(n, t)), cmp: null };
  }
  test(n, t, r, s) {
    let { result: i, cmp: o } = this.decide(n, t, r);
    t.focus &&
      this.tracing &&
      this.conds.push({
        after: this.points.length - 1,
        line: r,
        loop: s,
        result: i,
        text: xn(n),
        cmp: o,
      });
    let a = xn(n);
    return (
      this.simRec(
        'cond',
        r,
        `${a} est ${i ? 'vrai' : 'faux'} : ${s ? (i ? 'on fait un tour de boucle' : 'la boucle s\u2019arr\xEAte') : i ? 'on ex\xE9cute le bloc' : 'on saute le bloc'}`,
        { cond: { text: a, result: i } },
      ),
      i
    );
  }
  doImport(n) {
    let t = n.from ? [n.from] : n.names;
    for (let i of t)
      if (i !== 'math' && i !== 'random')
        throw new K(
          'unsupported',
          `Le module \xAB ${i} \xBB n\u2019est pas pris en charge.`,
          n.line,
        );
    if (!n.from) {
      n.names.forEach((i) => this.globals.vars.set(i, { t: 'module', name: i }));
      return;
    }
    let r = n.from === 'math' ? qM : _M;
    (n.names[0] === '*' ? [...r] : n.names).forEach((i) => {
      if (!r.has(i))
        throw new K('unsupported', `${n.from}.${i} n\u2019est pas pris en charge.`, n.line);
      this.globals.vars.set(i, { t: 'builtin', name: `${n.from}.${i}` });
    });
  }
  assign(n, t, r) {
    if (n.k === 'name') {
      r.vars.set(n.id, t);
      return;
    }
    if (n.k === 'tuple') {
      let i = fl(t, n.line);
      if (i.length !== n.items.length)
        throw new K('value', `${n.items.length} variables pour ${i.length} valeurs.`, n.line);
      n.items.forEach((o, a) => this.assign(o, i[a], r));
      return;
    }
    let s = this.eval(n.e, r);
    if (s.t !== 'list') throw new K('type', `On ne peut pas modifier ${Yr(s)}.`, n.line);
    s.items[Bb(s.items, this.eval(n.i, r), n.line)] = t;
  }
  eval(n, t) {
    switch (n.k) {
      case 'num': {
        if (/[.eE]/.test(n.text)) {
          let r = /^(\d*)\.?(\d*)(?:[eE]([+-]?\d+))?$/.exec(n.text),
            s = (r[1] || '0') + (r[2] ?? ''),
            i = C(BigInt(s), 10n ** BigInt((r[2] ?? '').length)),
            o = Number(r[3] ?? 0);
          if (Math.abs(o) > 300) throw new K('value', 'Nombre trop grand.', n.line);
          return (o && (i = N(i, at(C(10), o))), An(i));
        }
        return gn(BigInt(n.text));
      }
      case 'str':
        return { t: 'str', v: n.v };
      case 'const':
        return n.v === 'None' ? vr : Uo(n.v === 'True');
      case 'name':
        return this.lookup(t, n.id, n.line);
      case 'list':
        return sd(
          n.items.map((r) => this.eval(r, t)),
          n.line,
        );
      case 'tuple':
        return { t: 'tuple', items: n.items.map((r) => this.eval(r, t)) };
      case 'comp': {
        let r = [],
          s = new Map(t.vars);
        for (let i of fl(this.eval(n.iter, t), n.line))
          (this.tick(n.line),
            this.assign(n.target, i, t),
            (!n.cond || Xu(this.eval(n.cond, t))) && r.push(this.eval(n.elt, t)));
        return (t.vars.clear(), s.forEach((i, o) => t.vars.set(o, i)), sd(r, n.line));
      }
      case 'unary': {
        let r = this.eval(n.e, t);
        if (n.op === 'not') return Uo(!Xu(r));
        if (!ul(r)) throw new K('type', `\xAB ${n.op} \xBB impossible devant ${Yr(r)}.`, n.line);
        return n.op === '+'
          ? r.t === 'bool'
            ? gn(Ut(r))
            : r
          : r.t === 'float'
            ? An(fe(r.v))
            : gn(-Ut(r));
      }
      case 'bin': {
        let r = this.eval(n.l, t),
          s = this.eval(n.r, t),
          i = $1(n.op, r, s, n.line);
        return (
          t.focus &&
            this.tracing &&
            this.evals.length < $D &&
            ul(r) &&
            ul(s) &&
            this.evals.push({
              after: this.points.length - 1,
              line: n.line,
              op: n.op,
              l: Pt(r),
              r: Pt(s),
              v: Pt(i),
              text: xn(n),
            }),
          i
        );
      }
      case 'bool': {
        let r = this.eval(n.l, t);
        return n.op === 'and' ? (Xu(r) ? this.eval(n.r, t) : r) : Xu(r) ? r : this.eval(n.r, t);
      }
      case 'compare': {
        let r = this.eval(n.first, t);
        for (let s = 0; s < n.ops.length; s++) {
          let i = this.eval(n.rest[s], t);
          if (!cl(n.ops[s], r, i, n.line)) return Uo(!1);
          r = i;
        }
        return Uo(!0);
      }
      case 'ifexp':
        return Xu(this.eval(n.test, t)) ? this.eval(n.body, t) : this.eval(n.orelse, t);
      case 'index': {
        let r = this.eval(n.e, t),
          s = this.eval(n.i, t);
        if (r.t === 'list' || r.t === 'tuple') return r.items[Bb(r.items, s, n.line)];
        if (r.t === 'str')
          return {
            t: 'str',
            v: [...r.v][
              Bb(
                [...r.v].map(() => vr),
                s,
                n.line,
              )
            ],
          };
        throw new K('type', `On ne peut pas indexer ${Yr(r)}.`, n.line);
      }
      case 'slice': {
        let r = this.eval(n.e, t);
        if (r.t !== 'list' && r.t !== 'str')
          throw new K('type', `Tranche impossible sur ${Yr(r)}.`, n.line);
        let s = r.t === 'list' ? r.items : [...r.v].map((l) => ({ t: 'str', v: l })),
          i = s.length,
          o = (l, u) => {
            if (!l) return u;
            let c = this.eval(l, t);
            if (!$s(c)) throw new K('type', 'Une borne de tranche doit \xEAtre un entier.', n.line);
            let f = Number(Ut(c));
            return (f < 0 && (f += i), Math.min(Math.max(f, 0), i));
          };
        if (n.step)
          throw new K(
            'unsupported',
            'Les tranches avec un pas ne sont pas prises en charge.',
            n.line,
          );
        let a = s.slice(o(n.lo, 0), o(n.hi, i));
        return r.t === 'list'
          ? { t: 'list', items: a.map(Pt) }
          : { t: 'str', v: a.map((l) => l.v).join('') };
      }
      case 'attr': {
        let r = this.eval(n.e, t);
        if (r.t === 'module') {
          if (!(r.name === 'math' ? qM : _M).has(n.name))
            throw new K(
              'unsupported',
              `${r.name}.${n.name} n\u2019est pas pris en charge.`,
              n.line,
            );
          return { t: 'builtin', name: `${r.name}.${n.name}` };
        }
        if (r.t === 'list') return { t: 'method', self: r, name: n.name };
        throw new K('unsupported', `\xAB .${n.name} \xBB n\u2019est pas pris en charge.`, n.line);
      }
      case 'call':
        return this.call(n, t);
    }
  }
  call(n, t) {
    let r = this.eval(n.f, t),
      s = n.args.map((i) => this.eval(i, t));
    if (r.t === 'func') {
      let i = this.callUser(r.def, s, n.line, t);
      return (
        t.focus &&
          this.tracing &&
          this.calls.push({
            after: this.points.length - 1,
            name: r.def.name,
            atom: C1(r.def.name, s),
            value: i,
          }),
        i
      );
    }
    if (r.t === 'builtin') return this.builtin(r.name, s, n.line);
    if (r.t === 'method') return this.method(r.self, r.name, s, n.line);
    throw new K('type', `${ct(r)} n\u2019est pas une fonction.`, n.line);
  }
  callUser(n, t, r, s) {
    if (t.length !== n.params.length)
      throw new K(
        'type',
        `${n.name} attend ${n.params.length} argument${n.params.length > 1 ? 's' : ''}, pas ${t.length}.`,
        r,
      );
    if (++this.depth > ED) throw new K('recursion', 'Trop d\u2019appels imbriqu\xE9s.', r);
    let i = this.wanted === n.name && !s.focus && !this.focus,
      o = { vars: new Map(), focus: i };
    n.params.forEach((c, f) => o.vars.set(c, t[f]));
    let a = `${n.name}(${t.map((c) => ct(c, !0)).join(', ')})`;
    (this.stack.push({ id: ++this.frameSeq, name: a, f: o }),
      this.simRec('call', n.line, `Appel de ${a}`),
      i &&
        ((this.wanted = null),
        (this.focus = { name: n.name, args: t.map(Pt), atom: C1(n.name, t), value: null }),
        this.tracing &&
          this.points.push({ kind: 'start', line: n.line, vars: this.snapshot(o), end: !0 })));
    let l = this.execBody(n.body, o, 0);
    this.depth--;
    let u = l.k === 'return' ? l.v : vr;
    return (
      l.k !== 'return' &&
        this.simRec('return', n.line, 'Fin de la fonction, sans return : elle renvoie None', {
          ret: 'None',
        }),
      this.stack.pop(),
      i &&
        (l.k !== 'return' &&
          this.tracing &&
          this.points.push({
            kind: 'return',
            line: n.line,
            vars: this.snapshot(o),
            end: !0,
            unit: 'return',
            ret: vr,
          }),
        (this.focus.value = Pt(u))),
      u
    );
  }
  builtin(n, t, r) {
    let s = () => {
        if (t.length !== 1) throw new K('type', `${n} attend un argument.`, r);
        return t[0];
      },
      i = (o) =>
        o.map((a) => {
          if (!ul(a)) throw new K('type', `${n} : ${Yr(a)} n\u2019est pas un nombre.`, r);
          return a;
        });
    switch (n) {
      case 'print':
        return (this.output.push(t.map((o) => (o.t === 'str' ? o.v : ct(o, !0))).join(' ')), vr);
      case 'range': {
        if (!t.length || t.length > 3 || !t.every($s))
          throw new K('type', 'range attend 1 \xE0 3 entiers.', r);
        let [o, a, l] = t.map(Ut);
        if (t.length === 1) return { t: 'range', start: 0n, stop: o, step: 1n };
        if (l === 0n) throw new K('value', 'Le pas de range ne peut pas \xEAtre 0.', r);
        return { t: 'range', start: o, stop: a, step: l ?? 1n };
      }
      case 'len': {
        let o = s();
        if (o.t === 'list' || o.t === 'tuple') return gn(o.items.length);
        if (o.t === 'str') return gn([...o.v].length);
        if (o.t === 'range') return gn(_1(o));
        throw new K('type', `len impossible sur ${Yr(o)}.`, r);
      }
      case 'abs': {
        let o = i([s()])[0];
        return o.t === 'float' ? An(mn(o.v)) : gn(Ut(o) < 0n ? -Ut(o) : Ut(o));
      }
      case 'min':
      case 'max':
      case 'sum': {
        let o = t.length === 1 ? fl(t[0], r) : t;
        if (n === 'sum') return i(o).reduce((a, l) => $1('+', a, l, r), gn(0));
        if (!o.length) throw new K('value', `${n} d\u2019une liste vide.`, r);
        return o.reduce((a, l) => {
          let u = cl('<', l, a, r);
          return n === 'min' ? (u ? l : a) : cl('>', l, a, r) ? l : a;
        });
      }
      case 'int': {
        let o = s();
        if (o.t === 'str') {
          if (!/^\s*[+-]?\d+\s*$/.test(o.v))
            throw new K('value', 'Ce n\u2019est pas un entier.', r);
          return gn(BigInt(o.v.trim()));
        }
        let a = On(i([o])[0]);
        return gn(a.n >= 0n ? a.n / a.d : -(-a.n / a.d));
      }
      case 'float': {
        let o = s();
        if (o.t === 'str') {
          let a = nr(o.v.replace(',', '#'));
          if (!a) throw new K('value', 'Ce n\u2019est pas un nombre.', r);
          return An(a);
        }
        return An(On(i([o])[0]));
      }
      case 'round': {
        if (!t.length || t.length > 2) throw new K('type', 'round attend 1 ou 2 arguments.', r);
        let o = On(i([t[0]])[0]),
          a = t.length === 2 ? Number(Ut(t[1])) : 0;
        if (a < 0 || a > 20)
          throw new K('unsupported', 'round : nombre de chiffres non pris en charge.', r);
        let l = 10n ** BigInt(a),
          u = N(o, C(l)),
          c = Yu(u),
          f = me(u, C(c)),
          d = Re(f, C(1, 2)),
          m = d < 0 ? c : d > 0 ? c + 1n : c % 2n === 0n ? c : c + 1n;
        return t.length === 1 ? gn(m) : t[0].t === 'float' ? An(C(m, l)) : t[0];
      }
      case 'str':
        return { t: 'str', v: ct(s(), !0) };
      case 'bool':
        return Uo(Xu(s()));
      case 'list':
        return sd(t.length ? fl(s(), r).map(Pt) : [], r);
      case 'sorted': {
        let o = fl(s(), r).map(Pt);
        return (o.sort((a, l) => (cl('<', a, l, r) ? -1 : cl('>', a, l, r) ? 1 : 0)), sd(o, r));
      }
      case 'enumerate':
        return sd(
          fl(s(), r).map((o, a) => ({ t: 'tuple', items: [gn(a), o] })),
          r,
        );
      case 'math.sqrt': {
        let o = On(i([s()])[0]);
        if (o.n < 0n) throw new K('value', 'Racine d\u2019un nombre n\xE9gatif.', r);
        let a = NM(o);
        if (!a)
          throw new K('inexact', 'Cette racine n\u2019a pas de valeur d\xE9cimale exacte.', r);
        return An(a);
      }
      case 'math.floor':
        return gn(Yu(On(i([s()])[0])));
      case 'math.ceil':
        return gn(qD(On(i([s()])[0])));
      case 'math.fabs':
        return An(mn(On(i([s()])[0])));
    }
    if (n.startsWith('random.')) return this.randomCall(n.slice(7), t, r);
    throw new K('unsupported', `${n} n\u2019est pas pris en charge.`, r);
  }
  generator() {
    return (this.rng || (this.rng = new Sp(this.seedDefault)), this.rng);
  }
  takeDraw(n) {
    if (!this.draws) return null;
    if (this.drawIdx >= this.draws.length)
      throw new K(
        'value',
        `Plus de tirage : l\u2019\xE9nonc\xE9 en donne ${this.draws.length}.`,
        n,
      );
    return this.draws[this.drawIdx++];
  }
  randomCall(n, t, r) {
    let s = (a) => {
        if (!a.includes(t.length) || !t.every($s))
          throw new K('type', `${n} attend des entiers.`, r);
        return t.map(Ut);
      },
      i = () => this.drawIdx,
      o = (a, l) => new K('value', `Le tirage n\xB0 ${i()} (${ct(a)}) n\u2019est pas ${l}.`, r);
    switch (n) {
      case 'seed': {
        if (t.length > 1 || (t.length === 1 && !$s(t[0])))
          throw new K('unsupported', 'random.seed : une graine enti\xE8re.', r);
        return (this.draws || this.generator().seed(t.length ? Ut(t[0]) : 0n), vr);
      }
      case 'random': {
        if (t.length) throw new K('type', 'random() n\u2019attend pas d\u2019argument.', r);
        let a = this.takeDraw(r);
        if (a) {
          let u = On(a);
          if (!u || a.t === 'bool' || u.n < 0n || Re(u, q) >= 0)
            throw o(a, 'entre 0 (compris) et 1 (exclu)');
          return An(u);
        }
        let l = this.generator().random();
        return { t: 'float', v: C(l.n, l.d), bin: !0 };
      }
      case 'uniform': {
        if (t.length !== 2 || !t.every(ul)) throw new K('type', 'uniform attend deux nombres.', r);
        let a = On(t[0]),
          l = On(t[1]),
          u = this.takeDraw(r);
        if (u) {
          let f = On(u),
            d = Re(a, l) <= 0 ? a : l,
            m = Re(a, l) <= 0 ? l : a;
          if (!f || u.t === 'bool' || Re(f, d) < 0 || Re(f, m) > 0)
            throw o(u, `entre ${ct(t[0])} et ${ct(t[1])}`);
          return An(f);
        }
        let c = this.generator().random();
        return An(re(a, N(me(l, a), C(c.n, c.d))));
      }
      case 'randint':
      case 'randrange': {
        let a,
          l,
          u = 1n;
        if (n === 'randint') {
          let [d, m] = s([2]);
          ((a = d), (l = m + 1n));
        } else {
          let d = s([1, 2, 3]);
          d.length === 1 ? ((a = 0n), (l = d[0])) : ((a = d[0]), (l = d[1]), (u = d[2] ?? 1n));
        }
        if (u === 0n) throw new K('value', `${n} : le pas ne peut pas \xEAtre 0.`, r);
        let c = u > 0n ? (l - a + u - 1n) / u : (l - a + u + 1n) / u;
        if (c <= 0n) throw new K('value', `${n} : intervalle vide.`, r);
        let f = this.takeDraw(r);
        if (f) {
          let d = $s(f) && f.t !== 'bool' ? Ut(f) : null;
          if (!(d !== null && (d - a) % u === 0n && (d - a) / u >= 0n && (d - a) / u < c))
            throw o(
              f,
              n === 'randint' ? `un entier entre ${a} et ${l - 1n}` : `une valeur possible de ${n}`,
            );
          return gn(d);
        }
        return gn(a + u * this.generator().randbelow(c));
      }
      case 'choice': {
        if (t.length !== 1) throw new K('type', 'choice attend une liste.', r);
        let a = fl(t[0], r);
        if (!a.length) throw new K('index', 'choice sur une liste vide.', r);
        let l = this.takeDraw(r);
        if (l) {
          let u = a.find((c) => zi(c, l));
          if (!u) throw o(l, 'un \xE9l\xE9ment de la liste');
          return u;
        }
        return a[Number(this.generator().randbelow(BigInt(a.length)))];
      }
      case 'shuffle': {
        let a = t[0];
        if (t.length !== 1 || !a || a.t !== 'list')
          throw new K('type', 'shuffle attend une liste.', r);
        if (this.draws)
          throw new K(
            'unsupported',
            'shuffle avec des tirages impos\xE9s n\u2019est pas pris en charge.',
            r,
          );
        let l = a.items;
        for (let u = l.length - 1; u > 0; u--) {
          let c = Number(this.generator().randbelow(BigInt(u + 1)));
          [l[u], l[c]] = [l[c], l[u]];
        }
        return vr;
      }
    }
    throw new K('unsupported', `random.${n} n\u2019est pas pris en charge.`, r);
  }
  method(n, t, r, s) {
    if (n.t !== 'list')
      throw new K('unsupported', `\xAB .${t} \xBB n\u2019est pas pris en charge.`, s);
    let i = n.items;
    switch (t) {
      case 'append':
        if (r.length !== 1) throw new K('type', 'append attend un argument.', s);
        if (i.length >= Tp) throw new K('value', 'Liste trop longue.', s);
        return (i.push(r[0]), vr);
      case 'pop': {
        if (!i.length) throw new K('index', 'pop sur une liste vide.', s);
        let o = r.length ? Bb(i, r[0], s) : i.length - 1;
        return i.splice(o, 1)[0];
      }
      case 'insert': {
        if (r.length !== 2 || !$s(r[0]))
          throw new K('type', 'insert attend un indice et une valeur.', s);
        let o = Number(Ut(r[0]));
        return (
          o < 0 && (o = Math.max(0, o + i.length)),
          i.splice(Math.min(o, i.length), 0, r[1]),
          vr
        );
      }
      case 'remove': {
        let o = i.findIndex((a) => zi(a, r[0]));
        if (o < 0) throw new K('value', 'Valeur absente de la liste.', s);
        return (i.splice(o, 1), vr);
      }
      case 'count':
        return gn(i.filter((o) => zi(o, r[0])).length);
      case 'index': {
        let o = i.findIndex((a) => zi(a, r[0]));
        if (o < 0) throw new K('value', 'Valeur absente de la liste.', s);
        return gn(o);
      }
      case 'reverse':
        return (i.reverse(), vr);
      case 'sort':
        return (i.sort((o, a) => (cl('<', o, a, s) ? -1 : cl('>', o, a, s) ? 1 : 0)), vr);
    }
    throw new K('unsupported', `\xAB .${t} \xBB n\u2019est pas pris en charge.`, s);
  }
};
function OM(e) {
  return e.k === 'name'
    ? e.id
    : e.k === 'index'
      ? xn({ k: 'index', e: e.e, i: e.i, line: e.line })
      : e.items.map(OM).join(', ');
}
function KM(e) {
  return e.k === 'name'
    ? { k: 'name', id: e.id, line: e.line }
    : e.k === 'index'
      ? { k: 'index', e: e.e, i: e.i, line: e.line }
      : { k: 'tuple', items: e.items.map(KM), line: e.line };
}
function dl(e, n = {}) {
  let t = new E1(n.maxSteps ?? M1),
    r = LD(t, e, n);
  return {
    ok: !r,
    error: r,
    points: t.points,
    conds: t.conds,
    calls: t.calls,
    focus: t.focus,
    output: t.output,
    steps: t.steps,
    globals: t.snapshot(t.globals),
    evals: t.evals,
    drawsUsed: t.drawIdx,
  };
}
function LD(e, n, t) {
  let r = null;
  (t.draws && (e.draws = t.draws),
    t.seed !== void 0 && (e.seedDefault = t.seed),
    t.trace === !1 && (e.tracing = !1));
  try {
    let s = w1(n),
      i = null;
    if (t.call) {
      if (((i = S1(t.call)), i.k !== 'call' || i.f.k !== 'name'))
        throw new K('syntax', 'L\u2019appel suivi doit s\u2019\xE9crire \xAB f(\u2026) \xBB.', 1);
    } else
      ((e.globals.focus = !0),
        e.tracing && e.points.push({ kind: 'start', line: 0, vars: {}, end: !0 }));
    if (
      (e.execBody(s.body, e.globals, 0),
      i &&
        i.k === 'call' &&
        i.f.k === 'name' &&
        ((e.wanted = i.f.id), e.eval(i, e.globals), !e.focus))
    )
      throw new K('name', `La fonction \xAB ${e.wanted} \xBB n\u2019est pas d\xE9finie.`, 1);
  } catch (s) {
    if (!(s instanceof K)) throw s;
    r = s;
  }
  return r;
}
function q1(e, n, t = M1, r = {}) {
  let s = dl(e, { call: n, maxSteps: t, ...r });
  return s.ok && s.focus ? s.focus.value : null;
}
var di = {
    block: 'python.block@1',
    iteration: 'python.iteration@1',
    branch: 'python.branch@1',
    return: 'python.return@1',
    assign: 'python.assign@1',
    condition: 'python.condition@1',
    call: 'python.call@1',
    conclude: 'python.conclude@1',
    eval: 'python.eval@1',
    jump: 'python.jump@1',
    complete: 'python.complete@1',
  },
  FM = 15,
  ND = 2,
  ec = 'Algorithmique',
  yn = class extends Error {},
  ci = class extends Error {},
  OD = /[A-Za-z_À-ɏ]/,
  KD = /[A-Za-z0-9_À-ɏ]/,
  N1 = /^[A-Za-z_À-ɏ][A-Za-z0-9_À-ɏ]*$/,
  nc = /^([A-Za-z_À-ɏ][A-Za-z0-9_À-ɏ]*)\((.*)\)$/,
  VM = /^−?\d+(,\d+)?$/,
  zb = ['<', '>', '\u2264', '\u2265', '\u2260'],
  DM = ['+', '\u2212', '\xD7', '\xF7', '%'],
  K1 = ['True', 'False', 'None'],
  PD = ['[', ']', ','],
  PM = new Set(['=', '\u2248', ';', '(', ')', ...PD, ...zb, ...DM]),
  Gt = (e) => e.replace(/\s+/g, '');
function $p(e) {
  let n = [],
    t = e.trim(),
    r = 0,
    s = () => !n.length || PM.has(n[n.length - 1]);
  for (; r < t.length; ) {
    let i = t[r];
    if (/\s/.test(i)) {
      r++;
      continue;
    }
    if (OD.test(i)) {
      let f = r + 1;
      for (; f < t.length && KD.test(t[f]); ) f++;
      let d = f;
      for (; d < t.length && t[d] === ' '; ) d++;
      if (t[d] === '(' && !K1.includes(t.slice(r, f))) {
        let m = 0,
          p = d;
        for (
          ;
          p < t.length &&
          ((t[p] === '(' || t[p] === '[') && m++, (t[p] === ')' || t[p] === ']') && m--, m !== 0);
          p++
        );
        if (p >= t.length) throw new yn('Parenth\xE8se non ferm\xE9e.');
        (n.push(t.slice(r, f) + t.slice(d, p + 1).replace(/-/g, '\u2212')), (r = p + 1));
        continue;
      }
      (n.push(t.slice(r, f)), (r = f));
      continue;
    }
    let o = (i === '\u2212' || i === '-') && /\d/.test(t[r + 1] ?? '') && s();
    if (/\d/.test(i) || o) {
      let f = /^[−-]?\d+([.,]\d+)?/.exec(t.slice(r));
      (n.push(f[0].replace('-', '\u2212').replace('.', ',')), (r += f[0].length));
      continue;
    }
    let a = t.slice(r, r + 2),
      l = { '<=': '\u2264', '>=': '\u2265', '!=': '\u2260', '==': '=' };
    if (l[a]) {
      (n.push(l[a]), (r += 2));
      continue;
    }
    let c = { '-': '\u2212', '*': '\xD7', '/': '\xF7' }[i] ?? i;
    if (!PM.has(c)) throw new yn(`\xAB ${i} \xBB ne s\u2019\xE9crit pas sur une trace.`);
    (n.push(c), r++);
  }
  return n;
}
function BM(e) {
  return nr(e);
}
function od(e, n) {
  let t = 0,
    r = () => e[t],
    s = () => {
      let l = e[t];
      if (l === void 0) throw new ci();
      if (l === '(') {
        t++;
        let u = o();
        if (e[t] === void 0) throw new ci();
        if (e[t] !== ')') throw new yn('Parenth\xE8se non ferm\xE9e.');
        return (t++, u);
      }
      if (l === '\u2212') return (t++, { k: 'neg', e: s() });
      if (l === '[') {
        t++;
        let u = [];
        if (e[t] === ']') return (t++, { k: 'list', items: u });
        for (;;) {
          u.push(o());
          let c = e[t];
          if (c === void 0) throw new ci();
          if ((t++, c === ']')) return { k: 'list', items: u };
          if (c !== ',') throw new yn('Dans une liste, \xAB , \xBB s\xE9pare deux \xE9l\xE9ments.');
        }
      }
      if (l === ']' || l === ',') throw new yn(`\xAB ${l} \xBB est mal plac\xE9.`);
      if ((t++, VM.test(l))) return { k: 'num', q: BM(l) };
      if (l === 'None') return { k: 'none' };
      if (K1.includes(l)) return { k: 'bool', v: l === 'True' };
      if (nc.test(l)) {
        if (!n) throw new yn('\xC9cris la valeur, pas un appel.');
        return { k: 'call', atom: l };
      }
      if (N1.test(l)) {
        if (!n) throw new yn(`\xC9cris la valeur de la variable, pas \xAB ${l} \xBB.`);
        return { k: 'var', name: l };
      }
      throw new yn(`\xAB ${l} \xBB est mal plac\xE9.`);
    },
    i = () => {
      let l = s();
      for (; r() === '\xD7' || r() === '\xF7' || r() === '%'; )
        l = { k: 'bin', op: e[t++], l, r: s() };
      return l;
    },
    o = () => {
      let l = i();
      for (; r() === '+' || r() === '\u2212'; ) l = { k: 'bin', op: e[t++], l, r: i() };
      return l;
    },
    a = o();
  if (t < e.length) throw new yn(`\xAB ${e[t]} \xBB est mal plac\xE9.`);
  return a;
}
function ID(e, n) {
  let t = A(e, n);
  if (!t) return null;
  let r = t.n >= 0n ? t.n / t.d : -((-t.n + t.d - 1n) / t.d);
  return me(e, N(n, C(r)));
}
function zM(e, n, t) {
  return e === '+'
    ? re(n, t)
    : e === '\u2212'
      ? me(n, t)
      : e === '\xD7'
        ? N(n, t)
        : e === '%'
          ? ID(n, t)
          : A(n, t);
}
function ad(e) {
  if (e.k === 'bool' || e.k === 'none') return e;
  if (e.k === 'list') {
    let n = e.items.map(ad);
    return n.every((t) => t !== null) ? { k: 'list', items: n } : null;
  }
  if (e.k === 'num') return e;
  if (e.k === 'neg') {
    let n = ad(e.e);
    return n?.k === 'num' ? { k: 'num', q: fe(n.q) } : null;
  }
  if (e.k === 'bin') {
    let n = ad(e.l),
      t = ad(e.r);
    if (n?.k !== 'num' || t?.k !== 'num') return null;
    let r = zM(e.op, n.q, t.q);
    return r ? { k: 'num', q: r } : null;
  }
  return null;
}
function Cp(e) {
  if (!e.length) throw new ci();
  let n = e[e.length - 1];
  if (
    n === ';' ||
    n === '=' ||
    n === '\u2248' ||
    n === '[' ||
    n === ',' ||
    zb.includes(n) ||
    DM.includes(n) ||
    n === '('
  )
    throw new ci();
  let t = e.findIndex((o) => zb.includes(o));
  if (t >= 0) {
    if (e.includes(';') || e.includes('=') || e.includes('\u2248'))
      throw new yn('Une comparaison s\u2019\xE9crit seule sur sa ligne.');
    if (e.slice(t + 1).some((o) => zb.includes(o)))
      throw new yn('Une seule comparaison par ligne.');
    if (t === 0) throw new yn('\xC9cris d\u2019abord ce que tu compares.');
    return { kind: 'cmp', l: od(e.slice(0, t), !0), op: e[t], r: od(e.slice(t + 1), !0) };
  }
  let r = [[]];
  if ((e.forEach((o) => (o === ';' ? r.push([]) : r[r.length - 1].push(o))), r.length === 1)) {
    let o = r[0],
      a = o.findIndex((l) => l === '=' || l === '\u2248');
    if (a < 0 && o.length > 1) {
      try {
        od(o, !0);
      } catch (l) {
        throw l instanceof ci
          ? l
          : new yn('\xC9cris \xAB variable = valeur \xBB, ou un calcul \xAB n % 2 = 1 \xBB.');
      }
      throw new ci();
    }
    if (a > 1) {
      if (o[a] === '\u2248')
        throw new yn('Un calcul du programme s\u2019\xE9crit avec \xAB = \xBB.');
      let l = od(o.slice(0, a), !0);
      if (l.k !== 'bin') throw new yn('Une variable (ou un appel), puis \xAB = \xBB et sa valeur.');
      let u = o.slice(a + 1);
      if (u.some((f) => f === '=' || f === '\u2248'))
        throw new yn('Un seul \xAB = \xBB dans un calcul.');
      let c = ad(od(u, !1));
      if (!c) throw new yn('Valeur impossible \xE0 calculer.');
      return { kind: 'calc', e: l, value: c };
    }
  }
  let s = r.map((o) => {
      if (!o.length) throw new yn('Rien entre deux \xAB ; \xBB.');
      let a = o.findIndex((m) => m === '=' || m === '\u2248');
      if (a < 0)
        throw o.length === 1 && (N1.test(o[0]) || nc.test(o[0]))
          ? new ci()
          : new yn('\xC9cris \xAB variable = valeur \xBB.');
      if (a !== 1) throw new yn('Une variable (ou un appel), puis \xAB = \xBB et sa valeur.');
      let l = o[0],
        u = nc.test(l);
      if (!u && (!N1.test(l) || K1.includes(l)))
        throw new yn('Une variable (ou un appel), puis \xAB = \xBB et sa valeur.');
      let c = o.slice(2);
      if (c.some((m) => m === '=' || m === '\u2248'))
        throw new yn('Une seule valeur par variable : s\xE9pare par \xAB ; \xBB.');
      let f = o[1] === '\u2248';
      if (f) {
        if (c.length !== 1 || !VM.test(c[0]))
          throw new yn('Apr\xE8s \xAB \u2248 \xBB, un nombre arrondi.');
        let m = c[0].includes(',') ? c[0].split(',')[1].length : 0;
        return { target: l, call: u, value: { k: 'num', q: BM(c[0]) }, approx: f, places: m };
      }
      let d = ad(od(c, !1));
      if (!d) throw new yn('Valeur impossible \xE0 calculer.');
      return { target: l, call: u, value: d, approx: !1, places: 0 };
    }),
    i = new Set();
  return (
    s.forEach((o) => {
      let a = o.call ? Gt(o.target) : o.target;
      if (i.has(a)) throw new yn(`\xAB ${o.target} \xBB \xE9crit deux fois.`);
      i.add(a);
    }),
    { kind: 'claims', claims: s }
  );
}
function O1(e) {
  return e.k === 'list'
    ? `[${e.items.map(O1).join(',')}]`
    : e.k === 'none'
      ? 'None'
      : e.k === 'bool'
        ? String(e.v)
        : bt(e.q);
}
function UM(e) {
  if (e.kind === 'claims')
    return e.claims
      .map((t) => `${t.call ? Gt(t.target) : t.target}${t.approx ? '\u2248' : '='}${O1(t.value)}`)
      .sort()
      .join(';');
  let n = (t) =>
    t.k === 'list'
      ? `[${t.items.map(n).join(',')}]`
      : t.k === 'num'
        ? bt(t.q)
        : t.k === 'none'
          ? 'None'
          : t.k === 'bool'
            ? String(t.v)
            : t.k === 'var'
              ? t.name
              : t.k === 'call'
                ? Gt(t.atom)
                : t.k === 'neg'
                  ? `-(${n(t.e)})`
                  : `(${n(t.l)}${t.op}${n(t.r)})`;
  return e.kind === 'calc' ? `calc:${n(e.e)}=${O1(e.value)}` : `${n(e.l)}${e.op}${n(e.r)}`;
}
function Hb(e) {
  return { dis: [{ sides: [{ k: 's', n: e }] }] };
}
var AD = (e) =>
  e
    .join(' ')
    .replace(/\( /g, '(')
    .replace(/ \)/g, ')')
    .replace(/\[ /g, '[')
    .replace(/ \]/g, ']')
    .replace(/ ,/g, ',');
function GM(e) {
  let n = e.kernel?.program;
  if (!n) throw new Error('Feuille Python sans programme');
  return n;
}
function jD(e) {
  let n = e.trim();
  if (n === 'True' || n === 'False') return Uo(n === 'True');
  if (/^[−-]?\d+$/.test(n)) return gn(BigInt(n.replace('\u2212', '-')));
  if (/^[−-]?\d+,\d+$/.test(n)) {
    let t = nr(n.replace('-', '\u2212'));
    return t ? An(t) : null;
  }
  return null;
}
function ZM(e) {
  let n = e.kernel?.program?.draws;
  if (n)
    return n.map((t) => {
      let r = jD(t);
      if (!r) throw new Error(`Tirage illisible : \xAB ${t} \xBB`);
      return r;
    });
}
function HM(e) {
  let n = e.kernel,
    t = GM(e);
  if (n.goal.kind === 'complete') return oB(e);
  let r = ZM(e),
    s = dl(t.code, { ...(t.call ? { call: t.call } : {}), draws: r });
  if (!s.ok) throw new Error(`Programme : ${s.error.message} (ligne ${s.error.line})`);
  let i = s.points,
    o = i.flatMap((m, p) => (m.end ? [p] : [])),
    a = new Set();
  i.forEach((m) => Object.keys(m.vars).forEach((p) => a.add(p)));
  let l = new Set([...t.code.matchAll(/^\s*def\s+([A-Za-z_À-ɏ][\wÀ-ɏ]*)/gm)].map((m) => m[1])),
    u = Cp($p(n.answer));
  if (u.kind !== 'claims')
    throw new Error('La r\xE9ponse s\u2019\xE9crit \xAB variable = valeur \xBB.');
  let c = new Map();
  i.forEach((m) => {
    m.unit === 'iteration' && m.loop && c.set(m.loop, (c.get(m.loop) ?? 0) + 1);
  });
  let f = {
    mode: 'trace',
    spec: n,
    code: t.code,
    call: t.call ?? null,
    trace: s,
    points: i,
    last: i.length - 1,
    ends: o,
    watch: t.watch ?? QD(i),
    focusKey: s.focus ? Gt(s.focus.atom) : null,
    cursor: 0,
    lines: [],
    condsDone: new Set(),
    callsDone: new Set(),
    evalsDone: new Set(),
    visited: [0],
    loopTours: c,
    draws: r,
    complete: null,
    atLast: new Set(),
    concluded: !1,
    answer: u.claims,
    traps: [],
    path: n.path ?? [],
    known: null,
    callCache: new Map(),
    funcs: l,
    names: a,
  };
  f.traps = (e.traps ?? []).flatMap((m) => {
    try {
      return [{ key: UM(Cp($p(m.line))), title: m.title, why: m.why, line: Hb(m.line) }];
    } catch {
      return [];
    }
  });
  let d = [
    n.answer,
    ...f.path,
    ...(e.traps ?? []).map((m) => m.line),
    ...(e.choices ?? []).flatMap((m) => (m.line ? [m.line] : [])),
  ];
  return (
    (f.known = d.flatMap((m) => {
      try {
        return [$p(m)];
      } catch {
        return [];
      }
    })),
    f
  );
}
function QD(e) {
  let n = [],
    t = (r) => !!r && (r.t === 'int' || r.t === 'float' || r.t === 'bool');
  return (
    e.forEach((r, s) => {
      Object.keys(r.vars).forEach((i) => {
        if (n.includes(i) || !t(r.vars[i])) return;
        let o = s ? e[s - 1].vars[i] : void 0,
          a = !o || ct(o) !== ct(r.vars[i]);
        (s === 0 && e[0].kind === 'start') || (a && n.push(i));
      });
    }),
    n
  );
}
function WM(e, n) {
  return n.k === 'list'
    ? (e.t === 'list' || e.t === 'tuple') &&
        e.items.length === n.items.length &&
        e.items.every((t, r) => WM(t, n.items[r]))
    : n.k === 'none'
      ? e.t === 'none'
      : n.k === 'bool'
        ? e.t === 'bool' && e.v === n.v
        : e.t !== 'int' && e.t !== 'float'
          ? !1
          : M(On(e), n.q);
}
function Gb(e, n) {
  if (!e) return !1;
  if (n.value.k === 'list') return WM(e, n.value);
  if (n.value.k === 'none') return e.t === 'none';
  if (n.value.k === 'bool') return e.t === 'bool' && e.v === n.value.v;
  if (e.t !== 'int' && e.t !== 'float') return !1;
  let t = On(e);
  return n.approx ? qf(Uh(t), n.value.q, n.places) : M(t, n.value.q);
}
function JM(e, n, t) {
  let r = e.points[t];
  return n.call ? r.kind === 'return' && Gb(r.ret, n) : Gb(r.vars[n.target], n);
}
var fi = (e, n, t) => n.every((r) => JM(e, r, t));
function XM(e, n) {
  return e.ends.find((t) => t > n) ?? 1 / 0;
}
function FD(e, n) {
  let t = 0;
  return (
    e.ends.forEach((r) => {
      r < n && (t = r);
    }),
    t
  );
}
function YM(e, n) {
  let t = Gt(n);
  if (e.callCache.has(t)) return e.callCache.get(t);
  let r = nc.exec(n),
    s = r[2],
    i = `${r[1]}(${s.replace(/−/g, '-').replace(/(\d),(\d)/g, '$1.$2')})`,
    o = e.funcs.has(r[1]) ? q1(e.code, i, void 0, e.draws ? { draws: e.draws } : {}) : null;
  return (e.callCache.set(t, o), o);
}
function Ui(e, n, t) {
  switch (n.k) {
    case 'list':
      return null;
    case 'num':
      return n.q;
    case 'none':
      return null;
    case 'bool':
      return n.v;
    case 'var': {
      let r = t[n.name];
      return r ? (r.t === 'bool' ? r.v : On(r)) : null;
    }
    case 'call': {
      let r = Gt(n.atom) === e.focusKey ? (e.trace.focus?.value ?? null) : YM(e, n.atom);
      return r ? (r.t === 'bool' ? r.v : On(r)) : null;
    }
    case 'neg': {
      let r = Ui(e, n.e, t);
      return r !== null && typeof r != 'boolean' ? fe(r) : null;
    }
    case 'bin': {
      let r = Ui(e, n.l, t),
        s = Ui(e, n.r, t);
      return r === null || s === null || typeof r == 'boolean' || typeof s == 'boolean'
        ? null
        : zM(n.op, r, s);
    }
  }
}
var VD = { '<': '<', '>': '>', '<=': '\u2264', '>=': '\u2265', '!=': '\u2260', '==': '=' },
  DD = { '<': '\u2265', '>': '\u2264', '\u2264': '>', '\u2265': '<', '\u2260': '=', '=': '\u2260' },
  BD = { '<': '>', '>': '<', '\u2264': '\u2265', '\u2265': '\u2264', '\u2260': '\u2260', '=': '=' };
function zD(e, n, t) {
  if (typeof n == 'boolean' || typeof t == 'boolean')
    return e === '=' ? n === t : e === '\u2260' ? n !== t : !1;
  let r = Re(n, t);
  return e === '<'
    ? r < 0
    : e === '>'
      ? r > 0
      : e === '\u2264'
        ? r <= 0
        : e === '\u2265'
          ? r >= 0
          : e === '\u2260'
            ? r !== 0
            : r === 0;
}
var ml = (e, n) => {
  if (e === null) return !1;
  if (typeof e == 'boolean') return n.t === 'bool' && n.v === e;
  let t = On(n);
  return !!t && n.t !== 'bool' && M(e, t);
};
function UD(e, n, t, r) {
  if (!e.cmp) return !1;
  let s = VD[e.cmp.op];
  if (!s) return !1;
  let i = e.result ? s : DD[s];
  return ml(t, e.cmp.l) && ml(r, e.cmp.r) && n === i
    ? !0
    : ml(t, e.cmp.r) && ml(r, e.cmp.l) && n === BD[i];
}
function GD(e) {
  return e.known ?? [];
}
function e_(e, n) {
  return GD(e).some((t) => t.length > n.length && n.every((r, s) => t[s] === r));
}
function n_(e, n, t) {
  let r = n.flatMap((a) => a.atoms);
  if (!r.length) return { kind: 'empty', atoms: r, badChip: -1 };
  if (e.mode === 'complete') return cB(e, r, t);
  let s = e_(e, r),
    i;
  try {
    i = Cp(r);
  } catch (a) {
    return a instanceof ci || s
      ? { kind: s ? 'building' : 'open', atoms: r, complete: !1 }
      : {
          kind: 'syntax',
          atoms: r,
          title: '\xC7a commence mal',
          message: a instanceof Error ? a.message : String(a),
          badChip: n.length - 1,
        };
  }
  let o = HD(e, i, r);
  return s && !t?.verify
    ? o.kind === 'step'
      ? { ...o, kind: 'ready' }
      : { kind: 'building', atoms: r, complete: !0 }
    : !t?.verify && (o.kind === 'unjustified' || o.kind === 'false')
      ? { kind: 'pending', atoms: r, complete: !0 }
      : o;
}
var ld = (e) =>
    e.k === 'list'
      ? `[${e.items.map(ld).join(', ')}]`
      : e.k === 'none'
        ? 'None'
        : e.k === 'bool'
          ? e.v
            ? 'True'
            : 'False'
          : ct({ t: 'float', v: e.q }).replace(/^(-?\d+),0$/, '$1'),
  Zb = (e) => `${e.target} ${e.approx ? '\u2248' : '='} ${ld(e.value)}`,
  Ub = (e) => e.map(Zb).join(' ; '),
  ZD = {
    block: {
      id: di.block,
      label: 'Ex\xE9cuter les instructions',
      why: (e) => `Les instructions s\u2019ex\xE9cutent dans l\u2019ordre : ${e}.`,
    },
    iteration: {
      id: di.iteration,
      label: 'Un tour de boucle',
      why: (e) => `Apr\xE8s ce tour de boucle : ${e}.`,
    },
    branch: {
      id: di.branch,
      label: 'Ex\xE9cuter le bloc',
      why: (e) => `Le test choisit le bloc \xE0 ex\xE9cuter : ${e}.`,
    },
    return: {
      id: di.return,
      label: 'La valeur renvoy\xE9e',
      why: (e) => `La fonction renvoie sa valeur : ${e}.`,
    },
  };
function HD(e, n, t) {
  let r = AD(t),
    s = Hb(r),
    i = UM(n),
    o = { atoms: t, line: s };
  if (n.kind === 'cmp') return eB(e, n, i, o);
  if (n.kind === 'calc') return tB(e, n, i, o);
  for (let l of n.claims)
    if (l.call) {
      let u = nc.exec(l.target);
      if (Gt(l.target) !== e.focusKey && !e.funcs.has(u[1]))
        return {
          kind: 'false',
          ...o,
          title: 'Fonction inconnue',
          message: `Le programme n\u2019a pas de fonction \xAB ${u[1]} \xBB.`,
        };
    } else if (!e.names.has(l.target))
      return {
        kind: 'false',
        ...o,
        title: 'Variable inconnue',
        message: `Le programme n\u2019a pas de variable \xAB ${l.target} \xBB.`,
      };
  let a = n.claims.filter((l) => l.call && Gt(l.target) !== e.focusKey);
  return a.length && a.length < n.claims.length
    ? {
        kind: 'syntax',
        ...o,
        title: 'Une ligne pour l\u2019appel',
        message: '\xC9cris le calcul d\u2019un appel de fonction sur sa propre ligne.',
        badChip: -1,
      }
    : a.length
      ? rB(e, a, i, o)
      : WD(e, n.claims, i, o);
}
function cd(e, n, t, r, s) {
  let i = e.traps.find((o) => o.key === n);
  return i
    ? {
        kind: 'trap',
        ...t,
        title: 'Pi\xE8ge : ' + i.title.charAt(0).toLowerCase() + i.title.slice(1),
        message: i.why,
        trap: { line: i.line, title: i.title, why: i.why },
        badChip: -1,
      }
    : { kind: 'false', ...t, title: r, message: s };
}
function WD(e, n, t, r) {
  let s = e.cursor,
    i = n.map((v) => (v.call ? Gt(v.target) : v.target));
  if (fi(e, n, s)) {
    if (n.length === 1 && !n[0].call && !n[0].approx) {
      let v = n[0].value,
        k =
          v.k === 'none' || v.k === 'list'
            ? null
            : s_(
                e,
                { k: 'var', name: n[0].target },
                '=',
                v.k === 'bool' ? { k: 'bool', v: v.v } : { k: 'num', q: v.q },
                t,
                r,
              );
      if (k) return k;
    }
    return s === e.last && IM(e, n)
      ? e.concluded
        ? {
            kind: 'useless',
            ...r,
            title: 'Tu as d\xE9j\xE0 conclu',
            message: 'Le programme est fini et ta r\xE9ponse est \xE9crite.',
            pmove: { key: t },
          }
        : {
            kind: 'step',
            ...r,
            final: !0,
            hora: 1,
            rule: {
              id: di.conclude,
              card: ec,
              label: 'Conclure',
              hora: 1,
              why: `Le programme est fini : ${Ub(n)}.`,
            },
            pmove: { key: t, conclude: !0, to: s, targets: i },
          }
      : e.answer.length && s < e.last && r_(e, n) && fi(e, n, e.last)
        ? {
            kind: 'useless',
            ...r,
            title: 'Pas encore fini',
            message:
              'C\u2019est vrai pour l\u2019instant, mais le programme continue : trace la suite.',
            pmove: { key: t },
          }
        : {
            kind: 'useless',
            ...r,
            title: 'Rien de nouveau',
            message:
              'C\u2019est d\xE9j\xE0 l\u2019\xE9tat du programme \xE0 ta derni\xE8re ligne : \xE9cris ce qui change ensuite.',
            pmove: { key: t },
          };
  }
  let o = -1;
  for (let v = s + 1; v < e.points.length; v++)
    if (fi(e, n, v)) {
      o = v;
      break;
    }
  if (o < 0) {
    if (n.some((k) => !k.approx && k.value.k === 'num') && XD(e, n))
      return {
        kind: 'false',
        ...r,
        title: 'Valeur approch\xE9e',
        message:
          'Le programme calcule une valeur avec plus de d\xE9cimales : \xE9cris \xAB \u2248 \xBB pour une valeur arrondie.',
      };
    for (let k = 0; k < s; k++)
      if (fi(e, n, k))
        return cd(
          e,
          t,
          r,
          'C\u2019\xE9tait avant',
          'Ces valeurs, c\u2019\xE9tait plus t\xF4t dans le programme. \xC9cris l\u2019\xE9tat qui suit ta derni\xE8re ligne.',
        );
    let v = n.find((k) => !e.points.slice(s + 1).some((y, S) => JM(e, k, s + 1 + S)));
    return cd(
      e,
      t,
      r,
      'Ce n\u2019est pas ce que fait le programme',
      v
        ? v.call
          ? `${v.target} ne renvoie pas ${Zb(v).split(/ [=≈] /)[1]}.`
          : `Apr\xE8s ta derni\xE8re ligne, ${v.target} ne vaut jamais ${Zb(v).split(/ [=≈] /)[1]}.`
        : 'Ces valeurs ne sont jamais vraies en m\xEAme temps : relis l\u2019ordre des instructions.',
    );
  }
  let a = XM(e, s);
  o < a && a !== 1 / 0 && fi(e, n, a) && t_(e, n, s, a) && (o = a);
  let l = 0;
  if (o > a) {
    let v = e.points[a],
      k = JD(e, n, s, a, o);
    if (k.ok) l = k.tours;
    else
      return {
        kind: 'unjustified',
        ...r,
        title:
          k.title ??
          (v.unit === 'iteration' ? 'Un tour \xE0 la fois' : 'Une \xE9tape \xE0 la fois'),
        message:
          k.message ??
          (v.unit === 'iteration'
            ? 'Ta ligne sera juste plus tard : \xE9cris d\u2019abord l\u2019\xE9tat \xE0 la fin du tour suivant.'
            : 'Ta ligne sera juste plus tard : \xE9cris d\u2019abord ce que fait l\u2019\xE9tape suivante du programme.'),
      };
  }
  let u = e.points[s].end,
    c = o === a || l > 0,
    f = c ? (e.points[o].unit ?? 'block') : null,
    d = c && u ? 2 : 1,
    m = l
      ? {
          id: di.jump,
          label: 'Sauter des tours',
          why: (v) => `Tu avances de ${l} tours d\u2019un coup : \xE0 la fin de ce tour, ${v}.`,
        }
      : f
        ? ZD[f]
        : null,
    p = o === e.last && IM(e, n),
    g =
      o === e.last &&
      e.trace.conds.some((v, k) => v.after === e.last && v.loop && !e.condsDone.has(k)),
    h = p && !g && !e.concluded,
    b =
      (m ? m.why(Ub(n)) : `Une instruction ex\xE9cut\xE9e : ${Ub(n)}.`) +
      (h ? ' Le programme est fini.' : '');
  return {
    kind: 'step',
    ...r,
    hora: d,
    final: h,
    rule: m
      ? { id: m.id, card: ec, label: m.label, hora: d, why: b }
      : { id: di.assign, card: ec, label: 'Une affectation', hora: d, why: b },
    pmove: { key: t, to: o, targets: i, ...(h ? { conclude: !0 } : {}) },
  };
}
function JD(e, n, t, r, s) {
  let i = e.points[r],
    o = i.unit === 'iteration' ? i.loop : void 0;
  if (!o || (e.loopTours.get(o) ?? 0) < FM) return { ok: !1 };
  let a = e.ends.find((f) => f >= s) ?? -1,
    l = a >= 0 ? e.points[a] : null;
  return !l || l.unit !== 'iteration' || l.loop !== o
    ? { ok: !1 }
    : e.visited.filter((f) => {
          let d = e.points[f];
          return d.unit === 'iteration' && d.loop === o;
        }).length < ND
      ? {
          ok: !1,
          title: 'Un tour \xE0 la fois',
          message:
            'La boucle est longue : \xE9cris d\u2019abord deux tours en entier, ensuite tu pourras sauter des tours.',
        }
      : a !== s || !fi(e, n, a)
        ? {
            ok: !1,
            title: '\xC0 la fin d\u2019un tour',
            message:
              'Pour sauter des tours, \xE9cris l\u2019\xE9tat \xE0 la FIN d\u2019un tour, pas au milieu.',
          }
        : t_(e, n, t, a)
          ? {
              ok: !0,
              tours: e.points.filter(
                (f, d) => d > t && d <= a && f.unit === 'iteration' && f.loop === o,
              ).length,
            }
          : {
              ok: !1,
              title: 'L\u2019\xE9tat complet',
              message:
                'Pour sauter des tours, \xE9cris toutes les variables qui changent pendant la boucle, s\xE9par\xE9es par \xAB ; \xBB.',
            };
}
function t_(e, n, t, r) {
  let s = new Set(n.filter((l) => !l.call).map((l) => l.target)),
    i = e.points[t].vars,
    o = e.points[r].vars,
    a = (l) => (l ? ct(l, !0) : '\u2205');
  return e.watch.every((l) => a(i[l]) === a(o[l]) || s.has(l));
}
function r_(e, n) {
  let t = new Set(n.map((r) => (r.call ? Gt(r.target) : r.target)));
  return e.answer.every((r) => t.has(r.call ? Gt(r.target) : r.target));
}
function IM(e, n) {
  return r_(e, n) && fi(e, n, e.last) && fi(e, e.answer, e.last);
}
function XD(e, n) {
  let t = n.map((r) =>
    !r.approx && r.value.k === 'num' ? { ...r, approx: !0, places: YD(r.value.q) } : r,
  );
  for (let r = e.cursor + 1; r < e.points.length; r++) if (fi(e, t, r)) return !0;
  return !1;
}
function YD(e) {
  let n = 0,
    t = e;
  for (; !B(t) && n < 30; ) ((t = N(t, C(10))), n++);
  return n;
}
function P1(e, n) {
  let t = e.cursor;
  return n >= FD(e, t) && n < XM(e, t);
}
function ud(e, n = new Set()) {
  return (
    e.k === 'var' && n.add(e.name),
    e.k === 'call' && n.add(nc.exec(e.atom)[1]),
    e.k === 'neg' && ud(e.e, n),
    e.k === 'bin' && (ud(e.l, n), ud(e.r, n)),
    n
  );
}
function s_(e, n, t, r, s, i) {
  let o = e.trace.conds,
    a = ud(r, ud(n));
  for (let l = 0; l < o.length; l++) {
    let u = o[l];
    if (!P1(e, u.after)) continue;
    let c = new Set(u.text.match(/[A-Za-z_\u00C0-\u024F][\w\u00C0-\u024F]*/g) ?? []);
    if ([...a].some((k) => !c.has(k))) continue;
    let f = e.points[Math.max(0, u.after)].vars,
      d = Ui(e, n, f),
      m = Ui(e, r, f);
    if (!UD(u, t, d, m)) continue;
    if (e.condsDone.has(l))
      return {
        kind: 'useless',
        ...i,
        title: 'D\xE9j\xE0 test\xE9',
        message: 'Tu as d\xE9j\xE0 \xE9crit ce test.',
        pmove: { key: s },
      };
    let p = u.result ? 'vrai' : 'faux',
      g = u.loop
        ? u.result
          ? 'la boucle continue'
          : 'la boucle s\u2019arr\xEAte'
        : u.result
          ? 'on ex\xE9cute le bloc du if'
          : 'on passe \xE0 la suite (else)',
      b =
        u.loop &&
        !u.result &&
        u.after === e.last &&
        !e.concluded &&
        e.answer.every((k) => e.atLast.has(k.call ? Gt(k.target) : k.target)) &&
        fi(e, e.answer, e.last),
      v = `\xAB ${u.text} \xBB est ${p} : ${g}.` + (b ? ' Le programme est fini.' : '');
    return {
      kind: 'step',
      ...i,
      hora: 1,
      final: b,
      rule: { id: di.condition, card: ec, label: 'Tester la condition', hora: 1, why: v },
      pmove: { key: s, conds: [l], ...(b ? { conclude: !0 } : {}) },
    };
  }
  return null;
}
function eB(e, n, t, r) {
  let s = new Set(),
    i = (f) => {
      (f.k === 'var' && s.add(f.name), f.k === 'neg' && i(f.e), f.k === 'bin' && (i(f.l), i(f.r)));
    };
  (i(n.l), i(n.r));
  let o = [...s].find((f) => !e.names.has(f));
  if (o)
    return {
      kind: 'false',
      ...r,
      title: 'Variable inconnue',
      message: `Le programme n\u2019a pas de variable \xAB ${o} \xBB.`,
    };
  let a = s_(e, n.l, n.op, n.r, t, r);
  if (a) return a;
  let l = e.points[e.cursor].vars,
    u = Ui(e, n.l, l),
    c = Ui(e, n.r, l);
  return u === null || c === null
    ? {
        kind: 'false',
        ...r,
        title: 'Je ne peux pas comparer',
        message: 'Une des valeurs n\u2019existe pas encore \xE0 ce moment du programme.',
      }
    : zD(n.op, u, c)
      ? {
          kind: 'useless',
          ...r,
          title: 'Juste, mais \xE0 c\xF4t\xE9',
          message:
            'C\u2019est vrai, mais ce n\u2019est pas le test que fait le programme maintenant.',
          pmove: { key: t },
        }
      : cd(
          e,
          t,
          r,
          'Comparaison fausse',
          'Avec les valeurs \xE0 ta derni\xE8re ligne, cette comparaison est fausse.',
        );
}
var nB = { '+': '+', '\u2212': '-', '\xD7': '*', '\xF7': '/', '%': '%' };
function Rp(e) {
  switch (e.k) {
    case 'list':
      return `[${e.items.map(Rp).join(', ')}]`;
    case 'num':
      return ct({ t: 'float', v: e.q }).replace(/^(−?\d+),0$/, '$1');
    case 'none':
      return 'None';
    case 'bool':
      return e.v ? 'True' : 'False';
    case 'var':
      return e.name;
    case 'call':
      return e.atom;
    case 'neg':
      return `\u2212${Rp(e.e)}`;
    case 'bin':
      return `${Rp(e.l)} ${e.op} ${Rp(e.r)}`;
  }
}
function tB(e, n, t, r) {
  let s = ud(n.e),
    i = [...s].find((d) => !e.names.has(d) && !e.funcs.has(d));
  if (i)
    return {
      kind: 'false',
      ...r,
      title: 'Variable inconnue',
      message: `Le programme n\u2019a pas de variable \xAB ${i} \xBB.`,
    };
  let o = nB[n.e.op],
    a = n.value,
    l = Rp(n.e),
    u = e.trace.evals;
  for (let d = 0; d < u.length; d++) {
    let m = u[d];
    if (!P1(e, m.after) || (m.op !== o && !(o === '/' && m.op === '//'))) continue;
    let p = new Set(m.text.match(/[A-Za-z_\u00C0-\u024F][\w\u00C0-\u024F]*/g) ?? []);
    if ([...s].some((b) => !p.has(b))) continue;
    let g = e.points[Math.max(0, m.after)].vars;
    if (!ml(Ui(e, n.e.l, g), m.l) || !ml(Ui(e, n.e.r, g), m.r)) continue;
    return (a.k === 'num' ? ml(a.q, m.v) : a.k === 'bool' ? ml(a.v, m.v) : !1)
      ? e.evalsDone.has(d)
        ? {
            kind: 'useless',
            ...r,
            title: 'D\xE9j\xE0 calcul\xE9',
            message: 'Tu as d\xE9j\xE0 \xE9crit ce calcul.',
            pmove: { key: t },
          }
        : {
            kind: 'step',
            ...r,
            hora: 1,
            rule: {
              id: di.eval,
              card: ec,
              label: 'Calculer',
              hora: 1,
              why: `Le programme calcule ${m.text} : ${l} = ${ld(a)}.`,
            },
            pmove: { key: t, evals: [d] },
          }
      : cd(e, t, r, 'Recalcule', `${l} ne vaut pas ${ld(a)}.`);
  }
  let c = e.points[e.cursor].vars,
    f = Ui(e, n.e, c);
  return f === null || typeof f == 'boolean' || a.k !== 'num'
    ? {
        kind: 'false',
        ...r,
        title: 'Je ne peux pas calculer',
        message: 'Une des valeurs n\u2019existe pas encore \xE0 ce moment du programme.',
      }
    : M(f, a.q)
      ? {
          kind: 'useless',
          ...r,
          title: 'Juste, mais \xE0 c\xF4t\xE9',
          message: 'C\u2019est juste, mais le programme ne fait pas ce calcul maintenant.',
          pmove: { key: t },
        }
      : cd(e, t, r, 'Calcul faux', `${l} ne vaut pas ${ld(a)}.`);
}
function rB(e, n, t, r) {
  for (let o of n) {
    let a = YM(e, o.target);
    if (!a)
      return {
        kind: 'false',
        ...r,
        title: 'Appel impossible',
        message: `Je ne sais pas calculer ${o.target} avec ce programme.`,
      };
    if (!Gb(a, o))
      return cd(e, t, r, 'Recalcule', `${o.target} ne vaut pas ${Zb(o).split(/ [=≈] /)[1]}.`);
  }
  let s = n.filter(
    (o) =>
      !e.callsDone.has(Gt(o.target)) &&
      e.trace.calls.some((a) => Gt(a.atom) === Gt(o.target) && P1(e, a.after)),
  );
  if (!s.length)
    return n.every((o) => e.callsDone.has(Gt(o.target)))
      ? {
          kind: 'useless',
          ...r,
          title: 'D\xE9j\xE0 calcul\xE9',
          message: 'Tu as d\xE9j\xE0 \xE9crit ce calcul.',
          pmove: { key: t },
        }
      : {
          kind: 'useless',
          ...r,
          title: 'Juste, mais \xE0 c\xF4t\xE9',
          message: 'C\u2019est juste, mais le programme ne fait pas ce calcul maintenant.',
          pmove: { key: t },
        };
  let i = s.length;
  return {
    kind: 'step',
    ...r,
    hora: i,
    rule: {
      id: di.call,
      card: ec,
      label: `Calculer ${s.map((o) => o.target).join(' et ')}`,
      hora: i,
      why: `Le programme calcule ${s.map((o) => o.target).join(' et ')} : ${Ub(s)}.`,
    },
    pmove: { key: t, calls: s.map((o) => Gt(o.target)) },
  };
}
function i_(e, n) {
  let t = n.pmove;
  !t ||
    (n.kind !== 'step' && n.kind !== 'ready' && n.kind !== 'useless') ||
    (e.lines.push({ key: t.key, text: n.line ? n.line.dis[0].sides[0].n : '' }),
    n.kind !== 'useless' &&
      (t.to !== void 0 &&
        ((e.cursor = t.to),
        e.visited.push(t.to),
        t.to === e.last && (t.targets ?? []).forEach((r) => e.atLast.add(r))),
      (t.conds ?? []).forEach((r) => e.condsDone.add(r)),
      (t.calls ?? []).forEach((r) => e.callsDone.add(r)),
      (t.evals ?? []).forEach((r) => e.evalsDone.add(r)),
      t.conclude && (e.concluded = !0)));
}
function o_(e) {
  return e.concluded;
}
function sB(e) {
  try {
    return Cp($p(e));
  } catch {
    return null;
  }
}
function a_(e, n) {
  if (e.mode === 'complete') return lB(e, n);
  let t = sB(n);
  return !!t && t.kind === 'claims' && fi(e, t.claims, e.last);
}
var AM = /^(\s*)_{3,}\s*$/,
  L1 =
    /(\d+\.\d+|\d+)|([A-Za-z_À-ɏ][A-Za-z0-9_À-ɏ]*)|("(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*')|(\*\*=|\/\/=|\*\*|\/\/|==|!=|<=|>=|\+=|-=|\*=|\/=|%=|[-+*/%<>=():,[\].])/y,
  jM = new Set([
    'for',
    'in',
    'while',
    'if',
    'elif',
    'else',
    'return',
    'not',
    'and',
    'or',
    'def',
    'import',
    'from',
    'is',
    'pass',
    'break',
    'continue',
  ]),
  iB = (e) => /^[-+*/%<>=!]+$/.test(e);
function l_(e) {
  let n = e.replace(/−/g, '-').replace(/×/g, '*').replace(/÷/g, '/'),
    t = [],
    r = 0;
  for (; r < n.length; ) {
    if (/\s/.test(n[r])) {
      r++;
      continue;
    }
    L1.lastIndex = r;
    let s = L1.exec(n);
    if (!s) throw new yn(`\xAB ${n[r]} \xBB ne s\u2019\xE9crit pas en Python ici.`);
    (t.push(s[0]), (r = L1.lastIndex));
  }
  return t;
}
function u_(e) {
  let n = '';
  return (
    e.forEach((t, r) => {
      if (r === 0) {
        n = t;
        return;
      }
      let s = e[r - 1],
        i = e[r - 2],
        o = !0;
      ((t === ')' ||
        t === ']' ||
        t === ':' ||
        t === ',' ||
        t === '.' ||
        s === '(' ||
        s === '[' ||
        s === '.' ||
        ((t === '(' || t === '[') && /^[A-Za-z_À-ɏ0-9\])]/.test(s) && !jM.has(s)) ||
        (s === '-' &&
          (i === void 0 || iB(i) || i === '(' || i === '[' || i === ',' || jM.has(i)))) &&
        (o = !1),
        (n += (o ? ' ' : '') + t));
    }),
    n
  );
}
function c_(e) {
  try {
    return u_(l_(e));
  } catch {
    return null;
  }
}
function oB(e) {
  let n = e.kernel,
    t = GM(e),
    r = t.code.replace(/\s+$/, '').split(`
`),
    s = r.flatMap((u, c) => (AM.test(u) ? [c] : []));
  if (s.length !== 1)
    throw new Error('Le programme doit avoir une seule ligne manquante, \xE9crite \xAB ____ \xBB.');
  let i = s[0],
    o = (t.checks ?? []).map((u) => {
      let c = Cp($p(u));
      if (c.kind !== 'claims') throw new Error(`Test illisible : \xAB ${u} \xBB`);
      return { text: u, claims: c.claims };
    });
  if (!o.length && !t.output?.length)
    throw new Error('Compl\xE9ter un programme demande des tests (`checks` ou `output`).');
  let a = ZM(e),
    l = {
      mode: 'complete',
      spec: n,
      code: t.code,
      call: null,
      trace: dl(''),
      points: [],
      last: 0,
      ends: [],
      watch: [],
      focusKey: null,
      cursor: 0,
      lines: [],
      condsDone: new Set(),
      callsDone: new Set(),
      evalsDone: new Set(),
      visited: [],
      loopTours: new Map(),
      draws: a,
      complete: {
        lines: r,
        blank: i,
        indent: AM.exec(r[i])[1],
        checks: o,
        output: t.output ?? null,
        cache: new Map(),
      },
      atLast: new Set(),
      concluded: !1,
      answer: [],
      traps: [],
      path: n.path ?? [],
      known: null,
      callCache: new Map(),
      funcs: new Set(),
      names: new Set(),
    };
  return (
    (l.traps = (e.traps ?? []).flatMap((u) => {
      let c = c_(u.line);
      return c ? [{ key: c, title: u.title, why: u.why, line: Hb(c) }] : [];
    })),
    (l.known = [
      n.answer,
      ...l.path,
      ...(e.traps ?? []).map((u) => u.line),
      ...(e.choices ?? []).flatMap((u) => (u.line ? [u.line] : [])),
    ].flatMap((u) => {
      try {
        return [l_(u)];
      } catch {
        return [];
      }
    })),
    l
  );
}
var aB = (e) => {
  let n = nc.exec(e);
  return `${n[1]}(${n[2].replace(/−/g, '-').replace(/(\d),(\d)/g, '$1.$2')})`;
};
function f_(e, n) {
  let t = e.complete,
    r = t.cache.get(n);
  if (r) return r;
  let s = t.lines.slice();
  s[t.blank] = t.indent + n;
  let i =
      s.join(`
`) +
      `
`,
    o = t.blank + 1,
    a = (c, f) => ({ ok: !1, title: c, message: f }),
    l = (c) =>
      c.code === 'syntax'
        ? a(
            'Python ne comprend pas',
            c.line === o
              ? `Python ne comprend pas ta ligne : ${c.message}`
              : `Avec ta ligne, le programme est mal \xE9crit (ligne ${c.line}) : ${c.message}`,
          )
        : c.code === 'budget'
          ? a(
              'Le programme ne s\u2019arr\xEAte pas',
              'Avec ta ligne, le programme ne s\u2019arr\xEAte pas (ou il est beaucoup trop long).',
            )
          : a(
              'Erreur \xE0 l\u2019ex\xE9cution',
              `Avec ta ligne, le programme s\u2019arr\xEAte sur une erreur (ligne ${c.line}) : ${c.message}`,
            ),
    u = (() => {
      let c = { trace: !1, ...(e.draws ? { draws: e.draws } : {}) },
        f = dl(i, c);
      if (f.error) return l(f.error);
      if (t.output) {
        let d = f.output;
        if (d.length !== t.output.length || d.some((m, p) => m !== t.output[p]))
          return a(
            'Ce n\u2019est pas ce qu\u2019il faut afficher',
            d.length
              ? `Avec ta ligne, le programme affiche \xAB ${d.join(' ')} \xBB au lieu de \xAB ${t.output.join(' ')} \xBB.`
              : `Avec ta ligne, le programme n\u2019affiche rien : il doit afficher \xAB ${t.output.join(' ')} \xBB.`,
          );
      }
      for (let d of t.checks)
        for (let m of d.claims) {
          let p;
          if (m.call) {
            let g = dl(i, { ...c, call: aB(m.target) });
            if (g.error) return l(g.error);
            p = g.focus?.value ?? null;
          } else p = f.globals[m.target];
          if (p == null)
            return a(
              'Le test ne passe pas',
              `Avec ta ligne, ${m.target} n\u2019existe pas \xE0 la fin du programme.`,
            );
          if (!Gb(p, m))
            return a(
              'Le test ne passe pas',
              `Avec ta ligne, on obtient ${m.target} = ${ct(p)}, au lieu de ${ld(m.value)}.`,
            );
        }
      return { ok: !0 };
    })();
  return (t.cache.set(n, u), u);
}
function lB(e, n) {
  let t = c_(n);
  return t !== null && f_(e, t).ok;
}
var uB = (e) =>
  [
    ...e.checks.map((n) => n.text),
    ...(e.output ? [`affiche \xAB ${e.output.join(' ')} \xBB`] : []),
  ].join(' ; ');
function cB(e, n, t) {
  let r;
  try {
    r = u_(n);
  } catch (c) {
    return {
      kind: 'syntax',
      atoms: n,
      title: '\xC7a commence mal',
      message: c instanceof Error ? c.message : String(c),
      badChip: n.length - 1,
    };
  }
  let s = e_(e, n),
    i = Hb(r),
    o = { atoms: n, line: i },
    a = r,
    l = f_(e, r);
  if (l.ok) {
    if (e.concluded)
      return {
        kind: 'useless',
        ...o,
        title: 'Tu as d\xE9j\xE0 conclu',
        message: 'Le programme est compl\xE9t\xE9 et les tests passent.',
        pmove: { key: a },
      };
    let c = {
      kind: 'step',
      ...o,
      final: !0,
      hora: 3,
      rule: {
        id: di.complete,
        card: ec,
        label: 'Compl\xE9ter le programme',
        hora: 3,
        why: `Avec cette ligne, le programme passe les tests : ${uB(e.complete)}.`,
      },
      pmove: { key: a, conclude: !0 },
    };
    return s && !t?.verify ? { ...c, kind: 'ready' } : c;
  }
  if (s && !t?.verify) return { kind: 'building', atoms: n, complete: !0 };
  let u = e.traps.find((c) => c.key === a);
  return u
    ? {
        kind: 'trap',
        ...o,
        title: 'Pi\xE8ge : ' + u.title.charAt(0).toLowerCase() + u.title.slice(1),
        message: u.why,
        trap: { line: u.line, title: u.title, why: u.why },
        badChip: -1,
      }
    : t?.verify
      ? { kind: 'false', ...o, title: l.title, message: l.message }
      : {
          kind: l.title === 'Python ne comprend pas' ? 'open' : 'pending',
          atoms: n,
          complete: l.title !== 'Python ne comprend pas',
        };
}
var QM = new WeakMap();
function d_(e) {
  let n = QM.get(e);
  if (n !== void 0) return n;
  let t = (() => {
    try {
      let r = e.kernel,
        s = r?.program;
      if (!r || !s) return !1;
      if (
        r.goal?.kind === 'complete' ||
        s.draws ||
        s.checks ||
        s.output ||
        s.display ||
        /\b(import\s+random|from\s+random)\b/.test(s.code) ||
        /^\s*(if|elif|while)\b.*\b(and|or)\b/m.test(s.code)
      )
        return !0;
      let i = e,
        o = [
          r.answer,
          ...(r.path ?? []),
          ...(i.traps ?? []).map((u) => u.line ?? ''),
          ...(i.choices ?? []).map((u) => u.line ?? ''),
        ];
      for (let u of o) {
        if (/\bNone\b/.test(u)) return !0;
        let c = u.replace(/[A-Za-z_À-ɏ][\wÀ-ɏ]*\s*\([^()]*\)/g, 'F');
        if (c.includes('%')) return !0;
        if (!c.includes(';')) {
          let f = c.search(/[=≈]/);
          if (f > 0 && /[+−×÷*/-]/.test(c.slice(0, f))) return !0;
        }
      }
      let a = dl(s.code, s.call ? { call: s.call } : {});
      if (!a.ok) return !1;
      let l = new Map();
      return (
        a.points.forEach((u) => {
          u.unit === 'iteration' && u.loop && l.set(u.loop, (l.get(u.loop) ?? 0) + 1);
        }),
        [...l.values()].some((u) => u >= FM)
      );
    } catch {
      return !1;
    }
  })();
  return (QM.set(e, t), t);
}
var ft = class extends Error {
    constructor(t, r) {
      super(r);
      this.code = t;
    }
    code;
  },
  tc = (e) => ({ t: 's', q: e });
function Ho(e) {
  return { t: 'm', r: e.length, c: e[0]?.length ?? 0, a: e };
}
function md(e, n = q) {
  return Array.from({ length: e }, (t, r) =>
    Array.from({ length: e }, (s, i) => (r === i ? n : F)),
  );
}
var fd = (e) => `${e.r} \xD7 ${e.c}`;
function m_(e, n) {
  if (e.t === 'm') return e.a;
  if (e.t === 'id') return md(n, e.s);
  throw new ft('kind', 'Un nombre n\u2019est pas une matrice.');
}
function p_(e, n, t = 1) {
  let r = (a, l) => (t === 1 ? re(a, l) : me(a, l));
  if (e.t === 's' && n.t === 's') return tc(r(e.q, n.q));
  if (e.t === 's' || n.t === 's') {
    let a = e.t === 's' ? e : n,
      l = e.t === 's' ? n : e;
    if (!L(a.q)) throw new ft('kind', 'On n\u2019ajoute pas un nombre \xE0 une matrice.');
    return e.t === 's' ? (t === 1 ? l : rc(l, C(-1))) : l;
  }
  if (e.t === 'id' && n.t === 'id') return { t: 'id', s: r(e.s, n.s) };
  let s = e.t === 'm' ? e.r : n.r;
  if (e.t === 'm' && n.t === 'm' && (e.r !== n.r || e.c !== n.c))
    throw new ft(
      'size',
      `Les tailles ne vont pas : on n\u2019ajoute pas une matrice ${fd(e)} et une matrice ${fd(n)}.`,
    );
  if ((e.t === 'id' && n.t === 'm' && n.r !== n.c) || (n.t === 'id' && e.t === 'm' && e.r !== e.c))
    throw new ft(
      'size',
      'L\u2019identit\xE9 est carr\xE9e : on ne l\u2019ajoute qu\u2019\xE0 une matrice carr\xE9e.',
    );
  let i = m_(e, s),
    o = m_(n, s);
  return Ho(i.map((a, l) => a.map((u, c) => r(u, o[l][c]))));
}
function rc(e, n) {
  return e.t === 's'
    ? tc(N(e.q, n))
    : e.t === 'id'
      ? { t: 'id', s: N(e.s, n) }
      : Ho(e.a.map((t) => t.map((r) => N(r, n))));
}
function pl(e, n) {
  if (e.t === 's') return rc(n, e.q);
  if (n.t === 's') return rc(e, n.q);
  if (e.t === 'id' && n.t === 'id') return { t: 'id', s: N(e.s, n.s) };
  if (e.t === 'id') return rc(n, e.s);
  if (n.t === 'id') return rc(e, n.s);
  if (e.c !== n.r)
    throw new ft(
      'size',
      `Les tailles ne vont pas : une matrice ${fd(e)} fois une matrice ${fd(n)} n\u2019existe pas (le nombre de colonnes de la premi\xE8re doit \xEAtre le nombre de lignes de la seconde).`,
    );
  let t = [];
  for (let r = 0; r < e.r; r++) {
    let s = [];
    for (let i = 0; i < n.c; i++) {
      let o = F;
      for (let a = 0; a < e.c; a++) o = re(o, N(e.a[r][a], n.a[a][i]));
      s.push(o);
    }
    t.push(s);
  }
  return Ho(t);
}
function I1(e) {
  let n = e.length,
    t = e.map((s) => s.slice()),
    r = q;
  for (let s = 0; s < n; s++) {
    let i = s;
    for (; i < n && L(t[i][s]); ) i++;
    if (i === n) return F;
    i !== s && (([t[i], t[s]] = [t[s], t[i]]), (r = fe(r)));
    let o = t[s][s];
    r = N(r, o);
    for (let a = s + 1; a < n; a++) {
      let l = A(t[a][s], o);
      for (let u = s; u < n; u++) t[a][u] = me(t[a][u], N(l, t[s][u]));
    }
  }
  return r;
}
function A1(e) {
  let n = e.length,
    t = e.map((r, s) => [...r, ...md(n)[s]]);
  for (let r = 0; r < n; r++) {
    let s = r;
    for (; s < n && L(t[s][r]); ) s++;
    if (s === n) return null;
    [t[s], t[r]] = [t[r], t[s]];
    let i = t[r][r];
    t[r] = t[r].map((o) => A(o, i));
    for (let o = 0; o < n; o++) {
      if (o === r || L(t[o][r])) continue;
      let a = t[o][r];
      t[o] = t[o].map((l, u) => me(l, N(a, t[r][u])));
    }
  }
  return t.map((r) => r.slice(n));
}
function fB(e, n) {
  if (e.t === 's') {
    let i = at(e.q, n);
    if (!i) throw new ft('div0', 'Division par 0.');
    return tc(i);
  }
  if (e.t === 'id') {
    let i = at(e.s, n);
    if (!i) throw new ft('inverse', 'Cette matrice n\u2019est pas inversible.');
    return { t: 'id', s: i };
  }
  if (e.r !== e.c)
    throw new ft('size', `Seule une matrice carr\xE9e a des puissances (ici ${fd(e)}).`);
  let t = e.a;
  if (n < 0) {
    let i = A1(e.a);
    if (!i)
      throw new ft(
        'inverse',
        'Cette matrice n\u2019est pas inversible : son d\xE9terminant est nul.',
      );
    ((t = i), (n = -n));
  }
  if (n > 4096) throw new ft('power', 'Puissance trop grande.');
  let r = { t: 'id', s: q },
    s = Ho(t);
  for (; n > 0; ) (n & 1 && (r = pl(r, s)), (s = pl(s, s)), (n >>= 1));
  return r.t === 'id' ? Ho(md(e.r, r.s)) : r;
}
function dB(e) {
  return e.t !== 'm' ? e : Ho(Array.from({ length: e.c }, (n, t) => e.a.map((r) => r[t])));
}
function Zt(e, n) {
  if (e.t === 's' && n.t === 's') return M(e.q, n.q);
  if (e.t === 's' || n.t === 's') {
    let s = e.t === 's' ? e : n,
      i = e.t === 's' ? n : e;
    return L(s.q) ? (i.t === 'id' ? L(i.s) : i.a.every((o) => o.every(L))) : !1;
  }
  if (e.t === 'id' && n.t === 'id') return M(e.s, n.s);
  if (e.t === 'm' && n.t === 'm')
    return e.r === n.r && e.c === n.c && e.a.every((s, i) => s.every((o, a) => M(o, n.a[i][a])));
  let t = e.t === 'm' ? e : n,
    r = e.t === 'id' ? e : n;
  return t.r === t.c && Zt(t, Ho(md(t.r, r.s)));
}
var Mr = class extends Error {},
  Cs = class extends Error {},
  Wb = '\u2070\xB9\xB2\xB3\u2074\u2075\u2076\u2077\u2078\u2079',
  Zo = '\u2080\u2081\u2082\u2083\u2084\u2085\u2086\u2087\u2088\u2089',
  mB = new RegExp(`^([A-Z]|\u03C0)[${Zo}]*$`),
  pB = new RegExp(`^(\u207B\xB9|\u1D40|[${Wb}]+)$`),
  j1 = /^−?\d+(,\d+)?$/,
  gB = new Set(['=', '+', '\u2212', '\xD7', '\xF7', '(', ')', '[', ']', ',', ';']),
  hB = (e) => Number([...e].map((n) => Wb.indexOf(n)).join(''));
var Jb = (e) => pB.test(e),
  bB = new RegExp(`^[${Zo}]+$`),
  Q1 = (e) => bB.test(e),
  g_ = new RegExp(`\\)[${Zo}]`),
  Ep = (e) => mB.test(e);
function h_(e) {
  let n = [],
    t = e.trim(),
    r = 0,
    s = { '-': '\u2212', '*': '\xD7', '/': '\xF7', '\xB7': '\xD7' };
  for (; r < t.length; ) {
    let i = t[r];
    if (/\s/.test(i)) {
      r++;
      continue;
    }
    if (/\d/.test(i)) {
      let a = r;
      for (; a < t.length && /\d/.test(t[a]); ) a++;
      if (t[a] === ',' && /\d/.test(t[a + 1] ?? ''))
        for (a++; a < t.length && /\d/.test(t[a]); ) a++;
      (n.push(t.slice(r, a)), (r = a));
      continue;
    }
    if (Zo.includes(i) && n[n.length - 1] === ')') {
      let a = r;
      for (; a < t.length && Zo.includes(t[a]); ) a++;
      (n.push(t.slice(r, a)), (r = a));
      continue;
    }
    if (/[A-Z]/.test(i) || i === '\u03C0') {
      let a = r + 1;
      for (; a < t.length && Zo.includes(t[a]); ) a++;
      (n.push(t.slice(r, a)), (r = a));
      continue;
    }
    if (t.startsWith('det', r)) {
      (n.push('det'), (r += 3));
      continue;
    }
    if (t.startsWith('\u207B\xB9', r)) {
      (n.push('\u207B\xB9'), (r += 2));
      continue;
    }
    if (i === '\u1D40') {
      (n.push('\u1D40'), r++);
      continue;
    }
    if (Wb.includes(i)) {
      let a = r;
      for (; a < t.length && Wb.includes(t[a]); ) a++;
      (n.push(t.slice(r, a)), (r = a));
      continue;
    }
    let o = s[i] ?? i;
    if (!gB.has(o))
      throw new Mr(`\xAB ${i} \xBB ne s\u2019\xE9crit pas dans un calcul de matrices.`);
    (n.push(o), r++);
  }
  return n;
}
function hl(e) {
  let n = '';
  return (
    e.forEach((t, r) => {
      let s = e[r - 1],
        i =
          r === 0 ||
          Jb(t) ||
          Q1(t) ||
          (s === '\u2212' &&
            (r < 2 || ['(', '[', ',', ';', '=', '\xD7', '\xF7'].includes(e[r - 2]))) ||
          t === ')' ||
          t === ']' ||
          t === ',' ||
          s === '(' ||
          s === '[' ||
          (s === 'det' && t === '(') ||
          ((Ep(t) || t === '(' || t === '[') &&
            s !== void 0 &&
            (Ep(s) || Jb(s) || j1.test(s) || s === ')' || s === ']'));
      n += (i ? '' : ' ') + t;
    }),
    n
  );
}
function F1(e) {
  let n = 0,
    t = () => e[n],
    r = (f) => {
      if (e[n] !== f) throw n >= e.length ? new Cs('') : new Mr(`\xAB ${f} \xBB attendu.`);
      n++;
    },
    s = (f) => f !== void 0 && (Ep(f) || f === '[' || f === '(' || f === 'det');
  function i() {
    let f = o();
    for (; t() === '+' || t() === '\u2212'; ) {
      let d = e[n++];
      if (n >= e.length) throw new Cs('');
      f = { k: d === '+' ? 'add' : 'sub', l: f, r: o() };
    }
    return f;
  }
  function o() {
    let f = a();
    for (;;) {
      let d = t();
      if (d === '\xD7' || d === '\xF7') {
        if ((n++, n >= e.length)) throw new Cs('');
        let m = a();
        f = d === '\xD7' ? { k: 'mul', l: f, r: m } : { k: 'div', l: f, r: m };
      } else if (s(d)) f = { k: 'mul', l: f, r: l(), implicit: !0 };
      else return f;
    }
  }
  function a() {
    if (t() === '\u2212') {
      if ((n++, n >= e.length)) throw new Cs('');
      return { k: 'neg', e: a() };
    }
    return l();
  }
  function l() {
    let f = u();
    for (;;) {
      let d = t();
      if (d !== void 0 && Q1(d)) {
        if (f.k !== 'paren')
          throw new Mr(
            'Un coefficient s\u2019\xE9crit entre parenth\xE8ses : \xAB (M\xB2)\u2081\u2083 \xBB.',
          );
        let m = [...d].map((p) => Zo.indexOf(p));
        if (m.length !== 2 || m.some((p) => p < 1))
          throw new Mr(
            'Un coefficient a deux indices, la ligne puis la colonne : \xAB (M\xB2)\u2081\u2083 \xBB.',
          );
        (n++, (f = { k: 'entry', e: f.e, i: m[0], j: m[1] }));
        continue;
      }
      if (d === void 0 || !Jb(d)) return f;
      if ((n++, d === '\u1D40')) f = { k: 'tr', e: f };
      else if (d === '\u207B\xB9') f = { k: 'pow', e: f, n: -1, text: d };
      else {
        let m = hB(d);
        if (!Number.isInteger(m) || m < 0) throw new Mr('Exposant illisible.');
        f = { k: 'pow', e: f, n: m, text: d };
      }
    }
  }
  function u() {
    let f = e[n];
    if (f === void 0) throw new Cs('');
    if (j1.test(f)) {
      n++;
      let d = nr(f.replace('\u2212', '-'));
      if (!d) throw new Mr(`Nombre illisible : \xAB ${f} \xBB.`);
      return { k: 'num', q: d, text: f };
    }
    if (Ep(f)) return (n++, { k: 'name', n: f });
    if (f === 'det') {
      (n++, r('('));
      let d = i();
      return (r(')'), { k: 'det', e: d });
    }
    if (f === '(') {
      n++;
      let d = i();
      return (r(')'), { k: 'paren', e: d });
    }
    if (f === '[') {
      n++;
      let d = [[]];
      for (;;) {
        d[d.length - 1].push(i());
        let p = e[n];
        if (p === void 0) throw new Cs('');
        if ((n++, p === ']')) break;
        if (p !== ',') {
          if (p === ';') {
            d.push([]);
            continue;
          }
          throw new Mr(
            `\xAB ${p} \xBB : dans une matrice, \xAB , \xBB s\xE9pare deux coefficients et \xAB ; \xBB deux lignes.`,
          );
        }
      }
      let m = d[0].length;
      if (d.some((p) => p.length !== m))
        throw new Mr('Les lignes de la matrice n\u2019ont pas le m\xEAme nombre de coefficients.');
      return { k: 'lit', rows: d };
    }
    throw new Mr(`\xAB ${f} \xBB ne commence pas un calcul.`);
  }
  if (!e.length) throw new Cs('');
  let c = [i()];
  for (; n < e.length; ) {
    if (e[n] !== '=') throw new Mr(`\xAB ${e[n]} \xBB de trop.`);
    if ((n++, n >= e.length)) throw new Cs('');
    c.push(i());
  }
  return c;
}
var b_ = new RegExp(`^I([${Zo}]*)$`);
function ln(e, n) {
  switch (e.k) {
    case 'num':
      return tc(e.q);
    case 'name': {
      let t = n.get(e.n);
      if (t) return t;
      let r = b_.exec(e.n);
      if (r) {
        if (!r[1]) return { t: 'id', s: q };
        let s = Number([...r[1]].map((i) => Zo.indexOf(i)).join(''));
        return Ho(md(s));
      }
      throw new ft('unknown', `Je ne connais pas la matrice ${e.n}.`);
    }
    case 'lit': {
      let t = e.rows.map((r) =>
        r.map((s) => {
          let i = ln(s, n);
          if (i.t !== 's') throw new ft('entry', 'Un coefficient de matrice est un nombre.');
          return i.q;
        }),
      );
      return Ho(t);
    }
    case 'paren':
      return ln(e.e, n);
    case 'add':
      return p_(ln(e.l, n), ln(e.r, n), 1);
    case 'sub':
      return p_(ln(e.l, n), ln(e.r, n), -1);
    case 'neg':
      return rc(ln(e.e, n), C(-1));
    case 'mul':
      return pl(ln(e.l, n), ln(e.r, n));
    case 'div': {
      let t = ln(e.r, n);
      if (t.t !== 's')
        throw new ft('kind', 'On ne divise pas par une matrice : on multiplie par son inverse.');
      let r = A(q, t.q);
      if (!r) throw new ft('div0', 'Division par 0.');
      return rc(ln(e.l, n), r);
    }
    case 'pow':
      return fB(ln(e.e, n), e.n);
    case 'tr':
      return dB(ln(e.e, n));
    case 'det': {
      let t = ln(e.e, n);
      if (t.t !== 'm' || t.r !== t.c)
        throw new ft('size', 'Seule une matrice carr\xE9e a un d\xE9terminant.');
      return tc(I1(t.a));
    }
    case 'entry': {
      let t = ln(e.e, n);
      if (t.t === 's') throw new ft('kind', 'Un nombre n\u2019a pas de coefficient.');
      if (t.t === 'id') return tc(e.i === e.j ? t.s : F);
      if (e.i > t.r || e.j > t.c)
        throw new ft('entry', `Une matrice ${fd(t)} n\u2019a pas de coefficient (${e.i}, ${e.j}).`);
      return tc(t.a[e.i - 1][e.j - 1]);
    }
  }
}
var vB = (e) => {
  let n = e.n < 0n,
    t = n ? fe(e) : e,
    r;
  if (t.d === 1n) r = t.n.toString();
  else {
    let s = t.d,
      i = 0;
    for (; s % 10n === 0n; ) ((s /= 10n), i++);
    let o = 0,
      a = 0,
      l = t.d;
    for (; l % 2n === 0n; ) ((l /= 2n), o++);
    for (; l % 5n === 0n; ) ((l /= 5n), a++);
    if (l === 1n) {
      let u = Math.max(o, a),
        f = ((t.n * 10n ** BigInt(u)) / t.d).toString().padStart(u + 1, '0');
      r = (f.slice(0, f.length - u) + ',' + f.slice(f.length - u)).replace(/,?0+$/, '');
    } else r = `${t.n} \xF7 ${t.d}`;
  }
  return (n ? '\u2212' : '') + r;
};
function Ze(e) {
  switch (e.k) {
    case 'num':
      return vB(e.q);
    case 'name':
      return e.n;
    case 'lit':
      return '[' + e.rows.map((n) => n.map(Ze).join(',')).join(';') + ']';
    case 'paren':
      return Ze(e.e);
    case 'add':
      return `(${Ze(e.l)}+${Ze(e.r)})`;
    case 'sub':
      return `(${Ze(e.l)}-${Ze(e.r)})`;
    case 'neg':
      return `-(${Ze(e.e)})`;
    case 'mul':
      return '(' + gl(e).map(Ze).join('*') + ')';
    case 'div':
      return `(${Ze(e.l)}/${Ze(e.r)})`;
    case 'pow':
      return `(${Ze(e.e)})^${e.n}`;
    case 'tr':
      return `(${Ze(e.e)})^T`;
    case 'det':
      return `det(${Ze(e.e)})`;
    case 'entry':
      return `(${Ze(e.e)})_${e.i},${e.j}`;
  }
}
function mi(e) {
  if (e.k === 'num') return e.q;
  if (e.k === 'paren') return mi(e.e);
  if (e.k === 'neg') {
    let n = mi(e.e);
    return n ? fe(n) : null;
  }
  return null;
}
function Gi(e) {
  let n = e.k === 'paren' ? e.e : e;
  return n.k === 'lit' && n.rows.every((t) => t.every((r) => mi(r) !== null));
}
function sc(e, n = new Set()) {
  switch (e.k) {
    case 'name':
      n.add(e.n);
      break;
    case 'lit':
      e.rows.forEach((t) => t.forEach((r) => sc(r, n)));
      break;
    case 'add':
    case 'sub':
    case 'mul':
    case 'div':
      (sc(e.l, n), sc(e.r, n));
      break;
    case 'neg':
    case 'paren':
    case 'pow':
    case 'tr':
    case 'det':
    case 'entry':
      sc(e.e, n);
      break;
    default:
      break;
  }
  return n;
}
function _r(e) {
  switch (e.k) {
    case 'num':
    case 'name':
      return 0;
    case 'lit':
      return e.rows.reduce((n, t) => n + t.reduce((r, s) => r + _r(s), 0), 0);
    case 'paren':
      return _r(e.e);
    case 'neg':
      return mi(e) !== null ? 0 : 1 + _r(e.e);
    case 'add':
    case 'sub':
    case 'mul':
    case 'div':
      return 1 + _r(e.l) + _r(e.r);
    case 'pow':
    case 'tr':
    case 'det':
      return 1 + _r(e.e);
    case 'entry':
      return _r(e.e);
  }
}
var dd = (e) => (e.k === 'paren' ? dd(e.e) : e);
function gl(e) {
  let n = dd(e);
  return n.k === 'mul' ? [...gl(n.l), ...gl(n.r)] : [n];
}
function pd(e) {
  let n = [],
    t = (o, a) => {
      let l = n[n.length - 1];
      l && l.base === o ? (l.n += a) : n.push({ base: o, n: a });
    },
    r = 2e3,
    s = (o) => o.k === 'name' || o.k === 'lit' || (o.k === 'pow' && o.n === -1) || o.k === 'tr',
    i = (o) => {
      let a = dd(o);
      if (a.k === 'mul') return i(a.l) && i(a.r);
      if (a.k === 'pow' && a.n >= 1) {
        let l = dd(a.e);
        if (s(l)) return (t(Ze(l), a.n), !0);
        for (let u = 0; u < a.n; u++) if (--r < 0 || !i(l)) return !1;
        return !0;
      }
      return s(a) ? (t(Ze(a), 1), !0) : !1;
    };
  return i(e) ? n : null;
}
function Es(e) {
  let n = dd(e);
  return n.k === 'name' ? b_.test(n.n) : n.k === 'pow' ? Es(n.e) : !1;
}
function v_(e) {
  let n = [],
    t = (r, s) => {
      let i = dd(r);
      if (i.k === 'add') return t(i.l, s) && t(i.r, s);
      if (i.k === 'sub') return t(i.l, s) && t(i.r, -s);
      try {
        let o = ln(i, new Map());
        return o.t !== 's' ? !1 : (n.push(s === 1 ? o.q : fe(o.q)), !0);
      } catch {
        return !1;
      }
    };
  return t(e, 1) ? n : null;
}
function k_(e, n) {
  if (e.length !== n.length) return !1;
  let t = (s) => bt(s),
    r = new Map();
  e.forEach((s) => r.set(t(s), (r.get(t(s)) ?? 0) + 1));
  for (let s of n) {
    let i = r.get(t(s)) ?? 0;
    if (!i) return !1;
    r.set(t(s), i - 1);
  }
  return !0;
}
var kB = /^[A-Za-zÀ-ÖØ-öø-ÿΑ-Ωα-ορ-ω]$/,
  xB = /[A-Za-zÀ-ÖØ-öø-ÿΑ-Ωα-ορ-ω]+/g,
  x_ = /[\u2080-\u209c′'’_]|\p{M}/u,
  yB = new Set([
    ...Object.keys(cf),
    Em,
    'ou',
    'et',
    'det',
    'card',
    'pgcd',
    'PGCD',
    'ppcm',
    'PPCM',
    'mod',
  ]),
  wB = new Set(['algebra', 'formula', 'claims', 'analysis']),
  SB = (e) => !!e && kB.test(e);
function TB(e) {
  let n = new Set(),
    t = (i) => {
      SB(i) && n.add(i);
    };
  Object.keys(e.symbols ?? {}).forEach(t);
  let r = e.kernel;
  (t(r?.goal?.target),
    (r?.hypotheses ?? []).forEach((i) => t(i.of)),
    (r?.system?.unknowns ?? []).forEach(t),
    t(r?.induction?.variable),
    (r?.claims ?? []).forEach((i) => Object.keys(i.at ?? {}).forEach(t)));
  let s = [r?.start, ...(r?.givens ?? []), ...(r?.system?.equations ?? []), ...(e.givens ?? [])];
  for (let i of s)
    if (i)
      try {
        Te(i).forEach(t);
      } catch {}
  return n;
}
function RB(e, n, t) {
  return e.length < 2 || yB.has(e) || t.has(e) ? !1 : [...e].every((r) => n.has(r));
}
function $B(e, n, t = new Set()) {
  return n.size
    ? e.replace(xB, (r, s, i) => {
        if (!RB(r, n, t)) return r;
        let o = i[s - 1] ?? '',
          a = i[s + r.length] ?? '';
        return x_.test(o) || x_.test(a) || (a === '(' && Cx(i.slice(s))) ? r : [...r].join(' ');
      })
    : e;
}
function V1(e) {
  let n = e.kernel;
  if (!n || !wB.has(n.plugin ?? '')) return e;
  let t = TB(e);
  if (t.size < 2) return e;
  let r = new Set(Object.keys(e.symbols ?? {})),
    s = !1,
    i = (f) => {
      if (typeof f != 'string') return f;
      let d = $B(f, t, r);
      return (d !== f && (s = !0), d);
    },
    o = (f) => f?.map((d) => i(d)),
    a = (f) => f?.map((d) => (d.line === void 0 ? d : { ...d, line: i(d.line) })),
    l = {
      ...n,
      start: i(n.start),
      answer: i(n.answer),
      path: o(n.path),
      givens: o(n.givens),
      domain: i(n.domain),
      ...(n.system ? { system: { ...n.system, equations: o(n.system.equations) } } : {}),
      ...(n.claims ? { claims: n.claims.map((f) => ({ ...f, rels: o(f.rels) })) } : {}),
      ...(n.induction
        ? { induction: { ...n.induction, hypothesis: i(n.induction.hypothesis) } }
        : {}),
    },
    u = {
      ...e,
      kernel: l,
      givens: o(e.givens),
      admitted: o(e.admitted),
      answers: o(e.answers),
      path: o(e.path),
      preds: a(e.preds),
      traps: a(e.traps),
      checks: a(e.checks),
      choices: a(e.choices),
    };
  if (!s) return e;
  let c = (f, d) => {
    Object.keys(f).forEach((m) => {
      f[m] === void 0 && !(m in d) && delete f[m];
    });
  };
  return (c(u, e), c(l, n), u);
}
function y_(e) {
  return V1(e) !== e;
}
var R_ = '\u2080\u2081\u2082\u2083\u2084\u2085\u2086\u2087\u2088\u2089',
  $_ = '\u2070\xB9\xB2\xB3\u2074\u2075\u2076\u2077\u2078\u2079';
function D1(e) {
  return 'o' + String(e).replace(/\d/g, (n) => R_[Number(n)]);
}
function oc(e) {
  let n = /^o([₀₁₂₃₄₅₆₇₈₉]+)$/.exec(e);
  return n ? Number([...n[1]].map((t) => R_.indexOf(t)).join('')) : null;
}
function ac(e, n = 'x') {
  return e === 0
    ? 'o(1)'
    : e === 1
      ? `o(${n})`
      : `o(${n}${String(e).replace(/\d/g, (t) => $_[Number(t)])})`;
}
function B1(e) {
  let n = /^o\((1|[a-zA-Z](?:([⁰¹²³⁴⁵⁶⁷⁸⁹]+))?)\)$/.exec(e);
  return n
    ? n[1] === '1'
      ? 0
      : n[2]
        ? Number([...n[2]].map((t) => $_.indexOf(t)).join(''))
        : 1
    : null;
}
function fn(e) {
  switch (e.k) {
    case 'sym':
      return oc(e.n) !== null;
    case 'num':
      return !1;
    case 'add':
    case 'mul':
      return e.c.some(fn);
    case 'fn':
      return fn(e.a);
    default:
      return fn(e.a) || fn(e.b);
  }
}
var Jo = F,
  Zi = q,
  ic = (e) => ({ co: L(e) ? new Map() : new Map([[0, e]]), e: 1 / 0 }),
  CB = () => ({ co: new Map([[1, Zi]]), e: 1 / 0 }),
  EB = (e) => ({ co: new Map(), e });
function hd(e, n) {
  return e.co.get(n) ?? Jo;
}
function _p(e) {
  let n = null;
  for (let [t, r] of e.co) !L(r) && (n === null || t < n) && (n = t);
  return n;
}
function Xb(e) {
  let n = _p(e);
  return n === null ? e.e : n;
}
function Yb(e, n) {
  let t = Math.min(e.e, n),
    r = new Map();
  for (let [s, i] of e.co) s <= t && !L(i) && r.set(s, i);
  return { co: r, e: t };
}
function qp(e, n) {
  let t = Math.min(e.e, n.e),
    r = new Map();
  for (let s of [e, n])
    for (let [i, o] of s.co) {
      if (i > t) continue;
      let a = re(r.get(i) ?? Jo, o);
      L(a) ? r.delete(i) : r.set(i, a);
    }
  return { co: r, e: t };
}
function ev(e, n) {
  if (L(n)) return { co: new Map(), e: 1 / 0 };
  let t = new Map();
  for (let [r, s] of e.co) t.set(r, N(s, n));
  return { co: t, e: e.e };
}
var MB = (e) => ev(e, C(-1));
function C_(e, n) {
  let t = new Map();
  for (let [r, s] of e.co) t.set(r + n, s);
  return { co: t, e: e.e + n };
}
function Hi(e, n) {
  if (!e.co.size && e.e === 1 / 0) return e;
  if (!n.co.size && n.e === 1 / 0) return n;
  let t = Math.min(e.e + Xb(n), n.e + Xb(e)),
    r = new Map();
  for (let [s, i] of e.co)
    for (let [o, a] of n.co) {
      let l = s + o;
      if (l > t) continue;
      let u = re(r.get(l) ?? Jo, N(i, a));
      L(u) ? r.delete(l) : r.set(l, u);
    }
  return { co: r, e: t };
}
function z1(e, n, t) {
  let r = ic(n(0)),
    s = ic(Zi);
  for (let i = 1; i <= Math.max(t, 0) + 2; i++) {
    s = Yb(Hi(s, e), t);
    let o = n(i);
    if ((L(o) || (r = qp(r, ev(s, o))), _p(s) === null && s.e >= t)) break;
  }
  return Yb(r, t);
}
function Lp(e, n) {
  let t = _p(e);
  if (t === null) return null;
  let r = e.co.get(t),
    s = { co: new Map(), e: e.e - t };
  for (let [a, l] of e.co) a !== t && s.co.set(a - t, A(l, r));
  if (!s.co.size && s.e === 1 / 0) return { co: new Map([[-t, A(Zi, r)]]), e: 1 / 0 };
  let i = Math.min(s.e, n + t),
    o = z1(MB(s), () => Zi, i);
  return C_(ev(o, A(Zi, r)), -t);
}
function U1(e, n, t) {
  if (!Number.isInteger(n) || Math.abs(n) > 24) return null;
  if (n < 0) {
    let s = U1(e, -n, t);
    return s ? Lp(s, t) : null;
  }
  let r = ic(Zi);
  for (let s = 0; s < n; s++) r = Hi(r, e);
  return r;
}
function E_(e) {
  for (let [n, t] of e.co) if (n < 0 && !L(t)) return null;
  return e.e < 0 ? null : hd(e, 0);
}
function Np(e, n, t) {
  let r = E_(e);
  if (r === null || !L(r)) return null;
  if (Xb(e) < 1)
    return e.e < 0 ? null : { co: L(n(0)) ? new Map() : new Map([[0, n(0)]]), e: Math.min(e.e, t) };
  let i = z1(e, n, t);
  return Yb(i, t);
}
var _B = (() => {
    let e = [1n];
    for (let n = 1; n <= 40; n++) e.push(e[n - 1] * BigInt(n));
    return e;
  })(),
  G1 = (e) => C(1n, _B[e]);
function qB(e, n) {
  let t = Zi;
  for (let r = 0; r < n; r++) t = N(t, A(me(e, C(r)), C(r + 1)));
  return t;
}
function w_(e, n) {
  if (e < 0n) return null;
  if (e < 2n) return e;
  let t = 0n,
    r = 1n;
  for (; r ** BigInt(n) <= e; ) r *= 2n;
  for (; t < r; ) {
    let s = (t + r + 1n) / 2n;
    s ** BigInt(n) <= e ? (t = s) : (r = s - 1n);
  }
  return t ** BigInt(n) === e ? t : null;
}
function LB(e, n) {
  if (te(e) <= 0) return null;
  let t = Number(n.n),
    r = Number(n.d);
  if (Math.abs(t) > 24 || r > 12) return null;
  let s = w_(e.n, r),
    i = w_(e.d, r);
  return s === null || i === null ? null : at(C(s, i), t);
}
function Z1(e, n, t) {
  let r = _p(e);
  if (r === null) return null;
  let s = e.co.get(r),
    i = N(C(r), n);
  if (!B(i)) return null;
  let o = LB(s, n);
  if (!o) return null;
  let a = { co: new Map(), e: e.e - r };
  for (let [f, d] of e.co) f !== r && a.co.set(f - r, A(d, s));
  let l = Number(i.n),
    u = Math.min(a.e, t - l),
    c = z1(a, (f) => qB(n, f), u);
  return C_(ev(c, o), l);
}
function M_(e, n) {
  return Np(e, G1, n);
}
function S_(e, n) {
  return Np(e, (t) => (t % 2 ? N(G1(t), C(t % 4 === 1 ? 1 : -1)) : Jo), n);
}
function T_(e, n) {
  return Np(e, (t) => (t % 2 ? Jo : N(G1(t), C(t % 4 === 0 ? 1 : -1))), n);
}
function NB(e, n) {
  return Np(e, (t) => (t % 2 ? C(t % 4 === 1 ? 1 : -1, t) : Jo), n);
}
function OB(e, n) {
  let t = E_(e);
  if (t === null || !M(t, Zi)) return null;
  let r = qp(e, ic(C(-1)));
  return Np(r, (s) => (s === 0 ? Jo : C(s % 2 ? 1 : -1, s)), n);
}
function H1(e, n, t) {
  switch (e) {
    case 'exp':
      return M_(n, t);
    case 'sin':
      return S_(n, t);
    case 'cos':
      return T_(n, t);
    case 'tan': {
      let r = S_(n, t + 2),
        s = T_(n, t + 2);
      if (!r || !s) return null;
      let i = Lp(s, t + 2);
      return i ? Yb(Hi(r, i), t) : null;
    }
    case 'arctan':
      return NB(n, t);
    case 'ln':
      return OB(n, t);
    case 'sqrt':
      return Z1(n, C(1, 2), t);
    default:
      return null;
  }
}
function __(e, n, t) {
  return B(n) ? U1(e, Number(n.n), t) : Z1(e, n, t);
}
function Op(e) {
  return gd(e);
}
function gd(e) {
  if (e.k === 'num') return e.v;
  if (e.k === 'mul') {
    let n = Zi;
    for (let t of e.c) {
      let r = gd(t);
      if (!r) return null;
      n = N(n, r);
    }
    return n;
  }
  if (e.k === 'div') {
    let n = gd(e.a),
      t = gd(e.b);
    return n && t ? A(n, t) : null;
  }
  if (e.k === 'add') {
    let n = Jo;
    for (let t of e.c) {
      let r = gd(t);
      if (!r) return null;
      n = re(n, r);
    }
    return n;
  }
  return null;
}
function es(e, n, t) {
  try {
    return Wo(e, n, t);
  } catch {
    return null;
  }
}
function Wo(e, n, t) {
  switch (e.k) {
    case 'num':
      return ic(e.v);
    case 'sym': {
      if (e.n === n) return CB();
      let r = oc(e.n);
      return r !== null ? EB(r) : null;
    }
    case 'add': {
      let r = ic(Jo);
      for (let s of e.c) {
        let i = Wo(s, n, t);
        if (!i) return null;
        r = qp(r, i);
      }
      return r;
    }
    case 'mul': {
      let r = ic(Zi);
      for (let s of e.c) {
        let i = Wo(s, n, t);
        if (!i) return null;
        r = Hi(r, i);
      }
      return r;
    }
    case 'div': {
      let r = Wo(e.a, n, t),
        s = Wo(e.b, n, t);
      if (!r || !s) return null;
      let i = Lp(s, t + Math.max(0, -Xb(r)));
      return i ? Hi(r, i) : null;
    }
    case 'pow': {
      let r = gd(e.b);
      if (r) {
        let o = Wo(e.a, n, t);
        return o ? (B(r) ? U1(o, Number(r.n), t) : Z1(o, r, t)) : null;
      }
      let s = Wo({ k: 'fn', f: 'ln', a: e.a }, n, t + 4),
        i = Wo(e.b, n, t + 4);
      return !s || !i ? null : M_(Hi(i, s), t);
    }
    case 'fn': {
      let r = Wo(e.a, n, t);
      return r ? H1(e.f, r, t) : null;
    }
    default:
      return null;
  }
}
function Mp(e, n, t) {
  let r = Math.max(t, 0) + 1;
  for (let s = r; s <= r + 12; s += 2) {
    let i = es(e, n, s);
    if (!i) return null;
    if (i.e >= t) return i;
  }
  return null;
}
function W1(e, n, t) {
  let r = new Set([...e.co.keys(), ...n.co.keys()]),
    s = null;
  for (let i of [...r].sort((o, a) => o - a))
    if (!(i > t) && !M(hd(e, i), hd(n, i))) {
      s = i;
      break;
    }
  return s;
}
function bd(e, n) {
  let t = _p(e);
  if (t !== null && t < 0) {
    let r = te(e.co.get(t));
    return t % 2 === 0
      ? { k: 'inf', s: r > 0 ? 1 : -1 }
      : n
        ? { k: 'inf', s: r * n > 0 ? 1 : -1 }
        : null;
  }
  return e.e < 0 ? null : { k: 'fin', v: en(hd(e, 0)) };
}
function J1(e, n, t) {
  let r = (o) => {
      switch (o.k) {
        case 'sym':
          return o.n === n;
        case 'num':
          return !1;
        case 'add':
        case 'mul':
          return o.c.some(r);
        case 'fn':
          return r(o.a);
        default:
          return r(o.a) || r(o.b);
      }
    },
    s = (o) => {
      let a = J1(o, n, t);
      return a
        ? a.k === 'inf'
          ? a.s > 0
            ? { k: 'inf', s: 1 }
            : { k: 'fin', v: 0 }
          : { k: 'fin', v: Math.exp(a.v) }
        : null;
    };
  if (e.k === 'pow' && r(e.b)) {
    let o = { k: 'mul', c: [e.b, { k: 'fn', f: 'ln', a: e.a }] };
    return s(o);
  }
  if (e.k === 'fn' && e.f === 'exp') {
    let o = Mp(e, n, 0);
    return o ? bd(o, t) : s(e.a);
  }
  let i = Mp(e, n, 0);
  return i ? bd(i, t) : null;
}
var nv = /(?<![A-Za-zÀ-ÿ])o\(\s*(1|([a-zA-Z])\s*(?:\^\s*\(?\s*(\d+)\s*\)?|([⁰¹²³⁴⁵⁶⁷⁸⁹]+))?)\s*\)/g,
  q_ = '\u2070\xB9\xB2\xB3\u2074\u2075\u2076\u2077\u2078\u2079';
function L_(e) {
  let n = [];
  return {
    text: e.replace(nv, (r, s, i, o, a) => {
      let l;
      return (
        s === '1'
          ? (l = 0)
          : o
            ? (l = Number(o))
            : a
              ? (l = Number([...a].map((u) => q_.indexOf(u)).join('')))
              : (l = 1),
        n.push(ac(l, i || 'x')),
        ` ${D1(l)} `
      );
    }),
    outs: n,
  };
}
function N_(e, n) {
  let t = 0;
  return e.map((r) => (oc(r) !== null ? (n[t++] ?? r) : r));
}
function O_(e) {
  return e.map((n) => {
    let t = B1(n);
    return t === null ? n : D1(t);
  });
}
function Y1(e) {
  nv.lastIndex = 0;
  let n = nv.test(e);
  return ((nv.lastIndex = 0), n);
}
function uc(e, n) {
  switch (e.k) {
    case 'sym':
      return e.n === n;
    case 'num':
      return !1;
    case 'add':
    case 'mul':
      return e.c.some((t) => uc(t, n));
    case 'fn':
      return uc(e.a, n);
    default:
      return uc(e.a, n) || uc(e.b, n);
  }
}
function Wi(e) {
  switch (e.k) {
    case 'sym': {
      let n = oc(e.n);
      return n === null ? -1 / 0 : n;
    }
    case 'num':
      return -1 / 0;
    case 'add':
    case 'mul':
      return Math.max(-1 / 0, ...e.c.map(Wi));
    case 'fn':
      return Wi(e.a);
    default:
      return Math.max(Wi(e.a), Wi(e.b));
  }
}
function tv(e, n) {
  switch (e.k) {
    case 'num':
      return !0;
    case 'sym':
      return e.n === n;
    case 'add':
    case 'mul':
      return e.c.every((t) => tv(t, n));
    case 'div':
      return tv(e.a, n) && !!rv(e.b, n);
    case 'pow': {
      let t = Op(e.b);
      return !!t && B(t) && te(t) >= 0 && tv(e.a, n);
    }
    default:
      return !1;
  }
}
function rv(e, n) {
  if (fn(e) || e.k === 'fn') return null;
  let t = es(e, n, 24);
  if (!t || t.e !== 1 / 0 || t.co.size !== 1) return null;
  let r = [...t.co][0];
  if (!r) return null;
  let [s, i] = r;
  return { d: s, c: i };
}
var X1 = (e, n) =>
    e.k === 'add' &&
    e.c.length === 2 &&
    e.c.some((t) => t.k === 'sym' && t.n === n) &&
    e.c.some((t) => t.k === 'num' && M(t.v, q)),
  KB = (e, n) => {
    if (e.k !== 'add' || e.c.length !== 2) return !1;
    let t = es(e, n, 4);
    return (
      !!t &&
      t.e === 1 / 0 &&
      t.co.size === 2 &&
      M(t.co.get(0) ?? F, q) &&
      M(t.co.get(1) ?? F, C(-1))
    );
  };
function PB(e, n) {
  let t = (r) => r.k === 'sym' && r.n === n;
  if (e.k === 'fn')
    return ['exp', 'sin', 'cos', 'tan', 'arctan'].includes(e.f)
      ? t(e.a)
      : e.f === 'ln' || e.f === 'sqrt'
        ? X1(e.a, n)
        : !1;
  if (e.k === 'pow') {
    let r = Op(e.b);
    return !!r && !B(r) && X1(e.a, n);
  }
  return e.k === 'div' ? e.a.k === 'num' && M(e.a.v, q) && (X1(e.b, n) || KB(e.b, n)) : !1;
}
function K_(e, n) {
  if (!fn(e)) return !1;
  let t = e.k === 'add' ? e.c : [e],
    r = 0,
    s = new Set();
  for (let i of t) {
    if (i.k === 'sym' && oc(i.n) !== null) {
      r++;
      continue;
    }
    if (fn(i)) return !1;
    let o = rv(i, n);
    if (!o || s.has(o.d)) return !1;
    s.add(o.d);
  }
  return r === 1;
}
function P_(e, n) {
  if (!K_(e, n)) return null;
  let t = e.k === 'add' ? e.c : [e],
    r = Wi(e);
  for (let s of t) {
    if (s.k === 'sym') continue;
    let i = rv(s, n);
    if (i && i.d > r) return { k: r, d: i.d };
  }
  return null;
}
function e0(e, n) {
  try {
    return lc(e, n);
  } catch {
    return null;
  }
}
function lc(e, n) {
  let { x: t, N: r } = n;
  if (e.k === 'sym') {
    let i = oc(e.n);
    if (i !== null) return { ser: { co: new Map(), e: i }, steps: [], dl: !0 };
  }
  let s = fn(e);
  if (!uc(e, t) && !s) {
    let i = es(e, t, r);
    return i ? { ser: i, steps: [], dl: !1 } : null;
  }
  if (s && K_(e, t)) {
    let i = es(e, t, r);
    return i ? { ser: i, steps: [], dl: !0 } : null;
  }
  if (!s && !n.fresh) {
    let i = n.lookup(e);
    if (i) return { ser: i, steps: [], dl: !0 };
  }
  if (!s && tv(e, t)) {
    let i = es(e, t, r);
    return i ? { ser: i, steps: [], dl: !1 } : null;
  }
  if (!s && PB(e, t)) {
    let i = es(e, t, r);
    return i ? { ser: i, steps: ['dlReference'], dl: !0 } : null;
  }
  switch (e.k) {
    case 'add': {
      let i = e.c.map((c) => lc(c, n));
      if (i.some((c) => !c)) return null;
      let o = i,
        a = { co: new Map(), e: 1 / 0 };
      o.forEach((c) => (a = qp(a, c.ser)));
      let l = o.flatMap((c) => c.steps),
        u = o.some((c) => c.dl);
      return (u && o.length >= 2 && l.push('dlSum'), { ser: a, steps: l, dl: u });
    }
    case 'mul': {
      let i = e.c.map((f) => lc(f, n));
      if (i.some((f) => !f)) return null;
      let o = i,
        a = { co: new Map([[0, q]]), e: 1 / 0 };
      o.forEach((f) => (a = Hi(a, f.ser)));
      let l = o.flatMap((f) => f.steps),
        u = e.c.filter((f, d) => o[d].dl).length,
        c = e.c.filter((f, d) => !o[d].dl && uc(f, t)).length;
      return (
        u >= 2 ? l.push('dlProduct') : u === 1 && c >= 1 && l.push('dlScale'),
        { ser: a, steps: l, dl: u > 0 }
      );
    }
    case 'div': {
      let i = lc(e.a, n);
      if (!i) return null;
      let o = !uc(e.b, t) && !fn(e.b) ? Op(e.b) : null;
      if (o) {
        let f = A(q, o);
        return f
          ? { ser: Hi(i.ser, { co: new Map([[0, f]]), e: 1 / 0 }), steps: i.steps, dl: i.dl }
          : null;
      }
      let a = lc(e.b, n);
      if (!a) return null;
      let l = Lp(a.ser, r + Math.max(0, -(IB(i.ser) ?? 0)));
      if (!l) return null;
      let u = Hi(i.ser, l),
        c = [...i.steps];
      return !i.dl && !a.dl
        ? { ser: u, steps: c, dl: !1 }
        : (!a.dl && rv(e.b, t) ? c.push('dlDivide') : c.push(...a.steps, 'dlQuotient'),
          { ser: u, steps: c, dl: !0 });
    }
    case 'pow': {
      let i = Op(e.b);
      if (!i) return null;
      let o = lc(e.a, n);
      if (!o) return null;
      let a = __(o.ser, i, r);
      if (!a) return null;
      let l = [...o.steps];
      if (B(i)) {
        let u = Number(i.n);
        return (
          u >= 2 && o.dl && l.push('dlProduct'),
          u < 0 && o.dl && l.push('dlQuotient'),
          { ser: a, steps: l, dl: o.dl }
        );
      }
      return (l.push('dlCompose'), { ser: a, steps: l, dl: !0 });
    }
    case 'fn': {
      let i = lc(e.a, n);
      if (!i) return null;
      let o = H1(e.f, i.ser, r);
      return o ? { ser: o, steps: [...i.steps, 'dlCompose'], dl: !0 } : null;
    }
    default:
      return null;
  }
}
function IB(e) {
  let n = null;
  for (let [t, r] of e.co) !L(r) && (n === null || t < n) && (n = t);
  return n;
}
function I_(e, n) {
  let t = [...n],
    r = [];
  for (let s of e) {
    let i = t.indexOf(s);
    i >= 0 ? t.splice(i, 1) : r.push(s);
  }
  return r;
}
function sv(e, n = 'x') {
  if (e === 0) return 'le terme constant';
  let t = (r) => String(r).replace(/\d/g, (s) => q_[Number(s)]);
  return e === 1
    ? `le terme en ${n}`
    : e > 1
      ? `le terme en ${n}${t(e)}`
      : e === -1
        ? `le terme en 1 \xF7 ${n}`
        : `le terme en 1 \xF7 ${n}${t(-e)}`;
}
var Xo = class extends Error {
    constructor(t) {
      super(`d\xE9rivation non prise en charge : ${t}`);
      this.what = t;
    }
    what;
  },
  tt = (e, n) => $(e).has(n),
  bl = !1,
  AB = new Set(['arctan', 'arcsin', 'arccos']);
function kd(e) {
  let n = bl;
  bl = !0;
  try {
    return Nf(e);
  } finally {
    bl = n;
  }
}
var cc = () => bl,
  j_ = /\barc(?:tan|sin|cos)\s*\(/,
  Q_ = (e) => bl && AB.has(e),
  Kp = T(0),
  Ms = T(1),
  F_ = (e) => e.k === 'num' && L(e.v);
function wn(e, n) {
  return R(sr(e, n));
}
function sr(e, n) {
  if (!tt(e, n)) return Kp;
  switch (e.k) {
    case 'num':
      return Kp;
    case 'sym':
      return e.n === n ? Ms : Kp;
    case 'add':
      return he(...e.c.map((t) => sr(t, n)));
    case 'mul': {
      let t = [];
      return (
        e.c.forEach((r, s) => {
          tt(r, n) && t.push(I(...e.c.map((i, o) => (o === s ? sr(r, n) : i))));
        }),
        he(...t)
      );
    }
    case 'div': {
      let { a: t, b: r } = e;
      return tt(r, n)
        ? tt(t, n)
          ? ye(he(I(sr(t, n), r), I(T(-1), t, sr(r, n))), et(r, T(2)))
          : ye(I(T(-1), t, sr(r, n)), et(r, T(2)))
        : ye(sr(t, n), r);
    }
    case 'pow': {
      let { a: t, b: r } = e;
      return tt(r, n)
        ? tt(t, n)
          ? I(e, he(I(sr(r, n), be('ln', t)), ye(I(r, sr(t, n)), t)))
          : I(be('ln', t), e, sr(r, n))
        : I(r, et(t, he(r, T(-1))), sr(t, n));
    }
    case 'fn':
      return I(sr(e.a, n), n0(e.f, e.a));
    case 'binom':
      throw new Xo('k parmi n');
  }
}
function n0(e, n) {
  switch (e) {
    case 'sqrt':
      return ye(Ms, I(T(2), be('sqrt', n)));
    case 'exp':
      return be('exp', n);
    case 'ln':
      return ye(Ms, n);
    case 'cos':
      return I(T(-1), be('sin', n));
    case 'sin':
      return be('cos', n);
    case 'tan':
      return ye(Ms, et(be('cos', n), T(2)));
    case 'abs':
      return ye(n, be('abs', n));
    case 'arctan':
      if (!bl) throw new Xo(e);
      return ye(Ms, he(Ms, et(n, T(2))));
    case 'arcsin':
      if (!bl) throw new Xo(e);
      return ye(Ms, be('sqrt', he(Ms, I(T(-1), et(n, T(2))))));
    case 'arccos':
      if (!bl) throw new Xo(e);
      return ye(T(-1), be('sqrt', he(Ms, I(T(-1), et(n, T(2))))));
    default:
      throw new Xo(e);
  }
}
function vd(e, n) {
  if (!tt(e, n)) return !1;
  try {
    return !tt(wn(e, n), n);
  } catch {
    return !1;
  }
}
function kl(e) {
  let n = R(e);
  return F_(n) ? [] : n.k === 'add' ? n.c : [n];
}
function vl(e, n) {
  let t = R(e),
    r = t.k === 'mul' ? t.c : [t],
    s = [],
    i = [];
  for (let o of r)
    tt(o, n)
      ? o.k === 'div' && !tt(o.b, n)
        ? (s.push(ye(Ms, o.b)), i.push(o.a))
        : i.push(o)
      : s.push(o);
  return { c: s, core: i };
}
function t0(e, n) {
  try {
    let t = iv(R(e), n);
    return t === null ? null : R(t);
  } catch {
    return null;
  }
}
function iv(e, n) {
  if (!tt(e, n)) return Kp;
  switch (e.k) {
    case 'sym':
      return e.n === n ? Ms : Kp;
    case 'add': {
      let t = e.c.map((r) => iv(r, n));
      return t.every((r) => r !== null) ? he(...t) : null;
    }
    case 'mul': {
      let { c: t, core: r } = vl(e, n);
      if (r.length !== 1) return null;
      let s = iv(r[0], n);
      return s === null ? null : I(...t, s);
    }
    case 'div': {
      if (!tt(e.b, n)) {
        let i = iv(e.a, n);
        return i === null ? null : ye(i, e.b);
      }
      if (tt(e.a, n)) return null;
      let { c: t, core: r } = vl(e.b, n);
      if (r.length !== 1) return null;
      let s = jB(r[0], n);
      return s ? I(ye(e.a, t.length ? I(...t) : Ms), sr(et(s.b, T(fe(s.n))), n)) : null;
    }
    case 'pow':
      return tt(e.b, n)
        ? tt(e.a, n)
          ? null
          : vd(e.b, n)
            ? sr(e, n)
            : null
        : vd(e.a, n) || (e.a.k === 'sym' && e.a.n === n)
          ? sr(e, n)
          : null;
    case 'fn':
      return !['sqrt', 'exp', 'ln', 'cos', 'sin', 'tan'].includes(e.f) && !Q_(e.f)
        ? null
        : vd(e.a, n)
          ? sr(e, n)
          : null;
    default:
      return null;
  }
}
function jB(e, n) {
  return vd(e, n)
    ? { b: e, n: q }
    : e.k === 'pow' && e.b.k === 'num' && vd(e.a, n)
      ? { b: e.a, n: e.b.v }
      : e.k === 'fn' && e.f === 'sqrt' && vd(e.a, n)
        ? { b: e.a, n: C(1, 2) }
        : null;
}
function Ji(e, n, t, r) {
  let s = t0(e, n);
  if (s) return s;
  let i = t(e);
  return i || (r.push(e), wn(e, n));
}
function Pp(e, n, t) {
  try {
    let r = kl(e),
      s = { pieces: [], rules: [], nested: [] };
    if (r.length === 1) {
      let i = FB(r[0], n, t);
      if (i) return i;
    }
    for (let i of r) {
      let o = QB(i, n, t, s.nested);
      if (!o) return null;
      (s.pieces.push(...o.pieces.filter((a) => !F_(R(a)))),
        s.rules.includes(o.rule) || s.rules.push(o.rule));
    }
    return (s.rules.length > 1 && (s.rules = s.rules.filter((i) => i !== 'usual')), s);
  } catch {
    return null;
  }
}
function QB(e, n, t, r) {
  let s = t0(e, n);
  if (s) return { pieces: [s], rule: 'usual' };
  let { c: i, core: o } = vl(e, n);
  if (o.length >= 2) {
    let l = o.map((u) => Ji(u, n, t, r));
    return {
      pieces: o.map((u, c) => I(...i, ...o.map((f, d) => (c === d ? l[c] : f)))),
      rule: 'product',
    };
  }
  let a = o[0];
  if (!a) return { pieces: [], rule: 'usual' };
  if (a.k === 'div') {
    if (!tt(a.a, n)) {
      let c = Ji(a.b, n, t, r);
      return { pieces: [ye(I(T(-1), ...i, a.a, c), et(a.b, T(2)))], rule: 'inverse' };
    }
    let l = Ji(a.a, n, t, r),
      u = Ji(a.b, n, t, r);
    return {
      pieces: [ye(I(...i, he(I(l, a.b), I(T(-1), a.a, u))), et(a.b, T(2)))],
      rule: 'quotient',
    };
  }
  if (a.k === 'pow' && !tt(a.b, n)) {
    let l = Ji(a.a, n, t, r);
    return { pieces: [I(...i, a.b, l, et(a.a, he(a.b, T(-1))))], rule: 'chain_pow' };
  }
  if (a.k === 'pow' && !tt(a.a, n)) {
    let l = Ji(a.b, n, t, r);
    return { pieces: [I(...i, be('ln', a.a), l, a)], rule: 'chain_exp' };
  }
  if (a.k === 'fn' && ['sqrt', 'exp', 'ln', 'cos', 'sin', 'tan'].includes(a.f)) {
    let l = Ji(a.a, n, t, r),
      u =
        a.f === 'exp'
          ? 'chain_exp'
          : a.f === 'ln'
            ? 'chain_ln'
            : a.f === 'sqrt'
              ? 'chain_sqrt'
              : 'chain_trig';
    return { pieces: [I(...i, l, n0(a.f, a.a))], rule: u };
  }
  if (a.k === 'fn' && Q_(a.f)) {
    let l = Ji(a.a, n, t, r);
    return { pieces: [I(...i, l, n0(a.f, a.a))], rule: 'chain_arc' };
  }
  return null;
}
function FB(e, n, t) {
  let { c: r, core: s } = vl(e, n);
  if (s.length !== 1) return null;
  let i = s[0];
  if (i.k !== 'div' || !tt(i.a, n) || !tt(i.b, n) || t0(e, n)) return null;
  let o = [],
    a = Ji(i.a, n, t, o),
    l = Ji(i.b, n, t, o);
  return {
    pieces: [I(...r, a, i.b), I(T(-1), ...r, i.a, l)],
    den: et(i.b, T(2)),
    rules: ['quotient'],
    nested: o,
  };
}
function V_(e, n) {
  let t = [],
    r = new Set(),
    s = (o) => {
      let a = R(o);
      if (!tt(a, n)) return;
      let l = E(a);
      r.has(l) || (r.add(l), t.push(a), i(a));
    },
    i = (o) => {
      switch (o.k) {
        case 'add':
          o.c.forEach(s);
          break;
        case 'mul': {
          let a = o.c.filter((u) => tt(u, n));
          if ((a.forEach(s), a.length > 2 && a.length <= 4))
            for (let u = 1; u < (1 << a.length) - 1; u++) {
              let c = a.filter((f, d) => u & (1 << d));
              c.length >= 2 && s(I(...c));
            }
          let l = o.c.filter((u) => !tt(u, n));
          l.length && a.forEach((u) => s(I(...l, u)));
          break;
        }
        case 'div':
          (s(o.a), s(o.b));
          break;
        case 'pow':
          (s(o.a), s(o.b));
          break;
        case 'fn':
          s(o.a);
          break;
        default:
          break;
      }
    };
  return (i(R(e)), t);
}
var D_ = [
    -3.71, -2.29, -1.63, -0.87, -0.61, -0.33, -0.13, 0.17, 0.39, 0.73, 0.91, 1.21, 1.47, 1.93, 2.57,
    3.37, 4.39, 5.83, 7.19,
  ],
  r0 = 5;
function nn(e, n) {
  return !Number.isFinite(e) || !Number.isFinite(n)
    ? !1
    : Math.abs(e - n) <= 1e-9 * Math.max(1, Math.abs(e), Math.abs(n));
}
function ov(e, n, t, r = {}) {
  return t.map((s) => {
    try {
      let i = D(e, { ...r, [n]: s });
      return Number.isFinite(i) ? i : NaN;
    } catch {
      return NaN;
    }
  });
}
function B_(e, n) {
  return e.length !== n.length || e.length < r0 ? !1 : e.every((t, r) => nn(t, n[r]));
}
function A_(e) {
  return e.every((n) => nn(n, 0));
}
function xd(e, n) {
  let t = null;
  for (let r = 0; r < e.length; r++) {
    if (!Number.isFinite(e[r]) || !Number.isFinite(n[r])) return null;
    if (Math.abs(n[r]) < 1e-12) {
      if (Math.abs(e[r]) > 1e-9) return null;
      continue;
    }
    let s = e[r] / n[r];
    if (t === null) t = s;
    else if (!nn(s, t)) return null;
  }
  return t;
}
function s0(e, n) {
  let t = null;
  for (let r = 0; r < e.length; r++) {
    if (!Number.isFinite(e[r]) || !Number.isFinite(n[r])) return null;
    let s = e[r] - n[r];
    if (t === null) t = s;
    else if (!nn(s + 1, t + 1)) return null;
  }
  return t;
}
function Yo(e, n) {
  let t = e.length,
    r = n.length;
  if (t === 0) return n.every(A_);
  if (r === 0) return e.every(A_);
  if (t > 10 || r > 5) return !1;
  let s = e[0].length,
    i = n.map(() => new Array(s).fill(0)),
    o = (a) => {
      if (a === t) return i.every((l, u) => l.every((c, f) => nn(c, n[u][f])));
      for (let l = 0; l < r; l++) {
        for (let u = 0; u < s; u++) i[l][u] += e[a][u];
        if (o(a + 1)) return !0;
        for (let u = 0; u < s; u++) i[l][u] -= e[a][u];
      }
      return !1;
    };
  return o(0);
}
function ns(e) {
  let n = e;
  switch (n.k) {
    case 'num':
    case 'sym':
      return 1;
    case 'add':
    case 'mul':
      return 1 + n.c.reduce((t, r) => t + ns(r), 0);
    case 'div':
    case 'pow':
    case 'binom':
      return 1 + ns(n.a) + ns(n.b);
    case 'fn':
      return 1 + ns(n.a);
  }
}
var se = (e, n = 0) => ({ k: 'fin', v: e, side: n }),
  Sn = (e) => ({ k: 'inf', s: e }),
  He = { k: 'unknown' },
  mc = (e) => ({ k: 'fi', form: e }),
  _s = (e) => e.k === 'fin' || e.k === 'inf',
  Xi = (e) => e.k === 'fin' && Math.abs(e.v) < 1e-12;
function yl(e, n) {
  return !Number.isFinite(e) || !Number.isFinite(n)
    ? !1
    : Math.abs(e - n) <= 1e-9 * Math.max(1, Math.abs(e), Math.abs(n));
}
var ir = (e) => (Math.abs(e) < 1e-12 ? 0 : e > 0 ? 1 : -1),
  yd = class extends Error {},
  VB = /^([+−]∞|−?\d+(,\d+)?[⁺⁻]?)$/;
function cv(e, n, t) {
  let r = e.trim().replace(/^-/, '\u2212');
  if (!VB.test(r)) throw new yd(`point illisible : \xAB ${e} \xBB`);
  if (r === '+\u221E') return { x: n, inf: 1, a: 0, side: 0, seq: t };
  if (r === '\u2212\u221E') {
    if (t) throw new yd('une suite tend vers +\u221E seulement');
    return { x: n, inf: -1, a: 0, side: 0, seq: t };
  }
  if (t) throw new yd('une suite se regarde en +\u221E');
  let s = r.endsWith('\u207A') ? 1 : r.endsWith('\u207B') ? -1 : 0,
    i = s ? r.slice(0, -1) : r,
    o = Number(i.replace('\u2212', '-').replace(',', '.'));
  if (!Number.isFinite(o)) throw new yd(`point illisible : \xAB ${e} \xBB`);
  return { x: n, inf: 0, a: o, side: s, seq: t };
}
function u0(e) {
  switch (e.k) {
    case 'inf':
      return e.s > 0 ? '+\u221E' : '\u2212\u221E';
    case 'fin': {
      let n = DB(e.v);
      return e.side && Math.abs(e.v) < 1e-12 ? `0${e.side > 0 ? '\u207A' : '\u207B'}` : n;
    }
    case 'bnd':
      return 'born\xE9e';
    case 'none':
      return 'pas de limite';
  }
}
function DB(e) {
  return Number.isInteger(e)
    ? String(e).replace('-', '\u2212')
    : String(Math.round(e * 1e6) / 1e6)
        .replace('-', '\u2212')
        .replace('.', ',');
}
function gi(e, n) {
  return e.k === 'inf'
    ? n.k === 'inf' && n.s === e.s
    : e.k === 'fin'
      ? n.k !== 'fin' || !yl(e.v, n.v) || (e.side && n.side && e.side !== n.side)
        ? !1
        : !e.side || n.side === e.side
      : e.k === n.k;
}
function Z_(e, n) {
  let t = e.map((r, s) => ({ a: r, i: s })).filter(({ a: r }) => !r.c);
  return t.length !== 1 ? 0 : n(t[0].i);
}
function fv(e, n = {}) {
  if (e.some((o) => o.r.k === 'unknown' || o.r.k === 'fi' || o.r.k === 'none')) {
    let o = e.find((a) => a.r.k === 'fi');
    return o ? o.r : He;
  }
  let t = e.filter((o) => o.r.k === 'inf').map((o) => o.r.s),
    r = e.filter((o) => o.r.k === 'bnd').length;
  if (t.includes(1) && t.includes(-1)) return mc('\u221E \u2212 \u221E');
  if (t.length) return r && !n.bnd ? He : Sn(t[0]);
  if (r) return n.bnd ? { k: 'bnd' } : He;
  let s = e.reduce((o, a) => o + a.r.v, 0),
    i = Z_(e, (o) => e[o].r.side);
  return se(s, i);
}
function Qp(e, n = {}) {
  if (e.some((l) => l.r.k === 'unknown' || l.r.k === 'none' || l.r.k === 'fi')) {
    let l = e.find((u) => u.r.k === 'fi');
    return l ? l.r : He;
  }
  let t = e.filter((l) => Xi(l.r)),
    r = e.filter((l) => l.r.k === 'inf'),
    s = e.filter((l) => l.r.k === 'bnd');
  if (t.length && r.length) return mc('0 \xD7 \u221E');
  if (s.length) return n.bnd ? (t.length ? se(0, 0) : r.length ? He : { k: 'bnd' }) : He;
  let i = 1;
  for (let l of e) l.r.k === 'inf' ? (i *= l.r.s) : l.r.k === 'fin' && !Xi(l.r) && (i *= ir(l.r.v));
  if (r.length) return Sn(i > 0 ? 1 : -1);
  let o = e.reduce((l, u) => l * u.r.v, 1);
  if (t.length) {
    let l = i;
    for (let u of t) {
      let c = u.r.side;
      if (!c) return se(0, 0);
      l *= c;
    }
    return se(0, l > 0 ? 1 : -1);
  }
  let a = Z_(e, (l) => {
    let u = e[l].r,
      c = o / u.v;
    return u.side * ir(c);
  });
  return se(o, a);
}
function dv(e, n, t = {}) {
  if (e.r.k === 'fi') return e.r;
  if (n.r.k === 'fi') return n.r;
  if (e.r.k === 'unknown' || n.r.k === 'unknown' || e.r.k === 'none' || n.r.k === 'none') return He;
  if (e.r.k === 'bnd')
    return t.bnd
      ? n.r.k === 'inf'
        ? se(0, 0)
        : n.r.k === 'fin' && !Xi(n.r)
          ? { k: 'bnd' }
          : He
      : He;
  if (n.r.k === 'bnd') return He;
  if (e.r.k === 'inf' && n.r.k === 'inf') return mc('\u221E \xF7 \u221E');
  if (Xi(e.r) && Xi(n.r)) return mc('0 \xF7 0');
  if (n.r.k === 'inf') return e.r.k !== 'fin' ? He : Xi(e.r) ? se(0, 0) : se(0, ir(e.r.v) * n.r.s);
  if (Xi(n.r)) {
    let o = e.r.k === 'inf' ? e.r.s : ir(e.r.v),
      a = n.r.side;
    return a ? Sn(o * a > 0 ? 1 : -1) : { k: 'none' };
  }
  let r = n.r.v;
  if (e.r.k === 'inf') return Sn(e.r.s * ir(r) > 0 ? 1 : -1);
  let s = e.r.v,
    i = 0;
  return (n.c ? (i = e.r.side * ir(r)) : e.c && (i = -n.r.side * ir(s)), se(s / r, i));
}
function BB(e) {
  return Number.isInteger(e) ? e : null;
}
function Sd(e, n, t = {}) {
  if (e.r.k === 'fi') return e.r;
  if (n.r.k === 'fi') return n.r;
  if (e.r.k === 'unknown' || n.r.k === 'unknown') return He;
  if (n.c && n.r.k === 'fin') {
    let r = n.r.v,
      s = BB(r);
    if (r === 0) return se(1, 0);
    if (e.r.k === 'bnd') return t.bnd && r > 0 ? { k: 'bnd' } : He;
    if (e.r.k === 'none') return He;
    if (e.r.k === 'inf') {
      if (s === null && e.r.s < 0) return He;
      let u = s !== null && s % 2 !== 0 ? e.r.s : 1;
      return r > 0 ? Sn(u) : se(0, u);
    }
    let i = e.r.v,
      o = e.r.side;
    if (Math.abs(i) < 1e-12) {
      if (s === null && o < 0) return He;
      let c = s !== null && s % 2 === 0 ? 1 : o;
      return r > 0 ? se(0, c) : c ? Sn(c) : { k: 'none' };
    }
    if (s === null && i < 0) return He;
    let a = i ** r,
      l = ir(r * Math.sign(i) ** (s !== null ? s - 1 : 0));
    return se(a, e.c ? 0 : o * l);
  }
  if (e.c && e.r.k === 'fin') {
    let r = e.r.v;
    return n.r.k === 'inf'
      ? r > 0
        ? yl(r, 1)
          ? se(1, 0)
          : (r > 1 ? 1 : -1) * n.r.s > 0
            ? Sn(1)
            : se(0, 1)
        : !t.seq || n.r.s < 0
          ? He
          : r > -1
            ? se(0, 0)
            : yl(r, -1)
              ? t.bnd
                ? { k: 'bnd' }
                : He
              : { k: 'none' }
      : n.r.k === 'fin'
        ? r <= 0
          ? He
          : se(r ** n.r.v, 0)
        : He;
  }
  return e.r.k === 'fin' && n.r.k === 'inf' && yl(e.r.v, 1)
    ? mc('1^\u221E')
    : Xi(e.r) && Xi(n.r)
      ? mc('0\u2070')
      : e.r.k === 'inf' && Xi(n.r)
        ? mc('\u221E\u2070')
        : e.r.k === 'fin' && e.r.v > 0 && n.r.k === 'fin'
          ? se(e.r.v ** n.r.v, 0)
          : e.r.k === 'fin' && e.r.v > 0 && n.r.k === 'inf'
            ? (e.r.v > 1 ? 1 : -1) * n.r.s > 0
              ? Sn(1)
              : se(0, 1)
            : e.r.k === 'inf' && e.r.s > 0 && n.r.k === 'fin'
              ? n.r.v > 0
                ? Sn(1)
                : se(0, 1)
              : e.r.k === 'inf' && e.r.s > 0 && n.r.k === 'inf'
                ? n.r.s > 0
                  ? Sn(1)
                  : se(0, 1)
                : He;
}
function Td(e, n, t = {}) {
  let r = n.r;
  if (r.k === 'fi') return r;
  if (r.k === 'none' && !t.v54 && t.bnd && ['sin', 'cos', 'arctan'].includes(e))
    return { k: 'bnd' };
  if (r.k === 'unknown' || r.k === 'none') return He;
  switch (e) {
    case 'exp':
      return r.k === 'inf'
        ? r.s > 0
          ? Sn(1)
          : se(0, 1)
        : r.k === 'bnd'
          ? t.bnd
            ? { k: 'bnd' }
            : He
          : se(Math.exp(r.v), n.c ? 0 : r.side);
    case 'ln':
      return r.k === 'inf'
        ? r.s > 0
          ? Sn(1)
          : He
        : r.k === 'bnd'
          ? He
          : r.v > 1e-12
            ? se(Math.log(r.v), n.c ? 0 : r.side)
            : Math.abs(r.v) < 1e-12 && r.side > 0
              ? Sn(-1)
              : He;
    case 'sqrt':
      return r.k === 'inf'
        ? r.s > 0
          ? Sn(1)
          : He
        : r.k === 'bnd'
          ? He
          : r.v > 1e-12
            ? se(Math.sqrt(r.v), n.c ? 0 : r.side)
            : Math.abs(r.v) < 1e-12 && r.side >= 0
              ? se(0, 1)
              : He;
    case 'abs':
      return r.k === 'inf'
        ? Sn(1)
        : r.k === 'bnd'
          ? t.bnd
            ? { k: 'bnd' }
            : He
          : se(Math.abs(r.v), Math.abs(r.v) < 1e-12 ? 1 : n.c ? 0 : r.side * ir(r.v));
    case 'cos':
    case 'sin':
      return r.k === 'inf' || r.k === 'bnd'
        ? t.bnd
          ? { k: 'bnd' }
          : He
        : se(e === 'cos' ? Math.cos(r.v) : Math.sin(r.v), 0);
    case 'arctan':
      return t.v54
        ? He
        : r.k === 'inf'
          ? se((r.s * Math.PI) / 2, -r.s)
          : r.k === 'bnd'
            ? t.bnd
              ? { k: 'bnd' }
              : He
            : se(Math.atan(r.v), n.c ? 0 : r.side);
    default:
      return He;
  }
}
var Oe = (e, n) => $(e).has(n);
function Lr(e) {
  try {
    return D(wd(e), {});
  } catch {
    return NaN;
  }
}
var H_ = new Set(['arctan', 'arcsin', 'arccos']);
function dc(e) {
  switch (e.k) {
    case 'num':
    case 'sym':
      return !1;
    case 'add':
    case 'mul':
      return e.c.some(dc);
    case 'fn':
      return H_.has(e.f) || dc(e.a);
    default:
      return dc(e.a) || dc(e.b);
  }
}
var zB = { k: 'div', a: { k: 'sym', n: '\u03C0' }, b: T(180) };
function wd(e) {
  if (!dc(e) || _$()) return e;
  switch (e.k) {
    case 'num':
    case 'sym':
      return e;
    case 'add':
    case 'mul':
      return { ...e, c: e.c.map(wd) };
    case 'fn': {
      let n = wd(e.a);
      return H_.has(e.f) ? { k: 'mul', c: [zB, { ...e, a: n }] } : { ...e, a: n };
    }
    default:
      return { ...e, a: wd(e.a), b: wd(e.b) };
  }
}
function o0(e) {
  return e.inf ? Sn(e.inf) : se(e.a, e.side);
}
function mv(e, n) {
  let t = n.x,
    r = (f) => f.k === 'sym' && f.n === t,
    s = (f) =>
      f.k === 'mul' &&
      f.c.length === 2 &&
      f.c.some((d) => d.k === 'num' && M(d.v, C(-1))) &&
      f.c.some(r),
    i = (f) =>
      r(f)
        ? 1
        : f.k === 'pow' && r(f.a) && f.b.k === 'num' && te(f.b.v) > 0
          ? en(f.b.v)
          : f.k === 'fn' && f.f === 'sqrt' && r(f.a)
            ? 0.5
            : null,
    o = (f) => (f.k === 'div' && f.a.k === 'num' && M(f.a.v, q) ? i(f.b) : null),
    a = (f) => (f.k === 'unknown' || f.k === 'fi' ? null : f),
    l = { r: o0(n), c: !1 },
    u = i(e);
  if (u !== null) return a(Sd(l, { r: se(u), c: !0 }));
  let c = o(e);
  if (c !== null) return a(dv({ r: se(1), c: !0 }, { r: Sd(l, { r: se(c), c: !0 }), c: !1 }));
  if (e.k === 'fn' && e.f === 'exp' && (r(e.a) || s(e.a)))
    return a(Td('exp', { r: r(e.a) ? o0(n) : Qp([{ r: se(-1), c: !0 }, l]), c: !1 }));
  if (e.k === 'fn' && e.f === 'ln' && r(e.a)) return a(Td('ln', l));
  if (e.k === 'fn' && e.f === 'arctan' && r(e.a) && n.inf && !n.v54) return a(Td('arctan', l));
  if (e.k === 'pow' && !Oe(e.a, t) && r(e.b) && n.inf) {
    let f = Lr(e.a);
    if (Number.isFinite(f)) return a(Sd({ r: se(f), c: !0 }, l, { seq: n.seq }));
  }
  return null;
}
function pv(e, n) {
  if (n.inf) return null;
  let t = { [n.x]: n.a },
    r = (i) => {
      switch (i.k) {
        case 'num':
        case 'sym':
          return !0;
        case 'add':
        case 'mul':
          return i.c.every(r);
        case 'div': {
          if (!r(i.a) || !r(i.b)) return !1;
          let o = qr(i.b, t);
          return Number.isFinite(o) && Math.abs(o) > 1e-12;
        }
        case 'pow': {
          if (!r(i.a) || !r(i.b)) return !1;
          let o = qr(i.a, t),
            a = qr(i.b, t);
          return !Number.isFinite(o) || !Number.isFinite(a)
            ? !1
            : Math.abs(o) < 1e-12
              ? a > 0 && Number.isInteger(a)
              : o > 0 || Number.isInteger(a);
        }
        case 'fn': {
          if (!r(i.a)) return !1;
          let o = qr(i.a, t);
          return Number.isFinite(o)
            ? i.f === 'ln' || i.f === 'log' || i.f === 'sqrt'
              ? o > 1e-12
              : i.f === 'arctan'
                ? !n.v54
                : ['exp', 'cos', 'sin', 'abs'].includes(i.f)
            : !1;
        }
        default:
          return !1;
      }
    };
  if (!r(e)) return null;
  let s = qr(e, t);
  return Number.isFinite(s) ? s : null;
}
function c0(e) {
  try {
    return Ge(e);
  } catch {
    return null;
  }
}
function W_(e) {
  let n = nr(String(Math.abs(e)).replace('.', ','));
  return n ? (e < 0 ? fe(n) : n) : null;
}
function qr(e, n) {
  try {
    return D(wd(e), n);
  } catch {
    return NaN;
  }
}
var pi = { c: 1, a: 0, b: 0, l: 0 },
  lv = (e, n) => ({ c: e.c * n.c, a: e.a + n.a, b: e.b + n.b, l: e.l + n.l });
function Rd(e, n) {
  return e.c < 0 && !Number.isInteger(n)
    ? null
    : { c: e.c ** n, a: e.a * n, b: e.b * n, l: e.l * n };
}
function Ap(e, n) {
  if (!Oe(e, n)) {
    let t = Lr(e);
    return Number.isFinite(t) ? { al: 0, be: t } : null;
  }
  try {
    let t = Ge(e),
      r = J_(t.d);
    if (r === null) return null;
    let s = uv(t.n, n);
    return !s || [...s.keys()].some((i) => i > 1)
      ? null
      : { al: en(s.get(1) ?? F) / r, be: en(s.get(0) ?? F) / r };
  } catch {
    return null;
  }
}
function J_(e) {
  if ([...e.t.values()].some((t) => t.m.length)) return null;
  let n = e.t.get('');
  return n ? en(n.c) : null;
}
function uv(e, n) {
  let t = new Map();
  for (let { m: r, c: s } of e.t.values()) {
    if (r.length > 1 || (r.length === 1 && r[0].a.symbol !== n)) return null;
    let i = r.length ? r[0].e : 0;
    t.set(i, re(t.get(i) ?? F, s));
  }
  return t;
}
function fc(e, n) {
  switch (e.k) {
    case 'num': {
      let t = en(e.v);
      return t ? { ...pi, c: t } : null;
    }
    case 'sym': {
      if (e.n === n) return { ...pi, a: 1 };
      let t = Lr(e);
      return Number.isFinite(t) && t ? { ...pi, c: t } : null;
    }
    case 'mul': {
      let t = pi;
      for (let r of e.c) {
        let s = fc(r, n);
        if (!s) return null;
        t = lv(t, s);
      }
      return t;
    }
    case 'div': {
      let t = fc(e.a, n),
        r = fc(e.b, n);
      if (!t || !r) return null;
      let s = Rd(r, -1);
      return s ? lv(t, s) : null;
    }
    case 'pow': {
      if (!Oe(e.b, n)) {
        let s = Lr(e.b),
          i = fc(e.a, n);
        return i && Number.isFinite(s) ? Rd(i, s) : null;
      }
      if (Oe(e.a, n)) return null;
      let t = Lr(e.a),
        r = Ap(e.b, n);
      return !(t > 0) || !r ? null : { ...pi, c: t ** r.be, b: r.al * Math.log(t) };
    }
    case 'fn': {
      if (e.f === 'exp') {
        let t = Ap(e.a, n);
        return t ? { ...pi, c: Math.exp(t.be), b: t.al } : null;
      }
      if (e.f === 'ln') return e.a.k === 'sym' && e.a.n === n ? { ...pi, l: 1 } : null;
      if (e.f === 'sqrt') {
        let t = fc(e.a, n);
        return t ? Rd(t, 0.5) : null;
      }
      return null;
    }
    default:
      return null;
  }
}
function X_(e, n) {
  if (n === 1) {
    let s = ir(e.c);
    return Math.abs(e.b) > 1e-12
      ? e.b > 0
        ? Sn(s)
        : se(0, s)
      : Math.abs(e.a) > 1e-12
        ? e.a > 0
          ? Sn(s)
          : se(0, s)
        : Math.abs(e.l) > 1e-12
          ? e.l > 0
            ? Sn(s)
            : se(0, s)
          : se(e.c, 0);
  }
  if (!Number.isInteger(e.l)) return null;
  let r = ir(e.c) * (e.l % 2 !== 0 ? -1 : 1);
  return Math.abs(e.a) > 1e-12
    ? e.a > 0
      ? se(0, r)
      : Sn(r)
    : Math.abs(e.l) > 1e-12
      ? e.l > 0
        ? Sn(r)
        : se(0, r)
      : se(e.c, 0);
}
function UB(e, n) {
  let r = [];
  return (
    n === 1
      ? (Math.abs(e.b) > 1e-12 && r.push(Math.sign(e.b)),
        Math.abs(e.a) > 1e-12 && r.push(Math.sign(e.a)),
        Math.abs(e.l) > 1e-12 && r.push(Math.sign(e.l)))
      : (Math.abs(e.a) > 1e-12 && r.push(-Math.sign(e.a)),
        Math.abs(e.l) > 1e-12 && r.push(Math.sign(e.l))),
    r.includes(1) && r.includes(-1)
  );
}
function GB(e, n) {
  let t = Y_(e, n);
  if (!t) return null;
  let r = fc(t.t, n.x);
  return r ? { g: r, at: t.at } : null;
}
function Y_(e, n) {
  let t = rn(n.x);
  if (n.inf === 1) return { t: e, at: 1 };
  if (n.inf === -1) return { t: j(e, { [n.x]: { k: 'mul', c: [T(-1), t] } }), at: 1 };
  if (!n.side) return null;
  if (n.a === 0 && n.side > 0) return { t: e, at: 0 };
  let r = W_(n.a);
  if (!r) return null;
  let s =
    n.side > 0 ? { k: 'add', c: [T(r), t] } : { k: 'add', c: [T(r), { k: 'mul', c: [T(-1), t] }] };
  return { t: j(e, { [n.x]: n.a === 0 ? { k: 'mul', c: [T(-1), t] } : s }), at: 0 };
}
function ZB(e, n) {
  if (n.inf || e.k !== 'div') return null;
  let t = n.x,
    r = e.b;
  if (!(Ap(r, t) && yl(Ap(r, t).al, 1) && yl(Ap(r, t).be, -n.a))) return null;
  let i = e.a,
    o = c0(i);
  if (o && uv(o.n, t) && J_(o.d) !== null) return null;
  let a = qr(i, { [t]: n.a });
  if (!Number.isFinite(a) || Math.abs(a) > 1e-9 || pv(i, n) === null) return null;
  let l;
  try {
    l = wn(i, t);
  } catch {
    return n.v54 ? null : HB(i, t, n.a);
  }
  let u = qr(l, { [t]: n.a });
  return Number.isFinite(u) ? u : null;
}
function HB(e, n, t) {
  let r = (a) => (qr(e, { [n]: t + a }) - qr(e, { [n]: t - a })) / (2 * a),
    s = r(1e-4),
    i = r(1e-5);
  if (
    !Number.isFinite(s) ||
    !Number.isFinite(i) ||
    Math.abs(s - i) > 1e-6 * Math.max(1, Math.abs(i))
  )
    return null;
  let o = nq.filter((a) => Math.abs(a - i) <= 1e-7 * Math.max(1, Math.abs(i)));
  return o.length === 1 ? o[0] : null;
}
function qs(e, n, t = {}) {
  let r = t.lookup?.(e);
  if (r) return r;
  if (!Oe(e, n.x)) {
    let l = Lr(e);
    return Number.isFinite(l) ? se(l, 0) : He;
  }
  if (e.k === 'sym') return o0(n);
  let s = mv(e, n);
  if (s) return s;
  let i = (l) => ({ r: qs(l, n, t), c: !Oe(l, n.x) }),
    o;
  switch (e.k) {
    case 'add':
      o = fv(e.c.map(i), t);
      break;
    case 'mul':
      o = Qp(e.c.map(i), t);
      break;
    case 'div':
      o = dv(i(e.a), i(e.b), t);
      break;
    case 'pow':
      o = Sd(i(e.a), i(e.b), { seq: n.seq, bnd: t.bnd });
      break;
    case 'fn':
      o = Td(e.f, i(e.a), { ...t, v54: n.v54 });
      break;
    default:
      o = He;
  }
  if (_s(o) || o.k === 'bnd' || o.k === 'none') return o;
  if (!t.noTheorems) {
    let l = gv(e, n);
    if (l) return l.v;
  }
  let a = pv(e, n);
  return a !== null ? se(a, 0) : o;
}
function gv(e, n) {
  let t = GB(e, n);
  if (t && UB(t.g, t.at)) {
    let s = X_(t.g, t.at);
    if (s) return { v: s, via: 'compare' };
  }
  let r = ZB(e, n);
  if (r !== null) return { v: se(r, 0), via: 'derivative' };
  if (!n.v54) {
    let s = JB(e, n);
    if (s) return s;
  }
  return null;
}
var av = '\u{1D44B}',
  eq = (e) => {
    try {
      return E(R(e));
    } catch {
      return E(e);
    }
  };
function WB(e, n) {
  let t = [],
    r = (s, i) => {
      switch ((!i && s.k !== 'sym' && s.k !== 'num' && Oe(s, n) && t.push(s), s.k)) {
        case 'add':
        case 'mul':
          s.c.forEach((o) => r(o, !1));
          break;
        case 'fn':
          r(s.a, !1);
          break;
        case 'div':
        case 'pow':
        case 'binom':
          (r(s.a, !1), r(s.b, !1));
          break;
        default:
          break;
      }
    };
  return (r(e, !0), t);
}
function Ip(e, n, t) {
  if (e.k !== 'num' && e.k !== 'sym' && eq(e) === n) return t;
  switch (e.k) {
    case 'add':
    case 'mul':
      return { ...e, c: e.c.map((r) => Ip(r, n, t)) };
    case 'fn':
      return { ...e, a: Ip(e.a, n, t) };
    case 'div':
    case 'pow':
    case 'binom':
      return { ...e, a: Ip(e.a, n, t), b: Ip(e.b, n, t) };
    default:
      return e;
  }
}
function JB(e, n) {
  let t = n.x,
    r = { k: 'sym', n: av },
    s = new Set();
  for (let i of WB(e, t)) {
    let o = eq(i);
    if (s.has(o)) continue;
    s.add(o);
    let a = Ip(e, o, r);
    if (Oe(a, t) || !Oe(a, av)) continue;
    let l = qs(i, n);
    if (l.k !== 'fin' && l.k !== 'inf') continue;
    let u =
        l.k === 'inf'
          ? { x: av, inf: l.s, a: 0, side: 0, seq: !1 }
          : { x: av, inf: 0, a: l.v, side: l.side, seq: !1 },
      c = gv(a, u);
    if (c) return { v: c.v, via: c.via, composite: i };
  }
  return null;
}
function i0(e, n) {
  let t;
  try {
    t = Ge(e);
  } catch {
    return null;
  }
  let r = uv(t.n, n.x),
    s = uv(t.d, n.x);
  if (!r || !s) return null;
  let i = (b) => Math.max(-1, ...[...b.entries()].filter(([, v]) => !L(v)).map(([v]) => v));
  if (i(s) < 0) return null;
  if (i(r) < 0) return se(0, 0);
  if (n.inf) {
    let b = i(r),
      v = i(s),
      k = en(r.get(b)) / en(s.get(v)),
      y = n.inf;
    return b === v ? se(k, 0) : b < v ? se(0, ir(k) * y ** (v - b)) : Sn(ir(k) * y ** (b - v));
  }
  let o = W_(n.a);
  if (!o) return null;
  let a = (b) => {
      let v = i(b),
        k = Array.from({ length: v + 1 }, () => F);
      for (let [y, S] of b) {
        let w = 1n;
        for (let _ = 0; _ <= y; _++) {
          let O = N(N(S, C(w)), at(o, y - _));
          ((k[_] = re(k[_], O)), (w = (w * BigInt(y - _)) / BigInt(_ + 1)));
        }
      }
      return k;
    },
    l = a(r),
    u = a(s),
    c = (b) => b.findIndex((v) => !L(v)),
    f = c(l),
    d = c(u);
  if (d < 0) return null;
  if (f < 0) return se(0, 0);
  let m = en(l[f]) / en(u[d]),
    p = f - d;
  if (p === 0) return se(m, 0);
  let g = (b) => (b > 0 ? 1 : (-1) ** p);
  if (!n.side)
    return p > 0 ? se(0, p % 2 === 0 ? ir(m) : 0) : -p % 2 === 0 ? Sn(ir(m)) : { k: 'none' };
  let h = ir(m) * g(n.side);
  return p > 0 ? se(0, h) : Sn(h);
}
function z_(e, n, t) {
  let r = (s, i) => (Math.abs(s - i) < 1e-12 ? 0 : s > i ? 1 : -1);
  return t === 1 ? r(e.b, n.b) || r(e.a, n.a) || r(e.l, n.l) : r(n.a, e.a) || r(e.l, n.l);
}
function xl(e, n, t) {
  let r = fc(e, n);
  if (r) return { g: r, exact: t === 1 || Math.abs(r.b) < 1e-12 };
  switch (e.k) {
    case 'add': {
      let s = e.c.map((o) => xl(o, n, t));
      if (s.some((o) => !o)) return null;
      let i = [];
      for (let o of s) {
        let a = i.find(
          (l) => z_(l.g, o.g, t) === 0 && (t === 0 || Math.abs(l.g.b - o.g.b) < 1e-12),
        );
        a
          ? ((a.g = { ...a.g, c: a.g.c + o.g.c }),
            (a.exact &&= o.exact),
            (a.scale = Math.max(a.scale, Math.abs(o.g.c))))
          : i.push({ g: { ...o.g }, exact: o.exact, scale: Math.abs(o.g.c) });
      }
      i.sort((o, a) => -z_(o.g, a.g, t));
      for (let o of i) {
        if (Math.abs(o.g.c) <= 1e-12 * Math.max(1, o.scale)) {
          if (!o.exact) return null;
          continue;
        }
        return { g: o.g, exact: o.exact && i.length === 1 };
      }
      return null;
    }
    case 'mul': {
      let s = pi,
        i = !0;
      for (let o of e.c) {
        let a = xl(o, n, t);
        if (!a) return null;
        ((s = lv(s, a.g)), (i &&= a.exact));
      }
      return { g: s, exact: i };
    }
    case 'div': {
      let s = xl(e.a, n, t),
        i = xl(e.b, n, t);
      if (!s || !i) return null;
      let o = Rd(i.g, -1);
      return o ? { g: lv(s.g, o), exact: s.exact && i.exact } : null;
    }
    case 'pow': {
      if (Oe(e.b, n)) return null;
      let s = Lr(e.b),
        i = xl(e.a, n, t);
      if (!i || !Number.isFinite(s)) return null;
      let o = Rd(i.g, s);
      return o ? { g: o, exact: i.exact } : null;
    }
    case 'fn': {
      if (e.f === 'sqrt') {
        let s = xl(e.a, n, t),
          i = s && Rd(s.g, 0.5);
        return s && i ? { g: i, exact: s.exact } : null;
      }
      if (e.f === 'ln' && t === 1) {
        let s = xl(e.a, n, t);
        return !s || s.g.c <= 0
          ? null
          : Math.abs(s.g.b) > 1e-12
            ? { g: { ...pi, c: s.g.b, a: 1 }, exact: !1 }
            : Math.abs(s.g.a) > 1e-12
              ? { g: { ...pi, c: s.g.a, l: 1 }, exact: !1 }
              : Math.abs(s.g.l) > 1e-12
                ? null
                : { g: { ...pi, c: Math.log(s.g.c) }, exact: !1 };
      }
      return null;
    }
    default:
      return null;
  }
}
function jp(e, n) {
  if (!n.inf && !n.side) {
    let i = jp(e, { ...n, side: 1 }),
      o = jp(e, { ...n, side: -1 });
    return !i || !o
      ? null
      : i.k === 'inf' && o.k === 'inf'
        ? i.s === o.s
          ? i
          : { k: 'none' }
        : i.k === 'fin' && o.k === 'fin' && yl(i.v, o.v)
          ? se(i.v, i.side === o.side ? i.side : 0)
          : { k: 'none' };
  }
  let t = Y_(e, n);
  if (!t) return null;
  let r = xl(YB(t.t), n.x, t.at);
  if (!r) return null;
  let s = X_(r.g, t.at);
  return s && s.k === 'fin' && !r.exact && Math.abs(s.v) > 1e-12 ? se(s.v, 0) : s;
}
function f0(e, n = !1) {
  if (e.inf)
    return (
      e.seq
        ? n
          ? [7, 12, 25, 50, 101, 250, 1e3, 4001]
          : [10, 100, 1e3, 1e4, 1e5, 1e6]
        : n
          ? [11.3, 23.7, 47.1, 97.9, 211.3, 503.7, 1013.9]
          : [10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8]
    ).map((s) => s * e.inf);
  let t = n
    ? [0.31, 0.13, 0.071, 0.023, 0.0089, 0.0031, 7e-4]
    : [0.1, 0.01, 0.001, 1e-4, 1e-5, 1e-6, 1e-7, 1e-8];
  return e.side ? t.map((r) => e.a + e.side * r) : t.flatMap((r) => [e.a + r, e.a - r]);
}
function a0(e, n, t = !0) {
  return f0(n, t).map((r) => ({ p: r, v: qr(e, { [n.x]: r }) }));
}
function l0(e, n) {
  if (!n.inf && !n.side) {
    let m = l0(e, { ...n, side: 1 }),
      p = l0(e, { ...n, side: -1 });
    return !m || !p
      ? null
      : m.k === 'inf' && p.k === 'inf'
        ? m.s === p.s
          ? m
          : { k: 'none' }
        : m.k === 'fin' && p.k === 'fin' && G_(m.v, p.v)
          ? se((m.v + p.v) / 2, m.side === p.side ? m.side : 0)
          : { k: 'none' };
  }
  let t = a0(e, n, !1).map((m) => m.v);
  if (n.seq) {
    let m = f0(n, !1).map((h) => qr(e, { [n.x]: h + 1 })),
      p = t[t.length - 1],
      g = m[m.length - 1];
    if (
      Number.isFinite(p) &&
      Number.isFinite(g) &&
      !G_(p, g) &&
      Math.abs(p) > 1e6 &&
      Math.abs(g) > 1e6 &&
      Math.sign(p) !== Math.sign(g)
    )
      return { k: 'none' };
  }
  let r = t.filter((m) => !Number.isNaN(m)).slice(-4);
  if (r.length < 4) return null;
  if (r.every((m) => m === 1 / 0)) return Sn(1);
  if (r.every((m) => m === -1 / 0)) return Sn(-1);
  let s = r.map((m) => (Number.isFinite(m) ? m : Math.sign(m) * 1e308)),
    i = s.map(Math.abs);
  if (
    s.every((m) => Math.sign(m) === Math.sign(s[3])) &&
    i[3] > 1e6 &&
    i.every((m, p) => p === 0 || m >= i[p - 1] * 1.5)
  )
    return Sn(s[3] > 0 ? 1 : -1);
  let a = s.slice(1).map((m, p) => m - s[p]),
    l = a.map(Math.abs),
    u = Math.max(1, Math.abs(s[3]));
  if (l[2] <= 1e-12 * u) return U_(s[3], 1e-9 * u, s);
  let c = l[1] / Math.max(l[0], 1e-300),
    f = l[2] / Math.max(l[1], 1e-300);
  if (
    Math.sign(a[1]) === Math.sign(a[2]) &&
    Math.sign(a[0]) === Math.sign(a[1]) &&
    c < 0.7 &&
    f < 0.7 &&
    Math.abs(c - f) < 0.35
  ) {
    let m = Math.max(c, f),
      p = (l[2] * m) / (1 - m),
      g = s[3] + Math.sign(a[2]) * p;
    return U_(g, Math.max(p, 1e-9 * u) * 2, s);
  }
  return null;
}
var nq = (() => {
  let e = [];
  for (let n = -60; n <= 60; n++) for (let t of [1, 2, 3, 4, 5, 6, 8, 10]) e.push(n / t);
  for (let n of [
    Math.E,
    1 / Math.E,
    Math.sqrt(Math.E),
    Math.exp(-0.5),
    Math.LN2,
    Math.PI,
    Math.SQRT2,
  ])
    e.push(n, -n, 2 * n);
  return [...new Set(e.map((n) => Math.round(n * 1e12) / 1e12))];
})();
function U_(e, n, t) {
  let r = nq.filter((i) => Math.abs(i - e) <= Math.max(n, 1e-9));
  if (r.length !== 1) return null;
  let s = r[0];
  return Math.abs(s) < 1e-12
    ? se(0, t.every((i) => i > 0) ? 1 : t.every((i) => i < 0) ? -1 : 0)
    : se(s, 0);
}
function G_(e, n) {
  return Math.abs(e - n) <= 1e-6 * Math.max(1, Math.abs(e), Math.abs(n));
}
function XB(e, n) {
  let r = (
    n.inf
      ? n.seq
        ? Array.from({ length: 120 }, (s, i) => 10 + i * 7 + (i % 3))
        : Array.from({ length: 120 }, (s, i) => n.inf * (5 + i * 3.7 + (i * i) / 9))
      : Array.from({ length: 60 }, (s, i) => 0.3 / (1 + i * 0.7)).flatMap((s) =>
          n.side ? [n.a + n.side * s] : [n.a + s, n.a - s],
        )
  )
    .map((s) => qr(e, { [n.x]: s }))
    .filter((s) => Number.isFinite(s));
  return r.length < 4 ? 0 : r.every((s) => s > 0) ? 1 : r.every((s) => s < 0) ? -1 : 0;
}
function YB(e) {
  try {
    return R(e);
  } catch {
    return e;
  }
}
function ez(e) {
  if (e.k !== 'add' || e.c.length !== 2) return null;
  let n = (l) => (l.k === 'fn' && l.f === 'sqrt') || (l.k === 'mul' && l.c.some(n)),
    [t, r] = e.c;
  if (!n(t) && !n(r)) return null;
  let s = (l) =>
      l.k === 'fn' && l.f === 'sqrt'
        ? l.a
        : l.k === 'mul'
          ? { k: 'mul', c: l.c.map((u) => (u.k === 'num' ? { k: 'num', v: N(u.v, u.v) } : s(u))) }
          : { k: 'pow', a: l, b: T(2) },
    i = (l) => ({ k: 'mul', c: [T(-1), l] }),
    o = { k: 'add', c: [s(t), i(s(r))] },
    a = o;
  try {
    a = Je(Ge(o));
  } catch {}
  return { k: 'div', a, b: { k: 'add', c: [t, i(r)] } };
}
function Yi(e, n, t = {}) {
  let r = (u) => (u.k === 'fin' && Math.abs(u.v) < 1e-12 && !u.side ? se(0, XB(e, n)) : u),
    s = qs(e, n, { ...t, bnd: !0 });
  if (_s(s) || s.k === 'none') return { v: r(s), via: 'known' };
  if (n.dl && !n.inf && Math.abs(n.a) < 1e-12) {
    let u = J1(e, n.x, n.side);
    if (u) return { v: r(u.k === 'fin' ? se(u.v) : Sn(u.s)), via: 'series' };
  }
  if (e.k === 'div' && e.a.k === 'add') {
    let u = e.a.c.map((c) => {
      let f = { k: 'div', a: c, b: e.b },
        d = qs(f, n, { ...t, bnd: !0 }),
        m = _s(d) ? d : (i0(f, n) ?? jp(f, n));
      return m ? { r: m, c: !1 } : null;
    });
    if (u.every((c) => c)) {
      let c = fv(u);
      if (_s(c)) return { v: r(c), via: 'known' };
    }
  }
  let i = i0(e, n);
  if (i) return { v: r(i), via: 'rational' };
  let o = jp(e, n);
  if (o) return { v: r(o), via: 'asym' };
  let a = ez(e);
  if (a) {
    let u = jp(a, n) ?? i0(a, n);
    if (u) return { v: r(u), via: 'asym' };
  }
  if (s.k === 'bnd') return { v: s, via: 'known' };
  let l = l0(e, n);
  return l ? { v: r(l), via: 'numeric' } : { v: null, via: null };
}
function Nr(e, n, t) {
  if (!dc(e) && !dc(n))
    try {
      if (qn(e, n) === 'equal') return !0;
    } catch {}
  let r = a0(e, t, !0),
    s = a0(n, t, !0),
    i = 0;
  for (let o = 0; o < r.length; o++) {
    let a = r[o].v,
      l = s[o].v;
    if (!(Number.isNaN(a) && Number.isNaN(l))) {
      if (Number.isNaN(a) || Number.isNaN(l)) return !1;
      if (!Number.isFinite(a) || !Number.isFinite(l)) {
        if (a !== l) return !1;
        continue;
      }
      if (!yl(a, l) && Math.abs(a - l) > 1e-9 * Math.max(1, Math.abs(a), Math.abs(l))) return !1;
      i++;
    }
  }
  return i >= 5;
}
function d0(e, n, t, r) {
  let s = f0(r, !0),
    i = r.seq ? s.flatMap((a) => [a, a + 1, a + 2]) : s,
    o = 0;
  for (let a of i) {
    let l = qr(e, { [r.x]: a }),
      u = qr(t, { [r.x]: a });
    if (!Number.isFinite(l) || !Number.isFinite(u)) continue;
    let c = 1e-12 * Math.max(1, Math.abs(l), Math.abs(u));
    if (!(n === '<' ? l < u + c : n === '>' ? l > u - c : n === '\u2264' ? l <= u + c : l >= u - c))
      return !1;
    o++;
  }
  return o >= 5 ? !0 : null;
}
var hi = '\u223C',
  hv = (e) => {
    try {
      return E(R(e));
    } catch {
      return E(e);
    }
  },
  Ls = (e, n = 1) => ({ k: 'num', v: C(e, n) }),
  Fp = (e) => (e.length === 1 ? e[0] : { k: 'add', c: e }),
  Vp = (e) => ({ k: 'mul', c: e }),
  Dp = (e, n) => ({ k: 'div', a: e, b: n }),
  m0 = (e, n) => ({ k: 'pow', a: e, b: n }),
  nz = (e, n) => ({ k: 'fn', f: e, a: n });
function tq(e, n) {
  try {
    return Yi(e, n).v;
  } catch {
    return null;
  }
}
var ea = (e, n, t) => {
  let r = tq(e, n);
  return !!r && r.k === 'fin' && Math.abs(r.v - t) < 1e-9;
};
function p0(e, n, t) {
  return tq(Dp(e, n), t);
}
function g0(e, n, t) {
  if (h0(n, t)) return !1;
  let r = p0(e, n, t);
  return !!r && r.k === 'fin' && Math.abs(r.v - 1) < 1e-9;
}
function h0(e, n) {
  if (Oe(e, n.x)) return Nr(e, Ls(0), n);
  try {
    return Math.abs(Lr(e)) < 1e-12;
  } catch {
    return !1;
  }
}
function tz(e) {
  if (e.k !== 'mul') return null;
  let n = e.c.findIndex((r) => r.k === 'num' && M(r.v, C(-1)));
  if (n < 0) return null;
  let t = e.c.filter((r, s) => s !== n);
  return t.length === 1 ? t[0] : Vp(t);
}
function rz(e, n) {
  let t = n.x;
  if (e.k === 'fn')
    return ['sin', 'tan', 'arcsin', 'arctan'].includes(e.f) && ea(e.a, n, 0)
      ? e.a
      : e.f === 'ln' && ea(e.a, n, 1)
        ? Fp([e.a, Ls(-1)])
        : null;
  if (e.k !== 'add' || e.c.length !== 2) return null;
  let r = e.c.findIndex((o) => !Oe(o, t));
  if (r < 0) return null;
  let s;
  try {
    s = Lr(e.c[r]);
  } catch {
    return null;
  }
  let i = e.c[1 - r];
  if (Math.abs(s + 1) < 1e-12) {
    if (i.k === 'fn' && i.f === 'exp' && ea(i.a, n, 0)) return i.a;
    if (i.k === 'fn' && i.f === 'sqrt' && ea(i.a, n, 1)) return Dp(Fp([i.a, Ls(-1)]), Ls(2));
    if (i.k === 'fn' && i.f === 'cos' && ea(i.a, n, 0))
      return Vp([Ls(-1), Dp(m0(i.a, Ls(2)), Ls(2))]);
    if (i.k === 'pow') {
      if (Oe(i.b, t)) {
        let o = Vp([i.b, nz('ln', i.a)]);
        return ea(o, n, 0) ? o : null;
      }
      if (ea(i.a, n, 1)) return Vp([i.b, Fp([i.a, Ls(-1)])]);
    }
    return null;
  }
  if (Math.abs(s - 1) < 1e-12) {
    let o = tz(i);
    if (o && o.k === 'fn' && o.f === 'cos' && ea(o.a, n, 0)) return Dp(m0(o.a, Ls(2)), Ls(2));
  }
  return null;
}
function rq(e) {
  return e.k !== 'add' ? [e] : e.c.flatMap(rq);
}
function sz(e, n, t) {
  if (e.k !== 'add') return !1;
  let r = rq(e);
  if (r.length < 2 || r.length > 8) return !1;
  for (let s = 1; s < (1 << r.length) - 1; s++) {
    let i = r.filter((a, l) => s & (1 << l)),
      o = r.filter((a, l) => !(s & (1 << l)));
    if (Nr(Fp(i), n, t) && ea(Dp(Fp(o), n), t, 0)) return !0;
  }
  return !1;
}
function iz(e, n) {
  let t = [...e.co.keys()].filter((r) => r <= e.e).sort((r, s) => r - s);
  for (let r of t) {
    let s = hd(e, r);
    if (L(s)) continue;
    let i = { k: 'sym', n },
      o = r === 0 ? Ls(1) : r === 1 ? i : m0(i, Ls(r));
    return M(s, q) ? o : Vp([{ k: 'num', v: s }, o]);
  }
  return null;
}
function pc(e, n, t) {
  return hv(e) === hv(n)
    ? []
    : e.k === 'mul' && n.k === 'mul' && e.c.length === n.c.length
      ? e.c.flatMap((r, s) => pc(r, n.c[s], t))
      : e.k === 'div' && n.k === 'div'
        ? [...pc(e.a, n.a, t), ...pc(e.b, n.b, t)]
        : (e.k === 'pow' && n.k === 'pow' && !Oe(e.b, t) && hv(e.b) === hv(n.b)) ||
            (e.k === 'fn' && n.k === 'fn' && e.f === 'sqrt' && n.f === 'sqrt')
          ? pc(e.a, n.a, t)
          : [[e, n]];
}
function sq(e, n, t, r, s) {
  let i = rz(e, t);
  if (i && Nr(i, n, t)) return 'equivReference';
  let o = s(e);
  if (o) {
    let a = iz(o, t.x);
    if (a && Nr(a, n, t)) return 'equivDL';
  }
  return sz(e, n, t) ? 'equivDominant' : r ? null : 'equivReplace';
}
var oz = {
    reference: 'limit.reference@1',
    continuity: 'limit.continuity@1',
    sum: 'limit.sum@1',
    product: 'limit.product@1',
    quotient: 'limit.quotient@1',
    composition: 'limit.composition@1',
    power: 'limit.power@1',
    factorDominant: 'limit.factor_dominant@1',
    simplify: 'limit.simplify@1',
    conjugate: 'limit.conjugate@1',
    rewrite: 'limit.rewrite@1',
    factor: 'limit.factor@1',
    conjugateMul: 'limit.conjugate_mul@1',
    compare: 'limit.compare@1',
    derivative: 'limit.derivative@1',
    bound: 'limit.bound@1',
    squeeze: 'limit.squeeze@1',
    comparison: 'limit.comparison@1',
    derivativeComposite: 'limit.derivative_composite@1',
    compareComposite: 'limit.compare_composite@1',
    expForm: 'limit.exp_form@1',
    dlReference: 'limit.dl_reference@1',
    dlCompose: 'limit.dl_compose@1',
    dlSum: 'limit.dl_sum@1',
    dlScale: 'limit.dl_scale@1',
    dlProduct: 'limit.dl_product@1',
    dlDivide: 'limit.dl_divide@1',
    dlQuotient: 'limit.dl_quotient@1',
    dlLimit: 'limit.dl_limit@1',
    sameDenominator: 'limit.same_denominator@1',
    equivReference: 'limit.equiv_reference@1',
    equivDL: 'limit.equiv_dl@1',
    equivDominant: 'limit.equiv_dominant@1',
    equivReplace: 'limit.equiv_replace@1',
    lnRule: 'limit.ln_rule@1',
    reduce: 'limit.reduce@1',
  },
  Bp = {
    reference: {
      label: 'Limite de r\xE9f\xE9rence',
      hora: 1,
      why: 'Une limite du cours : x, x\u207F, 1 \xF7 x, \u221Ax, e\u02E3, ln x, q\u207F.',
    },
    continuity: {
      label: 'Par continuit\xE9',
      hora: 1,
      why: 'L\u2019expression est d\xE9finie et continue au point : sa limite est sa valeur.',
    },
    sum: {
      label: 'Limite d\u2019une somme',
      hora: 1,
      why: 'On additionne les limites des termes (ce n\u2019est pas la forme \u221E \u2212 \u221E).',
    },
    product: {
      label: 'Limite d\u2019un produit',
      hora: 1,
      why: 'On multiplie les limites, avec la r\xE8gle des signes (ce n\u2019est pas la forme 0 \xD7 \u221E).',
    },
    quotient: {
      label: 'Limite d\u2019un quotient',
      hora: 1,
      why: 'On divise les limites ; un d\xE9nominateur qui tend vers 0 : son signe (0\u207A ou 0\u207B) d\xE9cide.',
    },
    composition: {
      label: 'Limite d\u2019une compos\xE9e',
      hora: 1,
      why: 'u tend vers b, et f(X) tend vers \u2113 quand X tend vers b : f(u) tend vers \u2113.',
    },
    power: {
      label: 'Limite d\u2019une puissance',
      hora: 1,
      why: 'Une puissance de ce qui a une limite, ou q\u207F selon q.',
    },
    factorDominant: {
      label: 'Factoriser par le terme dominant',
      hora: 2,
      why: 'On met en facteur le terme qui l\u2019emporte : la forme n\u2019est plus ind\xE9termin\xE9e.',
    },
    simplify: {
      label: 'Simplifier la fraction',
      hora: 2,
      why: 'On simplifie par le facteur qui s\u2019annule : la forme n\u2019est plus ind\xE9termin\xE9e.',
    },
    conjugate: {
      label: 'Multiplier par l\u2019expression conjugu\xE9e',
      hora: 2,
      why: '(\u221Aa \u2212 \u221Ab)(\u221Aa + \u221Ab) = a \u2212 b : la diff\xE9rence de racines dispara\xEEt.',
    },
    rewrite: {
      label: 'Transformer l\u2019\xE9criture',
      hora: 2,
      why: 'Une \xE9criture \xE9gale pr\xE8s du point, qui n\u2019est plus une forme ind\xE9termin\xE9e.',
    },
    conjugateMul: {
      label: 'Multiplier par l\u2019expression conjugu\xE9e',
      hora: 1,
      why: 'On multiplie en haut et en bas par l\u2019expression conjugu\xE9e (\u221Aa + \u221Ab) : la valeur ne change pas.',
    },
    factor: {
      label: 'Factoriser',
      hora: 1,
      why: 'Un facteur commun appara\xEEt en haut et en bas : il va se simplifier.',
    },
    compare: {
      label: 'Croissances compar\xE9es',
      hora: 2,
      why: 'En +\u221E, e\u02E3 l\u2019emporte sur toute puissance de x, qui l\u2019emporte sur ln x ; en 0, x\u1D43 l\u2019emporte sur ln x.',
    },
    derivative: {
      label: 'Nombre d\xE9riv\xE9',
      hora: 2,
      why: '(f(x) \u2212 f(a)) \xF7 (x \u2212 a) tend vers f\u2032(a) : on d\xE9rive f, puis on prend sa valeur en a.',
    },
    bound: {
      label: 'Encadrer',
      hora: 1,
      why: 'On encadre l\u2019expression pr\xE8s du point (\u22121 \u2264 cos \u2264 1, \u2026).',
    },
    squeeze: {
      label: 'Th\xE9or\xE8me des gendarmes',
      hora: 2,
      why: 'Encadr\xE9e par deux expressions qui ont la m\xEAme limite, l\u2019expression a cette limite.',
    },
    comparison: {
      label: 'Th\xE9or\xE8me de comparaison',
      hora: 2,
      why: 'Plus grande qu\u2019une expression qui tend vers +\u221E, elle tend vers +\u221E (plus petite qu\u2019une qui tend vers \u2212\u221E, vers \u2212\u221E).',
    },
    derivativeComposite: {
      label: 'Nombre d\xE9riv\xE9, par composition',
      hora: 2,
      why: 'On pose X \xE9gal au morceau int\xE9rieur : X tend vers a, et (f(X) \u2212 f(a)) \xF7 (X \u2212 a) tend vers f\u2032(a) (sin(X) \xF7 X \u2192 1 en 0). Par composition, l\u2019expression a la m\xEAme limite.',
    },
    compareComposite: {
      label: 'Croissances compar\xE9es, par composition',
      hora: 2,
      why: 'On pose X \xE9gal au morceau int\xE9rieur : X tend vers +\u221E (ou 0), et les croissances compar\xE9es donnent la limite en X. Par composition, l\u2019expression a la m\xEAme limite.',
    },
    expForm: {
      label: '\xC9crire avec l\u2019exponentielle',
      hora: 1,
      why: 'u\u1D5B = e^(v \xD7 ln(u)) (u > 0) : la puissance devient une exponentielle, on cherche la limite de v \xD7 ln(u).',
    },
    dlReference: {
      label: 'DL de r\xE9f\xE9rence',
      hora: 2,
      why: 'Un d\xE9veloppement limit\xE9 du cours en 0 (e\u02E3, sin x, cos x, ln(1 + x), (1 + x)^a\u2026), \xE9crit jusqu\u2019\xE0 l\u2019ordre voulu.',
    },
    dlCompose: {
      label: 'Composer les DL',
      hora: 2,
      why: 'Dans un DL de r\xE9f\xE9rence, on remplace la variable par une expression qui tend vers 0, et on garde les termes jusqu\u2019\xE0 l\u2019ordre voulu.',
    },
    dlSum: {
      label: 'Somme de DL',
      hora: 1,
      why: 'On additionne terme \xE0 terme ; le reste est le plus gros des o(\u2026).',
    },
    dlScale: {
      label: 'Multiplier un DL',
      hora: 1,
      why: 'Multiplier par une puissance de x d\xE9cale tous les degr\xE9s, le reste aussi : x \xD7 o(x\xB2) = o(x\xB3).',
    },
    dlProduct: {
      label: 'Produit de DL',
      hora: 2,
      why: 'On d\xE9veloppe le produit et on garde les termes dont on est s\xFBr : le reste se lit sur les premiers termes de chaque facteur.',
    },
    dlDivide: {
      label: 'Diviser par une puissance de x',
      hora: 1,
      why: 'Diviser par x\u1D4F abaisse tous les degr\xE9s de k, le reste aussi : o(x\xB2) \xF7 x\xB2 = o(1).',
    },
    dlQuotient: {
      label: 'Quotient de DL',
      hora: 2,
      why: 'On met en facteur le premier terme du d\xE9nominateur, puis 1 \xF7 (1 + u) = 1 \u2212 u + u\xB2 \u2212 \u2026 avec u \u2192 0.',
    },
    dlLimit: {
      label: 'Lire la limite sur le DL',
      hora: 1,
      why: 'o(1) tend vers 0 : la limite est le terme constant du d\xE9veloppement.',
    },
    sameDenominator: {
      label: 'R\xE9duire au m\xEAme d\xE9nominateur',
      hora: 1,
      why: 'Une seule fraction : la forme \u221E \u2212 \u221E devient 0 \xF7 0, qu\u2019un d\xE9veloppement limit\xE9 va lever.',
    },
    equivReference: {
      label: '\xC9quivalent de r\xE9f\xE9rence',
      hora: 2,
      why: 'Quand u tend vers 0 : sin u, tan u, arctan u, e\u1D58 \u2212 1 et ln(1 + u) sont \xE9quivalents \xE0 u ; 1 \u2212 cos u \xE0 u\xB2 \xF7 2 ; (1 + u)\u1D43 \u2212 1 \xE0 a \xD7 u.',
    },
    equivDL: {
      label: 'Lire l\u2019\xE9quivalent sur le DL',
      hora: 1,
      why: 'Le premier terme non nul d\u2019un d\xE9veloppement limit\xE9 est un \xE9quivalent de l\u2019expression.',
    },
    equivDominant: {
      label: 'Garder le terme dominant',
      hora: 1,
      why: 'Une somme est \xE9quivalente \xE0 son terme qui l\u2019emporte : les autres sont n\xE9gligeables devant lui.',
    },
    equivReplace: {
      label: 'Remplacer par un \xE9quivalent',
      hora: 1,
      why: 'Dans un produit ou un quotient, on peut remplacer un facteur par un \xE9quivalent (jamais dans une somme).',
    },
    lnRule: {
      label: 'Logarithme d\u2019un produit',
      hora: 1,
      why: 'ln(ab) = ln(a) + ln(b) : on s\xE9pare le facteur qui l\u2019emporte.',
    },
    reduce: {
      label: 'R\xE9duire',
      hora: 1,
      why: 'On r\xE9duit l\u2019\xE9criture : les termes qui s\u2019annulent disparaissent.',
    },
  },
  az = 'Limites',
  eo = class extends Error {},
  Ns = '\u2192',
  bv = new Set(['+\u221E', '\u2212\u221E']);
function Or(e, n) {
  let t = e.replace(/~/g, hi),
    r = t.indexOf(hi);
  if (r >= 0) {
    let u = t.slice(0, r).trim(),
      c = t.slice(r + 1).trim();
    return [...(u ? Or(u, n) : []), hi, ...(c ? Or(c, n) : [])];
  }
  if (Y1(e)) {
    let { text: u, outs: c } = L_(e);
    return N_(Or(u, n), c);
  }
  let s = (u) => (n?.raw ? Te(u) : ne(Te(u))),
    i = e.replace(/->/g, Ns),
    o = i.indexOf(Ns);
  if (o < 0) return s(i);
  let a = i.slice(0, o).trim(),
    l = i.slice(o + 1).trim();
  return [...(a ? s(a) : []), Ns, ...lz(l)];
}
function lz(e) {
  let n = e.replace(/^-/, '\u2212').replace(/\s+/g, '');
  return n === '+\u221E' || n === '\u221E'
    ? ['+\u221E']
    : n === '\u2212\u221E'
      ? ['\u2212\u221E']
      : e
        ? ne(Te(e))
        : [];
}
function kr(e) {
  let n = e.indexOf(hi);
  if (n >= 0) {
    let i = e.slice(0, n),
      o = e.slice(n + 1);
    return `${i.length ? kr(i) + ' ' : ''}${hi}${o.length ? ' ' + kr(o) : ''}`;
  }
  let t = e.indexOf(Ns);
  if (t < 0) return b0(e);
  let r = e.slice(0, t),
    s = e.slice(t + 1);
  return `${r.length ? b0(r) + ' ' : ''}${Ns}${s.length ? ' ' + b0(s) : ''}`;
}
function b0(e) {
  return ot(e)
    .replace(/\//g, '\xF7')
    .replace(/\s*÷\s*/g, ' \xF7 ');
}
var vv = (e) => ({ dis: [{ sides: [{ k: 's', n: kr(e) }] }] });
function wv(e) {
  return vv(Or(e));
}
var uz = { k: 'fn', f: 'exp', a: { k: 'num', v: { n: 1n, d: 1n } } };
function zp(e) {
  switch (e.k) {
    case 'sym':
      return e.n === 'e' ? uz : e;
    case 'add':
    case 'mul':
      return { ...e, c: e.c.map(zp) };
    case 'div':
    case 'pow':
    case 'binom':
      return { ...e, a: zp(e.a), b: zp(e.b) };
    case 'fn':
      return { ...e, a: zp(e.a) };
    default:
      return e;
  }
}
function rs(e) {
  if (!e.length) return null;
  try {
    let n = ie(ot(O_(e)));
    return n.ok && n.s.k === 'expr' ? zp(n.s.e) : null;
  } catch {
    return null;
  }
}
function Sv(e) {
  try {
    return rs(ne(Te(e)));
  } catch {
    return null;
  }
}
var ce = (e) => {
  try {
    return E(R(e));
  } catch {
    return E(e);
  }
};
function S0(e) {
  if (e.length === 1 && bv.has(e[0])) return { k: 'inf', s: e[0] === '+\u221E' ? 1 : -1 };
  if (!e.length) return null;
  let n = e[e.length - 1],
    t = /^(.*\d)([⁺⁻])$/.exec(n),
    r = 0,
    s = e;
  t && ((r = t[2] === '\u207A' ? 1 : -1), (s = [...e.slice(0, -1), t[1]]));
  let i = rs(s);
  if (!i || Up(i)) return null;
  let o;
  try {
    let a = qs(i, { x: '\xB7', inf: 1, a: 0, side: 0, seq: !1 });
    if (a.k !== 'fin') return null;
    o = a.v;
  } catch {
    return null;
  }
  return r && Math.abs(o) > 1e-12 ? null : se(o, r);
}
function Up(e) {
  switch (e.k) {
    case 'sym':
      return e.n !== '\u03C0';
    case 'num':
      return !1;
    case 'add':
    case 'mul':
      return e.c.some(Up);
    case 'fn':
      return Up(e.a);
    default:
      return Up(e.a) || Up(e.b);
  }
}
function cz(e) {
  let n = e.kernel,
    t = n.goal.target,
    r = n.point;
  if (!r) throw new eo('Le point (`point`) manque.');
  let s = cv(r, t, t === 'n'),
    i = Sv(n.start);
  if (!i) throw new eo(`Expression illisible : \xAB ${n.start} \xBB.`);
  if (!Oe(i, t)) throw new eo(`L\u2019expression ne d\xE9pend pas de ${t}.`);
  let o = Or(n.answer),
    a = o.indexOf(hi);
  if (a >= 0) {
    let f = rs(o.slice(0, a)),
      d = rs(o.slice(a + 1));
    if (!f || ce(f) !== ce(i))
      throw new eo('La r\xE9ponse commence par l\u2019expression de la question.');
    if (!d || !Oe(d, t)) throw new eo('L\u2019\xE9quivalent de la r\xE9ponse est illisible.');
    return { P: s, target: i, answer: se(1), equiv: d };
  }
  let l = o.indexOf(Ns);
  if (l < 0) throw new eo('La r\xE9ponse s\u2019\xE9crit \xAB expression \u2192 limite \xBB.');
  let u = rs(o.slice(0, l)),
    c = S0(o.slice(l + 1));
  if (!u || ce(u) !== ce(i))
    throw new eo('La r\xE9ponse commence par l\u2019expression de la question.');
  if (!c) throw new eo('La limite de la r\xE9ponse est illisible.');
  return { P: s, target: i, answer: c, equiv: null };
}
function Zp(e, n) {
  let t = e.kernel,
    r = cz(e);
  (n?.v54 && (r.P = { ...r.P, v54: !0 }),
    kv(e) && (r.P = { ...r.P, dl: !0 }),
    r.equiv && !r.P.inf && Math.abs(r.P.a) < 1e-12 && (r.P = { ...r.P, dl: !0 }));
  let s = (e.traps ?? []).map((a) => ({
      text: kr(Or(a.line)),
      line: wv(a.line),
      title: a.title ?? 'Attention',
      why: a.why,
    })),
    i = ce(r.target),
    o = new Set([kr(Or(t.start)), ...fz(e).map((a) => kr(Or(a)))]);
  return {
    model: e,
    P: r.P,
    target: r.target,
    targetKey: i,
    answer: r.answer,
    terms: new Map([[i, r.target]]),
    parent: new Map(),
    lim: new Map(),
    lower: new Map(),
    upper: new Map(),
    written: new Set(),
    givenTexts: o,
    path: t.path ?? [],
    traps: s,
    lines: 0,
    concluded: !1,
    v54: !!n?.v54,
    dl: kv(e) || !!r.P.dl,
    dls: new Map(),
    equiv: r.equiv,
    equivs: [],
  };
}
function kv(e) {
  let n = e.kernel;
  return n ? [n.start, n.answer, ...(n.path ?? []), ...(e.givens ?? [])].some(Y1) : !1;
}
function fz(e) {
  let n = e.kernel;
  return [`${n.goal.target} ${Ns} ${n.point ?? ''}`.trim(), n.start, ...(e.givens ?? [])];
}
function En(e, n) {
  let t = n;
  for (; e.parent.has(t) && e.parent.get(t) !== t; ) t = e.parent.get(t);
  return t;
}
function T0(e) {
  return {
    parent: new Map(e.parent),
    lim: new Map(e.lim),
    lower: new Map([...e.lower].map(([n, t]) => [n, [...t]])),
    upper: new Map([...e.upper].map(([n, t]) => [n, [...t]])),
    dls: new Map(e.dls),
  };
}
function cq(e, n, t) {
  let r = En(e, n),
    s = e.dls.get(r);
  (!s || t.e > s.e) && e.dls.set(r, t);
}
var xv = (e, n) => e.dls.get(En(e, n)) ?? null;
function Gp(e, n, t) {
  let r = En(e, n),
    s = En(e, t);
  if (r === s) return;
  let i = e.lim.get(r),
    o = e.lim.get(s);
  (e.parent.set(s, r), !i && o && e.lim.set(r, o));
  let a = e.dls.get(r),
    l = e.dls.get(s);
  l && (!a || l.e > a.e) && e.dls.set(r, l);
  let u = [...(e.lower.get(r) ?? []), ...(e.lower.get(s) ?? [])],
    c = [...(e.upper.get(r) ?? []), ...(e.upper.get(s) ?? [])];
  (u.length && e.lower.set(r, u), c.length && e.upper.set(r, c));
}
var bc = (e, n) => e.lim.get(En(e, n)) ?? null,
  Tv = (e) => (n) => bc(e, ce(n));
function dz(e, n) {
  if (!Oe(e, n.x)) {
    let r = qs(e, n);
    return r.k === 'fin' ? r : null;
  }
  if (gc(e, n) > mz) return null;
  let t = qs(e, n, { noTheorems: !0 });
  return _s(t) ? t : null;
}
var mz = 2;
function gc(e, n) {
  let t = n.x;
  if (!Oe(e, t) || e.k === 'sym' || mv(e, n)) return 0;
  let r = (s) => s.filter((i) => Oe(i, t));
  switch (e.k) {
    case 'mul': {
      let s = r(e.c);
      return s.length === 1 ? gc(s[0], n) : 99;
    }
    case 'add': {
      let s = r(e.c);
      return s.length === 1 ? 1 + gc(s[0], n) : 99;
    }
    case 'div':
      return Oe(e.b, t) ? (Oe(e.a, t) ? 99 : 1 + gc(e.b, n)) : gc(e.a, n);
    case 'pow':
      return Oe(e.b, t) ? 99 : 1 + gc(e.a, n);
    case 'fn':
      return 1 + gc(e.a, n);
    default:
      return 99;
  }
}
function pz(e, n, t) {
  return bc(t, ce(e)) ?? dz(e, n) ?? gz(e, n, t);
}
function gz(e, n, t) {
  let r = n.x,
    s = { k: 'num', v: { n: 1n, d: 1n } },
    i = [],
    o = null;
  if (e.k === 'mul') {
    let u = e.c.filter((c) => Oe(c, r));
    u.length === 1 && u.length < e.c.length && ((i = e.c.filter((c) => !Oe(c, r))), (o = u[0]));
  } else if (e.k === 'div' && !Oe(e.b, r) && Oe(e.a, r))
    ((i = [{ k: 'div', a: s, b: e.b }]), (o = e.a));
  else if (e.k === 'div' && e.a.k === 'mul') {
    let u = e.a.c.filter((c) => Oe(c, r));
    u.length === 1 &&
      u.length < e.a.c.length &&
      ((i = e.a.c.filter((c) => !Oe(c, r))), (o = { k: 'div', a: u[0], b: e.b }));
  }
  if (!o) return null;
  let a = bc(t, ce(o));
  if (!a) return null;
  let l = Qp([...i.map((u) => ({ r: se(Lr(u)), c: !0 })), { r: a, c: !1 }]);
  return _s(l) ? l : null;
}
function hz(e, n, t) {
  let r = (s) => {
    let i = pz(s, n, t);
    return i ? { r: i, c: !Oe(s, n.x) } : null;
  };
  switch (e.k) {
    case 'add': {
      let s = e.c.map(r);
      return s.some((i) => !i) ? null : { r: fv(s), kind: 'sum' };
    }
    case 'mul': {
      let s = e.c.map(r);
      return s.some((i) => !i) ? null : { r: Qp(s), kind: 'product' };
    }
    case 'div': {
      let s = r(e.a),
        i = r(e.b);
      return !s || !i ? null : { r: dv(s, i), kind: 'quotient' };
    }
    case 'pow': {
      let s = r(e.a),
        i = r(e.b);
      return !s || !i
        ? null
        : { r: Sd(s, i, { seq: n.seq }), kind: Oe(e.b, n.x) ? 'composition' : 'power' };
    }
    case 'fn': {
      let s = r(e.a);
      return s ? { r: Td(e.f, s, { v54: n.v54 }), kind: 'composition' } : null;
    }
    default:
      return null;
  }
}
function Rv(e, n, t, r) {
  let s = n.reduce((l, u) => l + Bp[u].hora, 0),
    i = n.reduce((l, u) => (Bp[u].hora > Bp[l].hora ? u : l), n[0]),
    o = [...new Set(n.map((l) => Bp[l].label))],
    a = [...new Set(n)].map((l) => Bp[l].why).join(' ') + (r ? ' C\u2019est la r\xE9ponse.' : '');
  return {
    kind: 'step',
    ...e,
    hora: s,
    final: r,
    rule: { id: oz[i], card: az, label: o.join(' \u2192 '), hora: s, why: a },
    lmove: { ...t, ...(r ? { final: r } : {}) },
  };
}
function R0(e, n, t, r) {
  return {
    kind: 'useless',
    ...e,
    jump: !0,
    final: t,
    title: t ? 'Juste !' : 'Juste, mais tu sautes des \xE9tapes',
    message:
      r ??
      (t
        ? 'C\u2019est la bonne limite. D\xE9taille ton raisonnement, une \xE9tape par ligne, pour gagner des HORA. Tu peux garder cette ligne sans HORA.'
        : 'Ta ligne est juste. D\xE9taille-la, une limite \xE0 la fois, pour gagner des HORA. Tu peux la garder sans HORA.'),
    lmove: { ...n, ...(t ? { final: t } : {}) },
  };
}
function ts(e, n, t) {
  let r = kr(n.atoms),
    s = e.traps.find((i) => i.text === r);
  return s
    ? {
        kind: 'trap',
        ...n,
        title: s.title,
        message: s.why,
        trap: { line: s.line, title: s.title, why: s.why },
      }
    : { kind: 'false', ...n, ...t };
}
var $v = (e) => ({ text: e, terms: [], eqs: [], lims: [], lower: [], upper: [], dls: [] });
function bz(e, n) {
  return e.path.some((t) => {
    let r;
    try {
      r = Or(t);
    } catch {
      return !1;
    }
    return r.length > n.length && n.every((s, i) => r[i] === s);
  });
}
var Md = new Set(['<', '>', '\u2264', '\u2265']);
function vc(e, n, t) {
  let r = wt(n),
    s = r.atoms;
  if (!s.length) return { kind: 'empty', atoms: s, badChip: -1 };
  let i = bz(e, s),
    o = () =>
      t?.verify
        ? { kind: 'syntax', atoms: s, title: 'Ligne inachev\xE9e', message: 'Termine ta ligne.' }
        : { kind: i ? 'building' : 'open', atoms: s, complete: !1 };
  if (s.includes(hi)) {
    let h = xz(e, n, r.src, s, i, o, t);
    return h.kind === 'syntax' || h.kind === 'building' || h.kind === 'open' || h.kind === 'empty'
      ? h
      : i && !t?.verify
        ? h.kind === 'step'
          ? { ...h, kind: 'ready', complete: !0 }
          : { kind: 'building', atoms: s, complete: !0 }
        : !t?.verify && (h.kind === 'unjustified' || h.kind === 'false')
          ? { kind: 'pending', atoms: s, complete: !0 }
          : { ...h, complete: !0 };
  }
  if (s.filter((h) => h === Ns).length > 1)
    return {
      kind: 'syntax',
      atoms: s,
      title: 'Une seule fl\xE8che',
      message:
        'La fl\xE8che \xAB \u2192 \xBB se met une fois, \xE0 la fin : \xAB expression \u2192 limite \xBB.',
      badChip: n.length - 1,
    };
  let l = s.indexOf(Ns),
    u = l < 0 ? s : s.slice(0, l),
    c = l < 0 ? [] : s.slice(l + 1);
  if (l === 0)
    return {
      kind: 'syntax',
      atoms: s,
      title: '\xC7a commence mal',
      message: '\xC9cris d\u2019abord l\u2019expression, puis \xAB \u2192 \xBB et sa limite.',
      badChip: 0,
    };
  if (c.some((h) => h === '=' || h === Ns || Md.has(h)))
    return {
      kind: 'syntax',
      atoms: s,
      title: 'La limite \xE0 la fin',
      message:
        'Apr\xE8s \xAB \u2192 \xBB, \xE9cris seulement la limite : \xAB +\u221E \xBB, \xAB 0\u207A \xBB, \xAB 3 \xBB\u2026',
      badChip: n.length - 1,
    };
  if (u.some((h) => bv.has(h)))
    return {
      kind: 'syntax',
      atoms: s,
      title: '\u221E n\u2019est pas un nombre',
      message:
        '\xAB +\u221E \xBB s\u2019\xE9crit seulement apr\xE8s \xAB \u2192 \xBB, comme limite.',
      badChip: r.src[u.findIndex((h) => bv.has(h))] ?? n.length - 1,
    };
  let f = vn(u, { chains: !0 });
  if (!f.ok)
    return i
      ? { kind: 'building', atoms: s, complete: !1 }
      : {
          kind: 'syntax',
          atoms: s,
          title: '\xC7a commence mal',
          message: f.msg,
          badChip: r.src[f.index] !== void 0 ? r.src[f.index] : n.length - 1,
        };
  if (!f.complete || (l >= 0 && !c.length)) return o();
  let d = u.some((h) => Md.has(h)),
    m = u.includes('=');
  if (l < 0 && !m && !d)
    return t?.verify
      ? {
          kind: 'syntax',
          atoms: s,
          line: vv(s),
          title: 'Une relation',
          message:
            '\xC9cris une limite (\xAB \u2026 \u2192 +\u221E \xBB), une \xE9galit\xE9 (\xAB \u2026 = \u2026 \xBB) ou un encadrement.',
        }
      : { kind: i ? 'building' : 'open', atoms: s, complete: !1 };
  let p = { atoms: s, line: vv(s) },
    g;
  if (d) {
    if (m || l >= 0)
      return {
        kind: 'syntax',
        atoms: s,
        title: 'Une chose par ligne',
        message:
          'Un encadrement s\u2019\xE9crit seul sur sa ligne, sans \xAB = \xBB ni \xAB \u2192 \xBB.',
      };
    g = Rz(e, p, u);
  } else {
    let h = Ed(u, '=').map(rs);
    if (h.some((k) => !k))
      return {
        kind: 'syntax',
        atoms: s,
        title: '\xC7a ne se lit pas',
        message: 'Une expression ne se lit pas : v\xE9rifie les parenth\xE8ses.',
        badChip: n.length - 1,
      };
    let b = null;
    if (l >= 0) {
      if (((b = S0(c)), !b)) {
        let k = vn(c);
        if (k.ok && !k.complete) return o();
      }
      if (!b)
        return {
          kind: 'syntax',
          atoms: s,
          title: 'Une limite',
          message:
            'Une limite s\u2019\xE9crit \xAB +\u221E \xBB, \xAB \u2212\u221E \xBB, un nombre, ou \xAB 0\u207A \xBB, \xAB 0\u207B \xBB.',
          badChip: n.length - 1,
        };
    }
    let v = h;
    if (v.some(fn)) {
      if (!e.dl)
        return {
          kind: 'syntax',
          atoms: s,
          title: '\xC7a ne se lit pas',
          message: 'Une expression ne se lit pas : v\xE9rifie les parenth\xE8ses.',
          badChip: n.length - 1,
        };
      g = Sz(e, p, v, b);
    } else g = kz(e, p, v, b);
  }
  return i && !t?.verify
    ? g.kind === 'step'
      ? { ...g, kind: 'ready', complete: !0 }
      : { kind: 'building', atoms: s, complete: !0 }
    : !t?.verify && (g.kind === 'unjustified' || g.kind === 'false')
      ? { kind: 'pending', atoms: s, complete: !0 }
      : { ...g, complete: !0 };
}
function Ed(e, n) {
  let t = [[]],
    r = 0;
  for (let s of e)
    (s === '(' && r++, s === ')' && r--, r === 0 && s === n ? t.push([]) : t[t.length - 1].push(s));
  return t;
}
function wl(e) {
  switch (e.k) {
    case 'fn':
      return e.f === 'sqrt' || wl(e.a);
    case 'add':
    case 'mul':
      return e.c.some(wl);
    case 'div':
    case 'pow':
      return wl(e.a) || wl(e.b);
    default:
      return !1;
  }
}
function yv(e) {
  return e.k === 'add' ? e.c.some(wl) : e.k === 'mul' ? e.c.some(yv) : !1;
}
function k0(e, n) {
  let t = (r) => (r.k === 'add' && r.c.some(wl)) || (r.k === 'div' && t(r.a));
  return wl(e) && t(e) && n.k === 'div' && yv(n.b) && !yv(n.a);
}
function $d(e, n) {
  let t = (r) =>
    (r.k === 'div' && Oe(r.b, n) && r.b.k !== 'add') ||
    (r.k === 'pow' && !Oe(r.a, n) && Oe(r.b, n) && Math.abs(Lr(r.a)) < 1) ||
    (r.k === 'mul' && r.c.some(t));
  switch (e.k) {
    case 'add':
      return e.c.some((r) => t(r) || $d(r, n));
    case 'mul':
      return e.c.some((r) => $d(r, n));
    case 'div':
    case 'pow':
      return $d(e.a, n) || $d(e.b, n);
    case 'fn':
      return $d(e.a, n);
    default:
      return !1;
  }
}
function vz(e, n, t) {
  if (k0(e, n)) return 'conjugate';
  if (!t.inf) return 'simplify';
  if (e.k === 'div' && n.k === 'div') return $d(n, t.x) ? 'factorDominant' : 'simplify';
  let r = (i) => {
      if (!Oe(i, t.x)) return !1;
      let o = c0(i);
      return i.k === 'pow' || i.k === 'sym' || (i.k === 'fn' && i.f === 'exp') || !!o;
    },
    s = (i) => i.k === 'mul' && i.c.some(r) && i.c.some((o) => o.k === 'add');
  return s(n) || (n.k === 'div' && (s(n.a) || s(n.b)))
    ? 'factorDominant'
    : n.k === 'div' && e.k === 'div'
      ? 'simplify'
      : 'rewrite';
}
function iq(e, n) {
  if (e.k !== 'div') return !1;
  let t = (i) => (i.k === 'mul' ? i.c : [i]).filter((o) => Oe(o, n)).map(ce),
    r = t(e.a),
    s = t(e.b);
  return r.length + s.length < 3 ? !1 : s.some((i) => r.includes(i));
}
function $0(e, n, t, r) {
  let s = ce(t),
    i = ce(r);
  if (s === i || En(n, s) === En(n, i)) return { k: 'none' };
  if (!Nr(t, r, e.P))
    return {
      k: 'false',
      title: 'Pas la m\xEAme expression',
      message:
        'Ces deux \xE9critures ne sont pas \xE9gales pr\xE8s du point : v\xE9rifie ton calcul.',
    };
  if (e.equiv) {
    if (k0(t, r)) return { k: 'step', steps: ['conjugate'] };
    if (oq(t, r, e.P.x)) return { k: 'step', steps: ['sameDenominator'] };
    if (v0(t, r, e.P.x)) return { k: 'step', steps: ['expForm'] };
    if (t.k === 'add' && r.k === 'add' && t.c.length === r.c.length) {
      let u = t.c.map((c, f) => [c, r.c[f]]).filter(([c, f]) => ce(c) !== ce(f));
      if (u.length === 1 && v0(u[0][0], u[0][1], e.P.x)) return { k: 'step', steps: ['expForm'] };
    }
    return hc(r) > hc(t) && hc(t) > 0
      ? { k: 'step', steps: ['lnRule'] }
      : Cd(r) < Cd(t) && x0(r).length < x0(t).length
        ? { k: 'step', steps: ['reduce'] }
        : iq(r, e.P.x)
          ? { k: 'step', steps: ['factor'] }
          : { k: 'none' };
  }
  let o = Tv(n);
  if (e.v54 ? bc(n, s) || bc(n, i) : bc(n, s)) return { k: 'none' };
  let a = qs(t, e.P, { lookup: o, noTheorems: !0 }),
    l = qs(r, e.P, { lookup: o, bnd: !0 });
  return _s(a)
    ? { k: 'none' }
    : _s(l)
      ? { k: 'step', steps: [vz(t, r, e.P)] }
      : iq(r, e.P.x)
        ? { k: 'step', steps: [yv(r.k === 'div' ? r.b : r) && wl(t) ? 'conjugateMul' : 'factor'] }
        : k0(t, r)
          ? { k: 'step', steps: ['conjugate'] }
          : !e.v54 && v0(t, r, e.P.x)
            ? { k: 'step', steps: ['expForm'] }
            : e.dl && oq(t, r, e.P.x)
              ? { k: 'step', steps: ['sameDenominator'] }
              : { k: 'none' };
}
function oq(e, n, t) {
  if (e.k !== 'add' || n.k !== 'div') return !1;
  let r = (s) =>
    (s.k === 'div' && Oe(s.b, t)) ||
    (s.k === 'mul' && s.c.some(r)) ||
    (s.k === 'pow' && Lr(s.b) < 0);
  return e.c.filter(r).length >= 2;
}
function v0(e, n, t) {
  if (e.k !== 'pow' || !Oe(e.b, t) || !Oe(e.a, t) || n.k !== 'fn' || n.f !== 'exp') return !1;
  let r = ce(e.a),
    s = (i) => {
      switch (i.k) {
        case 'fn':
          return (i.f === 'ln' && ce(i.a) === r) || s(i.a);
        case 'add':
        case 'mul':
          return i.c.some(s);
        case 'div':
        case 'pow':
          return s(i.a) || s(i.b);
        default:
          return !1;
      }
    };
  return s(n.a);
}
function aq(e, n, t) {
  let r = qs(e, n, { lookup: Tv(t), noTheorems: !0 });
  return r.k === 'fi' ? r.form : null;
}
function fq(e, n, t, r) {
  let s = Tv(n),
    i = Yi(t, e.P, { lookup: s });
  if (!i.v) return { k: 'unknown' };
  let o = i.v;
  if (!gi(r, o)) {
    if (r.k === 'inf' && o.k === 'inf')
      return {
        k: 'false',
        title: 'Le signe',
        message: 'Vers +\u221E ou vers \u2212\u221E ? Regarde le signe de chaque morceau.',
      };
    if (r.k === 'fin' && o.k === 'fin' && Math.abs(r.v) < 1e-12 && Math.abs(o.v) < 1e-12)
      return {
        k: 'false',
        title: 'Le c\xF4t\xE9',
        message:
          r.side && !o.side
            ? 'On ne sait pas de quel c\xF4t\xE9 elle tend vers 0 : \xE9cris seulement \xAB 0 \xBB.'
            : '0\u207A ou 0\u207B : regarde le signe de l\u2019expression pr\xE8s du point.',
      };
    let h = aq(t, e.P, n);
    return h
      ? {
          k: 'false',
          title: 'Forme ind\xE9termin\xE9e',
          message: `\xAB ${h} \xBB est une forme ind\xE9termin\xE9e : on ne conclut pas par les op\xE9rations. Transforme d\u2019abord l\u2019\xE9criture.`,
        }
      : o.k === 'none' || o.k === 'bnd'
        ? {
            k: 'false',
            title: 'Ce n\u2019est pas la limite',
            message: 'Regarde comment l\u2019expression se comporte pr\xE8s du point.',
          }
        : {
            k: 'false',
            title: 'Ce n\u2019est pas la limite',
            message: 'Reprends la limite de chaque morceau.',
          };
  }
  let a = bc(n, ce(t));
  if (a && gi(r, a)) return { k: 'none' };
  if (e.dl) {
    let h = xv(n, ce(t)),
      b = h ? bd(h, e.P.side) : null;
    if (b && C0(r, b)) return { k: 'step', steps: ['dlLimit'] };
  }
  if (mv(t, e.P)) return { k: 'step', steps: ['reference'] };
  let l = hz(t, e.P, n);
  if (l && _s(l.r) && gi(r, l.r)) return { k: 'step', steps: [l.kind] };
  if (l && _s(l.r) && r.k === 'fin' && l.r.k === 'fin' && gi(se(r.v), l.r))
    return { k: 'step', steps: [l.kind] };
  if (!e.P.inf && pv(t, e.P) !== null && (r.k !== 'fin' || !r.side))
    return { k: 'step', steps: ['continuity'] };
  let u = gv(t, e.P),
    c = u
      ? u.composite
        ? u.via === 'derivative'
          ? 'derivativeComposite'
          : 'compareComposite'
        : u.via
      : null;
  if (u && c && gi(r, u.v)) return { k: 'step', steps: [c] };
  if (u && c && r.k === 'fin' && u.v.k === 'fin' && gi(se(r.v), u.v))
    return { k: 'step', steps: [c] };
  let f = En(n, ce(t)),
    d = (h) => {
      let b = qs(h, e.P, { lookup: s });
      return _s(b) ? b : null;
    },
    m = (n.lower.get(f) ?? []).map(d),
    p = (n.upper.get(f) ?? []).map(d);
  if (
    r.k === 'fin' &&
    m.some((h) => h?.k === 'fin' && Math.abs(h.v - r.v) < 1e-9) &&
    p.some((h) => h?.k === 'fin' && Math.abs(h.v - r.v) < 1e-9)
  )
    return { k: 'step', steps: ['squeeze'] };
  if (r.k === 'inf' && r.s > 0 && m.some((h) => h?.k === 'inf' && h.s > 0))
    return { k: 'step', steps: ['comparison'] };
  if (r.k === 'inf' && r.s < 0 && p.some((h) => h?.k === 'inf' && h.s < 0))
    return { k: 'step', steps: ['comparison'] };
  let g = aq(t, e.P, n);
  return g
    ? {
        k: 'jump',
        message: `C\u2019est juste, mais \xAB ${g} \xBB est une forme ind\xE9termin\xE9e : montre comment la lever (factoriser, simplifier\u2026). Tu peux garder cette ligne sans HORA.`,
      }
    : { k: 'jump' };
}
function kz(e, n, t, r) {
  let s = kr(n.atoms);
  if (e.givenTexts.has(s))
    return {
      kind: 'useless',
      ...n,
      title: 'C\u2019est l\u2019\xE9nonc\xE9',
      message: 'Cette ligne est d\xE9j\xE0 dans l\u2019\xE9nonc\xE9.',
    };
  let i = T0(e),
    o = $v(s),
    a = [],
    l = null,
    u = !1;
  t.forEach((f) => o.terms.push([ce(f), f]));
  for (let f = 1; f < t.length; f++) {
    let d = $0(e, i, t[f - 1], t[f]);
    if (d.k === 'false') return ts(e, n, { title: d.title, message: d.message });
    (d.k === 'step' && a.push(...d.steps),
      Gp(i, ce(t[f - 1]), ce(t[f])),
      o.eqs.push([ce(t[f - 1]), ce(t[f])]));
  }
  if (r) {
    let f = t[t.length - 1],
      d = fq(e, i, f, r);
    if (d.k === 'false') return ts(e, n, { title: d.title, message: d.message });
    if (
      (d.k === 'step' && a.push(...d.steps),
      d.k === 'jump' && (l = d.message),
      d.k === 'unknown' && (u = !0),
      d.k !== 'unknown')
    ) {
      let m = Yi(f, e.P, { lookup: Tv(i) }).v,
        p = m && m.k === 'fin' && m.side ? m : r;
      (o.lims.push([ce(f), p]), i.lim.set(En(i, ce(f)), p));
    }
  }
  let c = e.equiv
    ? !e.concluded && Cv(e, i, e.equivs)
    : !!i.lim.get(En(i, e.targetKey)) && !e.lim.get(En(e, e.targetKey));
  return u
    ? {
        kind: 'useless',
        ...n,
        unknown: !0,
        title: 'Je ne sais pas encore v\xE9rifier ce passage',
        message: 'Ta ligne reste sur la feuille, sans HORA.',
        lmove: o,
      }
    : l !== null
      ? R0(n, o, c, l)
      : a.length
        ? Rv(n, a, o, c)
        : {
            kind: 'useless',
            ...n,
            title:
              t.length > 1 && !r ? 'Juste, mais \xE7a ne t\u2019avance pas' : 'Rien de nouveau',
            message:
              t.length > 1 && !r
                ? 'Les deux \xE9critures sont \xE9gales, mais la limite ne se lit pas mieux. Cherche une \xE9criture qui n\u2019est plus une forme ind\xE9termin\xE9e.'
                : 'Cette limite est d\xE9j\xE0 \xE9crite.',
            lmove: o,
            final: c,
          };
}
function Cd(e) {
  switch (e.k) {
    case 'add':
    case 'mul':
      return 1 + e.c.reduce((n, t) => n + Cd(t), 0);
    case 'fn':
      return 1 + Cd(e.a);
    case 'div':
    case 'pow':
    case 'binom':
      return 1 + Cd(e.a) + Cd(e.b);
    default:
      return 1;
  }
}
function x0(e) {
  return e.k === 'add' ? e.c.flatMap(x0) : [e];
}
function hc(e) {
  switch (e.k) {
    case 'fn':
      return (e.f === 'ln' ? 1 : 0) + hc(e.a);
    case 'add':
    case 'mul':
      return e.c.reduce((n, t) => n + hc(t), 0);
    case 'div':
    case 'pow':
    case 'binom':
      return hc(e.a) + hc(e.b);
    default:
      return 0;
  }
}
function dq(e, n, t) {
  let r = new Set([En(e, t)]),
    s = [],
    i = new Set(),
    o = !0;
  for (; o; )
    ((o = !1),
      n.forEach(([a, l], u) => {
        if (i.has(u)) return;
        let c = En(e, a),
          f = En(e, ce(l));
        (r.has(c) || r.has(f)) && (i.add(u), s.push(l), r.add(c), r.add(f), (o = !0));
      }));
  return { roots: r, terms: s };
}
function Cv(e, n, t) {
  if (!e.equiv) return !1;
  let { roots: r, terms: s } = dq(n, t, e.targetKey);
  return r.has(En(n, ce(e.equiv))) ? !0 : s.some((i) => Nr(i, e.equiv, e.P));
}
var lq = 'un d\xE9veloppement limit\xE9, un \xE9quivalent de r\xE9f\xE9rence ou le terme dominant.';
function xz(e, n, t, r, s, i, o) {
  let a = (h, b, v) => ({
    kind: 'syntax',
    atoms: r,
    title: h,
    message: b,
    badChip: v !== void 0 && t[v] !== void 0 ? t[v] : n.length - 1,
  });
  if (!e.equiv)
    return a(
      'Pas d\u2019\xE9quivalent ici',
      'Cette feuille cherche une limite : \xE9cris \xAB expression \u2192 limite \xBB.',
    );
  if (r.filter((h) => h === hi).length > 1)
    return a(
      'Un seul \xAB \u223C \xBB',
      'Un \xE9quivalent par ligne : \xAB expression \u223C \xE9quivalent \xBB.',
    );
  let l = r.indexOf(hi);
  if (l === 0)
    return a(
      '\xC7a commence mal',
      '\xC9cris d\u2019abord l\u2019expression, puis \xAB \u223C \xBB et son \xE9quivalent.',
      0,
    );
  if (r.includes(Ns) || r.some((h) => Md.has(h)))
    return a(
      'Une chose par ligne',
      'Un \xE9quivalent s\u2019\xE9crit seul sur sa ligne, sans \xAB \u2192 \xBB ni in\xE9galit\xE9.',
    );
  let u = r.slice(0, l),
    c = r.slice(l + 1),
    f = r.findIndex((h) => bv.has(h));
  if (f >= 0)
    return a(
      '\u221E n\u2019est pas un nombre',
      '\xAB +\u221E \xBB s\u2019\xE9crit seulement comme une limite.',
      f,
    );
  let d = vn(u, { chains: !0 });
  if (!d.ok)
    return s
      ? { kind: 'building', atoms: r, complete: !1 }
      : a('\xC7a commence mal', d.msg, d.index);
  if (!d.complete || !c.length) return i();
  let m = vn(c, { chains: !0 });
  if (!m.ok)
    return s
      ? { kind: 'building', atoms: r, complete: !1 }
      : a('\xC7a ne se lit pas', m.msg, l + 1 + m.index);
  if (!m.complete) return i();
  let p = Ed(u, '=').map(rs),
    g = Ed(c, '=').map(rs);
  return [...p, ...g].some((h) => !h)
    ? a('\xC7a ne se lit pas', 'Une expression ne se lit pas : v\xE9rifie les parenth\xE8ses.')
    : [...p, ...g].some((h) => fn(h))
      ? a(
          'Sans reste',
          'Un \xE9quivalent s\u2019\xE9crit sans o(\u2026) : \xAB expression \u223C x\xB2 \xF7 2 \xBB.',
        )
      : yz(e, { atoms: r, line: vv(r) }, p, g);
}
function yz(e, n, t, r) {
  let s = kr(n.atoms);
  if (e.givenTexts.has(s))
    return {
      kind: 'useless',
      ...n,
      title: 'C\u2019est l\u2019\xE9nonc\xE9',
      message: 'Cette ligne est d\xE9j\xE0 dans l\u2019\xE9nonc\xE9.',
    };
  let i = e.P,
    o = T0(e),
    a = $v(s);
  a.equivs = [];
  let l = [];
  [...t, ...r].forEach((v) => a.terms.push([ce(v), v]));
  for (let v = 1; v < t.length; v++) {
    let k = $0(e, o, t[v - 1], t[v]);
    if (k.k === 'false') return ts(e, n, { title: k.title, message: k.message });
    (k.k === 'step' && l.push(...k.steps),
      Gp(o, ce(t[v - 1]), ce(t[v])),
      a.eqs.push([ce(t[v - 1]), ce(t[v])]));
  }
  for (let v = 1; v < r.length; v++) {
    if (!Nr(r[v - 1], r[v], i))
      return ts(e, n, {
        title: 'Pas la m\xEAme expression',
        message:
          'Apr\xE8s \xAB \u223C \xBB, les \xE9critures reli\xE9es par \xAB = \xBB doivent \xEAtre \xE9gales.',
      });
    (Gp(o, ce(r[v - 1]), ce(r[v])), a.eqs.push([ce(r[v - 1]), ce(r[v])]));
  }
  let u = t[t.length - 1],
    c = r[0];
  if (h0(c, i))
    return ts(e, n, {
      title: 'Rien n\u2019est \xE9quivalent \xE0 0',
      message:
        'Seule une fonction nulle est \xE9quivalente \xE0 0 : \xE9cris un \xE9quivalent qui n\u2019est pas 0.',
    });
  if (Nr(u, c, i))
    return {
      kind: 'useless',
      ...n,
      title: 'C\u2019est une \xE9galit\xE9',
      message:
        'Les deux \xE9critures sont \xE9gales : \xE9cris \xAB = \xBB. Un \xE9quivalent, lui, simplifie.',
      lmove: a,
    };
  let f = p0(u, c, i);
  if (!f)
    return {
      kind: 'useless',
      ...n,
      unknown: !0,
      title: 'Je ne sais pas encore v\xE9rifier ce passage',
      message: 'Ta ligne reste sur la feuille, sans HORA.',
      lmove: a,
    };
  if (!(f.k === 'fin' && Math.abs(f.v - 1) < 1e-9)) {
    let v = f.k === 'fin' && Math.abs(f.v) > 1e-9;
    return ts(
      e,
      n,
      v
        ? {
            title: 'Le coefficient ne va pas',
            message: 'Le quotient des deux ne tend pas vers 1 : v\xE9rifie le coefficient.',
          }
        : {
            title: 'Pas le m\xEAme ordre de grandeur',
            message:
              'Le quotient des deux ne tend pas vers 1 : v\xE9rifie la puissance, le terme qui l\u2019emporte.',
          },
    );
  }
  let d = dq(o, e.equivs, ce(u)),
    m = (v) => d.roots.has(En(o, ce(v))) || d.terms.some((k) => Nr(k, v, i));
  r.forEach((v) => a.equivs.push([ce(u), v]));
  let p = !e.concluded && Cv(e, o, [...e.equivs, ...a.equivs]);
  if (r.every(m) && !l.length)
    return {
      kind: 'useless',
      ...n,
      title: 'Rien de nouveau',
      message: 'Cet \xE9quivalent est d\xE9j\xE0 \xE9crit.',
      lmove: a,
      final: p,
    };
  let g = pc(u, c, i.x),
    h = !g.length || g.length > 2,
    b = [];
  if (!h)
    for (let [v, k] of g) {
      if (!g0(v, k, i)) {
        h = !0;
        break;
      }
      let y = sq(v, k, i, v === u, (S) => xv(o, ce(S)));
      if (!y) {
        h = !0;
        break;
      }
      b.push(y);
    }
  return h
    ? R0(
        n,
        a,
        p,
        p
          ? `C\u2019est le bon \xE9quivalent. Justifie-le : ${lq} Tu peux garder cette ligne sans HORA.`
          : `Ta ligne est juste. Justifie-la : ${lq} Tu peux la garder sans HORA.`,
      )
    : (l.push(...b), Rv(n, l, a, p));
}
function C0(e, n) {
  return n.k === 'inf'
    ? e.k === 'inf' && e.s === n.s
    : e.k === 'fin' && Math.abs(e.v - n.v) < 1e-9 * Math.max(1, Math.abs(n.v));
}
var y0 =
  'Ton d\xE9veloppement est juste, mais tu encha\xEEnes plusieurs calculs d\u2019un coup : \xE9cris-les un par un pour gagner des HORA. Tu peux garder cette ligne sans HORA.';
function wz(e, n, t, r) {
  let s = e.P.x,
    i = Math.max(Wi(r), Wi(t), 0) + 8,
    o = es(r, s, i);
  if (!o) return { k: 'unknown' };
  let a = fn(t) ? es(t, s, i) : Mp(t, s, o.e);
  if (!a) return { k: 'unknown' };
  let l = W1(a, o, Math.min(a.e, o.e));
  if (l !== null) {
    let m = sv(l, s);
    return {
      k: 'false',
      title: 'Un coefficient ne va pas',
      message: `${m[0].toUpperCase()}${m.slice(1)} ne va pas : reprends ce calcul.`,
    };
  }
  if (o.e > a.e)
    return {
      k: 'false',
      title: 'Trop pr\xE9cis',
      message: `L\u2019\xE9criture de gauche n\u2019est connue qu\u2019\xE0 ${ac(a.e, s)} pr\xE8s : tu ne peux pas \xE9crire ${ac(o.e, s)}.`,
    };
  if (!fn(t)) {
    let m = xv(n, ce(t));
    if (m && m.e >= o.e) return { k: 'none', serY: o, known: !0 };
  }
  let u = (m) => (fn(m) ? null : xv(n, ce(m))),
    c = null;
  for (let m of [!1, !0]) {
    for (let p = Math.max(o.e, 0) + 2; p <= Math.max(o.e, 0) + 12; p += 2) {
      let g = e0(t, { x: s, N: p, lookup: u, fresh: m });
      if (g && g.ser.e >= o.e) {
        c = g;
        break;
      }
    }
    if (c) break;
  }
  if (!c) return { k: 'jump', message: y0, serY: o };
  let f = e0(r, { x: s, N: i, lookup: u, fresh: !1 }),
    d = I_(c.steps, f?.steps ?? []);
  return d.length > 3
    ? { k: 'jump', message: y0, serY: o }
    : d.length
      ? { k: 'step', steps: d, serY: o }
      : { k: 'none', serY: o, known: !1 };
}
function Sz(e, n, t, r) {
  let s = kr(n.atoms),
    i = e.P.x;
  if (e.P.inf || Math.abs(e.P.a) > 1e-12)
    return {
      kind: 'syntax',
      ...n,
      title: 'En 0 seulement',
      message: 'Un d\xE9veloppement limit\xE9 s\u2019\xE9crit ici quand x tend vers 0.',
    };
  if (fn(t[0]))
    return {
      kind: 'syntax',
      ...n,
      title: 'L\u2019expression d\u2019abord',
      message:
        'Commence par l\u2019expression, puis son d\xE9veloppement : \xAB e\u02E3 = 1 + x + o(x) \xBB.',
    };
  for (let h of t) {
    let b = P_(h, i);
    if (b)
      return {
        kind: 'syntax',
        ...n,
        title: `Au-del\xE0, c\u2019est ${ac(b.k, i)}`,
        message: `${sv(b.d, i)[0].toUpperCase()}${sv(b.d, i).slice(1)} est d\xE9j\xE0 dans ${ac(b.k, i)} : arr\xEAte ton d\xE9veloppement \xE0 l\u2019ordre ${b.k}.`,
      };
  }
  let o = T0(e),
    a = $v(s),
    l = [],
    u = null,
    c = !1,
    f = !1,
    d = null,
    m = null,
    p = t[0];
  t.forEach((h) => {
    fn(h) || a.terms.push([ce(h), h]);
  });
  for (let h = 1; h < t.length; h++) {
    let b = t[h - 1],
      v = t[h];
    if (!fn(b) && !fn(v)) {
      let y = $0(e, o, b, v);
      if (y.k === 'false') return ts(e, n, { title: y.title, message: y.message });
      (y.k === 'step' && l.push(...y.steps),
        Gp(o, ce(b), ce(v)),
        a.eqs.push([ce(b), ce(v)]),
        (p = v));
      continue;
    }
    if (!fn(v))
      return ts(e, n, {
        title: 'Le reste ne dispara\xEEt pas',
        message:
          'Un o(\u2026) ne dispara\xEEt pas d\u2019un \xAB = \xBB : garde-le, ou \xE9cris la limite avec \xAB \u2192 \xBB sur une autre ligne.',
      });
    let k = wz(e, o, b, v);
    if (k.k === 'false') return ts(e, n, { title: k.title, message: k.message });
    if (k.k === 'unknown') {
      c = !0;
      continue;
    }
    (k.k === 'jump' && (u = k.message),
      k.k === 'step' && l.push(...k.steps),
      k.k === 'none' && k.known && (f = !0),
      d || (d = k.serY),
      (m = k.serY));
  }
  if ((d && !c && (a.dls.push([ce(p), d]), cq(o, ce(p), d)), r)) {
    let h = t[t.length - 1];
    if (fn(h)) {
      let b = m ? bd(m, e.P.side) : null;
      if (!b)
        return ts(e, n, {
          title: 'Pas assez pr\xE9cis',
          message: 'Avec ce reste, on ne lit pas la limite : il faut au moins un o(1).',
        });
      if (!C0(r, b))
        return ts(e, n, {
          title: 'Ce n\u2019est pas la limite',
          message: 'Lis la limite sur le d\xE9veloppement : o(1) tend vers 0.',
        });
      l.push('dlLimit');
      let v = b.k === 'fin' ? se(b.v) : { k: 'inf', s: b.s };
      (a.lims.push([ce(p), v]), o.lim.set(En(o, ce(p)), v));
    } else {
      let b = fq(e, o, h, r);
      if (b.k === 'false') return ts(e, n, { title: b.title, message: b.message });
      (b.k === 'step' && l.push(...b.steps),
        b.k === 'jump' && (u = b.message ?? y0),
        b.k === 'unknown' && (c = !0),
        b.k !== 'unknown' && (a.lims.push([ce(h), r]), o.lim.set(En(o, ce(h)), r)));
    }
  }
  let g = e.equiv
    ? !e.concluded && Cv(e, o, e.equivs)
    : !!o.lim.get(En(o, e.targetKey)) && !e.lim.get(En(e, e.targetKey));
  return c
    ? {
        kind: 'useless',
        ...n,
        unknown: !0,
        title: 'Je ne sais pas encore v\xE9rifier ce passage',
        message: 'Ta ligne reste sur la feuille, sans HORA.',
        lmove: a,
      }
    : u !== null
      ? R0(n, a, g, u)
      : l.length
        ? Rv(n, l, a, g)
        : {
            kind: 'useless',
            ...n,
            title: f ? 'Rien de nouveau' : 'Juste, continue',
            message: f
              ? 'Ce d\xE9veloppement est d\xE9j\xE0 \xE9crit.'
              : 'Ta ligne est juste : continue le calcul (r\xE9duire, diviser\u2026) pour gagner des HORA.',
            lmove: a,
            final: g,
          };
}
function Tz(e, n, t) {
  let r = e.P.x;
  if (fn(n[0])) return !1;
  let s = null;
  for (let i = 1; i < n.length; i++) {
    let o = n[i - 1],
      a = n[i];
    if (!fn(o) && !fn(a)) {
      if (!Nr(o, a, e.P)) return !1;
      continue;
    }
    if (!fn(a)) return !1;
    let l = Math.max(Wi(a), Wi(o), 0) + 8,
      u = es(a, r, l);
    if (!u) return !1;
    let c = fn(o) ? es(o, r, l) : Mp(o, r, u.e);
    if (!c || u.e > c.e || W1(c, u, u.e) !== null) return !1;
    s = u;
  }
  if (t) {
    let i = n[n.length - 1];
    if (fn(i)) {
      let a = s ? bd(s, e.P.side) : null;
      return !!a && C0(t, a);
    }
    let o = Yi(i, e.P).v;
    return !!o && gi(t, o);
  }
  return n.length > 1;
}
function Rz(e, n, t) {
  let r = kr(n.atoms),
    s = [[]],
    i = [],
    o = 0;
  for (let v of t)
    (v === '(' && o++,
      v === ')' && o--,
      o === 0 && Md.has(v) ? (i.push(v), s.push([])) : s[s.length - 1].push(v));
  let a = s.map(rs);
  if (a.some((v) => !v) || i.length > 2)
    return {
      kind: 'syntax',
      ...n,
      title: '\xC7a ne se lit pas',
      message: '\xC9cris \xAB a \u2264 u \u2264 b \xBB ou \xAB u \u2265 a \xBB.',
    };
  let l = a,
    u = i.every((v) => v === '<' || v === '\u2264'),
    c = i.every((v) => v === '>' || v === '\u2265');
  if (!u && !c)
    return {
      kind: 'syntax',
      ...n,
      title: 'Un seul sens',
      message: 'Un encadrement va dans un seul sens : \xAB a \u2264 u \u2264 b \xBB.',
    };
  for (let v = 0; v < i.length; v++) {
    let k = d0(l[v], i[v], l[v + 1], e.P);
    if (k === !1)
      return ts(e, n, {
        title: 'In\xE9galit\xE9 fausse',
        message: 'Cette in\xE9galit\xE9 n\u2019est pas vraie pr\xE8s du point : v\xE9rifie-la.',
      });
    if (k === null)
      return {
        kind: 'useless',
        ...n,
        unknown: !0,
        title: 'Je ne sais pas encore v\xE9rifier ce passage',
        message: 'Ta ligne reste sur la feuille, sans HORA.',
      };
  }
  let f = $v(r);
  l.forEach((v) => f.terms.push([ce(v), v]));
  let d = (v) => (u ? l[v] : l[v + 1]),
    m = (v) => (u ? l[v + 1] : l[v]),
    p;
  l.length === 3
    ? ((p = l[1]), f.lower.push([ce(p), u ? l[0] : l[2]]), f.upper.push([ce(p), u ? l[2] : l[0]]))
    : ((p = l[0]), u ? f.upper.push([ce(p), m(0)]) : f.lower.push([ce(p), d(0)]));
  let g = En(e, ce(p));
  if (e.lim.get(g) || !Oe(p, e.P.x))
    return {
      kind: 'useless',
      ...n,
      title: 'Juste, mais \xE0 c\xF4t\xE9',
      message: 'C\u2019est juste, mais \xE7a ne sert pas pour la question.',
      lmove: f,
    };
  let b = (v, k) => (v ?? []).some((y) => ce(y) === ce(k));
  return f.lower.every(([v, k]) => b(e.lower.get(En(e, v)), k)) &&
    f.upper.every(([v, k]) => b(e.upper.get(En(e, v)), k))
    ? {
        kind: 'useless',
        ...n,
        title: 'Rien de nouveau',
        message: 'Cet encadrement est d\xE9j\xE0 \xE9crit.',
        lmove: f,
      }
    : Rv(n, ['bound'], f, !1);
}
function Hp(e, n) {
  let t = n.lmove;
  if (!t) return;
  (e.written.add(t.text),
    e.lines++,
    t.terms.forEach(([s, i]) => {
      e.terms.has(s) || e.terms.set(s, i);
    }));
  let r = { parent: e.parent, lim: e.lim, lower: e.lower, upper: e.upper, dls: e.dls };
  (t.eqs.forEach(([s, i]) => Gp(r, s, i)),
    t.lims.forEach(([s, i]) => {
      let o = En(e, s);
      e.lim.has(o) || e.lim.set(o, i);
    }),
    (t.dls ?? []).forEach(([s, i]) => cq(e, s, i)),
    t.lower.forEach(([s, i]) => {
      let o = En(e, s);
      e.lower.set(o, [...(e.lower.get(o) ?? []), i]);
    }),
    t.upper.forEach(([s, i]) => {
      let o = En(e, s);
      e.upper.set(o, [...(e.upper.get(o) ?? []), i]);
    }),
    (t.equivs ?? []).forEach((s) => e.equivs.push(s)),
    e.equiv
      ? Cv(e, e, e.equivs) && (e.concluded = !0)
      : e.lim.get(En(e, e.targetKey)) && (e.concluded = !0));
}
function mq(e) {
  return e.concluded;
}
function $z(e) {
  let n;
  try {
    n = Or(e);
  } catch {
    return null;
  }
  let t = n.indexOf(hi);
  if (t >= 0) {
    let a = Ed(n.slice(0, t), '=').map(rs),
      l = Ed(n.slice(t + 1), '=').map(rs);
    return !a.length || !l.length || [...a, ...l].some((u) => !u)
      ? null
      : { members: a, value: null, bound: null, equiv: l };
  }
  let r = n.indexOf(Ns),
    s = r < 0 ? n : n.slice(0, r);
  if (s.some((a) => Md.has(a))) {
    let a = [[]],
      l = [],
      u = 0;
    for (let f of s)
      (f === '(' && u++,
        f === ')' && u--,
        u === 0 && Md.has(f) ? (l.push(f), a.push([])) : a[a.length - 1].push(f));
    let c = a.map(rs);
    return c.some((f) => !f) ? null : { members: [], value: null, bound: { terms: c, rels: l } };
  }
  let i = Ed(s, '=').map(rs);
  if (i.some((a) => !a)) return null;
  let o = r >= 0 ? S0(n.slice(r + 1)) : null;
  return r >= 0 && !o ? null : { members: i, value: o, bound: null };
}
function Ev(e, n) {
  let t = $z(n);
  if (!t) return !1;
  if (t.equiv) {
    if ([...t.members, ...t.equiv].some(fn)) return !1;
    for (let s of [t.members, t.equiv])
      for (let i = 1; i < s.length; i++) if (!Nr(s[i - 1], s[i], e.P)) return !1;
    return g0(t.members[t.members.length - 1], t.equiv[0], e.P);
  }
  if (t.bound) {
    let { terms: r, rels: s } = t.bound;
    return s.every((i, o) => d0(r[o], i, r[o + 1], e.P) === !0);
  }
  if (t.members.some(fn)) return e.dl && Tz(e, t.members, t.value);
  for (let r = 1; r < t.members.length; r++)
    if (!Nr(t.members[r - 1], t.members[r], e.P)) return !1;
  if (t.value) {
    let r = Yi(t.members[t.members.length - 1], e.P).v;
    return !!r && gi(t.value, r);
  }
  return t.members.length > 1;
}
var Cz = (e) => e.map((n) => ({ atoms: [n], text: n }));
function w0(e, n) {
  let t = Zp(e, n),
    r = [];
  for (let s of t.path) {
    let i = Or(s),
      o = vc(t, Cz(i), { verify: !0 });
    if (o.kind !== 'step') break;
    (Hp(t, o), r.push({ line: wv(s), text: kr(i), atoms: i, v: o }));
  }
  return { lines: r, reached: t.concluded };
}
var Ez = /arc(?:tan|sin|cos)/,
  uq = new WeakMap();
function pq(e) {
  let n = uq.get(e);
  if (n !== void 0) return n;
  let t = !1,
    r = e.kernel;
  if (r)
    if ([r.start, r.answer, ...(r.path ?? [])].some((i) => Ez.test(i))) t = !0;
    else
      try {
        let i = w0(e),
          o = w0(e, { v54: !0 }),
          a = (l) =>
            JSON.stringify([
              l.reached,
              l.lines.map((u) => [u.text, u.v.kind, u.v.hora ?? 0, u.v.rule?.id ?? '']),
            ]);
        t = a(i) !== a(o);
      } catch {
        t = !1;
      }
  return (uq.set(e, t), t);
}
var Mz = 3,
  _z = 5,
  qz = 6;
var Lz = 10,
  Nz = 11,
  Oz = 12,
  Kz = 13,
  Pz = 14,
  Iz = 15,
  Az = 16,
  jz = 17,
  Qz = 18,
  Fz = 19;
function Vz(e) {
  let n = e.kernel;
  return n
    ? [
        n.start ?? '',
        n.answer ?? '',
        ...(n.path ?? []),
        ...(e.traps ?? []).map((r) => r?.line ?? ''),
        ...(e.choices ?? []).map((r) => r?.line ?? ''),
      ].some((r) => /\b(exp|ln)\b/.test(r) || /\^\s*\(?\s*[−-]?\s*[A-Za-zα-ωπ]/.test(r))
    : !1;
}
var Dz = 20;
function Bz(e) {
  let n = e.kernel;
  return n
    ? e.rounding || n.goal?.kind === 'simplify'
      ? !0
      : [
          n.start ?? '',
          n.answer ?? '',
          ...(n.path ?? []),
          ...(e.traps ?? []).map((r) => r?.line ?? ''),
          ...(e.choices ?? []).map((r) => r?.line ?? ''),
        ].some((r) => /√|\b(cos|sin|tan)\b/.test(r))
    : !1;
}
var zz = 21;
function Uz(e) {
  let n = e.kernel;
  return n
    ? (n.hypotheses ?? []).some((r) => r?.kind === 'acute' || r?.kind === 'angle')
      ? !0
      : [
          n.start ?? '',
          n.answer ?? '',
          ...(n.path ?? []),
          ...(e.traps ?? []).map((r) => r?.line ?? ''),
          ...(e.choices ?? []).map((r) => r?.line ?? ''),
        ].some((r) => /\barc(cos|sin|tan)\b/.test(r))
    : !1;
}
var Gz = 22;
function Zz(e) {
  return !!e.kernel?.system;
}
var Hz = 23,
  Wz = ['factor', 'trig', 'test'],
  Jz = /[<>≤≥][^=≈]*[<>≤≥]|[<>≤≥].*\bou\b|\bou\b.*[<>≤≥]/;
function _0(e) {
  let n = e.kernel;
  return n
    ? n.method === 'factor'
      ? !0
      : n.method === 'trig' || n.method === 'test'
        ? !1
        : [
            n.start ?? '',
            n.answer ?? '',
            ...(n.path ?? []),
            ...(e.traps ?? []).map((r) => r?.line ?? ''),
            ...(e.choices ?? []).map((r) => r?.line ?? ''),
          ].some((r) => Jz.test(r))
    : !1;
}
var Xz = 24;
function q0(e) {
  let n = e.kernel;
  return (
    !!n &&
    n.plugin !== 'analysis' &&
    n.plugin !== 'variations' &&
    (n.method === 'trig' || !!n.domain)
  );
}
var Yz = 25;
function e3(e) {
  let n = e.kernel;
  return !!n && n.plugin === 'geometry';
}
var n3 = 26;
function t3(e) {
  return !!e.kernel?.induction;
}
var gq = 27,
  r3 = 28;
function s3(e) {
  let n = e.kernel;
  return !!n && n.plugin === 'python';
}
var i3 = 29,
  o3 = 30;
function a3(e) {
  let n = e.kernel;
  return !!n && n.plugin === 'matrix';
}
var l3 = 31;
function vq(e) {
  let n = e.kernel;
  return !!n && n.plugin === 'analysis';
}
function u3(e) {
  let n = e.kernel;
  if (n?.plugin !== 'algebra' || !n.start) return !1;
  let t = ie(n.start);
  if (!t.ok) return !1;
  let r = n.goal?.target ?? 'x',
    s = (a) => {
      try {
        let l = Ys(Ge(a).n, r);
        return l ? l.length - 1 : 0;
      } catch {
        return 0;
      }
    },
    i = (a) => {
      switch (a.k) {
        case 'div':
          return s(a.b) >= 4 || i(a.a) || i(a.b);
        case 'add':
        case 'mul':
          return a.c.some(i);
        case 'pow':
        case 'binom':
          return i(a.a) || i(a.b);
        case 'fn':
          return i(a.a);
        default:
          return !1;
      }
    },
    o = t.s;
  return o.k === 'expr' ? i(o.e) : on(o).some((a) => i(a.l) || i(a.r));
}
function c3(e) {
  let n = e.kernel;
  return vq(e) && /′′|″|''/.test(n?.goal?.target ?? '');
}
var f3 = 32;
function d3(e) {
  return e.kernel?.plugin === 'formula';
}
var m3 = 33;
function p3(e) {
  return !!e.kernel?.form;
}
var g3 = 34,
  h3 = ['units', 'congruence', 'complex', 'bounds'],
  hq = { units: 'convert', congruence: 'residue', complex: 'calculate', bounds: 'bound' };
function Mv(e) {
  let n = e.kernel?.plugin;
  return h3.includes(n ?? '') ? n : null;
}
function b3(e) {
  return Mv(e) !== null;
}
var v3 = 35;
function k3(e) {
  return e.kernel?.plugin === 'arith';
}
var x3 = 36;
function y3(e) {
  return e.kernel?.plugin === 'claims';
}
var w3 = 37;
function S3(e) {
  let n = e.kernel;
  if (n?.plugin !== 'claims') return !1;
  let t = n.path ?? [];
  return cC(t) || mC([...t, ...(n.claims ?? []).flatMap((r) => r.rels)]);
}
var T3 = 38,
  R3 = /\d,\d{7,}|\d{17,}/,
  $3 = 39,
  C3 = 40,
  E3 = 41,
  M3 = 42,
  _3 = 42;
function q3(e) {
  return e.kernel?.plugin === 'variations';
}
var L3 = 42,
  N3 = 43;
function O3(e) {
  return e.kernel?.form === 'canonical';
}
var K3 = 44;
function P3(e) {
  let n = e.kernel;
  return n?.plugin === 'analysis' && (n.goal?.kind === 'tangent' || !!n.condition);
}
var I3 = 45,
  A3 = 46;
function j3(e) {
  return e.kernel?.form === 'fraction';
}
var _v = 47,
  Q3 = 48;
function F3(e) {
  return e.kernel?.method === 'test';
}
var V3 = 49;
function L0(e) {
  return !!e.kernel?.conditions?.length;
}
var D3 = 50,
  B3 = 51;
function z3(e) {
  let n = e.kernel;
  return n?.plugin === 'arith' && (n.goal?.kind === 'gcd_primes' || n.goal?.kind === 'lcm');
}
var U3 = 52,
  G3 = 53;
function Z3(e) {
  let n = e.kernel;
  if (n?.plugin !== 'claims') return !1;
  let t = n.path ?? [],
    r = n.claims ?? [];
  return (
    r.some((s) => sC(s)) ||
    rC(t) ||
    WE(t) ||
    HE([...t, ...r.filter((s) => !(s.at && Object.keys(s.at).length)).flatMap((s) => s.rels)])
  );
}
var H3 = 54;
function N0(e) {
  return e.kernel?.plugin === 'limit';
}
var W3 = 55;
function J3(e) {
  return e.kernel?.plugin === 'integral';
}
var X3 = 56;
function Y3(e) {
  return N0(e) ? pq(e) : !1;
}
var eU = 57;
function nU(e) {
  return e.kernel?.plugin === 'limclaims';
}
var tU = 58;
function rU(e) {
  return N0(e) ? kv(e) : !1;
}
var sU = 59;
function iU(e) {
  return e.kernel?.plugin === 'riemann';
}
var oU = 60,
  aU = /\barc(?:tan|sin|cos)\s*\(/;
function lU(e) {
  let n = e.kernel;
  return !n || !['integral', 'riemann', 'analysis'].includes(n.plugin ?? '')
    ? !1
    : [
        n.start ?? '',
        n.answer ?? '',
        n.condition ?? '',
        ...(n.path ?? []),
        ...(e.givens ?? []),
        ...(e.traps ?? []).map((t) => t.line ?? ''),
        ...(e.choices ?? []).map((t) => t.line ?? ''),
      ].some((t) => typeof t == 'string' && aU.test(t));
}
var uU = 61;
function cU(e) {
  let n = e.kernel;
  return n?.plugin !== 'limit'
    ? !1
    : [
        n.start ?? '',
        n.answer ?? '',
        ...(n.path ?? []),
        ...(e.givens ?? []),
        ...(e.traps ?? []).map((t) => t.line ?? ''),
        ...(e.choices ?? []).map((t) => t.line ?? ''),
      ].some((t) => typeof t == 'string' && /[∼~]/.test(t));
}
var fU = 62;
function dU(e) {
  return e.kernel?.plugin === 'ode';
}
var mU = 63;
function pU(e) {
  let n = e.kernel;
  if (!n) return !1;
  if (n.plugin === 'ode') {
    if (n.ode?.variable && n.ode.variable !== 'x') return !0;
    let t = (n.goal?.target ?? 'y').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return new RegExp(`^\\s*${t}\\(`).test(n.answer ?? '');
  }
  return (
    n.plugin === 'analysis' &&
    n.goal?.kind === 'antiderivative' &&
    !n.condition &&
    /^[^=]*[′']\s*\(/.test(n.start ?? '')
  );
}
var gU = 64;
function hU(e) {
  return e.kernel?.plugin === 'partial';
}
function bU(e) {
  let n = e.kernel;
  return n?.plugin !== 'matrix'
    ? !1
    : [
        n.start ?? '',
        n.answer ?? '',
        n.goal?.target ?? '',
        ...(n.path ?? []),
        ...(e.traps ?? []).map((r) => r.line ?? ''),
        ...(e.choices ?? []).map((r) => r.line ?? ''),
      ].some((r) => g_.test(r));
}
function vU(e) {
  let n = e.kernel;
  return n?.plugin !== 'python'
    ? !1
    : [
        n.answer ?? '',
        ...(n.path ?? []),
        ...(n.program?.checks ?? []),
        ...(e.traps ?? []).map((r) => r.line ?? ''),
        ...(e.choices ?? []).map((r) => r.line ?? ''),
      ].some((r) => /=\s*\[/.test(r));
}
function kU(e) {
  let n = e.kernel;
  if (n?.plugin !== 'claims') return !1;
  let t = n.claims ?? [],
    r = !t.some((s) => s.at && 'e' in s.at);
  return t.some(
    (s) =>
      !(s.at && Object.keys(s.at).length) &&
      !K0(s) &&
      s.rels.some((i) => {
        let o = ie(i);
        return o.ok ? [...Dn(o.s)].some((a) => a !== '\u03C0' && !(r && a === 'e')) : !1;
      }),
  );
}
function xU(e) {
  let n = e.kernel;
  if (!n || n.plugin !== 'algebra') return !1;
  if (n.auxiliary || (n.minEngine ?? 0) >= _v) return !0;
  let t = n.goal?.target ?? 'x';
  return [
    n.start ?? '',
    n.answer ?? '',
    ...(n.path ?? []),
    ...(e.choices ?? []).map((s) => s.line ?? ''),
  ].some((s) => /\blog\(/.test(s) || yU(s, t));
}
function yU(e, n) {
  let t = ie(e);
  if (!t.ok) return !1;
  let r = (i) =>
      (i.k === 'fn' && i.f === 'ln' && _d(i.a, n)) ||
      (i.k === 'mul' && i.c.some((o) => o.k === 'fn' && o.f === 'ln' && _d(o.a, n))),
    s = (i) => {
      if (i.k === 'add' && i.c.filter(r).length >= 2) return !0;
      switch (i.k) {
        case 'add':
        case 'mul':
          return i.c.some(s);
        case 'div':
        case 'pow':
        case 'binom':
          return s(i.a) || s(i.b);
        case 'fn':
          return s(i.a);
        default:
          return !1;
      }
    };
  return on(t.s).some((i) => s(i.l) || s(i.r));
}
function _d(e, n) {
  switch (e.k) {
    case 'sym':
      return e.n === n;
    case 'num':
      return !1;
    case 'add':
    case 'mul':
      return e.c.some((t) => _d(t, n));
    case 'div':
    case 'pow':
    case 'binom':
      return _d(e.a, n) || _d(e.b, n);
    case 'fn':
      return _d(e.a, n);
  }
}
function wU(e) {
  let n = e.kernel;
  if (n?.plugin !== 'claims') return !1;
  let t = n.path ?? [],
    r = !(n.claims ?? []).some((i) => i.at && 'e' in i.at),
    s = [...t, ...(n.claims ?? []).flatMap((i) => i.rels)];
  return uC(t) || (r && s.some((i) => lC.test(i))) || s.some((i) => /ln\(\s*(−|-|0\s*\))/.test(i));
}
function SU(e) {
  return e.kernel?.plugin === 'tables';
}
function TU(e) {
  let n = e.kernel;
  return (
    Array.isArray(n?.path) && n.path.some((t) => typeof t == 'string' && t.startsWith('\u229E'))
  );
}
function RU(e) {
  let n = e.kernel;
  return n?.plugin === 'claims' && kM(n.path ?? []);
}
function $U(e, n) {
  let t = ie(e);
  return t.ok && t.s.k === 'rel' && ui(t.s, n) === 'cube';
}
function CU(e) {
  let n = e.kernel;
  return n?.plugin !== 'claims'
    ? !1
    : !!n.single || (n.claims ?? []).some((t) => K0(t)) || dC(n.path ?? []);
}
function EU(e) {
  let n = e.kernel;
  return n?.plugin !== 'claims'
    ? !1
    : (n.claims ?? []).some((t) => !!t.form) || fC(n.path ?? []) || MU(n.claims ?? []);
}
function MU(e) {
  let n = new Map(),
    t = !1;
  return (
    e.forEach((r, s) => {
      if (!(!r.at || !Object.keys(r.at).length))
        for (let i of r.rels ?? [])
          for (let o of i.split(/[=<>≤≥]/)) {
            let a = o.replace(/\s+/g, '');
            if (!Object.keys(r.at).some((u) => a.includes(u))) continue;
            let l = n.get(a);
            l !== void 0 && l !== s ? (t = !0) : n.set(a, s);
          }
    }),
    t
  );
}
function _U(e) {
  let n = e.kernel;
  return n?.form
    ? [n.start ?? '', n.answer ?? '', ...(n.path ?? [])].some((t) => /e\^|exp\(/.test(t))
    : !1;
}
function qU(e) {
  if (!e.kernel) return !1;
  let n = e.kernel;
  return [
    ...kq(e),
    ...(n.claims ?? []).flatMap((r) => [...(r.rels ?? []), ...Object.values(r.at ?? {})]),
  ].some((r) => R3.test(r));
}
function kq(e) {
  let n = e,
    t = n.kernel;
  return [
    t?.start ?? '',
    t?.answer ?? '',
    ...(t?.path ?? []),
    ...(t?.givens ?? []),
    ...Object.keys(n.symbols ?? {}),
    ...Object.values(n.symbols ?? {}).flatMap((r) => r?.exact ?? []),
    ...(n.givens ?? []),
    ...(n.admitted ?? []),
    ...(n.answers ?? []),
    ...(n.preds ?? []).map((r) => r?.line ?? ''),
    ...(n.traps ?? []).map((r) => r?.line ?? ''),
    ...(n.checks ?? []).map((r) => r?.line ?? ''),
    ...(n.choices ?? []).map((r) => r?.line ?? ''),
  ];
}
function LU(e) {
  return kq(e).some((n) => /(^|[^A-Za-zÀ-ÿ])parmi([^A-Za-zÀ-ÿ]|$)/.test(n));
}
function NU(e) {
  let n = e.kernel;
  return n
    ? [n.start ?? '', n.answer ?? '', ...(n.path ?? [])].some(
        (r) => r.includes('!') || /(^|[^A-Za-zÀ-ÿ])parmi([^A-Za-zÀ-ÿ]|$)/.test(r),
      )
      ? !0
      : O0(n)
    : !1;
}
function O0(e) {
  let n = e.goal?.target;
  if (
    !n ||
    !e.answer ||
    !(e.hypotheses ?? []).some(
      (s) => (s?.kind === 'natural' || s?.kind === 'integer') && s?.of === n,
    )
  )
    return !1;
  let r = n.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return new RegExp(`^\\s*${r}\\s*[<>\u2264\u2265]\\s*[\u2212-]?\\d+\\s*$`).test(e.answer);
}
function OU(e) {
  let n = e;
  return [
    ...Object.keys(n.symbols ?? {}),
    ...Object.values(n.symbols ?? {}).flatMap((r) => r.exact ?? []),
    ...(n.givens ?? []),
    ...(n.admitted ?? []),
    ...(n.answers ?? []),
    ...(n.preds ?? []).map((r) => r.line ?? ''),
    ...(n.traps ?? []).map((r) => r.line),
    ...(n.checks ?? []).map((r) => r.line),
    ...(n.choices ?? []).map((r) => r.line ?? ''),
  ].some((r) => r.includes('!') || /(^|[^A-Za-z])card\(/.test(r));
}
var KU = 4,
  Kn = x.string().min(1).max(40),
  Ee = x.string().min(1).max(400),
  PU = x.object({
    given: x.boolean().optional(),
    tool: x.boolean().optional(),
    meaning: x.string().min(1).max(80).optional(),
    value: x.number().optional(),
    values: x.array(x.number()).max(8).optional(),
    kind: x.enum(['length', 'free', 'int']).optional(),
    exact: x.array(Ee).max(8).optional(),
  }),
  IU = x.object({
    line: Ee,
    title: x.string().min(1).max(120),
    why: x.string().min(1).max(600),
    misconception_id: x.string().min(1).max(80).optional(),
  }),
  AU = x.object({ skill: x.literal('pythagore'), right: Kn, hyp: Kn, sides: x.tuple([Kn, Kn]) }),
  jU = x.object({
    skill: x.literal('baisse'),
    base: x.union([x.number(), Kn]),
    taux: x.number().positive().max(100),
    remise: Kn,
    nouveau: Kn,
  }),
  QU = x.object({ skill: x.literal('produitNul') }),
  FU = x.object({ skill: x.literal('facteurCommun') }),
  VU = x.object({
    skill: x.literal('secondDegre'),
    a: Kn,
    b: Kn,
    c: Kn,
    delta: Kn,
    roots: x.tuple([Kn, Kn]),
    double: Kn.optional(),
  }),
  DU = x.object({ skill: x.literal('differenceCarres') }),
  BU = x.object({ skill: x.literal('carreParfait') }),
  zU = x.object({
    skill: x.literal('formule'),
    line: Ee,
    label: x.string().max(60).optional(),
    hora: x.number().int().min(1).max(6).optional(),
    why: x.string().max(600).optional(),
    hint: x.string().max(600).optional(),
    rule: x.string().max(80).optional(),
  }),
  UU = x.object({
    skill: x.literal('recurrence'),
    hyp: Ee,
    init: Ee,
    next: Ee,
    inst: x.array(Ee).max(4).optional(),
  }),
  GU = x.discriminatedUnion('skill', [AU, jU, QU, FU, VU, DU, BU, zU, UU]);
var ZU = x.object({
    id: x.string().max(64).optional(),
    label: x.string().min(1).max(200),
    correct: x.boolean(),
    line: Ee.optional(),
    value: x.number().optional(),
    exact: Ee.optional(),
  }),
  HU = x.object({
    vars: x.record(Kn, x.array(x.number()).min(1).max(16)),
    defs: x.array(Ee).max(8).optional(),
  }),
  WU = x.object({
    mod: x.number().int().min(2).max(1e5),
    target: Ee,
    residue: x.number().int().min(0).optional(),
    path: x.array(Ee).min(1).max(12),
  }),
  JU = x.object({
    target: Ee,
    path: x.array(Ee).min(1).max(12),
    form: x.enum(['algebraic', 'exponential']).optional(),
    unknown: Kn.optional(),
    solutions: x.array(Ee).max(6).optional(),
    defs: x.record(Kn, Ee).optional(),
  }),
  XU = x.object({
    target: Ee,
    unit: x.string().min(1).max(20),
    valueUnit: x.string().min(1).max(12).optional(),
    path: x.array(Ee).min(1).max(12),
  }),
  YU = x.object({ goal: Ee, path: x.array(Ee).min(1).max(12) }),
  eG = x
    .object({
      expr: Ee,
      lower: x.string().min(1).max(20).optional(),
      upper: x.string().min(1).max(20).optional(),
      path: x.array(Ee).min(1).max(12),
    })
    .refine((e) => e.lower !== void 0 || e.upper !== void 0, { message: 'au moins une borne' }),
  nG = ['positive', 'negative', 'nonzero', 'nonnegative', 'integer', 'natural', 'acute', 'angle'],
  tG = x.object({ kind: x.enum(nG), of: Ee }),
  rG = [
    'solve',
    'isolate_variable',
    'simplify',
    'solve_system',
    'prove',
    'trace',
    'complete',
    'compute',
    'differentiate',
    'antiderivative',
    'evaluate',
    'convert',
    'residue',
    'calculate',
    'bound',
    'gcd',
    'bezout',
    'gcd_primes',
    'lcm',
    'decide',
    'study',
    'fill',
    'tangent',
    'limit',
    'integrate',
    'riemann',
    'solve_ode',
    'partial',
  ],
  sG = [
    'algebra',
    'geometry',
    'python',
    'matrix',
    'analysis',
    'formula',
    'units',
    'congruence',
    'complex',
    'bounds',
    'arith',
    'claims',
    'variations',
    'tables',
    'limit',
    'integral',
    'limclaims',
    'riemann',
    'ode',
    'partial',
  ],
  iG = /^([A-Z]|π)[₀-₉]*(⁻¹|ᵀ|[⁰¹²³⁴⁵⁶⁷⁸⁹]+)?$/,
  oG = /^(True|False|[−-]?\d+(,\d+)?)$/,
  aG = x.object({
    code: x.string().min(1).max(2e3),
    call: x.string().min(3).max(120).optional(),
    watch: x.array(Kn).min(1).max(8).optional(),
    draws: x.array(x.string().regex(oG)).min(1).max(40).optional(),
    checks: x.array(Ee).min(1).max(6).optional(),
    output: x.array(x.string().min(1).max(200)).min(1).max(30).optional(),
    display: x.string().min(1).max(2e3).optional(),
  }),
  bq = x.number().finite().min(-1e3).max(1e3),
  E0 = x.tuple([bq, bq]),
  lG = x.object({
    points: x
      .record(x.string().regex(/^[A-Z]$/), E0)
      .refine((e) => Object.keys(e).length >= 2 && Object.keys(e).length <= 12, {
        message: '2 \xE0 12 points',
      }),
    lines: x.record(x.string().regex(/^[a-zΔ][₀-₉]*$/), x.tuple([E0, E0])).optional(),
  }),
  uG = ['unique', 'none', 'infinite'],
  cG = x.object({
    unknowns: x.array(Kn).min(2).max(3),
    equations: x.array(Ee).min(2).max(4),
    outcome: x.enum(uG),
  }),
  fG = x.object({
    hypothesis: Ee,
    variable: Kn.optional(),
    from: x.number().int().min(0).max(20).optional(),
  }),
  dG = x
    .object({
      rels: x.array(Ee).min(1).max(3),
      at: x
        .record(Kn, Ee)
        .refine((e) => Object.keys(e).length >= 1 && Object.keys(e).length <= 3, {
          message: '1 \xE0 3 lettres',
        })
        .optional(),
      form: x.enum(Y$).optional(),
      divisibleBy: x
        .string()
        .regex(/^[1-9]\d{0,5}$/)
        .refine((e) => Number(e) >= 2, { message: 'un diviseur \u2265 2' })
        .optional(),
      not: x.literal(!0).optional(),
    })
    .superRefine((e, n) => {
      if (K0(e)) {
        !!e.form == !!e.divisibleBy &&
          n.addIssue({
            code: x.ZodIssueCode.custom,
            path: ['form'],
            message:
              'une affirmation de propri\xE9t\xE9 (une \xE9criture seule) a UNE propri\xE9t\xE9 : `form` ou `divisibleBy`',
          });
        return;
      }
      ((e.divisibleBy || e.not || e.form === 'prime') &&
        n.addIssue({
          code: x.ZodIssueCode.custom,
          path: ['divisibleBy'],
          message:
            '\xAB nombre premier \xBB, `divisibleBy` et `not` vont avec une \xE9criture seule',
        }),
        e.form &&
          (e.rels.length !== 1 || !/=/.test(e.rels[0]) || /[<>≤≥]/.test(e.rels[0])) &&
          n.addIssue({
            code: x.ZodIssueCode.custom,
            path: ['form'],
            message: 'une forme va avec UNE \xE9galit\xE9 \xAB a = b \xBB',
          }));
    });
function K0(e) {
  return e.rels.length === 1 && !/[=<>≤≥≠]/.test(e.rels[0]);
}
var mG = [
    'increasing',
    'decreasing',
    'constant',
    'min',
    'max',
    'no_min',
    'no_max',
    'extrema',
    'no_extremum',
    'sign',
    'sequence',
    'other',
  ],
  pG = x.object({
    text: x.string().min(1).max(120),
    kind: x.enum(mG),
    on: x.array(Ee).max(3).optional(),
    at: x.array(Ee).min(1).max(6).optional(),
    value: Ee.optional(),
    local: x.literal(!0).optional(),
    sign: x.enum(['+', '\u2212', '0', 'change']).optional(),
    seq: x
      .array(x.enum(['increasing', 'decreasing']))
      .min(1)
      .max(4)
      .optional(),
  }),
  gG = ['series', 'proportion', 'cross', 'values', 'freq'],
  hG = x.object({
    kind: x.enum(gG),
    form: x.enum(['raw', 'counts', 'cumulative']).optional(),
    coef: x.literal(!0).optional(),
    exprs: x.array(x.string().min(1).max(40).nullable()).min(1).max(5).optional(),
    mod: x.number().int().min(2).max(20).optional(),
    percent: x.literal(!0).optional(),
  }),
  bG = [
    'value',
    'proportional',
    'not_proportional',
    'other',
    'pairs',
    'set',
    'within',
    'avoids',
    'reached',
    'same_rows',
    'largest',
    'same_freq',
  ],
  M0 = x.string().min(1).max(24),
  vG = x.object({
    text: x.string().min(1).max(120),
    kind: x.enum(bG),
    stats: x
      .record(x.string().min(1).max(40), x.string().min(1).max(40))
      .refine((e) => Object.keys(e).length <= 4, { message: '4 grandeurs au plus' })
      .optional(),
    pairs: x
      .array(x.tuple([M0, M0]))
      .min(1)
      .max(8)
      .optional(),
    values: x.array(M0).min(1).max(12).optional(),
    row: x.number().int().min(1).max(5).optional(),
    rows: x.tuple([x.number().int().min(1).max(5), x.number().int().min(1).max(5)]).optional(),
    cols: x.array(x.string().min(1).max(40)).min(1).max(8).optional(),
    places: x.number().int().min(0).max(6).optional(),
  }),
  kG = x.object({
    expr: x.string().min(1).max(200),
    x: x
      .string()
      .regex(/^[a-z]$/, { message: 'une lettre : \xAB x \xBB, \xAB n \xBB, \xAB t \xBB' }),
    point: x
      .string()
      .regex(/^([+−]∞|−?\d+(,\d+)?[⁺⁻]?)$/, {
        message:
          'un point : \xAB +\u221E \xBB, \xAB \u2212\u221E \xBB, \xAB 2 \xBB, \xAB 2\u207A \xBB, \xAB 0\u207B \xBB',
      }),
    value: x
      .string()
      .regex(/^([+−]∞|−?\d+(,\d+)?|0[⁺⁻])$/, {
        message:
          'une limite : \xAB +\u221E \xBB, \xAB \u2212\u221E \xBB, \xAB 0 \xBB, \xAB 3 \xBB, \xAB 0\u207A \xBB',
      }),
  }),
  xG = ['expanded', 'factored', 'canonical', 'fraction'],
  yG = ['exp', 'ln'],
  wG = x.object({
    name: x
      .string()
      .regex(/^[A-DF-Za-df-z]$/, {
        message: 'une lettre (\xAB X \xBB, \xAB u \xBB), pas \xAB e \xBB',
      }),
    of: x.enum(yG),
  }),
  SG = x.object({
    initial: x.array(Ee).max(2).optional(),
    variable: x
      .string()
      .regex(/^[a-z]$/, { message: 'la variable : une lettre minuscule (\xAB t \xBB)' })
      .optional(),
    constants: x
      .array(
        x
          .string()
          .regex(/^[A-Z][₀-₉]?$/, {
            message: 'une constante : \xAB C \xBB, \xAB A \xBB, \xAB C\u2081 \xBB',
          }),
      )
      .min(1)
      .max(3)
      .optional(),
  }),
  TG = x.object({
    curve: x
      .object({
        t: x
          .string()
          .regex(/^[a-z]$/, { message: 'la variable : une lettre minuscule (\xAB t \xBB)' }),
        g: x
          .string()
          .regex(/^[a-zA-Z]$/, { message: 'la fonction compos\xE9e : une lettre (\xAB g \xBB)' }),
        x: x.string().min(1).max(80),
        y: x.string().min(1).max(80),
      })
      .optional(),
  }),
  RG = x.object({
    plugin: x.enum(sG),
    goal: x.object({ kind: x.enum(rG), target: Kn }),
    start: Ee,
    answer: Ee,
    hypotheses: x.array(tG).max(6).optional(),
    path: x.array(Ee).min(1).max(40).optional(),
    system: cG.optional(),
    method: x.enum(Wz).optional(),
    form: x.enum(xG).optional(),
    domain: Ee.optional(),
    at: x
      .string()
      .regex(/^(−?\d+(,\d+)?|e|π)$/, {
        message: 'une abscisse : un nombre, \xAB e \xBB ou \xAB \u03C0 \xBB',
      })
      .optional(),
    point: x
      .string()
      .regex(/^([+−]∞|−?\d+(,\d+)?[⁺⁻]?)$/, {
        message:
          'un point : \xAB +\u221E \xBB, \xAB \u2212\u221E \xBB, \xAB 2 \xBB, \xAB 2\u207A \xBB, \xAB 0\u207B \xBB',
      })
      .optional(),
    condition: Ee.optional(),
    figure: lG.optional(),
    induction: fG.optional(),
    program: aG.optional(),
    matrices: x
      .record(x.string().regex(iG), Ee)
      .refine((e) => Object.keys(e).length <= 8, { message: '8 matrices au plus' })
      .optional(),
    claims: x.array(dG).min(2).max(8).optional(),
    single: x.literal(!0).optional(),
    vclaims: x.array(pG).min(2).max(8).optional(),
    table: hG.optional(),
    tclaims: x.array(vG).min(2).max(8).optional(),
    lclaims: x.array(kG).min(2).max(8).optional(),
    ode: SG.optional(),
    partial: TG.optional(),
    auxiliary: wG.optional(),
    minEngine: x.number().int().min(47).max(999).optional(),
    conditions: x.array(Ee).min(1).max(4).optional(),
  });
var $G = x.object({
    line: Ee,
    label: x.string().min(1).max(60),
    why: x.string().min(1).max(400),
    hora: x.number().int().min(1).max(6).optional(),
  }),
  CG = x.object({
    places: x.number().int().min(0).max(4),
    symbol: Kn.optional(),
    hora: x.number().int().min(1).max(6).optional(),
  }),
  EG = x
    .object({
      symbols: x.record(Kn, PU),
      goal: x.array(Kn).min(1).max(4),
      goalValues: x.array(x.number()).max(8).optional(),
      answers: x.array(Ee).max(8).optional(),
      aim: x.enum(['factor', 'expand']).optional(),
      stepwise: x.boolean().optional(),
      path: x.array(Ee).min(1).max(16).optional(),
      factorHint: x.string().max(300).optional(),
      givens: x.array(Ee).max(8).optional(),
      admitted: x.array(Ee).max(8).optional(),
      preds: x.array(GU).max(6).optional(),
      envs: x.array(x.record(Kn, x.number())).min(2).max(16).optional(),
      samples: HU.optional(),
      traps: x.array(IU).max(16).optional(),
      checks: x.array($G).max(6).optional(),
      choices: x.array(ZU).max(8).optional(),
      congruence: WU.optional(),
      complex: JU.optional(),
      units: XU.optional(),
      geometry: YU.optional(),
      rounding: CG.optional(),
      bounds: eG.optional(),
      kernel: RG.optional(),
    })
    .superRefine((e, n) => {
      if (
        (e.kernel &&
          (e.kernel.goal.kind === 'solve_system') != !!e.kernel.system &&
          n.addIssue({
            code: 'custom',
            path: ['kernel', 'system'],
            message:
              'un syst\xE8me (`system`) va avec l\u2019objectif solve_system, et seulement lui',
          }),
        e.kernel?.system &&
          !e.kernel.system.unknowns.includes(e.kernel.goal.target) &&
          n.addIssue({
            code: 'custom',
            path: ['kernel', 'goal', 'target'],
            message: `l'inconnue ${e.kernel.goal.target} doit \xEAtre une inconnue du syst\xE8me`,
          }),
        e.kernel?.conditions &&
          (e.kernel.plugin !== 'algebra' ||
            e.kernel.goal.kind !== 'solve' ||
            e.kernel.auxiliary ||
            e.kernel.method === 'test' ||
            e.kernel.method === 'trig') &&
          n.addIssue({
            code: 'custom',
            path: ['kernel', 'conditions'],
            message:
              'des conditions (`conditions`) vont avec le plugin \xAB algebra \xBB et l\u2019objectif solve (sans inconnue auxiliaire, ni m\xE9thode \xAB test \xBB ou \xAB trig \xBB)',
          }),
        e.kernel?.method &&
          e.kernel.goal.kind !== 'solve' &&
          n.addIssue({
            code: 'custom',
            path: ['kernel', 'method'],
            message: `la m\xE9thode \xAB ${e.kernel.method} \xBB r\xE9sout une \xE9quation ou une in\xE9quation (objectif solve)`,
          }),
        e.kernel?.form &&
          (e.kernel.plugin !== 'algebra' || e.kernel.goal.kind !== 'simplify' || !e.kernel.path) &&
          n.addIssue({
            code: 'custom',
            path: ['kernel', 'form'],
            message:
              'une forme (`form`) va avec le plugin \xAB algebra \xBB, l\u2019objectif simplify et un corrig\xE9 (`path`)',
          }),
        e.kernel?.domain &&
          e.kernel.method !== 'trig' &&
          e.kernel.plugin !== 'analysis' &&
          e.kernel.plugin !== 'variations' &&
          e.kernel.plugin !== 'ode' &&
          n.addIssue({
            code: 'custom',
            path: ['kernel', 'domain'],
            message:
              'un intervalle (`domain`) va avec la m\xE9thode \xAB trig \xBB ou les plugins \xAB analysis \xBB, \xAB variations \xBB et \xAB ode \xBB',
          }),
        e.kernel)
      ) {
        let t = e.kernel.plugin === 'analysis',
          r =
            e.kernel.goal.kind === 'differentiate' ||
            e.kernel.goal.kind === 'antiderivative' ||
            e.kernel.goal.kind === 'tangent';
        (t !== r &&
          n.addIssue({
            code: 'custom',
            path: ['kernel', 'goal', 'kind'],
            message:
              'les objectifs differentiate, antiderivative et tangent vont avec le plugin \xAB analysis \xBB, et lui seul',
          }),
          (e.kernel.goal.kind === 'tangent') != !!e.kernel.at &&
            n.addIssue({
              code: 'custom',
              path: ['kernel', 'at'],
              message:
                'l\u2019abscisse du point (`at`) va avec l\u2019objectif tangent, et lui seul',
            }),
          e.kernel.condition &&
            e.kernel.goal.kind !== 'antiderivative' &&
            n.addIssue({
              code: 'custom',
              path: ['kernel', 'condition'],
              message: 'une condition (`condition`) va avec l\u2019objectif antiderivative',
            }),
          t &&
            (e.kernel.method ||
              e.kernel.system ||
              e.kernel.hypotheses?.length ||
              e.kernel.figure ||
              e.kernel.induction ||
              e.kernel.program ||
              e.kernel.matrices ||
              e.rounding ||
              !e.kernel.path?.length) &&
            n.addIssue({
              code: 'custom',
              path: ['kernel'],
              message:
                'une d\xE9riv\xE9e ou une primitive a son corrig\xE9 (`path`), sans m\xE9thode, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme, matrices ni arrondi',
            }));
      }
      if (e.kernel) {
        let t = e.kernel.plugin === 'python',
          r = e.kernel.goal.kind === 'trace' || e.kernel.goal.kind === 'complete';
        (t !== !!e.kernel.program || t !== r) &&
          n.addIssue({
            code: 'custom',
            path: ['kernel', 'program'],
            message:
              'les objectifs trace et complete vont avec un programme Python (plugin \xAB python \xBB, `program`), et eux seuls',
          });
        let s = e.kernel.program;
        if (t && s) {
          let i = e.kernel.goal.kind === 'complete',
            o = s.code
              .split(
                `
`,
              )
              .filter((a) => /^\s*_{3,}\s*$/.test(a)).length;
          (i &&
            (o !== 1 || (!s.checks && !s.output) || s.call) &&
            n.addIssue({
              code: 'custom',
              path: ['kernel', 'program'],
              message:
                'compl\xE9ter un programme : une seule ligne manquante \xAB ____ \xBB, des tests (`checks` ou `output`), pas d\u2019appel suivi',
            }),
            !i &&
              (o || s.checks || s.output) &&
              n.addIssue({
                code: 'custom',
                path: ['kernel', 'program'],
                message: 'une ligne manquante et des tests vont avec l\u2019objectif complete',
              }),
            s.draws &&
              !/\brandom\b/.test(s.code) &&
              n.addIssue({
                code: 'custom',
                path: ['kernel', 'program', 'draws'],
                message: 'des tirages impos\xE9s vont avec un programme qui utilise random',
              }));
        }
        (t &&
          (e.kernel.method ||
            e.kernel.domain ||
            e.kernel.system ||
            e.kernel.hypotheses?.length ||
            e.kernel.figure ||
            e.kernel.induction ||
            e.rounding ||
            !e.kernel.path?.length) &&
          n.addIssue({
            code: 'custom',
            path: ['kernel'],
            message:
              'une trace Python a son corrig\xE9 (`path`), sans m\xE9thode, intervalle, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence ni arrondi',
          }),
          t &&
            e.kernel.program &&
            e.kernel.start !== (e.kernel.program.call ?? e.kernel.goal.target) &&
            n.addIssue({
              code: 'custom',
              path: ['kernel', 'start'],
              message:
                '`start` est l\u2019appel suivi (`program.call`), sinon la variable cherch\xE9e',
            }));
      }
      if (e.kernel) {
        let t = e.kernel.plugin === 'matrix';
        (t !== (e.kernel.goal.kind === 'compute') &&
          n.addIssue({
            code: 'custom',
            path: ['kernel', 'goal', 'kind'],
            message:
              'l\u2019objectif compute va avec un calcul matriciel (plugin \xAB matrix \xBB), et lui seul',
          }),
          e.kernel.matrices &&
            !t &&
            n.addIssue({
              code: 'custom',
              path: ['kernel', 'matrices'],
              message: 'des matrices (`matrices`) vont avec le plugin \xAB matrix \xBB',
            }),
          t &&
            (e.kernel.method ||
              e.kernel.domain ||
              e.kernel.system ||
              e.kernel.hypotheses?.length ||
              e.kernel.figure ||
              e.kernel.induction ||
              e.kernel.program ||
              e.rounding ||
              !e.kernel.path?.length) &&
            n.addIssue({
              code: 'custom',
              path: ['kernel'],
              message:
                'un calcul matriciel a son corrig\xE9 (`path`), sans m\xE9thode, intervalle, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme ni arrondi',
            }));
      }
      if (e.kernel) {
        let t = e.kernel.plugin === 'geometry',
          r = !!e.kernel.induction;
        ((t !== !!e.kernel.figure || (t || r) !== (e.kernel.goal.kind === 'prove')) &&
          n.addIssue({
            code: 'custom',
            path: ['kernel', 'plugin'],
            message:
              'l\u2019objectif prove va avec une d\xE9monstration de g\xE9om\xE9trie (plugin \xAB geometry \xBB, une figure) ou une r\xE9currence (`induction`), et elles seules',
          }),
          r &&
            (t ||
              e.kernel.method ||
              e.kernel.domain ||
              e.kernel.system ||
              e.rounding ||
              !e.kernel.path?.length) &&
            n.addIssue({
              code: 'custom',
              path: ['kernel', 'induction'],
              message:
                'une r\xE9currence (plugin \xAB algebra \xBB) a son corrig\xE9 (`path`), sans figure, m\xE9thode, intervalle, syst\xE8me ni arrondi',
            }),
          t &&
            (e.kernel.method ||
              e.kernel.domain ||
              e.kernel.system ||
              e.kernel.hypotheses?.length ||
              e.rounding ||
              !e.kernel.path?.length) &&
            n.addIssue({
              code: 'custom',
              path: ['kernel'],
              message:
                'une d\xE9monstration de g\xE9om\xE9trie a son corrig\xE9 (`path`), sans m\xE9thode, intervalle, syst\xE8me, hypoth\xE8ses ni arrondi',
            }));
      }
      if (e.kernel) {
        let t = e.kernel.plugin === 'arith',
          r =
            e.kernel.goal.kind === 'gcd' ||
            e.kernel.goal.kind === 'bezout' ||
            e.kernel.goal.kind === 'gcd_primes' ||
            e.kernel.goal.kind === 'lcm';
        (t !== r &&
          n.addIssue({
            code: 'custom',
            path: ['kernel', 'goal', 'kind'],
            message:
              'les objectifs gcd, bezout, gcd_primes et lcm vont avec l\u2019arithm\xE9tique (plugin \xAB arith \xBB), et elle seule',
          }),
          t &&
            (e.kernel.method ||
              e.kernel.form ||
              e.kernel.domain ||
              e.kernel.system ||
              e.kernel.hypotheses?.length ||
              e.kernel.figure ||
              e.kernel.induction ||
              e.kernel.program ||
              e.kernel.matrices ||
              e.complex ||
              e.congruence ||
              e.units ||
              e.bounds ||
              e.geometry ||
              e.rounding ||
              !e.kernel.path?.length) &&
            n.addIssue({
              code: 'custom',
              path: ['kernel'],
              message:
                'une feuille d\u2019arithm\xE9tique a son corrig\xE9 (`path`), sans m\xE9thode, forme, intervalle, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme, matrices, mode sp\xE9cial ni arrondi',
            }));
      }
      if (e.kernel) {
        let t = e.kernel.plugin === 'limit';
        ((t !== (e.kernel.goal.kind === 'limit') || t !== !!e.kernel.point) &&
          n.addIssue({
            code: 'custom',
            path: ['kernel', 'point'],
            message:
              'l\u2019objectif limit va avec une feuille de limites (plugin \xAB limit \xBB, `point`), et elle seule',
          }),
          t &&
            (e.kernel.method ||
              e.kernel.form ||
              e.kernel.domain ||
              e.kernel.system ||
              e.kernel.hypotheses?.length ||
              e.kernel.figure ||
              e.kernel.induction ||
              e.kernel.program ||
              e.kernel.matrices ||
              e.kernel.claims ||
              e.complex ||
              e.congruence ||
              e.units ||
              e.bounds ||
              e.geometry ||
              e.rounding ||
              !e.kernel.path?.length) &&
            n.addIssue({
              code: 'custom',
              path: ['kernel'],
              message:
                'une feuille de limites a son corrig\xE9 (`path`), sans m\xE9thode, forme, intervalle, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme, matrices, affirmations, mode sp\xE9cial ni arrondi',
            }));
      }
      if (e.kernel) {
        let t = e.kernel.plugin === 'integral';
        (t !== (e.kernel.goal.kind === 'integrate') &&
          n.addIssue({
            code: 'custom',
            path: ['kernel', 'goal', 'kind'],
            message:
              'l\u2019objectif integrate va avec une feuille d\u2019int\xE9grales (plugin \xAB integral \xBB), et elle seule',
          }),
          t &&
            (e.kernel.method ||
              e.kernel.form ||
              e.kernel.domain ||
              e.kernel.system ||
              e.kernel.hypotheses?.length ||
              e.kernel.figure ||
              e.kernel.induction ||
              e.kernel.program ||
              e.kernel.matrices ||
              e.kernel.claims ||
              e.kernel.point ||
              e.complex ||
              e.congruence ||
              e.units ||
              e.bounds ||
              e.geometry ||
              e.rounding ||
              !e.kernel.path?.length) &&
            n.addIssue({
              code: 'custom',
              path: ['kernel'],
              message:
                'une feuille d\u2019int\xE9grales a son corrig\xE9 (`path`), sans m\xE9thode, forme, intervalle, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme, matrices, affirmations, point, mode sp\xE9cial ni arrondi',
            }));
      }
      if (e.kernel) {
        let t = e.kernel.plugin === 'ode';
        (t !== (e.kernel.goal.kind === 'solve_ode') &&
          n.addIssue({
            code: 'custom',
            path: ['kernel', 'goal', 'kind'],
            message:
              'l\u2019objectif solve_ode va avec une feuille d\u2019\xE9quation diff\xE9rentielle (plugin \xAB ode \xBB), et elle seule',
          }),
          !t &&
            e.kernel.ode &&
            n.addIssue({
              code: 'custom',
              path: ['kernel', 'ode'],
              message:
                'la cl\xE9 `ode` va avec une feuille d\u2019\xE9quation diff\xE9rentielle, et elle seule',
            }),
          t &&
            (e.kernel.method ||
              e.kernel.form ||
              e.kernel.system ||
              e.kernel.hypotheses?.length ||
              e.kernel.figure ||
              e.kernel.induction ||
              e.kernel.program ||
              e.kernel.matrices ||
              e.kernel.claims ||
              e.kernel.lclaims ||
              e.kernel.point ||
              e.kernel.condition ||
              e.complex ||
              e.congruence ||
              e.units ||
              e.bounds ||
              e.geometry ||
              e.rounding ||
              !e.kernel.path?.length) &&
            n.addIssue({
              code: 'custom',
              path: ['kernel'],
              message:
                'une feuille d\u2019\xE9quation diff\xE9rentielle a son corrig\xE9 (`path`), sans m\xE9thode, forme, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme, matrices, affirmations, point, condition, mode sp\xE9cial ni arrondi',
            }));
      }
      if (e.kernel) {
        let t = e.kernel.plugin === 'partial';
        (t !== (e.kernel.goal.kind === 'partial') &&
          n.addIssue({
            code: 'custom',
            path: ['kernel', 'goal', 'kind'],
            message:
              'l\u2019objectif partial va avec une feuille de d\xE9riv\xE9es partielles (plugin \xAB partial \xBB), et elle seule',
          }),
          !t &&
            e.kernel.partial &&
            n.addIssue({
              code: 'custom',
              path: ['kernel', 'partial'],
              message:
                'la cl\xE9 `partial` va avec une feuille de d\xE9riv\xE9es partielles, et elle seule',
            }),
          t &&
            (e.kernel.method ||
              e.kernel.form ||
              e.kernel.domain ||
              e.kernel.system ||
              e.kernel.hypotheses?.length ||
              e.kernel.figure ||
              e.kernel.induction ||
              e.kernel.program ||
              e.kernel.matrices ||
              e.kernel.claims ||
              e.kernel.lclaims ||
              e.kernel.point ||
              e.kernel.condition ||
              e.kernel.ode ||
              e.complex ||
              e.congruence ||
              e.units ||
              e.bounds ||
              e.geometry ||
              e.rounding ||
              !e.kernel.path?.length) &&
            n.addIssue({
              code: 'custom',
              path: ['kernel'],
              message:
                'une feuille de d\xE9riv\xE9es partielles a son corrig\xE9 (`path`), sans m\xE9thode, forme, intervalle, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme, matrices, affirmations, point, condition, \xE9quation diff\xE9rentielle, mode sp\xE9cial ni arrondi',
            }));
      }
      if (e.kernel) {
        let t = e.kernel.plugin === 'riemann';
        (t !== (e.kernel.goal.kind === 'riemann') &&
          n.addIssue({
            code: 'custom',
            path: ['kernel', 'goal', 'kind'],
            message:
              'l\u2019objectif riemann va avec une feuille de sommes de Riemann (plugin \xAB riemann \xBB), et elle seule',
          }),
          t &&
            (e.kernel.method ||
              e.kernel.form ||
              e.kernel.domain ||
              e.kernel.system ||
              e.kernel.hypotheses?.length ||
              e.kernel.figure ||
              e.kernel.induction ||
              e.kernel.program ||
              e.kernel.matrices ||
              e.kernel.claims ||
              e.kernel.lclaims ||
              e.kernel.point ||
              e.complex ||
              e.congruence ||
              e.units ||
              e.bounds ||
              e.geometry ||
              e.rounding ||
              !e.kernel.path?.length) &&
            n.addIssue({
              code: 'custom',
              path: ['kernel'],
              message:
                'une feuille de sommes de Riemann a son corrig\xE9 (`path`), sans m\xE9thode, forme, intervalle, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme, matrices, affirmations, point, mode sp\xE9cial ni arrondi',
            }));
      }
      if (e.kernel) {
        let t = e.kernel.plugin === 'formula';
        (t !== (e.kernel.goal.kind === 'evaluate') &&
          n.addIssue({
            code: 'custom',
            path: ['kernel', 'goal', 'kind'],
            message:
              'l\u2019objectif evaluate va avec une feuille \xE0 formules (plugin \xAB formula \xBB), et elle seule',
          }),
          t &&
            (e.kernel.method ||
              e.kernel.domain ||
              e.kernel.system ||
              e.kernel.hypotheses?.length ||
              e.kernel.figure ||
              e.kernel.induction ||
              e.kernel.program ||
              e.kernel.matrices ||
              e.complex ||
              e.congruence ||
              e.units ||
              e.geometry ||
              e.bounds ||
              !e.kernel.path?.length) &&
            n.addIssue({
              code: 'custom',
              path: ['kernel'],
              message:
                'une feuille \xE0 formules a son corrig\xE9 (`path`), sans m\xE9thode, intervalle, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme, matrices, ni mode sp\xE9cial (complexes, congruences, unit\xE9s, g\xE9om\xE9trie, encadrement)',
            }),
          t &&
            e.kernel.start.trim() !== e.kernel.goal.target &&
            n.addIssue({
              code: 'custom',
              path: ['kernel', 'start'],
              message:
                '`start` est la grandeur cherch\xE9e (`goal.target`) dans une feuille \xE0 formules',
            }));
      }
      if (e.kernel) {
        let t = Mv(e),
          r = Object.values(hq).includes(e.kernel.goal.kind);
        ((t !== null) !== r || (t && hq[t] !== e.kernel.goal.kind)) &&
          n.addIssue({
            code: 'custom',
            path: ['kernel', 'goal', 'kind'],
            message:
              'les objectifs convert, residue, calculate et bound vont avec les plugins units, congruence, complex et bounds (dans cet ordre), et eux seuls',
          });
        let s = ['units', 'congruence', 'complex', 'bounds'].filter((i) => !!e[i]);
        (t &&
          (s.length !== 1 || s[0] !== t) &&
          n.addIssue({
            code: 'custom',
            path: ['kernel', 'plugin'],
            message: `le plugin \xAB ${t} \xBB garde la cl\xE9 de son mode (\`${t}\`), et elle seule`,
          }),
          !t &&
            s.length &&
            n.addIssue({
              code: 'custom',
              path: ['kernel'],
              message:
                'une feuille du noyau n\u2019a pas de mode sp\xE9cial, sauf avec son plugin (units, congruence, complex, bounds)',
            }),
          t &&
            (e.kernel.method ||
              e.kernel.domain ||
              e.kernel.system ||
              e.kernel.hypotheses?.length ||
              e.kernel.figure ||
              e.kernel.induction ||
              e.kernel.program ||
              e.kernel.matrices ||
              e.kernel.form ||
              e.geometry ||
              e.rounding ||
              !e.kernel.path?.length) &&
            n.addIssue({
              code: 'custom',
              path: ['kernel'],
              message:
                'un mode sp\xE9cial du noyau a son corrig\xE9 (`path`), sans m\xE9thode, intervalle, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme, matrices, forme ni arrondi',
            }));
      }
      if (e.kernel) {
        let t = e.kernel.plugin === 'claims',
          r = e.kernel.plugin === 'limclaims';
        ((t !== !!e.kernel.claims || (t || r) !== (e.kernel.goal.kind === 'decide')) &&
          n.addIssue({
            code: 'custom',
            path: ['kernel', 'claims'],
            message:
              'l\u2019objectif decide va avec des affirmations \xE0 trancher (plugin \xAB claims \xBB, `claims` ; plugin \xAB limclaims \xBB, `lclaims`), et elles seules',
          }),
          r !== !!e.kernel.lclaims &&
            n.addIssue({
              code: 'custom',
              path: ['kernel', 'lclaims'],
              message:
                '`lclaims` va avec des limites affirm\xE9es (plugin \xAB limclaims \xBB), et elles seules',
            }),
          r &&
            (e.kernel.method ||
              e.kernel.form ||
              e.kernel.domain ||
              e.kernel.system ||
              e.kernel.hypotheses?.length ||
              e.kernel.figure ||
              e.kernel.induction ||
              e.kernel.program ||
              e.kernel.matrices ||
              e.kernel.claims ||
              e.kernel.vclaims ||
              e.kernel.tclaims ||
              e.kernel.point ||
              e.complex ||
              e.congruence ||
              e.units ||
              e.bounds ||
              e.geometry ||
              e.rounding ||
              !e.kernel.path?.length) &&
            n.addIssue({
              code: 'custom',
              path: ['kernel'],
              message:
                'des limites affirm\xE9es ont leur corrig\xE9 (`path`), sans m\xE9thode, forme, intervalle, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme, matrices, autres affirmations, point, mode sp\xE9cial ni arrondi',
            }),
          r &&
            e.kernel.lclaims &&
            e.kernel.start.trim() !== e.kernel.lclaims[0].expr.trim() &&
            n.addIssue({
              code: 'custom',
              path: ['kernel', 'start'],
              message: '`start` est l\u2019expression de la 1re limite affirm\xE9e',
            }),
          r &&
            e.kernel.lclaims &&
            e.choices &&
            e.choices.length !== e.kernel.lclaims.length &&
            n.addIssue({
              code: 'custom',
              path: ['kernel', 'lclaims'],
              message: 'une limite affirm\xE9e par choix du QCM, dans le m\xEAme ordre',
            }),
          t &&
            (e.kernel.method ||
              e.kernel.form ||
              e.kernel.domain ||
              e.kernel.system ||
              e.kernel.hypotheses?.length ||
              e.kernel.figure ||
              e.kernel.induction ||
              e.kernel.program ||
              e.kernel.matrices ||
              e.complex ||
              e.congruence ||
              e.units ||
              e.bounds ||
              e.geometry ||
              e.rounding ||
              !e.kernel.path?.length) &&
            n.addIssue({
              code: 'custom',
              path: ['kernel'],
              message:
                'une feuille d\u2019affirmations a son corrig\xE9 (`path`), sans m\xE9thode, forme, intervalle, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme, matrices, mode sp\xE9cial ni arrondi',
            }),
          t &&
            e.kernel.claims &&
            e.kernel.start.trim() !== e.kernel.claims[0].rels[0].trim() &&
            n.addIssue({
              code: 'custom',
              path: ['kernel', 'start'],
              message: '`start` est la 1re relation de la 1re affirmation',
            }));
        let s = e.kernel.plugin === 'variations',
          i = e.kernel.plugin === 'tables';
        (!t &&
          !s &&
          !i &&
          !r &&
          e.kernel.single &&
          n.addIssue({
            code: 'custom',
            path: ['kernel', 'single'],
            message: '`single` (r\xE9ponse unique) va avec une feuille d\u2019affirmations',
          }),
          (s !== (e.kernel.goal.kind === 'study') || s !== !!e.kernel.vclaims) &&
            n.addIssue({
              code: 'custom',
              path: ['kernel', 'vclaims'],
              message:
                'l\u2019objectif study va avec l\u2019\xE9tude d\u2019une fonction (plugin \xAB variations \xBB, `vclaims`), et elle seule',
            }),
          s &&
            (e.kernel.method ||
              e.kernel.form ||
              e.kernel.system ||
              e.kernel.hypotheses?.length ||
              e.kernel.figure ||
              e.kernel.induction ||
              e.kernel.program ||
              e.kernel.matrices ||
              e.kernel.claims ||
              e.complex ||
              e.congruence ||
              e.units ||
              e.bounds ||
              e.geometry ||
              e.rounding ||
              !e.kernel.path?.length) &&
            n.addIssue({
              code: 'custom',
              path: ['kernel'],
              message:
                'une \xE9tude de fonction a son corrig\xE9 (`path`), sans m\xE9thode, forme, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme, matrices, affirmations, mode sp\xE9cial ni arrondi',
            }),
          (i !== (e.kernel.goal.kind === 'fill') ||
            i !== !!e.kernel.tclaims ||
            i !== !!e.kernel.table) &&
            n.addIssue({
              code: 'custom',
              path: ['kernel', 'tclaims'],
              message:
                'l\u2019objectif fill va avec un tableau \xE0 remplir (plugin \xAB tables \xBB, `table` et `tclaims`), et lui seul',
            }),
          i &&
            (e.kernel.method ||
              e.kernel.form ||
              e.kernel.domain ||
              e.kernel.system ||
              e.kernel.hypotheses?.length ||
              e.kernel.figure ||
              e.kernel.induction ||
              e.kernel.program ||
              e.kernel.matrices ||
              e.kernel.claims ||
              e.kernel.vclaims ||
              e.complex ||
              e.congruence ||
              e.units ||
              e.bounds ||
              e.geometry ||
              e.rounding ||
              !e.kernel.path?.length ||
              !e.kernel.start.startsWith('\u229F')) &&
            n.addIssue({
              code: 'custom',
              path: ['kernel'],
              message:
                'un tableau \xE0 remplir part du tableau de l\u2019\xE9nonc\xE9 (`start` = \xAB \u229F{\u2026} \xBB) et a son corrig\xE9 (`path`), sans m\xE9thode, forme, intervalle, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme, matrices, affirmations, mode sp\xE9cial ni arrondi',
            }),
          i &&
            e.kernel.tclaims &&
            e.choices &&
            e.choices.length !== e.kernel.tclaims.length &&
            n.addIssue({
              code: 'custom',
              path: ['kernel', 'tclaims'],
              message: 'une affirmation par choix du QCM, dans le m\xEAme ordre',
            }),
          s &&
            e.kernel.vclaims &&
            e.choices &&
            e.choices.length !== e.kernel.vclaims.length &&
            n.addIssue({
              code: 'custom',
              path: ['kernel', 'vclaims'],
              message: 'une affirmation par choix du QCM, dans le m\xEAme ordre',
            }),
          t &&
            e.kernel.claims &&
            e.choices &&
            e.choices.length !== e.kernel.claims.length &&
            n.addIssue({
              code: 'custom',
              path: ['kernel', 'claims'],
              message: 'une affirmation par choix du QCM, dans le m\xEAme ordre',
            }));
      }
      (e.kernel &&
        !e.goal.includes(e.kernel.goal.target) &&
        n.addIssue({
          code: 'custom',
          path: ['kernel', 'goal', 'target'],
          message: `l'inconnue ${e.kernel.goal.target} doit \xEAtre dans goal`,
        }),
        e.goal.forEach((t, r) => {
          e.kernel?.plugin === 'claims' ||
            e.kernel?.plugin === 'limclaims' ||
            e.kernel?.plugin === 'variations' ||
            e.kernel?.plugin === 'tables' ||
            e.symbols[t] ||
            n.addIssue({
              code: 'custom',
              path: ['goal', r],
              message: `goal ${t} absent de symbols`,
            });
        }),
        Object.entries(e.symbols).forEach(([t, r]) => {
          r.given &&
            r.value === void 0 &&
            !r.exact?.length &&
            n.addIssue({
              code: 'custom',
              path: ['symbols', t],
              message: 'grandeur donn\xE9e sans value',
            });
        }));
    })
    .transform((e) => V1(e)),
  _ee = x.object({ engine_version: x.number().int().min(1), model: EG });
function xq(e) {
  let n = MG(e);
  ((qU(e) || _U(e)) && (n = Math.max(n, T3)),
    EU(e) && (n = Math.max(n, $3)),
    CU(e) && (n = Math.max(n, C3)),
    (y_(e) || DE(e, $U) || RU(e) || c3(e) || u3(e)) && (n = Math.max(n, E3)),
    TU(e) && (n = Math.max(n, M3)),
    q3(e) && (n = Math.max(n, _3)),
    SU(e) && (n = Math.max(n, L3)),
    O3(e) && (n = Math.max(n, N3)),
    P3(e) && (n = Math.max(n, K3)),
    wU(e) && (n = Math.max(n, I3)),
    j3(e) && (n = Math.max(n, A3)),
    xU(e) && (n = Math.max(n, _v)),
    F3(e) && (n = Math.max(n, Q3)),
    L0(e) && (n = Math.max(n, V3)),
    kU(e) && (n = Math.max(n, D3)),
    z3(e) && (n = Math.max(n, B3)),
    (bU(e) || vU(e)) && (n = Math.max(n, U3)),
    Z3(e) && (n = Math.max(n, G3)),
    N0(e) && (n = Math.max(n, H3)),
    J3(e) && (n = Math.max(n, W3)),
    Y3(e) && (n = Math.max(n, X3)),
    nU(e) && (n = Math.max(n, eU)),
    rU(e) && (n = Math.max(n, tU)),
    iU(e) && (n = Math.max(n, sU)),
    lU(e) && (n = Math.max(n, oU)),
    cU(e) && (n = Math.max(n, uU)),
    dU(e) && (n = Math.max(n, fU)),
    pU(e) && (n = Math.max(n, mU)),
    hU(e) && (n = Math.max(n, gU)));
  let t = e.kernel?.minEngine;
  return (t && (n = Math.max(n, t)), n);
}
function MG(e) {
  if (y3(e)) return S3(e) ? w3 : x3;
  if (k3(e)) return v3;
  if (b3(e)) return g3;
  if (p3(e)) return m3;
  if (d3(e)) return f3;
  if (vq(e)) return l3;
  if (a3(e)) return o3;
  if (s3(e)) return d_(e) ? i3 : r3;
  if (LU(e)) return gq;
  if (e.kernel)
    return NU(e)
      ? gq
      : t3(e)
        ? n3
        : e3(e)
          ? Yz
          : q0(e)
            ? Xz
            : _0(e)
              ? Hz
              : Zz(e)
                ? Gz
                : Uz(e)
                  ? zz
                  : Bz(e)
                    ? Dz
                    : Vz(e)
                      ? Fz
                      : Qz;
  if (/\barc(cos|sin|tan)\b/.test(JSON.stringify(e))) return jz;
  if (e.path?.length) return Az;
  if (e.stepwise) return Iz;
  if (e.bounds) {
    let n = e.bounds;
    return n.lower === void 0 || n.upper === void 0 ? Pz : Kz;
  }
  return _G(e.preds)
    ? Oz
    : e.complex
      ? Nz
      : e.rounding
        ? Lz
        : OU(e)
          ? qz
          : e.checks?.length
            ? _z
            : e.units || e.geometry
              ? KU
              : e.congruence
                ? Mz
                : 2;
}
function _G(e) {
  return (e ?? []).some(
    (n) => !!n && typeof n == 'object' && n.skill === 'secondDegre' && !!n.double,
  );
}
function qv(e) {
  if (e.dis.length !== 1) return null;
  let n = e.dis[0];
  if (n.cmp !== '\u2248' || n.sides.length !== 2 || n.rels || n.mod !== void 0) return null;
  try {
    return { l: _e(n.sides[0]), r: _e(n.sides[1]) };
  } catch (t) {
    if (t instanceof Gr) return null;
    throw t;
  }
}
function Sl(e) {
  switch (e.k) {
    case 'num':
    case 'sym':
      return 1;
    case 'add':
    case 'mul':
      return 1 + e.c.reduce((n, t) => n + Sl(t), 0);
    case 'div':
    case 'pow':
    case 'binom':
      return 1 + Sl(e.a) + Sl(e.b);
    case 'fn':
      return 1 + Sl(e.a);
  }
}
var ss = (e, n) => $(e).has(n);
function Wp(e, n) {
  switch (e.k) {
    case 'sym':
      return e.n === n ? 1 : 0;
    case 'num':
      return 0;
    case 'add':
    case 'mul':
      return e.c.reduce((t, r) => t + Wp(r, n), 0);
    case 'div':
    case 'pow':
    case 'binom':
      return Wp(e.a, n) + Wp(e.b, n);
    case 'fn':
      return Wp(e.a, n);
  }
}
function qG(e, n) {
  let t = ss(e.l, n),
    r = ss(e.r, n);
  if (!t && !r) return 0;
  let s = 0;
  (t && r && (s += 6), t || (s += 1));
  let i = t ? e.l : e.r;
  return ((s += Sl(i) - 1 + 2 * (Wp(i, n) - 1) + 2 * kc(i, n)), s);
}
function kc(e, n) {
  switch (e.k) {
    case 'div':
      return (ss(e, n) ? 1 : 0) + kc(e.a, n) + kc(e.b, n);
    case 'add':
    case 'mul':
      return e.c.reduce((t, r) => t + kc(r, n), 0);
    case 'pow':
    case 'binom':
      return kc(e.a, n) + kc(e.b, n);
    case 'fn':
      return kc(e.a, n);
    default:
      return 0;
  }
}
function Xp(e, n) {
  let t = Z(e, { sorts: n });
  return t.ok ? Je($e(t.rf)) : null;
}
function A0(e, n) {
  let t = Xp(e, n);
  return t !== null && E(t) === E(R(e, n));
}
function LG(e) {
  let n = 0,
    t = (r) => {
      (r.k === 'mul' && r.c.some((s) => s.k === 'add') && n++,
        r.k === 'pow' && r.a.k === 'add' && n++,
        r.k === 'add' || r.k === 'mul'
          ? r.c.forEach(t)
          : r.k === 'div' || r.k === 'pow'
            ? (t(r.a), t(r.b))
            : r.k === 'fn' && t(r.a));
    };
  return (t(e), n);
}
function j0(e, n) {
  let t = n.goal.kind;
  if (e.k === 'expr') {
    let r = e.e;
    switch (t) {
      case 'factor':
        return r.k === 'mul' || r.k === 'pow' ? 0 : 1;
      case 'expand':
        return LG(r) + (A0(r, n.sorts) ? 0 : 1);
      case 'compute':
        return r.k === 'num' ? 0 : Math.max(1, Sl(r) - 1);
      default:
        return A0(r, n.sorts) ? 0 : 1;
    }
  }
  return n.x ? on(e).reduce((r, s) => r + qG(s, n.x), 0) : 0;
}
function NG(e, n) {
  if (e.k === 'expr') {
    if (n.goal.kind === 'factor') {
      let r = e.e;
      if (r.k === 'pow') return r.a.k === 'add';
      if (r.k !== 'mul') return !1;
      let s = r.c.filter((i) => $(i).size > 0);
      return s.length >= 2 || s.some((i) => i.k === 'add');
    }
    return j0(e, n) === 0;
  }
  return !n.x || e.k === 'set'
    ? !1
    : (e.k === 'rel' ? [e] : e.items).every(
        (r) =>
          r.l.k === 'sym' &&
          r.l.n === n.x &&
          !ss(r.r, n.x) &&
          (n.goal.kind !== 'solve' || A0(r.r, n.sorts)),
      );
}
function P0(e) {
  return e.k === 'add' ? e.c : [e];
}
function Jp(e, n = []) {
  return (
    e.k === 'num' && e.v.d !== 1n && n.push(e.v.d),
    e.k === 'div' && e.b.k === 'num' && B(e.b.v) && n.push(e.b.v.n < 0n ? -e.b.v.n : e.b.v.n),
    e.k === 'add' || e.k === 'mul'
      ? e.c.forEach((t) => Jp(t, n))
      : e.k === 'div' || e.k === 'pow'
        ? (Jp(e.a, n), Jp(e.b, n))
        : e.k === 'fn' && Jp(e.a, n),
    n
  );
}
var wq = (e, n) => (n === 0n ? e : wq(n, e % n));
function OG(e, n) {
  let t = [],
    r = [],
    s = ss(e.l, n),
    i = s ? e.l : e.r,
    o = s ? e.r : e.l;
  for (let l of P0(i)) !ss(l, n) && P0(i).length > 1 && t.push(Mu(l));
  for (let l of P0(o)) ss(l, n) && t.push(Mu(l));
  if (i.k === 'mul') {
    let l = i.c.filter((u) => !ss(u, n));
    l.length && r.push(l.length === 1 ? l[0] : I(...l));
  }
  i.k === 'div' && !ss(i.b, n) && r.push(ye(T(1), i.b));
  let a = Jp({ k: 'add', c: [e.l, e.r] });
  if (a.length) {
    let l = a.reduce((u, c) => (u / wq(u, c)) * c, 1n);
    l > 1n && r.push(ye(T(1), T(C(l))));
  }
  return { add: t, scale: r };
}
function I0(e, n) {
  let t = R(e, n),
    r = Xp(t, n);
  return r && Sl(r) <= Sl(t) ? r : t;
}
function no(e, n = { fns: new Set(), pows: new Set() }) {
  switch (e.k) {
    case 'add':
    case 'mul':
      e.c.forEach((t) => no(t, n));
      break;
    case 'div':
      (no(e.a, n), no(e.b, n));
      break;
    case 'binom':
      (n.fns.add('binom'), no(e.a, n), no(e.b, n));
      break;
    case 'pow':
      (e.b.k === 'num' && n.pows.add(E(e.b)), no(e.a, n), no(e.b, n));
      break;
    case 'fn':
      (n.fns.add(e.f), no(e.a, n));
      break;
    default:
      break;
  }
  return n;
}
function qd(e, n = new Set()) {
  switch (e.k) {
    case 'add':
    case 'mul':
      e.c.forEach((t) => qd(t, n));
      break;
    case 'div':
    case 'binom':
      (qd(e.a, n), qd(e.b, n));
      break;
    case 'pow':
      (e.a.k === 'sym' && e.b.k === 'num' && n.add(e.a.n), qd(e.a, n));
      break;
    case 'fn':
      qd(e.a, n);
      break;
    default:
      break;
  }
  return n;
}
function KG(e, n) {
  if (!n.fns.size && !n.pows.size) return !0;
  let t = no({ k: 'add', c: [e.l, e.r] });
  return [...n.fns].every((r) => t.fns.has(r)) && [...n.pows].every((r) => t.pows.has(r));
}
function PG(e, n) {
  let t = [];
  if (!n.x) return t;
  let r = n.x,
    s = e.rel === '=',
    { add: i, scale: o } = OG(e, r);
  for (let a of n.rules) {
    if (a.appliesTo === 'expression' || (a.appliesTo === 'equation') !== s) continue;
    let l = pb(a);
    for (let u of a.directions) {
      if (!u.goals.includes(n.goal.kind)) continue;
      let c = l[u.from],
        f = l[u.to],
        d = { k: 'add', c: c.sides };
      if (!KG(e, no(d))) continue;
      let m = [...qd(d)],
        p = _y(a, n.sorts, 400);
      for (let g of NC(c, e, p)) {
        if (m.some((b) => g[b] && !ss(g[b], r))) continue;
        let h = [];
        if (!u.introduces.length) h.push({});
        else if (u.introduces.length === 1) {
          let b = u.introduces[0],
            v = a.forms[u.to].text,
            k = v.includes('+') ? i : v.includes('\xF7') ? o : o.map(AG);
          for (let y of k) h.push({ [b]: y });
          v.includes('\xD7') && !v.includes('+') && h.push({ [b]: T(-1) });
        }
        for (let b of h) {
          let v = { ...g, ...b },
            k = OC(c, f, e, v, n.sorts);
          if (!k) continue;
          let y = a.preconditions.map((O) => ({
              ...O,
              of: O.of.map((G) => oe(I0(v[G] ?? T(0), n.sorts))),
            })),
            S = y.map((O) => tr(O, n.facts));
          if (S.includes('false')) continue;
          let w = y.filter((O, G) => S[G] !== 'true');
          if (w.length) {
            if (w.some((O) => O.of.some((G) => IG(G, r)))) continue;
            if ((a.onUnknown ?? 'conditional') === 'branch') {
              w.forEach((O) => O.of.forEach((G) => n.wantsBranch.add(G)));
              continue;
            }
            if (a.onUnknown === 'refuse') continue;
          }
          let _ = { rel: k.rel, l: I0(k.l, n.sorts), r: I0(k.r, n.sorts) };
          t.push({
            r: _,
            step: {
              relation: a.relation,
              ruleId: a.qid,
              move: a.id,
              ...(w.length && { conditions: w }),
            },
            cost: Math.max(1, a.cost) + 1,
          });
        }
      }
    }
  }
  return t;
}
function IG(e, n) {
  let t = ie(e);
  return t.ok && Dn(t.s).has(n);
}
function AG(e) {
  return e.k === 'div' && e.a.k === 'num' && M(e.a.v, q) ? e.b : ye(T(1), e);
}
function yq(e, n, t) {
  let r = [];
  for (let o of n.rules) {
    if (o.appliesTo !== 'expression') continue;
    let a = pb(o);
    for (let l of o.directions) {
      if (!l.goals.includes(t)) continue;
      let u = _y(o, n.sorts, 400);
      for (let c of LC(a[l.from], a[l.to], e, u)) {
        let f = o.preconditions.map((p) => ({
            ...p,
            of: p.of.map((g) => oe(c.bindings[g] ?? T(0))),
          })),
          d = f.map((p) => tr(p, n.facts));
        if (d.includes('false')) continue;
        let m = f.filter((p, g) => d[g] !== 'true');
        r.push({
          t: c.term,
          step: {
            relation: o.relation,
            ruleId: o.qid,
            move: o.id,
            ...(m.length && { conditions: m }),
          },
          cost: Math.max(1, o.cost) + 1,
        });
      }
    }
  }
  if (t === 'factor' || t === 'solve') {
    let o = QG(e, n.sorts);
    o &&
      r.push({
        t: o,
        step: { relation: 'identity', move: 'factor_common', ...jG(n, 'algebra.distribute') },
        cost: 2,
      });
  }
  let s = Xp(e, n.sorts),
    i = t === 'compute' ? e : R(e, n.sorts);
  return (
    s &&
      E(s) !== E(i) &&
      t !== 'factor' &&
      r.push({
        t: s,
        step: {
          relation: t === 'compute' ? 'evaluation' : 'identity',
          move: t === 'compute' ? 'compute' : 'simplify',
        },
        cost: 4,
      }),
    r
  );
}
function jG(e, n) {
  let t = e.rules.find((r) => r.id === n);
  return t ? { ruleId: t.qid } : {};
}
function QG(e, n) {
  if (e.k !== 'add') return null;
  let t = Z(e, { sorts: n });
  if (!t.ok || je(t.rf.d) === null || !M(je(t.rf.d), q)) return null;
  let r = t.rf.n;
  if (r.t.size < 2) return null;
  let s = S$(r),
    i = [...r.t.values()],
    o = new Map();
  i[0].m.forEach((d) => d.a.kind === 'sym' && o.set(d.a.key, { a: d.a.term, e: d.e }));
  for (let d of i.slice(1))
    for (let [m, p] of [...o]) {
      let g = d.m.find((h) => h.a.key === m);
      g ? (p.e = Math.min(p.e, g.e)) : o.delete(m);
    }
  let a = te(Xs(r)[0].c) < 0 ? -1 : 1,
    l = N(s, C(a)),
    u = [...o.values()].map((d) => (d.e === 1 ? d.a : et(d.a, T(d.e))));
  if (M(l, q) && !u.length) return null;
  let c = R(I(T(l), ...u), n),
    f = Xp(ye(e, c), n);
  return !f || f.k !== 'add' ? null : R(I(c, f), n);
}
function FG(e) {
  if (e.rel !== '=') return null;
  let [n, t] =
    e.r.k === 'num' && L(e.r.v)
      ? [e.l, e.r]
      : e.l.k === 'num' && L(e.l.v)
        ? [e.r, e.l]
        : [null, null];
  if (!n || !t || n.k !== 'mul') return null;
  let r = n.c.filter((s) => $(s).size > 0);
  return r.length < 2 ? null : r.map((s) => ({ rel: '=', l: s, r: T(0) }));
}
function VG(e, n) {
  let t = [];
  if (e.k === 'expr') {
    for (let i of yq(e.e, n, n.goal.kind))
      t.push({ s: { k: 'expr', e: i.t }, step: i.step, cost: i.cost });
    return t;
  }
  if (e.k === 'set') return t;
  let r = e.k === 'rel' ? [{ rel: e.rel, l: e.l, r: e.r }] : e.items,
    s = (i, o) => {
      let a = [...r.slice(0, i), ...o, ...r.slice(i + 1)];
      return a.length === 1 ? { k: 'rel', ...a[0] } : { k: 'or', items: a };
    };
  return (
    r.forEach((i, o) => {
      if (n.x && i.l.k === 'sym' && i.l.n === n.x && !ss(i.r, n.x)) {
        let l = Xp(i.r, n.sorts);
        l &&
          E(l) !== E(i.r) &&
          t.push({
            s: s(o, [{ ...i, r: l }]),
            step: { relation: 'equivalent', move: 'simplify' },
            cost: 1,
          });
        return;
      }
      let a = FG(i);
      a && t.push({ s: s(o, a), step: { relation: 'equivalent', move: 'zero_product' }, cost: 1 });
      for (let l of PG(i, n)) t.push({ s: s(o, [l.r]), step: l.step, cost: l.cost });
      for (let l of ['l', 'r'])
        for (let u of yq(i[l], n, n.goal.kind === 'isolate_variable' ? 'solve' : n.goal.kind))
          u.step.ruleId &&
            t.push({
              s: s(o, [{ ...i, [l]: u.t }]),
              step: { ...u.step, relation: 'equivalent' },
              cost: u.cost + 1,
            });
      i.rel === '=' &&
        n.x &&
        !ss(i.l, n.x) &&
        ss(i.r, n.x) &&
        t.push({
          s: s(o, [{ rel: '=', l: i.r, r: i.l }]),
          step: { relation: 'equivalent', move: 'swap_sides' },
          cost: 1,
        });
    }),
    t
  );
}
function DG(e, n) {
  if (n.target) return n.target;
  let t = [...Dn(e)];
  return t.length === 1 ? t[0] : t.includes('x') ? 'x' : null;
}
function Sq(e, n) {
  let t = ie(e);
  return t.ok
    ? t.s.k === 'set'
      ? { status: 'unsupported', code: 'set_statement' }
      : Tq(t.s, n, n.budget.branches > 0)
    : { status: 'unsupported', code: t.reason };
}
function Tq(e, n, t) {
  let r = n.now ?? (() => Date.now()),
    s = [...(n.hypotheses ?? [])],
    i = n.sorts ?? {},
    o = {
      rules: n.rules,
      goal: n.goal,
      x: e.k === 'expr' ? null : DG(e, n.goal),
      facts: ji(s, i),
      hyps: s,
      sorts: i,
      deadline: r() + n.budget.ms,
      now: r,
      wantsBranch: new Set(),
    };
  if (e.k !== 'expr' && !o.x) return { status: 'unsupported', code: 'no_unknown' };
  let a = {};
  for (let [m, p] of o.facts.sign) p.zero && !p.pos && !p.neg && (a[m] = T(0));
  Object.keys(a).length && (e = Mt(e, (m) => j(m, a)));
  let l = (m) => Ii(o.goal.kind === 'compute' ? m : zG(m, i)),
    u = { s: e, key: l(e), g: 0, h: j0(e, o), depth: 0, steps: [], conditions: [] },
    c = [u],
    f = new Map([[u.key, 0]]),
    d = 0;
  for (; c.length; ) {
    if (r() > o.deadline) return { status: 'budget_exhausted', nodes: d, reason: 'ms' };
    if (d >= n.budget.nodes) return { status: 'budget_exhausted', nodes: d, reason: 'nodes' };
    let m = 0;
    for (let g = 1; g < c.length; g++) {
      let h = c[g],
        b = c[m],
        v = h.g + h.h,
        k = b.g + b.h;
      (v < k || (v === k && (h.h < b.h || (h.h === b.h && h.key < b.key)))) && (m = g);
    }
    let p = c.splice(m, 1)[0];
    if ((d++, NG(p.s, o)))
      return {
        status: 'found',
        steps: p.steps,
        final: _t(p.s),
        conditions: p.conditions,
        nodes: d,
      };
    if (!(p.depth >= n.budget.depth))
      for (let g of VG(p.s, o)) {
        let h = l(g.s),
          b = p.g + g.cost,
          v = f.get(h);
        (v !== void 0 && v <= b) ||
          (f.set(h, b),
          c.push({
            s: g.s,
            key: h,
            g: b,
            h: j0(g.s, o),
            depth: p.depth + 1,
            steps: [...p.steps, { from: _t(p.s), to: _t(g.s), ...g.step }],
            conditions: [...p.conditions, ...(g.step.conditions ?? [])],
          }));
      }
  }
  if (t && o.wantsBranch.size) {
    let m = [...o.wantsBranch].sort()[0],
      p = ie(m),
      g = p.ok && p.s.k === 'expr' ? BG(p.s.e) : null;
    if (g) {
      let h = [];
      for (let b of ['positive', 'negative', 'zero']) {
        let v = Wr(b, g);
        if (tr(v, o.facts) === 'false') continue;
        let k = Math.max(0, o.deadline - r());
        h.push({
          when: [v],
          result: Tq(e, { ...n, hypotheses: [...s, v], budget: { ...n.budget, ms: k } }, !1),
        });
      }
      return { status: 'branches', branches: h, nodes: d };
    }
  }
  return { status: 'not_found', nodes: d };
}
function BG(e) {
  let n = [...$(e)];
  return n.length === 1 ? { k: 'sym', n: n[0] } : e;
}
function zG(e, n) {
  return Mt(e, (t) => R(t, n));
}
var UG = ['identity', 'equivalence', 'implication'],
  $q = { identity: 'identity', equivalence: 'equivalent', implication: 'implies' },
  GG = ['expression', 'equation', 'inequality'],
  ZG = ['real', 'integer', 'natural', 'nonzero', 'positive', 'negative', 'nonnegative', 'distinct'],
  HG = ['refuse', 'branch', 'conditional'],
  WG = ['6e', '5e', '4e', '3e', '2nde', '1re', 'tle', 'mpsi', 'ptsi', 'mp', 'pt'],
  JG = /^[A-Za-zα-ω][₀-₉]?$/,
  XG = /^\?[A-Za-zα-ω][₀-₉]?$/,
  YG = /^[A-Za-zα-ω]{1,2}[₀-₉]?$/,
  e4 = /^[a-z][a-z0-9-]{1,39}$/,
  Q0 = /^[a-z][a-z0-9_]{0,23}$/,
  n4 = /^[a-z][a-z0-9-]{0,31}$/,
  t4 = x.string().trim().min(1).max(200),
  Rq = x.string().trim().min(1).max(200);
function Cq(e) {
  return x
    .record(x.enum(ZG), x.union([x.string().regex(e), x.array(x.string().regex(e))]))
    .superRefine((n, t) => {
      let r = Object.keys(n);
      if (r.length !== 1) {
        t.addIssue({ code: 'custom', message: 'une condition = une seule cl\xE9' });
        return;
      }
      let s = r[0],
        i = n[s];
      s === 'distinct'
        ? (!Array.isArray(i) || i.length < 2 || i.length > 4) &&
          t.addIssue({ code: 'custom', path: [s], message: '2 \xE0 4 termes distincts' })
        : typeof i != 'string' &&
          t.addIssue({ code: 'custom', path: [s], message: 'un seul terme' });
    });
}
var r4 = Cq(XG),
  s4 = Cq(YG),
  i4 = x.object({ flip_relation: x.literal(!0) }).strict(),
  o4 = x
    .object({
      from: x.string().regex(Q0),
      to: x.string().regex(Q0),
      goals: x.array(Ty).min(1).max(8),
    })
    .strict(),
  a4 = x
    .object({
      from: Rq,
      to: Rq,
      expect: x.enum(['valid', 'invalid']),
      assume: x.array(s4).max(8).optional(),
    })
    .strict(),
  l4 = x
    .object({
      id: x.string().regex(vC),
      version: x.number().int().min(1).max(999),
      kind: x.enum(UG),
      applies_to: x.enum(GG).optional(),
      vars: x
        .record(x.string().regex(JG), fb)
        .refine(
          (e) => Object.keys(e).length >= 1 && Object.keys(e).length <= 8,
          '1 \xE0 8 variables',
        ),
      forms: x
        .record(x.string().regex(Q0), t4)
        .refine((e) => Object.keys(e).length >= 2 && Object.keys(e).length <= 6, '2 \xE0 6 formes'),
      directions: x.array(o4).min(1).max(8),
      preconditions: x.array(r4).max(8).optional(),
      on_unknown: x.enum(HG).optional(),
      effects: x.array(i4).max(4).optional(),
      cost: x.number().int().min(0).max(100).optional(),
      label: x.string().trim().min(1).max(120),
      ref: x.string().trim().min(1).max(200).optional(),
      tags: x.array(x.string().regex(n4)).max(8).optional(),
      levels: x.array(x.enum(WG)).max(11).optional(),
      limits: x
        .object({ max_matches: x.number().int().min(1).max(1e3) })
        .strict()
        .optional(),
      examples: x.array(a4).min(1).max(16),
    })
    .strict(),
  u4 = 1,
  Eq = x
    .object({
      id: x.string().regex(e4),
      version: x.number().int().min(1).max(999),
      schema: x.literal(u4),
      label: x.string().trim().min(1).max(120).optional(),
      rules: x.array(l4).min(1).max(500),
    })
    .strict();
var c4 = [-9.7, -6.25, -4, -2.5, -1.3, -0.6, -0.25, 0, 0.4, 0.75, 1, 1.6, 2.2, 3, 4.5, 7.3, 11],
  f4 = Array.from({ length: 19 }, (e, n) => n - 9),
  d4 = Array.from({ length: 13 }, (e, n) => n),
  m4 = 24,
  p4 = 6,
  g4 = 8,
  F0 = -25,
  h4 = 25,
  Mq = 1e3;
function b4(e) {
  let n = 2166136261;
  for (let t = 0; t < e.length; t++) ((n ^= e.charCodeAt(t)), (n = Math.imul(n, 16777619)));
  return n >>> 0;
}
function v4(e) {
  let n = e >>> 0;
  return () => {
    n = (n + 1831565813) >>> 0;
    let t = n;
    return (
      (t = Math.imul(t ^ (t >>> 15), t | 1)),
      (t ^= t + Math.imul(t ^ (t >>> 7), t | 61)),
      ((t ^ (t >>> 14)) >>> 0) / 4294967296
    );
  };
}
function Lq(e, n) {
  return n.every((t) => {
    switch (t) {
      case 'integer':
        return Number.isInteger(e);
      case 'natural':
        return Number.isInteger(e) && e >= 0;
      case 'nonzero':
        return e !== 0;
      case 'positive':
        return e > 0;
      case 'negative':
        return e < 0;
      case 'nonnegative':
        return e >= 0;
      default:
        return !0;
    }
  });
}
function k4(e) {
  return (
    e.sort === 'natural' || e.conds.includes('natural')
      ? d4
      : e.sort === 'integer' || e.conds.includes('integer')
        ? f4
        : c4
  ).filter((t) => Lq(t, e.conds));
}
function Nq(e, n) {
  return n.every((t) => new Set(t.map((r) => e[r])).size === t.length);
}
function Oq(e, n, t) {
  let r = Object.keys(e.domains).sort();
  if (r.length === 0) return [{}];
  let s = r.map((a) => k4(e.domains[a]));
  if (s.some((a) => a.length === 0)) return [];
  let i = v4(b4(t)),
    o = [];
  for (let a = 0; o.length < n && a < n * 20; a++) {
    let l = {};
    (r.forEach((u, c) => {
      let f = s[c];
      l[u] = f[Math.floor(i() * f.length)];
    }),
      Nq(l, e.distinct) && o.push(l));
  }
  return o;
}
function Tl(e, n) {
  let t = H(e, n);
  return Number.isFinite(t) ? t : null;
}
function _q(e, n, t) {
  let r = Tl(n[0], t),
    s = n[1] ? Tl(n[1], t) : null;
  return r === null || s === null ? null : e === '=' ? Ce(r, s) : La(e, r, s);
}
function Kq(e, n) {
  let t = Tl(e[0], n),
    r = Tl(e[1], n);
  return t === null || r === null
    ? null
    : Math.abs(t - r) <= 1e-6 * Math.max(1, Math.abs(t), Math.abs(r));
}
function x4(e, n, t) {
  let r = (l) => {
      let u = { ...t, [n]: l },
        c = Tl(e[0], u),
        f = Tl(e[1], u);
      return c === null || f === null ? null : c - f;
    },
    s = [],
    i = (h4 - F0) / Mq,
    o = F0,
    a = r(o);
  for (let l = 1; l <= Mq; l++) {
    let u = F0 + l * i,
      c = r(u);
    if (a !== null && a === 0) s.push(o);
    else if (a !== null && c !== null && a * c < 0) {
      let f = o,
        d = u,
        m = a;
      for (let g = 0; g < 80; g++) {
        let h = (f + d) / 2,
          b = r(h);
        if (b === null) break;
        m * b <= 0 ? (d = h) : ((f = h), (m = b));
      }
      let p = (f + d) / 2;
      Kq(e, { ...t, [n]: p }) && s.push(p);
    }
    ((o = u), (a = c));
  }
  return s;
}
function qq(e, n, t, r) {
  let s = 0,
    i = Object.keys(t.domains)
      .sort()
      .filter((o) => {
        let a = t.domains[o];
        return (
          (a.sort === 'real' || a.sort === 'rational') &&
          !a.conds.some((l) => l === 'integer' || l === 'natural')
        );
      });
  for (let o of i) {
    let a = {
      domains: Object.fromEntries(Object.entries(t.domains).filter(([l]) => l !== o)),
      distinct: [],
    };
    for (let l of Oq(a, g4, `${r}#${o}`))
      for (let u of x4(e, o, l)) {
        let c = { ...l, [o]: u };
        if (!Lq(u, t.domains[o].conds) || !Nq(c, t.distinct)) continue;
        let f = Kq(n, c);
        if (f !== null) {
          if (!f) return { verdict: 'fails', env: c };
          s++;
        }
      }
  }
  return { verdict: 'holds', tested: s };
}
function V0(e, n, t, r, s, i) {
  let o = Object.keys(s.domains).length === 0,
    a = o ? 1 : p4;
  if (n === 'equation' && !o) {
    let u = qq(t.sides, r.sides, s, `${i}>`);
    if (u.verdict === 'fails') return u;
    if (e === 'implication') return u.tested > 0 ? u : { verdict: 'untestable' };
    let c = qq(r.sides, t.sides, s, `${i}<`);
    return c.verdict === 'fails'
      ? c
      : u.tested > 0 && c.tested > 0
        ? { verdict: 'holds', tested: u.tested + c.tested }
        : { verdict: 'untestable' };
  }
  let l = 0;
  for (let u of Oq(s, m4, i))
    if (n === 'expression') {
      let c = Tl(t.sides[0], u),
        f = Tl(r.sides[0], u);
      if (c === null || f === null) continue;
      if ((l++, !Ce(c, f))) return { verdict: 'fails', env: u };
    } else {
      let c = _q(t.relation, t.sides, u),
        f = _q(r.relation, r.sides, u);
      if (c === null || f === null) continue;
      if ((l++, e === 'implication' ? c && !f : c !== f)) return { verdict: 'fails', env: u };
    }
  return l >= a ? { verdict: 'holds', tested: l } : { verdict: 'untestable' };
}
var y4 = 50,
  w4 = 1;
function jq(e) {
  return (
    e &&
      typeof e == 'object' &&
      !Object.isFrozen(e) &&
      (Object.freeze(e), Object.values(e).forEach(jq)),
    e
  );
}
function Pq(e) {
  let n = Object.keys(e)[0],
    t = e[n],
    r = (Array.isArray(t) ? t : [t]).map((s) => s.replace(/^\?/, ''));
  return Iu.parse({ kind: n, of: r });
}
function Iq(e, n) {
  let t = {};
  Object.entries(e).forEach(([s, i]) => (t[s] = { sort: i, conds: [] }));
  let r = [];
  return (
    n.forEach((s) => {
      s.kind === 'distinct'
        ? r.push(s.of)
        : s.kind !== 'defined_on' && s.kind !== 'zero' && t[s.of[0]]?.conds.push(s.kind);
    }),
    { domains: t, distinct: r }
  );
}
function Aq(e, n, t) {
  return e.verdict === 'holds'
    ? null
    : e.verdict === 'untestable'
      ? { code: t }
      : { code: n, detail: JSON.stringify(e.env) };
}
function S4(e, n) {
  let t = [],
    r = (v, k, y) =>
      t.push({ code: v, rule: e.id, ...(k && { path: k }), ...(y !== void 0 && { detail: y }) });
  Object.entries(e.vars).forEach(([v, k]) => {
    gC.includes(k) || r('sort_not_supported', `vars.${v}`, k);
  });
  let s = {};
  Object.entries(e.forms).forEach(([v, k]) => {
    let y = db(k);
    y.ok ? (s[v] = y.parsed) : r(`form_${y.code}`, `forms.${v}`, y.detail);
  });
  let i = new Set(Object.keys(e.vars)),
    o = new Set();
  (Object.entries(s).forEach(([v, k]) =>
    k.vars.forEach((y) => {
      (o.add(y), i.has(y) || r('var_undeclared', `forms.${v}`, y));
    }),
  ),
    Object.keys(s).length === Object.keys(e.forms).length &&
      i.forEach((v) => o.has(v) || r('var_unused', `vars.${v}`, v)));
  let a = e.applies_to;
  (e.kind === 'identity'
    ? (a !== void 0 && a !== 'expression' && r('applies_to_mismatch', 'applies_to', a),
      (a = 'expression'))
    : a === void 0
      ? r('applies_to_missing', 'applies_to')
      : a === 'expression' && r('applies_to_mismatch', 'applies_to', a),
    a &&
      Object.entries(s).forEach(([v, k]) => {
        (a === 'expression'
          ? k.relation === 'none'
          : a === 'equation'
            ? k.relation === '='
            : $y.includes(k.relation)) || r('form_relation_mismatch', `forms.${v}`, k.relation);
      }));
  let l = new Set(),
    u = new Set();
  (e.directions.forEach((v, k) => {
    let y = `directions.${k}`;
    (v.from in e.forms || r('direction_unknown_form', y, v.from),
      v.to in e.forms || r('direction_unknown_form', y, v.to),
      v.from === v.to && r('direction_same_form', y, v.from),
      l.has(`${v.from}>${v.to}`) && r('direction_duplicate', y),
      l.add(`${v.from}>${v.to}`),
      u.add(v.from),
      u.add(v.to));
  }),
    Object.keys(e.forms).forEach((v) => u.has(v) || r('form_unused', `forms.${v}`, v)));
  let c = [];
  ((e.preconditions ?? []).forEach((v, k) => {
    let y = Pq(v);
    (y.of.forEach((S) => i.has(S) || r('precondition_var_undeclared', `preconditions.${k}`, S)),
      c.push(y));
  }),
    e.on_unknown && !c.length && r('on_unknown_without_preconditions', 'on_unknown'),
    c.length && !e.on_unknown && r('on_unknown_missing', 'on_unknown'));
  let f = (e.effects ?? []).some((v) => v.flip_relation);
  if (
    (e.effects?.length && e.kind === 'identity'
      ? r('effects_on_identity', 'effects')
      : f && a !== 'inequality' && r('effect_not_applicable', 'effects', 'flip_relation'),
    a === 'inequality' &&
      e.directions.forEach((v, k) => {
        let y = s[v.from]?.relation,
          S = s[v.to]?.relation;
        y &&
          S &&
          S !== (f ? wC(y) : y) &&
          r('flip_inconsistent', `directions.${k}`, `${y} \u2192 ${S}`);
      }),
    t.length || !a)
  )
    return { issues: t };
  let d = Iq(e.vars, c),
    m = 0,
    p = new Set();
  e.directions.forEach((v, k) => {
    let y = e.kind === 'implication' ? `${v.from}>${v.to}` : [v.from, v.to].sort().join('|');
    if (p.has(y)) return;
    p.add(y);
    let S = V0(e.kind, a, s[v.from], s[v.to], d, `${e.id}#${y}`),
      w = Aq(S, 'rule_unsound', 'rule_untestable');
    w ? r(w.code, `directions.${k}`, w.detail) : S.verdict === 'holds' && (m += S.tested);
  });
  let g = [];
  if (
    (e.examples.forEach((v, k) => {
      let y = `examples.${k}`,
        S = Cy(v.from),
        w = Cy(v.to);
      if (!S.ok || !w.ok) {
        r(
          'example_unparsable',
          y,
          S.ok ? (w.ok ? '' : `${w.code}: ${w.detail}`) : `${S.code}: ${S.detail}`,
        );
        return;
      }
      let _ = (ae) =>
        a === 'expression'
          ? ae.relation === 'none'
          : a === 'equation'
            ? ae.relation === '='
            : $y.includes(ae.relation);
      if (!_(S.parsed) || !_(w.parsed)) {
        r('example_relation_mismatch', y);
        return;
      }
      let O = [...new Set([...S.parsed.vars, ...w.parsed.vars])],
        G = (v.assume ?? []).map(Pq);
      G.forEach((ae) =>
        ae.of.forEach((P) => O.includes(P) || r('example_assume_unknown_var', y, P)),
      );
      let Se = Object.fromEntries(O.map((ae) => [ae, 'real'])),
        U = V0(e.kind, a, S.parsed, w.parsed, Iq(Se, G), `${e.id}#ex${k}`);
      if (v.expect === 'valid') {
        let ae = Aq(U, 'example_failed', 'example_untestable');
        ae && r(ae.code, y, ae.detail);
      } else
        U.verdict === 'holds'
          ? r('example_not_refuted', y)
          : U.verdict === 'untestable' && r('example_untestable', y);
      g.push({ from: v.from, to: v.to, expect: v.expect, assume: G });
    }),
    t.length)
  )
    return { issues: t };
  let h = {};
  Object.entries(e.forms).forEach(([v, k]) => {
    let y = s[v];
    h[v] = { key: v, text: k, relation: y.relation, vars: y.vars };
  });
  let b = {
    qid: `${e.id}@${e.version}`,
    id: e.id,
    version: e.version,
    pack: n,
    kind: e.kind,
    relation: $q[e.kind],
    appliesTo: a,
    vars: { ...e.vars },
    forms: h,
    directions: e.directions.map((v) => ({
      from: v.from,
      to: v.to,
      goals: [...v.goals],
      introduces: s[v.to].vars.filter((k) => !s[v.from].vars.includes(k)),
    })),
    preconditions: c,
    onUnknown: e.on_unknown ?? null,
    flipRelation: f,
    cost: e.cost ?? w4,
    label: e.label,
    ref: e.ref ?? null,
    tags: [...(e.tags ?? [])],
    levels: [...(e.levels ?? [])],
    maxMatches: e.limits?.max_matches ?? y4,
    examples: g,
    selfTest: { proof: 'sampled', tested: m },
  };
  return (
    g.forEach((v, k) => {
      let y = T4(b, v);
      (v.expect === 'valid' && y === 'no' && r('example_not_recognized', `examples.${k}`),
        v.expect === 'invalid' &&
          y === 'valid' &&
          r('example_wrongly_recognized', `examples.${k}`));
    }),
    t.length ? { issues: t } : { issues: t, rule: b }
  );
}
function T4(e, n) {
  let t = ie(n.from),
    r = ie(n.to);
  if (!t.ok || !r.ok) return 'no';
  let s = ji(n.assume),
    i = 'no';
  for (let o of gb(e, t.s, r.s)) {
    let a = o.conditions.map((l) => tr(l, s));
    if (!a.includes('false')) {
      if (a.every((l) => l === 'true')) return 'valid';
      i = 'maybe';
    }
  }
  return i;
}
function Qq(e) {
  let n = Eq.safeParse(e);
  if (!n.success)
    return {
      ok: !1,
      issues: n.error.issues.map((a) => ({
        code: 'schema',
        path: a.path.join('.'),
        detail: a.message,
      })),
    };
  let t = n.data,
    r = `${t.id}@${t.version}`,
    s = [],
    i = [],
    o = new Set();
  return (
    t.rules.forEach((a, l) => {
      (o.has(a.id) && s.push({ code: 'rule_duplicate', rule: a.id, path: `rules.${l}` }),
        o.add(a.id));
      let u = S4(a, r);
      (u.issues.forEach((c) => s.push({ ...c, path: `rules.${l}${c.path ? '.' + c.path : ''}` })),
        u.rule && i.push(u.rule));
    }),
    s.length
      ? { ok: !1, issues: s }
      : {
          ok: !0,
          pack: jq({ qid: r, id: t.id, version: t.version, label: t.label ?? null, rules: i }),
        }
  );
}
var Vq = 12,
  Dq = 40;
function R4(e) {
  let n = Z(e);
  if (!n.ok) return null;
  let t = $e(n.rf),
    r = je(t.d);
  if (!r || L(r)) return null;
  let s = new Map(),
    i = F;
  for (let { m: o, c: a } of Xs(t.n)) {
    let l = A(a, r);
    if (o.length === 0) i = re(i, l);
    else if (o.length === 1 && o[0].e === 1 && o[0].a.kind === 'sym') {
      let u = o[0].a.symbol,
        c = s.get(u) ?? F,
        f = re(c, l);
      L(f) ? s.delete(u) : s.set(u, f);
    } else return null;
  }
  return { coef: s, c: i };
}
function xc(e) {
  return e.k !== 'rel' || e.rel !== '=' ? null : R4(ve(e.l, e.r));
}
function D0(e) {
  let n = new Set();
  for (let t of e) for (let r of t.coef.keys()) n.add(r);
  return [...n].sort();
}
function is(e) {
  return e.coef.size === 0 && L(e.c);
}
function Yp(e) {
  return e.coef.size === 0 && !L(e.c);
}
function Fq(e, n) {
  return n.map((t) => (t === '' ? e.c : (e.coef.get(t) ?? F)));
}
function $4(e, n, t) {
  let r = e.length,
    s = e.map((l, u) => [...l, n[u]]),
    i = [],
    o = 0;
  for (let l = 0; l < t && o < r; l++) {
    let u = -1;
    for (let f = o; f < r; f++)
      if (!L(s[f][l])) {
        u = f;
        break;
      }
    if (u < 0) continue;
    [s[o], s[u]] = [s[u], s[o]];
    let c = A(q, s[o][l]);
    s[o] = s[o].map((f) => N(f, c));
    for (let f = 0; f < r; f++) {
      if (f === o || L(s[f][l])) continue;
      let d = s[f][l];
      s[f] = s[f].map((m, p) => me(m, N(d, s[o][p])));
    }
    (i.push(l), o++);
  }
  for (let l = o; l < r; l++) if (!L(s[l][t])) return null;
  let a = Array.from({ length: t }, () => F);
  return (i.forEach((l, u) => (a[l] = s[u][t])), a);
}
function Ld(e, n) {
  if (e.length === 0) return is(n) ? [] : null;
  if (e.length > Dq) return null;
  let t = [...D0([...e, n]), ''];
  if (t.length - 1 > Vq) return null;
  let r = e.map((i) => Fq(i, t)),
    s = t.map((i, o) => r.map((a) => a[o]));
  return $4(s, Fq(n, t), e.length);
}
function B0(e, n = D0(e)) {
  let t = [...n];
  if (t.length > Vq || e.length > Dq) return { kind: 'too_big' };
  let r = t.length,
    s = e.map((u) => [...t.map((c) => u.coef.get(c) ?? F), fe(u.c)]),
    i = [],
    o = 0;
  for (let u = 0; u < r && o < s.length; u++) {
    let c = -1;
    for (let d = o; d < s.length; d++)
      if (!L(s[d][u])) {
        c = d;
        break;
      }
    if (c < 0) continue;
    [s[o], s[c]] = [s[c], s[o]];
    let f = A(q, s[o][u]);
    s[o] = s[o].map((d) => N(d, f));
    for (let d = 0; d < s.length; d++) {
      if (d === o || L(s[d][u])) continue;
      let m = s[d][u];
      s[d] = s[d].map((p, g) => me(p, N(m, s[o][g])));
    }
    (i.push(u), o++);
  }
  for (let u = o; u < s.length; u++) if (!L(s[u][r])) return { kind: 'none' };
  let a = (u, c) => {
      let f = new Map();
      for (let [d, m] of u) f.set(t[d], m);
      i.forEach((d, m) => {
        let p = c ? F : s[m][r];
        for (let [g, h] of u) p = me(p, N(s[m][g], h));
        f.set(t[d], p);
      });
      for (let d = 0; d < r; d++) f.has(t[d]) || f.set(t[d], F);
      return f;
    },
    l = t.map((u, c) => c).filter((u) => !i.includes(u));
  return l.length === 0
    ? { kind: 'unique', values: a(new Map(), !1) }
    : {
        kind: 'infinite',
        particular: a(new Map(l.map((u) => [u, F])), !1),
        directions: l.map((u) => a(new Map(l.map((c) => [c, c === u ? q : F])), !0)),
        free: l.map((u) => t[u]),
      };
}
function na(e, n) {
  return is(e) || is(n) ? is(e) && is(n) : Ld([e], n) !== null;
}
var Bq = (e) => {
  let n = [];
  for (let t = 0; e >> t; t++) (e >> t) & 1 && n.push(t);
  return n;
};
function C4(e) {
  return e.k !== 'rel' || e.rel !== '='
    ? null
    : e.l.k === 'sym' && !$(e.r).has(e.l.n)
      ? { u: e.l.n, e: e.r }
      : null;
}
function eg(e, n, t, r) {
  let s = xc(e);
  return s ? { s: e, f: s, origin: t, K: n, text: r, isolated: C4(e) } : null;
}
function zq(e, n, t) {
  let r = e.map((a, l) => {
      let u = eg(a.s, a.K, 1 << l, a.text);
      if (!u) throw new Error(`\xE9quation non lin\xE9aire dans le syst\xE8me : ${a.K}`);
      return u;
    }),
    s = r.map((a) => a.f),
    i = (1 << r.length) - 1,
    o = [];
  for (let a = i; a > 0; a--) {
    if (o.some((u) => (u & a) === a)) continue;
    let l = Bq(a).map((u) => s[u]);
    B0(l, n).kind !== 'none' && o.push(a);
  }
  return {
    unknowns: n,
    outcome: t,
    equations: r,
    lines: [],
    rank: Uq(s, n),
    compatible: o,
    redundancies: [],
    values: new Map(),
    contradiction: !1,
  };
}
function Uq(e, n) {
  let t = B0(
    e.map((r) => ({ coef: r.coef, c: F })),
    n,
  );
  return t.kind === 'unique' ? n.length : t.kind === 'infinite' ? n.length - t.free.length : 0;
}
function Lv(e, n) {
  let t = e.equations.map((r) => r.f);
  return Yp(n)
    ? Ld(t, n) !== null
    : e.compatible.some(
        (r) =>
          Ld(
            Bq(r).map((s) => t[s]),
            n,
          ) !== null,
      );
}
function Gq(e, n) {
  if (n.coef.size === 0) return null;
  let t = (o) => ({ coef: o.coef, c: F }),
    r = t(n),
    s = yc(e),
    i = s.find((o) => o.f.coef.size > 0 && na(t(o.f), r));
  if (i) return { kind: 'transform', lines: [i] };
  for (let o = 0; o < s.length; o++)
    for (let a = o + 1; a < s.length; a++) {
      let l = s[o],
        u = s[a],
        c = Ld([t(l.f), t(u.f)], r);
      if (!(!c || L(c[0]) || L(c[1])) && B(c[0]) && B(c[1]))
        return { kind: 'combine', lines: [l, u] };
    }
  return null;
}
function Zq(e, n) {
  let t = [...n.coef.keys()],
    r = null;
  for (let s of yc(e)) {
    if (s.f.coef.size !== t.length || !t.every((o) => s.f.coef.has(o))) continue;
    let i = t.filter((o) => M(mn(s.f.coef.get(o)), mn(n.coef.get(o)))).length;
    (!r || i > r.score) && (r = { l: s, score: i });
  }
  return r?.l ?? null;
}
function yc(e) {
  return [...[...e.lines].reverse(), ...e.equations];
}
var Nd = (e) => new Set(e.coef.keys());
function z0(e, n, t, r, s) {
  let i = yc(e);
  if (is(t)) {
    let d = [];
    for (let m = 0; m < i.length; m++)
      for (let p = m + 1; p < i.length; p++) {
        let g = i[m],
          h = i[p];
        g.origin !== h.origin &&
          na(g.f, h.f) &&
          !e.redundancies.includes(Nv(g.origin, h.origin)) &&
          d.push({ kind: 'redundant', a: g, b: h });
      }
    return d;
  }
  let o = i.filter((d) => na(d.f, t)).map((d) => ({ kind: 'transform', from: d })),
    a = [],
    l = [];
  for (let d of i) {
    if (!d.isolated) continue;
    let { u: m, e: p } = d.isolated;
    for (let g of i) {
      if (g === d || !g.f.coef.has(m) || g.s.k !== 'rel') continue;
      let h = { [m]: p },
        b = { k: 'rel', rel: g.s.rel, l: j(g.s.l, h), r: j(g.s.r, h) };
      if (s(b) === r) a.push({ kind: 'substitute', sub: d, into: g, literal: !0 });
      else {
        let v = xc(b);
        v && na(v, t) && l.push({ kind: 'substitute', sub: d, into: g, literal: !1 });
      }
    }
  }
  let u = [],
    c = [],
    f = Nd(t);
  for (let d = 0; d < i.length; d++)
    for (let m = d + 1; m < i.length; m++) {
      let p = i[d],
        g = i[m];
      if (na(p.f, g.f)) continue;
      let h = Ld([p.f, g.f], t);
      if (!h || L(h[0]) || L(h[1])) continue;
      let b = [...new Set([...p.f.coef.keys(), ...g.f.coef.keys()])].filter((y) => !f.has(y)),
        v = B(h[0]) && B(h[1]),
        k = {
          kind: 'combine',
          a: p,
          b: g,
          lambdas: [h[0], h[1]],
          integer: v,
          eliminated: b.sort(),
        };
      (v && b.length ? u : c).push(k);
    }
  return [...o, ...a, ...u, ...l, ...c];
}
function Hq(e) {
  switch (e.kind) {
    case 'transform':
      return e.from.origin;
    case 'substitute':
      return e.sub.origin | e.into.origin;
    case 'combine':
    case 'redundant':
      return e.a.origin | e.b.origin;
  }
}
var Nv = (e, n) => String(e | n);
function Ov(e, n) {
  if (is(n.f)) return null;
  for (let t of yc(e)) {
    if (t.origin === n.origin || t.K !== n.K) continue;
    let r = Nv(t.origin, n.origin);
    if (!e.redundancies.includes(r)) return { key: r, other: t };
  }
  return null;
}
function Wq(e, n, t) {
  let r = (s, i) => !!s && !!i && M(mn(s), mn(i));
  return yc(e).some(
    (s) =>
      !na(s.f, t) &&
      [...t.coef.keys()].some(
        (i) => r(t.coef.get(i), s.f.coef.get(i)) && !r(n.f.coef.get(i), s.f.coef.get(i)),
      ),
  );
}
function U0(e, n, t) {
  let r = t.redundancy ?? Ov(e, n)?.key;
  (r && !e.redundancies.includes(r) && e.redundancies.push(r),
    t.value && e.values.set(t.value.u, t.value.v),
    t.contradiction && (e.contradiction = !0),
    is(n.f) || e.lines.push(n));
}
function G0(e) {
  switch (e.outcome) {
    case 'unique':
      return e.unknowns.every((n) => e.values.has(n));
    case 'none':
      return e.contradiction;
    case 'infinite': {
      let n = e.equations.length - e.rank;
      return n > 0 ? e.redundancies.length >= n : E4(e);
    }
  }
}
function E4(e) {
  let n = new Map();
  for (let i of e.lines) i.isolated && !n.has(i.isolated.u) && n.set(i.isolated.u, i);
  let t = [...n.values()],
    r = new Set(n.keys()),
    s = t.filter((i) => ![...$(i.isolated.e)].some((o) => r.has(o)));
  return s.length < e.rank
    ? !1
    : Uq(
        s.map((i) => i.f),
        e.unknowns,
      ) >= e.rank;
}
function Z0(e, n, t) {
  let r = {
    ...e,
    lines: [...e.lines],
    redundancies: [...e.redundancies],
    values: new Map(e.values),
  };
  return (U0(r, n, t), G0(r));
}
var ng = {
    definition: 'counting.binom_def@1',
    formula: 'counting.binom_formula@1',
    knownValue: 'counting.known_value@1',
    quotient: 'counting.fact_quotient@1',
  },
  Rl = 'D\xE9nombrement',
  Jq = () => ({ binom: 0, known: 0, quot: 0, span: 0, fact: 0, facts: 0 });
function Cl(e) {
  let n = Z(e);
  return n.ok ? _n($e(n.rf)) : null;
}
function W0(e) {
  let n = Z(e);
  return n.ok ? E(R(Je($e(n.rf)))) : null;
}
function M4(e) {
  let n = (r) => r !== null && B(r) && (r.n === 0n || r.n === 1n);
  if (n(Cl(e.a)) || n(Cl(ve(e.b, e.a)))) return !0;
  let t = Cl(e.b);
  return t !== null && B(t) && t.n >= 0n && t.n <= 5n && Cl(e.a) !== null;
}
function J0(e) {
  return e.k === 'mul' ? e.c.flatMap(J0) : [e];
}
var Kv = (e) => e.k === 'fn' && e.f === 'fact';
function H0(e, n = Jq()) {
  return (ta(e, n, new Set()), n);
}
function ta(e, n, t) {
  switch (e.k) {
    case 'binom':
      (M4(e) ? n.known++ : n.binom++, ta(e.a, n, t), ta(e.b, n, t));
      return;
    case 'add':
    case 'mul':
      e.c.forEach((r) => ta(r, n, t));
      return;
    case 'div':
      (_4(e, n, t), ta(e.a, n, t), ta(e.b, n, t));
      return;
    case 'pow':
      (ta(e.a, n, t), ta(e.b, n, t));
      return;
    case 'fn':
      if (Kv(e)) {
        n.facts++;
        let r = Cl(e.a);
        !t.has(e) && r !== null && B(r) && r.n >= 0n && n.fact++;
      }
      ta(e.a, n, t);
      return;
    default:
      return;
  }
}
function _4(e, n, t) {
  let r = J0(e.a),
    s = J0(e.b),
    i = new Set(),
    o = (l) => l.filter(Kv);
  for (let l of o(r)) {
    let u = null;
    for (let c of o(s)) {
      if (i.has(c)) continue;
      let f = Cl(ve(l.a, c.a));
      if (f === null || !B(f)) continue;
      let d = Number(f.n < 0n ? -f.n : f.n);
      (!u || d < u.d) && (u = { g: c, d });
    }
    u && (i.add(u.g), i.add(l), t.add(l).add(u.g), n.quot++, (n.span += Math.min(u.d, 40)));
  }
  let a = (l, u) => {
    for (let c of o(l)) {
      if (i.has(c)) continue;
      let f = W0(c.a);
      if (f === null || Cl(c.a) !== null) continue;
      let d = u.find((m) => !Kv(m) && !i.has(m) && W0(m) === f);
      d && (i.add(d), i.add(c), t.add(c), n.quot++, (n.span += 1));
    }
  };
  (a(s, r), a(r, s));
}
function Xq(e, n) {
  let t = Jq();
  e.k === 'expr' && H0(e.e, t);
  for (let r of n) (H0(r.l, t), H0(r.r, t));
  return t;
}
var X0 = (e) => 50 * e.binom + 10 * e.known + 2 * e.quot + e.span + 2 * e.fact,
  Yq = (e, n) => Object.keys(e).some((t) => e[t] !== n[t]);
function wc(e) {
  switch (e.k) {
    case 'div':
      return !0;
    case 'add':
    case 'mul':
      return e.c.some(wc);
    case 'pow':
    case 'binom':
      return wc(e.a) || wc(e.b);
    case 'fn':
      return wc(e.a);
    default:
      return !1;
  }
}
function $l(e, n = new Set()) {
  let t = (r) => {
    let s = Cl(r);
    if (s !== null) {
      (B(s) && s.n <= 1n) || n.add(`#${bt(s)}`);
      return;
    }
    let i = W0(r);
    i !== null && n.add(i);
  };
  switch (e.k) {
    case 'binom':
      (t(e.b), t(e.a), t(ve(e.b, e.a)), $l(e.a, n), $l(e.b, n));
      break;
    case 'fn':
      (Kv(e) && t(e.a), $l(e.a, n));
      break;
    case 'add':
    case 'mul':
      e.c.forEach((r) => $l(r, n));
      break;
    case 'div':
    case 'pow':
      ($l(e.a, n), $l(e.b, n));
      break;
    default:
      break;
  }
  return n;
}
function eL(e, n) {
  let t = $l(n),
    r = 0;
  for (let s of $l(e)) t.has(s) || r++;
  return r;
}
function nL(e, n, t) {
  return n.binom > e.binom
    ? {
        info: {
          id: ng.definition,
          card: Rl,
          label: 'Reconna\xEEtre k parmi n',
          hora: 2,
          why: 'n! \xF7 (k! \xD7 (n \u2212 k)!) s\u2019\xE9crit \xAB k parmi n \xBB : le nombre de fa\xE7ons de choisir k \xE9l\xE9ments parmi n.',
        },
      }
    : n.binom + n.known < e.binom + e.known
      ? n.facts > e.facts
        ? {
            info: {
              id: ng.definition,
              card: Rl,
              label: '\xC9crire avec les factorielles',
              hora: 2,
              why: 'k parmi n = n! \xF7 (k! \xD7 (n \u2212 k)!).',
            },
          }
        : t.division
          ? {
              info: {
                id: ng.formula,
                card: Rl,
                label: 'Formule de k parmi n',
                hora: 2,
                why: 'k parmi n = n \xD7 (n \u2212 1) \xD7 \u2026 \xD7 (n \u2212 k + 1) \xF7 k! : k facteurs en haut, k! en bas.',
              },
            }
          : n.binom === e.binom
            ? {
                info: {
                  id: ng.knownValue,
                  card: Rl,
                  label: 'Valeur \xE0 conna\xEEtre',
                  hora: 1,
                  why: '0 parmi n = 1, 1 parmi n = n, (n \u2212 1) parmi n = n, n parmi n = 1 ; les premi\xE8res lignes du triangle de Pascal se lisent directement.',
                },
              }
            : {
                reject: {
                  title: 'Montre comment',
                  message:
                    'Ta ligne est juste, mais on ne voit pas le calcul : \xE9cris d\u2019abord \xAB k parmi n \xBB avec les factorielles, n! \xF7 (k! \xD7 (n \u2212 k)!), ou avec la formule n \xD7 (n \u2212 1) \xD7 \u2026 \xF7 k!.',
                },
              }
      : n.quot < e.quot || n.span < e.span
        ? t.plain && e.span - n.span >= 2
          ? {
              reject: {
                title: 'Un calcul \xE0 la fois',
                message:
                  'Ta ligne est juste, mais elle simplifie les factorielles ET calcule d\u2019un coup. \xC9cris d\u2019abord le quotient simplifi\xE9 (100! \xF7 98! = 100 \xD7 99), puis calcule.',
              },
            }
          : {
              info: {
                id: ng.quotient,
                card: Rl,
                label: 'Simplifier les factorielles',
                hora: 2,
                why: 'n! = n \xD7 (n \u2212 1) \xD7 \u2026 \xD7 (p + 1) \xD7 p! : on simplifie le quotient par p! (100! \xF7 98! = 100 \xD7 99).',
              },
            }
        : n.fact < e.fact
          ? {
              info: {
                id: 'kernel.compute@1',
                card: Rl,
                label: 'Calculer la factorielle',
                hora: 1,
                why: 'n! = n \xD7 (n \u2212 1) \xD7 \u2026 \xD7 2 \xD7 1 : 5! = 120.',
              },
            }
          : null;
}
var Pv = { mixed: 50, trig: 40, isolated: 40, reference: 35, associated: 35, family: 20 },
  tL = (e, n) => $(e).has(n),
  ra = (e, n) => [...$(e)].some((t) => n.has(t)),
  Od = (e, n) => E(R(e)) === E(R(n));
function sa(e, n) {
  let t = [];
  for (let r of [...Za(e.l, n), ...Za(e.r, n)]) t.some((s) => E(s) === E(r)) || t.push(r);
  return t;
}
function Iv(e, n, t) {
  let r = sa(e, n);
  if (!r.length) return ra(e.l, t) || ra(e.r, t) ? 'family' : 'linear';
  if (r.length === 1) {
    let s = r[0],
      [i, o] = Od(e.l, s) ? [e.l, e.r] : Od(e.r, s) ? [e.r, e.l] : [null, null];
    if (!i || !o || tL(o, n)) return 'trig';
    let a = R(o);
    return a.k === 'fn' && s.k === 'fn' && a.f === s.f && $(a).size === 0
      ? 'reference'
      : 'isolated';
  }
  if (r.length === 2) {
    let [s, i] = r;
    if (
      ((Od(e.l, s) && Od(e.r, i)) || (Od(e.l, i) && Od(e.r, s))) &&
      s.k === 'fn' &&
      i.k === 'fn' &&
      s.f === i.f
    )
      return 'associated';
  }
  return 'mixed';
}
function tg(e) {
  return e.k === 'set'
    ? e.clauses
    : e.k === 'or'
      ? e.items.map((n) => [n])
      : e.k === 'rel'
        ? [[{ rel: e.rel, l: e.l, r: e.r }]]
        : [];
}
function rL(e, n, t, r, s) {
  let i = (u) => {
      let c = Iv(u, n, t);
      switch (c) {
        case 'mixed':
        case 'isolated':
        case 'reference':
        case 'associated':
          return Pv[c];
        case 'trig': {
          let f = sa(u, n)[0],
            d = E(f),
            m = '\xA7t',
            p = { rel: u.rel, l: ys(u.l, d, rn(m)), r: ys(u.r, d, rn(m)) };
          return Pv.trig + s(p, m);
        }
        case 'family':
          return (r ? Pv.family : 0) + s(u, n);
        case 'linear':
          return s(u, n);
      }
    },
    o = tg(e).map((u) => Math.max(...u.map(i)));
  if (!o.length) return Pv.mixed;
  let a = Math.max(...o),
    l = o.reduce((u, c) => u + c, 0);
  return a + 0.1 * (l - a) + 0.05 * (o.length - 1);
}
function sL(e, n, t, r) {
  if (e.k === 'set') return zo(e, n) && !on(e).some((i) => ra(i.l, t) || ra(i.r, t));
  let s = on(e);
  return (
    s.length > 0 &&
    s.every(
      (i) =>
        i.rel === '=' &&
        i.l.k === 'sym' &&
        i.l.n === n &&
        !tL(i.r, n) &&
        (!r || !ra(i.r, t)) &&
        sa(i, n).length === 0,
    )
  );
}
function rg(e, n) {
  return on(e).some((t) => ra(t.l, n) || ra(t.r, n));
}
function Y0(e, n, t) {
  let r = on(e);
  return r.length > 0 && r.every((s) => sa(s, n).length === 0 && !ra(s.l, t) && !ra(s.r, t));
}
var lL = '\u229E',
  uL = 6,
  cL = 6,
  q4 = ['\u2197', '\u2198'],
  iL = { '+': '+', '\u2212': '\u2212', '-': '\u2212', 0: '0', '\u2016': '\u2016', '.': '' };
function bi(e) {
  return e.startsWith(lL);
}
function jv(e) {
  if (!bi(e)) return null;
  let n;
  try {
    n = JSON.parse(e.slice(lL.length));
  } catch {
    return null;
  }
  if (!n || typeof n != 'object') return null;
  let { v: t, r, f: s } = n;
  if (
    !Array.isArray(t) ||
    !Array.isArray(r) ||
    t.length > uL ||
    !r.length ||
    r.length > cL ||
    !t.every((c) => typeof c == 'string' && c.trim().length > 0 && c.length <= 40)
  )
    return null;
  let i = 2 * t.length + 1,
    o = [];
  for (let c of r) {
    if (!Array.isArray(c) || c.length !== 2) return null;
    let [f, d] = c;
    if (typeof f != 'string' || !f.trim() || f.length > 80 || typeof d != 'string') return null;
    let m = Array.from(d);
    if (m.length !== i || !m.every((p) => p in iL)) return null;
    o.push({ label: f, cells: m.map((p) => iL[p]) });
  }
  if (s === void 0) return { values: t, rows: o };
  if (!Array.isArray(s) || s.length !== 2) return null;
  let [a, l] = s;
  if (typeof a != 'string' || !a.trim() || a.length > 80 || !Array.isArray(l) || l.length !== i)
    return null;
  let u = [];
  for (let c = 0; c < i; c++) {
    let f = l[c];
    if (typeof f != 'string' || f.length > 40 || (c % 2 === 0 && f !== '' && !q4.includes(f)))
      return null;
    u.push(f.trim());
  }
  return { values: t, rows: o, f: { label: a, cells: u } };
}
var nw = (e, n) => $(e).has(n);
function sg(e) {
  switch (e.k) {
    case 'num': {
      let { n, d: t } = e.v;
      if (t === 1n) return e;
      let r = t,
        s = 0;
      for (; r % 2n === 0n || r % 5n === 0n; )
        if (((r = r % 2n === 0n ? r / 2n : r / 5n), ++s > 12)) return e;
      return r !== 1n ? e : { k: 'sym', n: pe(Number(n) / Number(t)) };
    }
    case 'add':
    case 'mul':
      return { ...e, c: e.c.map(sg) };
    case 'div':
    case 'pow':
    case 'binom':
      return { ...e, a: sg(e.a), b: sg(e.b) };
    case 'fn':
      return { ...e, a: sg(e.a) };
    default:
      return e;
  }
}
var L4 = {
  0: '\u2070',
  1: '\xB9',
  2: '\xB2',
  3: '\xB3',
  4: '\u2074',
  5: '\u2075',
  6: '\u2076',
  7: '\u2077',
  8: '\u2078',
  9: '\u2079',
};
function ia(e) {
  return oe(sg(e))
    .replace(/\) × \(/g, ')(')
    .replace(/(\^\d+|[²³⁴⁵⁶⁷⁸⁹]) × \(/g, '$1(')
    .replace(/(^|[\s(−])(\d+(?:,\d+)?) × \(/g, '$1$2(')
    .replace(/\((−\d+(?:,\d+)?)\) × ([a-zα-ω])(?![\w(])/g, '$1$2')
    .replace(/\^(\d+)/g, (n, t) => [...t].map((r) => L4[r]).join(''));
}
function N4(e) {
  try {
    return ia(Je($e(Ge(e))));
  } catch {
    return ia(R(e));
  }
}
function to(e, n) {
  try {
    if (Nu(Ge(ve(e, n)))) return !0;
  } catch {}
  let t = D(e, {}),
    r = D(n, {});
  return Number.isFinite(t) && Number.isFinite(r) && Math.abs(t - r) < 1e-12;
}
function oL(e, n) {
  let t = td(e, n);
  if (!t || t.opaque || t.den) return null;
  let r;
  try {
    r = Bt(Ge(e), n);
  } catch {
    return null;
  }
  return !r || !r.complete ? null : r.roots;
}
function O4(e) {
  let n = D(e, {});
  return Number.isFinite(n) ? (Math.abs(n) < 1e-12 ? 0 : n > 0 ? 1 : -1) : null;
}
function Av(e, n, t, r) {
  if (!nw(e, n)) {
    let s = O4(e);
    return s === null || s === 0
      ? !1
      : (s < 0 && r.push({ term: R(e), label: ia(R(e)), den: t, roots: [], constant: !0 }), !0);
  }
  switch (e.k) {
    case 'mul':
      return e.c.every((s) => Av(s, n, t, r));
    case 'div':
      return Av(e.a, n, t, r) && Av(e.b, n, !t, r);
    case 'pow': {
      let s = e.b;
      if (s.k !== 'num' || !B(s.v) || s.v.n < 1n || nw(s, n)) return !1;
      if (e.a.k === 'fn' && e.a.f === 'exp')
        return (r.push({ term: e, label: ia(e), den: t, roots: [], constant: !1 }), !0);
      let i = oL(e.a, n);
      return i ? (r.push({ term: e, label: ia(e), den: t, roots: i, constant: !1 }), !0) : !1;
    }
    case 'fn':
      return e.f !== 'exp'
        ? !1
        : (r.push({ term: e, label: ia(e), den: t, roots: [], constant: !1 }), !0);
    default: {
      let s = oL(e, n);
      return s ? (r.push({ term: e, label: ia(e), den: t, roots: s, constant: !1 }), !0) : !1;
    }
  }
}
function Qv(e, n) {
  if (!nw(e, n)) return null;
  let t = [];
  if (!Av(e, n, !1, t) || !t.some((c) => !c.constant)) return null;
  let r = [];
  for (let c of t)
    for (let f of c.roots) {
      let d = D(f, {});
      if (!Number.isFinite(d)) return null;
      r.some((m) => to(m.t, f)) || r.push({ t: f, f: d });
    }
  if ((r.sort((c, f) => c.f - f.f), r.length > uL)) return null;
  let s = [];
  if (!r.length) s.push(0);
  else {
    s.push(r[0].f - 1);
    for (let c = 0; c + 1 < r.length; c++) s.push((r[c].f + r[c + 1].f) / 2);
    s.push(r[r.length - 1].f + 1);
  }
  let i = (c, f) => {
      let d = D(c, { [n]: f });
      return !Number.isFinite(d) || Math.abs(d) < 1e-12 ? null : d > 0 ? '+' : '\u2212';
    },
    o = (c, f) => c.roots.some((d) => to(d, f)),
    a = t.length === 1,
    l = [];
  if (!a)
    for (let c of t) {
      let f = [];
      for (let d = 0; d < s.length; d++) {
        let m = c.constant ? '\u2212' : i(c.term, s[d]);
        if (!m) return null;
        (f.push(m), d < r.length && f.push(o(c, r[d].t) ? '0' : ''));
      }
      l.push({ label: c.label, cells: f, den: c.den });
    }
  if (l.length + 1 > cL) return null;
  let u = [];
  for (let c = 0; c < s.length; c++) {
    let f = i(e, s[c]);
    if (!f) return null;
    if ((u.push(f), c < r.length)) {
      let d = r[c].t;
      u.push(
        t.some((m) => m.den && o(m, d)) ? '\u2016' : t.some((m) => !m.den && o(m, d)) ? '0' : '',
      );
    }
  }
  return (
    l.push({ label: ia(e), cells: u, den: !1 }),
    { x: n, subject: ia(e), values: r.map((c) => c.t), valueTexts: r.map((c) => N4(c.t)), rows: l }
  );
}
function ew(e, n) {
  let t = e.valueTexts,
    r = n === 0 ? '\u2212\u221E' : t[n - 1],
    s = n === t.length ? '+\u221E' : t[n];
  return `]${r} ; ${s}[`;
}
function K4(e) {
  let n = ie(e);
  return !n.ok || n.s.k !== 'expr' ? null : Number.isFinite(D(n.s.e, {})) ? n.s.e : null;
}
function P4(e, n) {
  return n.rows.length !== e.rows.length
    ? !1
    : n.rows.every((t, r) => aL(t.label) === aL(e.rows[r].label));
}
var aL = (e) => e.replace(/\s+/g, '').replace(/-/g, '\u2212');
function Fv(e, n) {
  let t = e.x;
  if (!P4(e, n))
    return {
      title: 'Ce tableau ne va pas avec ta ligne',
      message: `Les lignes du tableau sont les facteurs de ta derni\xE8re ligne compar\xE9e \xE0 0, puis ${e.subject}. Ouvre le tableau depuis la palette.`,
    };
  let r = [];
  for (let i = 0; i < n.values.length; i++) {
    let o = K4(n.values[i]);
    if (!o)
      return {
        title: 'Valeur illisible',
        message: `Je ne lis pas \xAB ${n.values[i]} \xBB comme un nombre.`,
        row: -1,
        col: i,
      };
    if (!e.values.some((a) => to(a, o)))
      return {
        title: 'Une valeur en trop',
        message: `Aucun facteur ne s\u2019annule en ${t} = ${n.values[i]} : retire cette valeur.`,
        row: -1,
        col: i,
      };
    if (r.some((a) => to(a, o)))
      return {
        title: 'Une valeur deux fois',
        message: `${t} = ${n.values[i]} est d\xE9j\xE0 sur la ligne des ${t}.`,
        row: -1,
        col: i,
      };
    r.push(o);
  }
  if (r.length < e.values.length)
    return {
      title: 'Il manque une valeur',
      message: `Chaque facteur s\u2019annule pour une valeur de ${t} : cherche-les toutes et place-les sur la ligne des ${t}.`,
      row: -1,
    };
  for (let i = 0; i < r.length; i++)
    if (!to(r[i], e.values[i]))
      return {
        title: 'Dans l\u2019ordre croissant',
        message: `Range les valeurs de ${t} de la plus petite \xE0 la plus grande, de \u2212\u221E \xE0 +\u221E.`,
        row: -1,
        col: i,
      };
  let s = e.rows.length - 1;
  for (let i = 0; i < e.rows.length; i++) {
    let o = e.rows[i],
      a = n.rows[i],
      l = o.label;
    for (let u = 0; u < o.cells.length; u++) {
      let c = o.cells[u],
        f = a.cells[u];
      if (c === f) continue;
      let d = u % 2 === 0,
        m = u >> 1;
      if (d)
        return f
          ? {
              title: 'Pas le bon signe',
              message:
                i === s && s > 0
                  ? `Sur ${ew(e, m)}, applique la r\xE8gle des signes aux facteurs de la colonne.`
                  : `Le signe de ${l} sur ${ew(e, m)} n\u2019est pas le bon : remplace ${t} par un nombre de cet intervalle.`,
              row: i,
              col: u,
            }
          : {
              title: 'Il manque un signe',
              message: `Mets un signe (+ ou \u2212) sur chaque intervalle : il en manque un sur ${ew(e, m)}.`,
              row: i,
              col: u,
            };
      let p = e.valueTexts[m];
      return f === '\u2016' && i !== s
        ? {
            title: 'La double barre',
            message:
              'La double barre ne va que sur la derni\xE8re ligne, sous une valeur interdite (le d\xE9nominateur s\u2019annule). Sur la ligne d\u2019un facteur, \xE9cris 0 l\xE0 o\xF9 il s\u2019annule.',
            row: i,
            col: u,
          }
        : c === '\u2016'
          ? {
              title: 'Une valeur interdite',
              message: `En ${t} = ${p}, le d\xE9nominateur s\u2019annule : la valeur est interdite, mets une double barre \u2016.`,
              row: i,
              col: u,
            }
          : c === '0'
            ? {
                title: 'Ici, \xE7a s\u2019annule',
                message:
                  i === s
                    ? `En ${t} = ${p}, un facteur du num\xE9rateur s\u2019annule : l\u2019expression vaut 0.`
                    : `${l} s\u2019annule en ${t} = ${p} : \xE9cris 0.`,
                row: i,
                col: u,
              }
            : {
                title: 'Rien ne s\u2019annule ici',
                message:
                  i === s
                    ? `En ${t} = ${p}, rien ne s\u2019annule : laisse la case vide.`
                    : `${l} ne s\u2019annule pas en ${t} = ${p} : laisse la case vide.`,
                row: i,
                col: u,
              };
    }
  }
  return null;
}
var tw = null;
function Du() {
  return (
    tw ||
      (tw = iE.flatMap((e) => {
        let n = Qq(e);
        if (!n.ok) throw new Error('paquet de r\xE8gles du noyau invalide');
        return n.pack.rules;
      })),
    tw
  );
}
var rw = null,
  sw = null,
  iw = null;
function mw(e, n = !1) {
  return n
    ? (iw || (iw = Du()), iw)
    : e
      ? (sw || (sw = Du().filter((t) => !t.qid.startsWith('condition.'))), sw)
      : (rw ||
          (rw = Du().filter((t) => !t.qid.startsWith('log.') && !t.qid.startsWith('condition.'))),
        rw);
}
var Me = {
    compute: 'kernel.compute@1',
    expand: 'kernel.expand@1',
    swap: 'kernel.swap@1',
    round: 'kernel.round@1',
    inverse: 'trig.inverse@1',
    combine: 'kernel.combine@1',
    substitute: 'kernel.substitute@1',
    redundant: 'kernel.redundant@1',
    integerBound: 'kernel.integer_bound@1',
    testValue: 'kernel.test_value@1',
    condition: 'kernel.condition@1',
    conditionKeep: 'kernel.condition_keep@1',
    factor: 'kernel.factor@1',
  },
  Un = {
    allOnOneSide: 'poly.all_on_one_side@1',
    factor: 'poly.factor@1',
    canonical: 'poly.canonical@1',
    zeroProduct: 'poly.zero_product@1',
    squareRoot: 'poly.square_root@1',
    squareCompare: 'poly.square_compare@1',
    cubeRoot: 'poly.cube_root@1',
    cubeCompare: 'poly.cube_compare@1',
    signTable: 'poly.sign_table@1',
    signTableFill: 'poly.sign_table_fill@1',
    signTableRead: 'poly.sign_table_read@1',
    clauses: 'poly.clauses@1',
    clearDenominator: 'poly.clear_denominator@1',
    sameDenominator: 'poly.same_denominator@1',
    discriminant: 'poly.discriminant@1',
    discriminantSign: 'poly.discriminant_sign@1',
    root: 'poly.root@1',
    roots: 'poly.roots@1',
    trinomialSign: 'poly.trinomial_sign@1',
    keep: 'poly.keep@1',
  },
  Kd = {
    divideCos: 'trig.divide_cos@1',
    associated: 'trig.associated@1',
    knownValue: 'trig.known_value@1',
    families: 'trig.families@1',
    circle: 'trig.circle@1',
    interval: 'trig.interval@1',
  };
function A4(e, n) {
  return { k: 'fn', f: e.of === 'exp' ? 'exp' : 'ln', a: { k: 'sym', n } };
}
function _L(e, n, t) {
  let r = A4(n, t),
    s = (i) => {
      switch (i.k) {
        case 'sym':
          return i.n === n.name ? r : i;
        case 'add':
        case 'mul':
          return { ...i, c: i.c.map(s) };
        case 'div':
        case 'pow':
        case 'binom':
          return { ...i, a: s(i.a), b: s(i.b) };
        case 'fn':
          return { ...i, a: s(i.a) };
        default:
          return i;
      }
    };
  return Mt(e, s);
}
function j4(e, n) {
  let t = !1,
    r = !0,
    s = (i) => {
      if (i.k === 'fn' && i.f === 'exp') {
        ((t = !0), (i.a.k === 'sym' && i.a.n === n) || (r = !1));
        return;
      }
      switch (i.k) {
        case 'add':
        case 'mul':
          i.c.forEach(s);
          return;
        case 'div':
        case 'pow':
        case 'binom':
          (s(i.a), s(i.b));
          return;
        case 'fn':
          s(i.a);
          return;
        default:
          return;
      }
    };
  for (let i of dt(e)) (s(i.l), s(i.r));
  return t && r;
}
function Q4(e, n) {
  let t = 0;
  for (let r of dt(e)) qL(r, n) && t++;
  return t;
}
function qL(e, n) {
  if (e.l.k !== 'sym' || e.l.n !== n || (e.rel !== '=' && e.rel !== '\u2264' && e.rel !== '<'))
    return !1;
  let t = Gn(e.r);
  return t?.k === 'num' && te(t.v) <= 0;
}
function F4(e, n) {
  let t = Gn(e);
  if (!t) return null;
  if (t.k === 'sym' && t.n === n) return 1n;
  if (t.k === 'mul' && t.c.length === 2) {
    let [r, s] = t.c,
      i = r.k === 'num' ? r : s.k === 'num' ? s : null,
      o = r.k === 'sym' ? r : s.k === 'sym' ? s : null;
    if (i?.k === 'num' && o?.k === 'sym' && o.n === n && i.v.d === 1n && i.v.n !== 0n) return i.v.n;
  }
  return null;
}
function ug(e, n, t) {
  let r = { k: 'sym', n: n.name },
    s = (o) => {
      if (o.k === 'fn') {
        if (n.of === 'exp' && o.f === 'exp') {
          let a = F4(o.a, t);
          if (a !== null) {
            let l = a < 0n ? -a : a,
              u = l === 1n ? r : { k: 'pow', a: r, b: { k: 'num', v: C(Number(l)) } };
            return a < 0n ? { k: 'div', a: { k: 'num', v: C(1) }, b: u } : u;
          }
        }
        if (n.of === 'ln' && o.f === 'ln') {
          let a = Gn(o.a);
          if (a?.k === 'sym' && a.n === t) return r;
        }
        return { ...o, a: s(o.a) };
      }
      switch (o.k) {
        case 'add':
        case 'mul':
          return { ...o, c: o.c.map(s) };
        case 'div':
        case 'pow':
        case 'binom':
          return { ...o, a: s(o.a), b: s(o.b) };
        default:
          return o;
      }
    },
    i = Mt(e, s);
  return dt(i).some((o) => hn(o.l, t) || hn(o.r, t)) ? null : i;
}
function V4(e) {
  return e.kind === 'acute' || e.kind === 'angle'
    ? { kind: 'positive', of: [e.of] }
    : { kind: e.kind, of: [e.of] };
}
function D4(e) {
  let n = {};
  return (
    (e.hypotheses ?? []).forEach((t) => {
      (t.kind === 'acute' || t.kind === 'angle') && (n[t.of] = t.kind);
    }),
    Object.keys(n).length ? n : null
  );
}
function Sc(e) {
  switch (e.k) {
    case 'add':
    case 'mul':
      return { ...e, c: e.c.map(Sc) };
    case 'div':
    case 'pow':
    case 'binom':
      return { ...e, a: Sc(e.a), b: Sc(e.b) };
    case 'fn':
      return e.f === 'deg' ? Sc(e.a) : cg.has(e.f) ? e : { ...e, a: Sc(e.a) };
    default:
      return e;
  }
}
function Dv(e, n) {
  return e ? Mt(n, Sc) : n;
}
function LL(e, n) {
  return n && e.angles ? { l: n.l, r: Sc(n.r) } : n;
}
function Tc(e) {
  let n = ie(e);
  if (!n.ok) throw new Error(`ligne illisible pour le noyau : ${e}`);
  return n.s;
}
function Lb(e) {
  let n = e.kernel,
    t = n.goal.target,
    r = D4(n),
    s = Dv(r, Tc(n.system?.equations[0] ?? n.start)),
    i = (e.traps ?? []).flatMap((b) => {
      try {
        let v = Ve(b.line),
          k = qu(v);
        if (!k.ok) return [];
        let y = Dv(r, k.s),
          S = n.auxiliary ? _L(y, { name: n.auxiliary.name, of: n.auxiliary.of }, t) : y;
        return [{ line: v, K: la(S), title: b.title, why: b.why }];
      } catch {
        return [];
      }
    }),
    o = _0(e),
    a = q0(e) ? J4(n, t) : null,
    l = n.form ? ao(Tc(n.answer), t) : null,
    u = l ? E(R(l)) : void 0,
    c = W4(n),
    f = O0(n),
    d = xq(e) >= _v,
    m = f && /[≤≥]/.test(n.answer),
    p = n.auxiliary ? { name: n.auxiliary.name, of: n.auxiliary.of } : null,
    g = L0(e),
    h = n.system
      ? zq(
          n.system.equations.map((b) => {
            let v = Tc(b);
            return { s: v, K: la(v), text: b };
          }),
          [...n.system.unknowns],
          n.system.outcome,
        )
      : null;
  return {
    spec: n,
    x: t,
    goal: { kind: n.goal.kind === 'solve_system' ? 'solve' : n.goal.kind, target: t },
    hyps: (n.hypotheses ?? []).map(V4),
    rules: mw(d, g),
    start: Ir(s, t, !0, o, a, {
      count: c,
      intBound: f,
      form: n.form ?? null,
      formAnswer: u,
      ...(d ? { v47: !0, intLarge: m } : {}),
      ...(p ? { aux: p } : {}),
    }),
    answer: Dv(r, Tc(n.answer)),
    lines: [],
    reached: !1,
    traps: i,
    ref: null,
    known: null,
    cache: new Map(),
    rounding:
      e.rounding && (!e.rounding.symbol || e.rounding.symbol === t)
        ? { places: e.rounding.places, hora: e.rounding.hora ?? 1 }
        : null,
    rounded: null,
    angles: r,
    sys: h,
    poly: o,
    aux: new Map(),
    trig: a,
    count: c,
    intBound: f,
    form: n.form ?? null,
    ...(u ? { formAnswer: u } : {}),
    tables: [],
    readable: d,
    intLarge: m,
    auxiliary: p,
    test: n.method === 'test',
    tests: new Map(),
    conds: (n.conditions ?? []).flatMap((b) => {
      let v = z4(Tc(b), s);
      return v ? [v] : [];
    }),
    condsOk: [],
  };
}
function B4(e) {
  if (e.k !== 'rel' || e.rel === '=') return null;
  let n = e.rel === '>' || e.rel === '\u2265',
    [t, r] = n ? [e.l, e.r] : [e.r, e.l],
    s = R({ k: 'add', c: [t, { k: 'mul', c: [{ k: 'num', v: C(-1) }, r] }] });
  return { kind: e.rel === '<' || e.rel === '>' ? 'positive' : 'nonnegative', of: [oe(ar(s))] };
}
function z4(e, n) {
  let t = B4(e);
  if (!t) return null;
  let r = ie(t.of[0]),
    s = r.ok && r.s.k === 'expr' ? E(R(r.s.e)) : null,
    i = (g) => s !== null && E(R(g)) === s,
    o = _t(e),
    a = 'Condition',
    l = `Les solutions doivent v\xE9rifier ${o}.`,
    u = [],
    c = (g) => {
      switch ((g.k === 'fn' && u.push({ f: g.f, a: g.a }), g.k)) {
        case 'add':
        case 'mul':
          g.c.forEach(c);
          return;
        case 'div':
        case 'pow':
        case 'binom':
          (c(g.a), c(g.b));
          return;
        case 'fn':
          c(g.a);
          return;
        default:
          return;
      }
    };
  on(n).forEach((g) => {
    (c(g.l), c(g.r));
  });
  let f = u.find((g) => g.f === 'ln' && i(g.a)),
    d = u.find((g) => g.f === 'sqrt' && i(g.a)),
    p = on(n).find(
      (g) =>
        g.rel === '=' &&
        ((g.l.k === 'fn' && g.l.f === 'sqrt' && i(g.r)) ||
          (g.r.k === 'fn' && g.r.f === 'sqrt' && i(g.l))),
    );
  return (
    f
      ? ((a = 'Condition d\u2019existence'),
        (l = `ln(${or(f.a)}) n\u2019existe que si ${or(f.a)} > 0 : les solutions v\xE9rifient ${o}.`))
      : d && t.kind === 'nonnegative'
        ? ((a = 'Condition d\u2019existence'),
          (l = `\u221A(${or(d.a)}) n\u2019existe que si ${or(d.a)} \u2265 0 : les solutions v\xE9rifient ${o}.`))
        : p &&
          t.kind === 'nonnegative' &&
          ((a = 'Une racine est positive'),
          (l = `Une racine carr\xE9e est positive ou nulle : l\u2019\xE9galit\xE9 demande ${o}.`)),
    { s: e, K: la(e), cond: t, label: a, why: l, ok: !1 }
  );
}
function U4(e, n) {
  let t = ql(e, e.answer, !0);
  if (n.K === t.K) return !0;
  let r = (s) => s.status === 'valid' && (s.relation === 'equivalent' || s.relation === 'identity');
  return r(Ll(e, t, n.s, n.raw, !0)) || r(Ll(e, n, t.s, t.raw, !0));
}
function fL(e) {
  return e.conds
    .filter((n) => n.ok)
    .map((n) => _t(n.s))
    .join(' et ');
}
function G4(e, n, t, r) {
  let s = Dn(n.s);
  if (!s.has(e.x) || s.size !== 1 || dt(n.s).length !== 1) return null;
  let i = e.conds.findIndex((a) => a.K === n.K || Z4(e, a.s, n.s, n.raw));
  if (i < 0) return null;
  let o = e.conds[i];
  return o.ok
    ? {
        kind: 'dup',
        atoms: r,
        line: t,
        title: 'D\xE9j\xE0 \xE9crit',
        message: 'Tu as d\xE9j\xE0 \xE9crit cette condition.',
      }
    : {
        kind: 'step',
        atoms: r,
        line: t,
        hora: 1,
        final: !1,
        rule: { id: Me.condition, card: '\xC9quations', label: o.label, hora: 1, why: o.why },
        cond: i,
      };
}
function Z4(e, n, t, r) {
  let s = `cond:${_t(n)}\u2192${r}`,
    i = e.cache.get(s);
  return (
    i ||
      ((i = Ss(n, t, {
        rules: e.rules,
        hypotheses: e.hyps,
        goal: e.goal,
        deadline: Date.now() + 250,
      })),
      e.cache.set(s, i)),
    i.status === 'valid' && (i.relation === 'equivalent' || i.relation === 'identity')
  );
}
function H4(e, n) {
  let t = e.conds.filter((s) => !s.ok);
  if (!t.length) return null;
  let r = [...t.map((s) => [s]), ...(t.length > 1 ? [t] : [])];
  for (let s of r)
    for (let i of Fd(e)) {
      let o = `need:${s.map((l) => l.K).join('&')}|${e.condsOk.length}|${i.raw}\u2192${n.raw}`,
        a = e.cache.get(o);
      if (
        (a ||
          ((a = Ss(i.s, n.s, {
            rules: e.rules,
            hypotheses: [...e.hyps, ...e.condsOk, ...s.map((l) => l.cond)],
            goal: e.goal,
            deadline: Date.now() + 250,
          })),
          e.cache.set(o, a)),
        a.status === 'valid' && (a.relation === 'equivalent' || a.relation === 'identity'))
      )
        return s[0];
    }
  return null;
}
function W4(e) {
  if (
    ![e.start, e.answer, ...(e.path ?? [])].some(
      (r) => r.includes('!') || /(^|[^A-Za-zÀ-ÿ])parmi([^A-Za-zÀ-ÿ]|$)/.test(r),
    )
  )
    return null;
  if (e.goal.kind !== 'simplify') return { answer: null };
  let t = Tc(e.answer);
  return { answer: t.k === 'rel' ? ao(t, e.goal.target) : null };
}
function ql(e, n, t, r = !1) {
  return Ir(n, e.x, t, e.poly, e.trig, {
    count: e.count,
    intBound: e.intBound,
    form: e.form,
    ...(e.formAnswer ? { formAnswer: e.formAnswer } : {}),
    ...(e.readable ? { v47: !0, intLarge: e.intLarge } : {}),
    ...(e.auxiliary ? { aux: e.auxiliary, auxWritten: r } : {}),
  });
}
function NL(e, n) {
  let t = Dv(e.angles, n);
  return e.auxiliary ? _L(t, e.auxiliary, e.x) : t;
}
function OL(e, n) {
  return !!e.auxiliary && Dn(n).has(e.auxiliary.name);
}
function J4(e, n) {
  let t = new Set(
      (e.hypotheses ?? [])
        .filter((i) => i.kind === 'integer' && /^[^\s+−×÷()]+$/.test(i.of))
        .map((i) => i.of),
    ),
    r = e.domain ? Tc(e.domain) : null,
    s = r ? ib(r, n) : null;
  return {
    domain: r,
    dom: s,
    bounded: !!s && s.lo !== null && s.hi !== null,
    params: t,
    text: e.domain ?? '',
  };
}
var dt = (e) => on(e);
function la(e) {
  return Ii(Mt(e, (n) => R(n)));
}
function Gn(e) {
  let n = Z(e);
  return n.ok ? R(Je($e(n.rf))) : null;
}
var hn = (e, n) => $(e).has(n);
function ig(e, n) {
  switch (e.k) {
    case 'sym':
      return e.n === n ? 1 : 0;
    case 'num':
      return 0;
    case 'add':
    case 'mul':
      return e.c.reduce((t, r) => t + ig(r, n), 0);
    case 'div':
    case 'pow':
    case 'binom':
      return ig(e.a, n) + ig(e.b, n);
    case 'fn':
      return ig(e.a, n);
  }
}
function Uv(e, n, t = !1) {
  let r = hn(e.l, n),
    s = hn(e.r, n);
  if (!r && !s) return 0;
  let i = 0;
  (r && s && (i += 6), r || (i += 1));
  let o = t ? X4(r ? e.l : e.r, n) : r ? e.l : e.r;
  return ((i += og(o, n, t) - 1 + 2 * (ig(o, n) - 1)), i);
}
function X4(e, n) {
  if (e.k !== 'add') return e;
  let t = (o) => {
      if (o.k === 'sym' && o.n === n) return { k: 'num', v: q };
      if (o.k !== 'mul') return null;
      let a = o.c.filter((u) => hn(u, n));
      if (a.length !== 1 || !(a[0].k === 'sym' && a[0].n === n)) return null;
      let l = o.c.filter((u) => u !== a[0]);
      return l.length === 1 ? l[0] : { k: 'mul', c: l };
    },
    r = [],
    s = [];
  for (let o of e.c) {
    let a = t(o);
    a ? r.push(a) : s.push(o);
  }
  if (r.length < 2) return e;
  let i = {
    k: 'mul',
    c: [
      { k: 'add', c: r },
      { k: 'sym', n },
    ],
  };
  return s.length ? { k: 'add', c: [i, ...s] } : i;
}
function Gv(e, n) {
  if (e.k !== 'add') return 0;
  let t = (s) => (s.k === 'mul' ? s.c.flatMap(t) : [s]),
    r = e.c.filter((s) => {
      if (s.k === 'sym') return s.n === n;
      if (s.k !== 'mul') return !1;
      let i = t(s).filter((o) => hn(o, n));
      return i.length === 1 && i[0].k === 'sym' && i[0].n === n;
    }).length;
  return Math.max(0, r - 1);
}
var dL = (e) => jn(e) && !oo(e) && oa(e, (n) => n === 'ln' || n === 'log' || n === 'exp'),
  mL = (e) =>
    (e.k === 'mul' && e.c[0]?.k === 'num' && te(e.c[0].v) < 0) || (e.k === 'num' && te(e.v) < 0);
function jd(e) {
  let n = 0;
  if (e.k === 'fn' && (e.f === 'ln' || e.f === 'log') && oo(e.a)) {
    let t = R(e.a);
    t.k === 'num' && t.v.d !== 1n && (n += 1);
  }
  if (e.k === 'div' && dL(e.a) && oo(e.b)) {
    let t = R(e.b);
    (t.k === 'num' && t.v.d === 1n && (t.v.n === 1n || t.v.n === -1n)) || (n += 1);
  }
  switch (
    (e.k === 'div' &&
      mL(e.a) &&
      dL(e.b) &&
      e.b.k === 'add' &&
      mL(e.b.c[e.b.c.length - 1]) &&
      (n += 1),
    e.k)
  ) {
    case 'add':
    case 'mul':
      return n + e.c.reduce((t, r) => t + jd(r), 0);
    case 'div':
    case 'pow':
    case 'binom':
      return n + jd(e.a) + jd(e.b);
    case 'fn':
      return n + jd(e.a);
    default:
      return n;
  }
}
function Y4(e, n) {
  let t = (r) => {
    switch (r.k) {
      case 'fn':
        return (['ln', 'exp', 'log'].includes(r.f) && hn(r.a, n) ? 1 : 0) + t(r.a);
      case 'add':
      case 'mul':
        return r.c.reduce((s, i) => s + t(i), 0);
      case 'div':
      case 'pow':
      case 'binom':
        return t(r.a) + t(r.b);
      default:
        return 0;
    }
  };
  return dt(e).reduce((r, s) => r + t(s.l) + t(s.r), 0);
}
function og(e, n, t = !1) {
  if (!hn(e, n) && oa(e, (r) => (t ? !0 : cg.has(r)))) return 1;
  switch (e.k) {
    case 'add':
    case 'mul':
      return 1 + e.c.reduce((r, s) => r + og(s, n, t), 0);
    case 'div':
    case 'pow':
    case 'binom':
      return 1 + og(e.a, n, t) + og(e.b, n, t);
    case 'fn':
      return 1 + og(e.a, n, t);
    default:
      return 1;
  }
}
function ro(e, n) {
  let t = (r) =>
    hn(r, n) && (r.k === 'add' || (r.k === 'mul' && r.c.some((s) => s.k === 'add' && hn(s, n))));
  switch (e.k) {
    case 'div':
      return (t(e.a) || hn(e.b, n) ? 1 : 0) + ro(e.a, n) + ro(e.b, n);
    case 'add':
    case 'mul':
      return e.c.reduce((r, s) => r + ro(s, n), 0);
    case 'pow':
    case 'binom':
      return ro(e.a, n) + ro(e.b, n);
    case 'fn':
      return ro(e.a, n);
    default:
      return 0;
  }
}
var jn = (e) => $(e).size === 0,
  oo = (e) => jn(e) && R(e).k === 'num',
  Xv = (e, n) => (n === 0n ? (e < 0n ? -e : e) : Xv(n, e % n));
function pw(e) {
  if (e.k === 'num') return !0;
  if (e.k === 'div' && e.a.k === 'num' && e.b.k === 'num') {
    let n = e.a.v,
      t = e.b.v;
    return n.d !== 1n || t.d !== 1n || t.n <= 1n ? !1 : Xv(n.n, t.n) === 1n;
  }
  return e.k === 'mul' &&
    e.c.length === 2 &&
    e.c[0].k === 'num' &&
    e.c[0].v.n === -1n &&
    e.c[0].v.d === 1n
    ? pw(e.c[1])
    : !1;
}
function KL(e) {
  return e.k === 'num'
    ? e.v.d === 1n
      ? e.v.n
      : null
    : e.k === 'mul' && e.c[0]?.k === 'num' && e.c[0].v.d === 1n
      ? e.c[0].v.n
      : null;
}
function e9(e) {
  if (jn(e)) return null;
  let n = R(e);
  if (n.k === 'mul' && n.c[0].k === 'num') {
    let t = n.c.slice(1);
    return E(t.length === 1 ? t[0] : { k: 'mul', c: t });
  }
  return E(n);
}
var lw = (e) => e.k === 'fn' && e.f === 'exp',
  uw = (e) => lw(e) || (e.k === 'pow' && lw(e.a)),
  pL = (e) => (uw(e) ? 1 : e.k === 'mul' ? e.c.filter(uw).length : 0);
function Pr(e) {
  if (jn(e) && R(e).k === 'num') return pw(e) ? 0 : Math.max(1, ag(e));
  if (jn(e) && e.k === 'fn' && !cg.has(e.f)) {
    let t = Gn(e);
    if (t && t.k === 'num') return 1;
  }
  let n = 0;
  return (
    e.k === 'div' && pL(e.a) > 0 && pL(e.b) > 0 && (n = 2),
    e.k === 'mul' && (n = 2 * Math.max(0, e.c.filter(uw).length - 1)),
    e.k === 'pow' && lw(e.a) && (n = 2),
    n + n9(e)
  );
}
function ag(e) {
  if (pw(e)) return 0;
  switch (e.k) {
    case 'add':
    case 'mul':
      return e.c.length - 1 + e.c.reduce((n, t) => n + ag(t), 0);
    case 'div':
    case 'pow':
    case 'binom':
      return 1 + ag(e.a) + ag(e.b);
    case 'fn':
      return 1 + ag(e.a);
    default:
      return 0;
  }
}
function n9(e) {
  switch (e.k) {
    case 'add': {
      let n = Math.max(0, e.c.filter(oo).length - 1),
        t = new Map();
      (e.c.forEach((s) => {
        let i = e9(s);
        i !== null && t.set(i, (t.get(i) ?? 0) + 1);
      }),
        t.forEach((s) => (n += s - 1)));
      let r = e.c.filter((s) => jn(s) && !oo(s) && ri(s) !== null).length;
      return ((n += Math.max(0, r - 1)), n + e.c.reduce((s, i) => s + Pr(i), 0));
    }
    case 'mul': {
      let n = e.c.filter(oo),
        t = Math.max(0, n.length - 1);
      n.length && e.c.some((s) => s.k === 'div' && jn(s) && !oo(s)) && (t += 1);
      let r = e.c.filter((s) => !jn(s)).map((s) => E(R(s)));
      return (new Set(r).size < r.length && (t += 1), t + e.c.reduce((s, i) => s + Pr(i), 0));
    }
    case 'div': {
      let n = Pr(e.a) + Pr(e.b);
      if (e.b.k === 'num' && e.b.v.d === 1n) {
        let t = e.b.v.n,
          r = KL(e.a);
        (t === 1n || t === -1n || (r !== null && Xv(r, t) > 1n)) && (n += 1);
      }
      return n;
    }
    case 'pow':
      return Pr(e.a) + Pr(e.b);
    case 'fn':
      return Pr(e.a);
    default:
      return 0;
  }
}
var gw = ['sqrt', 'value', 'radDen', 'conj', 'compound', 'like', 'gcd'],
  t9 = ['sqrt', 'value', 'radDen', 'conj'],
  r9 = { sqrt: 3, value: 6, radDen: 4, conj: 7, compound: 1, like: 1, gcd: 1 },
  cg = new Set(['cos', 'sin', 'tan', 'arccos', 'arcsin', 'arctan']),
  hw = () => ({ sqrt: 0, value: 0, radDen: 0, conj: 0, compound: 0, like: 0, gcd: 0 });
function oa(e, n) {
  switch (e.k) {
    case 'add':
    case 'mul':
      return e.c.some((t) => oa(t, n));
    case 'div':
    case 'pow':
    case 'binom':
      return oa(e.a, n) || oa(e.b, n);
    case 'fn':
      return n(e.f) || oa(e.a, n);
    default:
      return !1;
  }
}
var gL = (e) => e === 'sqrt';
function Bv(e) {
  switch (e.k) {
    case 'add':
      return !0;
    case 'mul':
      return e.c.some(Bv);
    case 'div':
    case 'pow':
    case 'binom':
      return Bv(e.a) || Bv(e.b);
    default:
      return !1;
  }
}
function Ml(e, n = hw()) {
  switch (e.k) {
    case 'add':
    case 'mul':
      e.c.forEach((t) => Ml(t, n));
      break;
    case 'div':
    case 'pow':
    case 'binom':
      (Ml(e.a, n), Ml(e.b, n));
      break;
    case 'fn':
      Ml(e.a, n);
      break;
    default:
      return n;
  }
  if (!jn(e) || oo(e)) return n;
  if (e.k === 'fn' && e.f === 'sqrt') {
    let t = e.a;
    if (t.k === 'num' && t.v.n > 0n) {
      let r = Hs(t.v);
      r && r.rad !== 1n && !(t.v.d === 1n && r.rad === t.v.n) && n.sqrt++;
    }
  } else if (e.k === 'fn' && cg.has(e.f)) {
    let t = Gn(e);
    t && !oa(t, (r) => cg.has(r)) && n.value++;
  } else if (e.k === 'div') {
    if (((e.a.k === 'div' || e.b.k === 'div') && n.compound++, oa(e.b, gL))) {
      let r = Gn(e.b);
      r && oa(r, gL) && (Bv(R(e.b)) ? n.conj++ : n.radDen++);
    }
    let t = R(e.b);
    if (e.a.k === 'add' && t.k === 'num' && t.v.d === 1n && t.v.n > 1n) {
      let r = t.v.n;
      for (let s of e.a.c) r = Xv(r, KL(R(s)) ?? 1n);
      r > 1n && n.gcd++;
    }
  } else if (e.k === 'add') {
    let t = new Map();
    (e.c.forEach((r) => {
      if (!jn(r) || oo(r)) return;
      let s = R(r),
        i = s.k === 'mul' && s.c[0].k === 'num' ? E({ k: 'mul', c: s.c.slice(1) }) : E(s);
      t.set(i, (t.get(i) ?? 0) + 1);
    }),
      t.forEach((r) => (n.like += r - 1)));
  }
  return n;
}
var Zv = (e) => gw.reduce((n, t) => n + r9[t] * e[t], 0);
function ow(e, n) {
  let t = hw();
  return (gw.forEach((r) => (t[r] = e[r] + n[r])), t);
}
function s9(e) {
  let n = (t) => {
    if (t.k === 'div' && jn(t)) return !0;
    switch (t.k) {
      case 'add':
      case 'mul':
        return t.c.some(n);
      case 'div':
      case 'pow':
      case 'binom':
        return n(t.a) || n(t.b);
      case 'fn':
        return n(t.a);
      default:
        return !1;
    }
  };
  return dt(e).some((t) => n(t.l) || n(t.r));
}
var Dd = { '=': '=', '<': '>', '>': '<', '\u2264': '\u2265', '\u2265': '\u2264' },
  hL = { '=': '=', '<': '\u2264', '\u2264': '<', '>': '\u2265', '\u2265': '>' };
function aw(e, n, t = !1) {
  let r = Gn(e.l),
    s = Gn(e.r);
  return !r || !s
    ? Uv(e, n, t)
    : Uv({ rel: e.rel, l: r, r: s }, n, t) + 2 * (ro(e.l, n) + ro(e.r, n));
}
function Ir(e, n, t, r = !1, s = null, i = {}) {
  let o = dt(e),
    a = 0,
    l = 0,
    u = 0,
    c = hw(),
    f = [],
    d = o.length > 0;
  for (let b of o) {
    let v = Gn(b.l),
      k = Gn(b.r);
    if (!v || !k) {
      ((d = !1), (a += Uv(b, n, i.v47)));
      continue;
    }
    ((a += Uv({ rel: b.rel, l: v, r: k }, n, i.v47) + 2 * (ro(b.l, n) + ro(b.r, n))),
      (l += Pr(b.l) + Pr(b.r)),
      i.v47 && ((l += jd(b.l) + jd(b.r)), (a += Gv(b.l, n) + Gv(b.r, n))),
      (c = ow(c, ow(Ml(b.l), Ml(b.r)))),
      (u += Kt(b.l) + Kt(b.r)));
    let [y, S, w] = b.rel === '>' || b.rel === '\u2265' ? [k, v, Dd[b.rel]] : [v, k, b.rel],
      _ = E(y),
      O = E(S);
    f.push(w === '=' ? [_, O].sort().join('=') : `${_}${w}${O}`);
  }
  if (e.k === 'set' && d) {
    let b = 0,
      v = e.clauses.map((k) =>
        f
          .slice(b, (b += k.length))
          .sort()
          .join('&'),
      );
    f.splice(0, f.length, ...v);
  }
  if (e.k === 'expr') {
    let b = Gn(e.e);
    ((d = !!b), b && (f.push(E(b)), (l += Pr(e.e)), (c = ow(c, Ml(e.e))), (u += Kt(e.e))));
  }
  l += Zv(c);
  let m = 0;
  (r &&
    ((a = b1(e, n, (b) => aw(b, n, i.v47))),
    i.v47 && (a += 4 * Math.max(0, Y4(e, n) - 1)),
    e.k === 'rel' && (m = v1(e, n))),
    s && (a = rL(e, n, s.params, s.bounded, (b, v) => aw(b, v))));
  let p, g;
  if (i.count) {
    p = Xq(e, o);
    let b = i.count.answer;
    if (b) {
      let v = ao(e, n);
      ((g = !!v && o9(v, b)), (a = g ? 0 : 1 + (v ? eL(v, b) : 9)));
    } else
      p.binom + p.known + p.facts > 0 &&
        o.some((v) => hn(v.l, n) || hn(v.r, n)) &&
        (a = p.binom + p.known > 0 ? 60 : 55);
  }
  if (i.intBound) {
    let b = Yv(e, n);
    ((g = b !== null && l === 0 && !(i.intLarge && (b.rel === '<' || b.rel === '>'))),
      g || (a += 1));
    for (let v of o) {
      let k = hn(v.l, n) ? Gn(v.l) : hn(v.r, n) ? Gn(v.r) : null;
      k && i9(k) && (a += 1);
    }
  }
  let h;
  if (i.form) {
    let b = ao(e, n);
    b
      ? ((h = FE(b, i.form, i.formAnswer)),
        (l += h.pow),
        (a = h.product && h.done && l > 0 ? 3 : h.h),
        (g = h.done && l === 0))
      : ((a = 50), (g = !1));
  }
  if (i.aux) {
    let b = ug(e, i.aux, n);
    if (b) {
      let v = i.aux.name,
        k = b1(b, v, (y) => aw(y, v, !0));
      ((a = i.auxWritten
        ? k + 3
        : zo(b, v)
          ? 2 + (i.aux.of === 'exp' ? Q4(b, v) : 0)
          : k + (i.aux.of === 'exp' && j4(e, n) ? 3.5 : 4)),
        b.k === 'rel' && (m = v1(b, v)));
    }
  }
  return {
    s: e,
    raw: Ii(e),
    K: la(e),
    NK: d ? `${e.k}:${f.sort().join(';')}` : null,
    h: a,
    calc: l,
    expand: u,
    debt:
      i.form === 'factored' && h && !h.product
        ? 0
        : i.form === 'canonical' || i.form === 'fraction'
          ? l
          : l + 3 * u + m + (p ? X0(p) : 0),
    rad: c,
    trusted: t,
    ...(i.auxWritten ? { auxWritten: !0 } : {}),
    ...(p ? { cnt: p } : {}),
    ...(g !== void 0 ? { answerForm: g } : {}),
    ...(h ? { fm: h } : {}),
  };
}
function i9(e) {
  let n = e.k === 'div' ? e.a : e,
    t = n.k === 'add' ? n.c[0] : n;
  return t.k === 'num' ? te(t.v) < 0 : t.k === 'mul' && t.c[0]?.k === 'num' && te(t.c[0].v) < 0;
}
function ao(e, n) {
  return e.k !== 'rel' || e.rel !== '=' ? null : e.l.k === 'sym' && e.l.n === n ? e.r : null;
}
function bL(e) {
  return e.k === 'num';
}
function o9(e, n) {
  return bL(n) ? bL(e) : E(R(e)) === E(R(n));
}
function Yv(e, n) {
  if (e.k !== 'rel' || e.rel === '=') return null;
  let t = (r) => {
    let s = R(r);
    return s.k === 'num' && s.v.d === 1n ? s.v.n : null;
  };
  if (e.l.k === 'sym' && e.l.n === n) {
    let r = t(e.r);
    return r === null ? null : { rel: e.rel, v: r };
  }
  if (e.r.k === 'sym' && e.r.n === n) {
    let r = t(e.l);
    return r === null ? null : { rel: Dd[e.rel], v: r };
  }
  return null;
}
var Hv = (e, n) => e.h < n.h || (e.h === n.h && e.debt < n.debt);
function cw(e) {
  let n = e.start;
  for (let t of e.lines) t.trusted && Hv(t, n) && (n = t);
  return n;
}
function so(e, n, t = null) {
  if (e.answerForm !== void 0) return e.answerForm;
  if (e.calc > 0) return !1;
  if (t) return sL(e.s, n, t.params, t.bounded);
  if (e.s.k === 'set') return zo(e.s, n);
  let r = dt(e.s);
  return r.length > 0 && r.every((s) => s.l.k === 'sym' && s.l.n === n && !hn(s.r, n));
}
function Ll(e, n, t, r, s = !1) {
  let i = s ? [] : e.condsOk,
    o = i.length ? `${i.length}|${n.raw}\u2192${r}` : `${n.raw}\u2192${r}`,
    a = e.cache.get(o);
  if (a) return a;
  let l = Date.now(),
    u = Ss(n.s, t, {
      rules: e.rules,
      hypotheses: i.length ? [...e.hyps, ...i] : e.hyps,
      goal: e.goal,
      deadline: l + 250,
      branches: !0,
      ...(e.angles ? { angles: e.angles } : {}),
      ...(e.trig && !e.angles ? { trig: { domain: e.trig.domain } } : {}),
    });
  return (e.cache.set(o, u), u);
}
function Fd(e) {
  return [...e.lines.filter((n) => n.trusted).reverse(), e.start];
}
var Wv = (e) => e.charAt(0).toLowerCase() + e.slice(1);
function io(e) {
  return /^[^\s]+$/.test(e) || /^\(.*\)$/.test(e) || /^\([^()]*\)[²³]$/.test(e) ? e : `(${e})`;
}
function PL(e) {
  if (!e.startsWith('\u2212')) return null;
  let n = e.slice(1);
  return /\s[+−]\s/.test(n) ? null : n;
}
function IL(e) {
  let n = typeof e.of == 'string' ? e.of : e.of.join(', '),
    t = /^([^\s+−]+) ([+−]) (\d+(?:,\d+)?)$/.exec(n),
    r = { positive: '>', negative: '<', nonzero: '\u2260', nonnegative: '\u2265' };
  if (e.kind === 'acute') return `0\xB0 < ${n} < 90\xB0`;
  if (e.kind === 'angle') return `0\xB0 < ${n} < 180\xB0`;
  if (r[e.kind]) {
    if (t && !/^\d/.test(t[1])) {
      let s = t[2] === '\u2212' ? t[3] : `\u2212${t[3]}`;
      return `${t[1]} ${r[e.kind]} ${s}`;
    }
    return `${n} ${r[e.kind]} 0`;
  }
  return e.kind === 'integer'
    ? `${n} est un entier`
    : e.kind === 'natural'
      ? `${n} est un entier naturel`
      : e.kind === 'zero'
        ? `${n} = 0`
        : n;
}
var a9 = new Set([
  'explog.exp_compare',
  'explog.exp_to_ln_below',
  'explog.exp_to_ln_above',
  'explog.ln_to_exp_below',
  'explog.ln_to_exp_above',
  'explog.ln_compare',
  'explog.apply_ln_compare',
  'log.pow10_to_log_below',
  'log.pow10_to_log_above',
  'log.log_to_pow10_below',
  'log.log_to_pow10_above',
  'log.log_compare',
]);
function l9(e) {
  return (
    e.startsWith('inequality.') ||
    a9.has(e) ||
    e === 'radical.sqrt_compare' ||
    e === 'condition.sqrt_below'
  );
}
var Os = !1;
function Ec(e) {
  let n = '',
    t = 0;
  for (; t < e.length; ) {
    let r = e.indexOf('exp(', t);
    if (r < 0 || (r > 0 && /[A-Za-z]/.test(e[r - 1]))) {
      if (r < 0) {
        n += e.slice(t);
        break;
      }
      ((n += e.slice(t, r + 4)), (t = r + 4));
      continue;
    }
    let s = 0,
      i = -1;
    for (let a = r + 3; a < e.length; a++)
      if (e[a] === '(') s++;
      else if (e[a] === ')' && --s === 0) {
        i = a;
        break;
      }
    if (i < 0) {
      n += e.slice(t);
      break;
    }
    let o = Ec(e.slice(r + 4, i));
    ((n += e.slice(t, r) + (/^[A-Za-zα-ω0-9,]+$/.test(o) ? `e^${o}` : `e^(${o})`)), (t = i + 1));
  }
  return n;
}
function u9(e) {
  if (!e) return null;
  let n = ie(e);
  if (!n.ok || n.s.k !== 'expr') return null;
  let t = Z(n.s.e);
  if (!t.ok) return null;
  let r = R(Je($e(t.rf)));
  if (r.k !== 'num' || r.v.d === 1n) return null;
  let s = ar(r);
  return s.k === 'sym' ? s.n : null;
}
function c9(e, n) {
  if (!e || !n) return null;
  let t = ie(n);
  if (!t.ok || t.s.k !== 'expr') return null;
  let r = Z({ k: 'div', a: { k: 'num', v: q }, b: t.s.e });
  if (!r.ok) return null;
  let s = E(Je($e(r.rf))),
    i = [],
    o = (a) => {
      (a.k === 'mul' && i.push(...a.c), (a.k === 'add' || a.k === 'mul') && a.c.forEach(o));
    };
  dt(e).forEach((a) => {
    (o(a.l), o(a.r));
  });
  for (let a of i) {
    if (a.k === 'num') continue;
    let l = Z(a);
    if (l.ok && E(Je($e(l.rf))) === s) return oe(ar(a));
  }
  return null;
}
function f9(e, n) {
  if (!e || !n) return null;
  let t = ie(n);
  if (!t.ok || t.s.k !== 'expr') return null;
  let r = Z({ k: 'div', a: { k: 'num', v: q }, b: t.s.e });
  if (!r.ok) return null;
  let s = E(Je($e(r.rf))),
    i = [],
    o = (a) => {
      (a.k === 'div' && i.push(a.b),
        a.k === 'add' || a.k === 'mul' ? a.c.forEach(o) : a.k === 'div' && (o(a.a), o(a.b)));
    };
  dt(e).forEach((a) => {
    (o(a.l), o(a.r));
  });
  for (let a of i) {
    let l = Z(a);
    if (l.ok && E(Je($e(l.rf))) === s) return oe(ar(a));
  }
  return null;
}
function vL(e, n, t = !1) {
  if (!e || !n) return null;
  let r = ie(n);
  if (!r.ok || r.s.k !== 'expr') return null;
  let s = r.s.e,
    i = [],
    o = (a) => {
      (a.k === 'div' && i.push(a.b),
        a.k === 'mul' && i.push(...a.c),
        a.k === 'add' || a.k === 'mul'
          ? a.c.forEach(o)
          : a.k === 'div' || a.k === 'pow'
            ? (o(a.a), o(a.b))
            : a.k === 'fn' && o(a.a));
    };
  dt(e).forEach((a) => {
    (o(a.l), o(a.r));
  });
  for (let a of i) {
    if (a.k === 'num' && !t) continue;
    let l = Z(a),
      u = Z(s);
    if (!(!l.ok || !u.ok) && E(Je($e(l.rf))) === E(Je($e(u.rf)))) return oe(ar(a));
  }
  return null;
}
function kL(e, n) {
  if (!e || !n) return null;
  let t = ie(n);
  if (!t.ok || t.s.k !== 'expr') return null;
  let r = Z({ k: 'mul', c: [{ k: 'num', v: C(-1) }, t.s.e] });
  if (!r.ok) return null;
  let s = E(Je($e(r.rf)));
  for (let i of dt(e))
    for (let o of [i.l, i.r])
      for (let a of o.k === 'add' ? o.c : [o]) {
        if (a.k === 'num') continue;
        let l = Z(a);
        if (l.ok && E(Je($e(l.rf))) === s) return d9(a);
      }
  return null;
}
function d9(e) {
  if (e.k === 'mul' && e.c.length >= 2 && e.c[0].k === 'num') {
    let n = ar(e.c[0]),
      t = e.c.length === 2 ? e.c[1] : { k: 'mul', c: e.c.slice(1) },
      r = oe(ar(t));
    if (n.k === 'sym' && /^[A-Za-zα-ωΔ(√]/.test(r)) return n.n + r;
  }
  return oe(ar(e));
}
function ar(e) {
  switch (e.k) {
    case 'num': {
      let { n, d: t } = e.v;
      if (t === 1n) return e;
      let r = t,
        s = 0;
      for (; r % 10n === 0n || r % 2n === 0n || r % 5n === 0n; )
        if ((r % 10n === 0n ? (r /= 10n) : r % 2n === 0n ? (r /= 2n) : (r /= 5n), s++, s > 12))
          return e;
      if (r !== 1n) return e;
      let i = Number(n) / Number(t);
      return { k: 'sym', n: pe(i) };
    }
    case 'add':
    case 'mul':
      return { ...e, c: e.c.map(ar) };
    case 'div':
    case 'pow':
    case 'binom':
      return { ...e, a: ar(e.a), b: ar(e.b) };
    case 'fn':
      return { ...e, a: ar(e.a) };
    default:
      return e;
  }
}
function m9(e) {
  let n = /^ln\(([\d,]+)\)$/.exec(e);
  if (!n) return null;
  let t = Number(n[1].replace(',', '.'));
  return !Number.isFinite(t) || t <= 0 || t === 1
    ? null
    : t < 1
      ? ` (car ${n[1]} < 1)`
      : ` (car ${n[1]} > 1)`;
}
function p9(e) {
  let n = /^(cos|sin|tan)\(([\d,]+)°\)$/.exec(e);
  if (!n) return null;
  let t = Number(n[2].replace(',', '.'));
  return t > 0 && t < 90 ? ` (car 0\xB0 < ${n[2]}\xB0 < 90\xB0)` : null;
}
function g9(e, n) {
  if (!e) return !1;
  let t = ie(e);
  return !t.ok || t.s.k !== 'expr' || t.s.e.k !== 'div' ? !1 : $(n ? t.s.e.a : t.s.e.b).size > 0;
}
function aa(e, n, t) {
  let r = e.ruleId,
    s = r.replace(/@\d+$/, ''),
    i = e.explanation?.params ?? {},
    o = l9(s),
    a = s.startsWith('counting.')
      ? Rl
      : s.startsWith('explog.') || s.startsWith('log.')
        ? 'Exponentielle et logarithme'
        : s.startsWith('radical.') || s.startsWith('condition.')
          ? 'Racines carr\xE9es'
          : o
            ? 'In\xE9quations'
            : s.startsWith('equation.')
              ? '\xC9quations'
              : 'Calcul litt\xE9ral',
    l = o ? 'le sens ne change pas.' : 'les solutions ne changent pas.',
    u = vL(n, i.v_k, Os) ?? vL(t, i.v_k, Os) ?? (Os ? u9(i.v_k) : null) ?? i.v_k,
    c = u ? (Os ? Ec(io(u)) : io(u)) : '',
    f = Os && /multiply/.test(s) ? (c9(t, i.v_k) ?? f9(n, i.v_k)) : null,
    d = f ? Ec(io(f)) : null,
    m = u ? u.replace(/\b(ln|exp|cos|sin|tan|arccos|arcsin|arctan)\(/g, '(').replace(/π/g, '') : '',
    p = u
      ? (m9(u) ?? p9(u) ?? (/[A-Za-zα-ω]/.test(m) ? ' (d\u2019apr\xE8s l\u2019\xE9nonc\xE9)' : ''))
      : '';
  switch (s) {
    case 'equation.add_both_sides':
    case 'inequality.add_both_sides': {
      let g = i.v_c ?? '',
        h = /÷/.test(g) ? (kL(t, g) ?? kL(n, g)) : null,
        b = h && !h.startsWith('\u2212') ? h : PL(g),
        v = b ? `Retrancher ${b}` : `Ajouter ${io(g)}`,
        k = b ? `On retranche ${b} aux deux membres` : `On ajoute ${io(g)} aux deux membres`;
      return { id: r, card: a, label: v, hora: 2, why: `${k} : ${l}` };
    }
    case 'inequality.divide_positive':
      return {
        id: r,
        card: a,
        label: `Diviser par ${c}`,
        hora: 2,
        why: `On divise par ${c}, positif${p} : le sens ne change pas.`,
      };
    case 'inequality.multiply_positive':
      return d
        ? {
            id: r,
            card: a,
            label: `Diviser par ${d}`,
            hora: 2,
            why: `On divise par ${d}, positif : le sens ne change pas.`,
          }
        : {
            id: r,
            card: a,
            label: `Multiplier par ${c}`,
            hora: 2,
            why: `On multiplie par ${c}, positif${p} : le sens ne change pas.`,
          };
    case 'inequality.divide_negative':
      return {
        id: r,
        card: a,
        label: `Diviser par ${c}, le sens change`,
        hora: 3,
        why: `On divise par ${c}, n\xE9gatif${p} : le sens de l\u2019in\xE9galit\xE9 change.`,
      };
    case 'inequality.multiply_negative':
      return d
        ? {
            id: r,
            card: a,
            label: `Diviser par ${d}, le sens change`,
            hora: 3,
            why: `On divise par ${d}, n\xE9gatif : le sens de l\u2019in\xE9galit\xE9 change.`,
          }
        : {
            id: r,
            card: a,
            label: `Multiplier par ${c}, le sens change`,
            hora: 3,
            why: `On multiplie par ${c}, n\xE9gatif${p} : le sens de l\u2019in\xE9galit\xE9 change.`,
          };
    case 'equation.divide_both_sides':
    case 'equation.multiply_both_sides':
      return g9(i.v_k, s === 'equation.multiply_both_sides')
        ? {
            id: r,
            card: a,
            label: 'Produit en croix',
            hora: 2,
            why: 'Deux quotients \xE9gaux : a = b \xF7 c \xE9quivaut \xE0 a \xD7 c = b, donc \xE0 c = b \xF7 a (a et c non nuls). Les solutions ne changent pas.',
          }
        : s === 'equation.multiply_both_sides' && d
          ? {
              id: r,
              card: a,
              label: `Diviser par ${d}`,
              hora: 2,
              why: `On divise les deux membres par ${d}, non nul : ${l}`,
            }
          : s === 'equation.multiply_both_sides'
            ? {
                id: r,
                card: a,
                label: `Multiplier par ${c}`,
                hora: 2,
                why: `On multiplie les deux membres par ${c}, non nul${p} : ${l}`,
              }
            : {
                id: r,
                card: a,
                label: `Diviser par ${c}`,
                hora: 2,
                why: `On divise les deux membres par ${c}, non nul${p} : ${l}`,
              };
    case 'equation.swap_sides':
      return {
        id: r,
        card: a,
        label: '\xC9changer les membres',
        hora: 1,
        why: 'On \xE9change les deux membres de l\u2019\xE9galit\xE9.',
      };
    case 'explog.exp_equal':
    case 'explog.exp_compare':
      return {
        id: r,
        card: a,
        label: 'Comparer les exposants',
        hora: 2,
        why: o
          ? 'La fonction exponentielle est strictement croissante : exp(a) < exp(b) \xE9quivaut \xE0 a < b, le sens ne change pas.'
          : 'exp(a) = exp(b) \xE9quivaut \xE0 a = b : on \xE9gale les exposants.',
      };
    case 'explog.exp_to_ln':
    case 'explog.exp_to_ln_below':
    case 'explog.exp_to_ln_above':
      return {
        id: r,
        card: a,
        label: 'Composer par ln',
        hora: 2,
        why: o
          ? 'ln est strictement croissante sur ]0 ; +\u221E[ : exp(a) < b (b > 0) \xE9quivaut \xE0 a < ln(b).'
          : 'exp(a) = b, avec b > 0, \xE9quivaut \xE0 a = ln(b).',
      };
    case 'explog.ln_to_exp':
    case 'explog.ln_to_exp_below':
    case 'explog.ln_to_exp_above':
      return {
        id: r,
        card: a,
        label: 'Composer par exp',
        hora: 2,
        why: o
          ? 'exp est strictement croissante : ln(a) < b \xE9quivaut \xE0 a < exp(b), pour a > 0.'
          : 'ln(a) = b \xE9quivaut \xE0 a = exp(b).',
      };
    case 'explog.ln_equal':
    case 'explog.ln_compare':
      return {
        id: r,
        card: a,
        label: 'Comparer sous le ln',
        hora: 2,
        why: o
          ? 'ln est strictement croissante sur ]0 ; +\u221E[ : ln(a) < ln(b) \xE9quivaut \xE0 a < b, pour a > 0 et b > 0.'
          : 'ln(a) = ln(b) \xE9quivaut \xE0 a = b, pour a > 0 et b > 0.',
      };
    case 'explog.apply_ln_equal':
    case 'explog.apply_ln_compare':
      return {
        id: r,
        card: a,
        label: 'Composer par ln',
        hora: 2,
        why: o
          ? 'Les deux membres sont strictement positifs et ln est croissante : le sens ne change pas. ln(q\u207F) = n ln(q).'
          : 'Les deux membres sont strictement positifs : on compose par ln. ln(q\u207F) = n ln(q).',
      };
    case 'log.pow10_to_log':
    case 'log.pow10_to_log_below':
    case 'log.pow10_to_log_above':
      return {
        id: r,
        card: a,
        label: 'Composer par log',
        hora: 2,
        why: o
          ? 'log est strictement croissante sur ]0 ; +\u221E[ : 10^a < b (b > 0) \xE9quivaut \xE0 a < log(b).'
          : '10^a = b, avec b > 0, \xE9quivaut \xE0 a = log(b) : log est la r\xE9ciproque de x \u21A6 10^x.',
      };
    case 'log.log_to_pow10':
    case 'log.log_to_pow10_below':
    case 'log.log_to_pow10_above':
      return {
        id: r,
        card: a,
        label: '\xC9crire avec une puissance de 10',
        hora: 2,
        why: o
          ? 'x \u21A6 10^x est strictement croissante : log(a) < b \xE9quivaut \xE0 a < 10^b, pour a > 0.'
          : 'log(a) = b \xE9quivaut \xE0 a = 10^b.',
      };
    case 'log.log_equal':
    case 'log.log_compare':
      return {
        id: r,
        card: a,
        label: 'Comparer sous le log',
        hora: 2,
        why: o
          ? 'log est strictement croissante sur ]0 ; +\u221E[ : log(a) < log(b) \xE9quivaut \xE0 a < b, pour a > 0 et b > 0.'
          : 'log(a) = log(b) \xE9quivaut \xE0 a = b, pour a > 0 et b > 0.',
      };
    case 'log.ln_product':
      return {
        id: r,
        card: a,
        label: 'Logarithme d\u2019un produit',
        hora: 2,
        why: 'ln(a) + ln(b) = ln(a \xD7 b), pour a > 0 et b > 0 (d\u2019apr\xE8s l\u2019\xE9nonc\xE9).',
      };
    case 'log.ln_quotient':
      return {
        id: r,
        card: a,
        label: 'Logarithme d\u2019un quotient',
        hora: 2,
        why: 'ln(a) \u2212 ln(b) = ln(a \xF7 b), pour a > 0 et b > 0 (d\u2019apr\xE8s l\u2019\xE9nonc\xE9).',
      };
    case 'radical.sqrt_equal':
      return {
        id: r,
        card: a,
        label: '\xC9lever au carr\xE9',
        hora: 2,
        why: '\u221Aa = b, avec b \u2265 0, \xE9quivaut \xE0 a = b\xB2 : on \xE9l\xE8ve les deux membres au carr\xE9.',
      };
    case 'radical.square_root': {
      let g = i.v_a ? io(i.v_a) : 'la grandeur';
      return {
        id: r,
        card: a,
        label: 'Prendre la racine carr\xE9e',
        hora: 2,
        why: `${g} est positive (d\u2019apr\xE8s l\u2019\xE9nonc\xE9) : a\xB2 = b \xE9quivaut alors \xE0 a = \u221Ab.`,
      };
    }
    case 'condition.sqrt_below':
      return {
        id: r,
        card: a,
        label: '\xC9lever au carr\xE9',
        hora: 2,
        why: 'La fonction carr\xE9 est croissante sur [0 ; +\u221E[ : avec a \u2265 0 (la condition) et b \u2265 0, \u221Aa < b \xE9quivaut \xE0 a < b\xB2, le sens ne change pas.',
      };
    case 'radical.sqrt_compare':
      return {
        id: r,
        card: a,
        label: '\xC9lever au carr\xE9',
        hora: 2,
        why: 'La fonction carr\xE9 est croissante sur [0 ; +\u221E[ : \u221Aa > b, avec b \u2265 0, \xE9quivaut \xE0 a > b\xB2, le sens ne change pas.',
      };
    case 'counting.binom_def':
      return xL(n) > xL(t)
        ? {
            id: r,
            card: a,
            label: 'Reconna\xEEtre k parmi n',
            hora: 2,
            why: 'n! \xF7 (k! \xD7 (n \u2212 k)!) s\u2019\xE9crit \xAB k parmi n \xBB : le nombre de fa\xE7ons de choisir k \xE9l\xE9ments parmi n.',
          }
        : {
            id: r,
            card: a,
            label: '\xC9crire avec les factorielles',
            hora: 2,
            why: 'k parmi n = n! \xF7 (k! \xD7 (n \u2212 k)!).',
          };
    case 'counting.binom_two':
      return {
        id: r,
        card: a,
        label: '2 parmi n = n(n \u2212 1) \xF7 2',
        hora: 2,
        why: 'Choisir 2 \xE9l\xE9ments parmi n : n choix pour le premier, n \u2212 1 pour le second, et l\u2019ordre ne compte pas (\xF7 2).',
      };
    case 'counting.symmetry':
      return {
        id: r,
        card: a,
        label: 'Sym\xE9trie',
        hora: 2,
        why: 'Choisir les k \xE9l\xE9ments que l\u2019on prend, c\u2019est choisir les n \u2212 k que l\u2019on laisse : k parmi n = (n \u2212 k) parmi n.',
      };
    case 'counting.pascal':
    case 'counting.pascal_down':
      return {
        id: r,
        card: a,
        label: 'Relation de Pascal',
        hora: 3,
        why: 'k parmi n + (k + 1) parmi n = (k + 1) parmi (n + 1) : chaque case du triangle de Pascal est la somme des deux cases au-dessus.',
      };
    case 'counting.fact_rec':
      return yL(n) > yL(t)
        ? {
            id: r,
            card: a,
            label: 'Regrouper en factorielle',
            hora: 2,
            why: 'n \xD7 (n \u2212 1)! = n!.',
          }
        : {
            id: r,
            card: a,
            label: 'n! = n \xD7 (n \u2212 1)!',
            hora: 2,
            why: 'On sort le premier facteur de la factorielle : n! = n \xD7 (n \u2212 1)!.',
          };
    default: {
      let g = i.label ?? 'R\xE8gle du cours',
        h = /distributivit/i.test(g);
      return { id: r, card: a, label: h ? 'D\xE9velopper' : g.slice(0, 60), hora: 2, why: g + '.' };
    }
  }
}
function xL(e) {
  return e ? AL(e, (n) => n.k === 'binom') : 0;
}
function yL(e) {
  return e ? AL(e, (n) => n.k === 'fn' && n.f === 'fact') : 0;
}
function AL(e, n) {
  let t = (r) => {
    let s = n(r) ? 1 : 0;
    switch (r.k) {
      case 'add':
      case 'mul':
        return s + r.c.reduce((i, o) => i + t(o), 0);
      case 'div':
      case 'pow':
      case 'binom':
        return s + t(r.a) + t(r.b);
      case 'fn':
        return s + t(r.a);
      default:
        return s;
    }
  };
  return (e.k === 'expr' ? t(e.e) : 0) + dt(e).reduce((r, s) => r + t(s.l) + t(s.r), 0);
}
var $b = aa;
function h9(e, n) {
  let t = e.explanation?.params?.f ?? 'cos',
    r = `arc${t}`;
  return {
    id: Me.inverse,
    card: 'Trigonom\xE9trie',
    label: `Utiliser ${r}`,
    hora: 2,
    why: `${n} est un angle de la figure, mesur\xE9 en degr\xE9s : ${t}(${n}) = c \xE9quivaut \xE0 ${n} = ${r}(c) (touche ${t}\u207B\xB9 de la calculatrice).`,
  };
}
function ek(e) {
  if (!/\.add_both_sides@/.test(e.ruleId ?? '')) return !1;
  let n = ie(e.explanation?.params?.v_c ?? '');
  return n.ok && n.s.k === 'expr' && R(n.s.e).k === 'add';
}
function fg(e, n, t, r, s) {
  let i = (o) => dt(o).reduce((a, l) => a + Kt(l.l) + Kt(l.r), 0) + (o.k === 'expr' ? Kt(o.e) : 0);
  if (i(r) < i(t))
    return {
      id: Me.expand,
      card: 'Calcul litt\xE9ral',
      label: 'D\xE9velopper',
      hora: 2,
      why: 'On d\xE9veloppe : la ligne ne change pas, elle s\u2019\xE9crit autrement.',
    };
  if (Os && s) {
    let o = (l) => dt(l).reduce((u, c) => u + Gv(c.l, s) + Gv(c.r, s), 0),
      a = (l) =>
        (l.k === 'mul' &&
          l.c.some((u) => u.k === 'sym' && u.n === s) &&
          l.c.some((u) => u.k === 'add' && jn(u))) ||
        ((l.k === 'add' || l.k === 'mul') && l.c.some(a));
    if (o(r) < o(t) && dt(r).some((l) => a(l.l) || a(l.r)))
      return {
        id: Me.compute,
        card: 'Calcul litt\xE9ral',
        label: `Mettre ${s} en facteur`,
        hora: 1,
        why: `On regroupe les termes en ${s} : a${s} + b${s} = (a + b)${s}. Il ne reste qu\u2019une division pour isoler ${s}.`,
      };
  }
  if (n.calc < e.calc) {
    let o = (a) => n.rad[a] < e.rad[a];
    return o('value')
      ? {
          id: Me.compute,
          card: 'Trigonom\xE9trie',
          label: 'Valeur exacte',
          hora: 1,
          why: 'On remplace par sa valeur exacte, \xE0 conna\xEEtre : cos 30\xB0 = \u221A3 \xF7 2, sin 30\xB0 = 1 \xF7 2, tan 45\xB0 = 1\u2026',
        }
      : o('conj')
        ? {
            id: Me.compute,
            card: 'Racines carr\xE9es',
            label: 'Multiplier par l\u2019expression conjugu\xE9e',
            hora: 2,
            why: '(a \u2212 b)(a + b) = a\xB2 \u2212 b\xB2 : on multiplie le haut et le bas par l\u2019expression conjugu\xE9e, la racine quitte le d\xE9nominateur.',
          }
        : o('radDen')
          ? {
              id: Me.compute,
              card: 'Racines carr\xE9es',
              label: 'Rendre le d\xE9nominateur rationnel',
              hora: 2,
              why: 'On multiplie le haut et le bas par la racine : \u221A3 \xD7 \u221A3 = 3, il n\u2019y a plus de racine au d\xE9nominateur.',
            }
          : o('sqrt')
            ? {
                id: Me.compute,
                card: 'Racines carr\xE9es',
                label: 'Simplifier la racine',
                hora: 1,
                why: 'On sort les carr\xE9s de la racine : \u221A12 = \u221A(4 \xD7 3) = 2\u221A3.',
              }
            : o('like')
              ? {
                  id: Me.compute,
                  card: 'Racines carr\xE9es',
                  label: 'R\xE9duire',
                  hora: 1,
                  why: 'On ajoute les coefficients d\u2019une m\xEAme racine : 2\u221A3 + 3\u221A3 = 5\u221A3.',
                }
              : {
                  id: Me.compute,
                  card: 'Calcul',
                  label: 'Calculer',
                  hora: 1,
                  why: 'On calcule et on r\xE9duit chaque membre.',
                };
  }
  return n.h < e.h && !b9(t, r)
    ? {
        id: Me.compute,
        card: 'Calcul',
        label: 'Calculer',
        hora: 1,
        why: 'On applique les r\xE8gles de calcul (puissances, exponentielle) : la ligne ne change pas, elle s\u2019\xE9crit plus simplement.',
      }
    : n.h < e.h
      ? {
          id: Me.swap,
          card: 'Calcul',
          label: '\xC9changer les membres',
          hora: 1,
          why: 'On lit la m\xEAme relation dans l\u2019autre sens : l\u2019inconnue passe \xE0 gauche.',
        }
      : null;
}
function b9(e, n) {
  if (e.k !== 'rel' || n.k !== 'rel') return !1;
  let t = (r, s) => {
    let i = Gn(r),
      o = Gn(s);
    return !!i && !!o && E(i) === E(o);
  };
  return n.rel === Dd[e.rel] && t(e.l, n.r) && t(e.r, n.l);
}
function v9(e) {
  if (!e.known) {
    let n = [...b5(e), e.spec.answer];
    e.known = n.flatMap((t) => {
      if (bi(t)) return [[t]];
      try {
        return [ne(zr(Ve(t)))];
      } catch {
        return [];
      }
    });
  }
  return e.known;
}
function k9(e, n) {
  return v9(e).some((t) => t.length > n.length && n.every((r, s) => t[s] === r));
}
function Nb(e, n, t) {
  let r = Os;
  Os = e.readable;
  try {
    return x9(e, n, t);
  } finally {
    Os = r;
  }
}
function x9(e, n, t) {
  let r = n.findIndex((c) => c.atoms.some(bi));
  if (r >= 0)
    return n.length !== 1 || n[0].atoms.length !== 1
      ? {
          kind: 'syntax',
          atoms: n.flatMap((c) => c.atoms),
          title: 'Le tableau seul sur sa ligne',
          message: 'Un tableau de signes se met seul sur sa ligne : retire les autres bouts.',
          badChip: r === 0 ? 1 : r,
        }
      : k5(e, n[0].atoms[0]);
  let s = wt(n),
    i = s.atoms;
  if (!i.length) return { kind: 'empty', atoms: i, badChip: -1 };
  let o = vn(i, { chains: e.poly || !!e.trig }),
    a = k9(e, i);
  if (!o.ok)
    return a
      ? { kind: 'building', atoms: i, complete: !1 }
      : {
          kind: 'syntax',
          atoms: i,
          title: '\xC7a commence mal',
          message: o.msg,
          badChip: s.src[o.index] !== void 0 ? s.src[o.index] : n.length - 1,
        };
  if (!o.complete || !o.hasEq) return { kind: a ? 'building' : 'open', atoms: i, complete: !1 };
  let l;
  try {
    l = Ae(i, { chains: e.poly || !!e.trig });
  } catch {
    return { kind: a ? 'building' : 'open', atoms: i, complete: !1 };
  }
  let u = y9(e, l, i);
  return a && !t?.verify
    ? u.kind === 'step'
      ? { ...u, kind: 'ready' }
      : { kind: 'building', atoms: i, complete: !0 }
    : !t?.verify && (u.kind === 'unjustified' || u.kind === 'false')
      ? { kind: 'pending', atoms: i, complete: !0 }
      : u;
}
function y9(e, n, t) {
  let r = Os;
  Os = e.readable;
  try {
    return w9(e, n, t);
  } finally {
    Os = r;
  }
}
function w9(e, n, t) {
  if (e.sys) return c5(e, e.sys, n, t);
  if (e.test) {
    let d = q9(e, n, t);
    if (d) return d;
  }
  let r = LL(e, qv(n));
  if (r) return S9(e, r.l, r.r, n, t);
  let s = qu(n),
    i = s.ok ? { ok: !0, s: NL(e, s.s) } : s;
  if (!i.ok || i.s.k === 'expr')
    return {
      kind: 'unjustified',
      atoms: t,
      line: n,
      title: 'Une relation par ligne',
      message:
        '\xC9cris une \xE9galit\xE9 ou une in\xE9galit\xE9 (avec \xAB = \xBB, \xAB < \xBB, \xAB > \xBB, \xAB \u2264 \xBB ou \xAB \u2265 \xBB), une seule par ligne.',
    };
  let o = ql(e, i.s, !0, s.ok && OL(e, s.s)),
    a = e.traps.find((d) => d.K === o.K);
  if (a)
    return {
      kind: 'trap',
      atoms: t,
      line: n,
      title: 'Pi\xE8ge : ' + Wv(a.title),
      message: a.why,
      trap: { line: a.line, title: a.title, why: a.why },
      badChip: -1,
    };
  if (e.poly) {
    let d = o5(e, i.s, n, t);
    if (d) return d;
  }
  if (o.raw === e.start.raw && !o.auxWritten)
    return {
      kind: 'given',
      atoms: t,
      line: n,
      title: 'C\u2019est l\u2019\xE9nonc\xE9',
      message: 'Cette ligne est d\xE9j\xE0 en t\xEAte de ta feuille : transforme-la.',
    };
  if (e.lines.some((d) => d.raw === o.raw && !!d.auxWritten == !!o.auxWritten))
    return {
      kind: 'dup',
      atoms: t,
      line: n,
      title: 'D\xE9j\xE0 \xE9crit',
      message: 'Tu as d\xE9j\xE0 cette ligne sur ta feuille.',
    };
  if (e.test) {
    let d = Yv(i.s, e.x);
    if (d) return L9(e, d, o, n, t);
  }
  if (e.conds.length) {
    let d = G4(e, o, n, t);
    if (d) return d;
  }
  let l = null,
    u = null,
    c = null,
    f = null;
  for (let d of Fd(e)) {
    let m = Ll(e, d, o.s, o.raw);
    if (m.status === 'valid' && (m.relation === 'equivalent' || m.relation === 'identity')) {
      l = { from: d, c: m };
      break;
    }
    if (m.status === 'valid') {
      u = m;
      break;
    }
    if (m.status === 'invalid') {
      c = m;
      break;
    }
    m.status === 'conditional' && (f ??= m);
  }
  if (l) return $9(e, l.from, l.c, o, n, t);
  if ((u || f) && e.conds.length) {
    let d = H4(e, o);
    if (d)
      return {
        kind: 'unjustified',
        atoms: t,
        line: n,
        title: 'La condition d\u2019abord',
        message: `Ta ligne n\u2019est juste qu\u2019avec une condition sur ${e.x}. ${d.why.replace(/ :.*$/, '.')} \xC9cris d\u2019abord cette condition sur sa ligne.`,
      };
  }
  return u
    ? {
        kind: 'false',
        atoms: t,
        line: n,
        title: 'Des solutions en trop',
        message:
          (u.explanation?.params?.at
            ? `${u.explanation.params.at} v\xE9rifie ta ligne, mais pas la pr\xE9c\xE9dente : `
            : 'Ta ligne d\xE9coule de la pr\xE9c\xE9dente, mais elle a plus de solutions : ') +
          'on doit garder exactement les m\xEAmes solutions.' +
          (dt(o.s).some((d) => d.rel === '\u2264' || d.rel === '\u2265')
            ? ' Attention aux in\xE9galit\xE9s larges (\u2264, \u2265) et strictes (<, >).'
            : ''),
      }
    : c
      ? P9(e, c, o, n, t)
      : f
        ? A9(f, n, t)
        : {
            kind: 'useless',
            atoms: t,
            line: n,
            unknown: !0,
            title: 'Je ne sais pas encore v\xE9rifier ce passage',
            message:
              'Ta ligne est peut-\xEAtre juste, mais je ne sais pas la v\xE9rifier. Garde-la sans HORA, ou \xE9cris le passage autrement.',
            kern: { s: o.s, trusted: !1, ...(o.auxWritten ? { auxWritten: !0 } : {}) },
          };
}
function S9(e, n, t, r, s) {
  let i = jn(n) ? n : null;
  if (!i && n.k === 'sym' && n.n === e.x) {
    for (let l of [...e.lines].reverse()) {
      if (!l.trusted || l.s.k !== 'rel' || l.s.rel !== '=') continue;
      let { l: u, r: c } = l.s;
      if (
        (u.k === 'sym' && u.n === e.x && jn(c)
          ? (i = c)
          : c.k === 'sym' && c.n === e.x && jn(u) && (i = u),
        i)
      )
        break;
    }
    if (!i)
      return {
        kind: 'unjustified',
        atoms: s,
        line: r,
        title: `Calcule d\u2019abord ${e.x}`,
        message: `\xC9cris la valeur exacte de ${e.x} (\xAB ${e.x} = \u2026 \xBB) avant d\u2019en donner une valeur approch\xE9e.`,
      };
  }
  if (!i)
    return {
      kind: 'unjustified',
      atoms: s,
      line: r,
      title: 'Une valeur approch\xE9e de quoi ?',
      message: `\xAB \u2248 \xBB sert \xE0 donner une valeur approch\xE9e d\u2019un nombre, ou de ${e.x} une fois sa valeur exacte \xE9crite.`,
    };
  if (e.rounding && n.k === 'sym' && n.n === e.x) {
    let l = T9(e, i, t, r, s);
    if (l) return l;
  }
  let o = Uf(null, i, t, { rules: e.rules, hypotheses: e.hyps }),
    a = () => {
      let l = D(i, {});
      return Number.isFinite(l) ? `Ce nombre vaut environ ${pe(Math.round(l * 1e4) / 1e4)}.` : '';
    };
  return o.status === 'valid'
    ? {
        kind: 'useless',
        atoms: s,
        line: r,
        title: 'Bonne valeur approch\xE9e',
        message:
          'Elle t\u2019aide \xE0 te rep\xE9rer, mais la r\xE9ponse attendue reste exacte : garde-la si tu veux.',
      }
    : o.status === 'invalid' && o.explanation?.code === 'truncated'
      ? {
          kind: 'false',
          atoms: s,
          line: r,
          title: 'Arrondir, ce n\u2019est pas couper',
          message:
            'Regarde le chiffre juste apr\xE8s : s\u2019il vaut 5 ou plus, le dernier chiffre gard\xE9 augmente de 1.',
        }
      : o.status === 'invalid'
        ? {
            kind: 'false',
            atoms: s,
            line: r,
            title: 'Valeur approch\xE9e fausse',
            message: a() || 'V\xE9rifie le calcul.',
          }
        : {
            kind: 'useless',
            atoms: s,
            line: r,
            unknown: !0,
            title: 'Je ne sais pas encore v\xE9rifier ce passage',
            message:
              'Je ne sais pas v\xE9rifier cette valeur approch\xE9e. Garde-la sans HORA si elle t\u2019aide.',
          };
}
function T9(e, n, t, r, s) {
  let i = e.rounding,
    o = K9(i.places),
    a = bw(t);
  if (a === null) return null;
  if (a > i.places)
    return Uf(null, n, t, { rules: e.rules, hypotheses: e.hyps }).status !== 'valid'
      ? null
      : {
          kind: 'useless',
          atoms: s,
          line: r,
          title: 'Garde moins de chiffres',
          message: `On demande ${e.x} arrondi ${o}${i.places === 0 ? ' : aucun chiffre apr\xE8s la virgule.' : ` : ${i.places} chiffre${i.places > 1 ? 's' : ''} apr\xE8s la virgule.`}`,
        };
  if (!VL(e, n, t)) {
    let l = Uf(null, n, t, {
      rules: e.rules,
      hypotheses: e.hyps,
      approximation: { places: i.places },
    });
    return l.status === 'invalid' && l.explanation?.code === 'approximation_too_coarse'
      ? {
          kind: 'useless',
          atoms: s,
          line: r,
          title: 'Pas assez pr\xE9cis',
          message: `On demande ${e.x} arrondi ${o}.`,
        }
      : null;
  }
  return e.rounded !== null
    ? {
        kind: 'dup',
        atoms: s,
        line: r,
        title: 'D\xE9j\xE0 \xE9crit',
        message: `Tu as d\xE9j\xE0 arrondi ${e.x}.`,
      }
    : {
        kind: 'step',
        atoms: s,
        line: r,
        hora: i.hora,
        final: !0,
        rule: {
          id: Me.round,
          card: 'Calcul',
          label: 'Arrondir',
          hora: i.hora,
          why: `On arrondit ${e.x} ${o} : on regarde le chiffre suivant, s\u2019il vaut 5 ou plus le dernier chiffre gard\xE9 augmente de 1.`,
        },
        round: D(t, {}),
      };
}
function R9(e) {
  let n = cw(e).s;
  return n.k === 'rel' && ui(n, e.x) === 'cube';
}
function $9(e, n, t, r, s, i) {
  if (!e.condsOk.length) return wL(e, n, t, r, s, i);
  let o = !U4(e, r);
  if (!o && n.condDep && so(n, e.x, e.trig) && so(r, e.x, e.trig)) {
    let l = zL(e, n, r),
      u = l?.info
        ? {
            ...l.info,
            why: l.info.why.replace(
              / ne convient pas : .*$/,
              ` ne convient pas : il ne v\xE9rifie pas la condition ${fL(e)}.`,
            ),
          }
        : {
            id: Me.conditionKeep,
            card: '\xC9quations',
            label: 'Tenir compte de la condition',
            hora: 1,
            why: `On ne garde que les ${e.x} qui v\xE9rifient la condition ${fL(e)}.`,
          };
    return {
      kind: 'step',
      atoms: i,
      line: s,
      hora: u.hora,
      final: !Rc(e),
      rule: u,
      kern: { s: r.s, trusted: !0 },
    };
  }
  let a = wL(e, n, t, r, s, i);
  return o ? { ...a, final: !1, ...(a.kern ? { kern: { ...a.kern, condDep: !0 } } : {}) } : a;
}
function wL(e, n, t, r, s, i) {
  let o = { s: r.s, trusted: !0, ...(r.auxWritten ? { auxWritten: !0 } : {}) },
    a = !!e.auxiliary && H9(e, n, r) && !Hv(cw(e), n);
  if (!Hv(r, cw(e)) && !a)
    return {
      kind: 'useless',
      atoms: i,
      line: s,
      title: 'Juste, mais \xE7a ne t\u2019avance pas',
      message: e.poly
        ? R9(e)
          ? 'Ta ligne est juste, mais elle ne rapproche pas de la r\xE9ponse : la fonction cube est strictement croissante, A\xB3 = c a une seule solution, le nombre dont le cube vaut c. \xC9cris-la. Garde ta ligne si elle t\u2019aide.'
          : 'Ta ligne est juste, mais elle ne rapproche pas de la r\xE9ponse : tout d\u2019un c\xF4t\xE9, factoriser (ou \u0394 et les racines), puis conclure. Garde-la si elle t\u2019aide.'
        : e.form === 'canonical'
          ? 'Ta ligne est juste, mais elle ne rapproche pas de la forme canonique a(x \u2212 \u03B1)\xB2 + \u03B2 : mets a en facteur devant x\xB2 et x, compl\xE8te le carr\xE9, d\xE9veloppe, puis calcule. Garde-la si elle t\u2019aide.'
          : e.form === 'fraction'
            ? 'Ta ligne est juste, mais elle ne rapproche pas d\u2019une seule fraction : r\xE9duis au m\xEAme d\xE9nominateur, d\xE9veloppe le num\xE9rateur, r\xE9duis-le, puis simplifie. Garde-la si elle t\u2019aide.'
            : e.form === 'factored'
              ? 'Ta ligne est juste, mais elle ne rapproche pas de la forme factoris\xE9e : fais appara\xEEtre le facteur commun (ou a\xB2 \u2212 b\xB2, a\xB2 + 2ab + b\xB2), puis factorise. Garde-la si elle t\u2019aide.'
              : e.form === 'expanded'
                ? 'Ta ligne est juste, mais elle ne rapproche pas de la forme d\xE9velopp\xE9e et r\xE9duite : d\xE9veloppe un produit \xE0 la fois, puis r\xE9duis. Garde-la si elle t\u2019aide.'
                : e.trig
                  ? 'Ta ligne est juste, mais elle ne rapproche pas de la r\xE9ponse : isole cos(x) (ou sin(x)), reconnais la valeur remarquable, puis \xE9cris les solutions. Garde-la si elle t\u2019aide.'
                  : e.count?.answer
                    ? 'Ta ligne est juste, mais elle ne rapproche pas de la r\xE9ponse : \xE9cris \xAB k parmi n \xBB avec les factorielles, simplifie les quotients de factorielles, puis calcule. Garde-la si elle t\u2019aide.'
                    : `Ta ligne est juste, mais elle ne rapproche pas de \xAB ${e.x} \xBB seul. Garde-la si elle t\u2019aide, ou repars de ta derni\xE8re ligne.`,
      kern: o,
    };
  if (e.count && r.cnt && n.cnt) {
    let f = t.proof === 'rule' && !!t.ruleId?.startsWith('counting.'),
      d = (r.NK !== null && r.NK === n.NK) || Jv(n.s, r.s, e.x),
      m =
        !f && d && Yq(n.cnt, r.cnt)
          ? nL(n.cnt, r.cnt, {
              division: dt(r.s).some((g) => wc(g.l) || wc(g.r)),
              plain: r.calc === 0 && X0(r.cnt) === 0,
            })
          : null;
    if (m && 'reject' in m) return { kind: 'unjustified', atoms: i, line: s, ...m.reject };
    let p = f ? aa(t, r.s, n.s) : m?.info;
    if (p)
      return {
        kind: 'step',
        atoms: i,
        line: s,
        hora: p.hora,
        final: so(r, e.x, e.trig) && !Rc(e),
        rule: p,
        kern: o,
      };
  }
  if (e.trig) {
    let f = s5(e, n, t, r);
    if (f?.reject) return { kind: 'unjustified', atoms: i, line: s, ...f.reject };
    if (f?.info)
      return {
        kind: 'step',
        atoms: i,
        line: s,
        hora: f.info.hora,
        final: so(r, e.x, e.trig) && !Rc(e),
        rule: f.info,
        kern: o,
      };
  }
  if (e.auxiliary) {
    let f = W9(e, n, t, r);
    if (f?.reject) return { kind: 'unjustified', atoms: i, line: s, ...f.reject };
    if (f?.info)
      return {
        kind: 'step',
        atoms: i,
        line: s,
        hora: f.info.hora,
        final: so(r, e.x, e.trig) && !Rc(e),
        rule: f.info,
        kern: o,
      };
  }
  if (e.poly) {
    let f = UL(e, n, t, r);
    if (f?.reject) return { kind: 'unjustified', atoms: i, line: s, ...f.reject };
    if (f?.info)
      return {
        kind: 'step',
        atoms: i,
        line: s,
        hora: f.info.hora,
        final: so(r, e.x, e.trig) && !Rc(e),
        rule: f.info,
        kern: o,
      };
  }
  if (
    e.form === 'fraction' &&
    n.h >= 10 &&
    !n.fm?.frac?.inner &&
    r.h < 10 &&
    r.fm?.frac?.numExpand === 0
  ) {
    let f = ao(n.s, e.x),
      d = ao(r.s, e.x),
      m = f ? jE(f) : null;
    if (m !== null && d && QE(d) < m)
      return {
        kind: 'unjustified',
        atoms: i,
        line: s,
        title: 'Une \xE9tape \xE0 la fois',
        message:
          'Ta ligne est juste, mais elle r\xE9duit au m\xEAme d\xE9nominateur ET calcule le num\xE9rateur d\u2019un coup. \xC9cris d\u2019abord la fraction avec le num\xE9rateur commun (a \xD7 d \u2212 c \xD7 b), puis d\xE9veloppe et r\xE9duis.',
      };
  }
  if (e.form) {
    let f = E9(e.form, e.x, n, r);
    if (f)
      return {
        kind: 'step',
        atoms: i,
        line: s,
        hora: f.hora,
        final: so(r, e.x, e.trig),
        rule: f,
        kern: o,
      };
  }
  let l = null;
  if (t.proof === 'rule' && t.ruleId && ek(t))
    return {
      kind: 'unjustified',
      atoms: i,
      line: s,
      title: 'Une op\xE9ration \xE0 la fois',
      message: `Ta ligne est juste, mais elle ajoute ${io(t.explanation?.params?.v_c ?? '')} d\u2019un coup : d\xE9place un terme \xE0 la fois, puis calcule.`,
    };
  let u = (r.NK !== null && r.NK === n.NK) || Jv(n.s, r.s, e.x);
  if (
    (t.proof === 'rule' && t.ruleId?.startsWith('algebra.') && u
      ? (l = fg(n, r, n.s, r.s, e.x) ?? aa(t, r.s, n.s))
      : t.proof === 'rule' && t.ruleId
        ? (l = aa(t, r.s, n.s))
        : t.explanation?.code === 'inverse_trig'
          ? (l = h9(t, e.x))
          : u && (l = fg(n, r, n.s, r.s, e.x)),
    l && (l.id === Me.compute || l.id === Me.expand))
  ) {
    let f = O9(n, r);
    if (f) return { kind: 'unjustified', atoms: i, line: s, ...f };
  } else if (l && t.proof === 'rule' && t9.some((f) => r.rad[f] < n.rad[f]))
    return {
      kind: 'unjustified',
      atoms: i,
      line: s,
      title: 'Une op\xE9ration \xE0 la fois',
      message:
        'Ta ligne est juste, mais elle fait une op\xE9ration des deux c\xF4t\xE9s ET un calcul (valeur exacte, racine\u2026) d\u2019un coup. \xC9cris-les l\u2019un apr\xE8s l\u2019autre.',
    };
  if ((!l && e.intBound && (l = N9(e, n, r)), !l))
    return {
      kind: 'unjustified',
      atoms: i,
      line: s,
      title: 'Juste, mais trop d\u2019un coup',
      message:
        'Ta ligne est juste, mais elle fait plusieurs op\xE9rations \xE0 la fois. \xC9cris-les une par une : une op\xE9ration des deux c\xF4t\xE9s, puis le calcul.',
    };
  let c = so(r, e.x, e.trig) && !Rc(e);
  return { kind: 'step', atoms: i, line: s, hora: l.hora, final: c, rule: l, kern: o };
}
function C9(e) {
  if (!e) return null;
  let n = e.k === 'add' ? e.c : [e];
  for (let t of n) {
    if (t.k !== 'mul') continue;
    let r = t.c.filter((s) => s.k === 'num');
    if (r.length === 1 && t.c.some((s) => s.k === 'add')) return oe(r[0]);
  }
  return null;
}
function E9(e, n, t, r) {
  let s = t.fm,
    i = r.fm;
  if (!s || !i) return null;
  let o = {
    id: Me.compute,
    card: 'Calcul litt\xE9ral',
    label: 'Enlever les parenth\xE8ses',
    hora: 1,
    why: 'Des parenth\xE8ses pr\xE9c\xE9d\xE9es de \xAB + \xBB s\u2019enl\xE8vent sans rien changer : a + (b \u2212 c) = a + b \u2212 c.',
  };
  if (e === 'fraction') {
    let u = s.frac,
      c = i.frac;
    return !u || !c || r.h >= t.h
      ? null
      : u.inner
        ? c.inner
          ? u.inner.h >= 10 && c.inner.h < 10
            ? {
                id: Me.compute,
                card: 'Fractions',
                label: 'M\xEAme d\xE9nominateur',
                hora: 2,
                why: 'Au num\xE9rateur : a \xF7 b \u2212 c \xF7 d = (a \xD7 d \u2212 c \xD7 b) \xF7 (b \xD7 d).',
              }
            : null
          : {
              id: Me.compute,
              card: 'Fractions',
              label: 'Diviser une fraction',
              hora: 1,
              why: 'Diviser par c, c\u2019est multiplier le d\xE9nominateur par c : (a \xF7 b) \xF7 c = a \xF7 (b \xD7 c).',
            }
        : t.h >= 10
          ? r.h >= 10
            ? {
                id: Me.compute,
                card: 'Fractions',
                label: 'R\xE9duire au m\xEAme d\xE9nominateur',
                hora: 1,
                why: 'On multiplie le num\xE9rateur et le d\xE9nominateur de chaque fraction par ce qui manque : a \xF7 b = (a \xD7 d) \xF7 (b \xD7 d).',
              }
            : u.dens === 1
              ? {
                  id: Me.compute,
                  card: 'Fractions',
                  label: 'Additionner les num\xE9rateurs',
                  hora: 1,
                  why: 'M\xEAme d\xE9nominateur : a \xF7 d + b \xF7 d = (a + b) \xF7 d. Attention aux signes devant une fraction.',
                }
              : {
                  id: Me.compute,
                  card: 'Fractions',
                  label: 'M\xEAme d\xE9nominateur',
                  hora: 2,
                  why: 'a \xF7 b \u2212 c \xF7 d = (a \xD7 d \u2212 c \xD7 b) \xF7 (b \xD7 d) : on r\xE9duit au m\xEAme d\xE9nominateur, puis on \xE9crit une seule fraction.',
                }
          : u.reducible && !u.visible && c.visible
            ? {
                id: Me.factor,
                card: 'Fractions',
                label: 'Faire appara\xEEtre le facteur commun',
                hora: 2,
                why: 'On factorise le num\xE9rateur (ou le d\xE9nominateur) : le facteur commun appara\xEEt en haut et en bas.',
              }
            : u.reducible && !c.reducible
              ? {
                  id: Me.compute,
                  card: 'Fractions',
                  label: 'Simplifier la fraction',
                  hora: 1,
                  why: 'Le num\xE9rateur et le d\xE9nominateur ont un facteur commun (non nul) : on divise les deux par ce facteur.',
                }
              : c.numExpand < u.numExpand
                ? {
                    id: Me.expand,
                    card: 'Calcul litt\xE9ral',
                    label: 'D\xE9velopper le num\xE9rateur',
                    hora: 2,
                    why: 'On d\xE9veloppe le num\xE9rateur, un produit \xE0 la fois ; le d\xE9nominateur peut rester factoris\xE9.',
                  }
                : null;
  }
  if (e === 'canonical') {
    if (r.h >= t.h) return null;
    if (r.h === 2 && t.h >= 3) {
      let u = C9(ao(r.s, n));
      return {
        id: Me.factor,
        card: 'Second degr\xE9',
        label: u ? `Mettre ${u} en facteur` : 'Mettre a en facteur',
        hora: 1,
        why: 'On met le coefficient de x\xB2 en facteur dans les deux termes en x : ax\xB2 + bx = a(x\xB2 + (b \xF7 a)x). Le nombre seul reste \xE0 part.',
      };
    }
    return r.h <= 1 && t.h >= 2
      ? {
          id: Me.factor,
          card: 'Second degr\xE9',
          label: 'Compl\xE9ter le carr\xE9',
          hora: 2,
          why: 'x\xB2 + 2px est le d\xE9but de (x + p)\xB2 = x\xB2 + 2px + p\xB2 : x\xB2 + 2px = (x + p)\xB2 \u2212 p\xB2.',
        }
      : r.h === 0 && t.h === 1
        ? {
            id: Me.expand,
            card: 'Second degr\xE9',
            label: 'D\xE9velopper',
            hora: 1,
            why: 'On distribue a : a((x + p)\xB2 \u2212 p\xB2) = a(x + p)\xB2 \u2212 ap\xB2. Le carr\xE9 reste \xE9crit.',
          }
        : null;
  }
  if (e === 'factored')
    return i.product && !s.product
      ? {
          id: Me.factor,
          card: 'Calcul litt\xE9ral',
          label: 'Factoriser',
          hora: 2,
          why: VE(s.pattern, ao(r.s, n)),
        }
      : !i.product && !s.product && r.h < t.h && i.pattern
        ? i.pattern === 'common'
          ? {
              id: Me.factor,
              card: 'Calcul litt\xE9ral',
              label: 'Faire appara\xEEtre le facteur commun',
              hora: 1,
              why: 'On \xE9crit chaque terme comme un produit qui contient le m\xEAme facteur : il ne reste plus qu\u2019\xE0 le mettre en \xE9vidence.',
            }
          : {
              id: Me.factor,
              card: 'Calcul litt\xE9ral',
              label: '\xC9crire les carr\xE9s',
              hora: 1,
              why:
                i.pattern === 'squares'
                  ? 'On \xE9crit chaque terme comme un carr\xE9 : on reconna\xEEt a\xB2 \u2212 b\xB2.'
                  : 'On \xE9crit les carr\xE9s et le double produit : on reconna\xEEt a\xB2 + 2ab + b\xB2 (ou a\xB2 \u2212 2ab + b\xB2).',
            }
        : i.product && s.product && s.h > 3 && i.h < s.h
          ? {
              id: Me.factor,
              card: 'Calcul litt\xE9ral',
              label: 'Factoriser',
              hora: 2,
              why: 'Un facteur se factorise encore : on le factorise \xE0 son tour.',
            }
          : i.nested < s.nested && r.expand >= t.expand
            ? o
            : null;
  if (r.expand < t.expand) return null;
  if (i.h - i.nested < s.h - s.nested && i.nested <= s.nested)
    return {
      id: Me.expand,
      card: 'Calcul litt\xE9ral',
      label: 'D\xE9velopper',
      hora: 2,
      why: 'On d\xE9veloppe un produit \xE0 la fois : la ligne ne change pas, elle s\u2019\xE9crit autrement.',
    };
  if (i.nested < s.nested) return o;
  let a = ao(t.s, n),
    l = ao(r.s, n);
  return i.pow < s.pow && a?.k === 'div' && a.a.k === 'add' && l && l.k !== 'div'
    ? {
        id: Me.compute,
        card: 'Calcul litt\xE9ral',
        label: 'Simplifier la fraction',
        hora: 1,
        why: 'Chaque terme du num\xE9rateur contient le d\xE9nominateur (non nul) : on divise chaque terme par lui.',
      }
    : i.pow < s.pow && r.calc - i.pow >= t.calc - s.pow
      ? {
          id: Me.compute,
          card: 'Puissances',
          label: 'R\xE8gles des puissances',
          hora: 1,
          why: 'a\u207F \xD7 a\u1D50 = a\u207F\u207A\u1D50, a\u207F \xF7 a\u1D50 = a\u207F\u207B\u1D50, (a\u207F)\u1D50 = a\u207F\u02E3\u1D50, (ab)\u207F = a\u207Fb\u207F.',
        }
      : null;
}
function Jv(e, n, t) {
  let r = (a) =>
      a.k !== 'rel' || a.rel !== '='
        ? null
        : a.l.k === 'sym' && a.l.n === t && jn(a.r)
          ? a.r
          : null,
    s = r(e),
    i = r(n);
  if (!s || !i) return !1;
  let o = Z(ve(s, i));
  return o.ok && Ue(o.rf.n);
}
function Qd(e) {
  let n = Gn(e);
  if (n && n.k === 'num') return { exact: n.v, f: en(n.v) };
  let t = D(e, {});
  return Number.isFinite(t) ? { exact: null, f: t } : null;
}
function Ad(e, n) {
  if (e.exact && n.exact) return Re(e.exact, n.exact);
  let t = e.f - n.f;
  return Math.abs(t) <= 1e-12 * Math.max(1, Math.abs(e.f), Math.abs(n.f)) ? 0 : t < 0 ? -1 : 1;
}
var fw = (e, n) =>
  n === '<'
    ? e < 0
    : n === '\u2264'
      ? e <= 0
      : n === '>'
        ? e > 0
        : n === '\u2265'
          ? e >= 0
          : e === 0;
function jL(e) {
  let n = [],
    t = e.x;
  for (let r of [e.start, ...e.lines.filter((s) => s.trusted)]) {
    if (r.s.k !== 'rel' || r.s.rel === '=') continue;
    let { l: s, r: i, rel: o } = r.s;
    hn(s, t) && !hn(i, t)
      ? n.push({ g: s, c: i, rel: o })
      : hn(i, t) && !hn(s, t) && n.push({ g: i, c: s, rel: Dd[o] });
  }
  return n;
}
function M9(e, n) {
  let t = jL(e)[0];
  if (!t) return null;
  let r = Qd(j(t.g, { [e.x]: { k: 'num', v: C(n) } })),
    s = Qd(t.c);
  return r && s ? fw(Ad(r, s), t.rel) : null;
}
function lg(e, n = []) {
  if (e.k === 'num')
    return (e.v.d === 1n && e.v.n >= 0n && e.v.n <= 100000n && n.push(Number(e.v.n)), n);
  switch (e.k) {
    case 'add':
    case 'mul':
      return (e.c.forEach((t) => lg(t, n)), n);
    case 'div':
    case 'pow':
    case 'binom':
      return (lg(e.a, n), lg(e.b, n), n);
    case 'fn':
      return lg(e.a, n);
    default:
      return n;
  }
}
function QL(e) {
  let n = Yv(e.answer, e.x);
  if (!n) return null;
  let t = n.rel === '>' || n.rel === '\u2265',
    r = Number(n.v) + (n.rel === '>' ? 1 : n.rel === '<' ? -1 : 0);
  return { up: t, n: r };
}
function _9(e) {
  let n = e.d,
    t = 0;
  for (; t <= 9; ) {
    if (n === 1n) return t;
    if (n % 10n === 0n) n /= 10n;
    else if (n % 2n === 0n) n /= 2n;
    else if (n % 5n === 0n) n /= 5n;
    else return null;
    if (n === 1n) return t + 1;
    t += 1;
  }
  return null;
}
function q9(e, n, t) {
  let r = e.x,
    s = qv(n),
    i,
    o,
    a = !1;
  if (s) ((i = s.l), (o = s.r), (a = !0));
  else {
    let w = qu(n);
    if (!w.ok || w.s.k !== 'rel' || w.s.rel !== '=') return null;
    ((i = w.s.l), (o = w.s.r));
  }
  if (hn(i, r) || hn(o, r)) return null;
  let l = Qd(i);
  if (!l) return null;
  let u = null;
  for (let w of jL(e)) {
    for (let _ of lg(i)) {
      let O = Qd(j(w.g, { [r]: { k: 'num', v: C(_) } }));
      if (O && Ad(O, l) === 0) {
        u = { k: _, side: w };
        break;
      }
    }
    if (u) break;
  }
  if (!u)
    return {
      kind: 'unjustified',
      atoms: t,
      line: n,
      title: 'Teste un rang',
      message: `Remplace ${r} par un entier dans l\u2019in\xE9galit\xE9 (\xAB ${r} = 10 \xBB), puis \xE9cris la valeur obtenue.`,
    };
  let { k: c, side: f } = u,
    d = Qd(o),
    m = R(o);
  if (!d || m.k !== 'num')
    return {
      kind: 'unjustified',
      atoms: t,
      line: n,
      title: '\xC9cris la valeur',
      message: '\xC0 droite, \xE9cris la valeur obtenue (un nombre, arrondi si besoin).',
    };
  if (a) {
    let w = _9(m.v),
      _ = Math.abs(l.f - d.f),
      O = w === null ? 0 : 0.5 * 10 ** -w;
    if (w === null || _ > O * (1 + 1e-9) + 1e-12) {
      let G = w !== null && _ < 2 * O && Math.abs(l.f) > Math.abs(d.f);
      return {
        kind: 'false',
        atoms: t,
        line: n,
        title: G ? 'Arrondir, ce n\u2019est pas couper' : 'Valeur approch\xE9e fausse',
        message: G
          ? 'Regarde le chiffre suivant : s\u2019il vaut 5 ou plus, le dernier chiffre gard\xE9 augmente de 1.'
          : `Recalcule la valeur pour ${r} = ${c}.`,
      };
    }
  } else if (Ad(l, d) !== 0)
    return {
      kind: 'false',
      atoms: t,
      line: n,
      title: l.exact ? 'Calcul faux' : '\xC9cris \xAB \u2248 \xBB',
      message: l.exact
        ? `Recalcule la valeur pour ${r} = ${c}.`
        : 'Cette valeur n\u2019est pas exacte : \xE9cris \xAB \u2248 \xBB et arrondis.',
    };
  let p = Qd(f.c);
  if (!p) return null;
  let g = fw(Ad(l, p), f.rel);
  if (fw(Ad(d, p), f.rel) !== g || (a && Ad(d, p) === 0))
    return {
      kind: 'useless',
      atoms: t,
      line: n,
      title: 'Pas assez pr\xE9cis pour comparer',
      message:
        'Ta valeur est juste, mais trop arrondie pour savoir de quel c\xF4t\xE9 du seuil elle est : garde plus de chiffres.',
    };
  if (e.tests.has(c))
    return {
      kind: 'dup',
      atoms: t,
      line: n,
      title: 'D\xE9j\xE0 test\xE9',
      message: `Tu as d\xE9j\xE0 test\xE9 ${r} = ${c}.`,
    };
  let h = QL(e),
    b = [...e.tests.entries()],
    v = h
      ? h.up
        ? g
          ? b.every(([w, _]) => !_ || w > c)
          : b.every(([w, _]) => _ || w < c)
        : g
          ? b.every(([w, _]) => !_ || w < c)
          : b.every(([w, _]) => _ || w > c)
      : !0,
    k = Ec(a ? oe(ar(m)) : oe(m)),
    y = Ec(oe(ar(R(f.c)))),
    S = {
      id: Me.testValue,
      card: 'Seuils',
      label: `Tester ${r} = ${c}`,
      hora: 1,
      why: g
        ? `Pour ${r} = ${c}, on trouve ${k} : l\u2019in\xE9galit\xE9 est v\xE9rifi\xE9e (seuil ${y}).`
        : `Pour ${r} = ${c}, on trouve ${k} : l\u2019in\xE9galit\xE9 n\u2019est pas v\xE9rifi\xE9e (seuil ${y}).`,
    };
  return v
    ? { kind: 'step', atoms: t, line: n, hora: 1, final: !1, rule: S, test: { k: c, holds: g } }
    : {
        kind: 'useless',
        atoms: t,
        line: n,
        title: 'Juste, mais l\u2019encadrement ne se resserre pas',
        message:
          'Tu as d\xE9j\xE0 un rang plus proche du seuil. Teste un rang entre ceux que tu as \xE9crits.',
        test: { k: c, holds: g },
      };
}
function L9(e, n, t, r, s) {
  let i = e.x,
    o = QL(e),
    a = n.rel === '>' || n.rel === '\u2265',
    l = Number(n.v) + (n.rel === '>' ? 1 : n.rel === '<' ? -1 : 0),
    u = 0,
    c = Math.max(l, o?.n ?? l) + 40;
  for (let g = u; g <= c; g++) {
    let h = M9(e, g);
    if (h === null) break;
    if (h !== (a ? g >= l : g <= l))
      return {
        kind: 'false',
        atoms: s,
        line: r,
        title: 'Ce n\u2019est pas le bon seuil',
        message:
          'Ta borne ne dit pas la m\xEAme chose que l\u2019in\xE9galit\xE9 de d\xE9part : teste les rangs autour d\u2019elle.',
      };
  }
  let f = e.tests.get(l),
    d = a ? e.tests.get(l - 1) : e.tests.get(l + 1),
    m = a ? l - 1 < u : !1;
  if (f !== !0 || (d !== !1 && !m))
    return {
      kind: 'unjustified',
      atoms: s,
      line: r,
      title: 'Juste, mais montre-le',
      message:
        'Ta borne est juste : montre-la par les tests, un rang qui ne convient pas et le suivant qui convient.',
    };
  let p = a ? l - 1 : l + 1;
  return {
    kind: 'step',
    atoms: s,
    line: r,
    hora: 2,
    final: !0,
    rule: {
      id: Me.integerBound,
      card: 'Seuils',
      label: a ? 'Le plus petit entier' : 'Le plus grand entier',
      hora: 2,
      why: m
        ? `${i} = ${l} convient d\xE9j\xE0 : c\u2019est le premier rang.`
        : `${i} = ${p} ne convient pas, ${i} = ${l} convient : la suite \xE9tant monotone, c\u2019est le ${a ? 'premier' : 'dernier'} rang.`,
    },
    kern: { s: t.s, trusted: !0 },
  };
}
function N9(e, n, t) {
  let r = Yv(t.s, e.x);
  if (!r || n.s.k !== 'rel' || n.s.rel === '=') return null;
  let s = n.s,
    i =
      s.l.k === 'sym' && s.l.n === e.x && jn(s.r)
        ? { rel: s.rel, t: s.r }
        : s.r.k === 'sym' && s.r.n === e.x && jn(s.l)
          ? { rel: Dd[s.rel], t: s.l }
          : null;
  if (!i) return null;
  let o = D(i.t, {});
  if (!Number.isFinite(o)) return null;
  let a = r.rel === '>' || r.rel === '\u2265',
    l = pe(Math.trunc(o * 100) / 100),
    u = Number.isInteger(o) ? pe(o) : `${l}\u2026`,
    c = pe(Number(r.v));
  return {
    id: Me.integerBound,
    card: 'Seuils',
    label: a ? 'Le plus petit entier' : 'Le plus grand entier',
    hora: 2,
    why: `${e.x} est un entier : ${e.x} ${i.rel} ${u} \xE9quivaut \xE0 ${e.x} ${r.rel} ${c}.`,
  };
}
function O9(e, n) {
  let t = gw.filter((s) => n.rad[s] < e.rad[s]);
  if (!t.length) return null;
  let r =
    (n.calc - Zv(n.rad) < e.calc - Zv(e.rad) ? 1 : 0) +
    (n.expand < e.expand ? 1 : 0) +
    (t.includes('sqrt') && !t.includes('like') && SL(n.s) < SL(e.s) ? 1 : 0);
  return t.length + r > 1
    ? {
        title: 'Un calcul \xE0 la fois',
        message:
          'Ta ligne est juste, mais elle fait plusieurs calculs d\u2019un coup (simplifier une racine, remplacer par une valeur exacte, r\xE9duire\u2026). \xC9cris-les un par un.',
      }
    : (t.includes('radDen') || t.includes('conj')) && !s9(n.s)
      ? {
          title: 'Montre comment',
          message:
            'Ta ligne est juste, mais on ne voit pas comment la racine quitte le d\xE9nominateur : \xE9cris d\u2019abord la fraction multipli\xE9e en haut et en bas.',
        }
      : null;
}
function SL(e) {
  let n = (t) => {
    switch (t.k) {
      case 'add':
        return t.c.reduce((r, s) => r + (jn(s) && !oo(s) ? 1 : 0) + n(s), 0);
      case 'mul':
        return t.c.reduce((r, s) => r + n(s), 0);
      case 'div':
      case 'pow':
      case 'binom':
        return n(t.a) + n(t.b);
      case 'fn':
        return n(t.a);
      default:
        return 0;
    }
  };
  return dt(e).reduce((t, r) => t + n(r.l) + n(r.r), 0);
}
function FL(e) {
  if (e.answer.k !== 'rel' || e.answer.rel !== '=') return null;
  let { l: n, r: t } = e.answer;
  return n.k === 'sym' && n.n === e.x && jn(t)
    ? t
    : t.k === 'sym' && t.n === e.x && jn(n)
      ? n
      : null;
}
function bw(e) {
  let n = R(e);
  if (n.k !== 'num') return null;
  let t = n.v;
  for (let r = 0; r <= 12; r++) {
    if (t.d === 1n) return r;
    t = N(t, C(10));
  }
  return null;
}
function Rc(e) {
  if (!e.rounding || e.rounded !== null) return !1;
  let n = FL(e);
  if (!n) return !0;
  let t = bw(n);
  return t === null || t > e.rounding.places;
}
function K9(e) {
  return e === 0
    ? '\xE0 l\u2019unit\xE9'
    : e === 1
      ? 'au dixi\xE8me'
      : e === 2
        ? 'au centi\xE8me'
        : e === 3
          ? 'au milli\xE8me'
          : `\xE0 ${e} chiffres apr\xE8s la virgule`;
}
function VL(e, n, t) {
  if (!e.rounding) return !1;
  let r = bw(t);
  return r === null || r > e.rounding.places
    ? !1
    : Uf(null, n, t, {
        rules: e.rules,
        hypotheses: e.hyps,
        approximation: { places: e.rounding.places },
      }).status === 'valid';
}
function P9(e, n, t, r, s) {
  if (t.s.k === 'rel' && t.s.rel !== '=') {
    let a = { ...t.s, rel: Dd[t.s.rel] },
      l = ql(e, a, !0);
    for (let u of Fd(e)) {
      let c = Ll(e, u, l.s, l.raw);
      if (c.status !== 'valid' || c.relation !== 'equivalent') continue;
      let f = c.ruleId ?? '';
      return /_negative@/.test(f)
        ? {
            kind: 'false',
            atoms: s,
            line: r,
            title: 'Le sens change !',
            message:
              'Tu divises (ou multiplies) par un nombre n\xE9gatif : l\u2019in\xE9galit\xE9 change de sens.',
          }
        : /^explog\./.test(f)
          ? {
              kind: 'false',
              atoms: s,
              line: r,
              title: 'Le sens ne change pas',
              message:
                'exp et ln sont strictement croissantes : les appliquer aux deux membres garde le sens de l\u2019in\xE9galit\xE9.',
            }
          : e.poly && u.s.k === 'rel' && ui(u.s, e.x) === 'cube'
            ? {
                kind: 'false',
                atoms: s,
                line: r,
                title: 'Le sens ne change pas',
                message:
                  'La fonction cube est strictement croissante : A\xB3 \u2264 c \xE9quivaut \xE0 A \u2264 b, o\xF9 b\xB3 = c. Le sens de l\u2019in\xE9galit\xE9 reste le m\xEAme.',
              }
            : /_positive@|add_both_sides@/.test(f)
              ? {
                  kind: 'false',
                  atoms: s,
                  line: r,
                  title: 'Le sens ne change pas',
                  message: /_positive@/.test(f)
                    ? 'Diviser (ou multiplier) par un nombre positif garde le sens de l\u2019in\xE9galit\xE9.'
                    : 'Ajouter ou retrancher un m\xEAme terme garde le sens de l\u2019in\xE9galit\xE9.',
                }
              : {
                  kind: 'false',
                  atoms: s,
                  line: r,
                  title: 'Dans le mauvais sens',
                  message:
                    'La m\xEAme ligne avec l\u2019autre signe serait juste : le sens change quand on multiplie ou divise par un nombre n\xE9gatif, et seulement l\xE0.',
                };
    }
  }
  if (t.s.k === 'rel' && t.s.rel !== '=') {
    let a = { ...t.s, rel: hL[t.s.rel] },
      l = ql(e, a, !0),
      u = n.explanation?.params?.at;
    for (let c of Fd(e)) {
      let f = Ll(e, c, l.s, l.raw);
      if (!(f.status !== 'valid' || f.relation !== 'equivalent'))
        return {
          kind: 'false',
          atoms: s,
          line: r,
          title: 'Strict ou large ?',
          message:
            (u ? `Avec ${u}, ta ligne pr\xE9c\xE9dente est vraie mais pas celle-ci. ` : '') +
            '\xAB \u2264 \xBB et \xAB \u2265 \xBB gardent la borne, \xAB < \xBB et \xAB > \xBB l\u2019enl\xE8vent : une in\xE9galit\xE9 stricte reste stricte, une large reste large.',
        };
    }
  }
  if (t.s.k === 'set') {
    let a = t.s.clauses,
      l = a.flatMap((c, f) => c.map((d, m) => [f, m])),
      u = [...l.slice(0, 6), null];
    for (let c of u) {
      if (c === null && l.length < 2) continue;
      let f = {
          k: 'set',
          clauses: a.map((p, g) =>
            p.map((h, b) =>
              c === null || (g === c[0] && b === c[1]) ? { ...h, rel: hL[h.rel] } : h,
            ),
          ),
        },
        d = ql(e, f, !0);
      if (
        Fd(e).some((p) => {
          let g = Ll(e, p, d.s, d.raw);
          return g.status === 'valid' && g.relation === 'equivalent';
        })
      )
        return {
          kind: 'false',
          atoms: s,
          line: r,
          title: 'Strict ou large ?',
          message:
            'Regarde chaque borne : elle est dans l\u2019ensemble si la ligne pr\xE9c\xE9dente y est vraie (\u2264, \u2265), exclue sinon (<, >). Une valeur interdite est toujours exclue.',
        };
    }
  }
  let i = { ...(n.explanation?.params ?? {}) };
  typeof i.at == 'string' && I9(e, i.at) && delete i.at;
  let o = n.explanation?.code;
  if (e.spec.goal.kind === 'simplify' && !i.at && (o === 'lost_solution' || o === 'counterexample'))
    return {
      kind: 'false',
      atoms: s,
      line: r,
      title: 'Ce n\u2019est pas la m\xEAme valeur',
      message: 'Ta ligne ne vaut pas la pr\xE9c\xE9dente : reprends le calcul.',
    };
  switch (o) {
    case 'counterexample':
      return {
        kind: 'false',
        atoms: s,
        line: r,
        title: 'Cette ligne ne d\xE9coule pas de la pr\xE9c\xE9dente',
        message: i.at
          ? `Avec ${i.at}, ta ligne pr\xE9c\xE9dente est vraie mais pas celle-ci.`
          : 'Elle ne garde pas les m\xEAmes solutions.',
      };
    case 'lost_solution':
      return {
        kind: 'false',
        atoms: s,
        line: r,
        title: 'Une solution se perd',
        message:
          (i.at
            ? `${i.at} v\xE9rifie ta ligne pr\xE9c\xE9dente, mais pas celle-ci.`
            : 'Des solutions de ta ligne pr\xE9c\xE9dente ne v\xE9rifient plus celle-ci.') +
          (e.trig && !e.angles ? Y9(e, t) : ''),
      };
    case 'division_by_zero':
      return {
        kind: 'false',
        atoms: s,
        line: r,
        title: 'Division par z\xE9ro',
        message: 'On ne divise jamais par z\xE9ro.',
      };
    case 'false_statement':
      return {
        kind: 'false',
        atoms: s,
        line: r,
        title: 'Cette ligne est fausse',
        message: 'V\xE9rifie le calcul.',
      };
    default:
      return {
        kind: 'false',
        atoms: s,
        line: r,
        title: 'Cette ligne ne d\xE9coule pas de la pr\xE9c\xE9dente',
        message: 'Elle ne garde pas les m\xEAmes solutions : reprends ta derni\xE8re ligne.',
      };
  }
}
function I9(e, n) {
  if (n.includes(',')) return !1;
  let t = ie(n);
  if (!t.ok) return !1;
  let r = on(t.s)[0];
  return !r || r.rel !== '=' || r.l.k !== 'sym' || r.l.n !== e.x
    ? !1
    : on(e.answer).some(
        (s) => s.rel === '=' && s.l.k === 'sym' && s.l.n === e.x && qn(s.r, r.r) === 'equal',
      );
}
function A9(e, n, t) {
  if (e.branches?.length) {
    let i = e.explanation?.params?.of ?? 'ce nombre';
    return {
      kind: 'unjustified',
      atoms: t,
      line: n,
      title: `\xC7a d\xE9pend du signe de ${i}`,
      message: `Le sens de l\u2019in\xE9galit\xE9 d\xE9pend du signe de ${i} : regarde ce que l\u2019\xE9nonc\xE9 en dit avant de diviser ou de multiplier.`,
    };
  }
  let r = (e.conditions ?? []).map(IL),
    s = r.length ? r.join(' et ') : 'une condition';
  return {
    kind: 'unjustified',
    atoms: t,
    line: n,
    title: `Juste seulement si ${s}`,
    message: `Cette \xE9tape n\u2019est juste que si ${s}, et l\u2019\xE9nonc\xE9 ne le garantit pas.`,
  };
}
var Vd = 'Second degr\xE9',
  Nl = (e) =>
    e.k === 'set'
      ? e.clauses
      : e.k === 'or'
        ? e.items.map((n) => [n])
        : e.k === 'rel'
          ? [[{ rel: e.rel, l: e.l, r: e.r }]]
          : [];
function j9(e, n) {
  let t = Nl(e);
  return (
    t.length > 0 && t.every((r) => r.every((s) => ['linear', 'solved'].includes(ui(s, n, !0))))
  );
}
function El(e) {
  return li(e.r) ? e.l : li(e.l) ? e.r : null;
}
var or = (e) => oe(ar(R(e))),
  Cc = (e) => or({ k: 'num', v: e });
function Q9(e) {
  let n = [];
  for (let t of Fd(e)) {
    if (t.s.k !== 'rel') continue;
    let r = Fb(t.s, e.x);
    r && n.push({ r: t.s, t: r });
  }
  return n;
}
function DL(e, n) {
  let t = Z({
    k: 'add',
    c: [
      {
        k: 'mul',
        c: [
          { k: 'num', v: e.a },
          { k: 'pow', a: n, b: { k: 'num', v: C(2) } },
        ],
      },
      { k: 'mul', c: [{ k: 'num', v: e.b }, n] },
      { k: 'num', v: e.c },
    ],
  });
  return t.ok && Ue(t.rf.n);
}
var dg = (e, n) => {
  let t = Z(ve(e, n));
  return t.ok && Ue(t.rf.n);
};
function dw(e, n) {
  let r = [...e.aux.values()]
      .filter((o) => k1(o.name, e.x) === 'root')
      .filter((o) => DL(n, o.value)),
    s = [];
  r.forEach((o) => {
    s.some((a) => dg(a, o.value)) || s.push(o.value);
  });
  let i = te(n.disc);
  if (i < 0) {
    let o = e.aux.get('\u0394');
    return !!o && dg(o.value, { k: 'num', v: n.disc });
  }
  return s.length === (i === 0 ? 1 : 2);
}
function F9(e, n, t) {
  let r = El(n) ?? ve(n.l, n.r),
    s = El(t) ?? ve(t.l, t.r);
  if (wp(s, e.x))
    return 'Identit\xE9 remarquable : a\xB2 \u2212 2ab + b\xB2 = (a \u2212 b)\xB2, a\xB2 + 2ab + b\xB2 = (a + b)\xB2.';
  if (ui(n, e.x) === 'canonical')
    return 'Identit\xE9 remarquable : a\xB2 \u2212 b\xB2 = (a \u2212 b)(a + b).';
  let i = Fb(n, e.x);
  return i && L(i.c)
    ? 'On met x en facteur : ax\xB2 + bx = x(ax + b).'
    : i && dw(e, i)
      ? 'Avec les racines x\u2081 et x\u2082 : ax\xB2 + bx + c = a(x \u2212 x\u2081)(x \u2212 x\u2082).'
      : (r.k === 'add', 'On factorise : en d\xE9veloppant, on retrouve la ligne pr\xE9c\xE9dente.');
}
function V9(e, n, t) {
  let r = { k: 'rel', ...n },
    s = { k: 'rel', ...t },
    i = `clause:${Ii(r)}\u2192${Ii(s)}`,
    o = e.cache.get(i);
  if (o) return o;
  let a = Ss(r, s, {
    rules: e.rules,
    hypotheses: e.hyps,
    goal: e.goal,
    deadline: Date.now() + 250,
    branches: !1,
  });
  return (e.cache.set(i, a), a);
}
function D9(e, n, t) {
  let r = V9(e, n, t);
  if (r.status !== 'valid' || (r.relation !== 'equivalent' && r.relation !== 'identity'))
    return null;
  let s = { k: 'rel', ...n },
    i = { k: 'rel', ...t };
  if (r.proof === 'rule' && r.ruleId && !ek(r)) return aa(r, i, s);
  let o = Ir(s, e.x, !0),
    a = Ir(i, e.x, !0);
  return (a.NK !== null && a.NK === o.NK) || Jv(s, i, e.x) ? fg(o, a, s, i) : null;
}
function BL(e, n, t) {
  if (n.length !== t.length) return null;
  let r = n.map((i, o) => D9(e, i, t[o]));
  if (r.some((i) => !i)) return null;
  let s = r[0];
  return r.some((i) => i.label !== s.label)
    ? null
    : r.length > 1
      ? { ...s, why: `${s.why} On le fait sur chaque membre de la cha\xEEne.` }
      : s;
}
var _l = (e) => la({ k: 'set', clauses: [e] });
function vw(e) {
  return e.length <= 1
    ? [e]
    : e.flatMap((n, t) => vw([...e.slice(0, t), ...e.slice(t + 1)]).map((r) => [n, ...r]));
}
function B9(e, n, t) {
  let r = Nl(n.s),
    s = Nl(t.s);
  if (r.length !== s.length || r.length > 4) return null;
  let i = r.length <= 3 ? vw(r.map((o, a) => a)) : [r.map((o, a) => a)];
  for (let o of i) {
    let a = [],
      l = !0;
    for (let f = 0; f < s.length && l; f++) {
      let d = r[o[f]],
        m = s[f];
      if (_l(d) === _l(m)) continue;
      let p = BL(e, d, m);
      p ? a.push({ f: d, st: p }) : (l = !1);
    }
    if (!l || !a.length) continue;
    let u = (f) => _t({ k: 'set', clauses: [f] });
    if (a.length === 1) {
      let { f, st: d } = a[0];
      return { info: { ...d, why: `Dans \xAB ${u(f)} \xBB : ${Wv(d.why)}` } };
    }
    let c = a.every((f) => f.f.every((d) => d.rel === '='));
    return {
      info: {
        id: Un.clauses,
        card: c ? '\xC9quations' : 'In\xE9quations',
        label: c ? 'R\xE9soudre chaque \xE9quation' : 'R\xE9soudre chaque in\xE9galit\xE9',
        hora: 2,
        why: a.map((f) => `\xAB ${u(f.f)} \xBB : ${Wv(f.st.label)}`).join(' ; ') + '.',
      },
    };
  }
  return null;
}
var z9 = {
    id: Un.clearDenominator,
    card: '\xC9quations',
    label: 'Chasser le d\xE9nominateur',
    hora: 2,
    why: 'On multiplie les deux membres par le d\xE9nominateur, non nul pour les valeurs permises : plus de fraction, les solutions ne changent pas.',
  },
  TL = {
    id: Un.zeroProduct,
    card: '\xC9quations',
    label: 'Quotient nul',
    hora: 2,
    why: 'Un quotient est nul quand son num\xE9rateur est nul et son d\xE9nominateur ne l\u2019est pas : on \xE9carte la valeur interdite.',
  };
function U9(e, n, t) {
  if (!$c(e) || n.s.k !== 'rel') return !1;
  let r = El({ rel: n.s.rel, l: n.s.l, r: n.s.r });
  if (!r) return !1;
  let s = new Set(
    ll(r)
      .filter((i) => hn(i, e.x))
      .map((i) => la({ k: 'expr', e: i })),
  ).size;
  return Nl(t.s).length < s;
}
function G9(e) {
  if (!e.startsWith('\u2212')) return null;
  let n = ie(e);
  if (!n.ok || n.s.k !== 'expr') return null;
  let t = Z({ k: 'mul', c: [{ k: 'num', v: C(-1) }, n.s.e] });
  if (!t.ok) return null;
  let r = oe(ar(Je($e(t.rf))));
  return r.startsWith('\u2212') ? null : r;
}
function $c(e) {
  return (e.spec.hypotheses ?? []).map((n) => IL(n)).join(', ');
}
function zL(e, n, t) {
  let r = Nl(n.s),
    s = Nl(t.s);
  if (!s.length || s.length >= r.length) return null;
  let i = new Set(r.map(_l));
  if (!s.every((c) => i.has(_l(c)))) return null;
  let o = new Set(s.map(_l)),
    a = r.filter((c) => !o.has(_l(c))),
    l = (c) => _t({ k: 'set', clauses: [c] }),
    u = $c(e);
  return {
    info: {
      id: Un.keep,
      card: '\xC9quations',
      label: 'Garder ce qui convient',
      hora: 1,
      why:
        a.map((c) => `\xAB ${l(c)} \xBB`).join(' et ') +
        (u
          ? ` ne convient pas : d\u2019apr\xE8s l\u2019\xE9nonc\xE9, ${u}.`
          : ' ne convient pas : on ne garde que les solutions permises.'),
    },
  };
}
var Vv = {
  pose: 'aux.pose@1',
  back: 'aux.back@1',
  compose: 'aux.compose@1',
  rewrite: 'aux.rewrite@1',
};
function Z9(e, n, t) {
  let r = `aux:${n.raw}\u2192${t.raw}`,
    s = e.cache.get(r);
  if (s) return s;
  let i = e.auxiliary.name,
    o = Ss(n.s, t.s, {
      rules: e.rules,
      hypotheses: [],
      goal: { ...e.goal, target: i },
      deadline: Date.now() + 250,
      branches: !0,
    });
  return (e.cache.set(r, o), o);
}
function H9(e, n, t) {
  let r = e.auxiliary;
  if (!r || !!n.auxWritten == !!t.auxWritten) return !1;
  let s = ug(n.s, r, e.x),
    i = ug(t.s, r, e.x);
  return !s || !i
    ? !1
    : Ir(s, r.name, !0, !0, null, { v47: !0 }).K === Ir(i, r.name, !0, !0, null, { v47: !0 }).K;
}
function W9(e, n, t, r) {
  let s = e.auxiliary,
    i = s.name,
    o = { x: '\u02E3', t: '\u1D57', n: '\u207F' },
    a = s.of === 'exp' ? (o[e.x] ? 'e' + o[e.x] : `e^${e.x}`) : `ln(${e.x})`,
    l = ug(n.s, s, e.x),
    u = ug(r.s, s, e.x);
  if (l && u) {
    let c = Ir(l, i, !0, !0, null, { v47: !0 }),
      f = Ir(u, i, !0, !0, null, { v47: !0 }),
      d = c.K === f.K;
    if (!d && !n.auxWritten && r.auxWritten)
      return {
        reject: {
          title: 'Une \xE9tape \xE0 la fois',
          message: `Pose d\u2019abord ${i} = ${a} : recopie ta ligne en \xE9crivant ${i} \xE0 la place de ${a}, puis transforme-la.`,
        },
      };
    if (!d && n.auxWritten && !r.auxWritten)
      return {
        reject: {
          title: 'Une \xE9tape \xE0 la fois',
          message: `Remplace d\u2019abord ${i} par ${a} dans ta ligne, puis transforme-la.`,
        },
      };
    if (d && !n.auxWritten && r.auxWritten)
      return {
        info: {
          id: Vv.pose,
          card: '\xC9quations',
          label: `Poser ${i} = ${a}`,
          hora: 1,
          why: `On pose ${i} = ${a} : la ligne devient une \xE9quation (ou une in\xE9quation) en ${i}, qu\u2019on sait r\xE9soudre.`,
        },
      };
    if (d && !n.auxWritten && !r.auxWritten && n.K !== r.K)
      return {
        info: {
          id: Vv.rewrite,
          card: 'Exponentielle et logarithme',
          label: `\xC9crire avec ${a}`,
          hora: 1,
          why:
            s.of === 'exp'
              ? `e^(2${e.x}) = (${a})\xB2 : la ligne s\u2019\xE9crit avec ${a} seulement, pr\xEAte pour ${i}.`
              : `La ligne s\u2019\xE9crit avec ${a} seulement, pr\xEAte pour ${i}.`,
        },
      };
    if (d && n.auxWritten && !r.auxWritten)
      return {
        info: {
          id: Vv.back,
          card: '\xC9quations',
          label: `Remplacer ${i} par ${a}`,
          hora: 1,
          why: `${i} = ${a} : on revient \xE0 l\u2019inconnue ${e.x}.`,
        },
      };
    let m = Z9(e, c, f),
      p = UL({ ...e, x: i, auxiliary: null }, c, m, f);
    if (p) return p;
    if (m.proof === 'rule') {
      let g = aa(m, f.s, c.s);
      if (g) return { info: g };
    }
    return null;
  }
  if (l && u && !n.auxWritten && !r.auxWritten && s.of === 'exp') {
    let c = J9(l, u, i);
    if (c && c.length > 0 && c.every((f) => qL(f.r, i)))
      return {
        info: {
          id: Un.keep,
          card: 'Exponentielle et logarithme',
          label: 'Garder ce qui convient',
          hora: 1,
          why: `${a} > 0 : ${c.map((f) => `${a} ${f.rel} ${Ec(oe({ k: 'num', v: f.c }))}`).join(' et ')} n\u2019a pas de solution.`,
        },
      };
  }
  return l && !u && n.auxWritten && zo(l, i) && zo(r.s, e.x)
    ? {
        reject: {
          title: 'Une \xE9tape \xE0 la fois',
          message: `Remplace d\u2019abord ${i} par ${a}, puis reviens \xE0 ${e.x}.`,
        },
      }
    : l && !u && zo(l, i) && zo(r.s, e.x)
      ? {
          info: {
            id: Vv.compose,
            card: 'Exponentielle et logarithme',
            label: s.of === 'exp' ? 'Composer par ln' : 'Composer par exp',
            hora: 2,
            why:
              s.of === 'exp'
                ? 'e\u02E3 = c \xE9quivaut \xE0 x = ln(c) quand c > 0 ; e\u02E3 = c n\u2019a pas de solution quand c \u2264 0 (e\u02E3 > 0). Pour une in\xE9galit\xE9, ln est croissante : le sens ne change pas.'
                : 'ln(x) = c \xE9quivaut \xE0 x = e\u1D9C ; exp est croissante : le sens d\u2019une in\xE9galit\xE9 ne change pas.',
          },
        }
      : null;
}
function J9(e, n, t) {
  let r = (a) => {
      let l = [];
      for (let u of dt(a)) {
        if (u.l.k !== 'sym' || u.l.n !== t) return null;
        let c = Gn(u.r);
        if (!c || c.k !== 'num') return null;
        l.push({ rel: u.rel, c: c.v, r: u });
      }
      return l;
    },
    s = r(e),
    i = r(n);
  if (!s || !i) return null;
  let o = (a, l) => a.rel === l.rel && M(a.c, l.c);
  return i.every((a) => s.some((l) => o(a, l))) ? s.filter((a) => !i.some((l) => o(a, l))) : null;
}
function X9(e, n, t) {
  let r = (o, a) => {
      if (E(R(o)) === E(R(a))) return 'same';
      if (
        o.k !== 'div' ||
        a.k !== 'div' ||
        E(R(o.b)) !== E(R(a.b)) ||
        !hn(o.a, t) ||
        !hn(o.b, t) ||
        o.a.k !== 'add' ||
        a.a.k !== 'mul'
      )
        return null;
      let l = Gn(o.a),
        u = Gn(a.a);
      return l && u && E(l) === E(u) ? 'factored' : null;
    },
    s = r(e.l, n.l),
    i = r(e.r, n.r);
  return (s === 'factored' && i === 'same') || (s === 'same' && i === 'factored');
}
function UL(e, n, t, r) {
  let s = e.x,
    i = n.s.k === 'rel' ? { rel: n.s.rel, l: n.s.l, r: n.s.r } : null,
    o = r.s.k === 'rel' ? { rel: r.s.rel, l: r.s.l, r: r.s.r } : null;
  if (!i) return zL(e, n, r) ?? B9(e, n, r);
  let a = ui(i, s),
    l = o ? ui(o, s) : null,
    u = i.rel === '=',
    c = u ? '\xC9quations' : 'In\xE9quations',
    f = so(r, s) || (r.s.k === 'or' && r.calc === 0 && r.h === 0),
    d = j9(r.s, s);
  if (t.proof === 'rule' && t.ruleId && ek(t)) {
    if (o && El(o) && !El(i)) {
      let b = t.explanation?.params?.v_c ?? '',
        v = PL(b) ?? G9(b),
        k = v ? `retranche ${io(v)}` : `ajoute ${io(b)}`;
      return {
        info: {
          id: Un.allOnOneSide,
          card: c,
          label: 'Tout passer du m\xEAme c\xF4t\xE9',
          hora: 2,
          why: `On ${k} aux deux membres : l\u2019un devient 0${u ? '' : ', le sens ne change pas'}. On pourra factoriser.`,
        },
      };
    }
    let h = i5(n.s, t.explanation?.params?.v_c);
    return h
      ? {
          info: aa(
            {
              ...t,
              explanation: { ...t.explanation, params: { ...t.explanation.params, v_c: h } },
            },
            r.s,
          ),
        }
      : null;
  }
  let m = r.NK !== null && r.NK === n.NK;
  if (m && u && o && r.h < n.h && Id(n.s, s) && !Id(r.s, s))
    return {
      info:
        li(i.l) || li(i.r)
          ? TL
          : {
              id: Un.clearDenominator,
              card: '\xC9quations',
              label: 'Simplifier la fraction',
              hora: 2,
              why: 'Le facteur commun ne s\u2019annule pas pour les valeurs permises : on simplifie la fraction, en gardant la valeur interdite \xE0 l\u2019\xE9cart.',
            },
    };
  if (e.readable && m && o && X9(i, o, s))
    return {
      info: {
        id: Un.factor,
        card: 'Calcul litt\xE9ral',
        label: 'Factoriser le num\xE9rateur',
        hora: 2,
        why: 'On factorise le num\xE9rateur, le d\xE9nominateur ne change pas : chaque facteur aura sa ligne dans le tableau de signes.',
      },
    };
  if (m && o && r.h < n.h) {
    let h = El(i) ?? ve(i.l, i.r),
      b = El(o),
      v = Gn(h),
      k = !!v && v.k === 'add';
    return l === 'factored' && h.k === 'add' && b?.k === 'div' && Id(n.s, s)
      ? {
          info: {
            id: Un.sameDenominator,
            card: 'Calcul litt\xE9ral',
            label: 'M\xEAme d\xE9nominateur',
            hora: 2,
            why: 'On r\xE9duit au m\xEAme d\xE9nominateur : une seule fraction, dont on \xE9tudie le signe du num\xE9rateur et du d\xE9nominateur.',
          },
        }
      : (l === 'factored' || l === 'partial') && a !== 'factored' && k
        ? {
            info: {
              id: Un.factor,
              card: 'Calcul litt\xE9ral',
              label: 'Factoriser',
              hora: 2,
              why: F9(e, i, o),
            },
          }
        : l === 'canonical' && (a === 'expanded' || a === 'unsorted')
          ? {
              info: {
                id: Un.canonical,
                card: Vd,
                label: 'Forme canonique',
                hora: 2,
                why: 'On compl\xE8te le carr\xE9 : ax\xB2 + bx + c = a(x \u2212 \u03B1)\xB2 + \u03B2. Le carr\xE9 se compare ensuite, ou se factorise avec a\xB2 \u2212 b\xB2.',
              },
            }
          : null;
  }
  if (m) return null;
  if (a === 'rational' && l && l !== 'rational' && !Id(r.s, s))
    return { info: li(i.l) || li(i.r) ? TL : z9 };
  if (u && r.s.k !== 'set' && d) {
    if (a === 'factored') {
      let h = Id(n.s, s),
        b = El(i),
        v =
          !h &&
          !!b &&
          new Set(
            ll(b)
              .filter((k) => hn(k, s))
              .map((k) => la({ k: 'expr', e: k })),
          ).size === 1;
      return {
        info: {
          id: Un.zeroProduct,
          card: '\xC9quations',
          label: h ? 'Quotient nul' : v ? 'Une puissance nulle' : 'Produit nul',
          hora: 2,
          why:
            (h
              ? 'Un quotient est nul quand son num\xE9rateur est nul et son d\xE9nominateur ne l\u2019est pas : on garde les valeurs permises.'
              : v
                ? 'Une puissance est nulle seulement si le nombre l\u2019est : A\xB2 = 0 \xE9quivaut \xE0 A = 0.'
                : 'Un produit est nul si et seulement si l\u2019un de ses facteurs est nul : chaque facteur donne une \xE9quation.') +
            (U9(e, n, r)
              ? ` D\u2019apr\xE8s l\u2019\xE9nonc\xE9, ${$c(e)} : on \xE9carte ce qui ne convient pas.`
              : ''),
        },
      };
    }
    if (a === 'cube') {
      let h = hn(i.l, s) ? i.l : i.r,
        b = Qb(h, s).base;
      return {
        info: {
          id: Un.cubeRoot,
          card: '\xC9quations',
          label: 'Fonction cube : une solution',
          hora: 2,
          why: `La fonction cube est strictement croissante : ${or(b)}\xB3 = c a une seule solution, le nombre dont le cube vaut c. Pas de solution n\xE9gative en plus, comme pour un carr\xE9.`,
        },
      };
    }
    if (a === 'square') {
      let h = hn(i.l, s) ? i.l : i.r,
        b = h === i.l ? i.r : i.l,
        v = wp(h, s).base,
        k = Gn(b),
        y = !!k && k.k === 'num' && L(k.v);
      return {
        info: {
          id: Un.squareRoot,
          card: '\xC9quations',
          label: y ? 'Un carr\xE9 nul' : 'Racine carr\xE9e : deux solutions',
          hora: 2,
          why: y
            ? `${or(v)}\xB2 = 0 \xE9quivaut \xE0 ${or(v)} = 0.`
            : Nl(r.s).length === 1 && $c(e)
              ? `${or(v)}\xB2 = c, avec c > 0 : ${or(v)} = \u221Ac ou ${or(v)} = \u2212\u221Ac ; d\u2019apr\xE8s l\u2019\xE9nonc\xE9, ${$c(e)} : on garde une seule solution.`
              : `${or(v)}\xB2 = c, avec c > 0 : ${or(v)} = \u221Ac ou ${or(v)} = \u2212\u221Ac. N\u2019oublie pas la solution n\xE9gative !`,
        },
      };
    }
  }
  let p = Fb(i, s),
    g = a === 'expanded' || a === 'canonical' || a === 'unsorted';
  if (!u) {
    if (f && e.tables.includes(n.K))
      return {
        info: {
          id: Un.signTableRead,
          card: 'In\xE9quations',
          label: 'Lire le tableau de signes',
          hora: 1,
          why: 'Sur la derni\xE8re ligne du tableau, on garde les intervalles o\xF9 l\u2019expression a le signe demand\xE9 ; un 0 est gard\xE9 si l\u2019in\xE9galit\xE9 est large, une valeur interdite (\u2016) jamais.',
        },
      };
    if (a === 'factored' && f)
      return {
        info: {
          id: Un.signTable,
          card: 'In\xE9quations',
          label: 'Tableau de signes',
          hora: 3,
          why:
            'Chaque facteur change de signe en sa racine ; la r\xE8gle des signes donne le signe du produit sur chaque intervalle.' +
            (Id(n.s, s) ? ' La valeur qui annule le d\xE9nominateur est interdite : exclue.' : ''),
        },
      };
    if (a === 'cube' && d)
      return {
        info: {
          id: Un.cubeCompare,
          card: 'In\xE9quations',
          label: 'Fonction cube',
          hora: 2,
          why: 'La fonction cube est strictement croissante : A\xB3 \u2264 c \xE9quivaut \xE0 A \u2264 b, o\xF9 b\xB3 = c. Le sens ne change pas, une seule borne.',
        },
      };
    if (a === 'square' && d) {
      let h = i.rel === '<' || i.rel === '\u2264',
        v = hn(i.l, s) ? h : !h;
      return {
        info: {
          id: Un.squareCompare,
          card: 'In\xE9quations',
          label: 'Fonction carr\xE9',
          hora: 3,
          why: v
            ? 'Pour c > 0 : A\xB2 \u2264 c \xE9quivaut \xE0 \u2212\u221Ac \u2264 A \u2264 \u221Ac (A\xB2 < c : bornes exclues).'
            : 'Pour c > 0 : A\xB2 \u2265 c \xE9quivaut \xE0 A \u2264 \u2212\u221Ac ou A \u2265 \u221Ac (A\xB2 > c : bornes exclues).',
        },
      };
    }
    return f && (g || a === 'partial')
      ? p && dw(e, p)
        ? {
            info: {
              id: Un.trinomialSign,
              card: Vd,
              label: 'Signe du trin\xF4me',
              hora: 3,
              why:
                te(p.disc) > 0
                  ? `a = ${Cc(p.a)} : le trin\xF4me est du signe de a \xE0 l\u2019ext\xE9rieur des racines, du signe contraire entre elles.`
                  : te(p.disc) === 0
                    ? `\u0394 = 0, a = ${Cc(p.a)} : le trin\xF4me est du signe de a partout, nul en sa racine double.`
                    : `\u0394 < 0, a = ${Cc(p.a)} : le trin\xF4me ne s\u2019annule pas, il est partout du signe de a.`,
            },
          }
        : {
            reject: {
              title: 'Juste, mais trop d\u2019un coup',
              message:
                'Pour lire le signe, factorise d\u2019abord (facteur commun, identit\xE9 remarquable), ou calcule \u0394 et les racines du trin\xF4me.',
            },
          }
      : null;
  }
  return f && (g || a === 'partial')
    ? p && dw(e, p)
      ? {
          info: {
            id: Un.roots,
            card: Vd,
            label: 'Les solutions sont les racines',
            hora: 2,
            why:
              'Les solutions de ax\xB2 + bx + c = 0 sont les racines du trin\xF4me, calcul\xE9es avec \u0394.' +
              ($c(e) && Nl(r.s).length < (L(p.disc) ? 1 : 2)
                ? ` D\u2019apr\xE8s l\u2019\xE9nonc\xE9, ${$c(e)} : on \xE9carte la racine qui ne convient pas.`
                : ''),
          },
        }
      : {
          reject: {
            title: 'Juste, mais trop d\u2019un coup',
            message:
              'Factorise d\u2019abord (puis produit nul), ou calcule \u0394 et les racines du trin\xF4me : une \xE9tape par ligne.',
          },
        }
    : null;
}
var Pd = 'Trigonom\xE9trie',
  RL = (e) => (e.k === 'rel' ? { rel: e.rel, l: e.l, r: e.r } : null);
function $L(e, n) {
  let t = sa(e, n)[0];
  return t?.k === 'fn' ? t.f : null;
}
var CL = (e, n) => {
  let t = sa(e, n)[0];
  return t ? oe(t) : 'cos(x)';
};
function Y9(e, n) {
  return rg(n.s, e.trig.params)
    ? ' Souvent, il y a deux familles : cos(a) = cos(b) donne a = b + 2k\u03C0 ou a = \u2212b + 2k\u03C0 ; sin(a) = sin(b) donne a = b + 2k\u03C0 ou a = \u03C0 \u2212 b + 2k\u03C0.'
    : ' Sur un tour du cercle, un cosinus ou un sinus prend en g\xE9n\xE9ral deux fois la m\xEAme valeur.';
}
function e5(e, n) {
  let t = e.trig;
  if (!t.dom || rg(n, t.params)) return null;
  for (let r of on(n)) {
    if (r.rel !== '=') continue;
    let s = r.l.k === 'sym' && r.l.n === e.x ? r.r : r.r.k === 'sym' && r.r.n === e.x ? r.l : null;
    if (!s || $(s).size) continue;
    let i = ri(s);
    if (i && !Jm(i, t.dom)) return `${e.x} = ${tb(i)}`;
  }
  return null;
}
function n5(e, n) {
  return on(e).every((t) => t.rel === '=' && t.l.k === 'sym' && t.l.n === n);
}
var EL = {
  cos: 'cos(a) = cos(b) \xE9quivaut \xE0 a = b + 2k\u03C0 ou a = \u2212b + 2k\u03C0, k entier (deux points du cercle, sym\xE9triques par rapport \xE0 l\u2019axe horizontal).',
  sin: 'sin(a) = sin(b) \xE9quivaut \xE0 a = b + 2k\u03C0 ou a = \u03C0 \u2212 b + 2k\u03C0, k entier (deux points du cercle, sym\xE9triques par rapport \xE0 l\u2019axe vertical).',
  tan: 'tan(a) = tan(b) \xE9quivaut \xE0 a = b + k\u03C0, k entier : tan revient tous les \u03C0.',
};
function t5(e, n, t) {
  let r = e.trig,
    s = [];
  for (let l of on(n.s)) {
    let u = sb(l, e.x, r.params);
    u && s.push(...u);
  }
  let i = new Map();
  for (let l of on(t.s)) {
    if (l.rel !== '=' || l.l.k !== 'sym' || l.l.n !== e.x) continue;
    let u = ri(l.r);
    if (!u) continue;
    let c = s.map((d) => z$(u, d)).find((d) => d !== null);
    if (c == null) continue;
    let f = c.toString().replace('-', '\u2212');
    i.set(f, [...(i.get(f) ?? []), `${e.x} = ${tb(u)}`]);
  }
  let o = [...i.entries()].map(([l, u]) => `k = ${l} donne ${u.join(' et ')}`),
    a = [...r.params][0] ?? 'k';
  return o.length
    ? `${o.join(' ; ')}. Les autres valeurs de ${a} sortent de l\u2019intervalle (${r.text}).`.replace(
        /\bk = /g,
        `${a} = `,
      )
    : `On donne \xE0 ${a} les valeurs enti\xE8res qui placent ${e.x} dans l\u2019intervalle (${r.text}).`;
}
function r5(e, n, t) {
  let r = tg(n.s),
    s = tg(t.s);
  if (r.length !== s.length || r.length > 4) return null;
  let i = r.length <= 3 ? vw(r.map((o, a) => a)) : [r.map((o, a) => a)];
  for (let o of i) {
    let a = [],
      l = !0;
    for (let c = 0; c < s.length && l; c++) {
      let f = r[o[c]],
        d = s[c];
      if (_l(f) === _l(d)) continue;
      let m = BL(e, f, d);
      m ? a.push(m) : (l = !1);
    }
    if (!l || !a.length) continue;
    let u = a[0];
    return a.some((c) => c.label !== u.label)
      ? null
      : { info: a.length > 1 ? { ...u, why: `${u.why} On le fait dans chaque clause.` } : u };
  }
  return null;
}
function s5(e, n, t, r) {
  let s = e.trig,
    i = e.x,
    o = s.bounded ? e5(e, r.s) : null;
  if (o)
    return {
      reject: {
        title: 'Hors de l\u2019intervalle',
        message: `${o} n\u2019est pas dans l\u2019intervalle de l\u2019\xE9nonc\xE9 (${s.text}) : ne garde que les solutions qui y sont.`,
      },
    };
  let a = RL(n.s),
    l = RL(r.s),
    u = a ? Iv(a, i, s.params) : null,
    c = l ? Iv(l, i, s.params) : null,
    f = rg(n.s, s.params),
    d = rg(r.s, s.params),
    m = Y0(r.s, i, s.params),
    p = Y0(n.s, i, s.params);
  if (u === 'mixed') {
    if (l && c !== 'mixed' && c !== 'family' && c !== 'linear' && $L(l, i) === 'tan') {
      let v = sa(a, i).find((y) => y.k === 'fn' && y.f === 'cos'),
        k = v ? oe(v) : `cos(${i})`;
      return {
        info: {
          id: Kd.divideCos,
          card: Pd,
          label: `Diviser par ${k}`,
          hora: 2,
          why: `${k} ne s\u2019annule pas sur les solutions : s\u2019il valait 0, le sinus vaudrait 1 ou \u22121 et l\u2019\xE9galit\xE9 serait fausse. Et sin \xF7 cos = tan.`,
        },
      };
    }
    return c === 'associated'
      ? {
          info: {
            id: Kd.associated,
            card: Pd,
            label: 'Angles associ\xE9s',
            hora: 2,
            why: 'Un angle associ\xE9 change une fonction en l\u2019autre : sin(a) = cos(\u03C0 \xF7 2 \u2212 a) et cos(a) = sin(\u03C0 \xF7 2 \u2212 a). Il reste deux cosinus (ou deux sinus) \xE0 comparer.',
          },
        }
      : {
          reject: {
            title: 'Une \xE9tape \xE0 la fois',
            message:
              'Ram\xE8ne-toi d\u2019abord \xE0 une seule fonction : divise par cos(x) (sin(x) \xF7 cos(x) = tan(x)), ou utilise un angle associ\xE9 (sin(x) = cos(\u03C0 \xF7 2 \u2212 x)).',
          },
        };
  }
  if (e.angles) return null;
  let g = !!a && a.rel !== '=',
    h = a ? ($L(a, i) ?? 'cos') : 'cos';
  if (u === 'isolated' && c === 'reference') {
    let v = sa(a, i)[0],
      k = E(R(a.l)) === E(R(v)) ? a.r : a.l,
      y = E(R(l.l)) === E(R(v)) ? l.r : l.l;
    return {
      info: {
        id: Kd.knownValue,
        card: Pd,
        label: 'Valeur remarquable',
        hora: 2,
        why: `${oe(k)} = ${oe(y)} : une valeur remarquable du cercle trigonom\xE9trique.`,
      },
    };
  }
  if (u === 'trig' && (c === 'reference' || d || m))
    return {
      reject: {
        title: 'Une op\xE9ration \xE0 la fois',
        message: `Isole d\u2019abord ${CL(a, i)} (une op\xE9ration des deux c\xF4t\xE9s), puis cherche la valeur remarquable.`,
      },
    };
  let b = u === 'isolated' || u === 'reference' || u === 'associated';
  if (b && d && !g) {
    let v = tg(r.s).length,
      k = h === 'tan' || v === 1 ? 'Une famille de solutions' : 'Deux familles de solutions';
    return { info: { id: Kd.families, card: Pd, label: k, hora: 3, why: EL[h] ?? EL.cos } };
  }
  return b && m && s.bounded
    ? {
        info: {
          id: Kd.circle,
          card: Pd,
          label: 'Lire sur le cercle',
          hora: 3,
          why: g
            ? `Sur le cercle trigonom\xE9trique, on rep\xE8re les points de l\u2019intervalle (${s.text}) o\xF9 l\u2019in\xE9galit\xE9 est vraie ; une borne est comprise avec \u2264 ou \u2265, exclue avec < ou >.`
            : `Sur le cercle trigonom\xE9trique, on rep\xE8re les points de l\u2019intervalle (${s.text}) o\xF9 ${CL(a, i)} prend cette valeur : ce sont les solutions.`,
        },
      }
    : f && m && s.bounded
      ? n5(n.s, i)
        ? {
            info: {
              id: Kd.interval,
              card: Pd,
              label: 'Garder celles de l\u2019intervalle',
              hora: 2,
              why: t5(e, n, r),
            },
          }
        : {
            reject: {
              title: 'Une op\xE9ration \xE0 la fois',
              message: `\xC9cris d\u2019abord les familles en ${i} seul (\xAB ${i} = \u2026 + 2k\u03C0 \xBB), puis garde celles de l\u2019intervalle.`,
            },
          }
      : (f && d) || (p && m)
        ? r5(e, n, r)
        : null;
}
function i5(e, n) {
  if (!n) return null;
  let t = ie(n);
  if (!t.ok || t.s.k !== 'expr') return null;
  let r = t.s.e;
  for (let s of dt(e))
    for (let i of [s.l, s.r])
      for (let o of i.k === 'add' ? i.c : [i]) {
        let a = R({ k: 'mul', c: [{ k: 'num', v: C(-1) }, o] });
        if (dg(a, r) && R(a).k !== 'add') return or(a);
      }
  return null;
}
function Id(e, n) {
  return dt(e).some((t) => {
    if (Bo(t.l, n) || Bo(t.r, n)) return !0;
    let r = Z(ve(t.l, t.r));
    if (!r.ok) return !1;
    let s = $e(r.rf).d;
    for (let { m: i } of s.t.values()) if (i.some((o) => o.a.symbol === n)) return !0;
    return !1;
  });
}
function o5(e, n, t, r) {
  if (n.k !== 'rel' || n.l.k !== 'sym') return null;
  let s = n.l.n,
    i = k1(s, e.x);
  if (!i) return null;
  let o = (b, v) => ({ kind: 'unjustified', atoms: r, line: t, title: b, message: v }),
    a = Q9(e);
  if (!a.length)
    return o(
      'Quel trin\xF4me ?',
      `\xC9cris d\u2019abord la ligne sous la forme ax\xB2 + bx + c = 0 (ou face \xE0 0) : ${s} se calcule pour ce trin\xF4me.`,
    );
  let l = n.r;
  if ($(l).has('\u0394')) {
    let b = e.aux.get('\u0394');
    if (!b)
      return o(
        'Calcule d\u2019abord \u0394',
        '\xC9cris \xAB \u0394 = \u2026 \xBB avant de t\u2019en servir.',
      );
    l = j(l, { Δ: b.value });
  }
  if ($(l).size)
    return o(
      'Avec des nombres',
      `${s} se calcule avec les nombres du trin\xF4me : pas de lettre \xE0 droite.`,
    );
  let u = Gn(l);
  if (!u)
    return o(
      'Ce calcul n\u2019a pas de sens',
      'V\xE9rifie le calcul (division par z\xE9ro, racine d\u2019un n\xE9gatif\u2026).',
    );
  let c = Pr(l) + Zv(Ml(l)),
    f = (b, v) => ({ s: n, trusted: b, auxLine: !0, ...(v ? { aux: v } : {}) }),
    d = a[0].t;
  if (n.rel !== '=') {
    let b = e.aux.get('\u0394');
    if (i !== 'disc' || !b)
      return o(
        'Calcule d\u2019abord \u0394',
        '\xC9cris \xAB \u0394 = \u2026 \xBB puis compare-le \xE0 0.',
      );
    let v = Gn(ve(b.value, l)),
      k = v && v.k === 'num' ? te(v.v) : null;
    if (k === null) return null;
    if (!(n.rel === '<' ? k < 0 : n.rel === '>' ? k > 0 : n.rel === '\u2264' ? k <= 0 : k >= 0))
      return {
        kind: 'false',
        atoms: r,
        line: t,
        title: 'Ce n\u2019est pas le signe de \u0394',
        message: `\u0394 = ${or(b.value)} : relis la comparaison.`,
      };
    if (e.lines.some((_) => _.raw === Ii(n)))
      return {
        kind: 'dup',
        atoms: r,
        line: t,
        title: 'D\xE9j\xE0 \xE9crit',
        message: 'Tu as d\xE9j\xE0 compar\xE9 \u0394 \xE0 0.',
      };
    let S = Gn(b.value),
      w = S && S.k === 'num' ? te(S.v) : 0;
    return {
      kind: 'step',
      atoms: r,
      line: t,
      hora: 1,
      rule: {
        id: Un.discriminantSign,
        card: Vd,
        label: 'Signe de \u0394',
        hora: 1,
        why:
          w > 0
            ? '\u0394 > 0 : le trin\xF4me a deux racines.'
            : w === 0
              ? '\u0394 = 0 : le trin\xF4me a une racine double.'
              : '\u0394 < 0 : le trin\xF4me n\u2019a pas de racine r\xE9elle.',
      },
      kern: f(!1),
    };
  }
  if (i === 'disc') {
    if (!a.some((k) => u.k === 'num' && M(u.v, k.t.disc)))
      return {
        kind: 'false',
        atoms: r,
        line: t,
        title: 'Ce n\u2019est pas le discriminant',
        message: `\u0394 = b\xB2 \u2212 4ac, avec a = ${Cc(d.a)}, b = ${Cc(d.b)}, c = ${Cc(d.c)} : attention aux signes.`,
      };
    let v = e.aux.get('\u0394');
    return v
      ? c < v.debt
        ? {
            kind: 'step',
            atoms: r,
            line: t,
            hora: 1,
            rule: {
              id: Me.compute,
              card: 'Calcul',
              label: 'Calculer',
              hora: 1,
              why: 'On calcule \u0394.',
            },
            kern: f(!1, { name: s, value: l, debt: c }),
          }
        : {
            kind: 'dup',
            atoms: r,
            line: t,
            title: 'D\xE9j\xE0 calcul\xE9',
            message: 'Tu as d\xE9j\xE0 \u0394.',
          }
      : {
          kind: 'step',
          atoms: r,
          line: t,
          hora: 2,
          rule: {
            id: Un.discriminant,
            card: Vd,
            label: 'Calculer le discriminant',
            hora: 2,
            why: '\u0394 = b\xB2 \u2212 4ac : son signe dit combien de racines a le trin\xF4me.',
          },
          kern: f(!1, { name: s, value: l, debt: c }),
        };
  }
  let m = s === `${e.x}\u2080`,
    p = a.filter((b) => DL(b.t, l));
  if (!p.length)
    return {
      kind: 'false',
      atoms: r,
      line: t,
      title: 'Ce n\u2019est pas une racine',
      message: m
        ? 'La racine double : x\u2080 = \u2212b \xF7 (2a).'
        : `x\u2081 = (\u2212b \u2212 \u221A\u0394) \xF7 (2a) et x\u2082 = (\u2212b + \u221A\u0394) \xF7 (2a) : v\xE9rifie les signes (b = ${Cc(d.b)}).`,
    };
  if (m && !p.some((b) => L(b.t.disc)))
    return o(
      'Pas de racine double',
      'x\u2080 d\xE9signe la racine double, quand \u0394 = 0 : ici, \xE9cris x\u2081 et x\u2082.',
    );
  let g =
    s === `${e.x}\u2081`
      ? e.aux.get(`${e.x}\u2082`)
      : s === `${e.x}\u2082`
        ? e.aux.get(`${e.x}\u2081`)
        : null;
  if (g && dg(g.value, l) && p.some((b) => te(b.t.disc) > 0))
    return {
      kind: 'useless',
      atoms: r,
      line: t,
      title: `C\u2019est la m\xEAme racine que ${g.name}`,
      message: 'Les deux racines diff\xE8rent par le signe devant \u221A\u0394.',
    };
  let h = e.aux.get(s);
  return h
    ? dg(h.value, l) && c < h.debt
      ? {
          kind: 'step',
          atoms: r,
          line: t,
          hora: 1,
          rule: {
            id: Me.compute,
            card: 'Calcul',
            label: 'Calculer',
            hora: 1,
            why: `On calcule ${s}.`,
          },
          kern: f(!1, { name: s, value: l, debt: c }),
        }
      : {
          kind: 'dup',
          atoms: r,
          line: t,
          title: 'D\xE9j\xE0 \xE9crit',
          message: `Tu as d\xE9j\xE0 ${s}.`,
        }
    : {
        kind: 'step',
        atoms: r,
        line: t,
        hora: 2,
        rule: {
          id: Un.root,
          card: Vd,
          label: m ? 'Racine double' : 'Racine du trin\xF4me',
          hora: 2,
          why: m
            ? '\u0394 = 0 : une racine double, x\u2080 = \u2212b \xF7 (2a).'
            : '\u0394 > 0 : x\u2081 = (\u2212b \u2212 \u221A\u0394) \xF7 (2a) et x\u2082 = (\u2212b + \u221A\u0394) \xF7 (2a).',
        },
        kern: f(!1, { name: s, value: l, debt: c }),
      };
}
function a5(e, n) {
  e.aux.set(n.name, n);
}
var zv = 'Syst\xE8mes';
function l5(e, n, t, r) {
  let s = `sys:${r}:${Ii(n)}\u2192${Ii(t)}`,
    i = e.cache.get(s);
  if (i) return i;
  let o = Ss(n, t, {
    rules: e.rules,
    hypotheses: e.hyps,
    goal: { kind: 'solve', target: r },
    deadline: Date.now() + 250,
    branches: !0,
  });
  return (e.cache.set(s, o), o);
}
var Kr = (e) => `\xAB ${e.text} \xBB`;
function GL(e, n, t, r) {
  let s = r.some((i) => Hv(Ir(t, i, !0), Ir(n, i, !0)));
  for (let i of r) {
    let o = l5(e, n, t, i);
    if (o.status !== 'valid' || (o.relation !== 'equivalent' && o.relation !== 'identity'))
      continue;
    if (o.proof === 'rule' && o.ruleId && ek(o))
      return { info: null, several: o.explanation?.params?.v_c ?? '', useful: s };
    let a = Ir(n, i, !0),
      l = Ir(t, i, !0),
      u = (l.NK !== null && l.NK === a.NK) || Jv(n, t, i),
      c = null;
    if (
      (o.proof === 'rule' && o.ruleId?.startsWith('algebra.') && u
        ? (c = fg(a, l, n, t) ?? aa(o, t, n))
        : o.proof === 'rule' && o.ruleId
          ? (c = aa(o, t, n))
          : u && (c = fg(a, l, n, t)),
      c)
    )
      return { info: c, several: null, useful: s };
  }
  return { info: null, several: null, useful: s };
}
function ZL(e, n, t) {
  let r = { origin: t };
  if (n.k !== 'rel' || n.rel !== '=') return r;
  if (n.l.k === 'sym' && jn(n.r)) {
    let i = R(n.r);
    i.k === 'num' && Pr(n.r) === 0 && (r.value = { u: n.l.n, v: i.v });
  }
  let s = xc(n);
  return (s && Yp(s) && jn(n.l) && jn(n.r) && Pr(n.l) + Pr(n.r) === 0 && (r.contradiction = !0), r);
}
function ML(e, n, t) {
  let r = te(e) < 0,
    s = mn(e),
    i = M(s, q) ? '' : `${pe(en(s))} \xD7 `;
  return `${r ? (t ? '\u2212' : ' \u2212 ') : t ? '' : ' + '}${i}${Kr(n)}`;
}
function u5(e, n, t, r, s, i, o) {
  let a = Hq(t),
    l = ZL(e, r.s, a);
  t.kind === 'redundant' && (l.redundancy = Nv(t.a.origin, t.b.origin));
  let u = { s: r.s, trusted: !0, sys: l },
    c = eg(r.s, r.K, a, Ke(s)),
    f = () => !!c && Z0(n, c, l),
    d = [...Nd(o)].sort(),
    m = (p) => {
      let g = n.outcome === 'infinite' && t.kind !== 'redundant' && c ? Ov(n, c) : null,
        h = g
          ? {
              ...p,
              hora: Math.max(2, p.hora),
              why: `${p.why} On retrouve ${Kr(g.other)} : les deux \xE9quations disent la m\xEAme chose, le syst\xE8me a une \xE9quation de trop.`,
            }
          : p;
      return { kind: 'step', atoms: i, line: s, hora: h.hora, final: f(), rule: h, kern: u };
    };
  switch (t.kind) {
    case 'transform': {
      let p = d.length ? d : [...Nd(t.from.f)].sort(),
        g = GL(e, t.from.s, r.s, p.length ? p : [e.x]),
        h = n.outcome === 'infinite' && !!c && !!Ov(n, c),
        b = { ...g, useful: g.useful || h || Wq(n, t.from, o) };
      return b.several !== null
        ? {
            kind: 'unjustified',
            atoms: i,
            line: s,
            title: 'Une op\xE9ration \xE0 la fois',
            message: `Ta ligne est juste, mais elle ajoute ${io(b.several)} d\u2019un coup : d\xE9place un terme \xE0 la fois, puis calcule.`,
          }
        : b.info
          ? !b.useful && !l.value && !l.contradiction && !f()
            ? {
                kind: 'useless',
                atoms: i,
                line: s,
                title: 'Juste, mais \xE7a ne t\u2019avance pas',
                message:
                  'Ta ligne est juste, mais elle ne rapproche d\u2019aucune inconnue seule. Garde-la si elle t\u2019aide, ou isole une inconnue pour la remplacer, ou combine deux lignes.',
                kern: u,
              }
            : m(b.info)
          : {
              kind: 'unjustified',
              atoms: i,
              line: s,
              title: 'Juste, mais trop d\u2019un coup',
              message:
                'Ta ligne est juste, mais elle fait plusieurs op\xE9rations \xE0 la fois sur ' +
                Kr(t.from) +
                ' : une seule par ligne (une op\xE9ration des deux c\xF4t\xE9s, puis le calcul).',
            };
    }
    case 'substitute': {
      let { u: p, e: g } = t.sub.isolated;
      if (!t.literal)
        return {
          kind: 'unjustified',
          atoms: i,
          line: s,
          title: 'Une op\xE9ration \xE0 la fois',
          message: `Ta ligne est juste, mais elle remplace ${p} ET calcule d\u2019un coup : \xE9cris d\u2019abord ${Kr(t.into)} avec ${p} remplac\xE9, puis calcule.`,
        };
      let h = Nd(t.into.f).size;
      if (d.length >= h)
        return {
          kind: 'useless',
          atoms: i,
          line: s,
          title: 'Juste, mais \xE7a ne t\u2019avance pas',
          message:
            'Ta ligne est juste, mais elle a toujours autant d\u2019inconnues : remplace une inconnue par une \xE9criture qui ne la contient pas.',
          kern: u,
        };
      let b = jn(g);
      return m({
        id: Me.substitute,
        card: zv,
        label: b ? 'Remplacer par sa valeur' : 'Remplacer',
        hora: 2,
        why: b
          ? `${p} est connu (${Kr(t.sub)}) : on remplace ${p} par sa valeur dans ${Kr(t.into)}.`
          : `${Kr(t.sub)} isole ${p} : on remplace ${p} dans ${Kr(t.into)}, il reste une inconnue de moins.`,
      });
    }
    case 'combine': {
      if (!t.integer)
        return {
          kind: 'unjustified',
          atoms: i,
          line: s,
          title: 'Juste, mais trop d\u2019un coup',
          message:
            'Ta ligne est juste, mais elle combine deux lignes ET divise d\u2019un coup : \xE9cris d\u2019abord la combinaison avec des nombres entiers, puis simplifie.',
        };
      if (!t.eliminated.length)
        return {
          kind: 'useless',
          atoms: i,
          line: s,
          title: 'Juste, mais \xE7a ne t\u2019avance pas',
          message:
            'Ta ligne est juste, mais aucune inconnue n\u2019a disparu : choisis les multiples des deux lignes pour qu\u2019une inconnue s\u2019\xE9limine.',
          kern: u,
        };
      let [p, g] =
          te(t.lambdas[0]) < 0 && te(t.lambdas[1]) > 0
            ? [
                [t.lambdas[1], t.b],
                [t.lambdas[0], t.a],
              ]
            : [
                [t.lambdas[0], t.a],
                [t.lambdas[1], t.b],
              ],
        h = ML(p[0], p[1], !0) + ML(g[0], g[1], !1),
        b = t.eliminated.join(' et ');
      return m({
        id: Me.combine,
        card: zv,
        label: 'Combiner deux lignes',
        hora: 2,
        why: l.contradiction
          ? `${h} : les inconnues disparaissent et il reste une \xE9galit\xE9 fausse. Le syst\xE8me n\u2019a aucune solution.`
          : `${h} : ${b} dispara\xEE${t.eliminated.length > 1 ? 'ssent' : 't'}.`,
      });
    }
    case 'redundant':
      return m({
        id: Me.redundant,
        card: zv,
        label: 'Deux \xE9quations \xE9quivalentes',
        hora: 2,
        why: `${Kr(t.a)} et ${Kr(t.b)} disent la m\xEAme chose : l\u2019une est un multiple de l\u2019autre, le syst\xE8me a une \xE9quation de trop.`,
      });
  }
}
function c5(e, n, t, r) {
  let s = qu(t);
  if (!s.ok || s.s.k !== 'rel' || s.s.rel !== '=')
    return {
      kind: 'unjustified',
      atoms: r,
      line: t,
      title: 'Une \xE9quation par ligne',
      message:
        'Dans un syst\xE8me, chaque ligne est une \xE9quation (avec \xAB = \xBB), une seule par ligne.',
    };
  let i = Ir(s.s, e.x, !0),
    o = e.traps.find((m) => m.K === i.K);
  if (o)
    return {
      kind: 'trap',
      atoms: r,
      line: t,
      title: 'Pi\xE8ge : ' + Wv(o.title),
      message: o.why,
      trap: { line: o.line, title: o.title, why: o.why },
      badChip: -1,
    };
  let a = xc(i.s),
    l = n.equations.findIndex((m) => m.K === i.K);
  if (l >= 0) {
    let m = 1 << l,
      p = a && n.outcome === 'infinite' ? yc(n).find((g) => g.origin !== m && na(g.f, a)) : void 0;
    if (p && !e.lines.some((g) => g.raw === i.raw)) {
      let g = GL(e, p.s, i.s, [...Nd(a)].sort());
      if (g.info) {
        let h = p.origin,
          b = ZL(e, i.s, h),
          v = eg(i.s, i.K, h, Ke(t));
        return {
          kind: 'step',
          atoms: r,
          line: t,
          hora: 2,
          final: !!v && Z0(n, v, b),
          rule: {
            id: Me.redundant,
            card: zv,
            label: 'Deux \xE9quations \xE9quivalentes',
            hora: 2,
            why: `${g.info.label} : ${Kr(p)} redonne ${Kr(n.equations[l])}, une \xE9quation de l\u2019\xE9nonc\xE9. Les deux disent la m\xEAme chose : le syst\xE8me a une \xE9quation de trop.`,
          },
          kern: { s: i.s, trusted: !0, sys: b },
        };
      }
    }
    return {
      kind: 'given',
      atoms: r,
      line: t,
      title: 'C\u2019est l\u2019\xE9nonc\xE9',
      message:
        'Cette \xE9quation est d\xE9j\xE0 en t\xEAte de ta feuille : transforme-la, ou combine-la avec une autre.',
    };
  }
  let u = !!a && is(a) && z0(n, i.s, a, i.K, la).length > 0;
  if (e.lines.some((m) => m.raw === i.raw) && !u)
    return {
      kind: 'dup',
      atoms: r,
      line: t,
      title: 'D\xE9j\xE0 \xE9crit',
      message: 'Tu as d\xE9j\xE0 cette ligne sur ta feuille.',
    };
  if (!a)
    return {
      kind: 'useless',
      atoms: r,
      line: t,
      unknown: !0,
      title: 'Je ne sais pas encore v\xE9rifier ce passage',
      message:
        'Dans ce syst\xE8me, les \xE9quations sont du premier degr\xE9 : une ligne avec un produit d\u2019inconnues ou une inconnue au d\xE9nominateur ne peut pas en d\xE9couler. Garde-la sans HORA, ou \xE9cris le passage autrement.',
      kern: { s: i.s, trusted: !1, ...(i.auxWritten ? { auxWritten: !0 } : {}) },
    };
  if (!Lv(n, a)) {
    let m = Gq(n, a);
    if (m)
      return {
        kind: 'false',
        atoms: r,
        line: t,
        title: 'Le nombre de l\u2019autre c\xF4t\xE9 ne suit pas',
        message:
          m.kind === 'combine'
            ? 'Les inconnues sont justes, mais pas le nombre de l\u2019autre c\xF4t\xE9 : quand tu combines deux lignes, fais la m\xEAme op\xE9ration sur les seconds membres.'
            : `Les inconnues sont justes, mais pas le nombre de l\u2019autre c\xF4t\xE9 : reprends ${Kr(m.lines[0])} et fais la m\xEAme op\xE9ration sur les deux membres.`,
      };
    let p = Zq(n, a);
    return {
      kind: 'false',
      atoms: r,
      line: t,
      title: p
        ? `Cette ligne ne d\xE9coule pas de ${Kr(p)}`
        : 'Cette ligne ne d\xE9coule pas des \xE9quations',
      message: p
        ? 'Elle n\u2019a pas les m\xEAmes solutions : v\xE9rifie les signes, et fais la m\xEAme op\xE9ration des deux c\xF4t\xE9s.'
        : 'Elle n\u2019est pas vraie pour les solutions du syst\xE8me : reprends ton dernier passage (signes, remplacement, seconds membres).',
    };
  }
  let c = z0(n, i.s, a, i.K, la),
    f = null,
    d = null;
  for (let m of c) {
    let p = u5(e, n, m, i, t, r, a);
    if (((f ??= p), p.kind !== 'step')) continue;
    let g =
        m.kind === 'transform'
          ? f5(m.from.f, a)
            ? 1
            : 15
          : m.kind === 'combine'
            ? Math.min(9, Math.max(...m.lambdas.map((b) => Math.abs(en(b)))))
            : 1,
      h = (p.final ? 0 : 100) + g;
    (!d || h < d.rank) && (d = { v: p, rank: h });
  }
  return d
    ? d.v
    : f ||
        (is(a)
          ? {
              kind: 'useless',
              atoms: r,
              line: t,
              title: 'Toujours vrai',
              message:
                'Ta ligne est toujours vraie : elle ne dit rien sur les inconnues. Elle sert seulement quand elle vient de deux \xE9quations qui disent la m\xEAme chose.',
            }
          : {
              kind: 'unjustified',
              atoms: r,
              line: t,
              title: 'Juste, mais trop d\u2019un coup',
              message:
                'Ta ligne est juste, mais elle fait plusieurs gestes \xE0 la fois. Un seul par ligne : isoler une inconnue, la remplacer dans une autre \xE9quation, combiner deux lignes, ou calculer.',
            });
}
function f5(e, n) {
  return e.coef.size !== n.coef.size
    ? !1
    : [...e.coef].every(([t, r]) => {
        let s = n.coef.get(t);
        return !!s && M(mn(s), mn(r));
      });
}
function d5(e, n, t) {
  if (!t.kern) return;
  let r = Ir(t.kern.s, e.x, t.kern.trusted);
  e.lines.push(r);
  let s = t.kern.sys;
  if (!t.kern.trusted || !s) return;
  let i = eg(t.kern.s, r.K, s.origin, t.line ? Ke(t.line) : _t(t.kern.s));
  (i && U0(n, i, s), G0(n) && (e.reached = !0));
}
function m5(e, n) {
  let t = ie(n);
  if (!t.ok || t.s.k !== 'rel' || t.s.rel !== '=') return !1;
  let r = xc(t.s);
  return r ? (e.outcome === 'none' ? Yp(r) && Lv(e, r) : !is(r) && Lv(e, r)) : !1;
}
function HL(e, n) {
  if (n.table !== void 0) {
    e.tables.includes(n.table) || e.tables.push(n.table);
    return;
  }
  if (e.sys) return d5(e, e.sys, n);
  if (n.test) {
    e.tests.set(n.test.k, n.test.holds);
    return;
  }
  if (n.cond !== void 0) {
    let r = e.conds[n.cond];
    r && !r.ok && ((r.ok = !0), e.condsOk.push(r.cond));
    return;
  }
  if (n.round !== void 0) {
    ((e.rounded = n.round), (e.reached = !0));
    return;
  }
  if (!n.kern) return;
  let t = ql(e, n.kern.s, n.kern.trusted, !!n.kern.auxWritten);
  (n.kern.auxLine && (t.aux = !0),
    n.kern.condDep && (t.condDep = !0),
    e.lines.push(t),
    n.kern.aux && a5(e, n.kern.aux),
    !t.condDep &&
      (t.trusted && (n.kind === 'step' || n.kind === 'ready') && n.final && (e.reached = !0),
      t.trusted && so(t, e.x, e.trig) && (e.reached = !0)));
}
function WL(e) {
  return e.reached && !Rc(e);
}
function JL(e, n, t = !1) {
  if (e.sys) return m5(e.sys, n);
  let r = LL(e, p5(n));
  if (r) {
    let l = FL(e);
    return !!l && r.l.k === 'sym' && r.l.n === e.x && VL(e, l, r.r);
  }
  let s = ie(n);
  if (!s.ok) return !1;
  let i = ql(e, NL(e, s.s), !0, OL(e, s.s));
  if (t && e.form && !i.answerForm) return !1;
  let o = ql(e, e.answer, !0);
  if (i.K === o.K) return !0;
  let a = (l) => l.status === 'valid' && (l.relation === 'equivalent' || l.relation === 'identity');
  return a(Ll(e, o, i.s, i.raw, !0)) ? !0 : a(Ll(e, i, o.s, o.raw, !0));
}
function XL(e) {
  if (e.sys) {
    let t = e.sys.values.get(e.x);
    return t ? [en(t)] : [];
  }
  let n = [];
  return (
    e.lines.forEach((t) => {
      if (
        (e.poly &&
          t.trusted &&
          t.s.k === 'or' &&
          t.s.items.forEach((i) => {
            let o = i.rel === '=' && i.l.k === 'sym' && i.l.n === e.x ? R(i.r) : null;
            o && o.k === 'num' && n.push(Number(o.v.n) / Number(o.v.d));
          }),
        !t.trusted || t.s.k !== 'rel' || t.s.rel !== '=')
      )
        return;
      let r = t.s.l.k === 'sym' && t.s.l.n === e.x ? t.s.r : null,
        s = r ? R(r) : null;
      s && s.k === 'num' && n.push(Number(s.v.n) / Number(s.v.d));
    }),
    n
  );
}
function p5(e) {
  if (!e.includes('\u2248')) return null;
  try {
    return qv(Ve(e));
  } catch {
    return null;
  }
}
var g5 = { ms: 400, nodes: 4e3, depth: 10, branches: 0 };
function h5(e, n) {
  let t = Sq(_t(n), {
    rules: e.rules,
    goal: e.goal,
    hypotheses: e.condsOk.length ? [...e.hyps, ...e.condsOk] : e.hyps,
    budget: g5,
  });
  return t.status === 'found' ? t.steps.map((r) => r.to) : null;
}
function b5(e) {
  return (e.ref || (e.ref = e.spec.path ?? (e.sys ? null : h5(e, e.start.s)) ?? []), e.ref);
}
function o1(e) {
  return bi(e) ? [e] : ne(zr(Ve(e)));
}
function v5(e) {
  if (!e.poly || e.sys || e.hyps.length) return null;
  let n = [e.start, ...e.lines.filter((t) => t.trusted && !t.aux)].reverse();
  for (let t of n) {
    if (t.s.k !== 'rel' || t.s.rel === '=') continue;
    let r = li(t.s.l),
      s = li(t.s.r);
    if (r === s) continue;
    let i = s ? t.s.l : t.s.r,
      o = Qv(i, e.x);
    if (!o) continue;
    let a;
    try {
      a = Ve(_t(t.s));
    } catch {
      continue;
    }
    return { line: a, key: t.K, side: i, exp: o };
  }
  return null;
}
function k5(e, n) {
  let t = [n],
    r = jv(n);
  if (!r)
    return {
      kind: 'syntax',
      atoms: t,
      title: 'Tableau illisible',
      message: 'Je ne lis pas ce tableau : ouvre-le de nouveau depuis la palette.',
      badChip: 0,
    };
  if (r.f)
    return {
      kind: 'false',
      atoms: t,
      title: 'Un tableau de signes',
      message:
        'Ici, on \xE9tudie un signe : le tableau n\u2019a pas de ligne de fl\xE8ches. Ouvre-le de nouveau depuis la palette.',
      badChip: 0,
    };
  let s = v5(e);
  if (!s)
    return {
      kind: 'unjustified',
      atoms: t,
      title: 'Factorise d\u2019abord',
      message: e.poly
        ? 'Le tableau de signes se dresse sur une ligne compar\xE9e \xE0 0 dont chaque facteur a un signe connu : tout d\u2019un c\xF4t\xE9, puis factorise (ou mets au m\xEAme d\xE9nominateur).'
        : 'Ici, pas de tableau de signes : continue avec des lignes.',
    };
  if (e.tables.includes(s.key))
    return {
      kind: 'dup',
      atoms: t,
      title: 'D\xE9j\xE0 dress\xE9',
      message: 'Le tableau de cette ligne est d\xE9j\xE0 sur ta feuille : lis-le pour conclure.',
    };
  let i = Fv(s.exp, r);
  return i
    ? {
        kind: 'false',
        atoms: t,
        title: i.title,
        message: i.message,
        badChip: 0,
        ...(i.row !== void 0
          ? { cell: { row: i.row, ...(i.col !== void 0 ? { col: i.col } : {}) } }
          : {}),
      }
    : {
        kind: 'step',
        atoms: t,
        hora: 2,
        rule: {
          id: Un.signTableFill,
          card: 'In\xE9quations',
          label: 'Tableau de signes',
          hora: 2,
          why: 'Chaque facteur change de signe en sa racine ; la r\xE8gle des signes donne le signe de l\u2019expression sur chaque intervalle. Une valeur qui annule le d\xE9nominateur est interdite (\u2016).',
        },
        table: s.key,
      };
}
var mt = class extends Error {},
  pg = [
    '//',
    '\u2226',
    '\u22A5',
    '\u2208',
    'milieu de',
    'm\xE9diatrice de',
    'cercle de diam\xE8tre',
    'sym\xE9trique de',
    'par rapport \xE0',
    'parall\xE9logramme',
    'rectangle',
    'losange',
    'carr\xE9',
    'rectangle en',
    'isoc\xE8le en',
    'n\u2019est pas rectangle',
  ],
  x5 = {
    para: 'parall\xE9logramme',
    rectangle: 'rectangle',
    losange: 'losange',
    carre: 'carr\xE9',
  },
  y5 = { parallélogramme: 'para', rectangle: 'rectangle', losange: 'losange', carré: 'carre' };
function Kl(e) {
  return e
    .replace(/[\u2009\u202f\u00a0]/g, ' ')
    .replace(/∥/g, '//')
    .replace(/'/g, '\u2019')
    .replace(/\s*(\/\/|∦|⊥|∈)\s*/g, ' $1 ')
    .replace(/\s+/g, ' ')
    .trim();
}
var w5 = /\??[A-Z][0-9]*/g;
function Bd(e, n) {
  let t = e.match(w5) ?? [];
  return t.join('') !== e ||
    !t.length ||
    t.some((r) => (n ? !r.startsWith('?') && r.length > 1 : r.length !== 1)) ||
    (!n && t.some((r) => r.startsWith('?')))
    ? null
    : t;
}
function Ol(e, n) {
  let t = Bd(e, n);
  if (!t || t.length !== 1)
    throw new mt('Un point s\u2019\xE9crit avec une lettre majuscule : A, B, M\u2026');
  return t[0];
}
var nk = (e) => new Set(e).size === e.length;
function kw(e, n) {
  let t = /^\((.+)\)$/.exec(e);
  if (!t) throw new mt('Une droite s\u2019\xE9crit entre parenth\xE8ses : (AB) ou (d\u2081).');
  let r = t[1],
    s = Bd(r, n);
  if (s && s.length === 2) {
    if (s[0] === s[1]) throw new mt('Une droite passe par deux points diff\xE9rents.');
    return { k: 'pts', a: s[0], b: s[1] };
  }
  if ((n ? /^(\?[a-z][0-9]*|[a-zΔ][₀-₉]*)$/ : /^[a-zΔ][₀-₉]*$/).test(r)) return { k: 'name', n: r };
  throw new mt('Une droite s\u2019\xE9crit entre parenth\xE8ses : (AB) ou (d\u2081).');
}
function tk(e, n) {
  let t = /^\[(.+)\]$/.exec(e),
    r = t ? Bd(t[1], n) : null;
  if (!r || r.length !== 2) throw new mt('Un segment s\u2019\xE9crit entre crochets : [AB].');
  if (r[0] === r[1]) throw new mt('Un segment a deux extr\xE9mit\xE9s diff\xE9rentes.');
  return [r[0], r[1]];
}
function mg(e, n) {
  if (n.includes(e))
    throw new mt('Le point doit \xEAtre diff\xE9rent des extr\xE9mit\xE9s du segment.');
}
function Pl(e) {
  let n = Kl(e);
  return (
    /(^|\s)(\/\/|∦|⊥|∈)(\s|$)/.test(n) ||
    /[[\]]/.test(n) ||
    /\((?:[A-Z?][A-Z0-9?]*|[a-zΔ?][₀-₉0-9a-z]*)\)/.test(n) ||
    /(milieu|symétrique|parallélogramme|rectangle|losange|carré|isocèle|médiatrice|cercle)/.test(n)
  );
}
function zd(e, n = !1) {
  let t = Kl(e),
    r = /^(\S+) (\/\/|∦|⊥) (\S+)$/.exec(t);
  if (r) {
    let s = kw(r[1], n),
      i = kw(r[3], n);
    if (vi(s) === vi(i) || vi(s) === vi(S5(i)))
      throw new mt('Il faut deux droites diff\xE9rentes.');
    return { k: r[2] === '//' ? 'par' : r[2] === '\u2226' ? 'npar' : 'perp', a: s, b: i };
  }
  if (((r = /^(\S+) (?:est (?:le )?)?milieu (?:de|du segment) (\S+)$/.exec(t)), r)) {
    let s = Ol(r[1], n),
      [i, o] = tk(r[2], n);
    return (mg(s, [i, o]), { k: 'mid', p: s, a: i, b: o });
  }
  if (((r = /^(\S+) ∈ (?:la )?médiatrice (?:de|du segment) (\S+)$/.exec(t)), r)) {
    let s = Ol(r[1], n),
      [i, o] = tk(r[2], n);
    return (mg(s, [i, o]), { k: 'bis', p: s, a: i, b: o });
  }
  if (((r = /^(\S+) ∈ (?:le )?cercle de diamètre (\S+)$/.exec(t)), r)) {
    let s = Ol(r[1], n),
      [i, o] = tk(r[2], n);
    return (mg(s, [i, o]), { k: 'circ', p: s, a: i, b: o });
  }
  if (((r = /^(\S+) ∈ (\S+)$/.exec(t)), r)) {
    let s = Ol(r[1], n);
    if (r[2].startsWith('[')) {
      let [o, a] = tk(r[2], n);
      return (mg(s, [o, a]), { k: 'onseg', p: s, a: o, b: a });
    }
    let i = kw(r[2], n);
    return (i.k === 'pts' && mg(s, [i.a, i.b]), { k: 'online', p: s, l: i });
  }
  if (((r = /^(\S+) (?:est )?(?:le )?symétrique de (\S+) par rapport à (\S+)$/.exec(t)), r)) {
    let s = Ol(r[1], n),
      i = Ol(r[2], n),
      o = Ol(r[3], n);
    if (!nk([s, i, o])) throw new mt('Il faut trois points diff\xE9rents.');
    return { k: 'mid', p: o, a: i, b: s };
  }
  if (((r = /^(\S+) (?:est )?(?:un triangle )?(rectangle|isocèle) en (\S+)$/.exec(t)), r)) {
    let s = Bd(r[1], n),
      i = Ol(r[3], n);
    if (!s || s.length !== 3 || !nk(s))
      throw new mt('Un triangle s\u2019\xE9crit avec trois points : ABC.');
    if (!s.includes(i))
      throw new mt(`Le sommet ${i} doit \xEAtre un sommet du triangle ${s.join('')}.`);
    let [o, a] = s.filter((l) => l !== i);
    return { k: r[2] === 'rectangle' ? 'rt' : 'iso', at: i, b: o, c: a };
  }
  if (((r = /^(\S+) n’est pas (?:un triangle )?rectangle$/.exec(t)), r)) {
    let s = Bd(r[1], n);
    if (!s || s.length !== 3 || !nk(s))
      throw new mt('Un triangle s\u2019\xE9crit avec trois points : ABC.');
    return { k: 'nrt', v: s };
  }
  if (((r = /^(\S+) (?:est (?:un )?)?(parallélogramme|rectangle|losange|carré)$/.exec(t)), r)) {
    let s = Bd(r[1], n);
    if (!s || s.length !== 4 || !nk(s))
      throw new mt(
        'Un quadrilat\xE8re s\u2019\xE9crit avec ses quatre sommets dans l\u2019ordre : ABCD.',
      );
    return { k: y5[r[2]], v: s };
  }
  throw new mt(
    '\xC9cris une seule propri\xE9t\xE9 : \xAB (MN) // (BC) \xBB, \xAB I milieu de [AB] \xBB, \xAB ABCD parall\xE9logramme \xBB, \xAB ABC rectangle en A \xBB\u2026',
  );
}
function S5(e) {
  return e.k === 'pts' ? { k: 'pts', a: e.b, b: e.a } : e;
}
function vi(e) {
  return e.k === 'pts' ? `(${e.a}${e.b})` : `(${e.n})`;
}
function rk(e) {
  switch (e.k) {
    case 'par':
      return `${vi(e.a)} // ${vi(e.b)}`;
    case 'npar':
      return `${vi(e.a)} \u2226 ${vi(e.b)}`;
    case 'perp':
      return `${vi(e.a)} \u22A5 ${vi(e.b)}`;
    case 'mid':
      return `${e.p} milieu de [${e.a}${e.b}]`;
    case 'onseg':
      return `${e.p} \u2208 [${e.a}${e.b}]`;
    case 'bis':
      return `${e.p} \u2208 m\xE9diatrice de [${e.a}${e.b}]`;
    case 'circ':
      return `${e.p} \u2208 cercle de diam\xE8tre [${e.a}${e.b}]`;
    case 'online':
      return `${e.p} \u2208 ${vi(e.l)}`;
    case 'para':
    case 'rectangle':
    case 'losange':
    case 'carre':
      return `${e.v.join('')} ${x5[e.k]}`;
    case 'rt':
      return `${e.at}${e.b}${e.c} rectangle en ${e.at}`;
    case 'iso':
      return `${e.at}${e.b}${e.c} isoc\xE8le en ${e.at}`;
    case 'nrt':
      return `${e.v.join('')} n\u2019est pas rectangle`;
  }
}
function gg(e) {
  let n = (t) => (t.k === 'pts' ? [t.a, t.b] : []);
  switch (e.k) {
    case 'par':
    case 'npar':
    case 'perp':
      return [...n(e.a), ...n(e.b)];
    case 'mid':
    case 'onseg':
    case 'bis':
    case 'circ':
      return [e.p, e.a, e.b];
    case 'online':
      return [e.p, ...n(e.l)];
    case 'rt':
    case 'iso':
      return [e.at, e.b, e.c];
    default:
      return [...e.v];
  }
}
function YL(e) {
  let n = (t) => (t.k === 'name' ? [t.n] : []);
  return e.k === 'par' || e.k === 'npar' || e.k === 'perp'
    ? [...n(e.a), ...n(e.b)]
    : e.k === 'online'
      ? n(e.l)
      : [];
}
function eN(e) {
  let n = [];
  for (let t = 0; t < e.length; t++) {
    let r = [...e.slice(t), ...e.slice(0, t)];
    n.push(r.join(''), [...r].reverse().join(''));
  }
  return n.sort()[0];
}
var T5 = [...pg].sort((e, n) => n.length - e.length);
function xw(e) {
  let n = Kl(e)
      .replace(/ est (?:le |la |un )?/g, ' ')
      .replace(/ ∈ (?:la |le )/g, ' \u2208 ')
      .replace(/ n’est pas (?:un triangle )?rectangle$/, ' n\u2019est pas rectangle')
      .replace(/ un triangle /g, ' ')
      .replace(/ du segment /g, ' de '),
    t = [];
  for (; n.length; ) {
    n = n.trimStart();
    let r = T5.find((i) => n.startsWith(i) && (n.length === i.length || n[i.length] === ' '));
    if (r) {
      (t.push(r), (n = n.slice(r.length)));
      continue;
    }
    let s = /^\S+/.exec(n)[0];
    (t.push(s), (n = n.slice(s.length)));
  }
  return t;
}
function rN(e, n) {
  let t = /^([A-Z])([A-Z])$/.exec(e);
  return !t || t[1] === t[2] || !n.has(t[1]) || !n.has(t[2])
    ? null
    : t[1] < t[2]
      ? t[1] + t[2]
      : t[2] + t[1];
}
function Mc(e, n) {
  let t = e.split(/\s*(=|≠)\s*/);
  if (t.length < 3)
    return {
      ok: !1,
      why: '\xC9cris une \xE9galit\xE9 (\xAB = \xBB) ou une diff\xE9rence (\xAB \u2260 \xBB) entre longueurs.',
    };
  let r = [],
    s = [];
  for (let o = 0; o < t.length; o += 2) {
    let a = t[o].trim();
    if (!a) return { ok: !1, why: 'Il manque un membre de part et d\u2019autre du signe.' };
    let l = ie(a);
    if (!l.ok || l.s.k !== 'expr')
      return {
        ok: !1,
        why: 'Une seule relation \xE0 la fois, avec \xAB = \xBB ou \xAB \u2260 \xBB.',
      };
    let u = {};
    for (let c of $(l.s.e)) {
      let f = rN(c, n);
      if (!f) return { ok: !1, why: `\xAB ${c} \xBB n\u2019est pas une longueur de la figure.` };
      f !== c && (u[c] = rn(f));
    }
    (r.push(Object.keys(u).length ? j(l.s.e, u) : l.s.e), o + 1 < t.length && s.push(t[o + 1]));
  }
  let i = s.map((o, a) => ({ op: o, l: r[a], r: r[a + 1] }));
  return { ok: !0, m: { members: r, ops: s, rels: i } };
}
function Gd(e) {
  return new Set([...$(e.l), ...$(e.r)]);
}
function sk(e) {
  let n = Z(ve(e.l, e.r));
  return n.ok ? n.rf : null;
}
var nN = (e) => Lt(e).size === 0;
function Ud(e) {
  let n = 0;
  for (let { m: t, c: r } of Xs(e)) {
    if (t.some((i) => i.a.kind === 'opaque')) return !1;
    let s = te(r);
    if (s !== 0) {
      if (n && s !== n) return !1;
      n = s;
    }
  }
  return n !== 0;
}
function Zd(e) {
  let n = sk(e);
  if (!n || !nN(n.n) || !nN(n.d)) return null;
  let t = Ue(n.n);
  return e.op === '=' ? t : !t;
}
function Ar(e, n) {
  if (e.op !== n.op) return !1;
  let t = sk(e),
    r = sk(n);
  if (!t || !r) return !1;
  let s = Ue(t.n),
    i = Ue(r.n);
  if (s || i) return s === i;
  if (Ud(t.d) && Ud(r.d)) {
    let a = Tr(t.n, r.n);
    if (a && Ud(a)) return !0;
    let l = Tr(r.n, t.n);
    if (l && Ud(l)) return !0;
  }
  let o;
  try {
    o = $e(Hr(t, r));
  } catch {
    return !1;
  }
  return Ud(o.n) && Ud(o.d);
}
function lo(e, n) {
  if (!n.size) return e;
  let t = Object.fromEntries(n);
  return { op: e.op, l: j(e.l, t), r: j(e.r, t) };
}
function ww(e) {
  let n = new Map();
  for (let t = 0; t < 12; t++) {
    let r = !1;
    for (let s of e) {
      if (s.op !== '=') continue;
      let i = lo(s, n),
        o = Gd(i);
      if (o.size !== 1) continue;
      let a = [...o][0];
      if (n.has(a)) continue;
      let l = sk(i);
      if (!l) continue;
      let u = Bt(l, a);
      if (!u) continue;
      let c = u.roots.filter((f) => D(f, {}) > 1e-12);
      c.length === 1 && (n.set(a, R(Je($e(R5(c[0]))))), (r = !0));
    }
    if (!r) break;
  }
  return n;
}
function R5(e) {
  let n = Z(e);
  if (!n.ok) throw new Error('valeur illisible');
  return n.rf;
}
function _c(e, n) {
  let t = j(e, Object.fromEntries(n));
  if ($(t).size) return null;
  let r = Z(t);
  return r.ok ? R(Je($e(r.rf))) : null;
}
var yw = (e) => e.k === 'num' && B(e.v);
function tN(e) {
  if (e.k !== 'fn' || e.f !== 'sqrt' || !yw(e.a)) return !1;
  let n = e.a.v.n;
  if (n < 2n) return !1;
  let t = _f(n);
  return !!t && t.square === 1n;
}
function $5(e) {
  if (e.k === 'num' || tN(e)) return !0;
  if (e.k === 'div' && yw(e.a) && yw(e.b)) {
    let n = e.b.v.n,
      t = e.a.v.n,
      r = sN(t < 0n ? -t : t, n < 0n ? -n : n);
    return n > 1n && r === 1n;
  }
  return !!(e.k === 'mul' && e.c.length === 2 && e.c[0].k === 'num' && tN(e.c[1]));
}
var sN = (e, n) => (n === 0n ? e : sN(n, e % n));
function ik(e) {
  if (e.k === 'num' || e.k === 'sym' || $5(e)) return 0;
  let n = e.k === 'add' || e.k === 'mul' ? e.c : e.k === 'fn' ? [e.a] : [e.a, e.b];
  return ($(e).size === 0 ? 1 : 0) + n.reduce((r, s) => r + ik(s), 0);
}
function hg(e) {
  return ik(e.l) + ik(e.r);
}
function Hd(e, n) {
  let t = D(e.l, n),
    r = D(e.r, n);
  if (!Number.isFinite(t) || !Number.isFinite(r)) return !1;
  let s = Math.abs(t - r) <= 1e-7 * Math.max(1, Math.abs(t), Math.abs(r));
  return e.op === '=' ? s : !s;
}
var uo = (e, n) => [e[0] - n[0], e[1] - n[1]],
  Sw = (e, n) => e[0] * n[0] + e[1] * n[1],
  C5 = (e, n) => e[0] * n[1] - e[1] * n[0],
  qc = (e) => Math.hypot(e[0], e[1]),
  Wd = class {
    constructor(n) {
      this.spec = n;
      let t = 1;
      for (let [r, s] of Object.values(n.points)) t = Math.max(t, Math.abs(r), Math.abs(s));
      this.scale = t;
    }
    spec;
    scale;
    has(n) {
      return n in this.spec.points;
    }
    pt(n) {
      let t = this.spec.points[n];
      if (!t) throw new Error(`point ${n} absent de la figure`);
      return [t[0], t[1]];
    }
    line(n) {
      if (n.k === 'pts') {
        let s = this.pt(n.a);
        return { o: s, u: uo(this.pt(n.b), s) };
      }
      let t = this.spec.lines?.[n.n];
      if (!t) throw new Error(`droite (${n.n}) absente de la figure`);
      let r = [t[0][0], t[0][1]];
      return { o: r, u: uo([t[1][0], t[1][1]], r) };
    }
    dist(n, t) {
      return qc(uo(this.pt(n), this.pt(t)));
    }
    lengths() {
      let n = Object.keys(this.spec.points).sort(),
        t = {};
      for (let r = 0; r < n.length; r++)
        for (let s = r + 1; s < n.length; s++) t[n[r] + n[s]] = this.dist(n[r], n[s]);
      return t;
    }
    zeroLen(n) {
      return Math.abs(n) <= 1e-7 * this.scale;
    }
    same(n, t) {
      return this.zeroLen(qc(uo(n, t)));
    }
    parallel(n, t) {
      let r = qc(n),
        s = qc(t);
      return r > 0 && s > 0 && Math.abs(C5(n, t)) <= 1e-7 * r * s;
    }
    orthogonal(n, t) {
      let r = qc(n),
        s = qc(t);
      return r > 0 && s > 0 && Math.abs(Sw(n, t)) <= 1e-7 * r * s;
    }
    onLine(n, t, r) {
      let s = uo(n, t);
      return qc(s) <= 1e-7 * this.scale || this.parallel(s, r);
    }
    collinear(n, t, r) {
      let s = this.pt(n);
      return this.onLine(this.pt(r), s, uo(this.pt(t), s));
    }
    rightAt(n, t, r) {
      let s = this.pt(n);
      return this.orthogonal(uo(this.pt(t), s), uo(this.pt(r), s));
    }
    parallelogram(n) {
      let [t, r, s, i] = n.map((o) => this.pt(o));
      return (
        this.same([t[0] + s[0], t[1] + s[1]], [r[0] + i[0], r[1] + i[1]]) &&
        !this.collinear(n[0], n[1], n[2])
      );
    }
    eqLen(n, t, r, s) {
      let i = this.dist(n, t),
        o = this.dist(r, s);
      return Math.abs(i - o) <= 1e-7 * Math.max(1, i, o);
    }
    holds(n) {
      switch (n.k) {
        case 'par':
        case 'npar': {
          let t = this.parallel(this.line(n.a).u, this.line(n.b).u);
          return n.k === 'par' ? t : !t;
        }
        case 'perp':
          return this.orthogonal(this.line(n.a).u, this.line(n.b).u);
        case 'mid': {
          let t = this.pt(n.a),
            r = this.pt(n.b);
          return this.same(this.pt(n.p), [(t[0] + r[0]) / 2, (t[1] + r[1]) / 2]);
        }
        case 'onseg': {
          if (!this.collinear(n.a, n.b, n.p)) return !1;
          let t = this.pt(n.a),
            r = uo(this.pt(n.b), t),
            s = Sw(uo(this.pt(n.p), t), r) / Sw(r, r);
          return s >= -1e-9 && s <= 1 + 1e-9;
        }
        case 'online': {
          let { o: t, u: r } = this.line(n.l);
          return this.onLine(this.pt(n.p), t, r);
        }
        case 'bis':
          return this.eqLen(n.p, n.a, n.p, n.b);
        case 'circ':
          return this.rightAt(n.p, n.a, n.b);
        case 'para':
          return this.parallelogram(n.v);
        case 'rectangle':
          return this.parallelogram(n.v) && this.rightAt(n.v[1], n.v[0], n.v[2]);
        case 'losange':
          return this.parallelogram(n.v) && this.eqLen(n.v[0], n.v[1], n.v[1], n.v[2]);
        case 'carre':
          return (
            this.parallelogram(n.v) &&
            this.rightAt(n.v[1], n.v[0], n.v[2]) &&
            this.eqLen(n.v[0], n.v[1], n.v[1], n.v[2])
          );
        case 'rt':
          return !this.collinear(n.at, n.b, n.c) && this.rightAt(n.at, n.b, n.c);
        case 'iso':
          return !this.collinear(n.at, n.b, n.c) && this.eqLen(n.at, n.b, n.at, n.c);
        case 'nrt': {
          let [t, r, s] = n.v;
          return (
            !this.collinear(t, r, s) &&
            !this.rightAt(t, r, s) &&
            !this.rightAt(r, t, s) &&
            !this.rightAt(s, t, r)
          );
        }
      }
    }
  };
var ok = {
  id: 'geometry-core',
  version: 1,
  schema: 1,
  label:
    'G\xE9om\xE9trie d\xE9ductive du coll\xE8ge : droites, milieux, quadrilat\xE8res, Pythagore, Thal\xE8s',
  rules: [
    {
      id: 'perp_perp_par',
      version: 1,
      label: 'Deux droites perpendiculaires \xE0 une m\xEAme droite sont parall\xE8les',
      card: 'Droites parall\xE8les et perpendiculaires',
      if: ['(?d1) \u22A5 (?d3)', '(?d2) \u22A5 (?d3)'],
      then: ['(?d1) // (?d2)'],
      levels: ['6e', '5e'],
      examples: [
        {
          facts: ['(d\u2081) \u22A5 (AB)', '(d\u2082) \u22A5 (AB)'],
          proves: '(d\u2081) // (d\u2082)',
          points: { A: [0, 0], B: [4, 0] },
          lines: {
            'd\u2081': [
              [1, 0],
              [1, 3],
            ],
            'd\u2082': [
              [3, 0],
              [3, 2],
            ],
          },
        },
      ],
    },
    {
      id: 'par_par_par',
      version: 1,
      label: 'Deux droites parall\xE8les \xE0 une m\xEAme droite sont parall\xE8les',
      card: 'Droites parall\xE8les et perpendiculaires',
      if: ['(?d1) // (?d3)', '(?d2) // (?d3)'],
      then: ['(?d1) // (?d2)'],
      levels: ['6e', '5e'],
      examples: [
        {
          facts: ['(d\u2081) // (AB)', '(d\u2082) // (AB)'],
          proves: '(d\u2081) // (d\u2082)',
          points: { A: [0, 0], B: [4, 0] },
          lines: {
            'd\u2081': [
              [0, 1],
              [2, 1],
            ],
            'd\u2082': [
              [0, 3],
              [5, 3],
            ],
          },
        },
      ],
    },
    {
      id: 'perp_par',
      version: 1,
      label:
        'Si deux droites sont parall\xE8les, toute perpendiculaire \xE0 l\u2019une est perpendiculaire \xE0 l\u2019autre',
      card: 'Droites parall\xE8les et perpendiculaires',
      if: ['(?d1) // (?d2)', '(?d3) \u22A5 (?d1)'],
      then: ['(?d3) \u22A5 (?d2)'],
      levels: ['6e', '5e'],
      examples: [
        {
          facts: ['(d\u2081) // (d\u2082)', '(AB) \u22A5 (d\u2081)'],
          proves: '(AB) \u22A5 (d\u2082)',
          points: { A: [1, 0], B: [1, 4] },
          lines: {
            'd\u2081': [
              [0, 1],
              [3, 1],
            ],
            'd\u2082': [
              [0, 2],
              [3, 2],
            ],
          },
        },
      ],
    },
    {
      id: 'midline',
      version: 1,
      label: 'Th\xE9or\xE8me des milieux',
      card: 'Th\xE9or\xE8me des milieux',
      if: ['?I milieu de [?A?B]', '?J milieu de [?A?C]'],
      then: ['(?I?J) // (?B?C)', '?I?J = ?B?C \xF7 2'],
      levels: ['4e'],
      examples: [
        {
          facts: ['I milieu de [AB]', 'J milieu de [AC]'],
          proves: '(IJ) // (BC)',
          points: { A: [0, 4], B: [-2, 0], C: [4, 0], I: [-1, 2], J: [2, 2] },
        },
        {
          facts: ['I milieu de [AB]', 'J milieu de [AC]'],
          proves: 'IJ = BC \xF7 2',
          points: { A: [0, 4], B: [-2, 0], C: [4, 0], I: [-1, 2], J: [2, 2] },
        },
      ],
    },
    {
      id: 'midline_converse',
      version: 1,
      label: 'R\xE9ciproque du th\xE9or\xE8me des milieux',
      card: 'Th\xE9or\xE8me des milieux',
      if: ['?I milieu de [?A?B]', '?J \u2208 [?A?C]', '(?I?J) // (?B?C)'],
      then: ['?J milieu de [?A?C]'],
      levels: ['4e'],
      examples: [
        {
          facts: ['I milieu de [AB]', 'J \u2208 [AC]', '(IJ) // (BC)'],
          proves: 'J milieu de [AC]',
          points: { A: [0, 4], B: [-2, 0], C: [4, 0], I: [-1, 2], J: [2, 2] },
        },
      ],
    },
    {
      id: 'para_def',
      version: 1,
      label:
        'Un quadrilat\xE8re dont les c\xF4t\xE9s oppos\xE9s sont parall\xE8les est un parall\xE9logramme',
      card: 'Propri\xE9t\xE9s du parall\xE9logramme',
      if: ['(?A?B) // (?C?D)', '(?A?D) // (?B?C)'],
      then: ['?A?B?C?D parall\xE9logramme'],
      levels: ['5e'],
      examples: [
        {
          facts: ['(AB) // (CD)', '(AD) // (BC)'],
          proves: 'ABCD parall\xE9logramme',
          points: { A: [0, 0], B: [4, 0], C: [5, 3], D: [1, 3] },
        },
      ],
    },
    {
      id: 'para_sides',
      version: 1,
      label:
        'Les c\xF4t\xE9s oppos\xE9s d\u2019un parall\xE9logramme sont parall\xE8les et de m\xEAme longueur',
      card: 'Propri\xE9t\xE9s du parall\xE9logramme',
      if: ['?A?B?C?D parall\xE9logramme'],
      then: ['(?A?B) // (?C?D)', '(?A?D) // (?B?C)', '?A?B = ?C?D', '?A?D = ?B?C'],
      levels: ['5e'],
      examples: [
        {
          facts: ['ABCD parall\xE9logramme'],
          proves: '(AB) // (CD)',
          points: { A: [0, 0], B: [4, 0], C: [5, 3], D: [1, 3] },
        },
        {
          facts: ['ABCD parall\xE9logramme'],
          proves: 'AD = BC',
          points: { A: [0, 0], B: [4, 0], C: [5, 3], D: [1, 3] },
        },
      ],
    },
    {
      id: 'para_diag',
      version: 1,
      label:
        'Un quadrilat\xE8re dont les diagonales ont le m\xEAme milieu est un parall\xE9logramme',
      card: 'Propri\xE9t\xE9s du parall\xE9logramme',
      if: ['?I milieu de [?A?C]', '?I milieu de [?B?D]'],
      then: ['?A?B?C?D parall\xE9logramme'],
      levels: ['5e'],
      examples: [
        {
          facts: ['I milieu de [AC]', 'I milieu de [BD]'],
          proves: 'ABCD parall\xE9logramme',
          points: { A: [0, 0], B: [4, 0], C: [5, 3], D: [1, 3], I: [2.5, 1.5] },
        },
      ],
    },
    {
      id: 'para_diag_mid',
      version: 1,
      label: 'Les diagonales d\u2019un parall\xE9logramme se coupent en leur milieu',
      card: 'Propri\xE9t\xE9s du parall\xE9logramme',
      if: ['?A?B?C?D parall\xE9logramme', '?I milieu de [?A?C]'],
      then: ['?I milieu de [?B?D]'],
      levels: ['5e'],
      examples: [
        {
          facts: ['ABCD parall\xE9logramme', 'I milieu de [AC]'],
          proves: 'I milieu de [BD]',
          points: { A: [0, 0], B: [4, 0], C: [5, 3], D: [1, 3], I: [2.5, 1.5] },
        },
      ],
    },
    {
      id: 'para_one_pair',
      version: 1,
      label:
        'Un quadrilat\xE8re non crois\xE9 qui a deux c\xF4t\xE9s oppos\xE9s parall\xE8les et de m\xEAme longueur est un parall\xE9logramme',
      card: 'Propri\xE9t\xE9s du parall\xE9logramme',
      if: ['(?A?B) // (?C?D)', '?A?B = ?C?D'],
      then: ['?A?B?C?D parall\xE9logramme'],
      levels: ['5e'],
      examples: [
        {
          facts: ['(AB) // (CD)', 'AB = CD'],
          proves: 'ABCD parall\xE9logramme',
          points: { A: [0, 0], B: [4, 0], C: [5, 3], D: [1, 3] },
        },
      ],
    },
    {
      id: 'rect_para_right',
      version: 1,
      label: 'Un parall\xE9logramme qui a un angle droit est un rectangle',
      card: 'Rectangle, losange, carr\xE9',
      if: ['?A?B?C?D parall\xE9logramme', '(?A?B) \u22A5 (?B?C)'],
      then: ['?A?B?C?D rectangle'],
      levels: ['5e'],
      examples: [
        {
          facts: ['ABCD parall\xE9logramme', '(AB) \u22A5 (BC)'],
          proves: 'ABCD rectangle',
          points: { A: [0, 0], B: [4, 0], C: [4, 3], D: [0, 3] },
        },
      ],
    },
    {
      id: 'rect_para_diag',
      version: 1,
      label: 'Un parall\xE9logramme dont les diagonales ont la m\xEAme longueur est un rectangle',
      card: 'Rectangle, losange, carr\xE9',
      if: ['?A?B?C?D parall\xE9logramme', '?A?C = ?B?D'],
      then: ['?A?B?C?D rectangle'],
      levels: ['5e'],
      examples: [
        {
          facts: ['ABCD parall\xE9logramme', 'AC = BD'],
          proves: 'ABCD rectangle',
          points: { A: [0, 0], B: [4, 0], C: [4, 3], D: [0, 3] },
        },
      ],
    },
    {
      id: 'rect_props',
      version: 1,
      label:
        'Un rectangle est un parall\xE9logramme qui a quatre angles droits et des diagonales de m\xEAme longueur',
      card: 'Rectangle, losange, carr\xE9',
      if: ['?A?B?C?D rectangle'],
      then: ['?A?B?C?D parall\xE9logramme', '(?A?B) \u22A5 (?B?C)', '?A?C = ?B?D'],
      levels: ['5e'],
      examples: [
        {
          facts: ['ABCD rectangle'],
          proves: '(BC) \u22A5 (CD)',
          points: { A: [0, 0], B: [4, 0], C: [4, 3], D: [0, 3] },
        },
        {
          facts: ['ABCD rectangle'],
          proves: 'AC = BD',
          points: { A: [0, 0], B: [4, 0], C: [4, 3], D: [0, 3] },
        },
      ],
    },
    {
      id: 'los_para_sides',
      version: 1,
      label:
        'Un parall\xE9logramme qui a deux c\xF4t\xE9s cons\xE9cutifs de m\xEAme longueur est un losange',
      card: 'Rectangle, losange, carr\xE9',
      if: ['?A?B?C?D parall\xE9logramme', '?A?B = ?B?C'],
      then: ['?A?B?C?D losange'],
      levels: ['5e'],
      examples: [
        {
          facts: ['ABCD parall\xE9logramme', 'AB = BC'],
          proves: 'ABCD losange',
          points: { A: [0, 0], B: [5, 0], C: [8, 4], D: [3, 4] },
        },
      ],
    },
    {
      id: 'los_para_diag',
      version: 1,
      label: 'Un parall\xE9logramme dont les diagonales sont perpendiculaires est un losange',
      card: 'Rectangle, losange, carr\xE9',
      if: ['?A?B?C?D parall\xE9logramme', '(?A?C) \u22A5 (?B?D)'],
      then: ['?A?B?C?D losange'],
      levels: ['5e'],
      examples: [
        {
          facts: ['ABCD parall\xE9logramme', '(AC) \u22A5 (BD)'],
          proves: 'ABCD losange',
          points: { A: [0, 0], B: [5, 0], C: [8, 4], D: [3, 4] },
        },
      ],
    },
    {
      id: 'los_props',
      version: 1,
      label:
        'Un losange est un parall\xE9logramme aux c\xF4t\xE9s de m\xEAme longueur et aux diagonales perpendiculaires',
      card: 'Rectangle, losange, carr\xE9',
      if: ['?A?B?C?D losange'],
      then: ['?A?B?C?D parall\xE9logramme', '?A?B = ?B?C', '(?A?C) \u22A5 (?B?D)'],
      levels: ['5e'],
      examples: [
        {
          facts: ['ABCD losange'],
          proves: '(AC) \u22A5 (BD)',
          points: { A: [0, 0], B: [5, 0], C: [8, 4], D: [3, 4] },
        },
      ],
    },
    {
      id: 'carre_def',
      version: 1,
      label: 'Un quadrilat\xE8re \xE0 la fois rectangle et losange est un carr\xE9',
      card: 'Rectangle, losange, carr\xE9',
      if: ['?A?B?C?D rectangle', '?A?B?C?D losange'],
      then: ['?A?B?C?D carr\xE9'],
      levels: ['5e'],
      examples: [
        {
          facts: ['ABCD rectangle', 'ABCD losange'],
          proves: 'ABCD carr\xE9',
          points: { A: [0, 0], B: [3, 0], C: [3, 3], D: [0, 3] },
        },
      ],
    },
    {
      id: 'carre_rect_sides',
      version: 1,
      label:
        'Un rectangle qui a deux c\xF4t\xE9s cons\xE9cutifs de m\xEAme longueur est un carr\xE9',
      card: 'Rectangle, losange, carr\xE9',
      if: ['?A?B?C?D rectangle', '?A?B = ?B?C'],
      then: ['?A?B?C?D carr\xE9'],
      levels: ['5e'],
      examples: [
        {
          facts: ['ABCD rectangle', 'AB = BC'],
          proves: 'ABCD carr\xE9',
          points: { A: [0, 0], B: [3, 0], C: [3, 3], D: [0, 3] },
        },
      ],
    },
    {
      id: 'carre_props',
      version: 1,
      label: 'Un carr\xE9 est \xE0 la fois un rectangle et un losange',
      card: 'Rectangle, losange, carr\xE9',
      if: ['?A?B?C?D carr\xE9'],
      then: ['?A?B?C?D rectangle', '?A?B?C?D losange'],
      levels: ['5e'],
      examples: [
        {
          facts: ['ABCD carr\xE9'],
          proves: 'ABCD losange',
          points: { A: [0, 0], B: [3, 0], C: [3, 3], D: [0, 3] },
        },
      ],
    },
    {
      id: 'rt_def',
      version: 1,
      label: 'Un triangle qui a deux c\xF4t\xE9s perpendiculaires est rectangle',
      card: 'Triangle rectangle',
      if: ['(?A?B) \u22A5 (?A?C)'],
      then: ['?A?B?C rectangle en ?A'],
      levels: ['6e', '5e'],
      examples: [
        {
          facts: ['(AB) \u22A5 (AC)'],
          proves: 'ABC rectangle en A',
          points: { A: [0, 0], B: [3, 0], C: [0, 4] },
        },
      ],
    },
    {
      id: 'rt_sides',
      version: 1,
      label:
        'Dans un triangle rectangle, les c\xF4t\xE9s de l\u2019angle droit sont perpendiculaires',
      card: 'Triangle rectangle',
      if: ['?A?B?C rectangle en ?A'],
      then: ['(?A?B) \u22A5 (?A?C)'],
      levels: ['6e', '5e'],
      examples: [
        {
          facts: ['ABC rectangle en A'],
          proves: '(AB) \u22A5 (AC)',
          points: { A: [0, 0], B: [3, 0], C: [0, 4] },
        },
      ],
    },
    {
      id: 'pythagore',
      version: 1,
      label: 'Th\xE9or\xE8me de Pythagore',
      card: 'Th\xE9or\xE8me de Pythagore',
      if: ['?A?B?C rectangle en ?A'],
      then: ['?B?C\xB2 = ?A?B\xB2 + ?A?C\xB2'],
      levels: ['4e'],
      examples: [
        {
          facts: ['ABC rectangle en A'],
          proves: 'BC\xB2 = AB\xB2 + AC\xB2',
          points: { A: [0, 0], B: [3, 0], C: [0, 4] },
        },
      ],
    },
    {
      id: 'pythagore_converse',
      version: 1,
      label: 'R\xE9ciproque du th\xE9or\xE8me de Pythagore',
      card: 'Th\xE9or\xE8me de Pythagore',
      if: ['?B?C\xB2 = ?A?B\xB2 + ?A?C\xB2'],
      then: ['?A?B?C rectangle en ?A'],
      levels: ['4e'],
      examples: [
        {
          facts: ['BC\xB2 = AB\xB2 + AC\xB2'],
          proves: 'ABC rectangle en A',
          points: { A: [0, 0], B: [3, 0], C: [0, 4] },
        },
      ],
    },
    {
      id: 'pythagore_contra',
      version: 1,
      label: 'Contrapos\xE9e du th\xE9or\xE8me de Pythagore',
      card: 'Th\xE9or\xE8me de Pythagore',
      if: ['?B?C\xB2 \u2260 ?A?B\xB2 + ?A?C\xB2'],
      then: ['?A?B?C n\u2019est pas rectangle'],
      when: [{ longest: ['?B?C', '?A?B', '?A?C'] }],
      levels: ['4e', '3e'],
      examples: [
        {
          facts: ['AB = 4', 'AC = 5', 'BC = 7', 'BC\xB2 \u2260 AB\xB2 + AC\xB2'],
          proves: 'ABC n\u2019est pas rectangle',
          points: { A: [0, 0], B: [4, 0], C: [-1, 4.898979485566356] },
        },
      ],
    },
    {
      id: 'thales',
      version: 1,
      label: 'Th\xE9or\xE8me de Thal\xE8s',
      card: 'Th\xE9or\xE8me de Thal\xE8s',
      if: ['?M \u2208 (?A?B)', '?N \u2208 (?A?C)', '(?M?N) // (?B?C)'],
      then: [
        '?A?M \xF7 ?A?B = ?A?N \xF7 ?A?C',
        '?A?M \xF7 ?A?B = ?M?N \xF7 ?B?C',
        '?A?N \xF7 ?A?C = ?M?N \xF7 ?B?C',
      ],
      levels: ['4e', '3e'],
      examples: [
        {
          facts: ['M \u2208 [AB]', 'N \u2208 [AC]', '(MN) // (BC)'],
          proves: 'AM \xF7 AB = AN \xF7 AC',
          points: { A: [0, 0], B: [6, 0], C: [3, 6], M: [2, 0], N: [1, 2] },
        },
      ],
    },
    {
      id: 'thales_converse',
      version: 1,
      label: 'R\xE9ciproque du th\xE9or\xE8me de Thal\xE8s',
      card: 'Th\xE9or\xE8me de Thal\xE8s',
      if: ['?M \u2208 [?A?B]', '?N \u2208 [?A?C]', '?A?M \xF7 ?A?B = ?A?N \xF7 ?A?C'],
      then: ['(?M?N) // (?B?C)'],
      levels: ['3e'],
      examples: [
        {
          facts: ['M \u2208 [AB]', 'N \u2208 [AC]', 'AM \xF7 AB = AN \xF7 AC'],
          proves: '(MN) // (BC)',
          points: { A: [0, 0], B: [6, 0], C: [3, 6], M: [2, 0], N: [1, 2] },
        },
      ],
    },
    {
      id: 'thales_converse_bowtie',
      version: 1,
      label: 'R\xE9ciproque du th\xE9or\xE8me de Thal\xE8s',
      card: 'Th\xE9or\xE8me de Thal\xE8s',
      if: ['?A \u2208 [?M?B]', '?A \u2208 [?N?C]', '?A?M \xF7 ?A?B = ?A?N \xF7 ?A?C'],
      then: ['(?M?N) // (?B?C)'],
      levels: ['3e'],
      examples: [
        {
          facts: ['A \u2208 [MB]', 'A \u2208 [NC]', 'AM \xF7 AB = AN \xF7 AC'],
          proves: '(MN) // (BC)',
          points: { A: [0, 0], B: [6, 0], C: [3, 6], M: [-2, 0], N: [-1, -2] },
        },
      ],
    },
    {
      id: 'thales_contra',
      version: 1,
      label: 'Contrapos\xE9e du th\xE9or\xE8me de Thal\xE8s',
      card: 'Th\xE9or\xE8me de Thal\xE8s',
      if: ['?M \u2208 (?A?B)', '?N \u2208 (?A?C)', '?A?M \xF7 ?A?B \u2260 ?A?N \xF7 ?A?C'],
      then: ['(?M?N) \u2226 (?B?C)'],
      levels: ['3e'],
      examples: [
        {
          facts: ['M \u2208 [AB]', 'N \u2208 [AC]', 'AM \xF7 AB \u2260 AN \xF7 AC'],
          proves: '(MN) \u2226 (BC)',
          points: { A: [0, 0], B: [6, 0], C: [3, 6], M: [2, 0], N: [1.5, 3] },
        },
      ],
    },
    {
      id: 'bis_def',
      version: 1,
      label:
        'Un point de la m\xE9diatrice d\u2019un segment est \xE0 \xE9gale distance de ses extr\xE9mit\xE9s',
      card: 'M\xE9diatrice d\u2019un segment',
      if: ['?M \u2208 m\xE9diatrice de [?A?B]'],
      then: ['?M?A = ?M?B'],
      levels: ['6e', '5e'],
      examples: [
        {
          facts: ['M \u2208 m\xE9diatrice de [AB]'],
          proves: 'MA = MB',
          points: { A: [0, 0], B: [4, 0], M: [2, 3] },
        },
      ],
    },
    {
      id: 'bis_converse',
      version: 1,
      label:
        'Un point \xE0 \xE9gale distance des extr\xE9mit\xE9s d\u2019un segment est sur sa m\xE9diatrice',
      card: 'M\xE9diatrice d\u2019un segment',
      if: ['?M?A = ?M?B'],
      then: ['?M \u2208 m\xE9diatrice de [?A?B]'],
      levels: ['6e', '5e'],
      examples: [
        {
          facts: ['MA = MB'],
          proves: 'M \u2208 m\xE9diatrice de [AB]',
          points: { A: [0, 0], B: [4, 0], M: [2, 3] },
        },
      ],
    },
    {
      id: 'iso_def',
      version: 1,
      label: 'Un triangle qui a deux c\xF4t\xE9s de m\xEAme longueur est isoc\xE8le',
      card: 'Triangle isoc\xE8le',
      if: ['?A?B = ?A?C'],
      then: ['?A?B?C isoc\xE8le en ?A'],
      levels: ['6e', '5e'],
      examples: [
        {
          facts: ['AB = AC'],
          proves: 'ABC isoc\xE8le en A',
          points: { A: [2, 4], B: [0, 0], C: [4, 0] },
        },
      ],
    },
    {
      id: 'iso_props',
      version: 1,
      label:
        'Les deux c\xF4t\xE9s issus du sommet principal d\u2019un triangle isoc\xE8le ont la m\xEAme longueur',
      card: 'Triangle isoc\xE8le',
      if: ['?A?B?C isoc\xE8le en ?A'],
      then: ['?A?B = ?A?C'],
      levels: ['6e', '5e'],
      examples: [
        {
          facts: ['ABC isoc\xE8le en A'],
          proves: 'AB = AC',
          points: { A: [2, 4], B: [0, 0], C: [4, 0] },
        },
      ],
    },
    {
      id: 'circle_rt',
      version: 1,
      label:
        'Un triangle inscrit dans un cercle qui a pour diam\xE8tre l\u2019un de ses c\xF4t\xE9s est rectangle',
      card: 'Triangle rectangle et cercle circonscrit',
      if: ['?A \u2208 cercle de diam\xE8tre [?B?C]'],
      then: ['?A?B?C rectangle en ?A'],
      levels: ['4e'],
      examples: [
        {
          facts: ['A \u2208 cercle de diam\xE8tre [BC]'],
          proves: 'ABC rectangle en A',
          points: { A: [0, 0], B: [3, 0], C: [0, 4] },
        },
      ],
    },
    {
      id: 'rt_circle',
      version: 1,
      label:
        'Le cercle circonscrit \xE0 un triangle rectangle a pour diam\xE8tre l\u2019hypot\xE9nuse',
      card: 'Triangle rectangle et cercle circonscrit',
      if: ['?A?B?C rectangle en ?A'],
      then: ['?A \u2208 cercle de diam\xE8tre [?B?C]'],
      levels: ['4e'],
      examples: [
        {
          facts: ['ABC rectangle en A'],
          proves: 'A \u2208 cercle de diam\xE8tre [BC]',
          points: { A: [0, 0], B: [3, 0], C: [0, 4] },
        },
      ],
    },
    {
      id: 'rt_median',
      version: 1,
      label:
        'Dans un triangle rectangle, la m\xE9diane issue de l\u2019angle droit mesure la moiti\xE9 de l\u2019hypot\xE9nuse',
      card: 'Triangle rectangle et cercle circonscrit',
      if: ['?A?B?C rectangle en ?A', '?I milieu de [?B?C]'],
      then: ['?A?I = ?B?C \xF7 2'],
      levels: ['4e'],
      examples: [
        {
          facts: ['ABC rectangle en A', 'I milieu de [BC]'],
          proves: 'AI = BC \xF7 2',
          points: { A: [0, 0], B: [3, 0], C: [0, 4], I: [1.5, 2] },
        },
      ],
    },
    {
      id: 'rt_median_converse',
      version: 1,
      label:
        'Si la m\xE9diane issue d\u2019un sommet mesure la moiti\xE9 du c\xF4t\xE9 oppos\xE9, le triangle est rectangle en ce sommet',
      card: 'Triangle rectangle et cercle circonscrit',
      if: ['?I milieu de [?B?C]', '?A?I = ?B?C \xF7 2'],
      then: ['?A?B?C rectangle en ?A'],
      levels: ['4e'],
      examples: [
        {
          facts: ['I milieu de [BC]', 'AI = BC \xF7 2'],
          proves: 'ABC rectangle en A',
          points: { A: [0, 0], B: [3, 0], C: [0, 4], I: [1.5, 2] },
        },
      ],
    },
    {
      id: 'seg_add',
      version: 1,
      label:
        'Un point d\u2019un segment le partage en deux segments dont les longueurs s\u2019ajoutent',
      card: 'Milieu d\u2019un segment',
      if: ['?M \u2208 [?A?B]'],
      then: ['?A?B = ?A?M + ?M?B'],
      levels: ['6e'],
      examples: [
        {
          facts: ['M \u2208 [AB]'],
          proves: 'AB = AM + MB',
          points: { A: [0, 0], B: [5, 0], M: [2, 0] },
        },
      ],
    },
    {
      id: 'mid_lengths',
      version: 1,
      label: 'Le milieu d\u2019un segment le partage en deux segments de m\xEAme longueur',
      card: 'Milieu d\u2019un segment',
      if: ['?I milieu de [?A?B]'],
      then: ['?I?A = ?I?B', '?A?I = ?A?B \xF7 2'],
      levels: ['6e'],
      examples: [
        {
          facts: ['I milieu de [AB]'],
          proves: 'AI = AB \xF7 2',
          points: { A: [0, 0], B: [6, 0], I: [3, 0] },
        },
      ],
    },
    {
      id: 'mid_from_eq',
      version: 1,
      label:
        'Un point d\u2019un segment \xE0 \xE9gale distance de ses extr\xE9mit\xE9s en est le milieu',
      card: 'Milieu d\u2019un segment',
      if: ['?I \u2208 [?A?B]', '?I?A = ?I?B'],
      then: ['?I milieu de [?A?B]'],
      levels: ['6e'],
      examples: [
        {
          facts: ['I \u2208 [AB]', 'IA = IB'],
          proves: 'I milieu de [AB]',
          points: { A: [0, 0], B: [6, 0], I: [3, 0] },
        },
      ],
    },
  ],
};
var lN = /\?[A-Z][0-9]*/g;
function iN(e) {
  if (Pl(e)) return { k: 'prop', p: zd(e, !0), text: e };
  if (!/[=≠]/.test(e)) throw new Error(`motif sans relation : ${e}`);
  return { k: 'metric', text: e };
}
function Tw(e) {
  return e.k === 'metric'
    ? (e.text.match(lN) ?? [])
    : [...gg(e.p), ...YL(e.p)].filter((n) => n.startsWith('?'));
}
function oN(e) {
  return e.k === 'metric' ? 2 : e.p.k === 'online' ? 1 : 0;
}
function uN(e) {
  if (e.schema !== 1) throw new Error('paquet de g\xE9om\xE9trie : sch\xE9ma inconnu');
  let n = new Set();
  return e.rules.map((t) => {
    if (!/^[a-z][a-z0-9_]*$/.test(t.id) || n.has(t.id))
      throw new Error(`r\xE8gle de g\xE9om\xE9trie : identifiant invalide ou en double (${t.id})`);
    n.add(t.id);
    let r = t.if.map(iN).sort((a, l) => oN(a) - oN(l)),
      s = t.then.map(iN);
    if (!r.length || !s.length)
      throw new Error(`r\xE8gle ${t.id} : conditions ou conclusion vides`);
    let i = new Set(r.flatMap(Tw)),
      o = s.flatMap(Tw).filter((a) => !i.has(a));
    if (o.length && s.some((a) => a.k === 'metric'))
      throw new Error(`r\xE8gle ${t.id} : variables libres dans la conclusion (${o.join(', ')})`);
    for (let a of t.when ?? [])
      for (let l of a.longest)
        for (let u of l.match(lN) ?? [])
          if (!i.has(u) && !s.flatMap(Tw).includes(u))
            throw new Error(`r\xE8gle ${t.id} : variable ${u} inconnue dans \xAB when \xBB`);
    if (!t.examples.length) throw new Error(`r\xE8gle ${t.id} : au moins un exemple`);
    return {
      qid: `geometry.${t.id}@${t.version}`,
      id: t.id,
      label: t.label,
      card: t.card,
      hyps: r,
      concl: s,
      when: t.when ?? [],
      spec: t,
    };
  });
}
var aN = null;
function Rw() {
  return ((aN ??= uN(ok)), aN);
}
var M5 = `${ok.id}@${ok.version}`;
var Jd = class {
  constructor(n, t, r) {
    this.rules = r;
    ((this.points = t),
      this.buildLines(n.flatMap((s) => (s.g ? [s.g] : []))),
      (this.props = n.flatMap((s) => (s.g ? [this.canon(s.g)] : []))),
      (this.rels = n.flatMap((s) => s.m?.rels ?? [])),
      (this.V = ww(this.rels)));
  }
  rules;
  points;
  lines = [];
  props;
  rels;
  V;
  metricInstances = null;
  buildLines(n) {
    let t = [],
      r = (o) => {
        t.push(o.k === 'pts' ? { pts: [o.a, o.b], names: [] } : { pts: [], names: [o.n] });
      };
    for (let o of n)
      o.k === 'mid' || o.k === 'onseg'
        ? t.push({ pts: [o.a, o.b, o.p], names: [] })
        : o.k === 'online'
          ? t.push(
              o.l.k === 'pts'
                ? { pts: [o.l.a, o.l.b, o.p], names: [] }
                : { pts: [o.p], names: [o.l.n] },
            )
          : (o.k === 'par' || o.k === 'npar' || o.k === 'perp') && (r(o.a), r(o.b));
    let s = t.map((o) => ({ pts: new Set(o.pts), names: new Set(o.names) })),
      i = !0;
    for (; i; ) {
      i = !1;
      e: for (let o = 0; o < s.length; o++)
        for (let a = o + 1; a < s.length; a++) {
          let l = s[o],
            u = s[a],
            c = [...l.pts].filter((d) => u.pts.has(d)).length,
            f = [...l.names].some((d) => u.names.has(d));
          if (c >= 2 || f) {
            (u.pts.forEach((d) => l.pts.add(d)),
              u.names.forEach((d) => l.names.add(d)),
              s.splice(a, 1),
              (i = !0));
            break e;
          }
        }
    }
    s.forEach((o, a) => this.lines.push({ id: `L${a}`, pts: o.pts, names: o.names }));
  }
  lineId(n) {
    let t = this.lines.find((s) =>
      n.k === 'pts' ? s.pts.has(n.a) && s.pts.has(n.b) : s.names.has(n.n),
    );
    if (t) return t.id;
    let r = `L${this.lines.length}`;
    return (
      this.lines.push({
        id: r,
        pts: new Set(n.k === 'pts' ? [n.a, n.b] : []),
        names: new Set(n.k === 'name' ? [n.n] : []),
      }),
      r
    );
  }
  line(n) {
    return this.lines.find((t) => t.id === n);
  }
  canon(n) {
    switch (n.k) {
      case 'par':
      case 'npar':
      case 'perp':
        return { k: n.k, a: this.lineId(n.a), b: this.lineId(n.b) };
      case 'online':
        return { k: 'online', p: n.p, l: this.lineId(n.l) };
      default:
        return n;
    }
  }
  established(n) {
    if (n.k === 'online') {
      let s = this.lineId(n.l);
      return this.line(s).pts.has(n.p);
    }
    let t = this.canon(n);
    if ((t.k === 'par' || t.k === 'npar' || t.k === 'perp') && t.a === t.b) return !1;
    let r = bg(t);
    return this.props.some(
      (s) => bg(s) === r || (t.k === 'onseg' && s.k === 'mid' && bg({ ...s, k: 'onseg' }) === r),
    );
  }
  sameProp(n, t) {
    return n.k === 'online' || t.k === 'online'
      ? n.k === 'online' && t.k === 'online' && n.p === t.p && this.lineId(n.l) === this.lineId(t.l)
      : bg(this.canon(n)) === bg(this.canon(t));
  }
  sameLine(n, t) {
    return this.lineId(n) === this.lineId(t);
  }
  knownRel(n) {
    return this.rels.find((t) => Ar(t, n)) ?? null;
  }
  bindPt(n, t, r) {
    if (!t.startsWith('?')) return t === r ? n : null;
    let s = n.get(t);
    if (s !== void 0) return s === r ? n : null;
    for (let [o, a] of n) if (a === r && !o.startsWith('?l')) return null;
    let i = new Map(n);
    return (i.set(t, r), i);
  }
  bindLine(n, t, r) {
    if (t.k === 'name') {
      if (!t.n.startsWith('?')) return this.lineId(t) === r ? [n] : [];
      let o = '?l' + t.n,
        a = n.get(o);
      if (a !== void 0) return a === r ? [n] : [];
      for (let [u, c] of n) if (u.startsWith('?l') && c === r) return [];
      let l = new Map(n);
      return (l.set(o, r), [l]);
    }
    let s = [...this.line(r).pts],
      i = [];
    for (let o of s)
      for (let a of s) {
        if (o === a) continue;
        let l = this.bindPt(n, t.a, o),
          u = l && this.bindPt(l, t.b, a);
        u && i.push(u);
      }
    return i;
  }
  bindPts(n, t, r) {
    let s = n;
    for (let i = 0; i < t.length && s; i++) s = this.bindPt(s, t[i], r[i]);
    return s;
  }
  unify(n, t, r) {
    if (!(n.k === t.k || (n.k === 'onseg' && t.k === 'mid'))) return [];
    switch (n.k) {
      case 'par':
      case 'npar':
      case 'perp': {
        let i = t,
          o = [];
        for (let [a, l] of [
          [i.a, i.b],
          [i.b, i.a],
        ])
          for (let u of this.bindLine(r, n.a, a)) o.push(...this.bindLine(u, n.b, l));
        return o;
      }
      case 'mid':
      case 'onseg':
      case 'bis':
      case 'circ': {
        let i = t;
        return [
          this.bindPts(r, [n.p, n.a, n.b], [i.p, i.a, i.b]),
          this.bindPts(r, [n.p, n.a, n.b], [i.p, i.b, i.a]),
        ].filter((o) => !!o);
      }
      case 'rt':
      case 'iso': {
        let i = t;
        return [
          this.bindPts(r, [n.at, n.b, n.c], [i.at, i.b, i.c]),
          this.bindPts(r, [n.at, n.b, n.c], [i.at, i.c, i.b]),
        ].filter((o) => !!o);
      }
      case 'nrt': {
        let i = t.v;
        return cN(i)
          .map((o) => this.bindPts(r, n.v, o))
          .filter((o) => !!o);
      }
      case 'online':
        return [];
      default: {
        let i = t.v;
        return _5(i)
          .map((o) => this.bindPts(r, n.v, o))
          .filter((o) => !!o);
      }
    }
  }
  unifyOnline(n, t) {
    let r = [];
    for (let s of this.lines) {
      if (n.l.k === 'name') {
        for (let o of s.pts) {
          let a = this.bindPt(t, n.p, o);
          a && r.push(...this.bindLine(a, n.l, s.id));
        }
        continue;
      }
      let i = [...s.pts];
      if (!(i.length < 3))
        for (let o of i)
          for (let a of i)
            for (let l of i) {
              if (o === a || o === l || a === l) continue;
              let u = this.bindPts(t, [n.p, n.l.a, n.l.b], [o, a, l]);
              u && r.push(u);
            }
    }
    return r;
  }
  metricHolds(n, t) {
    let r = Mc(ak(n, t), this.points);
    return r.ok ? r.m.rels.every((s) => this.rels.some((i) => Ar(i, s))) : !1;
  }
  satisfy(n, t, r = 0, s = [], i = 400) {
    if (s.length >= i) return s;
    if (r === n.length) return (s.push(t), s);
    let o = n[r];
    if (o.k === 'metric') {
      let l = [...new Set(o.text.match(/\?[A-Z][0-9]*/g) ?? [])].filter((u) => !t.has(u));
      for (let u of this.assignFree(l, t))
        this.metricHolds(o.text, u) && this.satisfy(n, u, r + 1, s, i);
      return s;
    }
    let a =
      o.p.k === 'online'
        ? this.unifyOnline(o.p, t)
        : this.props.flatMap((l) => this.unify(o.p, l, t));
    for (let l of a) this.satisfy(n, l, r + 1, s, i);
    return s;
  }
  assignFree(n, t) {
    if (!n.length) return [t];
    let [r, ...s] = n,
      i = [];
    for (let o of this.points) {
      let a = this.bindPt(t, r, o);
      a && i.push(...this.assignFree(s, a));
    }
    return i;
  }
  conditionsHold(n, t) {
    for (let r of n.when) {
      let [s, ...i] = r.longest.map((l) => ak(l, t)),
        o = (l) => {
          let u = l.length === 2 && l[0] > l[1] ? l[1] + l[0] : l,
            c = this.V.get(u);
          return c ? D(c, {}) : null;
        },
        a = o(s);
      if (a === null) return !1;
      for (let l of i) {
        let u = o(l);
        if (u === null || u > a + 1e-9) return !1;
      }
    }
    return !0;
  }
  justifyProp(n) {
    let t = this.canon(n);
    for (let r of this.rules)
      for (let s of r.concl)
        if (s.k === 'prop') {
          for (let i of this.unify(s.p, t, new Map()))
            for (let o of this.satisfy(r.hyps, i)) if (this.conditionsHold(r, o)) return r;
        }
    return null;
  }
  instances() {
    if (this.metricInstances) return this.metricInstances;
    let n = [];
    for (let t of this.rules) {
      let r = t.concl.filter((s) => s.k === 'metric');
      if (r.length) {
        for (let s of this.satisfy(t.hyps, new Map()))
          if (this.conditionsHold(t, s))
            for (let i of r) {
              let o = Mc(ak(i.text, s), this.points);
              o.ok && o.m.rels.forEach((a) => n.push({ rule: t, rel: a }));
            }
      }
    }
    return ((this.metricInstances = n), n);
  }
  justifyRel(n) {
    let t = lo(n, this.V),
      r = Zd(t) !== null;
    for (let { rule: s, rel: i } of this.instances())
      if (Ar(i, n) || (!r && Ar(lo(i, this.V), t))) return s;
    return null;
  }
};
function ak(e, n) {
  return e.replace(/\?[A-Z][0-9]*/g, (t) => n.get(t) ?? t);
}
function bg(e) {
  switch (e.k) {
    case 'par':
    case 'npar':
    case 'perp': {
      let [n, t] = [e.a, e.b].sort();
      return `${e.k} ${n} ${t}`;
    }
    case 'mid':
    case 'onseg':
    case 'bis':
    case 'circ':
      return `${e.k} ${e.p} ${[e.a, e.b].sort().join('')}`;
    case 'online':
      return `online ${e.p} ${e.l}`;
    case 'rt':
    case 'iso':
      return `${e.k} ${e.at} ${[e.b, e.c].sort().join('')}`;
    case 'nrt':
      return `nrt ${[...e.v].sort().join('')}`;
    default:
      return `${e.k} ${eN(e.v)}`;
  }
}
function cN(e) {
  return e.length <= 1
    ? [e]
    : e.flatMap((n, t) => cN([...e.slice(0, t), ...e.slice(t + 1)]).map((r) => [n, ...r]));
}
function _5(e) {
  let n = [];
  for (let t = 0; t < e.length; t++) {
    let r = [...e.slice(t), ...e.slice(0, t)];
    n.push(r, [...r].reverse());
  }
  return n;
}
var q5 = 'kernel.compute@1';
function pN(e) {
  return { dis: [{ sides: [{ k: 's', n: e }] }] };
}
var L5 = (e) =>
  pg.includes(e) ||
  e === '=' ||
  e === '\u2260' ||
  (e.length > 1 && /^[([]/.test(e) && /[)\]]$/.test(e));
function N5(e) {
  let n = [],
    t = [],
    r = () => {
      (t.length && n.push(ot(t)), (t = []));
    };
  for (let s of e) L5(s) ? (r(), n.push(s)) : t.push(s);
  return (r(), Kl(n.join(' ')));
}
function O5(e) {
  return Pl(e)
    ? xw(e)
    : Kl(e)
        .split(/\s*(=|≠)\s*/)
        .flatMap((t, r) => (r % 2 ? [t] : Te(t)));
}
function $w(e, n, t) {
  let r = Kl(e);
  if (Pl(r)) {
    let i = zd(r),
      o = gg(i).find((a) => !n.has(a));
    if (o) throw new mt(`Il n\u2019y a pas de point ${o} sur la figure.`);
    if (t) {
      for (let a of [i.k === 'par' || i.k === 'npar' || i.k === 'perp' ? [i.a, i.b] : []]
        .flat()
        .concat(i.k === 'online' ? [i.l] : []))
        if (a.k === 'name' && !t.spec.lines?.[a.n])
          throw new mt(`La droite (${a.n}) n\u2019est pas sur la figure.`);
    }
    return { text: rk(i), g: i };
  }
  let s = Mc(r, n);
  if (!s.ok) throw new mt(s.why);
  return { text: r, m: s.m };
}
function gN(e) {
  if (e.ops.some((t) => t !== '=') || e.members.length < 3) return e.rels;
  let n = [];
  for (let t = 0; t < e.members.length; t++)
    for (let r = t + 1; r < e.members.length; r++)
      n.push({ op: '=', l: e.members[t], r: e.members[r] });
  return n;
}
function K5(e) {
  return e.m ? { ...e, m: { ...e.m, rels: gN(e.m) } } : e;
}
function hN(e) {
  let n = e.kernel,
    t = new Wd(n.figure),
    r = new Set(Object.keys(n.figure.points)),
    s = (i) => $w(i, r, t);
  return {
    spec: n,
    figure: t,
    lengths: t.lengths(),
    points: r,
    givens: [n.start, ...(e.givens ?? [])].map(s),
    lines: [],
    answer: s(n.answer),
    traps: (e.traps ?? []).flatMap((i) => {
      try {
        return [{ fact: s(i.line), title: i.title, why: i.why, line: pN(i.line) }];
      } catch {
        return [];
      }
    }),
    path: n.path ?? [],
    rules: Rw(),
    known: null,
  };
}
function bN(e, n = []) {
  return new Jd([...e.givens, ...e.lines, ...n].map(K5), e.points, e.rules);
}
function P5(e, n) {
  return n.g ? e.figure.holds(n.g) : n.m.rels.every((t) => Hd(t, e.lengths));
}
function vN(e, n, t) {
  return n.g && t.g
    ? e.sameProp(n.g, t.g)
    : n.m && t.m
      ? n.m.rels.every((r) => t.m.rels.some((s) => Ar(r, s)))
      : !1;
}
function I5(e) {
  return ((e.known ??= [...e.path, e.spec.answer].map(O5)), e.known);
}
function A5(e, n) {
  return I5(e).some((t) => t.length > n.length && n.every((r, s) => t[s] === r));
}
var j5 = new Set(['+', '\u2212', '\xD7', '\xF7', '(', '^', '\u221A', '=', '\u2260', '\xB2']);
function Q5(e, n) {
  let t = e[e.length - 1];
  return pg.includes(t) && t !== 'parall\xE9logramme'
    ? !['rectangle', 'losange', 'carr\xE9', 'n\u2019est pas rectangle'].includes(t)
    : (j5.has(t) && t !== '\xB2') || (!Pl(n) && !/[=≠]/.test(n))
      ? !0
      : e.length === 1;
}
function kN(e, n, t) {
  let r = n.flatMap((l) => l.atoms);
  if (!r.length) return { kind: 'empty', atoms: r, badChip: -1 };
  let s = N5(r),
    i = A5(e, r),
    o;
  try {
    o = $w(s, e.points, e.figure);
  } catch (l) {
    return i
      ? { kind: 'building', atoms: r, complete: !1 }
      : Q5(r, s)
        ? { kind: 'open', atoms: r, complete: !1 }
        : {
            kind: 'syntax',
            atoms: r,
            title: '\xC7a commence mal',
            message: l instanceof mt ? l.message : 'Ligne illisible.',
            badChip: n.length - 1,
          };
  }
  let a = V5(e, o, r);
  return i && !t?.verify
    ? a.kind === 'step'
      ? { ...a, kind: 'ready' }
      : { kind: 'building', atoms: r, complete: !0 }
    : !t?.verify && (a.kind === 'unjustified' || a.kind === 'false')
      ? { kind: 'pending', atoms: r, complete: !0 }
      : a;
}
var F5 = (e) => e.charAt(0).toLowerCase() + e.slice(1);
function V5(e, n, t) {
  let r = pN(n.text),
    s = bN(e),
    i = e.traps.find((o) => vN(s, n, o.fact));
  return i
    ? {
        kind: 'trap',
        atoms: t,
        line: r,
        title: 'Pi\xE8ge : ' + F5(i.title),
        message: i.why,
        trap: { line: i.line, title: i.title, why: i.why },
        badChip: -1,
      }
    : n.g
      ? B5(e, s, n, t, r)
      : Z5(e, s, n, t, r);
}
var xN = {
  title: 'Tu le sais d\xE9j\xE0',
  message: 'C\u2019est d\xE9j\xE0 dans l\u2019\xE9nonc\xE9 ou sur ta feuille.',
};
function D5(e) {
  switch (e.k) {
    case 'par':
      return 'Ces deux droites ne sont pas parall\xE8les.';
    case 'npar':
      return 'Ces deux droites sont parall\xE8les.';
    case 'perp':
      return 'Ces deux droites ne sont pas perpendiculaires.';
    case 'mid':
      return `${e.p} n\u2019est pas le milieu de [${e.a}${e.b}].`;
    case 'onseg':
      return `${e.p} n\u2019est pas sur le segment [${e.a}${e.b}].`;
    case 'online':
      return `${e.p} n\u2019est pas sur cette droite.`;
    case 'para':
      return `${e.v.join('')} n\u2019est pas un parall\xE9logramme (attention \xE0 l\u2019ordre des sommets).`;
    case 'rectangle':
      return `${e.v.join('')} n\u2019est pas un rectangle.`;
    case 'losange':
      return `${e.v.join('')} n\u2019est pas un losange.`;
    case 'carre':
      return `${e.v.join('')} n\u2019est pas un carr\xE9.`;
    case 'rt':
      return `Le triangle ${e.at}${e.b}${e.c} n\u2019est pas rectangle en ${e.at}.`;
    case 'iso':
      return `Le triangle ${e.at}${e.b}${e.c} n\u2019est pas isoc\xE8le en ${e.at}.`;
    case 'nrt':
      return `Le triangle ${e.v.join('')} est rectangle.`;
    case 'bis':
      return `${e.p} n\u2019est pas sur la m\xE9diatrice de [${e.a}${e.b}].`;
    case 'circ':
      return `${e.p} n\u2019est pas sur le cercle de diam\xE8tre [${e.a}${e.b}].`;
  }
}
function yN(e, n, t, r, s, i) {
  let o = TN(e, n),
    a = s ? 2 : 1,
    l = o
      ? 'C\u2019est ce qu\u2019il fallait d\xE9montrer.'
      : s
        ? s.label + '.'
        : i === 'Comparer'
          ? 'Tu compares deux nombres calcul\xE9s avec les longueurs connues.'
          : 'Tu remplaces les longueurs connues et tu calcules.';
  return {
    kind: 'step',
    atoms: t,
    line: r,
    final: o,
    hora: a,
    rule: { id: s ? s.qid : q5, card: s ? s.card : '', label: s ? s.label : i, hora: a, why: l },
    gfact: n,
  };
}
function B5(e, n, t, r, s) {
  let i = t.g;
  if (!e.figure.holds(i))
    return { kind: 'false', atoms: r, line: s, title: 'C\u2019est faux', message: D5(i) };
  if (n.established(i)) return { kind: 'useless', atoms: r, line: s, ...xN, gfact: t };
  let o = n.justifyProp(i);
  return o
    ? yN(e, t, r, s, o, '')
    : {
        kind: 'unjustified',
        atoms: r,
        line: s,
        title: 'D\u2019o\xF9 vient-elle ?',
        message:
          'C\u2019est vrai, mais \xE7a ne d\xE9coule pas encore de ce que tu as \xE9crit. Cherche une propri\xE9t\xE9 du cours dont toutes les conditions sont dans l\u2019\xE9nonc\xE9 ou sur ta feuille.',
      };
}
var wN = (e) => $(e).size > 0;
function fN(e) {
  if (e.op !== '=') return null;
  for (let [n, t] of [
    [e.l, e.r],
    [e.r, e.l],
  ]) {
    if (wN(t)) continue;
    if (
      n.k === 'sym' ||
      (n.k === 'pow' && n.a.k === 'sym' && n.b.k === 'num') ||
      (n.k === 'div' && n.a.k === 'sym' && n.b.k === 'sym')
    )
      return E(R(n));
  }
  return null;
}
function dN(e, n) {
  let t = _c(n, e.V);
  if (t) return t;
  for (let r of e.rels)
    if (r.op === '=')
      for (let s of [r.l, r.r]) {
        let i = _c(s, e.V);
        if (!(!i || wN(s)) && Ar(lo({ op: '=', l: n, r: i }, e.V), lo(r, e.V))) return i;
      }
  return null;
}
function z5(e, n) {
  for (let t of e.rels)
    if (t.op === '=')
      for (let [r, s] of [
        [t.l, t.r],
        [t.r, t.l],
      ]) {
        if (r.k !== 'sym' || E(r) === E(s)) continue;
        let i = { [r.n]: s },
          o = (l) => ({ op: l.op, l: j(l.l, i), r: j(l.r, i) }),
          a = o(n);
        for (let l of e.rels) if (l !== t && (Ar(l, a) || Ar(o(l), n))) return !0;
      }
  return !1;
}
function U5(e, n) {
  let t = e.rels.filter((o) => Ar(o, n));
  if (t.length) {
    if (Math.min(...t.map(hg)) > hg(n)) return { c: 'rewrite' };
    let o = fN(n);
    return o && !t.some((a) => fN(a) === o) ? { c: 'rewrite' } : { c: 'known' };
  }
  let r = e.justifyRel(n);
  if (r) return { c: 'rule', rule: r };
  let s = lo(n, e.V),
    i = Zd(s);
  if (i === !0) return { c: Gd(n).size ? 'calc' : 'num' };
  if (i === null) {
    if (e.rels.some((l) => Ar(lo(l, e.V), s))) return { c: 'calc' };
    let o = dN(e, n.l),
      a = dN(e, n.r);
    if (o && a && Zd({ op: n.op, l: o, r: a }) === !0) return { c: 'calc' };
    if (z5(e, n)) return { c: 'calc' };
  }
  return { c: 'unjustified' };
}
function G5(e, n, t) {
  let r = n.rels.find((l) => !Hd(l, t.lengths)) ?? n.rels[0],
    s = _c(r.l, e.V),
    i = _c(r.r, e.V),
    o = Gd({ op: '=', l: r.l, r: r.l }).size === 0,
    a = Gd({ op: '=', l: r.r, r: r.r }).size === 0;
  if (r.op === '=' && s && i && o !== a) {
    let [l, u, c] = o ? [r.r, i, r.l] : [r.l, s, r.r];
    return `${oe(l)} = ${oe(u)}, pas ${oe(c)}.`;
  }
  if (s && i) {
    let l = `${oe(r.l)} = ${oe(s)} et ${oe(r.r)} = ${oe(i)}`;
    return r.op === '='
      ? `${l} : ces deux nombres ne sont pas \xE9gaux.`
      : `${l} : ces deux nombres sont \xE9gaux.`;
  }
  return 'Cette \xE9galit\xE9 n\u2019est pas vraie pour la figure de l\u2019\xE9nonc\xE9. V\xE9rifie avec les longueurs donn\xE9es.';
}
function Z5(e, n, t, r, s) {
  let i = t.m;
  if (!i.rels.every((u) => Hd(u, e.lengths)))
    return { kind: 'false', atoms: r, line: s, title: 'C\u2019est faux', message: G5(n, i, e) };
  let o = i.rels.map((u) => U5(n, u));
  if (o.some((u) => u.c === 'unjustified'))
    return {
      kind: 'unjustified',
      atoms: r,
      line: s,
      title: 'D\u2019o\xF9 vient-elle ?',
      message:
        'Cette \xE9galit\xE9 est juste, mais elle ne d\xE9coule pas encore de ce que tu as \xE9crit : quelle propri\xE9t\xE9 du cours la donne ?',
    };
  if (o.every((u) => u.c === 'known' || u.c === 'num'))
    return o.some((u) => u.c === 'known')
      ? { kind: 'useless', atoms: r, line: s, ...xN, gfact: t }
      : {
          kind: 'useless',
          atoms: r,
          line: s,
          title: 'Juste, mais\u2026',
          message:
            'Ce calcul est juste, mais il ne dit rien de la figure : \xE9cris la longueur ou le rapport que tu calcules.',
          gfact: t,
        };
  let a = o.find((u) => u.c === 'rule')?.rule ?? null,
    l = i.ops.includes('\u2260');
  return !a && l && i.rels.length === 1 && H5(e, i.rels[0])
    ? {
        kind: 'useless',
        atoms: r,
        line: s,
        title: 'Juste, mais \xE0 c\xF4t\xE9',
        message:
          'Pour savoir si le triangle est rectangle, compare le carr\xE9 du PLUS GRAND c\xF4t\xE9 \xE0 la somme des carr\xE9s des deux autres.',
        gfact: t,
      }
    : yN(e, t, r, s, a, l ? 'Comparer' : 'Calculer');
}
function mN(e) {
  return e.k === 'pow' && e.a.k === 'sym' && oe(e.b) === '2' ? e.a.n : null;
}
function H5(e, n) {
  for (let [t, r] of [
    [n.l, n.r],
    [n.r, n.l],
  ]) {
    let s = mN(t);
    if (!s || r.k !== 'add' || r.c.length !== 2) continue;
    let i = r.c.map(mN);
    if (!i[0] || !i[1]) continue;
    let o = (l) => e.lengths[l] ?? Number.NaN,
      a = Math.max(o(i[0]), o(i[1]));
    if (o(s) < a * (1 - 1e-9)) return !0;
  }
  return !1;
}
function SN(e, n) {
  n.gfact &&
    (n.kind === 'step' || n.kind === 'ready' || n.kind === 'useless') &&
    e.lines.push(n.gfact);
}
function TN(e, n) {
  let t = e.answer;
  if (t.g) return !!n.g && vN(bN(e), n, t);
  if (!n.m) return !1;
  let r = gN(n.m);
  return t.m.rels.every((s) => r.some((i) => Ar(i, s) && hg(i) === 0));
}
function Cw(e) {
  return e.lines.some((n) => TN(e, n));
}
function RN(e, n) {
  try {
    return P5(e, $w(n, e.points, e.figure));
  } catch {
    return !1;
  }
}
function $N(e) {
  if (!Cw(e) || !e.answer.m) return [];
  let n = _c(e.answer.m.rels[0].r, new Map());
  return n ? [D(n, {})] : [];
}
var Nc = {
    hypothesis: 'induction.hypothesis@1',
    definition: 'induction.definition@1',
    substitute: 'kernel.substitute@1',
    compute: 'kernel.compute@1',
    increasing: 'induction.increasing@1',
    weaken: 'induction.weaken@1',
  },
  Oc = 'Raisonnement par r\xE9currence',
  co = class extends Error {},
  W5 = { '=': '=', '<': '>', '>': '<', '\u2264': '\u2265', '\u2265': '\u2264' };
function J5(e, n, t) {
  let r = E(R(n)),
    s = E(R(t)),
    i = e;
  return (
    (i === '>' || i === '\u2265') && (([r, s] = [s, r]), (i = W5[i])),
    i === '=' && r > s && ([r, s] = [s, r]),
    `${i}:${r}|${s}`
  );
}
var Kc = (e) =>
  e
    .map((n) => n.key)
    .sort()
    .join('&');
function lk(e, n, t, r, s) {
  return { rel: e, l: n, r: t, lText: r, rText: s, key: J5(e, n, t) };
}
function qN(e, n, t) {
  if (e.rels || e.mod !== void 0) throw new co('Une congruence n\u2019a pas sa place ici.');
  if (e.sides.length < 2) throw new co('\xC9cris une \xE9galit\xE9 ou une in\xE9galit\xE9.');
  let r;
  try {
    r = e.sides.map(_e);
  } catch {
    throw new co('Je ne sais pas lire cette \xE9criture.');
  }
  let s = e.sides.map((a) => ot(Br(a)));
  if (e.cmp === '\u2248') throw new co('Pas de valeur approch\xE9e : on d\xE9montre.');
  if (e.chain || e.cmp) {
    let l = (e.chain ?? [e.cmp]).map((u, c) => lk(u, r[c], r[c + 1], s[c], s[c + 1]));
    return { text: n, src: t, rels: l, pairs: l, units: [l] };
  }
  let i = r.slice(1).map((a, l) => lk('=', r[l], a, s[l], s[l + 1])),
    o = [];
  for (let a = 0; a < r.length; a++)
    for (let l = a + 1; l < r.length; l++) o.push(lk('=', r[a], r[l], s[a], s[l]));
  return { text: n, src: t, rels: i, pairs: o, units: i.map((a) => [a]) };
}
function Lc(e, n = 'line') {
  let t;
  try {
    t = Ve(e);
  } catch {
    throw new co('Ligne illisible.');
  }
  if (t.dis.length !== 1) throw new co('Une seule relation par ligne.');
  return qN(t.dis[0], e, n);
}
function LN(e) {
  return ne(Te(e));
}
function X5(e) {
  return { kind: e.kind === 'acute' || e.kind === 'angle' ? 'positive' : e.kind, of: [e.of] };
}
function NN(e) {
  let n = e.kernel,
    t = n.induction,
    r = t.variable ?? 'n',
    s = t.hypothesis,
    i = [],
    o = Lc(s, 'hr');
  (n.start.trim() !== s.trim() && i.push(Lc(n.start, 'def')),
    (e.givens ?? []).forEach((u) => i.push(Lc(u, 'given'))),
    i.push(o));
  let a = (n.hypotheses ?? []).map(X5);
  a.some((u) => u.of[0] === r) || a.unshift({ kind: 'natural', of: [r] });
  let l = {
    spec: n,
    x: r,
    hyps: a,
    facts: i,
    lines: [],
    hr: o,
    answer: Lc(n.answer, 'line'),
    traps: (e.traps ?? []).flatMap((u) => {
      try {
        return [{ fact: Lc(u.line), title: u.title, why: u.why, line: Ve(u.line) }];
      } catch {
        return [];
      }
    }),
    path: n.path ?? [],
    defs: new Map(),
    cons: null,
    constrained: new Set(),
    envs: [],
    consEnvs: [],
    known: null,
    cache: new Map(),
  };
  return (nZ(l), (l.envs = rZ(l, e)), (l.consEnvs = sZ(l)), Du(), l);
}
function Al(e, n) {
  let t = n;
  for (let r = 0; r < 8; r++) {
    let s = [...$(t)].filter((o) => e.defs.has(o));
    if (!s.length) return t;
    let i = {};
    (s.forEach((o) => (i[o] = e.defs.get(o))), (t = j(t, i)));
  }
  return t;
}
var Y5 = (e) => qn(e, T(0)) === 'equal';
function eZ(e, n) {
  let t = (i) => j(e, { [n]: T(i) }),
    r = t(0),
    s = ve(t(1), r);
  return Y5(s) || qn(ve(t(2), t(1)), s) !== 'equal' || $(s).has(n) ? null : R(ye(Mu(r), s));
}
function nZ(e) {
  let n = [e.hr, ...e.facts.filter((r) => r !== e.hr)],
    t = [];
  for (let r of n)
    for (let s of r.rels) {
      if (s.rel !== '=') {
        (r.src === 'hr' || r.src === 'given') && t.push({ rel: s.rel, l: s.l, r: s.r });
        continue;
      }
      tZ(e, s);
    }
  if (t.length) {
    let r = t.map((s) => ({ rel: s.rel, l: Al(e, s.l), r: Al(e, s.r) }));
    ((e.cons = r.length === 1 ? { k: 'rel', ...r[0] } : { k: 'set', clauses: [r] }),
      r.forEach((s) => {
        ($(s.l, e.constrained), $(s.r, e.constrained));
      }),
      e.constrained.delete(e.x));
  }
}
function tZ(e, n) {
  let t = (s) => s !== e.x && !e.defs.has(s) && s !== '\u03C0';
  for (let [s, i] of [
    [n.l, n.r],
    [n.r, n.l],
  ])
    if (s.k === 'sym' && t(s.n)) {
      let o = Al(e, i);
      if (!$(o).has(s.n)) {
        e.defs.set(s.n, i);
        return;
      }
    }
  let r = R(ve(n.l, n.r));
  for (let s of $(r)) {
    if (!t(s)) continue;
    let i = eZ(r, s);
    if (i && !$(Al(e, i)).has(s)) {
      e.defs.set(s, i);
      return;
    }
  }
}
function rZ(e, n) {
  let t = e.spec.induction?.from ?? 0,
    r = new Set(),
    s = (u) =>
      u.pairs.forEach((c) => {
        ($(Al(e, c.l), r), $(Al(e, c.r), r));
      });
  ([...e.facts, e.answer].forEach(s),
    e.path.forEach((u) => {
      try {
        s(Lc(u));
      } catch {}
    }),
    Object.keys(n.symbols).forEach((u) => r.add(u)));
  let i = [...r].filter(
      (u) => u !== '\u03C0' && !e.defs.has(u) && !e.constrained.has(u) && /^[^?]/.test(u),
    ),
    o = (u) => e.hyps.find((c) => c.of.length === 1 && c.of[0] === u)?.kind ?? 'real',
    a = (u) => {
      switch (u === e.x ? 'natural' : o(u)) {
        case 'natural':
          return u === e.x ? [0, 1, 2, 3, 4, 5, 7].map((c) => c + t) : [0, 1, 2, 3, 5];
        case 'integer':
          return [-2, -1, 0, 1, 2, 3];
        case 'positive':
          return [0.5, 1, 2.5, 4];
        case 'nonnegative':
          return [0, 0.5, 2, 3.5];
        case 'negative':
          return [-0.5, -1, -2.5];
        default:
          return [-1.5, 0.5, 2, 3.25];
      }
    },
    l = [{}];
  for (let u of i) {
    let c = [];
    for (let f of l) for (let d of a(u)) c.push({ ...f, [u]: d });
    l = c.slice(0, 96);
  }
  return l;
}
function sZ(e) {
  if (!e.cons || !e.constrained.size || e.constrained.size > 2) return [];
  let n = [];
  for (let i = -6; i <= 12; i += 0.37) n.push(Math.round(i * 1e3) / 1e3);
  [0, 1, 2, 3, 4, 5, Math.SQRT2].forEach((i) => n.push(i));
  let t = [...e.constrained],
    r = e.cons.k === 'rel' ? [e.cons] : e.cons.k === 'set' ? e.cons.clauses[0] : [],
    s = [];
  for (let i of e.envs.slice(0, 6)) {
    let o =
      t.length === 1
        ? n.map((a) => [a])
        : n.flatMap((a) => n.filter((l, u) => u % 4 === 0).map((l) => [a, l]));
    for (let a of o) {
      let l = { ...i };
      (t.forEach((u, c) => (l[u] = a[c])),
        r.every((u) => _w(u.rel, D(u.l, l), D(u.r, l))) && s.push(l));
    }
  }
  return s.slice(0, 400);
}
function _w(e, n, t) {
  let r = 1e-9 * (1 + Math.abs(n) + Math.abs(t));
  switch (e) {
    case '=':
      return Math.abs(n - t) <= r;
    case '<':
      return n < t - r;
    case '>':
      return n > t + r;
    case '\u2264':
      return n <= t + r;
    case '\u2265':
      return n >= t - r;
  }
}
function Ew(e, n, t) {
  let r = `${JSON.stringify(n, CN)}\u2192${JSON.stringify(t, CN)}`,
    s = e.cache.get(r);
  if (s) return s;
  let i = Ss(n, t, { rules: mw(!1), hypotheses: e.hyps, deadline: Date.now() + 200, branches: !1 });
  return (e.cache.set(r, i), i);
}
var CN = (e, n) => (typeof n == 'bigint' ? n.toString() : n),
  vg = (e) => (e.length === 1 ? { k: 'rel', ...e[0] } : { k: 'set', clauses: [e] });
function ON(e, n) {
  let t = n.map((a) => ({ src: a, rel: a.rel, l: Al(e, a.l), r: Al(e, a.r) })),
    r = [];
  for (let a of t) (a.rel === '=' && qn(a.l, a.r) === 'equal') || r.push(a);
  if (!r.length) return { v: 'true' };
  let s = (a) => [...$(a.l), ...$(a.r)].some((l) => e.constrained.has(l));
  if (e.cons && r.some(s)) {
    let a = Ew(e, e.cons, vg(r));
    if (a.status === 'valid' && a.relation !== 'none') return { v: 'true' };
    if (a.status === 'invalid') return { v: 'false', at: a.explanation?.params?.at };
    if (!e.consEnvs.length) return { v: 'unknown' };
  }
  let i = 0,
    o = e.cons && r.some(s) ? e.consEnvs : e.envs;
  for (let a of o)
    for (let l of r) {
      let u = D(l.l, a),
        c = D(l.r, a);
      if (!(!Number.isFinite(u) || !Number.isFinite(c)) && (i++, !_w(l.rel, u, c)))
        return { v: 'false', env: a, rel: l.src, lv: u, rv: c };
    }
  return i ? { v: 'true' } : { v: 'unknown' };
}
function iZ(e) {
  return (
    (e.known ??= [...e.path, e.spec.answer].flatMap((n) => {
      try {
        return [LN(n)];
      } catch {
        return [];
      }
    })),
    e.known
  );
}
function oZ(e, n) {
  return iZ(e).some((t) => t.length > n.length && n.every((r, s) => t[s] === r));
}
function KN(e, n, t) {
  let r = wt(n),
    s = r.atoms;
  if (!s.length) return { kind: 'empty', atoms: s, badChip: -1 };
  let i = vn(s, { chains: !0 }),
    o = oZ(e, s);
  if (!i.ok)
    return o
      ? { kind: 'building', atoms: s, complete: !1 }
      : {
          kind: 'syntax',
          atoms: s,
          title: '\xC7a commence mal',
          message: i.msg,
          badChip: r.src[i.index] !== void 0 ? r.src[i.index] : n.length - 1,
        };
  if (!i.complete || !i.hasEq) return { kind: o ? 'building' : 'open', atoms: s, complete: !1 };
  let a, l;
  try {
    if (((a = Ae(s, { chains: !0 })), a.dis.length !== 1))
      throw new co('Une seule relation par ligne.');
    l = qN(a.dis[0], ot(s), 'line');
  } catch (c) {
    return o
      ? { kind: 'building', atoms: s, complete: !1 }
      : c instanceof co
        ? {
            kind: 'syntax',
            atoms: s,
            title: '\xC7a commence mal',
            message: c.message,
            badChip: n.length - 1,
          }
        : { kind: 'open', atoms: s, complete: !1 };
  }
  let u = lZ(e, l, s, a);
  return o && !t?.verify
    ? u.kind === 'step'
      ? { ...u, kind: 'ready' }
      : { kind: 'building', atoms: s, complete: !0 }
    : !t?.verify && (u.kind === 'unjustified' || u.kind === 'false')
      ? { kind: 'pending', atoms: s, complete: !0 }
      : u;
}
var aZ = (e) => e.charAt(0).toLowerCase() + e.slice(1);
function PN(e, n = []) {
  let t = new Set();
  return (
    [...e.facts, ...e.lines].forEach((r) => r.pairs.forEach((s) => t.add(s.key))),
    n.forEach((r) => t.add(r.key)),
    t
  );
}
function lZ(e, n, t, r) {
  let s = Kc(n.rels),
    i = e.traps.find((g) => Kc(g.fact.rels) === s);
  if (i)
    return {
      kind: 'trap',
      atoms: t,
      line: r,
      title: 'Pi\xE8ge : ' + aZ(i.title),
      message: i.why,
      trap: { line: i.line, title: i.title, why: i.why },
      badChip: -1,
    };
  let o = [],
    a = [],
    l = [],
    u = null;
  for (let g of n.units) {
    let h = cZ(e, g, o, n);
    if (h.kind === 'false' || h.kind === 'unjustified')
      return { kind: h.kind, atoms: t, line: r, title: h.title, message: h.message };
    if (h.kind === 'unknown')
      return {
        kind: 'useless',
        atoms: t,
        line: r,
        unknown: !0,
        title: 'Je ne sais pas encore v\xE9rifier ce passage',
        message:
          'Ta ligne est peut-\xEAtre juste, mais je ne sais pas la v\xE9rifier. Garde-la sans HORA, ou \xE9cris le passage autrement.',
      };
    (h.kind === 'useless' && (u ??= h),
      h.kind === 'step' && h.info && (a.push(h.info), l.push(h.from)),
      o.push(...g));
  }
  if (!a.length) {
    let g = u ?? uZ(e, n);
    return { kind: 'useless', atoms: t, line: r, title: g.title, message: g.message, rfact: n };
  }
  let c = a.reduce((g, h) => (h.hora > g.hora ? h : g)),
    f = l.every((g) => g === 'hr') ? { ...n, origin: 'hr' } : n,
    d = a.reduce((g, h) => g + h.hora, 0),
    m = AN(e, n),
    p = m
      ? c.why + ' C\u2019est P(n + 1) : l\u2019h\xE9r\xE9dit\xE9 est d\xE9montr\xE9e.'
      : a.length > 1
        ? a.map((g) => g.why).join(' ')
        : c.why;
  return {
    kind: 'step',
    atoms: t,
    line: r,
    final: m,
    hora: d,
    rule: { id: c.id, card: c.card, label: c.label, hora: d, why: p },
    rfact: f,
  };
}
function uZ(e, n) {
  let t = Kc(n.rels);
  if (Kc(e.hr.rels) === t)
    return {
      kind: 'useless',
      title: 'Tu le sais d\xE9j\xE0',
      message: 'C\u2019est l\u2019hypoth\xE8se de r\xE9currence : sers-t\u2019en pour remplacer.',
    };
  let r = e.facts.find((s) => s.src === 'def');
  return r && Kc(r.rels) === t
    ? {
        kind: 'useless',
        title: 'Tu le sais d\xE9j\xE0',
        message: 'C\u2019est la d\xE9finition de la suite, dans l\u2019\xE9nonc\xE9.',
      }
    : {
        kind: 'useless',
        title: 'Tu le sais d\xE9j\xE0',
        message: 'C\u2019est d\xE9j\xE0 dans l\u2019\xE9nonc\xE9 ou sur ta feuille.',
      };
}
function cZ(e, n, t, r) {
  let s = PN(e, t);
  if (n.every((u) => s.has(u.key))) return { kind: 'known' };
  let i = ON(e, n);
  if (i.v === 'false') return { kind: 'false', title: 'C\u2019est faux', message: fZ(e, i) };
  let o = mZ(e, n, t);
  if (o) return o;
  let a = gZ(e, n, t);
  if (a) return { kind: 'step', info: a };
  let l = kZ(e, n, t);
  return l && l !== 'jump'
    ? { kind: 'step', info: l.info, from: l.from }
    : i.v === 'unknown' && !l
      ? { kind: 'unknown' }
      : xZ(e, n, r)
        ? {
            kind: 'unjustified',
            title: 'C\u2019est le but de l\u2019h\xE9r\xE9dit\xE9',
            message:
              'Cette ligne, c\u2019est P(n + 1) : ce qu\u2019il faut d\xE9montrer, pas un point de d\xE9part. Pars de la d\xE9finition de la suite, remplace avec l\u2019hypoth\xE8se de r\xE9currence, puis calcule jusqu\u2019\xE0 elle.',
          }
        : l === 'jump'
          ? {
              kind: 'unjustified',
              title: 'Une \xE9tape \xE0 la fois',
              message:
                'Ta ligne est juste, mais elle fait plusieurs choses d\u2019un coup. \xC9cris une \xE9tape \xE0 la fois : remplacer, d\xE9velopper, r\xE9duire, factoriser\u2026',
            }
          : {
              kind: 'unjustified',
              title: 'D\u2019o\xF9 vient-elle ?',
              message:
                'C\u2019est juste, mais \xE7a ne d\xE9coule pas en un pas de ce qui est \xE9crit. Remplace avec l\u2019hypoth\xE8se de r\xE9currence ou la d\xE9finition de la suite, ou transforme une ligne d\xE9j\xE0 \xE9crite \u2014 une \xE9tape \xE0 la fois.',
            };
}
function fZ(e, n) {
  if (n.env && n.rel && n.lv !== void 0 && n.rv !== void 0) {
    let t = Object.entries(n.env)
        .filter(([u]) => u === e.x || e.hyps.some((c) => c.of[0] === u))
        .map(([u, c]) => `${u} = ${pe(c)}`)
        .join(', '),
      r = t ? `Pour ${t}` : 'Avec les valeurs de l\u2019\xE9nonc\xE9',
      s = !$(n.rel.l).size,
      i = !$(n.rel.r).size,
      o = s ? n.rel.lText : `${n.rel.lText} vaut ${pe(n.lv)}`,
      a = i ? n.rel.rText : `${n.rel.rText} vaut ${pe(n.rv)}`,
      l =
        n.rel.rel === '='
          ? 'ce n\u2019est pas \xE9gal'
          : 'l\u2019in\xE9galit\xE9 n\u2019est pas v\xE9rifi\xE9e';
    return `${r}, ${o} et ${a} : ${l}. V\xE9rifie ton calcul (et l\u2019hypoth\xE8se de r\xE9currence).`;
  }
  return n.at
    ? `\xC7a ne d\xE9coule pas de l\u2019hypoth\xE8se de r\xE9currence : essaie ${n.at}. V\xE9rifie chaque in\xE9galit\xE9.`
    : 'Ta ligne ne d\xE9coule pas de l\u2019\xE9nonc\xE9 et de l\u2019hypoth\xE8se de r\xE9currence.';
}
function dZ(e, n) {
  let t = new Set(),
    r = (s) => {
      (t.add(E(R(s.l))), t.add(E(R(s.r))));
    };
  return ([...e.facts, ...e.lines, e.answer].forEach((s) => s.pairs.forEach(r)), n.forEach(r), t);
}
function mZ(e, n, t) {
  if (
    !n.every((o) =>
      o.rel === '='
        ? qn(o.l, o.r) === 'equal'
        : [...$(o.l), ...$(o.r)].filter((l) => l !== '\u03C0').length
          ? !1
          : _w(o.rel, D(o.l, {}), D(o.r, {})),
    )
  )
    return null;
  let s = dZ(e, t);
  return n.some((o) => {
    let a = E(R(o.l)),
      l = E(R(o.r));
    return a !== l && (s.has(a) || s.has(l));
  })
    ? {
        kind: 'step',
        info: {
          id: Nc.compute,
          card: Oc,
          label: 'Calculer',
          hora: 1,
          why: 'Tu \xE9cris la m\xEAme quantit\xE9 autrement : c\u2019est un calcul, vrai pour tout n.',
        },
      }
    : {
        kind: 'useless',
        title: 'Juste, mais \xE0 c\xF4t\xE9',
        message:
          'Ce calcul est juste, mais il ne sert pas ta d\xE9monstration. Pars de ce qui est \xE9crit : la d\xE9finition de la suite, l\u2019hypoth\xE8se de r\xE9currence, ou ta derni\xE8re ligne.',
      };
}
function Il(e, n, t) {
  if (E(e) === n) return { t, n: 1 };
  switch (e.k) {
    case 'add':
    case 'mul': {
      let r = 0,
        s = e.c.map((i) => {
          let o = Il(i, n, t);
          return ((r += o.n), o.t);
        });
      return { t: { k: e.k, c: s }, n: r };
    }
    case 'div':
    case 'pow':
    case 'binom': {
      let r = Il(e.a, n, t),
        s = Il(e.b, n, t);
      return { t: { k: e.k, a: r.t, b: s.t }, n: r.n + s.n };
    }
    case 'fn': {
      let r = Il(e.a, n, t);
      return { t: { k: 'fn', f: e.f, a: r.t }, n: r.n };
    }
    default:
      return { t: e, n: 0 };
  }
}
function pZ(e, n) {
  let t = [];
  return (
    [...e.facts, ...e.lines].forEach((r) =>
      r.pairs.forEach((s) => {
        s.rel === '=' && t.push({ rel: s, src: r.origin ?? r.src, text: r.text });
      }),
    ),
    n.forEach((r) => {
      r.rel === '=' && t.push({ rel: r, src: 'line', text: `${r.lText} = ${r.rText}` });
    }),
    t
  );
}
function IN(e, n) {
  let t = [];
  return (
    [...e.facts, ...e.lines].forEach((r) => {
      let s = r.origin ?? r.src;
      (r.pairs.forEach((i) => t.push({ rels: [i], src: s })),
        r.units.length === 1 && r.units[0].length > 1 && t.push({ rels: r.units[0], src: s }));
    }),
    n.forEach((r) => t.push({ rels: [r], src: 'line' })),
    t
  );
}
function EN(e, n) {
  let t = `${e.rel.lText} = ${e.rel.rText}`;
  return e.src === 'hr'
    ? {
        id: Nc.hypothesis,
        card: Oc,
        label: 'Utiliser l\u2019hypoth\xE8se de r\xE9currence',
        hora: 3,
        why: `On remplace gr\xE2ce \xE0 l\u2019hypoth\xE8se de r\xE9currence ${t} : c\u2019est l\xE0 qu\u2019elle sert.`,
      }
    : e.src === 'def'
      ? {
          id: Nc.definition,
          card: Oc,
          label: 'Utiliser la d\xE9finition de la suite',
          hora: 2,
          why: `On remplace gr\xE2ce \xE0 la d\xE9finition de la suite : ${t}.`,
        }
      : {
          id: Nc.substitute,
          card: Oc,
          label: n && e.src === 'line' ? 'Encha\xEEner les \xE9galit\xE9s' : 'Remplacer',
          hora: 1,
          why:
            n && e.src === 'line'
              ? `On encha\xEEne avec ${t}, \xE9crite plus haut.`
              : `On remplace gr\xE2ce \xE0 ${t}.`,
        };
}
function gZ(e, n, t) {
  let r = Kc(n),
    s = pZ(e, t),
    i = IN(e, t),
    o = { hr: 0, def: 1, given: 2, line: 3 };
  s.sort((a, l) => o[a.src] - o[l.src]);
  for (let a of s)
    for (let [l, u] of [
      [a.rel.l, a.rel.r],
      [a.rel.r, a.rel.l],
    ]) {
      if (!$(l).size) continue;
      let c = R(l),
        f = E(c),
        d = R(u);
      for (let g of i) {
        if (g.rels.some((v) => v.key === a.rel.key)) continue;
        let h = 0,
          b = g.rels.map((v) => {
            let k = Il(R(v.l), f, d),
              y = Il(R(v.r), f, d);
            return ((h += k.n + y.n), lk(v.rel, R(k.t), R(y.t), '', ''));
          });
        if (h && Kc(b) === r) {
          let v = g.rels.some((k) => E(R(k.l)) === f || E(R(k.r)) === f);
          return EN(a, v);
        }
      }
      if (!n.some((g) => hZ(e, t, a.rel, g))) continue;
      let m = 0,
        p = n.every((g) => {
          if (g.rel !== '=') return !1;
          let h = Il(R(g.l), f, d),
            b = Il(R(g.r), f, d);
          return ((m += h.n + b.n), E(R(h.t)) === E(R(b.t)));
        });
      if (m && p) return EN(a, !1);
    }
  return null;
}
function hZ(e, n, t, r) {
  let s = new Set(),
    i = (o) => {
      o.key !== t.key && (s.add(E(R(o.l))), s.add(E(R(o.r))));
    };
  return (
    [...e.facts, ...e.lines].forEach((o) => o.pairs.forEach(i)),
    n.forEach(i),
    s.has(E(R(r.l))) || s.has(E(R(r.r)))
  );
}
function Mw(e) {
  return e.k === 'add' ? e.c.length : e.k === 'div' ? Mw(e.a) : 1;
}
var MN = (e) => e.reduce((n, t) => n + Mw(R(t.l)) + Mw(R(t.r)), 0);
function _N(e, n, t, r, s) {
  let i = $b(e, n, t);
  return i.label === 'D\xE9velopper' && MN(s) < MN(r)
    ? { ...i, label: 'Factoriser', why: 'On factorise : k \xD7 a + k \xD7 b = k(a + b).' }
    : i;
}
var bZ = [
  {
    f: 'sqrt',
    label: 'Appliquer la racine carr\xE9e',
    why: 'La fonction racine carr\xE9e est croissante sur [0 ; +\u221E[ : elle conserve l\u2019ordre.',
  },
  {
    f: 'exp',
    label: 'Appliquer l\u2019exponentielle',
    why: 'La fonction exponentielle est croissante : elle conserve l\u2019ordre.',
  },
  {
    f: 'ln',
    label: 'Appliquer le logarithme',
    why: 'La fonction ln est croissante sur ]0 ; +\u221E[ : elle conserve l\u2019ordre.',
  },
];
function Xd(e, n) {
  return E(R(e)) === E(R(n)) || qn(e, n) === 'equal';
}
function vZ(e, n) {
  if (e.length !== n.length) return null;
  for (let t of bZ)
    if (
      e.every((s, i) => {
        let o = n[i];
        return o.rel !== s.rel ? !1 : Xd(be(t.f, s.l), o.l) && Xd(be(t.f, s.r), o.r);
      })
    )
      return t;
  return null;
}
function kZ(e, n, t) {
  let r = vg(n.map((u) => ({ rel: u.rel, l: u.l, r: u.r }))),
    s = null,
    i = !1,
    o = 'line',
    a = (u, c) => {
      (!s || c > s.score) && (s = { info: u, score: c, from: o });
    };
  for (let u of IN(e, t)) {
    if (((o = u.src), u.rels.length !== n.length && n.length > 1)) continue;
    let c = vg(u.rels.map((p) => ({ rel: p.rel, l: p.l, r: p.r }))),
      f = Ew(e, c, r);
    if (f.status !== 'valid' || f.relation === 'none') continue;
    if (f.ruleId) {
      a(_N(f, r, c, u.rels, n), 5);
      continue;
    }
    if (u.rels.length === n.length && n.length > 1) {
      let p = u.rels.map((h, b) => Ew(e, vg([h]), vg([n[b]]))),
        g = new Set(p.map((h) => h.ruleId ?? ''));
      if (p.every((h) => h.status === 'valid' && h.ruleId) && g.size === 1) {
        a(_N(p[0], r, c, u.rels, n), 5);
        continue;
      }
    }
    let d = vZ(u.rels, n);
    if (d) {
      a({ id: Nc.increasing, card: Oc, label: d.label, hora: 2, why: d.why }, 4);
      continue;
    }
    if (f.relation === 'implies') {
      let p = n.length > 1;
      a(
        {
          id: Nc.weaken,
          card: Oc,
          label: p ? '\xC9largir l\u2019encadrement' : '\xC9largir l\u2019in\xE9galit\xE9',
          hora: 1,
          why: 'Ta ligne d\xE9coule de la pr\xE9c\xE9dente : elle est moins pr\xE9cise, mais toujours vraie.',
        },
        1,
      );
      continue;
    }
    if (
      u.rels.length === n.length &&
      u.rels.every((p, g) => {
        let h = n[g];
        if (h.rel !== p.rel && !(h.rel === '=' && p.rel === '=')) return !1;
        let b = Xd(p.l, h.l) && Xd(p.r, h.r),
          v = p.rel === '=' && Xd(p.l, h.r) && Xd(p.r, h.l);
        return b || v;
      })
    ) {
      a(
        {
          id: Nc.compute,
          card: Oc,
          label: 'Calculer',
          hora: 1,
          why: 'Tu calcules un membre : la relation ne change pas.',
        },
        3,
      );
      continue;
    }
    i = !0;
  }
  let l = s;
  return l ? { info: l.info, from: l.from } : i ? 'jump' : null;
}
function xZ(e, n, t) {
  let r = new Set([...n, ...t.pairs].map((s) => s.key));
  return e.answer.rels.every((s) => r.has(s.key));
}
function AN(e, n) {
  let t = PN(e, n?.pairs ?? []);
  return e.answer.rels.every((r) => t.has(r.key));
}
function jN(e) {
  return AN(e);
}
function QN(e, n) {
  n.rfact &&
    !n.unknown &&
    (n.kind === 'step' || n.kind === 'ready' || n.kind === 'useless') &&
    e.lines.push(n.rfact);
}
function yZ(e, n) {
  try {
    let t = Lc(n),
      r = !1;
    for (let s of t.units) {
      let i = ON(e, s);
      if (i.v === 'false') return 'false';
      i.v === 'unknown' && (r = !0);
    }
    return r ? 'unknown' : 'true';
  } catch {
    return 'unknown';
  }
}
function FN(e, n) {
  return yZ(e, n) === 'true';
}
var wZ = {
    substitute: 'matrix.substitute@1',
    power: 'matrix.power@1',
    identity: 'matrix.identity@1',
    product: 'matrix.product@1',
    entrywise: 'matrix.entrywise@1',
    transpose: 'matrix.transpose@1',
    inverse: 'matrix.inverse@1',
    inverseCheck: 'matrix.inverse_check@1',
    det: 'matrix.det@1',
    compute: 'matrix.compute@1',
    factor: 'matrix.factor@1',
    solve: 'matrix.solve@1',
    define: 'matrix.define@1',
    expand: 'matrix.expand@1',
    entryProduct: 'matrix.entry_product@1',
    entry: 'matrix.entry@1',
  },
  kg = {
    substitute: {
      label: 'Remplacer',
      hora: 1,
      why: 'Une matrice remplac\xE9e par sa valeur (ou une valeur reconnue).',
    },
    power: {
      label: '\xC9crire la puissance',
      hora: 1,
      why: 'Une puissance est un produit de facteurs \xE9gaux : A\xB2 = A \xD7 A, A\u2074 = A\xB2 \xD7 A\xB2.',
    },
    identity: {
      label: 'Multiplier par I',
      hora: 1,
      why: 'I est neutre : I \xD7 M = M \xD7 I = M, et I\u1D4F = I.',
    },
    product: {
      label: 'Ligne par colonne',
      hora: 2,
      why: 'Le coefficient (i, j) d\u2019un produit, c\u2019est la ligne i de la premi\xE8re matrice par la colonne j de la seconde : on multiplie terme \xE0 terme et on ajoute.',
    },
    entrywise: {
      label: 'Coefficient par coefficient',
      hora: 1,
      why: 'Une somme de matrices, ou un nombre fois une matrice, se calcule coefficient par coefficient.',
    },
    transpose: {
      label: 'Transposer',
      hora: 1,
      why: 'Les lignes de la matrice deviennent ses colonnes.',
    },
    inverse: {
      label: 'Inverse d\u2019une matrice 2 \xD7 2',
      hora: 3,
      why: 'Si det A \u2260 0 : A\u207B\xB9 = (1 \xF7 det A) \xD7 [d, \u2212b ; \u2212c, a] \u2014 on \xE9change a et d, on change le signe de b et c.',
    },
    inverseCheck: {
      label: 'V\xE9rifier l\u2019inverse',
      hora: 2,
      why: 'AM = I : M est l\u2019inverse de A.',
    },
    det: { label: 'D\xE9terminant', hora: 2, why: 'det [a, b ; c, d] = a \xD7 d \u2212 b \xD7 c.' },
    compute: { label: 'Calculer', hora: 1, why: 'Les calculs faits.' },
    factor: {
      label: 'Factoriser par un nombre',
      hora: 1,
      why: 'Tous les coefficients sont des multiples du m\xEAme nombre.',
    },
    solve: {
      label: 'Multiplier par l\u2019inverse',
      hora: 2,
      why: 'AX = B avec A inversible : X = A\u207B\xB9B \u2014 on multiplie \xE0 GAUCHE par A\u207B\xB9, l\u2019ordre compte.',
    },
    define: {
      label: 'Nommer un calcul',
      hora: 1,
      why: 'Un calcul interm\xE9diaire re\xE7oit un nom.',
    },
    expand: {
      label: 'D\xE9velopper',
      hora: 1,
      why: 'Le produit se distribue sur la somme en gardant l\u2019ordre des facteurs : A(A \u2212 2I) = A\xB2 \u2212 2A, et AI = A.',
    },
    entryProduct: {
      label: 'Ligne par colonne',
      hora: 2,
      why: 'Le coefficient (i, j) d\u2019un produit, c\u2019est la ligne i de la premi\xE8re matrice par la colonne j de la seconde : on multiplie terme \xE0 terme et on ajoute.',
    },
    entry: {
      label: 'Lire le coefficient',
      hora: 1,
      why: 'Le coefficient (i, j) se lit \xE0 la ligne i, colonne j de la matrice \xE9crite.',
    },
  },
  SZ = 'Calcul matriciel';
function Ic(e) {
  return h_(e);
}
function TZ(e) {
  return Kw(Ic(e));
}
var Kw = (e) => ({ dis: [{ sides: [{ k: 's', n: hl(e) }] }] });
function jl(e) {
  return F1(Ic(e));
}
var We = (e) => (e.k === 'paren' ? We(e.e) : e);
function Zn(e) {
  let n = pd(e);
  return n ? n.map((t) => (t.n === 1 ? t.base : `${t.base}^${t.n}`)).join('\xB7') : Ze(e);
}
var ca = (e) => e.slice(1).reduce((n, t) => ({ k: 'mul', l: n, r: t }), e[0]);
function HN(e) {
  let n = e.kernel,
    t = new Map(),
    r = new Map(),
    s = (m, p, g, h) => ({
      key: Ze(m),
      start: p,
      value: g,
      form: null,
      written: new Set([Zn(m), Zn(p)]),
      target: h,
      relevant: !0,
    }),
    i = new Set(),
    o = new Set();
  for (let [m, p] of Object.entries(n.matrices ?? {})) {
    let g = jl(p);
    if (g.length !== 1) throw new Error(`Matrice ${m} : une seule expression attendue.`);
    let h = ln(g[0], t);
    o.add(hl(Ic(`${m} = ${p}`)));
    let b = jl(m),
      v = We(b[0]);
    if (b.length !== 1) throw new Error(`Nom de matrice illisible : ${m}`);
    if (v.k !== 'name') {
      let k = We(v.k === 'pow' || v.k === 'tr' ? v.e : v);
      if (k.k !== 'name') throw new Error(`Nom de matrice illisible : ${m}`);
      if (!t.has(k.n)) {
        if (v.k !== 'pow' || v.n !== -1 || h.t !== 'm')
          throw new Error(`${m} : donne d\u2019abord la matrice ${k.n}.`);
        let y = A1(h.a);
        if (!y) throw new Error(`${m} n\u2019est pas inversible.`);
        t.set(k.n, { t: 'm', r: h.r, c: h.c, a: y });
      }
      if (!Zt(ln(v, t), h)) throw new Error(`${m} ne correspond pas \xE0 ${k.n}.`);
      r.set(Ze(v), s(v, g[0], h, !1));
      continue;
    }
    (t.set(m, h), We(g[0]).k === 'lit' ? i.add(m) : r.set(m, s(v, g[0], h, !1)));
  }
  o.add(hl(Ic(n.start)));
  let a = jl(n.start),
    l = null,
    u,
    c = jl(n.goal.target);
  if (c.length !== 1) throw new Error('La cible est une matrice ou un calcul.');
  if (a.length === 2) {
    let m = Ze(c[0]),
      p = We(a[0]);
    if (p.k !== 'mul') throw new Error('\xC9quation attendue : AX = B ou XA = B.');
    let g = Ze(p.r) === m ? 'left' : Ze(p.l) === m ? 'right' : null;
    if (!g) throw new Error('L\u2019inconnue doit \xEAtre un facteur du produit : AX = B.');
    let h = g === 'left' ? p.l : p.r,
      b = ln(h, t),
      v = ln(a[1], t),
      k = ln({ k: 'pow', e: h, n: -1, text: '\u207B\xB9' }, t),
      y = g === 'left' ? pl(k, v) : pl(v, k);
    (t.set(m, y),
      (l = { coef: h, right: a[1], side: g, unknown: m }),
      (u = s(c[0], c[0], y, !0)),
      r.set(m, u));
  } else {
    let m = a[0],
      p = ln(m, t);
    ((u = s(c[0], m, p, !0)),
      r.set(u.key, u),
      Ze(m) !== u.key && (r.set(Ze(m), u), o.add(hl(Ic(`${n.goal.target} = ${n.start}`)))));
    let g = We(c[0]);
    g.k === 'name' && !t.has(g.n) && t.set(g.n, p);
  }
  let f = jl(n.answer),
    d = {
      model: e,
      env: t,
      objects: r,
      target: u,
      equation: l,
      answerLast: f[f.length - 1],
      relevantKeys: new Set([...r.keys()]),
      traps: [],
      givenLit: i,
      givenTexts: o,
      lines: [],
      known: [],
      concluded: !1,
      path: n.path ?? [],
    };
  for (let m of d.path)
    try {
      let p = jl(m);
      d.relevantKeys.add(Ze(p[0]));
    } catch {}
  return (
    (d.traps = (e.traps ?? []).flatMap((m) => {
      try {
        let p = jl(m.line),
          g = null;
        try {
          g = ln(p[p.length - 1], t);
        } catch {
          g = null;
        }
        return [
          {
            key: Ze(p[0]),
            text: hl(Ic(m.line)),
            value: g,
            line: TZ(m.line),
            title: m.title,
            why: m.why,
          },
        ];
      } catch {
        return [];
      }
    })),
    (d.known = [n.answer, ...d.path, ...(e.traps ?? []).map((m) => m.line)].flatMap((m) => {
      try {
        return [Ic(m)];
      } catch {
        return [];
      }
    })),
    d
  );
}
function Tn(e, n) {
  try {
    return ln(n, e.env);
  } catch {
    return null;
  }
}
function RZ(e, n) {
  let t = { t: 's', q };
  for (let r of n) {
    let s = Tn(e, r);
    if (!s) return null;
    try {
      t = pl(t, s);
    } catch {
      return null;
    }
  }
  return t;
}
function fa(e) {
  return gl(e).flatMap((n) => {
    let t = We(n);
    return t.k === 'pow' && t.n >= 2 && t.n <= 12
      ? Array.from({ length: t.n }, () => We(t.e))
      : [t];
  });
}
var kt = (...e) => ({ ok: !0, kinds: e });
function VN(e, n, t) {
  let r = We(n),
    s = We(t),
    i = Tn(e, r),
    o = Tn(e, s);
  if (!i || !o || !Zt(i, o)) return !1;
  let a = Zn(r),
    l = Zn(s);
  if (a === l) return !0;
  let u = (c, f) => Gi(f) && ((c.k === 'name' && e.givenLit.has(c.n)) || Es(c));
  if (u(r, s) || u(s, r)) return !0;
  for (let c of new Set(e.objects.values())) if (c.written.has(a) && c.written.has(l)) return !0;
  return !1;
}
function WN(e, n) {
  let t = e.objects.get(Ze({ k: 'det', e: We(n) }));
  return !!t && !!t.form && mi(t.form) !== null;
}
function DN(e, n, t) {
  let r = We(n),
    s = We(t);
  if (r.k !== 'pow' || r.n !== -1) return 'no';
  let i = Tn(e, r.e);
  if (!i || i.t !== 'm' || i.r !== 2 || i.c !== 2) return 'no';
  let [[o, a], [l, u]] = i.a,
    c = {
      t: 'm',
      r: 2,
      c: 2,
      a: [
        [u, fe(a)],
        [fe(l), o],
      ],
    },
    f = I1(i.a),
    d = (h) => {
      let b = Tn(e, h);
      return !!b && b.t === 'm' && Zt(b, c);
    },
    m = !1,
    p = gl(s),
    g = p.filter((h) => We(h).k === 'lit');
  if (g.length === 1 && p.length > 1 && d(g[0])) {
    let h = RZ(
      e,
      p.filter((b) => We(b).k !== 'lit'),
    );
    h && h.t === 's' && M(N(h.q, f), q) && (m = !0);
  }
  if (s.k === 'div' && d(s.l)) {
    let h = Tn(e, s.r);
    h && h.t === 's' && M(h.q, f) && (m = !0);
  }
  return (s.k === 'lit' && M(f, q) && d(s) && (m = !0), m ? (WN(e, r.e) ? 'ok' : 'needDet') : 'no');
}
var ck = { same: 0, ok: 1, inverse: 2, needDet: 3, no: 4 },
  qw = (e, n) => (ck[e] >= ck[n] ? e : n);
function Pc(e, n, t) {
  let r = We(n),
    s = We(t);
  if (Zn(r) === Zn(s)) return 'same';
  if (r.k === 'mul' || s.k === 'mul') {
    let o = fa(r),
      a = fa(s);
    if (o.length > 10 || a.length > 10) return 'no';
    let l = new Map(),
      u = (c, f) => {
        if (c === o.length && f === a.length) return 'same';
        if (c === o.length || f === a.length) return 'no';
        let d = `${c},${f}`,
          m = l.get(d);
        if (m) return m;
        let p = 'no';
        for (let g = 1; c + g <= o.length; g++)
          for (let h = 1; f + h <= a.length; h++) {
            if (g > 1 && h > 1) continue;
            let b = o.slice(c, c + g),
              v = a.slice(f, f + h),
              k;
            if (g === 1 && h === 1) k = Pc(e, b[0], v[0]);
            else if (VN(e, ca(b), ca(v))) k = 'ok';
            else if (g === 1) {
              let w = DN(e, b[0], ca(v));
              k = w === 'ok' ? 'inverse' : w;
            } else k = 'no';
            if (k === 'no') continue;
            let y = u(c + g, f + h);
            if (y === 'no') continue;
            let S = qw(k, y);
            ck[S] < ck[p] && (p = S);
          }
        return (l.set(d, p), p);
      };
    return u(0, 0);
  }
  if (r.k === s.k && (r.k === 'add' || r.k === 'sub' || r.k === 'div')) {
    let o = s;
    return qw(Pc(e, r.l, o.l), Pc(e, r.r, o.r));
  }
  if (r.k === s.k && (r.k === 'neg' || r.k === 'tr' || r.k === 'det')) return Pc(e, r.e, s.e);
  if (r.k === 'pow' && s.k === 'pow' && r.n === s.n) {
    let o = Pc(e, r.e, s.e);
    if (o !== 'no') return o;
  }
  if (r.k === 'lit' && s.k === 'lit') {
    if (r.rows.length !== s.rows.length || r.rows[0].length !== s.rows[0].length) return 'no';
    let o = 'same';
    for (let a = 0; a < r.rows.length; a++)
      for (let l = 0; l < r.rows[0].length; l++) o = qw(o, Pc(e, r.rows[a][l], s.rows[a][l]));
    return o;
  }
  if (VN(e, r, s)) return 'ok';
  let i = DN(e, r, s);
  return i === 'ok' ? 'inverse' : i;
}
function $Z(e, n, t) {
  let r = fa(n);
  if (r.length !== 2) return null;
  let s = Tn(e, r[0]),
    i = Tn(e, r[1]);
  if (!s || !i || s.t !== 'm' || i.t !== 'm') return null;
  let o = We(t);
  if (o.k !== 'lit' || o.rows.length !== s.r || o.rows[0].length !== i.c) return null;
  for (let a = 0; a < s.r; a++)
    for (let l = 0; l < i.c; l++) {
      let u = [];
      for (let c = 0; c < s.c; c++) u.push(N(s.a[a][c], i.a[c][l]));
      if (!fk(o.rows[a][l], u)) return { i: a, j: l };
    }
  return 'ok';
}
function fk(e, n) {
  let t = v_(e);
  if (!t) return !1;
  let r = (s) => s.filter((i) => !L(i));
  return k_(r(t), r(n)) && (t.length > 1 || r(n).length <= 1);
}
function Ql(e, n) {
  let t = We(n),
    r = (i, o) => (i ? i.map((a) => ({ k: N(a.k, o), v: a.v })) : null);
  switch (t.k) {
    case 'add':
    case 'sub': {
      let i = Ql(e, t.l),
        o = Ql(e, t.r);
      return !i || !o ? null : [...i, ...(t.k === 'sub' ? r(o, fe(q)) : o)];
    }
    case 'neg':
      return r(Ql(e, t.e), fe(q));
    case 'mul': {
      let i = Tn(e, t.l),
        o = Tn(e, t.r);
      if (i?.t === 's' && o && o.t !== 's') return r(Ql(e, t.r), i.q);
      if (o?.t === 's' && i && i.t !== 's') return r(Ql(e, t.l), o.q);
      break;
    }
    case 'div': {
      let i = Tn(e, t.r);
      if (i?.t === 's' && !L(i.q)) return r(Ql(e, t.l), A(q, i.q));
      break;
    }
    default:
      break;
  }
  if (t.k !== 'name' && t.k !== 'lit') return null;
  let s = Tn(e, t);
  return s && s.t !== 's' ? [{ k: q, v: s }] : null;
}
var CZ = (e, n, t) => (e.t === 'm' ? e.a[n][t] : e.t === 'id' ? (n === t ? e.s : F) : e.q);
function EZ(e, n, t) {
  let r = We(t);
  if (r.k !== 'lit') return !1;
  let s = Ql(e, n);
  if (!s || s.length < 2) return !1;
  let i = r.rows.length,
    o = r.rows[0].length;
  if (s.some((a) => a.v.t === 'm' && (a.v.r !== i || a.v.c !== o))) return !1;
  for (let a = 0; a < i; a++)
    for (let l = 0; l < o; l++)
      if (
        !fk(
          r.rows[a][l],
          s.map((u) => N(u.k, CZ(u.v, a, l))),
        )
      )
        return !1;
  return !0;
}
function ua(e, n) {
  let t = We(n),
    r = (i, o = q) => new Map([[i, o]]),
    s = (i, o, a) => {
      let l = new Map(i);
      return (
        o.forEach((u, c) => {
          let f = re(l.get(c) ?? F, a === 1 ? u : fe(u));
          L(f) ? l.delete(c) : l.set(c, f);
        }),
        l
      );
    };
  switch (t.k) {
    case 'num':
      return r('', t.q);
    case 'name':
      return r(Es(t) ? '' : t.n);
    case 'lit':
      return r(Ze(t));
    case 'neg': {
      let i = ua(e, t.e);
      return i ? s(new Map(), i, -1) : null;
    }
    case 'add':
    case 'sub': {
      let i = ua(e, t.l),
        o = ua(e, t.r);
      return i && o ? s(i, o, t.k === 'add' ? 1 : -1) : null;
    }
    case 'mul': {
      let i = ua(e, t.l),
        o = ua(e, t.r);
      if (!i || !o || i.size * o.size > 64) return null;
      let a = new Map();
      return (
        i.forEach((l, u) =>
          o.forEach((c, f) => {
            a = s(a, r([u, f].filter(Boolean).join('\xB7'), N(l, c)), 1);
          }),
        ),
        a
      );
    }
    case 'pow': {
      if (Es(t)) return r('');
      if (t.n < 2 || t.n > 6) return r(Ze(t));
      let i = r('');
      for (let o = 0; o < t.n && i; o++)
        i = ua(e, { k: 'mul', l: { k: 'paren', e: MZ(i) }, r: t.e });
      return i;
    }
    case 'div': {
      let i = Tn(e, t.r),
        o = ua(e, t.l);
      if (!o || !i || i.t !== 's' || L(i.q)) return null;
      let a = new Map();
      return (o.forEach((l, u) => a.set(u, A(l, i.q))), a);
    }
    case 'det': {
      let i = Tn(e, t);
      return i && i.t === 's' ? r('', i.q) : null;
    }
    default:
      return r(Ze(t));
  }
}
function MZ(e) {
  let n = [...e.entries()].map(([t, r]) => {
    let s = { k: 'num', q: r, text: '' };
    if (!t) return s;
    let i = t.split('\xB7').map((o) => ({ k: 'name', n: o }));
    return { k: 'mul', l: s, r: ca(i) };
  });
  return n.length
    ? n.slice(1).reduce((t, r) => ({ k: 'add', l: t, r }), n[0])
    : { k: 'num', q: F, text: '0' };
}
var _Z = (e, n) =>
  !!e && !!n && e.size === n.size && [...e].every(([t, r]) => !!n.get(t) && M(n.get(t), r));
function qZ(e, n) {
  return Ql(e, n) !== null;
}
function fo(e, n) {
  let t = We(n);
  switch (t.k) {
    case 'mul': {
      let r = Tn(e, t.l),
        s = Tn(e, t.r);
      return r && s && r.t !== 's' && s.t !== 's' ? !0 : fo(e, t.l) || fo(e, t.r);
    }
    case 'add':
    case 'sub':
    case 'div':
      return fo(e, t.l) || fo(e, t.r);
    case 'neg':
      return fo(e, t.e);
    case 'pow': {
      let r = Tn(e, t.e);
      return !!r && r.t === 'm';
    }
    case 'tr':
    case 'det':
      return !0;
    case 'entry':
      return fo(e, t.e);
    case 'lit':
      return t.rows.some((r) => r.some((s) => fo(e, s)));
    default:
      return !1;
  }
}
function Ac(e, n = new Set()) {
  let t = We(e);
  return t.k === 'det'
    ? n
    : t.k === 'name'
      ? (/^I[₀-₉]*$/.test(t.n) || n.add(t.n), n)
      : (t.k === 'lit'
          ? t.rows.forEach((r) => r.forEach((s) => Ac(s, n)))
          : 'l' in t
            ? (Ac(t.l, n), Ac(t.r, n))
            : 'e' in t && Ac(t.e, n),
        n);
}
function BN(e) {
  let n = We(e);
  if (n.k === 'mul') {
    let t = gl(n),
      r = t.filter((i) => !Es(i)),
      s = t.length - r.length;
    return r.length ? { e: ca(r), dropped: s } : { e: { k: 'name', n: 'I' }, dropped: s };
  }
  return n.k === 'pow' && Es(n) ? { e: { k: 'name', n: 'I' }, dropped: 1 } : { e: n, dropped: 0 };
}
var Ow = (e) => Gi(e) || mi(e) !== null || Es(e),
  zN = {
    ok: !1,
    title: 'Une \xE9tape \xE0 la fois',
    message:
      'Je ne vois pas comment on passe de ta ligne pr\xE9c\xE9dente \xE0 celle-ci : \xE9cris une \xE9tape de plus.',
  },
  UN = {
    ok: !1,
    title: 'Le d\xE9terminant d\u2019abord',
    message:
      'Calcule d\u2019abord le d\xE9terminant : il dit si la matrice est inversible, et par quoi diviser.',
  };
function Lw(e, n) {
  let t = We(n);
  if (Gi(t) || Es(t) || (t.k === 'name' && e.givenLit.has(t.n))) return Tn(e, t);
  let r = Zn(t);
  for (let s of new Set(e.objects.values()))
    if (s.form && (Gi(s.form) || Es(s.form)) && s.written.has(r)) return s.value;
  return null;
}
function LZ(e, n, t) {
  let r = mi(t);
  if (r !== null && Lw(e, n.e)) return kt('entry');
  let s = fa(n.e),
    i = n.i - 1,
    o = n.j - 1;
  for (let a = 1; a < s.length; a++) {
    let l = Lw(e, ca(s.slice(0, a))),
      u = Lw(e, ca(s.slice(a)));
    if (!l || !u || l.t !== 'm' || u.t !== 'm' || l.c !== u.r || i >= l.r || o >= u.c) continue;
    let c = [];
    for (let f = 0; f < l.c; f++) c.push(N(l.a[i][f], u.a[f][o]));
    if (_r(t) > 0 && fk(t, c)) return kt('entryProduct');
  }
  return r !== null && fo(e, n.e)
    ? {
        ok: !1,
        title: 'Montre le calcul',
        message: `\xC9cris le coefficient (${n.i}, ${n.j}) : la ligne ${n.i} de la premi\xE8re matrice par la colonne ${n.j} de la seconde, terme \xE0 terme.`,
      }
    : null;
}
function uk(e, n, t, r, s = 0) {
  let i = We(t),
    o = We(r);
  if (Ze(i) === Ze(o)) return kt();
  if (i.k === 'entry') {
    let g = LZ(e, i, o);
    if (g) return g;
  }
  let a = e.equation;
  if (a && n.target && Ze(i) === a.unknown) {
    let g = { k: 'pow', e: a.coef, n: -1, text: '\u207B\xB9' },
      h = a.side === 'left' ? { k: 'mul', l: g, r: a.right } : { k: 'mul', l: a.right, r: g };
    return Zn(o) === Zn(h)
      ? kt('solve')
      : {
          ok: !1,
          title: 'Isole X',
          message:
            a.side === 'left'
              ? 'Pour isoler X dans AX = B, multiplie \xE0 gauche par A\u207B\xB9 : X = A\u207B\xB9B.'
              : 'Pour isoler X dans XA = B, multiplie \xE0 droite par A\u207B\xB9 : X = BA\u207B\xB9.',
        };
  }
  let l = pd(i),
    u = pd(o);
  if (l && u && l.length === u.length && l.every((g, h) => g.base === u[h].base && g.n === u[h].n))
    return kt('power');
  let c = BN(i),
    f = BN(o);
  if (c.dropped > f.dropped && Zn(c.e) === Zn(f.e)) return kt('identity');
  let d = Pc(e, i, o);
  if (d === 'same') return kt();
  if (d === 'ok') return kt('substitute');
  if (d === 'inverse') return kt('inverse');
  if (d === 'needDet') return UN;
  if (i.k === 'pow' && i.n === -1) {
    let g = Tn(e, i.e),
      h = Tn(e, o);
    if (h && g) {
      let b = (k) => {
        if (Es(k)) return !0;
        let y = Tn(e, k);
        return !!y && Gi(k) && Zt(y, { t: 'id', s: q });
      };
      if (
        e.lines.some(({ members: k }) => {
          let y = fa(k[0]);
          if (y.length !== 2) return !1;
          let S = Tn(e, y[0]),
            w = Tn(e, y[1]);
          return !S || !w
            ? !1
            : ((Zt(S, g) && Zt(w, h)) || (Zt(S, h) && Zt(w, g))) && b(k[k.length - 1]);
        })
      )
        return kt('inverseCheck');
      if (Ow(o))
        return g.t === 'm' && g.r === 2 && !WN(e, i.e)
          ? UN
          : {
              ok: !1,
              title: 'Montre le calcul',
              message:
                g.t === 'm' && g.r === 2
                  ? '\xC9cris l\u2019inverse avec la formule : (1 \xF7 det A) \xD7 [d, \u2212b ; \u2212c, a].'
                  : 'V\xE9rifie d\u2019abord que le produit de la matrice par celle que tu proposes donne I.',
            };
    }
  }
  if (i.k === 'det') {
    let g = Tn(e, i.e);
    if (g && g.t === 'm' && g.r === 2 && g.c === 2) {
      let h = [N(g.a[0][0], g.a[1][1]), fe(N(g.a[0][1], g.a[1][0]))];
      if (_r(o) > 0 && fk(o, h)) return kt('det');
      if (mi(o) !== null)
        return {
          ok: !1,
          title: 'Montre le calcul',
          message: '\xC9cris le calcul du d\xE9terminant : a \xD7 d \u2212 b \xD7 c.',
        };
    }
  }
  if (i.k === 'tr' && o.k === 'lit' && Gi(o))
    return We(i.e).k !== 'lit' && We(i.e).k !== 'name' ? zN : kt('transpose');
  let m = $Z(e, i, o);
  if (m === 'ok') return kt('product');
  if (m && Gi(o))
    return {
      ok: !1,
      title: 'Montre le calcul',
      message: '\xC9cris le produit ligne par colonne avant de donner le r\xE9sultat.',
    };
  if (m)
    return {
      ok: !1,
      title: 'Montre le calcul',
      message: `\xC9cris le coefficient (${m.i + 1}, ${m.j + 1}) : la ligne ${m.i + 1} de la premi\xE8re matrice par la colonne ${m.j + 1} de la seconde, terme \xE0 terme.`,
    };
  if (EZ(e, i, o)) return kt('entrywise');
  let p = ua(e, i);
  if (p && [...p.keys()].some((g) => g !== '') && _Z(p, ua(e, o))) return kt('expand');
  if (s < 4) {
    if (i.k === o.k && (i.k === 'add' || i.k === 'sub')) {
      let g = o,
        h = uk(e, n, i.l, g.l, s + 1),
        b = uk(e, n, i.r, g.r, s + 1);
      return h.ok ? (b.ok ? kt(...h.kinds, ...b.kinds) : b) : h;
    }
    if (i.k === 'mul' || o.k === 'mul') {
      let g = fa(i),
        h = fa(o),
        b = 0;
      for (; b < g.length - 1 && b < h.length - 1 && Zn(g[b]) === Zn(h[b]); ) b++;
      let v = 0;
      for (
        ;
        v < g.length - 1 - b &&
        v < h.length - 1 - b &&
        Zn(g[g.length - 1 - v]) === Zn(h[h.length - 1 - v]);
      )
        v++;
      let k = g.slice(b, g.length - v),
        y = h.slice(b, h.length - v);
      if (b + v > 0 && k.length && y.length) return uk(e, n, ca(k), ca(y), s + 1);
    }
  }
  if (i.k === 'lit' && o.k === 'lit' && _r(o) < _r(i)) return kt('compute');
  if (o.k === 'lit' && qZ(e, i) && !Gi(i)) {
    let g = [...Ac(i)];
    return g.length
      ? {
          ok: !1,
          title: 'Montre le calcul',
          message: `Remplace d\u2019abord ${g.join(', ')} par sa matrice, puis calcule coefficient par coefficient.`,
        }
      : kt('entrywise');
  }
  if (i.k === 'lit' && o.k === 'mul') {
    let g = gl(o);
    if (g.length === 2 && mi(g[0]) !== null && We(g[1]).k === 'lit') return kt('factor');
  }
  return !fo(e, i) &&
    [...sc(o)].every((g) => sc(i).has(g)) &&
    [...Ac(i)].every((g) => Ac(o).has(g)) &&
    _r(o) < _r(i)
    ? kt('compute')
    : Ow(o) && fo(e, i)
      ? {
          ok: !1,
          title: 'Montre le calcul',
          message: '\xC9cris le produit ligne par colonne avant de donner le r\xE9sultat.',
        }
      : zN;
}
function GN(e, n) {
  if (e.relevantKeys.has(Ze(We(n)))) return !0;
  let t = We(e.target.start);
  if (t.k === 'pow' && t.n === -1) {
    let i = fa(n);
    if (i.length === 2 && i.some((o) => Zn(o) === Zn(t.e))) return !0;
  }
  let r = pd(n);
  if (!r || r.length !== 1) return !1;
  let s = pd(e.target.start);
  return !!s && s.some((i) => i.base === r[0].base && i.n >= r[0].n);
}
function Pw(e, n) {
  let t = We(n),
    r = e.objects.get(Ze(t));
  if (r) return r;
  let s = Zn(t);
  for (let i of new Set(e.objects.values())) if (i.form && Zn(i.form) === s) return i;
}
function NZ(e, n) {
  return e.known.some((t) => t.length > n.length && n.every((r, s) => t[s] === r));
}
function OZ(e, n, t) {
  let r = n.value,
    s = We(n.start);
  if (s.k === 'entry' && t.t === 's') {
    let o = We(s.e);
    if (o.k === 'pow' && o.n >= 2) {
      let a = Tn(e, { k: 'entry', e: o.e, i: s.i, j: s.j });
      if (a && a.t === 's' && M(a.q, t.q) && !Zt(a, r))
        return {
          title: 'La puissance',
          message: `C\u2019est le coefficient de la matrice elle-m\xEAme : il faut celui de sa puissance ${o.text}.`,
        };
    }
  }
  if (r.t === 'm' && t.t === 'm' && (r.r !== t.r || r.c !== t.c))
    return {
      title: 'Pas la bonne taille',
      message: `Le r\xE9sultat est une matrice ${r.r} \xD7 ${r.c} (${r.r} ligne${r.r > 1 ? 's' : ''}, ${r.c} colonne${r.c > 1 ? 's' : ''}).`,
    };
  let i = fa(n.start);
  if (i.length === 2) {
    let o = Tn(e, i[0]),
      a = Tn(e, i[1]);
    if (o && a && o.t === 'm' && a.t === 'm') {
      try {
        if (Zt(t, pl(a, o)) && !Zt(t, r))
          return {
            title: 'Pas le bon ordre',
            message:
              'Le produit de matrices d\xE9pend de l\u2019ordre : tu as calcul\xE9 le produit dans l\u2019autre sens.',
          };
      } catch {}
      if (o.r === a.r && o.c === a.c && t.t === 'm' && t.r === o.r && t.c === o.c) {
        let l = o.a.map((u, c) => u.map((f, d) => N(f, a.a[c][d])));
        if (Zt(t, { t: 'm', r: o.r, c: o.c, a: l }))
          return {
            title: 'Ligne par colonne',
            message:
              'Un produit de matrices ne se calcule pas coefficient par coefficient : c\u2019est ligne par colonne.',
          };
      }
    }
  }
  if (r.t === 'm' && t.t === 'm') {
    for (let o = 0; o < r.r; o++)
      for (let a = 0; a < r.c; a++)
        if (!M(r.a[o][a], t.a[o][a]))
          return {
            title: 'Calcul faux',
            message: `Le coefficient (${o + 1}, ${a + 1}) ne va pas.`,
          };
  }
  return r.t === 'id' && t.t === 'm'
    ? { title: 'Calcul faux', message: 'Ce n\u2019est pas la bonne matrice.' }
    : { title: 'Calcul faux', message: 'Ce n\u2019est pas la bonne valeur.' };
}
function JN(e, n, t) {
  let r = n.flatMap((a) => a.atoms);
  if (!r.length) return { kind: 'empty', atoms: r, badChip: -1 };
  let s = NZ(e, r),
    i;
  try {
    i = F1(r);
  } catch (a) {
    return a instanceof Cs || (s && !t?.verify)
      ? t?.verify
        ? { kind: 'syntax', atoms: r, title: 'Ligne inachev\xE9e', message: 'Termine ta ligne.' }
        : { kind: s ? 'building' : 'open', atoms: r, complete: !1 }
      : {
          kind: 'syntax',
          atoms: r,
          title: '\xC7a ne se lit pas',
          message: a instanceof Mr ? a.message : String(a),
          badChip: n.length - 1,
        };
  }
  if (i.length < 2)
    return t?.verify
      ? {
          kind: 'syntax',
          atoms: r,
          line: Kw(r),
          title: 'Une \xE9galit\xE9',
          message: '\xC9cris une \xE9galit\xE9 : \xAB AB = \u2026 \xBB.',
        }
      : { kind: s ? 'building' : 'open', atoms: r, complete: !1 };
  let o = KZ(e, r, i);
  return s && !t?.verify
    ? o.kind === 'step'
      ? { ...o, kind: 'ready', complete: !0 }
      : { kind: 'building', atoms: r, complete: !0 }
    : !t?.verify && (o.kind === 'unjustified' || o.kind === 'false')
      ? { kind: 'pending', atoms: r, complete: !0 }
      : { ...o, complete: !0 };
}
function KZ(e, n, t) {
  let r = Kw(n),
    s = { atoms: n, line: r };
  if (e.givenTexts.has(hl(n)))
    return {
      kind: 'useless',
      ...s,
      title: 'C\u2019est l\u2019\xE9nonc\xE9',
      message: 'Cette ligne est d\xE9j\xE0 dans l\u2019\xE9nonc\xE9 : \xE9cris le calcul suivant.',
    };
  let i = We(t[0]),
    o = Ze(i),
    a = Pw(e, i),
    l,
    u,
    c = [];
  if (a) u = [a.form ?? a.start, ...t.slice(1)];
  else if (i.k === 'name' && !e.env.has(i.n) && !/^I/.test(i.n)) {
    if (Ow(t[1]))
      return {
        kind: 'unjustified',
        ...s,
        title: 'D\u2019o\xF9 vient-elle ?',
        message: `Un nouveau nom se d\xE9finit par un calcul : \xE9cris d\u2019abord ce que vaut ${i.n} avec les matrices de l\u2019\xE9nonc\xE9.`,
      };
    let h;
    try {
      h = ln(t[1], e.env);
    } catch (b) {
      return { kind: 'false', ...s, title: 'Calcul impossible', message: b.message };
    }
    ((l = { name: i.n, value: h }),
      (a = {
        key: o,
        start: t[1],
        value: h,
        form: null,
        written: new Set([Zn(i)]),
        target: !1,
        relevant: GN(e, i),
      }),
      (u = t.slice(1)),
      c.push('define'));
  } else {
    let h;
    try {
      h = ln(i, e.env);
    } catch (b) {
      return Nw(e, o, null, s, {
        title:
          b instanceof ft && b.code === 'size' ? 'Les tailles ne vont pas' : 'Calcul impossible',
        message: b.message,
      });
    }
    ((a = {
      key: o,
      start: i,
      value: h,
      form: null,
      written: new Set([Zn(i)]),
      target: !1,
      relevant: GN(e, i),
    }),
      (u = t));
  }
  for (let h of t.slice(l ? 1 : 0)) {
    let b;
    try {
      b = ln(h, e.env);
    } catch (v) {
      return Nw(e, a.key, null, s, {
        title:
          v instanceof ft && v.code === 'size' ? 'Les tailles ne vont pas' : 'Calcul impossible',
        message: v.message,
      });
    }
    if (!Zt(b, a.value)) return Nw(e, a.key, b, s, OZ(e, a, b));
  }
  if (!a.relevant)
    return {
      kind: 'useless',
      ...s,
      title: 'Juste, mais \xE0 c\xF4t\xE9',
      message: 'C\u2019est juste, mais ce calcul ne sert pas pour la question.',
    };
  for (let h = 0; h + 1 < u.length; h++) {
    let b = uk(e, a, u[h], u[h + 1]);
    if (!b.ok) return { kind: 'unjustified', ...s, title: b.title, message: b.message };
    c.push(...b.kinds);
  }
  let f = t[t.length - 1];
  if (!c.length)
    return {
      kind: 'useless',
      ...s,
      title: 'Rien de nouveau',
      message: 'Cette ligne redit ce qui est d\xE9j\xE0 \xE9crit.',
    };
  let d = a.target && !e.concluded && (Zn(f) === Zn(e.answerLast) || (ZN(e.answerLast) && ZN(f))),
    m = c.reduce((h, b) => h + kg[b].hora, 0),
    p = c.reduce((h, b) => (kg[b].hora >= kg[h].hora ? b : h), c[0]),
    g = [...new Set(c)].map((h) => kg[h].why).join(' ') + (d ? ' C\u2019est la r\xE9ponse.' : '');
  return {
    kind: 'step',
    ...s,
    hora: m,
    final: d,
    rule: { id: wZ[p], card: SZ, label: kg[p].label, hora: m, why: g },
    mmove: { key: a.key, members: t, ...(l ? { define: l } : {}), ...(d ? { final: d } : {}) },
  };
}
var ZN = (e) => Gi(e) || mi(e) !== null || Es(e);
function Nw(e, n, t, r, s) {
  let i = hl(r.atoms),
    o = e.traps.find((a) => a.text === i || (a.key === n && !!t && !!a.value && Zt(t, a.value)));
  return o
    ? {
        kind: 'trap',
        ...r,
        title: o.title,
        message: o.why,
        trap: { line: o.line, title: o.title, why: o.why },
      }
    : { kind: 'false', ...r, title: s.title, message: s.message };
}
function XN(e, n) {
  let t = n.mmove;
  if (!t) return;
  let r = e.objects.get(t.key);
  if (
    (t.define &&
      (e.env.set(t.define.name, t.define.value),
      r ||
        ((r = {
          key: t.key,
          start: t.members[1],
          value: t.define.value,
          form: null,
          written: new Set(),
          target: !1,
          relevant: !0,
        }),
        e.objects.set(t.key, r))),
    r || (r = Pw(e, t.members[0])),
    !r)
  ) {
    let s = t.members[0];
    ((r = {
      key: t.key,
      start: s,
      value: ln(s, e.env),
      form: null,
      written: new Set(),
      target: !1,
      relevant: !0,
    }),
      e.objects.set(t.key, r));
  }
  (t.members.forEach((s) => r.written.add(Zn(s))),
    (r.form = t.members[t.members.length - 1]),
    e.lines.push({ key: r.key, members: t.members }),
    t.final && (e.concluded = !0));
}
function YN(e) {
  return e.concluded;
}
function PZ(e) {
  try {
    return jl(e);
  } catch {
    return null;
  }
}
function e2(e, n) {
  let t = PZ(n);
  if (!t || t.length < 2) return !1;
  try {
    let r = We(t[0]),
      s = Pw(e, r),
      i = s ? s.value : ln(r, e.env);
    return t.every((o) => Zt(ln(o, e.env), i));
  } catch {
    return !1;
  }
}
var Qn = class extends Error {},
  mo = class extends Error {},
  po = '\u2212',
  IZ = /^(?:PGCD|pgcd|gcd)\s*\(\s*([−-]?)\s*(\d+)\s*[;,]\s*([−-]?)\s*(\d+)\s*\)/,
  AZ = /^(?:PPCM|ppcm|lcm)\s*\(\s*([−-]?)\s*(\d+)\s*[;,]\s*([−-]?)\s*(\d+)\s*\)/,
  jZ = /^[⁰¹²³⁴⁵⁶⁷⁸⁹]+/,
  s2 = '\u2070\xB9\xB2\xB3\u2074\u2075\u2076\u2077\u2078\u2079',
  QZ = /^\[\s*(\d+)\s*\]/,
  FZ = /^\d+/,
  VZ = /^[a-zA-Z](?:[₀-₉]+)?/,
  DZ = {
    '+': '+',
    '-': po,
    [po]: po,
    '\xD7': '\xD7',
    '*': '\xD7',
    '\xB7': '\xD7',
    '(': '(',
    ')': ')',
    '=': '=',
    '\u2261': '\u2261',
    ';': ';',
    '\xF7': '\xF7',
    '/': '\xF7',
  },
  jw = (e) => !!e && /^PGCD\(/.test(e),
  n2 = (e) => !!e && /^\[\d+\]$/.test(e),
  Qw = (e) => !!e && /^PPCM\(/.test(e),
  Fw = (e) => !!e && /^[⁰¹²³⁴⁵⁶⁷⁸⁹]+$/.test(e),
  pk = (e, n) => `PPCM(${Fc(e)} ; ${Fc(n)})`,
  BZ = (e) =>
    String(e)
      .split('')
      .map((n) => s2[Number(n)])
      .join(''),
  zZ = (e) => BigInt([...e].map((n) => s2.indexOf(n)).join('')),
  gk = (e, n) => `PGCD(${Fc(e)} ; ${Fc(n)})`;
var Fc = (e) => (e < 0n ? po + String(-e) : String(e));
function Yd(e) {
  let n = [],
    t = e.replace(/\u202f|\u00a0/g, ' ');
  for (; t.length; ) {
    let r = /^\s+/.exec(t);
    if (r) {
      t = t.slice(r[0].length);
      continue;
    }
    let s = IZ.exec(t);
    if (s) {
      let f = BigInt(s[2]) * (s[1] ? -1n : 1n),
        d = BigInt(s[4]) * (s[3] ? -1n : 1n);
      (n.push(gk(f, d)), (t = t.slice(s[0].length)));
      continue;
    }
    let i = AZ.exec(t);
    if (i) {
      let f = BigInt(i[2]) * (i[1] ? -1n : 1n),
        d = BigInt(i[4]) * (i[3] ? -1n : 1n);
      (n.push(pk(f, d)), (t = t.slice(i[0].length)));
      continue;
    }
    let o = jZ.exec(t);
    if (o) {
      (n.push(o[0]), (t = t.slice(o[0].length)));
      continue;
    }
    let a = QZ.exec(t);
    if (a) {
      (n.push(`[${BigInt(a[1])}]`), (t = t.slice(a[0].length)));
      continue;
    }
    let l = FZ.exec(t);
    if (l) {
      (n.push(String(BigInt(l[0]))), (t = t.slice(l[0].length)));
      continue;
    }
    let u = VZ.exec(t);
    if (u) {
      (n.push(u[0]), (t = t.slice(u[0].length)));
      continue;
    }
    let c = DZ[t[0]];
    if (c) {
      (n.push(c), (t = t.slice(1)));
      continue;
    }
    throw new Qn(`\xAB ${t[0]} \xBB ne se lit pas ici.`);
  }
  return n;
}
var Vw = (e) => !!e && /^\d+$/.test(e),
  i2 = (e) => !!e && /^[a-zA-Z][₀-₉]*$/.test(e),
  Iw = class {
    constructor(n) {
      this.a = n;
    }
    a;
    i = 0;
    peek() {
      return this.a[this.i];
    }
    next() {
      return this.a[this.i++];
    }
    end() {
      return this.i >= this.a.length;
    }
  };
function Aw(e) {
  let n = [],
    t = 1;
  for (e.peek() === '+' && e.next(), n.push({ s: t, e: t2(e) }); ; ) {
    let r = e.peek();
    if (r !== '+' && r !== po) break;
    (e.next(), (t = r === '+' ? 1 : -1), n.push({ s: t, e: t2(e) }));
  }
  return n.length === 1 && n[0].s === 1 ? n[0].e : { k: 'add', t: n };
}
var UZ = (e) => Vw(e) || i2(e) || jw(e) || Qw(e) || e === '(';
function t2(e) {
  let n = [mk(e)];
  for (;;) {
    let t = e.peek();
    if (t === '\xD7') {
      (e.next(), n.push(mk(e)));
      continue;
    }
    if (t === '\xF7')
      throw new Qn('\xC9cris la division euclidienne sous la forme \xAB a = q \xD7 b + r \xBB.');
    if (UZ(t)) {
      let r = n[n.length - 1];
      if (Vw(t) && (r.k === 'num' || r.k === 'neg' || r.k === 'pow'))
        throw new Qn('Il manque une op\xE9ration entre deux nombres.');
      n.push(mk(e));
      continue;
    }
    break;
  }
  return n.length === 1 ? n[0] : { k: 'mul', f: n };
}
function mk(e) {
  return e.peek() === po ? (e.next(), { k: 'neg', e: mk(e) }) : GZ(e);
}
function GZ(e) {
  let n = ZZ(e);
  for (; Fw(e.peek()); ) {
    let t = zZ(e.next());
    if (t > 64n) throw new Qn('Un exposant plus petit, s\u2019il te pla\xEEt.');
    n = { k: 'pow', b: n, e: t };
  }
  return n;
}
function ZZ(e) {
  let n = e.next();
  if (n === void 0) throw new mo('ligne inachev\xE9e');
  if (Vw(n)) return { k: 'num', v: BigInt(n) };
  if (jw(n)) {
    let t = /^PGCD\((−?\d+) ; (−?\d+)\)$/.exec(n);
    return { k: 'gcd', a: dk(t[1]), b: dk(t[2]) };
  }
  if (Qw(n)) {
    let t = /^PPCM\((−?\d+) ; (−?\d+)\)$/.exec(n);
    return { k: 'lcm', a: dk(t[1]), b: dk(t[2]) };
  }
  if (Fw(n)) throw new Qn('Un exposant se place apr\xE8s un nombre.');
  if (i2(n)) return { k: 'sym', n };
  if (n === '(') {
    if (e.end()) throw new mo('parenth\xE8se ouverte');
    let t = Aw(e);
    if (e.end()) throw new mo('parenth\xE8se ouverte');
    if (e.next() !== ')') throw new Qn('Une parenth\xE8se n\u2019est pas ferm\xE9e.');
    return { k: 'paren', e: t };
  }
  throw n === ')'
    ? new Qn('Une parenth\xE8se ferm\xE9e de trop.')
    : new Qn(`\xAB ${n} \xBB ne se place pas l\xE0.`);
}
var dk = (e) => (e.startsWith(po) ? -BigInt(e.slice(1)) : BigInt(e));
function HZ(e) {
  if (!e.length) throw new mo('membre vide');
  let n = null,
    t = e;
  if (
    n2(e[e.length - 1]) &&
    ((n = BigInt(e[e.length - 1].slice(1, -1))), (t = e.slice(0, -1)), n < 2n)
  )
    throw new Qn('Le modulo est un entier sup\xE9rieur ou \xE9gal \xE0 2.');
  if (t.some((o) => n2(o)))
    throw new Qn('Le modulo \xAB [n] \xBB s\u2019\xE9crit \xE0 la fin de la ligne.');
  let r = new Iw(t),
    s = [Aw(r)],
    i = [];
  for (; !r.end(); ) {
    let o = r.next();
    if (o !== '=' && o !== '\u2261') throw new Qn(`\xAB ${o} \xBB ne se place pas l\xE0.`);
    if (r.end()) throw new mo('membre vide');
    (i.push(o), s.push(Aw(r)));
  }
  if (n !== null && !i.includes('\u2261'))
    throw new Qn('Un modulo \xAB [n] \xBB va avec \xAB \u2261 \xBB.');
  if (n === null && i.includes('\u2261')) throw new mo('modulo \xE0 \xE9crire');
  return { members: s, rels: i, mod: n };
}
function wg(e) {
  let n = [[]];
  return (
    e.forEach((t) => (t === ';' ? n.push([]) : n[n.length - 1].push(t))),
    { parts: n.map(HZ) }
  );
}
function ki(e) {
  switch (e.k) {
    case 'num':
      return Fc(e.v);
    case 'gcd':
      return gk(e.a, e.b);
    case 'lcm':
      return pk(e.a, e.b);
    case 'pow':
      return ki(e.b) + BZ(e.e);
    case 'sym':
      return e.n;
    case 'paren':
      return `(${ki(e.e)})`;
    case 'neg':
      return po + ki(e.e);
    case 'mul':
      return e.f
        .map((n, t) => {
          let r = ki(n),
            s = e.f[t - 1];
          return t ? (s && s.k === 'num' && n.k === 'sym' ? r : ' \xD7 ' + r) : r;
        })
        .join('');
    case 'add':
      return e.t
        .map((n, t) =>
          t === 0 ? (n.s < 0 ? po : '') + ki(n.e) : (n.s < 0 ? ` ${po} ` : ' + ') + ki(n.e),
        )
        .join('');
  }
}
function WZ(e) {
  let n = ki(e.members[0]);
  return (
    e.rels.forEach((t, r) => (n += ` ${t} ${ki(e.members[r + 1])}`)),
    e.mod !== null ? `${n} [${e.mod}]` : n
  );
}
function os(e) {
  try {
    return wg(e).parts.map(WZ).join(' ; ');
  } catch {
    return e.join(' ');
  }
}
var rt = (e) => (e < 0n ? -e : e);
function Sg(e, n) {
  let t = rt(e),
    r = rt(n);
  for (; r; ) [t, r] = [r, t % r];
  return t;
}
function hk(e, n) {
  return e === 0n || n === 0n ? 0n : rt(e * n) / Sg(e, n);
}
function lr(e, n) {
  switch (e.k) {
    case 'num':
      return e.v;
    case 'gcd':
      return Sg(e.a, e.b);
    case 'lcm':
      return hk(e.a, e.b);
    case 'pow': {
      let t = lr(e.b, n);
      return t === null ? null : t ** e.e;
    }
    case 'sym':
      return n?.get(e.n) ?? null;
    case 'paren':
      return lr(e.e, n);
    case 'neg': {
      let t = lr(e.e, n);
      return t === null ? null : -t;
    }
    case 'mul': {
      let t = 1n;
      for (let r of e.f) {
        let s = lr(r, n);
        if (s === null) return null;
        t *= s;
      }
      return t;
    }
    case 'add': {
      let t = 0n;
      for (let r of e.t) {
        let s = lr(r.e, n);
        if (s === null) return null;
        t += BigInt(r.s) * s;
      }
      return t;
    }
  }
}
function Tt(e) {
  if (e.k === 'num') return e.v;
  if (e.k === 'paren') return Tt(e.e);
  if (e.k === 'neg') {
    let n = Tt(e.e);
    return n === null ? null : -n;
  }
  return null;
}
function Qc(e, n = new Set()) {
  return (
    e.k === 'sym'
      ? n.add(e.n)
      : e.k === 'paren' || e.k === 'neg'
        ? Qc(e.e, n)
        : e.k === 'pow'
          ? Qc(e.b, n)
          : e.k === 'mul'
            ? e.f.forEach((t) => Qc(t, n))
            : e.k === 'add' && e.t.forEach((t) => Qc(t.e, n)),
    n
  );
}
function Fl(e) {
  return e.k === 'gcd'
    ? !0
    : e.k === 'paren' || e.k === 'neg'
      ? Fl(e.e)
      : e.k === 'pow'
        ? Fl(e.b)
        : e.k === 'mul'
          ? e.f.some(Fl)
          : e.k === 'add'
            ? e.t.some((n) => Fl(n.e))
            : !1;
}
function Vl(e) {
  return e.k === 'lcm'
    ? !0
    : e.k === 'paren' || e.k === 'neg'
      ? Vl(e.e)
      : e.k === 'pow'
        ? Vl(e.b)
        : e.k === 'mul'
          ? e.f.some(Vl)
          : e.k === 'add'
            ? e.t.some((n) => Vl(n.e))
            : !1;
}
function jc(e) {
  return e.k === 'paren'
    ? e.e.k === 'add' || jc(e.e)
    : e.k === 'neg'
      ? jc(e.e)
      : e.k === 'pow'
        ? jc(e.b)
        : e.k === 'mul'
          ? e.f.some(jc)
          : e.k === 'add'
            ? e.t.some((n) => jc(n.e))
            : !1;
}
var o2 = (e) => (e.k === 'add' ? e.t.length : 1);
function a2(e, n) {
  let t = rt(e) >= rt(n) ? rt(e) : rt(n),
    r = rt(e) >= rt(n) ? rt(n) : rt(e);
  if (r === 0n) throw new Qn('Le PGCD avec 0 ne demande pas l\u2019algorithme.');
  let s = [t, r],
    i = [0n];
  for (; r; ) {
    i.push(t / r);
    let o = t % r;
    if ((s.push(o), ([t, r] = [r, o]), s.length > 60)) throw new Qn('Algorithme trop long.');
  }
  return { r: s, q: i, m: s.length - 2 };
}
function go(e) {
  return [...e.entries()]
    .filter(([, n]) => n !== 0n)
    .sort((n, t) => n[0] - t[0])
    .map(([n, t]) => `${n}:${t}`)
    .join(',');
}
var JZ = (e) => `${go(e.lin)}|${e.c}`;
function xg(e, n) {
  let t = new Map();
  return (e.forEach((r, s) => r * n !== 0n && t.set(s, r * n)), t);
}
function l2(e, n) {
  let t = new Map(e);
  return (
    n.forEach((r, s) => {
      let i = (t.get(s) ?? 0n) + r;
      i === 0n ? t.delete(s) : t.set(s, i);
    }),
    t
  );
}
var r2 = (e, n) => {
  let t = new Set(),
    r = [];
  for (let s of e) {
    let i = JZ(s);
    if (!t.has(i) && (t.add(i), r.push(s), r.length >= n)) break;
  }
  return r;
};
function yg(e, n, t = 256) {
  switch (e.k) {
    case 'num': {
      let r = [{ lin: new Map(), c: e.v }],
        s = n.get(e.v);
      return (s !== void 0 && r.push({ lin: new Map([[s, 1n]]), c: 0n }), r);
    }
    case 'gcd':
      return [{ lin: new Map(), c: Sg(e.a, e.b) }];
    case 'lcm':
      return [{ lin: new Map(), c: hk(e.a, e.b) }];
    case 'pow': {
      let r = lr(e);
      return r === null ? [] : [{ lin: new Map(), c: r }];
    }
    case 'sym':
      return [];
    case 'paren':
      return yg(e.e, n, t);
    case 'neg':
      return yg(e.e, n, t).map((r) => ({ lin: xg(r.lin, -1n), c: -r.c }));
    case 'add': {
      let r = [{ lin: new Map(), c: 0n }];
      for (let s of e.t) {
        let i = yg(s.e, n, t),
          o = [];
        for (let a of r)
          for (let l of i)
            o.push({ lin: l2(a.lin, xg(l.lin, BigInt(s.s))), c: a.c + BigInt(s.s) * l.c });
        r = r2(o, t);
      }
      return r;
    }
    case 'mul': {
      let r = [{ lin: new Map(), c: 1n }];
      for (let s of e.f) {
        let i = yg(s, n, t),
          o = [];
        for (let a of r)
          for (let l of i)
            (a.lin.size && l.lin.size) ||
              (a.lin.size
                ? o.push({ lin: xg(a.lin, l.c), c: 0n })
                : l.lin.size
                  ? o.push({ lin: xg(l.lin, a.c), c: 0n })
                  : o.push({ lin: new Map(), c: a.c * l.c }));
        r = r2(o, t);
      }
      return r;
    }
  }
}
var Dw = (e, n) =>
  yg(e, n)
    .filter((t) => t.c === 0n && t.lin.size > 0)
    .map((t) => t.lin);
function u2(e, n, t) {
  let r = e.get(n);
  if (r === void 0) return e;
  let s = new Map(e);
  return (s.delete(n), l2(s, xg(t, r)));
}
function XZ(e) {
  if (e < 2n) return !1;
  for (let n = 2n; n * n <= e; n++) if (e % n === 0n) return !1;
  return !0;
}
function bk(e) {
  let n = e.k === 'paren' ? e.e : e,
    t = n.k === 'mul' ? n.f : [n],
    r = [];
  for (let s of t) {
    let i = s.k === 'paren' ? s.e : s;
    if (i.k === 'num' && i.v > 0n) r.push({ b: i.v, e: 1 });
    else if (i.k === 'pow') {
      let o = i.b.k === 'paren' ? i.b.e : i.b;
      if (o.k !== 'num' || o.v <= 0n) return null;
      r.push({ b: o.v, e: Number(i.e) });
    } else return null;
  }
  return r;
}
function vk(e) {
  let n = bk(e);
  if (!n || !n.length || n.some((r) => !XZ(r.b) || r.e < 1)) return null;
  let t = new Map();
  return (n.forEach((r) => t.set(r.b, (t.get(r.b) ?? 0) + r.e)), t);
}
var kk = (e, n) => e.size === n.size && [...e].every(([t, r]) => n.get(t) === r);
function xk(e, n, t) {
  let r = new Map(),
    s = new Set([...e.keys(), ...n.keys()]);
  for (let i of s) {
    let o = e.get(i) ?? 0,
      a = n.get(i) ?? 0,
      l = t === 'gcd' ? Math.min(o, a) : Math.max(o, a);
    l > 0 && r.set(i, l);
  }
  return r;
}
var YZ = {
    division: 'arith.division@1',
    gcdStep: 'arith.gcd_step@1',
    gcdZero: 'arith.gcd_zero@1',
    gcdDivides: 'arith.gcd_divides@1',
    gcdLast: 'arith.gcd_last@1',
    isolate: 'arith.isolate@1',
    substitute: 'arith.substitute@1',
    expand: 'arith.expand@1',
    regroup: 'arith.regroup@1',
    read: 'arith.read@1',
    decompose: 'arith.primes@1',
    gcdPrimes: 'arith.gcd_primes@1',
    lcmPrimes: 'arith.lcm_primes@1',
    compute: 'arith.compute@1',
  },
  Tg = {
    division: {
      label: 'Division euclidienne',
      hora: 2,
      why: 'a = q \xD7 b + r, avec un reste r positif et plus petit que b.',
    },
    gcdStep: {
      label: 'PGCD(a ; b) = PGCD(b ; r)',
      hora: 1,
      why: 'Les diviseurs communs de a et b sont ceux de b et du reste r : PGCD(a ; b) = PGCD(b ; r).',
    },
    gcdZero: { label: 'PGCD(a ; 0) = a', hora: 1, why: 'Tout nombre divise 0 : PGCD(a ; 0) = a.' },
    gcdDivides: {
      label: 'b divise a',
      hora: 1,
      why: 'Le reste est nul : b divise a, donc PGCD(a ; b) = b.',
    },
    gcdLast: {
      label: 'Le dernier reste non nul',
      hora: 1,
      why: 'Le PGCD est le dernier reste non nul de l\u2019algorithme d\u2019Euclide.',
    },
    isolate: {
      label: 'Isoler le reste',
      hora: 1,
      why: 'De a = q \xD7 b + r, on tire r = a \u2212 q \xD7 b.',
    },
    substitute: {
      label: 'Remplacer un reste',
      hora: 2,
      why: 'On remplace un reste par son expression tir\xE9e de la division qui l\u2019a donn\xE9, entre parenth\xE8ses.',
    },
    expand: {
      label: 'D\xE9velopper',
      hora: 1,
      why: 'On d\xE9veloppe le produit par la parenth\xE8se.',
    },
    regroup: {
      label: 'Regrouper',
      hora: 1,
      why: 'On regroupe les termes en chacun des deux nombres du d\xE9part.',
    },
    decompose: {
      label: 'D\xE9composer en facteurs premiers',
      hora: 2,
      why: 'On \xE9crit le nombre comme un produit de nombres premiers, avec des puissances.',
    },
    gcdPrimes: {
      label: 'Les facteurs communs',
      hora: 2,
      why: 'Le PGCD : les facteurs premiers communs aux deux d\xE9compositions, chacun avec le plus petit exposant.',
    },
    lcmPrimes: {
      label: 'Tous les facteurs',
      hora: 2,
      why: 'Le PPCM : tous les facteurs premiers des deux d\xE9compositions, chacun avec le plus grand exposant.',
    },
    compute: { label: 'Calculer', hora: 1, why: 'On calcule le produit.' },
    read: {
      label: 'Lire les coefficients',
      hora: 1,
      why: 'Les coefficients de l\u2019\xE9galit\xE9 de B\xE9zout donnent un couple solution.',
    },
  },
  eH = 'Arithm\xE9tique';
function nH(e) {
  return Yd(e);
}
var Uw = (e) => ({ dis: [{ sides: [{ k: 's', n: os(e) }] }] });
function tH(e) {
  return Uw(nH(e));
}
var Bw = (e) => {
    try {
      return os(Yd(e));
    } catch {
      return e.trim();
    }
  },
  ho = (e) => (e.k === 'paren' ? ho(e.e) : e),
  Gw = (e) => {
    let n = ho(e);
    return n.k === 'gcd' ? { a: n.a, b: n.b } : null;
  },
  d2 = (e) => {
    let n = ho(e);
    return n.k === 'lcm' ? { a: n.a, b: n.b } : null;
  };
function Rg(e) {
  switch (e.k) {
    case 'num':
      return { coef: new Map(), c: e.v };
    case 'sym':
      return { coef: new Map([[e.n, 1n]]), c: 0n };
    case 'paren':
      return Rg(e.e);
    case 'neg': {
      let n = Rg(e.e);
      return n ? { coef: new Map([...n.coef].map(([t, r]) => [t, -r])), c: -n.c } : null;
    }
    case 'add': {
      let n = new Map(),
        t = 0n;
      for (let r of e.t) {
        let s = Rg(r.e);
        if (!s) return null;
        (s.coef.forEach((i, o) => n.set(o, (n.get(o) ?? 0n) + BigInt(r.s) * i)),
          (t += BigInt(r.s) * s.c));
      }
      return { coef: n, c: t };
    }
    case 'mul': {
      let n = { coef: new Map(), c: 1n };
      for (let t of e.f) {
        let r = Rg(t);
        if (!r || (n.coef.size && r.coef.size)) return null;
        n.coef.size
          ? (n = { coef: new Map([...n.coef].map(([s, i]) => [s, i * r.c])), c: n.c * r.c })
          : r.coef.size
            ? (n = { coef: new Map([...r.coef].map(([s, i]) => [s, i * n.c])), c: r.c * n.c })
            : (n = { coef: new Map(), c: n.c * r.c });
      }
      return n;
    }
    case 'gcd':
    case 'lcm':
      return null;
    case 'pow': {
      let n = lr(e);
      return n === null ? null : { coef: new Map(), c: n };
    }
  }
}
function rH(e) {
  let n = e.kernel,
    t = wg(Yd(n.start));
  if (t.parts.length !== 1) throw new Qn('Le d\xE9part est une seule \xE9criture.');
  let r = t.parts[0],
    s = n.goal.kind;
  if (s === 'gcd' || s === 'gcd_primes') {
    let c = r.members.length === 1 ? Gw(r.members[0]) : null;
    if (!c) throw new Qn('Le d\xE9part d\u2019un PGCD s\u2019\xE9crit \xAB PGCD(a ; b) \xBB.');
    return { goal: 'gcd', primes: s === 'gcd_primes', a: rt(c.a), b: rt(c.b), eq: null };
  }
  if (s === 'lcm') {
    let c = r.members.length === 1 ? d2(r.members[0]) : null;
    if (!c) throw new Qn('Le d\xE9part d\u2019un PPCM s\u2019\xE9crit \xAB PPCM(a ; b) \xBB.');
    return { goal: 'lcm', primes: !0, a: rt(c.a), b: rt(c.b), eq: null };
  }
  if (r.members.length !== 2 || r.rels[0] !== '=' || r.mod !== null)
    throw new Qn('Le d\xE9part de B\xE9zout s\u2019\xE9crit \xAB au + bv = d \xBB.');
  let i = Rg(r.members[0]),
    o = Tt(r.members[1]);
  if (!i || o === null || i.c !== 0n || i.coef.size !== 2)
    throw new Qn(
      'Le d\xE9part de B\xE9zout s\u2019\xE9crit \xAB au + bv = d \xBB, deux inconnues.',
    );
  let a = [...i.coef.keys()],
    [l, u] = a.map((c) => i.coef.get(c));
  if (!l || !u) throw new Qn('Les deux coefficients sont non nuls.');
  return {
    goal: 'bezout',
    primes: !1,
    a: rt(l),
    b: rt(u),
    eq: { coef: i.coef, rhs: o, unknowns: a },
  };
}
function m2(e) {
  let n = e.kernel,
    t = rH(e);
  if (t.a === 0n || t.b === 0n) throw new Qn('Deux nombres non nuls.');
  let r = a2(t.a, t.b),
    s = new Map();
  r.r.forEach((u, c) => {
    u !== 0n && !s.has(u) && s.set(u, c);
  });
  let i = r.r[r.m],
    o = (e.traps ?? []).map((u) => ({
      text: Bw(u.line),
      line: tH(u.line),
      title: u.title ?? 'Attention',
      why: u.why,
    })),
    a = new Set([Bw(n.start), ...(e.givens ?? []).map(Bw)]),
    l = new Map();
  if (t.primes)
    for (let u of e.givens ?? []) {
      let c = aH(u, t.a, t.b);
      c && l.set(String(c[0]), c[1]);
    }
  return {
    model: e,
    goal: t.goal,
    primes: t.primes,
    a: t.a,
    b: t.b,
    L: hk(t.a, t.b),
    dec: l,
    primesForm: !1,
    eu: r,
    idx: s,
    d: i,
    target: t.goal === 'lcm' ? pk(t.a, t.b) : gk(r.r[0], r.r[1]),
    eq: t.eq,
    divisions: new Set(),
    isolated: new Set(),
    cur: null,
    combos: new Set(),
    bez: [],
    assigned: new Map(),
    gcdKnown: !1,
    concluded: !1,
    written: new Set(),
    givenTexts: a,
    path: n.path ?? [],
    traps: o,
    lines: 0,
  };
}
function da(e, n, t, r, s = '') {
  let i = n.reduce((l, u) => l + Tg[u].hora, 0),
    o = n.reduce((l, u) => (Tg[u].hora > Tg[l].hora ? u : l), n[0]),
    a =
      [...new Set(n)].map((l) => Tg[l].why).join(' ') + s + (r ? ' C\u2019est la r\xE9ponse.' : '');
  return {
    kind: 'step',
    ...e,
    hora: i,
    final: r,
    rule: { id: YZ[o], card: eH, label: Tg[o].label, hora: i, why: a },
    amove: { ...t, ...(r ? { final: r } : {}) },
  };
}
function nm(e, n, t) {
  return {
    kind: 'useless',
    ...e,
    jump: !0,
    final: t,
    title: t ? 'Juste !' : 'Juste, mais tu sautes des \xE9tapes',
    message: t
      ? 'C\u2019est la bonne r\xE9ponse. D\xE9taille ton raisonnement, une \xE9tape par ligne, pour gagner des HORA. Tu peux garder cette ligne sans HORA.'
      : 'Ta ligne est juste. D\xE9taille-la, une \xE9tape par ligne, pour gagner des HORA. Tu peux la garder sans HORA.',
    amove: { ...n, ...(t ? { final: t } : {}) },
  };
}
var em = (e, n) => ({
    kind: 'useless',
    ...e,
    title: 'Juste, mais \xE0 c\xF4t\xE9',
    message: n ?? 'C\u2019est juste, mais \xE7a ne sert pas pour la question.',
  }),
  xi = (e, n) => ({
    kind: 'useless',
    ...e,
    title: 'Rien de nouveau',
    message: n ?? 'Cette ligne redit ce qui est d\xE9j\xE0 \xE9crit.',
  });
function Dl(e, n, t) {
  let r = os(n.atoms),
    s = e.traps.find((i) => i.text === r);
  return s
    ? {
        kind: 'trap',
        ...n,
        title: s.title,
        message: s.why,
        trap: { line: s.line, title: s.title, why: s.why },
      }
    : { kind: 'false', ...n, ...t };
}
function sH(e, n) {
  return e.path.some((t) => {
    let r;
    try {
      r = Yd(t);
    } catch {
      return !1;
    }
    return r.length > n.length && n.every((s, i) => r[i] === s);
  });
}
function p2(e, n, t) {
  let r = n.flatMap((a) => a.atoms);
  if (!r.length) return { kind: 'empty', atoms: r, badChip: -1 };
  let s = sH(e, r),
    i;
  try {
    i = wg(r).parts;
  } catch (a) {
    if (a instanceof mo || (s && !t?.verify))
      return t?.verify
        ? { kind: 'syntax', atoms: r, title: 'Ligne inachev\xE9e', message: 'Termine ta ligne.' }
        : { kind: s ? 'building' : 'open', atoms: r, complete: !1 };
    let l = r.includes(';') && r.includes('(');
    return {
      kind: 'syntax',
      atoms: r,
      title: '\xC7a ne se lit pas',
      message: l
        ? '\xC9cris un couple ainsi : \xAB u = \u2026 ; v = \u2026 \xBB.'
        : a instanceof Qn
          ? a.message
          : String(a),
      badChip: n.length - 1,
    };
  }
  if (i.some((a) => a.members.length < 2))
    return t?.verify
      ? {
          kind: 'syntax',
          atoms: r,
          line: Uw(r),
          title: 'Une \xE9galit\xE9',
          message: '\xC9cris une \xE9galit\xE9 : \xAB \u2026 = \u2026 \xBB.',
        }
      : { kind: s ? 'building' : 'open', atoms: r, complete: !1 };
  let o = iH(e, r, i);
  return s && !t?.verify
    ? o.kind === 'step'
      ? { ...o, kind: 'ready', complete: !0 }
      : { kind: 'building', atoms: r, complete: !0 }
    : !t?.verify && (o.kind === 'unjustified' || o.kind === 'false')
      ? { kind: 'pending', atoms: r, complete: !0 }
      : { ...o, complete: !0 };
}
function iH(e, n, t) {
  let r = Uw(n),
    s = { atoms: n, line: r },
    i = os(n);
  if (t.some((p) => p.rels.includes('\u2261') || p.mod !== null))
    return {
      kind: 'syntax',
      ...s,
      title: 'Pas de congruence ici',
      message: 'Dans cette feuille, on \xE9crit des \xE9galit\xE9s \xAB = \xBB entre entiers.',
    };
  if (e.givenTexts.has(i))
    return {
      kind: 'useless',
      ...s,
      title: 'C\u2019est l\u2019\xE9nonc\xE9',
      message: 'Cette ligne est d\xE9j\xE0 dans l\u2019\xE9nonc\xE9 : \xE9cris le calcul suivant.',
    };
  if (e.written.has(i)) return xi(s, 'Cette ligne est d\xE9j\xE0 sur ta feuille.');
  let o = e.eq?.unknowns ?? [],
    a = (p) =>
      p.members.length === 2 && ho(p.members[0]).k === 'sym' && o.includes(ho(p.members[0]).n);
  if (o.length && t.every(a)) return pH(e, s, t);
  if (t.length > 1)
    return {
      kind: 'syntax',
      ...s,
      title: 'Une \xE9galit\xE9 par ligne',
      message: o.length
        ? 'Une seule \xE9galit\xE9 par ligne, sauf le couple \xAB u = \u2026 ; v = \u2026 \xBB.'
        : 'Une seule \xE9galit\xE9 par ligne.',
    };
  let l = t[0];
  if (l.members.some((p) => Qc(p).size))
    return {
      kind: 'unjustified',
      ...s,
      title: 'Avec des nombres',
      message: o.length
        ? 'Cherche un couple avec l\u2019algorithme d\u2019Euclide : \xE9cris des divisions et des calculs avec des nombres, puis \xAB u = \u2026 ; v = \u2026 \xBB.'
        : '\xC9cris des divisions et des calculs avec des nombres.',
    };
  if (e.primes) {
    let p = lH(e, s, l.members);
    if (p) return p;
  }
  if (l.members.some(Vl))
    return em(s, `Ce PPCM n\u2019est pas celui de la question : ${e.target}.`);
  if (l.members.some(Fl)) return fH(e, s, l.members);
  let u = l.members.map((p) => lr(p));
  if (u.some((p) => p === null))
    return { kind: 'syntax', ...s, title: '\xC7a ne se lit pas', message: 'Termine ta ligne.' };
  if (u.some((p) => p !== u[0]))
    return Dl(e, s, {
      title: 'Le calcul ne tombe pas juste',
      message:
        l.members.length === 2
          ? `${ki(l.members[1])} ne fait pas ${ki(l.members[0])} : v\xE9rifie ton calcul.`
          : 'Les membres de ta ligne ne sont pas tous \xE9gaux : v\xE9rifie ton calcul.',
    });
  if (l.members.length === 2) {
    let p = c2(l.members[0], l.members[1]) ?? c2(l.members[1], l.members[0]);
    if (p) return cH(e, s, p);
  }
  let c = Tt(l.members[0]),
    f = Tt(l.members[l.members.length - 1]),
    d = c !== null ? c : f,
    m = c !== null ? l.members.slice(1) : l.members.slice(0, -1);
  if (d !== null && e.goal === 'bezout') {
    if (d === e.d) return dH(e, s, m);
    let p = e.idx.get(d);
    if (p !== void 0 && p >= 2 && p <= e.eu.m) return mH(e, s, p, m);
  }
  return m.every((p) => Tt(p) !== null)
    ? xi(s)
    : {
        kind: 'useless',
        ...s,
        title: 'Calcul juste',
        message:
          'Ce calcul est juste, mais il ne sert pas pour la question. Garde-le s\u2019il t\u2019aide : il ne rapporte pas de HORA.',
      };
}
function oH(e, n) {
  let t = e.goal === 'lcm' ? d2(n) : Gw(n);
  return !!t && Ks(rt(t.a), rt(t.b)) === Ks(e.a, e.b);
}
function g2(e, n, t) {
  if (e.length < 2) return null;
  let r = Tt(e[0]),
    s = Tt(e[e.length - 1]),
    i = [
      [r, e[e.length - 1]],
      [s, e[0]],
    ];
  for (let [o, a] of i)
    if (o !== null && (o === n || o === t) && Tt(a) === null && bk(a))
      return { n: o, end: a, pf: vk(a) };
  return null;
}
function aH(e, n, t) {
  let r = k2(e);
  if (!r || r.length !== 1) return null;
  let s = g2(r[0].members, n, t);
  return s?.pf && r[0].members.map((o) => lr(o)).every((o) => o === s.n) ? [s.n, s.pf] : null;
}
function lH(e, n, t) {
  if (t.some((o) => Fl(o) || Vl(o))) return uH(e, n, t);
  if (e.primesForm) {
    let o = e.goal === 'lcm' ? e.L : e.d,
      a = e.dec.get(String(e.a)),
      l = e.dec.get(String(e.b)),
      u = a && l ? xk(a, l, e.goal === 'lcm' ? 'lcm' : 'gcd') : null,
      c = t.map((f) => lr(f));
    if (
      u &&
      c.every((f) => f === o) &&
      t.some((f) => {
        let d = Tt(f) === null ? vk(f) : null;
        return !!d && kk(d, u);
      }) &&
      t.some((f) => Tt(f) === o)
    )
      return da(n, ['compute'], { text: os(n.atoms), gcdKnown: !0 }, !e.concluded);
  }
  let r = g2(t, e.a, e.b);
  if (!r) return null;
  let s = t.map((o) => lr(o));
  if (s.some((o) => o === null)) return null;
  if (s.some((o) => o !== r.n))
    return Dl(e, n, {
      title: 'Le produit ne tombe pas juste',
      message: `Ton produit ne vaut pas ${r.n} : v\xE9rifie ton calcul.`,
    });
  let i = os(n.atoms);
  if (!r.pf && e.goal === 'gcd' && t.length === 2) {
    let o = bk(r.end),
      a = r.n === e.a ? e.b : e.a;
    if (o?.length === 2 && o.every((l) => l.e === 1) && o.some((l) => l.b === a)) return null;
  }
  return r.pf
    ? e.dec.has(String(r.n))
      ? xi(n, `La d\xE9composition de ${r.n} est d\xE9j\xE0 sur ta feuille.`)
      : da(n, ['decompose'], { text: i, dec: [r.n, r.pf] }, !1)
    : {
        kind: 'useless',
        ...n,
        title: 'Pas encore en facteurs premiers',
        message:
          'Ta ligne est juste, mais un facteur n\u2019est pas un nombre premier : continue \xE0 d\xE9composer. Tu peux la garder sans HORA.',
        amove: { text: i },
      };
}
function uH(e, n, t) {
  let r = e.goal === 'lcm' ? 'lcm' : 'gcd',
    s = [];
  for (let v of t) {
    if (oH(e, v)) {
      s.push({ k: 'target' });
      continue;
    }
    if (Fl(v) || Vl(v)) return null;
    let k = lr(v);
    if (k === null) return null;
    let y = Tt(v);
    y !== null ? s.push({ k: 'num', v: y }) : s.push({ k: 'prod', v: k, pf: vk(v) });
  }
  if (!s.some((v) => v.k === 'target')) return null;
  let i = r === 'lcm' ? e.L : e.d,
    o = r === 'lcm' ? 'PPCM' : 'PGCD',
    a = e.dec.get(String(e.a)),
    l = e.dec.get(String(e.b)),
    u = (v) => (v.k === 'target' ? i : v.v),
    c = s.some((v) => u(v) !== i);
  if (!c && r === 'gcd' && !e.primesForm && !s.some((v) => v.k === 'prod')) return null;
  if (c) {
    let v = `Pas le ${o}`,
      k = `Ce n\u2019est pas le ${o} de ${e.a} et ${e.b} : compare tes deux d\xE9compositions.`,
      y = r === 'gcd' ? e.L : e.d;
    y !== i &&
      s.some((w) => w.k !== 'target' && w.v === y) &&
      ((v = r === 'gcd' ? 'Les facteurs COMMUNS' : 'TOUS les facteurs'),
      (k =
        r === 'gcd'
          ? `${y} est le PPCM. Pour le PGCD, on garde seulement les facteurs premiers communs aux deux nombres, avec le plus petit exposant.`
          : `${y} est le PGCD. Pour le PPCM, on garde tous les facteurs premiers des deux nombres, avec le plus grand exposant.`));
    let S = s.find((w) => w.k === 'prod' && w.pf);
    if (S && a && l) {
      let w = xk(a, l, r),
        _ = xk(a, l, r === 'gcd' ? 'lcm' : 'gcd'),
        O = S.pf.size === w.size && [...w.keys()].every((G) => S.pf.has(G));
      kk(S.pf, _)
        ? ((v = r === 'gcd' ? 'Les facteurs COMMUNS' : 'TOUS les facteurs'),
          (k =
            r === 'gcd'
              ? 'Pour le PGCD, on garde seulement les facteurs premiers communs aux deux nombres, avec le plus petit exposant.'
              : 'Pour le PPCM, on garde tous les facteurs premiers des deux nombres, avec le plus grand exposant.'))
        : O &&
          ((v = r === 'gcd' ? 'Le plus PETIT exposant' : 'Le plus GRAND exposant'),
          (k =
            r === 'gcd'
              ? 'Les bons facteurs premiers, mais pour le PGCD chacun prend le plus petit des deux exposants.'
              : 'Les bons facteurs premiers, mais pour le PPCM chacun prend le plus grand des deux exposants.'));
    }
    return (
      r === 'lcm' &&
        v === `Pas le ${o}` &&
        s.some((w) => w.k !== 'target' && w.v === e.a * e.b) &&
        ((v = 'Pas le plus petit'),
        (k = `${e.a} \xD7 ${e.b} est un multiple commun de ${e.a} et ${e.b}, mais pas le plus petit.`)),
      Dl(e, n, { title: v, message: k })
    );
  }
  let f = [],
    d = !1,
    m = !1,
    p = (v, k) => {
      if (v.k !== 'target' && k.k === 'target') return p(k, v);
      if (v.k === 'target') {
        if (k.k === 'target') return;
        if (k.k === 'prod' && k.pf) {
          a && l ? (f.push(r === 'lcm' ? 'lcmPrimes' : 'gcdPrimes'), (m = !0)) : (d = !0);
          return;
        }
        k.k === 'num' && (e.primesForm || m) ? f.push('compute') : (d = !0);
        return;
      }
      (v.k === 'num' && k.k === 'num') ||
        (v.k === 'prod' && k.k === 'prod' && v.pf && k.pf && kk(v.pf, k.pf)) ||
        f.push('compute');
    };
  for (let v = 0; v + 1 < s.length; v++) p(s[v], s[v + 1]);
  let g = s.some((v) => v.k === 'num' && v.v === i),
    h = g && !e.concluded,
    b = { text: os(n.atoms), ...(m ? { primesForm: m } : {}), ...(g ? { gcdKnown: !0 } : {}) };
  return d ? nm(n, b, h) : f.length ? da(n, f, b, h) : xi(n);
}
function c2(e, n) {
  let t = Tt(e);
  if (t === null || t <= 0n) return null;
  let r = ho(n),
    s = r.k === 'add' ? r.t : [{ s: 1, e: r }];
  if (s.some((o) => o.s !== 1)) return null;
  let i = (o) => {
    let a = ho(o);
    if (a.k !== 'mul' || a.f.length !== 2) return null;
    let l = Tt(a.f[0]),
      u = Tt(a.f[1]);
    return l !== null && u !== null && l > 0n && u > 0n ? [l, u] : null;
  };
  if (s.length === 1) {
    let o = i(s[0].e);
    return o ? { x: t, f: o, r: 0n } : null;
  }
  if (s.length !== 2) return null;
  for (let [o, a] of [
    [0, 1],
    [1, 0],
  ]) {
    let l = i(s[o].e),
      u = Tt(s[a].e);
    if (l && u !== null) return { x: t, f: l, r: u };
  }
  return null;
}
function cH(e, n, t) {
  let r = [
    { q: t.f[0], y: t.f[1] },
    { q: t.f[1], y: t.f[0] },
  ].filter((a) => t.r >= 0n && t.r < a.y);
  if (!r.length)
    return Dl(e, n, {
      title: 'Pas une division euclidienne',
      message:
        'Dans une division euclidienne, le reste est positif et plus petit que le diviseur : continue la division.',
    });
  let s = e.eu.r,
    i = r
      .map((a) => {
        for (let l = 1; l <= e.eu.m; l++) if (s[l - 1] === t.x && s[l] === a.y) return l;
        return 0;
      })
      .find((a) => a > 0);
  if (!i)
    return em(
      n,
      `Cette division est juste, mais elle ne fait pas partie de l\u2019algorithme d\u2019Euclide de ${e.target}.`,
    );
  if (e.divisions.has(i)) return xi(n, 'Cette division est d\xE9j\xE0 sur ta feuille.');
  let o = { text: os(n.atoms), divisions: [i] };
  if (i === 1 || e.divisions.has(i - 1)) {
    let a = s[i + 1] === 0n;
    return da(
      n,
      ['division'],
      o,
      !1,
      a ? ' Le reste est nul : l\u2019algorithme s\u2019arr\xEAte.' : '',
    );
  }
  return nm(n, o, !1);
}
var Ks = (e, n) => (e >= n ? `${e}|${n}` : `${n}|${e}`);
function yk(e, n, t) {
  let r = n >= t ? n : t,
    s = n >= t ? t : n,
    i = e.eu.r;
  for (let o = 1; o <= e.eu.m; o++) if (i[o - 1] === r && i[o] === s) return o;
  return 0;
}
function fH(e, n, t) {
  let r = [];
  for (let h of t) {
    let b = Gw(h);
    if (b) {
      if (b.a < 0n || b.b < 0n || (b.a === 0n && b.b === 0n))
        return {
          kind: 'syntax',
          ...n,
          title: 'PGCD de deux entiers positifs',
          message: 'Le PGCD se calcule pour deux entiers positifs, pas tous les deux nuls.',
        };
      r.push({ k: 'gcd', a: b.a, b: b.b });
      continue;
    }
    let v = Tt(h);
    if (v === null)
      return {
        kind: 'syntax',
        ...n,
        title: 'Une cha\xEEne de PGCD',
        message:
          '\xC9cris des PGCD ou un nombre, reli\xE9s par \xAB = \xBB : \xAB PGCD(a ; b) = PGCD(b ; r) \xBB.',
      };
    r.push({ k: 'num', v });
  }
  let s = (h) => (h.k === 'gcd' ? Sg(h.a, h.b) : h.v),
    i = s(r[0]);
  if (r.some((h) => s(h) !== i))
    return Dl(e, n, {
      title: 'Pas le m\xEAme PGCD',
      message: 'Les membres de ta ligne ne sont pas \xE9gaux : v\xE9rifie tes divisions.',
    });
  if (!r.some((h) => h.k === 'gcd' && (yk(e, h.a, h.b) > 0 || Ks(h.a, h.b) === Ks(e.d, 0n))))
    return em(
      n,
      `Ce PGCD n\u2019appara\xEEt pas dans l\u2019algorithme d\u2019Euclide de ${e.target}.`,
    );
  let a = e.eu.r,
    l = () => {
      for (let h = 1; h <= e.eu.m; h++) if (!e.divisions.has(h)) return !1;
      return !0;
    },
    u = [],
    c = !1,
    f = (h) => h.k === 'gcd' && Ks(h.a, h.b) === Ks(a[0], a[1]),
    d = (h, b) => {
      if (h.k === 'num' && b.k === 'num') return;
      if (h.k === 'num' && b.k === 'gcd') return d(b, h);
      if (h.k !== 'gcd') return;
      let v = h.a >= h.b ? h.a : h.b,
        k = h.a >= h.b ? h.b : h.a;
      if (b.k === 'gcd') {
        if (Ks(b.a, b.b) === Ks(h.a, h.b)) return;
        let y = k === 0n ? null : v % k,
          S = b.a >= b.b ? b.a : b.b,
          w = b.a >= b.b ? b.b : b.a,
          _ = w === 0n ? null : S % w;
        if (y !== null && Ks(b.a, b.b) === Ks(k, y)) {
          let O = yk(e, v, k);
          O && e.divisions.has(O) ? u.push('gcdStep') : (c = !0);
          return;
        }
        if (_ !== null && Ks(h.a, h.b) === Ks(w, _)) {
          let O = yk(e, S, w);
          O && e.divisions.has(O) ? u.push('gcdStep') : (c = !0);
          return;
        }
        c = !0;
        return;
      }
      if (k === 0n) {
        b.v === v ? u.push('gcdZero') : (c = !0);
        return;
      }
      if (v % k === 0n && b.v === k) {
        let y = yk(e, v, k);
        y && e.divisions.has(y) ? u.push('gcdDivides') : (c = !0);
        return;
      }
      if (f(h) && b.v === e.d && l()) {
        u.push('gcdLast');
        return;
      }
      c = !0;
    };
  for (let h = 0; h + 1 < r.length; h++) d(r[h], r[h + 1]);
  let m = r.some(f) && r.some((h) => h.k === 'num' && h.v === e.d),
    p = e.goal === 'gcd' && m && !e.concluded,
    g = { text: os(n.atoms), ...(m ? { gcdKnown: !0 } : {}) };
  return c ? nm(n, g, p) : u.length ? da(n, u, g, p) : xi(n);
}
function $g(e, n) {
  let t = [...n.values()].filter((r) => r !== 0n).length;
  return (jc(e) ? 2 : 0) + Math.max(0, o2(e) - t);
}
var zw = (e) => Math.max(-1, ...[...e.entries()].filter(([, n]) => n !== 0n).map(([n]) => n)),
  h2 = (e, n) =>
    new Map([
      [n - 1, 1n],
      [n, -e.eu.q[n]],
    ]);
function dH(e, n, t) {
  let r = e.cur,
    s = [],
    i = !1,
    o = [],
    a = [];
  for (let u of t) {
    let c = Dw(u, e.idx),
      f = (p) => c.some((g) => go(g) === go(p));
    if (!c.length) {
      if (Tt(u) !== null) continue;
      return em(
        n,
        'Ce calcul est juste, mais il n\u2019utilise pas les restes de l\u2019algorithme d\u2019Euclide.',
      );
    }
    let d = null,
      m = e.eu.m - 1;
    if (m >= 1) {
      let p = h2(e, m);
      f(p) &&
        $g(u, p) === 0 &&
        !e.combos.has(go(p)) &&
        ((d = { lin: p, measure: 0 }),
        e.divisions.has(m) ? s.push('isolate') : (i = !0),
        a.push(m));
    }
    if (!d && r)
      for (let [p, g] of r.lin) {
        if (p < 2 || g === 0n) continue;
        let h = new Map([
            [p - 2, 1n],
            [p - 1, -e.eu.q[p - 1]],
          ]),
          b = u2(r.lin, p, h);
        if (!f(b)) continue;
        let v = $g(u, b);
        ((d = { lin: b, measure: v }),
          !e.divisions.has(p - 1) || v === 0 ? (i = !0) : s.push('substitute'));
        break;
      }
    if (!d && r && f(r.lin)) {
      let p = $g(u, r.lin);
      if (p >= r.measure) {
        if (t.length === 1) return xi(n);
        continue;
      }
      (s.push(p === 0 ? 'regroup' : 'expand'), (d = { lin: r.lin, measure: p }));
    }
    if (!d) {
      let p = [...c].sort((g, h) => zw(g) - zw(h))[0];
      ((d = { lin: p, measure: $g(u, p) }), (i = !0));
    }
    ((r = d), o.push(d));
  }
  if (!o.length) return xi(n);
  let l = { text: os(n.atoms), combos: o, isolated: a };
  return i ? nm(n, l, !1) : s.length ? da(n, s, l, !1) : xi(n);
}
function mH(e, n, t, r) {
  let s = t - 1,
    i = h2(e, s);
  if (r.length !== 1) return em(n);
  let o = r[0];
  if (!Dw(o, e.idx).some((u) => go(u) === go(i)) || $g(o, i) !== 0) return em(n);
  if (e.isolated.has(s)) return xi(n);
  let l = { text: os(n.atoms), isolated: [s] };
  return e.divisions.has(s) ? da(n, ['isolate'], l, !1) : nm(n, l, !1);
}
function f2(e, n, t) {
  let r = e.eq.coef.get(t),
    s = e.idx.get(rt(r));
  return (n.get(s) ?? 0n) * (r < 0n ? -1n : 1n);
}
function Zw(e, n) {
  let t = 0n;
  return (e.eq.coef.forEach((r, s) => (t += r * n.get(s))), t === e.eq.rhs);
}
function pH(e, n, t) {
  let r = e.eq,
    s = new Map();
  for (let c of t) {
    let f = ho(c.members[0]).n,
      d = lr(c.members[1]);
    if (d === null || Qc(c.members[1]).size)
      return {
        kind: 'unjustified',
        ...n,
        title: 'Une valeur',
        message: `Donne la valeur de ${f} : un nombre entier.`,
      };
    if (s.has(f) && s.get(f) !== d)
      return Dl(e, n, { title: 'Deux valeurs', message: `${f} ne peut pas avoir deux valeurs.` });
    s.set(f, d);
  }
  let i = [...s].filter(([c, f]) => e.assigned.get(c) !== f);
  if (!i.length) return xi(n);
  if (i.some(([c]) => e.assigned.has(c)))
    return Dl(e, n, {
      title: 'D\xE9j\xE0 trouv\xE9e',
      message: 'Tu as d\xE9j\xE0 donn\xE9 une autre valeur \xE0 cette inconnue.',
    });
  let o = new Map([...e.assigned, ...s]),
    a = r.unknowns.every((c) => o.has(c)),
    l = e.bez.some((c) => [...s].every(([f, d]) => f2(e, c, f) === d)),
    u = { text: os(n.atoms), assign: [...s] };
  if (a) {
    if (!Zw(e, o)) {
      let f = (() => {
        for (let d of e.bez) {
          if (
            r.unknowns.every((g, h) => {
              let b = r.unknowns[1 - h];
              return o.get(g) === f2(e, d, b);
            })
          )
            return `Tu as \xE9chang\xE9 les coefficients : ${r.unknowns[0]} va avec ${rt(r.coef.get(r.unknowns[0]))}.`;
          if (r.unknowns.every((g) => o.get(g) === (d.get(e.idx.get(rt(r.coef.get(g)))) ?? 0n)))
            return 'Attention au signe : regarde le signe devant chaque inconnue dans l\u2019\xE9quation.';
        }
        return null;
      })();
      return Dl(e, n, {
        title: 'Ce couple ne va pas',
        message:
          f ??
          'Ce couple ne v\xE9rifie pas l\u2019\xE9quation : remplace les inconnues pour le v\xE9rifier.',
      });
    }
    let c = !e.concluded;
    return l ? da(n, ['read'], u, c) : nm(n, u, c);
  }
  return l
    ? da(n, ['read'], u, !1)
    : {
        kind: 'unjustified',
        ...n,
        title: 'D\u2019o\xF9 vient cette valeur ?',
        message: e.bez.length
          ? 'Lis-la sur ton \xE9galit\xE9 de B\xE9zout, celle qui ne contient plus que les deux nombres du d\xE9part.'
          : `Trouve d\u2019abord une \xE9galit\xE9 \xAB ${Fc(e.d)} = \u2026 \xBB avec les deux nombres du d\xE9part, en remontant l\u2019algorithme d\u2019Euclide.`,
      };
}
function b2(e, n) {
  let t = n.amove;
  t &&
    (e.written.add(t.text),
    e.lines++,
    t.divisions?.forEach((r) => e.divisions.add(r)),
    t.isolated?.forEach((r) => e.isolated.add(r)),
    t.combos?.forEach((r) => {
      ((e.cur = r),
        e.combos.add(go(r.lin)),
        zw(r.lin) <= 1 && !e.bez.some((s) => go(s) === go(r.lin)) && e.bez.push(r.lin));
    }),
    t.gcdKnown && (e.gcdKnown = !0),
    t.dec && e.dec.set(String(t.dec[0]), t.dec[1]),
    t.primesForm && (e.primesForm = !0),
    t.assign?.forEach(([r, s]) => e.assigned.set(r, s)),
    t.final && (e.concluded = !0),
    e.goal === 'bezout' &&
      e.eq &&
      e.eq.unknowns.every((r) => e.assigned.has(r)) &&
      Zw(e, e.assigned) &&
      (e.concluded = !0),
    (e.goal === 'gcd' || e.goal === 'lcm') && e.gcdKnown && (e.concluded = !0));
}
function v2(e) {
  return e.concluded;
}
function k2(e) {
  try {
    return wg(Yd(e)).parts;
  } catch {
    return null;
  }
}
function x2(e, n) {
  let t = k2(n);
  if (!t || t.some((s) => s.members.length < 2 || s.mod !== null)) return !1;
  let r = e.eq?.unknowns ?? [];
  if (
    r.length &&
    t.every((s) => {
      let i = ho(s.members[0]);
      return i.k === 'sym' && r.includes(i.n);
    })
  ) {
    let s = new Map();
    for (let i of t) {
      let o = lr(i.members[1]);
      if (o === null) return !1;
      s.set(ho(i.members[0]).n, o);
    }
    return r.every((i) => s.has(i)) && Zw(e, s);
  }
  return t.every((s) => {
    let i = s.members.map((o) => lr(o));
    return i.every((o) => o !== null && o === i[0]);
  });
}
var gH = {
    name: 'integral.name@1',
    parts: 'integral.parts@1',
    primitive: 'integral.primitive@1',
    recognize: 'integral.recognize@1',
    constant: 'integral.constant@1',
    linearity: 'integral.linearity@1',
    linearize: 'integral.linearize@1',
    decompose: 'integral.decompose@1',
    rewrite: 'integral.rewrite@1',
    chasles: 'integral.chasles@1',
    bracket: 'integral.bracket@1',
    bracketMerge: 'integral.bracket_merge@1',
    replace: 'integral.replace@1',
    recognizeI: 'integral.recognize_i@1',
    collect: 'integral.collect@1',
    divide: 'integral.divide@1',
    compute: 'kernel.compute@1',
  },
  Dc = {
    name: {
      label: 'Nommer',
      hora: 1,
      why: 'On choisit u et v\u2032 avec u \xD7 v\u2032 = la fonction \xE0 int\xE9grer ; u\u2032 se d\xE9rive, v est une primitive de v\u2032.',
    },
    parts: {
      label: 'Int\xE9gration par parties',
      hora: 2,
      why: '\u222Bu v\u2032 = [u v] \u2212 \u222Bu\u2032 v : on d\xE9rive u, on prend une primitive de v\u2032.',
    },
    primitive: {
      label: 'Primitive',
      hora: 2,
      why: 'Une primitive F de la fonction : \u222B(a ; b) f(x) dx = [F(x)](a ; b).',
    },
    recognize: {
      label: 'Reconna\xEEtre une forme',
      hora: 3,
      why: 'La fonction est de la forme u\u2032e\u1D58, u\u2032 \xF7 u, u\u2032u\u207F\u2026 : on \xE9crit directement sa primitive.',
    },
    constant: {
      label: 'Int\xE9grale d\u2019une constante',
      hora: 1,
      why: '\u222B(a ; b) k dx = k \xD7 (b \u2212 a).',
    },
    linearity: {
      label: 'Lin\xE9arit\xE9',
      hora: 1,
      why: 'L\u2019int\xE9grale d\u2019une somme est la somme des int\xE9grales ; une constante sort de l\u2019int\xE9grale.',
    },
    linearize: {
      label: 'Lin\xE9ariser',
      hora: 2,
      why: 'cos\xB2x = (1 + cos 2x) \xF7 2, sin\xB2x = (1 \u2212 cos 2x) \xF7 2 : plus de puissance de cos ou de sin.',
    },
    decompose: {
      label: 'D\xE9composer en \xE9l\xE9ments simples',
      hora: 2,
      why: 'La fraction devient une somme de fractions plus simples, qui ont chacune une primitive.',
    },
    rewrite: {
      label: 'Transformer la fonction',
      hora: 1,
      why: 'Une \xE9criture \xE9gale de la fonction \xE0 int\xE9grer, plus facile \xE0 int\xE9grer.',
    },
    chasles: {
      label: 'Relation de Chasles',
      hora: 2,
      why: '\u222B(a ; b) = \u222B(a ; c) + \u222B(c ; b) : sur chaque morceau, la fonction s\u2019\xE9crit sans valeur absolue.',
    },
    bracket: {
      label: 'Remplacer x par les bornes',
      hora: 1,
      why: '[F(x)](a ; b) = F(b) \u2212 F(a) : la borne du haut, puis celle du bas.',
    },
    bracketMerge: {
      label: 'Regrouper les crochets',
      hora: 1,
      why: 'Des crochets aux m\xEAmes bornes se regroupent : [F](a ; b) + [G](a ; b) = [F + G](a ; b).',
    },
    replace: {
      label: 'Remplacer',
      hora: 1,
      why: 'On remplace une int\xE9grale par ce qu\u2019on a calcul\xE9 \xE0 part.',
    },
    recognizeI: {
      label: 'Reconna\xEEtre I',
      hora: 1,
      why: 'L\u2019int\xE9grale de d\xE9part r\xE9appara\xEEt : on l\u2019\xE9crit I, ce qui donne une \xE9quation en I.',
    },
    collect: { label: 'Regrouper les I', hora: 1, why: 'On passe les I du m\xEAme c\xF4t\xE9.' },
    divide: {
      label: 'Diviser',
      hora: 1,
      why: 'On divise les deux membres par le coefficient de I.',
    },
    compute: { label: 'Calculer', hora: 1, why: 'Un calcul sur les nombres.' },
  },
  hH = 'Int\xE9grales',
  bo = class extends Error {},
  rS = /^∫\((.+) ; (.+)\)$/,
  q2 = /^\]\((.+) ; (.+)\)$/,
  sS = /^d([a-zθ])$/,
  bH = /^([uv])(′?)\(([a-zθ])\)$/,
  Qr = (e) => !!e && rS.test(e),
  yi = (e) => !!e && q2.test(e),
  Fr = (e) => !!e && sS.test(e),
  Mg = (e) => Qr(e) || yi(e) || Fr(e) || e === '[';
function Sk(e) {
  return Tk(ne(Te(e.trim())));
}
function Tk(e) {
  return ot(e)
    .replace(/\//g, '\xF7')
    .replace(/\s*÷\s*/g, ' \xF7 ')
    .trim();
}
function vH(e, n) {
  return `\u222B(${Sk(e)} ; ${Sk(n)})`;
}
function kH(e, n) {
  return `](${Sk(e)} ; ${Sk(n)})`;
}
function y2(e, n) {
  let t = 0;
  for (let r = n; r < e.length; r++) {
    let s = e[r];
    if (s === '(') t++;
    else if (s === ')' && (t--, t === 0)) return { inner: e.slice(n + 1, r), end: r + 1 };
  }
  return null;
}
function w2(e) {
  let n = 0;
  for (let t = 0; t < e.length; t++) {
    let r = e[t];
    if (r === '(') n++;
    else if (r === ')') n--;
    else if (r === ';' && n === 0) return [e.slice(0, t), e.slice(t + 1)];
  }
  return null;
}
var xH = /[A-Za-zÀ-ÖØ-öø-ÿα-ωΑ-Ω]/;
function pa(e) {
  let n = [],
    t = '',
    r = () => {
      (t.trim() && n.push(...Te(t)), (t = ''));
    },
    s = String(e);
  for (let i = 0; i < s.length; ) {
    let o = s[i];
    if (o === '\u222B' && s[i + 1] === '(') {
      let a = y2(s, i + 1),
        l = a && w2(a.inner);
      if (a && l) {
        (r(), n.push(vH(l[0], l[1])), (i = a.end));
        continue;
      }
    }
    if (o === '[') {
      (r(), n.push('['), i++);
      continue;
    }
    if (o === ']' && s[i + 1] === '(') {
      let a = y2(s, i + 1),
        l = a && w2(a.inner);
      if (a && l) {
        (r(), n.push(kH(l[0], l[1])), (i = a.end));
        continue;
      }
    }
    if (
      o === 'd' &&
      /[a-zθ]/.test(s[i + 1] ?? '') &&
      !xH.test(s[i - 1] ?? '') &&
      !/[A-Za-zÀ-ÿα-ω₀-₉′(]/.test(s[i + 2] ?? '')
    ) {
      (r(), n.push('d' + s[i + 1]), (i += 2));
      continue;
    }
    ((t += o), i++);
  }
  return (r(), L2(yH(n)).atoms);
}
function yH(e) {
  let n = [];
  for (let t = 0; t < e.length; t++) {
    let r = e[t];
    n.push(r);
    let s = e[t + 1];
    Dr(r) &&
      s !== void 0 &&
      s !== '(' &&
      (jt(s) || yt(s) || Xt(s)) &&
      !Mg(s) &&
      (n.push('(', s, ')'), t++);
  }
  return n;
}
var S2 = (e) => ff(e) || e === ')' || e === '\xB2' || Ds(e) || e === '!' || Ea(e),
  T2 = (e) => jt(e) || Xt(e) || Dr(e) || e === '(' || e === '\u221A' || yt(e);
function L2(e) {
  let n = [],
    t = [];
  return (
    e.forEach((r, s) => {
      let i = n[n.length - 1];
      if (i !== void 0 && i !== '\xD7') {
        let o = Qr(i) || i === '[',
          a = yi(i) || Fr(i),
          l = !1;
        (Qr(r) || r === '['
          ? (l = !o && (a || S2(i)))
          : yi(r) || Fr(r)
            ? (l = !1)
            : a
              ? (l = T2(r) && !yt(r) ? !0 : yt(r))
              : o || (l = S2(i) && T2(r) && !yt(r)),
          l && (n.push('\xD7'), t.push(s)));
      }
      (n.push(r), t.push(s));
    }),
    { atoms: n, src: t }
  );
}
function Is(e) {
  let n = [],
    t = [],
    r = () => {
      (t.length && n.push(Tk(t)), (t = []));
    };
  for (let i of e) Mg(i) ? (r(), n.push(i)) : t.push(i);
  r();
  let s = '';
  return (
    n.forEach((i, o) => {
      let a = n[o - 1];
      o ? (a === '[' || yi(i) ? (s += i) : (s += ' ' + i)) : (s = i);
    }),
    s.replace(/\s+/g, ' ').trim()
  );
}
var Jw = (e) => ({ dis: [{ sides: [{ k: 's', n: Is(e) }] }] });
function wH(e) {
  return Jw(pa(e));
}
var SH = { k: 'fn', f: 'exp', a: { k: 'num', v: { n: 1n, d: 1n } } };
function Cg(e) {
  switch (e.k) {
    case 'sym':
      return e.n === 'e' ? SH : e;
    case 'add':
    case 'mul':
      return { ...e, c: e.c.map(Cg) };
    case 'div':
    case 'pow':
    case 'binom':
      return { ...e, a: Cg(e.a), b: Cg(e.b) };
    case 'fn':
      return { ...e, a: Cg(e.a) };
    default:
      return e;
  }
}
function rm(e) {
  if (!e.length) return null;
  try {
    let n = ie(ot(e));
    return n.ok && n.s.k === 'expr' ? Cg(n.s.e) : null;
  } catch {
    return null;
  }
}
function Rk(e) {
  try {
    return rm(ne(Te(e)));
  } catch {
    return null;
  }
}
var jr = (e) => {
    try {
      return E(R(e));
    } catch {
      return E(e);
    }
  },
  Gl = (e) => {
    try {
      return nl(e);
    } catch {
      return E(e);
    }
  };
function Xw(e) {
  return e.k === 'num'
    ? e.v.d === 1n
      ? e.v.n < 0n
        ? -e.v.n
        : e.v.n
      : null
    : e.k === 'mul' && e.c[0]?.k === 'num'
      ? Xw(e.c[0])
      : null;
}
var N2 = (e, n) => (n === 0n ? e : N2(n, e % n));
function Vc(e) {
  switch (e.k) {
    case 'div': {
      let n = Xw(e.a),
        t = Xw(e.b);
      return (
        (n !== null && t !== null && n > 0n && t > 1n && N2(n, t) > 1n ? 1 : 0) + Vc(e.a) + Vc(e.b)
      );
    }
    case 'add':
    case 'mul':
      return e.c.reduce((n, t) => n + Vc(t), 0);
    case 'pow':
      return Vc(e.a) + Vc(e.b);
    case 'fn':
      return Vc(e.a);
    default:
      return 0;
  }
}
var sm = (e) => {
    try {
      return Yf(e) + Vc(e);
    } catch {
      return 99;
    }
  },
  xo = (e) => e.k === 'num' && e.v.n === 1n && e.v.d === 1n,
  vo = (e) => e.k === 'num' && e.v.n === 0n;
function Ps(e, n = {}) {
  try {
    let t = Nf(() => D(e, n));
    return Number.isFinite(t) ? t : NaN;
  } catch {
    return NaN;
  }
}
var Hn = (e, n) =>
  Number.isFinite(e) &&
  Number.isFinite(n) &&
  Math.abs(e - n) <= 1e-9 * Math.max(1, Math.abs(e), Math.abs(n));
function ma(e) {
  switch (e.k) {
    case 'fn': {
      let n = ma(e.a),
        t = { ...e, a: n };
      if ([...$(n)].every((r) => r === '\u03C0')) {
        let r = Ps(t);
        for (let s of [-1, 0, 1]) if (Number.isFinite(r) && Math.abs(r - s) < 1e-12) return T(s);
      }
      return t;
    }
    case 'mul': {
      let n = e.c.map(ma);
      if (n.some(vo)) return T(0);
      let t = n.filter((r) => !xo(r));
      return t.length === 0 ? T(1) : t.length === 1 ? t[0] : I(...t);
    }
    case 'add': {
      let n = e.c.map(ma).filter((t) => !vo(t));
      return n.length === 0 ? T(0) : n.length === 1 ? n[0] : he(...n);
    }
    case 'div': {
      let n = ma(e.a),
        t = ma(e.b);
      return vo(n) ? T(0) : xo(t) ? n : ye(n, t);
    }
    case 'pow': {
      let n = ma(e.a),
        t = ma(e.b);
      return xo(t) ? n : vo(t) || xo(n) ? T(1) : vo(n) ? T(0) : { ...e, a: n, b: t };
    }
    default:
      return e;
  }
}
var TH = [
    0.9914553711208126, 0.9491079123427585, 0.8648644233597691, 0.7415311855993945,
    0.5860872354676911, 0.4058451513773972, 0.20778495500789848, 0,
  ],
  R2 = [
    0.022935322010529224, 0.06309209262997856, 0.10479001032225019, 0.14065325971552592,
    0.1690047266392679, 0.19035057806478542, 0.20443294007529889, 0.20948214108472782,
  ],
  $2 = [0.1294849661688697, 0.27970539148927664, 0.3818300505051189, 0.4179591836734694];
function Hw(e, n, t) {
  let r = (n + t) / 2,
    s = (t - n) / 2,
    i = e(r),
    o = i * R2[7],
    a = i * $2[3];
  for (let l = 0; l < 7; l++) {
    let u = s * TH[l],
      c = e(r - u) + e(r + u);
    ((o += R2[l] * c), l % 2 === 1 && (a += $2[(l - 1) / 2] * c));
  }
  return { k: o * s, err: Math.abs((o - a) * s) };
}
function _g(e, n, t) {
  if (!Number.isFinite(n) || !Number.isFinite(t)) return NaN;
  if (n === t) return 0;
  let r = Hw(e, n, t);
  if (!Number.isFinite(r.k)) return NaN;
  let s = 1e-13 * Math.max(1, Math.abs(r.k)),
    i = 0,
    o = (l, u, c, f) => {
      if (c.err <= s * ((u - l) / (t - n) + 0.001) || f > 40 || i > 4e3) return c.k;
      let d = (l + u) / 2,
        m = Hw(e, l, d),
        p = Hw(e, d, u);
      return ((i += 2), o(l, d, m, f + 1) + o(d, u, p, f + 1));
    },
    a = o(n, t, r, 0);
  return Number.isFinite(a) ? a : NaN;
}
var zl = (e) => (e.atom ? e.atom.key : 'I');
function O2(e, n, t, r) {
  return `${e}|${jr(n)}|${jr(t)}|${jr(r)}`;
}
function $k(e, n) {
  let t = e.cache.get(n.key);
  if (t !== void 0) return t;
  let r;
  return (
    n.k === 'brk'
      ? (r = Ps(n.body, { [e.x]: n.b }) - Ps(n.body, { [e.x]: n.a }))
      : (r = _g((s) => Ps(n.body, { [e.x]: s }), n.a, n.b)),
    e.cache.set(n.key, r),
    r
  );
}
function Yw(e, n, t = e.value) {
  let r = n.cv;
  for (let s of n.items) r += s.cv * (s.atom ? $k(e, s.atom) : t);
  return r;
}
function Eg(e, n = !1) {
  let t = (s) => sm(n ? ma(s) : s),
    r = t(e.c);
  for (let s of e.items) xo(s.coef) || (r += t(s.coef));
  return r;
}
function wk(e, n) {
  let t = (r) => [...$(r)].some((s) => n.has(s));
  if (!t(e)) return [{ coef: e, ref: null }];
  switch (e.k) {
    case 'sym':
      return [{ coef: T(1), ref: e.n }];
    case 'add': {
      let r = [];
      for (let s of e.c) {
        let i = wk(s, n);
        if (!i) return null;
        r.push(...i);
      }
      return r;
    }
    case 'mul': {
      let r = e.c.filter(t);
      if (r.length !== 1) return null;
      let s = e.c.filter((o) => !t(o)),
        i = wk(r[0], n);
      return i
        ? i.map((o) => ({
            coef: s.length
              ? xo(o.coef)
                ? s.length === 1
                  ? s[0]
                  : I(...s)
                : I(...s, o.coef)
              : o.coef,
            ref: o.ref,
          }))
        : null;
    }
    case 'div': {
      if (t(e.b)) return null;
      let r = wk(e.a, n);
      return r ? r.map((s) => ({ coef: ye(s.coef, e.b), ref: s.ref })) : null;
    }
    default:
      return null;
  }
}
function RH(e, n, t) {
  let r = new Map(),
    s = [];
  for (let u of e) {
    if (u.ref === null) {
      s.push(u.coef);
      continue;
    }
    let c = u.ref === t ? null : n.get(u.ref),
      f = c ? c.key : 'I',
      d = r.get(f) ?? { atom: c, coefs: [] };
    (d.coefs.push(u.coef), r.set(f, d));
  }
  let i = [...r.values()]
      .map((u) => {
        let c = u.coefs.length === 1 ? u.coefs[0] : he(...u.coefs);
        return { atom: u.atom, coef: c, cv: Ps(c) };
      })
      .filter((u) => !Hn(u.cv, 0) || !Number.isFinite(u.cv)),
    o = s.length === 0 ? T(0) : s.length === 1 ? s[0] : he(...s),
    a = i.filter((u) => !u.atom).reduce((u, c) => u + c.cv, 0),
    l =
      i
        .map((u) => `${zl(u)}:${Gl(u.coef)}`)
        .sort()
        .join(',') +
      '#' +
      (vo(o) ? '' : Gl(o));
  return { items: i, c: o, cv: Ps(o), iCoef: a, wkey: l };
}
var It = (e, n, t) => ({ k: 'syntax', title: e, message: n, index: t });
function K2(e, n) {
  if (!n.length) return { k: 'empty' };
  let t = bH.exec(n[0]);
  if (t) {
    if (n.length === 1) return { k: 'incomplete' };
    if (n[1] !== '=') return It('Nomme une fonction', '\xC9cris \xAB u(x) = \u2026 \xBB.', 1);
    if (t[3] !== e.x)
      return It(
        'La variable',
        `\xC9cris ${t[1]}${t[2]}(${e.x}) = \u2026 : la variable est ${e.x}.`,
        0,
      );
    let m = n.slice(2);
    if (!m.length) return { k: 'incomplete' };
    if (m.some(Mg) || m.includes('='))
      return It(
        'Une fonction',
        'Apr\xE8s \xAB = \xBB, \xE9cris seulement une fonction de ' + e.x + '.',
        2,
      );
    let p = vn(m);
    if (!p.ok) return It('\xC7a commence mal', p.msg, 2 + p.index);
    if (!p.complete) return { k: 'incomplete' };
    let g = rm(m);
    return g
      ? { k: 'name', head: t[1] === 'u' ? (t[2] ? 'du' : 'u') : t[2] ? 'dv' : 'v', expr: g }
      : It('\xC7a ne se lit pas', 'V\xE9rifie les parenth\xE8ses.', n.length - 1);
  }
  let r = new Map(),
    s = [],
    i = [],
    o = 0;
  for (let m = 0; m < n.length; m++) {
    let p = n[m];
    if (Qr(p) || p === '[') {
      let g = Qr(p),
        h = m + 1;
      for (; h < n.length && !(g ? Fr(n[h]) : yi(n[h])); ) {
        if (Mg(n[h]))
          return It(
            g ? 'Ferme l\u2019int\xE9grale' : 'Ferme le crochet',
            g
              ? 'Une int\xE9grale se ferme par \xAB dx \xBB avant d\u2019\xE9crire autre chose.'
              : 'Un crochet se ferme par \xAB ](a ; b) \xBB avant d\u2019\xE9crire autre chose.',
            h,
          );
        h++;
      }
      if (h >= n.length) return { k: 'incomplete' };
      let b = n
        .slice(m + 1, h)
        .filter((G, Se, U) => !(G === '\xD7' && (Se === 0 || Se === U.length - 1)));
      if (!b.length)
        return It(
          g ? 'La fonction \xE0 int\xE9grer' : 'Dans le crochet',
          g
            ? '\xC9cris la fonction entre \u222B et dx.'
            : '\xC9cris une fonction entre les crochets.',
          h,
        );
      let v = vn(ne(b));
      if (!v.ok) return It('\xC7a commence mal', v.msg, m + 1 + Math.min(v.index, b.length - 1));
      if (!v.complete) return It('\xC7a ne se lit pas', 'La fonction n\u2019est pas finie.', h);
      let k = rm(ne(b));
      if (!k) return It('\xC7a ne se lit pas', 'V\xE9rifie les parenth\xE8ses.', h);
      let y = (g ? rS : q2).exec(g ? p : n[h]);
      if (g && sS.exec(n[h])[1] !== e.x)
        return It(
          'La variable',
          `La variable est ${e.x} : ferme l\u2019int\xE9grale par \xAB d${e.x} \xBB.`,
          h,
        );
      let S = Rk(y[1]),
        w = Rk(y[2]);
      if (!S || !w) return It('Les bornes', 'Une borne ne se lit pas.', g ? m : h);
      let _ = {
          k: g ? 'int' : 'brk',
          lo: S,
          hi: w,
          a: Ps(S),
          b: Ps(w),
          body: k,
          key: O2(g ? 'int' : 'brk', S, w, k),
          text: g ? `${p} ${Tk(ne(b))} ${n[h]}` : `[${Tk(ne(b))}${n[h]}`,
        },
        O = `\u03C8${String(++o)
          .split('')
          .map((G) => '\u2080\u2081\u2082\u2083\u2084\u2085\u2086\u2087\u2088\u2089'[Number(G)])
          .join('')}`;
      (r.set(O, _), s.push(O), i.push(m), (m = h));
      continue;
    }
    if (yi(p))
      return It(
        'Ouvre le crochet',
        'Un crochet s\u2019ouvre par \xAB [ \xBB avant de se fermer.',
        m,
      );
    if (Fr(p))
      return It(
        '\xAB dx \xBB ferme une int\xE9grale',
        '\xC9cris d\u2019abord \xAB \u222B(a ; b) \xBB, puis la fonction.',
        m,
      );
    (s.push(p), i.push(m));
  }
  let a = ne(s),
    l = vn(a, { chains: !0 });
  if (!l.ok) return It('\xC7a commence mal', l.msg, i[Math.min(l.index, i.length - 1)] ?? 0);
  if (!l.complete) return { k: 'incomplete' };
  if (!a.includes('=')) return { k: 'noeq' };
  let u = new Set([...r.keys(), e.name]),
    c = [[]],
    f = 0;
  for (let m of a)
    (m === '(' && f++,
      m === ')' && f--,
      f === 0 && m === '=' ? c.push([]) : c[c.length - 1].push(m));
  let d = [];
  for (let m of c) {
    let p = rm(m);
    if (!p)
      return It(
        '\xC7a ne se lit pas',
        'Un membre ne se lit pas : v\xE9rifie les parenth\xE8ses.',
        n.length - 1,
      );
    if ([...$(p)].some((h) => !u.has(h) && h !== '\u03C0'))
      return It(
        'Une lettre en trop',
        `Hors d\u2019une int\xE9grale ou d\u2019un crochet, ${e.x} n\u2019a pas de valeur : \xE9cris des nombres, ${e.name}, des int\xE9grales ou des crochets.`,
        n.length - 1,
      );
    let g = wk(p, u);
    if (!g)
      return It(
        'Une int\xE9grale \xE0 part',
        'Une int\xE9grale (ou un crochet) se multiplie par un nombre, s\u2019ajoute ou se retranche ; elle ne se met pas dans une fonction.',
        n.length - 1,
      );
    d.push(RH(g, r, e.name));
  }
  return { k: 'chain', members: d };
}
var $H = [0.061, 0.137, 0.229, 0.318, 0.411, 0.503, 0.597, 0.689, 0.773, 0.857, 0.941];
function zc(e, n) {
  let t = Math.min(e, n),
    r = Math.max(e, n);
  return !(r > t) || !Number.isFinite(t) || !Number.isFinite(r)
    ? []
    : $H.map((s) => t + s * (r - t));
}
function Bl(e, n, t) {
  return t.map((r) => Ps(e, { [n]: r }));
}
function P2(e, n) {
  let t = 0;
  for (let r = 0; r < e.length; r++) {
    let s = e[r],
      i = n[r];
    if (Number.isNaN(s) !== Number.isNaN(i)) return !1;
    if (!Number.isNaN(s)) {
      if (!nn(s, i) && !(Math.abs(s - i) < 1e-11)) return !1;
      t++;
    }
  }
  return t >= 5;
}
var ko = (e, n, t, r) => P2(Bl(e, t, r), Bl(n, t, r));
function CH(e, n, t, r) {
  let s = Bl(e, t, r),
    i = Bl(n, t, r),
    o = null,
    a = 0;
  for (let l = 0; l < s.length; l++) {
    if (!Number.isFinite(s[l]) || !Number.isFinite(i[l])) {
      if (Number.isNaN(s[l]) !== Number.isNaN(i[l])) return !1;
      continue;
    }
    let u = s[l] - i[l];
    if (o === null) o = u;
    else if (!nn(u + 1, o + 1)) return !1;
    a++;
  }
  return a >= 5;
}
function Uc(e, n) {
  try {
    return kd(() => wn(e, n));
  } catch {
    return null;
  }
}
function I2(e, n, t, r, s) {
  let i = n.reduce((u, c) => u + Dc[c].hora, 0),
    o = 0;
  n.forEach((u, c) => {
    Dc[u].hora > Dc[n[o]].hora && (o = c);
  });
  let a = [...new Set(t.map((u, c) => u || Dc[n[c]].label))],
    l = [...new Set(n)].map((u) => Dc[u].why).join(' ') + (s ? ' C\u2019est la r\xE9ponse.' : '');
  return {
    kind: 'step',
    ...e,
    hora: i,
    final: s,
    rule: { id: gH[n[o]], card: hH, label: a.join(' \u2192 '), hora: i, why: l },
    imove: { ...r, ...(s ? { final: s } : {}) },
  };
}
function C2(e, n, t, r) {
  return {
    kind: 'useless',
    ...e,
    jump: !0,
    final: t,
    title: t ? 'Juste !' : 'Juste, mais tu sautes des \xE9tapes',
    message:
      r ??
      (t
        ? 'C\u2019est la bonne valeur. D\xE9taille ton calcul, une \xE9tape par ligne, pour gagner des HORA. Tu peux garder cette ligne sans HORA.'
        : 'Ta ligne est juste. D\xE9taille-la, une \xE9tape \xE0 la fois, pour gagner des HORA. Tu peux la garder sans HORA.'),
    imove: { ...n, ...(t ? { final: t } : {}) },
  };
}
function EH(e, n, t) {
  let r = Is(n.atoms),
    s = e.traps.find((i) => i.text === r);
  return s
    ? {
        kind: 'trap',
        ...n,
        title: s.title,
        message: s.why,
        trap: { line: s.line, title: s.title, why: s.why },
      }
    : { kind: 'false', ...n, ...t };
}
var Ul = (e) => `k:${Math.round(e * 1e9)}`;
function MH(e) {
  let n = e.kernel,
    t = n.goal.target,
    r = pa(n.start);
  if (r[0] !== t || r[1] !== '=')
    throw new bo(`Le d\xE9part s\u2019\xE9crit \xAB ${t} = \u222B(a ; b) \u2026 dx \xBB.`);
  let s = r.findIndex(Qr),
    i = r.findIndex(Fr);
  if (s !== 2 || i !== r.length - 1)
    throw new bo(
      `Le d\xE9part s\u2019\xE9crit \xAB ${t} = \u222B(a ; b) \u2026 dx \xBB : une seule int\xE9grale.`,
    );
  let o = sS.exec(r[i])[1],
    a = rS.exec(r[s]),
    l = rm(ne(r.slice(s + 1, i))),
    u = Rk(a[1]),
    c = Rk(a[2]);
  if (!l || !u || !c) throw new bo(`D\xE9part illisible : \xAB ${n.start} \xBB.`);
  if ([...$(l)].some((p) => p !== o && p !== '\u03C0'))
    throw new bo(`La fonction \xE0 int\xE9grer ne d\xE9pend que de ${o}.`);
  let f = {
      k: 'int',
      lo: u,
      hi: c,
      a: Ps(u),
      b: Ps(c),
      body: l,
      key: O2('int', u, c, l),
      text: Is(r.slice(2)),
    },
    d = pa(n.answer);
  if (d[0] !== t || d[1] !== '=' || d.length < 3)
    throw new bo(`La r\xE9ponse s\u2019\xE9crit \xAB ${t} = valeur \xBB.`);
  if (d.slice(2).some(Mg))
    throw new bo('La r\xE9ponse est une valeur, sans int\xE9grale ni crochet.');
  let m = rm(d.slice(2));
  if (!m || [...$(m)].some((p) => p !== '\u03C0'))
    throw new bo('La r\xE9ponse est une valeur (des nombres, e, \u03C0, ln\u2026).');
  return { name: t, x: o, atom: f, answer: m };
}
function Ck(e) {
  let n = e.kernel,
    t = MH(e),
    r = {
      model: e,
      name: t.name,
      x: t.x,
      startAtom: t.atom,
      value: NaN,
      answer: t.answer,
      answerValue: Ps(t.answer),
      answerOps: sm(t.answer),
      classes: new Map(),
      side: new Map(),
      names: {},
      written: new Set(),
      givenTexts: new Set(),
      path: n.path ?? [],
      traps: [],
      lines: 0,
      concluded: !1,
      cache: new Map(),
    };
  if (((r.value = $k(r, t.atom)), !Number.isFinite(r.value)))
    throw new bo(
      'L\u2019int\xE9grale n\u2019a pas de valeur (la fonction n\u2019est pas d\xE9finie sur l\u2019intervalle).',
    );
  let s = {
    items: [{ atom: t.atom, coef: T(1), cv: 1 }],
    c: T(0),
    cv: 0,
    iCoef: 0,
    wkey: `${t.atom.key}:1#`,
  };
  return (
    r.classes.set(Ul(1), [s]),
    (r.givenTexts = new Set(_H(e).map((i) => Is(pa(i))))),
    (r.traps = (e.traps ?? []).map((i) => ({
      text: Is(pa(i.line)),
      line: wH(i.line),
      title: i.title ?? 'Attention',
      why: i.why,
    }))),
    r
  );
}
function _H(e) {
  return [e.kernel.start, ...(e.givens ?? [])];
}
function iS(e, n) {
  let t = [...n.items],
    r = [],
    s = !1;
  for (let i of e.items) {
    let o = t.findIndex((a) => zl(a) === zl(i) && Hn(a.cv, i.cv));
    o >= 0 ? (Gl(t[o].coef) !== Gl(i.coef) && (s = !0), t.splice(o, 1)) : r.push(i);
  }
  return { gone: r, came: t, recoef: s };
}
var Ww = (e, n) => Hn(e.a, n.a) && Hn(e.b, n.b);
function eS(e, n) {
  let t = [],
    r = [],
    s = (o) => {
      o.k === 'mul'
        ? o.c.forEach(s)
        : o.k === 'div' && !$(o.b).has(n)
          ? (t.push(ye(T(1), o.b)), s(o.a))
          : $(o).has(n)
            ? r.push(o)
            : t.push(o);
    };
  if (e.k === 'add') return he(...e.c.map((o) => eS(o, n)));
  if ((s(e), r.length === 1 && r[0].k === 'add'))
    return he(...r[0].c.map((o) => eS(t.length ? I(...t, o) : o, n)));
  let i = [...t, ...r];
  return i.length === 1 ? i[0] : I(...i);
}
function E2(e, n) {
  let t = null;
  try {
    t = kd(() => Pp(eS(e, n), n, () => null));
  } catch {
    t = null;
  }
  if (!t || t.rules.includes('product') || t.rules.includes('quotient')) return null;
  let r = t.rules.find((i) => i !== 'usual');
  return r
    ? {
        kind: 'recognize',
        label:
          r === 'chain_exp'
            ? 'Reconna\xEEtre u\u2032e\u1D58'
            : r === 'chain_ln'
              ? 'Reconna\xEEtre u\u2032 \xF7 u'
              : r === 'chain_pow'
                ? 'Reconna\xEEtre u\u2032u\u207F'
                : r === 'chain_sqrt'
                  ? 'Reconna\xEEtre u\u2032 \xF7 \u221Au'
                  : r === 'chain_trig'
                    ? 'Reconna\xEEtre u\u2032 cos u'
                    : r === 'inverse'
                      ? 'Reconna\xEEtre u\u2032 \xF7 u\xB2'
                      : r === 'chain_arc'
                        ? qH(e)
                        : Dc.recognize.label,
      }
    : { kind: 'primitive', label: Dc.primitive.label };
}
function qH(e) {
  let n = (t, r) =>
    t.k === 'fn'
      ? t.f === r || n(t.a, r)
      : t.k === 'add' || t.k === 'mul'
        ? t.c.some((s) => n(s, r))
        : t.k === 'num' || t.k === 'sym'
          ? !1
          : n(t.a, r) || n(t.b, r);
  return n(e, 'arcsin') || n(e, 'arccos')
    ? 'Reconna\xEEtre u\u2032 \xF7 \u221A(1 \u2212 u\xB2)'
    : 'Reconna\xEEtre u\u2032 \xF7 (1 + u\xB2)';
}
function A2(e, n, t, r) {
  let s;
  try {
    s = vl(e, t);
  } catch {
    return null;
  }
  let i = [],
    o = [...s.c],
    a = (u) => {
      u.k === 'mul'
        ? u.c.forEach(a)
        : u.k === 'div' && !$(u.b).has(t)
          ? (o.push(ye(T(1), u.b)), a(u.a))
          : $(u).has(t)
            ? i.push(u)
            : o.push(u);
    };
  s.core.forEach(a);
  let l = i.length;
  if (!l || l > 6) return null;
  for (let u = 1; u < 1 << l; u++) {
    let c = i.filter((g, h) => u & (1 << h)),
      f = [...o, ...i.filter((g, h) => !(u & (1 << h)))];
    if (!f.some((g) => [...$(g)].includes(t))) continue;
    let d = c.length === 1 ? c[0] : I(...c),
      m = f.length === 1 ? f[0] : I(...f),
      p = Uc(m, t);
    if (p && ko(I(d, p), n, t, r)) return { u: d, v: m };
  }
  return null;
}
function tm(e) {
  switch (e.k) {
    case 'fn':
      return e.f === 'cos' || e.f === 'sin' ? 1 : 0;
    case 'add':
      return Math.max(0, ...e.c.map(tm));
    case 'mul':
      return e.c.reduce((n, t) => n + tm(t), 0);
    case 'div':
      return tm(e.a);
    case 'pow': {
      let n = e.b.k === 'num' && e.b.v.d === 1n ? Number(e.b.v.n) : 0;
      return n > 0 ? n * tm(e.a) : 0;
    }
    default:
      return 0;
  }
}
function Bc(e, n) {
  switch (e.k) {
    case 'div':
      return ($(e.b).has(n) ? 1 : 0) + Bc(e.a, n) + Bc(e.b, n);
    case 'add':
    case 'mul':
      return e.c.reduce((t, r) => t + Bc(r, n), 0);
    case 'pow':
      return Bc(e.a, n);
    case 'fn':
      return Bc(e.a, n);
    default:
      return 0;
  }
}
function M2(e, n, t) {
  let r = tm(e);
  if (r >= 2 && tm(n) < r) return 'linearize';
  let s = 0,
    i = 0;
  try {
    ((s = Bc(e, t)), (i = Bc(n, t)));
  } catch {}
  return s === 1 && i >= 2 ? 'decompose' : 'rewrite';
}
var nS = (e) =>
  e.length === 1
    ? xo(e[0].coef)
      ? e[0].atom.body
      : I(e[0].coef, e[0].atom.body)
    : he(...e.map((n) => (xo(n.coef) ? n.atom.body : I(n.coef, n.atom.body))));
function tS(e, n, t) {
  let r = e.x,
    s = iS(n, t),
    i = Hn(n.cv, t.cv),
    o = Gl(n.c) === Gl(t.c);
  if (!s.gone.length && !s.came.length) {
    if (n.wkey === t.wkey) return { k: 'same' };
    let b = Eg(n),
      v = Eg(t);
    return v < b
      ? Eg(n, !0) - v > 4
        ? { k: 'jump' }
        : { k: 'step', steps: ['compute'], labels: [''] }
      : { k: 'same' };
  }
  let a = s.gone.filter((b) => !b.atom),
    l = s.came.filter((b) => !b.atom),
    u = s.gone.filter((b) => b.atom?.k === 'int'),
    c = s.gone.filter((b) => b.atom?.k === 'brk'),
    f = s.came.filter((b) => b.atom?.k === 'int'),
    d = s.came.filter((b) => b.atom?.k === 'brk');
  if (s.gone.length === 1 && s.gone[0].atom && !a.length) {
    let b = s.gone[0];
    for (let v of e.side.get(b.atom.key) ?? []) {
      let k = [...v.items.map((S) => ({ ...S, cv: S.cv * b.cv }))];
      if (
        k.length === s.came.length &&
        k.every((S) => s.came.some((w) => zl(w) === zl(S) && Hn(w.cv, S.cv))) &&
        Hn(t.cv, n.cv + b.cv * v.cv)
      )
        return { k: 'step', steps: ['replace'], labels: [''] };
    }
  }
  if (
    u.length === 1 &&
    l.length === 1 &&
    s.gone.length === 1 &&
    s.came.length === 1 &&
    u[0].atom.key === e.startAtom.key &&
    Hn(u[0].cv, l[0].cv) &&
    i
  )
    return { k: 'step', steps: ['recognizeI'], labels: [''] };
  if (a.length || l.length) return { k: 'jump' };
  if (c.length && !u.length && !s.came.length) {
    let b = n.c,
      v = vo(n.c) ? [] : [n.c];
    for (let S of c) {
      let w = S.atom,
        _ = w.body,
        O = he(j(_, { [r]: w.hi }), I(T(-1), j(_, { [r]: w.lo })));
      v.push(xo(S.coef) ? O : I(S.coef, O));
    }
    b = v.length === 1 ? v[0] : he(...v);
    let k = sm(ma(b)),
      y = sm(t.c);
    return (y === 0 && k >= 4) || k - y > 7
      ? { k: 'jump' }
      : {
          k: 'step',
          steps: ['bracket'],
          labels: [c.length > 1 ? 'Remplacer x par les bornes (les crochets)' : ''],
        };
  }
  if (c.length && d.length && !u.length && !f.length) {
    let b = c[0].atom;
    if (![...c, ...d].every((S) => Ww(S.atom, b))) return { k: 'jump' };
    if (!i || !o) return { k: 'jump' };
    let v = zc(b.a, b.b),
      k = he(...c.map((S) => I(S.coef, S.atom.body))),
      y = he(...d.map((S) => I(S.coef, S.atom.body)));
    return CH(k, y, r, v)
      ? {
          k: 'step',
          steps: ['bracketMerge'],
          labels: [d.length !== c.length ? '' : 'Transformer le crochet'],
        }
      : { k: 'jump' };
  }
  if (!u.length || c.length) return { k: 'jump' };
  if (!i || !o)
    return !s.came.length && u.every((b) => !$(b.atom.body).has(r))
      ? { k: 'step', steps: ['constant'], labels: [''] }
      : { k: 'jump' };
  let m = u[0].atom,
    p = nS(u),
    g = zc(m.a, m.b),
    h = (b) => b.every((v) => Ww(v.atom, m));
  if (u.length === 1 && f.length >= 2 && !d.length) {
    let b = [...f].sort((w, _) => Math.min(w.atom.a, w.atom.b) - Math.min(_.atom.a, _.atom.b)),
      v = Math.min(m.a, m.b),
      k = Math.max(m.a, m.b),
      y = v,
      S = !0;
    for (let w of b) {
      let _ = Math.min(w.atom.a, w.atom.b),
        O = Math.max(w.atom.a, w.atom.b);
      (Hn(_, y) || (S = !1), (y = O));
    }
    if (S && Hn(y, k) && !h(f))
      return b.every((_) => {
        let O = zc(_.atom.a, _.atom.b);
        return ko(I(_.coef, _.atom.body), I(u[0].coef, m.body), r, O);
      })
        ? { k: 'step', steps: ['chasles'], labels: [''] }
        : { k: 'jump' };
  }
  if (u.length >= 2 && d.length === u.length && !f.length) {
    let b = [...d],
      v = [],
      k = [];
    for (let y of u) {
      let S = b.findIndex((O) => {
        if (!Ww(O.atom, y.atom)) return !1;
        let G = Uc(O.atom.body, r),
          Se = zc(y.atom.a, y.atom.b);
        return !!G && ko(I(O.coef, G), I(y.coef, y.atom.body), r, Se);
      });
      if (S < 0) return { k: 'jump' };
      let w = b.splice(S, 1)[0];
      if (!$(y.atom.body).has(r)) {
        (v.push('constant'), k.push(''));
        continue;
      }
      let _ = E2(w.atom.body, r);
      if (!_)
        return {
          k: 'jump',
          message:
            'C\u2019est bien une primitive, mais elle ne se lit pas directement : passe par une int\xE9gration par parties pour la trouver. Tu peux garder cette ligne sans HORA.',
        };
      (v.push(_.kind), k.push(_.label));
    }
    return { k: 'step', steps: v, labels: k };
  }
  if (!h(u) || !h(f) || !h(d)) return { k: 'jump' };
  if (!f.length && d.length === 1) {
    let b = d[0],
      v = Uc(b.atom.body, r);
    if (!v || !ko(I(b.coef, v), p, r, g))
      return {
        k: 'jump',
        luck: !0,
        message:
          'Ce crochet a la m\xEAme valeur, mais ce n\u2019est pas une primitive de la fonction : c\u2019est un hasard. D\xE9rive ce qui est dans le crochet pour v\xE9rifier.',
      };
    if (!$(p).has(r)) return { k: 'step', steps: ['constant'], labels: [''] };
    let k = E2(b.atom.body, r);
    return k
      ? { k: 'step', steps: [k.kind], labels: [k.label] }
      : {
          k: 'jump',
          message:
            'C\u2019est bien une primitive, mais elle ne se lit pas directement : passe par une int\xE9gration par parties pour la trouver. Tu peux garder cette ligne sans HORA.',
        };
  }
  if (f.length === 1 && d.length === 1) {
    let b = d[0],
      v = f[0],
      k = Uc(b.atom.body, r);
    if (!k) return { k: 'jump' };
    let y = he(I(b.coef, k), I(v.coef, v.atom.body));
    if (!ko(y, p, r, g))
      return {
        k: 'jump',
        luck: !0,
        message:
          'Ta ligne a la m\xEAme valeur, mais ce n\u2019est pas une int\xE9gration par parties juste : c\u2019est un hasard. V\xE9rifie u, v\u2032, u\u2032 et v.',
      };
    let S = ye(p, b.coef);
    return u.length === 1 && A2(b.atom.body, S, r, g)
      ? { k: 'step', steps: ['parts'], labels: [''] }
      : {
          k: 'jump',
          message:
            'Ta ligne est juste, mais ce n\u2019est pas une int\xE9gration par parties : choisis u et v\u2032 avec u \xD7 v\u2032 = la fonction \xE0 int\xE9grer. Tu peux la garder sans HORA.',
        };
  }
  if (!d.length && f.length) {
    let b = nS(f);
    if (!ko(b, p, r, g))
      return {
        k: 'jump',
        luck: !0,
        message:
          'Les deux int\xE9grales ont la m\xEAme valeur, mais pas la m\xEAme fonction : c\u2019est un hasard. V\xE9rifie ta transformation (lin\xE9arisation, d\xE9veloppement, signe\u2026).',
      };
    if (u.length === 1 && f.length === 1) {
      let v = u[0],
        k = f[0];
      if (jr(v.atom.body) === jr(k.atom.body)) return { k: 'same' };
      let y = (() => {
        let w = Bl(v.atom.body, r, g),
          _ = Bl(k.atom.body, r, g),
          O = null;
        for (let G = 0; G < w.length; G++) {
          if (!Number.isFinite(w[G]) || !Number.isFinite(_[G]) || Math.abs(_[G]) < 1e-12) continue;
          let Se = w[G] / _[G];
          if (O === null) O = Se;
          else if (!nn(Se, O)) return null;
        }
        return O;
      })();
      return y !== null && !Hn(y, 1)
        ? { k: 'step', steps: ['linearity'], labels: ['Sortir la constante'] }
        : { k: 'step', steps: [M2(v.atom.body, k.atom.body, r)], labels: [''] };
    }
    if (u.length === 1 && f.length >= 2) {
      let v = kl(p).map((S) => Bl(S, r, g)),
        k = f.map((S) => Bl(I(S.coef, S.atom.body), r, g));
      if (v.length >= f.length && LH(v, k))
        return { k: 'step', steps: ['linearity'], labels: [''] };
      let y = M2(p, b, r);
      return {
        k: 'step',
        steps: [y],
        labels: [y === 'rewrite' ? 'Transformer et s\xE9parer' : ''],
      };
    }
    if (u.length >= 2 && f.length === 1)
      return { k: 'step', steps: ['linearity'], labels: ['R\xE9unir les int\xE9grales'] };
  }
  return { k: 'jump' };
}
function LH(e, n) {
  let t = e.length,
    r = n.length;
  if (t > 10 || r > 5) return !1;
  let s = e[0]?.length ?? 0,
    i = n.map(() => new Array(s).fill(0)),
    o = (a) => {
      if (a === t) return i.every((l, u) => P2(l, n[u]));
      for (let l = 0; l < r; l++) {
        for (let u = 0; u < s; u++) i[l][u] += e[a][u];
        if (o(a + 1)) return !0;
        for (let u = 0; u < s; u++) i[l][u] -= e[a][u];
      }
      return !1;
    };
  return o(0);
}
function NH(e, n, t) {
  let r = e.x,
    s = iS(n, t),
    i = s.gone.filter((u) => u.atom?.k === 'int'),
    o = s.gone.filter((u) => u.atom?.k === 'brk'),
    a = s.came.filter((u) => u.atom?.k === 'int'),
    l = s.came.filter((u) => u.atom?.k === 'brk');
  if (i.length === 1 && l.length === 1 && a.length === 1) {
    let u = i[0].atom,
      c = zc(u.a, u.b),
      f = nS(i),
      d = l[0],
      m = a[0],
      p = Uc(d.atom.body, r);
    return p && ko(he(I(d.coef, p), I(T(-1), m.coef, m.atom.body)), f, r, c)
      ? {
          title: 'Le signe',
          message:
            'Int\xE9gration par parties : \u222Bu v\u2032 = [u v] \u2212 \u222Bu\u2032 v. Devant l\u2019int\xE9grale qui reste, c\u2019est \xAB \u2212 \xBB.',
        }
      : A2(d.atom.body, ye(f, d.coef), r, c)
        ? {
            title: 'V\xE9rifie u\u2032 \xD7 v',
            message:
              'Le crochet [u v] est bon ; l\u2019int\xE9grale qui reste est celle de u\u2032 \xD7 v : v\xE9rifie u\u2032 et v.',
          }
        : {
            title: 'Ce n\u2019est pas une int\xE9gration par parties',
            message:
              'Choisis u et v\u2032 avec u \xD7 v\u2032 = la fonction \xE0 int\xE9grer ; puis \u222Bu v\u2032 = [u v] \u2212 \u222Bu\u2032 v.',
          };
  }
  if (i.length && l.length === 1 && !a.length)
    return {
      title: 'Pas une primitive',
      message:
        'D\xE9rive ce qui est dans le crochet : tu dois retrouver la fonction \xE0 int\xE9grer.',
    };
  if (o.length && !s.came.length) {
    let u = n.cv;
    for (let c of o) u += -c.cv * $k(e, c.atom);
    return Hn(u, t.cv)
      ? {
          title: 'Dans le bon ordre',
          message:
            '[F(x)](a ; b) vaut F(b) \u2212 F(a) : la borne du haut d\u2019abord, puis on retranche celle du bas.',
        }
      : {
          title: 'Calcul faux',
          message: 'Remplace x par la borne du haut, puis par celle du bas, et retranche.',
        };
  }
  return i.length && a.length && !l.length
    ? {
        title: 'Ce n\u2019est pas la m\xEAme int\xE9grale',
        message:
          'La nouvelle \xE9criture ne vaut pas la m\xEAme chose : v\xE9rifie ta transformation (lin\xE9arisation, d\xE9veloppement, signe\u2026).',
      }
    : !s.gone.length && !s.came.length
      ? {
          title: 'Calcul faux',
          message: 'Ce n\u2019est pas la m\xEAme valeur : reprends ton calcul.',
        }
      : {
          title: 'Ce n\u2019est pas \xE9gal',
          message: 'Les deux membres n\u2019ont pas la m\xEAme valeur.',
        };
}
function OH(e, n) {
  return e.path.some((t) => {
    let r;
    try {
      r = pa(t);
    } catch {
      return !1;
    }
    return r.length > n.length && n.every((s, i) => r[i] === s);
  });
}
function Zl(e, n, t) {
  let r = n.flatMap((d) => d.atoms),
    s = [];
  n.forEach((d, m) => d.atoms.forEach(() => s.push(m)));
  let i = L2(r),
    o = i.atoms;
  if (!o.length) return { kind: 'empty', atoms: o, badChip: -1 };
  let a = OH(e, o),
    l = () =>
      t?.verify
        ? { kind: 'syntax', atoms: o, title: 'Ligne inachev\xE9e', message: 'Termine ta ligne.' }
        : { kind: a ? 'building' : 'open', atoms: o, complete: !1 },
    u = K2(e, o);
  if (u.k === 'empty') return { kind: 'empty', atoms: o, badChip: -1 };
  if (u.k === 'incomplete') return l();
  if (u.k === 'syntax')
    return a && !t?.verify
      ? { kind: 'building', atoms: o, complete: !1 }
      : {
          kind: 'syntax',
          atoms: o,
          title: u.title,
          message: u.message,
          badChip: s[i.src[u.index] ?? r.length - 1] ?? n.length - 1,
        };
  if (u.k === 'noeq')
    return t?.verify
      ? {
          kind: 'syntax',
          atoms: o,
          line: Jw(o),
          title: 'Une \xE9galit\xE9',
          message: `\xC9cris une \xE9galit\xE9 : \xAB ${e.name} = \u2026 \xBB.`,
        }
      : { kind: a ? 'building' : 'open', atoms: o, complete: !1 };
  let c = { atoms: o, line: Jw(o) },
    f = u.k === 'name' ? IH(e, c, u.head, u.expr) : FH(e, c, u.members);
  return a && !t?.verify
    ? f.kind === 'step'
      ? { ...f, kind: 'ready', complete: !0 }
      : { kind: 'building', atoms: o, complete: !0 }
    : !t?.verify && (f.kind === 'unjustified' || f.kind === 'false')
      ? { kind: 'pending', atoms: o, complete: !0 }
      : { ...f, complete: !0 };
}
function KH(e) {
  let n = [],
    t = new Set(),
    r = [...e.classes.values()].flat().reverse();
  for (let s of [...r, ...[...e.side.values()].flat().reverse()])
    for (let i of s.items)
      i.atom?.k === 'int' && !t.has(i.atom.key) && (t.add(i.atom.key), n.push(i.atom));
  return n;
}
function _2(e) {
  let n = (() => {
      try {
        return R(e);
      } catch {
        return e;
      }
    })(),
    t = n.k === 'mul' ? n.c : [n],
    r = [];
  for (let s of t)
    if (s.k !== 'num')
      if (s.k === 'pow' && s.b.k === 'num' && s.b.v.d === 1n && s.b.v.n > 0n && s.b.v.n < 6n)
        for (let i = 0; i < Number(s.b.v.n); i++) r.push(jr(s.a));
      else r.push(jr(s));
  return r;
}
function PH(e, n) {
  let t = _2(e),
    r = _2(n);
  if (!t.length) return !1;
  let s = [...r];
  for (let i of t) {
    let o = s.indexOf(i);
    if (o < 0) return !1;
    s.splice(o, 1);
  }
  return !0;
}
function IH(e, n, t, r) {
  let s = e.x,
    i = Is(n.atoms),
    o = { u: 'Nommer u', dv: 'Nommer v\u2032', du: 'D\xE9river u', v: 'Une primitive de v\u2032' }[
      t
    ],
    a = { text: i, to: null, name: { head: t, expr: r } },
    l = () => I2(n, ['name'], [o], a, !1),
    u = e.names[t];
  if (u && jr(u) === jr(r))
    return {
      kind: 'useless',
      ...n,
      title: 'D\xE9j\xE0 \xE9crit',
      message: 'Cette ligne est d\xE9j\xE0 sur ta feuille.',
    };
  if ([...$(r)].some((g) => g !== s && g !== '\u03C0'))
    return {
      kind: 'syntax',
      ...n,
      title: 'Une fonction de ' + s,
      message: `\xC9cris une fonction de ${s} seulement.`,
    };
  let c = KH(e),
    f = c[0] ?? e.startAtom,
    d = zc(f.a, f.b);
  if (t === 'u' || t === 'dv') {
    if (t === 'u' && !$(r).has(s))
      return {
        kind: 'unjustified',
        ...n,
        title: 'u d\xE9pend de ' + s,
        message:
          'u est la partie qu\u2019on d\xE9rive : choisis un facteur qui d\xE9pend de ' + s + '.',
      };
    let g = t === 'u' ? r : e.names.u;
    return t === 'dv' && g
      ? c.some((v) => ko(I(g, r), v.body, s, zc(v.a, v.b)))
        ? l()
        : {
            kind: 'false',
            ...n,
            title: 'u \xD7 v\u2032',
            message: 'u \xD7 v\u2032 doit redonner la fonction \xE0 int\xE9grer.',
          }
      : c.some((b) => PH(r, b.body) || (t === 'dv' && jr(r) === '1'))
        ? l()
        : {
            kind: 'unjustified',
            ...n,
            title: 'Un facteur de la fonction',
            message: `${t === 'u' ? 'u' : 'v\u2032'} est un des facteurs de la fonction \xE0 int\xE9grer.`,
          };
  }
  if (t === 'du') {
    let g = e.names.u;
    if (!g)
      return {
        kind: 'unjustified',
        ...n,
        title: 'Nomme d\u2019abord u',
        message: '\xC9cris d\u2019abord \xAB u(x) = \u2026 \xBB.',
      };
    let h = Uc(g, s);
    return h && ko(h, r, s, d)
      ? l()
      : {
          kind: 'false',
          ...n,
          title: 'Pas la d\xE9riv\xE9e de u',
          message: 'D\xE9rive u : ce n\u2019est pas sa d\xE9riv\xE9e.',
        };
  }
  let m = e.names.dv;
  if (!m)
    return {
      kind: 'unjustified',
      ...n,
      title: 'Nomme d\u2019abord v\u2032',
      message: '\xC9cris d\u2019abord \xAB v\u2032(x) = \u2026 \xBB.',
    };
  let p = Uc(r, s);
  return p && ko(p, m, s, d)
    ? l()
    : {
        kind: 'false',
        ...n,
        title: 'Pas une primitive de v\u2032',
        message: 'D\xE9rive v : tu dois retrouver v\u2032.',
      };
}
function AH(e) {
  return e.items.length !== 1 || e.items[0].atom || !Hn(e.cv, 0) || !vo(e.c) ? null : e.items[0].cv;
}
function jH(e) {
  return e.items.length !== 1 || !e.items[0].atom || !vo(e.c) || !xo(e.items[0].coef)
    ? null
    : e.items[0].atom;
}
var QH = (e) => [...[...e.classes.values()].flat(), ...[...e.side.values()].flat()];
function FH(e, n, t) {
  let r = Is(n.atoms);
  if (e.givenTexts.has(r))
    return {
      kind: 'useless',
      ...n,
      title: 'C\u2019est l\u2019\xE9nonc\xE9',
      message: 'Cette ligne est d\xE9j\xE0 dans l\u2019\xE9nonc\xE9.',
    };
  let s = t.map((v) => Yw(e, v));
  if (s.some((v) => !Number.isFinite(v)))
    return {
      kind: 'false',
      ...n,
      title: 'Pas de valeur',
      message:
        'Une int\xE9grale ou un crochet n\u2019a pas de valeur ici : la fonction n\u2019est pas d\xE9finie sur tout l\u2019intervalle.',
    };
  let i = AH(t[0]),
    o = i === null ? jH(t[0]) : null;
  if (i === null && !o)
    return {
      kind: 'unjustified',
      ...n,
      title: `Pars de ${e.name}`,
      message: `\xC9cris \xAB ${e.name} = \u2026 \xBB (ou une int\xE9grale de ta feuille, \xAB \u222B(a ; b) \u2026 dx = \u2026 \xBB).`,
    };
  if (o && !QH(e).some((v) => v.items.some((k) => k.atom?.key === o.key)))
    return {
      kind: 'unjustified',
      ...n,
      title: 'Pas dans ton calcul',
      message: `Cette int\xE9grale n\u2019appara\xEEt pas encore dans le calcul de ${e.name}.`,
    };
  let a = e.value,
    l = i !== null ? i * a : $k(e, o);
  for (let v = 1; v < t.length; v++)
    if (!Hn(s[v], l)) {
      let k = v === 1 ? VH(e, t[0], i, o, t[1]) : t[v - 1];
      return EH(e, n, NH(e, k, t[v]));
    }
  let u =
      i !== null
        ? { k: 'class', key: Ul(i), forms: t.slice(1) }
        : { k: 'side', key: o.key, forms: t.slice(1) },
    c = { text: r, to: u },
    f = [],
    d = [],
    m = null,
    p = !1,
    g = 0;
  for (let v = 1; v < t.length; v++) {
    let k = t[v],
      y = v === 1 ? DH(e, t[0], i, o, k) : tS(e, t[v - 1], k);
    y.k === 'step'
      ? (f.push(...y.steps), d.push(...y.labels))
      : y.k === 'same'
        ? g++
        : ((m = y.message ?? m ?? void 0), y.luck && (p = !0));
  }
  let h = t[t.length - 1],
    b =
      !e.concluded &&
      i !== null &&
      Hn(i, 1) &&
      !h.items.length &&
      Hn(h.cv, e.answerValue) &&
      sm(h.c) <= e.answerOps;
  return p
    ? { ...C2(n, { text: r, to: null }, !1, m ?? void 0), title: 'M\xEAme valeur par hasard' }
    : m !== null
      ? C2(n, c, b, m)
      : f.length
        ? I2(n, f, d, c, b)
        : {
            kind: 'useless',
            ...n,
            title: g ? 'Rien de nouveau' : 'Juste, mais \xE7a ne t\u2019avance pas',
            message: g
              ? 'Cette \xE9criture est d\xE9j\xE0 sur ta feuille.'
              : 'Les deux \xE9critures sont \xE9gales, mais le calcul n\u2019avance pas.',
            imove: c,
            final: b,
          };
}
function j2(e, n, t) {
  return n !== null
    ? [...(e.classes.get(Ul(n)) ?? [])].reverse()
    : [
        { items: [{ atom: t, coef: T(1), cv: 1 }], c: T(0), cv: 0, iCoef: 0, wkey: `${t.key}:1#` },
        ...[...(e.side.get(t.key) ?? [])].reverse(),
      ];
}
function VH(e, n, t, r, s) {
  let i = j2(e, t, r),
    o = i[0] ?? n,
    a = -1;
  for (let l of i) {
    let u = iS(l, s),
      c = l.items.length - u.gone.length;
    c > a && ((a = c), (o = l));
  }
  return o;
}
function DH(e, n, t, r, s) {
  let i = j2(e, t, r),
    o = null;
  for (let a of i) {
    let l = tS(e, a, s);
    if (l.k === 'step') return l;
    l.k === 'same' ? (o = l) : o || (o = l);
  }
  if (t !== null && !Hn(t, 1) && !e.classes.has(Ul(t)))
    for (let a of [...(e.classes.get(Ul(1)) ?? [])].reverse()) {
      if (Hn(a.iCoef, 0) || !Hn(1 - a.iCoef, t)) continue;
      let l = { ...a, items: a.items.filter((c) => c.atom) };
      l.wkey =
        l.items
          .map((c) => `${zl(c)}:${Gl(c.coef)}`)
          .sort()
          .join(',') +
        '#' +
        (vo(l.c) ? '' : Gl(l.c));
      let u = tS(e, l, s);
      if (u.k === 'same') return { k: 'step', steps: ['collect'], labels: [''] };
      if (u.k === 'step')
        return { k: 'step', steps: ['collect', ...u.steps], labels: ['', ...u.labels] };
    }
  if (t !== null && Hn(t, 1))
    for (let [a, l] of e.classes) {
      if (a === Ul(1)) continue;
      let u = Number(a.slice(2)) / 1e9;
      for (let c of [...l].reverse())
        if (
          !(
            c.items.length !== s.items.length ||
            !c.items.every((d) => s.items.some((m) => zl(m) === zl(d) && Hn(m.cv, d.cv / u))) ||
            !Hn(s.cv, c.cv / u)
          ) &&
          !(Eg(s) > Eg(c) + 2)
        )
          return { k: 'step', steps: ['divide'], labels: [`Diviser par ${BH(u)}`] };
    }
  return o ?? { k: 'jump' };
}
function BH(e) {
  return Number.isInteger(e)
    ? String(e).replace('-', '\u2212')
    : String(Math.round(e * 1e3) / 1e3)
        .replace('.', ',')
        .replace('-', '\u2212');
}
function Ek(e, n) {
  let t = n.imove;
  if (t) {
    if ((e.written.add(t.text), e.lines++, t.name)) {
      let { head: r, expr: s } = t.name;
      (r === 'u' && e.names.u && jr(e.names.u) !== jr(s) && delete e.names.du,
        r === 'dv' && e.names.dv && jr(e.names.dv) !== jr(s) && delete e.names.v,
        (e.names[r] = s));
      return;
    }
    if (t.to) {
      let r = t.to.k === 'class' ? e.classes : e.side;
      r.set(t.to.key, [...(r.get(t.to.key) ?? []), ...t.to.forms]);
    }
    if (t.final) e.concluded = !0;
    else if (t.to?.k === 'class' && t.to.key === Ul(1)) {
      let r = t.to.forms[t.to.forms.length - 1];
      r &&
        !r.items.length &&
        Hn(r.cv, e.answerValue) &&
        sm(r.c) <= e.answerOps &&
        (e.concluded = !0);
    }
  }
}
function Q2(e) {
  return e.concluded;
}
function F2(e) {
  return [...(e.classes.get(Ul(1)) ?? []), ...(e.side.get(e.startAtom.key) ?? [])].some(
    (t) => !t.items.length,
  );
}
function zH(e, n) {
  let t;
  try {
    t = pa(n);
  } catch {
    return null;
  }
  let r = K2(e, t);
  return r.k === 'chain' ? r.members : null;
}
function Mk(e, n) {
  let t = zH(e, n);
  if (!t || t.length < 2) return !1;
  let r = Yw(e, t[0]);
  return Number.isFinite(r) && t.every((s) => Hn(Yw(e, s), r));
}
var UH = {
    rewrite: 'ode.rewrite@1',
    homogeneous: 'ode.homogeneous@1',
    characteristic: 'ode.characteristic@1',
    discriminant: 'ode.discriminant@1',
    roots: 'ode.roots@1',
    general: 'ode.general@1',
    homogSolutions: 'ode.homogeneous_solutions@1',
    constant: 'ode.constant@1',
    particular: 'ode.particular@1',
    superpose: 'ode.superpose@1',
    derive: 'ode.derive@1',
    evaluate: 'ode.evaluate@1',
    condition: 'ode.condition@1',
    solveC: 'ode.solve_constant@1',
    member: 'ode.member@1',
    value: 'ode.value@1',
    compute: 'kernel.compute@1',
  },
  ga = {
    rewrite: {
      label: 'Transformer l\u2019\xE9quation',
      hora: 1,
      why: 'Une \xE9quation \xE9quivalente : on passe un terme de l\u2019autre c\xF4t\xE9, on divise par un nombre non nul.',
    },
    homogeneous: {
      label: '\xC9quation homog\xE8ne',
      hora: 1,
      why: 'L\u2019\xE9quation homog\xE8ne (sans second membre) : on remplace le second membre par 0.',
    },
    characteristic: {
      label: '\xC9quation caract\xE9ristique',
      hora: 1,
      why: '\xC0 ay\u2033 + by\u2032 + cy = 0 correspond l\u2019\xE9quation caract\xE9ristique ar\xB2 + br + c = 0.',
    },
    discriminant: {
      label: 'Discriminant',
      hora: 1,
      why: 'Le discriminant de ar\xB2 + br + c : \u0394 = b\xB2 \u2212 4ac.',
    },
    roots: {
      label: 'Racines',
      hora: 1,
      why: 'Les racines de l\u2019\xE9quation caract\xE9ristique donnent les solutions.',
    },
    general: {
      label: 'Toutes les solutions',
      hora: 2,
      why: 'Toutes les solutions de l\u2019\xE9quation.',
    },
    homogSolutions: {
      label: 'Solutions de l\u2019\xE9quation homog\xE8ne',
      hora: 2,
      why: 'Les solutions de l\u2019\xE9quation homog\xE8ne.',
    },
    constant: {
      label: 'Solution constante',
      hora: 1,
      why: 'Une fonction constante y = k : sa d\xE9riv\xE9e est nulle, il reste une \xE9quation en k.',
    },
    particular: {
      label: 'Solution particuli\xE8re',
      hora: 1,
      why: 'Une solution de l\u2019\xE9quation compl\xE8te : en la rempla\xE7ant dans l\u2019\xE9quation, on retrouve l\u2019\xE9galit\xE9.',
    },
    superpose: {
      label: 'Toutes les solutions',
      hora: 1,
      why: 'Toutes les solutions = les solutions de l\u2019\xE9quation homog\xE8ne + une solution particuli\xE8re.',
    },
    derive: {
      label: 'D\xE9river',
      hora: 1,
      why: 'On d\xE9rive les solutions : les constantes restent des constantes.',
    },
    evaluate: {
      label: 'Calculer',
      hora: 1,
      why: 'On remplace x par sa valeur dans les solutions.',
    },
    condition: {
      label: 'Utiliser la condition',
      hora: 1,
      why: 'La condition donne une \xE9quation en la constante.',
    },
    solveC: {
      label: 'Trouver la constante',
      hora: 1,
      why: 'On r\xE9sout l\u2019\xE9quation en la constante.',
    },
    member: {
      label: 'Remplacer la constante',
      hora: 1,
      why: 'On remplace la constante par sa valeur dans les solutions.',
    },
    value: {
      label: 'Calculer la valeur',
      hora: 1,
      why: 'On remplace la variable par sa valeur dans la solution trouv\xE9e.',
    },
    compute: { label: 'Calculer', hora: 1, why: 'Un calcul.' },
  },
  GH = '\xC9quations diff\xE9rentielles',
  ht = class extends Error {},
  V2 = '\u039E\u039E\u039E',
  D2 = '\u039E\u039E\u039E\u039E',
  H2 = '\u2070\xB9\xB2\xB3\u2074\u2075\u2076\u2077\u2078\u2079',
  lS = (e) => e.length > 0 && [...e].every((n) => H2.includes(n));
function Wl(e, n = 'y', t = 'x') {
  let r = n.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'),
    s = e
      .replace(new RegExp(`([A-Za-z])(?=${r}(?:\u2033|\u2032|'|\u2019))`, 'g'), '$1 ')
      .replace(
        new RegExp(
          `(?<![A-Za-z\xC0-\xFF])${r}(?:\u2033|\u2032\u2032|''|\u2019\u2019)(?!\\s*\\()`,
          'g',
        ),
        ` ${D2} `,
      )
      .replace(
        new RegExp(`(?<![A-Za-z\xC0-\xFF])${r}(?:\u2032|'|\u2019)(?!\\s*\\()`, 'g'),
        ` ${V2} `,
      ),
    i = [];
  for (let a of Te(s)) {
    let l = i[i.length - 1];
    if (lS(a) && l !== void 0 && lS(l)) {
      i[i.length - 1] = l + a;
      continue;
    }
    i.push(a);
  }
  let o = i.map((a) => {
    if (a === V2) return `${n}\u2032`;
    if (a === D2) return `${n}\u2033`;
    if (a === `${n}(${t})`) return n;
    if (a === `${n}\u2032(${t})`) return `${n}\u2032`;
    if (a === `${n}\u2032\u2032(${t})`) return `${n}\u2033`;
    let l = new RegExp(`^${r}\u2032\u2032\\((.+)\\)$`).exec(a);
    return l ? `${n}\u2033(${l[1]})` : a;
  });
  return ne(o);
}
function Gc(e) {
  return ot(e)
    .replace(/ ([⁰¹²³⁴⁵⁶⁷⁸⁹]+)/g, '$1')
    .replace(/\//g, '\xF7')
    .replace(/\s*÷\s*/g, ' \xF7 ');
}
var qk = (e) => ({ dis: [{ sides: [{ k: 's', n: Gc(e) }] }] });
function ZH(e, n = 'y') {
  return qk(Wl(e, n));
}
function HH(e) {
  let n = [];
  for (let t = 0; t < e.length; t++) {
    let r = e[t];
    if (lS(r) && r !== '\xB2') {
      n.push('^', [...r].map((s) => String(H2.indexOf(s))).join(''));
      continue;
    }
    n.push(r);
  }
  return n;
}
var WH = { k: 'fn', f: 'exp', a: { k: 'num', v: { n: 1n, d: 1n } } };
function qg(e) {
  switch (e.k) {
    case 'sym':
      return e.n === 'e' ? WH : e;
    case 'add':
    case 'mul':
      return { ...e, c: e.c.map(qg) };
    case 'div':
    case 'pow':
    case 'binom':
      return { ...e, a: qg(e.a), b: qg(e.b) };
    case 'fn':
      return { ...e, a: qg(e.a) };
    default:
      return e;
  }
}
var At = (e) => qg(_e(e));
function we(e, n) {
  try {
    let t = D(e, n);
    return Number.isFinite(t) ? t : NaN;
  } catch {
    return NaN;
  }
}
function yo(e) {
  switch (e.k) {
    case 'num':
      return e.v.d === 1n ? 1 : 2;
    case 'sym':
      return 1;
    case 'add':
    case 'mul':
      return 1 + e.c.reduce((n, t) => n + yo(t), 0);
    case 'div':
    case 'pow':
    case 'binom':
      return 1 + yo(e.a) + yo(e.b);
    case 'fn':
      return 1 + yo(e.a);
  }
}
var dn = (e, n, t = 1) =>
  Number.isFinite(e) &&
  Number.isFinite(n) &&
  Math.abs(e - n) <= 1e-7 * Math.max(1, t, Math.abs(e), Math.abs(n));
function Lk(e, n) {
  try {
    return wn(e, n);
  } catch {
    return null;
  }
}
var om = [
    [0.7, -1.3],
    [-1.9, 0.45],
    [2.6, 1.7],
  ],
  JH = [
    [0.37, -1.21, 0.83],
    [1.9, 0.44, -0.6],
    [-0.73, 2.1, 1.3],
  ],
  W2 = [-2.3, -1.7, -1.15, -0.6, -0.25, 0.2, 0.55, 0.95, 1.35, 1.8, 2.25],
  XH = [0.3, 0.7, 1.1, 1.6, 2.1, 2.7, 3.3];
function J2(e, n, t) {
  let [r, s, i] = e.Y,
    o = $(n);
  for (let f of o) if (f !== e.x && f !== r && f !== s && f !== i && f !== '\u03C0') return null;
  if (!o.has(r) && !o.has(s) && !o.has(i)) return null;
  let a = [];
  for (let f of [r, s, i]) {
    let d = Lk(n, f);
    if (!d) return null;
    let m = $(d);
    if (m.has(r) || m.has(s) || m.has(i)) return null;
    a.push(d);
  }
  let l;
  try {
    l = R(j(n, { [r]: T(0), [s]: T(0), [i]: T(0) }));
  } catch {
    return null;
  }
  for (let f of t.slice(0, 5))
    for (let d of JH) {
      let m = { [e.x]: f, [r]: d[0], [s]: d[1], [i]: d[2] },
        p = we(n, m),
        g = a.reduce((h, b, v) => h + we(b, { [e.x]: f }) * d[v], we(l, m));
      if (!dn(p, g)) return null;
    }
  let u = (f) => t.some((d) => Math.abs(we(f, { [e.x]: d })) > 1e-12),
    c = u(a[2]) ? 2 : u(a[1]) ? 1 : 0;
  return c === 0 ? null : { order: c, a: [a[0], a[1], a[2]], f: R(I(T(-1), l)) };
}
function Lg(e, n, t) {
  return [...e.a.map((r) => we(r, { [n]: t })), we(e.f, { [n]: t })];
}
function uS(e, n, t, r) {
  return e.order !== n.order
    ? !1
    : r.every((s) => {
        let i = Lg(e, t, s),
          o = Lg(n, t, s),
          a = 0;
        if (
          (o.forEach((u, c) => {
            Math.abs(u) > Math.abs(o[a]) && (a = c);
          }),
          !(Math.abs(o[a]) > 1e-12) || !Number.isFinite(i[a]))
        )
          return !1;
        let l = i[a] / o[a];
        return Math.abs(l) > 1e-12 ? i.every((u, c) => dn(u, l * o[c], Math.abs(l * o[c]))) : !1;
      });
}
var Nk = (e) => ({ ...e, f: T(0) });
function oS(e, n, t, r) {
  let s = Lk(t, e.x),
    i = s ? Lk(s, e.x) : null;
  if (!s || (n.order === 2 && !i)) return !1;
  let o = [t, s, i ?? T(0)];
  return e.pts.every((a) => {
    let l = { ...r, [e.x]: a },
      u = [0, 1, 2].map((m) => (m > n.order ? 0 : we(n.a[m], { [e.x]: a }) * we(o[m], l))),
      c = we(n.f, { [e.x]: a }),
      f = u.reduce((m, p) => m + p, 0),
      d = Math.abs(c) + u.reduce((m, p) => m + Math.abs(p), 0);
    return dn(f, c, d);
  });
}
function ha(e, n) {
  let t = $(n);
  return e.consts.filter((r) => t.has(r));
}
function Ok(e, n) {
  return [...$(n)].filter((t) => t !== e.x && t !== '\u03C0' && !e.consts.includes(t));
}
var ur = (e, n) => Object.fromEntries(e.map((t, r) => [t, n[r] ?? 0]));
function YH(e, n, t) {
  let r = ur(
    t,
    t.map(() => 0),
  );
  return om.every((s) =>
    e.pts.every((i) => {
      let o = we(n, { ...r, [e.x]: i }),
        a = o;
      return (
        t.forEach((l, u) => {
          let c = ur(
            t,
            t.map((f, d) => (d === u ? 1 : 0)),
          );
          a += (s[u] ?? 0) * (we(n, { ...c, [e.x]: i }) - o);
        }),
        dn(we(n, { ...ur(t, s), [e.x]: i }), a)
      );
    }),
  );
}
function cS(e) {
  let n = e.map((s) => {
      let i = Math.max(...s.map((o) => Math.abs(o)));
      return i > 0 ? s.map((o) => o / i) : s.slice();
    }),
    t = 0,
    r = n[0]?.length ?? 0;
  for (let s = 0; s < r && t < n.length; s++) {
    let i = t;
    for (let o = t + 1; o < n.length; o++) Math.abs(n[o][s]) > Math.abs(n[i][s]) && (i = o);
    if (!(Math.abs(n[i][s]) < 1e-7)) {
      [n[t], n[i]] = [n[i], n[t]];
      for (let o = 0; o < n.length; o++) {
        if (o === t) continue;
        let a = n[o][s] / n[t][s];
        for (let l = s; l < r; l++) n[o][l] -= a * n[t][l];
      }
      t++;
    }
  }
  return t;
}
function X2(e, n, t) {
  let r = ur(
    t,
    t.map(() => 0),
  );
  return t.map((s, i) => {
    let o = ur(
      t,
      t.map((a, l) => (l === i ? 1 : 0)),
    );
    return e.pts.map((a) => we(n, { ...o, [e.x]: a }) - we(n, { ...r, [e.x]: a }));
  });
}
function Y2(e, n) {
  let t = ha(e, n),
    r = e.homog
      ? [['full', e.ode]]
      : [
          ['full', e.ode],
          ['homog', Nk(e.ode)],
        ];
  if (!t.length) {
    for (let [l, u] of r) if (oS(e, u, n, {})) return { k: 'one', of: l };
    return { k: 'none', why: 'plain' };
  }
  if (!YH(e, n, t)) return { k: 'none', why: 'notAffine' };
  let s = e.ode.order;
  for (let [l, u] of r)
    if (om.every((c) => oS(e, u, n, ur(t, c))))
      return cS(X2(e, n, t)) >= s ? { k: 'general', of: l, cs: t } : { k: 'partial', of: l, cs: t };
  let i = ur(
      t,
      t.map(() => 0),
    ),
    o = j(n, Object.fromEntries(Object.entries(i).map(([l, u]) => [l, T(u)]))),
    a = R(he(n, I(T(-1), o)));
  return !e.homog && om.every((l) => oS(e, Nk(e.ode), a, ur(t, l)))
    ? { k: 'none', why: 'particular' }
    : { k: 'none', why: 'homog' };
}
function B2(e, n, t) {
  let r = n.cs,
    s = ur(
      r,
      r.map(() => 0),
    ),
    i = e.pts.map((m) => we(n.F, { ...s, [e.x]: m })),
    o = X2(e, n.F, r),
    a = e.pts.map((m) => we(t, { [e.x]: m }) - i[e.pts.indexOf(m)]),
    l = r.length,
    u = Array.from({ length: l }, (m, p) =>
      Array.from({ length: l }, (g, h) => o[p].reduce((b, v, k) => b + v * o[h][k], 0)),
    ),
    c = Array.from({ length: l }, (m, p) => o[p].reduce((g, h, b) => g + h * a[b], 0)),
    f = eO(u, c);
  return f &&
    e.pts.every((m, p) =>
      dn(
        o.reduce((g, h, b) => g + f[b] * h[p], 0),
        a[p],
      ),
    )
    ? f
    : null;
}
function eO(e, n) {
  if (e.length === 1) {
    let t = e[0][0];
    return Math.abs(t) > 1e-12 ? [n[0] / t] : null;
  }
  if (e.length === 2) {
    let [[t, r], [s, i]] = e,
      o = t * i - r * s;
    return Math.abs(o) < 1e-12 * Math.max(1, Math.abs(t * i), Math.abs(r * s))
      ? null
      : [(n[0] * i - r * n[1]) / o, (t * n[1] - s * n[0]) / o];
  }
  return null;
}
function Kk(e, n) {
  let t = we(
    e,
    ur(
      n,
      n.map(() => 0),
    ),
  );
  if (!Number.isFinite(t)) return null;
  let r = n.map(
    (i, o) =>
      we(
        e,
        ur(
          n,
          n.map((a, l) => (l === o ? 1 : 0)),
        ),
      ) - t,
  );
  return r.some((i) => !Number.isFinite(i))
    ? null
    : om.every((i) =>
          dn(
            we(e, ur(n, i)),
            r.reduce((o, a, l) => o + a * i[l], t),
          ),
        )
      ? { w: r, r: t }
      : null;
}
function Og(e) {
  for (let n = e.families.length - 1; n >= 0; n--)
    if (e.families[n].of === 'full') return e.families[n];
  return null;
}
function Kg(e, n, t) {
  let r = e;
  for (let s = 0; s < t && r; s++) r = Lk(r, n);
  return r;
}
function nO(e, n, t) {
  let r = Kg(n.F, e.x, t.k);
  if (!r) return null;
  let s = j(r, { [e.x]: T(t.x0) }),
    i = Kk(s, n.cs);
  return i ? { w: i.w, r: t.v - i.r } : null;
}
function e6(e, n) {
  let t = e.conds.map((a) => nO(e, n, a));
  if (t.some((a) => !a) || t.length < n.cs.length) return null;
  let r = t,
    s = n.cs.length,
    i = Array.from({ length: s }, (a, l) =>
      Array.from({ length: s }, (u, c) => r.reduce((f, d) => f + d.w[l] * d.w[c], 0)),
    ),
    o = Array.from({ length: s }, (a, l) => r.reduce((u, c) => u + c.w[l] * c.r, 0));
  return eO(i, o);
}
var im = (e) => [...e.w, e.r];
function fS(e, n) {
  let t = 0;
  if (
    (n.forEach((s, i) => {
      Math.abs(s) > Math.abs(n[t]) && (t = i);
    }),
    !(Math.abs(n[t]) > 1e-12))
  )
    return !1;
  let r = e[t] / n[t];
  return Math.abs(r) > 1e-12 ? e.every((s, i) => dn(s, r * n[i], Math.abs(r * n[i]))) : !1;
}
var aS = [-1.3, 0.4, 2.2, 3.1];
function n6(e, n) {
  let t = aS.map((b) => we(e, { [n]: b }));
  if (t.some((b) => !Number.isFinite(b))) return null;
  let [r, s, i] = aS,
    [o, a, l] = t,
    u = (r - s) * (r - i),
    c = (s - r) * (s - i),
    f = (i - r) * (i - s),
    d = o / u + a / c + l / f,
    m = (-o * (s + i)) / u - (a * (r + i)) / c - (l * (r + s)) / f,
    p = (o * s * i) / u + (a * r * i) / c + (l * r * s) / f,
    g = aS[3];
  if (!dn(d * g * g + m * g + p, t[3])) return null;
  let h = (b) => (Math.abs(b) < 1e-10 ? 0 : b);
  return [h(d), h(m), h(p)];
}
function t6(e) {
  let [n, t, r] = e,
    s = t * t - 4 * n * r;
  if (Math.abs(s) < 1e-12 * Math.max(1, t * t)) return [{ re: -t / (2 * n), im: 0 }];
  if (s > 0) {
    let o = Math.sqrt(s);
    return [
      { re: (-t - o) / (2 * n), im: 0 },
      { re: (-t + o) / (2 * n), im: 0 },
    ];
  }
  let i = Math.sqrt(-s);
  return [
    { re: -t / (2 * n), im: -i / (2 * n) },
    { re: -t / (2 * n), im: i / (2 * n) },
  ];
}
function r6(e) {
  if ([...$(e)].some((o) => o !== 'i' && o !== '\u03C0')) return null;
  let t = we(e, { i: 0 }),
    r = we(e, { i: 1 }),
    s = we(e, { i: 2 });
  if (![t, r, s].every(Number.isFinite)) return null;
  let i = r - t;
  return dn(s, t + 2 * i) ? { re: t, im: i } : null;
}
var z2 = (e, n) => dn(e.re, n.re) && dn(e.im, n.im);
function Wn(e, n, t, r, s, i) {
  let o = ga[n];
  return {
    kind: 'step',
    ...e,
    hora: o.hora,
    final: r,
    rule: {
      id: UH[n],
      card: GH,
      label: s ?? o.label,
      hora: o.hora,
      why: (i ?? o.why) + (r ? ' C\u2019est la r\xE9ponse.' : ''),
    },
    omove: { ...t, ...(r ? { final: r } : {}) },
  };
}
function Pk(e, n, t, r) {
  return {
    kind: 'useless',
    ...e,
    jump: !0,
    final: t,
    title: t ? 'Juste !' : 'Juste, mais tu sautes des \xE9tapes',
    message:
      r ??
      (t
        ? 'C\u2019est la r\xE9ponse. D\xE9taille ton raisonnement, une \xE9tape par ligne, pour gagner des HORA. Tu peux garder cette ligne sans HORA.'
        : 'Ta ligne est juste. D\xE9taille-la, une \xE9tape \xE0 la fois, pour gagner des HORA. Tu peux la garder sans HORA.'),
    omove: { ...n, ...(t ? { final: t } : {}) },
  };
}
function st(e, n, t, r) {
  return { kind: 'useless', ...e, title: n, message: t, ...(r ? { omove: r } : {}) };
}
function Vr(e, n, t) {
  let r = Gc(n.atoms),
    s = e.traps.find((i) => i.text === r);
  return s
    ? {
        kind: 'trap',
        ...n,
        title: s.title,
        message: s.why,
        trap: { line: s.line, title: s.title, why: s.why },
      }
    : { kind: 'false', ...n, ...t };
}
function s6(e, n) {
  let t = e.kernel?.domain;
  if (!t) return () => !0;
  let r = [];
  try {
    r = Ae(ne(Te(t)), { chains: !0 }).dis.flatMap((i) =>
      (i.chain ?? (i.cmp ? [i.cmp] : [])).map((a, l) => ({
        l: At(i.sides[l]),
        r: At(i.sides[l + 1]),
        cmp: a,
      })),
    );
  } catch {
    throw new ht(`Intervalle illisible : \xAB ${t} \xBB.`);
  }
  return (s) =>
    r.every(({ l: i, r: o, cmp: a }) => {
      let l = we(i, { [n]: s }),
        u = we(o, { [n]: s });
      return a === '>'
        ? l > u
        : a === '<'
          ? l < u
          : a === '\u2265'
            ? l >= u
            : a === '\u2264'
              ? l <= u
              : !0;
    });
}
function Ng(e) {
  let n;
  try {
    n = Ae(ne(HH(e)), { chains: !0 });
  } catch {
    return { k: 'incomplete' };
  }
  if (n.dis.length > 1)
    return n.dis.some((r) => r.cmp || r.chain || r.rels || r.sides.length !== 2)
      ? {
          k: 'syntax',
          title: 'Des \xE9galit\xE9s',
          message: '\xC9cris \xAB r = \u2026 ou r = \u2026 \xBB.',
        }
      : { k: 'or', clauses: n.dis.map((r) => r.sides) };
  let t = n.dis[0];
  return t.cmp || t.chain || t.rels || t.mod !== void 0
    ? {
        k: 'syntax',
        title: 'Une \xE9galit\xE9',
        message:
          '\xC9cris une \xE9galit\xE9 : \xAB y = \u2026 \xBB, \xAB y\u2032 = \u2026 \xBB, \xAB y(0) = \u2026 \xBB.',
      }
    : t.sides.length < 2
      ? { k: 'incomplete' }
      : { k: 'eq', sides: t.sides };
}
function i6(e, n, t) {
  let r = Wl(e, n, t),
    s = Ng(r),
    i = () =>
      new ht(
        `Une condition s\u2019\xE9crit \xAB ${n}(0) = 1 \xBB ou \xAB ${n}\u2032(0) = 0 \xBB : \xAB ${e} \xBB.`,
      );
  if (s.k !== 'eq' || s.sides.length !== 2) throw i();
  let o = s.sides[0],
    a = o.k === 's' ? Ik(n).exec(o.n) : null;
  if (!a) throw i();
  let l = a[1] === '\u2033' ? 2 : a[1].length,
    u = we(dS(a[2]), {}),
    c = we(At(s.sides[1]), {});
  if (!Number.isFinite(u) || !Number.isFinite(c)) throw i();
  return { k: l, x0: u, head: o.n, v: c, text: Gc(r) };
}
var Ik = (e) =>
  new RegExp(`^${e.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}(\u2032*|\u2033)\\((.+)\\)$`);
function dS(e) {
  let n = Ae(ne(Te(e)));
  return At(n.dis[0].sides[0]);
}
function o6(e) {
  let n = e.kernel,
    t = n.goal.target;
  if (!/^[a-zA-Z]$/.test(t)) throw new ht('La fonction inconnue est une lettre (\xAB y \xBB).');
  let r = n.ode?.variable ?? 'x';
  if (!/^[a-z]$/.test(r) || r === t || ['e', 'i', 'r'].includes(r))
    throw new ht('La variable est une lettre (\xAB x \xBB, \xAB t \xBB) autre que la fonction.');
  return { fn: t, x: r, consts: n.ode?.constants ?? ['C', 'A', 'B', 'C\u2081', 'C\u2082', 'K'] };
}
function tO(e) {
  let n = e.kernel,
    t = o6(e),
    { fn: r, x: s } = t,
    i = [r, `${r}\u2032`, `${r}\u2033`],
    o = s6(e, s),
    a = {
      model: e,
      fn: r,
      x: s,
      Y: i,
      consts: t.consts,
      ode: { order: 1, a: [T(0), T(0), T(0)], f: T(0) },
      homog: !1,
      constCoef: !1,
      pts: [],
      conds: [],
      goal: 'general',
      answerShape: null,
      answerText: '',
      target: null,
      values: new Map(),
      eqs: [],
      homogWritten: !1,
      families: [],
      ones: [],
      derivs: [],
      evals: new Map(),
      cEqs: [],
      cFamily: null,
      cKnown: !1,
      charQ: null,
      deltas: new Set(),
      rootsWritten: !1,
      written: new Set(),
      givenTexts: new Set(),
      path: n.path ?? [],
      traps: [],
      lines: 0,
      concluded: !1,
    },
    l = Wl(n.start, r, s),
    u = Ng(l);
  if (u.k !== 'eq' || u.sides.length !== 2)
    throw new ht(`Le d\xE9part est une \xE9quation : \xAB ${n.start} \xBB.`);
  let c = R(he(At(u.sides[0]), I(T(-1), At(u.sides[1])))),
    f = [...W2, ...XH].filter(o),
    d = J2(a, c, f);
  if (!d)
    throw new ht(
      `Le d\xE9part n\u2019est pas une \xE9quation diff\xE9rentielle lin\xE9aire en ${r}, ${r}\u2032, ${r}\u2033 : \xAB ${n.start} \xBB.`,
    );
  if (
    ((a.pts = [...new Set(f)]
      .filter((k) => {
        let y = Lg(d, s, k);
        return y.every(Number.isFinite) && Math.abs(y[d.order]) > 1e-9;
      })
      .sort((k, y) => k - y)
      .slice(0, 11)),
    a.pts.length < 6)
  )
    throw new ht('Pas assez de points pour v\xE9rifier l\u2019\xE9quation.');
  if (
    ((a.ode = d),
    (a.homog = a.pts.every((k) => Math.abs(we(d.f, { [s]: k })) < 1e-12)),
    (a.constCoef = [...d.a, d.f].every((k) => !$(k).has(s))),
    _k(u.sides) !== 'autre' && a.eqs.push({ of: 'full', shape: _k(u.sides) }),
    (a.conds = (n.ode?.initial ?? []).map((k) => i6(k, r, s))),
    a.conds.some((k) => k.k >= d.order))
  )
    throw new ht(`Une condition porte sur ${r} ou ses d\xE9riv\xE9es d\u2019ordre < ${d.order}.`);
  let m = Wl(n.answer, r, s);
  a.answerText = Gc(m);
  let p = Ng(m);
  if (p.k !== 'eq' || p.sides.length !== 2)
    throw new ht(`La r\xE9ponse est une \xE9galit\xE9 : \xAB ${n.answer} \xBB.`);
  let g = p.sides[0],
    h = At(p.sides[1]),
    b = [...$(h)].some((k) => a.Y.includes(k)),
    v = g.k === 's' ? Ik(r).exec(g.n) : null;
  if (v && v[1] === '' && [...$(h)].every((k) => k === '\u03C0')) {
    let k = we(dS(v[2]), {}),
      y = we(h, {});
    if (!Number.isFinite(k) || !Number.isFinite(y))
      throw new ht(`La r\xE9ponse est une valeur : \xAB ${r}(0) = \u2026 \xBB.`);
    if (a.conds.length < d.order)
      throw new ht(`Il faut ${d.order} conditions pour trouver la valeur.`);
    if (a.conds.some((w) => w.k === 0 && dn(w.x0, k)))
      throw new ht('La valeur cherch\xE9e est d\xE9j\xE0 une condition de l\u2019\xE9nonc\xE9.');
    let S = l6(a, k);
    if (S === null)
      throw new ht(
        'Les conditions ne fixent pas la solution (\xE0 l\u2019ordre 2 : y et y\u2032 au m\xEAme point).',
      );
    if (!dn(y, S, Math.abs(S)))
      throw new ht(`La r\xE9ponse n\u2019est pas la valeur de la solution (${S}).`);
    ((a.goal = 'value'), (a.target = { x0: k, head: g.n, arg: v[2], v: S, size: yo(h) }));
  } else if (g.k === 's' && g.n === r && !b) {
    let k = ha(a, h);
    if (
      ((a.goal = k.length ? 'general' : a.conds.length ? 'unique' : 'particular'),
      a.goal === 'unique' && a.conds.length < d.order)
    )
      throw new ht(`Il faut ${d.order} conditions pour une seule solution.`);
    let y = Y2(a, h);
    if (a.goal === 'general' && !(y.k === 'general' && y.of === 'full'))
      throw new ht('La r\xE9ponse n\u2019est pas l\u2019ensemble des solutions.');
    if (a.goal !== 'general' && !(y.k === 'one' && y.of === 'full'))
      throw new ht('La r\xE9ponse n\u2019est pas une solution de l\u2019\xE9quation.');
    if (a.goal === 'unique' && !Ak(a, h))
      throw new ht('La r\xE9ponse ne v\xE9rifie pas les conditions.');
  } else {
    let k = rO(a, p.sides);
    if (!k || !uS(k, a.ode, s, a.pts))
      throw new ht('La r\xE9ponse n\u2019est pas l\u2019\xE9quation r\xE9\xE9crite.');
    ((a.goal = 'rewrite'), (a.answerShape = _k(p.sides)));
  }
  return (
    (a.givenTexts = new Set(a6(e).map((k) => Gc(Wl(k, r, s))))),
    (a.traps = (e.traps ?? []).map((k) => ({
      text: Gc(Wl(k.line, r, s)),
      line: ZH(k.line, r),
      title: k.title ?? 'Attention',
      why: k.why,
    }))),
    a
  );
}
function a6(e) {
  let n = e.kernel;
  return [n.start, ...(n.ode?.initial ?? []), ...(n.domain ? [n.domain] : [])];
}
function _k(e) {
  let n = e[0];
  return n.k === 's' ? `h:${n.n}` : 'autre';
}
function rO(e, n) {
  if (n.length !== 2) return null;
  let t;
  try {
    t = R(he(At(n[0]), I(T(-1), At(n[1]))));
  } catch {
    return null;
  }
  return J2(e, t, e.pts.length ? e.pts : W2);
}
function l6(e, n) {
  let t = e.ode,
    r = e.conds.find((f) => f.k === 0);
  if (!r) return null;
  let s = t.order === 2 ? e.conds.find((f) => f.k === 1 && dn(f.x0, r.x0)) : null;
  if (t.order === 2 && !s) return null;
  if (dn(n, r.x0)) return r.v;
  let i = e.constCoef ? Lg(t, e.x, r.x0) : null,
    o = e.constCoef ? 2e3 : 600,
    a = (n - r.x0) / o,
    l = (f, d) => {
      let [m, p, g, h] = i ?? Lg(t, e.x, f);
      return t.order === 1 ? [(h - m * d[0]) / p] : [d[1], (h - p * d[1] - m * d[0]) / g];
    },
    u = t.order === 1 ? [r.v] : [r.v, s.v],
    c = r.x0;
  for (let f = 0; f < o; f++) {
    let d = l(c, u),
      m = l(
        c + a / 2,
        u.map((h, b) => h + (a / 2) * d[b]),
      ),
      p = l(
        c + a / 2,
        u.map((h, b) => h + (a / 2) * m[b]),
      ),
      g = l(
        c + a,
        u.map((h, b) => h + a * p[b]),
      );
    ((u = u.map((h, b) => h + (a / 6) * (d[b] + 2 * m[b] + 2 * p[b] + g[b]))), (c += a));
  }
  return u.every(Number.isFinite) ? u[0] : null;
}
function Ak(e, n) {
  return e.conds.every((t) => {
    let r = Kg(n, e.x, t.k);
    return !!r && dn(we(r, { [e.x]: t.x0 }), t.v);
  });
}
function u6(e, n) {
  return e.path.some((t) => {
    let r;
    try {
      r = Wl(t, e.fn, e.x);
    } catch {
      return !1;
    }
    return r.length > n.length && n.every((s, i) => r[i] === s);
  });
}
function sO(e, n, t) {
  let r = n.flatMap((c) => c.atoms),
    s = ne(r);
  if (!s.length) return { kind: 'empty', atoms: s, badChip: -1 };
  let i = u6(e, s),
    o = () =>
      t?.verify
        ? { kind: 'syntax', atoms: s, title: 'Ligne inachev\xE9e', message: 'Termine ta ligne.' }
        : { kind: i ? 'building' : 'open', atoms: s, complete: !1 },
    a = Ng(s);
  if (a.k === 'incomplete') return o();
  if (a.k === 'syntax')
    return i && !t?.verify
      ? { kind: 'building', atoms: s, complete: !1 }
      : { kind: 'syntax', atoms: s, line: qk(s), title: a.title, message: a.message };
  let l = { atoms: s, line: qk(s) },
    u;
  try {
    u = iO(e, l, a);
  } catch {
    u = {
      kind: 'syntax',
      ...l,
      title: '\xC7a ne se lit pas',
      message: 'Cette ligne ne se lit pas : v\xE9rifie l\u2019\xE9criture.',
    };
  }
  return i && !t?.verify
    ? u.kind === 'step'
      ? { ...u, kind: 'ready', complete: !0 }
      : { kind: 'building', atoms: s, complete: !0 }
    : !t?.verify && (u.kind === 'unjustified' || u.kind === 'false')
      ? { kind: 'pending', atoms: s, complete: !0 }
      : { ...u, complete: !0 };
}
function iO(e, n, t) {
  let r = Gc(n.atoms);
  if (e.givenTexts.has(r))
    return st(
      n,
      'C\u2019est l\u2019\xE9nonc\xE9',
      'Cette ligne est dans l\u2019\xE9nonc\xE9 : \xE9cris l\u2019\xE9tape suivante.',
    );
  if (e.written.has(r))
    return st(
      n,
      'D\xE9j\xE0 \xE9crit',
      'Tu as d\xE9j\xE0 \xE9crit cette ligne : \xE9cris l\u2019\xE9tape suivante.',
    );
  if (t.k === 'or') return Z2(e, n, t.clauses, r);
  let s = t.sides,
    i = s[0],
    o = s.slice(1).map(At),
    a = new Set(o.flatMap((d) => [...$(d)])),
    l = e.Y.some((d) => a.has(d)),
    u = i.k === 's' ? i.n : null;
  if (u === e.fn && !l) return f6(e, n, o, r);
  if ((u === e.Y[1] || u === e.Y[2]) && !l && o.some((d) => ha(e, d).length > 0))
    return g6(e, n, u === e.Y[1] ? 1 : 2, o, r);
  if (u && Ik(e.fn).test(u)) return h6(e, n, u, o, r);
  if (u === '\u0394') return k6(e, n, o, r);
  let c = new Set([...(i.k === 's' ? [u] : [...$(At(i))]), ...a]);
  if (e.Y.some((d) => c.has(d)))
    return s.length !== 2
      ? {
          kind: 'syntax',
          ...n,
          title: 'Une \xE9quation',
          message: '\xC9cris l\u2019\xE9quation sur une ligne : \xAB y\u2032 = \u2026 \xBB.',
        }
      : c6(e, n, s, r);
  let f = [...c].filter((d) => d !== '\u03C0');
  return f.length && f.every((d) => d === 'r')
    ? u === 'r' && s.length === 2 && !$(o[0]).has('r')
      ? Z2(e, n, [s], r)
      : v6(e, n, s, r)
    : f.length && f.every((d) => e.consts.includes(d))
      ? b6(e, n, s, r)
      : {
          kind: 'syntax',
          ...n,
          title: '\xC7a ne se lit pas',
          message: `\xC9cris \xAB ${e.fn} = \u2026 \xBB, \xAB ${e.fn}\u2032 = \u2026 \xBB, \xAB ${e.fn}(0) = \u2026 \xBB ou une \xE9quation en la constante.`,
        };
}
function c6(e, n, t, r) {
  let s = rO(e, t);
  if (!s)
    return {
      kind: 'false',
      ...n,
      title: 'Pas une \xE9quation lin\xE9aire',
      message: `L\u2019\xE9quation s\u2019\xE9crit avec ${e.fn}, ${e.fn}\u2032${e.ode.order === 2 ? `, ${e.fn}\u2033` : ''}, des nombres et ${e.x}.`,
    };
  let i = _k(t),
    a =
      t[0].k === 's' && (t[0].n === e.Y[1] || t[0].n === e.Y[2])
        ? `Isoler ${t[0].n}`
        : ga.rewrite.label;
  if (uS(s, e.ode, e.x, e.pts)) {
    if (e.eqs.some((u) => u.of === 'full' && u.shape === i))
      return st(
        n,
        'Rien de nouveau',
        'C\u2019est la m\xEAme \xE9quation, \xE9crite autrement : passe \xE0 l\u2019\xE9tape suivante.',
      );
    let l = e.goal === 'rewrite' && i === e.answerShape;
    return Wn(n, 'rewrite', { text: r, kind: 'eq', of: 'full', shape: i }, l, a);
  }
  return !e.homog && uS(s, Nk(e.ode), e.x, e.pts)
    ? e.homogWritten
      ? e.eqs.some((l) => l.of === 'homog' && l.shape === i)
        ? st(n, 'Rien de nouveau', 'Tu as d\xE9j\xE0 \xE9crit l\u2019\xE9quation homog\xE8ne.')
        : Wn(n, 'rewrite', { text: r, kind: 'eq', of: 'homog', shape: i }, !1, a)
      : Wn(n, 'homogeneous', { text: r, kind: 'eq', of: 'homog', shape: i }, !1)
    : Vr(e, n, {
        title: 'Pas la m\xEAme \xE9quation',
        message:
          'Ce n\u2019est pas une r\xE9\xE9criture de l\u2019\xE9quation : un terme qui change de c\xF4t\xE9 change de signe, et on divise tous les termes par le m\xEAme nombre.',
      });
}
function U2(e, n) {
  let t = n === 'homog' ? Nk(e.ode) : e.ode,
    r = e.fn;
  if (t.order === 1) {
    if (e.pts.every((o) => Math.abs(we(t.a[0], { [e.x]: o })) < 1e-12))
      return {
        label: 'Primitives',
        why: `Les solutions de ${r}\u2032 = f(${e.x}) sont les primitives de f : F(${e.x}) + C.`,
      };
    let i = n === 'homog' || e.homog;
    return e.constCoef
      ? i
        ? {
            label: `Solutions de ${r}\u2032 = a${r}`,
            why: `Les solutions de ${r}\u2032 = a${r} sont les fonctions ${e.x} \u21A6 Ce^(a${e.x}), C r\xE9el.`,
          }
        : {
            label: `Solutions de ${r}\u2032 = a${r} + b`,
            why: `Les solutions de ${r}\u2032 = a${r} + b (a \u2260 0) sont les fonctions ${e.x} \u21A6 Ce^(a${e.x}) \u2212 b \xF7 a, C r\xE9el.`,
          }
      : i
        ? {
            label: `Solutions de ${r}\u2032 + a(${e.x})${r} = 0`,
            why: `Les solutions de ${r}\u2032 + a(${e.x})${r} = 0 sont les fonctions ${e.x} \u21A6 Ce^(\u2212A(${e.x})), A une primitive de a.`,
          }
        : { label: ga.general.label, why: ga.general.why };
  }
  if (e.constCoef) {
    let [s, i, o] = t.a.map((u) => we(u, {})),
      a = i * i - 4 * o * s,
      l = n === 'homog' && !e.homog ? 'Solutions de l\u2019\xE9quation homog\xE8ne' : 'Solutions';
    return Math.abs(a) < 1e-12 * Math.max(1, i * i)
      ? {
          label: `${l} : racine double`,
          why: `Une racine double r : ${r} = (C\u2081${e.x} + C\u2082)e^(r${e.x}).`,
        }
      : a > 0
        ? {
            label: `${l} : deux racines r\xE9elles`,
            why: `Deux racines r\xE9elles r\u2081 et r\u2082 : ${r} = C\u2081e^(r\u2081${e.x}) + C\u2082e^(r\u2082${e.x}).`,
          }
        : {
            label: `${l} : racines complexes`,
            why: `Deux racines complexes \u03B1 \xB1 i\u03B2 : ${r} = e^(\u03B1${e.x})(C\u2081cos(\u03B2${e.x}) + C\u2082sin(\u03B2${e.x})).`,
          };
  }
  return { label: ga.general.label, why: ga.general.why };
}
function f6(e, n, t, r) {
  let s = t[t.length - 1],
    i = Ok(e, s);
  if (i.length)
    return {
      kind: 'syntax',
      ...n,
      title: 'Une lettre de trop',
      message: `\xAB ${i[0]} \xBB n\u2019est ni ${e.x} ni une constante de la feuille.`,
    };
  if (t.length > 1) {
    let l = t[0],
      u = [...new Set(t.flatMap((f) => ha(e, f)))];
    if (
      !t.every((f) =>
        om.every((d) =>
          e.pts.every((m) =>
            dn(we(f, { ...ur(u, d), [e.x]: m }), we(l, { ...ur(u, d), [e.x]: m })),
          ),
        ),
      )
    )
      return Vr(e, n, {
        title: 'Pas la m\xEAme fonction',
        message: 'Les membres de ta ligne ne sont pas \xE9gaux : v\xE9rifie ton calcul.',
      });
  }
  let o = Y2(e, s),
    a = yo(s);
  if (o.k === 'general') {
    let l = e.families.filter((d) => d.of === o.of);
    if (l.length)
      return a < Math.min(...l.map((d) => d.size))
        ? Wn(
            n,
            'compute',
            { text: r, kind: 'family', of: o.of, F: s, size: a },
            o.of === 'full' && e.goal === 'general',
          )
        : st(
            n,
            'Rien de nouveau',
            'Ce sont les m\xEAmes solutions, \xE9crites autrement : passe \xE0 l\u2019\xE9tape suivante.',
            { text: r, kind: 'family', of: o.of, F: s, size: a },
          );
    let u = o.of === 'full' && e.goal === 'general';
    if (o.of === 'homog') {
      let d = U2(e, 'homog');
      return Wn(
        n,
        'homogSolutions',
        { text: r, kind: 'family', of: 'homog', F: s, size: a },
        !1,
        e.ode.order === 2 && e.constCoef ? d.label : ga.homogSolutions.label,
        d.why,
      );
    }
    if (e.families.some((d) => d.of === 'homog') && e.ones.length)
      return Wn(n, 'superpose', { text: r, kind: 'family', of: 'full', F: s, size: a }, u);
    let f = U2(e, 'full');
    return Wn(
      n,
      'general',
      { text: r, kind: 'family', of: 'full', F: s, size: a },
      u,
      f.label,
      f.why,
    );
  }
  if (o.k === 'partial')
    return Vr(e, n, {
      title: 'Il manque des solutions',
      message:
        e.ode.order === 2
          ? 'Une \xE9quation d\u2019ordre 2 a deux solutions ind\xE9pendantes : il faut deux constantes.'
          : 'Toutes les solutions : il faut une constante C.',
    });
  if (o.k === 'one') {
    if (o.of === 'homog')
      return Vr(e, n, {
        title: 'Solution de l\u2019\xE9quation homog\xE8ne',
        message:
          'Cette fonction v\xE9rifie l\u2019\xE9quation homog\xE8ne, pas l\u2019\xE9quation compl\xE8te : il manque le second membre.',
      });
    let l = { text: r, kind: 'one', F: s, size: a };
    if (e.ones.some((m) => dn(G2(e, m.F, s), 0))) {
      let m = e.ones.filter((g) => dn(G2(e, g.F, s), 0)),
        p = m6(e, s);
      return a < Math.min(...m.map((g) => g.size))
        ? Wn(n, 'compute', l, p)
        : st(n, 'Rien de nouveau', 'C\u2019est la m\xEAme fonction, \xE9crite autrement.', l);
    }
    let u = e.pts.every((m) => dn(we(s, { [e.x]: m }), we(s, { [e.x]: e.pts[0] }))),
      c = Og(e),
      f = !e.homog && !e.ones.length,
      d = () => Wn(n, u ? 'constant' : 'particular', l, !1);
    if (e.goal === 'unique' || e.goal === 'value') {
      let m = e.goal === 'unique';
      if (Ak(e, s))
        return c && e.cKnown && e.cFamily && B2(e, c, s)
          ? Wn(n, 'member', l, m, d6(c))
          : Pk(
              n,
              l,
              m,
              c
                ? `C\u2019est la solution. Montre comment tu trouves ${c.cs.join(' et ')} : \xE9cris ce que donne ${e.conds.map((g) => g.text).join(' et ')}. Tu peux garder cette ligne sans HORA.`
                : void 0,
            );
      if (f) return d();
      let p = e.conds.find((g) => {
        let h = Kg(s, e.x, g.k);
        return !h || !dn(we(h, { [e.x]: g.x0 }), g.v);
      });
      return st(
        n,
        'Juste, mais \xE0 c\xF4t\xE9',
        `Cette fonction est bien une solution, mais elle ne v\xE9rifie pas ${p?.text ?? 'les conditions'}.`,
      );
    }
    return e.goal === 'particular'
      ? c && B2(e, c, s)
        ? Wn(n, 'member', l, !0, 'Un cas particulier')
        : u
          ? Wn(n, 'constant', l, !0)
          : Pk(n, l, !0)
      : e.goal === 'general' && f
        ? d()
        : st(
            n,
            'Juste, mais \xE0 c\xF4t\xE9',
            e.goal === 'general'
              ? 'C\u2019est une solution, mais la question demande toutes les solutions (avec une constante).'
              : 'C\u2019est une solution, mais la question demande de r\xE9\xE9crire l\u2019\xE9quation.',
            l,
          );
  }
  return o.why === 'notAffine'
    ? Vr(e, n, {
        title: 'Pas toutes les solutions',
        message:
          'Les solutions s\u2019\xE9crivent avec la constante en facteur : C \xD7 (une fonction) + (une solution).',
      })
    : o.why === 'particular'
      ? Vr(e, n, {
          title: 'La solution particuli\xE8re',
          message:
            'La partie avec la constante est juste, mais la fonction qu\u2019on ajoute n\u2019est pas une solution de l\u2019\xE9quation compl\xE8te.',
        })
      : Vr(e, n, {
          title: ha(e, s).length ? 'Ce ne sont pas des solutions' : 'Pas une solution',
          message: `V\xE9rifie : avec ${e.fn} = \u2026, calcule ${e.fn}\u2032${e.ode.order === 2 ? ` et ${e.fn}\u2033` : ''}, puis remplace dans l\u2019\xE9quation : on ne retrouve pas l\u2019\xE9galit\xE9.`,
        });
}
function d6(e) {
  return e.cs.length > 1 ? `Remplacer ${e.cs.join(' et ')}` : `Remplacer ${e.cs[0]}`;
}
function m6(e, n) {
  return e.goal === 'unique' ? Ak(e, n) : e.goal === 'particular';
}
function Hl(e) {
  let n = (s) => s.k === 'num',
    t = (s) => s.k === 'num' && s.v.n === 0n,
    r = (s) => s.k === 'num' && s.v.n === s.v.d;
  switch (e.k) {
    case 'num':
    case 'sym':
      return !1;
    case 'add':
      return e.c.some(t) || e.c.filter(n).length > 1 || e.c.some(Hl);
    case 'mul':
      return e.c.some(t) || e.c.some(r) || e.c.filter(n).length > 1 || e.c.some(Hl);
    case 'div':
      return r(e.b) || t(e.a) || (n(e.a) && n(e.b)) || Hl(e.a) || Hl(e.b);
    case 'pow':
      return t(e.b) || r(e.b) || (n(e.a) && n(e.b)) || Hl(e.a) || Hl(e.b);
    case 'fn':
      return (e.f === 'exp' && t(e.a)) || (e.f === 'ln' && r(e.a)) || Hl(e.a);
    default:
      return !1;
  }
}
function p6(e, n, t, r, s) {
  let i = e.target,
    o = [...new Set(r.flatMap((m) => [...$(m)]))].filter((m) => m !== '\u03C0');
  if (o.length)
    return {
      kind: 'syntax',
      ...n,
      title: o.includes(e.x) ? 'Une valeur' : 'Une lettre de trop',
      message: o.includes(e.x)
        ? `${t} est un nombre : remplace ${e.x} par ${i.arg}.`
        : `\xAB ${o[0]} \xBB n\u2019a pas sa place dans une valeur.`,
    };
  if (!r.every((m) => dn(we(m, {}), i.v, Math.abs(i.v))))
    return Vr(e, n, {
      title: 'Pas la bonne valeur',
      message: `Remplace ${e.x} par ${i.arg} dans la solution qui v\xE9rifie ${e.conds.map((m) => m.text).join(' et ')}, puis calcule.`,
    });
  let a = r[r.length - 1],
    l = yo(a),
    u = l <= i.size + 2 && !Hl(a),
    c = { text: s, kind: 'value', head: t, size: l },
    f = e.values.get(t);
  return f !== void 0
    ? l < f || (u && !e.concluded)
      ? Wn(n, 'compute', c, u)
      : st(n, 'Rien de nouveau', `Tu as d\xE9j\xE0 calcul\xE9 ${t}.`)
    : (e.cKnown && !!Og(e)) || e.ones.some((m) => Ak(e, m.F))
      ? Wn(
          n,
          'value',
          c,
          u,
          `Calculer ${t}`,
          `On remplace ${e.x} par ${i.arg} dans la solution trouv\xE9e.`,
        )
      : Pk(
          n,
          c,
          u,
          `${u ? 'C\u2019est la r\xE9ponse.' : 'Ta ligne est juste.'} Montre comment : trouve d\u2019abord la solution qui v\xE9rifie ${e.conds.map((m) => m.text).join(' et ')}, puis remplace ${e.x} par ${i.arg}. Tu peux la garder sans HORA.`,
        );
}
function G2(e, n, t) {
  return Math.max(...e.pts.map((r) => Math.abs(we(n, { [e.x]: r }) - we(t, { [e.x]: r }))));
}
function g6(e, n, t, r, s) {
  let i = r[r.length - 1];
  if (Ok(e, i).length)
    return {
      kind: 'syntax',
      ...n,
      title: 'Une lettre de trop',
      message: `\xAB ${Ok(e, i)[0]} \xBB n\u2019est ni ${e.x} ni une constante de la feuille.`,
    };
  let o = e.families;
  if (!o.length)
    return {
      kind: 'unjustified',
      ...n,
      title: 'D\u2019abord les solutions',
      message: `\xC9cris d\u2019abord les solutions : \xAB ${e.fn} = \u2026 \xBB.`,
    };
  let a = (l, u, c) =>
    om.every((f) =>
      e.pts.every((d) => dn(we(l, { ...ur(c, f), [e.x]: d }), we(u, { ...ur(c, f), [e.x]: d }))),
    );
  for (let l = o.length - 1; l >= 0; l--) {
    let u = o[l],
      c = Kg(u.F, e.x, t);
    if (c && r.every((f) => a(f, c, u.cs))) {
      let f = yo(i),
        d = e.derivs.filter((p) => p.order === t && a(p.F, c, u.cs)),
        m = { text: s, kind: 'deriv', F: i, size: f, order: t };
      return d.length
        ? f < Math.min(...d.map((p) => p.size))
          ? Wn(n, 'compute', m, !1)
          : st(n, 'Rien de nouveau', 'Tu as d\xE9j\xE0 \xE9crit cette d\xE9riv\xE9e.')
        : Wn(n, 'derive', m, !1, t === 2 ? 'D\xE9river deux fois' : 'D\xE9river');
    }
  }
  return Vr(e, n, {
    title: 'Pas la d\xE9riv\xE9e',
    message: `D\xE9rive chaque terme des solutions ; ${o[o.length - 1].cs.join(', ')} reste${o[o.length - 1].cs.length > 1 ? 'nt' : ''} une constante.`,
  });
}
function h6(e, n, t, r, s) {
  let i = Ik(e.fn).exec(t),
    o = i[1] === '\u2033' ? 2 : i[1].length,
    a;
  try {
    a = we(dS(i[2]), {});
  } catch {
    a = NaN;
  }
  if (!Number.isFinite(a))
    return {
      kind: 'syntax',
      ...n,
      title: 'Un nombre',
      message: `\xC9cris la valeur de ${e.x} : \xAB ${e.fn}(0) \xBB.`,
    };
  let l = e.conds.find((k) => k.k === o && dn(k.x0, a)),
    u = r.every((k) => !ha(e, k).length),
    c = e.goal === 'value' && e.target && o === 0 && dn(a, e.target.x0) ? e.target : null;
  if (c && u) return p6(e, n, t, r, s);
  if (u && l && r.every((k) => dn(we(k, {}), l.v)))
    return st(
      n,
      'C\u2019est l\u2019\xE9nonc\xE9',
      `${l.text} : c\u2019est une donn\xE9e de l\u2019\xE9nonc\xE9.`,
    );
  let f = Og(e);
  if (!f)
    return {
      kind: 'unjustified',
      ...n,
      title: 'D\u2019abord les solutions',
      message: `\xC9cris d\u2019abord toutes les solutions : \xAB ${e.fn} = \u2026 \xBB, avec la constante.`,
    };
  let d = Kg(f.F, e.x, o),
    m = d ? j(d, { [e.x]: T(a) }) : null,
    p = m ? Kk(m, f.cs) : null;
  if (
    !(
      !!p &&
      r.every((k) => {
        if (Ok(e, k).length) return !1;
        let y = Kk(k, f.cs);
        return !!y && dn(y.r, p.r) && y.w.every((S, w) => dn(S, p.w[w]));
      })
    )
  )
    return Vr(e, n, {
      title: 'Pas la bonne valeur',
      message: `Remplace ${e.x} par ${i[2]} dans ${o ? 'la d\xE9riv\xE9e des solutions' : 'les solutions'}, puis calcule.`,
    });
  let h = yo(r[r.length - 1]),
    b = { text: s, kind: 'eval', head: t, size: h },
    v = e.evals.get(t);
  return v !== void 0
    ? h < v
      ? Wn(n, 'compute', b, !1)
      : st(n, 'Rien de nouveau', `Tu as d\xE9j\xE0 calcul\xE9 ${t}.`)
    : !l && !c
      ? st(
          n,
          'Juste, mais \xE0 c\xF4t\xE9',
          `${t} n\u2019est pas dans les conditions de l\u2019\xE9nonc\xE9 : calcule ${e.conds.map((k) => k.head).join(' et ') || 'autre chose'}.`,
        )
      : Wn(
          n,
          'evaluate',
          b,
          !1,
          `Calculer ${t}`,
          `On remplace ${e.x} par ${i[2]} dans ${o ? 'la d\xE9riv\xE9e des solutions' : 'les solutions'}.`,
        );
}
function b6(e, n, t, r) {
  let s = Og(e);
  if (!s)
    return {
      kind: 'unjustified',
      ...n,
      title: 'D\u2019abord les solutions',
      message: `\xC9cris d\u2019abord toutes les solutions : \xAB ${e.fn} = \u2026 \xBB, avec la constante.`,
    };
  if (t.length !== 2)
    return {
      kind: 'syntax',
      ...n,
      title: 'Une \xE9galit\xE9',
      message: 'Une seule \xE9galit\xE9 par ligne.',
    };
  let i = R(he(At(t[0]), I(T(-1), At(t[1]))));
  if ([...$(i)].filter((S) => S !== '\u03C0' && !s.cs.includes(S)).length)
    return {
      kind: 'syntax',
      ...n,
      title: 'Une lettre de trop',
      message: `Les constantes des solutions sont ${s.cs.join(' et ')}.`,
    };
  let a = Kk(i, s.cs);
  if (!a)
    return {
      kind: 'false',
      ...n,
      title: 'Une \xE9quation du premier degr\xE9',
      message: `La condition donne une \xE9quation du premier degr\xE9 en ${s.cs.join(' et ')}.`,
    };
  let l = { w: a.w, r: -a.r };
  if (l.w.every((S) => Math.abs(S) < 1e-12))
    return st(n, 'Rien de nouveau', `Ta ligne ne dit rien sur ${s.cs.join(' ni ')}.`);
  let u = e6(e, s);
  if (!u)
    return st(
      n,
      'Rien ne fixe la constante',
      `L\u2019\xE9nonc\xE9 ne donne pas de condition pour trouver ${s.cs.join(' et ')}.`,
    );
  let c = l.w.reduce((S, w, _) => S + w * u[_], 0);
  if (!dn(c, l.r))
    return Vr(e, n, {
      title: 'Pas la bonne \xE9quation',
      message: `\xC9cris ce que donne${e.conds.length > 1 ? 'nt' : ''} ${e.conds.map((S) => S.text).join(' et ')} avec les solutions.`,
    });
  let d = e.cFamily && e.cFamily.join() === s.cs.join() ? e.cEqs : [],
    m = (S, w) => S.k === 's' && w(S.n),
    p =
      (m(t[0], (S) => s.cs.includes(S)) && !ha(e, At(t[1])).length) ||
      (m(t[1], (S) => s.cs.includes(S)) && !ha(e, At(t[0])).length),
    h =
      l.w.filter((S) => Math.abs(S) > 1e-12).length === 1
        ? s.cs[l.w.findIndex((S) => Math.abs(S) > 1e-12)]
        : null,
    b = { text: r, kind: 'ceq', w: l.w, r: l.r, solved: p },
    v = d.filter((S) => fS(im(l), im(S)));
  if (v.length)
    return p && !v.some((S) => S.solved)
      ? Wn(
          n,
          'solveC',
          b,
          !1,
          h ? `Trouver ${h}` : ga.solveC.label,
          h ? `On r\xE9sout l\u2019\xE9quation en ${h}.` : ga.solveC.why,
        )
      : st(n, 'Rien de nouveau', 'C\u2019est la m\xEAme \xE9quation, \xE9crite autrement.');
  let k = e.conds.find((S) => {
    let w = nO(e, s, S);
    return !!w && fS(im(l), im(w));
  });
  if (k)
    return Wn(
      n,
      'condition',
      b,
      !1,
      `Utiliser ${k.text}`,
      `La condition ${k.text} donne une \xE9quation en ${s.cs.join(' et ')}.`,
    );
  let y = d.map(im);
  return y.length && cS([...y, im(l)]) === cS(y)
    ? Wn(
        n,
        'solveC',
        b,
        !1,
        h ? `Trouver ${h}` : 'Combiner les \xE9quations',
        h
          ? `On r\xE9sout l\u2019\xE9quation en ${h}.`
          : 'On combine les \xE9quations en les constantes.',
      )
    : Pk(
        n,
        b,
        !1,
        `Ta ligne est juste. \xC9cris d\u2019abord ce que donne ${e.conds.map((S) => S.text).join(' et ')}, une \xE9tape par ligne, pour gagner des HORA. Tu peux la garder sans HORA.`,
      );
}
function mS(e) {
  if (e.ode.order !== 2 || !e.constCoef) return null;
  let [n, t, r] = e.ode.a.map((s) => we(s, {}));
  return [r, t, n];
}
function v6(e, n, t, r) {
  let s = mS(e);
  if (!s)
    return st(
      n,
      'Pas d\u2019\xE9quation caract\xE9ristique ici',
      'L\u2019\xE9quation caract\xE9ristique sert aux \xE9quations d\u2019ordre 2 \xE0 coefficients constants.',
    );
  if (t.length !== 2)
    return {
      kind: 'syntax',
      ...n,
      title: 'Une \xE9quation',
      message: '\xC9cris \xAB r\xB2 + \u2026 = 0 \xBB.',
    };
  let i = R(he(At(t[0]), I(T(-1), At(t[1])))),
    o = n6(i, 'r');
  return o && fS(o, s)
    ? e.charQ
      ? st(n, 'Rien de nouveau', 'Tu as d\xE9j\xE0 \xE9crit l\u2019\xE9quation caract\xE9ristique.')
      : Wn(n, 'characteristic', { text: r, kind: 'char', q: o }, !1)
    : Vr(e, n, {
        title: 'Pas la bonne \xE9quation caract\xE9ristique',
        message: `\xC0 ${e.fn}\u2033 correspond r\xB2, \xE0 ${e.fn}\u2032 correspond r, \xE0 ${e.fn} correspond 1 : on garde les coefficients.`,
      });
}
function k6(e, n, t, r) {
  let s = mS(e);
  if (!s)
    return st(
      n,
      'Pas de discriminant ici',
      'Le discriminant sert \xE0 l\u2019\xE9quation caract\xE9ristique (ordre 2).',
    );
  let i = [s, ...(e.charQ ? [e.charQ] : [])],
    o = t.map((c) => ($(c).size ? NaN : we(c, {})));
  if (
    !i.find((c) => {
      let f = c[1] * c[1] - 4 * c[0] * c[2];
      return o.every((d) => dn(d, f));
    })
  )
    return Vr(e, n, {
      title: 'Pas le bon discriminant',
      message:
        '\u0394 = b\xB2 \u2212 4ac, avec les coefficients de l\u2019\xE9quation caract\xE9ristique.',
    });
  let l = String(Math.round(o[0] * 1e9)),
    u = { text: r, kind: 'delta', delta: o[0] };
  return e.deltas.has(l)
    ? (t.length === 1 && yo(t[0]) <= 2,
      st(n, 'Rien de nouveau', 'Tu as d\xE9j\xE0 calcul\xE9 \u0394.'))
    : Wn(n, 'discriminant', u, !1);
}
function Z2(e, n, t, r) {
  let s = mS(e);
  if (!s)
    return st(
      n,
      'Pas de racines ici',
      'Les racines de l\u2019\xE9quation caract\xE9ristique servent aux \xE9quations d\u2019ordre 2 \xE0 coefficients constants.',
    );
  let i = [];
  for (let c of t) {
    let f = c[0];
    if (f.k !== 's' || f.n !== 'r' || c.length !== 2)
      return {
        kind: 'syntax',
        ...n,
        title: 'Les racines',
        message: '\xC9cris \xAB r = \u2026 ou r = \u2026 \xBB.',
      };
    let d = r6(At(c[1]));
    if (!d)
      return {
        kind: 'syntax',
        ...n,
        title: 'Un nombre',
        message: 'Une racine est un nombre (r\xE9el ou complexe, avec i).',
      };
    i.push(d);
  }
  let o = t6(s),
    a = i.every((c) => o.some((f) => z2(c, f))),
    l = o.every((c) => i.some((f) => z2(f, c)));
  if (!a)
    return Vr(e, n, {
      title: 'Pas les racines',
      message:
        'V\xE9rifie : remplace r par ta valeur dans l\u2019\xE9quation caract\xE9ristique, on doit trouver 0.',
    });
  if (!l)
    return {
      kind: 'false',
      ...n,
      title: 'Il manque une racine',
      message:
        'L\u2019\xE9quation caract\xE9ristique a deux racines : \xE9cris-les toutes les deux (\xAB r = \u2026 ou r = \u2026 \xBB).',
    };
  if (e.rootsWritten) return st(n, 'Rien de nouveau', 'Tu as d\xE9j\xE0 \xE9crit les racines.');
  let u =
    o.length === 1
      ? 'Racine double'
      : o[0].im !== 0
        ? 'Racines complexes'
        : 'Deux racines r\xE9elles';
  return Wn(n, 'roots', { text: r, kind: 'roots' }, !1, u);
}
function oO(e, n) {
  let t = n.omove;
  if (t) {
    switch ((e.written.add(t.text), e.lines++, t.kind)) {
      case 'eq':
        (e.eqs.push({ of: t.of, shape: t.shape }), t.of === 'homog' && (e.homogWritten = !0));
        break;
      case 'family': {
        let r = ha(e, t.F);
        (e.families.push({ of: t.of, F: t.F, cs: r, size: t.size }),
          t.of === 'full' &&
            (!e.cFamily || e.cFamily.join() !== r.join()) &&
            ((e.cFamily = r), (e.cEqs = []), (e.cKnown = !1)));
        break;
      }
      case 'one':
        e.ones.push({ F: t.F, size: t.size });
        break;
      case 'deriv':
        e.derivs.push({ order: t.order, F: t.F, size: t.size });
        break;
      case 'eval':
        e.evals.set(t.head, Math.min(t.size, e.evals.get(t.head) ?? 1 / 0));
        break;
      case 'value':
        e.values.set(t.head, Math.min(t.size, e.values.get(t.head) ?? 1 / 0));
        break;
      case 'ceq': {
        let r = Og(e);
        (r &&
          (!e.cFamily || e.cFamily.join() !== r.cs.join()) &&
          ((e.cFamily = r.cs), (e.cEqs = [])),
          e.cEqs.push({ w: t.w, r: t.r, solved: !!t.solved }),
          r &&
            (e.cKnown = r.cs.every((s, i) =>
              e.cEqs.some(
                (o) =>
                  o.solved &&
                  Math.abs(o.w[i]) > 1e-12 &&
                  o.w.every((a, l) => l === i || Math.abs(a) < 1e-12),
              ),
            )));
        break;
      }
      case 'char':
        e.charQ = t.q;
        break;
      case 'delta':
        e.deltas.add(String(Math.round(t.delta * 1e9)));
        break;
      case 'roots':
        e.rootsWritten = !0;
        break;
      default:
        break;
    }
    t.final && (e.concluded = !0);
  }
}
function aO(e) {
  return e.concluded;
}
function x6(e, n) {
  let t;
  try {
    t = Wl(n, e.fn, e.x);
  } catch {
    return null;
  }
  return { base: { atoms: t, line: qk(t) }, r: Ng(t) };
}
function lO(e, n) {
  let t = x6(e, n);
  if (!t || (t.r.k !== 'eq' && t.r.k !== 'or')) return !1;
  let r = { ...e, written: new Set(), givenTexts: new Set(), traps: [] },
    s;
  try {
    s = iO(r, t.base, t.r);
  } catch {
    return !1;
  }
  return (
    s.kind === 'step' ||
    (s.kind === 'useless' && s.title !== 'C\u2019est l\u2019\xE9nonc\xE9' && !!s.omove)
  );
}
var y6 = {
    first: 'partial.first@1',
    second: 'partial.second@1',
    gradient: 'partial.gradient@1',
    laplacian: 'partial.laplacian@1',
    point: 'partial.point@1',
    simplify: 'partial.simplify@1',
    substitute: 'partial.substitute@1',
    curve: 'partial.curve@1',
    compose: 'partial.compose@1',
    chain: 'partial.chain@1',
    derive: 'partial.derive@1',
    compute: 'kernel.compute@1',
  },
  w6 = {
    first: {
      label: 'D\xE9river par rapport \xE0 x',
      hora: 2,
      why: 'Une d\xE9riv\xE9e partielle : on d\xE9rive par rapport \xE0 une variable, l\u2019autre est une constante.',
    },
    second: {
      label: 'D\xE9river une d\xE9riv\xE9e partielle',
      hora: 2,
      why: 'Une d\xE9riv\xE9e seconde : on d\xE9rive une d\xE9riv\xE9e partielle d\xE9j\xE0 calcul\xE9e.',
    },
    gradient: {
      label: 'Gradient',
      hora: 1,
      why: 'Le gradient est le couple des d\xE9riv\xE9es partielles.',
    },
    laplacian: {
      label: 'Laplacien',
      hora: 1,
      why: 'Le laplacien est la somme des deux d\xE9riv\xE9es secondes.',
    },
    point: {
      label: 'Calculer en un point',
      hora: 1,
      why: 'On remplace les variables par les coordonn\xE9es du point.',
    },
    simplify: {
      label: 'Simplifier la fonction',
      hora: 1,
      why: 'Une \xE9criture plus simple de la fonction.',
    },
    substitute: {
      label: 'Remplacer',
      hora: 1,
      why: 'On remplace par ce qui est d\xE9j\xE0 calcul\xE9.',
    },
    curve: {
      label: 'D\xE9river x(t)',
      hora: 1,
      why: 'La d\xE9riv\xE9e d\u2019une coordonn\xE9e de la courbe.',
    },
    compose: {
      label: 'Composer',
      hora: 1,
      why: 'On remplace x et y par x(t) et y(t) dans la fonction.',
    },
    chain: {
      label: 'R\xE8gle de la cha\xEEne',
      hora: 2,
      why: 'g\u2032(t) = x\u2032(t) \xD7 \u2202f/\u2202x + y\u2032(t) \xD7 \u2202f/\u2202y, les d\xE9riv\xE9es partielles prises en (x(t), y(t)).',
    },
    derive: {
      label: 'D\xE9river',
      hora: 2,
      why: 'Une fonction d\u2019une variable : on la d\xE9rive.',
    },
    compute: { label: 'Calculer', hora: 1, why: 'Un calcul.' },
  },
  S6 = 'D\xE9riv\xE9es partielles',
  xr = class extends Error {},
  Yl = (e) => e.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
function uO(e) {
  let n = e.kernel,
    t = /^\s*([A-Za-z])\s*\(\s*([\p{L}])\s*[,;]\s*([\p{L}])\s*\)\s*=/u.exec(n.start);
  if (!t)
    throw new xr(
      `Le d\xE9part d\xE9finit la fonction : \xAB f(x, y) = \u2026 \xBB (\xAB ${n.start} \xBB).`,
    );
  let r = t[1],
    s = [t[2], t[3]];
  if (s[0] === s[1] || s.includes(r))
    throw new xr('Deux variables distinctes, autres que la fonction.');
  let i = n.partial?.curve;
  return { fn: r, vars: s, curve: i ? { t: i.t, g: i.g, x: i.x, y: i.y } : null };
}
var Zc = '\u039E\u039E\u039E',
  Qk =
    '\u0391\u0392\u0393\u0395\u0396\u0397\u0399\u039A\u039B\u039C\u039D\u039F\u03A1\u03A4\u03A5\u03A6\u03A7\u03A8\u03D8\u03DA\u03DC\u03E0',
  Fk = `${Zc}\u03A9`,
  cO = '\u2070\xB9\xB2\xB3\u2074\u2075\u2076\u2077\u2078\u2079',
  gS = (e) => e.length > 0 && [...e].every((n) => cO.includes(n));
function T6(e) {
  return /^[∂∇Δ]/.test(e) || /^[\p{L}][′″]*\(.+\)$/u.test(e);
}
function fO(e) {
  return e
    .split(/\s*[,;]\s*/)
    .map((n) => n.trim())
    .filter((n) => n.length > 0);
}
function Xl(e, n) {
  let t = [],
    r = (p) => {
      let g = t.indexOf(p);
      return (g < 0 && (g = t.push(p) - 1), ` ${Zc}${Qk[g] ?? '\u03DE'} `);
    },
    s = Yl(n.fn),
    i = `(${n.vars.map(Yl).join('|')})`,
    o = '(?:\\s*\\(([^()]*)\\))?',
    a = n.fn,
    l = n.vars,
    u = (p) => {
      if (p === void 0) return '';
      let g = fO(p);
      return g.length === 2 && g[0] === l[0] && g[1] === l[1] ? '' : `(${g.join(', ')})`;
    },
    c = e
      .replace(/[’']{2}/g, '\u2033')
      .replace(/[’']/g, '\u2032')
      .replace(/′′/g, '\u2033');
  c = c
    .replace(
      new RegExp(`\u2202\\s*\xB2\\s*${s}\\s*/\\s*\u2202\\s*${i}\\s*\u2202\\s*${i}${o}`, 'gu'),
      (p, g, h, b) => r(`\u2202\xB2${a}/\u2202${g}\u2202${h}${u(b)}`),
    )
    .replace(
      new RegExp(`\u2202\\s*\xB2\\s*${s}\\s*/\\s*\u2202\\s*${i}\\s*\xB2${o}`, 'gu'),
      (p, g, h) => r(`\u2202\xB2${a}/\u2202${g}\xB2${u(h)}`),
    )
    .replace(new RegExp(`\u2202\\s*${s}\\s*/\\s*\u2202\\s*${i}${o}`, 'gu'), (p, g, h) =>
      r(`\u2202${a}/\u2202${g}${u(h)}`),
    )
    .replace(new RegExp(`\u2207\\s*${s}${o}`, 'gu'), (p, g) => r(`\u2207${a}${u(g)}`))
    .replace(new RegExp(`\u0394\\s*${s}${o}`, 'gu'), (p, g) => r(`\u0394${a}${u(g)}`));
  let f = n.curve;
  if (f) {
    let p = Yl(f.t);
    c = c
      .replace(new RegExp(`(?<![\\p{L}])${i}\\s*\u2032\\s*\\(\\s*${p}\\s*\\)`, 'gu'), (g, h) =>
        r(`${h}\u2032(${f.t})`),
      )
      .replace(
        new RegExp(`(?<![\\p{L}])${Yl(f.g)}\\s*(\u2033|\u2032)?\\s*\\(([^()]*)\\)`, 'gu'),
        (g, h, b) => r(`${f.g}${h ?? ''}(${b.trim()})`),
      )
      .replace(new RegExp(`(?<![\\p{L}])${i}\\s*\\(\\s*${p}\\s*\\)`, 'gu'), (g, h) => ` ${h} `);
  }
  ((c = c.replace(new RegExp(`(?<![\\p{L}])${s}\\s*\\(([^()]*)\\)`, 'gu'), (p, g) => {
    let h = u(g);
    return r(h ? `${a}${h}` : `${a}(${l.join(', ')})`);
  })),
    (c = c.replace(/\s*;\s*|,\s+/g, ` ${Fk} `)));
  let d = [];
  for (let p of Te(c)) {
    let g = d[d.length - 1];
    if (gS(p) && g !== void 0 && gS(g)) {
      d[d.length - 1] = g + p;
      continue;
    }
    d.push(p);
  }
  let m = d.map((p) => {
    if (p === Fk) return ',';
    if (p.startsWith(Zc) && p.length === Zc.length + 1) {
      let g = Qk.indexOf(p[Zc.length]);
      if (g >= 0 && t[g] !== void 0) return t[g];
    }
    return p;
  });
  return ne(m);
}
function Hc(e) {
  let n = [],
    t = e.map((s) =>
      T6(s) ? (n.push(s), `${Zc}${Qk[n.length - 1] ?? '\u03DE'}`) : s === ',' ? Fk : s,
    ),
    r = ot(t)
      .replace(/ ([⁰¹²³⁴⁵⁶⁷⁸⁹]+)/g, '$1')
      .replace(/\//g, '\xF7')
      .replace(/\s*÷\s*/g, ' \xF7 ')
      .replace(new RegExp(`\\s*${Fk}\\s*`, 'g'), ', ');
  return (
    n.forEach((s, i) => {
      r = r.split(`${Zc}${Qk[i] ?? '\u03DE'}`).join(s);
    }),
    r
  );
}
var hS = (e) => ({ dis: [{ sides: [{ k: 's', n: Hc(e) }] }] });
function R6(e, n) {
  return hS(Xl(e, n));
}
function dO(e) {
  let n = [];
  for (let t of e) {
    if (gS(t) && t !== '\xB2') {
      n.push('^', [...t].map((r) => String(cO.indexOf(r))).join(''));
      continue;
    }
    n.push(t);
  }
  return n;
}
var $6 = { k: 'fn', f: 'exp', a: { k: 'num', v: { n: 1n, d: 1n } } };
function lm(e) {
  switch (e.k) {
    case 'sym':
      return e.n === 'e' ? $6 : e;
    case 'add':
    case 'mul':
      return { ...e, c: e.c.map(lm) };
    case 'div':
    case 'pow':
    case 'binom':
      return { ...e, a: lm(e.a), b: lm(e.b) };
    case 'fn':
      return { ...e, a: lm(e.a) };
    default:
      return e;
  }
}
function bS(e, n) {
  try {
    let t = D(e, n);
    return Number.isFinite(t) ? t : NaN;
  } catch {
    return NaN;
  }
}
function eu(e) {
  switch (e.k) {
    case 'num':
      return e.v.d === 1n ? 1 : 2;
    case 'sym':
      return 1;
    case 'add':
    case 'mul':
      return 1 + e.c.reduce((n, t) => n + eu(t), 0);
    case 'div':
    case 'pow':
    case 'binom':
      return 1 + eu(e.a) + eu(e.b);
    case 'fn':
      return 1 + eu(e.a);
  }
}
var C6 = (e, n) =>
  Number.isFinite(e) &&
  Number.isFinite(n) &&
  Math.abs(e - n) <= 1e-7 * Math.max(1, Math.abs(e), Math.abs(n));
function vS(e) {
  let n = ne(dO(Te(e))),
    t = Ae(n, { chains: !0 }),
    r = t.dis[0]?.sides;
  if (!r || r.length !== 1 || t.dis.length !== 1) throw new xr(`\xAB ${e} \xBB`);
  return lm(_e(r[0]));
}
var E6 = [
    [0.7, 1.3],
    [1.9, -0.6],
    [-1.1, 0.45],
    [2.3, 1.7],
    [-0.8, -1.4],
    [0.35, 2.2],
    [1.25, 0.9],
    [-1.7, 0.6],
    [0.55, -0.85],
  ],
  M6 = [-1.3, -0.7, -0.2, 0.3, 0.8, 1.2, 1.7, 2.1, 2.6];
function _6(e, n) {
  if (e.heads.has(n)) return e.heads.get(n);
  let t = q6(e.spec, n);
  return (t && e.heads.set(n, t), t);
}
function q6(e, n) {
  let t = Yl(e.fn),
    r = `(${e.vars.map(Yl).join('|')})`,
    s = '(?:\\(([^()]*)\\))?',
    i = (l, u, c) => {
      let f = c === void 0 ? void 0 : fO(c),
        d =
          l === 'd1' || l === 'cd'
            ? `${l}:${u[0]}`
            : l === 'd2'
              ? `d2:${[...u].sort((m, p) => e.vars.indexOf(m) - e.vars.indexOf(p)).join(',')}`
              : l;
      return {
        key: f ? `${d}@${f.join(',')}` : d,
        text: n,
        kind: l,
        vars: u,
        ...(f ? { pt: f } : {}),
      };
    },
    o;
  if (n === e.fn || n === `${e.fn}(${e.vars.join(', ')})`) return i('f', []);
  if ((o = new RegExp(`^${t}\\(([^()]*)\\)$`, 'u').exec(n))) return i('f', [], o[1]);
  if ((o = new RegExp(`^\u2202\xB2${t}/\u2202${r}\u2202${r}${s}$`, 'u').exec(n)))
    return i('d2', [o[1], o[2]], o[3]);
  if ((o = new RegExp(`^\u2202\xB2${t}/\u2202${r}\xB2${s}$`, 'u').exec(n)))
    return i('d2', [o[1], o[1]], o[2]);
  if ((o = new RegExp(`^\u2202${t}/\u2202${r}${s}$`, 'u').exec(n))) return i('d1', [o[1]], o[2]);
  if ((o = new RegExp(`^\u2207${t}${s}$`, 'u').exec(n))) return i('grad', [], o[1]);
  if ((o = new RegExp(`^\u0394${t}${s}$`, 'u').exec(n))) return i('lap', [], o[1]);
  let a = e.curve;
  if (a) {
    if ((o = new RegExp(`^${r}\u2032\\(${Yl(a.t)}\\)$`, 'u').exec(n))) return i('cd', [o[1]]);
    if ((o = new RegExp(`^${Yl(a.g)}(\u2033|\u2032)?\\(([^()]*)\\)$`, 'u').exec(n))) {
      let l = o[1] === '\u2033' ? 'g2' : o[1] === '\u2032' ? 'g1' : 'g';
      return o[2] === a.t ? i(l, []) : i(l, [], o[2]);
    }
  }
  return null;
}
function L6(e, n) {
  let t = n.kind,
    r = n.key.replace(/@.*$/, ''),
    s =
      t === 'f'
        ? e.fn
        : t === 'g' || t === 'g1' || t === 'g2'
          ? `${e.curve.g}${t === 'g1' ? '\u2032' : t === 'g2' ? '\u2033' : ''}(${e.curve.t})`
          : n.text.replace(/\([^()]*\)$/, '');
  return { key: r, text: s, kind: t, vars: n.vars };
}
function yS(e, n) {
  if (e.termCache.has(n.key)) return e.termCache.get(n.key);
  let t = null;
  try {
    let [r, s] = e.vars,
      i = () => R(j(e.F, { [r]: e.curve.X, [s]: e.curve.Y })),
      o;
    switch (n.kind) {
      case 'f':
        o = e.F;
        break;
      case 'd1':
        o = wn(e.F, n.vars[0]);
        break;
      case 'd2':
        o = wn(wn(e.F, n.vars[1]), n.vars[0]);
        break;
      case 'grad':
        o = [wn(e.F, r), wn(e.F, s)];
        break;
      case 'lap':
        o = R(he(wn(wn(e.F, r), r), wn(wn(e.F, s), s)));
        break;
      case 'cd':
        o = wn(n.vars[0] === r ? e.curve.X : e.curve.Y, e.curve.t);
        break;
      case 'g':
        o = i();
        break;
      case 'g1':
        o = wn(i(), e.curve.t);
        break;
      case 'g2':
        o = wn(wn(i(), e.curve.t), e.curve.t);
        break;
    }
    if (n.pt) {
      let l = n.kind === 'g' || n.kind === 'g1' || n.kind === 'g2' ? [e.curve.t] : e.vars;
      if (n.pt.length !== l.length) return null;
      let u = Object.fromEntries(l.map((c, f) => [c, vS(n.pt[f])]));
      o = Array.isArray(o) ? [R(j(o[0], u)), R(j(o[1], u))] : R(j(o, u));
    }
    t = o;
  } catch {
    t = null;
  }
  return (e.termCache.set(n.key, t), t);
}
function mO(e, n) {
  let t = e.syms.get(n.key);
  return (t || ((t = `\u03A8${e.syms.size}`), e.syms.set(n.key, t)), t);
}
function jk(e, n) {
  let t = [],
    r = n.map((o) => {
      let a = _6(e, o);
      return a ? (t.push(a), mO(e, a)) : o;
    }),
    s;
  try {
    s = Ae(ne(dO(r)), { chains: !0 });
  } catch {
    return null;
  }
  let i = s.dis[0];
  if (s.dis.length !== 1 || !i || i.cmp || i.rels || i.sides.length !== 1) return null;
  try {
    return { S: lm(_e(i.sides[0])), heads: t };
  } catch {
    return null;
  }
}
function pS(e, n, t) {
  let r = {};
  for (let s of t) {
    let i = yS(e, s);
    if (!i || Array.isArray(i)) return null;
    r[mO(e, s)] = i;
  }
  try {
    return R(j(n, r));
  } catch {
    return null;
  }
}
function kS(e, n) {
  if (!n.length) return 'incomplete';
  let t = 0,
    r = [];
  for (let l = 0; l < n.length; l++) {
    let u = n[l];
    if ((u === '(' && t++, u === ')' && t--, t < 0)) return 'incomplete';
    if (u === ',') {
      if (t !== 1) return { err: 'couple' };
      r.push(l);
    }
  }
  if (t !== 0) return 'incomplete';
  let s = new Set(e.vars);
  if (r.length) {
    if (r.length !== 1 || n[0] !== '(' || n[n.length - 1] !== ')') return { err: 'couple' };
    let l = 0;
    for (let b = 0; b < n.length - 1; b++)
      if ((n[b] === '(' && l++, n[b] === ')' && l--, l === 0)) return { err: 'couple' };
    let u = n.slice(1, r[0]),
      c = n.slice(r[0] + 1, n.length - 1);
    if (!u.length || !c.length) return 'incomplete';
    let f = jk(e, u),
      d = jk(e, c);
    if (!f || !d) return 'incomplete';
    let m = [...f.heads, ...d.heads];
    if (m.some((b) => b.kind === 'grad')) return { err: 'grad' };
    let p = pS(e, f.S, f.heads),
      g = pS(e, d.S, d.heads);
    if (!p || !g) return { err: 'read' };
    let h = new Set([...$(f.S), ...$(d.S)]);
    return {
      atoms: n,
      heads: m,
      S: null,
      T: null,
      couple: [p, g],
      single: null,
      size: eu(f.S) + eu(d.S),
      hasVars: [...h].some((b) => s.has(b)),
      hasT: !!e.curve && h.has(e.curve.t),
    };
  }
  let i = jk(e, n);
  if (!i) return 'incomplete';
  let o = n.length === 1 ? (i.heads[0] ?? null) : null;
  if (i.heads.some((l) => l.kind === 'grad')) {
    if (!o) return { err: 'grad' };
    let l = yS(e, o);
    return !l || !Array.isArray(l)
      ? { err: 'read' }
      : {
          atoms: n,
          heads: i.heads,
          S: i.S,
          T: null,
          couple: l,
          single: o,
          size: 1,
          hasVars: !1,
          hasT: !1,
        };
  }
  let a = pS(e, i.S, i.heads);
  return a
    ? {
        atoms: n,
        heads: i.heads,
        S: i.S,
        T: a,
        couple: null,
        single: o,
        size: eu(i.S),
        hasVars: [...$(i.S)].some((l) => s.has(l)),
        hasT: !!e.curve && $(i.S).has(e.curve.t),
      }
    : { err: 'read' };
}
function wS(e, n) {
  let t = [],
    r = 0;
  if (
    (n.forEach((o, a) => {
      (o === '(' && r++, o === ')' && r--, o === '=' && r === 0 && t.push(a));
    }),
    !t.length)
  )
    return { k: 'incomplete' };
  if (t.length > 1)
    return {
      k: 'syntax',
      title: 'Une \xE9galit\xE9',
      message: `\xC9cris une \xE9galit\xE9 par ligne : \xAB \u2202${e.fn}/\u2202${e.vars[0]} = \u2026 \xBB.`,
    };
  let s = kS(e, n.slice(0, t[0])),
    i = kS(e, n.slice(t[0] + 1));
  if (s === 'incomplete' || i === 'incomplete') return { k: 'incomplete' };
  for (let o of [s, i])
    if ('err' in o)
      return o.err === 'couple'
        ? {
            k: 'syntax',
            title: 'Un couple',
            message: '\xC9cris un couple entre parenth\xE8ses : \xAB (\u2026, \u2026) \xBB.',
          }
        : o.err === 'grad'
          ? {
              k: 'syntax',
              title: 'Le gradient est un couple',
              message: `\xC9cris \xAB \u2207${e.fn} = (\u2026, \u2026) \xBB.`,
            }
          : {
              k: 'syntax',
              title: '\xC7a ne se lit pas',
              message: 'V\xE9rifie l\u2019\xE9criture de ta ligne.',
            };
  return { k: 'eq', sides: [s, i] };
}
function SS(e, n) {
  if (!e.curve) return e.grid;
  let t = e.curve.t;
  return n.some(
    (s) =>
      s.heads.some((i) => ['cd', 'g', 'g1', 'g2'].includes(i.kind)) ||
      (s.T ? $(s.T).has(t) : !1) ||
      (s.couple ? s.couple.some((i) => $(i).has(t)) : !1),
  )
    ? e.tEnvs
    : e.grid;
}
function As(e, n) {
  return n.map((t) => bS(e, t));
}
function Wc(e, n) {
  let t = 0;
  for (let r = 0; r < e.length; r++) {
    let s = Number.isFinite(e[r]),
      i = Number.isFinite(n[r]);
    if (s !== i) return !1;
    if (s) {
      if (!C6(e[r], n[r])) return !1;
      t++;
    }
  }
  return t >= 4;
}
function TS(e, n) {
  let t = new Set([...e.vars, '\u03C0', ...(e.curve ? [e.curve.t] : [])]);
  for (let r of n)
    for (let s of r.couple ?? (r.T ? [r.T] : [])) for (let i of $(s)) if (!t.has(i)) return i;
  return null;
}
function RS(e, n, t) {
  if (!!n.couple != !!t.couple) return 'shape';
  let r = SS(e, [n, t]);
  return n.couple && t.couple
    ? Wc(As(n.couple[0], r), As(t.couple[0], r)) && Wc(As(n.couple[1], r), As(t.couple[1], r))
      ? 'eq'
      : 'neq'
    : Wc(As(n.T, r), As(t.T, r))
      ? 'eq'
      : 'neq';
}
function am(e, n, t) {
  if (!t || !n.T) return !1;
  let r = SS(e, [n]);
  return Wc(As(n.T, r), As(t, r));
}
function pO(e) {
  let n = e.kernel,
    t = uO(e),
    r = {
      model: e,
      spec: t,
      fn: t.fn,
      vars: t.vars,
      F: { k: 'num', v: { n: 0n, d: 1n } },
      Fsize: 0,
      curve: null,
      grid: [],
      tEnvs: [],
      target: { key: '', text: '' },
      answer: { size: 0, heads: 0, text: '' },
      facts: new Map(),
      written: new Set(),
      givenTexts: new Set(),
      path: n.path ?? [],
      traps: [],
      heads: new Map(),
      syms: new Map(),
      termCache: new Map(),
      lines: 0,
      concluded: !1,
    },
    s = Xl(n.start, t),
    i = s.indexOf('='),
    o = jk(r, s.slice(i + 1));
  if (i !== 1 || !o || o.heads.length)
    throw new xr(`Le d\xE9part est \xAB f(x, y) = expression \xBB : \xAB ${n.start} \xBB.`);
  ((r.F = R(o.S)), (r.Fsize = eu(o.S)));
  for (let m of $(r.F))
    if (!r.vars.includes(m) && m !== '\u03C0')
      throw new xr(`La fonction n\u2019a que les variables ${r.vars.join(', ')}.`);
  if (t.curve) {
    if (r.vars[0] !== 'x' || r.vars[1] !== 'y')
      throw new xr('Le long d\u2019une courbe, les variables sont x et y.');
    let m = t.curve.t;
    if ([r.fn, ...r.vars, 'e', 'i'].includes(m) || t.curve.g === r.fn)
      throw new xr('La variable t et la fonction g ont d\u2019autres lettres.');
    let p = vS(t.curve.x),
      g = vS(t.curve.y);
    for (let h of [...$(p), ...$(g)])
      if (h !== m && h !== '\u03C0') throw new xr('La courbe ne d\xE9pend que de t.');
    ((r.curve = { t: m, g: t.curve.g, X: p, Y: g }),
      (r.tEnvs = M6.map((h) => ({ [m]: h, x: bS(p, { [m]: h }), y: bS(g, { [m]: h }) }))));
  }
  r.grid = E6.map(([m, p]) => ({ [r.vars[0]]: m, [r.vars[1]]: p }));
  let a = Xl(n.goal.target, t),
    l = kS(r, a);
  if (l === 'incomplete' || 'err' in l || !l.heads.length)
    throw new xr(`La question est une d\xE9riv\xE9e : \xAB ${n.goal.target} \xBB.`);
  r.target = { key: xS(r, l), text: Hc(a) };
  let u = Xl(n.answer, t),
    c = wS(r, u);
  if (c.k !== 'eq') throw new xr(`La r\xE9ponse est une \xE9galit\xE9 : \xAB ${n.answer} \xBB.`);
  let [f, d] = c.sides;
  if (xS(r, f) !== r.target.key) throw new xr('La r\xE9ponse commence par la question.');
  if (TS(r, [f, d])) throw new xr('Une lettre inconnue dans la r\xE9ponse.');
  if (RS(r, f, d) !== 'eq') throw new xr('La r\xE9ponse est fausse.');
  return (
    (r.answer = { size: d.size, heads: d.heads.length, text: Hc(u) }),
    (r.givenTexts = new Set(N6(e).map((m) => Hc(Xl(m, t))))),
    (r.traps = (e.traps ?? []).map((m) => ({
      text: Hc(Xl(m.line, t)),
      line: R6(m.line, t),
      title: m.title ?? 'Attention',
      why: m.why,
    }))),
    r
  );
}
function N6(e) {
  let n = e.kernel,
    t = n.partial?.curve;
  if (!t) return [n.start];
  let r = uO(e);
  return [
    n.start,
    `${r.vars[0]} = ${t.x}`,
    `${r.vars[1]} = ${t.y}`,
    `${t.g}(${t.t}) = ${r.fn}(${r.vars.join(', ')})`,
  ];
}
function xS(e, n) {
  if (n.single) return `h:${n.single.key}`;
  try {
    return `e:${E(R(n.S))}`;
  } catch {
    return `t:${Hc(n.atoms)}`;
  }
}
function xt(e, n, t, r, s, i) {
  let o = w6[n];
  return {
    kind: 'step',
    ...e,
    hora: o.hora,
    final: r,
    rule: {
      id: y6[n],
      card: S6,
      label: s ?? o.label,
      hora: o.hora,
      why: (i ?? o.why) + (r ? ' C\u2019est la r\xE9ponse.' : ''),
    },
    omove: { ...t, ...(r ? { final: r } : {}) },
  };
}
function wi(e, n, t, r) {
  return {
    kind: 'useless',
    ...e,
    jump: !0,
    final: t,
    title: t ? 'Juste !' : 'Juste, mais tu sautes des \xE9tapes',
    message:
      r ??
      (t
        ? 'C\u2019est la r\xE9ponse. D\xE9taille ton calcul, une \xE9tape par ligne, pour gagner des HORA. Tu peux garder cette ligne sans HORA.'
        : 'Ta ligne est juste. D\xE9taille-la, une \xE9tape \xE0 la fois, pour gagner des HORA. Tu peux la garder sans HORA.'),
    omove: { ...n, ...(t ? { final: t } : {}) },
  };
}
function um(e, n, t, r) {
  return { kind: 'useless', ...e, title: n, message: t, ...(r ? { omove: r } : {}) };
}
function Rt(e, n, t) {
  return { kind: 'false', ...e, title: n, message: t };
}
var Jl = (e, n) => e.facts.has(`h:${n}`);
function O6(e, n) {
  return e.path.some((t) => {
    let r;
    try {
      r = Xl(t, e.spec);
    } catch {
      return !1;
    }
    return r.length > n.length && n.every((s, i) => r[i] === s);
  });
}
function gO(e, n, t) {
  let r = ne(n.flatMap((u) => u.atoms));
  if (!r.length) return { kind: 'empty', atoms: r, badChip: -1 };
  let s = O6(e, r),
    i = () =>
      t?.verify
        ? { kind: 'syntax', atoms: r, title: 'Ligne inachev\xE9e', message: 'Termine ta ligne.' }
        : { kind: s ? 'building' : 'open', atoms: r, complete: !1 },
    o = wS(e, r);
  if (o.k === 'incomplete') return i();
  if (o.k === 'syntax')
    return s && !t?.verify
      ? { kind: 'building', atoms: r, complete: !1 }
      : { kind: 'syntax', atoms: r, line: hS(r), title: o.title, message: o.message };
  let a = { atoms: r, line: hS(r) },
    l;
  try {
    l = K6(e, a, o.sides[0], o.sides[1]);
  } catch {
    l = {
      kind: 'syntax',
      ...a,
      title: '\xC7a ne se lit pas',
      message: 'Cette ligne ne se lit pas : v\xE9rifie l\u2019\xE9criture.',
    };
  }
  return s && !t?.verify
    ? l.kind === 'step'
      ? { ...l, kind: 'ready', complete: !0 }
      : { kind: 'building', atoms: r, complete: !0 }
    : !t?.verify && (l.kind === 'unjustified' || l.kind === 'false')
      ? { kind: 'pending', atoms: r, complete: !0 }
      : { ...l, complete: !0 };
}
function K6(e, n, t, r) {
  let s = Hc(n.atoms);
  if (e.givenTexts.has(s))
    return um(
      n,
      'C\u2019est l\u2019\xE9nonc\xE9',
      'Cette ligne est dans l\u2019\xE9nonc\xE9 : \xE9cris l\u2019\xE9tape suivante.',
    );
  if (e.written.has(s))
    return um(
      n,
      'D\xE9j\xE0 \xE9crit',
      'Tu as d\xE9j\xE0 \xE9crit cette ligne : \xE9cris l\u2019\xE9tape suivante.',
    );
  let i = e.traps.find((d) => d.text === s);
  if (i)
    return {
      kind: 'trap',
      ...n,
      title: i.title,
      message: i.why,
      trap: { line: i.line, title: i.title, why: i.why },
    };
  if (!t.heads.length)
    return {
      kind: 'syntax',
      ...n,
      title: 'Ce que tu calcules',
      message: `Commence ta ligne par ce que tu calcules : \xAB \u2202${e.fn}/\u2202${e.vars[0]} = \u2026 \xBB.`,
    };
  let o = TS(e, [t, r]);
  if (o)
    return {
      kind: 'syntax',
      ...n,
      title: 'Une lettre inconnue',
      message: `Que vaut ${o} ? Les variables sont ${e.vars.join(' et ')}${e.curve ? `, et ${e.curve.t}` : ''}.`,
    };
  let a = RS(e, t, r);
  if (a !== 'eq') return A6(e, n, t, r, a);
  let l = xS(e, t),
    u = l === e.target.key && r.size <= e.answer.size && r.heads.length <= e.answer.heads,
    c = { text: s, key: l, size: r.size, heads: r.heads.map((d) => d.key), vars: r.hasVars },
    f = e.facts.get(l);
  return f ? I6(e, n, r, f, c, u) : P6(e, n, t, r, c, u);
}
function P6(e, n, t, r, s, i) {
  let o = t.single,
    a = e.fn,
    l = (d, m) => {
      let p = d.findIndex((g) => !Jl(e, g));
      return p < 0 ? null : m[p];
    };
  if (!o) {
    if (r.heads.length) return wi(n, s, i);
    let d = t.heads.filter((m) => m.kind !== 'f' && !Jl(e, m.key));
    return d.length
      ? wi(n, s, i, `\xC9cris d\u2019abord \xAB ${d[0].text} = \u2026 \xBB.`)
      : xt(
          n,
          'substitute',
          s,
          i,
          'Remplacer',
          'On remplace chaque d\xE9riv\xE9e par son expression.',
        );
  }
  if (o.pt) {
    let d = L6(e, o);
    if (r.heads.length) return wi(n, s, i);
    let m =
      o.kind === 'f'
        ? `Calculer ${a}(${o.pt.join(', ')})`
        : o.kind === 'g' || o.kind === 'g1' || o.kind === 'g2'
          ? `Calculer en ${e.curve.t} = ${o.pt[0]}`
          : `Calculer en (${o.pt.join(', ')})`;
    return d.kind === 'f' || Jl(e, d.key)
      ? xt(n, 'point', s, i, m)
      : wi(n, s, i, `\xC9cris d\u2019abord \xAB ${d.text} = \u2026 \xBB.`);
  }
  let [u, c] = e.vars,
    f = (d) => `\u2202${a}/\u2202${d}`;
  switch (o.kind) {
    case 'f':
      return r.heads.length || r.size >= e.Fsize
        ? um(
            n,
            'Rien de nouveau',
            'C\u2019est la fonction de l\u2019\xE9nonc\xE9 : \xE9cris l\u2019\xE9tape suivante.',
          )
        : xt(n, 'simplify', s, i, `Simplifier ${a}`);
    case 'd1': {
      if (r.heads.length)
        return um(n, '\xC9cris l\u2019expression', `\xC9cris ${o.text} avec ${u} et ${c}.`);
      let d = o.vars[0],
        m = d === u ? c : u;
      return xt(
        n,
        'first',
        s,
        i,
        `D\xE9river par rapport \xE0 ${d}`,
        `On d\xE9rive par rapport \xE0 ${d} : ${m} est une constante.`,
      );
    }
    case 'd2': {
      if (r.heads.length)
        return um(n, '\xC9cris l\u2019expression', `\xC9cris ${o.text} avec ${u} et ${c}.`);
      let [d, m] = o.vars;
      return Jl(e, `d1:${m}`)
        ? xt(n, 'second', s, i, `D\xE9river ${f(m)} par rapport \xE0 ${d}`)
        : d !== m && Jl(e, `d1:${d}`)
          ? xt(
              n,
              'second',
              s,
              i,
              `D\xE9river ${f(d)} par rapport \xE0 ${m}`,
              'Une d\xE9riv\xE9e crois\xE9e : l\u2019ordre des d\xE9rivations ne change rien (th\xE9or\xE8me de Schwarz).',
            )
          : wi(
              n,
              s,
              i,
              `Ta ligne est juste. \xC9cris d\u2019abord \xAB ${f(m)} = \u2026 \xBB, puis d\xE9rive-la : tu gagneras des HORA. Tu peux garder cette ligne sans HORA.`,
            );
    }
    case 'grad': {
      if (r.heads.length)
        return xt(
          n,
          'gradient',
          s,
          i,
          'Gradient',
          'Le gradient est le couple des d\xE9riv\xE9es partielles.',
        );
      let d = l([`d1:${u}`, `d1:${c}`], [f(u), f(c)]);
      return d
        ? wi(
            n,
            s,
            i,
            `Ta ligne est juste. \xC9cris d\u2019abord \xAB ${d} = \u2026 \xBB : tu gagneras des HORA. Tu peux garder cette ligne sans HORA.`,
          )
        : xt(n, 'gradient', s, i);
    }
    case 'lap': {
      if (r.heads.length) return xt(n, 'laplacian', s, i);
      let d = l(
        [`d2:${u},${u}`, `d2:${c},${c}`],
        [`\u2202\xB2${a}/\u2202${u}\xB2`, `\u2202\xB2${a}/\u2202${c}\xB2`],
      );
      return d
        ? wi(
            n,
            s,
            i,
            `Ta ligne est juste. \xC9cris d\u2019abord \xAB ${d} = \u2026 \xBB : tu gagneras des HORA. Tu peux garder cette ligne sans HORA.`,
          )
        : xt(n, 'laplacian', s, i);
    }
    case 'cd': {
      let d = o.vars[0];
      return xt(n, 'curve', s, i, `D\xE9river ${d}(${e.curve.t})`);
    }
    case 'g':
      return r.heads.length ? wi(n, s, i) : xt(n, 'compose', s, i);
    case 'g1': {
      let d = e.curve;
      if (r.heads.some((p) => p.kind === 'd1')) return xt(n, 'chain', s, i);
      if (Jl(e, 'g')) return xt(n, 'derive', s, i, `D\xE9river ${d.g}(${d.t})`);
      let m = l(
        [`d1:${u}`, `d1:${c}`, `cd:${u}`, `cd:${c}`],
        [f(u), f(c), `${u}\u2032(${d.t})`, `${c}\u2032(${d.t})`],
      );
      return m
        ? wi(
            n,
            s,
            i,
            `Ta ligne est juste. \xC9cris d\u2019abord \xAB ${m} = \u2026 \xBB : tu gagneras des HORA. Tu peux garder cette ligne sans HORA.`,
          )
        : xt(n, 'chain', s, i);
    }
    case 'g2': {
      let d = e.curve;
      return Jl(e, 'g1')
        ? xt(n, 'derive', s, i, `D\xE9river ${d.g}\u2032(${d.t})`)
        : wi(
            n,
            s,
            i,
            `Ta ligne est juste. \xC9cris d\u2019abord \xAB ${d.g}\u2032(${d.t}) = \u2026 \xBB : tu gagneras des HORA. Tu peux garder cette ligne sans HORA.`,
          );
    }
  }
}
function I6(e, n, t, r, s, i) {
  let o = new Set(s.heads);
  if (t.heads.length < r.heads.length)
    return r.heads.filter((u) => !o.has(u)).filter((u) => !u.startsWith('f') && !Jl(e, u)).length
      ? wi(n, s, i)
      : xt(
          n,
          'substitute',
          s,
          i,
          'Remplacer',
          'On remplace chaque d\xE9riv\xE9e par son expression.',
        );
  if (e.curve && r.vars && !t.hasVars && t.hasT && t.heads.length <= r.heads.length)
    return xt(
      n,
      'substitute',
      s,
      i,
      `Remplacer ${e.vars[0]} et ${e.vars[1]}`,
      `On remplace ${e.vars[0]} et ${e.vars[1]} par leurs expressions en ${e.curve.t}.`,
    );
  if (t.size < r.size) {
    let a = s.heads.includes('f') && !r.heads.includes('f');
    return xt(
      n,
      'compute',
      s,
      i,
      a ? `Reconna\xEEtre ${e.fn}` : 'Calculer',
      a ? `On reconna\xEEt l\u2019expression de ${e.fn}.` : 'Un calcul.',
    );
  }
  return i
    ? xt(n, 'compute', s, i)
    : um(
        n,
        'Juste, mais \xE7a ne t\u2019avance pas',
        'Ta ligne est juste, mais elle n\u2019avance pas le calcul : simplifie, ou \xE9cris l\u2019\xE9tape suivante.',
      );
}
function A6(e, n, t, r, s) {
  let i = t.single,
    o = e.fn,
    [a, l] = e.vars;
  if (s === 'shape')
    return t.couple
      ? Rt(
          n,
          'Le gradient est un couple',
          `Le gradient a deux coordonn\xE9es : \xAB \u2207${o} = (\u2202${o}/\u2202${a}, \u2202${o}/\u2202${l}) \xBB.`,
        )
      : Rt(n, 'Pas un couple', 'Ici, on attend un nombre ou une expression, pas un couple.');
  if (i && i.kind === 'grad' && t.couple && r.couple) {
    let u = SS(e, [t, r]),
      c = As(t.couple[0], u),
      f = As(t.couple[1], u),
      d = As(r.couple[0], u),
      m = As(r.couple[1], u);
    return Wc(c, m) && Wc(f, d)
      ? Rt(
          n,
          'Dans l\u2019ordre',
          `Le gradient s\u2019\xE9crit (\u2202${o}/\u2202${a}, \u2202${o}/\u2202${l}) : la d\xE9riv\xE9e par rapport \xE0 ${a} d\u2019abord.`,
        )
      : Wc(c, d)
        ? Rt(
            n,
            'La seconde coordonn\xE9e',
            `La seconde coordonn\xE9e est \u2202${o}/\u2202${l} : elle ne va pas.`,
          )
        : Rt(
            n,
            'La premi\xE8re coordonn\xE9e',
            `La premi\xE8re coordonn\xE9e est \u2202${o}/\u2202${a} : elle ne va pas.`,
          );
  }
  if (i && !i.pt) {
    let u = (c, f) => {
      let d = yS(e, { key: `${c}:${f.join(',')}`, text: '', kind: c, vars: f });
      return d && !Array.isArray(d) ? d : null;
    };
    if (i.kind === 'd1') {
      let c = i.vars[0],
        f = c === a ? l : a;
      return am(e, r, u('d1', [f]))
        ? Rt(
            n,
            'Pas la bonne variable',
            `Tu as d\xE9riv\xE9 par rapport \xE0 ${f}. Pour \u2202${o}/\u2202${c}, on d\xE9rive par rapport \xE0 ${c} : ${f} est une constante.`,
          )
        : am(e, r, e.F)
          ? Rt(
              n,
              'Tu n\u2019as pas d\xE9riv\xE9',
              `C\u2019est ${o} elle-m\xEAme : d\xE9rive-la par rapport \xE0 ${c}.`,
            )
          : Rt(
              n,
              'Pas la bonne d\xE9riv\xE9e',
              `D\xE9rive par rapport \xE0 ${c} en gardant ${f} constant.`,
            );
    }
    if (i.kind === 'd2') {
      let [c, f] = i.vars;
      return am(e, r, u('d1', [f])) || am(e, r, u('d1', [c]))
        ? Rt(
            n,
            'D\xE9rive deux fois',
            `C\u2019est une d\xE9riv\xE9e premi\xE8re : d\xE9rive-la encore une fois${c === f ? ` par rapport \xE0 ${c}` : ''}.`,
          )
        : c !== f && (am(e, r, u('d2', [c, c])) || am(e, r, u('d2', [f, f])))
          ? Rt(
              n,
              'Une fois par rapport \xE0 chaque variable',
              `\u2202\xB2${o}/\u2202${c}\u2202${f} : on d\xE9rive une fois par rapport \xE0 ${f}, puis une fois par rapport \xE0 ${c}.`,
            )
          : Rt(
              n,
              'Pas la bonne d\xE9riv\xE9e seconde',
              'V\xE9rifie chacune des deux d\xE9rivations.',
            );
    }
    if (i.kind === 'lap')
      return Rt(
        n,
        'Pas le laplacien',
        `\u0394${o} = \u2202\xB2${o}/\u2202${a}\xB2 + \u2202\xB2${o}/\u2202${l}\xB2 : v\xE9rifie les deux d\xE9riv\xE9es secondes.`,
      );
    if (i.kind === 'f')
      return Rt(
        n,
        'Ce n\u2019est pas \xE9gal',
        `Ce n\u2019est pas la fonction ${o} de l\u2019\xE9nonc\xE9.`,
      );
    if (i.kind === 'cd')
      return Rt(
        n,
        'Pas la bonne d\xE9riv\xE9e',
        `D\xE9rive ${i.vars[0]}(${e.curve.t}) par rapport \xE0 ${e.curve.t}.`,
      );
    if (i.kind === 'g')
      return Rt(
        n,
        `Ce n\u2019est pas ${e.curve.g}(${e.curve.t})`,
        `${e.curve.g}(${e.curve.t}) = ${o}(${a}, ${l}) : remplace ${a} et ${l} par leurs expressions en ${e.curve.t}.`,
      );
    if (i.kind === 'g1' && r.heads.some((c) => c.kind === 'd1' || c.kind === 'cd'))
      return Rt(
        n,
        'La r\xE8gle de la cha\xEEne',
        `${e.curve.g}\u2032(${e.curve.t}) = ${a}\u2032(${e.curve.t}) \xD7 \u2202${o}/\u2202${a} + ${l}\u2032(${e.curve.t}) \xD7 \u2202${o}/\u2202${l}.`,
      );
    if (i.kind === 'g1' || i.kind === 'g2')
      return Rt(n, 'Pas la bonne d\xE9riv\xE9e', 'V\xE9rifie ta d\xE9rivation.');
  }
  return i && i.pt
    ? Rt(
        n,
        'Pas la bonne valeur',
        i.kind === 'g' || i.kind === 'g1' || i.kind === 'g2'
          ? `Remplace ${e.curve.t} par ${i.pt[0]}, puis calcule.`
          : `Remplace ${a} et ${l} par les coordonn\xE9es du point, puis calcule.`,
      )
    : Rt(n, 'Ce n\u2019est pas \xE9gal', 'Les deux membres de ta ligne ne sont pas \xE9gaux.');
}
function hO(e, n) {
  let t = n.omove;
  t &&
    (e.written.add(t.text),
    e.lines++,
    e.facts.set(t.key, { size: t.size, heads: t.heads, vars: t.vars }),
    t.final && (e.concluded = !0));
}
function bO(e) {
  return e.concluded;
}
function j6(e, n) {
  try {
    return wS(e, Xl(n, e.spec));
  } catch {
    return null;
  }
}
function vO(e, n) {
  let t = j6(e, n);
  if (!t || t.k !== 'eq') return !1;
  let [r, s] = t.sides;
  return !r.heads.length || TS(e, [r, s]) ? !1 : RS(e, r, s) === 'eq';
}
var F6 = {
    rewrite: 'riemann.rewrite@1',
    reindex: 'riemann.reindex@1',
    logPower: 'riemann.log_power@1',
    logProduct: 'riemann.log_product@1',
    riemann: 'riemann.riemann@1',
    conclude: 'riemann.conclude@1',
    compose: 'riemann.compose@1',
    compute: 'kernel.compute@1',
  },
  cm = {
    rewrite: {
      label: 'Faire appara\xEEtre f(k \xF7 n)',
      hora: 1,
      why: 'On met 1 \xF7 n en facteur et on \xE9crit ce qu\u2019on additionne comme une fonction de k \xF7 n : (1 \xF7 n) \xD7 \u03A3 f(k \xF7 n).',
    },
    reindex: {
      label: 'Changer d\u2019indice',
      hora: 1,
      why: 'On renomme l\u2019indice (j = k \u2212 n\u2026) : les m\xEAmes termes, additionn\xE9s autrement.',
    },
    logPower: {
      label: 'Logarithme d\u2019une puissance',
      hora: 1,
      why: 'ln(a\u1D47) = b \xD7 ln(a).',
    },
    logProduct: {
      label: 'Logarithme d\u2019un produit',
      hora: 1,
      why: 'Le logarithme d\u2019un produit est la somme des logarithmes : le produit devient une somme.',
    },
    riemann: {
      label: 'Somme de Riemann',
      hora: 2,
      why: 'Si f est continue sur [a ; b], (1 \xF7 n) \xD7 \u03A3 f(k \xF7 n), pour k \xF7 n allant de a \xE0 b, tend vers \u222B(a ; b) f(x) dx.',
    },
    conclude: {
      label: 'Conclure',
      hora: 1,
      why: 'La suite tend vers l\u2019int\xE9grale, et l\u2019int\xE9grale est calcul\xE9e.',
    },
    compose: {
      label: 'Composer par exp',
      hora: 1,
      why: 'exp est continue : si ln(u\u2099) tend vers \u2113, u\u2099 = exp(ln(u\u2099)) tend vers exp(\u2113).',
    },
    compute: { label: 'Calculer', hora: 1, why: 'On calcule la valeur de la limite.' },
  },
  V6 = 'Sommes de Riemann',
  Xc = '\u2192',
  wo = class extends Error {},
  _O = /^([ΣΠ])\(([a-z]) = (.+) ; (.+)\)$/,
  D6 = /^([uv])(′?)\(([a-zθ])\)$/,
  dm = (e) => !!e && _O.test(e);
function kO(e) {
  return ot(ne(Te(e.trim())))
    .replace(/\//g, ' \xF7 ')
    .replace(/\s*÷\s*/g, ' \xF7 ')
    .replace(/(\d) × (?=[a-zα-ω])/g, '$1')
    .replace(/\s+/g, ' ')
    .trim();
}
function B6(e, n, t, r) {
  return `${e}(${n} = ${kO(t)} ; ${kO(r)})`;
}
function z6(e, n) {
  let t = 0;
  for (let r = n; r < e.length; r++) {
    let s = e[r];
    if (s === '(') t++;
    else if (s === ')' && (t--, t === 0)) return { inner: e.slice(n + 1, r), end: r + 1 };
  }
  return null;
}
function U6(e) {
  let n = 0;
  for (let t = 0; t < e.length; t++) {
    let r = e[t];
    if (r === '(') n++;
    else if (r === ')') n--;
    else if (r === ';' && n === 0) return [e.slice(0, t), e.slice(t + 1)];
  }
  return null;
}
var CS = (e) => ff(e) || e === ')' || e === '\xB2' || Ds(e) || e === '!' || Ea(e),
  xO = (e) => jt(e) || Xt(e) || Dr(e) || e === '(' || e === '\u221A' || yt(e);
function qS(e) {
  let n = [],
    t = [];
  return (
    e.forEach((r, s) => {
      let i = n[n.length - 1];
      if (i !== void 0 && i !== '\xD7') {
        let o = Qr(i) || i === '[' || dm(i),
          a = yi(i) || Fr(i),
          l = !1;
        (Qr(r) || r === '[' || dm(r)
          ? (l = !o && (a || CS(i)))
          : yi(r) || Fr(r)
            ? (l = !1)
            : a
              ? (l = xO(r) || yt(r))
              : o || (l = CS(i) && xO(r) && !yt(r)),
          l && (n.push('\xD7'), t.push(s)));
      }
      (n.push(r), t.push(s));
    }),
    { atoms: n, src: t }
  );
}
function js(e) {
  let n = String(e).replace(/->/g, Xc),
    t = [],
    r = '',
    s = () => {
      (r.trim() && t.push(...pa(r)), (r = ''));
    };
  for (let i = 0; i < n.length; ) {
    let o = n[i];
    if ((o === '\u03A3' || o === '\u03A0') && n[i + 1] === '(') {
      let a = z6(n, i + 1),
        l = a && U6(a.inner),
        u = l && /^\s*([a-z])\s*=\s*(.+)$/.exec(l[0]);
      if (a && l && u) {
        (s(), t.push(B6(o, u[1], u[2], l[1])), (i = a.end));
        continue;
      }
    }
    if (o === Xc) {
      (s(), t.push(Xc), i++);
      continue;
    }
    ((r += o), i++);
  }
  return (s(), qS(t).atoms);
}
function So(e) {
  let n = (i) => {
      let o = [],
        a = [],
        l = () => {
          (a.length && o.push(Is(a)), (a = []));
        };
      for (let u of i) dm(u) ? (l(), o.push(u)) : a.push(u);
      return (l(), o.join(' ').replace(/\s+/g, ' ').trim());
    },
    t = e.indexOf(Xc);
  if (t < 0) return n(e);
  let r = n(e.slice(0, t)),
    s = n(e.slice(t + 1));
  return `${r ? r + ' ' : ''}${Xc}${s ? ' ' + s : ''}`;
}
var Vg = (e) => ({ dis: [{ sides: [{ k: 's', n: So(e) }] }] }),
  yO = (e) => e.map((n) => ({ atoms: [n], text: n }));
function G6(e) {
  return Vg(js(e));
}
var Z6 = { k: 'fn', f: 'exp', a: { k: 'num', v: { n: 1n, d: 1n } } };
function Ig(e) {
  switch (e.k) {
    case 'sym':
      return e.n === 'e' ? Z6 : e;
    case 'add':
    case 'mul':
      return { ...e, c: e.c.map(Ig) };
    case 'div':
    case 'pow':
    case 'binom':
      return { ...e, a: Ig(e.a), b: Ig(e.b) };
    case 'fn':
      return { ...e, a: Ig(e.a) };
    default:
      return e;
  }
}
function Ag(e) {
  if (!e.length) return null;
  try {
    let n = ie(ot(e));
    return n.ok && n.s.k === 'expr' ? Ig(n.s.e) : null;
  } catch {
    return null;
  }
}
function Vk(e) {
  try {
    return Ag(ne(Te(e)));
  } catch {
    return null;
  }
}
var mm = (e) => {
    try {
      return E(R(e));
    } catch {
      return E(e);
    }
  },
  LS = (e) => {
    try {
      return nl(e);
    } catch {
      return E(e);
    }
  },
  Dk = (e) => {
    try {
      return Yf(e);
    } catch {
      return 99;
    }
  };
function Fn(e, n = {}) {
  try {
    let t = Nf(() => D(e, n));
    return Number.isFinite(t) ? t : NaN;
  } catch {
    return NaN;
  }
}
var Jn = (e, n, t = 1e-9) =>
    Number.isFinite(e) &&
    Number.isFinite(n) &&
    Math.abs(e - n) <= t * Math.max(1, Math.abs(e), Math.abs(n)),
  jg = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 15, 20, 24];
function H6(e, n) {
  let t = Fn(e.lo, { n }),
    r = Fn(e.hi, { n }),
    s = Math.round(t),
    i = Math.round(r);
  if (!Number.isFinite(t) || !Number.isFinite(r)) return NaN;
  if (Math.abs(t - s) > 1e-9 || Math.abs(r - i) > 1e-9 || i - s > 2e4) return NaN;
  let o = e.sign === '\u03A3' ? 0 : 1;
  for (let a = s; a <= i; a++) {
    let l = Fn(e.body, { [e.k]: a, n });
    if (!Number.isFinite(l)) return NaN;
    o = e.sign === '\u03A3' ? o + l : o * l;
  }
  return o;
}
function Uk(e, n, t = {}) {
  let r = { n, ...t };
  for (let [s, i] of e.sums) {
    let o = H6(i, n);
    if (!Number.isFinite(o)) return NaN;
    r[s] = o;
  }
  return Fn(e.outer, r);
}
function NS(e, n) {
  let t = 0;
  for (let r of jg) {
    let s = e(r),
      i = n(r);
    if (!(Number.isNaN(s) && Number.isNaN(i))) {
      if (!Jn(s, i)) return !1;
      t++;
    }
  }
  return t >= 6;
}
var it = (e, n, t) => ({ k: 'syntax', title: e, message: n, index: t }),
  wO = 0,
  SO = (e) =>
    String(e)
      .split('')
      .map((n) => '\u2080\u2081\u2082\u2083\u2084\u2085\u2086\u2087\u2088\u2089'[Number(n)])
      .join('');
function pm(e, n) {
  let t = new Map(),
    r = new Map(),
    s = [],
    i = [];
  for (let f = 0; f < e.length; f++) {
    let d = e[f];
    if (dm(d)) {
      let m = f + 1,
        p = 0;
      for (; m < e.length; m++) {
        let _ = e[m];
        if (_ === '(') p++;
        else if (_ === ')') {
          if (p === 0) break;
          p--;
        } else if (p === 0 && (_ === '=' || ((_ === '+' || _ === '\u2212') && m > f + 1))) break;
        if (dm(_) || Qr(_) || _ === '[')
          return it(
            'Une somme \xE0 la fois',
            'Ce qu\u2019on additionne ne contient ni autre somme, ni int\xE9grale.',
            n + m,
          );
      }
      let g = e.slice(f + 1, m);
      if (!g.length)
        return m >= e.length
          ? { k: 'incomplete' }
          : it(
              'Ce qu\u2019on additionne',
              'Apr\xE8s \xAB \u03A3(k = 1 ; n) \xBB, \xE9cris le terme de la somme.',
              n + f,
            );
      let h = vn(ne(g));
      if (!h.ok)
        return it('\xC7a commence mal', h.msg, n + f + 1 + Math.min(h.index, g.length - 1));
      if (!h.complete)
        return m >= e.length
          ? { k: 'incomplete' }
          : it('\xC7a ne se lit pas', 'Le terme de la somme n\u2019est pas fini.', n + m);
      let b = Ag(ne(g)),
        v = _O.exec(d),
        k = Vk(v[3]),
        y = Vk(v[4]);
      if (!b || !k || !y)
        return it('\xC7a ne se lit pas', 'V\xE9rifie les parenth\xE8ses.', n + m - 1);
      let S = v[2];
      if (S === 'n')
        return it(
          'L\u2019indice',
          'L\u2019indice de la somme n\u2019est pas n : \xE9cris \xAB \u03A3(k = 1 ; n) \xBB.',
          n + f,
        );
      if ([...$(b)].some((_) => _ !== S && _ !== 'n' && _ !== '\u03C0'))
        return it(
          'Une lettre en trop',
          `Le terme de la somme ne d\xE9pend que de ${S} et de n.`,
          n + m - 1,
        );
      if ([...$(k), ...$(y)].some((_) => _ !== 'n'))
        return it('Les bornes', 'Les bornes de la somme ne d\xE9pendent que de n.', n + f);
      let w = `\u03C3${SO(++wO)}`;
      (t.set(w, {
        sign: v[1],
        k: S,
        lo: k,
        hi: y,
        body: b,
        key: `${v[1]}|${mm(k)}|${mm(y)}|${mm(j(b, { [S]: { k: 'sym', n: '\u03BA' } }))}`,
      }),
        s.push(w),
        i.push(f),
        (f = m - 1));
      continue;
    }
    if (Qr(d)) {
      let m = f + 1;
      for (; m < e.length && !Fr(e[m]); ) {
        if (Qr(e[m]) || dm(e[m]) || e[m] === '[')
          return it(
            'Ferme l\u2019int\xE9grale',
            'Une int\xE9grale se ferme par \xAB dx \xBB avant d\u2019\xE9crire autre chose.',
            n + m,
          );
        m++;
      }
      if (m >= e.length) return { k: 'incomplete' };
      let p = e
        .slice(f + 1, m)
        .filter((w, _, O) => !(w === '\xD7' && (_ === 0 || _ === O.length - 1)));
      if (!p.length)
        return it(
          'La fonction \xE0 int\xE9grer',
          '\xC9cris la fonction entre \u222B et dx.',
          n + m,
        );
      let g = vn(ne(p));
      if (!g.ok)
        return it('\xC7a commence mal', g.msg, n + f + 1 + Math.min(g.index, p.length - 1));
      if (!g.complete) return it('\xC7a ne se lit pas', 'La fonction n\u2019est pas finie.', n + m);
      let h = Ag(ne(p)),
        b = /^∫\((.+) ; (.+)\)$/.exec(d),
        v = Vk(b[1]),
        k = Vk(b[2]),
        y = /^d([a-zθ])$/.exec(e[m])[1];
      if (!h || !v || !k) return it('\xC7a ne se lit pas', 'V\xE9rifie les parenth\xE8ses.', n + m);
      if (y === 'n' || y === 'k')
        return it(
          'La variable',
          'Dans l\u2019int\xE9grale, la variable n\u2019est ni n ni l\u2019indice : \xE9cris \xAB dx \xBB et une fonction de x.',
          n + m,
        );
      if ([...$(h)].some((w) => w !== y && w !== '\u03C0'))
        return it(
          'Une lettre en trop',
          `La fonction \xE0 int\xE9grer ne d\xE9pend que de ${y} : remplace k \xF7 n par ${y}.`,
          n + m - 1,
        );
      if ([...$(v), ...$(k)].some((w) => w !== '\u03C0'))
        return it('Les bornes', 'Les bornes de l\u2019int\xE9grale sont des nombres.', n + f);
      let S = `\u03C6${SO(++wO)}`;
      (r.set(S, { lo: v, hi: k, a: Fn(v), b: Fn(k), x: y, body: h, text: Is(e.slice(f, m + 1)) }),
        s.push(S),
        i.push(f),
        (f = m));
      continue;
    }
    if (d === '[' || yi(d))
      return it(
        'Un crochet \xE0 part',
        'Calcule l\u2019int\xE9grale sur sa propre ligne : \xAB \u222B(a ; b) \u2026 dx = [ \u2026 ](a ; b) \xBB.',
        n + f,
      );
    if (Fr(d))
      return it(
        '\xAB dx \xBB ferme une int\xE9grale',
        '\xC9cris d\u2019abord \xAB \u222B(a ; b) \xBB, puis la fonction.',
        n + f,
      );
    (s.push(d), i.push(f));
  }
  let o = ne(s);
  if (!o.length) return { k: 'incomplete' };
  let a = vn(o, { chains: !0 });
  if (!a.ok) return it('\xC7a commence mal', a.msg, n + (i[Math.min(a.index, i.length - 1)] ?? 0));
  if (!a.complete) return { k: 'incomplete' };
  let l = [[]],
    u = 0;
  for (let f of o)
    (f === '(' && u++,
      f === ')' && u--,
      u === 0 && f === '=' ? l.push([]) : l[l.length - 1].push(f));
  let c = [];
  for (let f of l) {
    if (!f.length) return { k: 'incomplete' };
    let d = Ag(f);
    if (!d)
      return it(
        '\xC7a ne se lit pas',
        'Un membre ne se lit pas : v\xE9rifie les parenth\xE8ses.',
        n + e.length - 1,
      );
    let m = $(d),
      p = new Map([...t].filter(([h]) => m.has(h))),
      g = new Map([...r].filter(([h]) => m.has(h)));
    c.push({ outer: d, sums: p, ints: g, wkey: qO(d, p, g) });
  }
  return { k: 'ok', members: c };
}
function qO(e, n, t) {
  let r = {};
  for (let [s, i] of n) r[s] = { k: 'sym', n: `\xAB${i.key}\xBB` };
  for (let [s, i] of t) r[s] = { k: 'sym', n: `\xAB${i.text}\xBB` };
  return LS(j(e, r));
}
function LO(e) {
  if (!e.length) return { k: 'empty' };
  let n = e.map((r, s) => (r === Xc ? s : -1)).filter((r) => r >= 0);
  if (n.length > 1)
    return it(
      'Une limite par ligne',
      '\xC9cris une seule fl\xE8che \xAB \u2192 \xBB par ligne.',
      n[1],
    );
  if (n.length === 1) {
    let r = n[0],
      s = e.slice(0, r),
      i = e.slice(r + 1);
    if (!s.length)
      return it(
        'La suite',
        'Avant \xAB \u2192 \xBB, \xE9cris la suite (\xAB S\u2099 \u2192 \u2026 \xBB).',
        r,
      );
    if (s.includes('=') || i.includes('='))
      return it(
        'Une relation par ligne',
        'Une ligne est une \xE9galit\xE9, ou une limite \xAB S\u2099 \u2192 \u2026 \xBB, pas les deux.',
        r,
      );
    let o = pm(s, 0);
    if (o.k !== 'ok') return o;
    if (!i.length) return { k: 'incomplete' };
    let a = pm(i, r + 1);
    return a.k !== 'ok' ? a : { k: 'lim', left: o.members[0], right: a.members[0] };
  }
  let t = pm(e, 0);
  return t.k !== 'ok' ? t : t.members.length < 2 ? { k: 'noeq' } : { k: 'eq', members: t.members };
}
function hm(e, n) {
  let t = (r) => $(r).has(n);
  if (!t(e)) return null;
  switch (e.k) {
    case 'sym':
      return e.n === n ? T(1) : null;
    case 'mul': {
      let r = e.c.filter(t);
      if (r.length !== 1) return null;
      let s = hm(r[0], n);
      if (!s) return null;
      let i = e.c.filter((o) => !t(o));
      return i.length ? { k: 'mul', c: [...i, s] } : s;
    }
    case 'div': {
      if (t(e.b)) return null;
      let r = hm(e.a, n);
      return r ? { k: 'div', a: r, b: e.b } : null;
    }
    default:
      return null;
  }
}
function NO(e) {
  let n = (s) => {
      let i = Fn(s, { n: 1 }),
        o = Fn(s, { n: 2 });
      if (!Number.isFinite(i) || !Number.isFinite(o)) return null;
      let a = o - i,
        l = i - a;
      if (Math.abs(a - Math.round(a)) > 1e-9 || Math.abs(l - Math.round(l)) > 1e-9) return null;
      for (let u of jg) if (!Jn(Fn(s, { n: u }), a * u + l)) return null;
      return { s: Math.round(a), c: Math.round(l) };
    },
    t = n(e.lo),
    r = n(e.hi);
  return !t || !r || r.s <= t.s || t.s < 0 ? null : { A: t.s, B: r.s };
}
var W6 = [0.061, 0.137, 0.229, 0.318, 0.411, 0.503, 0.597, 0.689, 0.773, 0.857, 0.941],
  OO = (e, n) => W6.map((t) => e + t * (n - e));
function ES(e, n, t, r, s) {
  let i = (a, l) => s(l) * Fn(e, { [n]: a * l, n: l }),
    o = 0;
  for (let a of OO(t, r)) {
    let l = i(a, 19);
    for (let u of [7, 53, 211]) {
      let c = i(a, u);
      if (!(Number.isNaN(l) && Number.isNaN(c)) && !Jn(c, l, 1e-8)) return null;
    }
    Number.isFinite(l) && o++;
  }
  return o < 6 ? null : (a) => i(a, 19);
}
function J6(e) {
  let n = (r) => r.k === 'sym' && r.n === 'n',
    t = (r) => r.k === 'div' && r.a.k === 'num' && r.a.v.n === 1n && r.a.v.d === 1n && n(r.b);
  if (e.k === 'div' && n(e.b)) return e.a;
  if (e.k === 'mul') {
    let r = e.c.findIndex(t);
    if (r >= 0) {
      let s = e.c.filter((i, o) => o !== r);
      return s.length === 1 ? s[0] : { k: 'mul', c: s };
    }
  }
  return null;
}
function Bk(e) {
  if (e.sums.size !== 1 || e.ints.size) return null;
  let [n, t] = [...e.sums][0];
  if (t.sign !== '\u03A3') return null;
  let r = hm(e.outer, n);
  if (!r || [...$(r)].some((u) => u !== 'n' && u !== '\u03C0')) return null;
  let s = NO(t);
  if (!s) return null;
  let { A: i, B: o } = s,
    a = [3, 7, 20].map((u) => Fn(r, { n: u }) * u);
  if (a.every((u) => Jn(u, a[0])) && !Jn(a[0], 0)) {
    let u = ES(t.body, t.k, i, o, () => 1);
    return u ? { lambda: a[0], a: i, b: o, g: u } : null;
  }
  let l = [3, 7, 20].map((u) => Fn(r, { n: u }));
  if (l.every((u) => Jn(u, l[0])) && !Jn(l[0], 0)) {
    let u = J6(t.body);
    if (!u) return null;
    let c = ES(u, t.k, i, o, () => 1);
    return c ? { lambda: l[0], a: i, b: o, g: c } : null;
  }
  return null;
}
function KO(e) {
  if (e.sums.size !== 1 || e.ints.size) return null;
  let [n, t] = [...e.sums][0];
  if (t.sign !== '\u03A3') return null;
  let r = hm(e.outer, n);
  if (!r || [...$(r)].some((o) => o !== 'n' && o !== '\u03C0')) return null;
  let s = NO(t);
  if (!s) return null;
  let i = ES(t.body, t.k, s.A, s.B, (o) => o * Fn(r, { n: o }));
  return i ? { lambda: 1, a: s.A, b: s.B, g: i } : null;
}
var TO = (e) => [...e.sums.values()].filter((n) => n.sign === '\u03A0').length,
  Pg = (e) => [...e.sums.values()].filter((n) => n.sign === '\u03A3').length;
function $S(e) {
  let n = new Set([...e.sums].filter(([, s]) => s.sign === '\u03A0').map(([s]) => s)),
    t = !1,
    r = (s) => {
      t ||
        (s.k === 'fn'
          ? (s.f === 'ln' && s.a.k === 'pow' && [...$(s.a.a)].some((i) => n.has(i)) && (t = !0),
            r(s.a))
          : s.k === 'add' || s.k === 'mul'
            ? s.c.forEach(r)
            : (s.k === 'div' || s.k === 'pow' || s.k === 'binom') && (r(s.a), r(s.b)));
    };
  return (r(e.outer), t);
}
var RO = (e) =>
  [...e.sums.values()]
    .filter((n) => n.sign === '\u03A3')
    .map((n) => `${mm(n.lo)}|${mm(n.hi)}`)
    .sort()
    .join(',');
function $O(e, n) {
  if (e.wkey === n.wkey) return { k: 'same' };
  let t = [],
    r = TO(e) > TO(n) && Pg(n) > Pg(e);
  return (
    r ? ($S(e) && t.push('logPower'), t.push('logProduct')) : $S(e) && !$S(n) && t.push('logPower'),
    Pg(e) && Pg(n) && RO(e) !== RO(n) && t.push('reindex'),
    Pg(e) && !r && !Bk(e) && Bk(n) && t.push('rewrite'),
    t.length ? { k: 'step', steps: t } : { k: 'flat' }
  );
}
var gm = (e) => {
    if (!Number.isFinite(e)) return '?';
    let n = Math.round(e * 1e4) / 1e4;
    return String(n).replace('.', ',').replace('-', '\u2212');
  },
  Yc = (e) => mm(e);
function X6(e) {
  let n = e.kernel,
    t = n.goal.target,
    r = js(n.start);
  if (r[0] !== t || r[1] !== '=')
    throw new wo(`Le d\xE9part s\u2019\xE9crit \xAB ${t} = \u03A3(k = 1 ; n) \u2026 \xBB.`);
  let s = pm(r.slice(2), 2);
  if (s.k !== 'ok' || s.members.length !== 1)
    throw new wo(`D\xE9part illisible : \xAB ${n.start} \xBB.`);
  let i = s.members[0];
  if (!i.sums.size || i.ints.size)
    throw new wo('Le d\xE9part est une somme (ou un produit), sans int\xE9grale.');
  if ([...$(i.outer)].some((u) => u !== 'n' && u !== '\u03C0' && !i.sums.has(u)))
    throw new wo('Le d\xE9part ne d\xE9pend que de n.');
  let o = js(n.answer),
    a = o.indexOf(Xc);
  if (a < 0 || o[0] !== t || a !== 1)
    throw new wo(`La r\xE9ponse s\u2019\xE9crit \xAB ${t} \u2192 valeur \xBB.`);
  let l = Ag(o.slice(a + 1));
  if (!l || [...$(l)].some((u) => u !== '\u03C0'))
    throw new wo('La r\xE9ponse est une valeur (des nombres, e, \u03C0, ln\u2026).');
  return { X: t, start: i, answer: l };
}
function PO(e) {
  let n = e.kernel,
    t = X6(e),
    r = { k: 'sym', n: t.X },
    s = {
      model: e,
      X: t.X,
      start: t.start,
      startText: So(js(n.start)),
      answer: t.answer,
      answerValue: Fn(t.answer),
      answerOps: Dk(t.answer),
      forms: new Map([[Yc(r), { subject: r, forms: [t.start] }]]),
      lims: new Map(),
      subs: [],
      written: new Set(),
      givenTexts: new Set(),
      path: n.path ?? [],
      intPath: [],
      traps: [],
      lines: 0,
      concluded: !1,
    };
  if (!Number.isFinite(s.answerValue)) throw new wo('La r\xE9ponse n\u2019a pas de valeur.');
  return (
    (s.givenTexts = new Set(Y6(e).map((i) => So(js(i))))),
    (s.intPath = s.path.filter((i) => IS(js(i)))),
    (s.traps = (e.traps ?? []).map((i) => ({
      text: So(js(i.line)),
      line: G6(i.line),
      title: i.title ?? 'Attention',
      why: i.why,
    }))),
    s
  );
}
function Y6(e) {
  return [e.kernel.start, ...(e.givens ?? [])];
}
var eW = (e, n) => Uk(e.start, n);
function Dg(e, n, t) {
  let r = eW(e, t);
  return Number.isFinite(r) ? Fn(n, { [e.X]: r, n: t }) : NaN;
}
var OS = (e, n) => Fn(n, { [e.X]: e.answerValue });
function zk(e, n) {
  if (n.sums.size || n.ints.size) return !1;
  let t = $(n.outer);
  return t.has(e.X) && [...t].every((r) => r === e.X || r === '\u03C0');
}
function KS(e, n) {
  let t = e.forms.get(Yc(n));
  if (t) return [...t.forms].reverse();
  let r = [],
    s = e.forms.get(Yc({ k: 'sym', n: e.X }));
  for (let i of [...s.forms].reverse()) {
    let o = j(n, { [e.X]: i.outer });
    r.push({ outer: o, sums: i.sums, ints: i.ints, wkey: qO(o, i.sums, i.ints) });
  }
  return r;
}
function Qg(e, n, t, r) {
  let s = [...new Set(n)],
    i = s.reduce((u, c) => u + cm[c].hora, 0),
    o = s[0];
  for (let u of s) cm[u].hora > cm[o].hora && (o = u);
  let a =
      s.includes('logPower') && s.includes('logProduct')
        ? [
            'Passer au logarithme',
            ...s.filter((u) => u !== 'logPower' && u !== 'logProduct').map((u) => cm[u].label),
          ].join(' \u2192 ')
        : s.map((u) => cm[u].label).join(' \u2192 '),
    l = s.map((u) => cm[u].why).join(' ') + (r ? ' C\u2019est la r\xE9ponse.' : '');
  return {
    kind: 'step',
    ...e,
    hora: i,
    final: r,
    rule: { id: F6[o], card: V6, label: a, hora: i, why: l },
    rmove: t,
  };
}
function fm(e, n, t, r) {
  return {
    kind: 'useless',
    ...e,
    jump: !0,
    final: t,
    title: t ? 'Juste !' : 'Juste, mais tu sautes des \xE9tapes',
    message:
      r ??
      (t
        ? 'C\u2019est la bonne limite. D\xE9taille ton calcul, une \xE9tape par ligne, pour gagner des HORA. Tu peux garder cette ligne sans HORA.'
        : 'Ta ligne est juste. D\xE9taille-la, une \xE9tape \xE0 la fois, pour gagner des HORA. Tu peux la garder sans HORA.'),
    ...(n ? { rmove: n } : {}),
  };
}
function Jc(e, n, t) {
  let r = So(n.atoms),
    s = e.traps.find((i) => i.text === r);
  return s
    ? {
        kind: 'trap',
        ...n,
        title: s.title,
        message: s.why,
        trap: { line: s.line, title: s.title, why: s.why },
      }
    : { kind: 'false', ...n, ...t };
}
function PS(e, n) {
  return n.k === 'sym' ? n.n : `cette expression de ${e.X}`;
}
function nW(e, n, t) {
  let r = (a) => Dg(e, n, a),
    s = (a) => Uk(t, a),
    i = jg.map((a) => s(a) / r(a)).filter((a) => Number.isFinite(a)),
    o = PS(e, n);
  if (i.length >= 6) {
    let a = jg.map((u) => s(u) / r(u) / u).filter((u) => Number.isFinite(u)),
      l = jg.map((u) => (s(u) / r(u)) * u).filter((u) => Number.isFinite(u));
    if (a.length >= 6 && a.every((u) => Jn(u, 1, 1e-7)))
      return {
        title: 'Un facteur n de trop',
        message: `Ton \xE9criture vaut n fois ${o} : il y a un facteur n de trop.`,
      };
    if (l.length >= 6 && l.every((u) => Jn(u, 1, 1e-7)))
      return {
        title: 'Il manque un facteur n',
        message: `Ton \xE9criture vaut ${o} \xF7 n : il manque un facteur n (si tu sors 1 \xF7 n de la somme, multiplie ce qu\u2019il reste par n).`,
      };
    if (i.every((u) => Jn(u, i[0], 1e-7)) && !Jn(i[0], 1))
      return {
        title: 'Un facteur ne va pas',
        message: `Ton \xE9criture vaut ${gm(i[0])} fois ${o}.`,
      };
  }
  return {
    title: 'Ce n\u2019est pas \xE9gal',
    message: `Pour n = 3, ${o} vaut ${gm(r(3))} et ton \xE9criture ${gm(s(3))}.`,
  };
}
function tW(e, n, t) {
  let r = So(n.atoms);
  if (e.givenTexts.has(r))
    return {
      kind: 'useless',
      ...n,
      title: 'C\u2019est l\u2019\xE9nonc\xE9',
      message: 'Cette ligne est d\xE9j\xE0 dans l\u2019\xE9nonc\xE9.',
    };
  let s = t[0];
  if (!zk(e, s))
    return {
      kind: 'unjustified',
      ...n,
      title: `Pars de ${e.X}`,
      message: `\xC9cris \xAB ${e.X} = \u2026 \xBB (ou \xAB ln(${e.X}) = \u2026 \xBB).`,
    };
  let i = s.outer;
  for (let f of t.slice(1)) {
    if (f.ints.size)
      return {
        kind: 'false',
        ...n,
        title: 'Une limite, pas une \xE9galit\xE9',
        message: `${PS(e, i)} n\u2019est pas \xE9gale \xE0 une int\xE9grale : elle tend vers elle. \xC9cris \xAB ${e.X} \u2192 \u222B(\u2026) \u2026 dx \xBB.`,
      };
    if ($(f.outer).has(e.X))
      return {
        kind: 'unjustified',
        ...n,
        title: 'Une \xE9criture de la suite',
        message: `\xC0 droite du \xAB = \xBB, \xE9cris la suite avec n (une somme, un produit), sans ${e.X}.`,
      };
    if ([...$(f.outer)].some((d) => d !== 'n' && d !== '\u03C0' && !f.sums.has(d)))
      return {
        kind: 'syntax',
        ...n,
        title: 'Une lettre en trop',
        message: 'Hors de la somme, l\u2019\xE9criture ne d\xE9pend que de n.',
      };
  }
  for (let f = 1; f < t.length; f++) {
    let d = t[f];
    if (
      !NS(
        (m) => Dg(e, i, m),
        (m) => Uk(d, m),
      )
    )
      return Jc(e, n, nW(e, i, d));
  }
  let a = { k: 'eq', skey: Yc(i), subject: i, forms: t.slice(1), text: r },
    l = [],
    u = 0,
    c = 0;
  for (let f = 1; f < t.length; f++) {
    let d = t[f],
      m = null;
    if (f === 1)
      for (let p of KS(e, i)) {
        let g = $O(p, d);
        if (g.k === 'step') {
          m = g;
          break;
        }
        (!m || g.k === 'same') && (m = g);
      }
    else m = $O(t[f - 1], d);
    m && (m.k === 'step' ? l.push(...m.steps) : m.k === 'same' ? u++ : c++);
  }
  return l.length
    ? Qg(n, l, a, !1)
    : {
        kind: 'useless',
        ...n,
        title: u && !c ? 'Rien de nouveau' : 'Juste, mais \xE7a ne t\u2019avance pas',
        message:
          u && !c
            ? 'Cette \xE9criture est d\xE9j\xE0 sur ta feuille.'
            : 'Les deux \xE9critures sont \xE9gales, mais le calcul n\u2019avance pas : vise (1 \xF7 n) \xD7 \u03A3 f(k \xF7 n).',
        rmove: a,
      };
}
function Fg(e, n, t) {
  let r = Jn(e.a, t.a) && Jn(e.b, t.b),
    s = (l) => n * Fn(e.body, { [e.x]: l }),
    i = OO(t.a, t.b),
    a = ((l) => {
      let u = 0;
      for (let c of i) {
        let f = l(c),
          d = t.lambda * t.g(c);
        if (!(Number.isNaN(f) && Number.isNaN(d))) {
          if (!Jn(f, d, 1e-8)) return !1;
          u++;
        }
      }
      return u >= 6;
    })(s);
  if (r && a) return 'yes';
  if (a) return 'bounds';
  if (r) {
    let l = i.map((u) => s(u) / (t.lambda * t.g(u))).filter((u) => Number.isFinite(u));
    return l.length >= 6 && l.every((u) => Jn(u, l[0], 1e-8)) ? 'coef' : 'fn';
  }
  return 'no';
}
function rW(e) {
  return `k \xF7 n va de ${gm(e.a)} \xE0 ${gm(e.b)}`;
}
function sW(e, n, t, r) {
  let s = So(n.atoms);
  if (r.ints.size !== 1 || r.sums.size)
    return {
      kind: 'syntax',
      ...n,
      title: 'Une int\xE9grale',
      message:
        '\xC0 droite de la fl\xE8che, \xE9cris une int\xE9grale (\xE9ventuellement multipli\xE9e par un nombre).',
    };
  let [i, o] = [...r.ints][0],
    a = hm(r.outer, i);
  if (!a || [...$(a)].some((h) => h !== '\u03C0'))
    return {
      kind: 'syntax',
      ...n,
      title: 'Une int\xE9grale',
      message:
        'L\u2019int\xE9grale se multiplie par un nombre ; elle ne se met pas dans une fonction.',
    };
  let l = Fn(a),
    u = l * _g((h) => Fn(o.body, { [o.x]: h }), o.a, o.b),
    c = OS(e, t),
    f = KS(e, t),
    d = f.map(Bk).filter((h) => !!h),
    m = f.map(KO).filter((h) => !!h);
  if (!Jn(u, c, 1e-7)) {
    for (let h of [...d, ...m]) {
      let b = Fg(o, l, h);
      if (b === 'bounds')
        return Jc(e, n, {
          title: 'Les bornes',
          message: `La fonction est la bonne, pas les bornes : ${rW(h)}.`,
        });
      if (b === 'fn')
        return Jc(e, n, {
          title: 'Pas la bonne fonction',
          message:
            'Les bornes vont ; pour la fonction, remplace k \xF7 n par x dans ce qu\u2019on additionne.',
        });
      if (b === 'coef')
        return Jc(e, n, {
          title: 'Le coefficient',
          message:
            'La fonction et les bornes vont, pas le nombre devant : regarde le facteur devant la somme.',
        });
    }
    return Jc(e, n, {
      title: 'Ce n\u2019est pas la limite',
      message: d.length
        ? 'Remplace k \xF7 n par x dans ce qu\u2019on additionne, et regarde les valeurs de k \xF7 n pour les bornes.'
        : 'Fais d\u2019abord appara\xEEtre une somme de Riemann : (1 \xF7 n) \xD7 \u03A3 f(k \xF7 n).',
    });
  }
  let p = { k: 'riem', skey: Yc(t), subject: t, value: u, int: o.text, coef: l, text: s };
  return e.lims.get(Yc(t))?.ints.some((h) => e.subs[h.sub]?.text === o.text && Jn(h.coef, l))
    ? {
        kind: 'useless',
        ...n,
        title: 'Rien de nouveau',
        message: 'Cette limite est d\xE9j\xE0 sur ta feuille.',
      }
    : d.some((h) => Fg(o, l, h) === 'yes')
      ? Qg(n, ['riemann'], p, !1)
      : m.some((h) => Fg(o, l, h) === 'yes')
        ? fm(
            n,
            p,
            !1,
            `Juste, mais fais d\u2019abord appara\xEEtre la somme de Riemann : \xE9cris \xAB ${e.X} = (1 \xF7 n) \xD7 \u03A3\u2026 \xBB avec ce qu\u2019on additionne fonction de k \xF7 n.`,
          )
        : fm(
            n,
            p,
            !1,
            'Juste, mais \xE9cris l\u2019int\xE9grale qui vient de la somme : remplace k \xF7 n par x.',
          );
}
function iW(e, n, t, r) {
  let s = So(n.atoms);
  if (r.sums.size || $(r.outer).has('n') || $(r.outer).has(e.X))
    return {
      kind: 'false',
      ...n,
      title: 'Une limite ne d\xE9pend pas de n',
      message: '\xC0 droite de la fl\xE8che, \xE9cris un nombre (ou une int\xE9grale), sans n.',
    };
  let i = r.outer,
    o = Fn(i),
    a = OS(e, t),
    l = Yc(t),
    c = t.k === 'sym' && t.n === e.X && Jn(o, e.answerValue) && Dk(i) <= e.answerOps;
  if (!Jn(o, a, 1e-9)) {
    let m = e.lims.get(l);
    if (m?.ints.length) {
      let p = m.ints[0],
        g = e.subs[p.sub]?.value ?? NaN;
      if (Jn(o, g) && !Jn(p.coef, 1))
        return Jc(e, n, {
          title: 'Le coefficient',
          message: `${PS(e, t)} tend vers ${gm(p.coef)} fois l\u2019int\xE9grale : n\u2019oublie pas le nombre devant.`,
        });
    }
    return Jc(e, n, {
      title: 'Ce n\u2019est pas la limite',
      message: 'Ce nombre n\u2019est pas la limite : calcule l\u2019int\xE9grale, puis conclus.',
    });
  }
  let f = { k: 'val', skey: l, subject: t, value: o, t: i, text: s, final: c },
    d = e.lims.get(l);
  if (d?.writings.length) {
    let m = LS(i);
    if (d.writings.some((h) => h.wkey === m))
      return {
        kind: 'useless',
        ...n,
        title: 'Rien de nouveau',
        message: 'Cette limite est d\xE9j\xE0 sur ta feuille.',
      };
    let p = Dk(i),
      g = Math.min(...d.writings.map((h) => h.ops));
    return p < g
      ? g - p > 4
        ? fm(n, f, c)
        : Qg(n, ['compute'], f, c)
      : {
          kind: 'useless',
          ...n,
          title: 'Juste, mais \xE7a ne t\u2019avance pas',
          message:
            'Les deux \xE9critures de la limite sont \xE9gales, mais le calcul n\u2019avance pas.',
          rmove: f,
          final: c,
        };
  }
  if (d?.ints.length)
    return d.ints.some((p) => e.subs[p.sub] && F2(e.subs[p.sub].ks))
      ? Qg(n, ['conclude'], f, c)
      : fm(
          n,
          f,
          c,
          'Juste, mais calcule d\u2019abord l\u2019int\xE9grale sur ta feuille : \xAB \u222B(\u2026) \u2026 dx = \u2026 \xBB.',
        );
  for (let [, m] of e.lims) {
    if (
      !m.writings.length ||
      !NS(
        (h) => Dg(e, t, h),
        (h) => Math.exp(Dg(e, m.subject, h)),
      )
    )
      continue;
    return i.k === 'fn' && i.f === 'exp' && Jn(Fn(i.a), m.value)
      ? Qg(n, ['compose'], f, c)
      : fm(
          n,
          f,
          c,
          'Juste, mais une \xE9tape \xE0 la fois : compose d\u2019abord par exp, \xAB \u2026 \u2192 e^(\u2026) \xBB, puis calcule.',
        );
  }
  return fm(n, f, c);
}
function IS(e) {
  return !!e.length && (Qr(e[0]) || e[0] === '[' || D6.test(e[0]));
}
var oW = (e) =>
  e.toFixed(12).replace(/0+$/, '').replace(/\.$/, '').replace('.', ',').replace('-', '\u2212');
function MS(e, n) {
  let t = js(n),
    r = pm(t, 0);
  if (r.k !== 'ok' || r.members.length !== 1 || r.members[0].ints.size !== 1)
    throw new wo(`Int\xE9grale illisible : \xAB ${n} \xBB.`);
  let s = [...r.members[0].ints.values()][0],
    i = _g((l) => Fn(s.body, { [s.x]: l }), s.a, s.b),
    o = {
      ...e.model,
      symbols: { I: {} },
      goal: ['I'],
      traps: [],
      choices: void 0,
      givens: void 0,
      kernel: {
        plugin: 'integral',
        goal: { kind: 'integrate', target: 'I' },
        start: `I = ${s.text}`,
        answer: `I = ${oW(i)}`,
        path: [`I = ${s.text}`],
      },
    },
    a = { ks: Ck(o), text: s.text, value: i };
  return ((a.ks.path = e.intPath.map((l) => AO(a, l))), a);
}
function IO(e) {
  if (!Qr(e[0])) return null;
  let n = e.findIndex(Fr);
  return n > 0 ? Is(e.slice(0, n + 1)) : null;
}
function aW(e, n) {
  let t = js(n),
    r = pm(t, 0);
  if (r.k !== 'ok' || r.members.length !== 1 || r.members[0].ints.size !== 1) return !1;
  let s = [...r.members[0].ints.values()][0];
  for (let { forms: i } of e.forms.values())
    for (let o of i) {
      let a = Bk(o) ?? KO(o);
      if (!a) continue;
      let l = Fg(s, 1, a);
      if (l === 'yes') return !0;
      if (l === 'coef' || l === 'fn') {
        let u = { ...a, lambda: 1 };
        if (Fg(s, 1, u) === 'yes') return !0;
      }
    }
  return !1;
}
var lW = {
    step: 10,
    ready: 9,
    useless: 7,
    building: 6,
    pending: 5,
    open: 4,
    unjustified: 3,
    trap: 2,
    false: 1,
    syntax: 0,
    empty: -1,
  },
  CO = (e) => lW[e.kind] * 100 + (e.hora ?? 0) + (e.kind === 'useless' ? (e.jump ? 20 : 10) : 0),
  uW = (e) =>
    e.kind === 'unjustified' && (e.title === 'Pas dans ton calcul' || e.title === 'Pars de I');
function _S(e, n) {
  if (IO(n) !== e.text) return { atoms: n, shift: 0 };
  let r = n.findIndex(Fr);
  return { atoms: ['I', ...n.slice(r + 1)], shift: r };
}
var AO = (e, n) => {
  try {
    let { atoms: t } = _S(e, js(n));
    return Is(t);
  } catch {
    return n;
  }
};
function EO(e, n, t, r, s, i) {
  let o = { ...e, atoms: n, final: !1 };
  return (
    delete o.imove,
    e.line && (o.line = Vg(n)),
    e.badChip !== void 0 && e.badChip >= 0 && (o.badChip = r(e.badChip === 0 ? 0 : e.badChip + t)),
    o.rule && (o.rule = { ...o.rule, why: o.rule.why.replace(' C\u2019est la r\xE9ponse.', '') }),
    (e.kind === 'step' || e.kind === 'useless' || e.kind === 'ready') &&
      (o.rmove = { k: 'int', sub: s, ...(i ? { fresh: i } : {}), v: e, text: So(n) }),
    o
  );
}
function MO(e, n, t, r) {
  return !(t.kind === 'ready' || (t.kind === 'building' && t.complete)) || jO(e, n)
    ? t
    : r.kind === 'unjustified' || r.kind === 'false'
      ? { ...r, kind: 'pending', complete: !0 }
      : r;
}
function cW(e, n, t, r) {
  let s = null;
  for (let l = 0; l < e.subs.length; l++) {
    let u = _S(e.subs[l], n),
      c = yO(u.atoms),
      f = Zl(e.subs[l].ks, c, { verify: !0 });
    if (uW(f)) continue;
    let d = r?.verify ? f : MO(e, n, Zl(e.subs[l].ks, c, r), f);
    (!s || CO(d) > CO(s.v)) && (s = { i: l, v: d, shift: u.shift });
  }
  if (s) return EO(s.v, n, s.shift, t, s.i);
  let i = IO(n);
  if (i && aW(e, i))
    try {
      let l = MS(e, i),
        u = _S(l, n),
        c = yO(u.atoms),
        f = r?.verify ? Zl(l.ks, c, r) : MO(e, n, Zl(l.ks, c, r), Zl(l.ks, c, { verify: !0 }));
      return EO(f, n, u.shift, t, -1, i);
    } catch {}
  let o = n[n.length - 1],
    a = n.includes('=') && (CS(o) || Fr(o) || yi(o));
  return !r?.verify && !a
    ? { kind: 'open', atoms: n, complete: !1 }
    : {
        kind: r?.verify ? 'unjustified' : 'pending',
        atoms: n,
        line: Vg(n),
        complete: !0,
        title: 'D\u2019o\xF9 vient cette int\xE9grale ?',
        message: `\xC9cris d\u2019abord la limite de ${e.X} comme une int\xE9grale : \xAB ${e.X} \u2192 \u222B(\u2026) \u2026 dx \xBB.`,
      };
}
function jO(e, n) {
  return e.path.some((t) => {
    let r;
    try {
      r = qS(js(t)).atoms;
    } catch {
      return !1;
    }
    return e.written.has(So(r)) ? !1 : r.length > n.length && n.every((s, i) => r[i] === s);
  });
}
function QO(e, n, t) {
  let r = n.flatMap((d) => d.atoms),
    s = [];
  n.forEach((d, m) => d.atoms.forEach(() => s.push(m)));
  let i = qS(r),
    o = i.atoms;
  if (!o.length) return { kind: 'empty', atoms: o, badChip: -1 };
  if (IS(o)) return cW(e, o, (d) => s[i.src[d] ?? r.length - 1] ?? n.length - 1, t);
  let a = jO(e, o),
    l = () =>
      t?.verify
        ? { kind: 'syntax', atoms: o, title: 'Ligne inachev\xE9e', message: 'Termine ta ligne.' }
        : { kind: a ? 'building' : 'open', atoms: o, complete: !1 },
    u = LO(o);
  if (u.k === 'empty') return { kind: 'empty', atoms: o, badChip: -1 };
  if (u.k === 'incomplete') return l();
  if (u.k === 'syntax')
    return a && !t?.verify
      ? { kind: 'building', atoms: o, complete: !1 }
      : {
          kind: 'syntax',
          atoms: o,
          title: u.title,
          message: u.message,
          badChip: s[i.src[u.index] ?? r.length - 1] ?? n.length - 1,
        };
  if (u.k === 'noeq')
    return t?.verify
      ? {
          kind: 'syntax',
          atoms: o,
          line: Vg(o),
          title: 'Une \xE9galit\xE9 ou une limite',
          message: `\xC9cris \xAB ${e.X} = \u2026 \xBB ou \xAB ${e.X} \u2192 \u2026 \xBB.`,
        }
      : { kind: a ? 'building' : 'open', atoms: o, complete: !1 };
  let c = { atoms: o, line: Vg(o) },
    f;
  return (
    u.k === 'eq'
      ? (f = tW(e, c, u.members))
      : zk(e, u.left)
        ? u.right.ints.size
          ? (f = sW(e, c, u.left.outer, u.right))
          : (f = iW(e, c, u.left.outer, u.right))
        : (f = {
            kind: 'unjustified',
            ...c,
            title: `Pars de ${e.X}`,
            message: `\xC9cris \xAB ${e.X} \u2192 \u2026 \xBB (ou \xAB ln(${e.X}) \u2192 \u2026 \xBB).`,
          }),
    a && !t?.verify
      ? f.kind === 'step'
        ? { ...f, kind: 'ready', complete: !0 }
        : { kind: 'building', atoms: o, complete: !0 }
      : !t?.verify && (f.kind === 'unjustified' || f.kind === 'false')
        ? { kind: 'pending', atoms: o, complete: !0 }
        : { ...f, complete: !0 }
  );
}
function FO(e, n) {
  let t = n.rmove;
  if (!t) return;
  if ((e.written.add(t.text), e.lines++, t.k === 'int')) {
    let s = t.sub;
    if (s < 0 && t.fresh) {
      let o = MS(e, t.fresh);
      (e.subs.push(o), (s = e.subs.length - 1));
    }
    let i = e.subs[s];
    i && Ek(i.ks, t.v);
    return;
  }
  if (t.k === 'eq') {
    let s = e.forms.get(t.skey) ?? { subject: t.subject, forms: KS(e, t.subject).reverse() };
    (s.forms.push(...t.forms), e.forms.set(t.skey, s));
    return;
  }
  let r = e.lims.get(t.skey) ?? { subject: t.subject, value: t.value, ints: [], writings: [] };
  if (t.k === 'riem') {
    let s = e.subs.findIndex((i) => i.text === t.int);
    if (s < 0)
      try {
        (e.subs.push(MS(e, t.int)), (s = e.subs.length - 1));
      } catch {
        s = -1;
      }
    s >= 0 && r.ints.push({ sub: s, coef: t.coef });
  } else (r.writings.push({ t: t.t, wkey: LS(t.t), ops: Dk(t.t) }), t.final && (e.concluded = !0));
  e.lims.set(t.skey, r);
}
function VO(e) {
  return e.concluded;
}
function DO(e, n) {
  let t;
  try {
    t = js(n);
  } catch {
    return !1;
  }
  if (IS(t)) return e.subs.some((s) => Mk(s.ks, AO(s, n)));
  let r = LO(t);
  if (!r) return !1;
  if (r.k === 'eq') {
    let s = r.members[0];
    return zk(e, s)
      ? r.members.slice(1).every(
          (i) =>
            !i.ints.size &&
            NS(
              (o) => Dg(e, s.outer, o),
              (o) => Uk(i, o),
            ),
        )
      : !1;
  }
  if (r.k === 'lim') {
    if (!zk(e, r.left)) return !1;
    let s = OS(e, r.left.outer);
    if (r.right.ints.size === 1 && !r.right.sums.size) {
      let [i, o] = [...r.right.ints][0],
        a = hm(r.right.outer, i);
      if (!a) return !1;
      let l = Fn(a) * _g((u) => Fn(o.body, { [o.x]: u }), o.a, o.b);
      return Jn(l, s, 1e-7);
    }
    return r.right.sums.size || r.right.ints.size || $(r.right.outer).has('n')
      ? !1
      : Jn(Fn(r.right.outer), s, 1e-9);
  }
  return !1;
}
var nu = class extends Error {},
  zg = '\u2192',
  zO = (e) => {
    try {
      return E(R(e));
    } catch {
      return E(e);
    }
  };
function dW(e) {
  let n = e.trim().replace(/^-/, '\u2212');
  if (n === '+\u221E') return { k: 'inf', s: 1 };
  if (n === '\u2212\u221E') return { k: 'inf', s: -1 };
  let t = /^(−?\d+(?:,\d+)?)([⁺⁻]?)$/.exec(n);
  if (!t) return null;
  let r = Number(t[1].replace('\u2212', '-').replace(',', '.'));
  if (!Number.isFinite(r)) return null;
  let s = t[2] === '\u207A' ? 1 : t[2] === '\u207B' ? -1 : 0;
  return s && r !== 0 ? null : { k: 'fin', v: r, side: s };
}
function mW(e, n, t) {
  let r = Sv(n.expr);
  if (!r) throw new nu(`Expression illisible : \xAB ${n.expr} \xBB.`);
  let s;
  try {
    s = cv(n.point, n.x, n.x === 'n');
  } catch (a) {
    throw new nu(a instanceof Error ? a.message : String(a));
  }
  let i = Yi(r, s).v,
    o = i && (i.k === 'fin' || i.k === 'inf') ? `${n.expr} ${zg} ${u0(i)}` : `${n.expr} ${zg} 0`;
  return {
    ...e,
    symbols: { [n.x]: {} },
    goal: [n.x],
    traps: [],
    choices: void 0,
    givens: void 0,
    kernel: {
      plugin: 'limit',
      goal: { kind: 'limit', target: n.x },
      point: n.point,
      start: n.expr,
      answer: o,
      path: t,
    },
  };
}
function UO(e) {
  let n = e.kernel;
  if (n.plugin !== 'limclaims' || !n.lclaims)
    throw new nu('Affirmations de limites attendues (plugin \xAB limclaims \xBB).');
  let t = n.path ?? [],
    r = (l) =>
      n.lclaims.map((u, c) => {
        let f = dW(u.value);
        if (!f) throw new nu(`Limite affirm\xE9e illisible : \xAB ${u.value} \xBB.`);
        let d;
        try {
          d = Zp(mW(e, u, l[c] ?? []));
        } catch (g) {
          throw g instanceof nu ? g : new nu(g instanceof Error ? g.message : String(g));
        }
        let m = Yi(d.target, d.P).v,
          p = m ? gi(f, m) : null;
        return { spec: u, ks: d, claimed: f, real: m, truth: p };
      }),
    s = {
      model: e,
      claims: r([]),
      decisions: n.lclaims.map(() => null),
      single: !!n.single,
      path: t,
      owner: [],
      lines: 0,
      texts: [],
    },
    i = { ...s, claims: r([]), decisions: [...s.decisions], texts: [] },
    o = [];
  for (let l of t) {
    let u = QS(i, GO(Or(l)), { verify: !0 });
    (o.push(u.claim ?? -1), (u.kind === 'step' || u.kind === 'useless') && FS(i, u));
  }
  s.owner = o;
  let a = s.claims.map((l, u) => t.filter((c, f) => o[f] === u));
  return ((s.claims = r(a)), s);
}
var GO = (e) => e.map((n) => ({ atoms: [n], text: n })),
  pW = new Set(['<', '>', '\u2264', '\u2265']);
function AS(e) {
  let n = e.indexOf(zg),
    t = n < 0 ? e : e.slice(0, n),
    r = [[]],
    s = 0;
  for (let i of t)
    (i === '(' && s++,
      i === ')' && s--,
      s === 0 && (i === '=' || pW.has(i)) ? r.push([]) : r[r.length - 1].push(i));
  return r.flatMap((i) => {
    if (!i.length) return [];
    let o = Sv(i.join(' '));
    return o ? [o] : [];
  });
}
function Bg(e, n) {
  switch ((n.add(zO(e)), e.k)) {
    case 'add':
    case 'mul':
      e.c.forEach((t) => Bg(t, n));
      break;
    case 'fn':
      Bg(e.a, n);
      break;
    case 'div':
    case 'pow':
    case 'binom':
      (Bg(e.a, n), Bg(e.b, n));
      break;
    default:
  }
}
function gW(e) {
  let n = new Set();
  for (let t of e.ks.terms.values()) Bg(t, n);
  return n;
}
function jS(e, n) {
  if (!n.length) return !1;
  let t = gW(e);
  return n.some((r) => t.has(zO(r)));
}
var hW = {
  step: 10,
  ready: 9,
  useless: 7,
  building: 6,
  pending: 5,
  open: 4,
  unjustified: 3,
  trap: 2,
  false: 1,
  syntax: 0,
  empty: -1,
};
function BO(e) {
  let n = hW[e.kind] * 100 + (e.hora ?? 0);
  return (e.kind === 'useless' && (n += e.jump ? 20 : e.unknown ? 0 : 10), n);
}
function ZO(e) {
  let n = e.claims.map((t) => (t.ks.concluded ? t.truth : null));
  if (e.single) {
    let t = n.filter((s) => s === !0).length;
    if (t === 1) return n.map((s) => s === !0);
    let r = n.filter((s) => s === null).length;
    if (!t && r === 1) return n.map((s) => s === null);
  }
  return n;
}
function QS(e, n, t) {
  let r = n.flatMap((d) => d.atoms);
  if (!r.length) return { kind: 'empty', atoms: r, badChip: -1 };
  let s = AS(r),
    i = e.claims.map((d, m) => ({ c: d, i: m })).filter(({ c: d }) => jS(d, s)),
    o = i.length ? i : e.claims.map((d, m) => ({ c: d, i: m })),
    a = null;
  for (let { c: d, i: m } of o) {
    let p = vc(d.ks, n, t);
    (!a || BO(p) > BO(a.v)) && (a = { v: p, i: m });
  }
  let l = a.v;
  if (!i.length && (l.kind === 'step' || l.kind === 'useless' || l.kind === 'ready'))
    return {
      kind: 'useless',
      atoms: r,
      line: wv(kr(r)),
      complete: !0,
      title: 'De quelle limite parles-tu ?',
      message:
        'Ta ligne ne parle d\u2019aucune des expressions de l\u2019\xE9nonc\xE9 : pars de l\u2019une d\u2019elles (ou d\u2019un de ses morceaux).',
    };
  let u = { ...l, claim: a.i },
    c = e.claims[a.i].spec;
  if (
    (e.claims.some((d) => d.spec.point !== c.point || d.spec.x !== c.x) &&
      (l.kind === 'false' || l.kind === 'trap') &&
      l.message &&
      (u.message = `Quand ${c.x} ${zg} ${c.point} : ${l.message.charAt(0).toLowerCase()}${l.message.slice(1)}`),
    l.kind === 'step' || l.kind === 'ready' || (l.kind === 'useless' && l.lmove))
  ) {
    let d = ZO(e),
      m = bW(e, i.length ? i.map((h) => h.i) : [a.i], n, t),
      p = m.flatMap((h, b) => (d[b] === null && h !== null ? [{ index: b, truth: h }] : []));
    p.length && (u.decided = p);
    let g = m.every((h) => h !== null);
    if (((u.final = g), l.kind === 'step' && l.rule && p.length)) {
      let h = p.map((b) => {
        let v = e.claims[b.index].spec;
        return `\xAB ${v.expr} ${zg} ${v.value} \xBB est ${b.truth ? 'vraie' : 'fausse'}.`;
      });
      u.rule = {
        ...l.rule,
        why: `${l.rule.why.replace(' C\u2019est la r\xE9ponse.', '')} ${h.join(' ')}`.trim(),
      };
    }
  }
  return u;
}
function bW(e, n, t, r) {
  let s = e.claims.map((o, a) => {
      if (o.ks.concluded) return !0;
      if (!n.includes(a)) return !1;
      let l = vc(o.ks, t, r);
      return !(l.kind === 'step' || l.kind === 'ready' || l.kind === 'useless') || !l.lmove
        ? !1
        : !!l.final;
    }),
    i = e.claims.map((o, a) => (s[a] ? o.truth : null));
  if (e.single) {
    let o = i.filter((l) => l === !0).length;
    if (o === 1) return i.map((l) => l === !0);
    let a = i.filter((l) => l === null).length;
    if (!o && a === 1) return i.map((l) => l === null);
  }
  return i;
}
function FS(e, n) {
  let t = kr(n.atoms),
    r = AS(n.atoms),
    s = GO(n.atoms);
  (e.claims.forEach((i, o) => {
    if (!jS(i, r) && o !== n.claim) return;
    let a = o === n.claim ? n : vc(i.ks, s, { verify: !0 });
    (a.kind === 'step' || a.kind === 'useless' || a.kind === 'ready') && a.lmove && Hp(i.ks, a);
  }),
    (e.decisions = ZO(e)),
    e.texts.push(t),
    e.lines++);
}
function HO(e) {
  return e.decisions.every((n) => n !== null);
}
function WO(e, n) {
  let t;
  try {
    t = Or(n);
  } catch {
    return !1;
  }
  let r = AS(t);
  return e.claims.some((s) => jS(s, r) && Ev(s.ks, n));
}
var Hg = {
  usual: 'analysis.usual@1',
  product: 'analysis.product@1',
  quotient: 'analysis.quotient@1',
  inverse: 'analysis.inverse@1',
  chain: 'analysis.chain@1',
  name: 'analysis.name@1',
  substitute: 'analysis.substitute@1',
  rewrite: 'analysis.rewrite@1',
  primitive: 'analysis.primitive@1',
  recognize: 'analysis.recognize@1',
  point: 'analysis.point@1',
  tangent: 'analysis.tangent@1',
  condition: 'analysis.condition@1',
};
var Wt = {
    usual: {
      label: 'D\xE9riv\xE9es usuelles',
      hora: 2,
      why: 'Terme \xE0 terme : (x\u207F)\u2032 = nx\u207F\u207B\xB9, (1 \xF7 x)\u2032 = \u22121 \xF7 x\xB2, (\u221Ax)\u2032 = 1 \xF7 (2\u221Ax), (e\u02E3)\u2032 = e\u02E3, (ln x)\u2032 = 1 \xF7 x ; et (g(ax + b))\u2032 = a \xD7 g\u2032(ax + b).',
    },
    product: {
      label: 'D\xE9riv\xE9e d\u2019un produit',
      hora: 2,
      why: '(uv)\u2032 = u\u2032v + uv\u2032.',
    },
    quotient: {
      label: 'D\xE9riv\xE9e d\u2019un quotient',
      hora: 3,
      why: '(u \xF7 v)\u2032 = (u\u2032v \u2212 uv\u2032) \xF7 v\xB2.',
    },
    inverse: {
      label: 'D\xE9riv\xE9e de 1 \xF7 v',
      hora: 2,
      why: '(1 \xF7 v)\u2032 = \u2212v\u2032 \xF7 v\xB2.',
    },
    chain: {
      label: 'D\xE9riv\xE9e d\u2019une compos\xE9e',
      hora: 2,
      why: '(g(u))\u2032 = u\u2032 \xD7 g\u2032(u) : (e\u1D58)\u2032 = u\u2032e\u1D58, (ln u)\u2032 = u\u2032 \xF7 u, (\u221Au)\u2032 = u\u2032 \xF7 (2\u221Au), (u\u207F)\u2032 = nu\u2032u\u207F\u207B\xB9, (cos u)\u2032 = \u2212u\u2032 sin u.',
    },
    name: { label: 'Nommer', hora: 1, why: 'Une partie de f re\xE7oit un nom.' },
    substitute: {
      label: 'Remplacer',
      hora: 1,
      why: 'Chaque nom est remplac\xE9 par son expression, les calculs faits dans chaque morceau.',
    },
    rewrite: { label: 'R\xE9duire', hora: 1, why: 'La m\xEAme fonction, \xE9crite autrement.' },
    primitive: {
      label: 'Primitive usuelle',
      hora: 2,
      why: 'Terme \xE0 terme : x\u207F a pour primitive x\u207F\u207A\xB9 \xF7 (n + 1), 1 \xF7 x a pour primitive ln x, e\u02E3 a pour primitive e\u02E3\u2026 On v\xE9rifie en d\xE9rivant.',
    },
    recognize: {
      label: 'Reconna\xEEtre une forme',
      hora: 3,
      why: 'u\u2032e\u1D58 a pour primitive e\u1D58, u\u2032 \xF7 u a pour primitive ln u, u\u2032u\u207F a pour primitive u\u207F\u207A\xB9 \xF7 (n + 1)\u2026 On v\xE9rifie en d\xE9rivant.',
    },
    point: {
      label: 'Calculer en un point',
      hora: 1,
      why: 'On remplace x par la valeur du point : f(a) avec l\u2019expression de f, f\u2032(a) avec celle de f\u2032, F(a) avec celle de F.',
    },
    tangent: {
      label: '\xC9quation de la tangente',
      hora: 2,
      why: 'La tangente au point d\u2019abscisse a : y = f\u2032(a)(x \u2212 a) + f(a).',
    },
    condition: {
      label: 'Utiliser la condition',
      hora: 1,
      why: 'Les primitives diff\xE8rent d\u2019une constante C : la condition F(a) = \u2026 la fixe.',
    },
  },
  Hk = 'D\xE9rivation',
  Wg = 'Primitives',
  YO = 'Tangente',
  Gg = 0.6180339887,
  eK = 1.4142135623;
function vW(e) {
  let n = e.kernel;
  return n
    ? [
        n.start,
        n.answer,
        n.condition ?? '',
        ...(n.path ?? []),
        ...(e.givens ?? []),
        ...(e.traps ?? []).map((t) => t.line),
        ...(e.choices ?? []).map((t) => t.line ?? ''),
      ].some((t) => j_.test(t))
    : !1;
}
function Wk(e, n) {
  return e.arcs && !cc() ? kd(n) : n();
}
var nK = '\u2070\xB9\xB2\xB3\u2074\u2075\u2076\u2077\u2078\u2079',
  DS = (e) => e.length > 0 && [...e].every((n) => nK.includes(n));
function Ht(e) {
  let n = [];
  for (let t of Te(e)) {
    let r = n[n.length - 1];
    if (DS(t) && r !== void 0 && DS(r)) {
      n[n.length - 1] = r + t;
      continue;
    }
    n.push(t);
  }
  return n;
}
function ka(e) {
  let n = [];
  for (let t = 0; t < e.length; t++) {
    let r = t,
      s = '';
    for (; r < e.length && DS(e[r]); )
      ((s += [...e[r]].map((i) => String(nK.indexOf(i))).join('')), r++);
    if (r > t && !(r - t === 1 && e[t] === '\xB2')) {
      (n.push('^', s), (t = r - 1));
      continue;
    }
    n.push(e[t]);
  }
  return n;
}
function as(e) {
  return ot(e)
    .replace(/ ([⁰¹²³⁴⁵⁶⁷⁸⁹]+)/g, '$1')
    .replace(/(\d) √/g, '$1\u221A')
    .replace(/\//g, '\xF7')
    .replace(/\s*÷\s*/g, ' \xF7 ');
}
var vm = (e) => ({ dis: [{ sides: [{ k: 's', n: as(e) }] }] });
function tK(e) {
  return vm(Ht(e));
}
var Si = class extends Error {},
  ef = /^([A-Za-zα-ω][₀-₉]*)(′*)\(([^()]+)\)$/;
function ZS(e, n) {
  let t = ef.exec(e);
  if (!t || t[3] !== n.x) return null;
  let r = { base: t[1], primes: t[2].length };
  return n.shiftBase && r.base === n.shiftBase && r.primes >= 1
    ? { base: n.fBase, primes: r.primes - 1 }
    : r;
}
function Gk(e, n, t) {
  let r = ef.exec(Ht(e)[0] ?? '');
  return r && r[1] === n && r[3] === t ? r[2].length : -1;
}
function HS(e, n) {
  let t = Ae(ne(ka(n)), { chains: !0 });
  if (t.dis.length !== 1) throw new Si('Une seule \xE9galit\xE9 par ligne.');
  let r = t.dis[0];
  if (r.cmp || r.chain || r.rels || r.mod !== void 0 || r.sides.length < 2)
    throw new Si(
      `\xC9cris une \xE9galit\xE9 \xAB ${e.tBase}${e.goal === 'differentiate' ? '\u2032' : ''}(${e.x}) = \u2026 \xBB.`,
    );
  let s = r.sides[0],
    i = s.k === 's' ? ZS(s.n, e) : null;
  if (!i)
    throw new Si(
      `Commence la ligne par le nom de la fonction : \xAB ${e.tBase}${e.goal === 'differentiate' ? '\u2032' : ''}(${e.x}) = \u2026 \xBB, \xAB u(${e.x}) = \u2026 \xBB.`,
    );
  let o;
  try {
    o = r.sides.slice(1).map((a) => _e(a));
  } catch (a) {
    throw a instanceof Gr ? new Si('Ce calcul ne se lit pas.') : a;
  }
  return { head: i, members: o };
}
function xa(e, n) {
  let t = [];
  return (
    $(n).forEach((r) => {
      let s = ZS(r, e);
      s && t.push(s);
    }),
    t
  );
}
var BS = (e) => `${e.base}${'\u2032'.repeat(e.primes)}(x)`;
function ru(e, n) {
  let t = {};
  for (let r of $(n)) {
    let s = ZS(r, e);
    if (!s) continue;
    let i = WS(e, s);
    if (!i) return { missing: s };
    t[r] = i;
  }
  return { t: Object.keys(t).length ? R(j(n, t)) : n };
}
function WS(e, n) {
  if (n.base === e.fBase) return n.primes === 0 ? e.f : n.primes === 1 ? su(e.f, e.x) : null;
  let t = e.names.get(n.base);
  return t
    ? n.primes === 0
      ? t.def
      : n.primes === 1
        ? (e.derivs.get(n.base)?.expr ?? su(t.def, e.x))
        : null
    : null;
}
function su(e, n) {
  try {
    return wn(e, n);
  } catch {
    return null;
  }
}
var bn = (e, n) => ov(n, e.x, e.points, e.env);
function ya(e, n) {
  let t = ru(e, n);
  return 'missing' in t ? null : bn(e, t.t);
}
var Vn = (e, n) => B_(e, n);
function rK(e, n, t) {
  if (!e) return !0;
  let r = e.dis[0],
    s = r.sides.map((o) => {
      try {
        return D(R(_e(o)), { [n]: t });
      } catch {
        return NaN;
      }
    });
  return (r.chain ?? (r.cmp ? [r.cmp] : [])).every((o, a) => {
    let l = s[a],
      u = s[a + 1];
    if (!Number.isFinite(l) || !Number.isFinite(u)) return !1;
    switch (o) {
      case '<':
        return l < u;
      case '>':
        return l > u;
      case '\u2264':
        return l <= u;
      case '\u2265':
        return l >= u;
      default:
        return !0;
    }
  });
}
function Jg(e) {
  if (vW(e) && !cc()) {
    let le = kd(() => Jg(e));
    return ((le.arcs = !0), le.second && (le.second.arcs = !0), le);
  }
  let n = e.kernel,
    t = n.goal.kind === 'antiderivative' ? 'antiderivative' : 'differentiate',
    r = n.goal.kind === 'tangent',
    s = r || !!n.condition,
    i = Ht(n.start),
    o = Ae(ne(ka(i)), { chains: !0 }),
    a = o.dis[0];
  if (o.dis.length !== 1 || a.sides.length !== 2 || a.sides[0].k !== 's')
    throw new Error('D\xE9part attendu : \xAB f(x) = \u2026 \xBB.');
  let l = ef.exec(a.sides[0].n),
    u = t === 'antiderivative' && l?.[2] === '\u2032';
  if (!l || (l[2] && !u)) throw new Error('D\xE9part attendu : \xAB f(x) = \u2026 \xBB.');
  let c = l[3];
  if (!/^[a-zα-ω]$/.test(c)) throw new Error('La variable est une lettre : \xAB f(x) \xBB.');
  let f = u ? `${l[1]}\u2032` : l[1],
    d = r ? `${f}\u2032(${c})` : n.goal.target,
    m = ef.exec(d);
  if (!m || m[3] !== c)
    throw new Error(`Cible attendue : \xAB ${f}\u2032(${c}) \xBB ou \xAB F(${c}) \xBB.`);
  if (u && m[1] !== l[1])
    throw new Error(`Cible attendue : \xAB ${l[1]}(${c}) \xBB (l\u2019\xE9nonc\xE9 donne ${f}).`);
  let p = m[1],
    g = t === 'differentiate' && m[2] === '\u2032\u2032';
  if (t === 'differentiate' && (p !== f || (m[2] !== '\u2032' && !g)))
    throw new Error(
      `Cible attendue : \xAB ${f}\u2032(${c}) \xBB ou \xAB ${f}\u2032\u2032(${c}) \xBB.`,
    );
  if (t === 'antiderivative' && (p === f || m[2]))
    throw new Error(`Cible attendue : \xAB F(${c}) \xBB.`);
  let h = R(_e(a.sides[1])),
    b,
    v = null;
  try {
    ((b = wn(h, c)), g && (v = wn(b, c)));
  } catch (le) {
    throw new Error(le instanceof Xo ? le.message : String(le));
  }
  let k = n.domain ? Ae(ne(ka(Ht(n.domain))), { chains: !0 }) : null,
    y = (le) => {
      let Pn = Ae(ne(ka(Ht(le))), { chains: !0 }).dis[0].sides;
      return _e(Pn[Pn.length - 1]);
    },
    S = r ? b : y(n.answer),
    w = s ? { C: Gg, e: Math.E } : { C: Gg },
    _ = (le, Xn) => {
      try {
        return Number.isFinite(D(le, { ...w, [c]: Xn }));
      } catch {
        return !1;
      }
    },
    O = t === 'antiderivative' ? su(S, c) : null,
    G = D_.filter(
      (le) =>
        rK(k, c, le) &&
        _(h, le) &&
        _(b, le) &&
        (!v || _(v, le)) &&
        _(S, le) &&
        (t === 'differentiate' || (!!O && _(O, le))),
    );
  if (G.length < r0)
    throw new Error(
      'Trop peu de points o\xF9 la fonction est d\xE9finie : pr\xE9cise l\u2019intervalle.',
    );
  let Se = n.path ?? [],
    U = g ? Se.findIndex((le) => Gk(le, f, c) === 2) : -1,
    ae = U < 0 ? Se : Se.slice(0, U),
    P = U < 0 ? [] : Se.slice(U),
    ee = s
      ? kW(n, { x: c, f: h, fprime: b, fBase: f, tBase: p, env: w, domain: k, lastMember: y })
      : void 0,
    Mn = {
      model: e,
      x: c,
      goal: t,
      points: G,
      givenTexts: new Set([as(i), ...(ee?.condText ? [ee.condText] : [])]),
      known: [...Se, n.answer].map(Ht),
      env: w,
    },
    xe = JO(Mn, {
      fBase: f,
      tBase: p,
      ...(u ? { shiftBase: l[1] } : {}),
      f: h,
      want: t === 'differentiate' ? b : null,
      answer: g ? b : S,
      answerSize: g || r ? 1 / 0 : ns(t === 'antiderivative' ? sK(S, c) : S),
      path: ae,
    });
  (ee &&
    ((xe.point = ee), (ee.tangent = r ? xe.points.map((le) => ee.fpa * (le - ee.a) + ee.fa) : [])),
    g &&
      (xe.second = JO(Mn, {
        fBase: `${f}\u2032`,
        tBase: `${f}\u2032`,
        shiftBase: f,
        f: b,
        want: v,
        answer: S,
        answerSize: ns(S),
        path: [...ae.filter((le) => Gk(le, f, c) === 1), ...P],
      })));
  for (let le of e.traps ?? []) {
    let Xn = xe.second && Gk(le.line, f, c) === 2 ? xe.second : xe;
    try {
      let Pn = HS(Xn, Ht(le.line)),
        Jt = Pn.members[Pn.members.length - 1],
        To = ya(Xn, Jt);
      if (!To) continue;
      Xn.traps.push({
        text: as(Ht(le.line)),
        kind: Jk(Xn, Pn.head),
        base: Pn.head.base,
        vec: To,
        line: tK(le.line),
        title: le.title ?? 'Pi\xE8ge',
        why: le.why ?? '',
      });
    } catch {}
  }
  return xe;
}
function JO(e, n) {
  let t = {
    ...e,
    fBase: n.fBase,
    tBase: n.tBase,
    ...(n.shiftBase ? { shiftBase: n.shiftBase } : {}),
    f: n.f,
    fVec: [],
    fForms: [n.f],
    want: [],
    answer: n.answer,
    answerSize: n.answerSize,
    names: new Map(),
    derivs: new Map(),
    targets: [],
    concluded: !1,
    traps: [],
    path: n.path,
    lines: [],
  };
  return ((t.fVec = bn(t, n.f)), (t.want = n.want ? bn(t, n.want) : t.fVec), t);
}
function kW(e, n) {
  let t = (f) => {
      let d = D(R(n.lastMember(`a = ${f}`)), n.env);
      if (!Number.isFinite(d)) throw new Error(`\xAB ${f} \xBB ne se calcule pas.`);
      return d;
    },
    r = {
      kind: 'tangent',
      at: '',
      a: 0,
      fa: 0,
      fpa: 0,
      tangent: [],
      answerSize: 0,
      condText: '',
      condHead: '',
      valueText: '',
      value: 0,
      values: new Map(),
      c: null,
      ys: [],
      concluded: !1,
    };
  if (e.goal.kind === 'tangent') {
    let f = e.at,
      d = t(f);
    if (!rK(n.domain, n.x, d))
      throw new Error(`Le point ${f} n\u2019est pas dans l\u2019intervalle.`);
    let m = (v) => D(v, { ...n.env, [n.x]: d }),
      p = m(n.f),
      g = m(n.fprime);
    if (!Number.isFinite(p) || !Number.isFinite(g))
      throw new Error(`${n.fBase} n\u2019est pas d\xE9rivable en ${f}.`);
    let h = Ae(ne(ka(Ht(e.answer))), { chains: !0 }),
      b = h.dis[0]?.sides[0];
    if (h.dis.length !== 1 || !b || b.k !== 's' || b.n !== 'y')
      throw new Error('R\xE9ponse attendue : \xAB y = \u2026 \xBB.');
    return { ...r, at: f, a: d, fa: p, fpa: g, answerSize: ns(n.lastMember(e.answer)) };
  }
  let s = Ht(e.condition),
    i = Ae(ne(ka(s)), { chains: !0 }),
    o = i.dis[0],
    a = o.sides[0],
    l = a.k === 's' ? ef.exec(a.n) : null;
  if (i.dis.length !== 1 || o.sides.length !== 2 || o.cmp || !l || l[1] !== n.tBase || l[2])
    throw new Error(`Condition attendue : \xAB ${n.tBase}(a) = \u2026 \xBB.`);
  let u = l[3],
    c = s.indexOf('=');
  return {
    ...r,
    kind: 'condition',
    at: u,
    a: t(u),
    condText: as(s),
    condHead: a.n,
    valueText: as(s.slice(c + 1)),
    value: D(R(_e(o.sides[1])), n.env),
  };
}
function sK(e, n) {
  let t = ba(e).filter((r) => $(r).has(n));
  return t.length ? (t.length === 1 ? t[0] : { k: 'add', c: t }) : e;
}
function ba(e) {
  return e.k === 'add' ? e.c.flatMap(ba) : e.k === 'num' && e.v.n === 0n ? [] : [e];
}
function km(e, n) {
  return E(R(e)) === E(R(n)) && ns(n) >= ns(e);
}
function Jk(e, n) {
  return n.base === e.tBase && (e.goal === 'differentiate' ? n.primes === 1 : n.primes === 0)
    ? 'target'
    : n.base === e.fBase && n.primes === 0
      ? 'f'
      : n.primes === 0
        ? 'name'
        : 'deriv';
}
var zS = (e) => e.every((n) => nn(n, 0));
function tu(e, n) {
  let t = [];
  for (let r of ba(n)) {
    let s = ya(e, r);
    if (!s) return null;
    t.push(s);
  }
  return t;
}
function Zg(e) {
  let n = R(e);
  if (n.k === 'div') return { n: n.a, d: n.b };
  if (n.k === 'mul') {
    let t = n.c.filter((i) => i.k === 'div');
    if (t.length !== 1) return null;
    let r = t[0],
      s = n.c.filter((i) => i !== r);
    return { n: R({ k: 'mul', c: [...s, r.a] }), d: r.b };
  }
  return null;
}
var iK = (e, n) => e.map((t) => t * n),
  oK = (e, n) => e.map((t, r) => t / n[r]);
function xW(e, n, t) {
  let r = t.pieces.map((i) => bn(e, i));
  if (t.den) {
    let i = bn(e, t.den),
      o = Zg(n);
    if (o) {
      let l = ya(e, o.d),
        u = l ? xd(l, i) : null;
      if (u !== null && !nn(u, 0)) {
        let c = tu(e, o.n);
        if (
          c &&
          Yo(
            c.map((f) => iK(f, 1 / u)),
            r,
          )
        )
          return !0;
      }
    }
    let a = tu(e, n);
    return (
      !!a &&
      Yo(
        a,
        r.map((l) => oK(l, i)),
      )
    );
  }
  let s = tu(e, n);
  return !!s && Yo(s, r);
}
function yW(e) {
  return (n) => {
    let t = bn(e, n);
    for (let [r, s] of e.names) {
      let i = e.derivs.get(r);
      if (i && Vn(s.vec, t)) return i.expr;
    }
    return null;
  };
}
var wW = (e) =>
  e === 'usual'
    ? 'usual'
    : e === 'product'
      ? 'product'
      : e === 'quotient'
        ? 'quotient'
        : e === 'inverse'
          ? 'inverse'
          : 'chain';
function aK(e, n, t) {
  let r = null,
    s = [];
  for (let i of n) {
    let o = Pp(i, e.x, yW(e));
    if (!o || (s.length || (s = o.rules), !xW(e, t, o))) continue;
    let a = { rules: [...new Set(o.rules.map(wW))], nested: o.nested, affine: bm(i, e.x) };
    if (!o.nested.length) return a;
    r ??= a;
  }
  return r ?? { fail: s };
}
function bm(e, n) {
  let t = (r) => {
    if (r.k === 'sym' || !$(r).has(n)) return !1;
    try {
      return !$(wn(r, n)).has(n);
    } catch {
      return !1;
    }
  };
  switch (e.k) {
    case 'fn':
      return t(e.a) || bm(e.a, n);
    case 'pow':
      return (!$(e.b).has(n) && t(e.a)) || bm(e.a, n);
    case 'div':
      return t(e.b) || bm(e.a, n) || bm(e.b, n);
    case 'add':
    case 'mul':
      return e.c.some((r) => bm(r, n));
    default:
      return !1;
  }
}
function SW(e) {
  let n = [],
    t = e.x,
    r = e.want;
  for (let s of kl(e.f)) {
    let i;
    try {
      i = wn(s, t);
    } catch {
      continue;
    }
    let o = r.map((p, g) => p - bn(e, i)[g]),
      a = (p, g) => {
        try {
          let h = bn(e, R(p));
          n.push({ vec: o.map((b, v) => b + h[v]), d: g });
        } catch {}
      };
    kl(e.f).length > 1 &&
      !zS(bn(e, i)) &&
      n.push({
        vec: o,
        d: {
          title: 'Il manque un morceau',
          message: 'D\xE9rive chaque terme de la somme : il en manque un.',
        },
      });
    let { c: l, core: u } = vl(s, t),
      c = (...p) => ({ k: 'mul', c: [...l, ...p] }),
      f = T(-1),
      d = (p) => su(p, t);
    if (u.length === 2) {
      let [p, g] = u,
        h = d(p),
        b = d(g);
      h &&
        b &&
        (a(c(h, b), {
          title: '(uv)\u2032 n\u2019est pas u\u2032v\u2032',
          message:
            'La d\xE9riv\xE9e d\u2019un produit n\u2019est pas le produit des d\xE9riv\xE9es : (uv)\u2032 = u\u2032v + uv\u2032.',
        }),
        a(c(h, g), {
          title: 'Il manque un terme',
          message: '(uv)\u2032 = u\u2032v + uv\u2032 : deux termes.',
        }),
        a(c(p, b), {
          title: 'Il manque un terme',
          message: '(uv)\u2032 = u\u2032v + uv\u2032 : deux termes.',
        }));
    }
    let m = u.length === 1 ? u[0] : null;
    if (m && m.k === 'div') {
      let p = m.a,
        g = m.b,
        h = d(p),
        b = d(g),
        v = { k: 'pow', a: g, b: T(2) };
      h && b && $(p).has(t)
        ? (a(c({ k: 'div', a: { k: 'add', c: [c(h, g), c(p, b)] }, b: v }), {
            title: 'Le signe',
            message:
              '(u \xF7 v)\u2032 = (u\u2032v \u2212 uv\u2032) \xF7 v\xB2 : un MOINS au num\xE9rateur.',
          }),
          a(
            c({
              k: 'div',
              a: {
                k: 'add',
                c: [
                  { k: 'mul', c: [p, b] },
                  { k: 'mul', c: [f, h, g] },
                ],
              },
              b: v,
            }),
            {
              title: 'L\u2019ordre',
              message:
                '(u \xF7 v)\u2032 = (u\u2032v \u2212 uv\u2032) \xF7 v\xB2 : u\u2032v d\u2019abord.',
            },
          ),
          a(
            c({
              k: 'div',
              a: {
                k: 'add',
                c: [
                  { k: 'mul', c: [h, g] },
                  { k: 'mul', c: [f, p, b] },
                ],
              },
              b: g,
            }),
            {
              title: 'Le d\xE9nominateur',
              message:
                '(u \xF7 v)\u2032 = (u\u2032v \u2212 uv\u2032) \xF7 v\xB2 : le d\xE9nominateur est v\xB2, au carr\xE9.',
            },
          ),
          a(c({ k: 'div', a: h, b }), {
            title: '(u \xF7 v)\u2032 n\u2019est pas u\u2032 \xF7 v\u2032',
            message:
              'La d\xE9riv\xE9e d\u2019un quotient n\u2019est pas le quotient des d\xE9riv\xE9es : (u \xF7 v)\u2032 = (u\u2032v \u2212 uv\u2032) \xF7 v\xB2.',
          }))
        : b &&
          !$(p).has(t) &&
          (a(c({ k: 'div', a: { k: 'mul', c: [p, b] }, b: v }), {
            title: 'Le signe',
            message: '(1 \xF7 v)\u2032 = \u2212v\u2032 \xF7 v\xB2 : un signe moins.',
          }),
          a(c({ k: 'div', a: { k: 'mul', c: [f, p, b] }, b: g }), {
            title: 'Le d\xE9nominateur',
            message:
              '(1 \xF7 v)\u2032 = \u2212v\u2032 \xF7 v\xB2 : le d\xE9nominateur est v\xB2, au carr\xE9.',
          }));
    }
    if (m && (m.k === 'fn' || (m.k === 'pow' && !$(m.b).has(t)))) {
      let p = (m.k === 'fn', m.a),
        g = d(p),
        h = d(m);
      if (g && h && $(p).has(t) && !zS(bn(e, g))) {
        let b = R({ k: 'div', a: h, b: g });
        (p.k !== 'sym' &&
          a(c(b), {
            title: 'Multiplie par u\u2032',
            message:
              '(g(u))\u2032 = u\u2032 \xD7 g\u2032(u) : la d\xE9riv\xE9e de l\u2019int\xE9rieur manque.',
          }),
          m.k === 'fn' &&
            m.f === 'sqrt' &&
            a(c({ k: 'div', a: g, b: m }), {
              title: 'Le 2',
              message: '(\u221Au)\u2032 = u\u2032 \xF7 (2\u221Au).',
            }),
          m.k === 'pow' &&
            a(c(m.b, g, m), {
              title: 'L\u2019exposant',
              message:
                '(u\u207F)\u2032 = n \xD7 u\u2032 \xD7 u\u207F\u207B\xB9 : l\u2019exposant baisse de 1.',
            }));
      }
    }
  }
  return n;
}
function TW(e, n) {
  for (let s of SW(e)) if (Vn(n, s.vec)) return s.d;
  if (Vn(n, e.fVec) && !Vn(e.fVec, e.want))
    return {
      title: `C\u2019est ${e.fBase}`,
      message: `Tu as recopi\xE9 ${e.fBase} : d\xE9rive-la.`,
    };
  let t = xd(n, e.want);
  if (t !== null && nn(t, -1))
    return {
      title: 'Le signe',
      message: 'Tout est juste au signe pr\xE8s : v\xE9rifie les signes moins.',
    };
  if (t !== null && !nn(t, 0) && !nn(t, 1))
    return {
      title: 'Le coefficient',
      message: 'La forme est la bonne, mais pas le coefficient devant : v\xE9rifie-le.',
    };
  let r = s0(n, e.want);
  return r !== null && !nn(r, 0)
    ? { title: 'La constante', message: 'La d\xE9riv\xE9e d\u2019une constante est 0.' }
    : {
        title: 'D\xE9riv\xE9e fausse',
        message: `Ce n\u2019est pas la d\xE9riv\xE9e de ${e.fBase}.`,
      };
}
function US(e) {
  return e.fBase === `${e.tBase}\u2032`
    ? `${e.tBase}(${e.x}) connaissant ${e.fBase}(${e.x})`
    : `${e.tBase}(${e.x}) telle que ${e.tBase}\u2032 = ${e.fBase}`;
}
function RW(e, n, t) {
  let r = e.fBase,
    s =
      e.fBase === `${e.tBase}\u2032` ? US(e) : `${e.tBase} telle que ${e.tBase}\u2032 = ${e.fBase}`;
  if (Vn(t, e.fVec))
    return { title: `C\u2019est ${r}`, message: `Tu as recopi\xE9 ${r} : on cherche ${s}.` };
  let i = (() => {
    let a = su(e.f, e.x);
    return a ? bn(e, a) : null;
  })();
  if (i && Vn(t, i))
    return {
      title: 'Tu as d\xE9riv\xE9',
      message: `C\u2019est la d\xE9riv\xE9e de ${r} : on cherche une primitive, ${s}.`,
    };
  let o = xd(n, e.fVec);
  return o !== null && nn(o, -1)
    ? {
        title: 'Le signe',
        message: `En d\xE9rivant ta proposition, on trouve \u2212${r} : change le signe.`,
      }
    : o !== null && !nn(o, 0) && !nn(o, 1)
      ? {
          title: 'Le coefficient',
          message: `En d\xE9rivant ta proposition, on trouve ${pe(o)} \xD7 ${r} : ajuste le coefficient.`,
        }
      : {
          title: 'Pas une primitive',
          message: `D\xE9rive ta proposition : tu ne retrouves pas ${r}.`,
        };
}
var lK = {
  usual: 'D\xE9rive terme \xE0 terme avec les d\xE9riv\xE9es usuelles.',
  product: '\xC9cris d\u2019abord (uv)\u2032 = u\u2032v + uv\u2032 : nomme u et v.',
  quotient:
    '\xC9cris d\u2019abord (u \xF7 v)\u2032 = (u\u2032v \u2212 uv\u2032) \xF7 v\xB2 : nomme u et v.',
  inverse: '\xC9cris d\u2019abord (1 \xF7 v)\u2032 = \u2212v\u2032 \xF7 v\xB2.',
  chain_exp: '\xC9cris d\u2019abord (e\u1D58)\u2032 = u\u2032e\u1D58 : nomme u.',
  chain_ln: '\xC9cris d\u2019abord (ln u)\u2032 = u\u2032 \xF7 u : nomme u.',
  chain_sqrt: '\xC9cris d\u2019abord (\u221Au)\u2032 = u\u2032 \xF7 (2\u221Au) : nomme u.',
  chain_pow:
    '\xC9cris d\u2019abord (u\u207F)\u2032 = n \xD7 u\u2032 \xD7 u\u207F\u207B\xB9 : nomme u.',
  chain_trig:
    '\xC9cris d\u2019abord (cos u)\u2032 = \u2212u\u2032 sin u, (sin u)\u2032 = u\u2032 cos u : nomme u.',
  chain_arc: '\xC9cris d\u2019abord (arctan u)\u2032 = u\u2032 \xF7 (1 + u\xB2) : nomme u.',
};
function uK(e, n) {
  return e.known.some((t) => t.length > n.length && n.every((r, s) => t[s] === r));
}
function GS(e, n, t) {
  let r = n.flatMap((a) => a.atoms);
  if (!r.length) return { kind: 'empty', atoms: r, badChip: -1 };
  let s = uK(e, r),
    i;
  try {
    i = HS(e, r);
  } catch (a) {
    return t?.verify
      ? a instanceof Si
        ? { kind: 'syntax', atoms: r, line: vm(r), title: 'Une \xE9galit\xE9', message: a.message }
        : {
            kind: 'syntax',
            atoms: r,
            title: '\xC7a ne se lit pas',
            message: 'Termine ta ligne : il manque un morceau.',
            badChip: n.length - 1,
          }
      : { kind: s ? 'building' : 'open', atoms: r, complete: !1 };
  }
  let o = $W(e, r, i);
  return s && !t?.verify
    ? o.kind === 'step'
      ? { ...o, kind: 'ready', complete: !0 }
      : { kind: 'building', atoms: r, complete: !0 }
    : !t?.verify && (o.kind === 'unjustified' || o.kind === 'false')
      ? { kind: 'pending', atoms: r, complete: !0 }
      : { ...o, complete: !0 };
}
function Zk(e, n, t, r, s) {
  let i = as(r.atoms),
    o = e.traps.find((a) => a.text === i || (a.kind === n && Vn(a.vec, t)));
  return o
    ? {
        kind: 'trap',
        ...r,
        title: o.title,
        message: o.why,
        trap: { line: o.line, title: o.title, why: o.why },
      }
    : { kind: 'false', ...r, title: s.title, message: s.message };
}
function VS(e, n, t) {
  let r = BS(n).replace('(x)', `(${e.x})`);
  return n.primes > 1
    ? {
        kind: 'unjustified',
        ...t,
        title: 'Une d\xE9riv\xE9e \xE0 la fois',
        message: 'Ici, on ne d\xE9rive qu\u2019une fois.',
      }
    : {
        kind: 'unjustified',
        ...t,
        title: `Nomme d\u2019abord ${n.base}`,
        message:
          n.primes === 0
            ? `\xC9cris d\u2019abord ce que vaut ${r} : \xAB ${r} = \u2026 \xBB.`
            : `\xC9cris d\u2019abord ${n.base}(${e.x}) = \u2026, puis sa d\xE9riv\xE9e.`,
      };
}
function $W(e, n, t) {
  let r = { atoms: n, line: vm(n) };
  if (e.givenTexts.has(as(n)))
    return {
      kind: 'useless',
      ...r,
      title: 'C\u2019est l\u2019\xE9nonc\xE9',
      message: 'Cette ligne est dans l\u2019\xE9nonc\xE9 : \xE9cris la suivante.',
    };
  let { head: s, members: i } = t,
    o = Jk(e, s);
  if (s.primes > 1) return VS(e, s, r);
  if (e.goal === 'antiderivative' && s.base === e.tBase && s.primes === 1)
    return {
      kind: 'useless',
      ...r,
      title: 'C\u2019est la d\xE9finition',
      message: `On cherche ${US(e)} : \xE9cris \xAB ${e.tBase}(${e.x}) = \u2026 \xBB.`,
    };
  if (e.goal === 'antiderivative' && s.base === e.fBase && s.primes === 1)
    return {
      kind: 'useless',
      ...r,
      title: 'On cherche une primitive',
      message: `Ici, on ne d\xE9rive pas ${e.fBase} : on cherche ${US(e)}.`,
    };
  for (let a of i)
    for (let l of xa(e, a)) {
      if (l.base === e.tBase && e.goal === 'antiderivative')
        return {
          kind: 'unjustified',
          ...r,
          title: '\xC9cris F',
          message: `\xC9cris l\u2019expression de ${e.tBase}(${e.x}), sans ${e.tBase} dedans.`,
        };
      if (!WS(e, l)) return VS(e, l, r);
    }
  return o === 'name'
    ? CW(e, r, s, i)
    : o === 'deriv' && !e.names.has(s.base)
      ? VS(e, { base: s.base, primes: 0 }, r)
      : o === 'deriv'
        ? EW(e, r, s, i)
        : o === 'f'
          ? _W(e, r, i)
          : e.goal === 'differentiate'
            ? qW(e, r, i)
            : LW(e, r, i);
}
function CW(e, n, t, r) {
  let s = r.map((c) => ya(e, c));
  if (!s.every((c) => Vn(c, s[0])))
    return {
      kind: 'false',
      ...n,
      title: 'Pas la m\xEAme fonction',
      message: 'Les membres de ta ligne ne sont pas \xE9gaux.',
    };
  let i = s[0],
    o = e.names.get(t.base);
  if (o)
    return Vn(o.vec, i)
      ? {
          kind: 'useless',
          ...n,
          title: 'Rien de nouveau',
          message: `${t.base} est d\xE9j\xE0 nomm\xE9.`,
        }
      : {
          kind: 'false',
          ...n,
          title: `${t.base} est d\xE9j\xE0 pris`,
          message: `${t.base}(${e.x}) a d\xE9j\xE0 une autre expression : choisis une autre lettre.`,
        };
  if (!e.fForms.some((c) => V_(c, e.x).some((f) => Vn(bn(e, f), i))))
    return {
      kind: 'useless',
      ...n,
      title: `Pas une partie de ${e.fBase}`,
      message: `${t.base} doit \xEAtre une partie de ${e.fBase} : un facteur, le num\xE9rateur, le d\xE9nominateur, ce qui est sous une fonction\u2026`,
    };
  let l = (() => {
      let c = ru(e, r[r.length - 1]);
      return 'missing' in c ? r[0] : c.t;
    })(),
    u = Wt.name;
  return {
    kind: 'step',
    ...n,
    hora: u.hora,
    rule: {
      id: Hg.name,
      card: e.goal === 'differentiate' ? Hk : Wg,
      label: `Nommer ${t.base}`,
      hora: u.hora,
      why: u.why,
    },
    amove: { kind: 'name', base: t.base, members: r, value: l },
  };
}
function EW(e, n, t, r) {
  let s = e.names.get(t.base),
    i = su(s.def, e.x);
  if (!i)
    return { kind: 'unjustified', ...n, title: 'Je ne sais pas d\xE9river \xE7a', message: '' };
  let o = bn(e, i);
  for (let p of r) {
    let g = ya(e, p);
    if (!Vn(g, o)) {
      let h = xd(g, o);
      return {
        kind: 'false',
        ...n,
        title: h !== null && nn(h, -1) ? 'Le signe' : 'D\xE9riv\xE9e fausse',
        message: `Ce n\u2019est pas la d\xE9riv\xE9e de ${t.base}(${e.x}).`,
      };
    }
  }
  if (e.derivs.has(t.base))
    return {
      kind: 'useless',
      ...n,
      title: 'Rien de nouveau',
      message: `${t.base}\u2032(${e.x}) est d\xE9j\xE0 \xE9crite.`,
    };
  let a = aK(e, [s.def], r[0]);
  if ('fail' in a)
    return {
      kind: 'unjustified',
      ...n,
      title: 'Montre le calcul',
      message: lK[a.fail[0] ?? 'usual'],
    };
  if (a.nested.length) return cK(e, n, a.nested[0]);
  let l = a.rules,
    u = l.length === 1 && l[0] === 'usual',
    c = u ? 1 : l.reduce((p, g) => p + (g === 'usual' ? 0 : Wt[g].hora), 0),
    f = [];
  for (let p = 1; p < r.length; p++) km(r[p - 1], r[p]) || (f.push('rewrite'), (c += 1));
  let d = u ? 'usual' : l.find((p) => p !== 'usual'),
    m = ru(e, r[r.length - 1]);
  return {
    kind: 'step',
    ...n,
    hora: c,
    rule: {
      id: Hg[d],
      card: Hk,
      label: u ? `D\xE9river ${t.base}` : Wt[d].label,
      hora: c,
      why: [...new Set([d, ...f])].map((p) => Wt[p].why).join(' '),
    },
    amove: { kind: 'deriv', base: t.base, members: r, value: 'missing' in m ? i : m.t },
  };
}
function cK(e, n, t) {
  return {
    kind: 'unjustified',
    ...n,
    title: 'Une d\xE9riv\xE9e \xE0 la fois',
    message: `Deux r\xE8gles d\u2019un coup : nomme d\u2019abord ${MW(t)} (v(${e.x}) = \u2026) et \xE9cris sa d\xE9riv\xE9e.`,
  };
}
var MW = (e) => oe(e);
function _W(e, n, t) {
  for (let a of t) {
    let l = ya(e, a);
    if (!Vn(l, e.fVec))
      return Zk(e, 'f', l, n, {
        title: `Ce n\u2019est pas ${e.fBase}`,
        message: `Ta ligne ne donne pas la m\xEAme fonction que ${e.fBase} : v\xE9rifie le calcul.`,
      });
  }
  let r = e.fForms[e.fForms.length - 1],
    s = [],
    i = 0;
  for (let a of t) {
    let l = ru(e, a),
      u = 'missing' in l ? a : l.t;
    if (e.fForms.some((c) => km(c, u)) || km(r, u)) {
      r = u;
      continue;
    }
    (s.push(JS(r, u)), (i += 1), (r = u));
  }
  if (!i)
    return {
      kind: 'useless',
      ...n,
      title: 'Rien de nouveau',
      message: `Cette \xE9criture de ${e.fBase} est d\xE9j\xE0 l\xE0.`,
    };
  let o = s.length === 1 ? s[0] : `R\xE9\xE9crire ${e.fBase}`;
  return {
    kind: 'step',
    ...n,
    hora: i,
    rule: {
      id: Hg.rewrite,
      card: e.goal === 'differentiate' ? Hk : Wg,
      label: o,
      hora: i,
      why: `${e.fBase} \xE9crite autrement : souvent, une forme plus simple \xE0 ${e.goal === 'differentiate' ? 'd\xE9river' : 'int\xE9grer'}.`,
    },
    amove: {
      kind: 'f',
      base: e.fBase,
      members: t.map((a) => {
        let l = ru(e, a);
        return 'missing' in l ? a : l.t;
      }),
    },
  };
}
function JS(e, n) {
  let t = kl(e).length,
    r = kl(n).length;
  return t === 1 && r > 1 && e.k === 'div'
    ? 'S\xE9parer la fraction'
    : t === 1 && r > 1
      ? 'D\xE9velopper'
      : r === 1 && t > 1
        ? n.k === 'div'
          ? 'R\xE9duire au m\xEAme d\xE9nominateur'
          : 'Factoriser'
        : r > t
          ? 'D\xE9velopper'
          : r < t
            ? 'R\xE9duire'
            : 'Simplifier';
}
function qW(e, n, t) {
  for (let c of t) {
    let f = ya(e, c);
    if (!Vn(f, e.want)) return Zk(e, 'target', f, n, TW(e, f));
  }
  let r = [],
    s = [],
    i = e.targets.length ? e.targets[e.targets.length - 1] : null,
    o = !1;
  for (let c of t) {
    if (i === null) {
      let f = aK(e, e.fForms, c);
      if ('fail' in f)
        return {
          kind: 'unjustified',
          ...n,
          title: 'Montre le calcul',
          message: lK[f.fail.find((p) => p !== 'usual') ?? f.fail[0] ?? 'usual'],
        };
      if (f.nested.length) return cK(e, n, f.nested[0]);
      let d = f.rules.length > 1 ? f.rules.filter((p) => p !== 'usual') : f.rules,
        m = new Set(
          xa(e, c)
            .map((p) => p.base)
            .filter((p) => p !== e.fBase),
        );
      (d.length === 1 &&
        d[0] === 'usual' &&
        m.size &&
        (d = [m.size >= 2 ? (Zg(c) ? 'quotient' : 'product') : Zg(c) ? 'inverse' : 'chain']),
        r.push(...d),
        s.push(
          d.length === 1 && d[0] === 'usual' && f.affine ? 'D\xE9river g(ax + b)' : Wt[d[0]].label,
        ),
        (o = !0));
    } else {
      let f = OW(e, i, c);
      if (f === 'same') {
        i = c;
        continue;
      }
      if (f === 'jump')
        return {
          kind: 'unjustified',
          ...n,
          title: 'Une \xE9tape \xE0 la fois',
          message: 'Remplace d\u2019abord chaque nom par son expression, puis fais les calculs.',
        };
      if (f === 'names')
        return {
          kind: 'unjustified',
          ...n,
          title: 'Dans l\u2019ordre',
          message: 'Les noms (u, v\u2026) s\u2019\xE9crivent dans la formule, avant de remplacer.',
        };
      (r.push(f === 'substitute' ? 'substitute' : 'rewrite'),
        s.push(f === 'substitute' ? Wt.substitute.label : f));
    }
    i = c;
  }
  if (!r.length)
    return {
      kind: 'useless',
      ...n,
      title: 'Rien de nouveau',
      message: 'Cette ligne redit ce qui est d\xE9j\xE0 \xE9crit.',
    };
  let a = t[t.length - 1],
    l = xa(e, a).length === 0,
    u = !e.concluded && l && ns(a) <= e.answerSize;
  return Xk(e, n, r, s, u, { kind: 'target', base: e.tBase, members: t, final: u, ruled: o });
}
function LW(e, n, t) {
  let r = e.point?.kind === 'condition' ? e.point : null,
    s = [];
  for (let d of t) {
    let m = ru(e, d),
      p = 'missing' in m ? d : m.t;
    s.push(p);
    let g = su(p, e.x),
      h = g ? bn(e, g) : null;
    if (!h || !Vn(h, e.fVec)) {
      let b = bn(e, p);
      return Zk(e, 'target', b, n, RW(e, h ?? b, b));
    }
    if (r && !va(p) && !dK(e, p)) return Zk(e, 'target', bn(e, p), n, KW(e, p));
  }
  let i = [],
    o = [],
    a = e.targets.length ? e.targets[e.targets.length - 1] : null,
    l = a ? eT(e, a) : null;
  for (let d = 0; d < t.length; d++) {
    let m = s[d],
      p = t[d];
    if (l && a && Vn(bn(e, l), bn(e, m))) {
      (xa(e, a).length && !xa(e, p).length
        ? (i.push('substitute'), o.push(Wt.substitute.label))
        : km(a, p) || (i.push('rewrite'), o.push(JS(l, m))),
        (l = m),
        (a = p));
      continue;
    }
    if (r && l && va(l) && !va(m) && s0(bn(e, m), bn(e, l)) !== null) {
      (r.c !== null
        ? (i.push('substitute'), o.push('Remplacer C'))
        : (i.push('condition'),
          o.push(`Utiliser ${r.condText}`),
          r.values.has(r.condHead) || (i.push('point'), o.push(`Calculer ${r.condHead}`))),
        (l = m),
        (a = p));
      continue;
    }
    let g = Pp(m, e.x, () => null);
    if (
      !(
        !!g &&
        e.fForms.some((v) => {
          let k = tu(e, v);
          if (!k) return !1;
          let y = g.pieces.map((w) => bn(e, w)),
            S = g.den ? y.map((w) => oK(w, bn(e, g.den))) : y;
          return Yo(
            k,
            S.filter((w) => !zS(w)),
          );
        })
      )
    )
      return {
        kind: 'unjustified',
        ...n,
        title: 'Montre comment',
        message: `\xC9cris d\u2019abord ${e.fBase} comme une somme de formes connues (x\u207F, u\u2032e\u1D58, u\u2032 \xF7 u, u\u2032u\u207F\u2026).`,
      };
    let b = g.rules.every((v) => v === 'usual');
    (i.push(b ? 'primitive' : 'recognize'),
      o.push(b ? Wt.primitive.label : NW(g.rules)),
      r && !va(m) && (i.push('condition'), o.push(`Utiliser ${r.condText}`)),
      (l = m),
      (a = p));
  }
  if (!i.length)
    return {
      kind: 'useless',
      ...n,
      title: 'Rien de nouveau',
      message: 'Cette primitive est d\xE9j\xE0 \xE9crite.',
    };
  let u = s[s.length - 1],
    c = xa(e, t[t.length - 1]).length === 0,
    f = !e.concluded && c && ns(sK(u, e.x)) <= e.answerSize && (!r || !va(u));
  return Xk(e, n, i, o, f, { kind: 'target', base: e.tBase, members: t, final: f, ruled: !0 });
}
function NW(e) {
  switch (e.find((t) => t !== 'usual')) {
    case 'chain_exp':
      return 'Reconna\xEEtre u\u2032e\u1D58';
    case 'chain_ln':
      return 'Reconna\xEEtre u\u2032 \xF7 u';
    case 'chain_pow':
      return 'Reconna\xEEtre u\u2032u\u207F';
    case 'chain_sqrt':
      return 'Reconna\xEEtre u\u2032 \xF7 \u221Au';
    case 'chain_trig':
      return 'Reconna\xEEtre u\u2032 cos u';
    case 'chain_arc':
      return 'Reconna\xEEtre u\u2032 \xF7 (1 + u\xB2)';
    default:
      return Wt.recognize.label;
  }
}
function OW(e, n, t) {
  if (km(n, t)) return 'same';
  let r = new Set(xa(e, n).map(BS)),
    s = xa(e, t).map(BS);
  if (s.some((i) => !r.has(i))) return 'names';
  if (r.size && s.length < r.size) {
    let i = tu(e, n),
      o = tu(e, t),
      a = Zg(n),
      l = Zg(t);
    if (a && l) {
      let u = ya(e, a.d),
        c = ya(e, l.d),
        f = u && c ? xd(c, u) : null,
        d = tu(e, a.n),
        m = tu(e, l.n);
      return f !== null &&
        !nn(f, 0) &&
        d &&
        m &&
        Yo(
          m.map((p) => iK(p, 1 / f)),
          d,
        )
        ? 'substitute'
        : 'jump';
    }
    return i && o && Yo(o, i) ? 'substitute' : 'jump';
  }
  return r.size ? 'jump' : JS(n, t);
}
function Xk(e, n, t, r, s, i, o) {
  let a = [...new Set(t)],
    l = t.reduce((d, m) => d + Wt[m].hora, 0),
    u = t.reduce((d, m) => (Wt[m].hora > Wt[d].hora ? m : d), t[0]),
    c = r[t.indexOf(u)] ?? Wt[u].label,
    f = a.map((d) => Wt[d].why).join(' ') + (s ? ' C\u2019est la r\xE9ponse.' : '');
  return {
    kind: 'step',
    ...n,
    hora: l,
    final: s,
    rule: {
      id: Hg[u],
      card: o ?? (e.goal === 'differentiate' ? Hk : Wg),
      label: c,
      hora: l,
      why: f,
    },
    amove: i,
  };
}
var va = (e) => $(e).has('C');
function iu(e, n, t, r) {
  if (t === void 0 && $(n).has(e.x)) return null;
  let s = { ...e.env, ...r, ...(t === void 0 ? {} : { [e.x]: t }) };
  try {
    let i = D(n, { ...s, C: Gg }),
      o = D(n, { ...s, C: eK });
    return Number.isFinite(i) && Number.isFinite(o) ? [i, o] : null;
  } catch {
    return null;
  }
}
var fK = (e, n) => nn(e[0], n[0]) && nn(e[1], n[1]);
function dK(e, n) {
  let t = e.point,
    r = iu(e, n, t.a);
  return !!r && nn(r[0], t.value);
}
function KW(e, n) {
  let t = e.point;
  if (!ba(n).some((i) => !$(i).has(e.x)))
    return {
      title: 'Il manque la constante',
      message: `C\u2019est une primitive, mais ${t.condHead} ne vaut pas ${t.valueText} : \xE9cris \xAB ${e.tBase}(${e.x}) = \u2026 + C \xBB, puis calcule C.`,
    };
  let s = iu(e, n, t.a);
  return {
    title: 'La constante',
    message: `Avec cette constante, ${t.condHead} = ${s ? pe(s[0]) : '?'} et non ${t.valueText} : calcule C avec ${t.condText}.`,
  };
}
function Yk(e) {
  for (let n = e.targets.length - 1; n >= 0; n--) {
    let t = eT(e, e.targets[n]);
    if (va(t)) return t;
  }
  return null;
}
function mK(e, n) {
  return Yk(e)
    ? null
    : e.targets.length
      ? {
          kind: 'unjustified',
          ...n,
          title: 'Ajoute la constante',
          message: `Les primitives de ${e.fBase} s\u2019\xE9crivent \xAB ${e.tBase}(${e.x}) = \u2026 + C \xBB : \xE9cris-les avec C.`,
        }
      : {
          kind: 'unjustified',
          ...n,
          title: `\xC9cris d\u2019abord ${e.tBase}(${e.x})`,
          message: `\xC9cris d\u2019abord les primitives : \xAB ${e.tBase}(${e.x}) = \u2026 + C \xBB.`,
        };
}
function pK(e, n) {
  let t = e.point,
    r = iu(e, n, t.a);
  if (!r) return null;
  let s = (r[1] - r[0]) / (eK - Gg);
  return Math.abs(s) < 1e-12 ? null : Gg + (t.value - r[0]) / s;
}
function XS(e, n) {
  let t = e.point;
  if (!t || !n) return null;
  if (t.kind === 'tangent' && n === 'y') return { kind: 'y' };
  if (t.kind === 'condition' && n === 'C') return { kind: 'c' };
  let r = ef.exec(n);
  if (!r || r[3] !== t.at) return null;
  let s = r[2].length;
  return t.kind === 'tangent' && r[1] === e.fBase && s <= 1
    ? { kind: 'value', key: n, primes: s }
    : t.kind === 'condition' && n === t.condHead
      ? { kind: 'value', key: n, primes: s }
      : null;
}
function YS(e, n) {
  let t = Ae(ne(ka(n)), { chains: !0 });
  if (t.dis.length !== 1) throw new Si('Une seule \xE9galit\xE9 par ligne.');
  let r = t.dis[0],
    s = r.sides[0];
  if (
    r.cmp ||
    r.chain ||
    r.rels ||
    r.mod !== void 0 ||
    r.sides.length < 2 ||
    !s ||
    s.k !== 's' ||
    s.n !== n[0]
  )
    throw new Si(`\xC9cris une \xE9galit\xE9 \xAB ${n[0]} = \u2026 \xBB.`);
  try {
    return r.sides.slice(1).map((i) => _e(i));
  } catch (i) {
    throw i instanceof Gr ? new Si('Ce calcul ne se lit pas.') : i;
  }
}
function PW(e, n, t, r) {
  let s = n.flatMap((u) => u.atoms),
    i = uK(e, s),
    o;
  try {
    o = YS(e, s);
  } catch (u) {
    return r?.verify
      ? u instanceof Si
        ? { kind: 'syntax', atoms: s, line: vm(s), title: 'Une \xE9galit\xE9', message: u.message }
        : {
            kind: 'syntax',
            atoms: s,
            title: '\xC7a ne se lit pas',
            message: 'Termine ta ligne : il manque un morceau.',
            badChip: n.length - 1,
          }
      : { kind: i ? 'building' : 'open', atoms: s, complete: !1 };
  }
  let a = { atoms: s, line: vm(s) },
    l = e.givenTexts.has(as(s))
      ? {
          kind: 'useless',
          ...a,
          title: 'C\u2019est l\u2019\xE9nonc\xE9',
          message: 'Cette ligne est dans l\u2019\xE9nonc\xE9 : \xE9cris la suivante.',
        }
      : t.kind === 'value'
        ? AW(e, a, t, o)
        : t.kind === 'c'
          ? QW(e, a, o)
          : FW(e, a, o);
  return i && !r?.verify
    ? l.kind === 'step'
      ? { ...l, kind: 'ready', complete: !0 }
      : { kind: 'building', atoms: s, complete: !0 }
    : !r?.verify && (l.kind === 'unjustified' || l.kind === 'false')
      ? { kind: 'pending', atoms: s, complete: !0 }
      : { ...l, complete: !0 };
}
function gK(e, n) {
  let t = e.point;
  if (t.kind === 'tangent') return n.primes ? [t.fpa, t.fpa] : [t.fa, t.fa];
  let r = Yk(e);
  return r ? iu(e, r, t.a) : null;
}
function IW(e) {
  return e.point?.kind === 'tangent' ? YO : Wg;
}
function AW(e, n, t, r) {
  let s = e.point;
  if (s.kind === 'tangent' && t.primes === 1 && !e.concluded)
    return {
      kind: 'unjustified',
      ...n,
      title: `\xC9cris d\u2019abord ${e.fBase}\u2032(${e.x})`,
      message: `${t.key} se calcule avec l\u2019expression de ${e.fBase}\u2032 : d\xE9rive d\u2019abord ${e.fBase}.`,
    };
  if (s.kind === 'condition') {
    let a = mK(e, n);
    if (a) return a;
  }
  let i = gK(e, t);
  for (let a of r) {
    if ($(a).has(e.x))
      return {
        kind: 'unjustified',
        ...n,
        title: `Remplace ${e.x}`,
        message: `Dans ${t.key}, ${e.x} vaut ${s.at} : remplace-le partout.`,
      };
    let l = iu(e, a);
    if (!l || !fK(l, i)) return { kind: 'false', ...n, ...jW(e, t, l) };
  }
  if (s.values.has(t.key))
    return {
      kind: 'useless',
      ...n,
      title: 'Rien de nouveau',
      message: `${t.key} est d\xE9j\xE0 calcul\xE9.`,
    };
  let o = Wt.point;
  return {
    kind: 'step',
    ...n,
    hora: o.hora,
    rule: { id: Hg.point, card: IW(e), label: `Calculer ${t.key}`, hora: o.hora, why: o.why },
    amove: { kind: 'value', base: t.key, members: r, pair: i },
  };
}
function jW(e, n, t) {
  let r = e.point;
  if (r.kind === 'tangent') {
    let s = `${e.fBase}(${r.at})`,
      i = `${e.fBase}\u2032(${r.at})`;
    if (t && !nn(r.fa, r.fpa)) {
      if (n.primes === 0 && nn(t[0], r.fpa))
        return {
          title: `C\u2019est ${i}`,
          message: `${s} se calcule avec l\u2019expression de ${e.fBase}, pas avec celle de ${e.fBase}\u2032.`,
        };
      if (n.primes === 1 && nn(t[0], r.fa))
        return {
          title: `C\u2019est ${s}`,
          message: `${i} se calcule avec l\u2019expression de ${e.fBase}\u2032 (la d\xE9riv\xE9e), pas avec celle de ${e.fBase}.`,
        };
    }
    return {
      title: `Ce n\u2019est pas ${n.key}`,
      message: `Remplace ${e.x} par ${r.at} dans ${e.fBase}${n.primes ? '\u2032' : ''}(${e.x}), puis calcule.`,
    };
  }
  return {
    title: `Ce n\u2019est pas ${n.key}`,
    message: `Remplace ${e.x} par ${r.at} dans ta primitive \xAB ${e.tBase}(${e.x}) = \u2026 + C \xBB : C reste C.`,
  };
}
function QW(e, n, t) {
  let r = e.point,
    s = mK(e, n);
  if (s) return s;
  let i = pK(e, Yk(e));
  if (i === null)
    return {
      kind: 'unjustified',
      ...n,
      title: 'O\xF9 est C ?',
      message: `${r.condHead} ne d\xE9pend pas de C : \xE9cris \xAB ${e.tBase}(${e.x}) = \u2026 + C \xBB.`,
    };
  for (let l of t) {
    if ($(l).has(e.x) || va(l))
      return {
        kind: 'unjustified',
        ...n,
        title: 'Une valeur',
        message: '\xC9cris la valeur de C : \xAB C = \u2026 \xBB.',
      };
    let u = iu(e, l);
    if (!u || !nn(u[0], i))
      return {
        kind: 'false',
        ...n,
        title: 'Pas cette valeur',
        message: `Avec C = ${u ? pe(u[0]) : '?'}, ${r.condHead} ne vaut pas ${r.valueText} : \xE9cris ${r.condHead} avec ta primitive, \xE9gale-le \xE0 ${r.valueText}, puis r\xE9sous.`,
      };
  }
  if (r.c !== null && nn(r.c, i))
    return {
      kind: 'useless',
      ...n,
      title: 'Rien de nouveau',
      message: 'C est d\xE9j\xE0 trouv\xE9e.',
    };
  let o = ['condition'],
    a = [`Utiliser ${r.condText}`];
  return (
    r.values.has(r.condHead) || (o.push('point'), a.push(`Calculer ${r.condHead}`)),
    Xk(e, n, o, a, !1, { kind: 'c', base: 'C', members: t, pair: [i, i] }, Wg)
  );
}
function FW(e, n, t) {
  let r = e.point,
    s = `${e.fBase}(${r.at})`,
    i = `${e.fBase}\u2032(${r.at})`,
    o = { ...e.env, [s]: r.fa, [i]: r.fpa },
    a = (g) => ov(g, e.x, e.points, o),
    l = (g) => [...$(g)].filter((h) => h === s || h === i);
  for (let g of t) {
    let h = a(g);
    if (!Vn(h, r.tangent)) return { kind: 'false', ...n, ...VW(e, h) };
  }
  if (!(e.concluded || r.values.has(i)) && t.some((g) => !$(g).has(i)))
    return {
      kind: 'unjustified',
      ...n,
      title: `Calcule d\u2019abord ${i}`,
      message: `La pente de la tangente est ${i} : d\xE9rive ${e.fBase}, puis calcule ${i}.`,
    };
  let c = [],
    f = [],
    d = r.ys.length ? r.ys[r.ys.length - 1] : null;
  for (let g of t) {
    if (d === null) {
      let h = e.points.map((v) => r.fpa * (v - r.a)),
        b = e.points.map(() => r.fa);
      if (!Yo(ba(g).map(a), [h, b]))
        return {
          kind: 'unjustified',
          ...n,
          title: '\xC9cris la formule',
          message: `La tangente en ${r.at} : \xAB y = ${i} \xD7 (${e.x} \u2212 ${r.at}) + ${s} \xBB, puis remplace.`,
        };
      (c.push('tangent'), f.push(Wt.tangent.label));
    } else {
      if (km(d, g)) {
        d = g;
        continue;
      }
      let h = l(d).length,
        b = l(g).length;
      if (b > h)
        return {
          kind: 'unjustified',
          ...n,
          title: 'Dans l\u2019ordre',
          message: `${s} et ${i} s\u2019\xE9crivent dans la formule, avant de remplacer.`,
        };
      if (b < h) {
        if (!Yo(ba(g).map(a), ba(d).map(a)))
          return {
            kind: 'unjustified',
            ...n,
            title: 'Une \xE9tape \xE0 la fois',
            message: 'Remplace d\u2019abord chaque nom par sa valeur, puis r\xE9duis.',
          };
        (c.push('substitute'), f.push(Wt.substitute.label));
      } else
        (c.push('rewrite'), f.push(ba(g).length > ba(d).length ? 'D\xE9velopper' : 'R\xE9duire'));
    }
    d = g;
  }
  if (!c.length)
    return {
      kind: 'useless',
      ...n,
      title: 'Rien de nouveau',
      message: 'Cette ligne redit ce qui est d\xE9j\xE0 \xE9crit.',
    };
  let m = t[t.length - 1],
    p = !r.concluded && !l(m).length && ns(m) <= r.answerSize;
  return Xk(e, n, c, f, p, { kind: 'y', base: 'y', members: t, final: p }, YO);
}
function VW(e, n) {
  let t = e.point,
    r = `${e.fBase}(${t.at})`,
    s = `${e.fBase}\u2032(${t.at})`,
    i = `y = ${s}(${e.x} \u2212 ${t.at}) + ${r}`,
    o = (a) => e.points.map(a);
  return !nn(t.fpa, 0) &&
    Vn(
      n,
      o(() => t.fa),
    )
    ? { title: 'La pente', message: `La tangente a pour pente ${s} : ${i}.` }
    : !nn(t.a, 0) &&
        Vn(
          n,
          o((a) => t.fpa * a + t.fa),
        )
      ? {
          title: `${e.x} \u2212 ${t.at}`,
          message: `${i} : n\u2019oublie pas \xAB \u2212 ${t.at} \xBB.`,
        }
      : Vn(
            n,
            o((a) => t.fa * (a - t.a) + t.fpa),
          )
        ? {
            title: 'Dans l\u2019ordre',
            message: `La pente est ${s}, la valeur au point est ${r} : ${i}.`,
          }
        : !nn(t.fa, 0) &&
            Vn(
              n,
              o((a) => t.fpa * (a - t.a)),
            )
          ? { title: `Il manque ${r}`, message: `${i} : ajoute ${r}.` }
          : {
              title: 'Pas la tangente',
              message: `Ce n\u2019est pas la tangente en ${t.at} : ${i}.`,
            };
}
function DW(e, n) {
  let t = n.amove,
    r = e.point;
  (t.kind === 'value' && r.values.set(t.base, t.pair),
    t.kind === 'c' && (r.c = t.pair[0]),
    t.kind === 'y' && (r.ys.push(t.members[t.members.length - 1]), t.final && (r.concluded = !0)),
    e.lines.push({ text: as(n.atoms) }));
}
function hK(e, n, t) {
  let r;
  try {
    r = YS(e, Ht(n));
  } catch {
    return !1;
  }
  let s = e.point;
  if (t.kind === 'y') {
    let o = { ...e.env, [`${e.fBase}(${s.at})`]: s.fa, [`${e.fBase}\u2032(${s.at})`]: s.fpa };
    return r.every((a) => Vn(ov(a, e.x, e.points, o), s.tangent));
  }
  if (t.kind === 'c') {
    let o = Yk(e),
      a = o ? pK(e, o) : null;
    return (
      a !== null &&
      r.every((l) => {
        let u = iu(e, l);
        return !!u && nn(u[0], a);
      })
    );
  }
  let i = gK(e, t);
  return (
    !!i &&
    r.every((o) => {
      let a = iu(e, o);
      return !!a && fK(a, i);
    })
  );
}
function XO(e, n) {
  let t = n.amove;
  if (t) {
    switch (t.kind) {
      case 'name':
        e.names.set(t.base, { def: t.value, vec: bn(e, t.value) });
        break;
      case 'deriv':
        e.derivs.set(t.base, { expr: t.value, vec: bn(e, t.value) });
        break;
      case 'f':
        t.members.forEach((r) => {
          e.fForms.some((s) => E(R(s)) === E(R(r))) || e.fForms.push(r);
        });
        break;
      case 'target':
        (e.targets.push(t.members[t.members.length - 1]), t.final && (e.concluded = !0));
        break;
    }
    e.lines.push({ text: as(n.atoms) });
  }
}
function BW(e, n) {
  return !e.second || n === 0 ? e : n === 2 || e.concluded ? e.second : e;
}
var zW = (e, n) => {
  let t = ef.exec(n ?? '');
  return t && t[1] === e.fBase && t[3] === e.x ? t[2].length : -1;
};
function UW(e, n, t) {
  let r = e.point,
    s = XS(e, n[0]?.atoms[0]);
  if (s) return PW(e, n, s, t);
  let i = GS(e, n, t);
  return r.kind !== 'tangent' || !i.final
    ? i
    : {
        ...i,
        final: !1,
        ...(i.rule && {
          rule: {
            ...i.rule,
            why: i.rule.why.replace(
              ' C\u2019est la r\xE9ponse.',
              ` Calcule maintenant ${e.fBase}(${r.at}) et ${e.fBase}\u2032(${r.at}).`,
            ),
          },
        }),
      };
}
function Xg(e, n, t) {
  if (e.arcs && !cc()) return Wk(e, () => Xg(e, n, t));
  if (e.point) return UW(e, n, t);
  if (!e.second) return GS(e, n, t);
  let r = n.flatMap((a) => a.atoms),
    s = zW(e, r[0]),
    i = BW(e, s),
    o = GS(i, n, t);
  return i === e
    ? o.final
      ? {
          ...o,
          final: !1,
          ...(o.rule && {
            rule: {
              ...o.rule,
              why: o.rule.why.replace(
                ' C\u2019est la r\xE9ponse.',
                ` D\xE9rive-la \xE0 son tour : ${e.fBase}\u2032\u2032 est la d\xE9riv\xE9e de ${e.fBase}\u2032.`,
              ),
            },
          }),
        }
      : o
    : !e.concluded && (o.kind === 'step' || o.kind === 'ready')
      ? t?.verify
        ? {
            kind: 'useless',
            atoms: r,
            line: vm(r),
            complete: !0,
            title: `\xC9cris d\u2019abord ${e.fBase}\u2032(${e.x})`,
            message: `Ta ligne est juste, mais ${e.fBase}\u2032\u2032 est la d\xE9riv\xE9e de ${e.fBase}\u2032 : \xE9cris ${e.fBase}\u2032(${e.x}) = \u2026, puis d\xE9rive-la. Tu peux garder cette ligne sans HORA.`,
            stage: 2,
          }
        : { kind: 'pending', atoms: r, complete: !0 }
      : { ...o, stage: 2 };
}
function Yg(e, n) {
  if (e.arcs && !cc()) return Wk(e, () => Yg(e, n));
  let t = n.amove?.kind;
  if (e.point && (t === 'value' || t === 'c' || t === 'y')) {
    DW(e, n);
    return;
  }
  if (e.second && n.stage === 2) {
    (XO(e.second, n), n.amove && e.lines.push({ text: as(n.atoms) }));
    return;
  }
  XO(e, n);
  let r = n.amove;
  if (e.second && r?.kind === 'target') {
    let s = r.members[r.members.length - 1];
    e.second.fForms.some((i) => E(R(i)) === E(R(s))) || e.second.fForms.push(s);
  }
}
function eh(e, n) {
  if (e.arcs && !cc()) return Wk(e, () => eh(e, n));
  let t = XS(e, Ht(n)[0]);
  return t
    ? hK(e, n, t)
    : e.second
      ? Gk(n, e.fBase, e.x) === 2
        ? Ug(e.second, n)
        : Ug(e, n) || (e.concluded && Ug(e.second, n))
      : Ug(e, n);
}
function ex(e, n) {
  if (e.arcs && !cc()) return Wk(e, () => ex(e, n));
  let t = e.point;
  if (t?.kind === 'tangent') {
    let r = XS(e, Ht(n)[0]);
    if (r?.kind !== 'y' || !hK(e, n, r)) return !1;
    try {
      let s = YS(e, Ht(n)),
        i = new Set([`${e.fBase}(${t.at})`, `${e.fBase}\u2032(${t.at})`]);
      return s.every((o) => ![...$(o)].some((a) => i.has(a)));
    } catch {
      return !1;
    }
  }
  return GW(e.second ?? e, n);
}
function bK(e) {
  return e.point?.kind === 'tangent' ? e.point.concluded : (e.second ?? e).concluded;
}
function vK(e, n) {
  try {
    return HS(e, Ht(n));
  } catch {
    return null;
  }
}
function Ug(e, n) {
  let t = vK(e, n);
  if (!t) return !1;
  let r = Jk(e, t.head);
  return t.members.every((s) => {
    let i = ru(e, s);
    if ('missing' in i) return !1;
    if (r === 'target') {
      if (e.goal === 'differentiate') return Vn(bn(e, i.t), e.want);
      let a = su(i.t, e.x);
      return !a || !Vn(bn(e, a), e.fVec)
        ? !1
        : e.point?.kind !== 'condition' || va(i.t) || dK(e, i.t);
    }
    if (r === 'f') return Vn(bn(e, i.t), e.fVec);
    let o = WS(e, t.head);
    return !!o && Vn(bn(e, i.t), bn(e, o));
  });
}
function GW(e, n) {
  let t = vK(e, n);
  return !t ||
    Jk(e, t.head) !== 'target' ||
    t.members.some((r) => xa(e, r).length) ||
    (e.point?.kind === 'condition' && t.members.some((r) => va(eT(e, r))))
    ? !1
    : Ug(e, n);
}
var eT = (e, n) => {
  let t = ru(e, n);
  return 'missing' in t ? n : t.t;
};
var WW = { table: 'variations.table@1' },
  kK = {
    id: WW.table,
    card: 'Variations',
    label: 'Tableau de variations',
    hora: 3,
    why: 'Le signe de f\u2032 donne le sens de variation de f : l\xE0 o\xF9 f\u2032 est positive, f cro\xEEt (\u2197) ; l\xE0 o\xF9 elle est n\xE9gative, f d\xE9cro\xEEt (\u2198). Sous chaque valeur o\xF9 f\u2032 s\u2019annule, la valeur de f.',
  },
  Qs = class extends Error {},
  JW = /^\s*([A-Za-z])(′*)\(\s*([a-zα-ω])\s*\)\s*$/;
function xm(e) {
  let n = e.indexOf('=');
  if (n < 0 || e.indexOf('=', n + 1) >= 0) return null;
  let t = JW.exec(e.slice(0, n).replace(/'/g, '\u2032'));
  if (!t) return null;
  let r;
  try {
    let s = Ae(ne(ka(Ht(e))), { chains: !0 }),
      i = s.dis[0];
    if (s.dis.length !== 1 || !i || i.sides.length !== 2) return null;
    r = R(_e(i.sides[1]));
  } catch {
    return null;
  }
  return { base: t[1], primes: t[2].length, x: t[3], expr: r };
}
function tT(e) {
  let n = ie(e);
  return !n.ok || n.s.k !== 'expr' ? null : Number.isFinite(D(n.s.e, {})) ? n.s.e : null;
}
var XW = { '<': '>', '>': '<', '\u2264': '\u2265', '\u2265': '\u2264', '=': '=' };
function YW(e, n) {
  let t = ie(e);
  if (!t.ok || t.s.k === 'or' || t.s.k === 'expr' || (t.s.k === 'set' && t.s.clauses.length !== 1))
    return null;
  let r = { lo: -1 / 0, hi: 1 / 0, loC: !1, hiC: !1 };
  for (let s of on(t.s)) {
    let i = s.l.k === 'sym' && s.l.n === n,
      o = s.r.k === 'sym' && s.r.n === n;
    if (i === o) return null;
    let a = D(i ? s.r : s.l, {});
    if (!Number.isFinite(a)) return null;
    let l = i ? s.rel : XW[s.rel];
    if (l === '=') return null;
    l === '<' || l === '\u2264'
      ? ((r.hi = a), (r.hiC = l === '\u2264'))
      : ((r.lo = a), (r.loC = l === '\u2265'));
  }
  return r.lo < r.hi ? r : null;
}
var xK = { lo: -1 / 0, hi: 1 / 0, loC: !1, hiC: !1 },
  nf = 1e-9;
function e7(e, n) {
  if (!e.fExpr) return null;
  let t = R(j(e.fExpr, { [e.x]: n }));
  return Number.isFinite(D(t, {})) ? t : null;
}
function iT(e, n) {
  let t = E(R(n));
  if (e.cache.has(t)) return e.cache.get(t);
  let r = null,
    s = Qv(n, e.x);
  if (s) {
    let i = s.rows.map((m) => ({ ...m, cells: [...m.cells] }));
    i[i.length - 1].label = `${e.f}\u2032(${e.x})`;
    let o = i[i.length - 1].cells,
      a = s.values.length,
      l = [],
      u = [],
      c = !0;
    for (let m = 0; m <= a; m++) {
      let p = o[2 * m];
      (p !== '+' && p !== '\u2212' && (c = !1),
        l.push(p === '+' ? '+' : '\u2212'),
        u.push(p === '+' ? '\u2197' : '\u2198'));
    }
    let f = s.values.map((m, p) => o[2 * p + 1] === '\u2016'),
      d = s.values.map((m, p) => (f[p] ? null : e7(e, m)));
    c &&
      (r = {
        sign: { ...s, rows: i, subject: `${e.f}\u2032(${e.x})` },
        arrows: u,
        forbidden: f,
        values: d,
        floats: s.values.map((m) => D(m, {})),
        signs: l,
      });
  }
  return (e.cache.set(t, r), r);
}
function rT(e, n) {
  let t = [],
    r = e.floats.length;
  for (let s = 0; s <= r; s++) {
    let i = s === 0 ? -1 / 0 : e.floats[s - 1],
      o = s === r ? 1 / 0 : e.floats[s];
    Math.max(i, n.lo) < Math.min(o, n.hi) - nf && t.push(s);
  }
  return t;
}
var rx = (e, n) =>
  (e > n.lo + nf || (n.loC && Math.abs(e - n.lo) <= nf)) &&
  (e < n.hi - nf || (n.hiC && Math.abs(e - n.hi) <= nf));
function oT(e, n) {
  return e.floats.some((t, r) => e.forbidden[r] && rx(t, n));
}
function sT(e, n, t) {
  let r = rT(e, n);
  return !!r.length && !oT(e, n) && r.every((s) => e.signs[s] === t);
}
function yK(e, n) {
  return e.sign.values.findIndex((t) => to(t, n));
}
function nT(e, n, t, r) {
  if (!rx(n, t) || oT(e, t)) return !1;
  let s = { lo: t.lo, loC: t.loC, hi: n, hiC: !1 },
    i = { lo: n, loC: !1, hi: t.hi, hiC: t.hiC },
    o = r === 'min' ? '\u2212' : '+',
    a = r === 'min' ? '+' : '\u2212',
    l = s.hi - s.lo <= nf || sT(e, s, o),
    u = i.hi - i.lo <= nf || sT(e, i, a);
  return l && u;
}
function nx(e, n, t) {
  if (n < 0 || e.forbidden[n]) return !1;
  let [r, s] = [e.signs[n], e.signs[n + 1]];
  return t === 'min' ? r === '\u2212' && s === '+' : r === '+' && s === '\u2212';
}
function wK(e, n) {
  let t = e.sign.values.map((r, s) => ({ c: e.floats[s], term: r }));
  return (
    n.loC && Number.isFinite(n.lo) && t.push({ c: n.lo, term: null }),
    n.hiC && Number.isFinite(n.hi) && t.push({ c: n.hi, term: null }),
    t
  );
}
function n7(e, n, t) {
  let r = e.x,
    s = (c) => {
      let f = YW(c, r);
      if (!f) throw new Qs(`intervalle illisible : \xAB ${c} \xBB`);
      return f;
    },
    i = (t.on ?? []).map(s),
    o = i[0] ?? xK,
    a = (t.at ?? []).map((c) => {
      let f = tT(c);
      if (!f) throw new Qs(`abscisse illisible : \xAB ${c} \xBB`);
      return f;
    }),
    l = (c, f) => {
      if (!e.fExpr) throw new Qs('une valeur de f demande f(x) dans `start`');
      if (!c) return !1;
      let d = R(j(e.fExpr, { [r]: c }));
      return to(d, f);
    },
    u = t.value ? tT(t.value) : null;
  if (t.value && !u) throw new Qs(`valeur illisible : \xAB ${t.value} \xBB`);
  switch (t.kind) {
    case 'other':
      return null;
    case 'constant':
      return !1;
    case 'increasing':
    case 'decreasing': {
      let c = t.kind === 'increasing' ? '+' : '\u2212';
      return (i.length ? i : [xK]).every((f) => sT(n, f, c));
    }
    case 'sign': {
      let c = rT(n, o);
      return t.sign === '0'
        ? !1
        : t.sign === 'change'
          ? c.some((f) => n.signs[f] === '+') && c.some((f) => n.signs[f] === '\u2212')
          : !!c.length && c.every((f) => n.signs[f] === t.sign);
    }
    case 'sequence': {
      let c = [];
      for (let f of rT(n, o)) {
        let d = n.signs[f] === '+' ? 'increasing' : 'decreasing';
        c[c.length - 1] !== d && c.push(d);
      }
      return !oT(n, o) && c.join() === (t.seq ?? []).join();
    }
    case 'extrema': {
      let c = n.sign.values.filter((f, d) => nx(n, d, 'min') || nx(n, d, 'max'));
      return c.length === a.length && a.every((f) => c.some((d) => to(d, f)));
    }
    case 'no_extremum': {
      let c = a[0] ? yK(n, a[0]) : -1;
      return c < 0 || n.forbidden[c]
        ? !1
        : n.sign.rows[n.sign.rows.length - 1].cells[2 * c + 1] === '0' &&
            n.signs[c] === n.signs[c + 1];
    }
    case 'no_min':
    case 'no_max': {
      let c = t.kind === 'no_min' ? 'min' : 'max';
      return !wK(n, o).some((f) => nT(n, f.c, o, c));
    }
    case 'min':
    case 'max': {
      let c = t.kind;
      if (a[0]) {
        let d = a[0],
          m = D(d, {}),
          p = yK(n, d);
        return (t.local ? nx(n, p, c) && rx(m, o) : nT(n, m, o, c)) ? (u ? l(d, u) : !0) : !1;
      }
      if (!u) throw new Qs('un extremum sans abscisse ni valeur');
      if (t.local)
        return n.sign.values.some((d, m) => nx(n, m, c) && rx(n.floats[m], o) && l(d, u));
      let f = wK(n, o).find((d) => nT(n, d.c, o, c));
      if (!f) return !1;
      if (!f.term)
        throw new Qs('extremum \xE0 une borne : sa valeur n\u2019est pas dans le tableau');
      return l(f.term, u);
    }
  }
}
function TK(e) {
  let n = e.kernel;
  if (n.plugin !== 'variations' || !n.vclaims)
    throw new Qs('\xC9tude de fonction attendue (plugin \xAB variations \xBB).');
  let t = xm(n.start);
  if (!t || t.primes > 1)
    throw new Qs('D\xE9part attendu : \xAB f(x) = \u2026 \xBB ou \xAB f\u2032(x) = \u2026 \xBB.');
  let { base: r, x: s } = t,
    i = t.primes === 0 ? t.expr : null,
    o = t.primes === 1 ? t.expr : null;
  for (let m of e.givens ?? []) {
    let p = xm(m);
    p && p.base === r && p.x === s && p.primes === 1 && (o = p.expr);
  }
  let a = !!o,
    l = n.path ?? [];
  if (!a && !i) throw new Qs('f\u2032 inconnue : donne f(x) ou f\u2032(x).');
  let u = a ? null : t7(e);
  if (!a && !u) throw new Qs('Le corrig\xE9 doit d\xE9river f (\xAB f\u2032(x) = \u2026 \xBB).');
  let c = u ? Jg(u) : null,
    f = {
      model: e,
      f: r,
      x: s,
      fExpr: i,
      fprime: o,
      given: a,
      ana: c,
      table: null,
      claims: [],
      decisions: n.vclaims.map(() => null),
      single: !!n.single,
      path: l,
      lines: 0,
      texts: [],
      cache: new Map(),
    },
    d = r7(f);
  return ((f.claims = n.vclaims.map((m) => ({ spec: m, truth: d ? n7(f, d, m) : null }))), f);
}
function t7(e) {
  let n = e.kernel;
  if (n?.plugin !== 'variations') return null;
  let t = xm(n.start);
  if (!t || t.primes !== 0) return null;
  let { base: r, x: s } = t;
  if (
    (e.givens ?? []).some((l) => {
      let u = xm(l);
      return !!u && u.base === r && u.primes === 1;
    })
  )
    return null;
  let o = (n.path ?? []).filter((l) => !bi(l)),
    a = [...o].reverse().find((l) => {
      let u = xm(l);
      return !!u && u.base === r && u.primes === 1;
    });
  return a
    ? {
        ...e,
        traps: [],
        kernel: {
          plugin: 'analysis',
          goal: { kind: 'differentiate', target: `${r}\u2032(${s})` },
          start: n.start,
          answer: a,
          path: o,
          ...(n.domain ? { domain: n.domain } : {}),
        },
      }
    : null;
}
function r7(e) {
  let n = e.fprime;
  for (let t of e.path) {
    let r = xm(t);
    r && r.base === e.f && r.primes === 1 && (n = r.expr);
  }
  return n ? iT(e, n) : null;
}
function RK(e) {
  let n = e.claims.map((t) => t.truth);
  if (e.single) {
    let t = n.filter((s) => s === !0).length;
    if (t === 1) return n.map((s) => s === !0);
    let r = n.filter((s) => s === null).length;
    if (!t && r === 1) return n.map((s) => s === null);
  }
  return n;
}
var SK = (e, n) => {
    let t = e.sign.valueTexts,
      r = n === 0 ? '\u2212\u221E' : t[n - 1],
      s = n === t.length ? '+\u221E' : t[n];
    return `]${r} ; ${s}[`;
  },
  tx = (e) => e.replace(/\s+/g, '').replace(/-/g, '\u2212').replace(/'/g, '\u2032');
function $K(e, n) {
  let t = [n],
    r = jv(n);
  if (!r)
    return {
      kind: 'syntax',
      atoms: t,
      title: 'Tableau illisible',
      message: 'Je ne lis pas ce tableau : ouvre-le de nouveau depuis la palette.',
      badChip: 0,
    };
  if (!e.fprime)
    return {
      kind: 'unjustified',
      atoms: t,
      title: `Calcule d\u2019abord ${e.f}\u2032(${e.x})`,
      message: `Le sens de variation de ${e.f} se lit sur le signe de ${e.f}\u2032 : d\xE9rive ${e.f}, puis dresse le tableau.`,
    };
  let s = iT(e, e.fprime);
  if (!s)
    return {
      kind: 'unjustified',
      atoms: t,
      title: `Factorise ${e.f}\u2032(${e.x})`,
      message: `Pour lire le signe de ${e.f}\u2032(${e.x}), \xE9cris-la comme un produit (ou un quotient) de facteurs dont tu connais le signe.`,
    };
  if (e.table && n === s7(e))
    return {
      kind: 'dup',
      atoms: t,
      title: 'D\xE9j\xE0 dress\xE9',
      message: 'Ce tableau est d\xE9j\xE0 sur ta feuille : lis-le pour trancher les choix.',
    };
  let i = Fv(s.sign, { values: r.values, rows: r.rows });
  if (i)
    return {
      kind: 'false',
      atoms: t,
      title: i.title,
      message: i.message,
      badChip: 0,
      ...(i.row !== void 0
        ? { cell: { row: i.row, ...(i.col !== void 0 ? { col: i.col } : {}) } }
        : {}),
    };
  let o = r.rows.length;
  if (!r.f)
    return {
      kind: 'false',
      atoms: t,
      title: `Il manque la ligne de ${e.f}`,
      message: `Sous la ligne de ${e.f}\u2032(${e.x}), \xE9cris les fl\xE8ches de ${e.f} : \u2197 l\xE0 o\xF9 ${e.f}\u2032 est positive, \u2198 l\xE0 o\xF9 elle est n\xE9gative.`,
      badChip: 0,
      cell: { row: o },
    };
  if (tx(r.f.label) !== tx(`${e.f}(${e.x})`) && tx(r.f.label) !== tx(e.f))
    return {
      kind: 'false',
      atoms: t,
      title: 'La derni\xE8re ligne',
      message: `La derni\xE8re ligne du tableau est celle de ${e.f} : ouvre le tableau depuis la palette.`,
      badChip: 0,
    };
  let a = s.sign.values.length;
  for (let c = 0; c < 2 * a + 1; c++) {
    let f = r.f.cells[c] ?? '',
      d = c >> 1,
      m = { row: o, col: c };
    if (c % 2 === 0) {
      let b = s.arrows[d];
      if (f === b) continue;
      return f
        ? {
            kind: 'false',
            atoms: t,
            title: 'Pas le bon sens de variation',
            message: `Sur ${SK(s, d)}, la fl\xE8che suit le signe de ${e.f}\u2032 : positive, ${e.f} cro\xEEt (\u2197) ; n\xE9gative, ${e.f} d\xE9cro\xEEt (\u2198).`,
            badChip: 0,
            cell: m,
          }
        : {
            kind: 'false',
            atoms: t,
            title: 'Il manque une fl\xE8che',
            message: `Mets une fl\xE8che sur chaque intervalle : il en manque une sur ${SK(s, d)}.`,
            badChip: 0,
            cell: m,
          };
    }
    let p = s.sign.valueTexts[d];
    if (s.forbidden[d]) {
      if (f === '\u2016') continue;
      return {
        kind: 'false',
        atoms: t,
        title: 'Une valeur interdite',
        message: `${e.f} n\u2019est pas d\xE9finie en ${e.x} = ${p} : mets une double barre \u2016 sous cette valeur.`,
        badChip: 0,
        cell: m,
      };
    }
    if (f === '\u2016')
      return {
        kind: 'false',
        atoms: t,
        title: 'La double barre',
        message: `${e.f} est d\xE9finie en ${e.x} = ${p} : la double barre ne va que sous une valeur interdite.`,
        badChip: 0,
        cell: m,
      };
    let g = s.values[d];
    if (!g) {
      if (!f) continue;
      return {
        kind: 'false',
        atoms: t,
        title: `On ne conna\xEEt pas ${e.f}`,
        message: `L\u2019\xE9nonc\xE9 ne donne que ${e.f}\u2032 : laisse vide la case sous ${e.x} = ${p}.`,
        badChip: 0,
        cell: m,
      };
    }
    if (!f)
      return {
        kind: 'false',
        atoms: t,
        title: `La valeur de ${e.f}`,
        message: `Sous ${e.x} = ${p}, \xE9cris ${e.f}(${p}) : remplace ${e.x} par ${p} dans ${e.f}(${e.x}).`,
        badChip: 0,
        cell: m,
      };
    let h = tT(f);
    if (!h || !to(h, g))
      return {
        kind: 'false',
        atoms: t,
        title: 'Pas la bonne valeur',
        message: `${e.f}(${p}) ne vaut pas ${f} : remplace ${e.x} par ${p} dans ${e.f}(${e.x}) et calcule.`,
        badChip: 0,
        cell: m,
      };
  }
  let l = RK(e),
    u = l.flatMap((c, f) => (c === null ? [] : [{ index: f, truth: c }]));
  return {
    kind: 'step',
    atoms: t,
    hora: kK.hora,
    rule: kK,
    decided: u,
    final: l.every((c) => c !== null),
    vtable: !0,
  };
}
function s7(e) {
  for (let n = e.texts.length - 1; n >= 0; n--) if (bi(e.texts[n])) return e.texts[n];
  return null;
}
function CK(e, n, t) {
  let r = n.flatMap((o) => o.atoms);
  if (!r.length) return { kind: 'empty', atoms: r };
  if (r.filter(bi).length)
    return r.length !== 1
      ? {
          kind: 'syntax',
          atoms: r,
          title: 'Le tableau seul sur sa ligne',
          message: 'Un tableau occupe toute une ligne : efface ce qu\u2019il y a autour.',
          badChip: r.findIndex((o) => !bi(o)),
        }
      : $K(e, r[0]);
  if (!e.ana)
    return {
      kind: 'unjustified',
      atoms: r,
      complete: !0,
      title: 'Dresse le tableau de variations',
      message: `${e.f}\u2032(${e.x}) est donn\xE9e : \xE9tudie son signe dans le tableau de variations (bouton \xAB Tableau \xBB de la palette).`,
    };
  let i = Xg(e.ana, n, t);
  return i.kind === 'step' && i.final
    ? {
        ...i,
        final: !1,
        ...(i.rule && {
          rule: {
            ...i.rule,
            why: i.rule.why.replace(
              ' C\u2019est la r\xE9ponse.',
              ` \xC9tudie maintenant son signe : dresse le tableau de variations de ${e.f}.`,
            ),
          },
        }),
      }
    : i;
}
function EK(e, n) {
  let t = n.vtable ? n.atoms[0] : as(n.atoms);
  if (n.vtable) ((e.table = iT(e, e.fprime)), (e.decisions = RK(e)));
  else if (e.ana) {
    Yg(e.ana, n);
    let r = n.amove;
    r?.kind === 'target' && ex(e.ana, t) && (e.fprime = r.members[r.members.length - 1]);
  }
  (e.texts.push(t), e.lines++);
}
function MK(e) {
  return !!e.table && e.decisions.every((n) => n !== null);
}
function _K(e, n) {
  return bi(n) ? $K({ ...e, table: null, texts: [] }, n).kind === 'step' : !!e.ana && eh(e.ana, n);
}
var NK = '\u229F';
function rh(e) {
  return e.startsWith(NK + '{');
}
var aT = (e, n) => typeof e == 'string' && e.length <= n && !/[\n\r]/.test(e);
function sx(e) {
  if (!rh(e)) return null;
  let n;
  try {
    n = JSON.parse(e.slice(NK.length));
  } catch {
    return null;
  }
  if (!n || typeof n != 'object') return null;
  let { h: t, r } = n;
  if (
    (t !== void 0 && (!Array.isArray(t) || t.length > 13 || !t.every((i) => aT(i, 40)))) ||
    !Array.isArray(r) ||
    r.length < 1 ||
    r.length > 6
  )
    return null;
  let s = [];
  for (let i of r) {
    if (!Array.isArray(i) || i.length !== 2) return null;
    let [o, a] = i;
    if (
      !aT(o, 40) ||
      !Array.isArray(a) ||
      a.length < 1 ||
      a.length > 24 ||
      !a.every((l) => aT(l, 24))
    )
      return null;
    s.push({ label: o, cells: a });
  }
  return t && s.some((i) => i.cells.length !== t.length)
    ? null
    : { ...(t ? { head: t } : {}), rows: s };
}
function $t(e) {
  let n = e.replace(/[\s\u00a0\u202f\u2009]/g, '').replace(/−/g, '-');
  if (!n) return null;
  let t = n.split(/[/÷]/);
  if (t.length > 2) return null;
  let r = nr(t[0]);
  if (!r) return null;
  if (t.length === 1) return r;
  let s = nr(t[1]);
  return s ? A(r, s) : null;
}
function ls(e) {
  let n = e.d,
    t = 0;
  for (; n % 2n === 0n; ) ((n /= 2n), t++);
  let r = 0;
  for (; n % 5n === 0n; ) ((n /= 5n), r++);
  let s = e.n < 0n ? '\u2212' : '',
    i = e.n < 0n ? -e.n : e.n;
  if (n !== 1n) return `${s}${i}/${e.d}`;
  let o = Math.max(t, r),
    l = ((i * 10n ** BigInt(o)) / e.d).toString().padStart(o + 1, '0'),
    u = l.slice(0, l.length - o),
    c = o ? l.slice(l.length - o).replace(/0+$/, '') : '';
  return s + u + (c ? ',' + c : '');
}
var wa = (e) => C(BigInt(e)),
  tf = { fill: 'tables.fill@1', read: 'tables.read@1' },
  rf = 'Tableau',
  i7 = {
    series: {
      id: tf.fill,
      card: rf,
      label: 'Tableau des effectifs',
      hora: 3,
      why: 'Les valeurs rang\xE9es, l\u2019effectif de chacune, puis les effectifs cumul\xE9s : le rang de chaque valeur se lit dans la derni\xE8re ligne.',
    },
    proportion: {
      id: tf.fill,
      card: rf,
      label: 'Tableau de proportionnalit\xE9',
      hora: 3,
      why: 'Dans un tableau de proportionnalit\xE9, on passe d\u2019une ligne \xE0 l\u2019autre en multipliant par le m\xEAme nombre : le coefficient (le quotient de chaque colonne).',
    },
    cross: {
      id: tf.fill,
      card: rf,
      label: 'Tableau \xE0 double entr\xE9e',
      hora: 3,
      why: 'Dans un tableau \xE0 double entr\xE9e, les cases d\u2019une ligne (ou d\u2019une colonne) s\u2019additionnent dans sa case \xAB Total \xBB.',
    },
    values: {
      id: tf.fill,
      card: rf,
      label: 'Tableau de valeurs',
      hora: 3,
      why: 'Pour chaque colonne, on remplace la variable par sa valeur dans la formule de la ligne, puis on calcule.',
    },
    freq: {
      id: tf.fill,
      card: rf,
      label: 'Tableau des fr\xE9quences',
      hora: 3,
      why: 'Fr\xE9quence = effectif \xF7 effectif total (\xD7 100 pour un pourcentage). Les fr\xE9quences se comparent, m\xEAme quand les effectifs totaux ne sont pas les m\xEAmes.',
    },
  },
  o7 = {
    id: tf.fill,
    card: rf,
    label: 'Tableau de restes',
    hora: 3,
    why: 'Tout entier a un reste entre 0 et m \u2212 1 : pour chacun, on calcule l\u2019expression et son reste. Le tableau contient toutes les possibilit\xE9s.',
  },
  qK = {
    id: tf.read,
    card: rf,
    label: 'Lire le tableau',
    hora: 1,
    why: 'La r\xE9ponse se lit dans le tableau.',
  },
  J = class extends Error {},
  a7 = ['Valeur', 'Effectif', 'Effectif cumul\xE9'],
  lT = (e) => /^total$/i.test(e.trim());
function l7(e, n) {
  let t = (a) =>
      a.map((l) => {
        let u = $t(l);
        if (!u) throw new J(`nombre illisible dans l\u2019\xE9nonc\xE9 : \xAB ${l} \xBB`);
        return u;
      }),
    r = (a) =>
      t(a).map((l) => {
        if (!B(l) || l.n < 0n) throw new J('effectif attendu : entier \u2265 0');
        return l.n;
      }),
    s,
    i;
  if (e === 'raw') {
    if (n.rows.length !== 1) throw new J('s\xE9rie brute : une seule ligne');
    let a = t(n.rows[0].cells);
    ((s = []),
      (i = []),
      [...a]
        .sort((l, u) => Re(l, u))
        .forEach((l) => {
          let u = s[s.length - 1];
          u && M(u, l) ? (i[i.length - 1] += 1n) : (s.push(l), i.push(1n));
        }));
  } else {
    if (n.rows.length !== 2) throw new J('valeurs et effectifs : deux lignes');
    s = t(n.rows[0].cells);
    for (let l = 1; l < s.length; l++)
      if (Re(s[l - 1], s[l]) >= 0)
        throw new J('valeurs de l\u2019\xE9nonc\xE9 : rang\xE9es, chacune une fois');
    let a = r(n.rows[1].cells);
    if (a.length !== s.length) throw new J('une case par valeur');
    if (e === 'counts') i = a;
    else if (((i = a.map((l, u) => l - (u ? a[u - 1] : 0n))), i.some((l) => l <= 0n)))
      throw new J('effectifs cumul\xE9s : croissants strictement');
  }
  if (i.some((a) => a <= 0n)) throw new J('effectif nul');
  let o = [];
  return (
    i.forEach((a, l) => o.push(a + (l ? o[l - 1] : 0n))),
    { kind: 'series', form: e, values: s, counts: i, ecc: o, N: o[o.length - 1] }
  );
}
function u7(e, n) {
  if (e.rows.length !== 2) throw new J('proportionnalit\xE9 : deux lignes');
  let t = (f) => {
      if (f.trim() === '?') return null;
      let d = $t(f);
      if (!d) throw new J(`nombre illisible dans l\u2019\xE9nonc\xE9 : \xAB ${f} \xBB`);
      return d;
    },
    r = e.rows[0].cells.map(t),
    s = e.rows[1].cells.map(t);
  if (r.length !== s.length || r.length < 2)
    throw new J('deux colonnes au moins, autant de cases par ligne');
  let i = [];
  if (
    (r.forEach((f, d) => {
      if ((f && s[d] && i.push(d), !f && !s[d])) throw new J('une colonne sans aucune donn\xE9e');
      if (f && M(f, F)) throw new J('une valeur nulle dans la 1re ligne');
    }),
    !i.length)
  )
    throw new J('au moins une colonne compl\xE8te');
  let o = A(s[i[0]], r[i[0]]),
    a = i.every((f) => M(A(s[f], r[f]), o)),
    l = r.some((f, d) => !f || !s[d]);
  if (l && !a)
    throw new J('une case \xE0 trouver dans un tableau qui n\u2019est pas proportionnel');
  if (l && M(o, F)) throw new J('coefficient nul');
  let u = r.map((f, d) => f ?? A(s[d], o)),
    c = s.map((f, d) => f ?? N(r[d], o));
  return {
    kind: 'proportion',
    labels: [e.rows[0].label, e.rows[1].label],
    a: u,
    b: c,
    givenA: r,
    givenB: s,
    proportional: a,
    k: a ? o : null,
    coef: n,
  };
}
function c7(e) {
  let n = e.head;
  if (!n || n.length < 3 || !lT(n[n.length - 1]))
    throw new J('double entr\xE9e : des en-t\xEAtes, la derni\xE8re colonne \xAB Total \xBB');
  if (e.rows.length < 3 || !lT(e.rows[e.rows.length - 1].label))
    throw new J('double entr\xE9e : la derni\xE8re ligne \xAB Total \xBB');
  let t = e.rows.map((a) =>
      a.cells.map((l) => {
        if (l.trim() === '?') return null;
        let u = $t(l);
        if (!u) throw new J(`nombre illisible dans l\u2019\xE9nonc\xE9 : \xAB ${l} \xBB`);
        return u;
      }),
    ),
    r = t.length,
    s = n.length,
    i = t.map((a) => [...a]);
  for (let a = 0; a < r * s; a++) {
    let l = !1,
      u = [];
    for (let c = 0; c < r; c++) u.push(Array.from({ length: s }, (f, d) => [c, d]));
    for (let c = 0; c < s; c++) u.push(Array.from({ length: r }, (f, d) => [d, c]));
    for (let c of u) {
      let f = c.filter(([b, v]) => !i[b][v]);
      if (f.length !== 1) continue;
      let [d, m] = f[0],
        p = c[c.length - 1],
        g = c.slice(0, -1),
        h;
      if (d === p[0] && m === p[1]) h = g.reduce((b, [v, k]) => re(b, i[v][k]), F);
      else {
        h = i[p[0]][p[1]];
        for (let [b, v] of g) (b !== d || v !== m) && (h = me(h, i[b][v]));
      }
      ((i[d][m] = h), (l = !0));
    }
    if (!l) break;
  }
  if (i.some((a) => a.some((l) => !l)))
    throw new J('double entr\xE9e : des cases ne se d\xE9duisent pas');
  let o = i;
  for (let a = 0; a < r; a++) {
    let l = o[a].slice(0, -1).reduce((u, c) => re(u, c), F);
    if (!M(l, o[a][s - 1])) throw new J('double entr\xE9e : un total faux');
  }
  for (let a = 0; a < s; a++) {
    let l = o.slice(0, -1).reduce((u, c) => re(u, c[a]), F);
    if (!M(l, o[r - 1][a])) throw new J('double entr\xE9e : un total faux');
  }
  return { kind: 'cross', head: n, labels: e.rows.map((a) => a.label), given: t, full: o };
}
function OK(e, n, t, r) {
  let s = Ai(e, { [n]: t });
  if (!s) return null;
  if (r === null) return s;
  if (!B(s)) return null;
  let i = ((s.n % r) + r) % r;
  return C(i);
}
function f7(e, n, t) {
  if (e.head) throw new J('tableau de valeurs : pas d\u2019en-t\xEAtes de colonnes');
  if (e.rows.length < 2) throw new J('tableau de valeurs : la variable, puis une ligne au moins');
  let r = e.rows[0].label.trim();
  if (!/^[a-zA-Z]$/.test(r))
    throw new J('la 1re ligne porte le nom de la variable (\xAB x \xBB, \xAB n \xBB)');
  let s = t === void 0 ? null : BigInt(t),
    i = e.rows[0].cells.map((l) => {
      let u = $t(l);
      if (!u) throw new J(`valeur de ${r} illisible : \xAB ${l} \xBB`);
      if (s !== null && !B(u)) throw new J('tableau de restes : des entiers');
      return u;
    });
  if (i.length < 2) throw new J('deux colonnes au moins');
  if (
    (i.forEach((l, u) => {
      if (i.findIndex((c) => M(l, c)) !== u) throw new J(`${r} : chaque valeur une seule fois`);
    }),
    n.length !== e.rows.length - 1)
  )
    throw new J('`table.exprs` : une formule (ou null) par ligne apr\xE8s la 1re');
  let o = 0,
    a = e.rows.slice(1).map((l, u) => {
      let c = n[u] ?? null;
      if (l.cells.length !== i.length) throw new J('une case par valeur de la variable');
      let f = l.cells.map((h) => {
        if (h.trim() === '?') return null;
        let b = $t(h);
        if (!b) throw new J(`nombre illisible dans l\u2019\xE9nonc\xE9 : \xAB ${h} \xBB`);
        return b;
      });
      if (((o += f.filter((h) => h === null).length), c === null)) {
        if (f.some((h) => h === null))
          throw new J(`ligne \xAB ${l.label} \xBB sans formule : toutes ses cases sont donn\xE9es`);
        return { label: l.label, expr: null, term: null, given: f, full: f };
      }
      let d = ie(c);
      if (!d.ok || d.s.k !== 'expr') throw new J(`formule illisible : \xAB ${c} \xBB`);
      let m = d.s.e;
      if ([...$(m)].filter((h) => h !== r).length)
        throw new J(`formule \xAB ${c} \xBB : la seule lettre est ${r}`);
      let g = i.map((h) => {
        let b = OK(m, r, h, s);
        if (!b) throw new J(`\xAB ${c} \xBB ne se calcule pas exactement en ${ls(h)}`);
        return b;
      });
      return (
        f.forEach((h, b) => {
          if (h && !M(h, g[b]))
            throw new J(
              `ligne \xAB ${l.label} \xBB : la case donn\xE9e sous ${ls(i[b])} est fausse`,
            );
        }),
        { label: l.label, expr: c, term: m, given: f, full: g }
      );
    });
  if (!o) throw new J('tableau de valeurs : au moins une case \xE0 remplir');
  return { kind: 'values', variable: r, xs: i, rows: a, mod: s };
}
var wm = wa(100),
  ym = (e) => e.reduce((n, t) => re(n, t), F);
function d7(e, n) {
  let t = e.head;
  if (!t?.length) throw new J('fr\xE9quences : des en-t\xEAtes de colonnes (une par cat\xE9gorie)');
  let r = e.rows.length;
  if (r !== 2 && r !== 3)
    throw new J(
      'fr\xE9quences : la ligne des effectifs, (celle des effectifs totaux,) celle des fr\xE9quences',
    );
  let s = t.length,
    i = lT(t[s - 1]) ? s - 1 : -1;
  if (i === 0) throw new J('fr\xE9quences : une cat\xE9gorie avant \xAB Total \xBB');
  let o = r === 3,
    a = n ? wm : q,
    l = e.rows.map((k) => {
      if (k.cells.length !== s) throw new J('une case par colonne');
      return k.cells.map((y) => {
        if (y.trim() === '?') return null;
        let S = $t(y);
        if (!S) throw new J(`nombre illisible dans l\u2019\xE9nonc\xE9 : \xAB ${y} \xBB`);
        return S;
      });
    });
  if (!l.flat().filter((k) => k === null).length)
    throw new J('fr\xE9quences : au moins une case \xE0 remplir');
  let c = t.map((k, y) => y).filter((k) => k !== i),
    f = [...l[0]],
    d = o ? [...l[1]] : t.map(() => null),
    m = l[r - 1].map((k) => (k ? A(k, a) : null)),
    p = null;
  for (let k = 0; k < 4 * (s + 2); k++) {
    let y = !1,
      S = (w, _, O) => {
        !O || w[_] || ((w[_] = O), (y = !0));
      };
    if (i >= 0)
      for (let w of o ? [f, d] : [f]) {
        let _ = [...c, i].filter((G) => !w[G]);
        if (_.length !== 1) continue;
        let O = _[0];
        O === i
          ? S(w, O, ym(c.map((G) => w[G])))
          : S(w, O, me(w[i], ym(c.filter((G) => G !== O).map((G) => w[G]))));
      }
    if (o)
      t.forEach((w, _) => {
        let [O, G, Se] = [f[_], d[_], m[_]];
        (O && G && !Se && S(m, _, A(O, G)),
          O && Se && !G && !M(Se, F) && S(d, _, A(O, Se)),
          G && Se && !O && S(f, _, N(G, Se)));
      });
    else {
      if (!p) {
        if (i >= 0 && f[i]) p = f[i];
        else if (c.every((w) => f[w])) p = ym(c.map((w) => f[w]));
        else {
          let w = c.find((_) => f[_] && m[_] && !M(m[_], F));
          w !== void 0 && (p = A(f[w], m[w]));
        }
        p && (y = !0);
      }
      if (p) {
        i >= 0 && (S(f, i, p), S(m, i, q));
        for (let w of c)
          (f[w] && !m[w] && S(m, w, A(f[w], p)), m[w] && !f[w] && S(f, w, N(m[w], p)));
      }
    }
    if (!y) break;
  }
  if ([...f, ...m].some((k) => !k) || (o ? d.some((k) => !k) : !p))
    throw new J('fr\xE9quences : des cases ne se d\xE9duisent pas');
  let g = f,
    h = m,
    b = o ? d : t.map(() => p);
  if (
    (t.forEach((k, y) => {
      if (Re(g[y], F) < 0 || Re(b[y], F) <= 0)
        throw new J(`colonne \xAB ${k} \xBB : effectif n\xE9gatif ou effectif total nul`);
      if (Re(h[y], F) < 0 || Re(h[y], q) > 0)
        throw new J(`colonne \xAB ${k} \xBB : une fr\xE9quence entre 0 et 1`);
      if (!M(N(h[y], b[y]), g[y]))
        throw new J(`colonne \xAB ${k} \xBB : fr\xE9quence \u2260 effectif \xF7 effectif total`);
    }),
    i >= 0)
  ) {
    if (!M(ym(c.map((k) => g[k])), g[i]))
      throw new J('fr\xE9quences : le total des effectifs est faux');
    if (o && !M(ym(c.map((k) => b[k])), b[i]))
      throw new J('fr\xE9quences : le total des effectifs totaux est faux');
  } else if (!o && !M(ym(c.map((k) => g[k])), p))
    throw new J('fr\xE9quences : l\u2019effectif total n\u2019est pas la somme des effectifs');
  let v = [g, ...(o ? [b] : []), h.map((k) => N(k, a))];
  return (
    l.forEach((k, y) =>
      k.forEach((S, w) => {
        if (S && !M(S, v[y][w]))
          throw new J(`colonne \xAB ${t[w]} \xBB : une case donn\xE9e ne tient pas`);
      }),
    ),
    {
      kind: 'freq',
      head: t,
      labels: e.rows.map((k) => k.label),
      totalCol: i,
      group: o,
      percent: n,
      given: l,
      full: v,
      n: g,
      N: b,
      f: h,
    }
  );
}
function m7(e) {
  let n = e.kernel,
    t = n.table;
  if (!t) throw new J('`table` manquant');
  let r = sx(n.start);
  if (!r) throw new J('`start` : le tableau de l\u2019\xE9nonc\xE9 \xAB \u229F{\u2026} \xBB');
  return t.kind === 'series'
    ? l7(t.form ?? 'raw', r)
    : t.kind === 'proportion'
      ? u7(r, !!t.coef)
      : t.kind === 'values'
        ? f7(r, t.exprs ?? [], t.mod)
        : t.kind === 'freq'
          ? d7(r, !!t.percent)
          : c7(r);
}
function nh(e, n) {
  let t = e.ecc.findIndex((r) => r >= n);
  return e.values[t];
}
var cT = (e, n) => (e + n - 1n) / n;
function p7(e) {
  return e.N % 2n === 1n
    ? nh(e, (e.N + 1n) / 2n)
    : A(re(nh(e, e.N / 2n), nh(e, e.N / 2n + 1n)), wa(2));
}
var g7 = (e) => nh(e, cT(e.N, 4n)),
  h7 = (e) => nh(e, cT(3n * e.N, 4n)),
  b7 = {
    series: ['N', 'Me', 'Q\u2081', 'Q\u2083'],
    proportion: ['k'],
    cross: [],
    values: [],
    freq: [],
  },
  v7 = { Q1: 'Q\u2081', Q3: 'Q\u2083', Q_1: 'Q\u2081', Q_3: 'Q\u2083', M: 'Me' },
  ix = (e) => v7[e] ?? e;
function ox(e, n) {
  if (e.kind === 'freq') {
    if (n === 'N') return e.totalCol >= 0 ? e.N[e.totalCol] : e.group ? void 0 : e.N[0];
    let r = /^(f|n|N)\((.+)\)$/.exec(n),
      s = r ? e.head.findIndex((i) => fT(i, r[2])) : -1;
    return !r || s < 0
      ? void 0
      : r[1] === 'f'
        ? N(e.f[s], e.percent ? wm : q)
        : r[1] === 'n'
          ? e.n[s]
          : e.N[s];
  }
  let t = /^(n|ECC|y|T)\((.+)\)$/.exec(n);
  if (e.kind === 'series') {
    if (n === 'N') return wa(e.N);
    if (n === 'Me') return p7(e);
    if (n === 'Q\u2081') return g7(e);
    if (n === 'Q\u2083') return h7(e);
    if (t && (t[1] === 'n' || t[1] === 'ECC')) {
      let r = $t(t[2]);
      if (!r) return;
      let s = e.values.findIndex((o) => M(o, r));
      if (t[1] === 'n') return wa(s < 0 ? 0n : e.counts[s]);
      let i = 0n;
      return (
        e.values.forEach((o, a) => {
          Re(o, r) <= 0 && (i += e.counts[a]);
        }),
        wa(i)
      );
    }
    return;
  }
  if (e.kind === 'proportion') {
    if (n === 'k') return e.k;
    if (t && t[1] === 'y') {
      let r = $t(t[2]),
        s = r ? e.a.findIndex((i) => M(i, r)) : -1;
      return s < 0 ? void 0 : e.b[s];
    }
    return;
  }
  if (e.kind !== 'values') {
    if (n === 'T') return e.full[e.full.length - 1][e.head.length - 1];
    if (t && t[1] === 'T') {
      let r = t[2].trim(),
        s = e.labels.findIndex((o) => o.trim() === r);
      if (s >= 0) return e.full[s][e.head.length - 1];
      let i = e.head.findIndex((o) => o.trim() === r);
      if (i >= 0) return e.full[e.full.length - 1][i];
    }
  }
}
function k7(e, n) {
  if (e.kind === 'series') {
    let t = e.values.map(ls),
      r = (o, a) =>
        e.form === 'raw'
          ? null
          : o === 0
            ? n.rows[0].cells[a]
            : (o === 1 && e.form === 'counts') || (o === 2 && e.form === 'cumulative')
              ? n.rows[1].cells[a]
              : null,
      s = ['value', 'count', 'ecc'],
      i = [e.values, e.counts.map(wa), e.ecc.map(wa)];
    return {
      kind: 'series',
      rows: a7.map((o, a) => ({
        label: o,
        role: s[a],
        cells: t.map((l, u) => ({ given: r(a, u), want: i[a][u] })),
      })),
    };
  }
  if (e.kind === 'proportion') {
    let t = [
      {
        label: e.labels[0],
        role: 'a',
        cells: e.a.map((r, s) => ({ given: e.givenA[s] ? n.rows[0].cells[s] : null, want: r })),
      },
      {
        label: e.labels[1],
        role: 'b',
        cells: e.b.map((r, s) => ({ given: e.givenB[s] ? n.rows[1].cells[s] : null, want: r })),
      },
    ];
    return (
      e.coef &&
        t.push({
          label: `${e.labels[1]} \xF7 ${e.labels[0]}`,
          role: 'quotient',
          cells: e.a.map((r, s) => ({ given: null, want: A(e.b[s], r) })),
        }),
      { kind: 'proportion', rows: t }
    );
  }
  if (e.kind === 'values') {
    let t = e.xs.map(ls);
    return {
      kind: 'values',
      rows: [
        {
          label: n.rows[0].label,
          role: 'var',
          cells: e.xs.map((r, s) => ({ given: n.rows[0].cells[s], want: r })),
        },
        ...e.rows.map((r, s) => ({
          label: r.label,
          role: 'fn',
          cells: r.full.map((i, o) => ({
            given: r.given[o] ? n.rows[s + 1].cells[o] : null,
            want: i,
          })),
          ...(r.expr
            ? {
                fn: {
                  variable: e.variable,
                  xs: t,
                  expr: r.expr,
                  mod: e.mod === null ? null : e.mod.toString(),
                },
              }
            : {}),
        })),
      ],
    };
  }
  if (e.kind === 'freq') {
    let t = {
        head: e.head,
        totalCol: e.totalCol,
        group: e.group,
        percent: e.percent,
        n: e.n,
        N: e.N,
      },
      r = e.group ? ['fcount', 'ftotal', 'freq'] : ['fcount', 'freq'];
    return {
      kind: 'freq',
      head: e.head,
      rows: e.labels.map((s, i) => ({
        label: s,
        role: r[i],
        fq: t,
        cells: e.full[i].map((o, a) => ({
          given: e.given[i][a] ? n.rows[i].cells[a] : null,
          want: o,
        })),
      })),
    };
  }
  return {
    kind: 'cross',
    head: e.head,
    rows: e.labels.map((t, r) => ({
      label: t,
      role: 'cross',
      cells: e.full[r].map((s, i) => ({
        given: e.given[r][i] ? n.rows[r].cells[i] : null,
        want: s,
      })),
    })),
  };
}
var fT = (e, n) =>
  e.replace(/\s+/g, ' ').trim().toLowerCase() === n.replace(/\s+/g, ' ').trim().toLowerCase();
function KK(e, n) {
  let t = {
    title: 'Ce tableau ne va pas avec l\u2019\xE9nonc\xE9',
    message: 'Ouvre le tableau depuis la palette : il a les bonnes lignes et les bonnes colonnes.',
  };
  if (n.rows.length !== e.rows.length || (e.head && (!n.head || n.head.length !== e.head.length)))
    return t;
  for (let r = 0; r < e.rows.length; r++) {
    let s = e.rows[r],
      i = n.rows[r];
    if (!fT(s.label, i.label) || i.cells.length !== s.cells.length) return t;
  }
  for (let r = 0; r < e.rows.length; r++) {
    let s = e.rows[r],
      i = n.rows[r];
    for (let o = 0; o < s.cells.length; o++) {
      let a = s.cells[o],
        l = i.cells[o].trim(),
        u = { row: r, col: o };
      if (a.given !== null) {
        let f = $t(l);
        if (!f || !M(f, a.want))
          return {
            title: 'C\u2019est une donn\xE9e de l\u2019\xE9nonc\xE9',
            message: 'Recopie cette case telle qu\u2019elle est dans l\u2019\xE9nonc\xE9.',
            ...u,
          };
        continue;
      }
      if (!l) return { title: 'Il manque une case', message: x7(e, s, o), ...u };
      let c = $t(l);
      if (!c)
        return {
          title: 'Case illisible',
          message:
            '\xC9cris un nombre dans chaque case : \xAB 12 \xBB, \xAB 2,5 \xBB ou une fraction \xAB 3/4 \xBB.',
          ...u,
        };
      if (!M(c, a.want)) return { ...w7(e, s, o, c), ...u };
    }
  }
  return null;
}
function x7(e, n, t) {
  if (n.fq) {
    let r = n.fq,
      s = r.head[t],
      i = t === r.totalCol;
    return n.role === 'fcount'
      ? i
        ? 'Dans la colonne \xAB Total \xBB : additionne les effectifs.'
        : `Sous \xAB ${s} \xBB : effectif = fr\xE9quence \xD7 effectif total.`
      : n.role === 'ftotal'
        ? i
          ? 'Dans la colonne \xAB Total \xBB : additionne les effectifs totaux.'
          : `Sous \xAB ${s} \xBB : effectif total = effectif \xF7 fr\xE9quence.`
        : i && !r.group
          ? r.percent
            ? 'Toutes les fr\xE9quences ensemble font 100 %.'
            : 'Toutes les fr\xE9quences ensemble font 1.'
          : `Sous \xAB ${s} \xBB : fr\xE9quence = effectif \xF7 effectif total${r.percent ? ', puis \xD7 100 pour un pourcentage' : ''}.`;
  }
  if (n.role === 'value')
    return '\xC9cris chaque valeur de la s\xE9rie une seule fois, de la plus petite \xE0 la plus grande.';
  if (n.role === 'count')
    return '\xC9cris sous chaque valeur son effectif : combien de fois elle appara\xEEt dans la s\xE9rie.';
  if (n.role === 'ecc')
    return 'Sous chaque valeur, l\u2019effectif cumul\xE9 : les effectifs jusqu\u2019\xE0 cette valeur, additionn\xE9s.';
  if (n.role === 'quotient') return 'Dans chaque colonne, divise la 2e ligne par la 1re.';
  if (n.role === 'cross')
    return 'Chaque case se d\xE9duit : une ligne (ou une colonne) s\u2019additionne dans sa case \xAB Total \xBB.';
  if (n.role === 'fn' && n.fn) {
    let r = n.fn.xs[t];
    return n.fn.mod
      ? `Sous ${n.fn.variable} = ${r} : calcule ${n.fn.expr} pour ${n.fn.variable} = ${r}, puis son reste dans la division par ${n.fn.mod}.`
      : `Sous ${n.fn.variable} = ${r} : remplace ${n.fn.variable} par ${r} dans ${n.fn.expr}, puis calcule.`;
  }
  return 'Le tableau est proportionnel : trouve la case avec le coefficient (ou un produit en croix).';
}
function y7(e, n, t) {
  let r = e.fq,
    s = r.head[n],
    i = n === r.totalCol,
    o = e.cells[n].want;
  if (e.role === 'fcount')
    return {
      title: 'Pas le bon effectif',
      message: i
        ? 'Dans la colonne \xAB Total \xBB, additionne les effectifs.'
        : `Sous \xAB ${s} \xBB : effectif = fr\xE9quence \xD7 effectif total.`,
    };
  if (e.role === 'ftotal')
    return {
      title: 'Pas le bon effectif total',
      message: i
        ? 'Dans la colonne \xAB Total \xBB, additionne les effectifs totaux.'
        : `Sous \xAB ${s} \xBB : effectif total = effectif \xF7 fr\xE9quence.`,
    };
  if (r.percent && M(N(t, wm), o))
    return {
      title: 'En pourcentage',
      message: 'Cette ligne est en pourcentage : multiplie ta fr\xE9quence par 100.',
    };
  if (!r.percent && M(t, N(o, wm)))
    return {
      title: 'Une fr\xE9quence est entre 0 et 1',
      message: 'Ici, pas de pourcentage : divise par 100 (25 % \u2192 0,25).',
    };
  let a = r.n[n];
  return !M(a, F) && M(t, N(A(r.N[n], a), r.percent ? wm : q))
    ? {
        title: '\xC0 l\u2019envers',
        message: 'Fr\xE9quence = effectif \xF7 effectif total, pas l\u2019inverse.',
      }
    : Re(t, r.percent ? wm : q) > 0
      ? {
          title: r.percent ? 'Pas plus de 100 %' : 'Une fr\xE9quence est entre 0 et 1',
          message:
            'Divise l\u2019effectif par l\u2019effectif total : la fr\xE9quence ne d\xE9passe jamais le tout.',
        }
      : !M(o, F) && Math.abs(th(t) - th(o)) < 0.01 * Math.abs(th(o))
        ? {
            title: 'Une valeur approch\xE9e',
            message:
              'La fr\xE9quence doit \xEAtre exacte : \xE9cris-la en fraction, effectif / effectif total.',
          }
        : i && !r.group
          ? {
              title: 'Pas la bonne fr\xE9quence',
              message: r.percent
                ? 'Toutes les fr\xE9quences ensemble font 100 %.'
                : 'Toutes les fr\xE9quences ensemble font 1.',
            }
          : {
              title: 'Pas la bonne fr\xE9quence',
              message: `Sous \xAB ${s} \xBB : divise l\u2019effectif par l\u2019effectif total${r.percent ? ', puis multiplie par 100' : ''}.`,
            };
}
function w7(e, n, t, r) {
  if (n.fq) return y7(n, t, r);
  if (n.role === 'value')
    return n.cells.map((a) => a.want).some((a) => M(a, r))
      ? {
          title: 'Dans l\u2019ordre croissant',
          message:
            'Range les valeurs de la plus petite \xE0 la plus grande, chacune une seule fois.',
        }
      : {
          title: 'Une valeur qui n\u2019est pas dans la s\xE9rie',
          message: `${ls(r)} n\u2019est pas une valeur de la s\xE9rie : recopie les valeurs de l\u2019\xE9nonc\xE9, rang\xE9es.`,
        };
  if (n.role === 'fn' && n.fn) {
    let i = n.fn.xs[t];
    if (n.fn.mod) {
      let o = BigInt(n.fn.mod);
      return !B(r) || r.n < 0n || r.n >= o
        ? {
            title: 'Pas un reste',
            message: `Un reste de la division par ${n.fn.mod} est un entier entre 0 et ${(o - 1n).toString()}.`,
          }
        : {
            title: 'Pas le bon reste',
            message: `Calcule ${n.fn.expr} pour ${n.fn.variable} = ${i}, puis son reste dans la division par ${n.fn.mod}.`,
          };
    }
    return {
      title: 'Pas la bonne valeur',
      message: `Remplace ${n.fn.variable} par ${i} dans ${n.fn.expr}, puis calcule.`,
    };
  }
  let s = e.rows[0]?.cells[t] ? ls(e.rows[0].cells[t].want) : '';
  return n.role === 'count'
    ? {
        title: 'Pas le bon effectif',
        message: `Compte combien de fois ${s} appara\xEEt dans la s\xE9rie.`,
      }
    : n.role === 'ecc'
      ? {
          title: 'Pas le bon effectif cumul\xE9',
          message:
            t === 0
              ? 'Sous la plus petite valeur, l\u2019effectif cumul\xE9 est son effectif.'
              : `Sous ${s} : l\u2019effectif cumul\xE9 d\u2019avant, plus l\u2019effectif de ${s}.`,
        }
      : n.role === 'quotient'
        ? r.d !== 1n &&
          Math.abs(Number(r.n) / Number(r.d) - th(n.cells[t].want)) <
            0.01 * Math.abs(th(n.cells[t].want))
          ? {
              title: 'Une valeur approch\xE9e',
              message: 'Le quotient doit \xEAtre exact : \xE9cris-le en fraction (\xAB 14/6 \xBB).',
            }
          : {
              title: 'Pas le bon quotient',
              message: 'Dans cette colonne, divise le nombre de la 2e ligne par celui de la 1re.',
            }
        : n.role === 'cross'
          ? {
              title: 'Pas le bon nombre',
              message:
                'Sur une ligne (ou une colonne), les cases s\u2019additionnent dans la case \xAB Total \xBB : additionne, ou retranche du total.',
            }
          : {
              title: 'Pas le bon nombre',
              message:
                'Le tableau est proportionnel : multiplie par le coefficient (ou fais un produit en croix).',
            };
}
var th = (e) => Number(e.n) / Number(e.d);
function PK(e, n) {
  return n.flatMap((t, r) => (t !== null && e[r] === null ? [{ index: r, truth: t }] : []));
}
function S7(e, n) {
  let t = Object.entries(n.stats ?? {}),
    r = () =>
      t.every(([s, i]) => {
        let o = ox(e, ix(s)),
          a = $t(i);
        if (o === void 0) throw new J(`grandeur inconnue : \xAB ${s} \xBB`);
        if (!a) throw new J(`valeur illisible : \xAB ${i} \xBB`);
        return o === null ? !1 : n.places === void 0 ? M(o, a) : qf(Uh(o), a, n.places);
      });
  switch (n.kind) {
    case 'value':
      if (!t.length) throw new J('une affirmation \xAB value \xBB donne des grandeurs');
      return r();
    case 'proportional':
      if (e.kind !== 'proportion') throw new J('\xAB proportional \xBB : proportionnalit\xE9');
      return e.proportional && r();
    case 'not_proportional':
      if (e.kind !== 'proportion') throw new J('\xAB not_proportional \xBB : proportionnalit\xE9');
      return !e.proportional;
    case 'other':
      return null;
    default:
      return e.kind === 'freq' ? T7(e, n) : C7(e, n);
  }
}
function T7(e, n) {
  let t = (n.cols ?? []).map((r) => {
    let s = e.head.findIndex((i) => fT(i, r));
    if (s < 0 || s === e.totalCol)
      throw new J(`affirmation \xAB ${n.text} \xBB : pas de cat\xE9gorie \xAB ${r} \xBB`);
    return s;
  });
  if (n.kind === 'largest') {
    if (t.length !== 1) throw new J('\xAB largest \xBB : une colonne (`cols`)');
    let r = t[0];
    return e.head.every((s, i) => i === r || i === e.totalCol || Re(e.f[r], e.f[i]) > 0);
  }
  if (n.kind === 'same_freq') {
    if (t.length < 2) throw new J('\xAB same_freq \xBB : deux colonnes au moins');
    return t.every((r) => M(e.f[r], e.f[t[0]]));
  }
  throw new J(`\xAB ${n.kind} \xBB : pas sur un tableau des fr\xE9quences`);
}
var R7 = (e, n) => {
  if (!e?.length) throw new J(`${n} : la liste \`values\` manque`);
  return e.map((t) => {
    let r = $t(t);
    if (!r) throw new J(`valeur illisible : \xAB ${t} \xBB`);
    return r;
  });
};
function $7(e, n) {
  let t = n.row ?? 1,
    r = e.rows[t - 1];
  if (!r) throw new J(`affirmation \xAB ${n.text} \xBB : pas de ligne ${t}`);
  return r;
}
function C7(e, n) {
  if (e.kind !== 'values')
    throw new J(`\xAB ${n.kind} \xBB : un tableau de valeurs (\`table.kind = 'values'\`)`);
  if (n.kind === 'same_rows') {
    let [i, o] = n.rows ?? [],
      a = i ? e.rows[i - 1] : void 0,
      l = o ? e.rows[o - 1] : void 0;
    if (!a || !l || i === o) throw new J('\xAB same_rows \xBB : deux lignes (`rows`)');
    return a.full.every((u, c) => M(u, l.full[c]));
  }
  let t = $7(e, n);
  if (n.kind === 'pairs') {
    if (!n.pairs?.length) throw new J('\xAB pairs \xBB : la liste `pairs` manque');
    if (!t.term) throw new J('\xAB pairs \xBB : sur une ligne avec une formule');
    return n.pairs.every(([i, o]) => {
      let a = $t(i),
        l = $t(o);
      if (!a || !l) throw new J(`couple illisible : (${i} ; ${o})`);
      let u = OK(t.term, e.variable, a, e.mod);
      return !!u && M(u, l);
    });
  }
  let r = R7(n.values, `\xAB ${n.kind} \xBB`),
    s = (i) => t.full.some((o) => M(o, i));
  if (n.kind === 'reached') return r.every(s);
  if (n.kind === 'avoids') return !r.some(s);
  if (n.kind === 'within') return t.full.every((i) => r.some((o) => M(o, i)));
  if (n.kind === 'set') return r.every(s) && t.full.every((i) => r.some((o) => M(o, i)));
  throw new J(`genre d\u2019affirmation inconnu : \xAB ${n.kind} \xBB`);
}
function E7(e, n) {
  return n.kind !== 'pairs'
    ? !0
    : (n.pairs ?? []).every(([t]) => {
        let r = $t(t);
        return !!r && e.xs.some((s) => M(r, s));
      });
}
function IK(e) {
  let n = e.kernel;
  if (n.plugin !== 'tables' || !n.tclaims)
    throw new J('Tableau \xE0 remplir attendu (plugin \xAB tables \xBB).');
  let t = m7(e),
    r = sx(n.start),
    s = n.tclaims.map((a) => ({ spec: a, truth: S7(t, a) })),
    i = new Set();
  t.kind === 'series' &&
    (t.form !== 'raw' && t.values.forEach((a) => i.add(`n(${ls(a)})`)),
    t.form === 'cumulative' && (i.add('N'), t.values.forEach((a) => i.add(`ECC(${ls(a)})`))));
  let o = {
    model: e,
    data: t,
    start: r,
    expected: k7(t, r),
    claims: s,
    known: i,
    propKnown: !1,
    table: !1,
    decisions: s.map(() => null),
    single: !!n.single,
    path: n.path ?? [],
    lines: 0,
    texts: [],
  };
  return ((o.decisions = ax(o)), o);
}
function M7(e) {
  let n = ix(e),
    t = /^(n|ECC|y)\((.+)\)$/.exec(n);
  if (!t) return n;
  let r = $t(t[2]);
  return r ? `${t[1]}(${ls(r)})` : n;
}
function _7(e, n) {
  let t = e.data;
  if (t.kind === 'freq') return n.spec.kind !== 'other' && e.table ? n.truth : null;
  let r = Object.entries(n.spec.stats ?? {}),
    s = () => {
      let i = !0;
      for (let [o, a] of r) {
        let l = M7(o);
        if (!e.known.has(l)) {
          i = !1;
          continue;
        }
        let u = ox(t, l),
          c = $t(a);
        if (!u || !c || !M(u, c)) return !1;
      }
      return i ? !0 : null;
    };
  return n.spec.kind === 'value'
    ? s()
    : n.spec.kind === 'not_proportional'
      ? e.propKnown
        ? t.kind === 'proportion' && !t.proportional
        : null
      : n.spec.kind === 'proportional'
        ? e.propKnown
          ? t.kind !== 'proportion' || !t.proportional
            ? !1
            : s()
          : null
        : t.kind === 'values' && n.spec.kind !== 'other'
          ? !e.table || !E7(t, n.spec)
            ? null
            : n.truth
          : null;
}
function ax(e) {
  let n = e.claims.map((t) => _7(e, t));
  if (e.single) {
    let t = n.filter((s) => s === !0).length;
    if (t === 1) return n.map((s) => s === !0);
    let r = n.filter((s) => s === null).length;
    if (!t && r === 1) return n.map((s) => s === null);
  }
  return n;
}
function LK(e) {
  return e.data.kind === 'values' && e.data.mod !== null ? o7 : i7[e.data.kind];
}
function q7(e, n) {
  let t = [n],
    r = sx(n);
  if (!r)
    return {
      kind: 'syntax',
      atoms: t,
      title: 'Tableau illisible',
      message: 'Je ne lis pas ce tableau : ouvre-le de nouveau depuis la palette.',
      badChip: 0,
    };
  if (e.table && e.texts.includes(n))
    return {
      kind: 'dup',
      atoms: t,
      title: 'D\xE9j\xE0 rempli',
      message: 'Ce tableau est d\xE9j\xE0 sur ta feuille : lis-le pour trancher les choix.',
    };
  let s = KK(e.expected, r);
  if (s)
    return {
      kind: 'false',
      atoms: t,
      title: s.title,
      message: s.message,
      badChip: 0,
      ...(s.row !== void 0
        ? { cell: { row: s.row, ...(s.col !== void 0 ? { col: s.col } : {}) } }
        : {}),
    };
  let i = L7(e);
  return {
    kind: 'step',
    atoms: t,
    hora: LK(e).hora,
    rule: LK(e),
    grid: !0,
    decided: PK(e.decisions, i.decisions),
    final: i.decisions.every((o) => o !== null),
  };
}
function AK(e) {
  let n = e.data,
    t = [];
  return n.kind === 'series'
    ? (t.push('N'),
      n.values.forEach((r) => t.push(`n(${ls(r)})`, `ECC(${ls(r)})`)),
      { known: t, prop: !1 })
    : n.kind === 'proportion'
      ? (n.a.forEach((r) => t.push(`y(${ls(r)})`)),
        n.coef && n.proportional && t.push('k'),
        { known: t, prop: n.coef })
      : n.kind === 'values' || n.kind === 'freq'
        ? { known: t, prop: !1 }
        : (n.labels.forEach((r) => t.push(`T(${r.trim()})`)),
          n.head.forEach((r) => t.push(`T(${r.trim()})`)),
          t.push('T'),
          { known: t, prop: !1 });
}
function L7(e) {
  let n = AK(e),
    t = new Set([...e.known, ...n.known]),
    r = { ...e, known: t, propKnown: e.propKnown || n.prop, table: !0 };
  return { known: t, decisions: ax(r) };
}
function uT(e) {
  if (e.length < 3 || e[1] !== '=') return null;
  let n = e.slice(2).join(' ').trim();
  return n ? { name: ix(e[0]), value: n } : null;
}
function N7(e, n) {
  let t = e.data;
  return t.kind === 'series'
    ? n === 'N'
      ? e.table || t.form !== 'raw'
      : e.table || t.form === 'cumulative'
    : t.kind === 'proportion'
      ? e.table
      : !1;
}
function O7(e, n, t) {
  let r = e.data;
  if (r.kind === 'series') {
    let s = r.N.toString();
    if (n === 'N') return 'N est l\u2019effectif total : la somme des effectifs.';
    if (n === 'Me')
      return r.N % 2n === 1n
        ? `Me \u2260 ${t} : N = ${s} est impair, la m\xE9diane est la valeur de rang (N + 1) \xF7 2 = ${(r.N + 1n) / 2n} dans la s\xE9rie rang\xE9e.`
        : `Me \u2260 ${t} : N = ${s} est pair, la m\xE9diane est la moyenne des valeurs de rangs ${r.N / 2n} et ${r.N / 2n + 1n} dans la s\xE9rie rang\xE9e.`;
    let i = n === 'Q\u2081' ? 1n : 3n,
      o = cT(i * r.N, 4n),
      a = ls(A(wa(i * r.N), wa(4)));
    return `${n} \u2260 ${t} : c\u2019est la premi\xE8re valeur dont l\u2019effectif cumul\xE9 atteint ${i === 1n ? 'N \xF7 4' : '3N \xF7 4'} = ${a} (rang ${o}).`;
  }
  return r.kind === 'proportion' && !r.proportional
    ? 'Les quotients ne sont pas tous \xE9gaux : le tableau n\u2019est pas proportionnel, il n\u2019a pas de coefficient.'
    : `k \u2260 ${t} : k est le quotient (2e ligne) \xF7 (1re ligne), le m\xEAme dans chaque colonne.`;
}
function K7(e, n, t) {
  let r = uT(n),
    s = b7[e.data.kind];
  if (!r)
    return n.length <= 2 && s.includes(ix(n[0])) && (n.length === 1 || n[1] === '=')
      ? { kind: 'building', atoms: n, complete: !1 }
      : {
          kind: 'syntax',
          atoms: n,
          title: 'Lis le tableau',
          message: s.length
            ? `\xC9cris une grandeur lue dans le tableau : \xAB ${s[s.length - 1]} = \u2026 \xBB.`
            : 'Ici, tout se lit dans le tableau : remplis-le (bouton \xAB Tableau \xBB de la palette).',
          badChip: 0,
        };
  if (!s.includes(r.name))
    return {
      kind: 'syntax',
      atoms: n,
      title: 'Pas dans ce tableau',
      message: `Ici, on lit ${s.map((c) => `\xAB ${c} \xBB`).join(', ')}.`,
      badChip: 0,
    };
  let i = $t(r.value);
  if (!i)
    return {
      kind: 'syntax',
      atoms: n,
      title: 'Valeur illisible',
      message:
        '\xC9cris un nombre apr\xE8s \xAB = \xBB : \xAB 12 \xBB, \xAB 8,5 \xBB ou \xAB 3/4 \xBB.',
      badChip: n.length - 1,
    };
  if (e.known.has(r.name) && e.texts.some((c) => uT(c.split(' '))?.name === r.name))
    return {
      kind: 'dup',
      atoms: n,
      complete: !0,
      title: 'D\xE9j\xE0 \xE9crit',
      message: `${r.name} est d\xE9j\xE0 sur ta feuille.`,
    };
  let o = ox(e.data, r.name);
  if (!o || !M(o, i))
    return t?.verify
      ? {
          kind: 'false',
          atoms: n,
          complete: !0,
          title: 'Pas la bonne valeur',
          message: O7(e, r.name, r.value),
          badChip: n.length - 1,
        }
      : { kind: 'pending', atoms: n, complete: !0 };
  if (e.known.has(r.name))
    return {
      kind: 'useless',
      atoms: n,
      complete: !0,
      title: 'D\xE9j\xE0 dans ton tableau',
      message: `${r.name} se lit d\xE9j\xE0 dans ton tableau : passe \xE0 la suite.`,
    };
  let a = new Set([...e.known, r.name]),
    l = ax({ ...e, known: a }),
    u = l.every((c) => c !== null);
  return N7(e, r.name)
    ? {
        kind: 'step',
        atoms: n,
        complete: !0,
        hora: qK.hora,
        rule: qK,
        read: { name: r.name },
        decided: PK(e.decisions, l),
        final: u,
      }
    : {
        kind: 'useless',
        atoms: n,
        complete: !0,
        title: u ? 'Tu tiens la r\xE9ponse !' : 'Juste !',
        message:
          e.data.kind === 'series'
            ? 'Juste, mais montre d\u2019o\xF9 elle vient : remplis le tableau des effectifs cumul\xE9s (bouton \xAB Tableau \xBB de la palette).'
            : 'Juste, mais montre d\u2019o\xF9 elle vient : remplis le tableau (bouton \xAB Tableau \xBB de la palette).',
        read: { name: r.name },
        jump: !0,
        final: u,
      };
}
function jK(e, n, t) {
  let r = n.flatMap((i) => i.atoms);
  return r.length
    ? r.filter(rh).length
      ? r.length !== 1
        ? {
            kind: 'syntax',
            atoms: r,
            title: 'Le tableau seul sur sa ligne',
            message: 'Un tableau occupe toute une ligne : efface ce qu\u2019il y a autour.',
            badChip: r.findIndex((i) => !rh(i)),
          }
        : q7(e, r[0])
      : K7(e, r, t)
    : { kind: 'empty', atoms: r };
}
function QK(e, n) {
  if (n.grid) {
    let t = AK(e);
    (t.known.forEach((r) => e.known.add(r)),
      t.prop && (e.propKnown = !0),
      (e.table = !0),
      e.texts.push(n.atoms[0]));
  } else (n.read && e.known.add(n.read.name), e.texts.push(n.atoms.join(' ')));
  ((e.decisions = ax(e)), e.lines++);
}
function FK(e) {
  return e.decisions.every((n) => n !== null);
}
function VK(e, n) {
  if (rh(n)) {
    let i = sx(n);
    return !!i && !KK(e.expected, i);
  }
  let t = uT(P7(n));
  if (!t) return !1;
  let r = ox(e.data, t.name),
    s = $t(t.value);
  return !!r && !!s && M(r, s);
}
function P7(e) {
  return rh(e) ? [e] : e.trim().split(/\s+/);
}
var mT = new Set(['<', '\u2264', '>', '\u2265']),
  DK = (e) => H($i(ne(Te(e))), {});
function I7(e) {
  return e.k === 'sqrt' ? H(e.a, {}) : H(e, {}) ** 2;
}
function zK(e) {
  let n = $i(ne(Te(e.expr)));
  return {
    spec: e,
    value: H(n, {}),
    inner: I7(n),
    lo: e.lower === void 0 ? null : DK(e.lower),
    hi: e.upper === void 0 ? null : DK(e.upper),
    lowOk: !1,
    highOk: !1,
    done: !1,
    written: new Set(),
  };
}
function BK(e) {
  let n = e.filter((l) => mT.has(l));
  if (!n.length) {
    let l = Ae(e);
    if (l.dis.length !== 1 || l.dis[0].cmp)
      throw new Error('\xC9cris un calcul ou une comparaison.');
    return { k: 'eq', line: l, sides: l.dis[0].sides };
  }
  if (e.includes('=')) throw new Error('Pas de \xAB = \xBB dans une comparaison.');
  let t = n.every((l) => l === '>' || l === '\u2265'),
    r = n.every((l) => l === '<' || l === '\u2264');
  if (!t && !r)
    throw new Error(
      'Une comparaison va dans un seul sens : tout en \xAB < \xBB, ou tout en \xAB > \xBB.',
    );
  let s = [[]];
  if (
    (e.forEach((l) => (mT.has(l) ? s.push([]) : s[s.length - 1].push(l))), s.some((l) => !l.length))
  )
    throw new Error('Il manque un nombre.');
  let i = s.map((l) => $i(l)),
    o = n.map((l) => l === '<' || l === '>');
  return (
    t && ((i = i.reverse()), (o = o.reverse())),
    { k: 'cmp', line: { dis: [{ sides: i, cmp: '<' }] }, terms: i, strict: o }
  );
}
function A7(e) {
  let n = e[e.length - 1];
  return e.reduce((r, s) => r + (s === '(' ? 1 : s === ')' ? -1 : 0), 0) > 0
    ? !0
    : !n || mT.has(n) || ['=', '+', '\u2212', '\xD7', '\xF7', '(', '\u221A', '^'].includes(n);
}
var j7 = (e, n) =>
    ((e.k === 'sq' && Ce(H(e.a, {}), n)) ||
      (e.k === 'pow' && Ce(H(e.a, {}), n) && Ce(H(e.b, {}), 2)) ||
      (e.k === 'mul' && e.c.length === 2 && e.c.every((t) => Ce(H(t, {}), n)))) &&
    !0,
  dT = (e, n, t, r, s, i = !1) => ({
    kind: 'step',
    atoms: n,
    line: e,
    final: i,
    hora: r,
    rule: { id: 'encadrement', card: 'Encadrer une racine carr\xE9e', label: t, hora: r, why: s },
  });
function pT(e, n, t, r) {
  let s = ne(wt(t).atoms.flatMap((g) => (/\s/.test(g) ? Te(g) : [g])));
  if (!s.length) return { kind: 'empty', atoms: s, badChip: -1 };
  let i;
  try {
    i = BK(s);
  } catch (g) {
    return A7(s)
      ? { kind: 'open', atoms: s, complete: !1 }
      : {
          kind: 'syntax',
          atoms: s,
          title: '\xC7a commence mal',
          message: g.message,
          badChip: t.length - 1,
        };
  }
  let o = Ke(i.line),
    a = n.find((g) => {
      try {
        return Ke(BK(ne(Te(g.line))).line) === o;
      } catch {
        return !1;
      }
    });
  if (a)
    return {
      kind: 'trap',
      atoms: s,
      title: 'Pi\xE8ge : ' + a.title.charAt(0).toLowerCase() + a.title.slice(1),
      message: a.why,
      trap: { line: i.line, title: a.title, why: a.why },
      badChip: -1,
    };
  if (e.written.has(o))
    return {
      kind: 'useless',
      atoms: s,
      line: i.line,
      title: 'Tu l\u2019as d\xE9j\xE0 \xE9crit',
      message: 'Cette ligne est d\xE9j\xE0 dans ta feuille.',
    };
  let l;
  try {
    l = (i.k === 'eq' ? i.sides : i.terms).map((g) => H(g, {}));
  } catch {
    l = [NaN];
  }
  if (l.some((g) => !isFinite(g)))
    return {
      kind: 'syntax',
      atoms: s,
      title: 'Un nombre seulement',
      message: 'Ici, on ne calcule qu\u2019avec des nombres.',
      badChip: -1,
    };
  if (i.k === 'eq')
    return l.every((h) => Ce(h, l[0]))
      ? [e.lo, e.hi, e.value].find(
          (h) => h !== null && Ce(l[0], h * h) && i.sides.some((b) => j7(b, h)),
        ) === void 0
        ? {
            kind: 'useless',
            atoms: s,
            line: i.line,
            title: 'Juste, mais \xE0 c\xF4t\xE9',
            message: 'Calcule les carr\xE9s des nombres \xE0 comparer.',
          }
        : dT(
            i.line,
            s,
            'Carr\xE9',
            1,
            'On calcule le carr\xE9 pour le comparer au nombre sous la racine.',
          )
      : {
          kind: 'false',
          atoms: s,
          line: i.line,
          title: 'Calcul faux',
          message: 'V\xE9rifie ce calcul.',
        };
  for (let g = 0; g + 1 < l.length; g++)
    if (!(i.strict[g] ? l[g] < l[g + 1] && !Ce(l[g], l[g + 1]) : l[g] <= l[g + 1] + 1e-9))
      return {
        kind: 'false',
        atoms: s,
        line: i.line,
        title: 'Comparaison fausse',
        message:
          'Compare les valeurs : ' +
          l.map((b) => String(+b.toFixed(4)).replace('.', ',')).join(' ; ') +
          '.',
      };
  let u = (g) => Ce(H(g, {}), e.value) && JSON.stringify(g).includes('sqrt'),
    c = (g) => Ce(g, e.inner),
    f = e.lo === null ? NaN : e.lo * e.lo,
    d = e.hi === null ? NaN : e.hi * e.hi,
    m = e.lo !== null && e.hi !== null;
  if (!i.terms.some(u)) {
    let g = !1,
      h = !1;
    if (
      (l.length === 3 && c(l[1])
        ? ((g = Ce(l[0], f)), (h = Ce(l[2], d)))
        : l.length === 2 && ((g = Ce(l[0], f) && c(l[1])), (h = c(l[0]) && Ce(l[1], d))),
      !g && !h)
    )
      return {
        kind: 'useless',
        atoms: s,
        line: i.line,
        title: 'Juste, mais \xE0 c\xF4t\xE9',
        message:
          'Encadre ' +
          String(e.inner).replace('.', ',') +
          ' par les carr\xE9s des deux nombres cherch\xE9s.',
      };
    let b = (e.lo === null || g) && (e.hi === null || h);
    return {
      ...dT(
        i.line,
        s,
        b
          ? m
            ? 'Encadrer par des carr\xE9s'
            : 'Comparer les carr\xE9s'
          : 'Comparer \xE0 un carr\xE9',
        b ? 2 : 1,
        m
          ? 'Le nombre sous la racine est entre deux carr\xE9s.'
          : 'On compare les carr\xE9s : ils sont rang\xE9s comme les nombres positifs.',
      ),
      bnd: { low: g, high: h },
    };
  }
  let p = e.lo === null ? 0 : 1;
  return l.length !== (m ? 3 : 2) || !u(i.terms[p])
    ? {
        kind: 'useless',
        atoms: s,
        line: i.line,
        title: m ? 'L\u2019encadrement complet' : 'La comparaison demand\xE9e',
        message: '\xC9cris : ' + Q7(e.spec) + '.',
      }
    : (e.lo !== null && !Ce(l[0], e.lo)) || (e.hi !== null && !Ce(l[l.length - 1], e.hi))
      ? {
          kind: 'useless',
          atoms: s,
          line: i.line,
          title: 'Juste, mais pas l\u2019encadrement demand\xE9',
          message: 'Cherche des bornes plus proches.',
        }
      : (e.lo === null || e.lowOk) && (e.hi === null || e.highOk)
        ? {
            ...dT(
              i.line,
              s,
              m ? 'Prendre les racines' : 'Conclure',
              2,
              'La racine carr\xE9e conserve l\u2019ordre des nombres positifs.',
              !0,
            ),
            bnd: { low: !1, high: !1, done: !0 },
          }
        : r?.verify
          ? {
              kind: 'unjustified',
              atoms: s,
              line: i.line,
              keep: { line: i.line, kind: 'jump' },
              title: 'Justifie avec les carr\xE9s',
              message:
                '\xC9cris d\u2019abord la comparaison des carr\xE9s (' +
                [e.lo === null ? null : f, e.inner, e.hi === null ? null : d]
                  .filter((g) => g !== null)
                  .map((g) => String(+g.toFixed(6)).replace('.', ','))
                  .join(' < ') +
                ').',
            }
          : { kind: 'pending', atoms: s, complete: !0 };
}
function UK(e, n) {
  n.line &&
    (e.written.add(Ke(n.line)),
    n.kind === 'useless' && n.bnd?.done && (e.done = !0),
    n.kind === 'step' &&
      n.bnd &&
      (n.bnd.done && (e.done = !0), n.bnd.low && (e.lowOk = !0), n.bnd.high && (e.highOk = !0)));
}
function gT(e) {
  return e.done;
}
function GK(e, n) {
  return e.written.has(Ke(n));
}
function Q7(e) {
  return [e.lower, e.expr, e.upper].filter((n) => n !== void 0).join(' < ');
}
var F7 = '\u2009',
  ou = [1, 0, 0, 0],
  ah = [2, 0, 0, 0],
  Ta = [3, 0, 0, 0],
  Sa = [0, 1, 0, 0],
  Sm = [0, 0, 1, 0],
  ZK = [0, 0, 0, 1],
  HK = {
    km: { f: 1e3, d: ou },
    hm: { f: 100, d: ou },
    dam: { f: 10, d: ou },
    m: { f: 1, d: ou },
    dm: { f: 0.1, d: ou },
    cm: { f: 0.01, d: ou },
    mm: { f: 0.001, d: ou },
    t: { f: 1e6, d: Sa },
    kg: { f: 1e3, d: Sa },
    hg: { f: 100, d: Sa },
    dag: { f: 10, d: Sa },
    g: { f: 1, d: Sa },
    dg: { f: 0.1, d: Sa },
    cg: { f: 0.01, d: Sa },
    mg: { f: 0.001, d: Sa },
    hL: { f: 0.1, d: Ta },
    daL: { f: 0.01, d: Ta },
    L: { f: 0.001, d: Ta },
    dL: { f: 1e-4, d: Ta },
    cL: { f: 1e-5, d: Ta },
    mL: { f: 1e-6, d: Ta },
    ha: { f: 1e4, d: ah },
    a: { f: 100, d: ah },
    j: { f: 86400, d: Sm },
    h: { f: 3600, d: Sm },
    min: { f: 60, d: Sm },
    s: { f: 1, d: Sm },
    '\u20AC': { f: 1, d: ZK },
  },
  V7 = Object.keys(HK).sort((e, n) => n.length - e.length),
  hT = { '\xB2': 2, '\xB3': 3 };
function D7(e, n) {
  return { f: e.f ** n, d: e.d.map((t) => t * n) };
}
function bT(e, n, t = 1) {
  return e.map((r, s) => r + t * n[s]);
}
function us(e, n) {
  return e.every((t, r) => t === n[r]);
}
var vT = [0, 0, 0, 0];
function WK(e, n) {
  let t = n,
    r = () => {
      let l = V7.find((p) => e.startsWith(p, t));
      if (!l) return null;
      let u = e[t + l.length];
      if (u && /[A-Za-zÀ-ÿ]/.test(u)) return null;
      t += l.length;
      let c = HK[l],
        f = l,
        d = t;
      for (; e[d] === ' '; ) d++;
      e[d] && hT[e[d]] && (t = d);
      let m = e[t];
      return (m && hT[m] && ((c = D7(c, hT[m])), (f += m), t++), { def: c, text: f });
    },
    s = r();
  if (!s) return null;
  let i = s.def.f,
    o = s.def.d,
    a = s.text;
  for (;;) {
    let l = t;
    for (; e[l] === ' '; ) l++;
    if (e[l] !== '/' && e[l] !== '\xF7') break;
    let u = t;
    for (t = l + 1; e[t] === ' '; ) t++;
    let c = r();
    if (!c) {
      t = u;
      break;
    }
    ((i /= c.def.f), (o = bT(o, c.def.d, -1)), (a += '/' + c.text));
  }
  return { unit: { text: a, f: i, d: o }, len: t - n };
}
function lx(e) {
  let n = e.replace(F7, '').trim(),
    t = WK(n, 0);
  return t && t.len === n.length ? t.unit : null;
}
var Fs = class extends Error {};
function JK(e) {
  let n = e.replace(/\u2009|\u202F|\u00A0/g, ' '),
    t = [],
    r = 0;
  for (; r < n.length; ) {
    let s = n[r];
    if (/\s/.test(s)) {
      r++;
      continue;
    }
    let i = /^\d+(?:[,.]\d+)?/.exec(n.slice(r));
    if (i) {
      (t.push({ t: 'num', v: Number(i[0].replace(',', '.')), text: i[0].replace('.', ',') }),
        (r += i[0].length));
      continue;
    }
    if ('+\u2212-\xD7\xF7()=/'.includes(s) || s === '*') {
      let a = s === '-' ? '\u2212' : s === '*' ? '\xD7' : s === '/' ? '\xF7' : s;
      (t.push({ t: 'op', o: a }), r++);
      continue;
    }
    let o = WK(n, r);
    if (o) {
      (t.push({ t: 'unit', u: o.unit }), (r += o.len));
      continue;
    }
    throw new Fs(`\xAB ${n.slice(r).split(/\s/)[0]} \xBB n\u2019est pas une unit\xE9 connue.`);
  }
  return t;
}
function B7(e) {
  let n = 0,
    t = () => e[n],
    r = () => {
      let a = s();
      for (;;) {
        let l = t();
        if (l && l.t === 'op' && (l.o === '+' || l.o === '\u2212'))
          (n++, (a = { k: 'add', a, b: s(), op: l.o }));
        else return a;
      }
    },
    s = () => {
      let a = i();
      for (;;) {
        let l = t();
        if (l && l.t === 'op' && (l.o === '\xD7' || l.o === '\xF7'))
          (n++, (a = { k: 'mul', a, b: i(), op: l.o }));
        else return a;
      }
    },
    i = () => {
      let a = t();
      if (!a) throw new Fs('La ligne s\u2019arr\xEAte au milieu d\u2019un calcul.');
      if (a.t === 'op' && a.o === '\u2212') return (n++, { k: 'neg', a: i() });
      if (a.t === 'op' && a.o === '(') {
        n++;
        let u = r(),
          c = t();
        if (!c || c.t !== 'op' || c.o !== ')')
          throw new Fs('Une parenth\xE8se n\u2019est pas referm\xE9e.');
        return (n++, { k: 'par', a: u });
      }
      if (a.t === 'unit')
        throw new Fs(`\xC9cris un nombre avant l\u2019unit\xE9 \xAB ${a.u.text} \xBB.`);
      if (a.t !== 'num') throw new Fs(`\xAB ${a.o} \xBB arrive trop t\xF4t.`);
      let l = [];
      for (; t() && t().t === 'num'; ) {
        let u = e[n++],
          c = t();
        if (c && c.t === 'unit') (n++, l.push({ v: u.v, text: u.text, u: c.u }));
        else {
          l.push({ v: u.v, text: u.text, u: null });
          break;
        }
      }
      if (l.length > 1 && l.some((u) => !u.u))
        throw new Fs('Deux nombres se suivent : mets une op\xE9ration entre eux.');
      return { k: 'q', parts: l };
    },
    o = r();
  if (n < e.length) {
    let a = e[n];
    throw new Fs(
      a.t === 'unit'
        ? `L\u2019unit\xE9 \xAB ${a.u.text} \xBB suit d\xE9j\xE0 une unit\xE9.`
        : a.t === 'num'
          ? 'Deux nombres se suivent : mets une op\xE9ration entre eux.'
          : `\xAB ${a.o} \xBB est mal plac\xE9.`,
    );
  }
  return o;
}
var sh = class extends Error {},
  z7 = [
    [ou, 'une longueur'],
    [ah, 'une aire'],
    [Ta, 'un volume'],
    [Sa, 'une masse'],
    [Sm, 'une dur\xE9e'],
    [ZK, 'un prix'],
    [[1, 0, -1, 0], 'une vitesse'],
    [[-3, 1, 0, 0], 'une masse volumique'],
    [[3, 0, -1, 0], 'un d\xE9bit'],
    [vT, 'un nombre sans unit\xE9'],
  ];
function ux(e) {
  let n = z7.find(([t]) => us(t, e));
  return n ? n[1] : 'une grandeur compos\xE9e';
}
function cs(e) {
  switch (e.k) {
    case 'q': {
      let n = 0,
        t = null;
      for (let r of e.parts) {
        let s = r.u ? r.u.d : vT;
        if (t && !us(t, s))
          throw new sh(
            'On n\u2019accole que des grandeurs de m\xEAme nature (\xAB 2 h 30 min \xBB).',
          );
        ((t = s), (n += r.v * (r.u ? r.u.f : 1)));
      }
      return { v: n, d: t ?? vT };
    }
    case 'par':
      return cs(e.a);
    case 'neg': {
      let n = cs(e.a);
      return { v: -n.v, d: n.d };
    }
    case 'add': {
      let n = cs(e.a),
        t = cs(e.b);
      if (!us(n.d, t.d))
        throw new sh(
          `On ne peut pas ${e.op === '+' ? 'ajouter' : 'soustraire'} ${ux(n.d)} et ${ux(t.d)}.`,
        );
      return { v: e.op === '+' ? n.v + t.v : n.v - t.v, d: n.d };
    }
    case 'mul': {
      let n = cs(e.a),
        t = cs(e.b);
      if (e.op === '\xF7' && t.v === 0) throw new sh('On ne divise pas par 0.');
      return e.op === '\xD7'
        ? { v: n.v * t.v, d: bT(n.d, t.d) }
        : { v: n.v / t.v, d: bT(n.d, t.d, -1) };
    }
  }
}
function Ti(e) {
  switch (e.k) {
    case 'q':
      return e.parts.map((n) => (n.u ? `${n.text} ${n.u.text}` : n.text)).join(' ');
    case 'par':
      return '(' + Ti(e.a) + ')';
    case 'neg':
      return '\u2212' + Ti(e.a);
    case 'add':
      return Ti(e.a) + ' ' + e.op + ' ' + Ti(e.b);
    case 'mul':
      return Ti(e.a) + ' ' + e.op + ' ' + Ti(e.b);
  }
}
function cr(e) {
  switch (e.k) {
    case 'q':
      return e.parts.map((n) => pe(n.v) + (n.u ? ' ' + n.u.text : '')).join(' ');
    case 'par':
      return cr(e.a);
    case 'neg':
      return '\u2212(' + cr(e.a) + ')';
    case 'add':
      return '(' + cr(e.a) + e.op + cr(e.b) + ')';
    case 'mul': {
      if (e.op === '\xD7') {
        let n = cr(e.a),
          t = cr(e.b);
        return '(' + [n, t].sort().join('\xD7') + ')';
      }
      return '(' + cr(e.a) + '\xF7' + cr(e.b) + ')';
    }
  }
}
function ih(e, n) {
  return (
    n.add(cr(e)),
    (e.k === 'par' || e.k === 'neg') && ih(e.a, n),
    (e.k === 'add' || e.k === 'mul') && (ih(e.a, n), ih(e.b, n)),
    e.k === 'q' && e.parts.length === 1 && e.parts[0].u && n.add(cr(e)),
    n
  );
}
function Tm(e) {
  let n = e.k === 'par' ? e.a : e;
  return n.k !== 'q' || n.parts.some((t) => !t.u) ? null : n.parts.map((t) => t.u.text).join(' ');
}
function lh(e) {
  let n = JK(e);
  if (n.some((r) => r.t === 'op' && r.o === '\u2261'))
    throw new Fs('Ici on \xE9crit des \xE9galit\xE9s de grandeurs.');
  let t = [[]];
  if (
    (n.forEach((r) => {
      r.t === 'op' && r.o === '=' ? t.push([]) : t[t.length - 1].push(r);
    }),
    t.some((r) => !r.length))
  )
    throw new Fs('Un membre de l\u2019\xE9galit\xE9 est vide.');
  return { sides: t.map(B7) };
}
function U7(e) {
  return { dis: [{ sides: e.sides.map((t) => ({ k: 's', n: Ti(t) })) }] };
}
function XK(e) {
  return lh(e.dis[0].sides.map((n) => n.n ?? '').join(' = '));
}
var uh = (e, n) => Math.abs(e - n) <= 1e-9 * Math.max(1, Math.abs(e), Math.abs(n));
function YK(e, n = []) {
  let t = lh(e.target).sides[0],
    r = cs(t),
    s = e.unit
      .split(/\s+/)
      .map((a) => lx(a).text)
      .join(' '),
    i = lx(e.valueUnit ?? e.unit.split(/\s+/).pop());
  if (!i) throw new Fs(`Unit\xE9 inconnue : ${e.unit}`);
  let o = {
    spec: e,
    target: t,
    tv: r,
    unit: s,
    valueUnit: i,
    linked: ih(t, new Set()),
    sides: new Map(),
    vals: [],
  };
  return (
    oh(o, t),
    o.sides.set(cr(t), { node: t, val: r }),
    n.forEach((a) => {
      try {
        eP(o, lh(a));
      } catch {}
    }),
    o
  );
}
function oh(e, n) {
  try {
    e.vals.push(cs(n));
  } catch {}
  ((n.k === 'par' || n.k === 'neg') && oh(e, n.a),
    (n.k === 'add' || n.k === 'mul') && (oh(e, n.a), oh(e, n.b)));
}
function G7(e, n) {
  if (e.linked.has(cr(n)) || e.sides.has(cr(n))) return !0;
  let t;
  try {
    t = cs(n);
  } catch {
    return !1;
  }
  return e.vals.some((r) => us(r.d, t.d) && uh(r.v, t.v));
}
function eP(e, n) {
  let t = 0;
  return (
    n.sides.forEach((r) => {
      let s = cr(r);
      (e.sides.has(s) || (t++, e.sides.set(s, { node: r, val: cs(r) })), ih(r, e.linked), oh(e, r));
    }),
    t
  );
}
function nP(e, n) {
  eP(e, XK(n));
}
function kT(e, n) {
  if (Tm(n) !== e.unit) return !1;
  let t = cs(n);
  return us(t.d, e.tv.d) && uh(t.v, e.tv.v);
}
function xT(e) {
  for (let { node: n } of e.sides.values()) if (kT(e, n)) return !0;
  return !1;
}
function tP(e) {
  let n = [];
  for (let { node: t, val: r } of e.sides.values()) kT(e, t) && n.push(r.v / e.valueUnit.f);
  return n;
}
function Z7(e) {
  try {
    let n = e.sides.map(cs);
    return n.every((t, r) => !r || (us(t.d, n[0].d) && uh(t.v, n[0].v)));
  } catch {
    return !1;
  }
}
function rP(e) {
  try {
    return Z7(XK(e));
  } catch {
    return !1;
  }
}
function H7(e) {
  return e
    .flatMap((n) => n.atoms)
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim();
}
function W7(e) {
  if (e <= 0) return null;
  let n = Math.round(Math.log10(e));
  return n !== 0 && uh(e, 10 ** n) ? n : null;
}
function J7(e, n, t, r) {
  let s = Tm(e),
    i = Tm(n),
    o = `\xAB ${Ti(e)} = ${Ti(n)} \xBB est faux.`;
  if (s && i && s !== i) {
    let a = lx(s.split(' ').pop()),
      l = lx(i.split(' ').pop());
    if (
      us(t.d, Sm) &&
      (s.includes('h') || i.includes('h')) &&
      (s.includes('min') || i.includes('min'))
    )
      return `${o} Une heure fait 60 minutes (pas 100) : 0,5 h = 30 min, 0,25 h = 15 min.`;
    if (a && l && s.split(' ').length === 1 && i.split(' ').length === 1) {
      let u = l.f / a.f,
        c = W7(r.v / t.v),
        f = u >= 1 ? `1 ${l.text} = ${pe(u)} ${a.text}` : `1 ${a.text} = ${pe(1 / u)} ${l.text}`;
      return (
        o +
        (c !== null
          ? ` Ton nombre est ${pe(10 ** Math.abs(c))} fois trop ${c > 0 ? 'grand' : 'petit'}. `
          : ' ') +
        `Rep\xE8re : ${f}.`
      );
    }
  }
  return o + ' Calcule \xE0 nouveau, en gardant les unit\xE9s.';
}
function yT(e, n, t, r) {
  let s = t.flatMap((l) => l.atoms);
  if (!s.length) return { kind: 'empty', atoms: s, badChip: -1 };
  let i = H7(t);
  if (!i.includes('=')) {
    try {
      JK(i);
    } catch (l) {
      return {
        kind: 'syntax',
        atoms: s,
        title: '\xC7a commence mal',
        message: l.message,
        badChip: t.length - 1,
      };
    }
    return { kind: 'open', atoms: s, complete: !1 };
  }
  let o;
  try {
    o = lh(i);
  } catch (l) {
    return (i.match(/\(/g) ?? []).length > (i.match(/\)/g) ?? []).length ||
      /[=+−×÷(/]\s*$/.test(i) ||
      /\d\s*$/.test(i)
      ? { kind: 'open', atoms: s, complete: !1 }
      : {
          kind: 'syntax',
          atoms: s,
          title: '\xC7a commence mal',
          message: l.message,
          badChip: t.length - 1,
        };
  }
  let a = X7(e, n, o, s);
  return !r?.verify && (a.kind === 'unjustified' || a.kind === 'false')
    ? { kind: 'pending', atoms: s, complete: !0 }
    : a;
}
function X7(e, n, t, r) {
  let s = U7(t),
    i = (h) => h.sides.map(cr).join(' = '),
    o = i(t),
    a = n.find((h) => {
      try {
        return i(lh(h.line)) === o;
      } catch {
        return !1;
      }
    }),
    l;
  try {
    l = t.sides.map(cs);
  } catch (h) {
    return { kind: 'false', atoms: r, title: 'Pas la m\xEAme nature', message: h.message };
  }
  for (let h = 0; h + 1 < l.length; h++) {
    let b = l[h],
      v = l[h + 1];
    if (!(us(b.d, v.d) && uh(b.v, v.v)))
      return a
        ? {
            kind: 'trap',
            atoms: r,
            title: 'Pi\xE8ge : ' + a.title.charAt(0).toLowerCase() + a.title.slice(1),
            message: a.why,
            trap: { line: s, title: a.title, why: a.why },
            badChip: -1,
          }
        : us(b.d, v.d)
          ? {
              kind: 'false',
              atoms: r,
              title: 'Ce n\u2019est pas \xE9gal',
              message: J7(t.sides[h], t.sides[h + 1], b, v),
            }
          : {
              kind: 'false',
              atoms: r,
              title: 'Pas la m\xEAme nature',
              message: `\xC0 gauche, ${ux(b.d)} ; \xE0 droite, ${ux(v.d)} : elles ne peuvent pas \xEAtre \xE9gales. V\xE9rifie tes unit\xE9s${us(b.d, ah) || us(v.d, ah) || us(b.d, Ta) || us(v.d, Ta) ? ' (et les \xB2 ou \xB3)' : ''}.`,
            };
  }
  if (!t.sides.some((h) => G7(e, h)))
    return {
      kind: 'useless',
      atoms: r,
      line: s,
      title: 'Juste, mais \xE0 c\xF4t\xE9 de la question',
      message: `C\u2019est vrai, mais \xE7a ne part pas de ${Ti(e.target)}. Garde-la comme rep\xE8re, ou pars de la grandeur de la question.`,
    };
  let c = t.sides.filter((h) => !e.sides.has(cr(h))).length;
  if (!c)
    return {
      kind: 'useless',
      atoms: r,
      line: s,
      title: 'Juste, mais \xE7a ne t\u2019avance pas',
      message: 'Tu avais d\xE9j\xE0 \xE9crit tout \xE7a.',
    };
  let d = !xT(e) && t.sides.some((h) => kT(e, h)),
    m = t.sides.some((h, b) => {
      let v = Tm(h);
      return !!v && t.sides.some((k, y) => y !== b && Tm(k) && Tm(k) !== v);
    }),
    p = Math.min(3, c);
  return {
    kind: 'step',
    atoms: r,
    line: s,
    final: d,
    hora: p,
    rule: {
      id: m ? 'conversion' : 'grandeurs',
      card: '',
      label: m ? 'Conversion' : 'Calcul avec les unit\xE9s',
      hora: p,
      why: d
        ? `${Ti(e.target)} est \xE9crit en ${e.unit} : c\u2019est la r\xE9ponse.`
        : 'Chaque maillon est juste : m\xEAme nature, m\xEAme valeur.',
    },
  };
}
var wT = 16,
  sf = class extends Error {};
function Y7(e) {
  let n = [{}];
  if (
    (Object.keys(e.vars).forEach((t) => {
      let r = e.vars[t];
      n = n.flatMap((s) => r.map((i) => ({ ...s, [t]: i })));
    }),
    n.length > wT)
  ) {
    let t = n.length / wT;
    n = Array.from({ length: wT }, (r, s) => n[Math.floor(s * t)]);
  }
  return (
    (e.defs || []).forEach((t) => {
      let r;
      try {
        r = Ve(t);
      } catch {
        throw new sf(`d\xE9finition illisible : \xAB ${t} \xBB`);
      }
      let s = r.dis.length === 1 ? r.dis[0] : null,
        i = s && s.sides.length === 2 && s.sides[0].k === 's' ? s.sides[0].n : null;
      if (!s || !i)
        throw new sf(
          `une d\xE9finition s'\xE9crit \xAB grandeur = expression \xBB : \xAB ${t} \xBB`,
        );
      n.forEach((o) => {
        let a = H(s.sides[1], o);
        if (!Number.isFinite(a))
          throw new sf(
            `\xAB ${t} \xBB ne se calcule pas pour ${Object.entries(o)
              .map(([l, u]) => `${l} = ${u}`)
              .join(', ')}`,
          );
        o[i] = a;
      });
    }),
    n
  );
}
function sP(e) {
  let n = NaN;
  try {
    let t = Ve(e),
      r = t.dis.length === 1 ? t.dis[0] : null;
    r && r.sides.length === 1 && (n = H(r.sides[0], {}));
  } catch {
    n = NaN;
  }
  if (!Number.isFinite(n)) throw new sf(`valeur exacte illisible : \xAB ${e} \xBB`);
  return n;
}
function ST(e) {
  return (
    Object.values(e.symbols).some((n) => !!n.exact?.length) ||
    (e.choices ?? []).some((n) => !!n.exact && n.value === void 0)
  );
}
function eJ(e) {
  if (!ST(e)) return e;
  let n = {};
  Object.entries(e.symbols).forEach(([r, s]) => {
    if (!s.exact?.length) {
      n[r] = s;
      return;
    }
    let i = s.exact.map(sP);
    n[r] = s.given ? { ...s, value: i[0] } : { ...s, values: i };
  });
  let t = e.choices?.map((r) =>
    r.exact && r.value === void 0 && !e.complex ? { ...r, value: sP(r.exact) } : r,
  );
  return { ...e, symbols: n, ...(t ? { choices: t } : {}) };
}
function iP(e) {
  let n = eJ(e);
  if (!n.samples || n.envs) return n;
  let t = Y7(n.samples);
  if (t.length < 2) throw new sf('il faut au moins 2 environnements d\u2019\xE9chantillons');
  return { ...n, envs: t };
}
var oP = new WeakMap(),
  aP = new WeakMap();
function Ie(e) {
  return Ve(e);
}
function Vs(e, n) {
  return (e.model.preds || []).filter((t) => t.skill === n);
}
var lu = {
  pythagore: {
    card: 'Th\xE9or\xE8me de Pythagore',
    conclusions(e) {
      return Vs(e, 'pythagore').map((n) => ({
        line: Ie(n.hyp + '\xB2 = ' + n.sides[0] + '\xB2 + ' + n.sides[1] + '\xB2'),
        label: 'Pythagore',
        hora: 5,
        why:
          'Le triangle est rectangle en ' +
          n.right +
          ', donc [' +
          n.hyp +
          '] est l\u2019hypot\xE9nuse : ' +
          n.hyp +
          '\xB2 = ' +
          n.sides[0] +
          '\xB2 + ' +
          n.sides[1] +
          '\xB2.',
        hint:
          'Le triangle est rectangle en ' +
          n.right +
          ' : quel th\xE9or\xE8me relie ses trois c\xF4t\xE9s ? Commence la ligne par ' +
          n.hyp +
          '\xB2.',
      }));
    },
    traps(e) {
      let n = [];
      return (
        Vs(e, 'pythagore').forEach((t) => {
          let r = t.hyp,
            s = t.sides[0],
            i = t.sides[1],
            o =
              'L\u2019angle droit est en ' +
              t.right +
              ' : l\u2019hypot\xE9nuse est le c\xF4t\xE9 oppos\xE9, [' +
              r +
              ']. C\u2019est ' +
              r +
              '\xB2 qui est seul d\u2019un c\xF4t\xE9.',
            a =
              'Pour obtenir le carr\xE9 de l\u2019hypot\xE9nuse, on ADDITIONNE les carr\xE9s des deux autres c\xF4t\xE9s.';
          (n.push({
            line: Ie(r + ' = ' + s + ' + ' + i),
            title: 'Additionner les longueurs',
            why:
              'Pythagore relie les CARR\xC9S des longueurs : ' +
              r +
              '\xB2 = ' +
              s +
              '\xB2 + ' +
              i +
              '\xB2. En additionnant les longueurs, on tombe sur une r\xE9ponse pi\xE8ge.',
          }),
            n.push({
              line: Ie(r + '\xB2 = ' + s + ' + ' + i),
              title: 'Il manque les carr\xE9s',
              why:
                'Ce sont les carr\xE9s des c\xF4t\xE9s qui s\u2019additionnent : ' +
                s +
                '\xB2 + ' +
                i +
                '\xB2.',
            }),
            n.push({
              line: Ie(s + '\xB2 = ' + r + '\xB2 + ' + i + '\xB2'),
              title: 'Mauvaise hypot\xE9nuse',
              why: o,
            }),
            n.push({
              line: Ie(i + '\xB2 = ' + r + '\xB2 + ' + s + '\xB2'),
              title: 'Mauvaise hypot\xE9nuse',
              why: o,
            }),
            n.push({
              line: Ie(r + '\xB2 = ' + i + '\xB2 \u2212 ' + s + '\xB2'),
              title: 'Soustraire au lieu d\u2019additionner',
              why: a,
            }),
            n.push({
              line: Ie(r + '\xB2 = ' + s + '\xB2 \u2212 ' + i + '\xB2'),
              title: 'Soustraire au lieu d\u2019additionner',
              why: a,
            }));
        }),
        n
      );
    },
  },
  baisse: {
    card: 'Appliquer un pourcentage',
    conclusions(e) {
      let n = [];
      return (
        Vs(e, 'baisse').forEach((t) => {
          (n.push({
            line: Ie(t.remise + ' = ' + t.taux + ' % \xD7 ' + t.base),
            label: 'Pourcentage',
            hora: 4,
            why:
              'Baisser de ' +
              t.taux +
              ' %, c\u2019est retirer ' +
              t.taux +
              ' % du prix : la remise vaut ' +
              t.taux +
              ' % de ' +
              t.base +
              '.',
            hint: 'Commence par la remise : combien font ' + t.taux + ' % de ' + t.base + ' ?',
          }),
            n.push({
              line: Ie(t.nouveau + ' = ' + t.base + ' \u2212 ' + t.remise),
              label: 'Retirer la remise',
              hora: 3,
              why: 'Le nouveau prix, c\u2019est le prix de d\xE9part moins la remise.',
              hint: 'Le nouveau prix, c\u2019est le prix de d\xE9part moins la remise.',
            }),
            n.push({
              line: Ie(t.nouveau + ' = ' + t.base + ' \u2212 ' + t.taux + ' % \xD7 ' + t.base),
              label: 'Pourcentage',
              hora: 4,
              why: 'On retire du prix ' + t.taux + ' % de ce prix.',
              hint:
                'Le nouveau prix, c\u2019est le prix de d\xE9part moins ' +
                t.taux +
                ' % de ce prix.',
            }),
            n.push({
              line: Ie(t.nouveau + ' = ' + t.base + ' \xD7 (1 \u2212 ' + t.taux + ' %)'),
              label: 'Coefficient multiplicateur',
              hora: 5,
              why:
                'Baisser de ' +
                t.taux +
                ' %, c\u2019est garder ' +
                (100 - t.taux) +
                ' % du prix : on multiplie par 1 \u2212 ' +
                t.taux +
                ' %.',
              hint:
                'Baisser de ' +
                t.taux +
                ' %, c\u2019est multiplier le prix par un nombre. Lequel ?',
            }));
        }),
        n
      );
    },
    traps(e) {
      let n = [];
      return (
        Vs(e, 'baisse').forEach((t) => {
          let r =
            t.taux +
            ' % de ' +
            t.base +
            ' ne font pas ' +
            t.taux +
            ' : la remise se calcule sur le prix (' +
            t.taux +
            ' % \xD7 ' +
            t.base +
            ').';
          (n.push({
            line: Ie(t.nouveau + ' = ' + t.base + ' \u2212 ' + t.taux),
            title: '\u2212' + t.taux + ' % n\u2019est pas \u2212' + t.taux,
            why: r,
          }),
            n.push({
              line: Ie(t.remise + ' = ' + t.taux),
              title: 'La remise n\u2019est pas ' + t.taux,
              why: r,
            }),
            n.push({
              line: Ie(t.nouveau + ' = ' + t.taux + ' % \xD7 ' + t.base),
              title: '\xC7a, c\u2019est la remise',
              why:
                t.taux +
                ' % \xD7 ' +
                t.base +
                ' est le montant de la r\xE9duction, pas le nouveau prix. Il faut encore le retirer du prix de d\xE9part.',
            }),
            n.push({
              line: Ie(t.nouveau + ' = ' + t.remise),
              title: '\xC7a, c\u2019est la remise',
              why:
                'La remise est ce qu\u2019on enl\xE8ve. Le nouveau prix, c\u2019est ' +
                t.base +
                ' \u2212 remise.',
            }),
            n.push({
              line: Ie(t.nouveau + ' = ' + t.base + ' \u2212 ' + t.taux + ' %'),
              title: 'Retirer ' + pe(t.taux / 100) + ', ce n\u2019est pas retirer ' + t.taux + ' %',
              why:
                t.taux +
                ' % s\u2019applique au prix : ' +
                t.taux +
                ' % \xD7 ' +
                t.base +
                ', puis on le retire.',
            }));
        }),
        n
      );
    },
  },
  produitNul: {
    card: '\xC9quation produit nul',
    conclusions(e) {
      let n = [];
      return (
        e.facts.forEach((t) => {
          if (t.line.dis.length !== 1) return;
          let r = mh(t.line.dis[0], e.K);
          if (r) {
            if (r.length === 1) {
              n.push({
                line: { dis: [{ sides: [r[0], X(0)] }] },
                label: 'Carr\xE9 nul',
                hora: 5,
                why: 'Un carr\xE9 est nul si et seulement si le nombre \xE9lev\xE9 au carr\xE9 est nul : u\xB2 = 0 donne u = 0.',
                hint: 'Un carr\xE9 est nul quand le nombre au carr\xE9 est nul : \xE9cris \xAB (ce qui est au carr\xE9) = 0 \xBB.',
              });
              return;
            }
            n.push({
              line: { dis: r.map((s) => ({ sides: [s, X(0)] })) },
              label: 'Produit nul',
              hora: 6,
              caseHora: 3,
              caseLabel: 'Produit nul (un cas)',
              why: 'Un produit est nul si et seulement si l\u2019un de ses facteurs est nul.',
              hint: 'Un produit est nul quand l\u2019un de ses facteurs est nul : \xE9cris \xAB facteur = 0 ou facteur = 0 \xBB.',
            });
          }
        }),
        n
      );
    },
    traps(e) {
      let n = [];
      return (
        e.facts.forEach((t) => {
          if (t.line.dis.length !== 1) return;
          let r = mh(t.line.dis[0], e.K);
          !r ||
            r.length !== 2 ||
            n.push({
              line: Lm(r[0], r[1]),
              title: 'Chaque facteur se compare \xE0 0',
              why: 'Le produit vaut 0 : c\u2019est CHAQUE facteur qu\u2019on \xE9gale \xE0 0, pas les facteurs entre eux.',
            });
        }),
        n
      );
    },
  },
  facteurCommun: {
    card: 'Factoriser avec un facteur commun',
    conclusions(e) {
      let n = [];
      return (
        (e.model.answers ? e.facts.slice() : e.facts.slice().reverse()).forEach((r) => {
          if (r.line.dis.length !== 1 || r.line.dis[0].sides.length !== 2) return;
          let s = r.line.dis[0];
          [0, 1].forEach((i) => {
            let o = s.sides[i];
            if (o.k !== 'add' || o.c.length < 2 || !De(o, e.K)) return;
            let a = s.sides[1 - i];
            if (!(a.k === 's' && !Fe(o)[a.n]) && De(a, e.K)) return;
            let u = o.c.map((m) => {
              let p = $n(m),
                g = (p.t.k === 'mul' ? p.t.c : [p.t]).flatMap((h) =>
                  h.k === 'sq' && h.a.k === 'add' && De(h.a, e.K) ? [h.a, h.a] : [h],
                );
              return { neg: p.neg, f: g };
            });
            if (
              (u[0].f.forEach((m) => {
                if (!De(m, e.K) || n.length) return;
                let p = Ne(m);
                if (!u.every((h) => h.f.some((b) => Ne(b) === p))) return;
                let g = u.map((h) => {
                  let b = !1,
                    v = h.f.filter((y) => (!b && Ne(y) === p ? ((b = !0), !1) : !0)),
                    k = v.length ? V('mul', v) : X(1);
                  return h.neg ? qe(k) : k;
                });
                n.push({
                  line: { dis: [Rn(i, V('mul', [m, V('add', g)]), s.sides[1 - i])] },
                  label: 'Facteur commun',
                  hora: 5,
                  transform: !0,
                  why:
                    'On rep\xE8re le facteur commun ' +
                    z(m) +
                    ' dans chaque terme et on le met en \xE9vidence : k\xB7a \u2212 k\xB7b = k(a \u2212 b).',
                  hint:
                    'Un m\xEAme facteur appara\xEEt dans chaque terme. Lequel ? \xC9cris ' +
                    s.sides[i === 0 ? 1 : 0].n +
                    ' = (ce facteur)(\u2026).',
                });
              }),
              n.length)
            )
              return;
            let c = kP(o, e.K);
            if (!c) return;
            let f = s.sides[1 - i],
              d = (fh(o.c[0], e.K)?.c ?? 0) < 0;
            if (
              (d ||
                n.push({
                  line: { dis: [Rn(i, V('add', c.shown), f)] },
                  label: 'Faire appara\xEEtre le facteur commun',
                  hora: 2,
                  transform: !0,
                  why: 'On \xE9crit chaque terme comme un produit par ' + z(c.k) + '.',
                  hint:
                    'Quel nombre (ou quelle lettre) divise chaque terme ? \xC9cris chaque terme sous la forme ' +
                    z(c.k) +
                    ' \xD7 (\u2026).',
                }),
              d)
            ) {
              let m = qe(c.k);
              n.push({
                line: {
                  dis: [
                    Rn(
                      i,
                      V('mul', [
                        m,
                        V(
                          'add',
                          c.rest.map((p) => qe(p)),
                        ),
                      ]),
                      f,
                    ),
                  ],
                },
                label: 'Facteur commun',
                hora: 5,
                transform: !0,
                why:
                  z(m) +
                  ' divise chaque terme : on le met en \xE9vidence, et chaque signe change dans la parenth\xE8se.',
                hint: 'Mets ' + z(m) + ' en facteur : chaque terme est divis\xE9 par ' + z(m) + '.',
              });
            }
            n.push({
              line: { dis: [Rn(i, V('mul', [c.k, V('add', c.rest)]), f)] },
              label: 'Facteur commun',
              hora: 5,
              transform: !0,
              why:
                z(c.k) +
                ' divise chaque terme : on le met en \xE9vidence, k \xD7 a + k \xD7 b = k(a + b).',
              hint:
                'Un m\xEAme facteur divise chaque terme. Lequel ? \xC9cris ' +
                (f.k === 's' ? f.n : '\u2026') +
                ' = ' +
                z(c.k) +
                '(\u2026).',
            });
          });
        }),
        n
      );
    },
    traps(e) {
      let n = [];
      return (
        e.facts.forEach((t) => {
          if (t.source !== 'given' || t.line.dis.length !== 1 || t.line.dis[0].sides.length !== 2)
            return;
          let r = t.line.dis[0];
          [0, 1].forEach((s) => {
            let i = r.sides[s];
            if (i.k !== 'add' || !De(i, e.K)) return;
            let o = kP(i, e.K);
            o &&
              i.c.forEach((a, l) => {
                if (Ne(a) === Ne(o.rest[l])) return;
                let u = o.rest.map((c, f) => (f === l ? a : c));
                n.push({
                  line: { dis: [Rn(s, V('mul', [o.k, V('add', u)]), r.sides[1 - s])] },
                  title: 'Chaque terme est divis\xE9',
                  why:
                    'Quand on met ' +
                    z(o.k) +
                    ' en facteur, il faut le retirer de CHAQUE terme : ' +
                    z($n(a).t) +
                    ' = ' +
                    z(o.k) +
                    ' \xD7 ' +
                    z($n(o.rest[l]).t) +
                    ', il reste donc ' +
                    z(o.rest[l]) +
                    '.',
                });
              });
          });
        }),
        n
      );
    },
  },
  secondDegre: {
    card: '\xC9quation du second degr\xE9',
    conclusions(e, n) {
      let t = [];
      return (
        Vs(e, 'secondDegre').forEach((r) => {
          t.push({
            line: Ie(r.delta + ' = ' + r.b + '\xB2 \u2212 4 \xD7 ' + r.a + ' \xD7 ' + r.c),
            label: 'Discriminant',
            hora: 5,
            why: 'Pour ax\xB2 + bx + c = 0, on calcule le discriminant : \u0394 = b\xB2 \u2212 4ac.',
            hint: 'Commence par le discriminant : \u0394 = b\xB2 \u2212 4ac.',
          });
          let s = e.K[r.delta],
            i = s !== void 0 && s > 0,
            o = s !== void 0 && Math.abs(s) < 1e-12;
          if (
            (r.double &&
              n &&
              s === void 0 &&
              t.push({
                line: Ie(
                  r.double +
                    ' = (\u2212' +
                    r.b +
                    ' + \u221A' +
                    r.delta +
                    ') \xF7 (2 \xD7 ' +
                    r.a +
                    ')',
                ),
                label: 'Solution double',
                hora: 5,
                needsProof: !0,
                why: '\u0394 = 0, donc une seule solution : ' + r.double + ' = \u2212b \xF7 (2a).',
                hint: 'Calcule d\u2019abord \u0394.',
              }),
            r.double &&
              (o || (n && s !== void 0)) &&
              t.push({
                line: Ie(r.double + ' = \u2212' + r.b + ' \xF7 (2 \xD7 ' + r.a + ')'),
                label: 'Solution double',
                hora: 5,
                needsProof: !o,
                why: '\u0394 = 0, donc une seule solution : ' + r.double + ' = \u2212b \xF7 (2a).',
                hint:
                  '\u0394 est nul : il y a une seule solution. \xC9cris ' +
                  r.double +
                  ' = \u2212b \xF7 (2a).',
              }),
            i || n)
          ) {
            let a = r.roots[0],
              l = r.roots[1];
            [
              [a, '\u2212'],
              [l, '+'],
              [a, '+'],
              [l, '\u2212'],
            ].forEach((u) => {
              t.push({
                line: Ie(
                  u[0] +
                    ' = (\u2212' +
                    r.b +
                    ' ' +
                    u[1] +
                    ' \u221A' +
                    r.delta +
                    ') \xF7 (2 \xD7 ' +
                    r.a +
                    ')',
                ),
                label: 'Formule des racines',
                hora: 5,
                needsProof: !i,
                why:
                  '\u0394 > 0, donc deux solutions : ' +
                  a +
                  ' = (\u2212b \u2212 \u221A\u0394) \xF7 (2a) et ' +
                  l +
                  ' = (\u2212b + \u221A\u0394) \xF7 (2a).',
                hint:
                  '\u0394 est positif : il y a deux solutions. \xC9cris ' +
                  u[0] +
                  ' = (\u2212b ' +
                  u[1] +
                  ' \u221A\u0394) \xF7 (2a).',
              });
            });
          }
        }),
        t
      );
    },
    traps(e) {
      let n = [],
        t = pe;
      return (
        Vs(e, 'secondDegre').forEach((r) => {
          let s = e.K[r.a],
            i = e.K[r.b],
            o = e.K[r.c];
          (n.push({
            line: Ie(r.delta + ' = ' + r.b + '\xB2 + 4 \xD7 ' + r.a + ' \xD7 ' + r.c),
            title: 'Le signe dans \u0394',
            why:
              '\u0394 = b\xB2 \u2212 4ac. Ici, \u22124 \xD7 a \xD7 c = \u22124 \xD7 ' +
              t(s) +
              ' \xD7 (' +
              t(o) +
              ') = ' +
              t(-4 * s * o) +
              '.',
          }),
            r.roots.forEach((a) => {
              ['\u2212', '+'].forEach((l) => {
                (n.push({
                  line: Ie(
                    a +
                      ' = (' +
                      r.b +
                      ' ' +
                      l +
                      ' \u221A' +
                      r.delta +
                      ') \xF7 (2 \xD7 ' +
                      r.a +
                      ')',
                  ),
                  title: 'Le signe de \u2212b',
                  why:
                    'La formule commence par \u2212b. Ici b = ' +
                    t(i) +
                    ', donc \u2212b = ' +
                    t(-i) +
                    '.',
                }),
                  n.push({
                    line: Ie(a + ' = (\u2212' + r.b + ' ' + l + ' \u221A' + r.delta + ') \xF7 2'),
                    title: 'Diviser par 2a',
                    why:
                      'Le d\xE9nominateur est 2a = 2 \xD7 ' + t(s) + ' = ' + t(2 * s) + ', pas 2.',
                  }),
                  n.push({
                    line: Ie(
                      a +
                        ' = (\u2212' +
                        r.b +
                        ' ' +
                        l +
                        ' \u221A' +
                        r.delta +
                        ') \xF7 2 \xD7 ' +
                        r.a,
                    ),
                    title: 'Des parenth\xE8ses autour de 2a',
                    why: 'On divise par le produit 2a : \xE9cris \xF7 (2a). Sans parenth\xE8ses, on divise par 2 puis on multiplie par a.',
                  }),
                  n.push({
                    line: Ie(
                      a +
                        ' = (\u2212' +
                        r.b +
                        ' ' +
                        l +
                        ' ' +
                        r.delta +
                        ') \xF7 (2 \xD7 ' +
                        r.a +
                        ')',
                    ),
                    title: 'La racine de \u0394',
                    why: 'Dans la formule, c\u2019est \u221A\u0394 qui appara\xEEt, pas \u0394.',
                  }));
              });
            }));
        }),
        n
      );
    },
    unjustified(e, n) {
      let t = null;
      return (
        Vs(e, 'secondDegre').forEach((r) => {
          t ||
            e.K[r.delta] !== void 0 ||
            n.dis.length !== 1 ||
            n.dis[0].sides.length !== 2 ||
            (n.dis[0].sides.some(
              (s) => s.k === 's' && (r.roots.indexOf(s.n) >= 0 || s.n === r.double),
            ) &&
              (t = {
                title: 'Calcule d\u2019abord \u0394',
                message:
                  'C\u2019est le signe du discriminant qui dit combien il y a de solutions. Calcule \u0394 avant d\u2019\xE9crire ' +
                  r.roots.join(' ou ') +
                  '.',
              }));
        }),
        t
      );
    },
  },
  differenceCarres: {
    card: 'Identit\xE9 remarquable a\xB2 \u2212 b\xB2',
    conclusions(e) {
      let n = [];
      return (
        TT(e).forEach((t) => {
          if (t.explicit)
            n.push({
              line: {
                dis: [
                  Rn(t.si, V('mul', [V('add', [t.a, qe(t.b)]), V('add', [t.a, t.b])]), t.other),
                ],
              },
              label: 'Identit\xE9 a\xB2 \u2212 b\xB2',
              hora: 5,
              transform: !0,
              why:
                'a\xB2 \u2212 b\xB2 = (a \u2212 b)(a + b), avec a = ' +
                z(t.a) +
                ' et b = ' +
                z(t.b) +
                '.',
              hint: 'Tu as une diff\xE9rence de deux carr\xE9s, a\xB2 \u2212 b\xB2. Applique a\xB2 \u2212 b\xB2 = (a \u2212 b)(a + b).',
            });
          else {
            let r = [];
            (t.pExplicit || r.push(z(t.pTerm) + ' = ' + z(tn('sq', t.a))),
              t.qExplicit || r.push(z(t.qTerm) + ' = ' + z(tn('sq', t.b))),
              n.push({
                line: { dis: [Rn(t.si, V('add', [tn('sq', t.a), qe(tn('sq', t.b))]), t.other)] },
                label: 'Reconna\xEEtre a\xB2 \u2212 b\xB2',
                hora: 3,
                transform: !0,
                why:
                  r.join(' et ') + ' : on fait appara\xEEtre une diff\xE9rence de deux carr\xE9s.',
                hint:
                  'Fais appara\xEEtre deux carr\xE9s : ' +
                  z(t.qTerm) +
                  ', c\u2019est le carr\xE9 de quel nombre ?',
              }));
          }
        }),
        n
      );
    },
    unjustified(e, n) {
      return !lP(e, n) || !TT(e).length
        ? null
        : {
            title: 'D\u2019o\xF9 vient ce produit ?',
            message:
              'Factoriser de t\xEAte, c\u2019est risqu\xE9. Fais d\u2019abord appara\xEEtre deux carr\xE9s : \xE9cris ' +
              e.model.goal[0] +
              ' = (\u2026)\xB2 \u2212 (\u2026)\xB2. Ensuite, je valide chaque transformation.',
          };
    },
    traps(e) {
      let n = [];
      return (
        TT(e).forEach((t) => {
          (n.push({
            line: { dis: [Rn(t.si, tn('sq', V('add', [t.a, qe(t.b)])), t.other)] },
            title: 'Ce n\u2019est pas (a \u2212 b)\xB2',
            why: '(a \u2212 b)\xB2 = a\xB2 \u2212 2ab + b\xB2. Ici, c\u2019est une DIFF\xC9RENCE de deux carr\xE9s : a\xB2 \u2212 b\xB2 = (a \u2212 b)(a + b).',
          }),
            n.push({
              line: { dis: [Rn(t.si, tn('sq', V('add', [t.a, t.b])), t.other)] },
              title: 'Ce n\u2019est pas (a + b)\xB2',
              why: '(a + b)\xB2 = a\xB2 + 2ab + b\xB2. Ici, c\u2019est une DIFF\xC9RENCE de deux carr\xE9s : a\xB2 \u2212 b\xB2 = (a \u2212 b)(a + b).',
            }),
            t.qExplicit ||
              n.push({
                line: {
                  dis: [
                    Rn(
                      t.si,
                      V('mul', [V('add', [t.a, qe(t.qTerm)]), V('add', [t.a, t.qTerm])]),
                      t.other,
                    ),
                  ],
                },
                title: 'b, pas b\xB2',
                why:
                  z(t.qTerm) +
                  ' = ' +
                  z(tn('sq', t.b)) +
                  ' : dans (a \u2212 b)(a + b), on met b = ' +
                  z(t.b) +
                  ', pas ' +
                  z(t.qTerm) +
                  '.',
              }));
        }),
        n
      );
    },
  },
  carreParfait: {
    card: 'Identit\xE9s remarquables (a + b)\xB2 et (a \u2212 b)\xB2',
    conclusions(e) {
      let n = [];
      return (
        RT(e).forEach((t) => {
          let r = t.minus ? '(a \u2212 b)\xB2' : '(a + b)\xB2',
            s = t.minus
              ? 'a\xB2 \u2212 2ab + b\xB2 = (a \u2212 b)\xB2'
              : 'a\xB2 + 2ab + b\xB2 = (a + b)\xB2';
          if (t.explicit)
            n.push({
              line: {
                dis: [Rn(t.si, tn('sq', V('add', [t.a, t.minus ? qe(t.b) : t.b])), t.other)],
              },
              label: 'Identit\xE9 ' + r,
              hora: 5,
              transform: !0,
              why: s + ', avec a = ' + z(t.a) + ' et b = ' + z(t.b) + '.',
              hint:
                'Tu reconnais ' +
                (t.minus ? 'a\xB2 \u2212 2ab + b\xB2' : 'a\xB2 + 2ab + b\xB2') +
                '. \xC9cris-le sous la forme ' +
                r +
                '.',
            });
          else {
            let i = V('mul', [X(2), t.a, t.b]);
            n.push({
              line: {
                dis: [
                  Rn(t.si, V('add', [tn('sq', t.a), t.minus ? qe(i) : i, tn('sq', t.b)]), t.other),
                ],
              },
              label: 'Reconna\xEEtre ' + r,
              hora: 3,
              transform: !0,
              why:
                'On fait appara\xEEtre ' +
                (t.minus ? 'a\xB2 \u2212 2ab + b\xB2' : 'a\xB2 + 2ab + b\xB2') +
                ', avec a = ' +
                z(t.a) +
                ' et b = ' +
                z(t.b) +
                '.',
              hint:
                'Trois termes, dont deux carr\xE9s : ' +
                z(t.pTerm) +
                ' et ' +
                z(t.qTerm) +
                '. \xC9cris-les a\xB2 et b\xB2, et le terme du milieu 2 \xD7 a \xD7 b.',
            });
          }
        }),
        n
      );
    },
    unjustified(e, n) {
      return !lP(e, n) || !RT(e).length
        ? null
        : {
            title: 'D\u2019o\xF9 vient ce carr\xE9 ?',
            message:
              'Factoriser de t\xEAte, c\u2019est risqu\xE9. Fais d\u2019abord appara\xEEtre a\xB2 + 2ab + b\xB2 (ou a\xB2 \u2212 2ab + b\xB2) : les deux carr\xE9s et le double produit 2 \xD7 a \xD7 b. Ensuite, je valide chaque transformation.',
          };
    },
    traps(e) {
      let n = [];
      return (
        RT(e).forEach((t) => {
          (n.push({
            line: { dis: [Rn(t.si, tn('sq', V('add', [t.a, t.minus ? t.b : qe(t.b)])), t.other)] },
            title: t.minus
              ? 'Le signe dans la parenth\xE8se'
              : 'Ce n\u2019est pas (a \u2212 b)\xB2',
            why: t.minus
              ? 'Le double produit est pr\xE9c\xE9d\xE9 d\u2019un \xAB \u2212 \xBB : c\u2019est (a \u2212 b)\xB2 = a\xB2 \u2212 2ab + b\xB2, pas (a + b)\xB2.'
              : 'Le double produit est pr\xE9c\xE9d\xE9 d\u2019un \xAB + \xBB : c\u2019est (a + b)\xB2 = a\xB2 + 2ab + b\xB2, pas (a \u2212 b)\xB2.',
          }),
            n.push({
              line: {
                dis: [
                  Rn(t.si, V('mul', [V('add', [t.a, qe(t.b)]), V('add', [t.a, t.b])]), t.other),
                ],
              },
              title: 'Ce n\u2019est pas a\xB2 \u2212 b\xB2',
              why: '(a \u2212 b)(a + b) = a\xB2 \u2212 b\xB2 : il n\u2019y a pas de double produit. Ici, il y en a un : c\u2019est un carr\xE9 parfait.',
            }));
        }),
        n
      );
    },
  },
  formule: {
    card: 'Formule',
    conclusions(e) {
      return Vs(e, 'formule').map((n) => ({
        line: Ie(n.line),
        label: n.label || 'Formule',
        hora: n.hora || 3,
        why: n.why || 'On applique la formule : ' + n.line + '.',
        hint: n.hint || 'Utilise la formule : ' + n.line + '.',
      }));
    },
  },
  recurrence: {
    card: 'Raisonnement par r\xE9currence',
    setup(e, n) {
      lf(e, Ie(n.hyp), 'hyp');
    },
    conclusions(e, n) {
      let t = [];
      return (
        Vs(e, 'recurrence').forEach((r) => {
          t.push({
            line: Ie(r.init),
            label: 'Initialisation',
            hora: 3,
            obligation: !0,
            why: 'On v\xE9rifie que la formule est vraie au premier rang, n = 0.',
            hint:
              'Commence par l\u2019initialisation : la formule est-elle vraie pour n = 0 ? Compare ' +
              r.init.split('=')[0].trim() +
              ' et la formule au rang 0.',
          });
          let s = uP(e, r);
          (s || n) &&
            (r.inst || []).forEach((i) => {
              t.push({
                line: Ie(i),
                label: 'Conclusion de la r\xE9currence',
                hora: 5,
                needsProof: !s,
                why: 'Initialisation et h\xE9r\xE9dit\xE9 sont d\xE9montr\xE9es : la formule est vraie pour tout n, donc aussi pour ce rang.',
                hint: 'L\u2019initialisation et l\u2019h\xE9r\xE9dit\xE9 sont faites : la formule est vraie pour tout n. Applique-la au rang demand\xE9.',
              });
            });
        }),
        t
      );
    },
    next(e) {
      let n = Vs(e, 'recurrence')[0];
      return !n || e.stated.hyp || !ph(e, Ie(n.init))
        ? null
        : {
            line: Ie(n.hyp),
            kind: 'hyp',
            label: 'Hypoth\xE8se de r\xE9currence',
            text: 'H\xE9r\xE9dit\xE9 : suppose la formule vraie \xE0 un rang n. \xC9cris cette hypoth\xE8se.',
            why: 'H\xE9r\xE9dit\xE9 : on suppose la formule vraie \xE0 un rang n, pour la d\xE9montrer au rang n + 1.',
          };
    },
    traps(e) {
      let n = [];
      return (
        Vs(e, 'recurrence').forEach((t) => {
          let r = Ie(t.hyp).dis[0],
            s = Ie(t.next).dis[0],
            i = r.sides[0].k === 's' ? r.sides[0] : r.sides[1],
            o = r.sides[0].k === 's' ? s.sides[1] : s.sides[0];
          e.facts.forEach((a) => {
            if (a.source === 'hyp' || a.line.dis.length !== 1) return;
            let l = a.line.dis[0];
            Fe({ k: 'add', c: l.sides })[i.n] &&
              n.push({
                line: { dis: [{ sides: l.sides.map((u) => (u.k === 's' ? u : Nm(u, i.n, o))) }] },
                title: 'Hypoth\xE8se au mauvais rang',
                why:
                  'Tu remplaces ' +
                  i.n +
                  ' : c\u2019est l\u2019hypoth\xE8se au rang n qui sert, ' +
                  t.hyp +
                  '. La formule au rang n + 1, c\u2019est ce que tu cherches \xE0 d\xE9montrer.',
              });
          });
        }),
        n
      );
    },
    unjustified(e, n) {
      let t = null;
      return (
        Vs(e, 'recurrence').forEach((r) => {
          if (t || n.dis.length !== 1) return;
          if (hs(n, Ie(r.next), e.K) && !ph(e, Ie(r.next))) {
            t = {
              title: 'C\u2019est le but de l\u2019h\xE9r\xE9dit\xE9',
              message:
                'Cette \xE9galit\xE9, c\u2019est la formule au rang n + 1 : c\u2019est ce que tu dois d\xE9montrer, pas un point de d\xE9part. Pars de la d\xE9finition de la suite et utilise l\u2019hypoth\xE8se de r\xE9currence.',
            };
            return;
          }
          let s = uP(e, r);
          (r.inst || []).forEach((i) => {
            !t &&
              !s &&
              hs(n, Ie(i), e.K) &&
              (t = {
                title: 'Pas encore d\xE9montr\xE9',
                message:
                  'Tu appliques la formule, mais elle n\u2019est encore qu\u2019une conjecture. D\xE9montre-la d\u2019abord : initialisation (n = 0), puis h\xE9r\xE9dit\xE9 (de n \xE0 n + 1).',
              });
          });
        }),
        t
      );
    },
  },
};
function dx(e) {
  return e.k === 'sq'
    ? { r: e.a, explicit: !0 }
    : e.k === 'n' && e.v > 0 && Number.isInteger(Math.sqrt(e.v))
      ? { r: X(Math.sqrt(e.v)), explicit: !1 }
      : e.k === 'mul' &&
          e.c.length === 2 &&
          e.c[0].k === 'n' &&
          e.c[1].k === 'sq' &&
          Number.isInteger(Math.sqrt(e.c[0].v))
        ? { r: V('mul', [X(Math.sqrt(e.c[0].v)), e.c[1].a]), explicit: !1 }
        : null;
}
function TT(e) {
  let n = [];
  return (
    e.facts.forEach((t) => {
      if (t.line.dis.length !== 1 || t.line.dis[0].sides.length !== 2) return;
      let r = t.line.dis[0];
      [0, 1].forEach((s) => {
        let i = r.sides[s];
        if (!De(i, e.K)) return;
        let o = TP(i);
        o && n.push({ si: s, other: r.sides[1 - s], ...o });
      });
    }),
    n
  );
}
function TP(e) {
  if (e.k !== 'add' || e.c.length !== 2) return null;
  let n = e.c.filter((o) => !$n(o).neg),
    t = e.c.filter((o) => $n(o).neg);
  if (n.length !== 1 || t.length !== 1) return null;
  let r = $n(t[0]).t,
    s = dx(n[0]),
    i = dx(r);
  return !s || !i
    ? null
    : {
        a: s.r,
        b: i.r,
        explicit: s.explicit && i.explicit,
        pExplicit: s.explicit,
        qExplicit: i.explicit,
        pTerm: n[0],
        qTerm: r,
      };
}
function lP(e, n) {
  return e.model.aim !== 'factor' ||
    e.model.factorHint ||
    n.dis.length !== 1 ||
    n.dis[0].sides.length !== 2
    ? !1
    : n.dis[0].sides.some((t) => _m(t, e.K).length >= 2 || (t.k === 'sq' && t.a.k === 'add'));
}
function RT(e) {
  let n = [];
  return (
    e.facts.forEach((t) => {
      if (t.line.dis.length !== 1 || t.line.dis[0].sides.length !== 2) return;
      let r = t.line.dis[0];
      [0, 1].forEach((s) => {
        let i = r.sides[s];
        if (!De(i, e.K)) return;
        let o = RP(i, e.K);
        o && n.push({ si: s, other: r.sides[1 - s], ...o });
      });
    }),
    n
  );
}
function RP(e, n) {
  if (e.k !== 'add' || e.c.length !== 3) return null;
  for (let t = 0; t < 3; t++)
    for (let r = t + 1; r < 3; r++) {
      let s = 3 - t - r,
        i = e.c[t],
        o = e.c[r];
      if ($n(i).neg || $n(o).neg) continue;
      let a = dx(i),
        l = dx(o);
      if (!a || !l) continue;
      let u = V('mul', [X(2), a.r, l.r]),
        c = e.c[s],
        f = Eh(c, qe(u), n);
      if (!(!f && !Eh(c, u, n)))
        return { a: a.r, b: l.r, minus: f, explicit: a.explicit && l.explicit, pTerm: i, qTerm: o };
    }
  return null;
}
function uP(e, n) {
  return ph(e, Ie(n.init)) && ph(e, Ie(n.next));
}
function mh(e, n) {
  if (e.sides.length !== 2) return null;
  for (let t = 0; t < 2; t++) {
    let r = e.sides[t],
      s = e.sides[1 - t];
    if (r.k === 'n' && r.v === 0 && s.k === 'sq' && De(s.a, n) && s.a.k === 'add') return [s.a];
    if (r.k === 'n' && r.v === 0 && s.k === 'mul' && s.c.filter((i) => De(i, n)).length >= 2)
      return s.c.filter((i) => De(i, n));
  }
  return null;
}
function $P(e, n) {
  let t = [],
    r = {};
  return (
    (e.model.preds || []).forEach((s) => {
      r[s.skill] = 1;
    }),
    e.facts.some((s) => s.line.dis.length === 1 && mh(s.line.dis[0], e.K)) && (r.produitNul = 1),
    Object.keys(lu).forEach((s) => {
      r[s] &&
        lu[s].conclusions(e, n).forEach((i) => {
          ((i.skill = s), (i.card = lu[s].card), t.push(i));
        });
    }),
    t
  );
}
function ph(e, n) {
  let t = e.K,
    r = ps(n, t);
  return e.facts.some((s) =>
    s.source !== 'line' ? !1 : !!hs(s.line, n, t) || (r && Kx(s.line, n, t)),
  );
}
function Ra(e) {
  if (e.c) {
    let n = e.c
      .map(Ra)
      .filter(
        (t) =>
          !(e.k === 'add' && t.k === 'n' && t.v === 0) &&
          !(e.k === 'mul' && t.k === 'n' && t.v === 1),
      );
    return n.length ? V(e.k, n) : X(e.k === 'add' ? 0 : 1);
  }
  return Ei(e, Ra);
}
function Rn(e, n, t) {
  return { sides: e === 0 ? [n, t] : [t, n] };
}
function cx(e) {
  return e.k === 'n'
    ? e.v > 0
      ? 'Retire ' + pe(e.v) + ' des deux c\xF4t\xE9s.'
      : 'Ajoute ' + pe(-e.v) + ' aux deux c\xF4t\xE9s.'
    : 'Retire ' + z(e) + ' des deux c\xF4t\xE9s.';
}
function $a(e, n) {
  let t = [];
  if (e.sides.length !== 2) return t;
  [0, 1].forEach((s) => {
    let i = e.sides[s],
      o = e.sides[1 - s];
    if (
      De(i, n) &&
      (i.k === 'add' &&
        i.c.forEach((a, l) => {
          if (!pt(a, n)) return;
          let u = V(
              'add',
              i.c.filter((f, d) => d !== l),
            ),
            c = qe(a);
          (t.push({ eq: Rn(s, u, V('add', [o, c])), kind: 'transpo', desc: cx(a) }),
            t.push({
              eq: Rn(s, V('add', [i, c]), V('add', [o, c])),
              kind: 'bothsides',
              desc: cx(a),
            }));
        }),
      i.k === 'mul' &&
        i.c.forEach((a, l) => {
          if (!pt(a, n)) return;
          let u = V(
              'mul',
              i.c.filter((f, d) => d !== l),
            ),
            c = 'Divise les deux c\xF4t\xE9s par ' + z(a) + '.';
          (t.push({ eq: Rn(s, u, ms(o, a)), kind: 'transpo', desc: c }),
            t.push({ eq: Rn(s, ms(i, a), ms(o, a)), kind: 'bothsides', desc: c }));
        }),
      i.k === 'div' &&
        pt(i.b, n) &&
        t.push({
          eq: Rn(s, i.a, V('mul', [o, i.b])),
          kind: 'transpo',
          desc: 'Multiplie les deux c\xF4t\xE9s par ' + z(i.b) + '.',
        }),
      i.k === 'neg' &&
        t.push({
          eq: Rn(s, i.a, qe(o)),
          kind: 'transpo',
          desc: 'Change les signes des deux c\xF4t\xE9s.',
        }),
      i.k === 'add' &&
        !De(o, n) &&
        Object.keys(Fe(i)).filter((l) => n[l] === void 0).length === 2 &&
        i.c.forEach((l, u) => {
          if (l.k !== 's' || n[l.n] !== void 0) return;
          let c = i.c.filter((f, d) => d !== u);
          t.push({
            eq: Rn(s, l, V('add', [o].concat(c.map(qe)))),
            kind: 'transpo',
            desc: 'Isole ' + l.n + ' : les autres termes passent de l\u2019autre c\xF4t\xE9.',
          });
        }),
      De(o, n))
    ) {
      let a = o.k === 'add' ? o.c : [o],
        l = (c) => Object.keys(Fe(c)).filter((f) => n[f] === void 0),
        u = l(i);
      a.forEach((c, f) => {
        let d = l(c);
        if (!d.length || !d.every((h) => u.includes(h))) return;
        let m = a.filter((h, b) => b !== f),
          p = V('add', (i.k === 'add' ? i.c : [i]).concat([qe(c)])),
          g = Rn(s, p, m.length ? V('add', m) : X(0));
        (t.push({ eq: g, kind: 'transpo', desc: cx(c), unknownMove: !0 }),
          t.push({
            eq: { sides: g.sides.map((h) => Ra(bh(h, [], n))) },
            kind: 'transpo',
            desc: cx(c).replace(/\.$/, ', puis regroupe les x.'),
            unknownMove: !0,
          }));
      });
    }
  });
  let r = [];
  return (
    t.forEach((s) => {
      let i = { sides: s.eq.sides.map(Ra) };
      if (
        (Ke({ dis: [i] }) !== Ke({ dis: [s.eq] }) && r.push({ eq: i, kind: s.kind, desc: s.desc }),
        De(s.eq.sides[0], n) && De(s.eq.sides[1], n))
      ) {
        let o = [],
          a = { sides: i.sides.map((l) => uf(l, {}, o)) };
        o.length &&
          Ke({ dis: [a] }) !== Ke({ dis: [i] }) &&
          r.push({ eq: a, kind: s.kind, desc: s.desc });
      }
    }),
    t.concat(r)
  );
}
function CP(e, n) {
  let t = e.model.symbols[n];
  return !!t && t.kind === 'length';
}
function EP(e, n) {
  let t = [];
  return (
    e.sides.length !== 2 ||
      [0, 1].forEach((r) => {
        let s = e.sides[r];
        s.k === 'sq' &&
          s.a.k === 's' &&
          n.K[s.a.n] === void 0 &&
          CP(n, s.a.n) &&
          t.push({ sides: [s.a, tn('sqrt', e.sides[1 - r])] });
      }),
    t
  );
}
function MP(e, n) {
  let t = [];
  return (
    e.sides.length !== 2 ||
      [0, 1].forEach((r) => {
        let s = e.sides[r],
          i = e.sides[1 - r];
        if (s.k !== 'sq') return;
        if (s.a.k === 's') {
          if (n.K[s.a.n] !== void 0 || CP(n, s.a.n)) return;
        } else if (!De(s.a, n.K)) return;
        if (De(i, n.K)) return;
        let o = ds(i, n.K);
        if (o === null || !(o > 0)) return;
        let a = tn('sqrt', i);
        t.push({ dis: [{ sides: [s.a, a] }, { sides: [s.a, qe(a)] }] });
      }),
    t
  );
}
function bx(e) {
  let n = [];
  return (
    e.facts.forEach((t, r) => {
      if (t.line.dis.length !== 1) return;
      let s = t.line.dis[0];
      s.sides.length === 2 &&
        [0, 1].forEach((i) => {
          let o = s.sides[i],
            a = s.sides[1 - i];
          o.k !== 's' ||
            e.K[o.n] !== void 0 ||
            a.k === 's' ||
            Fe(a)[o.n] ||
            (De(a, e.K) && n.push({ s: o.n, expr: a, gi: r, source: t.source }));
        });
    }),
    n
  );
}
function vx(e, n) {
  let t = [];
  return (
    e.facts.forEach((r, s) => {
      if (r.line.dis.length !== 1) return;
      let i = r.line.dis[0];
      i.sides.length === 2 &&
        n.forEach((o) => {
          if (o.gi === s) return;
          let a = !1,
            l = i.sides.map((u) => (Fe(u)[o.s] ? ((a = !0), Nm(u, o.s, o.expr)) : u));
          a && t.push({ line: { dis: [{ sides: l }] }, kind: 'subst', def: o, src: s });
        });
    }),
    t
  );
}
function vh(e, n, t) {
  let r = e.K,
    s = [];
  return (
    e.facts.forEach((i, o) => {
      s.push({ line: i.line, kind: 'fact', src: o });
      let a = i.line.dis;
      a.length > 1 && a.forEach((u) => s.push({ line: { dis: [u] }, kind: 'case', src: o }));
      let l = a.map((u) => $a(u, r));
      if (
        (l.forEach((u) => {
          u.forEach((c) => {
            (s.push({
              line: { dis: [c.eq] },
              kind: a.length > 1 ? 'transpo' : c.kind,
              desc: c.desc,
              src: o,
            }),
              n
                ? $a(c.eq, r).forEach((f) =>
                    s.push({
                      line: { dis: [f.eq] },
                      kind: 'transpo',
                      desc: f.desc,
                      src: o,
                      deep: !0,
                    }),
                  )
                : c.unknownMove &&
                  a.length === 1 &&
                  $a(c.eq, r)
                    .filter((f) => f.kind === 'transpo' && !f.unknownMove)
                    .forEach((f) =>
                      s.push({ line: { dis: [f.eq] }, kind: 'transpo', desc: f.desc, src: o }),
                    ));
          });
        }),
        a.length > 1)
      ) {
        let u = a.map((f, d) =>
            [f].concat(l[d].filter((m) => m.kind === 'transpo').map((m) => m.eq)),
          ),
          c = [[]];
        (u.forEach((f) => {
          let d = [];
          (c.forEach((m) => f.forEach((p) => d.push(m.concat([p])))), (c = d.slice(0, 60)));
        }),
          c.forEach((f) => {
            f.every((d, m) => d === a[m]) || s.push({ line: { dis: f }, kind: 'transpo', src: o });
          }));
      }
      if (a.length === 1) {
        let u = BP(a[0], r);
        u &&
          s.push({
            line: { dis: [{ sides: a[0].sides.map((c) => zP(c, u)) }] },
            kind: 'bothsides',
            desc: 'multiplie les deux membres par ' + u + ', le d\xE9nominateur commun.',
            src: o,
          });
      }
      a.forEach((u) => {
        (EP(u, e).forEach((c) => s.push({ line: { dis: [c] }, kind: 'racine', src: o })),
          a.length === 1 && MP(u, e).forEach((c) => s.push({ line: c, kind: 'racine', src: o })));
      });
    }),
    vx(e, bx(e)).forEach((i) => s.push(i)),
    $P(e, t).forEach((i) => {
      (s.push({ line: i.line, kind: 'rule', rc: i }),
        i.line.dis.length > 1
          ? i.line.dis.forEach((o) => {
              (s.push({ line: { dis: [o] }, kind: 'rule', rc: i, isCase: !0 }),
                n &&
                  $a(o, r).forEach((a) =>
                    s.push({ line: { dis: [a.eq] }, kind: 'rule', rc: i, isCase: !0, deep: !0 }),
                  ));
            })
          : n &&
            $a(i.line.dis[0], r).forEach((o) =>
              s.push({ line: { dis: [o.eq] }, kind: 'rule', rc: i, deep: !0 }),
            ));
    }),
    s
  );
}
function nJ(e) {
  let n = oP.get(e.model);
  return (
    n ||
      ((n = (e.model.traps || []).map((t) => ({ line: Ie(t.line), title: t.title, why: t.why }))),
      oP.set(e.model, n)),
    n
  );
}
function _P(e) {
  let n = [],
    t = {};
  return (
    (e.model.preds || []).forEach((r) => {
      t[r.skill] = 1;
    }),
    (t.produitNul = 1),
    Object.keys(lu).forEach((r) => {
      let s = lu[r].traps;
      t[r] && s && s(e).forEach((i) => n.push(i));
    }),
    nJ(e).forEach((r) => n.push(r)),
    e.facts.forEach((r) => {
      r.line.dis.forEach((s) => {
        s.sides.length === 2 &&
          [0, 1].forEach((i) => {
            let o = s.sides[i];
            o.k === 'sq' &&
              o.a.k === 's' &&
              e.K[o.a.n] === void 0 &&
              n.push({
                line: Lm(o.a, s.sides[1 - i]),
                title: 'La racine oubli\xE9e',
                why:
                  'C\u2019est ' +
                  o.a.n +
                  '\xB2 qui vaut \xE7a. Pour trouver ' +
                  o.a.n +
                  ', il faut prendre la racine carr\xE9e.',
              });
          });
      });
    }),
    n
  );
}
function tJ(e) {
  let n = [];
  function t(r, s) {
    if (r.k === 'sq' && r.a.k === 'add' && r.a.c.length === 2) {
      n.push({
        to: s(
          V(
            'add',
            r.a.c.map((a) => tn('sq', $n(a).t)),
          ),
        ),
        title: 'Il manque le double produit',
        why: '(a + b)\xB2 = a\xB2 + 2ab + b\xB2 : le carr\xE9 d\u2019une somme n\u2019est pas la somme des carr\xE9s.',
      });
      let i = $n(r.a.c[0]),
        o = $n(r.a.c[1]);
      i.neg !== o.neg &&
        n.push({
          to: s(V('add', [tn('sq', i.t), uu(V('mul', [X(2), i.t, o.t])), tn('sq', o.t)])),
          title: 'Le signe du double produit',
          why: '(a \u2212 b)\xB2 = a\xB2 \u2212 2ab + b\xB2 : le double produit garde le signe \xAB \u2212 \xBB.',
        });
    }
    if (
      (r.k === 'neg' &&
        r.a.k === 'add' &&
        r.a.c.length >= 2 &&
        n.push({
          to: s(V('add', [qe(r.a.c[0])].concat(r.a.c.slice(1)))),
          title: 'Le \xAB \u2212 \xBB devant la parenth\xE8se',
          why:
            'Un \xAB \u2212 \xBB devant une parenth\xE8se change le signe de CHAQUE terme : ' +
            z(r) +
            ' = ' +
            z(V('add', r.a.c.map(qe))) +
            '.',
        }),
      r.k === 'mul' && r.c.length === 2 && r.c.every((i) => i.k === 'add' && i.c.length === 2))
    ) {
      let i = r.c[0].c,
        o = r.c[1].c;
      n.push({
        to: s(V('add', [qT([], i[0], o[0]), qT([], i[1], o[1])])),
        title: 'Les produits crois\xE9s oubli\xE9s',
        why:
          'Chaque terme de la 1re parenth\xE8se multiplie chaque terme de la 2de : ' +
          z(r) +
          ' donne 4 produits, pas 2.',
      });
    }
    (r.k === 'mul' &&
      (r.c.forEach((i, o) => {
        if (i.k !== 'add' || i.c.length < 2) return;
        let a = r.c.filter((u, c) => c !== o);
        if (!a.every((u) => u.k === 'n')) return;
        let l = uu(V('mul', a.concat([i.c[0]])));
        n.push({
          to: s(V('add', [l].concat(i.c.slice(1)))),
          title: 'Distribuer \xE0 chaque terme',
          why:
            'Le facteur multiplie TOUS les termes de la parenth\xE8se : ' +
            z(r) +
            ' = ' +
            z(HP(r)) +
            '.',
        });
      }),
      r.c.forEach((i, o) => {
        i.k === 'n' &&
          r.c.forEach((a, l) => {
            if (a.k !== 'pow' || a.a.k !== 'n' || a.a.v !== i.v) return;
            let u = r.c.filter((f, d) => d !== o && d !== l),
              c = Ci(X(i.v * i.v), a.b);
            n.push({
              to: s(u.length ? V('mul', u.concat([c])) : c),
              title: 'Multiplier des puissances',
              why:
                z(V('mul', [i, a])) +
                ' = ' +
                z(Ci(X(i.v), uu(V('add', [a.b, X(1)])))) +
                ' : on ajoute 1 \xE0 l\u2019exposant. Ce n\u2019est pas ' +
                z(c) +
                '.',
            });
          });
      })),
      r.c
        ? r.c.forEach((i, o) =>
            t(i, (a) => {
              let l = r.c.slice();
              return ((l[o] = a), s(V(r.k, l)));
            }),
          )
        : qa(r)
          ? (t(r.a, (i) => s(Ro(r.k, i, r.b))), t(r.b, (i) => s(Ro(r.k, r.a, i))))
          : r.a && t(r.a, (i) => s(r.k === 'neg' ? qe(i) : tn(r.k, i))));
  }
  return (t(e, (r) => r), n);
}
function rJ(e) {
  let n = [],
    t = e.facts
      .map((r) => r.line)
      .concat(vx(e, bx(e)).map((r) => r.line))
      .concat($P(e).map((r) => r.line));
  return (
    t.slice().forEach((r) => px(r, e, t, 2)),
    t.forEach((r) => {
      if (r.dis.length !== 1 || r.dis[0].sides.length !== 2) return;
      let s = r.dis[0];
      [0, 1].forEach((i) => {
        tJ(s.sides[i]).forEach((o) => {
          n.push({
            line: { dis: [Rn(i, o.to, s.sides[1 - i])] },
            title: o.title,
            why: o.why,
            ident: !0,
          });
        });
      });
    }),
    n
  );
}
function sJ(e) {
  let n = [];
  function t(r, s) {
    if (
      (r.k === 'n' &&
        r.v !== 0 &&
        n.push({ line: s(X(-r.v)), title: 'Attention au signe', sign: !0 }),
      r.k === 'add' &&
        r.c.length === 2 &&
        ((r.c[1].k === 'n' && r.c[1].v < 0) || r.c[1].k === 'neg'))
    ) {
      let i = r.c[1].k === 'n' ? X(-r.c[1].v) : r.c[1].a;
      n.push({
        line: s(ms(r.c[0], i)),
        title: 'Diviser, pas soustraire',
        why: 'Le nombre multiplie l\u2019inconnue : pour l\u2019enlever, on divise les deux c\xF4t\xE9s. On ne le soustrait pas.',
      });
    }
    if (
      (r.k === 'div' &&
        n.push({
          line: s(ms(r.b, r.a)),
          title: 'Dans le bon sens',
          why: 'On divise ce qui est de l\u2019autre c\xF4t\xE9 par le nombre qui multiplie l\u2019inconnue, pas l\u2019inverse.',
        }),
      r.k === 'sq' &&
        n.push({
          line: s(V('mul', [r.a, X(2)])),
          title: 'Le carr\xE9 n\u2019est pas le double',
          why: 'Un carr\xE9, c\u2019est le nombre multipli\xE9 par lui-m\xEAme : 6\xB2 = 6 \xD7 6 = 36, pas 6 \xD7 2.',
          square: !0,
        }),
      r.c)
    )
      r.c.forEach((i, o) =>
        t(i, (a) => {
          let l = r.c.slice();
          return ((l[o] = a), s(V(r.k, l)));
        }),
      );
    else if (qa(r)) {
      if (r.k === 'pow') return;
      (t(r.a, (i) => s(Ro(r.k, i, r.b))), t(r.b, (i) => s(Ro(r.k, r.a, i))));
    } else r.a && t(r.a, (i) => s(r.k === 'neg' ? qe(i) : tn(r.k, i)));
  }
  return (
    e.dis.forEach((r, s) => {
      r.sides.forEach((i, o) => {
        t(i, (a) => ({
          dis: e.dis.map((l, u) =>
            u !== s ? l : { sides: l.sides.map((c, f) => (f === o ? a : c)) },
          ),
        }));
      });
    }),
    n
  );
}
var cP = new WeakMap();
function iJ(e) {
  if ((!e.samples || e.envs) && !ST(e)) return e;
  let n = cP.get(e);
  return (n || ((n = iP(e)), cP.set(e, n)), n);
}
function oJ(e) {
  let n = iJ(e),
    t = { model: n, K: {}, facts: [], stated: {} };
  if (n.kernel?.plugin === 'geometry') return ((t.kgeo = hN(n)), t);
  if (n.kernel?.induction) return ((t.krec = NN(n)), t);
  if (n.kernel?.plugin === 'python') return ((t.kprog = HM(n)), t);
  if (n.kernel?.plugin === 'matrix') return ((t.kmat = HN(n)), t);
  if (n.kernel?.plugin === 'arith') return ((t.karith = m2(n)), t);
  if (n.kernel?.plugin === 'limit') return ((t.klim = Zp(n)), t);
  if (n.kernel?.plugin === 'limclaims') return ((t.klc = UO(n)), t);
  if (n.kernel?.plugin === 'integral') return ((t.kint = Ck(n)), t);
  if (n.kernel?.plugin === 'ode') return ((t.kode = tO(n)), t);
  if (n.kernel?.plugin === 'partial') return ((t.kpart = pO(n)), t);
  if (n.kernel?.plugin === 'riemann') return ((t.kriem = PO(n)), t);
  if (n.kernel?.plugin === 'claims') return ((t.kclaims = dM(n)), t);
  if (n.kernel?.plugin === 'variations') return ((t.kvar = TK(n)), t);
  if (n.kernel?.plugin === 'tables') return ((t.ktab = IK(n)), t);
  if (n.kernel?.plugin === 'analysis') return ((t.kana = Jg(n)), t);
  if (n.kernel?.plugin === 'formula') return ((t.kfor = gE(n)), t);
  let r = Mv(n);
  if (r) t.kspecial = r;
  else if (n.kernel) return ((t.kern = Lb(n)), t);
  return n.congruence
    ? ((t.cong = pR(n, n.congruence)), t)
    : n.complex
      ? ((t.cplx = MR(n, n.complex)), t)
      : n.bounds
        ? ((t.bnd = zK(n.bounds)), t)
        : n.geometry
          ? ((t.geo = AR(n.geometry, [...(n.givens ?? []), ...(n.admitted ?? [])])), t)
          : n.units
            ? ((t.units = YK(n.units, [...(n.givens ?? []), ...(n.admitted ?? [])])), t)
            : (Object.keys(n.symbols).forEach((s) => {
                let i = n.symbols[s];
                i.given && ((t.K[s] = i.value), lf(t, Lm(pf(s), X(i.value)), 'given'));
              }),
              (n.givens || []).forEach((s) => lf(t, Ve(s), 'given', { shown: !0 })),
              (n.admitted || []).forEach((s) => lf(t, Ve(s), 'given', { admitted: !0 })),
              (n.preds || []).forEach((s) => {
                let i = lu[s.skill].setup;
                i && i(t, s);
              }),
              t);
}
function lf(e, n, t, r) {
  (e.facts.push(Object.assign({ line: n, atoms: ne(zr(n)), source: t }, r || {})), lJ(e));
}
function aJ(e) {
  return {
    model: e.model,
    K: Object.assign({}, e.K),
    facts: e.facts.slice(),
    stated: Object.assign({}, e.stated),
    _cache: null,
  };
}
function lJ(e) {
  let n = !0;
  for (; n; )
    ((n = !1),
      e.facts.forEach((t) => {
        if (t.line.dis.length !== 1) return;
        let r = t.line.dis[0];
        r.sides.length === 2 &&
          [0, 1].forEach((s) => {
            let i = r.sides[s],
              o = r.sides[1 - s],
              a = i.k === 's' ? e.model.symbols[i.n] : void 0;
            if (a && e.K[i.n] === void 0 && (a.values || []).length === 1) {
              let l = ds(o, e.K);
              l !== null && ((e.K[i.n] = l), (n = !0));
            }
          });
      }));
}
function qP(e) {
  let n = Object.assign({}, e.K);
  return (
    Object.keys(e.model.symbols).forEach((t) => {
      let r = e.model.symbols[t];
      n[t] === void 0 && (r.values || []).length === 1 && (n[t] = r.values[0]);
    }),
    n
  );
}
function fP(e, n) {
  let t = [{}];
  return (
    e.forEach((r) => {
      let s = [];
      (t.forEach((i) => {
        (n[r] || [NaN]).forEach((o) => {
          let a = Object.assign({}, i);
          ((a[r] = o), s.push(a));
        });
      }),
        (t = s));
    }),
    t
  );
}
function dP(e, n) {
  let t = H(e.sides[0], n);
  return e.sides.every((r) => Ce(H(r, n), t));
}
function mx(e, n) {
  if (n.kern) return JL(n.kern, Ke(e));
  if (n.kgeo) return RN(n.kgeo, Ke(e));
  if (n.krec) return FN(n.krec, Ke(e));
  if (n.kprog) return a_(n.kprog, Ke(e));
  if (n.kmat) return e2(n.kmat, Ke(e));
  if (n.karith) return x2(n.karith, Ke(e));
  if (n.klim) return Ev(n.klim, Ke(e));
  if (n.klc) return WO(n.klc, Ke(e));
  if (n.kint) return Mk(n.kint, Ke(e));
  if (n.kode) return lO(n.kode, Ke(e));
  if (n.kpart) return vO(n.kpart, Ke(e));
  if (n.kriem) return DO(n.kriem, Ke(e));
  if (n.kclaims) return SM(n.kclaims, Ke(e));
  if (n.kvar) return _K(n.kvar, Ke(e));
  if (n.ktab) return VK(n.ktab, Ke(e));
  if (n.kana) return eh(n.kana, Ke(e));
  if (n.kfor) return OE(n.kfor, Ke(e));
  if (n.cong) return hR(n.cong, e);
  if (n.cplx) return qR(n.cplx, e);
  if (n.units) return rP(e);
  if (n.geo) return DR(n.geo, e);
  if (n.bnd) return GK(n.bnd, e);
  let t = n.model;
  if (t.envs) return t.envs.every((s) => e.dis.some((i) => dP(i, s)));
  let r = {};
  return (
    Object.keys(t.symbols).forEach((s) => {
      let i = t.symbols[s];
      r[s] = i.given ? [i.value] : i.values;
    }),
    e.dis.every((s) => {
      let i = Object.keys(Fe({ k: 'add', c: s.sides }));
      return s.cmp
        ? fP(i, r).some((o) => La(s.cmp, H(s.sides[0], o), H(s.sides[1], o)))
        : fP(i, r).some((o) => dP(s, o));
    })
  );
}
function LP(e) {
  return _x(e) || e.k === 'sqrt' || e.k === 'pow' ? !0 : e.k === 's' ? Xt(e.n) : Cn(e).some(LP);
}
function NP(e) {
  if (!pt(e, {}) || !LP(e)) return null;
  let n = H(e, {});
  if (!isFinite(n) || Yt(n)) return null;
  let t = [];
  return (uf(e, {}, t), t.length ? null : n);
}
function uJ(e) {
  let n = {};
  return (
    e.facts.forEach((t) => {
      if (t.line.dis.length !== 1) return;
      let r = t.line.dis[0];
      r.sides.length === 2 &&
        [0, 1].forEach((s) => {
          let i = r.sides[s],
            o = r.sides[1 - s];
          i.k === 's' && NP(o) !== null && (n[i.n] = o);
        });
    }),
    n
  );
}
function OT(e) {
  if (e.k === 'n') return e.v;
  let n = NP(e);
  if (n !== null) return n;
  let t = $n(e),
    r = t.t;
  if (r.k !== 'div' || r.a.k !== 'n' || r.b.k !== 'n') return null;
  let s = r.a.v,
    i = r.b.v;
  return !Number.isInteger(s) ||
    !Number.isInteger(i) ||
    i <= 1 ||
    s === 0 ||
    Cm(Math.abs(s), i) !== 1
    ? null
    : (t.neg ? -1 : 1) * (s / i);
}
function OP(e) {
  let n = {};
  return e.kgeo
    ? ((n[e.model.goal[0]] = $N(e.kgeo)), n)
    : e.krec ||
        e.kprog ||
        e.kmat ||
        e.kana ||
        e.karith ||
        e.klim ||
        e.klc ||
        e.kint ||
        e.kode ||
        e.kpart ||
        e.kriem ||
        e.kclaims ||
        e.kvar ||
        e.ktab
      ? n
      : e.kfor
        ? NE(e.kfor)
        : e.kern
          ? ((n[e.kern.x] = XL(e.kern)), n)
          : e.cong
            ? ((n[e.model.goal[0]] = gR(e.cong)), n)
            : e.cplx
              ? ((n[e.model.goal[0]] = _R(e.cplx)), n)
              : e.units
                ? ((n[e.model.goal[0]] = tP(e.units)), n)
                : (e.geo ||
                    e.bnd ||
                    e.facts.forEach((t) => {
                      t.source === 'line' &&
                        t.line.dis.forEach((r) => {
                          r.sides.length === 2 &&
                            [0, 1].forEach((s) => {
                              let i = r.sides[s],
                                o = r.sides[1 - s],
                                a = i.k === 's' ? OT(o) : null;
                              a !== null && (n[i.n] = n[i.n] || []).push(a);
                            });
                        });
                    }),
                  n);
}
function cJ(e) {
  let n = aP.get(e.model);
  return (n || ((n = (e.model.answers || []).map((t) => Ie(t))), aP.set(e.model, n)), n);
}
function KP(e) {
  if (e.k === 'mul') {
    let n = e.c.filter((t) => t.k === 's').map((t) => t.n);
    if (n.some((t, r) => n.indexOf(t) !== r)) return !0;
  }
  return Cn(e).some(KP);
}
function $m(e, n) {
  return e.model.aim === 'expand' && n.dis.some((t) => t.sides.some(KP))
    ? !1
    : cJ(e).some((t) => !!hs(n, t, e.K));
}
function KT(e) {
  return e.kfor ? LE(e.kfor) : !fJ(e) && !VJ(e) ? !1 : !FJ(e);
}
function fJ(e) {
  if (e.kern) return WL(e.kern);
  if (e.kgeo) return Cw(e.kgeo);
  if (e.krec) return jN(e.krec);
  if (e.kprog) return o_(e.kprog);
  if (e.kmat) return YN(e.kmat);
  if (e.karith) return v2(e.karith);
  if (e.klim) return mq(e.klim);
  if (e.klc) return HO(e.klc);
  if (e.kint) return Q2(e.kint);
  if (e.kode) return aO(e.kode);
  if (e.kpart) return bO(e.kpart);
  if (e.kriem) return VO(e.kriem);
  if (e.kclaims) return bM(e.kclaims);
  if (e.kvar) return MK(e.kvar);
  if (e.ktab) return FK(e.ktab);
  if (e.kana) return bK(e.kana);
  if (e.cong) return vf(e.cong);
  if (e.cplx) return du(e.cplx);
  if (e.units) return xT(e.units);
  if (e.geo) return VR(e.geo);
  if (e.bnd) return gT(e.bnd);
  if (e.model.answers) return e.facts.some((t) => t.source === 'line' && $m(e, t.line));
  let n = OP(e);
  return e.model.goalValues
    ? e.model.goalValues.every((t) => e.model.goal.some((r) => (n[r] || []).some((s) => Ce(t, s))))
    : e.model.goal.every((t) =>
        (e.model.symbols[t].values || []).every((r) => (n[t] || []).some((s) => Ce(r, s))),
      );
}
function mP(e, n) {
  if (KT(e)) return !1;
  let t = Ke(n);
  if (e.facts.some((s) => Ke(s.line) === t)) return !1;
  if (kx(n, e, !1)) return !0;
  let r = OP(e);
  return (
    n.dis.length === 1 &&
    n.dis[0].sides.length === 2 &&
    [0, 1].some((s) => {
      let i = n.dis[0].sides[s],
        o = n.dis[0].sides[1 - s];
      return i.k === 's' && pt(o, {}) && !r[i.n] && e.model.symbols[i.n] !== void 0;
    })
  );
}
function kx(e, n, t) {
  return e.dis.every((r) =>
    r.sides.length !== 2
      ? !1
      : [0, 1].some((s) => {
          let i = r.sides[s],
            o = r.sides[1 - s];
          return i.k === 's' && n.model.goal.indexOf(i.n) >= 0 && (t ? OT(o) !== null : pt(o, {}));
        }),
  );
}
function PT(e) {
  return e.join(qm) + qm;
}
function PP(e) {
  let n = {};
  return (
    Object.keys(e.model.symbols).forEach((t) => {
      let r = e.model.symbols[t];
      r.given && (n[t] = r.value);
    }),
    n
  );
}
function IP(e, n) {
  let t = [e],
    r = nR(e, n);
  Ke(r) !== Ke(e) && t.push(r);
  let s = [];
  return (
    t.forEach((i) => {
      GT(ne(zr(i))).forEach((o) => s.push(PT(o)));
    }),
    s
  );
}
function px(e, n, t, r) {
  let s = e;
  for (let i = 0; i < (r || 4); i++) {
    let o = YJ(s, n);
    if (!o) break;
    (t.push(o.line), (s = o.line));
  }
}
function AP(e, n, t) {
  let r = e.facts.length + '|' + (e.stated.hyp ? 1 : 0);
  e._cache = e._cache && e._cache.sig === r ? e._cache : { sig: r };
  let s = e._cache;
  return (n in s || (s[n] = t()), s[n]);
}
function dJ(e) {
  return AP(e, 'keys', () => mJ(e));
}
function mJ(e) {
  let n = PP(e),
    t = [],
    r = [];
  return (
    vh(e, !1, !0).forEach((s) => {
      (r.push(s.line), (s.kind === 'subst' || s.kind === 'rule') && px(s.line, e, r));
    }),
    e.facts.forEach((s) => px(s.line, e, r)),
    VP(e).forEach((s) => r.push(s.line)),
    r.forEach((s) => {
      t = t.concat(IP(s, n));
    }),
    t
  );
}
function pJ(e, n) {
  let t = PT(e),
    r = 0,
    s = !1;
  return (
    n.forEach((i) => {
      i.indexOf(t) === 0 && i !== t && (s = !0);
      let o = i.split(qm),
        a = 0;
      for (; a < e.length && o[a] === e[a]; ) a++;
      a > r && (r = a);
    }),
    { strict: s, len: r }
  );
}
function gJ(e, n) {
  let t = PP(e),
    r = PT(n),
    s = _P(e);
  for (let i = 0; i < s.length; i++) {
    let o = IP(s[i].line, t);
    for (let a = 0; a < o.length; a++) if (o[a].indexOf(r) === 0 && o[a] !== r) return s[i];
  }
  return null;
}
var pP = {
  fact: 0,
  subst: 1,
  trans: 1,
  transpo: 2,
  bothsides: 2,
  racine: 3,
  case: 4,
  rule: 5,
  ident: 6,
  comb: 6,
};
function jP(e, n) {
  let t = e.K,
    r = vh(e, !1).filter((i) => !(i.rc && i.rc.needsProof));
  (r.forEach((i, o) => {
    i.ord = o;
  }),
    r.sort((i, o) => pP[i.kind] - pP[o.kind] || (o.src || 0) - (i.src || 0) || i.ord - o.ord));
  let s = kx(n, e, !0);
  for (let i = 0; i < r.length; i++) {
    let o = r[i];
    if (o.line.dis.length !== n.dis.length) continue;
    let a = hs(n, o.line, t);
    if (!(a && s && o.kind === 'rule' && a.ev > 0)) {
      if (a && o.kind !== 'rule' && a.ev > 0)
        for (let l = i + 1; l < r.length; l++) {
          let u = r[l];
          if (u.kind !== 'rule' || !u.rc?.transform || u.line.dis.length !== n.dis.length) continue;
          let c = hs(n, u.line, t);
          if (c && c.ev === 0) return { cand: u, m: c };
        }
      if (a) return { cand: o, m: a };
    }
  }
  if (n.dis.length === 1) {
    for (let i = e.facts.length - 1; i >= 0; i--) {
      let o = e.facts[i].line;
      if (o.dis.length !== 1) continue;
      if (e.facts[i].source === 'given' && $m(e, n)) {
        let l = fu(n.dis[0], o.dis[0], t, !0),
          u = l && MJ(e, l.from, l.to);
        if (l && u)
          return {
            cand: { kind: 'ident', line: o, src: i, from: l.from, to: l.to, identity: u },
            m: { ev: 0, sub: 0 },
          };
        continue;
      }
      let a = fu(n.dis[0], o.dis[0], t);
      if (a)
        return {
          cand: { kind: 'ident', line: o, src: i, from: a.from, to: a.to },
          m: { ev: 0, sub: 0 },
        };
    }
    if (ps(n, t)) {
      let i = vJ(e, n.dis[0]);
      if (i) return i;
      let o = QP(e, n.dis[0], 0);
      if (o)
        return {
          cand: { kind: 'bothsides', line: e.facts[o.src].line, src: o.src, desc: o.desc },
          m: { ev: 0, sub: 0 },
        };
      let a = e.model.envs && e.model.path?.length ? hJ(e, n.dis[0]) : null;
      if (a)
        return {
          cand: { kind: 'bothsides', line: e.facts[a.src].line, src: a.src, desc: a.desc },
          m: { ev: 0, sub: 0 },
        };
      let l = bJ(e, n.dis[0]);
      if (l)
        return {
          cand: { kind: 'comb', line: e.facts[l.src].line, src: l.src, desc: l.desc },
          m: { ev: 0, sub: 0 },
        };
    }
  }
  return null;
}
function gx(e) {
  if (e.sides.length !== 2 || e.cmp || e.rels) return null;
  let [n, t] = e.sides;
  return (r) => H(n, r) - H(t, r);
}
function hJ(e, n) {
  let t = gx(n);
  if (!t || n.sides.some((c) => !Object.keys(Fe(c)).length && !1)) return null;
  let r = new Set(),
    s = [];
  (n.sides.forEach((c) => Object.keys(Fe(c)).forEach((f) => r.add(f))),
    e.facts.forEach((c, f) => {
      if (c.line.dis.length !== 1 || c.source === 'hyp') return;
      let d = gx(c.line.dis[0]);
      d &&
        (s.push({ f: d, fi: f }),
        c.line.dis[0].sides.forEach((m) => Object.keys(Fe(m)).forEach((p) => r.add(p))));
    }));
  let i = [...r];
  if (!i.length || !s.length) return null;
  let o = [1.37, 2.11, 0.73, 3.29, 1.83, 2.57, 0.91, 4.13],
    a = [0, 1, 2, 3, 4].map((c) => {
      let f = {};
      return (i.forEach((d, m) => (f[d] = o[(m + 3 * c) % o.length] + 0.07 * c + 0.03 * m)), f);
    }),
    l = a.map(t);
  if (l.some((c) => !isFinite(c) || Math.abs(c) < 1e-9)) return null;
  let u = [{ m: () => 1, t: '' }];
  i.forEach((c) => {
    (u.push({ m: (f) => f[c], t: c }),
      u.push({ m: (f) => 1 / f[c], t: '1 \xF7 ' + c }),
      u.push({ m: (f) => f[c] * f[c], t: c + '\xB2' }),
      i.forEach((f) => {
        f !== c &&
          (u.push({ m: (d) => d[c] / d[f], t: c + ' \xF7 ' + f }),
          c < f && u.push({ m: (d) => d[c] * d[f], t: c + ' \xD7 ' + f }));
      }));
  });
  for (let c = s.length - 1; c >= 0; c--) {
    let f = a.map(s[c].f);
    if (!f.some((d) => !isFinite(d) || Math.abs(d) < 1e-9))
      for (let d of u) {
        let m = a.map((p, g) => l[g] / (f[g] * d.m(p)));
        if (m.every((p) => isFinite(p) && Math.abs(p - m[0]) < 1e-7 * Math.max(1, Math.abs(p)))) {
          let p = m[0];
          return !d.t && Math.abs(Math.abs(p) - 1) < 1e-9
            ? { src: s[c].fi, desc: 'passe des termes d\u2019un membre \xE0 l\u2019autre' }
            : {
                src: s[c].fi,
                desc:
                  'multiplie (ou divise) les deux membres par ' +
                  (d.t ? (d.t.startsWith('1 \xF7 ') ? d.t.slice(4) : d.t) : pe(Math.abs(1 / p))),
              };
        }
      }
  }
  return null;
}
function gP(e) {
  for (let n = 1; n <= 12; n++) {
    let t = Math.round(e * n);
    if (Math.abs(t) <= 144 && Math.abs(t / n - e) < 1e-9) return [t, n];
  }
  return null;
}
function bJ(e, n) {
  let t = e.K,
    r = gx(n);
  if (!r || jT({ dis: [n] })) return null;
  let s = [];
  if (
    (e.facts.forEach((m, p) => {
      if (m.line.dis.length !== 1 || m.source === 'hyp') return;
      let g = m.line.dis[0];
      if (Object.keys(qx(m.line)).filter((b) => t[b] === void 0).length < 2) return;
      let h = gx(g);
      h && s.push({ f: h, fi: p });
    }),
    s.length < 2)
  )
    return null;
  let i = {};
  [n, ...s.map((m) => e.facts[m.fi].line.dis[0])].forEach((m) => m.sides.forEach((p) => Fe(p, i)));
  let o = Object.keys(i).filter((m) => t[m] === void 0);
  if (o.length < 2) return null;
  let l = [
      [1.37, -2.11, 0.73, 3.29],
      [-0.83, 1.91, 2.47, -1.53],
      [2.21, 0.59, -1.17, 0.97],
      [-1.63, -0.71, 1.43, 2.83],
      [0.41, 2.69, -2.39, -0.37],
    ].map((m) => {
      let p = { ...t };
      return (o.forEach((g, h) => (p[g] = m[h % m.length] + h * 0.17)), p);
    }),
    u = (m, p) => {
      let g = { ...t };
      return (o.forEach((h) => (g[h] = (l[m][h] + l[p][h]) / 2)), g);
    },
    c = (m) =>
      [
        [0, 1],
        [2, 3],
        [1, 4],
      ].every(([p, g]) => {
        let h = m(u(p, g)),
          b = (m(l[p]) + m(l[g])) / 2;
        return isFinite(h) && Math.abs(h - b) < 1e-7 * Math.max(1, Math.abs(h));
      });
  if (!c(r)) return null;
  let f = s.filter((m) => c(m.f));
  if (((s.length = 0), s.push(...f), s.length < 2)) return null;
  let d = l.map(r);
  if (d.some((m) => !isFinite(m)) || d.every((m) => Math.abs(m) < 1e-9)) return null;
  for (let m = 0; m < s.length; m++)
    for (let p = m + 1; p < s.length; p++) {
      let g = l.map(s[m].f),
        h = l.map(s[p].f);
      if (g.concat(h).some((G) => !isFinite(G))) continue;
      let b = g[0] * h[1] - g[1] * h[0];
      if (Math.abs(b) < 1e-9) continue;
      let v = (d[0] * h[1] - d[1] * h[0]) / b,
        k = (g[0] * d[1] - g[1] * d[0]) / b;
      if (
        Math.abs(v) < 1e-9 ||
        Math.abs(k) < 1e-9 ||
        !d.every((G, Se) => Math.abs(v * g[Se] + k * h[Se] - G) < 1e-7 * Math.max(1, Math.abs(G)))
      )
        continue;
      let S = gP(v),
        w = gP(k);
      if (!S || !w) continue;
      let _ = pe,
        O =
          Math.abs(v) === 1 && Math.abs(k) === 1
            ? v === k
              ? 'additionne les deux \xE9quations'
              : 'soustrait les deux \xE9quations'
            : 'combine les deux \xE9quations (' +
              _(v) +
              ' \xD7 la premi\xE8re, ' +
              _(k) +
              ' \xD7 la seconde)';
      return { src: s[p].fi, desc: O };
    }
  return null;
}
function vJ(e, n) {
  let t = e.K;
  if (n.sides.length !== 2) return null;
  let r = [];
  e.facts.forEach((s, i) => {
    s.line.dis.length === 1 &&
      s.line.dis[0].sides.length === 2 &&
      r.push({ d: s.line.dis[0], fi: i });
  });
  for (let s = 0; s < r.length; s++)
    for (let i = 0; i < r.length; i++)
      if (s !== i)
        for (let o = 0; o < 2; o++)
          for (let a = 0; a < 2; a++) {
            let l = r[s].d.sides[o];
            if (Ne(l) !== Ne(r[i].d.sides[a])) continue;
            let u = { sides: [r[s].d.sides[1 - o], r[i].d.sides[1 - a]] },
              c = Mh(n, u, t);
            if (c)
              return { cand: { kind: 'trans', line: { dis: [u] }, src: r[i].fi, via: l }, m: c };
          }
  return null;
}
function QP(e, n, t) {
  let r = e.K;
  if (n.sides.length !== 2) return null;
  let s = [];
  [0, 1].forEach((i) => {
    let o = n.sides[i],
      a = n.sides[1 - i],
      l = ds(a, r),
      u = o.k === 'mul' ? o.c : [o],
      c = a.k === 'mul' ? a.c : [a];
    u.length > 1 &&
      u.forEach((m, p) => {
        let g = V(
            'mul',
            u.filter((b, v) => v !== p),
          ),
          h = 'Multiplie les deux c\xF4t\xE9s par ' + z(m) + '.';
        (c.length > 1 &&
          c.forEach((b, v) => {
            Ne(m) === Ne(b) &&
              s.push({
                eq: Rn(
                  i,
                  g,
                  V(
                    'mul',
                    c.filter((k, y) => y !== v),
                  ),
                ),
                desc: h,
              });
          }),
          m.k === 'n' &&
            m.v !== 0 &&
            l !== null &&
            a.k !== 'mul' &&
            s.push({ eq: Rn(i, g, X(l / m.v)), desc: h }));
      });
    let f = o.k === 'add' ? o.c : [o],
      d = a.k === 'add' ? a.c : [a];
    (f.length > 1 &&
      f.forEach((m, p) => {
        let g = V(
            'add',
            f.filter((v, k) => k !== p),
          ),
          h = $n(m),
          b =
            (h.neg ? 'Retire ' : 'Ajoute ') +
            z(h.t) +
            (h.neg ? ' des deux c\xF4t\xE9s.' : ' aux deux c\xF4t\xE9s.');
        (d.length > 1 &&
          d.forEach((v, k) => {
            Ne(m) === Ne(v) &&
              s.push({
                eq: Rn(
                  i,
                  g,
                  V(
                    'add',
                    d.filter((y, S) => S !== k),
                  ),
                ),
                desc: b,
              });
          }),
          m.k === 'n' &&
            l !== null &&
            a.k !== 'add' &&
            s.push({ eq: Rn(i, g, X(l - m.v)), desc: b }));
      }),
      o.k === 'div' &&
        a.k === 'div' &&
        Ne(o.b) === Ne(a.b) &&
        s.push({ eq: Rn(i, o.a, a.a), desc: 'Divise les deux c\xF4t\xE9s par ' + z(o.b) + '.' }));
  });
  for (let i = 0; i < s.length; i++) {
    for (let o = e.facts.length - 1; o >= 0; o--) {
      let a = e.facts[o].line;
      if (a.dis.length === 1 && Mh(s[i].eq, a.dis[0], r)) return { src: o, desc: s[i].desc };
    }
    if (t < 1) {
      let o = QP(e, s[i].eq, t + 1);
      if (o) return { src: o.src, desc: o.desc.replace(/\.$/, '') + ', puis ' + xx(s[i].desc) };
    }
  }
  return null;
}
function kJ(e, n) {
  let t = e.K,
    r = vh(e, !0);
  for (let s = 0; s < r.length; s++)
    if (r[s].line.dis.length === n.dis.length && hs(n, r[s].line, t)) return r[s];
  if (
    n.dis.length > 1 &&
    n.dis.every((i) => r.some((o) => o.line.dis.length === 1 && hs({ dis: [i] }, o.line, t)))
  )
    return { kind: 'transpo' };
  if (n.dis.length === 1) {
    let s = e.facts.map((i) => i.line).concat(vx(e, bx(e)).map((i) => i.line));
    for (let i = 0; i < s.length; i++)
      if (s[i].dis.length === 1 && fu(n.dis[0], s[i].dis[0], t, !0)) return { kind: 'ident' };
  }
  return null;
}
function xJ(e, n) {
  let t = e.K,
    r = vh(e, !1).filter((s) => !(s.rc && s.rc.needsProof));
  for (let s = 0; s < r.length; s++) {
    if (r[s].line.dis.length !== n.dis.length) continue;
    let i = { mis: 0, max: 1, at: null };
    if (hs(n, r[s].line, t, i) && i.mis === 1 && i.at) return i.at;
  }
  return null;
}
function yJ(e, n) {
  let t = e.K,
    r = _P(e);
  for (let i = 0; i < r.length; i++) {
    let o = r[i];
    if (
      hs(n, o.line, t) ||
      (n.dis.length === 1 &&
        o.line.dis.length === 1 &&
        ps(n, t) &&
        fu(n.dis[0], o.line.dis[0], t, !0))
    )
      return o;
    if (n.dis.length > 1) {
      for (let a = 0; a < n.dis.length; a++) if (hs({ dis: [n.dis[a]] }, o.line, t)) return o;
    }
  }
  if (n.dis.length === 1) {
    let i = rJ(e);
    for (let o = 0; o < i.length; o++) if (fu(n.dis[0], i[o].line.dis[0], t, !0)) return i[o];
  }
  let s = sJ(n);
  for (let i = 0; i < s.length; i++) {
    let o = s[i];
    if (o.square) {
      if (!ps(o.line, t) && mx(o.line, e)) return o;
      continue;
    }
    if (!mx(o.line, e)) continue;
    let a = kJ(e, o.line);
    if (a) {
      if (o.sign) {
        let l = a.kind === 'transpo' || a.kind === 'bothsides' || (a.kind === 'rule' && a.deep);
        return {
          title: o.title,
          why: l
            ? 'Quand un nombre passe de l\u2019autre c\xF4t\xE9 du signe =, il change de signe : on fait la m\xEAme op\xE9ration des deux c\xF4t\xE9s.'
            : 'Un signe s\u2019est invers\xE9 en route : reprends le signe de chaque terme, un par un.',
        };
      }
      return o;
    }
  }
  return null;
}
function hx(e) {
  return e.slice().sort().join(qm);
}
function wJ(e, n) {
  let t = e.K,
    r = gs(n, t);
  return e.facts.some((s) => s.line.dis.some((i) => Ox(n, i, t) && r >= gs(i, t)));
}
function gh(e) {
  return (e.k === 'neg' && e.a.k === 'add' ? 1 : 0) + Cn(e).reduce((n, t) => n + gh(t), 0);
}
function SJ(e, n) {
  if (hh(n) < hh(e) && fr(n) <= fr(e)) return !0;
  let t = [fr(e), gh(e), Ma(e), ET(e)],
    r = [fr(n), gh(n), Ma(n), ET(n)];
  for (let s = 0; s < 4; s++) {
    if (r[s] < t[s]) return !0;
    if (r[s] > t[s]) return !1;
  }
  return !1;
}
function ET(e) {
  return e.k === 's' ? 1 : Cn(e).reduce((n, t) => n + ET(t), 0);
}
function $T(e) {
  let n = [];
  return (FT(bh(ZP(uf(e, {}, n), n), n), n), n.length === 0);
}
function MT(e) {
  return (e.k === 'add' ? e.c.length : 0) + Cn(e).reduce((n, t) => n + MT(t), 0);
}
function hh(e) {
  return (
    (e.k === 'sq' && e.a.k === 'add' && e.a.c.length === 2 ? 1 : 0) +
    Cn(e).reduce((n, t) => n + hh(t), 0)
  );
}
function TJ(e, n) {
  let t = n.k === 'mul' || (n.k === 'neg' && n.a.k === 'mul');
  return e.k === 'add' && t
    ? 'Factoriser'
    : hh(n) < hh(e) && fr(n) < fr(e)
      ? 'D\xE9velopper avec une identit\xE9'
      : fr(n) < fr(e)
        ? $T(n)
          ? 'D\xE9velopper et r\xE9duire'
          : 'D\xE9velopper'
        : gh(n) < gh(e)
          ? $T(n)
            ? 'R\xE9duire'
            : 'Supprimer les parenth\xE8ses'
          : MT(n) === MT(e) && !$T(e)
            ? 'Calculer'
            : 'R\xE9duire';
}
var RJ = {
    Factoriser: 'On met le facteur commun en \xE9vidence.',
    'D\xE9velopper avec une identit\xE9':
      'On d\xE9veloppe avec une identit\xE9 remarquable : (a + b)\xB2 = a\xB2 + 2ab + b\xB2 et (a \u2212 b)\xB2 = a\xB2 \u2212 2ab + b\xB2.',
    Développer:
      'On d\xE9veloppe : chaque terme d\u2019une parenth\xE8se multiplie chaque terme de l\u2019autre.',
    'D\xE9velopper et r\xE9duire': 'On d\xE9veloppe, puis on regroupe les termes semblables.',
    'Supprimer les parenth\xE8ses':
      'Un \xAB \u2212 \xBB devant une parenth\xE8se change le signe de chaque terme.',
    Réduire: 'On regroupe les termes semblables : l\u2019expression garde la m\xEAme valeur.',
    Calculer: 'On calcule chaque produit.',
  },
  $J = {
    'Identit\xE9 (a + b)\xB2': 'Tu reconnais (a + b)\xB2 = a\xB2 + 2ab + b\xB2.',
    'Identit\xE9 (a \u2212 b)\xB2': 'Tu reconnais (a \u2212 b)\xB2 = a\xB2 \u2212 2ab + b\xB2.',
    'Identit\xE9 (a + b)(a \u2212 b)': 'Tu reconnais (a + b)(a \u2212 b) = a\xB2 \u2212 b\xB2.',
    'Identit\xE9 a\xB2 \u2212 b\xB2':
      'Tu reconnais une diff\xE9rence de deux carr\xE9s : a\xB2 \u2212 b\xB2 = (a \u2212 b)(a + b).',
    Distributivité: 'Le facteur multiplie chaque terme de la parenth\xE8se : k(a + b) = ka + kb.',
    'Double distributivit\xE9':
      'Chaque terme de la premi\xE8re parenth\xE8se multiplie chaque terme de la seconde : (a + b)(c + d) = ac + ad + bc + bd.',
  };
function Rm(e) {
  let n = $n(e);
  return (n.neg ? '\u2212' : '+') + Ne(n.t);
}
function ch(e, n) {
  if (e.length !== n.length) return !1;
  let t = e.map(Rm).sort(),
    r = n.map(Rm).sort();
  return t.every((s, i) => s === r[i]);
}
function of(e) {
  return e.k === 'add' ? e.c : [e];
}
function CJ(e, n, t) {
  if (e.k !== 'mul' || e.c.length !== 2) return !1;
  let [r, s] = e.c,
    i = of(n).concat([qe(t)]),
    o = of(n).concat([t]);
  return (ch(of(r), i) && ch(of(s), o)) || (ch(of(r), o) && ch(of(s), i));
}
function EJ(e) {
  if (e.k !== 'mul' || e.c.length !== 2) return !1;
  let [n, t] = e.c;
  if (n.k !== 'add' || t.k !== 'add' || n.c.length !== 2 || t.c.length !== 2) return !1;
  for (let r = 0; r < 2; r++)
    for (let s = 0; s < 2; s++) {
      if (Rm(n.c[r]) !== Rm(t.c[s])) continue;
      let i = n.c[1 - r],
        o = t.c[1 - s];
      if (Rm(i) === Rm(qe(o))) return !0;
    }
  return !1;
}
function MJ(e, n, t) {
  if (t.k === 'add' && fr(t) === 0 && n.k === 'mul') {
    let s = n.c.filter((o) => o.k === 'add'),
      i = n.c.every((o) => o.k === 'add' || fr(o) === 0);
    if (i && s.length === 1 && t.c.length === s[0].c.length) return 'Distributivit\xE9';
    if (i && s.length === 2 && n.c.length === 2 && t.c.length === s[0].c.length * s[1].c.length)
      return 'Double distributivit\xE9';
  }
  if (
    t.k === 'add' &&
    fr(t) === 0 &&
    n.k === 'neg' &&
    n.a.k === 'add' &&
    t.c.length === n.a.c.length
  )
    return 'Distributivit\xE9';
  if (t.k === 'add' && fr(t) === 0) {
    if (n.k === 'sq' && n.a.k === 'add' && n.a.c.length === 2 && t.c.length === 3) {
      let [s, i] = n.a.c;
      return $n(s).neg !== $n(i).neg ? 'Identit\xE9 (a \u2212 b)\xB2' : 'Identit\xE9 (a + b)\xB2';
    }
    if (EJ(n) && t.c.length === 2) return 'Identit\xE9 (a + b)(a \u2212 b)';
  }
  let r = (s) => (e.model.preds || []).some((i) => i.skill === s);
  if (r('differenceCarres')) {
    let s = TP(n);
    if (s && CJ(t, s.a, s.b)) return 'Identit\xE9 a\xB2 \u2212 b\xB2';
  }
  if (r('carreParfait')) {
    let s = RP(n, e.K);
    if (
      s &&
      t.k === 'sq' &&
      t.a.k === 'add' &&
      ch(t.a.c, of(s.a).concat([s.minus ? qe(s.b) : s.b]))
    )
      return s.minus ? 'Identit\xE9 (a \u2212 b)\xB2' : 'Identit\xE9 (a + b)\xB2';
  }
  return null;
}
function _J(e, n) {
  switch (e.kind) {
    case 'rule': {
      let t = e.rc;
      return {
        id: t.skill,
        card: t.card,
        obligation: !!t.obligation && !e.isCase,
        label: (e.isCase && t.caseLabel) || t.label,
        hora: e.isCase ? t.caseHora || 2 : t.hora,
        why: t.why + (n.sub ? ' On remplace par les valeurs de l\u2019\xE9nonc\xE9.' : ''),
      };
    }
    case 'subst': {
      let t = e.def;
      return t.source === 'hyp'
        ? {
            id: 'recurrence',
            card: 'Raisonnement par r\xE9currence',
            label: 'Utiliser l\u2019hypoth\xE8se',
            hora: 4,
            why:
              'On remplace ' +
              t.s +
              ' par ' +
              z(t.expr) +
              ' : c\u2019est l\u2019hypoth\xE8se de r\xE9currence.',
          }
        : {
            id: 'remplacer',
            card: 'Calcul',
            label: 'Remplacer',
            hora: 2,
            why: 'On remplace ' + t.s + ' par ' + z(t.expr) + '.',
          };
    }
    case 'ident': {
      if (e.identity) {
        let r = /distributivité/i.test(e.identity);
        return {
          id: r ? 'distributivite' : 'identite',
          card: r ? 'D\xE9velopper' : 'Identit\xE9s remarquables',
          label: e.identity,
          hora: r ? 4 : 5,
          why: $J[e.identity] || 'On reconna\xEEt une identit\xE9 remarquable.',
        };
      }
      let t = TJ(e.from, e.to);
      return { id: 'calcul', card: 'Calcul litt\xE9ral', label: t, hora: 2, why: RJ[t] };
    }
    case 'trans':
      return {
        id: 'remplacer',
        card: 'Calcul',
        label: 'Remplacer',
        hora: 2,
        why:
          'Les deux expressions sont \xE9gales \xE0 ' +
          z(e.via) +
          ' : on remplace l\u2019une par l\u2019autre.',
      };
    case 'transpo':
      return {
        id: 'equation',
        card: 'R\xE9soudre une \xE9quation',
        label: 'M\xEAme op\xE9ration des deux c\xF4t\xE9s',
        hora: 4,
        why: e.desc ? fx(e.desc) : 'On fait la m\xEAme op\xE9ration des deux c\xF4t\xE9s.',
      };
    case 'comb':
      return {
        id: 'equation',
        card: 'R\xE9soudre un syst\xE8me',
        label: 'Combinaison des \xE9quations',
        hora: 4,
        why: e.desc ? fx(e.desc) : 'On combine les deux \xE9quations.',
      };
    case 'bothsides':
      return {
        id: 'equation',
        card: 'R\xE9soudre une \xE9quation',
        label: 'M\xEAme op\xE9ration des deux c\xF4t\xE9s',
        hora: 2,
        why: e.desc ? fx(e.desc) : 'On fait la m\xEAme op\xE9ration des deux c\xF4t\xE9s.',
      };
    case 'racine':
      return e.line.dis.length === 2
        ? {
            id: 'racine',
            card: 'Racine carr\xE9e',
            label: 'Deux racines carr\xE9es',
            hora: 4,
            why: 'Un nombre et son oppos\xE9 ont le m\xEAme carr\xE9 : x\xB2 = k (k > 0) donne x = \u221Ak ou x = \u2212\u221Ak.',
          }
        : {
            id: 'racine',
            card: 'Racine carr\xE9e',
            label: 'Racine carr\xE9e',
            hora: 3,
            why: 'Une longueur est positive : on prend la racine carr\xE9e.',
          };
    case 'case':
      return {
        id: 'cas',
        card: '\xC9quation produit nul',
        label: 'Un des cas',
        hora: 2,
        why: 'L\u2019un des facteurs est nul.',
      };
    default:
      return {
        id: 'calcul',
        card: 'Calcul',
        label:
          n.sub && n.ev
            ? 'Remplacer et calculer'
            : n.sub
              ? 'Remplacer'
              : n.ev
                ? 'Calculer'
                : 'R\xE9\xE9crire',
        hora: 2,
        why: n.sub
          ? 'On remplace les grandeurs connues par leur valeur' +
            (n.ev ? ', puis on calcule.' : '.')
          : 'On calcule.',
      };
  }
}
function FP(e, n, t, r, s) {
  let i = e.K,
    o = hx(r),
    a = _J(s.cand, s.m),
    l = { kind: 'step', atoms: r, rule: a, line: n },
    u = (g) =>
      g.dis
        .map((h) => h.sides.map(Ne).sort().join('='))
        .sort()
        .join('|'),
    c = e.facts.filter((g) => hx(g.atoms) === o && Kx(g.line, t, i) && u(g.line) === u(t))[0];
  if (c && c.source === 'hyp')
    return e.stated.hyp
      ? Object.assign(l, {
          kind: 'dup',
          title: 'D\xE9j\xE0 dans ton raisonnement',
          message: 'Tu as d\xE9j\xE0 pos\xE9 cette hypoth\xE8se.',
        })
      : Object.assign(l, {
          kind: 'step',
          hora: 2,
          final: !1,
          hyp: !0,
          rule: {
            id: 'recurrence',
            card: 'Raisonnement par r\xE9currence',
            label: 'Hypoth\xE8se de r\xE9currence',
            hora: 2,
            why: 'H\xE9r\xE9dit\xE9 : on suppose la formule vraie \xE0 un rang n, pour d\xE9montrer qu\u2019elle l\u2019est au rang n + 1.',
          },
        });
  if (c) {
    let g = c.source === 'given';
    return Object.assign(l, {
      kind: g ? 'given' : 'dup',
      title: g ? 'C\u2019est dans l\u2019\xE9nonc\xE9' : 'D\xE9j\xE0 dans ton raisonnement',
      message: g
        ? 'Juste, mais l\u2019\xE9nonc\xE9 te le donne d\xE9j\xE0 : \xE7a ne t\u2019apprend rien de nouveau.'
        : 'Tu as d\xE9j\xE0 \xE9crit cette ligne. Passe \xE0 la suite.',
    });
  }
  if (a.obligation)
    return ph(e, s.cand.line)
      ? Object.assign(l, {
          kind: 'dup',
          title: 'D\xE9j\xE0 fait',
          message: 'L\u2019initialisation est d\xE9j\xE0 dans ton raisonnement.',
        })
      : Object.assign(l, { kind: 'step', hora: a.hora, final: !1 });
  let f = s.cand.kind === 'fact' ? e.facts[s.cand.src] : void 0;
  if (f && f.shown && s.m.sub > 0 && !ps(t, i) && KT(e) && !e.stated.verif)
    return Object.assign(l, {
      kind: 'step',
      hora: 1,
      final: !1,
      verif: !0,
      rule: {
        id: 'verif',
        card: 'V\xE9rifier',
        label: 'V\xE9rification',
        hora: 1,
        why: 'On remplace par la solution trouv\xE9e : l\u2019\xE9galit\xE9 de l\u2019\xE9nonc\xE9 est bien vraie.',
      },
    });
  if ($m(e, n)) return Object.assign(l, { kind: 'step', final: !0, hora: a.hora + 2 });
  let d = e.model.aim,
    m = (g, h) =>
      Object.assign(l, {
        kind: 'useless',
        title: g || 'Juste, mais \xE7a ne t\u2019avance pas',
        message:
          h ||
          'Cette ligne est vraie et bien justifi\xE9e, mais tu as d\xE9j\xE0 la m\xEAme information, \xE9crite plus simplement. Cherche ce qui te rapproche de la question.',
      });
  if (s.cand.kind === 'ident') {
    if (d === 'factor' && /^Développer/.test(a.label))
      return m(
        'Juste, mais tu t\u2019\xE9loignes du but',
        'On te demande une forme factoris\xE9e, c\u2019est-\xE0-dire un produit. D\xE9velopper, c\u2019est faire le chemin inverse.',
      );
    if (d === 'expand' && a.label === 'Factoriser')
      return m(
        'Juste, mais tu t\u2019\xE9loignes du but',
        'On te demande de d\xE9velopper : une somme de termes, pas un produit.',
      );
    if (!SJ(s.cand.from, s.cand.to) && !$m(e, n) && !mP(e, n)) return m();
  } else if (s.cand.kind !== 'bothsides' && !(s.cand.rc && s.cand.rc.transform)) {
    let g = t.dis.some((b) => !wJ(e, b));
    (!g &&
      d &&
      f &&
      t.dis.length === 1 &&
      f.line.dis.length === 1 &&
      (g = gs(t.dis[0], i) < gs(f.line.dis[0], i)),
      !g &&
        f &&
        f.source === 'line' &&
        f === e.facts[e.facts.length - 1] &&
        t.dis.length === 1 &&
        f.line.dis.length === 1 &&
        ps(t, i) &&
        (g = gs(t.dis[0], i) < gs(f.line.dis[0], i)),
      !g && mP(e, n) && (g = !0),
      !g && e.model.path?.length && ps(t, i) && (g = !0));
    let h = s.cand.src !== void 0 ? e.facts[s.cand.src] : void 0;
    if (!g && s.cand.kind === 'transpo' && h && t.dis.length === 1 && h.line.dis.length === 1) {
      let b = (S) => S.sides.filter((w) => De(w, i)).length;
      g = b(t.dis[0]) < b(h.line.dis[0]);
      let v = h.line.dis[0],
        k = (S) => S.sides.some((w) => w.k === 's' && i[w.n] === void 0),
        y = Object.keys(Fe({ k: 'add', c: v.sides })).filter((S) => i[S] === void 0);
      !g && y.length === 2 && !k(v) && k(t.dis[0]) && (g = !0);
    }
    if (!g) return m();
  }
  let p = kx(n, e, !0) || $m(e, n);
  return Object.assign(l, { kind: 'step', final: p, hora: a.hora + (p ? 2 : 0) });
}
function qJ(e) {
  return AP(e, 'pending', () => LJ(e));
}
function LJ(e) {
  let n = {},
    t = qP(e);
  function r(i) {
    (i.k !== 'n' && i.k !== 's' && !De(i, t) && ((n[Ne(i)] = 1), (n[Ne(gf(i, t))] = 1)),
      Cn(i).forEach(r));
  }
  let s = vh(e, !1, !0).map((i) => i.line);
  return (
    e.facts.forEach((i) => px(i.line, e, s)),
    s.forEach((i) => i.dis.forEach((o) => o.sides.forEach(r))),
    n
  );
}
function NJ(e, n, t) {
  let r = hx(t),
    s = e.facts.filter((c) => hx(c.atoms) === r)[0];
  if (s) {
    let c = s.source === 'given';
    return {
      kind: c ? 'given' : 'dup',
      atoms: t,
      title: c ? 'C\u2019est dans l\u2019\xE9nonc\xE9' : 'D\xE9j\xE0 dans ton raisonnement',
      message: c
        ? 'Juste, mais l\u2019\xE9nonc\xE9 te le donne d\xE9j\xE0.'
        : 'Tu as d\xE9j\xE0 \xE9crit ce calcul.',
    };
  }
  let i = [];
  n.dis.forEach((c) => c.sides.forEach((f) => i.push(f)));
  let o = i.filter((c) => c.k !== 'n' && c.k !== 's');
  if (!o.length)
    return {
      kind: 'useless',
      atoms: t,
      line: n,
      title: 'Juste, mais \xE9vident',
      message:
        'C\u2019est vrai, mais \xE7a ne t\u2019apprend rien : il n\u2019y a rien \xE0 calculer.',
    };
  let a = qJ(e),
    l = qP(e);
  return o.some((c) => a[Ne(c)] || a[Ne(gf(c, l))])
    ? {
        kind: 'step',
        atoms: t,
        line: n,
        hora: 1,
        final: !1,
        rule: {
          id: 'calcul',
          card: 'Calcul',
          label: 'Calcul',
          hora: 1,
          why: 'Un calcul interm\xE9diaire dont tu as besoin.',
        },
      }
    : {
        kind: 'useless',
        atoms: t,
        line: n,
        title: 'Juste, mais \xE7a ne sert pas ici',
        message:
          'Ton calcul est juste, mais il n\u2019appara\xEEt nulle part dans le raisonnement de cet exercice.',
      };
}
function hP(e, n, t) {
  return e[n] !== void 0 ? e[n] : t - 1;
}
function xx(e) {
  return e.charAt(0).toLowerCase() + e.slice(1);
}
function fx(e) {
  return 'On ' + xx(e);
}
var OJ = '\u2070\xB9\xB2\xB3\u2074\u2075\u2076\u2077\u2078\u2079';
function _T(e, n = !1) {
  let t = [];
  for (let r of e) {
    let s = r.replace(/[\u2009\u202F\u00A0]/g, ' ').trim();
    if (!s) continue;
    let i = /^(.*?)([⁰¹²³⁴⁵⁶⁷⁸⁹]+)$/.exec(s);
    i && !(n && /[a-zA-Zµ]$/.test(i[1]))
      ? (i[1] && t.push(i[1]), t.push('^', [...i[2]].map((o) => String(OJ.indexOf(o))).join('')))
      : t.push(...s.split(/\s+/));
  }
  return t;
}
function KJ(e) {
  let n = e.model.kernel;
  return n
    ? [...(n.path ?? []), n.answer].map((r) => {
        if (e.units) return _T([r], !0);
        try {
          return _T(ne(Te(r)));
        } catch {
          return [];
        }
      })
    : [];
}
function PJ(e, n, t) {
  let r = IJ(e, n, t);
  if (!t?.verify && r.kind !== 'empty') {
    let s = _T(
      n.flatMap((o) => o.atoms),
      !!e.units,
    );
    if (s.length > 0 && KJ(e).some((o) => o.length > s.length && s.every((a, l) => o[l] === a))) {
      if (r.kind === 'step') return { ...r, kind: 'ready' };
      if (r.kind !== 'ready')
        return { kind: 'building', atoms: r.atoms, complete: r.kind !== 'open' };
    }
  }
  return r;
}
function IJ(e, n, t) {
  let r = { verify: !0 },
    s = e.cong
      ? Fx(e.cong, e.model, n, r)
      : e.cplx
        ? Jx(e.cplx, e.model, n, r)
        : e.units
          ? yT(e.units, e.model.traps ?? [], n, r)
          : pT(e.bnd, e.model.traps ?? [], n, r);
  if (!t?.verify && (s.kind === 'unjustified' || s.kind === 'false'))
    return { kind: 'pending', atoms: s.atoms, complete: !0 };
  if (s.kind === 'unjustified' && s.keep) {
    let i = s.keep.line;
    if (s.keep.kind === 'aside')
      return {
        kind: 'useless',
        atoms: s.atoms,
        line: i,
        title: 'Calcul juste',
        message:
          'Ce calcul est juste, mais il ne part pas de la question. Garde-le s\u2019il t\u2019aide : il ne rapporte pas de HORA.',
      };
    let o = e.cong ? bR(e.cong, i) : e.cplx ? KR(e.cplx, i) : !!e.bnd && !gT(e.bnd);
    return {
      kind: 'useless',
      atoms: s.atoms,
      line: i,
      jump: !0,
      final: o,
      title: o ? 'Juste !' : 'Juste, mais tu sautes des \xE9tapes',
      message: o
        ? 'C\u2019est la bonne r\xE9ponse. D\xE9taille ton raisonnement, une \xE9tape par ligne, pour gagner des HORA. Tu peux garder cette ligne sans HORA.'
        : 'Ta ligne est juste. D\xE9taille-la, une \xE9tape par ligne, pour gagner des HORA. Tu peux la garder sans HORA.',
      ...(e.bnd ? { bnd: { low: !1, high: !1, done: !0 } } : {}),
    };
  }
  return s;
}
function AJ(e, n, t) {
  if (e.kern) return Nb(e.kern, n, t);
  if (e.kgeo) return kN(e.kgeo, n, t);
  if (e.krec) return KN(e.krec, n, t);
  if (e.kprog) return n_(e.kprog, n, t);
  if (e.kmat) return JN(e.kmat, n, t);
  if (e.karith) return p2(e.karith, n, t);
  if (e.klim) return vc(e.klim, n, t);
  if (e.klc) return QS(e.klc, n, t);
  if (e.kint) return Zl(e.kint, n, t);
  if (e.kode) return sO(e.kode, n, t);
  if (e.kpart) return gO(e.kpart, n, t);
  if (e.kriem) return QO(e.kriem, n, t);
  if (e.kclaims) return xM(e.kclaims, n, t);
  if (e.kvar) return CK(e.kvar, n, t);
  if (e.ktab) return jK(e.ktab, n, t);
  if (e.kana) return Xg(e.kana, n, t);
  if (e.kfor) return yE(e.kfor, n, t);
  if (e.kspecial) return PJ(e, n, t);
  if (e.cong) return Fx(e.cong, e.model, n, t);
  if (e.cplx) return Jx(e.cplx, e.model, n, t);
  if (e.units) return yT(e.units, e.model.traps ?? [], n, t);
  if (e.geo) return QR(e.geo, e.model.traps ?? [], n, t);
  if (e.bnd) return pT(e.bnd, e.model.traps ?? [], n, t);
  let r = t || {},
    s = wt(n),
    i = s.atoms;
  if (!i.length) return { kind: 'empty', atoms: i, badChip: -1 };
  let o = vn(i);
  if (!o.ok)
    return {
      kind: 'syntax',
      atoms: i,
      title: '\xC7a commence mal',
      message: o.msg,
      badChip: hP(s.src, o.index, n.length),
    };
  let a = pJ(i, dJ(e)),
    l = a.len < i.length ? hP(s.src, a.len, n.length) : -1;
  if (!o.complete || !o.hasEq) {
    let d = !a.strict && gJ(e, i);
    return d
      ? {
          kind: 'trap',
          atoms: i,
          title: 'Pi\xE8ge : ' + xx(d.title),
          message: d.why,
          trap: d,
          badChip: l,
        }
      : { kind: a.strict ? 'building' : 'open', atoms: i, complete: !1 };
  }
  let u;
  try {
    u = Ae(i);
  } catch {
    return { kind: 'open', atoms: i, complete: !1 };
  }
  let c = u.dis.length === 1 && u.dis[0].cmp ? u.dis[0] : null,
    f = c ? BJ(e, c, u, i) : zJ(e, u, i, l);
  return a.strict && !r.verify
    ? f.kind === 'step'
      ? Object.assign(f, { kind: 'ready' })
      : { kind: 'building', atoms: i, complete: !0 }
    : !r.verify && (f.kind === 'unjustified' || f.kind === 'false')
      ? { kind: 'pending', atoms: i, complete: !0 }
      : f;
}
function yx(e) {
  let n = e.cmp === '<' || e.cmp === '\u2264',
    t = e.cmp === '<' ? '>' : e.cmp === '\u2264' ? '\u2265' : e.cmp,
    [r, s] = n ? [e.sides[1], e.sides[0]] : [e.sides[0], e.sides[1]];
  return Ne(r) + ' ' + t + ' ' + Ne(s);
}
function VP(e) {
  return (e.model.checks ?? []).flatMap((n) => {
    try {
      let t = Ve(n.line),
        r = t.dis[0];
      return r && r.cmp ? [{ spec: n, line: t, key: yx(r) }] : [];
    } catch {
      return [];
    }
  });
}
function jJ(e, n) {
  return (e.stated.checks ?? []).includes(n);
}
function kh(e) {
  return e.model.rounding?.symbol ?? e.model.goal[0];
}
function QJ(e) {
  return e === 0
    ? '\xE0 l\u2019unit\xE9'
    : e === 1
      ? 'au dixi\xE8me'
      : e === 2
        ? 'au centi\xE8me'
        : e === 3
          ? 'au milli\xE8me'
          : '\xE0 ' + e + ' chiffres apr\xE8s la virgule';
}
function IT(e) {
  return e.model.symbols[kh(e)]?.values ?? [];
}
function FJ(e) {
  let n = e.model.rounding;
  if (!n) return !1;
  let t = IT(e);
  if (!t.length || t.every((s) => Rh(s) <= n.places)) return !1;
  let r = Ne(pf(kh(e))) + ' \u2248 ';
  return !(e.stated.checks ?? []).some((s) => s.startsWith(r));
}
function VJ(e) {
  if (!e.model.rounding) return !1;
  let n = kh(e),
    t = IT(e);
  return e.facts.some(
    (r) =>
      r.line.dis.length === 1 &&
      r.line.dis[0].sides.length === 2 &&
      !r.line.dis[0].cmp &&
      [0, 1].some((s) => {
        let i = r.line.dis[0],
          o = i.sides[s],
          a = i.sides[1 - s];
        if (o.k !== 's' || o.n !== n || !pt(a, {})) return !1;
        let l = H(a, {});
        if (!t.some((c) => Ce(l, c))) return !1;
        let u = [];
        return (uf(a, {}, u), u.length === 0);
      }),
  );
}
function DJ(e, n, t, r, s) {
  let i = e.model.rounding,
    o = kh(e),
    a = n.sides[0];
  if (!(!!i && a.k === 's' && a.n === o))
    return La('\u2248', r, s)
      ? {
          kind: 'useless',
          atoms: t,
          title: 'Juste, mais pas utile ici',
          message: i
            ? 'C\u2019est l\u2019arrondi de ' +
              o +
              ' qu\u2019on te demande, une fois sa valeur calcul\xE9e.'
            : 'L\u2019exercice demande une valeur exacte : \xE9cris \xAB = \xBB avec la valeur exacte.',
        }
      : {
          kind: 'false',
          atoms: t,
          title: 'Ce n\u2019est pas une bonne valeur approch\xE9e',
          message: 'Regarde les valeurs que tu as calcul\xE9es.',
        };
  let u = i.places,
    c = QJ(u),
    f = yx(n);
  if ((e.stated.checks ?? []).includes(f))
    return {
      kind: 'dup',
      atoms: t,
      title: 'D\xE9j\xE0 \xE9crit',
      message: 'Tu as d\xE9j\xE0 arrondi ' + o + '.',
    };
  if (Rh(s) > u)
    return La('\u2248', r, s)
      ? {
          kind: 'useless',
          atoms: t,
          title: 'Garde moins de chiffres',
          message:
            'On demande ' +
            o +
            ' arrondi ' +
            c +
            (u === 0
              ? ' : aucun chiffre apr\xE8s la virgule.'
              : ' : ' + u + ' chiffre' + (u > 1 ? 's' : '') + ' apr\xE8s la virgule.'),
        }
      : {
          kind: 'false',
          atoms: t,
          title: 'Valeur approch\xE9e fausse',
          message: o + ' vaut environ ' + pe(Mi(r, u + 2)) + '.',
        };
  if (Ce(s, Mi(r, u))) {
    let d = i.hora ?? 2;
    return {
      kind: 'step',
      atoms: t,
      line: { dis: [n] },
      hora: d,
      final: !0,
      rule: {
        id: 'arrondi',
        card: '',
        label: 'Arrondir',
        hora: d,
        why:
          'On arrondit ' +
          c +
          ' : on regarde le chiffre suivant (5 ou plus : on arrondit au-dessus).',
      },
    };
  }
  return Ce(s, eR(r, u))
    ? {
        kind: 'false',
        atoms: t,
        title: 'Arrondir, ce n\u2019est pas couper',
        message:
          'Regarde le chiffre juste apr\xE8s : s\u2019il vaut 5 ou plus, le dernier chiffre gard\xE9 augmente de 1.',
      }
    : {
        kind: 'false',
        atoms: t,
        title: 'Valeur approch\xE9e fausse',
        message: o + ' vaut environ ' + pe(Mi(r, u + 2)) + '.',
      };
}
function BJ(e, n, t, r) {
  let s = e.K,
    i = Object.keys(Fe({ k: 'add', c: n.sides })).filter((c) => s[c] === void 0 && !Xt(c));
  if (i.length)
    return {
      kind: 'unjustified',
      atoms: r,
      title: 'Calcule d\u2019abord ' + i.join(', '),
      message:
        'Pour comparer, il faut conna\xEEtre la valeur de ' +
        i.join(', ') +
        ' : calcule-la sur une ligne avant.',
    };
  let o = ds(n.sides[0], s),
    a = ds(n.sides[1], s);
  if (n.cmp === '\u2248' && o !== null && a !== null) return DJ(e, n, r, o, a);
  if (o === null || a === null || !La(n.cmp, o, a))
    return {
      kind: 'false',
      atoms: r,
      title: 'Cette comparaison est fausse',
      message:
        o !== null && n.sides[0].k === 's'
          ? n.sides[0].n + ' vaut ' + pe(o) + '.'
          : 'Regarde les valeurs que tu as calcul\xE9es.',
    };
  let l = yx(n),
    u = VP(e).find((c) => c.key === l);
  return u
    ? jJ(e, l)
      ? {
          kind: 'dup',
          atoms: r,
          title: 'D\xE9j\xE0 \xE9crit',
          message: 'Tu as d\xE9j\xE0 cette comparaison.',
        }
      : {
          kind: 'step',
          atoms: r,
          line: t,
          hora: u.spec.hora ?? 2,
          rule: {
            id: 'compare',
            card: '',
            label: u.spec.label,
            hora: u.spec.hora ?? 2,
            why: u.spec.why,
          },
        }
    : {
        kind: 'useless',
        atoms: r,
        title: 'Juste, mais \xE0 c\xF4t\xE9',
        message: 'Cette comparaison est vraie, mais elle ne d\xE9cide rien pour cette question.',
        line: t,
      };
}
function zJ(e, n, t, r) {
  let s = e.K;
  if (n.dis.length === 1 && n.dis[0].sides.length > 2 && ps(n, s)) return WJ(e, n, t);
  let i = {
    dis: n.dis.map((o) =>
      o.sides.length > 2 ? { sides: [o.sides[0], o.sides[o.sides.length - 1]] } : o,
    ),
  };
  if (mx(n, e)) {
    let o = jP(e, i);
    if (o && e.model.stepwise && UJ(e, n, o))
      return {
        kind: 'unjustified',
        atoms: t,
        line: n,
        title: '\xC9cris d\u2019abord l\u2019op\xE9ration',
        message:
          'Ta valeur est juste, mais montre comment tu l\u2019obtiens : \xE9cris d\u2019abord l\u2019op\xE9ration (par exemple \xAB x = 12 \xF7 3 \xBB), puis son r\xE9sultat.',
      };
    if (o) return FP(e, n, i, t, o);
    if (!ps(n, s)) return NJ(e, n, t);
    let a = AT(e, n, t);
    return e.model.envs && !(e.model.preds ?? []).some((l) => l.skill === 'recurrence')
      ? GJ(n, t, a)
      : a;
  }
  return DP(e, n, i, t, r);
}
function UJ(e, n, t) {
  let r =
      $m(e, n) ||
      (jT(n) && n.dis.every((o) => o.sides.some((a) => a.k === 's' && e.model.goal.includes(a.n)))),
    s =
      t.cand.kind === 'bothsides' &&
      /^(multiplie \(ou divise\)|passe des termes)/.test(t.cand.desc ?? '');
  if (!r || (t.m.ev === 0 && !s)) return !1;
  let i = t.cand.src;
  return i !== void 0 && e.facts[i]?.source === 'given';
}
function GJ(e, n, t) {
  let r = t.title === 'D\u2019o\xF9 \xE7a vient ?';
  return {
    kind: 'useless',
    atoms: n,
    line: e,
    title: 'Juste, mais sans HORA',
    message:
      'Ta ligne est juste. Je ne sais pas la relier \xE0 tes lignes pr\xE9c\xE9dentes : garde-la si elle t\u2019aide.' +
      (r ? '' : ' Conseil : ' + ZJ(t.message ?? '')),
  };
}
function ZJ(e) {
  return e.charAt(0).toLowerCase() + e.slice(1);
}
function HJ(e, n) {
  let t = e.model.envs;
  if (!t?.length || n.dis.length !== 1) return null;
  let r = n.dis[0];
  if (r.sides.length !== 2) return null;
  let s = (f) => e.model.symbols[f]?.kind === 'free';
  if (r.sides.some((f) => f.k === 's' && s(f.n))) return null;
  let i = Object.keys(Fe({ k: 'add', c: r.sides })).filter(s),
    o = (f) =>
      i.reduce(
        (d, m) =>
          d + Math.abs(f[m] ?? 0) + (Number.isInteger(f[m]) ? 0 : 10) + (f[m] === 0 ? 0.5 : 0),
        0,
      ),
    a = t
      .filter((f) => {
        let d = r.sides.map((m) => H(m, f));
        return d.every((m) => isFinite(m)) && !Ce(d[0], d[1]);
      })
      .sort((f, d) => o(f) - o(d))[0];
  if (!a) return null;
  let l = i.length ? 'pour ' + i.map((f) => f + ' = ' + pe(a[f])).join(' et ') + ', ' : '',
    [u, c] = r.sides.map((f) => z(f) + ' vaut ' + pe(H(f, a)));
  return l + u + ' mais ' + c + '.';
}
function DP(e, n, t, r, s) {
  let i = e.K,
    o = yJ(e, t);
  if (o)
    return {
      kind: 'trap',
      atoms: r,
      title: 'Pi\xE8ge : ' + xx(o.title),
      message: o.why,
      trap: { line: o.line || t, title: o.title, why: o.why || '' },
      badChip: s,
    };
  let a = e.model.rounding,
    l = n.dis.length === 1 ? n.dis[0] : null;
  if (a && l && l.sides.length === 2 && !l.cmp) {
    let d = kh(e),
      m = l.sides.findIndex((g) => g.k === 's' && g.n === d),
      p = m >= 0 ? ds(l.sides[1 - m], i) : null;
    if (p !== null && IT(e).some((g) => La('\u2248', g, p)))
      return {
        kind: 'false',
        atoms: r,
        title: 'C\u2019est une valeur approch\xE9e',
        message:
          d +
          ' ne vaut pas exactement ' +
          pe(p) +
          ' : \xE9cris \xAB ' +
          d +
          ' \u2248 ' +
          pe(p) +
          ' \xBB.',
        badChip: s,
      };
  }
  if (!ps(n, i)) {
    let d = n.dis[0],
      m = d.sides.map((p) => ds(p, i));
    return m.some((p) => p === null)
      ? {
          kind: 'false',
          atoms: r,
          title: 'Calcul impossible',
          message:
            'Ce calcul est impossible (division par z\xE9ro ou racine d\u2019un nombre n\xE9gatif).',
        }
      : {
          kind: 'false',
          atoms: r,
          title: 'Calcul faux',
          message:
            'Ce calcul est faux : ' +
            d.sides.map((p, g) => z(p) + ' vaut ' + pe(m[g])).join(', ') +
            '.',
        };
  }
  let u = xJ(e, t);
  if (u)
    return {
      kind: 'false',
      atoms: r,
      title: 'Presque !',
      message:
        'Erreur de calcul : \xE0 la place de ' +
        pe(u.wrote) +
        ', il fallait ' +
        pe(u.expected) +
        ' (c\u2019est ' +
        z(u.f) +
        ').',
    };
  let c = AT(e, n, r),
    f = c.title === 'D\u2019o\xF9 \xE7a vient ?' ? HJ(e, n) : null;
  return f
    ? {
        kind: 'false',
        atoms: r,
        title: 'Ce n\u2019est pas \xE9gal',
        message: 'Ta ligne est fausse : ' + f,
        badChip: s,
      }
    : c;
}
function AT(e, n, t) {
  let r = null;
  if (
    (Object.keys(lu).forEach((i) => {
      let o = lu[i].unjustified;
      !r && o && (r = o(e, n));
    }),
    r)
  ) {
    let i = r;
    return { kind: 'unjustified', atoms: t, title: i.title, message: i.message };
  }
  if (
    e.model.aim === 'factor' &&
    n.dis.length === 1 &&
    n.dis[0].sides.length === 2 &&
    n.dis[0].sides.some((i) => _m(i, e.K).length >= 2)
  )
    return {
      kind: 'unjustified',
      atoms: t,
      title: 'D\u2019o\xF9 vient ce produit ?',
      message:
        'Factoriser de t\xEAte, c\u2019est risqu\xE9. ' +
        (e.model.factorHint ||
          'Montre d\u2019abord le facteur commun, en \xE9crivant ' +
            e.model.goal[0] +
            ' = (facteur commun)(\u2026).') +
        ' Ensuite, je valide chaque transformation.',
    };
  if (n.dis.length === 1) {
    let i = vx(e, bx(e));
    for (let o = 0; o < i.length; o++)
      if (fu(n.dis[0], i[o].line.dis[0], e.K, !0)) {
        let a = i[o].def;
        return {
          kind: 'unjustified',
          atoms: t,
          title: 'Tu vas trop vite',
          message:
            'Montre d\u2019abord o\xF9 tu remplaces ' +
            a.s +
            ' par ' +
            z(a.expr) +
            ', sur une ligne \xE0 part. Ensuite seulement, d\xE9veloppe et r\xE9duis.',
        };
      }
  }
  let s = kx(n, e, !1);
  return {
    kind: 'unjustified',
    atoms: t,
    title: s ? 'D\u2019o\xF9 vient cette valeur ?' : 'D\u2019o\xF9 \xE7a vient ?',
    message: s
      ? '\xC9cris d\u2019abord le raisonnement qui m\xE8ne \xE0 cette valeur : je valide chaque ligne qui d\xE9coule des pr\xE9c\xE9dentes.'
      : 'Je ne trouve aucune de tes lignes, ni aucun outil, qui permette d\u2019\xE9crire \xE7a maintenant. Repars de ce que tu sais d\xE9j\xE0.',
  };
}
function WJ(e, n, t) {
  let r = n.dis[0].sides,
    s = aJ(e),
    i = [],
    o = [];
  for (let c = 1; c < r.length; c++) {
    let f = Lm(r[0], r[c]),
      d = ne(zr(f));
    if (!mx(f, e)) {
      let g = DP(s, f, f, t, -1);
      return (
        g.kind === 'unjustified' &&
          (g.message =
            '\xC0 partir de \xAB ' + z(r[c]) + ' \xBB, ta cha\xEEne ne tient plus. ' + g.message),
        g
      );
    }
    let m = jP(s, f);
    if (!m) {
      if (!ps(f, s.K)) {
        (i.push(f), lf(s, f, 'line'));
        continue;
      }
      let g = AT(s, f, t);
      return (
        (g.message =
          'Le maillon \xAB ' +
          Ke(f) +
          ' \xBB ne d\xE9coule pas de ce qui pr\xE9c\xE8de. ' +
          g.message),
        g
      );
    }
    let p = FP(s, f, f, d, m);
    (p.kind === 'step' && o.push(p), i.push(f), lf(s, f, 'line'), p.hyp && (s.stated.hyp = !0));
  }
  if (!o.length)
    return {
      kind: 'useless',
      atoms: t,
      line: n,
      links: i,
      title: 'Juste, mais \xE7a ne t\u2019avance pas',
      message: 'Chaque maillon est juste, mais tu avais d\xE9j\xE0 tout \xE7a.',
    };
  let a = o.reduce((c, f) => (f.rule.hora > c.rule.hora ? f : c)),
    l = [];
  o.forEach((c) => {
    l.indexOf(c.rule.label) < 0 && l.push(c.rule.label);
  });
  let u = o[o.length - 1];
  return {
    kind: 'step',
    atoms: t,
    line: n,
    links: i,
    final: !!u.final,
    hyp: o.some((c) => c.hyp),
    hora: o.reduce((c, f) => c + (f.hora || 0), 0),
    rule: Object.assign({}, a.rule, {
      label: l.join(' \u2192 '),
      why: o.map((c) => c.rule.why).join(' '),
    }),
  };
}
function JJ(e, n) {
  if (e.kern) {
    (HL(e.kern, n), n.line && e.facts.push({ line: n.line, atoms: n.atoms, source: 'line' }));
    return;
  }
  if (e.kgeo) {
    (SN(e.kgeo, n), n.line && e.facts.push({ line: n.line, atoms: n.atoms, source: 'line' }));
    return;
  }
  if (e.krec) {
    (QN(e.krec, n), n.line && e.facts.push({ line: n.line, atoms: n.atoms, source: 'line' }));
    return;
  }
  if (e.kprog) {
    (i_(e.kprog, n), n.line && e.facts.push({ line: n.line, atoms: n.atoms, source: 'line' }));
    return;
  }
  if (e.kmat) {
    (XN(e.kmat, n), n.line && e.facts.push({ line: n.line, atoms: n.atoms, source: 'line' }));
    return;
  }
  if (e.karith) {
    (b2(e.karith, n), n.line && e.facts.push({ line: n.line, atoms: n.atoms, source: 'line' }));
    return;
  }
  if (e.klim) {
    (Hp(e.klim, n), n.line && e.facts.push({ line: n.line, atoms: n.atoms, source: 'line' }));
    return;
  }
  if (e.kint) {
    (Ek(e.kint, n), n.line && e.facts.push({ line: n.line, atoms: n.atoms, source: 'line' }));
    return;
  }
  if (e.kode) {
    (oO(e.kode, n), n.line && e.facts.push({ line: n.line, atoms: n.atoms, source: 'line' }));
    return;
  }
  if (e.kpart) {
    (hO(e.kpart, n), n.line && e.facts.push({ line: n.line, atoms: n.atoms, source: 'line' }));
    return;
  }
  if (e.kriem) {
    (FO(e.kriem, n), n.line && e.facts.push({ line: n.line, atoms: n.atoms, source: 'line' }));
    return;
  }
  if (e.klc) {
    (FS(e.klc, n), n.line && e.facts.push({ line: n.line, atoms: n.atoms, source: 'line' }));
    return;
  }
  if (e.kclaims) {
    (wM(e.kclaims, n), n.line && e.facts.push({ line: n.line, atoms: n.atoms, source: 'line' }));
    return;
  }
  if (e.kvar) {
    (EK(e.kvar, n), n.line && e.facts.push({ line: n.line, atoms: n.atoms, source: 'line' }));
    return;
  }
  if (e.ktab) {
    QK(e.ktab, n);
    return;
  }
  if (e.kfor) {
    (qE(e.kfor, n), n.line && e.facts.push({ line: n.line, atoms: n.atoms, source: 'line' }));
    return;
  }
  if (e.kana) {
    (Yg(e.kana, n), n.line && e.facts.push({ line: n.line, atoms: n.atoms, source: 'line' }));
    return;
  }
  if (e.cong) {
    let s = n.line || Ae(n.atoms);
    (bf(e.cong, s.dis[0], 'line'), e.facts.push({ line: s, atoms: ne(zr(s)), source: 'line' }));
    return;
  }
  if (e.cplx) {
    let s = n.line || Ae(n.atoms);
    (Hx(e.cplx, s), e.facts.push({ line: s, atoms: ne(zr(s)), source: 'line' }));
    return;
  }
  if (e.bnd) {
    (UK(e.bnd, n), e.facts.push({ line: n.line, atoms: n.atoms, source: 'line' }));
    return;
  }
  if (e.geo) {
    let s = n.line;
    (n.kind === 'step' && FR(e.geo, s), e.facts.push({ line: s, atoms: n.atoms, source: 'line' }));
    return;
  }
  if (e.units) {
    let s = n.line;
    (nP(e.units, s), e.facts.push({ line: s, atoms: n.atoms, source: 'line' }));
    return;
  }
  let t = n.links || [n.line || Ae(n.atoms)],
    r = t.length === 1 && t[0].dis.length === 1 ? t[0].dis[0] : null;
  if (r && r.cmp) {
    ((e.stated = { ...e.stated, checks: [...(e.stated.checks ?? []), yx(r)] }), (e._cache = null));
    return;
  }
  (t.forEach((s) => lf(e, s, 'line', { obligation: !!(n.rule && n.rule.obligation) })),
    n.hyp && (e.stated.hyp = !0),
    n.verif && (e.stated.verif = !0));
}
function jT(e) {
  return e.dis.every(
    (n) =>
      n.sides.length === 2 &&
      [0, 1].some((t) => n.sides[t].k === 's' && OT(n.sides[1 - t]) !== null),
  );
}
function uu(e) {
  if (!e.c) return e;
  let n = e.c.filter((o) => o.k === 'n'),
    t = e.c.filter((o) => o.k !== 'n');
  if (n.length < 2 && !(e.k === 'mul' && n.length === 1 && n[0].v === 1 && t.length)) return e;
  let r = e.k === 'add' ? n.reduce((o, a) => o + a.v, 0) : n.reduce((o, a) => o * a.v, 1),
    s = e.k === 'add' ? 0 : 1,
    i = Ce(r, s) && t.length ? t : e.k === 'mul' ? [X(r)].concat(t) : t.concat([X(r)]);
  return V(e.k, i);
}
function $n(e) {
  return e.k === 'n' && e.v < 0
    ? { neg: !0, t: X(-e.v) }
    : e.k === 'neg'
      ? { neg: !0, t: e.a }
      : { neg: !1, t: e };
}
function qT(e, n, t) {
  let r = $n(n),
    s = $n(t),
    i;
  return (
    !e.length && De(r.t, {}) && Ne(r.t) === Ne(s.t)
      ? (i = tn('sq', r.t))
      : !e.length && De(r.t, {}) && De(s.t, {}) && (r.t.k === 'mul' || s.t.k === 'mul')
        ? (i = { k: 'mul', c: [r.t, s.t] })
        : (i = V('mul', e.concat([r.t, s.t]))),
    r.neg !== s.neg ? qe(i) : i
  );
}
function CT(e, n) {
  return n.k === 'mul' && De(n, {})
    ? { k: 'mul', c: e.concat([n]) }
    : n.k === 'n' && e.every((t) => t.k === 'n')
      ? { k: 'mul', c: e.concat([n]) }
      : n.k === 'n' && n.v > 0 && e.every((t) => t.k === 's')
        ? { k: 'mul', c: [n].concat(e) }
        : e.some((t) => t.k === 'n' && t.v < 0)
          ? { k: 'mul', c: e.concat([n]) }
          : uu(V('mul', e.concat([n])));
}
function BP(e, n) {
  if (e.sides.length !== 2 || !e.sides.some((s) => De(s, n)) || !e.sides.some((s) => s.k === 'add'))
    return null;
  let t = [];
  if (
    (e.sides.forEach((s) =>
      (s.k === 'add' ? s.c : [s]).forEach((i) => {
        let o = $n(i).t;
        o.k === 'div' &&
          o.b.k === 'n' &&
          Number.isInteger(o.b.v) &&
          o.b.v >= 2 &&
          De(o.a, n) &&
          t.push(o.b.v);
      }),
    ),
    !t.length)
  )
    return null;
  let r = t.reduce((s, i) => (s * i) / Cm(s, i), 1);
  return r <= 1e3 ? r : null;
}
function bP(e, n) {
  let t = $n(e),
    r = t.t,
    s;
  if (r.k === 'div' && r.b.k === 'n' && Number.isInteger(r.b.v) && n % r.b.v === 0) {
    let i = n / r.b.v,
      o = r.a;
    s = i === 1 ? o : uu(V('mul', [X(i)].concat(o.k === 'mul' ? o.c : [o])));
  } else s = uu(V('mul', [X(n)].concat(r.k === 'mul' ? r.c : [r])));
  return t.neg ? qe(s) : s;
}
function zP(e, n) {
  return e.k === 'add'
    ? V(
        'add',
        e.c.map((t) => bP(t, n)),
      )
    : bP(e, n);
}
function Cm(e, n) {
  return n ? Cm(n, e % n) : e;
}
function fh(e, n) {
  if (e.k === 'n') return { c: e.v, pw: {} };
  if (e.k === 's') return n[e.n] !== void 0 ? { c: n[e.n], pw: {} } : { c: 1, pw: { [e.n]: 1 } };
  if (e.k === 'neg') {
    let t = fh(e.a, n);
    return t ? { c: -t.c, pw: t.pw } : null;
  }
  if (e.k === 'sq') {
    let t = fh(e.a, n);
    if (!t) return null;
    let r = {};
    return (Object.keys(t.pw).forEach((s) => (r[s] = 2 * t.pw[s])), { c: t.c * t.c, pw: r });
  }
  if (e.k === 'mul') {
    let t = 1,
      r = {};
    for (let s = 0; s < e.c.length; s++) {
      let i = fh(e.c[s], n);
      if (!i) return null;
      ((t *= i.c), Object.keys(i.pw).forEach((o) => (r[o] = (r[o] || 0) + i.pw[o])));
    }
    return { c: t, pw: r };
  }
  return null;
}
function vP(e, n, t) {
  let r = [],
    s = Math.abs(e);
  (t.forEach((o) => {
    let a = n[o] || 0;
    (a === 1 && r.push({ k: 's', n: o }), a === 2 && r.push(tn('sq', { k: 's', n: o })));
  }),
    (s !== 1 || !r.length) && r.unshift(X(s)));
  let i = r.length === 1 ? r[0] : V('mul', r);
  return e < 0 ? qe(i) : i;
}
function kP(e, n) {
  if (e.k !== 'add' || e.c.length < 2) return null;
  let t = Object.keys(Fe(e)).filter((c) => n[c] === void 0);
  if (!t.length) return null;
  let r = e.c.map((c) => fh(c, n));
  if (r.some((c) => !c || !Number.isInteger(c.c) || c.c === 0)) return null;
  let s = r;
  if (s.some((c) => Object.values(c.pw).some((f) => f > 2))) return null;
  let i = s.reduce((c, f) => Cm(c, Math.abs(f.c)), 0),
    o = {};
  if (
    (t.forEach((c) => {
      let f = Math.min(...s.map((d) => d.pw[c] || 0));
      f && (o[c] = f);
    }),
    i === 1 && !Object.keys(o).length)
  )
    return null;
  let a = vP(i, o, t),
    l = s.map((c) => {
      let f = {};
      return (t.forEach((d) => (f[d] = (c.pw[d] || 0) - (o[d] || 0))), vP(c.c / i, f, t));
    }),
    u = l.map((c) => {
      let f = $n(c),
        d = { k: 'mul', c: (a.k === 'mul' ? a.c : [a]).concat(f.t.k === 'mul' ? f.t.c : [f.t]) };
      return f.neg ? qe(d) : d;
    });
  return { k: a, rest: l, shown: u };
}
function dh(e, n) {
  if (e.k === 'n') return { c: e.v, d: 0 };
  if (e.k === 's') return e.n === n ? { c: 1, d: 1 } : null;
  if (e.k === 'sq') {
    let t = dh(e.a, n);
    return t ? { c: t.c * t.c, d: 2 * t.d } : null;
  }
  if (e.k === 'neg') {
    let t = dh(e.a, n);
    return t ? { c: -t.c, d: t.d } : null;
  }
  if (e.k === 'mul') {
    let t = 1,
      r = 0;
    for (let s = 0; s < e.c.length; s++) {
      let i = dh(e.c[s], n);
      if (!i) return null;
      ((t *= i.c), (r += i.d));
    }
    return { c: t, d: r };
  }
  return null;
}
function QT(e, n, t) {
  if (Math.abs(e) < 1e-12) return X(0);
  if (e < 0) {
    let s = QT(-e, n, t);
    return s ? qe(s) : null;
  }
  if (n > 2) return null;
  let r = n === 0 ? null : n === 1 ? pf(t) : tn('sq', pf(t));
  return r
    ? Ce(e, 1)
      ? r
      : V('mul', [X(Math.round(e * 1e9) / 1e9), r])
    : X(Math.round(e * 1e9) / 1e9);
}
function UP(e, n) {
  let t = Object.keys(Fe(e)).filter((r) => n[r] === void 0);
  return t.length === 1 ? t[0] : null;
}
function GP(e, n) {
  let t = Ei(e, (i) => GP(i, n));
  if (t.k !== 'add') return t;
  let r = !1,
    s = [];
  return (
    t.c.forEach((i) => {
      i.k === 'neg' && i.a.k === 'add'
        ? ((r = !0), i.a.c.forEach((o) => s.push(qe(o))))
        : s.push(i);
    }),
    r && n.push(1),
    r ? V('add', s) : t
  );
}
function ZP(e, n, t) {
  let r = UP(e, t || {});
  if (!r) return e;
  function s(a) {
    let l = dh(a, r);
    if (!l) return a;
    let u = QT(l.c, l.d, r);
    return !u || Ne(u) === Ne(a) ? a : (n.push(1), u);
  }
  function i(a) {
    let l = Ei(a, i);
    return l.k === 'add' ? V('add', l.c.map(s)) : l;
  }
  let o = i(e);
  return o.k === 'mul' || o.k === 'neg' ? s(o) : o;
}
function bh(e, n, t) {
  let r = Ei(e, (a) => bh(a, n, t));
  if (r.k !== 'add') return r;
  let s = UP(r, t || {});
  if (!s) return r;
  let i = {};
  for (let a = 0; a < r.c.length; a++) {
    let l = dh(r.c[a], s);
    if (!l || l.d > 2) return r;
    i[l.d] = (i[l.d] || 0) + l.c;
  }
  let o = Object.keys(i)
    .map(Number)
    .filter((a) => Math.abs(i[a]) > 1e-12)
    .sort((a, l) => l - a);
  return o.length >= r.c.length
    ? r
    : (n.push(1),
      o.length
        ? V(
            'add',
            o.map((a) => QT(i[a], a, s)),
          )
        : X(0));
}
function HP(e) {
  if (e.k === 'sq' && e.a.k === 'add' && e.a.c.length === 2) {
    let [n, t] = e.a.c,
      r = $n(n),
      s = $n(t),
      i = uu(V('mul', [X(2), r.t, s.t]));
    return V('add', [tn('sq', r.t), r.neg !== s.neg ? qe(i) : i, tn('sq', s.t)]);
  }
  if (e.k === 'mul') {
    let n = [];
    if (
      (e.c.forEach((r, s) => {
        r.k === 'add' && n.push(s);
      }),
      n.length >= 2)
    ) {
      let r = e.c.filter((i, o) => o !== n[0] && o !== n[1]),
        s = [];
      return (
        e.c[n[0]].c.forEach((i) => e.c[n[1]].c.forEach((o) => s.push(qT(r, i, o)))),
        V('add', s)
      );
    }
    let t = -1;
    if (
      (e.c.forEach((r, s) => {
        t < 0 && r.k === 'add' && (t = s);
      }),
      t >= 0)
    ) {
      let r = e.c.filter((o, a) => a !== t),
        s = !1,
        i = $n(r[0]);
      return (
        i.neg && ((s = !0), (r = [i.t].concat(r.slice(1)))),
        V(
          'add',
          e.c[t].c.map((o) => {
            if (!s) return o.k === 'neg' ? qe(CT(r, o.a)) : CT(r, o);
            let a = $n(o),
              l = CT(r, a.t);
            return a.neg ? l : qe(l);
          }),
        )
      );
    }
  }
  return e.k === 'neg' && e.a.k === 'add'
    ? V(
        'add',
        e.a.c.map((n) => {
          let t = $n(n);
          return t.neg ? t.t : qe(t.t);
        }),
      )
    : e;
}
function WP(e, n, t = 0) {
  if (n.done) return e;
  let r = e.k === 'neg' && t > 0 ? e : HP(e);
  return r !== e
    ? ((n.done = !0),
      e.k === 'sq' && (n.square = $n(e.a.c[1]).neg !== $n(e.a.c[0]).neg ? 'minus' : 'plus'),
      r)
    : Ei(e, (s) => WP(s, n, t + 1));
}
function FT(e, n) {
  let t = Ei(e, (s) => FT(s, n));
  if (t.k !== 'mul') return t;
  let r = t.c;
  for (let s = 0; s < r.length; s++)
    if (r[s].k === 'n') {
      for (let i = 0; i < r.length; i++)
        if (r[i].k === 'pow' && r[i].a.k === 'n' && r[i].a.v === r[s].v) {
          n.push(1);
          let o = r.filter((l, u) => u !== s && u !== i),
            a = Ci(r[i].a, uu(V('add', [r[i].b, X(1)])));
          return o.length ? V('mul', o.concat([a])) : a;
        }
    }
  return t;
}
function au(e) {
  if (e.k === 'n') {
    let n = e.v;
    for (let t = 1; t <= 1e4; t *= 10) {
      let r = Math.round(n * t);
      if (Math.abs(r / t - n) < 1e-12) return [r, t];
    }
    return null;
  }
  if (e.k === 'div' && e.a.k === 'n' && e.b.k === 'n') {
    let n = au(e.a),
      t = au(e.b);
    return !n || !t || t[0] === 0 ? null : [n[0] * t[1], n[1] * t[0]];
  }
  if (e.k === 'neg') {
    let n = au(e.a);
    return n ? [-n[0], n[1]] : null;
  }
  return null;
}
function LT(e, n) {
  let t = Cm(Math.abs(e), Math.abs(n)) * (n < 0 ? -1 : 1),
    [r, s] = [e / t, n / t];
  return s === 1 || Yt(r / s) ? X(r / s) : ms(X(r), X(s));
}
function xP(e, n = !1) {
  if ((e.k !== 'add' && e.k !== 'mul') || !e.c.some((i) => i.k === 'div' || (n && NT(i))))
    return null;
  let t = e.c.map(au);
  if (t.some((i) => i === null || Math.abs(i[1]) > 1e6)) return null;
  let r = e.k === 'add' ? 0 : 1,
    s = 1;
  return (
    t.forEach(([i, o]) => {
      e.k === 'add' ? ((r = r * o + i * s), (s = s * o)) : ((r *= i), (s *= o));
    }),
    s === 0 ? null : LT(r, s)
  );
}
function uf(e, n, t) {
  if (e.k === 'n' || e.k === 's') return e;
  if (e.k === 'div' && e.a.k === 'n' && e.a.v === 0 && pt(e.b, n) && H(e.b, n) !== 0)
    return (t.push(e), X(0));
  if (
    e.k === 'mul' &&
    e.c.some((o) => o.k === 'sqrt') &&
    e.c.every((o) => o.k === 'sqrt' || o.k === 'n') &&
    pt(e, n) &&
    Yt(H(e, n))
  )
    return (t.push(e), X(Math.round(H(e, n) * 1e6) / 1e6));
  if (
    (e.k === 'pow' || e.k === 'sq') &&
    (e.a.k === 'sqrt' ||
      (e.k === 'pow' && e.b.k === 'div' && e.a.k === 'n') ||
      (e.a.k === 'mul' &&
        e.a.c.some((o) => o.k === 'sqrt') &&
        e.a.c.every((o) => o.k === 'sqrt' || o.k === 'n'))) &&
    pt(e, n)
  ) {
    let o = H(e, n);
    if (Yt(o)) return (t.push(e), X(Math.round(o * 1e6) / 1e6));
  }
  if (e.k === 'div' && e.b.k === 'n' && e.b.v !== 0 && De(e.a, n)) {
    let o = e.a.k === 'mul' ? e.a.c : [e.a],
      a = o.filter((u) => u.k === 'n'),
      l = o.filter((u) => u.k !== 'n');
    if (a.length === 1 && l.length && l.every((u) => u.k === 's')) {
      let u = a[0].v / e.b.v;
      if (Yt(u)) return (t.push(e), Ce(u, 1) ? V('mul', l) : V('mul', [X(u)].concat(l)));
    }
  }
  if (_x(e) && pt(e, n)) {
    let o = H(e, n);
    if (Yt(o)) return (t.push(e), X(o));
  }
  let r = Cn(e);
  if (pt(e, n) && r.every((o) => o.k === 'n')) {
    let o = H(e, n);
    if (e.k === 'div' && !Yt(o)) {
      let a = e.a.v,
        l = e.b.v;
      if (Number.isInteger(a) && Number.isInteger(l) && l !== 0) {
        let u = Cm(Math.abs(a), Math.abs(l)) * (l < 0 ? -1 : 1);
        if (u !== 1) return (t.push(e), ms(X(a / u), X(l / u)));
      } else if (l !== 0) {
        let u = $h(o);
        if (u) return (t.push(e), u[0] < 0 ? qe(ms(X(-u[0]), X(u[1]))) : ms(X(u[0]), X(u[1])));
      }
      return e;
    }
    if (!Yt(o)) {
      let a = yP(e);
      return a && !(a.k === e.k && z(a) === z(e)) ? (t.push(e), a) : e;
    }
    return (t.push(e), X(o));
  }
  if (e.c) {
    let o = t.length,
      a = e.c.map((f) => uf(f, n, t)),
      l = xP({ k: e.k, c: a });
    if (l && pt(e, n)) return (t.push(e), l);
    let u = a.filter((f) => f.k === 'n'),
      c = a.filter((f) => f.k !== 'n');
    if (u.length >= 2 && c.length && Yt(Mm(e.k, u, n))) {
      t.push(V(e.k, u));
      let f = Mm(e.k, u, n);
      a = Ce(f, e.k === 'add' ? 0 : 1) ? c : e.k === 'mul' ? [X(f)].concat(c) : c.concat([X(f)]);
    } else if (pt(e, n) && t.length === o) {
      let f = xP({ k: e.k, c: a }, !0);
      if (f) return (t.push(e), f);
    }
    return V(e.k, a);
  }
  let s = Ei(e, (o) => uf(o, n, t)),
    i = yP(s);
  return i && pt(e, n) ? (t.push(e), i) : s;
}
function yP(e) {
  if (e.k === 'div') {
    if (e.a.k !== 'div' && e.b.k !== 'div' && !NT(e.a) && !NT(e.b)) return null;
    let n = au(e.a),
      t = au(e.b);
    if (!n || !t || t[0] === 0 || (Yt(n[0] / n[1]) && Yt(t[0] / t[1]))) return null;
    let [r, s] = [n[0] * t[1], n[1] * t[0]];
    return Math.abs(r) > 1e9 || Math.abs(s) > 1e9 ? null : LT(r, s);
  }
  if (e.k === 'pow' || e.k === 'sq') {
    let n = au(e.a),
      t = e.k === 'sq' ? [2, 1] : au(e.b);
    if (!n || !t || t[1] !== 1 || !Number.isInteger(t[0]) || Math.abs(t[0]) > 30 || t[0] >= 0)
      return null;
    let r = Math.abs(t[0]),
      [s, i] = [n[0] ** r, n[1] ** r];
    return (
      t[0] < 0 && ([s, i] = [i, s]),
      (i !== 0 && Yt(s / i)) || i === 0 || Math.abs(s) > 1e9 || Math.abs(i) > 1e9 ? null : LT(s, i)
    );
  }
  return null;
}
function NT(e) {
  return e.k === 'neg' && e.a.k === 'div';
}
function af(e, n) {
  return Ke({ dis: [e] }) === Ke({ dis: [n] });
}
function wP(e, n, t, r = !1) {
  let s = n.K;
  if (e.sides.length !== 2) return null;
  let i = (P) => P.k === 's',
    o = [],
    a = uJ(n),
    l = e.sides.every(i),
    u = e.sides.map((P, ee) => {
      if (i(P)) {
        let xe = e.sides[1 - ee],
          le = n.model.goal;
        if (
          !(
            l &&
            ((s[P.n] !== void 0 && s[xe.n] === void 0) || (le.includes(xe.n) && !le.includes(P.n)))
          )
        )
          return P;
      }
      let Mn = gf(P, s, !1, a);
      return (
        Object.keys(Fe(P)).forEach((xe) => {
          s[xe] !== void 0 && o.indexOf(xe) < 0 && !Fe(Mn)[xe] && o.push(xe);
        }),
        Mn
      );
    });
  if (o.length && !af({ sides: u }, e))
    return {
      eq: { sides: u },
      kind: 'subst',
      label: 'Remplacer',
      text:
        'Remplace ' + o.join(' et ') + ' par ' + (o.length > 1 ? 'leurs valeurs.' : 'sa valeur.'),
      why:
        'On remplace ' +
        o.join(' et ') +
        ' par ' +
        (o.length > 1 ? 'leurs valeurs.' : 'sa valeur.'),
    };
  for (let P = (t || []).length - 1; P >= 0; P--) {
    let ee = t[P],
      Mn = !1,
      xe = e.sides.map((Pn) => (i(Pn) || !Fe(Pn)[ee.s] ? Pn : ((Mn = !0), Nm(Pn, ee.s, ee.expr))));
    if (!Mn) {
      let Pn = e.sides.findIndex((To) => i(To) && To.n === ee.s),
        Jt = Pn >= 0 ? e.sides[1 - Pn] : null;
      Jt &&
        De(Jt, s) &&
        !Fe(Jt)[ee.s] &&
        ((Mn = !0), (xe = Pn === 0 ? [ee.expr, Jt] : [Jt, ee.expr]));
    }
    let le = Object.keys(Fe({ k: 'add', c: xe })).filter((Pn) => s[Pn] === void 0),
      Xn =
        Mn &&
        le.length > 0 &&
        [1.37, 2.9, 0.53].every((Pn, Jt) => {
          let To = Object.assign({}, s);
          le.forEach((XP, YP) => (To[XP] = Pn + YP * 0.71 + Jt * 0.13));
          let wx = H(xe[0], To),
            JP = H(xe[1], To);
          return isFinite(wx) && Math.abs(wx - JP) <= 1e-9 * Math.max(1, Math.abs(wx));
        });
    if (Mn && !Xn)
      return {
        eq: { sides: xe },
        kind: 'subst',
        label: ee.source === 'hyp' ? 'Utiliser l\u2019hypoth\xE8se' : 'Remplacer',
        text:
          ee.source === 'hyp'
            ? 'Utilise l\u2019hypoth\xE8se de r\xE9currence : remplace ' +
              ee.s +
              ' par ' +
              z(ee.expr) +
              '.'
            : 'Remplace ' + ee.s + ' par ' + z(ee.expr) + '.',
        why:
          'On remplace ' +
          ee.s +
          ' par ' +
          z(ee.expr) +
          (ee.source === 'hyp' ? ' : c\u2019est l\u2019hypoth\xE8se de r\xE9currence.' : '.'),
      };
  }
  let c = [],
    f = e.sides.map((P) => GP(P, c));
  if (c.length && !af({ sides: f }, e))
    return {
      eq: { sides: f },
      kind: 'unparen',
      label: 'Supprimer les parenth\xE8ses',
      text: 'Supprime les parenth\xE8ses : un \xAB \u2212 \xBB devant change le signe de chaque terme.',
      why: 'Un \xAB \u2212 \xBB devant une parenth\xE8se change le signe de chaque terme.',
    };
  let d = mh(e, s);
  if (d && d.length > 1)
    return {
      line: { dis: d.map((P) => ({ sides: [P, X(0)] })) },
      kind: 'rule',
      label: 'Produit nul',
      text: 'Un produit est nul quand l\u2019un de ses facteurs est nul : \xE9cris \xAB facteur = 0 ou facteur = 0 \xBB.',
      why: 'Un produit est nul si et seulement si l\u2019un de ses facteurs est nul.',
    };
  let m = [],
    p = e.sides.map((P) => ZP(P, m, s));
  if (m.length && !af({ sides: p }, e))
    return {
      eq: { sides: p },
      kind: 'mono',
      label: 'Calculer',
      text: 'Calcule chaque produit.',
      why: 'On calcule chaque produit.',
    };
  let g = [],
    h = e.sides.map((P) => bh(P, g, s));
  if (g.length && !af({ sides: h }, e))
    return {
      eq: { sides: h },
      kind: 'collect',
      label: 'R\xE9duire',
      text: 'Regroupe les termes semblables : les x\xB2 ensemble, les x ensemble, les nombres ensemble.',
      why: 'On regroupe les termes semblables.',
    };
  let b = [],
    v = [],
    k = !1,
    y = e.sides.map((P) => {
      let ee = b.length + v.length,
        Mn = FT(uf(P, s, b), v);
      return (b.length + v.length > ee && De(P, s) && (k = !0), Mn);
    });
  if ((b.length || v.length) && !af({ sides: y }, e))
    return {
      eq: { sides: y },
      kind: 'calc',
      label: v.length || k ? 'R\xE9duire' : 'Calculer',
      text:
        v.length || k
          ? 'R\xE9duis : regroupe les nombres et les puissances de m\xEAme base.'
          : 'Calcule ' + b.slice(0, 2).map(z).join(' et ') + '.',
      why: v.length
        ? 'On regroupe les nombres, et 2 \xD7 2\u207F = 2\u207F\u207A\xB9 : multiplier par 2 ajoute 1 \xE0 l\u2019exposant.'
        : k
          ? 'On regroupe les nombres.'
          : 'On calcule ' + b.slice(0, 2).map(z).join(' et ') + '.',
    };
  let S = mh(e, s);
  if (S)
    return {
      line: { dis: S.map((P) => ({ sides: [P, X(0)] })) },
      kind: 'rule',
      label: S.length === 1 ? 'Carr\xE9 nul' : 'Produit nul',
      text: 'Un produit est nul quand l\u2019un de ses facteurs est nul : \xE9cris \xAB facteur = 0 ou facteur = 0 \xBB.',
      why: 'Un produit est nul si et seulement si l\u2019un de ses facteurs est nul.',
    };
  let w = (n.model.preds ?? []).some(
      (P) =>
        P.skill === 'differenceCarres' || P.skill === 'produitNul' || P.skill === 'secondDegre',
    ),
    _ = w ? [] : MP(e, n);
  if (_.length) {
    let P = _[0].dis[0].sides[0],
      ee = P.k === 's' ? P.n + '\xB2' : 'ce carr\xE9';
    return {
      line: _[0],
      kind: 'racine',
      label: 'Racine carr\xE9e',
      text:
        'Tu connais ' +
        ee +
        '. \xC9cris ses deux valeurs possibles : la racine carr\xE9e et son oppos\xE9.',
      why: 'Un carr\xE9 \xE9gal \xE0 un nombre positif : ce qui est au carr\xE9 vaut sa racine carr\xE9e ou son oppos\xE9.',
    };
  }
  let O = (n.model.preds ?? []).some(
      (P) =>
        P.skill === 'facteurCommun' || P.skill === 'differenceCarres' || P.skill === 'carreParfait',
    ),
    G = (P) => P.k === 'n' && P.v === 0,
    Se = O && !n.model.aim && !e.sides.some((P, ee) => P.k === 's' && !Fe(e.sides[1 - ee])[P.n]);
  if (Se && e.sides.length === 2 && !e.sides.some(G) && e.sides.every((P) => De(P, s))) {
    let P = $a(e, s).find(
      (ee) => ee.kind === 'transpo' && ee.eq.sides.length === 2 && G(ee.eq.sides[1]),
    );
    if (P)
      return {
        eq: { sides: P.eq.sides.map(Ra) },
        kind: 'isolate',
        label: 'Tout passer du m\xEAme c\xF4t\xE9',
        text: 'Pour factoriser, passe tous les termes du m\xEAme c\xF4t\xE9 : \xAB \u2026 = 0 \xBB.',
        why: 'On se ram\xE8ne \xE0 \xAB \u2026 = 0 \xBB pour pouvoir factoriser puis utiliser le produit nul.',
      };
  }
  if (!n.model.aim && !Se && !w) {
    let P = XJ(e, s);
    if (P)
      return {
        eq: P,
        kind: 'isolate',
        label: 'M\xEAme op\xE9ration des deux c\xF4t\xE9s',
        text: 'Isole le carr\xE9 : passe les nombres de l\u2019autre c\xF4t\xE9.',
        why: 'On isole le carr\xE9 pour pouvoir prendre la racine carr\xE9e.',
      };
  }
  if (n.model.aim !== 'factor' && !Se) {
    let P = {},
      ee = e.sides.map((Mn) => WP(Mn, P));
    if (P.done && P.square) {
      let Mn =
        P.square === 'minus'
          ? '(a \u2212 b)\xB2 = a\xB2 \u2212 2ab + b\xB2'
          : '(a + b)\xB2 = a\xB2 + 2ab + b\xB2';
      return {
        eq: { sides: ee },
        kind: 'expand',
        label: P.square === 'minus' ? 'Identit\xE9 (a \u2212 b)\xB2' : 'Identit\xE9 (a + b)\xB2',
        text: 'D\xE9veloppe le carr\xE9 avec l\u2019identit\xE9 ' + Mn + '.',
        why: 'On d\xE9veloppe avec l\u2019identit\xE9 remarquable ' + Mn + '.',
      };
    }
    if (P.done)
      return {
        eq: { sides: ee },
        kind: 'expand',
        label: 'D\xE9velopper',
        text: 'D\xE9veloppe : chaque terme d\u2019une parenth\xE8se multiplie chaque terme de l\u2019autre.',
        why: 'On d\xE9veloppe : chaque terme d\u2019une parenth\xE8se multiplie chaque terme de l\u2019autre.',
      };
  }
  let U = EP(e, n);
  if (U.length)
    return {
      eq: U[0],
      kind: 'racine',
      label: 'Racine carr\xE9e',
      text: 'Tu connais ' + U[0].sides[0].n + '\xB2. Prends la racine carr\xE9e.',
      why: U[0].sides[0].n + ' est une longueur, donc positive : on prend la racine carr\xE9e.',
    };
  let ae = BP(e, s);
  if (
    ae &&
    !r &&
    !n.model.aim &&
    !e.sides.some((P, ee) => P.k === 's' && !Fe(e.sides[1 - ee])[P.n])
  ) {
    let P = { sides: e.sides.map((ee) => zP(ee, ae)) };
    if (!af(P, e))
      return {
        eq: P,
        kind: 'isolate',
        label: 'Chasser les d\xE9nominateurs',
        text: 'Multiplie chaque terme des deux membres par ' + ae + ', le d\xE9nominateur commun.',
        why: 'On multiplie les deux membres par ' + ae + ' : les fractions disparaissent.',
      };
  }
  if (!jT({ dis: [e] })) {
    let P = null;
    $a(e, s)
      .filter((xe) => xe.kind === 'transpo')
      .forEach((xe) => {
        let le = { sides: xe.eq.sides.map(Ra) },
          Xn = xe.desc;
        xe.unknownMove &&
          ((le = { sides: le.sides.map((Jt) => Ra(bh(Jt, [], s))) }),
          (Xn = Xn.replace(/\.$/, ', puis regroupe les x.')));
        let Pn = gs(le, s);
        (xe.unknownMove &&
          $a(le, s)
            .filter((Jt) => Jt.kind === 'transpo' && !Jt.unknownMove)
            .forEach((Jt) => (Pn = Math.min(Pn, gs({ sides: Jt.eq.sides.map(Ra) }, s) + 1))),
          (!P || Pn < P.m) && (P = { eq: le, m: Pn, desc: Xn, moved: xe.unknownMove }));
      });
    let ee = P,
      Mn = (xe) => Object.keys(Fe({ k: 'add', c: xe.sides })).filter((le) => s[le] === void 0);
    if ((!ee || ee.m >= gs(e, s)) && Mn(e).length === 2 && !e.sides.some(i)) {
      let xe = $a(e, s)
        .filter((le) => le.kind === 'transpo')
        .map((le) => ({ sides: le.eq.sides.map(Ra) }))
        .filter((le) => le.sides.some((Xn) => i(Xn) && s[Xn.n] === void 0));
      if (
        (xe.length && (ee = { eq: xe[0], m: gs(xe[0], s), desc: 'Isole une inconnue.' }),
        ee && xe.length)
      )
        return {
          eq: ee.eq,
          kind: 'isolate',
          label: 'M\xEAme op\xE9ration des deux c\xF4t\xE9s',
          text: 'Isole ' + ee.eq.sides.find(i).n + ' pour pouvoir le remplacer.',
          why: 'On isole une inconnue : on pourra la remplacer par son expression dans l\u2019autre \xE9quation.',
        };
    }
    if (ee && ee.m < gs(e, s))
      return {
        eq: ee.eq,
        kind: ee.moved ? 'isolate' : 'transpo',
        label: 'M\xEAme op\xE9ration des deux c\xF4t\xE9s',
        text: ee.desc,
        why: fx(ee.desc),
      };
  }
  return null;
}
function SP(e, n) {
  let t = (r) =>
    (r.k === 'sq' || (r.k === 'pow' && r.b.k === 'n' && r.b.v === 2)) &&
    De(r.a, n) &&
    r.a.k !== 's';
  return t(e)
    ? !0
    : e.k === 'mul' &&
        e.c.filter((r) => t(r)).length === 1 &&
        e.c.every((r) => t(r) || r.k === 'n');
}
function XJ(e, n) {
  if (e.sides.length !== 2) return null;
  for (let t of [0, 1]) {
    let r = e.sides[t],
      s = e.sides[1 - t];
    if (!pt(s, n)) continue;
    let i = H(s, n);
    if (isFinite(i)) {
      if (r.k === 'add') {
        let o = r.c.filter((u) => De(u, n));
        if (o.length !== 1 || !SP(o[0], n)) continue;
        let a = r.c.filter((u) => !De(u, n)),
          l = i - a.reduce((u, c) => u + H(c, n), 0);
        if (!Yt(l)) continue;
        return t === 0 ? { sides: [o[0], X(l)] } : { sides: [X(l), o[0]] };
      }
      if (r.k === 'mul' && SP(r, n)) {
        let o = r.c.filter((l) => l.k === 'n').reduce((l, u) => l * u.v, 1),
          a = r.c.find((l) => l.k !== 'n');
        if (o === 0 || !Yt(i / o)) continue;
        return t === 0 ? { sides: [a, X(i / o)] } : { sides: [X(i / o), a] };
      }
    }
  }
  return null;
}
function YJ(e, n) {
  if (e.dis.length === 1) {
    let i = wP(e.dis[0], n, []);
    return !i || (i.eq && af(i.eq, e.dis[0]))
      ? null
      : { line: i.line || { dis: [i.eq] }, kind: i.kind, label: i.label, text: i.text, why: i.why };
  }
  let t = !1,
    r = [],
    s = e.dis.map((i) => {
      let o = wP(i, n, [], !0);
      return o && o.eq ? ((t = !0), r.indexOf(o.text) < 0 && r.push(o.text), o.eq) : i;
    });
  return t
    ? {
        line: { dis: s },
        kind: 'calc',
        label: 'M\xEAme op\xE9ration des deux c\xF4t\xE9s',
        text: r.length > 1 ? 'Dans chaque cas, isole x.' : r[0] + ' (dans chaque cas)',
        why: 'Dans chaque cas, on isole x en faisant la m\xEAme op\xE9ration des deux c\xF4t\xE9s.',
      }
    : null;
}
export {
  JJ as commit,
  oJ as createState,
  KT as goalReached,
  AJ as judge,
  o1 as kernelLineAtoms,
  LN as krecLineAtoms,
  Te as lex,
  ne as normalize,
};
